// Add ECMA262-5 string trim if not supported natively
//
if (typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  }
}

// Add ECMA262-5 Array methods if not supported natively
//
if (!('indexOf' in Array.prototype)) {
  Array.prototype.indexOf= function(find, i /*opt*/) {
    if (i===undefined) i= 0;
    if (i<0) i+= this.length;
    if (i<0) i= 0;
    for (var n= this.length; i<n; i++)
      if (i in this && this[i]===find)
        return i;
    return -1;
  };
}
if (!('lastIndexOf' in Array.prototype)) {
  Array.prototype.lastIndexOf= function(find, i /*opt*/) {
    if (i===undefined) i= this.length-1;
    if (i<0) i+= this.length;
    if (i>this.length-1) i= this.length-1;
    for (i++; i-->0;) /* i++ because from-argument is sadly inclusive */
      if (i in this && this[i]===find)
        return i;
    return -1;
  };
}
if (!('map' in Array.prototype)) {
  Array.prototype.map= function(mapper, that /*opt*/) {
    var other= new Array(this.length);
    for (var i= 0, n= this.length; i<n; i++)
      if (i in this)
        other[i]= mapper.call(that, this[i], i, this);
    return other;
  };
}
if (!('filter' in Array.prototype)) {
  Array.prototype.filter= function(filter, that /*opt*/) {
    var other= [], v;
    for (var i=0, n= this.length; i<n; i++)
      if (i in this && filter.call(that, v= this[i], i, this))
        other.push(v);
    return other;
  };
}

/**
 * @license Rangy, a cross-browser JavaScript range and selection library
 * http://code.google.com/p/rangy/
 *
 * Copyright 2012, Tim Down
 * Licensed under the MIT license.
 * Version: 1.2.3
 * Build date: 26 February 2012
 */
window['rangy'] = (function() {


    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";

    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer", "START_TO_START", "START_TO_END", "END_TO_START", "END_TO_END"];

    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];

    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];

    // Subset of TextRange's full set of methods that we're interested in
    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "getBookmark", "moveToBookmark",
        "moveToElementText", "parentElement", "pasteHTML", "select", "setEndPoint", "getBoundingClientRect"];

    /*----------------------------------------------------------------------------------------------------------------*/

    // Trio of functions taken from Peter Michaux's article:
    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
    function isHostMethod(o, p) {
        var t = typeof o[p];
        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
    }

    function isHostObject(o, p) {
        return !!(typeof o[p] == OBJECT && o[p]);
    }

    function isHostProperty(o, p) {
        return typeof o[p] != UNDEFINED;
    }

    // Creates a convenience function to save verbose repeated calls to tests functions
    function createMultiplePropertyTest(testFunc) {
        return function(o, props) {
            var i = props.length;
            while (i--) {
                if (!testFunc(o, props[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
    var areHostMethods = createMultiplePropertyTest(isHostMethod);
    var areHostObjects = createMultiplePropertyTest(isHostObject);
    var areHostProperties = createMultiplePropertyTest(isHostProperty);

    function isTextRange(range) {
        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
    }

    var api = {
        version: "1.2.3",
        initialized: false,
        supported: true,

        util: {
            isHostMethod: isHostMethod,
            isHostObject: isHostObject,
            isHostProperty: isHostProperty,
            areHostMethods: areHostMethods,
            areHostObjects: areHostObjects,
            areHostProperties: areHostProperties,
            isTextRange: isTextRange
        },

        features: {},

        modules: {},
        config: {
            alertOnWarn: false,
            preferTextRange: false
        }
    };

    function fail(reason) {
        window.alert("Rangy not supported in your browser. Reason: " + reason);
        api.initialized = true;
        api.supported = false;
    }

    api.fail = fail;

    function warn(msg) {
        var warningMessage = "Rangy warning: " + msg;
        if (api.config.alertOnWarn) {
            window.alert(warningMessage);
        } else if (typeof window.console != UNDEFINED && typeof window.console.log != UNDEFINED) {
            window.console.log(warningMessage);
        }
    }

    api.warn = warn;

    if ({}.hasOwnProperty) {
        api.util.extend = function(o, props) {
            for (var i in props) {
                if (props.hasOwnProperty(i)) {
                    o[i] = props[i];
                }
            }
        };
    } else {
        fail("hasOwnProperty not supported");
    }

    var initListeners = [];
    var moduleInitializers = [];

    // Initialization
    function init() {
        if (api.initialized) {
            return;
        }
        var testRange;
        var implementsDomRange = false, implementsTextRange = false;

        // First, perform basic feature tests

        if (isHostMethod(document, "createRange")) {
            testRange = document.createRange();
            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
                implementsDomRange = true;
            }
            testRange.detach();
        }

        var body = isHostObject(document, "body") ? document.body : document.getElementsByTagName("body")[0];

        if (body && isHostMethod(body, "createTextRange")) {
            testRange = body.createTextRange();
            if (isTextRange(testRange)) {
                implementsTextRange = true;
            }
        }

        if (!implementsDomRange && !implementsTextRange) {
            fail("Neither Range nor TextRange are implemented");
        }

        api.initialized = true;
        api.features = {
            implementsDomRange: implementsDomRange,
            implementsTextRange: implementsTextRange
        };

        // Initialize modules and call init listeners
        var allListeners = moduleInitializers.concat(initListeners);
        for (var i = 0, len = allListeners.length; i < len; ++i) {
            try {
                allListeners[i](api);
            } catch (ex) {
                if (isHostObject(window, "console") && isHostMethod(window.console, "log")) {
                    window.console.log("Init listener threw an exception. Continuing.", ex);
                }

            }
        }
    }

    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
    api.init = init;

    // Execute listener immediately if already initialized
    api.addInitListener = function(listener) {
        if (api.initialized) {
            listener(api);
        } else {
            initListeners.push(listener);
        }
    };

    var createMissingNativeApiListeners = [];

    api.addCreateMissingNativeApiListener = function(listener) {
        createMissingNativeApiListeners.push(listener);
    };

    function createMissingNativeApi(win) {
        win = win || window;
        init();

        // Notify listeners
        for (var i = 0, len = createMissingNativeApiListeners.length; i < len; ++i) {
            createMissingNativeApiListeners[i](win);
        }
    }

    api.createMissingNativeApi = createMissingNativeApi;

    /**
     * @constructor
     */
    function Module(name) {
        this.name = name;
        this.initialized = false;
        this.supported = false;
    }

    Module.prototype.fail = function(reason) {
        this.initialized = true;
        this.supported = false;

        throw new Error("Module '" + this.name + "' failed to load: " + reason);
    };

    Module.prototype.warn = function(msg) {
        api.warn("Module " + this.name + ": " + msg);
    };

    Module.prototype.createError = function(msg) {
        return new Error("Error in Rangy " + this.name + " module: " + msg);
    };

    api.createModule = function(name, initFunc) {
        var module = new Module(name);
        api.modules[name] = module;

        moduleInitializers.push(function(api) {
            initFunc(api, module);
            module.initialized = true;
            module.supported = true;
        });
    };

    api.requireModules = function(modules) {
        for (var i = 0, len = modules.length, module, moduleName; i < len; ++i) {
            moduleName = modules[i];
            module = api.modules[moduleName];
            if (!module || !(module instanceof Module)) {
                throw new Error("Module '" + moduleName + "' not found");
            }
            if (!module.supported) {
                throw new Error("Module '" + moduleName + "' not supported");
            }
        }
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Wait for document to load before running tests

    var docReady = false;

    var loadHandler = function(e) {

        if (!docReady) {
            docReady = true;
            if (!api.initialized) {
                init();
            }
        }
    };

    // Test whether we have window and document objects that we will need
    if (typeof window == UNDEFINED) {
        fail("No window found");
        return;
    }
    if (typeof document == UNDEFINED) {
        fail("No document found");
        return;
    }

    if (isHostMethod(document, "addEventListener")) {
        document.addEventListener("DOMContentLoaded", loadHandler, false);
    }

    // Add a fallback in case the DOMContentLoaded event isn't supported
    if (isHostMethod(window, "addEventListener")) {
        window.addEventListener("load", loadHandler, false);
    } else if (isHostMethod(window, "attachEvent")) {
        window.attachEvent("onload", loadHandler);
    } else {
        fail("Window does not have required addEventListener or attachEvent method");
    }

    return api;
})();
rangy.createModule("DomUtil", function(api, module) {

    var UNDEF = "undefined";
    var util = api.util;

    // Perform feature tests
    if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
        module.fail("document missing a Node creation method");
    }

    if (!util.isHostMethod(document, "getElementsByTagName")) {
        module.fail("document missing getElementsByTagName method");
    }

    var el = document.createElement("div");
    if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
            !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
        module.fail("Incomplete Element implementation");
    }

    // innerHTML is required for Range's createContextualFragment method
    if (!util.isHostProperty(el, "innerHTML")) {
        module.fail("Element is missing innerHTML property");
    }

    var textNode = document.createTextNode("test");
    if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
            !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
            !util.areHostProperties(textNode, ["data"]))) {
        module.fail("Incomplete Text Node implementation");
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
    // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
    // contains just the document as a single element and the value searched for is the document.
    var arrayContains = /*Array.prototype.indexOf ?
        function(arr, val) {
            return arr.indexOf(val) > -1;
        }:*/

        function(arr, val) {
            var i = arr.length;
            while (i--) {
                if (arr[i] === val) {
                    return true;
                }
            }
            return false;
        };

    // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
    function isHtmlNamespace(node) {
        var ns;
        return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
    }

    function parentElement(node) {
        var parent = node.parentNode;
        return (parent.nodeType == 1) ? parent : null;
    }

    function getNodeIndex(node) {
        var i = 0;
        while( (node = node.previousSibling) ) {
            i++;
        }
        return i;
    }

    function getNodeLength(node) {
        var childNodes;
        return isCharacterDataNode(node) ? node.length : ((childNodes = node.childNodes) ? childNodes.length : 0);
    }

    function getCommonAncestor(node1, node2) {
        var ancestors = [], n;
        for (n = node1; n; n = n.parentNode) {
            ancestors.push(n);
        }

        for (n = node2; n; n = n.parentNode) {
            if (arrayContains(ancestors, n)) {
                return n;
            }
        }

        return null;
    }

    function isAncestorOf(ancestor, descendant, selfIsAncestor) {
        var n = selfIsAncestor ? descendant : descendant.parentNode;
        while (n) {
            if (n === ancestor) {
                return true;
            } else {
                n = n.parentNode;
            }
        }
        return false;
    }

    function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
        var p, n = selfIsAncestor ? node : node.parentNode;
        while (n) {
            p = n.parentNode;
            if (p === ancestor) {
                return n;
            }
            n = p;
        }
        return null;
    }

    function isCharacterDataNode(node) {
        var t = node.nodeType;
        return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
    }

    function insertAfter(node, precedingNode) {
        var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
        if (nextNode) {
            parent.insertBefore(node, nextNode);
        } else {
            parent.appendChild(node);
        }
        return node;
    }

    // Note that we cannot use splitText() because it is bugridden in IE 9.
    function splitDataNode(node, index) {
        var newNode = node.cloneNode(false);
        newNode.deleteData(0, index);
        node.deleteData(index, node.length - index);
        insertAfter(newNode, node);
        return newNode;
    }

    function getDocument(node) {
        if (node.nodeType == 9) {
            return node;
        } else if (typeof node.ownerDocument != UNDEF) {
            return node.ownerDocument;
        } else if (typeof node.document != UNDEF) {
            return node.document;
        } else if (node.parentNode) {
            return getDocument(node.parentNode);
        } else {
            throw new Error("getDocument: no document found for node");
        }
    }

    function getWindow(node) {
        var doc = getDocument(node);
        if (typeof doc.defaultView != UNDEF) {
            return doc.defaultView;
        } else if (typeof doc.parentWindow != UNDEF) {
            return doc.parentWindow;
        } else {
            throw new Error("Cannot get a window object for node");
        }
    }

    function getIframeDocument(iframeEl) {
        if (typeof iframeEl.contentDocument != UNDEF) {
            return iframeEl.contentDocument;
        } else if (typeof iframeEl.contentWindow != UNDEF) {
            return iframeEl.contentWindow.document;
        } else {
            throw new Error("getIframeWindow: No Document object found for iframe element");
        }
    }

    function getIframeWindow(iframeEl) {
        if (typeof iframeEl.contentWindow != UNDEF) {
            return iframeEl.contentWindow;
        } else if (typeof iframeEl.contentDocument != UNDEF) {
            return iframeEl.contentDocument.defaultView;
        } else {
            throw new Error("getIframeWindow: No Window object found for iframe element");
        }
    }

    function getBody(doc) {
        return util.isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
    }

    function getRootContainer(node) {
        var parent;
        while ( (parent = node.parentNode) ) {
            node = parent;
        }
        return node;
    }

    function comparePoints(nodeA, offsetA, nodeB, offsetB) {
        // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
        var nodeC, root, childA, childB, n;
        if (nodeA == nodeB) {

            // Case 1: nodes are the same
            return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
        } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {

            // Case 2: node C (container B or an ancestor) is a child node of A
            return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
        } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {

            // Case 3: node C (container A or an ancestor) is a child node of B
            return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
        } else {

            // Case 4: containers are siblings or descendants of siblings
            root = getCommonAncestor(nodeA, nodeB);
            childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
            childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);

            if (childA === childB) {
                // This shouldn't be possible

                throw new Error("comparePoints got to case 4 and childA and childB are the same!");
            } else {
                n = root.firstChild;
                while (n) {
                    if (n === childA) {
                        return -1;
                    } else if (n === childB) {
                        return 1;
                    }
                    n = n.nextSibling;
                }
                throw new Error("Should not be here!");
            }
        }
    }

    function fragmentFromNodeChildren(node) {
        var fragment = getDocument(node).createDocumentFragment(), child;
        while ( (child = node.firstChild) ) {
            fragment.appendChild(child);
        }
        return fragment;
    }

    function inspectNode(node) {
        if (!node) {
            return "[No node]";
        }
        if (isCharacterDataNode(node)) {
            return '"' + node.data + '"';
        } else if (node.nodeType == 1) {
            var idAttr = node.id ? ' id="' + node.id + '"' : "";
            return "<" + node.nodeName + idAttr + ">[" + node.childNodes.length + "]";
        } else {
            return node.nodeName;
        }
    }

    /**
     * @constructor
     */
    function NodeIterator(root) {
        this.root = root;
        this._next = root;
    }

    NodeIterator.prototype = {
        _current: null,

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            var n = this._current = this._next;
            var child, next;
            if (this._current) {
                child = n.firstChild;
                if (child) {
                    this._next = child;
                } else {
                    next = null;
                    while ((n !== this.root) && !(next = n.nextSibling)) {
                        n = n.parentNode;
                    }
                    this._next = next;
                }
            }
            return this._current;
        },

        detach: function() {
            this._current = this._next = this.root = null;
        }
    };

    function createIterator(root) {
        return new NodeIterator(root);
    }

    /**
     * @constructor
     */
    function DomPosition(node, offset) {
        this.node = node;
        this.offset = offset;
    }

    DomPosition.prototype = {
        equals: function(pos) {
            return this.node === pos.node & this.offset == pos.offset;
        },

        inspect: function() {
            return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
        }
    };

    /**
     * @constructor
     */
    function DOMException(codeName) {
        this.code = this[codeName];
        this.codeName = codeName;
        this.message = "DOMException: " + this.codeName;
    }

    DOMException.prototype = {
        INDEX_SIZE_ERR: 1,
        HIERARCHY_REQUEST_ERR: 3,
        WRONG_DOCUMENT_ERR: 4,
        NO_MODIFICATION_ALLOWED_ERR: 7,
        NOT_FOUND_ERR: 8,
        NOT_SUPPORTED_ERR: 9,
        INVALID_STATE_ERR: 11
    };

    DOMException.prototype.toString = function() {
        return this.message;
    };

    api.dom = {
        arrayContains: arrayContains,
        isHtmlNamespace: isHtmlNamespace,
        parentElement: parentElement,
        getNodeIndex: getNodeIndex,
        getNodeLength: getNodeLength,
        getCommonAncestor: getCommonAncestor,
        isAncestorOf: isAncestorOf,
        getClosestAncestorIn: getClosestAncestorIn,
        isCharacterDataNode: isCharacterDataNode,
        insertAfter: insertAfter,
        splitDataNode: splitDataNode,
        getDocument: getDocument,
        getWindow: getWindow,
        getIframeWindow: getIframeWindow,
        getIframeDocument: getIframeDocument,
        getBody: getBody,
        getRootContainer: getRootContainer,
        comparePoints: comparePoints,
        inspectNode: inspectNode,
        fragmentFromNodeChildren: fragmentFromNodeChildren,
        createIterator: createIterator,
        DomPosition: DomPosition
    };

    api.DOMException = DOMException;
});rangy.createModule("DomRange", function(api, module) {
    api.requireModules( ["DomUtil"] );


    var dom = api.dom;
    var DomPosition = dom.DomPosition;
    var DOMException = api.DOMException;
    
    /*----------------------------------------------------------------------------------------------------------------*/

    // Utility functions

    function isNonTextPartiallySelected(node, range) {
        return (node.nodeType != 3) &&
               (dom.isAncestorOf(node, range.startContainer, true) || dom.isAncestorOf(node, range.endContainer, true));
    }

    function getRangeDocument(range) {
        return dom.getDocument(range.startContainer);
    }

    function dispatchEvent(range, type, args) {
        var listeners = range._listeners[type];
        if (listeners) {
            for (var i = 0, len = listeners.length; i < len; ++i) {
                listeners[i].call(range, {target: range, args: args});
            }
        }
    }

    function getBoundaryBeforeNode(node) {
        return new DomPosition(node.parentNode, dom.getNodeIndex(node));
    }

    function getBoundaryAfterNode(node) {
        return new DomPosition(node.parentNode, dom.getNodeIndex(node) + 1);
    }

    function insertNodeAtPosition(node, n, o) {
        var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
        if (dom.isCharacterDataNode(n)) {
            if (o == n.length) {
                dom.insertAfter(node, n);
            } else {
                n.parentNode.insertBefore(node, o == 0 ? n : dom.splitDataNode(n, o));
            }
        } else if (o >= n.childNodes.length) {
            n.appendChild(node);
        } else {
            n.insertBefore(node, n.childNodes[o]);
        }
        return firstNodeInserted;
    }

    function cloneSubtree(iterator) {
        var partiallySelected;
        for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
            partiallySelected = iterator.isPartiallySelectedSubtree();

            node = node.cloneNode(!partiallySelected);
            if (partiallySelected) {
                subIterator = iterator.getSubtreeIterator();
                node.appendChild(cloneSubtree(subIterator));
                subIterator.detach(true);
            }

            if (node.nodeType == 10) { // DocumentType
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }
            frag.appendChild(node);
        }
        return frag;
    }

    function iterateSubtree(rangeIterator, func, iteratorState) {
        var it, n;
        iteratorState = iteratorState || { stop: false };
        for (var node, subRangeIterator; node = rangeIterator.next(); ) {
            //log.debug("iterateSubtree, partially selected: " + rangeIterator.isPartiallySelectedSubtree(), nodeToString(node));
            if (rangeIterator.isPartiallySelectedSubtree()) {
                // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of the
                // node selected by the Range.
                if (func(node) === false) {
                    iteratorState.stop = true;
                    return;
                } else {
                    subRangeIterator = rangeIterator.getSubtreeIterator();
                    iterateSubtree(subRangeIterator, func, iteratorState);
                    subRangeIterator.detach(true);
                    if (iteratorState.stop) {
                        return;
                    }
                }
            } else {
                // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
                // descendant
                it = dom.createIterator(node);
                while ( (n = it.next()) ) {
                    if (func(n) === false) {
                        iteratorState.stop = true;
                        return;
                    }
                }
            }
        }
    }

    function deleteSubtree(iterator) {
        var subIterator;
        while (iterator.next()) {
            if (iterator.isPartiallySelectedSubtree()) {
                subIterator = iterator.getSubtreeIterator();
                deleteSubtree(subIterator);
                subIterator.detach(true);
            } else {
                iterator.remove();
            }
        }
    }

    function extractSubtree(iterator) {

        for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {


            if (iterator.isPartiallySelectedSubtree()) {
                node = node.cloneNode(false);
                subIterator = iterator.getSubtreeIterator();
                node.appendChild(extractSubtree(subIterator));
                subIterator.detach(true);
            } else {
                iterator.remove();
            }
            if (node.nodeType == 10) { // DocumentType
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }
            frag.appendChild(node);
        }
        return frag;
    }

    function getNodesInRange(range, nodeTypes, filter) {
        //log.info("getNodesInRange, " + nodeTypes.join(","));
        var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
        var filterExists = !!filter;
        if (filterNodeTypes) {
            regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
        }

        var nodes = [];
        iterateSubtree(new RangeIterator(range, false), function(node) {
            if ((!filterNodeTypes || regex.test(node.nodeType)) && (!filterExists || filter(node))) {
                nodes.push(node);
            }
        });
        return nodes;
    }

    function inspect(range) {
        var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
        return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
                dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)

    /**
     * @constructor
     */
    function RangeIterator(range, clonePartiallySelectedTextNodes) {
        this.range = range;
        this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;



        if (!range.collapsed) {
            this.sc = range.startContainer;
            this.so = range.startOffset;
            this.ec = range.endContainer;
            this.eo = range.endOffset;
            var root = range.commonAncestorContainer;

            if (this.sc === this.ec && dom.isCharacterDataNode(this.sc)) {
                this.isSingleCharacterDataNode = true;
                this._first = this._last = this._next = this.sc;
            } else {
                this._first = this._next = (this.sc === root && !dom.isCharacterDataNode(this.sc)) ?
                    this.sc.childNodes[this.so] : dom.getClosestAncestorIn(this.sc, root, true);
                this._last = (this.ec === root && !dom.isCharacterDataNode(this.ec)) ?
                    this.ec.childNodes[this.eo - 1] : dom.getClosestAncestorIn(this.ec, root, true);
            }

        }
    }

    RangeIterator.prototype = {
        _current: null,
        _next: null,
        _first: null,
        _last: null,
        isSingleCharacterDataNode: false,

        reset: function() {
            this._current = null;
            this._next = this._first;
        },

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            // Move to next node
            var current = this._current = this._next;
            if (current) {
                this._next = (current !== this._last) ? current.nextSibling : null;

                // Check for partially selected text nodes
                if (dom.isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
                    if (current === this.ec) {

                        (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
                    }
                    if (this._current === this.sc) {

                        (current = current.cloneNode(true)).deleteData(0, this.so);
                    }
                }
            }

            return current;
        },

        remove: function() {
            var current = this._current, start, end;

            if (dom.isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
                start = (current === this.sc) ? this.so : 0;
                end = (current === this.ec) ? this.eo : current.length;
                if (start != end) {
                    current.deleteData(start, end - start);
                }
            } else {
                if (current.parentNode) {
                    current.parentNode.removeChild(current);
                } else {

                }
            }
        },

        // Checks if the current node is partially selected
        isPartiallySelectedSubtree: function() {
            var current = this._current;
            return isNonTextPartiallySelected(current, this.range);
        },

        getSubtreeIterator: function() {
            var subRange;
            if (this.isSingleCharacterDataNode) {
                subRange = this.range.cloneRange();
                subRange.collapse();
            } else {
                subRange = new Range(getRangeDocument(this.range));
                var current = this._current;
                var startContainer = current, startOffset = 0, endContainer = current, endOffset = dom.getNodeLength(current);

                if (dom.isAncestorOf(current, this.sc, true)) {
                    startContainer = this.sc;
                    startOffset = this.so;
                }
                if (dom.isAncestorOf(current, this.ec, true)) {
                    endContainer = this.ec;
                    endOffset = this.eo;
                }

                updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
            }
            return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
        },

        detach: function(detachRange) {
            if (detachRange) {
                this.range.detach();
            }
            this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
        }
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    // Exceptions

    /**
     * @constructor
     */
    function RangeException(codeName) {
        this.code = this[codeName];
        this.codeName = codeName;
        this.message = "RangeException: " + this.codeName;
    }

    RangeException.prototype = {
        BAD_BOUNDARYPOINTS_ERR: 1,
        INVALID_NODE_TYPE_ERR: 2
    };

    RangeException.prototype.toString = function() {
        return this.message;
    };

    /*----------------------------------------------------------------------------------------------------------------*/

    /**
     * Currently iterates through all nodes in the range on creation until I think of a decent way to do it
     * TODO: Look into making this a proper iterator, not requiring preloading everything first
     * @constructor
     */
    function RangeNodeIterator(range, nodeTypes, filter) {
        this.nodes = getNodesInRange(range, nodeTypes, filter);
        this._next = this.nodes[0];
        this._position = 0;
    }

    RangeNodeIterator.prototype = {
        _current: null,

        hasNext: function() {
            return !!this._next;
        },

        next: function() {
            this._current = this._next;
            this._next = this.nodes[ ++this._position ];
            return this._current;
        },

        detach: function() {
            this._current = this._next = this.nodes = null;
        }
    };

    var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
    var rootContainerNodeTypes = [2, 9, 11];
    var readonlyNodeTypes = [5, 6, 10, 12];
    var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
    var surroundNodeTypes = [1, 3, 4, 5, 7, 8];

    function createAncestorFinder(nodeTypes) {
        return function(node, selfIsAncestor) {
            var t, n = selfIsAncestor ? node : node.parentNode;
            while (n) {
                t = n.nodeType;
                if (dom.arrayContains(nodeTypes, t)) {
                    return n;
                }
                n = n.parentNode;
            }
            return null;
        };
    }

    var getRootContainer = dom.getRootContainer;
    var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
    var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
    var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );

    function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
        if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
            throw new RangeException("INVALID_NODE_TYPE_ERR");
        }
    }

    function assertNotDetached(range) {
        if (!range.startContainer) {
            throw new DOMException("INVALID_STATE_ERR");
        }
    }

    function assertValidNodeType(node, invalidTypes) {
        if (!dom.arrayContains(invalidTypes, node.nodeType)) {
            throw new RangeException("INVALID_NODE_TYPE_ERR");
        }
    }

    function assertValidOffset(node, offset) {
        if (offset < 0 || offset > (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
            throw new DOMException("INDEX_SIZE_ERR");
        }
    }

    function assertSameDocumentOrFragment(node1, node2) {
        if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
            throw new DOMException("WRONG_DOCUMENT_ERR");
        }
    }

    function assertNodeNotReadOnly(node) {
        if (getReadonlyAncestor(node, true)) {
            throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
        }
    }

    function assertNode(node, codeName) {
        if (!node) {
            throw new DOMException(codeName);
        }
    }

    function isOrphan(node) {
        return !dom.arrayContains(rootContainerNodeTypes, node.nodeType) && !getDocumentOrFragmentContainer(node, true);
    }

    function isValidOffset(node, offset) {
        return offset <= (dom.isCharacterDataNode(node) ? node.length : node.childNodes.length);
    }

    function isRangeValid(range) {
        return (!!range.startContainer && !!range.endContainer
                && !isOrphan(range.startContainer)
                && !isOrphan(range.endContainer)
                && isValidOffset(range.startContainer, range.startOffset)
                && isValidOffset(range.endContainer, range.endOffset));
    }

    function assertRangeValid(range) {
        assertNotDetached(range);
        if (!isRangeValid(range)) {
            throw new Error("Range error: Range is no longer valid after DOM mutation (" + range.inspect() + ")");
        }
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Test the browser's innerHTML support to decide how to implement createContextualFragment
    var styleEl = document.createElement("style");
    var htmlParsingConforms = false;
    try {
        styleEl.innerHTML = "<b>x</b>";
        htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
    } catch (e) {
        // IE 6 and 7 throw
    }

    api.features.htmlParsingConforms = htmlParsingConforms;

    var createContextualFragment = htmlParsingConforms ?

        // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
        // discussion and base code for this implementation at issue 67.
        // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
        // Thanks to Aleks Williams.
        function(fragmentStr) {
            // "Let node the context object's start's node."
            var node = this.startContainer;
            var doc = dom.getDocument(node);

            // "If the context object's start's node is null, raise an INVALID_STATE_ERR
            // exception and abort these steps."
            if (!node) {
                throw new DOMException("INVALID_STATE_ERR");
            }

            // "Let element be as follows, depending on node's interface:"
            // Document, Document Fragment: null
            var el = null;

            // "Element: node"
            if (node.nodeType == 1) {
                el = node;

            // "Text, Comment: node's parentElement"
            } else if (dom.isCharacterDataNode(node)) {
                el = dom.parentElement(node);
            }

            // "If either element is null or element's ownerDocument is an HTML document
            // and element's local name is "html" and element's namespace is the HTML
            // namespace"
            if (el === null || (
                el.nodeName == "HTML"
                && dom.isHtmlNamespace(dom.getDocument(el).documentElement)
                && dom.isHtmlNamespace(el)
            )) {

            // "let element be a new Element with "body" as its local name and the HTML
            // namespace as its namespace.""
                el = doc.createElement("body");
            } else {
                el = el.cloneNode(false);
            }

            // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
            // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
            // "In either case, the algorithm must be invoked with fragment as the input
            // and element as the context element."
            el.innerHTML = fragmentStr;

            // "If this raises an exception, then abort these steps. Otherwise, let new
            // children be the nodes returned."

            // "Let fragment be a new DocumentFragment."
            // "Append all new children to fragment."
            // "Return fragment."
            return dom.fragmentFromNodeChildren(el);
        } :

        // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
        // previous versions of Rangy used (with the exception of using a body element rather than a div)
        function(fragmentStr) {
            assertNotDetached(this);
            var doc = getRangeDocument(this);
            var el = doc.createElement("body");
            el.innerHTML = fragmentStr;

            return dom.fragmentFromNodeChildren(el);
        };

    /*----------------------------------------------------------------------------------------------------------------*/

    var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
        "commonAncestorContainer"];

    var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
    var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;

    function RangePrototype() {}

    RangePrototype.prototype = {
        attachListener: function(type, listener) {
            this._listeners[type].push(listener);
        },

        compareBoundaryPoints: function(how, range) {
            assertRangeValid(this);
            assertSameDocumentOrFragment(this.startContainer, range.startContainer);

            var nodeA, offsetA, nodeB, offsetB;
            var prefixA = (how == e2s || how == s2s) ? "start" : "end";
            var prefixB = (how == s2e || how == s2s) ? "start" : "end";
            nodeA = this[prefixA + "Container"];
            offsetA = this[prefixA + "Offset"];
            nodeB = range[prefixB + "Container"];
            offsetB = range[prefixB + "Offset"];
            return dom.comparePoints(nodeA, offsetA, nodeB, offsetB);
        },

        insertNode: function(node) {
            assertRangeValid(this);
            assertValidNodeType(node, insertableNodeTypes);
            assertNodeNotReadOnly(this.startContainer);

            if (dom.isAncestorOf(node, this.startContainer, true)) {
                throw new DOMException("HIERARCHY_REQUEST_ERR");
            }

            // No check for whether the container of the start of the Range is of a type that does not allow
            // children of the type of node: the browser's DOM implementation should do this for us when we attempt
            // to add the node

            var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
            this.setStartBefore(firstNodeInserted);
        },

        cloneContents: function() {
            assertRangeValid(this);

            var clone, frag;
            if (this.collapsed) {
                return getRangeDocument(this).createDocumentFragment();
            } else {
                if (this.startContainer === this.endContainer && dom.isCharacterDataNode(this.startContainer)) {
                    clone = this.startContainer.cloneNode(true);
                    clone.data = clone.data.slice(this.startOffset, this.endOffset);
                    frag = getRangeDocument(this).createDocumentFragment();
                    frag.appendChild(clone);
                    return frag;
                } else {
                    var iterator = new RangeIterator(this, true);
                    clone = cloneSubtree(iterator);
                    iterator.detach();
                }
                return clone;
            }
        },

        canSurroundContents: function() {
            assertRangeValid(this);
            assertNodeNotReadOnly(this.startContainer);
            assertNodeNotReadOnly(this.endContainer);

            // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
            // no non-text nodes.
            var iterator = new RangeIterator(this, true);
            var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
                    (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
            iterator.detach();
            return !boundariesInvalid;
        },

        surroundContents: function(node) {
            assertValidNodeType(node, surroundNodeTypes);

            if (!this.canSurroundContents()) {
                throw new RangeException("BAD_BOUNDARYPOINTS_ERR");
            }

            // Extract the contents
            var content = this.extractContents();

            // Clear the children of the node
            if (node.hasChildNodes()) {
                while (node.lastChild) {
                    node.removeChild(node.lastChild);
                }
            }

            // Insert the new node and add the extracted contents
            insertNodeAtPosition(node, this.startContainer, this.startOffset);
            node.appendChild(content);

            this.selectNode(node);
        },

        cloneRange: function() {
            assertRangeValid(this);
            var range = new Range(getRangeDocument(this));
            var i = rangeProperties.length, prop;
            while (i--) {
                prop = rangeProperties[i];
                range[prop] = this[prop];
            }
            return range;
        },

        toString: function() {
            assertRangeValid(this);
            var sc = this.startContainer;
            if (sc === this.endContainer && dom.isCharacterDataNode(sc)) {
                return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
            } else {
                var textBits = [], iterator = new RangeIterator(this, true);

                iterateSubtree(iterator, function(node) {
                    // Accept only text or CDATA nodes, not comments

                    if (node.nodeType == 3 || node.nodeType == 4) {
                        textBits.push(node.data);
                    }
                });
                iterator.detach();
                return textBits.join("");
            }
        },

        // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
        // been removed from Mozilla.

        compareNode: function(node) {
            assertRangeValid(this);

            var parent = node.parentNode;
            var nodeIndex = dom.getNodeIndex(node);

            if (!parent) {
                throw new DOMException("NOT_FOUND_ERR");
            }

            var startComparison = this.comparePoint(parent, nodeIndex),
                endComparison = this.comparePoint(parent, nodeIndex + 1);

            if (startComparison < 0) { // Node starts before
                return (endComparison > 0) ? n_b_a : n_b;
            } else {
                return (endComparison > 0) ? n_a : n_i;
            }
        },

        comparePoint: function(node, offset) {
            assertRangeValid(this);
            assertNode(node, "HIERARCHY_REQUEST_ERR");
            assertSameDocumentOrFragment(node, this.startContainer);

            if (dom.comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
                return -1;
            } else if (dom.comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
                return 1;
            }
            return 0;
        },

        createContextualFragment: createContextualFragment,

        toHtml: function() {
            assertRangeValid(this);
            var container = getRangeDocument(this).createElement("div");
            container.appendChild(this.cloneContents());
            return container.innerHTML;
        },

        // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
        // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
        intersectsNode: function(node, touchingIsIntersecting) {
            assertRangeValid(this);
            assertNode(node, "NOT_FOUND_ERR");
            if (dom.getDocument(node) !== getRangeDocument(this)) {
                return false;
            }

            var parent = node.parentNode, offset = dom.getNodeIndex(node);
            assertNode(parent, "NOT_FOUND_ERR");

            var startComparison = dom.comparePoints(parent, offset, this.endContainer, this.endOffset),
                endComparison = dom.comparePoints(parent, offset + 1, this.startContainer, this.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        },


        isPointInRange: function(node, offset) {
            assertRangeValid(this);
            assertNode(node, "HIERARCHY_REQUEST_ERR");
            assertSameDocumentOrFragment(node, this.startContainer);

            return (dom.comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
                   (dom.comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
        },

        // The methods below are non-standard and invented by me.

        // Sharing a boundary start-to-end or end-to-start does not count as intersection.
        intersectsRange: function(range, touchingIsIntersecting) {
            assertRangeValid(this);

            if (getRangeDocument(range) != getRangeDocument(this)) {
                throw new DOMException("WRONG_DOCUMENT_ERR");
            }

            var startComparison = dom.comparePoints(this.startContainer, this.startOffset, range.endContainer, range.endOffset),
                endComparison = dom.comparePoints(this.endContainer, this.endOffset, range.startContainer, range.startOffset);

            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
        },

        intersection: function(range) {
            if (this.intersectsRange(range)) {
                var startComparison = dom.comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
                    endComparison = dom.comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);

                var intersectionRange = this.cloneRange();

                if (startComparison == -1) {
                    intersectionRange.setStart(range.startContainer, range.startOffset);
                }
                if (endComparison == 1) {
                    intersectionRange.setEnd(range.endContainer, range.endOffset);
                }
                return intersectionRange;
            }
            return null;
        },

        union: function(range) {
            if (this.intersectsRange(range, true)) {
                var unionRange = this.cloneRange();
                if (dom.comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
                    unionRange.setStart(range.startContainer, range.startOffset);
                }
                if (dom.comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
                    unionRange.setEnd(range.endContainer, range.endOffset);
                }
                return unionRange;
            } else {
                throw new RangeException("Ranges do not intersect");
            }
        },

        containsNode: function(node, allowPartial) {
            if (allowPartial) {
                return this.intersectsNode(node, false);
            } else {
                return this.compareNode(node) == n_i;
            }
        },

        containsNodeContents: function(node) {
            return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, dom.getNodeLength(node)) <= 0;
        },

        containsRange: function(range) {
            return this.intersection(range).equals(range);
        },

        containsNodeText: function(node) {
            var nodeRange = this.cloneRange();
            nodeRange.selectNode(node);
            var textNodes = nodeRange.getNodes([3]);
            if (textNodes.length > 0) {
                nodeRange.setStart(textNodes[0], 0);
                var lastTextNode = textNodes.pop();
                nodeRange.setEnd(lastTextNode, lastTextNode.length);
                var contains = this.containsRange(nodeRange);
                nodeRange.detach();
                return contains;
            } else {
                return this.containsNodeContents(node);
            }
        },

        createNodeIterator: function(nodeTypes, filter) {
            assertRangeValid(this);
            return new RangeNodeIterator(this, nodeTypes, filter);
        },

        getNodes: function(nodeTypes, filter) {
            assertRangeValid(this);
            return getNodesInRange(this, nodeTypes, filter);
        },

        getDocument: function() {
            return getRangeDocument(this);
        },

        collapseBefore: function(node) {
            assertNotDetached(this);

            this.setEndBefore(node);
            this.collapse(false);
        },

        collapseAfter: function(node) {
            assertNotDetached(this);

            this.setStartAfter(node);
            this.collapse(true);
        },

        getName: function() {
            return "DomRange";
        },

        equals: function(range) {
            return Range.rangesEqual(this, range);
        },

        isValid: function() {
            return isRangeValid(this);
        },

        inspect: function() {
            return inspect(this);
        }
    };

    function copyComparisonConstantsToObject(obj) {
        obj.START_TO_START = s2s;
        obj.START_TO_END = s2e;
        obj.END_TO_END = e2e;
        obj.END_TO_START = e2s;

        obj.NODE_BEFORE = n_b;
        obj.NODE_AFTER = n_a;
        obj.NODE_BEFORE_AND_AFTER = n_b_a;
        obj.NODE_INSIDE = n_i;
    }

    function copyComparisonConstants(constructor) {
        copyComparisonConstantsToObject(constructor);
        copyComparisonConstantsToObject(constructor.prototype);
    }

    function createRangeContentRemover(remover, boundaryUpdater) {
        return function() {
            assertRangeValid(this);

            var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;

            var iterator = new RangeIterator(this, true);

            // Work out where to position the range after content removal
            var node, boundary;
            if (sc !== root) {
                node = dom.getClosestAncestorIn(sc, root, true);
                boundary = getBoundaryAfterNode(node);
                sc = boundary.node;
                so = boundary.offset;
            }

            // Check none of the range is read-only
            iterateSubtree(iterator, assertNodeNotReadOnly);

            iterator.reset();

            // Remove the content
            var returnValue = remover(iterator);
            iterator.detach();

            // Move to the new position
            boundaryUpdater(this, sc, so, sc, so);

            return returnValue;
        };
    }

    function createPrototypeRange(constructor, boundaryUpdater, detacher) {
        function createBeforeAfterNodeSetter(isBefore, isStart) {
            return function(node) {
                assertNotDetached(this);
                assertValidNodeType(node, beforeAfterNodeTypes);
                assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);

                var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
                (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
            };
        }

        function setRangeStart(range, node, offset) {
            var ec = range.endContainer, eo = range.endOffset;
            if (node !== range.startContainer || offset !== range.startOffset) {
                // Check the root containers of the range and the new boundary, and also check whether the new boundary
                // is after the current end. In either case, collapse the range to the new position
                if (getRootContainer(node) != getRootContainer(ec) || dom.comparePoints(node, offset, ec, eo) == 1) {
                    ec = node;
                    eo = offset;
                }
                boundaryUpdater(range, node, offset, ec, eo);
            }
        }

        function setRangeEnd(range, node, offset) {
            var sc = range.startContainer, so = range.startOffset;
            if (node !== range.endContainer || offset !== range.endOffset) {
                // Check the root containers of the range and the new boundary, and also check whether the new boundary
                // is after the current end. In either case, collapse the range to the new position
                if (getRootContainer(node) != getRootContainer(sc) || dom.comparePoints(node, offset, sc, so) == -1) {
                    sc = node;
                    so = offset;
                }
                boundaryUpdater(range, sc, so, node, offset);
            }
        }

        function setRangeStartAndEnd(range, node, offset) {
            if (node !== range.startContainer || offset !== range.startOffset || node !== range.endContainer || offset !== range.endOffset) {
                boundaryUpdater(range, node, offset, node, offset);
            }
        }

        constructor.prototype = new RangePrototype();

        api.util.extend(constructor.prototype, {
            setStart: function(node, offset) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeStart(this, node, offset);
            },

            setEnd: function(node, offset) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeEnd(this, node, offset);
            },

            setStartBefore: createBeforeAfterNodeSetter(true, true),
            setStartAfter: createBeforeAfterNodeSetter(false, true),
            setEndBefore: createBeforeAfterNodeSetter(true, false),
            setEndAfter: createBeforeAfterNodeSetter(false, false),

            collapse: function(isStart) {
                assertRangeValid(this);
                if (isStart) {
                    boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
                } else {
                    boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
                }
            },

            selectNodeContents: function(node) {
                // This doesn't seem well specified: the spec talks only about selecting the node's contents, which
                // could be taken to mean only its children. However, browsers implement this the same as selectNode for
                // text nodes, so I shall do likewise
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, true);

                boundaryUpdater(this, node, 0, node, dom.getNodeLength(node));
            },

            selectNode: function(node) {
                assertNotDetached(this);
                assertNoDocTypeNotationEntityAncestor(node, false);
                assertValidNodeType(node, beforeAfterNodeTypes);

                var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
                boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
            },

            extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),

            deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),

            canSurroundContents: function() {
                assertRangeValid(this);
                assertNodeNotReadOnly(this.startContainer);
                assertNodeNotReadOnly(this.endContainer);

                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
                // no non-text nodes.
                var iterator = new RangeIterator(this, true);
                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
                iterator.detach();
                return !boundariesInvalid;
            },

            detach: function() {
                detacher(this);
            },

            splitBoundaries: function() {
                assertRangeValid(this);


                var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
                var startEndSame = (sc === ec);

                if (dom.isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
                    dom.splitDataNode(ec, eo);

                }

                if (dom.isCharacterDataNode(sc) && so > 0 && so < sc.length) {

                    sc = dom.splitDataNode(sc, so);
                    if (startEndSame) {
                        eo -= so;
                        ec = sc;
                    } else if (ec == sc.parentNode && eo >= dom.getNodeIndex(sc)) {
                        eo++;
                    }
                    so = 0;

                }
                boundaryUpdater(this, sc, so, ec, eo);
            },

            normalizeBoundaries: function() {
                assertRangeValid(this);

                var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;

                var mergeForward = function(node) {
                    var sibling = node.nextSibling;
                    if (sibling && sibling.nodeType == node.nodeType) {
                        ec = node;
                        eo = node.length;
                        node.appendData(sibling.data);
                        sibling.parentNode.removeChild(sibling);
                    }
                };

                var mergeBackward = function(node) {
                    var sibling = node.previousSibling;
                    if (sibling && sibling.nodeType == node.nodeType) {
                        sc = node;
                        var nodeLength = node.length;
                        so = sibling.length;
                        node.insertData(0, sibling.data);
                        sibling.parentNode.removeChild(sibling);
                        if (sc == ec) {
                            eo += so;
                            ec = sc;
                        } else if (ec == node.parentNode) {
                            var nodeIndex = dom.getNodeIndex(node);
                            if (eo == nodeIndex) {
                                ec = node;
                                eo = nodeLength;
                            } else if (eo > nodeIndex) {
                                eo--;
                            }
                        }
                    }
                };

                var normalizeStart = true;

                if (dom.isCharacterDataNode(ec)) {
                    if (ec.length == eo) {
                        mergeForward(ec);
                    }
                } else {
                    if (eo > 0) {
                        var endNode = ec.childNodes[eo - 1];
                        if (endNode && dom.isCharacterDataNode(endNode)) {
                            mergeForward(endNode);
                        }
                    }
                    normalizeStart = !this.collapsed;
                }

                if (normalizeStart) {
                    if (dom.isCharacterDataNode(sc)) {
                        if (so == 0) {
                            mergeBackward(sc);
                        }
                    } else {
                        if (so < sc.childNodes.length) {
                            var startNode = sc.childNodes[so];
                            if (startNode && dom.isCharacterDataNode(startNode)) {
                                mergeBackward(startNode);
                            }
                        }
                    }
                } else {
                    sc = ec;
                    so = eo;
                }

                boundaryUpdater(this, sc, so, ec, eo);
            },

            collapseToPoint: function(node, offset) {
                assertNotDetached(this);

                assertNoDocTypeNotationEntityAncestor(node, true);
                assertValidOffset(node, offset);

                setRangeStartAndEnd(this, node, offset);
            }
        });

        copyComparisonConstants(constructor);
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    // Updates commonAncestorContainer and collapsed after boundary change
    function updateCollapsedAndCommonAncestor(range) {
        range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
        range.commonAncestorContainer = range.collapsed ?
            range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
    }

    function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
        var startMoved = (range.startContainer !== startContainer || range.startOffset !== startOffset);
        var endMoved = (range.endContainer !== endContainer || range.endOffset !== endOffset);

        range.startContainer = startContainer;
        range.startOffset = startOffset;
        range.endContainer = endContainer;
        range.endOffset = endOffset;

        updateCollapsedAndCommonAncestor(range);
        dispatchEvent(range, "boundarychange", {startMoved: startMoved, endMoved: endMoved});
    }

    function detach(range) {
        assertNotDetached(range);
        range.startContainer = range.startOffset = range.endContainer = range.endOffset = null;
        range.collapsed = range.commonAncestorContainer = null;
        dispatchEvent(range, "detach", null);
        range._listeners = null;
    }

    /**
     * @constructor
     */
    function Range(doc) {
        this.startContainer = doc;
        this.startOffset = 0;
        this.endContainer = doc;
        this.endOffset = 0;
        this._listeners = {
            boundarychange: [],
            detach: []
        };
        updateCollapsedAndCommonAncestor(this);
    }

    createPrototypeRange(Range, updateBoundaries, detach);

    api.rangePrototype = RangePrototype.prototype;

    Range.rangeProperties = rangeProperties;
    Range.RangeIterator = RangeIterator;
    Range.copyComparisonConstants = copyComparisonConstants;
    Range.createPrototypeRange = createPrototypeRange;
    Range.inspect = inspect;
    Range.getRangeDocument = getRangeDocument;
    Range.rangesEqual = function(r1, r2) {
        return r1.startContainer === r2.startContainer &&
               r1.startOffset === r2.startOffset &&
               r1.endContainer === r2.endContainer &&
               r1.endOffset === r2.endOffset;
    };

    api.DomRange = Range;
    api.RangeException = RangeException;
});rangy.createModule("WrappedRange", function(api, module) {
    api.requireModules( ["DomUtil", "DomRange"] );

    /**
     * @constructor
     */
    var WrappedRange;
    var dom = api.dom;
    var DomPosition = dom.DomPosition;
    var DomRange = api.DomRange;



    /*----------------------------------------------------------------------------------------------------------------*/

    /*
    This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
    method. For example, in the following (where pipes denote the selection boundaries):

    <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>

    var range = document.selection.createRange();
    alert(range.parentElement().id); // Should alert "ul" but alerts "b"

    This method returns the common ancestor node of the following:
    - the parentElement() of the textRange
    - the parentElement() of the textRange after calling collapse(true)
    - the parentElement() of the textRange after calling collapse(false)
     */
    function getTextRangeContainerElement(textRange) {
        var parentEl = textRange.parentElement();

        var range = textRange.duplicate();
        range.collapse(true);
        var startEl = range.parentElement();
        range = textRange.duplicate();
        range.collapse(false);
        var endEl = range.parentElement();
        var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);

        return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
    }

    function textRangeIsCollapsed(textRange) {
        return textRange.compareEndPoints("StartToEnd", textRange) == 0;
    }

    // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started out as
    // an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/) but has
    // grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange bugs, handling
    // for inputs and images, plus optimizations.
    function getTextRangeBoundaryPosition(textRange, wholeRangeContainerElement, isStart, isCollapsed) {
        var workingRange = textRange.duplicate();

        workingRange.collapse(isStart);
        var containerElement = workingRange.parentElement();

        // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
        // check for that
        // TODO: Find out when. Workaround for wholeRangeContainerElement may break this
        if (!dom.isAncestorOf(wholeRangeContainerElement, containerElement, true)) {
            containerElement = wholeRangeContainerElement;

        }



        // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
        // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
        if (!containerElement.canHaveHTML) {
            return new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
        }

        var workingNode = dom.getDocument(containerElement).createElement("span");
        var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
        var previousNode, nextNode, boundaryPosition, boundaryNode;

        // Move the working range through the container's children, starting at the end and working backwards, until the
        // working range reaches or goes past the boundary we're interested in
        do {
            containerElement.insertBefore(workingNode, workingNode.previousSibling);
            workingRange.moveToElementText(workingNode);
        } while ( (comparison = workingRange.compareEndPoints(workingComparisonType, textRange)) > 0 &&
                workingNode.previousSibling);

        // We've now reached or gone past the boundary of the text range we're interested in
        // so have identified the node we want
        boundaryNode = workingNode.nextSibling;

        if (comparison == -1 && boundaryNode && dom.isCharacterDataNode(boundaryNode)) {
            // This is a character data node (text, comment, cdata). The working range is collapsed at the start of the
            // node containing the text range's boundary, so we move the end of the working range to the boundary point
            // and measure the length of its text to get the boundary's offset within the node.
            workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);


            var offset;

            if (/[\r\n]/.test(boundaryNode.data)) {
                /*
                For the particular case of a boundary within a text node containing line breaks (within a <pre> element,
                for example), we need a slightly complicated approach to get the boundary's offset in IE. The facts:

                - Each line break is represented as \r in the text node's data/nodeValue properties
                - Each line break is represented as \r\n in the TextRange's 'text' property
                - The 'text' property of the TextRange does not contain trailing line breaks

                To get round the problem presented by the final fact above, we can use the fact that TextRange's
                moveStart() and moveEnd() methods return the actual number of characters moved, which is not necessarily
                the same as the number of characters it was instructed to move. The simplest approach is to use this to
                store the characters moved when moving both the start and end of the range to the start of the document
                body and subtracting the start offset from the end offset (the "move-negative-gazillion" method).
                However, this is extremely slow when the document is large and the range is near the end of it. Clearly
                doing the mirror image (i.e. moving the range boundaries to the end of the document) has the same
                problem.

                Another approach that works is to use moveStart() to move the start boundary of the range up to the end
                boundary one character at a time and incrementing a counter with the value returned by the moveStart()
                call. However, the check for whether the start boundary has reached the end boundary is expensive, so
                this method is slow (although unlike "move-negative-gazillion" is largely unaffected by the location of
                the range within the document).

                The method below is a hybrid of the two methods above. It uses the fact that a string containing the
                TextRange's 'text' property with each \r\n converted to a single \r character cannot be longer than the
                text of the TextRange, so the start of the range is moved that length initially and then a character at
                a time to make up for any trailing line breaks not contained in the 'text' property. This has good
                performance in most situations compared to the previous two methods.
                */
                var tempRange = workingRange.duplicate();
                var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;

                offset = tempRange.moveStart("character", rangeLength);
                while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
                    offset++;
                    tempRange.moveStart("character", 1);
                }
            } else {
                offset = workingRange.text.length;
            }
            boundaryPosition = new DomPosition(boundaryNode, offset);
        } else {


            // If the boundary immediately follows a character data node and this is the end boundary, we should favour
            // a position within that, and likewise for a start boundary preceding a character data node
            previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
            nextNode = (isCollapsed || isStart) && workingNode.nextSibling;



            if (nextNode && dom.isCharacterDataNode(nextNode)) {
                boundaryPosition = new DomPosition(nextNode, 0);
            } else if (previousNode && dom.isCharacterDataNode(previousNode)) {
                boundaryPosition = new DomPosition(previousNode, previousNode.length);
            } else {
                boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
            }
        }

        // Clean up
        workingNode.parentNode.removeChild(workingNode);

        return boundaryPosition;
    }

    // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that node.
    // This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
    // (http://code.google.com/p/ierange/)
    function createBoundaryTextRange(boundaryPosition, isStart) {
        var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
        var doc = dom.getDocument(boundaryPosition.node);
        var workingNode, childNodes, workingRange = doc.body.createTextRange();
        var nodeIsDataNode = dom.isCharacterDataNode(boundaryPosition.node);

        if (nodeIsDataNode) {
            boundaryNode = boundaryPosition.node;
            boundaryParent = boundaryNode.parentNode;
        } else {
            childNodes = boundaryPosition.node.childNodes;
            boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
            boundaryParent = boundaryPosition.node;
        }

        // Position the range immediately before the node containing the boundary
        workingNode = doc.createElement("span");

        // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within the
        // element rather than immediately before or after it, which is what we want
        workingNode.innerHTML = "&#feff;";

        // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
        // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
        if (boundaryNode) {
            boundaryParent.insertBefore(workingNode, boundaryNode);
        } else {
            boundaryParent.appendChild(workingNode);
        }

        workingRange.moveToElementText(workingNode);
        workingRange.collapse(!isStart);

        // Clean up
        boundaryParent.removeChild(workingNode);

        // Move the working range to the text offset, if required
        if (nodeIsDataNode) {
            workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
        }

        return workingRange;
    }

    /*----------------------------------------------------------------------------------------------------------------*/

    if (api.features.implementsDomRange && (!api.features.implementsTextRange || !api.config.preferTextRange)) {
        // This is a wrapper around the browser's native DOM Range. It has two aims:
        // - Provide workarounds for specific browser bugs
        // - provide convenient extensions, which are inherited from Rangy's DomRange

        (function() {
            var rangeProto;
            var rangeProperties = DomRange.rangeProperties;
            var canSetRangeStartAfterEnd;

            function updateRangeProperties(range) {
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = range.nativeRange[prop];
                }
            }

            function updateNativeRange(range, startContainer, startOffset, endContainer,endOffset) {
                var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
                var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);

                // Always set both boundaries for the benefit of IE9 (see issue 35)
                if (startMoved || endMoved) {
                    range.setEnd(endContainer, endOffset);
                    range.setStart(startContainer, startOffset);
                }
            }

            function detach(range) {
                range.nativeRange.detach();
                range.detached = true;
                var i = rangeProperties.length, prop;
                while (i--) {
                    prop = rangeProperties[i];
                    range[prop] = null;
                }
            }

            var createBeforeAfterNodeSetter;

            WrappedRange = function(range) {
                if (!range) {
                    throw new Error("Range must be specified");
                }
                this.nativeRange = range;
                updateRangeProperties(this);
            };

            DomRange.createPrototypeRange(WrappedRange, updateNativeRange, detach);

            rangeProto = WrappedRange.prototype;

            rangeProto.selectNode = function(node) {
                this.nativeRange.selectNode(node);
                updateRangeProperties(this);
            };

            rangeProto.deleteContents = function() {
                this.nativeRange.deleteContents();
                updateRangeProperties(this);
            };

            rangeProto.extractContents = function() {
                var frag = this.nativeRange.extractContents();
                updateRangeProperties(this);
                return frag;
            };

            rangeProto.cloneContents = function() {
                return this.nativeRange.cloneContents();
            };

            // TODO: Until I can find a way to programmatically trigger the Firefox bug (apparently long-standing, still
            // present in 3.6.8) that throws "Index or size is negative or greater than the allowed amount" for
            // insertNode in some circumstances, all browsers will have to use the Rangy's own implementation of
            // insertNode, which works but is almost certainly slower than the native implementation.
/*
            rangeProto.insertNode = function(node) {
                this.nativeRange.insertNode(node);
                updateRangeProperties(this);
            };
*/

            rangeProto.surroundContents = function(node) {
                this.nativeRange.surroundContents(node);
                updateRangeProperties(this);
            };

            rangeProto.collapse = function(isStart) {
                this.nativeRange.collapse(isStart);
                updateRangeProperties(this);
            };

            rangeProto.cloneRange = function() {
                return new WrappedRange(this.nativeRange.cloneRange());
            };

            rangeProto.refresh = function() {
                updateRangeProperties(this);
            };

            rangeProto.toString = function() {
                return this.nativeRange.toString();
            };

            // Create test range and node for feature detection

            var testTextNode = document.createTextNode("test");
            dom.getBody(document).appendChild(testTextNode);
            var range = document.createRange();

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
            // correct for it

            range.setStart(testTextNode, 0);
            range.setEnd(testTextNode, 0);

            try {
                range.setStart(testTextNode, 1);
                canSetRangeStartAfterEnd = true;

                rangeProto.setStart = function(node, offset) {
                    try {
                        this.nativeRange.setStart(node, offset);
                        updateRangeProperties(this);    
                    }
                    catch (e) {
                        debugger
                    }
                    
                };

                rangeProto.setEnd = function(node, offset) {
                    this.nativeRange.setEnd(node, offset);
                    updateRangeProperties(this);
                };

                createBeforeAfterNodeSetter = function(name) {
                    return function(node) {
                        try {
                            this.nativeRange[name](node);
                            updateRangeProperties(this);
                        } catch (e) {
                            debugger
                        }
                    };
                };

            } catch(ex) {


                canSetRangeStartAfterEnd = false;

                rangeProto.setStart = function(node, offset) {
                    try {
                        this.nativeRange.setStart(node, offset);
                    } catch (ex) {
                        this.nativeRange.setEnd(node, offset);
                        this.nativeRange.setStart(node, offset);
                    }
                    updateRangeProperties(this);
                };

                rangeProto.setEnd = function(node, offset) {
                    try {
                        this.nativeRange.setEnd(node, offset);
                    } catch (ex) {
                        this.nativeRange.setStart(node, offset);
                        this.nativeRange.setEnd(node, offset);
                    }
                    updateRangeProperties(this);
                };

                createBeforeAfterNodeSetter = function(name, oppositeName) {
                    return function(node) {
                        try {
                            this.nativeRange[name](node);
                        } catch (ex) {
                            this.nativeRange[oppositeName](node);
                            this.nativeRange[name](node);
                        }
                        updateRangeProperties(this);
                    };
                };
            }

            rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
            rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
            rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
            rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for and correct Firefox 2 behaviour with selectNodeContents on text nodes: it collapses the range to
            // the 0th character of the text node
            range.selectNodeContents(testTextNode);
            if (range.startContainer == testTextNode && range.endContainer == testTextNode &&
                    range.startOffset == 0 && range.endOffset == testTextNode.length) {
                rangeProto.selectNodeContents = function(node) {
                    this.nativeRange.selectNodeContents(node);
                    updateRangeProperties(this);
                };
            } else {
                rangeProto.selectNodeContents = function(node) {
                    this.setStart(node, 0);
                    this.setEnd(node, DomRange.getEndOffset(node));
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for WebKit bug that has the beahviour of compareBoundaryPoints round the wrong way for constants
            // START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738

            range.selectNodeContents(testTextNode);
            range.setEnd(testTextNode, 3);

            var range2 = document.createRange();
            range2.selectNodeContents(testTextNode);
            range2.setEnd(testTextNode, 4);
            range2.setStart(testTextNode, 2);

            if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &
                    range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
                // This is the wrong way round, so correct for it


                rangeProto.compareBoundaryPoints = function(type, range) {
                    range = range.nativeRange || range;
                    if (type == range.START_TO_END) {
                        type = range.END_TO_START;
                    } else if (type == range.END_TO_START) {
                        type = range.START_TO_END;
                    }
                    return this.nativeRange.compareBoundaryPoints(type, range);
                };
            } else {
                rangeProto.compareBoundaryPoints = function(type, range) {
                    return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Test for existence of createContextualFragment and delegate to it if it exists
            if (api.util.isHostMethod(range, "createContextualFragment")) {
                rangeProto.createContextualFragment = function(fragmentStr) {
                    return this.nativeRange.createContextualFragment(fragmentStr);
                };
            }

            /*--------------------------------------------------------------------------------------------------------*/

            // Clean up
            dom.getBody(document).removeChild(testTextNode);
            range.detach();
            range2.detach();
        })();

        api.createNativeRange = function(doc) {
            doc = doc || document;
            return doc.createRange();
        };
    } else if (api.features.implementsTextRange) {
        // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
        // prototype

        WrappedRange = function(textRange) {
            this.textRange = textRange;
            this.refresh();
        };

        WrappedRange.prototype = new DomRange(document);

        WrappedRange.prototype.refresh = function() {
            var start, end;

            // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
            var rangeContainerElement = getTextRangeContainerElement(this.textRange);

            if (textRangeIsCollapsed(this.textRange)) {
                end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, true);
            } else {

                start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
                end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false);
            }

            this.setStart(start.node, start.offset);
            this.setEnd(end.node, end.offset);
        };

        DomRange.copyComparisonConstants(WrappedRange);

        // Add WrappedRange as the Range property of the global object to allow expression like Range.END_TO_END to work
        var globalObj = (function() { return this; })();
        if (typeof globalObj.Range == "undefined") {
            globalObj.Range = WrappedRange;
        }

        api.createNativeRange = function(doc) {
            doc = doc || document;
            return doc.body.createTextRange();
        };
    }

    if (api.features.implementsTextRange) {
        WrappedRange.rangeToTextRange = function(range) {
            if (range.collapsed) {
                var tr = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);



                return tr;

                //return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
            } else {
                var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
                var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
                var textRange = dom.getDocument(range.startContainer).body.createTextRange();
                textRange.setEndPoint("StartToStart", startRange);
                textRange.setEndPoint("EndToEnd", endRange);
                return textRange;
            }
        };
    }

    WrappedRange.prototype.getName = function() {
        return "WrappedRange";
    };

    api.WrappedRange = WrappedRange;

    api.createRange = function(doc) {
        doc = doc || document;
        return new WrappedRange(api.createNativeRange(doc));
    };

    api.createRangyRange = function(doc) {
        doc = doc || document;
        return new DomRange(doc);
    };

    api.createIframeRange = function(iframeEl) {
        return api.createRange(dom.getIframeDocument(iframeEl));
    };

    api.createIframeRangyRange = function(iframeEl) {
        return api.createRangyRange(dom.getIframeDocument(iframeEl));
    };

    api.addCreateMissingNativeApiListener(function(win) {
        var doc = win.document;
        if (typeof doc.createRange == "undefined") {
            doc.createRange = function() {
                return api.createRange(this);
            };
        }
        doc = win = null;
    });
});rangy.createModule("WrappedSelection", function(api, module) {
    // This will create a selection object wrapper that follows the Selection object found in the WHATWG draft DOM Range
    // spec (http://html5.org/specs/dom-range.html)

    api.requireModules( ["DomUtil", "DomRange", "WrappedRange"] );

    api.config.checkSelectionRanges = true;

    var BOOLEAN = "boolean",
        windowPropertyName = "_rangySelection",
        dom = api.dom,
        util = api.util,
        DomRange = api.DomRange,
        WrappedRange = api.WrappedRange,
        DOMException = api.DOMException,
        DomPosition = dom.DomPosition,
        getSelection,
        selectionIsCollapsed,
        CONTROL = "Control";



    function getWinSelection(winParam) {
        return (winParam || window).getSelection();
    }

    function getDocSelection(winParam) {
        return (winParam || window).document.selection;
    }

    // Test for the Range/TextRange and Selection features required
    // Test for ability to retrieve selection
    var implementsWinGetSelection = api.util.isHostMethod(window, "getSelection"),
        implementsDocSelection = api.util.isHostObject(document, "selection");

    var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);

    if (useDocumentSelection) {
        getSelection = getDocSelection;
        api.isSelectionValid = function(winParam) {
            var doc = (winParam || window).document, nativeSel = doc.selection;

            // Check whether the selection TextRange is actually contained within the correct document
            return (nativeSel.type != "None" || dom.getDocument(nativeSel.createRange().parentElement()) == doc);
        };
    } else if (implementsWinGetSelection) {
        getSelection = getWinSelection;
        api.isSelectionValid = function() {
            return true;
        };
    } else {
        module.fail("Neither document.selection or window.getSelection() detected.");
    }

    api.getNativeSelection = getSelection;

    var testSelection = getSelection();
    var testRange = api.createNativeRange(document);
    var body = dom.getBody(document);

    // Obtaining a range from a selection
    var selectionHasAnchorAndFocus = util.areHostObjects(testSelection, ["anchorNode", "focusNode"] &&
                                     util.areHostProperties(testSelection, ["anchorOffset", "focusOffset"]));
    api.features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;

    // Test for existence of native selection extend() method
    var selectionHasExtend = util.isHostMethod(testSelection, "extend");
    api.features.selectionHasExtend = selectionHasExtend;

    // Test if rangeCount exists
    var selectionHasRangeCount = (typeof testSelection.rangeCount == "number");
    api.features.selectionHasRangeCount = selectionHasRangeCount;

    var selectionSupportsMultipleRanges = false;
    var collapsedNonEditableSelectionsSupported = true;

    if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
            typeof testSelection.rangeCount == "number" && api.features.implementsDomRange) {

        (function() {
            var iframe = document.createElement("iframe");
            iframe.frameBorder = 0;
            iframe.style.position = "absolute";
            iframe.style.left = "-10000px";
            body.appendChild(iframe);

            var iframeDoc = dom.getIframeDocument(iframe);
            iframeDoc.open();
            iframeDoc.write("<html><head></head><body>12</body></html>");
            iframeDoc.close();

            var sel = dom.getIframeWindow(iframe).getSelection();
            var docEl = iframeDoc.documentElement;
            var iframeBody = docEl.lastChild, textNode = iframeBody.firstChild;

            // Test whether the native selection will allow a collapsed selection within a non-editable element
            var r1 = iframeDoc.createRange();
            r1.setStart(textNode, 1);
            r1.collapse(true);
            sel.addRange(r1);
            collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
            sel.removeAllRanges();

            //deprecated feature
            selectionSupportsMultipleRanges = false

            // // Test whether the native selection is capable of supporting multiple ranges
            // var r2 = r1.cloneRange();
            // r1.setStart(textNode, 0);
            // r2.setEnd(textNode, 2);
            // sel.addRange(r1);
            // sel.addRange(r2);

            // selectionSupportsMultipleRanges = (sel.rangeCount == 2);

            // Clean up
            r1.detach();
            // r2.detach();

            body.removeChild(iframe);
        })();
    }

    api.features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
    api.features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;

    // ControlRanges
    var implementsControlRange = false, testControlRange;

    if (body && util.isHostMethod(body, "createControlRange")) {
        testControlRange = body.createControlRange();
        if (util.areHostProperties(testControlRange, ["item", "add"])) {
            implementsControlRange = true;
        }
    }
    api.features.implementsControlRange = implementsControlRange;

    // Selection collapsedness
    if (selectionHasAnchorAndFocus) {
        selectionIsCollapsed = function(sel) {
            return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
        };
    } else {
        selectionIsCollapsed = function(sel) {
            return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
        };
    }

    function updateAnchorAndFocusFromRange(sel, range, backwards) {
        var anchorPrefix = backwards ? "end" : "start", focusPrefix = backwards ? "start" : "end";
        sel.anchorNode = range[anchorPrefix + "Container"];
        sel.anchorOffset = range[anchorPrefix + "Offset"];
        sel.focusNode = range[focusPrefix + "Container"];
        sel.focusOffset = range[focusPrefix + "Offset"];
    }

    function updateAnchorAndFocusFromNativeSelection(sel) {
        var nativeSel = sel.nativeSelection;
        sel.anchorNode = nativeSel.anchorNode;
        sel.anchorOffset = nativeSel.anchorOffset;
        sel.focusNode = nativeSel.focusNode;
        sel.focusOffset = nativeSel.focusOffset;
    }

    function updateEmptySelection(sel) {
        sel.anchorNode = sel.focusNode = null;
        sel.anchorOffset = sel.focusOffset = 0;
        sel.rangeCount = 0;
        sel.isCollapsed = true;
        sel._ranges.length = 0;
    }

    function getNativeRange(range) {
        var nativeRange;
        if (range instanceof DomRange) {
            nativeRange = range._selectionNativeRange;
            if (!nativeRange) {
                nativeRange = api.createNativeRange(dom.getDocument(range.startContainer));
                nativeRange.setEnd(range.endContainer, range.endOffset);
                nativeRange.setStart(range.startContainer, range.startOffset);
                range._selectionNativeRange = nativeRange;
                range.attachListener("detach", function() {

                    this._selectionNativeRange = null;
                });
            }
        } else if (range instanceof WrappedRange) {
            nativeRange = range.nativeRange;
        } else if (api.features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
            nativeRange = range;
        }
        return nativeRange;
    }

    function rangeContainsSingleElement(rangeNodes) {
        if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
            return false;
        }
        for (var i = 1, len = rangeNodes.length; i < len; ++i) {
            if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
                return false;
            }
        }
        return true;
    }

    function getSingleElementFromRange(range) {
        var nodes = range.getNodes();
        if (!rangeContainsSingleElement(nodes)) {
            throw new Error("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
        }
        return nodes[0];
    }

    function isTextRange(range) {
        return !!range && typeof range.text != "undefined";
    }

    function updateFromTextRange(sel, range) {
        // Create a Range from the selected TextRange
        var wrappedRange = new WrappedRange(range);
        sel._ranges = [wrappedRange];

        updateAnchorAndFocusFromRange(sel, wrappedRange, false);
        sel.rangeCount = 1;
        sel.isCollapsed = wrappedRange.collapsed;
    }

    function updateControlSelection(sel) {
        // Update the wrapped selection based on what's now in the native selection
        sel._ranges.length = 0;
        if (sel.docSelection.type == "None") {
            updateEmptySelection(sel);
        } else {
            var controlRange = sel.docSelection.createRange();
            if (isTextRange(controlRange)) {
                // This case (where the selection type is "Control" and calling createRange() on the selection returns
                // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
                // ControlRange have been removed from the ControlRange and removed from the document.
                updateFromTextRange(sel, controlRange);
            } else {
                sel.rangeCount = controlRange.length;
                var range, doc = dom.getDocument(controlRange.item(0));
                for (var i = 0; i < sel.rangeCount; ++i) {
                    range = api.createRange(doc);
                    range.selectNode(controlRange.item(i));
                    sel._ranges.push(range);
                }
                sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
                updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
            }
        }
    }

    function addRangeToControlSelection(sel, range) {
        var controlRange = sel.docSelection.createRange();
        var rangeElement = getSingleElementFromRange(range);

        // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
        // contained by the supplied range
        var doc = dom.getDocument(controlRange.item(0));
        var newControlRange = dom.getBody(doc).createControlRange();
        for (var i = 0, len = controlRange.length; i < len; ++i) {
            newControlRange.add(controlRange.item(i));
        }
        try {
            newControlRange.add(rangeElement);
        } catch (ex) {
            throw new Error("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
        }
        newControlRange.select();

        // Update the wrapped selection based on what's now in the native selection
        updateControlSelection(sel);
    }

    var getSelectionRangeAt;

    if (util.isHostMethod(testSelection,  "getRangeAt")) {
        getSelectionRangeAt = function(sel, index) {
            try {
                return sel.getRangeAt(index);
            } catch(ex) {
                return null;
            }
        };
    } else if (selectionHasAnchorAndFocus) {
        getSelectionRangeAt = function(sel) {
            var doc = dom.getDocument(sel.anchorNode);
            var range = api.createRange(doc);
            range.setStart(sel.anchorNode, sel.anchorOffset);
            range.setEnd(sel.focusNode, sel.focusOffset);

            // Handle the case when the selection was selected backwards (from the end to the start in the
            // document)
            if (range.collapsed !== this.isCollapsed) {
                range.setStart(sel.focusNode, sel.focusOffset);
                range.setEnd(sel.anchorNode, sel.anchorOffset);
            }

            return range;
        };
    }

    /**
     * @constructor
     */
    function WrappedSelection(selection, docSelection, win) {
        this.nativeSelection = selection;
        this.docSelection = docSelection;
        this._ranges = [];
        this.win = win;
        this.refresh();
    }

    api.getSelection = function(win) {
        win = win || window;
        var sel = win[windowPropertyName];
        var nativeSel = getSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
        if (sel) {
            sel.nativeSelection = nativeSel;
            sel.docSelection = docSel;
            sel.refresh(win);
        } else {
            sel = new WrappedSelection(nativeSel, docSel, win);
            win[windowPropertyName] = sel;
        }
        return sel;
    };

    api.getIframeSelection = function(iframeEl) {
        return api.getSelection(dom.getIframeWindow(iframeEl));
    };

    var selProto = WrappedSelection.prototype;

    function createControlSelection(sel, ranges) {
        // Ensure that the selection becomes of type "Control"
        var doc = dom.getDocument(ranges[0].startContainer);
        var controlRange = dom.getBody(doc).createControlRange();
        for (var i = 0, el; i < rangeCount; ++i) {
            el = getSingleElementFromRange(ranges[i]);
            try {
                controlRange.add(el);
            } catch (ex) {
                throw new Error("setRanges(): Element within the one of the specified Ranges could not be added to control selection (does it have layout?)");
            }
        }
        controlRange.select();

        // Update the wrapped selection based on what's now in the native selection
        updateControlSelection(sel);
    }

    // Selecting a range
    if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
        selProto.removeAllRanges = function() {
            this.nativeSelection.removeAllRanges();
            updateEmptySelection(this);
        };

        var addRangeBackwards = function(sel, range) {
            var doc = DomRange.getRangeDocument(range);
            var endRange = api.createRange(doc);
            endRange.collapseToPoint(range.endContainer, range.endOffset);
            sel.nativeSelection.addRange(getNativeRange(endRange));
            sel.nativeSelection.extend(range.startContainer, range.startOffset);
            sel.refresh();
        };

        if (selectionHasRangeCount) {
            selProto.addRange = function(range, backwards) {
                if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
                    addRangeToControlSelection(this, range);
                } else {
                    if (backwards && selectionHasExtend) {
                        addRangeBackwards(this, range);
                    } else {
                        var previousRangeCount;
                        if (selectionSupportsMultipleRanges) {
                            previousRangeCount = this.rangeCount;
                        } else {
                            this.removeAllRanges();
                            previousRangeCount = 0;
                        }
                        this.nativeSelection.addRange(getNativeRange(range));

                        // Check whether adding the range was successful
                        this.rangeCount = this.nativeSelection.rangeCount;

                        if (this.rangeCount == previousRangeCount + 1) {
                            // The range was added successfully

                            // Check whether the range that we added to the selection is reflected in the last range extracted from
                            // the selection
                            if (api.config.checkSelectionRanges) {
                                var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
                                if (nativeRange && !DomRange.rangesEqual(nativeRange, range)) {
                                    // Happens in WebKit with, for example, a selection placed at the start of a text node
                                    range = new WrappedRange(nativeRange);
                                }
                            }
                            this._ranges[this.rangeCount - 1] = range;
                            updateAnchorAndFocusFromRange(this, range, selectionIsBackwards(this.nativeSelection));
                            this.isCollapsed = selectionIsCollapsed(this);
                        } else {
                            // The range was not added successfully. The simplest thing is to refresh
                            this.refresh();
                        }
                    }
                }
            };
        } else {
            selProto.addRange = function(range, backwards) {
                if (backwards && selectionHasExtend) {
                    addRangeBackwards(this, range);
                } else {
                    this.nativeSelection.addRange(getNativeRange(range));
                    this.refresh();
                }
            };
        }

        selProto.setRanges = function(ranges) {
            if (implementsControlRange && ranges.length > 1) {
                createControlSelection(this, ranges);
            } else {
                this.removeAllRanges();
                for (var i = 0, len = ranges.length; i < len; ++i) {
                    this.addRange(ranges[i]);
                }
            }
        };
    } else if (util.isHostMethod(testSelection, "empty") && util.isHostMethod(testRange, "select") &&
               implementsControlRange && useDocumentSelection) {

        selProto.removeAllRanges = function() {
            // Added try/catch as fix for issue #21
            try {
                this.docSelection.empty();

                // Check for empty() not working (issue #24)
                if (this.docSelection.type != "None") {
                    // Work around failure to empty a control selection by instead selecting a TextRange and then
                    // calling empty()
                    var doc;
                    if (this.anchorNode) {
                        doc = dom.getDocument(this.anchorNode);
                    } else if (this.docSelection.type == CONTROL) {
                        var controlRange = this.docSelection.createRange();
                        if (controlRange.length) {
                            doc = dom.getDocument(controlRange.item(0)).body.createTextRange();
                        }
                    }
                    if (doc) {
                        var textRange = doc.body.createTextRange();
                        textRange.select();
                        this.docSelection.empty();
                    }
                }
            } catch(ex) {}
            updateEmptySelection(this);
        };

        selProto.addRange = function(range) {
            if (this.docSelection.type == CONTROL) {
                addRangeToControlSelection(this, range);
            } else {
                WrappedRange.rangeToTextRange(range).select();
                this._ranges[0] = range;
                this.rangeCount = 1;
                this.isCollapsed = this._ranges[0].collapsed;
                updateAnchorAndFocusFromRange(this, range, false);
            }
        };

        selProto.setRanges = function(ranges) {
            this.removeAllRanges();
            var rangeCount = ranges.length;
            if (rangeCount > 1) {
                createControlSelection(this, ranges);
            } else if (rangeCount) {
                this.addRange(ranges[0]);
            }
        };
    } else {
        module.fail("No means of selecting a Range or TextRange was found");
        return false;
    }

    selProto.getRangeAt = function(index) {
        if (index < 0 || index >= this.rangeCount) {
            throw new DOMException("INDEX_SIZE_ERR");
        } else {
            return this._ranges[index];
        }
    };

    var refreshSelection;

    if (useDocumentSelection) {
        refreshSelection = function(sel) {
            var range;
            if (api.isSelectionValid(sel.win)) {
                range = sel.docSelection.createRange();
            } else {
                range = dom.getBody(sel.win.document).createTextRange();
                range.collapse(true);
            }


            if (sel.docSelection.type == CONTROL) {
                updateControlSelection(sel);
            } else if (isTextRange(range)) {
                updateFromTextRange(sel, range);
            } else {
                updateEmptySelection(sel);
            }
        };
    } else if (util.isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == "number") {
        refreshSelection = function(sel) {
            if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
                updateControlSelection(sel);
            } else {
                sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
                if (sel.rangeCount) {
                    for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                        sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
                    }
                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackwards(sel.nativeSelection));
                    sel.isCollapsed = selectionIsCollapsed(sel);
                } else {
                    updateEmptySelection(sel);
                }
            }
        };
    } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && api.features.implementsDomRange) {
        refreshSelection = function(sel) {
            var range, nativeSel = sel.nativeSelection;
            if (nativeSel.anchorNode) {
                range = getSelectionRangeAt(nativeSel, 0);
                sel._ranges = [range];
                sel.rangeCount = 1;
                updateAnchorAndFocusFromNativeSelection(sel);
                sel.isCollapsed = selectionIsCollapsed(sel);
            } else {
                updateEmptySelection(sel);
            }
        };
    } else {
        module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
        return false;
    }

    selProto.refresh = function(checkForChanges) {
        var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
        refreshSelection(this);
        if (checkForChanges) {
            var i = oldRanges.length;
            if (i != this._ranges.length) {
                return false;
            }
            while (i--) {
                if (!DomRange.rangesEqual(oldRanges[i], this._ranges[i])) {
                    return false;
                }
            }
            return true;
        }
    };

    // Removal of a single range
    var removeRangeManually = function(sel, range) {
        var ranges = sel.getAllRanges(), removed = false;
        sel.removeAllRanges();
        for (var i = 0, len = ranges.length; i < len; ++i) {
            if (removed || range !== ranges[i]) {
                sel.addRange(ranges[i]);
            } else {
                // According to the draft WHATWG Range spec, the same range may be added to the selection multiple
                // times. removeRange should only remove the first instance, so the following ensures only the first
                // instance is removed
                removed = true;
            }
        }
        if (!sel.rangeCount) {
            updateEmptySelection(sel);
        }
    };

    if (implementsControlRange) {
        selProto.removeRange = function(range) {
            if (this.docSelection.type == CONTROL) {
                var controlRange = this.docSelection.createRange();
                var rangeElement = getSingleElementFromRange(range);

                // Create a new ControlRange containing all the elements in the selected ControlRange minus the
                // element contained by the supplied range
                var doc = dom.getDocument(controlRange.item(0));
                var newControlRange = dom.getBody(doc).createControlRange();
                var el, removed = false;
                for (var i = 0, len = controlRange.length; i < len; ++i) {
                    el = controlRange.item(i);
                    if (el !== rangeElement || removed) {
                        newControlRange.add(controlRange.item(i));
                    } else {
                        removed = true;
                    }
                }
                newControlRange.select();

                // Update the wrapped selection based on what's now in the native selection
                updateControlSelection(this);
            } else {
                removeRangeManually(this, range);
            }
        };
    } else {
        selProto.removeRange = function(range) {
            removeRangeManually(this, range);
        };
    }

    // Detecting if a selection is backwards
    var selectionIsBackwards;
    if (!useDocumentSelection && selectionHasAnchorAndFocus && api.features.implementsDomRange) {
        selectionIsBackwards = function(sel) {
            var backwards = false;
            if (sel.anchorNode) {
                backwards = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
            }
            return backwards;
        };

        selProto.isBackwards = function() {
            return selectionIsBackwards(this);
        };
    } else {
        selectionIsBackwards = selProto.isBackwards = function() {
            return false;
        };
    }

    // Selection text
    // This is conformant to the new WHATWG DOM Range draft spec but differs from WebKit and Mozilla's implementation
    selProto.toString = function() {

        var rangeTexts = [];
        for (var i = 0, len = this.rangeCount; i < len; ++i) {
            rangeTexts[i] = "" + this._ranges[i];
        }
        return rangeTexts.join("");
    };

    function assertNodeInSameDocument(sel, node) {
        if (sel.anchorNode && (dom.getDocument(sel.anchorNode) !== dom.getDocument(node))) {
            throw new DOMException("WRONG_DOCUMENT_ERR");
        }
    }

    // No current browsers conform fully to the HTML 5 draft spec for this method, so Rangy's own method is always used
    selProto.collapse = function(node, offset) {
        assertNodeInSameDocument(this, node);
        var range = api.createRange(dom.getDocument(node));
        range.collapseToPoint(node, offset);
        this.removeAllRanges();
        this.addRange(range);
        this.isCollapsed = true;
    };

    selProto.collapseToStart = function() {
        if (this.rangeCount) {
            var range = this._ranges[0];
            this.collapse(range.startContainer, range.startOffset);
        } else {
            throw new DOMException("INVALID_STATE_ERR");
        }
    };

    selProto.collapseToEnd = function() {
        if (this.rangeCount) {
            var range = this._ranges[this.rangeCount - 1];
            this.collapse(range.endContainer, range.endOffset);
        } else {
            throw new DOMException("INVALID_STATE_ERR");
        }
    };

    // The HTML 5 spec is very specific on how selectAllChildren should be implemented so the native implementation is
    // never used by Rangy.
    selProto.selectAllChildren = function(node) {
        assertNodeInSameDocument(this, node);
        var range = api.createRange(dom.getDocument(node));
        range.selectNodeContents(node);
        this.removeAllRanges();
        this.addRange(range);
    };

    selProto.deleteFromDocument = function() {
        // Sepcial behaviour required for Control selections
        if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
            var controlRange = this.docSelection.createRange();
            var element;
            while (controlRange.length) {
                element = controlRange.item(0);
                controlRange.remove(element);
                element.parentNode.removeChild(element);
            }
            this.refresh();
        } else if (this.rangeCount) {
            var ranges = this.getAllRanges();
            this.removeAllRanges();
            for (var i = 0, len = ranges.length; i < len; ++i) {
                ranges[i].deleteContents();
            }
            // The HTML5 spec says nothing about what the selection should contain after calling deleteContents on each
            // range. Firefox moves the selection to where the final selected range was, so we emulate that
            this.addRange(ranges[len - 1]);
        }
    };

    // The following are non-standard extensions
    selProto.getAllRanges = function() {
        return this._ranges.slice(0);
    };

    selProto.setSingleRange = function(range) {
        this.setRanges( [range] );
    };

    selProto.containsNode = function(node, allowPartial) {
        for (var i = 0, len = this._ranges.length; i < len; ++i) {
            if (this._ranges[i].containsNode(node, allowPartial)) {
                return true;
            }
        }
        return false;
    };

    selProto.toHtml = function() {
        var html = "";
        if (this.rangeCount) {
            var container = DomRange.getRangeDocument(this._ranges[0]).createElement("div");
            for (var i = 0, len = this._ranges.length; i < len; ++i) {
                container.appendChild(this._ranges[i].cloneContents());
            }
            html = container.innerHTML;
        }
        return html;
    };

    function inspect(sel) {
        var rangeInspects = [];
        var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
        var focus = new DomPosition(sel.focusNode, sel.focusOffset);
        var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";

        if (typeof sel.rangeCount != "undefined") {
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
                rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
            }
        }
        return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
                ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";

    }

    selProto.getName = function() {
        return "WrappedSelection";
    };

    selProto.inspect = function() {
        return inspect(this);
    };

    selProto.detach = function() {
        this.win[windowPropertyName] = null;
        this.win = this.anchorNode = this.focusNode = null;
    };

    WrappedSelection.inspect = inspect;

    api.Selection = WrappedSelection;

    api.selectionPrototype = selProto;

    api.addCreateMissingNativeApiListener(function(win) {
        if (typeof win.getSelection == "undefined") {
            win.getSelection = function() {
                return api.getSelection(this);
            };
        }
        win = null;
    });
});

(function () {

  var exports = this,
    defaults, InlineChangeEditor;

  defaults = {
    // ice node attribute names:
    changeIdAttribute: 'data-cid',
    userIdAttribute: 'data-userid',
    userNameAttribute: 'data-username',
    timeAttribute: 'data-time',

    // Prepended to `changeType.alias` for classname uniqueness, if needed
    attrValuePrefix: '',

    // Block element tagname, which wrap text and other inline nodes in `this.element`
    blockEl: 'p',

    // All permitted block element tagnames
    blockEls: ['p', 'ol', 'ul', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote'],

    // Unique style prefix, prepended to a digit, incremented for each encountered user, and stored
    // in ice node class attributes - cts1, cts2, cts3, ...
    stylePrefix: 'cts',
    currentUser: {
      id: null,
      name: null
    },

    // Default change types are insert and delete. Plugins or outside apps should extend this
    // if they want to manage new change types. The changeType name is used as a primary
    // reference for ice nodes; the `alias`, is dropped in the class attribute and is the
    // primary method of identifying ice nodes; and `tag` is used for construction only.
    // Invoking `this.getCleanContent()` will remove all delete type nodes and remove the tags
    // for the other types, leaving the html content in place.
    changeTypes: {
      insertType: {
        tag: 'span',
        alias: 'ins',
        action: 'Inserted'
      },
      deleteType: {
        tag: 'span',
        alias: 'del',
        action: 'Deleted'
      }
    },

    // If `true`, setup event listeners on `this.element` and handle events - good option for a basic
    // setup without a text editor. Otherwise, when set to `false`, events need to be manually passed
    // to `handleEvent`, which is good for a text editor with an event callback handler, like tinymce.
    handleEvents: false,

    // Sets this.element with the contentEditable element
    contentEditable: true,

    // Switch for toggling track changes on/off - when `false` events will be ignored.
    isTracking: false,

    // NOT IMPLEMENTED - Selector for elements that will not get track changes
    noTrack: '.ice-no-track',

    // Selector for elements to avoid - move range before or after - similar handling to deletes
    avoid: '.ice-avoid',

    // Switch for whether paragraph breaks should be removed when the user is deleting over a
    // paragraph break while changes are tracked.
    mergeBlocks: true,
  };

  InlineChangeEditor = function (options) {

    // Data structure for modelling changes in the element according to the following model:
    //  [changeid] => {`type`, `time`, `userid`, `username`}
    this._changes = {};

    options || (options = {});
    if (!options.element) throw Error("`options.element` must be defined for ice construction.");

    ice.dom.extend(true, this, defaults, options);

    this.pluginsManager = new ice.IcePluginManager(this);
    if (options.plugins) this.pluginsManager.usePlugins('ice-init', options.plugins);
  };

  InlineChangeEditor.prototype = {
    // Tracks all of the styles for users according to the following model:
    //  [userId] => styleId; where style is "this.stylePrefix" + "this.uniqueStyleIndex"
    _userStyles: {},
    _styles: {},

    // Incremented for each new user and appended to they style prefix, and dropped in the
    // ice node class attribute.
    _uniqueStyleIndex: 0,

    // _browserType: null,

    // One change may create multiple ice nodes, so this keeps track of the current batch id.
    _batchChangeid: null,

    // Incremented for each new change, dropped in the changeIdAttribute.
    _uniqueIDIndex: 1,

    // Temporary bookmark tags for deletes, when delete placeholding is active.
    _delBookmark: 'tempdel',
    isPlaceHoldingDeletes: false,

    /**
     * Turns on change tracking - sets up events, if needed, and initializes the environment,
     * range, and editor.
     */
    initialize: function () {
      this.element.setAttribute('contentEditable', this.contentEditable);
      document.execCommand('styleWithCSS', null, true)

      // If we are handling events setup the delegate to handle various events on `this.element`.
      if (this.handleEvents) {
        var self = this;
        ice.dom.bind(self.element, 'keyup.ice keydown.ice keypress.ice mousedown.ice mouseup.ice', function (e) {
          return self.handleEvent(e);
        });
      }

      this.initializeEnvironment();
      this.initializeEditor();
      this.findTrackTags();
      this.initializeRange();

      this.pluginsManager.fireEnabled(this.element);
      return this;
    },

    /**
     * Removes contenteditability and stops event handling.
     */
    disable: function () {
      this.element.setAttribute('contentEditable', false);

      // If we are handling events setup the delegate to handle various events on `this.element`.
      if (this.handleEvents) {
        var self = this;
        ice.dom.unbind(self.element, 'keyup.ice keydown.ice keypress.ice mousedown.ice mouseup.ice');
      }

      this.pluginsManager.fireDisabled(this.element);
      return this;
    },

    /**
     * Initializes the `env` object with pointers to key objects of the page.
     */
    initializeEnvironment: function () {
      this.env || (this.env = {});
      this.env.element = this.element;
      this.env.document = this.element.ownerDocument;
      this.env.window = this.env.document.defaultView || this.env.document.parentWindow || window;
      this.env.frame = this.env.window.frameElement;
      this.env.selection = this.selection = new ice.Selection(this.env);
      // Hack for using custom tags in IE 8/7
      this.env.document.createElement(this.changeTypes.insertType.tag);
      this.env.document.createElement(this.changeTypes.deleteType.tag);
    },

    /**
     * Initializes the internal range object and sets focus to the editing element.
     */
    initializeRange: function () {
      var range = this.selection.createRange();
      range.setStart(ice.dom.find(this.element, this.blockEls.join(', '))[0], 0);
      range.collapse(true);
      this.selection.addRange(range);
      if (this.env.frame) this.env.frame.contentWindow.focus();
      else this.element.focus();
    },

    /**
     * Initializes the content in the editor - cleans non-block nodes found between blocks.
     */
    initializeEditor: function () {
      // Clean the element html body - add an empty block if there is no body, or remove any
      // content between elements.
      var body = this.env.document.createElement('div');
      if (this.element.childNodes.length) {
        body.innerHTML = this.element.innerHTML;
        ice.dom.removeWhitespace(body);
      }
      if (body.innerHTML === '') {
        body.innerHTML = '<' + this.blockEl + '><br/></' + this.blockEl + '><' + this.blockEl + '><br/></' + this.blockEl + '>';
      }
      if (this.element.innerHTML != body.innerHTML) {
        this.element.innerHTML = body.innerHTML;
      }

    },

    find: function(exp) {
        return ice.dom.find(this.element, exp)
    },

    /*
     * Updates the list of changes to include all track tags found inside the element.
     */
    findTrackTags: function () {

      // Grab class for each changeType
      var self = this, changeTypeClasses = [];
      for (var changeType in this.changeTypes) {
        changeTypeClasses.push(this._getIceNodeClass(changeType));
      }

      ice.dom.each(ice.dom.find(this.element, '.' + changeTypeClasses.join(', .')), function (i, el) {
        var styleIndex = 0;
        var ctnType = '';
        var classList = el.className.split(' ');
        for (var i = 0; i < classList.length; i++) {
          var styleReg = new RegExp(self.stylePrefix + '-(\\d+)').exec(classList[i]);
          if (styleReg) styleIndex = styleReg[1];
          var ctnReg = new RegExp('(' + changeTypeClasses.join('|') + ')').exec(classList[i]);
          if (ctnReg) ctnType = self._getChangeTypeFromAlias(ctnReg[1]);
        }
        var userid = ice.dom.attr(el, self.userIdAttribute);
        self.setUserStyle(userid, Number(styleIndex));
        var changeid = ice.dom.attr(el, self.changeIdAttribute);
        self._changes[changeid] = {
          type: ctnType,
          userid: userid,
          username: ice.dom.attr(el, self.userNameAttribute),
          time: ice.dom.attr(el, self.timeAttribute)
        };
      });
    },

    /**
     * Turn on change tracking and event handling.
     */
    enableChangeTracking: function () {
      this.isTracking = true;
      this.pluginsManager.fireEnabled(this.element);
    },

    /**
     * Turn off change tracking and event handling.
     */
    disableChangeTracking: function () {
      this.isTracking = false;
      this.pluginsManager.fireDisabled(this.element);
    },

    /**
     * Set the user to be tracked. A user object has the following properties:
     * {`id`, `name`}
     */
    // setCurrentUser: function (user) {
    //   this.currentUser = user;
    // },

    /**
     * If tracking is on, handles event e when it is one of the following types:
     * mouseup, mousedown, keypress, keydown, and keyup. Each event type is
     * propagated to all of the plugins. Prevents default handling if the event
     * was fully handled.
     */
    handleEvent: function (e) {
      if (!this.isTracking) return;
      if (e.type == 'mouseup') {
        var self = this;
        setTimeout(function () {
          self.mouseUp(e);
        }, 200);
      } else if (e.type == 'mousedown') {
        return this.mouseDown(e);
      } else if (e.type == 'keypress') {
        var needsToBubble = this.keyPress(e);
        if (!needsToBubble) e.preventDefault();
        return needsToBubble;
      } else if (e.type == 'keydown') {
        var needsToBubble = this.keyDown(e);
        if (!needsToBubble) e.preventDefault();
        return needsToBubble;
      } else if (e.type == 'keyup') {
        this.ensureEmptyEnd();
        this.pluginsManager.fireCaretUpdated();
      }
    },
    visible: function (el) {
      if (el.nodeType === ice.dom.TEXT_NODE) el = el.parentNode;
      var rect = el.getBoundingClientRect();
      return (rect.top > 0 && rect.left > 0);
    },

    ensureEmptyEnd: function(){
      var c = this.element.children.length
      var lastNode = ""
      if (c > 0) {
          lastNode = this.element.children[this.element.children.length - 1].innerHTML
      }
      if (lastNode != "<br>") {
          this.element.appendChild(ice.dom.create("<p><br></p>"))
      }
    },

    /**
     * Returns a tracking tag for the given `changeType`, with the optional `childNode` appended.
     */
    createIceNode: function (changeType, childNode) {
      var node = this.env.document.createElement(this.changeTypes[changeType].tag);
      ice.dom.addClass(node, this._getIceNodeClass(changeType));

      
      node.appendChild(childNode ? childNode : this.env.document.createTextNode(''));
      this.addChange(this.changeTypes[changeType].alias, [node]);

      this.pluginsManager.fireNodeCreated(node, {
        'action': this.changeTypes[changeType].action
      });
      return node;
    },

    /**
     * Inserts the given string/node into the given range with tracking tags, collapsing (deleting)
     * the range first if needed. If range is undefined, then the range from the Selection object
     * is used. If the range is in a parent delete node, then the range is positioned after the delete.
     */
    insert: function (node, range) {
      // If the node is not defined, then we need to insert an
      // invisible space and force propagation to the browser.
      var isPropagating = !node;
      node || (node = '\uFEFF');

      if (range) this.selection.addRange(range);
      else range = this.getCurrentRange();

      if (typeof node === "string") node = document.createTextNode(node);

      // If we have any nodes selected, then we want to delete them before inserting the new text.
      if (!range.collapsed) {
        this.deleteContents();
        // Update the range
        range = this.getCurrentRange();
        if (range.startContainer === range.endContainer && this.element === range.startContainer) {
          // The whole editable element is selected. Need to remove everything and init its contents.
          ice.dom.empty(this.element);
          var firstSelectable = range.getLastSelectableChild(this.element);
          range.setStartAfter(firstSelectable);
          range.collapse(true);
        }
      }
      // If we are in a non-tracking/void element, move the range to the end/outside.
      this._moveRangeToValidTrackingPos(range);

      var changeid = this.startBatchChange();
      // Send a dummy node to be inserted, if node is undefined
      this._insertNode(node, range, isPropagating);
      this.pluginsManager.fireNodeInserted(node, range);
      this.endBatchChange(changeid);
      return isPropagating;
    },

    /**
     * This command will drop placeholders in place of delete tags in the element
     * body and store references in the `_deletes` array to the original delete nodes.
     *
     * A placeholder tag is of the following structure:
     *   <tempdel data-allocation="[NUM]" />
     * Where [NUM] is the referenced allocation in the `_deletes` array where the
     * original delete node is stored.
     */
    placeholdDeletes: function () {
      var self = this;
      if (this.isPlaceholdingDeletes) {
        this.revertDeletePlaceholders();
      }
      this.isPlaceholdingDeletes = true;
      this._deletes = [];
      var deleteSelector = '.' + this._getIceNodeClass('deleteType');
      ice.dom.each(ice.dom.find(this.element, deleteSelector), function (i, el) {
        self._deletes.push(ice.dom.cloneNode(el));
        ice.dom.replaceWith(el, '<' + self._delBookmark + ' data-allocation="' + (self._deletes.length - 1) + '"/>');
      });
      return true;
    },

    /**
     * Replaces all delete placeholders in the element body with the referenced
     * delete nodes in the `_deletes` array.
     *
     * A placeholder tag is of the following structure:
     *   <tempdel data-allocation="[NUM]" />
     * Where [NUM] is the referenced allocation in the `_deletes` array where the
     * original delete node is stored.
     */
    revertDeletePlaceholders: function () {
      var self = this;
      if (!this.isPlaceholdingDeletes) {
        return false;
      }
      ice.dom.each(this._deletes, function (i, el) {
        ice.dom.find(self.element, self._delBookmark + '[data-allocation=' + i + ']').replaceWith(el);
      });
      this.isPlaceholdingDeletes = false;
      return true;
    },
    /**
     * Deletes the contents in the given range or the range from the Selection object. If the range
     * is not collapsed, then a selection delete is handled; otherwise, it deletes one character
     * to the left or right if the right parameter is false or true, respectively.
     *
     * @return true if deletion was handled.
     */
    deleteContents: function (right, range) {
      var prevent = true;
      //var browser = ice.dom.browser();

      if (range) {
        this.selection.addRange(range);
      } else {
        range = this.getCurrentRange();
      }

      var changeid = this.startBatchChange(this.changeTypes['deleteType'].alias);
      if (range.collapsed === false) {
        if (this._currentUserIceNode(range.startContainer.parentNode)) {
          this._deleteSelection(range);
        } else {
          this._deleteSelection(range);
          // if (browser["type"] === "mozilla") {
          //   if (range.startContainer.parentNode.previousSibling) {
          //     range.setEnd(range.startContainer.parentNode.previousSibling, 0);
          //     range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
          //   } else {
          //     range.setEndAfter(range.startContainer.parentNode);
          //   }
          //   range.collapse(false);
          // } else {
          //   if (!this.visible(range.endContainer)) {
          //     range.setEnd(range.endContainer, range.endOffset - 1);
          //     range.collapse(false);
          //   }
          // }
        }
      } else {
        if (right) {
          // RIGHT DELETE
          // if (browser["type"] === "mozilla") {
          //   prevent = this._deleteRight(range);
          //   // Handling track change show/hide
          //   if (!this.visible(range.endContainer)) {
          //     if (range.endContainer.parentNode.nextSibling) {
          //       //            range.setEnd(range.endContainer.parentNode.nextSibling, 0);
          //       range.setEndBefore(range.endContainer.parentNode.nextSibling);
          //     } else {
          //       range.setEndAfter(range.endContainer);
          //     }
          //     range.collapse(false);
          //   }
          // }
          // else {
            // Calibrate Cursor before deleting
            if (range.endOffset === ice.dom.getNodeCharacterLength(range.endContainer)) {
              var next = range.startContainer.nextSibling;
              if (ice.dom.is(next, '.' + this._getIceNodeClass('deleteType'))) {
                while (next) {
                  if (ice.dom.is(next, '.' + this._getIceNodeClass('deleteType'))) {
                    next = next.nextSibling;
                    continue;
                  }
                  range.setStart(next, 0);
                  range.collapse(true);
                  break;
                }
              }
            }

            // Delete
            prevent = this._deleteRight(range);

            // Calibrate Cursor after deleting
            if (!this.visible(range.endContainer)) {
              if (ice.dom.is(range.endContainer.parentNode, '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType'))) {
                //            range.setStart(range.endContainer.parentNode.nextSibling, 0);
                range.setStartAfter(range.endContainer.parentNode);
                range.collapse(true);
              }
            }
          }
        // }
        else {
          // LEFT DELETE
          // if (browser["type"] === "mozilla") {
          //   prevent = this._deleteLeft(range);
          //   // Handling track change show/hide
          //   if (!this.visible(range.startContainer)) {
          //     if (range.startContainer.parentNode.previousSibling) {
          //       range.setEnd(range.startContainer.parentNode.previousSibling, 0);
          //     } else {
          //       range.setEnd(range.startContainer.parentNode, 0);
          //     }
          //     range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
          //     range.collapse(false);
          //   }
          // }
          // else {
            if (!this.visible(range.startContainer)) {
              if (range.endOffset === ice.dom.getNodeCharacterLength(range.endContainer)) {
                var prev = range.startContainer.previousSibling;
                if (ice.dom.is(prev, '.' + this._getIceNodeClass('deleteType'))) {
                  while (prev) {
                    if (ice.dom.is(prev, '.' + this._getIceNodeClass('deleteType'))) {
                      prev = prev.prevSibling;
                      continue;
                    }
                    range.setEndBefore(prev.nextSibling, 0);
                    range.collapse(false);
                    break;
                  }
                }
              }
            }
            prevent = this._deleteLeft(range);
          // }
        }
      }

      this.selection.addRange(range);
      this.endBatchChange(changeid);
      return prevent;
    },

    /**
     * Returns the changes - a hash of objects with the following properties:
     * [changeid] => {`type`, `time`, `userid`, `username`}
     */
    getChanges: function () {
      return this._changes;
    },

    /**
     * Returns an array with the user ids who made the changes
     */
    getChangeUserids: function () {
      var result = [];
      var keys = Object.keys(this._changes);

      for (var key in keys)
        result.push(this._changes[keys[key]].userid);

      return result.sort().filter(function (el, i, a) {
        if (i == a.indexOf(el)) return 1;
        return 0;
      });
    },

    /**
     * Returns the html contents for the tracked element.
     */
    getElementContent: function () {
      return this.element.innerHTML;
    },

    /**
     * Returns the html contents, without tracking tags, for `this.element` or
     * the optional `body` param which can be of either type string or node.
     * Delete tags, and their html content, are completely removed; all other
     * change type tags are removed, leaving the html content in place. After
     * cleaning, the optional `callback` is executed, which should further
     * modify and return the element body.
     *
     * prepare gets run before the body is cleaned by ice.
     */
    getCleanContent: function (body, callback, prepare) {
      var classList = '';
      var self = this;
      ice.dom.each(this.changeTypes, function (type, i) {
        if (type != 'deleteType') {
          if (i > 0) classList += ',';
          classList += '.' + self._getIceNodeClass(type);
        }
      });
      if (body) {
        if (typeof body === 'string') body = ice.dom.create('<div>' + body + '</div>');
        else body = ice.dom.cloneNode(body, false)[0];
      } else {
        body = ice.dom.cloneNode(this.element, false)[0];
      }
      body = prepare ? prepare.call(this, body) : body;
      var changes = ice.dom.find(body, classList);
      ice.dom.each(changes, function (el, i) {
        ice.dom.replaceWith(this, ice.dom.contents(this));
      });
      var deletes = ice.dom.find(body, '.' + this._getIceNodeClass('deleteType'));
      ice.dom.remove(deletes);

      body = callback ? callback.call(this, body) : body;

      return body.innerHTML;
    },

    /**
     * Accepts all changes in the element body - removes delete nodes, and removes outer
     * insert tags keeping the inner content in place.
     */
    acceptAll: function () {
      this.element.innerHTML = this.getCleanContent();
    },

    /**
     * Rejects all changes in the element body - removes insert nodes, and removes outer
     * delete tags keeping the inner content in place.*
     */
    rejectAll: function () {
      var insSel = '.' + this._getIceNodeClass('insertType');
      var delSel = '.' + this._getIceNodeClass('deleteType');

      ice.dom.remove(ice.dom.find(this.element, insSel));
      ice.dom.each(ice.dom.find(this.element, delSel), function (i, el) {
        ice.dom.replaceWith(el, ice.dom.contents(el));
      });
    },

    /**
     * Accepts the change at the given, or first tracking parent node of, `node`.  If
     * `node` is undefined then the startContainer of the current collapsed range will be used.
     * In the case of insert, inner content will be used to replace the containing tag; and in
     * the case of delete, the node will be removed.
     */
    acceptChange: function (node) {
      this.acceptRejectChange(node, true);
    },

    /**
     * Rejects the change at the given, or first tracking parent node of, `node`.  If
     * `node` is undefined then the startContainer of the current collapsed range will be used.
     * In the case of delete, inner content will be used to replace the containing tag; and in
     * the case of insert, the node will be removed.
     */
    rejectChange: function (node) {
      this.acceptRejectChange(node, false);
    },

    /**
     * Handles accepting or rejecting tracking changes
     */
    acceptRejectChange: function (node, isAccept) {
      var delSel, insSel, selector, removeSel, replaceSel, trackNode, changes, dom = ice.dom;

      if (!node) {
        var range = this.getCurrentRange();
        if (!range.collapsed) return;
        else node = range.startContainer;
      }

      delSel = removeSel = '.' + this._getIceNodeClass('deleteType');
      insSel = replaceSel = '.' + this._getIceNodeClass('insertType');
      selector = delSel + ',' + insSel;
      trackNode = dom.getNode(node, selector);
      // Some changes are done in batches so there may be other tracking
      // nodes with the same `changeIdAttribute` batch number.
      changes = dom.find(this.element, '[' + this.changeIdAttribute + '=' + dom.attr(trackNode, this.changeIdAttribute) + ']');

      if (!isAccept) {
        removeSel = insSel;
        replaceSel = delSel;
      }

      if (ice.dom.is(trackNode, replaceSel)) {
        dom.each(changes, function (i, node) {
          dom.replaceWith(node, ice.dom.contents(node));
        });
      } else if (dom.is(trackNode, removeSel)) {
        dom.remove(changes);
      }
    },

    /**
     * Returns true if the given `node`, or the current collapsed range is in a tracking
     * node; otherwise, false.
     */
    isInsideChange: function (node) {
      var selector = '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType');
      if (!node) {
        range = this.getCurrentRange();
        if (!range.collapsed) return false;
        else node = range.startContainer;
      }
      return !!ice.dom.getNode(node, selector);
    },

    /**
     * Add a new change tracking typeName with the given tag and alias.
     */
    addChangeType: function (typeName, tag, alias, action) {
      var changeType = {
        tag: tag,
        alias: alias
      };

      if (action) changeType.action = action;

      this.changeTypes[typeName] = changeType;
    },

    /**
     * Returns this `node` or the first parent tracking node with the given `changeType`.
     */
    getIceNode: function (node, changeType) {
      var selector = '.' + this._getIceNodeClass(changeType);
      return ice.dom.getNode(node, selector);
    },

    /**
     * Sets the given `range` to the first position, to the right, where it is outside of
     * void elements.
     */
    _moveRangeToValidTrackingPos: function (range) {
      var onEdge = false;
      var voidEl = this._getVoidElement(range.endContainer);
      while (voidEl) {
        // Move end of range to position it inside of any potential adjacent containers
        // E.G.:  test|<em>text</em>  ->  test<em>|text</em>
        try {
          range.moveEnd(ice.dom.CHARACTER_UNIT, 1);
          range.moveEnd(ice.dom.CHARACTER_UNIT, -1);
        } catch (e) {
          // Moving outside of the element and nothing is left on the page
          onEdge = true;
        }
        if (onEdge || ice.dom.onBlockBoundary(range.endContainer, range.startContainer, this.blockEls)) {
          range.setStartAfter(voidEl);
          range.collapse(true);
          break;
        }
        voidEl = this._getVoidElement(range.endContainer);
        if (voidEl) {
          range.setEnd(range.endContainer, 0);
          range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
          range.collapse();
        } else {
          range.setStart(range.endContainer, 0);
          range.collapse(true);
        }
      }
    },

    /**
     * Returns the given `node` or the first parent node that matches against the list of no track elements.
     */
    _getNoTrackElement: function (node) {
      var noTrackSelector = this._getNoTrackSelector();
      var parent = ice.dom.is(node, noTrackSelector) ? node : (ice.dom.parents(node, noTrackSelector)[0] || null);
      return parent;
    },

    /**
     * Returns a selector for not tracking changes
     */
    _getNoTrackSelector: function () {
      return this.noTrack;
    },

    /**
     * Returns the given `node` or the first parent node that matches against the list of void elements.
     */
    _getVoidElement: function (node) {
      var voidSelector = this._getVoidElSelector();
      return ice.dom.is(node, voidSelector) ? node : (ice.dom.parents(node, voidSelector)[0] || null);
    },

    /**
     * Returns a combined selector for delete and void elements.
     */
    _getVoidElSelector: function () {
      return '.' + this._getIceNodeClass('deleteType') + ',' + this.avoid;
    },

    /**
     * Returns true if node has a user id attribute that matches the current user id.
     */
    _currentUserIceNode: function (node) {
      return ice.dom.attr(node, this.userIdAttribute) == this.currentUser.id;
    },

    /**
     * With the given alias, searches the changeTypes objects and returns the
     * associated key for the alias.
     */
    _getChangeTypeFromAlias: function (alias) {
      var type, ctnType = null;
      for (type in this.changeTypes) {
        if (this.changeTypes.hasOwnProperty(type)) {
          if (this.changeTypes[type].alias == alias) {
            ctnType = type;
          }
        }
      }

      return ctnType;
    },

    _getIceNodeClass: function (changeType) {
      return this.attrValuePrefix + this.changeTypes[changeType].alias;
    },

    getUserStyle: function (userid) {
      var styleIndex = null;
      if (this._userStyles[userid]) styleIndex = this._userStyles[userid];
      else styleIndex = this.setUserStyle(userid, this.getNewStyleId());
      return styleIndex;
    },

    setUserStyle: function (userid, styleIndex) {
      var style = this.stylePrefix + '-' + styleIndex;
      if (!this._styles[styleIndex]) this._styles[styleIndex] = true;
      return this._userStyles[userid] = style;
    },

    getNewStyleId: function () {
      var id = ++this._uniqueStyleIndex;
      if (this._styles[id]) {
        // Dupe.. create another..
        return this.getNewStyleId();
      } else {
        this._styles[id] = true;
        return id;
      }
    },

    addChange: function (ctnType, ctNodes) {
      var changeid = this._batchChangeid || this.getNewChangeId();
      if (!this._changes[changeid]) {
        // Create the change object.
        this._changes[changeid] = {
          type: this._getChangeTypeFromAlias(ctnType),
          time: (new Date()).getTime(),
          userid: this.currentUser.id,
          username: this.currentUser.name
        };
      }
      var self = this;
      ice.dom.foreach(ctNodes, function (i) {
        self.addNodeToChange(changeid, ctNodes[i]);
      });

      return changeid;
    },

    /**
     * Adds tracking attributes from the change with changeid to the ctNode.
     * @param changeid Id of an existing change.
     * @param ctNode The element to add for the change.
     */
    addNodeToChange: function (changeid, ctNode) {
      if (this._batchChangeid !== null) changeid = this._batchChangeid;

      var change = this.getChange(changeid);

      if (!ctNode.getAttribute(this.changeIdAttribute)) ctNode.setAttribute(this.changeIdAttribute, changeid);

      if (!ctNode.getAttribute(this.userIdAttribute)) ctNode.setAttribute(this.userIdAttribute, change.userid);

      if (!ctNode.getAttribute(this.userNameAttribute)) ctNode.setAttribute(this.userNameAttribute, change.username);

      if (!ctNode.getAttribute(this.timeAttribute)) ctNode.setAttribute(this.timeAttribute, change.time);

      if (!ice.dom.hasClass(ctNode, this._getIceNodeClass(change.type))) ice.dom.addClass(ctNode, this._getIceNodeClass(change.type));

      var style = this.getUserStyle(change.userid);
      if (!ice.dom.hasClass(ctNode, style)) ice.dom.addClass(ctNode, style);
    },

    getChange: function (changeid) {
      var change = null;
      if (this._changes[changeid]) {
        change = this._changes[changeid];
      }
      return change;
    },

    getNewChangeId: function () {
      var id = ++this._uniqueIDIndex;
      if (this._changes[id]) {
        // Dupe.. create another..
        id = this.getNewChangeId();
      }
      return id;
    },

    startBatchChange: function () {
      this._batchChangeid = this.getNewChangeId();
      return this._batchChangeid;
    },

    endBatchChange: function (changeid) {
      if (changeid !== this._batchChangeid) return;
      this._batchChangeid = null;
    },

    getCurrentRange: function () {
      return this.selection.getRangeAt(0);
    },

    _insertNode: function (node, range, insertingDummy) {
      var origNode = node;
//       if (!ice.dom.isBlockElement(range.startContainer) && !ice.dom.canContainTextElement(ice.dom.getBlockParent(range.startContainer, this.element)) && range.startContainer.previousSibling) {
//         range.setStart(range.startContainer.previousSibling, 0);

//       }
      var startContainer = range.startContainer;
      var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || this.element;
      if (parentBlock === this.element) {
        var firstPar = document.createElement(this.blockEl);
        parentBlock.appendChild(firstPar);
        range.setStart(firstPar, 0);
        range.collapse();
        return this._insertNode(node, range, insertingDummy);
      }
      if (ice.dom.hasNoTextOrStubContent(parentBlock)) {
        ice.dom.empty(parentBlock);
        ice.dom.append(parentBlock, '<br>');
        range.setStart(parentBlock, 0);
      }

      var ctNode = this.getIceNode(range.startContainer, 'insertType');
      var inCurrentUserInsert = this._currentUserIceNode(ctNode);

      // Do nothing, let this bubble-up to insertion handler.
      if (insertingDummy && inCurrentUserInsert) return;
      // If we aren't in an insert node which belongs to the current user, then create a new ins node
      else if (!inCurrentUserInsert) node = this.createIceNode('insertType', node);

      range.insertNode(node);
      range.setEnd(node, 1);

      if (insertingDummy) {
        // Create a selection of the dummy character we inserted
        // which will be removed after it bubbles up to the final handler.
        range.setStart(node, 0);
      } else {
        range.collapse();
      }

      this.selection.addRange(range);
    },

    _handleVoidEl: function (el, range) {
      // If `el` is or is in a void element, but not a delete
      // then collapse the `range` and return `true`.
      var voidEl = this._getVoidElement(el);
      if (voidEl && !this.getIceNode(voidEl, 'deleteType')) {
        range.collapse(true);
        return true;
      }
      return false;
    },

    _deleteSelection: function (range) {

      // Bookmark the range and get elements between.
      var bookmark = new ice.Bookmark(this.env, range),
        elements = ice.dom.getElementsBetween(bookmark.start, bookmark.end),
        b1 = ice.dom.parents(range.startContainer, this.blockEls.join(', '))[0],
        b2 = ice.dom.parents(range.endContainer, this.blockEls.join(', '))[0],
        betweenBlocks = new Array();

      for (var i = 0; i < elements.length; i++) {
        var elem = elements[i];
        if (ice.dom.isBlockElement(elem)) {
          betweenBlocks.push(elem);
          if (!ice.dom.canContainTextElement(elem)) {
            // Ignore containers that are not supposed to contain text. Check children instead.
            for (var k = 0; k < elem.childNodes.length; k++) {
              elements.push(elem.childNodes[k]);
            }
            continue;
          }
        }
        // Ignore empty space nodes
        if (elem.nodeType === ice.dom.TEXT_NODE && ice.dom.getNodeTextContent(elem).length === 0) continue;

        if (!this._getVoidElement(elem)) {
          // If the element is not a text or stub node, go deeper and check the children.
          if (elem.nodeType !== ice.dom.TEXT_NODE) {
            // Browsers like to insert breaks into empty paragraphs - remove them
            if (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(elem)) {
              continue;
            }

            if (ice.dom.isStubElement(elem)) {
              this._addNodeTracking(elem, false, true);
              continue;
            }
            if (ice.dom.hasNoTextOrStubContent(elem)) {
              ice.dom.remove(elem);
            }

            for (j = 0; j < elem.childNodes.length; j++) {
              var child = elem.childNodes[j];
              elements.push(child);
            }
            continue;
          }
          var parentBlock = ice.dom.getBlockParent(elem);
          this._addNodeTracking(elem, false, true, true);
          if (ice.dom.hasNoTextOrStubContent(parentBlock)) {
            ice.dom.remove(parentBlock);
          }
        }
      }

      if (this.mergeBlocks && b1 !== b2) {
        while (betweenBlocks.length)
          ice.dom.mergeContainers(betweenBlocks.shift(), b1);
        ice.dom.removeBRFromChild(b2);
        ice.dom.removeBRFromChild(b1);
        ice.dom.mergeContainers(b2, b1);
      }

      bookmark.selectBookmark();
      //      range.collapse(false);
      range.collapse(true);
    },

    // Delete
    _deleteRight: function (range) {

      var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || null,
        isEmptyBlock = parentBlock ? (ice.dom.hasNoTextOrStubContent(parentBlock)) : false,
        nextBlock = parentBlock && ice.dom.getNextContentNode(parentBlock, this.element),
        nextBlockIsEmpty = nextBlock ? (ice.dom.hasNoTextOrStubContent(nextBlock)) : false,
        initialContainer = range.endContainer,
        initialOffset = range.endOffset,
        commonAncestor = range.commonAncestorContainer,
        nextContainer, returnValue;

      // If the current block is empty then let the browser handle the delete/event.
      if (isEmptyBlock) return false;

      // Some bugs in Firefox and Webkit make the caret disappear out of text nodes, so we try to put them back in.
      if (commonAncestor.nodeType !== ice.dom.TEXT_NODE) {

        // If placed at the beginning of a container that cannot contain text, such as an ul element, place the caret at the beginning of the first item.
        if (initialOffset === 0 && ice.dom.isBlockElement(commonAncestor) && (!ice.dom.canContainTextElement(commonAncestor))) {
          var firstItem = commonAncestor.firstElementChild;
          if (firstItem) {
            range.setStart(firstItem, 0);
            range.collapse();
            return this._deleteRight(range);
          }
        }

        if (commonAncestor.childNodes.length > initialOffset) {
          var tempTextContainer = document.createTextNode(' ');
          commonAncestor.insertBefore(tempTextContainer, commonAncestor.childNodes[initialOffset]);
          range.setStart(tempTextContainer, 1);
          range.collapse(true);
          returnValue = this._deleteRight(range);
          ice.dom.remove(tempTextContainer);
          return returnValue;
        } else {
          nextContainer = ice.dom.getNextContentNode(commonAncestor, this.element);
          range.setEnd(nextContainer, 0);
          range.collapse();
          return this._deleteRight(range);
        }
      }

      // Move range to position the cursor on the inside of any adjacent container that it is going
      // to potentially delete into or after a stub element.  E.G.:  test|<em>text</em>  ->  test<em>|text</em> or
      // text1 |<img> text2 -> text1 <img>| text2

      // Merge blocks: If mergeBlocks is enabled, merge the previous and current block.
      range.moveEnd(ice.dom.CHARACTER_UNIT, 1);
      range.moveEnd(ice.dom.CHARACTER_UNIT, -1);

      // Handle cases of the caret is at the end of a container or placed directly in a block element
      if (initialOffset === initialContainer.data.length && (!ice.dom.hasNoTextOrStubContent(initialContainer))) {
        nextContainer = ice.dom.getNextNode(initialContainer, this.element);

        // If the next container is outside of ICE then do nothing.
        if (!nextContainer) {
          range.selectNodeContents(initialContainer);
          range.collapse();
          return false;
        }

        // If the next container is <br> element find the next node
        if (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(nextContainer)) {
          nextContainer = ice.dom.getNextNode(nextContainer, this.element);
        }
        // If the next container is a text node, look at the parent node instead.
        if (nextContainer.nodeType === ice.dom.TEXT_NODE) {
          nextContainer = nextContainer.parentNode;
        }

        // If the next container is non-editable, enclose it with a delete ice node and add an empty text node after it to position the caret.
        if (!nextContainer.isContentEditable) {
          returnValue = this._addNodeTracking(nextContainer, false, false);
          var emptySpaceNode = document.createTextNode('');
          nextContainer.parentNode.insertBefore(emptySpaceNode, nextContainer.nextSibling);
          range.selectNode(emptySpaceNode);
          range.collapse(true);
          return returnValue;
        }

        if (this._handleVoidEl(nextContainer, range)) return true;

        // If the caret was placed directly before a stub element, enclose the element with a delete ice node.
        if (ice.dom.isChildOf(nextContainer, parentBlock) && ice.dom.isStubElement(nextContainer)) {
          return this._addNodeTracking(nextContainer, range, false);
        }

      }

      if (this._handleVoidEl(nextContainer, range)) return true;

      // If we are deleting into a no tracking containiner, then remove the content
      if (this._getNoTrackElement(range.endContainer.parentElement)) {
        range.deleteContents();
        return false;
      }

      if (ice.dom.isOnBlockBoundary(range.startContainer, range.endContainer, this.element)) {
        if (this.mergeBlocks && ice.dom.is(ice.dom.getBlockParent(nextContainer, this.element), this.blockEl)) {
          // Since the range is moved by character, it may have passed through empty blocks.
          // <p>text {RANGE.START}</p><p></p><p>{RANGE.END} text</p>
          if (nextBlock !== ice.dom.getBlockParent(range.endContainer, this.element)) {
            range.setEnd(nextBlock, 0);
          }
          // The browsers like to auto-insert breaks into empty paragraphs - remove them.
          var elements = ice.dom.getElementsBetween(range.startContainer, range.endContainer);
          for (var i = 0; i < elements.length; i++) {
            ice.dom.remove(elements[i]);
          }
          var startContainer = range.startContainer;
          var endContainer = range.endContainer;
          ice.dom.remove(ice.dom.find(startContainer, 'br'));
          ice.dom.remove(ice.dom.find(endContainer, 'br'));
          return ice.dom.mergeBlockWithSibling(range, ice.dom.getBlockParent(range.endContainer, this.element) || parentBlock);
        } else {
          // If the next block is empty, remove the next block.
          if (nextBlockIsEmpty) {
            ice.dom.remove(nextBlock);
            range.collapse(true);
            return true;
          }

          // Place the caret at the start of the next block.
          range.setStart(nextBlock, 0);
          range.collapse(true);
          return true;
        }
      }

      var entireTextNode = range.endContainer;
      var deletedCharacter = entireTextNode.splitText(range.endOffset);
      var remainingTextNode = deletedCharacter.splitText(1);

      return this._addNodeTracking(deletedCharacter, range, false);

    },

    // Backspace
    _deleteLeft: function (range) {

      var parentBlock = ice.dom.isBlockElement(range.startContainer) && range.startContainer || ice.dom.getBlockParent(range.startContainer, this.element) || null,
        isEmptyBlock = parentBlock ? ice.dom.hasNoTextOrStubContent(parentBlock) : false,
        prevBlock = parentBlock && ice.dom.getPrevContentNode(parentBlock, this.element), // || ice.dom.getBlockParent(parentBlock, this.element) || null,
        prevBlockIsEmpty = prevBlock ? ice.dom.hasNoTextOrStubContent(prevBlock) : false,
        initialContainer = range.startContainer,
        initialOffset = range.startOffset,
        commonAncestor = range.commonAncestorContainer,
        lastSelectable, prevContainer;
      // If the current block is empty, then let the browser handle the key/event.
      if (isEmptyBlock) return false;

      //merge lists if they are back to back
      if ((prevBlock.nodeName == 'UL' || prevBlock.nodeName == 'OL') && (parentBlock.nodeName == 'li')) {
          var myList = ice.dom.getParents(parentBlock, 'ul, ol', this.element)[0]
          if (myList) {
            
          } else {
              prevBlock.appendChild(parentBlock)
          }
      }


      // Handle cases of the caret is at the start of a container or outside a text node
      if (initialOffset === 0 || commonAncestor.nodeType !== ice.dom.TEXT_NODE) {
        // If placed at the end of a container that cannot contain text, such as an ul element, place the caret at the end of the last item.
        if (ice.dom.isBlockElement(commonAncestor) && (!ice.dom.canContainTextElement(commonAncestor))) {
          if (initialOffset === 0) {
            var firstItem = commonAncestor.firstElementChild;
            if (firstItem) {
              range.setStart(firstItem, 0);
              range.collapse();
              return this._deleteLeft(range);
            }

          } else {
            var lastItem = commonAncestor.lastElementChild;
            if (lastItem) {

              lastSelectable = range.getLastSelectableChild(lastItem);
              if (lastSelectable) {
                range.setStart(lastSelectable, lastSelectable.data.length);
                range.collapse();
                return this._deleteLeft(range);
              }
            }
          }
        }
        if (initialOffset === 0) {
          prevContainer = ice.dom.getPrevContentNode(initialContainer, this.element);
        } else {
          var newOffset = initialOffset;
          var style;
          //      while(newOffset > 0){
          //        prevContainer = commonAncestor.childNodes[--newOffset];
          //        if(!ice.dom.hasClass(prevContainer, "del")) break;
          //        prevContainer = null;
          //      }
          prevContainer = commonAncestor.childNodes[initialOffset - 1];
        }

        // If the previous container is outside of ICE then do nothing.
        if (!prevContainer) {
          return false;
        }
        // Firefox finds an ice node wrapped around an image instead of the image itself sometimes, so we make sure to look at the image instead.
        if (ice.dom.is(prevContainer, '.' + this._getIceNodeClass('insertType') + ', .' + this._getIceNodeClass('deleteType')) && prevContainer.childNodes.length > 0 && prevContainer.lastChild) {
          prevContainer = prevContainer.lastChild;
        }

        // If the previous container is a text node, look at the parent node instead.
        if (prevContainer.nodeType === ice.dom.TEXT_NODE) {
          prevContainer = prevContainer.parentNode;
        }

        // If the previous container is non-editable, enclose it with a delete ice node and add an empty text node before it to position the caret.
        if (!prevContainer.isContentEditable) {
          var returnValue = this._addNodeTracking(prevContainer, false, true);
          var emptySpaceNode = document.createTextNode('');
          prevContainer.parentNode.insertBefore(emptySpaceNode, prevContainer);
          range.selectNode(emptySpaceNode);
          range.collapse(true);
          return returnValue;
        }

        if (this._handleVoidEl(prevContainer, range)) return true;

        // If the caret was placed directly after a stub element, enclose the element with a delete ice node.
        if (ice.dom.isStubElement(prevContainer) && ice.dom.isChildOf(prevContainer, parentBlock) || !prevContainer.isContentEditable) {
          return this._addNodeTracking(prevContainer, range, true);
        }

        // If the previous container is a stub element between blocks
        // then just delete and leave the range/cursor in place.
        if (ice.dom.isStubElement(prevContainer)) {
          ice.dom.remove(prevContainer);
          range.collapse(true);
          return false;
        }

        if (prevContainer !== parentBlock && !ice.dom.isChildOf(prevContainer, parentBlock)) {

          if (!ice.dom.canContainTextElement(prevContainer)) {
            prevContainer = prevContainer.lastElementChild;
          }
          try {

          
          // Before putting the caret into the last selectable child, lets see if the last element is a stub element. If it is, we need to put the caret there manually.
          if (prevContainer.lastChild && prevContainer.lastChild.nodeType !== ice.dom.TEXT_NODE && ice.dom.isStubElement(prevContainer.lastChild) && prevContainer.lastChild.tagName !== 'BR') {
            range.setStartAfter(prevContainer.lastChild);
            range.collapse(true);
            return true;
          }
          } catch(e) {
              debugger
          }
          // Find the last selectable part of the prevContainer. If it exists, put the caret there.
          lastSelectable = range.getLastSelectableChild(prevContainer);

          if (lastSelectable && !ice.dom.isOnBlockBoundary(range.startContainer, lastSelectable, this.element)) {
            range.selectNodeContents(lastSelectable);
            range.collapse();
            return true;
          }
        }
      }

      // Firefox: If an image is at the start of the paragraph and the user has just deleted the image using backspace, an empty text node is created in the delete node before
      // the image, but the caret is placed with the image. We move the caret to the empty text node and execute deleteFromLeft again.
      if (initialOffset === 1 && !ice.dom.isBlockElement(commonAncestor) && range.startContainer.childNodes.length > 1 && range.startContainer.childNodes[0].nodeType === ice.dom.TEXT_NODE && range.startContainer.childNodes[0].data.length === 0) {
        range.setStart(range.startContainer, 0);
        return this._deleteLeft(range);
      }

      // Move range to position the cursor on the inside of any adjacent container that it is going
      // to potentially delete into or before a stub element.  E.G.: <em>text</em>| test  ->  <em>text|</em> test or
      // text1 <img>| text2 -> text1 |<img> text2
      range.moveStart(ice.dom.CHARACTER_UNIT, -1);
      range.moveStart(ice.dom.CHARACTER_UNIT, 1);

      // If we are deleting into a no tracking containiner, then remove the content
      if (this._getNoTrackElement(range.startContainer.parentElement)) {
        range.deleteContents();
        return false;
      }

      // Handles cases in which the caret is at the start of the block.
      if (ice.dom.isOnBlockBoundary(range.startContainer, range.endContainer, this.element)) {

        // If the previous block is empty, remove the previous block.
        if (prevBlockIsEmpty) {
          ice.dom.remove(prevBlock);
          range.collapse();
          return true;
        }

        // Merge blocks: If mergeBlocks is enabled, merge the previous and current block.
        if (this.mergeBlocks && ice.dom.is(ice.dom.getBlockParent(prevContainer, this.element), this.blockEl)) {
          // Since the range is moved by character, it may have passed through empty blocks.
          // <p>text {RANGE.START}</p><p></p><p>{RANGE.END} text</p>
          if (prevBlock !== ice.dom.getBlockParent(range.startContainer, this.element)) {
            range.setStart(prevBlock, prevBlock.childNodes.length);
          }
          // The browsers like to auto-insert breaks into empty paragraphs - remove them.
          var elements = ice.dom.getElementsBetween(range.startContainer, range.endContainer)
          for (var i = 0; i < elements.length; i++) {
            ice.dom.remove(elements[i]);
          }
          var startContainer = range.startContainer;
          var endContainer = range.endContainer;
          ice.dom.remove(ice.dom.find(startContainer, 'br'));
          ice.dom.remove(ice.dom.find(endContainer, 'br'));
          return ice.dom.mergeBlockWithSibling(range, ice.dom.getBlockParent(range.endContainer, this.element) || parentBlock);
        }

        // If the previous Block ends with a stub element, set the caret behind it.
        if (prevBlock && prevBlock.lastChild && ice.dom.isStubElement(prevBlock.lastChild)) {
          range.setStartAfter(prevBlock.lastChild);
          range.collapse(true);
          return true;
        }

        // Place the caret at the end of the previous block.
        lastSelectable = range.getLastSelectableChild(prevBlock);
        if (lastSelectable) {
          range.setStart(lastSelectable, lastSelectable.data.length);
          range.collapse(true);
        } else if (prevBlock) {
          range.setStart(prevBlock, prevBlock.childNodes.length);
          range.collapse(true);
        }

        return true;
      }

      var entireTextNode = range.startContainer;
      var deletedCharacter = entireTextNode.splitText(range.startOffset - 1);
      var remainingTextNode = deletedCharacter.splitText(1);

      return this._addNodeTracking(deletedCharacter, range, true);

    },

    // Marks text and other nodes for deletion
    _addNodeTracking: function (contentNode, range, moveLeft) {

      var contentAddNode = this.getIceNode(contentNode, 'insertType');

      if (contentAddNode && this._currentUserIceNode(contentAddNode)) {
        if (range && moveLeft) {
          range.selectNode(contentNode);
        }
        contentNode.parentNode.removeChild(contentNode);
        var cleanNode = ice.dom.cloneNode(contentAddNode);
        ice.dom.remove(ice.dom.find(cleanNode, '.iceBookmark'));
        // Remove a potential empty tracking container
        if (contentAddNode !== null && (ice.dom.hasNoTextOrStubContent(cleanNode[0]))) {
          var newstart = this.env.document.createTextNode('');
          ice.dom.insertBefore(contentAddNode, newstart);
          if (range) {
            range.setStart(newstart, 0);
            range.collapse(true);
          }
          ice.dom.replaceWith(contentAddNode, ice.dom.contents(contentAddNode));
        }

        return true;

      } else if (range && this.getIceNode(contentNode, 'deleteType')) {
        // It if the contentNode a text node, unite it with text nodes before and after it.
        contentNode.normalize();

        var found = false;
        if (moveLeft) {
          // Move to the left until there is valid sibling.
          var previousSibling = ice.dom.getPrevContentNode(contentNode, this.element);
          while (!found) {
            ctNode = this.getIceNode(previousSibling, 'deleteType');
            if (!ctNode) {
              found = true;
            } else {
              previousSibling = ice.dom.getPrevContentNode(previousSibling, this.element);
            }
          }
          if (previousSibling) {
            var lastSelectable = range.getLastSelectableChild(previousSibling);
            if (lastSelectable) {
              previousSibling = lastSelectable;
            }
            range.setStart(previousSibling, ice.dom.getNodeCharacterLength(previousSibling));
            range.collapse(true);
          }
          return true;
        } else {
          // Move the range to the right until there is valid sibling.

          var nextSibling = ice.dom.getNextContentNode(contentNode, this.element);
          while (!found) {
            ctNode = this.getIceNode(nextSibling, 'deleteType');
            if (!ctNode) {
              found = true;
            } else {
              nextSibling = ice.dom.getNextContentNode(nextSibling, this.element);
            }
          }

          if (nextSibling) {
            range.selectNodeContents(nextSibling);
            range.collapse(true);
          }
          return true;
        }

      }
      // Webkit likes to insert empty text nodes next to elements. We remove them here.
      if (contentNode.previousSibling && contentNode.previousSibling.nodeType === ice.dom.TEXT_NODE && contentNode.previousSibling.length === 0) {
        contentNode.parentNode.removeChild(contentNode.previousSibling);
      }
      if (contentNode.nextSibling && contentNode.nextSibling.nodeType === ice.dom.TEXT_NODE && contentNode.nextSibling.length === 0) {
        contentNode.parentNode.removeChild(contentNode.nextSibling);
      }
      var prevDelNode = this.getIceNode(contentNode.previousSibling, 'deleteType');
      var nextDelNode = this.getIceNode(contentNode.nextSibling, 'deleteType');
      var ctNode;

      if (prevDelNode && this._currentUserIceNode(prevDelNode)) {
        ctNode = prevDelNode;
        ctNode.appendChild(contentNode);
        if (nextDelNode && this._currentUserIceNode(nextDelNode)) {
          var nextDelContents = ice.dom.extractContent(nextDelNode);
          ice.dom.append(ctNode, nextDelContents);
          nextDelNode.parentNode.removeChild(nextDelNode);
        }
      } else if (nextDelNode && this._currentUserIceNode(nextDelNode)) {
        ctNode = nextDelNode;
        ctNode.insertBefore(contentNode, ctNode.firstChild);
      } else {
        ctNode = this.createIceNode('deleteType');
        contentNode.parentNode.insertBefore(ctNode, contentNode);
        ctNode.appendChild(contentNode);
      }

      if (range) {
        if (ice.dom.isStubElement(contentNode)) {
          range.selectNode(contentNode);
        } else {
          range.selectNodeContents(contentNode);
        }
        if (moveLeft) {
          range.collapse(true);
        } else {
          range.collapse();
        }
        contentNode.normalize();
      }
      return true;

    },


    /**
     * Handles arrow, delete key events, and others.
     *
     * @param {event} e The event object.
     * return {void|boolean} Returns false if default event needs to be blocked.
     */
    _handleAncillaryKey: function (e) {
      var key = e.keyCode ? e.keyCode : e.which;
      //var browser = ice.dom.browser();
      var preventDefault = true;
      var shiftKey = e.shiftKey;
      var self = this;
      var range = self.getCurrentRange();
      switch (key) {
        case ice.dom.DOM_VK_DELETE:
          preventDefault = this.deleteContents();
          this.pluginsManager.fireKeyPressed(e);
          break;
        case 46:
          // Key 46 is the DELETE key.
          preventDefault = this.deleteContents(true);
          this.pluginsManager.fireKeyPressed(e);
          break;

        /************************************************************************************/
        /** BEGIN: Handling of caret movements inside hidden .ins/.del elements on Firefox **/
        /**  *Fix for carets getting stuck in .del elements when track changes are hidden  **/
        case ice.dom.DOM_VK_DOWN:
        case ice.dom.DOM_VK_UP:
        case ice.dom.DOM_VK_LEFT:
          this.pluginsManager.fireCaretPositioned();
          // if (browser["type"] === "mozilla") {
          //   if (!this.visible(range.startContainer)) {
          //     // if Previous sibling exists in the paragraph, jump to the previous sibling
          //     if (range.startContainer.parentNode.previousSibling) {
          //       // When moving left and moving into a hidden element, skip it and go to the previousSibling
          //       range.setEnd(range.startContainer.parentNode.previousSibling, 0);
          //       range.moveEnd(ice.dom.CHARACTER_UNIT, ice.dom.getNodeCharacterLength(range.endContainer));
          //       range.collapse(false);
          //     }
          //     // if Previous sibling doesn't exist, get out of the hidden zone by moving to the right
          //     else {
          //       range.setEnd(range.startContainer.parentNode.nextSibling, 0);
          //       range.collapse(false);
          //     }
          //   }
          // }
          preventDefault = false;
          break;
        case ice.dom.DOM_VK_RIGHT:
          this.pluginsManager.fireCaretPositioned();
          // if (browser["type"] === "mozilla") {
          //   if (!this.visible(range.startContainer)) {
          //     if (range.startContainer.parentNode.nextSibling) {
          //       // When moving right and moving into a hidden element, skip it and go to the nextSibling
          //       range.setStart(range.startContainer.parentNode.nextSibling, 0);
          //       range.collapse(true);
          //     }
          //   }
          // }
          preventDefault = false;
          break;
        /** END: Handling of caret movements inside hidden .ins/.del elements ***************/
        /************************************************************************************/

        case 32:
          preventDefault = true;
          var range = this.getCurrentRange();
          this._moveRangeToValidTrackingPos(range, range.startContainer);
          this.insert('\u00A0', range);
          break;
        default:
          // Ignore key.
          preventDefault = false;
          break;
      } //end switch

      if (preventDefault === true) {
        ice.dom.preventDefault(e);
        return false;
      }
      return true;
    },

    keyDown: function (e) {
      if (!this.pluginsManager.fireKeyDown(e)) {
        ice.dom.preventDefault(e);
        return false;
      }
      var preventDefault = false;

      if (this._handleSpecialKey(e) === false) {
        // if (ice.dom.isBrowser('msie') !== true) {
        this._preventKeyPress = true;
        // }

        return false;
      } else if ((e.ctrlKey === true || e.metaKey === true)) {
        //&& (ice.dom.isBrowser('msie') === true || ice.dom.isBrowser('chrome') === true)
        // IE does not fire keyPress event if ctrl is also pressed.
        // E.g. CTRL + B (Bold) will not fire keyPress so this.plugins
        // needs to be notified here for IE.
        if (!this.pluginsManager.fireKeyPressed(e)) { //could handle ctl+z here
          return false;
        }
      }
      switch (e.keyCode) {
        case 27:
          // ESC
          break;
        default:
          // If not Firefox then check if event is special arrow key etc.
          // Firefox will handle this in keyPress event.
          if (/Firefox/.test(navigator.userAgent) !== true) {
            preventDefault = !(this._handleAncillaryKey(e));
          }
          break;
      }

      if (preventDefault) {
        ice.dom.preventDefault(e);
        return false;
      }
      return true;
    },

    keyPress: function (e) {
      if (this._preventKeyPress === true) {
        this._preventKeyPress = false;
        return;
      }

      if (!this.pluginsManager.fireKeyPress(e)) return false;

      var c = null;
      if (e.which == null) {
        // IE.
        c = String.fromCharCode(e.keyCode);
      } else if (e.which > 0) {
        c = String.fromCharCode(e.which);
      }

      // Inside a br - most likely in a placeholder of a new block - delete before handling.
      var range = this.getCurrentRange();
      var br = ice.dom.parents(range.startContainer, 'br')[0] || null;
      if (br) {
        range.moveToNextEl(br);
        br.parentNode.removeChild(br);
      }

      // Ice will ignore the keyPress event if CMD or CTRL key is also pressed
      if (c !== null && e.ctrlKey !== true && e.metaKey !== true) {
        var key = e.keyCode ? e.keyCode : e.which;
        switch (key) {
          case ice.dom.DOM_VK_DELETE:
            // Handle delete key for Firefox.
            return this._handleAncillaryKey(e);
          case ice.dom.DOM_VK_ENTER:
            return this._handleEnter();
          case 32:
            return this._handleAncillaryKey(e);
          default:
            // If we are in a deletion, move the range to the end/outside.
            this._moveRangeToValidTrackingPos(range, range.startContainer);
            return this.insert();
        }
      }

      return this._handleAncillaryKey(e);
    },

    _handleEnter: function () {
      var range = this.getCurrentRange();
      if (!range.collapsed) this.deleteContents();
      return true;
    },

    _handleSpecialKey: function (e) {
      var keyCode = e.which;
      if (keyCode === null) {
        // IE.
        keyCode = e.keyCode;
      }

      var preventDefault = false;
      switch (keyCode) {
        case 65:
          // Check for CTRL/CMD + A (select all).
          if (e.ctrlKey === true || e.metaKey === true) {
            preventDefault = true;
            var range = this.getCurrentRange();

            // if (ice.dom.isBrowser('msie') === true) {
            //   var selStart = this.env.document.createTextNode('');
            //   var selEnd = this.env.document.createTextNode('');

            //   if (this.element.firstChild) {
            //     ice.dom.insertBefore(this.element.firstChild, selStart);
            //   } else {
            //     this.element.appendChild(selStart);
            //   }

            //   this.element.appendChild(selEnd);

            //   range.setStart(selStart, 0);
            //   range.setEnd(selEnd, 0);
            // } else {
            range.setStart(range.getFirstSelectableChild(this.element), 0);
            var lastSelectable = range.getLastSelectableChild(this.element);
            range.setEnd(lastSelectable, lastSelectable.length);
            // } //end if

            this.selection.addRange(range);
          } //end if
          break;

        default:
          // Not a special key.
          break;
      } //end switch

      if (preventDefault === true) {
        ice.dom.preventDefault(e);
        return false;
      }

      return true;
    },

    mouseUp: function (e, target) {
      if (!this.pluginsManager.fireClicked(e)) return false;
      this.pluginsManager.fireSelectionChanged(this.getCurrentRange());
    },

    mouseDown: function (e, target) {
      if (!this.pluginsManager.fireMouseDown(e)) return false;
      this.pluginsManager.fireCaretUpdated();
    }
  };

  exports.ice = this.ice || {};
  exports.ice.InlineChangeEditor = InlineChangeEditor;

}).call(this);

(function () {
  var exports = this,
    dom = {};

  dom.KEY_TAB = 9;
  dom.DOM_VK_DELETE = 8;
  dom.DOM_VK_LEFT = 37;
  dom.DOM_VK_UP = 38;
  dom.DOM_VK_RIGHT = 39;
  dom.DOM_VK_DOWN = 40;
  dom.DOM_VK_ENTER = 13;
  dom.ELEMENT_NODE = 1;
  dom.ATTRIBUTE_NODE = 2;
  dom.TEXT_NODE = 3;
  dom.CDATA_SECTION_NODE = 4;
  dom.ENTITY_REFERENCE_NODE = 5;
  dom.ENTITY_NODE = 6;
  dom.PROCESSING_INSTRUCTION_NODE = 7;
  dom.COMMENT_NODE = 8;
  dom.DOCUMENT_NODE = 9;
  dom.DOCUMENT_TYPE_NODE = 10;
  dom.DOCUMENT_FRAGMENT_NODE = 11;
  dom.NOTATION_NODE = 12;
  dom.CHARACTER_UNIT = 'character';
  dom.WORD_UNIT = 'word';
  dom.BREAK_ELEMENT = 'br';
  dom.CONTENT_STUB_ELEMENTS = ['img', 'hr', 'iframe', 'param', 'link', 'meta', 'input', 'frame', 'col', 'base', 'area'];
  dom.BLOCK_ELEMENTS = ['p', 'div', 'pre', 'ul', 'ol', 'li', 'table', 'tbody', 'td', 'th', 'fieldset', 'form', 'blockquote', 'dl', 'dt', 'dd', 'dir', 'center', 'address', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  dom.TEXT_CONTAINER_ELEMENTS = ['p', 'div', 'pre', 'li', 'td', 'th', 'blockquote', 'dt', 'dd', 'center', 'address', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

  dom.STUB_ELEMENTS = dom.CONTENT_STUB_ELEMENTS.slice();
  dom.STUB_ELEMENTS.push(dom.BREAK_ELEMENT);

  dom.getKeyChar = function (e) {
    return String.fromCharCode(e.which);
  };
  dom.getClass = function (className, startElement, tagName) {
    if (!startElement) {
      startElement = document.body;
    }
    className = '.' + className.split(' ').join('.');
    if (tagName) {
      className = tagName + className;
    }
    return jQuery.makeArray(jQuery(startElement).find(className));
  };
  dom.getId = function (id, startElement) {
    if (!startElement) {
      startElement = document;
    }
    element = startElement.getElementById(id);
    return element;
  };
  dom.getTag = function (tagName, startElement) {
    if (!startElement) {
      startElement = document;
    }
    return jQuery.makeArray(jQuery(startElement).find(tagName));
  };
  dom.getElementWidth = function (element) {
    return element.offsetWidth;
  };
  dom.getElementHeight = function (element) {
    return element.offsetHeight;
  };
  dom.getElementDimensions = function (element) {
    var result = {
      'width': dom.getElementWidth(element),
      'height': dom.getElementHeight(element)
    };
    return result;
  };
  dom.trim = function (string) {
    return jQuery.trim(string);
  };
  dom.empty = function (element) {
    if (element) {
      return jQuery(element).empty();
    }
  };
  dom.remove = function (element) {
    if (element) {
      return jQuery(element).remove();
    }
  };
  dom.prepend = function (parent, elem) {
    jQuery(parent).prepend(elem);
  };
  dom.append = function (parent, elem) {
    jQuery(parent).append(elem);
  };
  dom.insertBefore = function (before, elem) {
    jQuery(before).before(elem);
  };
  dom.insertAfter = function (after, elem) {
    jQuery(after).after(elem);
  };
  dom.getHtml = function (element) {
    return jQuery(element).html();
  };
  dom.setHtml = function (element, content) {
    if (element) {
      jQuery(element).html(content);
    }
  };
  // Remove whitespace/newlines between nested block elements
  // that are supported by ice.
  // For example the following element with innerHTML:
  //   <div><p> para </p> <ul>  <li> hi </li>  </ul></div>
  // Will be converted to the following:
  //   <div><p> para </p><ul><li> hi </li></ul></div>
  dom.removeWhitespace = function(element) {
    jQuery(element).contents().filter(function() {
      // Ice supports UL and OL, so recurse in these blocks to
      // make sure that spaces don't exist between inner LI.
      if (this.nodeType != ice.dom.TEXT_NODE && this.nodeName == 'UL' || this.nodeName == 'OL') {
        dom.removeWhitespace(this);
        return false;
      } else if (this.nodeType != ice.dom.TEXT_NODE) {
        return false;
      } else {
        return !/\S/.test(this.nodeValue);
      }
    }).remove();
  };
  dom.contents = function (el) {
    return jQuery.makeArray(jQuery(el).contents());
  };
  /**
   * Returns the inner contents of `el` as a DocumentFragment.
   */
  dom.extractContent = function (el) {
    var frag = document.createDocumentFragment(),
      child;
    while ((child = el.firstChild)) {
      frag.appendChild(child);
    }
    return frag;
  };

  /**
   * Returns this `node` or the first parent tracking node that matches the given `selector`.
   */
  dom.getNode = function (node, selector) {
    return dom.is(node, selector) ? node : dom.parents(node, selector)[0] || null;
  };

  dom.getParents = function (elements, filter, stopEl) {
    var res = jQuery(elements).parents(filter);
    var ln = res.length;
    var ar = [];
    for (var i = 0; i < ln; i++) {
      if (res[i] === stopEl) {
        break;
      }
      ar.push(res[i]);
    }
    return ar;
  };
  dom.hasBlockChildren = function (parent) {
    var c = parent.childNodes.length;
    for (var i = 0; i < c; i++) {
      if (parent.childNodes[i].nodeType === dom.ELEMENT_NODE) {
        if (dom.isBlockElement(parent.childNodes[i]) === true) {
          return true;
        }
      }
    }
    return false;
  };
  dom.removeTag = function (element, selector) {
    jQuery(element).find(selector).replaceWith(function () {
      return jQuery(this).contents();
    });
    return element;
  };
  dom.stripEnclosingTags = function (content, allowedTags) {
    var c = jQuery(content);
    c.find('*').not(allowedTags).replaceWith(function () {
      var ret = jQuery();
      var $this;
      try{
        $this = jQuery(this);
        ret = $this.contents();
      } catch(e){}

      // Handling jQuery bug (which may be fixed in the official release later)
      // http://bugs.jquery.com/ticket/13401 
      if(ret.length === 0){
        $this.remove();
      }
      return ret;
    });
    return c[0];
  };
  dom.getSiblings = function (element, dir, elementNodesOnly, stopElem) {
    if (elementNodesOnly === true) {
      if (dir === 'prev') {
        return jQuery(element).prevAll();
      } else {
        return jQuery(element).nextAll();
      }
    } else {
      var elems = [];
      if (dir === 'prev') {
        while (element.previousSibling) {
          element = element.previousSibling;
          if (element === stopElem) {
            break;
          }
          elems.push(element);
        }
      } else {
        while (element.nextSibling) {
          element = element.nextSibling;
          if (element === stopElem) {
            break;
          }
          elems.push(element);
        }
      }
      return elems;
    }
  };
  dom.getNodeTextContent = function (node) {
    return jQuery(node).text();
  };
  dom.getNodeStubContent = function (node) {
    return jQuery(node).find(dom.CONTENT_STUB_ELEMENTS.join(', '));
  };
  dom.hasNoTextOrStubContent = function (node) {
    if (dom.getNodeTextContent(node).length > 0) return false;
    if (jQuery(node).find(dom.CONTENT_STUB_ELEMENTS.join(', ')).length > 0) return false;
    return true;
  };
  dom.getNodeCharacterLength = function (node) {
    return dom.getNodeTextContent(node).length + jQuery(node).find(dom.STUB_ELEMENTS.join(', ')).length;
  };
  dom.setNodeTextContent = function (node, txt) {
    return jQuery(node).text(txt);
  };
  dom.getTagName = function (node) {
    return node.tagName && node.tagName.toLowerCase() || null;
  };
  dom.getIframeDocument = function (iframe) {
    var doc = null;
    if (iframe.contentDocument) {
      doc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      doc = iframe.contentWindow.document;
    } else if (iframe.document) {
      doc = iframe.document;
    }
    return doc;
  };
  dom.isBlockElement = function (element) {
    return dom.BLOCK_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
  };
  dom.isStubElement = function (element) {
    return dom.STUB_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
  };
  dom.removeBRFromChild = function (node) {
    if (node && node.hasChildNodes()) {
      for(var z=0; z < node.childNodes.length ; z++) {
        var child = node.childNodes[z];
        if (child && (ice.dom.BREAK_ELEMENT == ice.dom.getTagName(child))) {
          child.parentNode.removeChild(child);
        }
      }
    }
  };
  dom.isChildOf = function (el, parent) {
    try {
      while (el && el.parentNode) {
        if (el.parentNode === parent) {
          return true;
        }
        el = el.parentNode;
      }
    } catch (e) {}
    return false;
  };
  dom.isChildOfTagName = function (el, name) {
    try {
      while (el && el.parentNode) {
        if (el.parentNode && el.parentNode.tagName && el.parentNode.tagName.toLowerCase() === name) {
          return el.parentNode;
        }
        el = el.parentNode;
      }
    } catch (e) {}
    return false;
  };


  dom.isChildOfTagNames = function (el, names) {
    try {
      while (el && el.parentNode) {
        if (el.parentNode && el.parentNode.tagName) {
          tagName = el.parentNode.tagName.toLowerCase();
          for (var i = 0; i < names.length; i++) {
            if (tagName === names[i]) {
              return el.parentNode;
            }
          }
        }
        el = el.parentNode;
      }
    } catch (e) {}
    return null;
  };

  dom.isChildOfClassName = function (el, name) {
    try {
      while (el && el.parentNode) {
        if (jQuery(el.parentNode).hasClass(name)) return el.parentNode;
        el = el.parentNode;
      }
    } catch (e) {}
    return null;
  };
  dom.cloneNode = function (elems, cloneEvents) {
    if (cloneEvents === undefined) {
      cloneEvents = true;
    }
    return jQuery(elems).clone(cloneEvents);
  };

  dom.bind = function (element, event, callback) {
    return jQuery(element).bind(event, callback);
  };

  dom.unbind = function (element, event, callback) {
    return jQuery(element).unbind(event, callback);
  };

  dom.attr = function (elements, key, val) {
    if (val) return jQuery(elements).attr(key, val);
    else return jQuery(elements).attr(key);
  };
  dom.replaceWith = function (node, replacement) {
    return jQuery(node).replaceWith(replacement);
  };
  dom.removeAttr = function (elements, name) {
    jQuery(elements).removeAttr(name);
  };
  dom.getElementsBetween = function (fromElem, toElem) {
    var elements = [];
    if (fromElem === toElem) {
      return elements;
    }
    if (dom.isChildOf(toElem, fromElem) === true) {
      var fElemLen = fromElem.childNodes.length;
      for (var i = 0; i < fElemLen; i++) {
        if (fromElem.childNodes[i] === toElem) {
          break;
        } else if (dom.isChildOf(toElem, fromElem.childNodes[i]) === true) {
          return dom.arrayMerge(elements, dom.getElementsBetween(fromElem.childNodes[i], toElem));
        } else {
          elements.push(fromElem.childNodes[i]);
        }
      }
      return elements;
    }
    var startEl = fromElem.nextSibling;
    while (startEl) {
      if (dom.isChildOf(toElem, startEl) === true) {
        elements = dom.arrayMerge(elements, dom.getElementsBetween(startEl, toElem));
        return elements;
      } else if (startEl === toElem) {
        return elements;
      } else {
        elements.push(startEl);
        startEl = startEl.nextSibling;
      }
    }
    var fromParents = dom.getParents(fromElem);
    var toParents = dom.getParents(toElem);
    var parentElems = dom.arrayDiff(fromParents, toParents, true);
    var pElemLen = parentElems.length;
    for (var j = 0; j < (pElemLen - 1); j++) {
      elements = dom.arrayMerge(elements, dom.getSiblings(parentElems[j], 'next'));
    }
    var lastParent = parentElems[(parentElems.length - 1)];
    elements = dom.arrayMerge(elements, dom.getElementsBetween(lastParent, toElem));
    return elements;
  };
  dom.getCommonAncestor = function (a, b) {
    var node = a;
    while (node) {
      if (dom.isChildOf(b, node) === true) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  };
  dom.getNextNode = function (node, container) {
    if (node) {
      while (node.parentNode) {
        if (node === container) {
          return null;
        }

        if (node.nextSibling) {
          // if next sibling is an empty text node, look further
          if (node.nextSibling.nodeType === dom.TEXT_NODE && node.nextSibling.length === 0) {
            node = node.nextSibling;
            continue;
          }

          return dom.getFirstChild(node.nextSibling);
        }
        node = node.parentNode;
      }
    }
    return null;
  };
  dom.getNextContentNode = function (node, container) {
    if (node) {
      while (node.parentNode) {
        if (node === container) {
          return null;
        }

        if (node.nextSibling && dom.canContainTextElement(dom.getBlockParent(node))) {
          // if next sibling is an empty text node, look further
          if (node.nextSibling.nodeType === dom.TEXT_NODE && node.nextSibling.length === 0) {
            node = node.nextSibling;
            continue;
          }

          return node.nextSibling;
        } else if (node.nextElementSibling) {
          return node.nextElementSibling;
        }

        node = node.parentNode;
      }
    }
    return null;
  };


  dom.getPrevNode = function (node, container) {
    if (node) {
      while (node.parentNode) {
        if (node === container) {
          return null;
        }

        if (node.previousSibling) {
          // if previous sibling is an empty text node, look further
          if (node.previousSibling.nodeType === dom.TEXT_NODE && node.previousSibling.length === 0) {
            node = node.previousSibling;
            continue;
          }

          return dom.getLastChild(node.previousSibling);
        }
        node = node.parentNode;
      }
    }
    return null;
  };
  dom.getPrevContentNode = function (node, container) {
    if (node) {
      while (node.parentNode) {
        if (node === container) {
          return null;
        }
        if (node.previousSibling && dom.canContainTextElement(dom.getBlockParent(node))) {

          // if previous sibling is an empty text node, look further
          if (node.previousSibling.nodeType === dom.TEXT_NODE && node.previousSibling.length === 0) {
            node = node.previousSibling;

            continue;
          }
          return node.previousSibling;
        } else if (node.previousElementSibling) {
          return node.previousElementSibling;
        }

        node = node.parentNode;
      }
    }
    return null;
  };

  dom.canContainTextElement = function (element) {
    if (element && element.nodeName) {
      return dom.TEXT_CONTAINER_ELEMENTS.lastIndexOf(element.nodeName.toLowerCase()) != -1;
    } else {
      return false;
    }
  };

  dom.getFirstChild = function (node) {
    if (node.firstChild) {
      if (node.firstChild.nodeType === dom.ELEMENT_NODE) {
        return dom.getFirstChild(node.firstChild);
      } else {
        return node.firstChild;
      }
    }
    return node;
  };
  dom.getLastChild = function (node) {
    if (node.lastChild) {
      if (node.lastChild.nodeType === dom.ELEMENT_NODE) {
        return dom.getLastChild(node.lastChild);
      } else {
        return node.lastChild;
      }
    }
    return node;
  };
  dom.removeEmptyNodes = function (parent, callback) {
    var elems = jQuery(parent).find(':empty');
    var i = elems.length;
    while (i > 0) {
      i--;
      if (dom.isStubElement(elems[i]) === false) {
        if (!callback || callback.call(this, elems[i]) !== false) {
          dom.remove(elems[i]);
        }
      }
    }
  };
  dom.create = function (html) {
    return jQuery(html)[0];
  };
  dom.find = function (parent, exp) {
    return jQuery(parent).find(exp);
  };
  dom.children = function (parent, exp) {
    return jQuery(parent).children(exp);
  };
  dom.parent = function (child, exp) {
    return jQuery(child).parent(exp)[0];
  };
  dom.parents = function (child, exp) {
    return jQuery(child).parents(exp);
  };
  dom.closest = function(node, exp, el) {
    return jQuery(node).closest(exp, el)
  }
  dom.is = function (node, exp) {
    return jQuery(node).is(exp);
  };
  dom.extend = function (deep, target, object1, object2) {
    return jQuery.extend.apply(this, arguments);
  };
  dom.walk = function (elem, callback, lvl) {
    if (!elem) {
      return;
    }
    if (!lvl) {
      lvl = 0;
    }
    var retVal = callback.call(this, elem, lvl);
    if (retVal === false) {
      return;
    }
    if (elem.childNodes && elem.childNodes.length > 0) {
      dom.walk(elem.firstChild, callback, (lvl + 1));
    } else if (elem.nextSibling) {
      dom.walk(elem.nextSibling, callback, lvl);
    } else if (elem.parentNode && elem.parentNode.nextSibling) {
      dom.walk(elem.parentNode.nextSibling, callback, (lvl - 1));
    }
  };
  dom.revWalk = function (elem, callback) {
    if (!elem) {
      return;
    }
    var retVal = callback.call(this, elem);
    if (retVal === false) {
      return;
    }
    if (elem.childNodes && elem.childNodes.length > 0) {
      dom.walk(elem.lastChild, callback);
    } else if (elem.previousSibling) {
      dom.walk(elem.previousSibling, callback);
    } else if (elem.parentNode && elem.parentNode.previousSibling) {
      dom.walk(elem.parentNode.previousSibling, callback);
    }
  };
  dom.setStyle = function (element, property, value) {
    if (element) {
      jQuery(element).css(property, value);
    }
  };
  dom.getStyle = function (element, property) {
    return jQuery(element).css(property);
  };
  dom.hasClass = function (element, className) {
    return jQuery(element).hasClass(className);
  };
  dom.addClass = function (element, classNames) {
    jQuery(element).addClass(classNames);
  };
  dom.removeClass = function (element, classNames) {
    jQuery(element).removeClass(classNames);
  };
  dom.preventDefault = function (e) {
    e.preventDefault();
    dom.stopPropagation(e);
  };
  dom.stopPropagation = function (e) {
    e.stopPropagation();
  };
  dom.noInclusionInherits = function (child, parent) {
    if (parent instanceof String || typeof parent === 'string') {
      parent = window[parent];
    }
    if (child instanceof String || typeof child === 'string') {
      child = window[child];
    }
    var above = function () {};
    if (dom.isset(parent) === true) {
      for (value in parent.prototype) {
        if (child.prototype[value]) {
          above.prototype[value] = parent.prototype[value];
          continue;
        }
        child.prototype[value] = parent.prototype[value];
      }
    }
    if (child.prototype) {
      above.prototype.constructor = parent;
      child.prototype['super'] = new above();
    }
  };

  dom.each = function (val, callback) {
    jQuery.each(val, function (i, el) {
      callback.call(this, i, el);
    });
  };

  dom.foreach = function (value, cb) {
    if (value instanceof Array || value instanceof NodeList || typeof value.length != 'undefined' && typeof value.item != 'undefined') {
      var len = value.length;
      for (var i = 0; i < len; i++) {
        var res = cb.call(this, i, value[i]);
        if (res === false) {
          break;
        }
      }
    } else {
      for (var id in value) {
        if (value.hasOwnProperty(id) === true) {
          var res = cb.call(this, id);
          if (res === false) {
            break;
          }
        }
      }
    }
  };
  dom.isBlank = function (value) {
    if (!value || /^\s*$/.test(value)) {
      return true;
    }
    return false;
  };
  dom.isFn = function (f) {
    if (typeof f === 'function') {
      return true;
    }
    return false;
  };
  dom.isObj = function (v) {
    if (v !== null && typeof v === 'object') {
      return true;
    }
    return false;
  };
  dom.isset = function (v) {
    if (typeof v !== 'undefined' && v !== null) {
      return true;
    }
    return false;
  };
  dom.isArray = function (v) {
    return jQuery.isArray(v);
  };
  dom.isNumeric = function (str) {
    var result = str.match(/^\d+$/);
    if (result !== null) {
      return true;
    }
    return false;
  };
  dom.getUniqueId = function () {
    var timestamp = (new Date()).getTime();
    var random = Math.ceil(Math.random() * 1000000);
    var id = timestamp + '' + random;
    return id.substr(5, 18).replace(/,/, '');
  };
  dom.inArray = function (needle, haystack) {
    var hln = haystack.length;
    for (var i = 0; i < hln; i++) {
      if (needle === haystack[i]) {
        return true;
      }
    }
    return false;
  };
  dom.arrayDiff = function (array1, array2, firstOnly) {
    var al = array1.length;
    var res = [];
    for (var i = 0; i < al; i++) {
      if (dom.inArray(array1[i], array2) === false) {
        res.push(array1[i]);
      }
    }
    if (firstOnly !== true) {
      al = array2.length;
      for (var i = 0; i < al; i++) {
        if (dom.inArray(array2[i], array1) === false) {
          res.push(array2[i]);
        }
      }
    }
    return res;
  };
  dom.arrayMerge = function (array1, array2) {
    var c = array2.length;
    for (var i = 0; i < c; i++) {
      array1.push(array2[i]);
    }
    return array1;
  };
  /**
   * Removes allowedTags from the given content html string. If allowedTags is a string, then it
   * is expected to be a selector; otherwise, it is expected to be array of string tag names.
   */
  dom.stripTags = function (content, allowedTags) {
    if (typeof allowedTags === "string") {
      var c = jQuery('<div>' + content + '</div>');
      c.find('*').not(allowedTags).remove();
      return c.html();
    } else {
      var match;
      var re = new RegExp(/<\/?(\w+)((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gim);
      var resCont = content;
      while ((match = re.exec(content)) != null) {
        if (dom.isset(allowedTags) === false || dom.inArray(match[1], allowedTags) !== true) {
          resCont = resCont.replace(match[0], '');
        }
      }
      return resCont;
    }
  };
  dom.browser = function () {
    var result = {};
    result.version = jQuery.browser.version;
    if (jQuery.browser.mozilla === true) {
      result.type = 'mozilla';
    } else if (jQuery.browser.msie === true) {
      result.type = 'msie';
    } else if (jQuery.browser.opera === true) {
      result.type = 'opera';
    } else if (jQuery.browser.webkit === true) {
      result.type = 'webkit';
    }
    return result;
  };
  dom.getBrowserType = function () {
    if (this._browserType === null) {
      var tests = ['msie', 'firefox', 'chrome', 'safari'];
      var tln = tests.length;
      for (var i = 0; i < tln; i++) {
        var r = new RegExp(tests[i], 'i');
        if (r.test(navigator.userAgent) === true) {
          this._browserType = tests[i];
          return this._browserType;
        }
      }

      this._browserType = 'other';
    }
    return this._browserType;
  };
  dom.getWebkitType = function(){
	if(dom.browser().type !== "webkit") {
		console.log("Not a webkit!");
		return false;
	}
    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
	if(isSafari) return "safari";
	return "chrome";
  };
  dom.isBrowser = function (browser) {
    return (dom.browser().type === browser);
  };

  dom.getBlockParent = function (node, container) {
    if (dom.isBlockElement(node) === true) {
      return node;
    }
    if (node) {
      while (node.parentNode) {
        node = node.parentNode;
        if (node === container) {
          return null;
        }

        if (dom.isBlockElement(node) === true) {
          return node;
        }
      }
    }
    return null;
  };
  dom.findNodeParent = function (node, selector, container) {
    if (node) {
      while (node.parentNode) {
        if (node === container) {
          return null;
        }

        if (dom.is(node, selector) === true) {
          return node;
        }
        node = node.parentNode;
      }
    }
    return null;
  };
  dom.onBlockBoundary = function (leftContainer, rightContainer, blockEls) {
    if (!leftContainer || !rightContainer) return false
    var bleft = dom.isChildOfTagNames(leftContainer, blockEls) || dom.is(leftContainer, blockEls.join(', ')) && leftContainer || null;
    var bright = dom.isChildOfTagNames(rightContainer, blockEls) || dom.is(rightContainer, blockEls.join(', ')) && rightContainer || null;
    return (bleft !== bright);
  };

  dom.isOnBlockBoundary = function (leftContainer, rightContainer, container) {
    if (!leftContainer || !rightContainer) return false
    var bleft = dom.getBlockParent(leftContainer, container) || dom.isBlockElement(leftContainer, container) && leftContainer || null;
    var bright = dom.getBlockParent(rightContainer, container) || dom.isBlockElement(rightContainer, container) && rightContainer || null;
    return (bleft !== bright);
  };

  dom.mergeContainers = function (node, mergeToNode) {
    if (!node || !mergeToNode) return false;

    if (node.nodeType === dom.TEXT_NODE || dom.isStubElement(node)) {
      // Move only this node.
      mergeToNode.appendChild(node);
    } else if (node.nodeType === dom.ELEMENT_NODE) {
      // Move all the child nodes to the new parent.
      while (node.firstChild) {
        mergeToNode.appendChild(node.firstChild);
      }

      dom.remove(node);
    }
    return true;
  };

  dom.mergeBlockWithSibling = function (range, block, next) {
    var siblingBlock = next ? jQuery(block).next().get(0) : jQuery(block).prev().get(0); // block['nextSibling'] : block['previousSibling'];
    if (next) dom.mergeContainers(siblingBlock, block);
    else dom.mergeContainers(block, siblingBlock);
    range.collapse(true);
    return true;
  };

  dom.date = function (format, timestamp, tsIso8601) {
    if (timestamp === null && tsIso8601) {
      timestamp = dom.tsIso8601ToTimestamp(tsIso8601);
      if (!timestamp) {
        return;
      }
    }
    var date = new Date(timestamp);
    var formats = format.split('');
    var fc = formats.length;
    var dateStr = '';
    for (var i = 0; i < fc; i++) {
      var r = '';
      var f = formats[i];
      switch (f) {
        case 'D':
        case 'l':
          var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          r = names[date.getDay()];
          if (f === 'D') {
            r = r.substring(0, 3);
          }
          break;
        case 'F':
        case 'm':
          r = date.getMonth() + 1;
          if (r < 10) r = '0' + r;
          break;
        case 'M':
          months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
          r = months[date.getMonth()];
          if (f === 'M') {
            r = r.substring(0, 3);
          }
          break;
        case 'd':
          r = date.getDate();
          break;
        case 'S':
          r = dom.getOrdinalSuffix(date.getDate());
          break;
        case 'Y':
          r = date.getFullYear();
          break;
        case 'y':
          r = date.getFullYear();
          r = r.toString().substring(2);
          break;
        case 'H':
          r = date.getHours();
          break;
        case 'h':
          r = date.getHours();
          if (r === 0) {
            r = 12;
          } else if (r > 12) {
            r -= 12;
          }
          break;
        case 'i':
          r = dom.addNumberPadding(date.getMinutes());
          break;
        case 'a':
          r = 'am';
          if (date.getHours() >= 12) {
            r = 'pm';
          }
          break;
        default:
          r = f;
          break;
      }
      dateStr += r;
    }
    return dateStr;
  };
  dom.getOrdinalSuffix = function (number) {
    var suffix = '';
    var tmp = (number % 100);
    if (tmp >= 4 && tmp <= 20) {
      suffix = 'th';
    } else {
      switch (number % 10) {
        case 1:
          suffix = 'st';
          break;
        case 2:
          suffix = 'nd';
          break;
        case 3:
          suffix = 'rd';
          break;
        default:
          suffix = 'th';
          break;
      }
    }
    return suffix;
  };
  dom.addNumberPadding = function (number) {
    if (number < 10) {
      number = '0' + number;
    }
    return number;
  };
  dom.tsIso8601ToTimestamp = function (tsIso8601) {
    var regexp = /(\d\d\d\d)(?:-?(\d\d)(?:-?(\d\d)(?:[T ](\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(?:Z|(?:([-+])(\d\d)(?::?(\d\d))?)?)?)?)?)?/;
    var d = tsIso8601.match(new RegExp(regexp));
    if (d) {
      var date = new Date();
      date.setDate(d[3]);
      date.setFullYear(d[1]);
      date.setMonth(d[2] - 1);
      date.setHours(d[4]);
      date.setMinutes(d[5]);
      date.setSeconds(d[6]);
      var offset = (d[9] * 60);
      if (d[8] === '+') {
        offset *= -1;
      }
      offset -= date.getTimezoneOffset();
      var timestamp = (date.getTime() + (offset * 60 * 1000));
      return timestamp;
    }
    return null;
  };

  dom.getRootNode = function(node, container) {
    if (node == container) return node
    while (node.parentNode) {
      if (node.parentNode == container) return node
      node = node.parentNode
    }
  }



  exports.dom = dom;

}).call(this.ice);

(function () {

  var exports = this,
    Selection;

  Selection = function (env) {
    this._selection = null;
    this.env = env;

    this._initializeRangeLibrary();
    this._getSelection();
  };

  Selection.prototype = {

    /**
     * Returns the selection object for the current browser.
     */
    _getSelection: function () {
      if (this._selection) {
		  this._selection.refresh();
	  }
      else if (this.env.frame) {
		  this._selection = rangy.getIframeSelection(this.env.frame);
	  }
      else {
		  this._selection = rangy.getSelection();
	  }
      return this._selection;
    },

    /**
     * Creates a range object.
     */
    createRange: function () {
      return rangy.createRange(this.env.document);
    },

    /**
     * Returns the range object at the specified position. The current range object
     * is at position 0. Note - currently only setting single range in `addRange` so
     * position 0 will be the only allocation filled.
     */
    getRangeAt: function (pos) {
      this._selection.refresh();
      try {
        return this._selection.getRangeAt(pos);
      } catch (e) {
        this._selection = null;
        return this._getSelection().getRangeAt(0);
      }
    },

    /**
     * Adds the specified range to the current selection. Note - only supporting setting
     * a single range, so the previous range gets evicted.
     */
    addRange: function (range) {
      this._selection || (this._selection = this._getSelection());
      this._selection.setSingleRange(range);
      this._selection.ranges = [range];
      return;
    },

    getCursorNode: function(){
      return this._selection.nativeSelection.baseNode
    },

    /**
     * Initialize and extend the `rangy` library with some custom functionality.
     */
    _initializeRangeLibrary: function () {
      var self = this;

      rangy.init();
      rangy.config.checkSelectionRanges = false;

      var move = function (range, unitType, units, isStart) {
        if (units === 0) {
		  return;
        }

        switch (unitType) {
          case ice.dom.CHARACTER_UNIT:
            if (units > 0) {
              range.moveCharRight(isStart, units);
            } else {
              range.moveCharLeft(isStart, units * -1);
            }
            break;

          case ice.dom.WORD_UNIT:
          default:
            // Removed. TODO: possibly refactor or re-implement.
            break;
        }
      };

      /**
       * Moves the start of the range using the specified `unitType`, by the specified
       * number of `units`. Defaults to `CHARACTER_UNIT` and units of 1.
       */
      rangy.rangePrototype.moveStart = function (unitType, units) {
        move(this, unitType, units, true);
      };

      /**
       * Moves the end of the range using the specified `unitType`, by the specified
       * number of `units`.
       */
      rangy.rangePrototype.moveEnd = function (unitType, units) {
        move(this, unitType, units, false);
      };

      /**
       * Depending on the given `start` boolean, sets the start or end containers
       * to the given `container` with `offset` units.
       */
      rangy.rangePrototype.setRange = function (start, container, offset) {
        if (start) {
          this.setStart(container, offset);
        } else {
          this.setEnd(container, offset);
        }
      };

      /**
       * Depending on the given `moveStart` boolean, moves the start or end containers
       * to the left by the given number of character `units`. Use the following
       * example as a demonstration for where the range will fall as it moves in and
       * out of tag boundaries (where "|" is the marked range):
       *
       * test <em>it</em> o|ut
       * test <em>it</em> |out
       * test <em>it</em>| out
       * test <em>i|t</em> out
       * test <em>|it</em> out
       * test| <em>it</em> out
       * tes|t <em>it</em> out
       * 
       * A range could be mapped in one of two ways:
       * 
       * (1) If a startContainer is a Node of type Text, Comment, or CDATASection, then startOffset
       * is the number of characters from the start of startNode. For example, the following
       * are the range properties for `<p>te|st</p>` (where "|" is the collapsed range):
       * 
       * startContainer: <TEXT>test<TEXT>
       * startOffset: 2
       * endContainer: <TEXT>test<TEXT>
       * endOffset: 2
       * 
       * (2) For other Node types, startOffset is the number of child nodes between the start of
       * the startNode. Take the following html fragment:
       * 
       * `<p>some <span>test</span> text</p>`
       * 
       * If we were working with the following range properties:
       * 
       * startContainer: <p>
       * startOffset: 2
       * endContainer: <p>
       * endOffset: 2
       * 
       * Since <p> is an Element node, the offsets are based on the offset in child nodes of <p> and
       * the range is selecting the second child - the <span> tag.
       * 
       * <p><TEXT>some </TEXT><SPAN>test</SPAN><TEXT> text</TEXT></p>
       */
      rangy.rangePrototype.moveCharLeft = function (moveStart, units) {
        var container, offset;

        if (moveStart) {
          container = this.startContainer;
          offset = this.startOffset;
        } else {
          container = this.endContainer;
          offset = this.endOffset;
        }

        // Handle the case where the range conforms to (2) (noted in the comment above).
        if (container.nodeType === ice.dom.ELEMENT_NODE) {
          if (container.hasChildNodes()) {
            container = container.childNodes[offset];

            container = this.getPreviousTextNode(container);

            // Get the previous text container that is not an empty text node.
            while (container && container.nodeType == ice.dom.TEXT_NODE && container.nodeValue === "") {
              container = this.getPreviousTextNode(container);
            }

            offset = container.data.length - units;
          } else {
            offset = units * -1;
          }
        } else {
          offset -= units;
        }

        if (offset < 0) {
          // We need to move to a previous selectable container.
          while (offset < 0) {
            var skippedBlockElem = [];

            container = this.getPreviousTextNode(container, skippedBlockElem);

            // We are at the beginning/out of the editable - break.
            if (!container) {
              return;
            }

            if (container.nodeType === ice.dom.ELEMENT_NODE) {
              continue;
            }

            offset += container.data.length;
          }
        }

        this.setRange(moveStart, container, offset);
      };

      /**
       * Depending on the given `moveStart` boolean, moves the start or end containers
       * to the right by the given number of character `units`. Use the following
       * example as a demonstration for where the range will fall as it moves in and
       * out of tag boundaries (where "|" is the marked range):
       *
       * tes|t <em>it</em> out
       * test| <em>it</em> out
       * test |<em>it</em> out
       * test <em>i|t</em> out
       * test <em>it|</em> out
       * test <em>it</em> |out
       * 
       * A range could be mapped in one of two ways:
       * 
       * (1) If a startContainer is a Node of type Text, Comment, or CDATASection, then startOffset
       * is the number of characters from the start of startNode. For example, the following
       * are the range properties for `<p>te|st</p>` (where "|" is the collapsed range):
       * 
       * startContainer: <TEXT>test<TEXT>
       * startOffset: 2
       * endContainer: <TEXT>test<TEXT>
       * endOffset: 2
       * 
       * (2) For other Node types, startOffset is the number of child nodes between the start of
       * the startNode. Take the following html fragment:
       * 
       * `<p>some <span>test</span> text</p>`
       * 
       * If we were working with the following range properties:
       * 
       * startContainer: <p>
       * startOffset: 2
       * endContainer: <p>
       * endOffset: 2
       * 
       * Since <p> is an Element node, the offsets are based on the offset in child nodes of <p> and
       * the range is selecting the second child - the <span> tag.
       * 
       * <p><TEXT>some </TEXT><SPAN>test</SPAN><TEXT> text</TEXT></p>
       */
      rangy.rangePrototype.moveCharRight = function (moveStart, units) {
        var container, offset;

        if (moveStart) {
          container = this.startContainer;
          offset = this.startOffset;
        } else {
          container = this.endContainer;
          offset = this.endOffset;
        }

        if (container.nodeType === ice.dom.ELEMENT_NODE) {
          container = container.childNodes[offset];
          if (container.nodeType !== ice.dom.TEXT_NODE) {
            container = this.getNextTextNode(container);
          }

          offset = units;
        } else {
          offset += units;
        }

        var diff = (offset - container.data.length);
        if (diff > 0) {
          var skippedBlockElem = [];
          // We need to move to the next selectable container.
          while (diff > 0) {
            container = this.getNextContainer(container, skippedBlockElem);

            if (container.nodeType === ice.dom.ELEMENT_NODE) {
              continue;
            }

            if (container.data.length >= diff) {
              // We found a container with enough content to select.
              break;
            } else if (container.data.length > 0) {
              // Container does not have enough content,
              // find the next one.
              diff -= container.data.length;
            }
          }

          offset = diff;
        }

        this.setRange(moveStart, container, offset);
      };

      /**
       * Returns the deepest next container that the range can be extended to.
       * For example, if the next container is an element that contains text nodes,
       * the the container's firstChild is returned.
       */
      rangy.rangePrototype.getNextContainer = function (container, skippedBlockElem) {
        if (!container) {
          return null;
        }

        while (container.nextSibling) {
          container = container.nextSibling;
          if (container.nodeType !== ice.dom.TEXT_NODE) {
            var child = this.getFirstSelectableChild(container);
            if (child !== null) {
              return child;
            }
          } else if (this.isSelectable(container) === true) {
            return container;
          }
        }

        // Look at parents next sibling.
        while (container && !container.nextSibling) {
          container = container.parentNode;
        }

        if (!container) {
          return null;
        }

        container = container.nextSibling;
        if (this.isSelectable(container) === true) {
          return container;
        } else if (skippedBlockElem && ice.dom.isBlockElement(container) === true) {
          skippedBlockElem.push(container);
        }

        var selChild = this.getFirstSelectableChild(container);
        if (selChild !== null) {
          return selChild;
        }

        return this.getNextContainer(container, skippedBlockElem);
      };

      /**
       * Returns the deepest previous container that the range can be extended to.
       * For example, if the previous container is an element that contains text nodes,
       * then the container's lastChild is returned.
       */
      rangy.rangePrototype.getPreviousContainer = function (container, skippedBlockElem) {
        if (!container) {
          return null;
        }

        while (container.previousSibling) {
          container = container.previousSibling;
          if (container.nodeType !== ice.dom.TEXT_NODE) {
            if (ice.dom.isStubElement(container) === true) {
              return container;
            } else {
              var child = this.getLastSelectableChild(container);
              if (child !== null) {
                return child;
              }
            }
          } else if (this.isSelectable(container) === true) {
            return container;
          }
        }

        // Look at parents next sibling.
        while (container && !container.previousSibling) {
          container = container.parentNode;
        }

        if (!container) {
          return null;
        }

        container = container.previousSibling;
        if (this.isSelectable(container) === true) {
          return container;
        } else if (skippedBlockElem && ice.dom.isBlockElement(container) === true) {
          skippedBlockElem.push(container);
        }

        var selChild = this.getLastSelectableChild(container);
        if (selChild !== null) {
          return selChild;
        }
        return this.getPreviousContainer(container, skippedBlockElem);
      };

      rangy.rangePrototype.getNextTextNode = function (container) {
        if (container.nodeType === ice.dom.ELEMENT_NODE) {
          if (container.childNodes.length !== 0) {
            return this.getFirstSelectableChild(container);
          }
        }

        container = this.getNextContainer(container);
        if (container.nodeType === ice.dom.TEXT_NODE) {
          return container;
        }

        return this.getNextTextNode(container);
      };

      rangy.rangePrototype.getPreviousTextNode = function (container, skippedBlockEl) {
        container = this.getPreviousContainer(container, skippedBlockEl);
        if (container.nodeType === ice.dom.TEXT_NODE) {
          return container;
        }

        return this.getPreviousTextNode(container, skippedBlockEl);
      };

      rangy.rangePrototype.getFirstSelectableChild = function (element) {
        if (element) {
          if (element.nodeType !== ice.dom.TEXT_NODE) {
            var child = element.firstChild;
            while (child) {
              if (this.isSelectable(child) === true) {
                return child;
              } else if (child.firstChild) {
                // This node does have child nodes.
                var res = this.getFirstSelectableChild(child);
                if (res !== null) {
                  return res;
                } else {
                  child = child.nextSibling;
                }
              } else {
                child = child.nextSibling;
              }
            }
          } else {
            // Given element is a text node so return it.
            return element;
          }
        }
        return null;
      };

      rangy.rangePrototype.getLastSelectableChild = function (element) {
        if (element) {
          if (element.nodeType !== ice.dom.TEXT_NODE) {
            var child = element.lastChild;
            while (child) {
              if (this.isSelectable(child) === true) {
                return child;
              } else if (child.lastChild) {
                // This node does have child nodes.
                var res = this.getLastSelectableChild(child);
                if (res !== null) {
                  return res;
                } else {
                  child = child.previousSibling;
                }
              } else {
                child = child.previousSibling;
              }
            }
          } else {
            // Given element is a text node so return it.
            return element;
          }
        }
        return null;
      };

      rangy.rangePrototype.isSelectable = function (container) {
        if (container && container.nodeType === ice.dom.TEXT_NODE && container.data.length !== 0) {
          return true;
        }
        return false;
      };

      rangy.rangePrototype.getHTMLContents = function (clonedSelection) {
        if (!clonedSelection) {
          clonedSelection = this.cloneContents();
        }
        var div = self.env.document.createElement('div');
        div.appendChild(clonedSelection.cloneNode(true));
        return div.innerHTML;
      };

      rangy.rangePrototype.getHTMLContentsObj = function () {
        return this.cloneContents();
      };
    }
  };

  exports.Selection = Selection;

}).call(this.ice);

(function() {

  var exports = this, Bookmark;

  Bookmark = function(env, range, keepOldBookmarks) {

    this.env = env;
    this.element = env.element;
    this.selection = this.env.selection;

    // Remove all bookmarks?
    if (!keepOldBookmarks) {
      this.removeBookmarks(this.element);
    }

    var currRange = range || this.selection.getRangeAt(0);
    range = currRange.cloneRange();
    var startContainer = range.startContainer;
    var endContainer = range.endContainer;
    var startOffset  = range.startOffset;
    var endOffset = range.endOffset;
    var tmp;

    // Collapse to the end of range.
    range.collapse(false);

    var endBookmark  = this.env.document.createElement('span');
    endBookmark.style.display = 'none';
    ice.dom.setHtml(endBookmark, '&nbsp;');
    ice.dom.addClass(endBookmark, 'iceBookmark iceBookmark_end');
    endBookmark.setAttribute('iceBookmark', 'end');
    range.insertNode(endBookmark);
    if(!ice.dom.isChildOf(endBookmark, this.element)) {
      this.element.appendChild(endBookmark);
    }

    // Move the range to where it was before.
    range.setStart(startContainer, startOffset);
    range.collapse(true);

    // Create the start bookmark.
    var startBookmark = this.env.document.createElement('span');
    startBookmark.style.display = 'none';
    ice.dom.addClass(startBookmark, 'iceBookmark iceBookmark_start');
    ice.dom.setHtml(startBookmark, '&nbsp;');
    startBookmark.setAttribute('iceBookmark', 'start');
    try {
      range.insertNode(startBookmark);

      // Make sure start and end are in correct position.
      if (startBookmark.previousSibling === endBookmark) {
        // Reverse..
        tmp  = startBookmark;
        startBookmark = endBookmark;
        endBookmark = tmp;
      }
    } catch (e) {
      // NS_ERROR_UNEXPECTED: I believe this is a Firefox bug.
      // It seems like if the range is collapsed and the text node is empty
      // (i.e. length = 0) then Firefox tries to split the node for no reason and fails...
      ice.dom.insertBefore(endBookmark, startBookmark);
    }

    if (ice.dom.isChildOf(startBookmark, this.element) === false) {
      if (this.element.firstChild) {
        ice.dom.insertBefore(this.element.firstChild, startBookmark);
      } else {
        // Should not happen...
        this.element.appendChild(startBookmark);
      }
    }

    if (!endBookmark.previousSibling) {
      tmp = this.env.document.createTextNode('');
      ice.dom.insertBefore(endBookmark, tmp);
    }

    // The original range object must be changed.
    if (!startBookmark.nextSibling) {
      tmp = this.env.document.createTextNode('');
      ice.dom.insertAfter(startBookmark, tmp);
    }

    currRange.setStart(startBookmark.nextSibling, 0);
    currRange.setEnd(endBookmark.previousSibling, (endBookmark.previousSibling.length || 0));

    this.start = startBookmark;
    this.end = endBookmark;
  };

  Bookmark.prototype = {

    selectBookmark: function() {
      var range = this.selection.getRangeAt(0);
      var startPos = null;
      var endPos = null;
      var startOffset = 0;
      var endOffset = null;
      if (this.start.nextSibling === this.end || ice.dom.getElementsBetween(this.start, this.end).length === 0) {
        // Bookmark is collapsed.
        if (this.end.nextSibling) {
          startPos = ice.dom.getFirstChild(this.end.nextSibling);
        } else if (this.start.previousSibling) {
          startPos = ice.dom.getFirstChild(this.start.previousSibling);
          if (startPos.nodeType === ice.dom.TEXT_NODE) {
            startOffset = startPos.length;
          }
        } else {
          // Create a text node in parent.
          this.end.parentNode.appendChild(this.env.document.createTextNode(''));
          startPos = ice.dom.getFirstChild(this.end.nextSibling);
        }
      } else {
        if (this.start.nextSibling) {
          startPos = ice.dom.getFirstChild(this.start.nextSibling);
        } else {
          if (!this.start.previousSibling) {
            var tmp = this.env.document.createTextNode('');
            ice.dom.insertBefore(this.start, tmp);
          }

          startPos = ice.dom.getLastChild(this.start.previousSibling);
          startOffset = startPos.length;
        }

        if (this.end.previousSibling) {
          endPos = ice.dom.getLastChild(this.end.previousSibling);
        } else {
          endPos = ice.dom.getFirstChild(this.end.nextSibling || this.end);
          endOffset = 0;
        }
      }

      ice.dom.remove([this.start, this.end]);

      if (endPos === null) {
        range.setEnd(startPos, startOffset);
        range.collapse(false);
      } else {
        range.setStart(startPos, startOffset);
        if (endOffset === null) {
          endOffset = (endPos.length || 0);
        }
        range.setEnd(endPos, endOffset);
      }

      try {
        this.selection.addRange(range);
      } catch (e) {
        // IE may throw exception for hidden elements..
      }
    },

    getBookmark: function(parent, type) {
      var elem = ice.dom.getClass('iceBookmark_' + type, parent)[0];
      return elem;
    },

    removeBookmarks: function(elem) {
      ice.dom.remove(ice.dom.getClass('iceBookmark', elem, 'span'));
    }
  };

  exports.Bookmark = Bookmark;

}).call(this.ice);
(function() {

var exports = this;

var IcePlugin = function(ice_instance) {
  this._ice = ice_instance;
};

IcePlugin.prototype = {

  start: function() {},
  clicked: function(e) {
    return true;
  },
  mouseDown: function(e) {
    return true;
  },
  keyDown: function(e) {
    return true;
  },
  keyPress: function(e) {
    return true;
  },
  selectionChanged: function(range) {},
  setEnabled: function(enabled) {},
  setDisabled: function(enabled) {},
  caretUpdated: function() {},
  nodeInserted: function(node, range) {},
  nodeCreated: function(node, options) {},
  caretPositioned: function() {},
  remove: function() {
    this._ice.removeKeyPressListener(this);
  },
  setSettings: function(settings) {}
};

exports.IcePlugin = IcePlugin;

}).call(this.ice);

(function() {

var exports = this;

var IcePluginManager = function(ice_instance) {

  this.plugins = {},
  this.pluginConstructors = {},
  this.keyPressListeners = {},
  this.activePlugin = null,
  this.pluginSets = {},
  this.activePluginSet = null,

  this._ice = ice_instance;
};

IcePluginManager.prototype = {

  getPluginNames: function() {
    var plugins = [];
    for (var name in this.plugins) {
      plugins.push(name);
    }
    return plugins;
  },

  addPluginObject: function(pluginName, pluginObj) {
    this.plugins[pluginName] = pluginObj;
  },

  addPlugin: function(name, pluginConstructor) {
    if (typeof pluginConstructor !== 'function') {
      throw Error('IcePluginException: plugin must be a constructor function');
    }

    if (ice.dom.isset(this.pluginConstructors[name]) === false) {
      this.pluginConstructors[name] = pluginConstructor;
    }
  },

  loadPlugins: function(plugins, callback) {
    if (plugins.length === 0) {
      callback.call(this);
    } else {
      var plugin = plugins.shift();
      if (typeof plugin === 'object') {
        plugin = plugin.name;
      }

      if (ice.dom.isset(ice._plugin[plugin]) === true) {
        this.addPlugin(plugin, ice._plugin[plugin]);
        this.loadPlugins(plugins, callback);
      } else {
        throw new Error('plugin was not included in the page: ' + plugin);
      }
    }
  },

  _enableSet: function(name) {
    this.activePluginSet = name;
    var pSetLen = this.pluginSets[name].length;
    for (var i = 0; i < pSetLen; i++) {
      var plugin   = this.pluginSets[name][i];
      var pluginName = '';
      if (typeof plugin === 'object') {
        pluginName = plugin.name;
      } else {
        pluginName = plugin;
      }

      var pluginConstructor = this.pluginConstructors[pluginName];
      if (pluginConstructor) {
        var pluginObj = new pluginConstructor(this._ice);
        this.plugins[pluginName] = pluginObj;

        if (ice.dom.isset(plugin.settings) === true) {
          pluginObj.setSettings(plugin.settings);
        }

        pluginObj.start();
      }
    }
  },

  setActivePlugin: function(name) {
    this.activePlugin = name;
  },

  getActivePlugin: function() {
    return this.activePlugin;
  },

  _getPluginName: function(pluginConstructor) {
    var fn = pluginConstructor.toString();
    var start = 'function '.length;
    var name = fn.substr(start, (fn.indexOf('(') - start));
    return name;
  },

  /**
   * Removes specified plugin.
   */
  removePlugin: function(plugin) {
    if (this.plugins[plugin]) {
      // Call the remove fn of the plugin incase it needs to do cleanup.
      this.plugins[plugin].remove();
    }
  },

  /**
   * Returns the plugin object for specified plugin name.
   */
  getPlugin: function(name) {
    return this.plugins[name];

  },

  /**
   * Add a new set of plugins.
   */
  usePlugins: function(name, plugins, callback) {
    var self = this;
    if (ice.dom.isset(plugins) === true) {
      this.pluginSets[name] = plugins;
    } else {
      this.pluginSets[name] = [];
    }
    var clone = this.pluginSets[name].concat([]);
    this.loadPlugins(clone, function() {
      self._enableSet(name);
      if(callback) callback.call(this);
    });
  },

  disablePlugin: function(name) {
    this.plugins[name].disable();
  },

  isPluginElement: function(element) {
    for (var i in this.plugins) {
      if (this.plugins[i].isPluginElement) {
        if (this.plugins[i].isPluginElement(element) === true) {
          return true;
        }
      }
    }
    return false;
  },

  fireKeyPressed: function(e) {
    if (this._fireKeyPressFns(e, 'all_keys') === false) {
      return false;
    }

    var eKeys = [];
    if (e.ctrlKey === true || e.metaKey === true) {
      eKeys.push('ctrl');
    }

    if (e.shiftKey === true) {
      eKeys.push('shift');
    }

    if (e.altKey === true) {
      eKeys.push('alt');
    }

    switch (e.keyCode) {
      case 13:
        eKeys.push('enter');
      break;

      case ice.dom.DOM_VK_LEFT:
        eKeys.push('left');
      break;

      case ice.dom.DOM_VK_RIGHT:
        eKeys.push('right');
      break;

      case ice.dom.DOM_VK_UP:
        eKeys.push('up');
      break;

      case ice.dom.DOM_VK_DOWN:
        eKeys.push('down');
      break;

      case 9:
        eKeys.push('tab');
      break;

      case ice.dom.DOM_VK_DELETE:
        eKeys.push('delete');
      break;

      default:
        var code;
        if (e.keyCode) {
          code = e.keyCode;
        } else if (e.which) {
          code = e.which;
        }

        // Other characters (a-z0-9..).
        if (code) {
          eKeys.push(String.fromCharCode(code).toLowerCase());
        }
      break;
    }//end switch

    var eKeysStr = eKeys.sort().join('+');

    return this._fireKeyPressFns(e, eKeysStr);

  },

  _fireKeyPressFns: function(e, eKeysStr) {
    if (this.keyPressListeners[eKeysStr]) {
      var ln = this.keyPressListeners[eKeysStr].length;
      for (var i = 0; i < ln; i++) {
        var listener = this.keyPressListeners[eKeysStr][i];
        var eventFn  = listener.fn;
        var plugin   = listener.plugin;
        var data   = listener.data;

        if (eventFn) {
          if (ice.dom.isFn(eventFn) === true) {
            if (eventFn.call(plugin, e, data) === true) {
              ice.dom.preventDefault(e);
              return false;
            }
          } else if (plugin[eventFn] && plugin[eventFn].call(plugin, e, data) === true) {
            ice.dom.preventDefault(e);
            return false;
          }
        }
      }
    }

    return true;
  },

  fireSelectionChanged: function(range) {
    for (var i in this.plugins) {
      this.plugins[i].selectionChanged(range);
    }
  },

  fireNodeInserted: function(node, range) {
    for (var i in this.plugins) {
      if (this.plugins[i].nodeInserted(node, range) === false) {
        return false;
      }
    }
  },

  fireNodeCreated: function(node, option) {
    for (var i in this.plugins) {
      if (this.plugins[i].nodeCreated(node, option) === false) {
        return false;
      }
    }
  },

  fireCaretPositioned: function() {
    for (var i in this.plugins) {
      this.plugins[i].caretPositioned()
    }
  },

  fireClicked: function(e) {
    var val = true;
    for (var i in this.plugins) {
      if (this.plugins[i].clicked(e) === false) {
        val = false;
      }
    }
    return val;
  },

  fireMouseDown: function(e) {
    var val = true;
    for (var i in this.plugins) {
      if (this.plugins[i].mouseDown(e) === false) {
        val = false;
      }
    }
    return val;
  },

  fireKeyDown: function(e) {
    var val = true;
    for (var i in this.plugins) {
      if (this.plugins[i].keyDown(e) === false) {
        val = false;
      }
    }
    return val;
  },

  fireKeyPress: function(e) {
    var val = true;
    for (var i in this.plugins) {
      if (this.plugins[i].keyPress(e) === false) {
        val = false;
      }
    }
    return val;
  },

  fireEnabled: function(enabled) {
    for (var i in this.plugins) {
      this.plugins[i].setEnabled(enabled);
    }
  },

  fireDisabled: function(disabled) {
    for (var i in this.plugins) {
      this.plugins[i].setDisabled(disabled);
    }
  },

  fireCaretUpdated: function() {
    for (var i in this.plugins) {
      if (this.plugins[i].caretUpdated) {
        this.plugins[i].caretUpdated();
      }
    }
  }
};

exports._plugin = {};
exports.IcePluginManager = IcePluginManager;

}).call(this.ice);

(function() {

var exports = this, IceAddTitlePlugin;
  
IceAddTitlePlugin = function(ice_instance) {
  this._ice = ice_instance;
};

IceAddTitlePlugin.prototype = {
  nodeCreated: function(node, option) {
    node.setAttribute('title', (option.action || 'Modified') + ' by ' + node.getAttribute(this._ice.userNameAttribute)
        + ' - ' + ice.dom.date('m/d/Y h:ia', parseInt(node.getAttribute(this._ice.timeAttribute))));
  }
};

ice.dom.noInclusionInherits(IceAddTitlePlugin, ice.IcePlugin);
exports._plugin.IceAddTitlePlugin = IceAddTitlePlugin;

}).call(this.ice);

(function() {

var exports = this, IceCopyPastePlugin;

IceCopyPastePlugin = function(ice_instance) {
  this._ice = ice_instance;
  this._tmpNode = null;
  this._tmpNodeTagName = 'icepaste';
  this._pasteId = 'icepastediv';
  var self = this;
  
  // API

  // 'formatted' - paste will be MS Word cleaned.
  // 'formattedClean' - paste will be MS Word cleaned, insert and
  //    delete tags will be removed keeping insert content in place,
  //    and tags not found in `preserve` will be stripped.
  this.pasteType = 'formatted';

  // Subset of tags that will not be stripped when pasteType
  // is set to 'formattedClean'. Parameter is of type string with
  // comma delimited tag and attribute definitions. For example:
  //   'p,a[href],i[style|title],span[*]'
  // Would allow `p`, `a`, `i` and `span` tags. The attributes for
  // each one of these tags would be cleaned as follows: `p` tags
  // would have all attributes removed, `a` tags will have all but
  // `href` attributes removed, `i` tags will have all but `style`
  // and `title` attributes removed, and `span` tags will keep all attributes.
  this.preserve = 'p';

  // Callback triggered before any paste cleaning happens
  this.beforePasteClean = function(body) { return body; };

  // Callback triggered at the end of the paste cleaning
  this.afterPasteClean = function(body) { return body; };

  // Event Listener for copying
  ice_instance.element.oncopy = function() { return self.handleCopy.apply(self); };
};

IceCopyPastePlugin.prototype = {

  setSettings: function(settings) {
    settings = settings || {};
    ice.dom.extend(this, settings);

    this.preserve += ',' + this._tmpNodeTagName;
    this.setupPreserved();
  },

  keyDown: function(e) {
    if (e.metaKey !== true && e.ctrlKey !== true)
      return;
    if (e.keyCode == 86)
      this.handlePaste();
    else if (e.keyCode == 88)
      this.handleCut();
    return true;
  },

  handleCopy: function(e) {},

  // Inserts a temporary placeholder for the current range and removes
  // the contents of the ice element body and calls a paste handler.
  handlePaste: function(e) {

    var range = this._ice.getCurrentRange();

    if (!range.collapsed) {
      if (this._ice.isTracking) {
        this._ice.deleteContents();
        range = range.cloneRange();
      } else {
        range.deleteContents();
        range.collapse(true);
      }
    }

    if (this._ice.isTracking)
      this._ice._moveRangeToValidTrackingPos(range);

    if (range.startContainer == this._ice.element) {
      // Fix a potentially empty body with a bad selection
      var firstBlock = ice.dom.find(this._ice.element, this._ice.blockEl)[0];
      if(!firstBlock) {
        firstBlock = ice.dom.create('<' + this._ice.blockEl + ' ><br/></' + this._ice.blockEl + '>');
        this._ice.element.appendChild(firstBlock);
      }
      range.setStart(firstBlock, 0);
      range.collapse(true);
      this._ice.env.selection.addRange(range);
    }

    this._tmpNode = this._ice.env.document.createElement(this._tmpNodeTagName);
    range.insertNode(this._tmpNode);

    switch (this.pasteType) {
      case 'formatted':
        this.setupPaste();
        break;
      case 'formattedClean':
        this.setupPaste(true);
        break;
    }
             
    return true;
  },

  // Create a temporary div and set focus to it so that the browser can paste into it.
  // Set a timeout to push a paste handler on to the end of the execution stack.
  setupPaste: function(stripTags) {
    var div = this.createDiv(this._pasteId),
        self = this,
        range = this._ice.getCurrentRange();
    
    range.selectNodeContents(div);
    this._ice.selection.addRange(range);

    div.onpaste = function(event) {
      setTimeout(function(){
        self.handlePasteValue(stripTags);
      },0);
       event.stopPropagation();
    };

    div.focus();
    return true;
  },

  // By the time we get here, the pasted content will already be in the body. Extract the
  // paste, format it, remove any Microsoft or extraneous tags outside of `this.preserve`
  // and merge the pasted content into the original fragment body.
  handlePasteValue: function(stripTags) {
    // Get the pasted content.
    var doc = this._ice.env.document,
        pasteDiv = doc.getElementById(this._pasteId),
        lastChildIdx = pasteDiv.children.length,
        This = this

    //remove a trailing br
    if (lastChildIdx && pasteDiv.children[lastChildIdx - 1].nodeName == "BR") {
      pasteDiv.children[lastChildIdx - 1].remove()
    } 
    
    //if the html is plain text, paste only that, not the wrapping span tag
    if(pasteDiv.children.length == 1 && pasteDiv.children[0].tagName == 'SPAN') {
      pasteDiv.innerHTML = pasteDiv.innerText
    }

    var html = ice.dom.getHtml(pasteDiv)

    html = this.beforePasteClean.call(this, html);

    if(stripTags) { 
      // Strip out change tracking tags.
      html = this._ice.getCleanContent(html);
      html = this.stripPaste(html);
    }

    html = this.afterPasteClean.call(this, html);
    html = ice.dom.trim(html);
    var range = this._ice.getCurrentRange();
    range.setStartAfter(this._tmpNode);
    range.collapse(true);

    var innerBlock = null, lastEl = null, newEl = null;
    var fragment = range.createContextualFragment(html);
    var changeid = this._ice.startBatchChange();

    // If fragment contains block level elements, most likely we will need to
    // do some splitting so we do not have P tags in P tags, etc. Split the
    // container from current selection and then insert paste contents after it.
    if ((pasteDiv.firstChild.nodeName == 'UL' || pasteDiv.firstChild.nodeName == 'OL') && range.commonAncestorContainer.nodeName == "LI") {
      var lis = ice.dom.children(pasteDiv.firstChild, "li")
      for (var i = lis.length - 1; i >= 0; i--) {
        var el = lis[i]
        newEl = This._ice.createIceNode('insertType', el);
        This._ice.addChange('insertType', [el]);
        range.commonAncestorContainer.insertAdjacentElement('afterend', newEl)
      }
    } else if(ice.dom.hasBlockChildren(fragment)) {
      // Split from current selection.
      var block = ice.dom.isChildOfTagNames(this._tmpNode, ice.dom.BLOCK_ELEMENTS);
      if (block) {
        range.setEndAfter(block.lastChild);
        this._ice.selection.addRange(range);
        var contents = range.extractContents();
        var newblock = doc.createElement(range.commonAncestorContainer.nodeName.toLowerCase());
        newblock.appendChild(contents);
        ice.dom.insertAfter(block, newblock);

        range.setStart(newblock, 0);
        range.collapse(true);
        this._ice.selection.addRange(range);
        var prevBlock = range.startContainer;
      }
      
      
      // Paste all of the children in the fragment.
      while(fragment.firstChild) {
        if(fragment.firstChild.nodeType === 3 && !jQuery.trim(fragment.firstChild.nodeValue)) {
          fragment.removeChild(fragment.firstChild);
          continue;
        }
        // We may have blocks with text nodes at the beginning or end. For example, this paste:
        //  textnode <p>blocktext</p> <p>blocktext</p> moretext
        // In which case we wrap the leading or trailing text nodes in blocks.
        if(ice.dom.isBlockElement(fragment.firstChild)) {
          if(fragment.firstChild.textContent !== "") {
            innerBlock = null;
            var insert = null;
            if(this._ice.isTracking) {
              insert = this._ice.createIceNode('insertType');
              this._ice.addChange('insertType', [insert]);
              newEl = doc.createElement(fragment.firstChild.tagName);
              insert.innerHTML = fragment.firstChild.innerHTML;
              newEl.appendChild(insert);
            } else {
              insert = newEl = doc.createElement(fragment.firstChild.tagName);
              newEl.innerHTML = fragment.firstChild.innerHTML;
            }
            lastEl = insert;
            ice.dom.insertBefore(prevBlock, newEl);
          }
          fragment.removeChild(fragment.firstChild);
        } else {
          if(!innerBlock) {
            // Create a new block and append an insert
            newEl = doc.createElement(this._ice.blockEl);
            ice.dom.insertBefore(prevBlock, newEl);
            if(this._ice.isTracking) {
              innerBlock = this._ice.createIceNode('insertType');
              this._ice.addChange('insertType', [innerBlock]);
              newEl.appendChild(innerBlock);
            } else {
              innerBlock = newEl;
            }
          }
          lastEl = innerBlock;
          innerBlock.appendChild(fragment.removeChild(fragment.firstChild));
        }
      }
      if (newblock && !newblock.textContent) {
        newblock.parentNode.removeChild(newblock);
      }

    } else {
      if(this._ice.isTracking) {
        newEl = this._ice.createIceNode('insertType', fragment);
        this._ice.addChange('insertType', [newEl]);
        range.insertNode(newEl);
        lastEl = newEl;
      } else {
        var child;
        while((child = fragment.firstChild)) {
          range.insertNode(child);
          range.setStartAfter(child);
          range.collapse(true);
          lastEl = child;
        }
      }
    }
    this._ice.endBatchChange(changeid);
    pasteDiv.parentNode.removeChild(pasteDiv);
    this._cleanup(lastEl);

    this._ice.ensureEmptyEnd()
  },


  createDiv: function(id) {
    var doc = this._ice.env.document, // Document object of window or tinyMCE iframe
        oldEl = doc.getElementById(id);
    if(oldEl) {
      ice.dom.remove(oldEl);
    }

    var div = doc.createElement('div');
    div.id = id;
    div.setAttribute('contentEditable', true);
    ice.dom.setStyle(div, 'width', '1px');
    ice.dom.setStyle(div, 'height', '1px');
    ice.dom.setStyle(div, 'overflow', 'hidden');
    ice.dom.setStyle(div, 'position', 'fixed');
    ice.dom.setStyle(div, 'top', '10px');
    ice.dom.setStyle(div, 'left', '10px');

    div.appendChild(doc.createElement('br'));
    doc.body.appendChild(div);
    return div;
  },

  // Intercepts cut operation and handles by creating an editable div, copying the current selection
  // into it, deleting the current selection with track changes, and selecting the contents in the
  // editable div.
  handleCut: function() {
    var self = this,
        range = this._ice.getCurrentRange();
    if (range.collapsed) return; // If nothing is selected, there's nothing to mark deleted

    this.cutElement = this.createDiv('icecut');
    // Chrome strips out spaces between text nodes and elements node during cut
    this.cutElement.innerHTML = range.getHTMLContents().replace(/ </g, '&nbsp;<').replace(/> /g, '>&nbsp;');

    if (this._ice.isTracking) this._ice.deleteContents();
    else range.deleteContents();

    var crange = this._ice.env.document.createRange();
    crange.setStart(this.cutElement.firstChild, 0);
    crange.setEndAfter(this.cutElement.lastChild);

    setTimeout(function() {
      self.cutElement.focus();

      // After the browser cuts out of the `cutElement`, reset the range and remove the cut element.
      setTimeout(function() {
        ice.dom.remove(self.cutElement);
        range.setStart(range.startContainer, range.startOffset);
        range.collapse(false);
        self._ice.env.selection.addRange(range);
      }, 100);
    }, 0);
    
    self._ice.env.selection.addRange(crange);
  },


  // Strips ice change tracking tags, Microsoft Word styling/content, and any
  // tags and attributes not found in `preserve` from the given `content`.
  stripPaste: function(content) {
    // Clean word stuff out and strip tags that are not in `this.preserve`.
    content = this._cleanWordPaste(content);
    content = this.cleanPreserved(content);
    return content;
  },

  // Parses `preserve` to setup `_tags` with a comma delimited list of all of the
  // defined tags, and the `_attributesMap` with a mapping between the allowed tags and
  // an array of their allowed attributes. For example, given this value:
  //   `preserve` = 'p,a[href|class],span[*]'
  // The following will result:
  //   `_tags` = 'p,a,span'
  //   `_attributesMap` = ['p' => [], 'a' => ['href', 'class'], 'span' => ['*']]
  setupPreserved: function() {
    var self = this;
    this._tags = '';
    this._attributesMap = [];
    
    ice.dom.each(this.preserve.split(','), function(i, tagAttr) {
      // Extract the tag and attributes list
      tagAttr.match(/(\w+)(\[(.+)\])?/);
      var tag = RegExp.$1;
      var attr = RegExp.$3;

      if(self._tags) self._tags += ',';
      self._tags += tag.toLowerCase();
      self._attributesMap[tag] = attr.split('|');
    });
  },

  // Cleans the given `body` by removing any tags not found in `_tags` and replacing them with
  // their inner contents, and removes attributes from any tags that aren't mapped in `_attributesMap`.
  cleanPreserved: function(body) {
    var self = this;
    var bodyel = this._ice.env.document.createElement('div');
    bodyel.innerHTML = body;

    // Strip out any tags not found in `this._tags`, replacing the tags with their inner contents.
    bodyel = ice.dom.stripEnclosingTags(bodyel, this._tags);

    // Strip out any attributes from the allowed set of tags that don't match what is in the `_attributesMap`
    ice.dom.each(ice.dom.find(bodyel, this._tags), function(i, el) {
      if (ice.dom.hasClass(el, 'skip-clean')) {
        return true;
      }
      var tag = el.tagName.toLowerCase();
      var attrMatches = self._attributesMap[tag];

      // Kleene star - keep all of the attributes for this tag.
      if(attrMatches[0] && attrMatches[0] === '*')
        return true;

      // Remove any foreign attributes that do not match the map.
      if(el.hasAttributes()) {
        var attributes = el.attributes;
        for(var i = attributes.length - 1; i >= 0; i--) {
          if(!ice.dom.inArray(attributes[i].name, attrMatches)) {
            el.removeAttribute(attributes[i].name);
          }
        }
      }
    });
    return bodyel.innerHTML;
  },

  _cleanWordPaste: function(content) {
    // Meta and link tags.
    content = content.replace(/<(meta|link)[^>]+>/g, "");

    // Comments.
    content = content.replace(/<!--(.|\s)*?-->/g, '');

    // Remove style tags.
    content = content.replace(/<style>[\s\S]*?<\/style>/g, '');

    // Remove span and o:p etc. tags.
    //content = content.replace(/<\/?span[^>]*>/gi, "");
    content = content.replace(/<\/?\w+:[^>]*>/gi, '' );

    // Remove XML tags.
    content = content.replace(/<\\?\?xml[^>]*>/gi, '');

    // Generic cleanup.
    content = this._cleanPaste(content);

    // Remove class, lang and style attributes.
    content = content.replace(/<(\w[^>]*) (lang)=([^ |>]*)([^>]*)/gi, "<$1$4");
  
    return content;
  },

  _cleanPaste: function(content) {
    // Some generic content cleanup. Change all b/i tags to strong/em.
    content = content.replace(/<b(\s+|>)/g, "<strong$1");
    content = content.replace(/<\/b(\s+|>)/g, "</strong$1");
    content = content.replace(/<i(\s+|>)/g, "<em$1");
    content = content.replace(/<\/i(\s+|>)/g, "</em$1");
    return content;
  },

  _cleanup: function(moveTo) {
    try {
      // Set focus back to ice element.
      if (this._ice.env.frame)
        this._ice.env.frame.contentWindow.focus();
      else
        this._ice.element.focus();

      moveTo = moveTo && moveTo.lastChild || moveTo || this._tmpNode;
      // Move the range to the end of moveTo so that the cursor will be at the end of the paste.
      var range = this._ice.getCurrentRange();
      range.setStartAfter(moveTo);
      range.collapse(true);
      this._ice.selection.addRange(range);
      
      // Kill the tmp node.
      this._tmpNode.parentNode.removeChild(this._tmpNode);
      this._tmpNode = null;
      // Kill any empty change nodes.
      var ins = this._ice.env.document.getElementsByClassName(this._ice.changeTypes['insertType'].alias);
      for(var i = 0; i < ins.length; i++) {
        if(!ins[i].textContent) {
          if(ins[i].parentNode) {
            ins[i].parentNode.removeChild(ins[i]);
          }
        }
      }
    } catch(e) {
      window.console && console.error(e);
    }
  }
};

ice.dom.noInclusionInherits(IceCopyPastePlugin, ice.IcePlugin);
exports._plugin.IceCopyPastePlugin = IceCopyPastePlugin;

}).call(this.ice);

(function () {

	var exports = this;

	/**
	 * When active, this plugin will convert two successively typed dashes, within
	 * the ice block element, into an emdash. 
	 */
	var IceEmdashPlugin = function (ice_instance) {
		this._ice = ice_instance;
	};

	IceEmdashPlugin.prototype = {

		keyDown: function (e) {
			// // Catch dashes.
			// if (ice.dom.isBrowser('mozilla')) {
			// 	var version = parseInt(ice.dom.browser().version);
			// 	if ((version > 14 && e.keyCode === 173) || (version <= 14 && e.keyCode === 109)) {
			// 		return this.convertEmdash(e);
			// 	}
			// } else 
			if (e.keyCode === 189) {
				return this.convertEmdash(e);
			}
			return true;
		},

		convertEmdash: function (e) {
			var range = this._ice.getCurrentRange();
			if (range.collapsed) {
				try {
					// Move the start back one character so we can enclose the range around the previous character to check if it is a dash
					range.moveStart(ice.dom.CHARACTER_UNIT, -1);
					// Get the parent block element for the start and end containers
					var startBlock = ice.dom.getParents(range.startContainer, this._ice.blockEl)[0];
					var endBlock = ice.dom.getParents(range.endContainer, this._ice.blockEl)[0];
					// Make sure that the start and end containers aren't in different blocks, or that the start isn't in a delete.
					if (startBlock === endBlock && !this._ice.getIceNode(range.startContainer, 'deleteType')) {
						// Get the last character and check to see if it is a dash.
						c = range.toHtml();
						if (c === '-') {
							// Extract the last character/dash and insert an emdash
							range.extractContents();
							range.collapse();
							var mdash = this._ice.env.document.createTextNode('\u2014');
							if (this._ice.isTracking) {
								this._ice._insertNode(mdash, range);
							} else {
								range.insertNode(mdash);
								range.setStart(mdash, 1);
								range.collapse(true);
							}
							this._ice._preventKeyPress = true;
							return false;
						}
					}
				} catch (e) { }
				range.collapse();
			}
			return true;
		}

	};

	ice.dom.noInclusionInherits(IceEmdashPlugin, ice.IcePlugin);
	exports._plugin.IceEmdashPlugin = IceEmdashPlugin;

}).call(this.ice);

(function () {

	var exports = this;

	/**
	 * When active, this plugin will convert two successively typed dashes, within
	 * the ice block element, into an emdash. 
	 */
	var plugin = function (ice_instance) {
		this._ice = ice_instance;

	};

	plugin.prototype = {

		keyDown: function (e) {
			if (e.keyCode != 9) return true

			var node = this._ice.getCurrentRange().startContainer
			if (!node) return true

			//if we are in an li, indent/outdent, otherwise, change the marginLeft
			if (this.isInLi()) {
				if (e.shiftKey) {
					//get the existing li
					var li = ice.dom.isChildOfTagName( this._ice.selection.getCursorNode(), "li")

					var origParent = ice.dom.getParents(li, 'ul, ol', this._ice.element)

					//browser command
					document.execCommand('outdent')

					//if we are no longer in a li, then the browser made this a root node. wrap this in a tracking range
					if (!this.isInLi()) {
						var isInBlock = !!ice.dom.getParents(this._ice.getCurrentRange().startContainer, this._ice.blockEl).length
						if (!isInBlock) {
							var rootNode = ice.dom.getRootNode(this._ice.getCurrentRange().startContainer, this._ice.element)
							var newRootNode = this._ice.env.document.createElement(this._ice.blockEl)
							
							var insert = newRootNode;
							if (this._ice.isTracking) {
							  var changeid = this._ice.startBatchChange();
							  insert = this._ice.createIceNode('insertType');
							  this._ice.addChange('insertType', [insert]);
							  newRootNode.appendChild(insert)
							  this._ice.endBatchChange(changeid);
							}
							insert.innerHTML = rootNode.innerHTML

							//replace the root span the browser created w/ the new root p tag
							ice.dom.replaceWith(rootNode, newRootNode)
						}

						//clean up any empty ul, ol tags
							//find all uls and ols
							this._ice.find('ol, ul').each(function(i, el){
								if (ice.dom.find(el, 'li').length == 0) {
									el.remove()
								}
							})
							//foreach, if it doesn't have any lis, remove
						
						

					}
				} else document.execCommand('indent')
			} else {
				var newMargin = parseInt("0" + node.style.marginLeft)
				if (e.shiftKey) {
					newMargin -= 40
				} else {
					newMargin += 40
				}
				node.style.marginLeft = newMargin + "px"
			}

			return false;
		},

		isInLi: function () {
			var node = this._ice.selection.getCursorNode()
			if (!node) return false

			var isInLi = ice.dom.closest(node, 'li', this._ice.element).length
			return !!isInLi
		}

	};

	ice.dom.noInclusionInherits(plugin, ice.IcePlugin);
	exports._plugin.Indent = plugin;

}).call(this.ice);

(function() {

var exports = this, ice = this.ice;

var IceSmartQuotesPlugin = function(ice_instance) {
  this._ice = ice_instance;
};

IceSmartQuotesPlugin.prototype = {

  /**
   * Finds each block in `element` and converts quotes into smart quotes.
   */
  convert: function(element) {
    var self = this;
    try {
      self._ice.placeholdDeletes();
      ice.dom.each(element.getElementsByTagName(this._ice.blockEl), function(i, el) {
        console.time('smart quotes took')
        self._convertBlock(el);
        console.timeEnd('smart quotes took')
      });
    } catch(e) {
      window.console && console.error(e);
    } finally {
      self._ice.revertDeletePlaceholders();
    }
  },
  
  // Converts the quotes in the given element to smart quotes.
  _convertBlock: function(el) {

    // If there are less than 2 characters, we don't have enough to go on.
    if (ice.dom.getNodeTextContent(el) < 2) return;

     console.time('smart quotes took')

    var previous, current, next, data, html = '', getNextChar,
      regularSingle = "'",
      regularDouble = '"',
      smartSingleLeft = String.fromCharCode(8216),  // aka - open curly single quote
      smartSingleRight = String.fromCharCode(8217),   // aka - close curly single quote
      smartDoubleLeft = String.fromCharCode(8220),  // aka - open curly double quote
      smartDoubleRight = String.fromCharCode(8221),   // aka - close curly double quote
      isDigit = function(c) { return /\d/.test(c); },
      isChar = function(c) { return /\w/.test(c); },
      isSpace = function(c) { return c === String.fromCharCode(160) || c === String.fromCharCode(32); },
      isStartChar = function(c) { return isSpace(c) || c === '('; },
      isEndChar = function(c) { return isSpace(c) || c == null || c === ';' || c === ')' || c == '.' || c === '!' || c === ',' || c === '?' || c === ':'; },
      isNonSpace = function(c) { return !isSpace(c); },
      isDouble = function(c) { return c === regularDouble || c === smartDoubleLeft || c === smartDoubleRight; },
      isSingle = function(c) { return c === regularSingle || c === smartSingleLeft || c === smartSingleRight; };

    // Split the html into array allocations with the following criteria:
    //   html tags: starts with "<" and ends with ">"
    //   html entities: starts with "&" and ends with ";"
    //   characters: any character outside of an html tag or entity
    // So the following html:
    //   n&ce <b id="bold">test</b>
    // Would split into the following array:
    //  ['n', '&amp;', 'c', 'e', ' ', '<b id="bold">', 't', 'e', 's', 't', '</b>'];
    data = ice.dom.getHtml(el).match(/(<("[^"]*"|'[^']*'|[^'">])*>|&.*;|.)/g);

    // Searches through the `data` array from the given index a given number of
    // characters forward or backward and returns the found character.
    getNextChar = function(data, fromIndex, nCharacters) {
      var dLength = data.length,
        addWith = nCharacters < 0 ? -1 : 1;
    
      return (function getChar(data, fromIndex, nCharacters) {
        // Base case - did we move outside of the bounds of the data array?
        if (fromIndex < 0 || fromIndex >= dLength) return null;
        
        var next = data[fromIndex + addWith];

        // If we find a character and we have moved through the
        // nCharacters, then the recursion is done.
        if (next && next.length == 1) {
          nCharacters += (addWith * -1);
          if (!nCharacters) return next;
        }
        return getChar(data, fromIndex + addWith, nCharacters);

      })(data, fromIndex, nCharacters);
    };

    ice.dom.each(data, function(pos, val) {
      // Convert space entities so that they can be processed as normal characters.
      if (val == '&nbsp;') val = data[pos] = ' ';

      // If the val is a character, then examine the surroundings
      // and convert smart quotes, if necessary.
      if (val.length == 1) {
        
        // Keep convenience pointers to the previous, current and next characters.
        previous = getNextChar(data, pos, -1);
        current = val;
        next = getNextChar(data, pos, 1);

        switch (current) {
          
          /**
           * Conversion Rules:
           * ----------------
           * 
           * START: assign smart left/open
           *   [SPACE|START_PARENTHESIS]'word
           *   [SPACE|START_PARENTHESIS]"word
           * 
           * END: assign smart right/close
           *   word'[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
           *   word"[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
           * 
           * PLURAL_CONTRACTION: assign smart right/close
           *   Matt's
           *   can't
           *   O'Reilly
           * 
           * YEAR_ABBREVIATION: assign smart right/close
           *   [SPACE|NULL]'99[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
           * 
           * NESTED_START: assign smart left/open
           *   [SPACE|NULL]"[SPACE]'word
           * 
           * NESTED_END: assign smart left/open
           *   word'[SPACE]"[SPACE|SEMICOLON|COLON|PERIOD|COMMA|EXCLAMATION_MARK|QUESTION_MARK|END_PARENTHESIS|NULL]
           * 
           * Notes:
           *  - The following will not be converted correctly - ...word 'Til Death - it should
           *  get a right/close smart quote, but will get a left/open.
           *  - Distinguishing between year abbreviation, '99, and when to use an open single quote
           *  could fail if a single quoted region starts with a double digit number - '99 problems'
           *  - Since they are a rare case and there are many permutations, measurements are not being
           *  handled (6'8", 6' 8", 6', 8").
           */

          // Convert smart single quotes to non-smart quote and fall through to single quote 
          // handling, in case the context has changed and we need to update the smart quote.
          case smartSingleLeft:
          case smartSingleRight:
            current = regularSingle;
          case regularSingle:
            // YEAR_ABBREVIATION - look 2 ahead to see if there are two digits in a row - not fool proof
            if ((previous == null || isSpace(previous)) && isDigit(next) && isDigit(getNextChar(data, pos, 2)) && isEndChar(getNextChar(data, pos, 3)))
              current = smartSingleRight;
            // START
            else if (previous == null || (isStartChar(previous) && isNonSpace(next)))
              current = smartSingleLeft;
            // END
            else if (next == null || (isNonSpace(previous) && isEndChar(next)))
              current = smartSingleRight;
            // PLURAL_CONTRACTION
            else if (isChar(previous) && isChar(next))
              current = smartSingleRight;
            break;
          
          // Convert smart double quotes to non-smart quote and fall through to double quote 
          // handling, in case the context has changed and we need to update the smart quote.
          case smartDoubleLeft:
          case smartDoubleRight:
            current = regularDouble;
          case regularDouble:
            // NESTED_END
            if (isEndChar(next) && isSpace(previous) && isSingle(getNextChar(data, pos, -2)))
              current = smartDoubleRight;
            // START
            else if (previous == null || (isStartChar(previous) && isNonSpace(next)))
              current = smartDoubleLeft;
            // END
            else if (next == null || (isNonSpace(previous) && isEndChar(next)))
              current = smartDoubleRight;
            // NESTED_START
            else if ((previous == null || isSpace(previous)) && (isSpace(next) && isSingle(getNextChar(data, pos, 1))))
              current = smartDoubleLeft;
            break;
        }
        if (current != null) data[pos] = current;
      }
    });
    
    ice.dom.setHtml(el, data.join(''));

    console.time('smart quotes took')
  }
};

ice.dom.noInclusionInherits(IceSmartQuotesPlugin, ice.IcePlugin);
exports.ice._plugin.IceSmartQuotesPlugin = IceSmartQuotesPlugin;

}).call(this);
/* global moment, angular */
(function () {
	'use strict';

	var module = angular.module("mdPickers", [
		"ngMaterial",
		"ngAnimate"
	]);

	module.config(["$mdIconProvider", "mdpIconsRegistry", function ($mdIconProvider, mdpIconsRegistry) {
		angular.forEach(mdpIconsRegistry, function (icon, index) {
			$mdIconProvider.icon(icon.id, icon.url);
		});
	}]);

	module.run(["$templateCache", "mdpIconsRegistry", function ($templateCache, mdpIconsRegistry) {
		angular.forEach(mdpIconsRegistry, function (icon, index) {
			$templateCache.put(icon.url, icon.svg);
		});
	}]);

})();
/* global moment, angular */
(function () {
    'use strict';
    
    var module = angular.module("mdPickers")

    function TimePickerCtrl($scope, $mdDialog, time, autoSwitch, $mdMedia) {
        var self = this;
        this.VIEW_HOURS = 1;
        this.VIEW_MINUTES = 2;
        this.currentView = this.VIEW_HOURS;
        if (time && isDate(time) && time.getHours() != 0) {
            this.time = moment(time)
            $scope.predictAmPm = false
        } else {
            this.time = moment().subtract(1, 'days').startOf('day')
            $scope.predictAmPm = true
        }
    
        this.autoSwitch = !!autoSwitch;
        this.hasSwitched = false
    
        this.clockHours = parseInt(this.time.format("h"));
        this.clockMinutes = parseInt(this.time.minutes());
    
        $scope.$mdMedia = $mdMedia;
	
        this.switchView = function () {
            self.currentView = self.currentView == self.VIEW_HOURS ? self.VIEW_MINUTES : self.VIEW_HOURS;
        };
    
        this.setAM = function () {
            if (self.time.hours() >= 12)
                self.time.hour(self.time.hour() - 12);
        };
    
        this.setPM = function () {
            if (self.time.hours() < 12)
                self.time.hour(self.time.hour() + 12);
        };
    
        this.cancel = function () {
            $mdDialog.cancel();
        };

        this.confirm = function () {
            $mdDialog.hide(this.time.toDate());
        };
    }

    function ClockCtrl($scope) {
        var TYPE_HOURS = "hours";
        var TYPE_MINUTES = "minutes";
        var self = this;
    
        this.STEP_DEG = 360 / 12;
        this.steps = [];
    
        this.CLOCK_TYPES = {
            "hours": {
                range: 12,
            },
            "minutes": {
                range: 60,
            }
        }
    
        this.getPointerStyle = function () {
            var divider = 1;
            switch (self.type) {
                case TYPE_HOURS:
                    divider = 12;
                    break;
                case TYPE_MINUTES:
                    divider = 60;
                    break;
            }
            var degrees = Math.round(self.selected * (360 / divider)) - 180;
            return {
                "-webkit-transform": "rotate(" + degrees + "deg)",
                "-ms-transform": "rotate(" + degrees + "deg)",
                "transform": "rotate(" + degrees + "deg)"
            }
        };
    
        this.setTimeByDeg = function (deg) {
            deg = deg >= 360 ? 0 : deg;
            var divider = 0;
            switch (self.type) {
                case TYPE_HOURS:
                    divider = 12;
                    break;
                case TYPE_MINUTES:
                    divider = 60;
                    break;
            }
        
            self.setTime(
                Math.round(divider / 360 * deg)
            );
        };
    
        this.setTime = function (time, type) {
            this.selected = time;
        
            switch (self.type) {
                case TYPE_HOURS:
                    if ($scope.predictAmPm) {
                        if (time < 7) time += 12
                    } else {
                        if (self.time.format("A") == "PM") time += 12;
                    }
                    this.time.hours(time);
                    break;
                case TYPE_MINUTES:
                    if (time > 59) time -= 60;
                    if (time % 5 != 0) time = Math.round(time / 5) * 5
                    this.time.minutes(time);
                    break;
            }
        
        };
    
        this.init = function () {
            self.type = self.type || "hours";
            switch (self.type) {
                case TYPE_HOURS:
                    for (var i = 1; i <= 12; i++)
                        self.steps.push(i);
                    self.selected = self.time.hours() || 0;
                    if (self.selected > 12) self.selected -= 12;
                    
                    break;
                case TYPE_MINUTES:
                    for (var i = 5; i <= 55; i += 5)
                        self.steps.push(i);
                    self.steps.push(0);
                    self.selected = self.time.minutes() || 0;
                
                    break;
            }
        };
    
        this.init();
    }

    module.directive("mdpClock", ["$animate", "$timeout", function ($animate, $timeout) {
        return {
            restrict: 'E',
            bindToController: {
                'type': '@?',
                'time': '=',
                'autoSwitch': '=?'
            },
            replace: true,
            template: '<div class="mdp-clock">' +
            '<div class="mdp-clock-container">' +
            '<md-toolbar class="mdp-clock-center md-primary"></md-toolbar>' +
            '<md-toolbar ng-style="clock.getPointerStyle()" class="mdp-pointer md-primary">' +
            '<span class="mdp-clock-selected md-button md-raised md-primary"></span>' +
            '</md-toolbar>' +
            '<md-button ng-class="{ \'md-primary\': clock.selected == step }" class="md-icon-button md-raised mdp-clock-deg{{ ::(clock.STEP_DEG * ($index + 1)) }}" ng-repeat="step in clock.steps" ng-click="clock.setTime(step)">{{ step }}</md-button>' +
            '</div>' +
            '</div>',
            controller: ["$scope", ClockCtrl],
            controllerAs: "clock",
            link: function (scope, element, attrs, ctrl) {
                var pointer = angular.element(element[0].querySelector(".mdp-pointer")),
                    timepickerCtrl = scope.$parent.timepicker;
            
                var onEvent = function (event) {
                    var containerCoords = event.currentTarget.getClientRects()[0];
                    var x = ((event.currentTarget.offsetWidth / 2) - (event.pageX - containerCoords.left)),
                        y = ((event.pageY - containerCoords.top) - (event.currentTarget.offsetHeight / 2));

                    var deg = Math.round((Math.atan2(x, y) * (180 / Math.PI)));
                    $timeout(function () {
                        ctrl.setTimeByDeg(deg + 180);
                        if (ctrl.autoSwitch && ["mouseup", "click"].indexOf(event.type) !== -1 && timepickerCtrl) {
                            if (!timepickerCtrl.hasSwitched) {
                                timepickerCtrl.switchView()
                                timepickerCtrl.hasSwitched = true
                            } else {
                                timepickerCtrl.confirm()
                            }
                        }
                        
                    });
                };
            
                element.on("mousedown", function () {
                    element.on("mousemove", onEvent);
                });
            
                element.on("mouseup", function (e) {
                    element.off("mousemove");
                });
            
                element.on("click", onEvent);
                scope.$on("$destroy", function () {
                    element.off("click", onEvent);
                    element.off("mousemove", onEvent);
                });
            }
        }
    }]);

    module.provider("$mdpTimePicker", function () {
        var LABEL_OK = "OK",
            LABEL_CANCEL = "Cancel";
        
        this.setOKButtonLabel = function (label) {
            LABEL_OK = label;
        };
    
        this.setCancelButtonLabel = function (label) {
            LABEL_CANCEL = label;
        };
    
        this.$get = ["$mdDialog", function ($mdDialog) {
            var timePicker = function (time, options) {
                if (!angular.isDate(time)) time = Date.now();
                if (!angular.isObject(options)) options = {};
    
                return $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'time', 'autoSwitch', '$mdMedia', TimePickerCtrl],
                    controllerAs: 'timepicker',
                    clickOutsideToClose: true,
                    template: '<md-dialog aria-label="" class="mdp-timepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }">' +
                    '<md-dialog-content layout-gt-xs="row" layout-wrap>' +
                    '<md-toolbar layout-gt-xs="column" layout-xs="row" layout-align="center center" flex class="mdp-timepicker-time md-hue-1 md-primary">' +
                    '<div class="mdp-timepicker-selected-time">' +
                    '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_HOURS }" ng-click="timepicker.currentView = timepicker.VIEW_HOURS">{{ timepicker.time.format("h") }}</span>:' +
                    '<span ng-class="{ \'active\': timepicker.currentView == timepicker.VIEW_MINUTES }" ng-click="timepicker.currentView = timepicker.VIEW_MINUTES">{{ timepicker.time.format("mm") }}</span>' +
                    '</div>' +
                    '<div layout="column" class="mdp-timepicker-selected-ampm">' +
                    '<span ng-click="timepicker.setAM()" ng-class="{ \'active\': timepicker.time.hours() < 12 }">AM</span>' +
                    '<span ng-click="timepicker.setPM()" ng-class="{ \'active\': timepicker.time.hours() >= 12 }">PM</span>' +
                    '</div>' +
                    '</md-toolbar>' +
                    '<div>' +
                    '<div class="mdp-clock-switch-container" ng-switch="timepicker.currentView" layout layout-align="center center">' +
                    '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="hours" ng-switch-when="1"></mdp-clock>' +
                    '<mdp-clock class="mdp-animation-zoom" auto-switch="timepicker.autoSwitch" time="timepicker.time" type="minutes" ng-switch-when="2"></mdp-clock>' +
                    '</div>' +
                                    
                    '<md-dialog-actions layout="row">' +
                    '<span flex></span>' +
                    '<md-button ng-click="timepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
                    '<md-button ng-click="timepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
                    '</md-dialog-actions>' +
                    '</div>' +
                    '</md-dialog-content>' +
                    '</md-dialog>',
                    targetEvent: options.targetEvent,
                    locals: {
                        time: time,
                        autoSwitch: options.autoSwitch
                    },
                    skipHide: true
                });
            };
    
            return timePicker;
        }];
    });

    module.directive("mdpTimePicker", ["$mdpTimePicker", "$timeout", function ($mdpTimePicker, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            transclude: true,
            template: function (element, attrs) {
                var noFloat = angular.isDefined(attrs.mdpNoFloat),
                    placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
                    openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;
            
                return '<div layout layout-align="start start">' +
                    '<md-button class="md-icon-button" ng-click="showPicker($event)"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + '>' +
                    '<md-icon md-svg-icon="mdp-access-time"></md-icon>' +
                    '</md-button>' +
                    '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
                    '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
                    '</md-input-container>' +
                    '</div>';
            },
            scope: {
                "timeFormat": "@mdpFormat",
                "placeholder": "@mdpPlaceholder",
                "autoSwitch": "=?mdpAutoSwitch",
                "disabled": "=?mdpDisabled"
            },
            link: function (scope, element, attrs, ngModel, $transclude) {
                var inputElement = angular.element(element[0].querySelector('input')),
                    inputContainer = angular.element(element[0].querySelector('md-input-container')),
                    inputContainerCtrl = inputContainer.controller("mdInputContainer");
                
                $transclude(function (clone) {
                    inputContainer.append(clone);
                });
            
                var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));
            
                scope.type = scope.timeFormat ? "text" : "time"
                scope.timeFormat = scope.timeFormat || "HH:mm";
                scope.autoSwitch = scope.autoSwitch || false;
            
                scope.$watch(function () { return ngModel.$error }, function (newValue, oldValue) {
                    inputContainerCtrl.setInvalid(!ngModel.$pristine && !!Object.keys(ngModel.$error).length);
                }, true);
            
                // update input element if model has changed
                ngModel.$formatters.unshift(function (value) {
                    var time = angular.isDate(value) && moment(value);
                    if (time && time.isValid())
                        updateInputElement(time.format(scope.timeFormat));
                    else
                        updateInputElement(null);
                });
            
                ngModel.$validators.format = function (modelValue, viewValue) {
                    return !viewValue || angular.isDate(viewValue) || moment(viewValue, scope.timeFormat, true).isValid();
                };
            
                ngModel.$validators.required = function (modelValue, viewValue) {
                    return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
                };
            
                ngModel.$parsers.unshift(function (value) {
                    var parsed = moment(value, scope.timeFormat, true);
                    if (parsed.isValid()) {
                        if (angular.isDate(ngModel.$modelValue)) {
                            var originalModel = moment(ngModel.$modelValue);
                            originalModel.minutes(parsed.minutes());
                            originalModel.hours(parsed.hours());
                            originalModel.seconds(parsed.seconds());
                        
                            parsed = originalModel;
                        }
                        return parsed.toDate();
                    } else
                        return null;
                });
            
                // update input element value
                function updateInputElement(value) {
                    inputElement[0].value = value;
                    inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
                }
            
                function updateTime(time) {
                    var value = moment(time, angular.isDate(time) ? null : scope.timeFormat, true),
                        strValue = value.format(scope.timeFormat);

                    if (value.isValid()) {
                        updateInputElement(strValue);
                        ngModel.$setViewValue(strValue);
                    } else {
                        updateInputElement(time);
                        ngModel.$setViewValue(time);
                    }
                
                    if (!ngModel.$pristine &&
                        messages.hasClass("md-auto-hide") &&
                        inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");
                
                    ngModel.$render();
                }
                
                scope.showPicker = function (ev) {
                    $mdpTimePicker(ngModel.$modelValue, {
                        targetEvent: ev,
                        autoSwitch: scope.autoSwitch
                    }).then(function (time) {
                        updateTime(time, true);
                    });
                };
            
                function onInputElementEvents(event) {
                    if (event.target.value !== ngModel.$viewVaue)
                        updateTime(event.target.value);
                }
            
                inputElement.on("reset input blur", onInputElementEvents);
            
                scope.$on("$destroy", function () {
                    inputElement.off("reset input blur", onInputElementEvents);
                })
            }
        };
    }]);

    module.directive("mdpTimePicker", ["$mdpTimePicker", "$timeout", function ($mdpTimePicker, $timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                "timeFormat": "@mdpFormat",
                "autoSwitch": "=?mdpAutoSwitch",
            },
            link: function (scope, element, attrs, ngModel, $transclude) {
                scope.format = scope.format || "HH:mm";
                function showPicker(ev) {
                    $mdpTimePicker(ngModel.$modelValue, {
                        targetEvent: ev,
                        autoSwitch: scope.autoSwitch
                    }).then(function (time) {
                        ngModel.$setViewValue(moment(time).format(scope.format));
                        ngModel.$render();
                    });
                };
            
                element.on("click", showPicker);
            
                scope.$on("$destroy", function () {
                    element.off("click", showPicker);
                });
            }
        }
    }]);

})();
/* global moment, angular */
(function () {
    'use strict';
    
    var module = angular.module("mdPickers")

    function DatePickerCtrl($scope, $mdDialog, $mdMedia, $timeout, currentDate, options) {
        var self = this;

        this.date = moment(currentDate);
        this.minDate = options.minDate && moment(options.minDate).isValid() ? moment(options.minDate) : null;
        this.maxDate = options.maxDate && moment(options.maxDate).isValid() ? moment(options.maxDate) : null;
        this.displayFormat = options.displayFormat || "ddd, MMM DD";
        this.dateFilter = angular.isFunction(options.dateFilter) ? options.dateFilter : null;
        this.selectingYear = false;
    
        // validate min and max date
        if (this.minDate && this.maxDate) {
            if (this.maxDate.isBefore(this.minDate)) {
                this.maxDate = moment(this.minDate).add(1, 'days');
            }
        }
	
        if (this.date) {
            // check min date
            if (this.minDate && this.date.isBefore(this.minDate)) {
                this.date = moment(this.minDate);
            }
    	
            // check max date
            if (this.maxDate && this.date.isAfter(this.maxDate)) {
                this.date = moment(this.maxDate);
            }
        }
	
        this.yearItems = {
            currentIndex_: 0,
            PAGE_SIZE: 5,
            START: (self.minDate ? self.minDate.year() : 1900),
            END: (self.maxDate ? self.maxDate.year() : 0),
            getItemAtIndex: function (index) {
                if (this.currentIndex_ < index)
                    this.currentIndex_ = index;
        	
                return this.START + index;
            },
            getLength: function () {
                return Math.min(
                    this.currentIndex_ + Math.floor(this.PAGE_SIZE / 2),
                    Math.abs(this.START - this.END) + 1
                );
            }
        };

        $scope.$mdMedia = $mdMedia;
        $scope.year = this.date.year();

        this.selectYear = function (year) {
            self.date.year(year);
            $scope.year = year;
            self.selectingYear = false;
            self.animate();
        };
    
        this.showYear = function () {
            self.yearTopIndex = (self.date.year() - self.yearItems.START) + Math.floor(self.yearItems.PAGE_SIZE / 2);
            self.yearItems.currentIndex_ = (self.date.year() - self.yearItems.START) + 1;
            self.selectingYear = true;
        };
    
        this.showCalendar = function () {
            self.selectingYear = false;
        };

        this.cancel = function () {
            $mdDialog.cancel();
        };

        this.confirm = function () {
            var date = this.date;
    	
            if (this.minDate && this.date.isBefore(this.minDate)) {
                date = moment(this.minDate);
            }
    	
            if (this.maxDate && this.date.isAfter(this.maxDate)) {
                date = moment(this.maxDate);
            }
    	
            $mdDialog.hide(date.toDate());
        };
    
        this.animate = function () {
            self.animating = true;
            $timeout(angular.noop).then(function () {
                self.animating = false;
            })
        };
    }

    module.provider("$mdpDatePicker", function () {
        var LABEL_OK = "OK",
            LABEL_CANCEL = "Cancel",
            DISPLAY_FORMAT = "ddd, MMM DD";
        
        this.setDisplayFormat = function (format) {
            DISPLAY_FORMAT = format;
        };
        
        this.setOKButtonLabel = function (label) {
            LABEL_OK = label;
        };
    
        this.setCancelButtonLabel = function (label) {
            LABEL_CANCEL = label;
        };
    
        this.$get = ["$mdDialog", function ($mdDialog) {
            var datePicker = function (currentDate, options) {
                if (!angular.isDate(currentDate)) currentDate = Date.now();
                if (!angular.isObject(options)) options = {};
            
                options.displayFormat = DISPLAY_FORMAT;
    
                return $mdDialog.show({
                    controller: ['$scope', '$mdDialog', '$mdMedia', '$timeout', 'currentDate', 'options', DatePickerCtrl],
                    controllerAs: 'datepicker',
                    clickOutsideToClose: true,
                    template: '<md-dialog aria-label="" class="mdp-datepicker" ng-class="{ \'portrait\': !$mdMedia(\'gt-xs\') }">' +
                    '<md-dialog-content layout="row" layout-wrap>' +
                    '<div layout="column" layout-align="start center">' +
                    '<md-toolbar layout-align="start start" flex class="mdp-datepicker-date-wrapper md-hue-1 md-primary" layout="column">' +
                    '<span class="mdp-datepicker-year" ng-click="datepicker.showYear()" ng-class="{ \'active\': datepicker.selectingYear }">{{ datepicker.date.format(\'YYYY\') }}</span>' +
                    '<span class="mdp-datepicker-date" ng-click="datepicker.showCalendar()" ng-class="{ \'active\': !datepicker.selectingYear }">{{ datepicker.date.format(datepicker.displayFormat) }}</span> ' +
                    '</md-toolbar>' +
                    '</div>' +
                    '<div>' +
                    '<div class="mdp-datepicker-select-year mdp-animation-zoom" layout="column" layout-align="center start" ng-if="datepicker.selectingYear">' +
                    '<md-virtual-repeat-container md-auto-shrink md-top-index="datepicker.yearTopIndex">' +
                    '<div flex md-virtual-repeat="item in datepicker.yearItems" md-on-demand class="repeated-year">' +
                    '<span class="md-button" ng-click="datepicker.selectYear(item)" md-ink-ripple ng-class="{ \'md-primary current\': item == year }">{{ item }}</span>' +
                    '</div>' +
                    '</md-virtual-repeat-container>' +
                    '</div>' +
                    '<mdp-calendar ng-if="!datepicker.selectingYear" class="mdp-animation-zoom" date="datepicker.date" min-date="datepicker.minDate" date-filter="datepicker.dateFilter" max-date="datepicker.maxDate"></mdp-calendar>' +
                    '<md-dialog-actions layout="row">' +
                    '<span flex></span>' +
                    '<md-button ng-click="datepicker.cancel()" aria-label="' + LABEL_CANCEL + '">' + LABEL_CANCEL + '</md-button>' +
                    '<md-button ng-click="datepicker.confirm()" class="md-primary" aria-label="' + LABEL_OK + '">' + LABEL_OK + '</md-button>' +
                    '</md-dialog-actions>' +
                    '</div>' +
                    '</md-dialog-content>' +
                    '</md-dialog>',
                    targetEvent: options.targetEvent,
                    locals: {
                        currentDate: currentDate,
                        options: options
                    },
                    skipHide: true
                });
            };
    
            return datePicker;
        }];
    });

    function CalendarCtrl($scope) {
        var self = this;
        this.dow = moment.localeData().firstDayOfWeek();
	
        this.weekDays = [].concat(
            moment.weekdaysMin().slice(
                this.dow
            ),
            moment.weekdaysMin().slice(
                0,
                this.dow
            )
        );
    
        this.daysInMonth = [];
    
        this.getDaysInMonth = function () {
            var days = self.date.daysInMonth(),
                firstDay = moment(self.date).date(1).day() - this.dow;
            
            if (firstDay < 0) firstDay = this.weekDays.length - 1;
            

            var arr = [];
            for (var i = 1; i <= (firstDay + days); i++) {
                var day = null;
                if (i > firstDay) {
                    day = {
                        value: (i - firstDay),
                        enabled: self.isDayEnabled(moment(self.date).date(i - firstDay).toDate())
                    };
                }
                arr.push(day);
            }
 
            return arr;
        };
    
        this.isDayEnabled = function (day) {
            return (!this.minDate || this.minDate <= day) &&
                (!this.maxDate || this.maxDate >= day) &&
                (!self.dateFilter || !self.dateFilter(day));
        };
    
        this.selectDate = function (dom) {
            self.date.date(dom);
        };

        this.nextMonth = function () {
            self.date.add(1, 'months');
        };

        this.prevMonth = function () {
            self.date.subtract(1, 'months');
        };
    
        this.updateDaysInMonth = function () {
            self.daysInMonth = self.getDaysInMonth();
        };
    
        $scope.$watch(function () { return self.date.unix() }, function (newValue, oldValue) {
            if (newValue && newValue !== oldValue)
                self.updateDaysInMonth();
        })
    
        self.updateDaysInMonth();
    }

    module.directive("mdpCalendar", ["$animate", function ($animate) {
        return {
            restrict: 'E',
            bindToController: {
                "date": "=",
                "minDate": "=",
                "maxDate": "=",
                "dateFilter": "="
            },
            template: '<div class="mdp-calendar">' +
            '<div layout="row" layout-align="space-between center">' +
            '<md-button aria-label="previous month" class="md-icon-button" ng-click="calendar.prevMonth()"><md-icon md-svg-icon="mdp-chevron-left"></md-icon></md-button>' +
            '<div class="mdp-calendar-monthyear" ng-show="!calendar.animating">{{ calendar.date.format("MMMM YYYY") }}</div>' +
            '<md-button aria-label="next month" class="md-icon-button" ng-click="calendar.nextMonth()"><md-icon md-svg-icon="mdp-chevron-right"></md-icon></md-button>' +
            '</div>' +
            '<div layout="row" layout-align="space-around center" class="mdp-calendar-week-days" ng-show="!calendar.animating">' +
            '<div layout layout-align="center center" ng-repeat="d in calendar.weekDays track by $index">{{ d }}</div>' +
            '</div>' +
            '<div layout="row" layout-align="start center" layout-wrap class="mdp-calendar-days" ng-class="{ \'mdp-animate-next\': calendar.animating }" ng-show="!calendar.animating" md-swipe-left="calendar.nextMonth()" md-swipe-right="calendar.prevMonth()">' +
            '<div layout layout-align="center center" ng-repeat-start="day in calendar.daysInMonth track by $index" ng-class="{ \'mdp-day-placeholder\': !day }">' +
            '<md-button class="md-icon-button md-raised" aria-label="Select day" ng-if="day" ng-class="{ \'md-accent\': calendar.date.date() == day.value }" ng-click="calendar.selectDate(day.value)" ng-disabled="!day.enabled">{{ day.value }}</md-button>' +
            '</div>' +
            '<div flex="100" ng-if="($index + 1) % 7 == 0" ng-repeat-end></div>' +
            '</div>' +
            '</div>',
            controller: ["$scope", CalendarCtrl],
            controllerAs: "calendar",
            link: function (scope, element, attrs, ctrl) {
                var animElements = [
                    element[0].querySelector(".mdp-calendar-week-days"),
                    element[0].querySelector('.mdp-calendar-days'),
                    element[0].querySelector('.mdp-calendar-monthyear')
                ].map(function (a) {
                    return angular.element(a);
                });
                
                scope.$watch(function () { return ctrl.date.format("YYYYMM") }, function (newValue, oldValue) {
                    var direction = null;
                
                    if (newValue > oldValue)
                        direction = "mdp-animate-next";
                    else if (newValue < oldValue)
                        direction = "mdp-animate-prev";
                
                    if (direction) {
                        for (var i in animElements) {
                            animElements[i].addClass(direction);
                            $animate.removeClass(animElements[i], direction);
                        }
                    }
                });
            }
        }
    }]);

    function formatValidator(value, format) {
        return !value || angular.isDate(value) || moment(value, format, true).isValid();
    }

    function minDateValidator(value, format, minDate) {
        var minDate = moment(minDate, "YYYY-MM-DD", true);
        var date = angular.isDate(value) ? moment(value) : moment(value, format, true);
    
        return !value ||
            angular.isDate(value) ||
            !minDate.isValid() ||
            date.isSameOrAfter(minDate);
    }

    function maxDateValidator(value, format, maxDate) {
        var maxDate = moment(maxDate, "YYYY-MM-DD", true);
        var date = angular.isDate(value) ? moment(value) : moment(value, format, true);
    
        return !value ||
            angular.isDate(value) ||
            !maxDate.isValid() ||
            date.isSameOrBefore(maxDate);
    }

    function filterValidator(value, format, filter) {
        var date = angular.isDate(value) ? moment(value) : moment(value, format, true);
                
        return !value ||
            angular.isDate(value) ||
            !angular.isFunction(filter) ||
            !filter(date);
    }

    function requiredValidator(value, ngModel) {
        return value
    }

    module.directive("mdpDatePicker", ["$mdpDatePicker", "$timeout", function ($mdpDatePicker, $timeout) {
        return {
            restrict: 'E',
            require: 'ngModel',
            transclude: true,
            template: function (element, attrs) {
                var noFloat = angular.isDefined(attrs.mdpNoFloat),
                    placeholder = angular.isDefined(attrs.mdpPlaceholder) ? attrs.mdpPlaceholder : "",
                    openOnClick = angular.isDefined(attrs.mdpOpenOnClick) ? true : false;
            
                return '<div layout layout-align="start start">' +
                    '<md-button' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' class="md-icon-button" ng-click="showPicker($event)">' +
                    '<md-icon md-svg-icon="mdp-event"></md-icon>' +
                    '</md-button>' +
                    '<md-input-container' + (noFloat ? ' md-no-float' : '') + ' md-is-error="isError()">' +
                    '<input type="{{ ::type }}"' + (angular.isDefined(attrs.mdpDisabled) ? ' ng-disabled="disabled"' : '') + ' aria-label="' + placeholder + '" placeholder="' + placeholder + '"' + (openOnClick ? ' ng-click="showPicker($event)" ' : '') + ' />' +
                    '</md-input-container>' +
                    '</div>';
            },
            scope: {
                "minDate": "=mdpMinDate",
                "maxDate": "=mdpMaxDate",
                "dateFilter": "=mdpDateFilter",
                "dateFormat": "@mdpFormat",
                "placeholder": "@mdpPlaceholder",
                "noFloat": "=mdpNoFloat",
                "openOnClick": "=mdpOpenOnClick",
                "disabled": "=?mdpDisabled"
            },
            link: {
                pre: function (scope, element, attrs, ngModel, $transclude) {
                
                },
                post: function (scope, element, attrs, ngModel, $transclude) {
                    var inputElement = angular.element(element[0].querySelector('input')),
                        inputContainer = angular.element(element[0].querySelector('md-input-container')),
                        inputContainerCtrl = inputContainer.controller("mdInputContainer");
                    
                    $transclude(function (clone) {
                        inputContainer.append(clone);
                    });
                
                    var messages = angular.element(inputContainer[0].querySelector("[ng-messages]"));
                
                    scope.type = scope.dateFormat ? "text" : "date"
                    scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";
                    scope.model = ngModel;
                
                    scope.isError = function () {
                        return !ngModel.$pristine && !!ngModel.$invalid;
                    };
                
                    // update input element if model has changed
                    ngModel.$formatters.unshift(function (value) {
                        var date = angular.isDate(value) && moment(value);
                        if (date && date.isValid())
                            updateInputElement(date.format(scope.dateFormat));
                        else
                            updateInputElement(null);
                    });
                
                    ngModel.$validators.format = function (modelValue, viewValue) {
                        return formatValidator(viewValue, scope.dateFormat);
                    };
                
                    ngModel.$validators.minDate = function (modelValue, viewValue) {
                        return minDateValidator(viewValue, scope.dateFormat, scope.minDate);
                    };
                
                    ngModel.$validators.maxDate = function (modelValue, viewValue) {
                        return maxDateValidator(viewValue, scope.dateFormat, scope.maxDate);
                    };
                
                    ngModel.$validators.filter = function (modelValue, viewValue) {
                        return filterValidator(viewValue, scope.dateFormat, scope.dateFilter);
                    };
                
                    ngModel.$validators.required = function (modelValue, viewValue) {
                        return angular.isUndefined(attrs.required) || !ngModel.$isEmpty(modelValue) || !ngModel.$isEmpty(viewValue);
                    };
                
                    ngModel.$parsers.unshift(function (value) {
                        var parsed = moment(value, scope.dateFormat, true);
                        if (parsed.isValid()) {
                            if (angular.isDate(ngModel.$modelValue)) {
                                var originalModel = moment(ngModel.$modelValue);
                                originalModel.year(parsed.year());
                                originalModel.month(parsed.month());
                                originalModel.date(parsed.date());
                            
                                parsed = originalModel;
                            }
                            return parsed.toDate();
                        } else
                            return null;
                    });
                
                    // update input element value
                    function updateInputElement(value) {
                        inputElement[0].value = value;
                        inputContainerCtrl.setHasValue(!ngModel.$isEmpty(value));
                    }
                
                    function updateDate(date) {
                        var value = moment(date, angular.isDate(date) ? null : scope.dateFormat, true),
                            strValue = value.format(scope.dateFormat);
    
                        if (value.isValid()) {
                            updateInputElement(strValue);
                            ngModel.$setViewValue(strValue);
                        } else {
                            updateInputElement(date);
                            ngModel.$setViewValue(date);
                        }
                    
                        if (!ngModel.$pristine &&
                            messages.hasClass("md-auto-hide") &&
                            inputContainer.hasClass("md-input-invalid")) messages.removeClass("md-auto-hide");
    
                        ngModel.$render();
                    }
                    
                    scope.showPicker = function (ev) {
                        $mdpDatePicker(ngModel.$modelValue, {
                            minDate: scope.minDate,
                            maxDate: scope.maxDate,
                            dateFilter: scope.dateFilter,
                            targetEvent: ev
                        }).then(updateDate);
                    };
                
                    function onInputElementEvents(event) {
                        if (event.target.value !== ngModel.$viewVaue)
                            updateDate(event.target.value);
                    }
                
                    inputElement.on("reset input blur", onInputElementEvents);
                
                    scope.$on("$destroy", function () {
                        inputElement.off("reset input blur", onInputElementEvents);
                    });
                }
            }
        };
    }]);


    module.directive("mdpDatePicker", ["$mdpDatePicker", "$timeout", function ($mdpDatePicker, $timeout) {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                "minDate": "@min",
                "maxDate": "@max",
                "dateFilter": "=mdpDateFilter",
                "dateFormat": "@mdpFormat",
            },
            link: function (scope, element, attrs, ngModel, $transclude) {
                scope.dateFormat = scope.dateFormat || "YYYY-MM-DD";
            
                ngModel.$validators.format = function (modelValue, viewValue) {
                    return formatValidator(viewValue, scope.format);
                };
            
                ngModel.$validators.minDate = function (modelValue, viewValue) {
                    return minDateValidator(viewValue, scope.format, scope.minDate);
                };
            
                ngModel.$validators.maxDate = function (modelValue, viewValue) {
                    return maxDateValidator(viewValue, scope.format, scope.maxDate);
                };
            
                ngModel.$validators.filter = function (modelValue, viewValue) {
                    return filterValidator(viewValue, scope.format, scope.dateFilter);
                };
            
                function showPicker(ev) {
                    $mdpDatePicker(ngModel.$modelValue, {
                        minDate: scope.minDate,
                        maxDate: scope.maxDate,
                        dateFilter: scope.dateFilter,
                        targetEvent: ev
                    }).then(function (time) {
                        ngModel.$setViewValue(moment(time).format(scope.format));
                        ngModel.$render();
                    });
                };
            
                element.on("click", showPicker);
            
                scope.$on("$destroy", function () {
                    element.off("click", showPicker);
                });
            }
        }
    }]);

})();
window.angularOrgChartTemplatePath = "/app/alignus/directives/angular-org-chart/";


(function () {
    'use strict';

    angular.module('app', [
        //bower dependencies
        'ngAnimate',
        'ngCookies',
        'ngMaterial',
        'ngResource',
        'ui.router',
        'angularMoment',
        'md.data.table',
        'ngFileUpload',
        'ngSanitize',
        'ngMessages',
        'as.sortable',
        'mdPickers',
        'chart.js',
        'ui.calendar',
        'ngDialog',
        'digestHud',
        'logglyLogger',
        'ngImgCrop',

        //app modules
        'angularOrgChart',
        'alignus',
        'alignus.layouts',
        'alignus.directives',
        'app.values',
        'app.authentication',
    ])
        // set paths for packages
        .config(["$mdIconProvider", "$compileProvider", "$animateProvider", "digestHudProvider", "LogglyLoggerProvider", "ngDialogProvider", function ($mdIconProvider, $compileProvider, $animateProvider, digestHudProvider, LogglyLoggerProvider, ngDialogProvider) {
            $mdIconProvider.defaultIconSet('assets/images/core-icons.svg');
            $animateProvider.classNameFilter(/angular-animate/);

            ngDialogProvider.setOpenOnePerName(true);
            ngDialogProvider.setDefaults({ trapFocus: false })

            //prod values
            if (window.location.hostname.indexOf("nocache.localhost") == -1) {
                window.getImagesFromS3 = true
                $compileProvider.debugInfoEnabled(false);
                console.debug('Prod run-time mode detected. Angular debugging disabled. Run `angular.reloadWithDebugInfo();` in the console to enable it.')

                LogglyLoggerProvider.inputToken('22060548-84e6-41b0-90da-dbff54370af4').sendConsoleErrors(true)

                //hide all debug message
                console.debug = function () { }
            } else {
                //dev values
                window.getImagesFromS3 = false
                digestHudProvider.enable()
            }
        }])
})();
(function() {
        updateYourPasswordDialogController.$inject = ["$rootScope", "toast"];
    angular
        .module('app')
        .controller('UpdateYourPasswordDialogController', updateYourPasswordDialogController)

        /* @ngInject */
        function updateYourPasswordDialogController($rootScope, toast) {
            var vm = this

            vm.change = function() {
                $rootScope.user.setPassword(vm.ownNewPassword, false, true).then(function() {
                    $rootScope.$mdDialog.hide()
                    toast.success('Password updated OK', true)
                })
            }
        }
})();
(function () {
    postToPageController.$inject = ["auUtility", "$q", "$mdDialog", "Page", "Post", "toast", "options"];
    angular
        .module('app')
        .controller('PostToPageController', postToPageController)

    /*@ngInject*/
    function postToPageController(auUtility, $q, $mdDialog, Page, Post, toast, options) {
        var vm = this
        vm.searchPages = auUtility.searchPages
        vm.cancel = $mdDialog.cancel
        vm.pageIds = []
        vm.post = new Post({
            Creator: $rootScope.user._id,
            Type: 'Update',
            Data: {
                Update: '',
                Poll: {
                    Questions: '',
                    PossibleResponses: []
                }
            }
        })

        if (options.page) vm.pageIds.push(options.page)

        vm.transformPageChip = function ($chip) {
            return $chip._id
        }

        vm.savePost = function () {
            if (vm.pageIds.length == 0) {
                toast.error("Does a post without a page make a news feed?")
                return $q.reject()
            } else if (vm.pageIds.length == 1) {
                var page = Page.getCache({_id: vm.pageIds[0]})[0]
                vm.post.Page = page._id
                vm.post.PageType = page.Type
                vm.post.PageIsEmbedded = page.IsEmbedded
                return $q.resolve(vm.post)
            } else if (vm.pageIds.length > 1) {
                //post on user's own page
                vm.post.Page = $rootScope.user._id
                vm.post.PageType = 'User'
                vm.post.PageIsEmbedded = false
                return vm.post.$saveItem()
                .then(function(originalPost){
                    //share the post on the pages the user entered
                    $q.all(vm.pageIds.map(function(pageId){
                        if (originalPost.Page != pageId) {
                            var page = Page.getCache({_id: pageId})
                            return new Post({
                                Creator: $rootScope.user._id,
                                Type: 'Share',
                                Page: pageId,
                                Data: {
                                    Share: {
                                        SharedItems: [{ Type: 'Post', Id: vm.post._id}]
                                    }
                                },
                                PageType: page.Type,
                                PageIsEmbedded: page.IsEmbedded
                            }).$saveItem().then(function(){
                                toast.success('Your post was successfully sent!', true)
                            })
                        }
                    }))
                })
            }
        }

        vm.close = function () {
            $mdDialog.hide()
        }
    }
})();
(function() {
        NewHighFiveController.$inject = ["auUtility", "$q", "$mdDialog", "Page", "Post", "User", "toast", "options"];
    angular
        .module('app')
        .controller('NewHighFiveController', NewHighFiveController)

        /*@ngInject*/
        function NewHighFiveController(auUtility, $q, $mdDialog, Page, Post, User, toast, options){
            var vm = this
            vm.cancel = $mdDialog.cancel
            vm.toUsers = []
            vm.message = ''
            vm.emojiType = 'high-five' 

            if (options.sendTo) {
            	vm.toUsers.push(options.sendTo._id)
            }

            vm.createHighFive = function() {
                var emojiString
                var coverPhotoUrl

                if (vm.toUsers.length == 0) {
                    return toast.error('Who are you high fiving?')
                }

                //emojiType is the gif file name
                switch(vm.emojiType){
                    case 'high-five':
                        emojiString = 'High Five'
                        coverPhotoUrl = 'https://s3.amazonaws.com/alignusstatic/UI/cover/high-five/high-five.png'
                        break;
                    case 'check':
                        emojiString = 'Great Job'
                        coverPhotoUrl = 'https://s3.amazonaws.com/alignusstatic/UI/cover/high-five/great-job.png'
                        break;
                    case 'thumb':
                        emojiString = 'Thank You'
                        coverPhotoUrl = 'https://s3.amazonaws.com/alignusstatic/UI/cover/high-five/thank-you.png'
                        break;                        
                }
                var sender = User.getCache({_id: $rootScope.user._id})[0]

				$q.all(vm.toUsers.map(function(user) {
                    var page = Page.getCache({_id: user})[0]
                    var receipient = User.getCache({_id: user})[0]
					return new Post({
						Page: page._id,
						PageType: page.Type,
						PageIsEmbedded: page.IsEmbedded,
                        Creator: sender._id,
						Type: 'Update',
						Data: {
                            Update: '<span contenteditable=\"false\" class=\"doc-mention User\" data-item-type=\"User\" data-item-id=\"{3}\" data-cke-filter=\"off\" title=\"User: {4}\">{4}</span> sent <span contenteditable=\"false\" class=\"doc-mention User\" data-item-type=\"User\" data-item-id=\"{5}\" data-cke-filter=\"off\" title=\"User: {6}\">{6}</span> a <span contenteditable="false" class="doc-mention HighFive" data-item-type="HighFive" high-five-type="{0}" high-five-message="{2}" data-cke-filter="off" title="High Five">{1}</span> <b>{2}</b>'.format(vm.emojiType, emojiString, vm.message, sender._id, sender.toString(), receipient._id, receipient.toString()),
                            Emoji: vm.emojiType,
                            IsHighFive: true
                        },
                        CoverPhotoUrl: coverPhotoUrl
					}).$saveItem()
				})).then(function() {
                    $mdDialog.hide()
					toast.success('Your high five was sent!', true)			
				}).catch(function() {
                    $mdDialog.hide()
					toast.error('Could not create high five', true)
				})
			}

            vm.transformUserChip = function($chip) {
                return $chip._id
            }
        }
})();
(function() {
	'use strict';

	AddWidgetsWizard.$inject = ["$timeout", "$mdDialog", "toast", "page"];
	angular
		.module('app')
		.controller('AddWidgetsWizard', AddWidgetsWizard);

	/* @ngInject */
	function AddWidgetsWizard($timeout, $mdDialog, toast, page) {
		var vm = this;
		vm.page = page
		vm.cancel = $mdDialog.cancel

		//set variables and user feedback when the user clicks a Select button
		vm.installWidget = function(index, name, readable){
			vm.selectedWidget = name
			vm.selectedReadableWidget = readable

			//make the Select buttons act like radio buttons
			angular.element('md-dialog-content button').removeClass('md-primary')
			angular.element('md-dialog-content button')[index].classList.add('md-primary')
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			vm.page.SideBarWidgets.push({Type: vm.selectedWidget, Data: {}})
			vm.page.$updateItem()

			$mdDialog.hide()
		}
	}
}
)();
(function () {
    'use strict';
    
    var module = angular.module("mdPickers")

    module.directive("ngMessage", ["$mdUtil", function ($mdUtil) {
        return {
            restrict: "EA",
            priority: 101,
            compile: function (element) {
                var inputContainer = $mdUtil.getClosest(element, "mdp-time-picker", true) ||
                    $mdUtil.getClosest(element, "mdp-date-picker", true);
            
                // If we are not a child of an input container, don't do anything
                if (!inputContainer) return;
            
                // Add our animation class
                element.toggleClass('md-input-message-animation', true);
            
                return {};
            }
        }
    }]);

})();
(function () {
    'use strict';
    
    var module = angular.module("mdPickers")

    module.constant("mdpIconsRegistry", [
        {
            id: 'mdp-chevron-left',
            url: 'mdp-chevron-left.svg',
            svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
        },
        {
            id: 'mdp-chevron-right',
            url: 'mdp-chevron-right.svg',
            svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
        },
        {
            id: 'mdp-access-time',
            url: 'mdp-access-time.svg',
            svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/><path d="M0 0h24v24H0z" fill="none"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>'
        },
        {
            id: 'mdp-event',
            url: 'mdp-event.svg',
            svg: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
        }
    ]);

})();
(function() {
	'use strict';

	RequestApprovalDialog.$inject = ["$rootScope", "$q", "$mdDialog", "options", "Schema", "Task", "oneSearch"];
	angular
		.module('app')
		.controller('RequestApprovalDialog', RequestApprovalDialog);

	/* @ngInject */
	function RequestApprovalDialog($rootScope, $q, $mdDialog, options, Schema, Task, oneSearch) {
        var vm = this;
        vm.usersToRequest = []
        vm.optionalMessage = ''

		// if the dialog was provided with an item to approve, bind it to the view model
		// note that this creates type ambiguity, since vm.itemToApprove could now be a full item or a OneSearch result
        if(options.itemToApprove) {
			vm.itemToApprove = options.itemToApprove
			vm.itemToApproveProvided = true
        }

		//confirm a user and item were entered	
		vm.confirmApproval = function() {
			// don't proceed unless we have an item, it's either a OneSearch result or a valid cached resource, and we have users to request
			return (vm.itemToApprove && (vm.itemToApprove.$key || vm.itemToApprove.ModelName) && vm.usersToRequest && vm.usersToRequest.length)
		}

        vm.search = function(){
        	if (vm.itemSearchText == "") {
				return;
			}
			return oneSearch.search(vm.itemSearchText)
			.then(function(searchResults) {
				var resultsOnly = searchResults.filter(function(result){
					if (!result.isSection) return result
				})
				return resultsOnly
			})
		}

        vm.transformUserChip = function($chip) {
            if(vm.usersToRequest.indexOf($chip._id) > -1) return null;
            return $chip._id
        }
            
        function getCSVUsers() {
            return vm.usersToRequest.map(function (userId) {
                return $filter('fullNameFilter')(userId)
            }).join(', ')
        }
		
        function getLIUsers() {
            return vm.usersToRequest.map(function (userId) {
                return "<li>" + $filter('fullNameFilter')(userId) + "</li>"
            }).join('')
        }

		vm.review = function() {
			var details = [
                {name: 'Item to Approve', value: vm.itemToApprove.SearchTitle || vm.itemToApprove.toString()},
                {name: 'Users to Request', value: getCSVUsers()}                    
            ]
            if (vm.optionalMessage) details.push({name: 'Message', value: vm.optionalMessage})

			return {error: false, details: details}
		}
        
		vm.finish = function(){
			var approvalTasks = []
			var getItemPromise

			// if vm.itemToApprove is already a full cached resource, we can resolve immediately
			if(vm.itemToApprove.$key) {
				getItemPromise = $q.resolve(true)
			} else {
				// if it's a OneSearch result, convert it into a full cached resource
				getItemPromise = Schema.resource(vm.itemToApprove.ModelName).getCache({_id: vm.itemToApprove.DocId}).$httpPromise.then(function(items) {
					vm.itemToApprove = items[0]
				})
			}

			//create task(s) for usersToRequest
			return getItemPromise.then(function() {
				return $q.all(vm.usersToRequest.map(function(user) {
					return new Task({
						Type: 'Approval',
						Title: 'Approval requested for "' + vm.itemToApprove.toString() + '" from ' + $rootScope.user.FirstName,
						Details: '{7}<div style="border: 1px solid #ccc; border-radius: 2px; padding: 20px;"><p><span contenteditable=\"false\" class=\"doc-mention User\" data-item-type=\"User\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"{1}\">{1}</span> requested your approval at {2} on the following item:<ul><li><span contenteditable=\"false\" class=\"doc-mention {3}\" data-item-type=\"{3}\" data-item-id=\"{4}\" data-cke-filter=\"off\" title=\"{5}\">{5}</span></li></ul></p><p>{1} is seeking approval from the following individuals: <ul>{6}</ul></p><p>Mark this task as Completed to notify {1} of your approval.</p></div>'.format($rootScope.user._id, $rootScope.user.FirstName, moment().format('MMM Do YYYY, h:mm a'), vm.itemToApprove.$key, vm.itemToApprove._id, vm.itemToApprove.toString(), getLIUsers(), vm.optionalMessage, $rootScope.user.toString()),
						AutoPostUpdates: false,
						EstimatedHours: .5,
						User: user,
						Creator: $rootScope.user._id
					}).$saveItem()
					.then(function(task){
						//convert the approvalTask cachedResource to an embedded task
						var embeddedTask = '<task id="{0}"></task>'.format(task._id)
						approvalTasks.push(embeddedTask)
					})
				}))
				.then(function(resolve){
					//create control task for approval seeker
					return (new Task({
						Type: 'GetApproval',
						Title: 'Get approval for "' + vm.itemToApprove.toString() + '" from ' + getCSVUsers(),
						Details: '<p class="margin-bottom-20">You requested approval for <span contenteditable=\"false\" class=\"doc-mention {0}\" data-item-type=\"{0}\" data-item-id=\"{1}\" data-cke-filter=\"off\" title=\"{2}\">{2}</span> on {4}. The following tasks were created:</p> {5} <p>Use this as a control task to track the requested approvals. <b>Once the above approvals have been obtained, please mark this task as Completed.</b></p>'.format(vm.itemToApprove.$key, vm.itemToApprove._id, vm.itemToApprove.toString(), $rootScope.user.FirstName, moment().format('MMM Do YYYY, h:mm a'), approvalTasks),
						AutoPostUpdates: false,
						User: $rootScope.user._id,
						Creator: $rootScope.user._id
					})).$saveItem()
				})
				.then(function(controlTask){
					//add the control task to the itemToApprove's Workflows -- if the item has a Workflows section
					if (vm.itemToApprove.Workflows){
						vm.itemToApprove.Workflows.push({Title: 'Approval from: ' + getCSVUsers(), Type: 'Task', LinkId: controlTask._id, CreatedBy: $rootScope.user._id, DateCreated: new Date()})
						vm.itemToApprove.$updateItem()
					}
					return controlTask.Title + ' has been created.'
				})
			})
		}
	}
}
)();

(function() {
    'use strict';

    angular
        .module('alignus.directives', [])
})();
(function() {
	'use strict';
	angular
		.module('alignus.directives')
		.directive('auFromTemplateStateButton', function() {
			controllerFn.$inject = ["$scope", "$window", "$mdDialog"];
			return {
				templateUrl: '/app/alignus/directives/au-template-buttons/au-from-template-state-button/au-from-template-state-button.tmpl.html',
				controller: controllerFn,
				scope: {
					itemType: '@'
				}
			}

			/* @ngInject */
			function controllerFn($scope, $window, $mdDialog) {
				$scope.openFromTemplate = function () {
					$mdDialog.cancel()
					$window.open('/newfromtemplate/' + $scope.itemType)
				}
			}
		})
})();
(function () {
    ShareItemController.$inject = ["auUtility", "$rootScope", "$q", "$mdDialog", "$http", "Page", "Post", "User", "toast", "options"];
    angular
        .module('app')
        .controller('ShareItemController', ShareItemController)

    /*@ngInject*/
    function ShareItemController(auUtility, $rootScope, $q, $mdDialog, $http, Page, Post, User, toast, options) {
        var vm = this
        vm.cancel = $mdDialog.cancel

        vm.item = options.item

        vm.toUsers = []
        if (options.sendTo) {
            vm.toUsers = options.sendTo._id
        }

        vm.sendShare = function () {
            $http.post("/api/shareItem", { users: vm.toUsers, modelName: vm.item.$key, itemId: vm.item._id }).then(function () {
                $mdDialog.hide()
                toast.success('Your share was sent!', true)
            }).catch(function () {
                $mdDialog.hide()
                toast.error('Could not create share.', true)
            })
        }
    }
})();
(function () {
    SelectOwnerController.$inject = ["$mdDialog"];
    angular
        .module('app')
        .controller('SelectOwnerController', SelectOwnerController)

    /*@ngInject*/
    function SelectOwnerController($mdDialog) {
        var vm = this
        vm.cancel = $mdDialog.cancel

        vm.done = function () {
            $mdDialog.hide({ item: vm.newOwner.item, note: vm.newOwnerNote })
        }
    }
})();
(function () {
	'use strict';

	AddDocumentDialogController.$inject = ["$scope", "$mdDialog", "Document", "item", "auUtility", "$q", "$window", "options"];
	angular
		.module('alignus.directives')
		.controller('AddDocumentDialogController', AddDocumentDialogController);

	/* @ngInject */
	function AddDocumentDialogController($scope, $mdDialog, Document, item, auUtility, $q, $window, options) {
		var vm = this
		vm.item = item
		vm.preventNewDocuments = options.preventNewDocuments
		vm.documentSubtype = options.documentSubtype
		vm.defaultNewDocTitle = options.defaultNewDocTitle
		vm.searchDocuments = auUtility.searchDocuments
		vm.newDocument = 'true'

		var fromProject = (item.$key == 'Project')
		var fromMeeting = (item.$key == 'Meeting')
		var fromTask = (item.$key == 'Task')

		//new doc placeholder - helpful for defaultNewDocTitle
		vm.document = {
			Editors: [],
		}

		vm.init = function () {
			if (vm.preventNewDocuments) {
				// hide the "new or existing" step
				vm.wizardSteps.getStep('stepSelectNewOrExisting').visible = false
				// hide the "create a doc" step"
				vm.wizardSteps.getStep('createDocument').visible = false
				vm.newDocument = 'false'
				console.debug($scope)
			}
		}

		vm.determineNextStep = function () {
			if (vm.newDocument == 'true') {
				// hide the 'find a document' step
				vm.wizardSteps.getStep('findDocument').visible = false
				vm.wizardSteps.getStep('createDocument').visible = true
				if (fromMeeting && vm.documentSubtype == 'Meeting Notes') {
					vm.document.Title = vm.defaultNewDocTitle
				}
			} else {
				//hide the'create a doc'step 
				vm.wizardSteps.getStep('findDocument').visible = true
				vm.wizardSteps.getStep('createDocument').visible = false
			}
			// needed
			return true
		}

		//user must enter Doc Title if creating a new document
		vm.confirmTitleEntered = function () {
			return vm.document.Title
		}

		vm.review = function () {
			return {
				error: false,
				details: [
					{ name: 'Document Title', value: vm.document ? vm.document.Title : '' }
				]
			}
		}

		vm.finish = function () {
			var docResource
			return getDocument()
				.then(function (document) {
					docResource = document
					return vm.item.AddDocumentTypeDocument(document.Title, document._id, vm.documentSubtype)
				})
				.then(function (response) {
					if (vm.newDocument == 'true' && !window.seleniumIDETesting) {
						docResource.open('new')
					}
					return docResource.Title + ' has been attached.'
				})
		}

		// returns a promise that resolves to 
		// either the new document or an existing document,
		// depending on which the user selected
		function getDocument() {
			// they chose to make a new document
			if (vm.newDocument == 'true') {
				// make a new document
				vm.document = new Document(vm.document)
				// set the Project field if this item was a project
				if (fromProject) {
					vm.document.Project = vm.item._id
					vm.document.IsPrivate = vm.item.IsPrivate
					vm.document.Editors = vm.item.GetRawMembers()
					vm.document.SharedWith = vm.item.GetRawSharedWith()
				}
				// set the Meeting field if this item was a meeting
				if (fromMeeting) {
					vm.document.Meeting = vm.item._id
					vm.document.IsPrivate = true
					if (vm.documentSubtype == 'Meeting Notes') {
						vm.document.SharedWith = vm.item.GetAllAttendees(true)
						vm.document.Editors = [$rootScope.user._id]
					} else {
						//only facilitators can attach docs
						vm.document.Editors = vm.item.GetFacilitators(true)
						vm.document.SharedWith = vm.item.GetRegularAttendees(true)
					}
				}
				//sync with Task fields if item was a Task
				if (fromTask) {
					vm.document.IsPrivate = vm.item.AutPostUpdates
					vm.document.Editors = [vm.item.Creator].concat(vm.item.User)
					vm.document.SharedWith = vm.item.SharedWith
				}
				// return a promise to save the item
				return vm.document.$saveItem()
			} else {
				//they are attaching an existing document - update it's SharedWith
				// set the Project field if this item was a project
				if (fromProject) {
					vm.document.Project = vm.item._id
					vm.document.SharedWith = vm.document.SharedWith.concat(vm.item.GetRawMembers()).concat(vm.item.GetRawSharedWith())
				}
				// set the Meeting field if this item was a meeting
				if (fromMeeting) {
					vm.document.Meeting = vm.item._id
					if (vm.documentSubtype == 'Meeting Notes') {
						vm.document.SharedWith = vm.document.SharedWith.concat(vm.item.GetAllAttendees(true))
					} else {
						//only facilitators can attach docs
						vm.document.SharedWith = vm.document.SharedWith.concat(vm.item.GetAllAttendees(true))
					}
				}
				//sync with Task fields if item was a Task
				if (fromTask) {
					vm.document.SharedWith = vm.document.SharedWith.concat([vm.item.Creator, vm.item.User]).concat(vm.item.SharedWith)
				}

				// return a promise to update the item
				vm.document.$noNotifications = true
				return vm.document.$updateItem().$promise

			}

		}
	}
})();
(function () {
	'use strict';

	/* global moment */

	UserDetailController.$inject = ["$scope", "$rootScope", "$stateParams", "$timeout", "$mdDialog", "$injector", "toast", "$filter", "$http", "itemSettings", "Department", "Location", "usStates", "PermissionPreset", "httpError", "s3Service", "User", "$state", "auUtility", "ItemViewer", "auMaterialColors", "auTheme"];
	angular
		.module('app')
		.controller('UserDetailController', UserDetailController);

	/* @ngInject */
	function UserDetailController($scope, $rootScope, $stateParams, $timeout, $mdDialog, $injector, toast, $filter, $http, itemSettings, Department, Location, usStates, PermissionPreset, httpError, s3Service, User, $state, auUtility, ItemViewer, auMaterialColors, auTheme) {
		var vm = this;
		vm.$mdDialog = $mdDialog

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//put the detail on the model  //markup was originally coded with vm.detail
		vm.detail = itemSettings.item;

		//data needed for dropdowns, etc.
		vm.permissionPresets = PermissionPreset.getCache();
		vm.departments = Department.getCache()
		vm.locations = Location.getCache()
		vm.users = User.getCache()

		//default values
		vm.states = usStates;
		vm.newPassword = { specify: '0' }
		vm.loginAsUserUrl = "Loading URL..."
		vm.showLoginAsUrl = false

		//default list data
		vm.educationLevels = [
			'',
			'High School',
			'GED',
			'Two-Year Degree',
			'Four-Year Degree',
			'Graduate Degree',
			'Doctoral Degree'
		];
		vm.genders = [
			'',
			'Male',
			'Female'
		];
		vm.maritalSatuses = [
			'',
			'Single',
			'Married'
		];
		vm.citizenshipStatuses = [
			'',
			'Citizen',
			'Non-Citizen National',
			'Permanent Resident',
			'Non-Resident Alien'
		];
		vm.addressTypes = [
			'Home',
			'Work'
		]

		if ($rootScope.user.IsUserAdmin || $rootScope.user._id == vm.detail._id) {
			vm.detail.getSettings().then(function (userSettings) {
				vm.detail.Settings = userSettings.data

				// color data for settings
				vm.colors = auMaterialColors;
				vm.toolbarColor = {
					color: vm.detail.Settings.TitlebarColor
				}

				//make us timezones the first in the list
				vm.timezones = window.moment.tz.names().filter(function (e) {
					return (e.startsWith('US/') || e == 'America/Chicago');
				}).concat(window.moment.tz.names().filter(function (e) {
					return !(e.startsWith('US/') || e == 'America/Chicago');
				}))

				//expose default daily email settings
				if (vm.detail.Settings.SendNightlyEmail) {
					vm.SendNightlyEmail = true
					vm.detail.Settings.SendNightlyEmail = new Date(vm.detail.Settings.SendNightlyEmail)
				}
				if (vm.detail.Settings.SendMorningEmail) {
					vm.SendMorningEmail = true
					vm.detail.Settings.SendMorningEmail = new Date(vm.detail.Settings.SendMorningEmail)
				}
			})
		}


		// test for ReportsTo circular dependencies. if we let them through
		// then the users simply go missing from the user org chart...
		// returns true if ok, false if circular dependency
		// matt note: could probably slap this in a service or something,
		// looks like it could be applicable in the future.
		vm.testCircularDependency = function (from, to) {
			if (!to) return true
			if (!to._id) return false;
			if (from._id == to._id) return false;
			var parent = to;
			var panic = 100;
			while (parent) {
				if (panic-- == 0) {
					console.warn('hit 100 iterations of circular dependency checking');
					return false; // assuming infinite loop
				};
				parent = parent.ReportsTo;
				if (typeof parent === 'string') {
					var newParent = vm.users.filter(function (user) {
						return user._id == parent;
					})[0];
					if (newParent == undefined) {
						return false;
					}
					parent = newParent;
				} else {
					return true;
				}
				if (parent._id == from._id) {
					return false;
				}
			}
			return true;
		}

		//search the cached list of users without case sensitivity
		// - this one tests for circular dependencies
		vm.searchUsers = function ($query) {
			if (!$query)
				return [];
			return vm.users.filter(function (user) {
				return (user.IsContact == false && $filter('fullNameFilter')(user).toLowerCase().indexOf($query.toLowerCase()) > -1)
					&& vm.testCircularDependency(vm.detail, user);
			})

		}

		//log in as another user
		vm.loginAsClicked = function () {
			$http.get("/api/user/" + vm.detail._id + "/GetAuthToken")
				.then(function (response) {
					if (response.data.authToken) {
						vm.loginAsUserUrl = window.location.origin + "/home?icu="
							+ encodeURIComponent(response.data.authToken)
						vm.showLoginAsUrl = true
					}
				})
		}

		//highlight (select) the url in the login as user card
		vm.selectUrl = function ($event) {
			$event.target.select();
			try {
				vm.copiedOK = document.execCommand('copy');
			} catch (err) {
				console.log('Oops, unable to copy');
			}
		}

		// enable/disable a user's account
		vm.setIsActive = function () {
			vm.detail.setIsActive(vm.detail.IsActive)
				.then(function (res) {
					var message = vm.detail.IsActive ? "Activated user account successfully!" : "Deactivated user account successfully!"
					toast.success(message)
					vm.detail.$updateItem()
				}, function (res) {
					var message = vm.isUserActive ? "Failed to activate that user's account!" : "Failed to deactivate that user's account!"
					vm.detail.IsActive = !vm.detail.IsActive
					toast.error(message)
				})
		}

		//confirm the user wants to reset this user's password
		vm.resetPassword = function ($event, self) {
			var dialog = $mdDialog.confirm({
				title: "Reset Password",
				textContent: vm.newPassword.specify == '0' && !self ? "Send this user a password recovery link?" : "Are you sure you want to reset {0} password?".format(self ? "your" : "this user's"),
				ok: "Do It",
				cancel: "Cancel",
				targetEvent: $event
			});
			$mdDialog.show(dialog)
				.then(function () {
					handlePasswordReset(self);
				}, null)
				.finally(function () {
					dialog = undefined;
				});
		}



		// addresses card
		//add an address record
		vm.addAddress = function () {
			if (!angular.isDefined(vm.detail.Addresses))
				vm.detail.Addresses = [];
			vm.detail.Addresses.push({ Type: 'work' });
		}

		//remove an address record
		vm.removeAddress = function ($index, $event) {
			var dialog = $mdDialog.confirm({
				title: "Remove Address",
				htmlContent: "Are you sure you want to remove this address? This action is not un-doable.",
				ok: "Do It",
				cancel: "Cancel",
				targetEvent: $event
			});
			$mdDialog.show(dialog)
				.then(function () {
					vm.detail.Addresses.splice($index, 1);
					$scope.editUserForm.$setDirty()
				}, null)
				.finally(function () {
					dialog = undefined;
				});
		}

		vm.addContactRow = function (contactInfo) {
			if (!contactInfo) {
				contactInfo = []
			}
			contactInfo.push({ type: null, value: null })
			setTimeout(function () {
				var el = angular.element('.grow.contact:last md-select')
				el.focus()
			}, 5)
		}

		//remove a contact record
		vm.removeContactInfo = function (contactInfo, $index, $event) {
			// don't ask for empty rows
			if (!contactInfo[$index].value) {
				contactInfo.splice($index, 1)
			} else {
				var dialog = $mdDialog.confirm({
					title: 'Delete contact field?',
					htmlContent: '<p>Are you sure you want to delete this additional contact field?</p>' +
						'<p>This cannot be undone!</p>',
					ok: 'Do it',
					cancel: 'Cancel',
					targetEvent: $event
				});
				$mdDialog.show(dialog)
					.then(function () {
						contactInfo.splice($index, 1)
					}, null)
					.finally(function () {
						dialog = undefined;
					});
			}
		}

		vm.reassignSubordinates = function ($event) {
			$mdDialog.show({
				controller: 'ReassignSubordinatesDialogController',
				controllerAs: 'vm',
				locals: {
					selectedUser: vm.detail,
				},
				bindToController: true,
				templateUrl: '/app/structure/users-and-teams/dialogs/reassign-subordinates-dialog.tmpl.html',
				clickOutsideToClose: false,
				targetEvent: $event
			}).then(function (result) {
				$mdDialog.show($mdDialog.alert({
					title: 'Success',
					textContent: result.data.modified + ' users were modified.',
					ok: 'Ok'
				}))
			}, function (err) {
				$mdDialog.show($mdDialog.alert({
					title: 'Error',
					textContent: httpError.parse(err),
					ok: 'Ok'
				}))
			})
		}

		// password reset
		function handlePasswordReset(self) {
			var newPassword = null;
			var dialog;

			vm.newPassword.inProgress = true;

			var action

			if (vm.newPassword.specify == '0' && !self) {
				action = $http.post("/api/resetpasswordtrigger", { user_id: vm.detail._id })
			} else {
				if (self) {
					newPassword = vm.ownNewPassword
				} else {
					newPassword = vm.newPassword.password;
				}

				action = vm.detail.setPassword(newPassword, vm.newPassword.sendEmail, self)

			}

			action.then(function (res) {
				dialog = $mdDialog.alert({
					title: 'Success!',
					textContent: vm.newPassword.specify == '0' && !self ? 'A password recovery link has been sent.' : 'The password was reset successfully.',
					ok: 'Ok',
				});
				$mdDialog.show(dialog)
					.then(function () {
						vm.newPassword.inProgress = false;
					}, null)
			})
		}

		vm.fixDate = function (theDate) {
			if (!theDate || !isDate(theDate.toISOString())) {
				theDate = null
				return
			}

			var thisYear = (new Date()).getFullYear()
			var theDateYear = theDate.getFullYear()

			if (thisYear - theDateYear > 100) {
				theDate.setFullYear(theDateYear + 100)
			}
		}


		vm.setToolbarColor = function (color) {
			if (vm.detail.Settings.TitlebarColor == color) return

			//for the md-select to know what's selected
			vm.toolbarColor = { color: color }

			//save the new setting
			vm.detail.setSetting({
				'TitlebarColor': color
			})

			//apply (does not consider that the user may override this on reload)
			auTheme.loadTheme(color, false)
		}

		vm.setTimezone = function () {
			vm.detail.setSetting({ Timezone: vm.detail.Settings.Timezone })
		}

		vm.transformChip = function (team) {
			if (vm.detail.Teams.indexOf(team._id) > -1) return null
			return team._id
		}

		$scope.$watch('vm.detail.Settings.SendNightlyEmail', function (newVal, oldVal) {
			if (newVal == oldVal) return;
			if (newVal && newVal.toString && oldVal && oldVal.toString && newVal.toString() == oldVal.toString()) return;
			vm.detail.setSetting({ SendNightlyEmail: newVal })
		})

		$scope.$watch('vm.detail.Settings.SendMorningEmail', function (newVal, oldVal) {
			if (newVal == oldVal) return;
			if (newVal && newVal.toString && oldVal && oldVal.toString && newVal.toString() == oldVal.toString()) return;
			vm.detail.setSetting({ SendMorningEmail: newVal })
		})

		vm.setDailyEmail = function (dailyEmailType) {
			if (vm[dailyEmailType]) {
				vm.detail.Settings[dailyEmailType] = (dailyEmailType == 'SendNightlyEmail') ? new Date('2017-05-16T19:00:00') : new Date('2017-05-16T06:00:00')
				vm.detail.setSetting({ dailyEmailType: vm.detail.Settings[dailyEmailType] })
			} else {
				vm.detail.Settings[dailyEmailType] = null
				vm.detail.setSetting({ dailyEmailType: null })
			}
		}
	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "TeamProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, TeamProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: TeamProvider,
            itemSection: 'team',
            detailTemplateUrl: '/app/structure/users-and-teams/team/item.tmpl.html',
            controller: 'TeamController'
        })
    }
})();
(function () {
	'use strict';

	/* global moment */

	TeamItemController.$inject = ["$scope", "$rootScope", "$filter", "$mdDialog", "$timeout", "usStates", "itemSettings", "toast", "auUtility", "ItemViewer", "User", "windowFab"];
	angular
		.module('app')
		.controller('TeamItemController', TeamItemController);

	/* @ngInject */
	function TeamItemController($scope, $rootScope, $filter, $mdDialog, $timeout, usStates, itemSettings, toast, auUtility, ItemViewer, User, windowFab) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose data to the view
		vm.item = itemSettings.item
		vm.states = usStates
		vm.page = auUtility.getPageFor(vm.item._id)
		if (!vm.page.Editors) vm.page.Editors = []
		vm.membersWithID = vm.item.Nodes.filter(function(member){
			return member.LinkWithUserId
		})

		vm.selectedHeadChanged = function (user) {
			if (!user || !user.$addNew) return

			vm.headSearchText = ""

			auUtility.addNewItem(user.$addNew).then(function (newItem) {
				if (!newItem) return
				vm.item.Owner = newItem._id
			})

		}

		//handle page editor chips
		vm.savePage = function () {
			vm.page.$updateItem()
		}


		//handle org chart - the timesChanged is super hacky but reliable - we want to catch the 3+ changes
		var timesChanged = 0
		$scope.$watchCollection('vm.item.Nodes', function (newVal, oldVal) {		
			angular.forEach(vm.item.Nodes, function (node) {
				node.toString = nodeToString
			})
		})

		function nodeToString(){
			return this.Text
		}

		//incrementing this variable will recenter the content
		vm.centerContentTrigger = 0
		vm.showConfirmRemove = false

		vm.showAddMember = function ($event) {
			angular.forEach(vm.item.Nodes, function (node) {
				node.$selected = false
			})
			var newId = ObjectId()
			vm.item.Nodes.push({ Text: 'New Member', id: newId, _id: newId, toString: nodeToString, $isRoot: true, $selected: true })
		}

		vm.showRemoveMember = function ($event) {
			var selectedNode = $filter('filter')(vm.item.Nodes, { $selected: true })
			if (selectedNode.length != 1) {
				toast.error('Exactly one member may be removed at a time.')
				return
			}

			$event.stopPropagation()

			selectedNode = selectedNode[0]

			// show confirm remove button
			vm.showConfirmRemove = true
		}

		vm.confirmRemoval = function ($event) {
			vm.showConfirmRemove = false
			var selectedNode = $filter('filter')(vm.item.Nodes, { $selected: true })[0]

			// hit the server
			vm.item.removeTeamMember(selectedNode._id)

			// remove the selected team member
			angular.forEach(vm.item.Nodes, function (node, i) {
				if (node._id == selectedNode._id) {
					vm.item.Nodes.splice(i, 1)
				}
				if (node.parentId == selectedNode._id) {
					node.parentId = null
					node.$isRoot = true
				}
			})

			//force the orgchart to re-render all child nodes
			angular.forEach(selectedNode.$children, function (child) {
				delete child.$OrgChartReady
				delete child.$parentId
			})

			vm.centerContentTrigger++
		}
	}

})();
(function() {
	'use strict';

	ResetPasswordsDialogController.$inject = ["$mdDialog", "$filter", "users", "httpError", "$q"];
	angular
		.module('app')
		.controller('ResetPasswordsDialogController', ResetPasswordsDialogController);

	/* @ngInject */
	function ResetPasswordsDialogController($mdDialog, $filter, users, httpError, $q) {
		var vm = this
		vm.newPassword = {
			specify: '0'
		}
		vm.finishing = false

		vm.cancel = function() {
			$mdDialog.cancel()
		}

		vm.handleBatchPasswordReset = function() {
			var newPassword = null;
			var dialog;
			var proms = []

			if (vm.newPassword.specify == "1") {
				newPassword = vm.newPassword.password;
			}

			users.forEach(function(user) {
				proms.push(user.setPassword(newPassword, vm.newPassword.sendEmail))
			})

			vm.finishing = true

			$q.all(proms).then(function() {
				dialog = $mdDialog.alert({
					title: 'Success!',
					textContent: 'The passwords were reset successfully.',
					ok: 'Ok',
				})
				$mdDialog.show(dialog)
			}, function(err) {
				dialog = $mdDialog.alert({
					title: 'Oh no!',
					htmlContent: httpError.parse(err),
					ok: 'Aw, shucks',
				})
				$mdDialog.show(dialog)
			})
		}
	}
})();
(function () {
	'use strict';

	ReassignSubordinatesDialogController.$inject = ["$scope", "$rootScope", "$mdDialog", "toast", "User", "$filter", "selectedUser", "httpError"];
	angular
		.module('app')
		.controller('ReassignSubordinatesDialogController', ReassignSubordinatesDialogController);

	/* @ngInject */
	function ReassignSubordinatesDialogController($scope, $rootScope, $mdDialog, toast, User, $filter, selectedUser, httpError) {
		var vm = this;
		
		vm.searchText = "";
		vm.selectedUser = selectedUser;
		vm.loading = false;
		vm.clearBoss = false;

		vm.reassignUsers = reassignUsers;
		
		vm.$mdDialog = $mdDialog

		function reassignUsers() {
			vm.loading = true;
			vm.selectedUser.reassignSubordinates(vm.toUser, vm.clearBoss)
				.then(function (res) {
					toast.success("Sucessfully reassigned subordinates of " + vm.selectedUser.toString() + " to " + $filter('fullNameFilter')(vm.toUser) + ".")
					console.debug('got back',res);
					vm.loading = false;
					$mdDialog.hide(res);
				}, function (err) {
					vm.loading = false;
					toast.error('Error: ' + err.data.error);
				})


		}
	}
})();
(function () {
    'use strict';

    AddContactDialog.$inject = ["$mdDialog", "$http", "$filter", "User", "Team"];
    angular
        .module('app')
        .controller('AddContactDialog', AddContactDialog)

    /* @ngInject */
    function AddContactDialog($mdDialog, $http, $filter, User, Team) {
        var vm = this
        vm.newItem = vm.contact = new User({Organization: $rootScope.Organization._id, IsContact: true})
        vm.typeOrUpload = 'type'
        vm.teams = []

        vm.determineNextStep = function () {
			if (vm.typeOrUpload == 'type') {
				// hide the 'upload contacts' step
				vm.wizardSteps.getStep('upload').visible = false
				vm.wizardSteps.getStep('basicInfo').visible = true
			}
			else {
				//hide the 'enter info' steps 
				vm.wizardSteps.getStep('upload').visible = true
				vm.wizardSteps.getStep('basicInfo').visible = false
			}
			// needed
			return true
        }
        
        vm.confirmFileChosen = function() {
            if (!vm.file) {
                toast.error("Please select a file")
                return false
            } else {
                return true
            }
        }

        vm.confirmNameEntered = function() {
            return vm.contact.FirstName && vm.contact.LastName
        }

        vm.transformTeamChip = function($chip) {
            return $chip._id
        }

        vm.getDisplayableTeams = function() {
            if (vm.teams.length == 0) return 'none'
            return vm.teams.map(function(teamId) {
                return $filter('auItemFilter')(teamId, 'Team')
            }).join(', ')
        }

        vm.review = function() {
            var returnVal = []
            if (vm.typeOrUpload == 'type') {
                returnVal = [
                    { name: 'Type In or Upload', value: 'Type In' },
                    { name: 'First Name', value: vm.contact.FirstName },
                    { name: 'Last Name', value: vm.contact.LastName },
                    { name: 'Email', value: vm.contact.Email ? vm.contact.Email : 'none' }
                ]
            } else {
                returnVal = [
                    { name: 'Type In or Upload', value: 'Upload' },
                    { name: 'File Selected', value: vm.file.name }
                ]
            }
            returnVal.push({ name: 'Groups', value: vm.getDisplayableTeams() })

            return {
                error: false,
                details: returnVal
            }
        }

        vm.finish = function() {
            if (vm.typeOrUpload == 'type') {
                //save the new contact 
                vm.contact.Teams = vm.teams
                
                return vm.contact.$saveItem()
                .then(function(resp){
                	if (Object.byString(resp, 'data.serverError')) {
                		throw new Error(resp.data.serverError)
                	}
                	
                    return "You have successfully added: " + vm.contact.toString()
                })
            } else {
                //submit for upload
                return $q(function(resolve, reject){                
                    var reader = new FileReader();
                    reader.onload = function(fileContents) {
                        vm.contact.csv = fileContents.target.result
                        vm.contact.schema = 'Contact'
                        vm.contact.Teams = vm.teams

                        $http.post('/api/uploadCsvToDatabase', vm.contact).then(function(res) {
                            //res.data format: {"success":true,"kueId":"Ok7aEYIwUUWoy3mkxuM+LQ=="}
                            if (res.data.success) {
                                return resolve("Your file upload is in progress. Align Us will notify you momentarilly with the results.")
                            } else {
                                console.log(res)
                                return reject("<h3>Unable to add. Please see below and try again.</h3>" + httpError.parse(res.data, true))
                            }
                        })
                    }

                    reader.readAsText(vm.file);
                })
            }
        }
    }
})();
(function () {
	'use strict';

	PermissionPresetDetailController.$inject = ["$scope", "$stateParams", "$mdDialog", "toast", "$filter", "$http", "$timeout", "itemSettings", "PermissionPreset", "User", "ItemViewer", "httpError", "auUtility", "$state"];
	angular
		.module('app')
		.controller('PermissionPresetDetailController', PermissionPresetDetailController);

	/* @ngInject */
	function PermissionPresetDetailController($scope, $stateParams, $mdDialog, toast, $filter, $http, $timeout, itemSettings, PermissionPreset, User, ItemViewer, httpError, auUtility, $state) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)
		
		//put some "fat" sub-objects directly on the view model
		vm.detail = itemSettings.item;

		// populate group members
		vm.members = []
		vm.detail.getUsers().then(function (members) {
			vm.members = members
		})
		
		// chip append
		vm.addUser = function (user) {
			console.debug('add user', user)
			vm.detail.addMember(user).then(function (res) {
				//yeah - it worked
			}, function (err) {
				toast.error('Error: Could not save.');
			})
		}

		// chip remove
		vm.removeUser = function (user) {
			console.debug('remove user', user)

			vm.detail.removeMember(user).then(function (res) {
				//yeah - it worked
			}, function (err) {
				toast.error('Error: Could not save.');
			})
		}

		vm.transformChip = function (user) {
			if (vm.members.indexOf(user._id) > -1) return null
			return user._id
		}

	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "OrganizationProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, OrganizationProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: OrganizationProvider,
        })
    }
})();
(function () {
	'use strict';

	OrganizationItemController.$inject = ["$scope", "$rootScope", "themeProvider", "$injector", "auMaterialColors", "$filter", "toast", "auTheme", "usStates", "auMaterialPaletteGen", "itemSettings", "auUtility", "ItemViewer", "User"];
	angular
		.module('app')
		.controller('OrganizationItemController', OrganizationItemController);

	/* @ngInject */
	function OrganizationItemController($scope, $rootScope, themeProvider, $injector, auMaterialColors, $filter, toast, auTheme, usStates, auMaterialPaletteGen, itemSettings, auUtility, ItemViewer, User) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)
	
		//expose data to the view
		vm.item = itemSettings.item
		vm.states = usStates;

		vm.item.Settings.SendMorningEmail = new Date(vm.item.Settings.SendMorningEmail)
		vm.item.Settings.SendNightlyEmail = new Date(vm.item.Settings.SendNightlyEmail)

		vm.industries = [
			'AGRICULTURE',
			'ENTERTAINMENT',
			'LAW',
			'AUTOMOTIVE',
			'ELECTRONICS',
			'CONSTRUCTION',
			'EDUCATION',
			'ENGINEERING',
			'FINANCE',
			'FOOD',
			'HEALTHCARE',
			'HOSPITALITY',
			'MANUFACTURING',
			'PERFORMING_ARTS',
			'PERSONAL',
			'POLITICS',
			'POST',
			'REAL_ESTATE',
			'MARKETING',
			'TRANSPORTATION',
			'STORAGE'
		]
		
		vm.timezones = window.moment.tz.names().filter(function (e) {
			return (e.startsWith('US/') || e == 'America/Chicago');
		}).concat(window.moment.tz.names().filter(function (e) {
			return !(e.startsWith('US/') || e == 'America/Chicago');
		}))

		vm.colors = auMaterialColors;
		vm.toolbarColor = {
			color: vm.item.Settings.TitlebarColor
		}
		vm.Members = User.getCache({IsContact: false}, true)
		$scope.$on('itemAdded', function(event, item){
			if (item.$key == 'User') {
				vm.Members.push(item)
			}
		})
		vm.onParentUpdate = function(node, oldParent){
			node.$updateItem()
			delete node._hasSubordinates
			delete oldParent._hasSubordinates
		}
		
		$scope.$watch('vm.item.Settings.Timezone', function (newVal, oldVal) {
			if (newVal == oldVal) return;
			$rootScope.Organization.setSetting({ Timezone: newVal }).then(function (res) {
				toast.success("Saved!");
			}, function (err) {
				console.error(err);
			})
		})

		$scope.$watch('vm.item.Settings.SendNightlyEmail', function(newVal, oldVal) {
			if (newVal == oldVal) return;
			if (newVal && newVal.toString && oldVal && oldVal.toString && newVal.toString() == oldVal.toString()) return;
			$rootScope.Organization.setSetting({ SendNightlyEmail: newVal }).then(function (res) {
				toast.success("Saved!");
			}, function (err) {
				console.error(err);
			});
		})

		$scope.$watch('vm.item.Settings.SendMorningEmail', function(newVal, oldVal) {
			if (newVal == oldVal) return;
			if (newVal && newVal.toString && oldVal && oldVal.toString && newVal.toString() == oldVal.toString()) return;
			$rootScope.Organization.setSetting({ SendMorningEmail: newVal }).then(function (res) {
				toast.success("Saved!");
			}, function (err) {
				console.error(err);
			});
		})

		vm.setToolbarColor = function(color) {	
			//validation error
			if (!color) return
					
			//ignore init
			if (vm.item.Settings.TitlebarColor == color) return
			
			//for the md-select to know what's selected
			vm.toolbarColor = {color: color}
			
			//save the new setting
			vm.item.setSetting({
				'TitlebarColor': color
			})

			//apply (does not consider that the user may override this on reload)
			auTheme.loadTheme(color, false)
		}
	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "LocationProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, LocationProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: LocationProvider,
            itemSection: 'location',
            detailTemplateUrl: '/app/structure/organization-settings/location/tmpl.html',
            controller: 'LocationController'
        })
    }
})();
(function () {
	'use strict';

	LocationItemController.$inject = ["$scope", "$timeout", "usStates", "itemSettings", "auUtility", "ItemViewer", "User"];
	angular
		.module('app')
		.controller('LocationItemController', LocationItemController);

	/* @ngInject */
	function LocationItemController($scope, $timeout, usStates, itemSettings, auUtility, ItemViewer, User) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose data to the view
		vm.item = itemSettings.item
		vm.states = usStates

		vm.addUser = function ($event) {
			auUtility.selectUsers('Type a user\'s name', vm.item.$Members.map(function (m) { return m._id }), true)
				.then(function (users) {
					users.forEach(function (user) {
						user = User.getCache({ _id: user })[0]
						user.Location = vm.item._id
						user.$updateItem()
					})

					toast.success('Changes processing... Please wait for the user\'s location update to complete.')
				})
		}

		vm.removeMember = function ($event) {
			var selectedNode = $filter('filter')(vm.item.$Members, { $selected: true })
			if (selectedNode.length != 1) {
				toast.error('Exactly one user may be removed at a time.')
				return
			}

			$event.stopPropagation()

			$mdDialog.show($mdDialog.confirm({
                title: 'Remove User',
                textContent: 'This will clear out the Location field for this user.'.format(vm.item.$key, vm.item.toString()),
                ok: 'Proceed',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function () {
				selectedNode[0].Location = null
				selectedNode[0].$updateItem()

				toast.success('Changes processing... Please wait for the user\'s location update to complete.')
            })
		}

		vm.oneUserSelected = function(){
			return vm.item.$Members.filter(function(user){return user.$selected}).length == 1
		}

		vm.selectedHeadChanged = function (user) {
			if (!user || !user.$addNew) return

			vm.headSearchText = ""

			auUtility.addNewItem(user.$addNew).then(function (newItem) {
				if (!newItem) return
				vm.item.Head = newItem._id
			})

		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app')
        .filter('creditCard', creditCard);

    /* @ngInject */
    function creditCard() {
        return filterFunction;

        ////////////////

        function filterFunction(value) {
			if (!value) return;
			if (typeof value != 'string') return;
			
            return value.replace(/.{4}/g,function(match) {
				return match+' '
			}).trim();
        }
    }

})();
(function() {
    'use strict';
    
        BatchChangeDepartmentLocationController.$inject = ["$mdDialog", "$q", "options", "toast"];
    angular
        .module('app')
        .controller('BatchChangeDepartmentLocationController', BatchChangeDepartmentLocationController);

        /* @ngInject */
        function BatchChangeDepartmentLocationController($mdDialog, $q, options, toast) {
            var vm = this

            vm.finish = function() {
                vm.finishing = true
                
                $q.all(options.users.map(function(user) {
                    if (vm.department) user.Department = vm.department
                    if (vm.location) user.Location = vm.location
                    return user.$updateItem().$promise
                })).then(function() {
                    $mdDialog.hide('Assigned ' + options.users.length + ' users.')
                }).catch(function(error) {
                    $mdDialog.cancel(error)
                })
            }
        }
})();
(function() {
    'use strict';
    
        BatchAddToTeamController.$inject = ["$mdDialog", "$q", "options", "toast", "Team"];
    angular
        .module('app')
        .controller('BatchAddToTeamController', BatchAddToTeamController);

        /* @ngInject */
        function BatchAddToTeamController($mdDialog, $q, options, toast, Team) {
            var vm = this

            vm.finish = function() {
                vm.finishing = true

                var promises = options.users.map(function(user) {
                    if (vm.addToTeam) return Team.getCache({_id: vm.addToTeam})[0].addTeamMember(user.toString(), user._id)
                }).concat(options.users.map(function(user) {
                    if (vm.removeFromTeam) return Team.getCache({_id: vm.removeFromTeam})[0].addTeamMember(user._id)
                }))

                $q.all(promises).then(function() {
                    $mdDialog.hide('Modified ' + options.users.length + ' users.')
                }).catch(function(error) {
                    $mdDialog.cancel(error)
                })
            }
        }
})();
(function() {
	'use strict';

	AddUserLicenseController.$inject = ["$scope", "$rootScope", "$mdDialog", "$timeout", "$filter", "$mdToast", "$http", "$q", "usStates", "User"];
	angular
		.module('app')
		.controller('AddUserLicenseController', AddUserLicenseController);

	/* @ngInject */
	function AddUserLicenseController($scope, $rootScope, $mdDialog, $timeout, $filter, $mdToast, $http, $q, usStates, User) {
		var vm = this;
		vm.states = usStates
		vm.parseInt = parseInt

		vm.stepChanged = function(currentStep, fromStep) { 
			toast.toast('Navigated from ' + fromStep + ' to ' + currentStep)
		}

		vm.data = {}

		vm.validateSelectLicenseStep = function() {
			if (vm.addLicenses == 0) {
				toast.error('Please select the number of licenses to add.')
				return false
			}
			if (!vm.agreedToTerms) {
				toast.error('You must agree to the terms of service to proceed.')
				return false
			}
			return true
		}		

		vm.confirmNextStep = function() {
			var res = confirm('Return false to prevent the user from going forward.')
			if (!res) toast.error('User prevented from proceeding.')
			return res
		}

		vm.review = function() {
			//must be {finishOK: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Number of Licenses To Add', value: vm.addLicenses},
					{name: 'Agreed to Terms?', value: vm.agreedToTerms},
					{name: 'Credit Card Number', value: vm.data.creditCard},
					{name: 'Expiration Date', value: vm.data.expirationDate},
					{name: 'CCV', value: vm.data.CCV},
					{name: 'Name on Card', value: vm.data.cardName},
					{name: 'Address', value: vm.data.billingAddress},
					{name: 'City', value: vm.data.city},
					{name: 'Zip Code', value: vm.data.zip},
					{name: 'Phone Number', value: vm.data.phone}
				]
			}
		}

		vm.finish = function(){
			var promise = $q.defer()

			// Button for step 3
			var postObj = {
				LicensesAdded: vm.addLicenses,
				CCNumber: vm.data.creditCard,
				CCExpiration: vm.data.expirationDate,
				CCV: vm.data.CCV,
				Name: vm.data.cardName,
				BillingAddress: vm.data.billingAddress,
				City: vm.data.city,
				Zip: vm.data.zip,
				Phone: vm.data.phone,
				AgreedToTerms: vm.agreedToTerms
			}

			$http.post('/api/organization/AddLicenses', postObj).then(function(res){
				promise.resolve('Thank you for your business! ' + vm.addLicenses + ' have been added to your account.')
				$rootScope.Organization.getSettings()
			}, function(err){
				promise.reject(err.data.error)
			})

			return promise.promise
		}		
	}
}
)();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "DepartmentProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, DepartmentProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: DepartmentProvider,
            itemSection: 'department',
            detailTemplateUrl: '/app/structure/organization-settings/department/tmpl.html',
            controller: 'DepartmentController'
        })
    }
})();
(function () {
	'use strict';

	DepartmentItemController.$inject = ["$scope", "$timeout", "usStates", "itemSettings", "auUtility", "ItemViewer", "User"];
	angular
		.module('app')
		.controller('DepartmentItemController', DepartmentItemController);

	/* @ngInject */
	function DepartmentItemController($scope, $timeout, usStates, itemSettings, auUtility, ItemViewer, User) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose data to the view
		vm.item = itemSettings.item
		vm.states = usStates

		vm.addUser = function ($event) {
			auUtility.selectUsers('Type a user\'s name', vm.item.$Members.map(function (m) { return m._id }), true)
				.then(function (users) {
					users.forEach(function (user) {
						user = User.getCache({ _id: user })[0]
						user.Department = vm.item._id
						user.$updateItem()
					})

					toast.success('Changes processing... Please wait for the user\'s department update to complete.')
				})
		}

		vm.removeMember = function ($event) {
			var selectedNode = $filter('filter')(vm.item.$Members, { $selected: true })
			if (selectedNode.length != 1) {
				toast.error('Exactly one user may be removed at a time.')
				return
			}

			$event.stopPropagation()

			$mdDialog.show($mdDialog.confirm({
                title: 'Remove User',
                textContent: 'This will clear out the Department field for this user.'.format(vm.item.$key, vm.item.toString()),
                ok: 'Proceed',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function () {
				selectedNode[0].Department = null
				selectedNode[0].$updateItem()

				toast.success('Changes processing... Please wait for the user\'s department update to complete.')
            })
		}

		vm.oneUserSelected = function(){
			return vm.item.$Members.filter(function(user){return user.$selected}).length == 1
		}

		vm.selectedHeadChanged = function (user) {
			if (!user || !user.$addNew) return

			vm.headSearchText = ""

			auUtility.addNewItem(user.$addNew).then(function (newItem) {
				if (!newItem) return
				vm.item.Head = newItem._id
			})

		}
	}
})();
(function() {
    'use strict';

    QuestionSearchController.$inject = ["$scope", "$element", "$compile", "$mdDialog", "Question", "$state", "$timeout", "$filter", "$location", "ItemViewer"];
    angular
        .module('app')
        .controller('QuestionSearchController', QuestionSearchController);

    /* @ngInject */
    function QuestionSearchController($scope, $element, $compile, $mdDialog, Question, $state, $timeout, $filter, $location, ItemViewer) {
        var vm = this;
        vm.searching = false
        $state.$current.data.fabButtons = null

        $rootScope.Organization.getStat("Question.QuestionCount")
            .then(function(res) {
                vm.questionCount = res.data.value
            })

        vm.goToQuestion = function(question) {
            // $state.go('shell.social.question', {id: question._id})
           question.open('recent')
        }

        vm.openAddQuestionDialog = function($event) {
            $mdDialog.show({
                controller: 'AskQuestionDialog',
                controllerAs: 'vm',
                templateUrl: '/app/social/questions/dialogs/ask-question.tmpl.html',
                targetEvent: $event,
                locals: { options: { questionTitle: vm.searchText } }
            }).then(function(hide) {
                //can run code after dialog closes normally
            })
        }

        vm.submitSearch = function() {
            console.debug('searching', vm.searchText)
            vm.searching = true

            //move the search into a one-search position
            $element.find(".question-input-container").addClass('as-one-search')
            $element.find(".search-form").css('top', '20px')
            $element.find('.search-header').addClass('display-none')
            $element.find('.search-button').css('margin-right', '-7px')

            //show the fab
            $state.$current.data.fabButtons = [{
                title: 'Ask Question',
                icon: 'zmdi zmdi-help',
                action: function($event) {
                    $mdDialog.show({
                        controller: 'AskQuestionDialog',
                        controllerAs: 'vm',
                        templateUrl: '/app/social/questions/dialogs/ask-question.tmpl.html',
                        targetEvent: $event,
                        locals: { options: { questionTitle: vm.searchText } }
                    })
                },
                permissionNeeded: '$root.user.EffPerms.QnA.CanCreate'
            }]
            $state.$current.data.fabIcon = 'zmdi zmdi-plus'

            //persist the search to the querysting to handle page reloads and link sharing
            $location.search('q', vm.searchText)

            Question.search(vm.searchText)
                .then(function(response) {
                    vm.searching = false
                    vm.searchResults = $filter('orderBy')(response.data, '-score')
                        // convert raw question objects to cached resources
                    vm.searchResults = vm.searchResults.map(function(rawQuestion) {
                        return new Question(rawQuestion)
                    })
                    vm.qasFound = vm.searchResults.length

                    //show the results
                    $element.find('.footer').css('position', 'static')
                    $element.find('.search-result-container').removeClass('display-none')
                    $element.find('.ask-question').removeClass('display-none')

                    //for each result, find three relevant sentences to show
                    /*
                    for each word in first server result (we'll push the stems into the result)
                    	do until x = 3
                    		get substring of questionbody + answers where indexof stem
                    	loop
                    next

                    */

                })
                .catch(function(error) {})
        }

        //on load
        setTimeout(function() {
            //bind focus and blur handlers to the text box
            $element.find("#TxtSearch").bind("focus", function() {
                $element.find(".question-input-container").addClass("focused")
            });

            $element.find("#TxtSearch").bind("blur", function() {
                $element.find(".question-input-container").removeClass("focused")
            });

            //submit the search if there was a Q querystring
            if ($location.search().q) {
                vm.searchText = $location.search().q
                vm.submitSearch()
            }
        }, 0)
    }

})();
(function () {
	'use strict';

	QuestionTagController.$inject = ["$scope", "$element", "$compile", "$mdDialog", "ItemViewer", "itemSettings", "auUtility"];
	angular
		.module('app')
		.controller('QuestionTagController', QuestionTagController);

	/* @ngInject */
	function QuestionTagController($scope, $element, $compile, $mdDialog, ItemViewer, itemSettings, auUtility) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;

	}

})();
(function () {
	'use strict';

	QuestionAnswerController.$inject = ["$scope", "toast", "$filter", "$state", "ItemViewer", "itemSettings"];
	angular
		.module('app')
		.controller('QuestionAnswerController', QuestionAnswerController);

	/* @ngInject */
	function QuestionAnswerController($scope, toast, $filter, $state, ItemViewer, itemSettings) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;
		

	}
})();
(function () {
	'use strict';

	QuestionsController.$inject = ["$scope", "$element", "$compile", "$mdDialog", "ItemViewer", "itemSettings", "toast", "QuestionAnswer"];
	angular
		.module('app')
		.controller('QuestionsController', QuestionsController);

	/* @ngInject */
	function QuestionsController($scope, $element, $compile, $mdDialog, ItemViewer, itemSettings, toast, QuestionAnswer) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;

		// this at least prevents a crash when UserQuestion is passed...
		// but we got some figurin' out to do.
		if(vm.item) {
			vm.newAnswer = new QuestionAnswer({
				Question: vm.item._id,
				Documents: []
			})
		}

		// 'submit answer' button text 
		vm.submitButtonText = 'Submit'

		vm.openEditQuestionDialog = function($event) {
			$mdDialog.show({
					controller: 'EditQuestionDialog',
					controllerAs: 'vm',
					templateUrl: '/app/social/questions/dialogs/edit-question.tmpl.html',
					targetEvent: $event,
					locals: {editingQuestion: vm.item}
			}).then(function (hide) {
				//can run code after dialog closes normally
				}, function (cancel) {
				//can run code if the user cancels out (hits X our clicks out)
			})
		}

		vm.openEditAnswerDialog = function($event, answer) {
			$mdDialog.show({
				controller: 'EditAnswerDialog',
				controllerAs: 'vm',
				templateUrl: '/app/social/questions/dialogs/edit-question-answer.tmpl.html',
				targetEvent: $event,
				locals: { editingAnswer: answer }
			}).then(function() {

			})
		}

		vm.deleteQuestion = function($event) {
			$mdDialog.show({
				controller: 'RemoveItemDialogController',
				controllerAs: 'vm',
				locals: {
					selectedItems: [vm.item],
					showConfirmationSignature: true
				},
				//bindToController: true,
				templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
				//scope: thisDialogScope,
				clickOutsideToClose: true,
				//fullscreen: useFullScreen,
				targetEvent: $event
			}).then(function() {
				$window.history.back()
			})
		}

		vm.toggleFaq = function() {
			vm.item.SetFaq(!vm.item.IsFAQ)
		}

		vm.toggleFollow = function() {
			if(vm.item.IsThisUserFollowing()) {
				vm.item.Unfollow()
				.then(function() {
					toast.success('You are no longer following this question')
				})
			} else {
				vm.item.Follow()
				.then(function() {
					toast.success('You are now following this question')
				})
			}
		}

		vm.flag = function($event) {
			var toDisplay = $mdDialog.confirm({
				title: 'Flag Question',
				textContent: 'Are you sure you want to flag this question as inappropriate?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})
			$mdDialog.show(toDisplay)
			.then(function() {
				return vm.item.Flag()
			})
			.then(function() {
				toast.success('You flagged this question as inappropriate')
			})
		}

		vm.flagAnswer = function($event, answer) {
			var toDisplay = $mdDialog.confirm({
				title: 'Flag Answer',
				textContent: 'Are you sure you want to flag this answer as inappropriate?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})
			$mdDialog.show(toDisplay)
			.then(function() {
				return answer.Flag()
			})
			.then(function() {
				toast.success('You flagged this answer as inappropriate')
			})
		}

		vm.submitAnswer = function() {
			var savedAnswer = new QuestionAnswer(vm.newAnswer)
			savedAnswer.$saveItem().then(function() {
				vm.item.$Answers.push(savedAnswer)
				vm.newAnswer = savedAnswer
				// UI needs to vary depending on whether they've submitted an answer
				vm.answerSubmitted = true
				vm.savedAnswer = savedAnswer
				vm.submitButtonText = 'Update'
				vm.responseText = 'Answer submitted!'
				// vm.newAnswer = {
				// 	Question: vm.item._id
				// }
			})
		}

		vm.answerButtonClicked = function() {
			// if their answer was already submitted, edit their answer
			if(vm.answerSubmitted) {
				vm.savedAnswer.$updateItem()
				.$promise
				.then(function() {
					vm.responseText = 'Answer updated!'
				})
			} else {
				// else submit their answer
				vm.submitAnswer()
			}
		}

		vm.deleteAnswer = function($event, answer, $index) {
			$mdDialog.show({
				controller: 'RemoveItemDialogController',
				controllerAs: 'vm',
				locals: {
					selectedItems: [answer],
					showConfirmationSignature: true
				},
				//bindToController: true,
				templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
				//scope: thisDialogScope,
				clickOutsideToClose: true,
				//fullscreen: useFullScreen,
				targetEvent: $event
			}).then(function(ret) {
				if(ret != 'cancelled') {
					// vm.item.$Answers.splice($index, 1)
					var realIndex
					for(var i = 0; i < vm.item.$Answers.length; i++) {
						if(vm.item.$Answers[i]._id == answer._id) {
							realIndex = i
							break
						}
					}
					vm.item.$Answers.splice(realIndex, 1)
				} 
			})
		}

		vm.upvoteAnswer = function($event, answer) {
			answer.Vote(1).then(function() {
				toast.success('You successfully upvoted this answer')
			})
		}

		vm.downvoteAnswer = function($event, answer) {
			answer.Vote(-1).then(function() {
				toast.success('You successfully downvoted this answer')
			})
		}

		vm.addCommentToAnswer = function($event, answer) {
			if(answer.$newComment) {
				answer.Comment(answer.$newComment)
				.then(function() {
					answer.$newComment = null
					toast.success('You have successfully replied to this answer')
				})
			}
		}

		vm.acceptAnswer = function($event, answerId) {
			vm.item.AcceptAnswer(answerId)
			.then(function() {
				toast.success('You successfully accepted this answer!')
			})
		}
		
		vm.whereToShare = [
			'My Profile Page',
			'A Friend\'s Page',
			'A Group Page',
			'A Private Message'
		];

		vm.showBody = function(){
			if (vm.item.QuestionBody) return true
			else return false
		}

	}

})();
(function () {
	'use strict';

	ModeratorsController.$inject = ["$scope", "$element", "$compile", "$mdDialog"];
	angular
		.module('app')
		.controller('ModeratorsController', ModeratorsController);

	/* @ngInject */
	function ModeratorsController($scope, $element, $compile, $mdDialog) {
		var vm = this;

		vm.openAskQuestionDialog = function ($event) {
			$mdDialog.show({
					controller: 'AskQuestionDialog',
					controllerAs: 'vm',
					templateUrl: '/app/social/questions/dialogs/ask-question.tmpl.html',
					targetEvent: $event,
					locals: { options: {}}
			}).then(function (hide) {
				//can run code after dialog closes normally
				}, function (cancel) {
				//can run code if the user cancels out (hits X our clicks out)
			})
		}
		
		vm.whereToShare = [
			'My Profile Page',
			'A Friend\'s Page',
			'A Group Page',
			'A Private Message'
		];

	}

})();
(function() {
	'use strict';

	EditQuestionDialog.$inject = ["$timeout", "toast", "User", "Question", "QuestionTag", "auUtility", "$mdConstant", "$q", "editingQuestion", "$mdDialog", "$filter"];
	angular
		.module('app')
		.controller('EditQuestionDialog', EditQuestionDialog);

	/* @ngInject */
	function EditQuestionDialog($timeout, toast, User, Question, QuestionTag, auUtility, $mdConstant, $q, editingQuestion, $mdDialog, $filter) {
		var vm = this;

		vm.question = editingQuestion
		vm.docSection = false

		vm.desiredTags = []
		vm.newTags = []
		// 186 = semicolon
		vm.separatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, 186]

		vm.searchTags = auUtility.searchTags
		vm.allTags = QuestionTag.getCache(true)
		vm.tagInQuestion = function (tag) {
			return vm.question.Tags.indexOf(tag._id) > -1
		}

		//expand and collapse attach doc section
		vm.showDocSection = function () {
			if(vm.docSection){
				vm.docSection = false
			} else {
				vm.docSection = true
			}
		}

		//confirm question has a title
		vm.confirmTitleEntered = function() {
			if (vm.question.QuestionTitle == "") toast.error('Question must have a title')
			else return vm.question.QuestionTitle
		}

		vm.toggleTagInQuestion = function (tag) {
			var idx = vm.question.Tags.indexOf(tag)
			if (idx > -1) {
				vm.question.Tags.splice(idx, 1)
			} else {
				vm.question.Tags.push(tag)
			}
		}

		vm.addTag = function () {
			vm.wizardSteps.getStep('newTags').visible = true
			vm.newTags.push( {TagText:vm.searchTagsText} )
			vm.searchTagsText = ""
		}

		vm.removeNewTag = function (tag) {
			var idx = vm.newTags.indexOf(tag)
			if (idx > -1) {
				vm.newTags.splice(idx, 1)
			}
			if (vm.newTags.length == 0) {
				vm.wizardSteps.getStep('newTags').visible = false
			}
		}

		vm.showAddTag = function () {
			return $filter('filter')(vm.allTags, {TagText: vm.searchTagsText}, true).length == 0
		}

		vm.checkForNewTags = function() {
			vm.wizardSteps[2].visible = false
			vm.question.Tags.forEach(function(tag, index) {
				if(typeof tag != 'object' && isTagNew(tag)) {
					vm.newTags.push(new QuestionTag({TagText: tag}))
				}
			})
			if(vm.newTags.length > 0) {
				vm.wizardSteps[2].visible = true
			}
			return true
		}

		vm.makeNewTags = function() {
			// this may or may not be way more complicated than it needs to be
			var proms = []
			vm.newTags.forEach(function(tag, index) {
				vm.newTags[index] = new QuestionTag(tag)
				proms.push(vm.newTags[index].$saveItem())
			})
			$q.all(proms)
			.then(function() {
				vm.newTags.forEach(function(newTag) {
					vm.question.Tags.push(newTag._id)
				})
			})
			return true
		}

		//return an object when the user gets to the review step
		vm.review = function() {
			//must be {error: boolean, details: array}
			var ret = {
				error: false,
				details: [
					{name: 'Title', value: vm.question.QuestionTitle},
					{name: 'Body', value: vm.question.QuestionBody},
					{name: 'Tags', value: ''}
				]
			}
			vm.newTags.forEach(function (tag) {
				ret.details[2].value += tag.TagText + ' '
			})
			vm.question.Tags.forEach(function (tag) {
				ret.details[2].value += $filter('questionTagFilter')(tag) + ' '
			})
			return ret
		}

		//complete the user request to finish the dialog
		vm.finish = function(){
			return vm.question.$updateItem().$promise
			.then(function(item){
				return "You have successfuly updated " + item.QuestionTitle
			})
		}

		vm.transformTagChip = function($chip) {
			console.debug('Transforming chip', $chip)
			return $chip
		}

		function isTagNew(tag) {
			return (QuestionTag.getCache({_id: tag}).length == 0)
		}
	}
}
)();
(function() {
	'use strict';

	EditAnswerDialog.$inject = ["$timeout", "toast", "User", "Question", "QuestionTag", "auUtility", "$mdConstant", "$q", "editingAnswer", "$mdDialog"];
	angular
		.module('app')
		.controller('EditAnswerDialog', EditAnswerDialog);

	/* @ngInject */
	function EditAnswerDialog($timeout, toast, User, Question, QuestionTag, auUtility, $mdConstant, $q, editingAnswer, $mdDialog) {
		var vm = this;

		vm.answer = editingAnswer

		//the toast is super annoying, but you get the idea
		vm.stepChanged = function(currentStep, fromStep) {
		}

		//potentially block a step by adding on-next-step to any au-wizard-step
		vm.confirmNextStep = function() {
			var res = confirm('Allow user to proceed going forward?')
			if (!res) toast.error('User prevented from proceeding.')
			return res //return false to prevent the user from going to the next step
		}

		//return an object when the user gets to the review step
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Title', value: vm.answer.AnswerTitle},
					{name: 'Body', value: vm.answer.Content},
				]
			}
		}

		//complete the user request to finish the dialog
		vm.finish = function(){
			return vm.answer.$updateItem().$promise
			.then(function(item){
				return "You have successfully updated " + item.AnswerTitle
			})
		}
	}
}
)();
(function () {
	'use strict';

	AskQuestionDialog.$inject = ["$timeout", "toast", "User", "Question", "QuestionTag", "auUtility", "$mdConstant", "$q", "$rootScope", "$sce", "$mdDialog", "$state", "options"];
	angular
		.module('app')
		.controller('AskQuestionDialog', AskQuestionDialog);

	/* @ngInject */
	function AskQuestionDialog($timeout, toast, User, Question, QuestionTag, auUtility, $mdConstant, $q, $rootScope, $sce, $mdDialog, $state, options) {
		var vm = this;
		vm.newItem = vm.question = new Question({
			WhoToAsk: {
				FirstAsk: {
					Type: 'Organization',
					Id: $rootScope.Organization._id,
					$Display: 'Everyone in ' + $rootScope.Organization.Name
				}
			},
			Tags: []
		})

		if (options.questionTitle) {
			vm.question.QuestionTitle = options.questionTitle
		}

		vm.docSection = false
		vm.desiredTags = []
		vm.newTags = []
		// vm.escalateDelayOptions = ['2 Hours', '4 Hours', '1 Day', '1.5 Days', '2 Days', '3 Days', '4 Days', '1 Week']
		vm.escalateDelayOptions = [{
			optionString: '2 Hours',
			dataValue: 2
		}, {
				optionString: '4 Hours',
				dataValue: 4
			}, {
				optionString: '1 Day',
				dataValue: 24
			}, {
				optionString: '1.5 Days',
				dataValue: 36
			}, {
				optionString: '2 Days',
				dataValue: 48
			}, {
				optionString: '3 Days',
				dataValue: 72
			}, {
				optionString: '4 Days',
				dataValue: 96
			}, {
				optionString: '1 Week',
				dataValue: 168
			}]
		// 186 = semicolon
		vm.separatorKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, 186]

		vm.searchUsersAndTeams = auUtility.searchUsersAndTeams
		vm.searchTags = auUtility.searchTags

		vm.getQuestionsMatchingSearch = function() {
			if (vm.question.QuestionTitle == "") {
				vm.showResults = false
				vm.showTooltip = false
			} else {
				Question.search(vm.question.QuestionTitle)
					.then(function(response) {
						vm.showResults = true
						vm.showTooltip = true
						vm.searchResults = $filter('orderBy')(response.data, '-score')
						// convert raw question objects into cached resources
						vm.searchResults = vm.searchResults.map(function(rawQuestion) {
							return new Question(rawQuestion)
						})
					})
			}
		}

		//bold the matched part of the word		
		vm.highlightSuggestion = function (itemText) {
			var words = vm.question.QuestionTitle.split(' ')

			//replace all words with <b>{{word}}</b>
			var returnVal = itemText
			words.forEach(function (word, i) {
				returnVal = returnVal.replace(new RegExp(word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'gi'), '<b><u>$&</u></b>')
			})
			return $sce.trustAsHtml(returnVal)
		}

		vm.shrinkResults = function () {
			if (vm.showResults) {
				vm.showResults = false
				angular.element('#CkeQuestionBody').click()  //sets focus
			} else {
				vm.showResults = true
			} 
				
		}

		//open the clicked on question as a recent item                
		vm.openQuestion = function (question) {
			question.open(true)
		}

		//expand and collapse attach docs section
		vm.showDocSection = function () {
			if(vm.docSection){
				vm.docSection = false
			} else {
				vm.docSection = true
			}
		}

		vm.allTags = QuestionTag.getCache(true)
		vm.tagInQuestion = function (tag) {
			return vm.question.Tags.indexOf(tag) > -1
		}
		vm.toggleTagInQuestion = function (tag) {
			var idx = vm.question.Tags.indexOf(tag)
			if (idx > -1) {
				vm.question.Tags.splice(idx, 1)
			} else {
				vm.question.Tags.push(tag)
			}
		}
		vm.addTag = function () {
			vm.wizardSteps.getStep('newTags').visible = true
			vm.newTags.push( {TagText:vm.searchTagsText} )
			vm.searchTagsText = ""
		}
		vm.removeNewTag = function (tag) {
			var idx = vm.newTags.indexOf(tag)
			if (idx > -1) {
				vm.newTags.splice(idx, 1)
			}
			if (vm.newTags.length == 0) {
				vm.wizardSteps.getStep('newTags').visible = false
			}
		}
		vm.showAddTag = function () {
			return $filter('filter')(vm.allTags, {TagText: vm.searchTagsText}, true).length == 0
		}

		vm.confirmQuestionEntered = function () {
			//if we are showing the search results, close them
			if (vm.showResults) vm.showResults = false
			//if there is a title and body, go to the next step
			if (vm.question.QuestionTitle && vm.question.QuestionBody) return true
		}

		vm.confirmWhoToAskEntered = function () {
			// Wo To Ask field must have a value for the user to continue
			//return vm.question.WhoToAsk
			if (vm.question.WhoToAsk.FirstAsk || vm.question.WhoToAsk.SecondAsk || vm.question.WhoToAsk.FinallyAsk) {
				return true
			} else {
				toast.error('Enter at least one person to ask')
			}
			// return true
		}

		vm.confirmTagsEntered = function () {
			// Tags field must have a value for the user to continue
			//return vm.question.Tags
			if (vm.question.Tags.length > 0 || vm.newTags.length > 0) {
				return true
			} else {
				toast.error('Enter at least one tag')
			}
		}

		vm.confirmTagDescriptions = function () {
			if (vm.newTags.every(function (tag) { return tag.Description })) {
				return true
			} else {
				toast.error('Enter a description for each new tag')
			}
		}

		vm.stepChanged = function (currentStep, fromStep) {
			if (fromStep == 0) {
				vm.wizardSteps.getStep('newTags').visible = vm.newTags.length > 0
			}
		}

		//return an object when the user gets to the review step		
		vm.review = function () {
			//must be {error: boolean, details: array}
			var ret = {
				details: [
					{ name: 'Question Title', value: vm.question.QuestionTitle }
				]
			}
			if (vm.newTags.length > 0){
				if (ret.details.indexOf('Tags') < 0) {
					ret.details.push({ name: 'Tags', value: ''})
				}
				vm.newTags.forEach(function (tag) {
					ret.details[1].value += tag.TagText + ' '
				})
			}
			if (vm.question.Tags.length > 0){
				if (ret.details.indexOf('Tags') < 0) {
					ret.details.push({ name: 'Tags', value: ''})
				}
				vm.question.Tags.forEach(function (tag) {
					ret.details[1].value += tag.TagText + ' '
				})
			}
			if (vm.question.QuestionBody){
				ret.details.push({ name: 'Question Body', value: vm.question.QuestionBody })
			}
			if (vm.question.Documents) vm.question.Documents.forEach(function (document) {
				ret.details.push({ name: 'Attached Document', value: document.Title })
			})
			if (vm.question.WhoToAsk.FirstAsk) {
				ret.details.push({ name: 'First Ask', value: vm.question.WhoToAsk.FirstAsk.$Display })
			}
			if (vm.question.WhoToAsk.SecondAsk) {
				ret.details.push({ name: 'Wait this many hours', value: vm.question.WhoToAsk.DelaySecondAsk })
				ret.details.push({ name: 'Then Ask', value: vm.question.WhoToAsk.SecondAsk.$Display })
			}
			if (vm.question.WhoToAsk.FinallyAsk) {
				ret.details.push({ name: 'Wait this many hours', value: vm.question.WhoToAsk.DelayFinallyAsk })
				ret.details.push({ name: 'Finally Ask', value: vm.question.WhoToAsk.FinallyAsk.$Display })
			}
			return ret
		}

		//complete the user request to finish the dialog		
		vm.finish = function () {
			var tagProms = []
			vm.newTags.forEach(function (newTag, index) {
				newTag = new QuestionTag(newTag)
				tagProms.push(newTag.$saveItem().then(function (savedTag) {
					vm.newTags[index] = savedTag
				}))
			})
			return ($q.all(tagProms)
				.then(function () {
					vm.question.Tags = vm.question.Tags.concat(vm.newTags)
					vm.question.Tags = vm.question.Tags.map(function (tag) {
						return tag._id
					})
					return vm.question.$saveItem()
					.then(function(item){
						return 'Your question was created successfully.'	
					})
					
				}))
			// return the promise here
		}

		vm.transformUserTeamChip = function ($chip) {
			console.debug('chip', $chip)
			return $chip.Id
		}

		vm.transformTagChip = function ($chip) {
			console.debug('Transforming chip', $chip)
			return $chip
		}

		vm.itemChanged = function (which) {
			if (which == 'second' && !vm.question.WhoToAsk.DelaySecondAsk) {
				vm.question.WhoToAsk.DelaySecondAsk = 24
			}
			if (which == 'finally' && !vm.question.WhoToAsk.DelayFinallyAsk) {
				vm.question.WhoToAsk.DelayFinallyAsk = 24
			}
		}

	}
}
)();
(function() {
	'use strict';

	AddTagDialog.$inject = ["$timeout", "$filter", "toast", "User", "QuestionTag", "$mdDialog", "auUtility"];
	angular
		.module('app')
		.controller('AddTagDialog', AddTagDialog);

	/* @ngInject */
	function AddTagDialog($timeout, $filter, toast, User, QuestionTag, $mdDialog, auUtility) {
		var vm = this;
        vm.newItem = vm.questionTag = new QuestionTag({})

		//the toast is super annoying, but you get the idea
		vm.stepChanged = function(currentStep, fromStep) {
			//toast.toast('Navigated from ' + fromStep + ' to ' + currentStep)
		}

        //this confrims that a tag was given a title before going to the next step
		vm.confirmTitleEntered = function(){
            return vm.questionTag.TagText
        }

        //this confirms that a moderator was selected before going to the next step
        vm.confirmModeratorEntered = function(){
            return vm.questionTag.Moderator
        }

		//return an object when the user gets to the review step
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Tag Title', value: vm.questionTag.TagText},
					{name: 'Tag Description', value: vm.questionTag.Description},
                    {name: 'Tag Moderator', value: $filter('auItemFilter')(vm.questionTag.Moderator, 'User')}
				]
			}
		}

		//complete the user request to finish the dialog
		vm.finish = function(){
			// var questionTag = new QuestionTag(vm.questionTag)
            return vm.questionTag.$saveItem()
			.then(function(item){
				return "You have successfully added: " + item.toString()
			})
		}

	}
}
)();
(function() {
	'use strict'
	
	configReport.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(configReport)

	/* @ngInject */
	function configReport($stateProvider) {
		$stateProvider.state('shell.social.meetings.reports', {
			views: {
				'@shell': {
					templateUrl: '/app/social/meetings/report/report.tmpl.html',
					controller: 'MeetingReportController',
					controllerAs: 'vm'
				}
			},
			url: '/report',
			navigationData: {
				breadcrumbTitle: 'Meeting Report'
			},
			resolve: {
				statsFromToday: ["$http", "meetingReports", function($http, meetingReports) {
					return meetingReports.getStatsFor({startDate: new Date().toString(), endDate: new Date().toString()})
				}]
			}
		})
	}
})();
(function() {
	'use strict'
	
		MeetingReportController.$inject = ["$scope", "$http", "$filter", "auUtility", "statsFromToday", "meetingReports"];
	angular
		.module('app')
		.controller('MeetingReportController', MeetingReportController)

		/* @ngInject */
		function MeetingReportController($scope, $http, $filter, auUtility, statsFromToday, meetingReports) {
			var vm = this
			// initialize query
			vm.reportQuery =  {}
			vm.reportQuery.startDate = new Date()
			vm.reportQuery.endDate = new Date()
			// initialize chart bindings
			vm.topFive = {}
			vm.bottomFive = {}
			vm.lineChart = {}
			// by default, show meeting stats for today
			bindDataFromReport(statsFromToday)

			// listen for oneSearch telling us that the user selected an item
			// to query by
			$scope.$on('changeMeetingReport', handleItemSelected)

			// when "go" is clicked, just re-query
			vm.goClicked = handleQueryChanged

			// handles the user selecting an item to query by
			function handleItemSelected(event, selectedItem) {
				console.debug('received event', selectedItem)
				// seems like on initialization this gets called with
				// NULL as the second param, so let's guard against that
				if(selectedItem) {
					// assign the item to the query, alongside the dates
					vm.reportQuery.item = selectedItem.item
					// handle the change to the query
					handleQueryChanged()
				}
			}

			function handleQueryChanged() {
				// use the meetingReports service to get stats matching user's query
				meetingReports.getStatsFor(vm.reportQuery)
				.then(function(report) {
					console.debug('new report', report)
					// we got the report; bind the data
					bindDataFromReport(report)
				})
			}

			// takes the data from a newly received report and binds it to
			// the proper models so that it can be displayed by the page
			function bindDataFromReport(report) {
				// bindBasicData(report)
				vm.report = report
				if(!report.Stats || report.Stats.length == 0) return
				// bind top 5 bar graph
				vm.topFive.raw = report.Stats
				.slice(0, 5)
				.filter(function(stat) {
					return stat.$reason.GoodText
				})
				vm.topFive.labels = makeTopFiveLabels(vm.topFive.raw)
				vm.topFive.data = makeTopFiveData(vm.topFive.raw)
				// bind bottom 5 bar graph
				vm.bottomFive.raw = report.Stats
				.slice(report.Stats.length - 6, report.Stats.length - 1)
				.filter(function(stat) {
					return stat.$reason.BadText
				})
				vm.bottomFive.labels = makeBottomFiveLabels(vm.bottomFive.raw)
				vm.bottomFive.data = makeBottomFiveData(vm.bottomFive.raw)
				vm.lineChart.data = makeLineChartData(report.OriginalReports)
				vm.lineChart.labels = makeLineChartLabels(report.OriginalReports)
				console.debug(vm.lineChart.labels)
				console.debug(vm.lineChart.data)
			}

			function makeTopFiveLabels(stats) {
				return stats.map(function(stat) {
					return stat.$reason.GoodText
				})
			}

			function makeBottomFiveLabels(stats) {
				return stats.map(function(stat) {
					return stat.$reason.BadText
				})
			}

			function makeTopFiveData(stats) {
				return [stats.map(function(stat) {
					return stat.sumPos
				})]
			}

			function makeBottomFiveData(stats) {
				return [stats.map(function(stat) {
					return stat.sumNeg
				})]
			}

			function makeLineChartData(reports) {
				return [reports.map(function(report) {
					return getPercentSuccessful(report)
				})]
			}

			function makeLineChartLabels(reports) {
				return reports.map(function(report) {
					return $filter('date')(report.ForDate, 'shortDate')
				})
			}

			// to get the percentage of successful meetings in a report...
			function getPercentSuccessful(report) {
				// ...it's just the number of meetings where more than 50% of 
				// people approved divided by the total number of meetings in the report
				var rawApprovalRatio = (report.MatchedMeetings.filter(function(meeting) {
					return meeting.ReportData.ApprovalStats.approvedPercentage >= 50
				}).length / report.MatchedMeetings.length)
				// then we round to 2 decimal places and phrase it as a percentage
				return Number(Math.round(rawApprovalRatio + 'e' + 2) + 'e-' + 2) * 100
			}

			vm.openMeeting = function(meeting) {
				$rootScope.$broadcast('openNewItem', meeting)
			}

			console.debug('statsFromToday', statsFromToday)
		}
})();
(function () {
	'use strict';
	videoCallRecipe.$inject = ["$rootScope", "socket", "ActivityLog", "videoStream", "$sce", "$timeout", "$interval", "$log", "$injector", "Schema"];
	angular
		.module('app')
		.service('videoCall', videoCallRecipe)

	/* @ngInject */
	function videoCallRecipe($rootScope, socket, ActivityLog, videoStream, $sce, $timeout, $interval, $log, $injector, Schema) {
		var api
		var calls = {}
		window.calls = calls

		console.log('Video call service initializing')

		// begin videoCall object constructor
		function videoCall(callLog, options) {
			var This = this
			var iceConfig = { iceServers: [{ url: 'stun:stun.l.google.com:19302' }, { url:'stun:stun1.l.google.com:19302' }, { url:'stun:stun2.l.google.com:19302' }] }
			var peers = {}

			this.callLog = callLog
			this.callGuid = callLog._id
			this.peers = peers
			this.unlistens = []
			this.streamPromises = []
			this.sdpPending = {}
			this.dcs = {}
			this.left = {}
			this.streamAudio = true

			if (callLog.User == $rootScope.user._id) {
				callLog.Data.Invited.forEach(function (invitedId) {
					// if you are initiating the call
					if (invitedId != $rootScope.user._id) {
						// add a graphic placeholder for that peer
						addPlaceholderPeer(invitedId)
						// if you invited this peer, you're responsible for timing them out
						if (This.callLog.User == $rootScope.user._id) {
							timeoutPeer(invitedId)
						}
					}
				})
			} else {
				callLog.Data.OnCall.forEach(function (onCallId) {
					// if you are not initiating the call
					if (onCallId != $rootScope.user._id) {
						// add a graphic placeholder for that peer
						addPlaceholderPeer(onCallId)
					}
				})
			}

			this.getPeerIds = function() {
				return Object.keys(This.peers)
			}

			this.getConnectedPeerIds = function() {
				var returnVal = []
				for (var p in This.peers) {
					var peer = This.peers[p]
					if (peer.signalingState == 'stable' && peer.iceConnectionState == 'connected') {
						returnVal.push(peer.peerId)
					}
				}
				
				return returnVal
			}

			this.hasConnectedPeer = function(peerId) {
				return This.getConnectedPeerIds().indexOf(peerId) > -1
			}

			this.getNegotiatingPeerIds = function() {
				return This.getPeerIds().filter(function(peerId) {
					var connectionState = This.peers[peerId].iceConnectionState
					return (connectionState == 'new' || connectionState == 'checking' || connectionState == 'completed')
				})
			}

			this.hasNegotiatingPeer = function(peerId) {
				return This.getNegotiatingPeerIds().indexOf(peerId) > -1
			}

			this.leaveCall = function () {
				// close all peer connections
				This.getPeerIds().forEach(function (peerId) {
					safeDeletePeer(peerId)
				})
				// stop recording the user's audio/video
				if(This.userStream) {
					This.userStream.getTracks().forEach(function (track) {
						track.stop()
					})
				}
				// record/broadcast that the user has left this call
				new ActivityLog({
					Type: 'VideoUserLeft',
					Data: {
						CallId: This.callGuid
					}
				}).$saveItem()
				// leave this call's preview if we're in it
				if(This.callLog.Type != 'VideoPreview') {
					leavePreview(This.callLog)
				}
				// unsubscribe from all events related to this call
				This.unlistens.forEach(function(unlistener) {
					unlistener()
				})
				// cancel the interval which syncs the UI
				$interval.cancel(This.uiSyncInterval)
				// no longer listen for messages relayed by the server
				socket.off('message' + this.callLog._id, handleMessage)

				// remove the call from the exposed API
				delete calls[This.callGuid]

				$interval(angular.noop, 100, 3)
			}

			this.emitError = function() {
				Array.prototype.push.call(arguments, ((new Date().toString())))
				Array.prototype.push.call(arguments, 'For call ID: ' + This.callGuid)
				Array.prototype.push.call(arguments, This)
				Array.prototype.unshift.call(arguments, 'VideoCallError')
				$log.error.apply(null, arguments)
			}

			this.inviteUsers = function(peerIds) {
				// we need to join the preview when we invite someone so they can
				// see a preview of us
				if(this.hasVideo) {
					api.join({ callLog: This.getPreviewLog() })				
				}
				// hit API to add the users to the video call record
				// and create invitations
				This.callLog.VideoInviteUsers(peerIds, This.userStream.getVideoTracks().length == 0)
					.then(function() {
						peerIds.forEach(addPlaceholderPeer)
						peerIds.forEach(timeoutPeer)
					}).catch(function(error) {
						This.emitError('Server could not add users', error)
					})
			}

			// returns a promise which will resolve with the stream from
			// the peer specified by userId
			this.getStreamByUserId = function (userId) {
				// lazy load
				if(!This.streamPromises[userId]) {
					This.streamPromises[userId] = $q.defer()
				}
				return This.streamPromises[userId].promise				
			}

			// stream the stream specified by "stream" (...) to all peers
			this.setStream = function (stream) {
				// this can happen in previews. unless you've invited someone to the corresponding call,
				// in which case your client will attempt to send them a preview stream,
				// you're not actually streaming anything while in the preview call.
				if(!stream) {
					This.hasVideo = false
					return;
				}
				// create a trusted URL to display your own stream in the UI
				This.myStreamAsUrl = $sce.trustAsResourceUrl(URL.createObjectURL(stream))
				// bind the stream to the call so that it can be used (for muting, streaming to future peers, etc)
				This.userStream = stream
				// match the stream's audio
				This.setAudioTo(This.streamAudio)
				// for every peer
				This.getPeerIds().forEach(function (peerId) {
					// if they're a full-fledged RTC peer...
					if (peers[peerId] instanceof RTCPeerConnection) {
						// ...add the stream
						peers[peerId].addStream(stream)
						// send them an SDP offer
						makeSDPOffer(peerId, true)
					}
				})

				This.hasVideo = (stream.getVideoTracks().length > 0)
			}.bind(this)

			// toggles whether the user's stream is muted or not
			this.toggleAudio = function() {
				// set UI flag
				This.streamAudio = (!This.streamAudio)
				// toggle "enabled" property of all audio tracks
				This.setAudioTo(This.streamAudio)
			}

			this.setAudioTo = function(enabled) {
				This.userStream.getAudioTracks().forEach(function(audioTrack) {
					audioTrack.enabled = enabled
				})
			}

			var myEmojiTimeout
			this.setEmoji = function (newEmoji) {
				This.myEmoji = newEmoji
				This.getPeerIds().forEach(function (peerId) {
					socket.emit('video-forward-message', { type: 'message-emoji-changed', to: peerId, from: $rootScope.user._id, callGuid: This.callGuid, newEmoji: newEmoji })
				})
				$timeout.cancel(myEmojiTimeout)
				myEmojiTimeout = $timeout(function () {
					This.myEmoji = ""
					$interval(angular.noop, 100, 3)
				}, 15*1000)
				$interval(angular.noop, 100, 3)
			}

			This.shareItem = function(item) {
				This.myShare = item

				//clear the shared item from the sender's UI after 15 secs
				$timeout(function(){
					This.myShare = null
				}, 15 * 1000)

				return new ActivityLog({
					Type: 'VideoShare',
					User: $rootScope.user._id,
					Data: {
						CallId: This.callGuid,
						Type: 'item',
						DocId: item._id,
						ModelName: item.$key
					}
				}).$saveItem()
			}

			This.getPreview = function() {
				return calls[Object.keys(calls).filter(function(callId) {
					return (calls[callId] && calls[callId].callLog.Type == 'VideoPreview' && calls[callId].callLog.Data.CallId == This.callGuid)
				})[0]]
			}

			This.getPreviewLog = function() {
				return ActivityLog.getCache(function(log) {
					return (log.Type == 'VideoPreview' && Object.byString(log, 'Data.CallId') == This.callGuid)
				}, false)[0]
			}

			function safeDeletePeer(peerId) {
				// short-circuit if the requested peer doesn't exist
				if(!This.peers[peerId]) return;
				// if this is a full RTCPeerConnection peer, call the .close()
				// function to end the peer-to-peer connection
				if(This.peers[peerId].close) {
					This.peers[peerId].close()
				}
				// cancel timeout indicating that this peer is DCed; they'll be gone, so it won't matter
				$timeout.cancel(This.peers[peerId].disconnectTimeout)
				// cancel the "they haven't picked up yet" timeout
				$timeout.cancel(This.peers[peerId].timeoutCounter)
				// cancel any "they left or declined" timeout
				$timeout.cancel(This.peers[peerId].leftOrDeclinedTimeout)
				delete This.peers[peerId]
				$interval(angular.noop, 100, 3)
			}

			function timeoutPeer(userId) {
				//immediately declare the progress started (a css change is required to kick in a css transition animation)
				$timeout(function () {
					angular.element('.sidebar-video-chat .progress-bar').addClass('started')
				})

				//at 25 seconds turn the progress bar red				
				$timeout(function () {
					console.log('turning red')
					angular.element('.sidebar-video-chat .progress-bar').addClass('warning')
				}, 25000)

				//remove the peer at 30 seconds
				This.peers[userId].timeoutCounter = $timeout(function () {
					if (!This.hasConnectedPeer(userId) && !This.hasNegotiatingPeer(userId)) {
						// log the timeout (might save us grief if this function ever deletes things it shouldn't)
						$log.log('VideoCall timing out peer ' + userId, new Date(), This.callGuid)
						// remove the peer
						safeDeletePeer(userId)
					}
				}, 30000)

				//create a missed video call notification after 60 seconds
				$timeout(function () {
					if (!This.hasConnectedPeer(userId) && !This.hasNegotiatingPeer(userId)) {
						// notify the peer that they missed a call
						This.callLog.VideoUserMissedCall(userId)
					}
				}, 60000)
			}

			// retrieve an RTCPeerConnection object representing a connection to the
			// user specified by peerId
			function getPeer(peerId) {
				var errorProm
				// don't try to connect to ourself
				if (peerId == $rootScope.user._id) {
					return;
				}
				// if we are already connected/attempting to connect to this peer, we can lazy-load them from
				// the map of all peers
				if (peers[peerId] && peers[peerId] instanceof RTCPeerConnection) {
					return peers[peerId]
				}
				// if not, create a new peer connection
				try {
					var peer = new RTCPeerConnection(iceConfig)
				} catch (error) {
					This.emitError('Creating RTCPeerConnection from browser API', iceConfig)
				}
				// hang a streamPromise from which we can wait on this peer's stream actually being connected
				if(!This.streamPromises[peerId]) {
					This.streamPromises[peerId] = $q.defer()
				}
				peer.peerId = peerId
				console.log('Calling addStream for peer', peerId)
				// stream from the user's camera to this peer
				if(This.userStream) {
					peer.addStream(This.userStream)				
				}				

				// when the PeerConnection API discovers a new ICE candidate for this peer,
				// forward the candidate to the peer
				peer.onicecandidate = function (iceEvent) {
					socket.emit('video-forward-message', { type: 'message-ice-candidate', to: peerId, from: $rootScope.user._id, callGuid: This.callGuid, iceCandidate: iceEvent.candidate })
				}

				// for now, just log this --> what causes this, do we need to respond?
				peer.onremovestream = function() {
					$log.log('Stream removed for peer', This.peers[peerId])
				}

				// fires once we have fully connected with the peer and
				// are ready to begin streaming their video/audio
				peer.onaddstream = function (streamEvent) {
					// the raw stream object; good to have access to, as it contains numerous useful properties
					peer.streamObject = streamEvent.stream
					// if there is no video track, expose a property to tell the UI and other components that this
					// peer is only streaming audio
					peer.streamObject.audioOnly = (peer.streamObject.getVideoTracks()[0] == undefined)
					// create a URL and trust it with $sce, then expose it so the UI can render the stream
					peer.stream = $sce.trustAsResourceUrl(URL.createObjectURL(streamEvent.stream))
					// flag indicating that the UI should render this peer as though it is fully connected and streaming
					// near-useless for actually diagnosing the connection -- rename?
					peer.isConnected = true
					// expose the peer's id -- do we need this?
					peer.peerId = peerId
					// clear whatever UI message was there before (the UI will show the peer's name by default)
					delete peer.peerHtml
					// if we're fully connected, SDP is obviously no longer pending
					This.sdpPending[peerId] = false
					// if other UI components are waiting on this peer's streamPromise, it should resolve
					// now that we have the stream
					This.streamPromises[peerId].resolve(peer.stream)
					console.log('Stream added', peer)
					// $rootScope.$apply workaround
					$interval(angular.noop, 100, 3)
					// clear the counter for timing out the peer
					$timeout.cancel(peer.timeoutCounter)
					delete peer.timeoutCounter
				}

				// unused; RTC supposedly diagnoses and handles connection issues internally,
				// i.e. using this is likely to hurt more than it helps
				peer.reconnect = function() {
					if(This.callLog.Type == 'VideoPreview') return;
					makeSDPOffer(peerId)
					socket.emit('video-forward-message', { type: 'failed-connection-detected', to: peerId, from: $rootScope.user._id, callGuid: This.callGuid })
				}

				peer.fixFrozenStream = function() {
					This.emitError('Unfreeze stream button clicked', peer)
					peer.stream = $sce.trustAsResourceUrl(URL.createObjectURL(peer.getRemoteStreams()[0]))
					$interval(angular.noop, 100, 3)						
				}

				// handle changes to the networked state of the peer
				peer.oniceconnectionstatechange = function (streamEvent) {
					switch(peer.iceConnectionState) {
						// per ICE docs, 'disconnected' can occur frequently and doesn't necessarily
						// mean that the connection is/should be terminated.
						// however, it's the only way we have to detect a legitimate "out of our control" disconnect,
						// like the user refreshing their browser, their internet dropping, etc. so we 
						// can't entirely ignore it.
						case 'disconnected':
							// don't stack timeouts
							$timeout.cancel(peer.disconnectTimeout)
							// start a timeout that will remove them from the UI
							// if they remain disconnected for a given length of time
							peer.disconnectTimeout = $timeout(function() {
								safeDeletePeer(peerId)
							}, 15*1000)
							This.dcs[peerId] = true
							// UI flag them as DCed -- could be janky, but there's no other way
							if(!peers[peerId].peerHtml) {
								peers[peerId].peerHtml = 'Disconnected'							
							}
							break;
						case 'connected':
							// cancel disconnect timeout
							$timeout.cancel(peer.disconnectTimeout)
							// remove peer from list of DCs
							delete This.dcs[peerId]
							// clear peer UI back to default state
							delete peers[peerId].peerHtml
							break;
						case 'closed':
							// dunno
							break;
						case 'failed':
							peerLeftOrDeclined(peerId, 'Failed to Connect')
							break;
					}
				}

				peer.onnegotiationneeded = function () {
					console.info('Negotiation needed for peer ', This.peers[peerId])
					makeSDPOffer(peerId)
				}

				// add this peer to the map of peers
				peers[peerId] = peer
				return peer
			}

			function peerLeftOrDeclined(peerId, message) {
				if (!peers[peerId]) return;
				peers[peerId].peerId = peerId
				peers[peerId].peerHtml = message
				peers[peerId].isConnected = false
				$timeout.cancel(peers[peerId].timeoutCounter)
				peers[peerId].leftOrDeclinedTimeout = $timeout(function() {
					if(!This.hasConnectedPeer(peerId) && !This.hasNegotiatingPeer(peerId)) {
						safeDeletePeer(peerId)
					}
				}, 10*1000)
			}

			function addPlaceholderPeer(invitedId) {
				This.peers[invitedId] = { peerId: invitedId, peerHtml: 'Connecting {{peer.peerId | firstNameFilter}}...', isConnected: false }
				This.streamPromises[invitedId] = $q.defer()
			}

			// make an SDP offer to the user specified by peerId
			function makeSDPOffer(peerId, renegotiating) {
				//noop if peerId is you or lower
				if (peerId == $rootScope.user._id) return;
				// although the "bigger" user ID always initiates the peer connection,
				// we have to allow anyone to renegotiate the connection since anyone can
				// change their video/audio device and this requires renegotiation
				if(!renegotiating) {
					if (peerId < $rootScope.user._id) return;
					if((This.hasConnectedPeer(peerId) || This.hasNegotiatingPeer(peerId) || This.sdpPending[peerId])) return;
				} else {
					console.info('Renegotiating flag passed')
				}

				This.sdpPending[peerId] = new Date()
				delete This.dcs[peerId]

				// retrieve a PeerConnection to this user
				var peer = getPeer(peerId)
				if (!peer || peer.signalingState.indexOf('have') > -1) return;
				// make an SDP offer to this peer
				peer.createOffer({ offerToReceiveVideo: true, OfferToReceiveVideo: true }).then(function(sdp) {
					// upon creation of the SDP offer, fill the peer connection's local description with the SDP data
					peer.setLocalDescription(sdp).then(function () {
						console.log('Local peer description set by creating an SDP offer for call ' + This.callGuid, new Date(), peer)
					}).catch(function (error) {
						This.emitError('Setting local description by SDP offer', peer, error)
					})
					// forward the SDP offer to this peer so they may handle it
					socket.emit('video-forward-message', { type: 'message-sdp-offer', to: peerId, from: $rootScope.user._id, callGuid: This.callGuid, sdpOffer: sdp })
				}).catch(function(error) {
					This.emitError('Creating SDP offer', peer, error)						
				})
			}

			// handle a message (forwarded from peer --> server --> us) of any type
			function handleMessage(message) {
				// retrieve a PeerConnection to the message's sender
				var peer = getPeer(message.from, message.forceReconnect)
				if (!peer) return;
				// take action depending on the type of the message
				switch (message.type) {
					case 'failed-connection-detected':
						debugger
						This.emitError('Failed connection detected', message)
					case 'message-sdp-offer':
						// if the message is an SDP offer:
						var sessionDescription = new RTCSessionDescription(message.sdpOffer)
						// we seem to receive an occasional error, the gist of which is "bad session description",
						// so guard against that a bit and print lots of debug info
						if(!sessionDescription || !sessionDescription.type) {
							This.emitError('Bad session description produced by SDP offer in message; will now attempt reconnect', message, sessionDescription)
							return
						}
						// NOTE: this is really awful Promise form (pyramid of doom) but for the sake of debugging i'd rather handle each
						// catch individually than flatten the promises and aggregate all errors to one error handler
						// 1) fill the peer connection's remote description with the data from their SDP offer
						peer.setRemoteDescription(sessionDescription).then(function() {
							console.log('Remote peer description set by receiving SDP offer for call ' + This.callGuid, new Date(), peer)
							// 2) create an SDP answer
							peer.createAnswer().then(function (sdpAnswer) {
								// 3) fill the peer connection's local description with our SDP answer									
								peer.setLocalDescription(sdpAnswer).then(function () {
									console.log('Local peer description set by creating SDP answer for call ' + This.callGuid, new Date(), peer)
								}).catch(function (error) {
									$log.error(error)
									This.emitError('Setting local description with SDP answer for call', message, error, peer)
								})
								// 4) reply to the peer with an SDP answer so that they may complete the connection
								socket.emit('video-forward-message', { type: 'message-sdp-answer', to: message.from, from: $rootScope.user._id, callGuid: This.callGuid, sdpAnswer: sdpAnswer })
							}).catch(function (error) {
								This.emitError('Creating SDP answer for call', error)
							})
						}).catch(function(error) {
							$log.error(error)									
							This.emitError('Setting remote description; will now attemt reconnect', message, error, peer)
						})
						break;
					case 'message-sdp-answer':
						// if the message is an SDP answer, fill the remote description for that peer connection
						// with the data from the forwarded SDP answer
						var sessionDescription = new RTCSessionDescription(message.sdpAnswer)
						// we seem to receive an occasional error, the gist of which is "bad session description",
						// so guard against that a bit and print lots of debug info
						if(!sessionDescription || !sessionDescription.type) {
							This.emitError('Bad session description produced by SDP answer in message; will now attempt reconnect', message, peer, sessionDescription)
							return
						}
						peer.setRemoteDescription(sessionDescription).then(function() {
							console.log('Remote peer description set by receiving an SDP answer for call ' + This.callGuid, new Date(), peer)									
						}).catch(function(error) {
							$log.error(error)									
							This.emitError('Setting remote description for call', message, error, peer)
						})
						break;
					case 'message-ice-candidate':
						// if the message is to inform us of a new ICE candidate, add that ice candidate
						// to the the connection for this peer
						if (message.iceCandidate && peer.signalingState != 'closed') {
							peer.addIceCandidate(new RTCIceCandidate(message.iceCandidate)).then(function (result) {
								console.log('Added ICE candidate')
							}).catch(function (error) {
								$log.error(error)										
								This.emitError('Error adding ICE candidate; will now attempt reconnect', message, error, peer)										
							})
						}
						break;
					case 'message-emoji-changed':
						peer.emoji = message.newEmoji
						$timeout.cancel(peer.emojiTimeout)
						peer.emojiTimeout = $timeout(function () {
							peer.emoji = ''
						}, 10000)
						$interval(angular.noop, 100, 3)
						break;
				}
			}

			This.unlistens.push($rootScope.$on('itemAdded', function (event, item) {
				if (item.$key == 'ActivityLog' && Object.byString(item, 'Data.CallId') == This.callGuid) {
					switch (item.Type) {
						case 'VideoUserJoined':
							// if they joined this call, send them an SDP offer
							console.log('VideoUserJoined received for user ' + item.User + '; Making SDP offer.')
							delete This.left[item.User]
							delete This.dcs[item.User]
							makeSDPOffer(item.User)
							break;
						case 'VideoUserLeft':
							// disconnect/remove them from active peers list
							if (item.User != $rootScope.user._id) {								
								peerLeftOrDeclined(item.User, 'Left Call')
								This.left[item.User] = new Date()
								delete This.sdpPending[item.User]
								delete This.dcs[item.User]
							}
							break;
						case 'VideoUserDeclined':
							if (item.User != $rootScope.user._id) {
								peerLeftOrDeclined(item.User, 'Not Available')				
							}
							break;
						case 'VideoShare':
							if(This.peers[item.User]) {
								if(item.Data.Type == 'item') {
									item.Data.$item = Schema.resource(item.Data.ModelName).getCache({ _id: item.Data.DocId })[0]
								}
								Object.setByString(This.peers[item.User], 'share', item)
							}
					}
				}
			}))

			This.uiSyncInterval = $interval(syncUi, 2000)

			function syncUi() {
				//bad smell - but required - something is not updating the VideoCall inside This properly
				This.callLog = ActivityLog.getCache({_id: This.callGuid})[0]

				// if a user is in Data.OnCall but not in this call's peers, send them an SDP offer				
				This.callLog.Data.OnCall.forEach(function(onCallUser) {
					if(onCallUser != $rootScope.user._id && !This.hasConnectedPeer(onCallUser) && !This.hasNegotiatingPeer(onCallUser) && !This.dcs[onCallUser] && !This.left[onCallUser]) {
						makeSDPOffer(onCallUser)
					}
				})
			}

			// handle messages forwarded from peer --> server --> us
			socket.on('message' + this.callLog._id, handleMessage)
		} // end call constructor

		function internalJoin(callLog, options) {
			$timeout(function () {
				if (!(callLog.Type == 'VideoPreview' && callLog.User == $rootScope.user._id)) {
					new ActivityLog({
						User: $rootScope.user._id,
						Type: 'VideoUserJoined',
						Data: {
							CallId: options.callLog._id
						}
					}).$saveItem()
					.catch(function(error) {
						This.emitError('Failed to save VideoUserJoined record', error)
					})
				}
			}, 300)
		}

		// options.userIds, options.stream
		// returns an ActivityLog of type VideoCall to describe this call instance,
		// either by creating a new one or using one supplied by the user in options.callLog
		function getCallLog(options) {
			// if we were provided with a call log...
			if (options.callLog) {
				internalJoin(options.callLog, options)
				return $q.resolve(options.callLog)
			}
			// otherwise, we're making a new call
			var newCall = new ActivityLog({
				User: $rootScope.user._id,
				Type: 'VideoCall',
				Data: {
					Invited: options.userIds || []
				}
			})
			return newCall.$saveItem()
		}

		function leavePreview(callLog) {
			if(calls[callLog._id] && calls[callLog._id].getPreview()) {
				calls[callLog._id].getPreview().leaveCall()				
			}
		}

		api = {
			'join': function (options) {
				console.log('Join called. Options: ')
				console.log(options)

				// don't join the same call twice
				if(calls[(Object.byString(options, 'callLog._id') || '1')]) return;

				// default video quality to low
				if(!options.videoQuality) options.videoQuality = 'videoLow';
				
				// ActivityLog cached resource representing data that surrounds the call
				var callLog
				// will be populated with a MediaStream of the user's video
				var userStream
				// previews begin with muted audio streams
				var beginNoAudio = (Object.byString(options, 'callLog.Type') == 'VideoPreview')

				var streamPromise = videoStream.get({
					videoType: options.videoQuality,
					beginNoAudio: beginNoAudio
				}).catch(function(error) {
					// attempt to recover with an audio-only stream if a video device wasn't found 
					if(error.name == 'DevicesNotFoundError') {
						if(!(Object.byString(options, 'callLog.Type') == 'VideoPreview')) {
							// not specifying video = audio only
							return videoStream.get({
								beginNoAudio: beginNoAudio
							})
						} else {
							return;
						}
					} else if(error.name == 'TrackStartError') {
						// google states that a TrackStartError is a generic error
						// which indicates that a problem occurred at the device/operating system level
						// when attempting to record audio or video.
						// in other words, it's way out of our hands; wait a few seconds and try again. 
						return new $q(function(resolve, reject) {
							$timeout(function() {
								videoStream.get({
									videoType: options.videoQuality,
									beginNoAudio: beginNoAudio
								}).then(function(stream) {
									resolve(stream)
								}).catch(function(error) {
									reject(error)
								})
							}, 1500)
						})
					} else {
						throw error					
					}
				})
				
				// wait until we've received a stream from the user's device
				return streamPromise.then(function (stream) {
					// store it
					userStream = stream
					// get a call log
					return getCallLog(options)
				})
				.then(function(retrievedCallLog) {
					callLog = retrievedCallLog
					// if we were provided with a call log, we don't need to make previews, etc.
					// however, if we made the call log ourselves, we need to make an associated
					// preview call log and then join it before we continue
					// if we didn't get a stream, don't make a preview
					if(options.callLog || !userStream) {
						return $q.resolve(true)						
					} else {
						return new ActivityLog({
							Type: 'VideoPreview',
							User: $rootScope.user._id,
							Data: {
								CallId: callLog._id,
								Invited: callLog.Data.Invited
							}
						}).$saveItem()
						.then(function(savedPreview) {
							console.log('SAVED PREVIEW')
							return api.join({ callLog: savedPreview })
						})
					}
				}).then(function() {
					var call = new videoCall(callLog, options)
					// add an entry in the dictionary of calls for this call
					calls[callLog._id] = call
					// set the stream
					// call.streamPromise = streamPromise
					call.setStream(userStream)
					if (callLog.Type != 'VideoPreview') {
						// leave the preview for this call
						if (callLog.User != $rootScope.user._id) {
							leavePreview(callLog)
						}
						// alert google analytics that someone joined a call
						window.ga('send', {
							hitType: 'event',
							eventCategory: 'VideoCalling',
							eventAction: 'VideoCallJoined'
						})
						// mark our last joined call in our settings
						if($rootScope.user.MySettings) {
							$rootScope.user.MySettings.LastVideoCall = callLog._id
							$rootScope.user.setSetting({ LastVideoCall: callLog._id })
						}
					}
					// if they specified anyone to invite right off the bat, invite them.
					// this is fire and forget--do we care?
					if(options.userIds) {
						callLog.VideoInviteUsers(options.userIds, userStream.getVideoTracks().length == 0)
					}
					return call
				}).catch(function(error) {
					// if an error occurs during call creation, leave the call to
					// release any resources (streams, etc)
					if(callLog && calls[callLog._id]) {
						calls[callLog._id].leaveCall()
					}
					// pass the error to this function's caller
					throw error
				})
			},
			'decline': function (callLog) {
				// decline the call
				new ActivityLog({
					Type: 'VideoUserDeclined',
					Data: { CallId: callLog._id }
				}).$saveItem()
				// disconnect from the preview call
				leavePreview(callLog)
			},
			'calls': calls
		} // end service API

		$rootScope.getUiActiveVideoCall = function() {
			return Object.byString($rootScope, 'videoCallController.activeCall')			
		}

		return api
	}
})();
(function () {
	IncomingVideoCallController.$inject = ["$scope", "$rootScope", "options", "videoCall", "$mdDialog", "$timeout", "auUtility", "$interval"];
	angular
		.module('app')
		.controller('IncomingVideoCallController', IncomingVideoCallController)

	/* @ngInject */
	function IncomingVideoCallController($scope, $rootScope, options, videoCall, $mdDialog, $timeout, auUtility, $interval) {
		var vm = this
		// bind vm variables
		vm.streamInfo = {}
		vm.holdingLogs = []
		vm.callLog = options.callLog

		// connect preview stream to UI
		vm.streamInfo = { peerId: options.invite.User, remoteStream: options.previewStream, audioOnly: options.previewNoVideo }

		// related to destroying dialog automatically/cleaning up streams when that happens
		var declineTimeout
		var killStreamOnClose = true

		// html that can be manipulated and displayed in dialog
		var remoteStreamHtml = "<div layout='column' layout-align='start-center' class='remote-stream'><au-profile-image class='margin-right-0' user='\"" + options.invite.User + "\"' size='200'></au-profile-image><div ng-if='!vm.streamInfo.audioOnly' class='my-video-container'><video ng-src='{{vm.streamInfo.remoteStream}}' autoplay></video></div><audio ng-if='vm.streamInfo.audioOnly' ng-src='{{vm.streamInfo.remoteStream}}' autoplay></audio><div>{{vm.streamInfo.peerId | fullNameFilter}}</div></div>"
		var localStreamHtml = "<div layout='column' layout-align='start-center'><div><au-profile-image class='margin-right-0' item='$root.user' size='200'></au-profile-image></div><div style='text-align:center'>{{$root.user | fullNameFilter}} <p ng-if='!vm.streamInfo.localStream'>(Accept to Stream)</p></div></div>"
		var incomingListHtml = "Incoming video call from <span ng-repeat='user in vm.callLog.Data.Invited | everyoneButMe'>{{user | fullNameFilter}}{{$last ? '' : ', '}}</span>."

		// indicate that a video call is incoming
		auUtility.flashTitle('Video call from ' + options.invite.$User.toString())

		// show a desktop notification
		if (window.NotificationApi && window.NotificationApi.permission == "granted") {
			var notification = new window.NotificationApi('Video Call from ' + options.invite.$User.toString(), {
				icon: (options.invite.$User.Photo ? auUtility.s3UrlFromId(options.invite.$User.Photo) : "/assets/images/walkthrough/al.png"),
				body: 'Don\'t leave them hanging!',
			});
			notification.onclick = function () {
				window.focus()
			};
		}

		var states = {
			default: {
				name: 'default',
				html: '<div layout="row">' + remoteStreamHtml + '<div class="md-padding"></div>' + localStreamHtml + '</div>' + '<div layout="row" class="padding-top-10" layout-align="center center">' + incomingListHtml + '</div>',
				primaryAction: function () {
					$rootScope.$broadcast('accept-video-chat', { callLog: options.callLog })
					$mdDialog.hide()
				},
				secondaryAction: declineAndHide
			},
			callWaiting: {
				name: 'callWaiting',
				html: remoteStreamHtml + '<div layout="row" class="padding-top-10" layout-align="center center">' + incomingListHtml + "</div>" + "Suspend your primary call and accept?" + '</div>',
				primaryAction: function () {
					vm.holdingLogs.push(options.callWaiting.callLog)
					options.callWaiting.leaveCall()
					auUtility.toggleNotificationsTab('zmdi-videocam')
					videoCall.join({ callLog: options.callLog }).then(function (call) {
						console.log('Left held call, joined new call')
						vm.call = call
						call.getStreamByUserId(options.invite.User).then(function (stream) {
							vm.streamInfo = { peerId: options.invite.User, remoteStream: stream, localStream: call.myStreamAsUrl, audioOnly: call.peers[options.invite.User].streamObject.audioOnly }
							vm.currentState = states.takingCall
						}).catch(function (error) {
							console.error(error)
							throw error
						})
					})
				},
				secondaryAction: declineAndHide
			},
			takingCall: {
				name: 'takingCall',
				html: '<div layout="row">' + remoteStreamHtml + '<div class="md-padding"></div>' + localStreamHtml + '</div>' + '<div layout="row" class="padding-top-10" layout-align="center center">Return to your primary call, or replace it with this one?</div>',
				titleHtml: 'Speaking with {{vm.call.callLog.User | fullNameFilter}}',
				secondaryHtml: 'Hang Up and Return',
				secondaryAction: function () {
					vm.call.leaveCall()
					$rootScope.$broadcast('accept-video-chat', { callLog: vm.holdingLogs.pop() })
					delete vm.call
					$mdDialog.hide()
				},
				primaryHtml: 'Replace Primary Call',
				primaryAction: function () {
					$mdDialog.hide()
					options.callWaiting.leaveCall()
					$rootScope.$broadcast('accept-video-chat', { call: vm.call })
				},
				thirdAction: function () {
					// merge the calls somehow
				}
			}
		}

		// if there is no call waiting or it's a one-man show, use default state
		if (!options.callWaiting || options.callWaiting.callLog.Data.OnCall.length == 1) {
			vm.currentState = states.default
		} else {
			// otherwise, prompt with "replace current call?" etc etc
			vm.currentState = states.callWaiting
		}

		function declineAndHide() {
			videoCall.decline(options.callLog)
			$mdDialog.hide()
		}

		$scope.$on('$destroy', function (event, args) {
			$timeout.cancel(declineTimeout)
			auUtility.endFlashTitle()
			console.log('In $destroy handler')
			Object.keys(videoCall.calls).forEach(function (key) {
				callLog = videoCall.calls[key].callLog
				if (callLog.Type == 'VideoPreview' && callLog.Data.CallId == options.callLog._id) {
					videoCall.calls[key].leaveCall()
				}
			})
			if (killStreamOnClose && Object.byString(vm, 'streamInfo.localStream.getTracks')) {
				console.log('Destroying stream tracks')
				vm.streamInfo.localStream.getTracks().forEach(function (track) {
					track.stop()
				})
			}
		})


		declineTimeout = $timeout(function () {
			if (vm.currentState.name != 'takingCall') {
				// declineAndHide()
				$mdDialog.hide()
				window.ga('send', {
					hitType: 'event',
					eventCategory: 'VideoCalling',
					eventAction: 'VideoInviteTimeout'
				})
			}
		}, 30 * 1000)
	}
})();
(function () {
/**
 * @ngdoc service
 * @name toast
 * @module app
 * 
 * @description
 * 
 * mdToast.simple has too many parameters. toast only needs text.
 * toast also shows up inside dialogs if one is open.
 */
/**
 * @ngdoc method
 * @name toast.toast
 * 
 * @param {string} message The message to display inside the toast
 * @description
 * Convenience method which builds and shows a simple toast. Default toasts last 1.5 seconds.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
 * rejected with `$mdToast.cancel()`.
 */
/**
 * @ngdoc method
 * @name toast.success
 * 
 * @param {string} message The message to display inside the toast
 * @description
 * Convenience method which builds and shows a green toast with a check mark Success toasts last 1.5 seconds.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
 * rejected with `$mdToast.cancel()`.
 */
/**
 * @ngdoc method
 * @name toast.error
 * 
 * @param {string} message The message to display inside the toast
 * @description
 * Convenience method which builds and shows a red toast with an x. Error toasts last 4 seconds.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
 * rejected with `$mdToast.cancel()`.
 */
	toastFunction.$inject = ["$mdToast"];
	angular.module('app').service('toast', toastFunction)

	/* @ngInject */
	function toastFunction($mdToast) {
		this.toast = function (text, skipDialog) {
			var parent = skipDialog ? document.body : findParent()
			return $mdToast.show($mdToast.simple()
				.textContent(text)
				.position('top right')
				.hideDelay(1500)
				.parent(parent)
			)
		}
		
		this.success = function(text, skipDialog) {
			var parent = skipDialog ? document.body : findParent()
			return $mdToast.show({
				templateUrl: '/app/alignus/services/toast/toast-success.tmpl.html',
				controller: ["$scope", "toastContent", function($scope, toastContent) {
					$scope.toastContent = toastContent;
				}],
				locals: {
					toastContent: text
				},
				position: 'top right',
				parent: parent,
				hideDelay: 1500
			})
		}
		
		this.error = function(text, skipDialog) {
			var parent = skipDialog ? document.body : findParent()
			return $mdToast.show({
				templateUrl: '/app/alignus/services/toast/toast-error.tmpl.html',
				controller: ["$scope", "toastContent", function($scope, toastContent) {
					$scope.toastContent = toastContent;
				}],
				locals: {
					toastContent: text
				},
				position: 'top right',
				parent: parent,
				hideDelay: 4000
			})
		}
		
		//search an array of possible parents and return the first one found
		function findParent() {
			var possibleParents = [
				'md-dialog:not(.md-transition-out) md-dialog-content ng-form div', //item dialog
				'md-dialog:not(.md-transition-out) md-dialog-content', //most dialogs
				'#content-panel', //no dialog
				'#admin-panel', //structure-old
				'body' //default
			]

			var parent = null
			for (var i = 0; i < possibleParents.length; i++){
				parent = document.querySelector(possibleParents[i])
				if (parent && angular.element(parent).is(":visible")){
					return parent
				}
			}
		}
	}
})();
// GOAL: enable easy displaying of 'eventable' items, i.e. items
// which represent a user's business obligation. think
// Meetings, Event Pages, Project deadlines, etc. 
// we often want to equate all of these and display them in the same context,
// such as a calendar, yet they all have varied
// date/time/location fields in them. the goal here is to add an intermediary
// layer that converts them all into a generic "event" format so that the 
// UI doesn't have to struggle with the complexity of displaying them all, 
// and allow us to easily add support for future 'eventables' along these same lines.
(function() {
	eventableFormatter.$inject = ["ItemViewer", "toast"];
	angular.module('app').service('eventableFormatter', eventableFormatter)

	/* @ngInject */
	function eventableFormatter(ItemViewer, toast) {
		var eventableFormatter = {}
		// EXPECTS: an array of cached resources.
		// RETURNS: an array of generic "displayable events" or "eventables" which have
		// the format: 
		// {
		//	title: string,
		//	subtitle: string,
		//	start: date,
		// 	end: date,
		//	id: string (an object ID),
		//	type: string,
		//	event: object (optional, event pages only, the actual Event field from the Page)
		// }
		eventableFormatter.formatEventables = function(cachedResources) {
			return cachedResources
			.map(function(resource) {
				return _formatResource(resource)					
			})
		}

		// EXPECTS: single cached resource representing some 'eventable' item 
		// RETURNS: single generic "eventable" object, null if item was invalid.
		// to support a new type of item, just extend the switch with another case.
		function _formatResource(resource) {
			var event
			switch(resource.$key) {
				case 'Project':
					event = {
					'title': resource.Title,
					'subtitle': 'Your project ' + resource.Title + ' is planned to end on this date.',
					'start': new Date(resource.PlannedStartDate),
					'end': new Date(resource.PlannedEndDate),
					'sortByMe': new Date(resource.PlannedEndDate),
					'id': resource._id.toString(),
					'type': 'Project'
				}; break;
				case 'Task':
					event = {
					'title': resource.Title,
					'subtitle': 'Your task ' + resource.Title + ' is due on this date.',
					'start': new Date(resource.PlannedStartDate),
					'end': new Date(resource.PlannedEndDate),
					'sortByMe': new Date(resource.PlannedEndDate),					
					'id': resource._id,
					'type': 'Task'
				}; break;
				case 'Meeting':
					event = {
					'title': resource.Title,
					'subtitle': 'The meeting ' + resource.Title + ' is on this date.',
					'start': new Date(resource.StartDate),
					'end': new Date(resource.EndDate),
					'sortByMe': new Date(resource.StartDate),					
					'id': resource._id,
					'type': 'Meeting',
					'location': resource.Location
				}; break;
				case 'Page':
					event = {
					'title': resource.Title,
					'subtitle': resource.SideBarWidgets[0].Data.PageDescription,
					'start': new Date(resource.Event.Start),
					'end': new Date(resource.Event.End),
					'sortByMe': new Date(resource.Event.Start),										
					'id': resource._id.toString(),
					'type': 'Event',
					'openAs': 'Page',
					'event': resource.Event,
					'location': resource.Event.Location
				}; break;
				default:
					return null
			} // end switch

			event.getOpenableType = function() {
				return this.openAs ? this.openAs : this.type
			}.bind(event)
			
			event.open = function() {
				var item
				var collection = $injector.get(this.getOpenableType())
				if(collection) {
					item = collection.getCache({_id: this.id})[0]
				} else {
					toast.error('Unsupported event type ' + this.type)
					return;
				}
				if(item) {
					item.open('recent')
				}
			}.bind(event)

			return event
		} // end _formatResource
		return eventableFormatter
	} // end service recipe
})();
(function() {
	eventableFetcher.$inject = ["$rootScope", "$http", "$q", "Schema", "eventableFormatter"];
	angular.module('app').service('eventableFetcher', eventableFetcher)

	/* @ngInject */
	function eventableFetcher($rootScope, $http, $q, Schema, eventableFormatter) {
		var eventableFetcher = {}

		// gets ui-calendar displayable items from the server
		// these include meetings, event pages, tasks/projects 
		// with planned start dates, etc.
		eventableFetcher.getMyEvents = function(formatEvents, when) {
			return eventableFetcher.getEventsForUser($rootScope.user._id, formatEvents, when)
		}

		eventableFetcher.getEventsForUser = function(userId, formatEvents, when) {
			return $http.get('/api/eventcalendar?userid=' + userId + (when ? ('&when=' + when) : ''))
			.then(function(response) {
				// turn the eventables into a flat array of cached resources
				var eventables = _makeArray(response.data)
				// if they wanted to format the events, do it
				// if not, just return cached resources
				if(formatEvents) {
					return eventableFormatter.formatEventables(eventables)
				} else {
					return eventables
				}
			})
		}

		// converts an array of { type: string, items: [document] }
		// to a flat array of cached resources
		function _makeArray(eventableSets) {
			var eventables = []
			// for every set of eventables...
			eventableSets.forEach(function(eventableSet) {
				// convert all of its items to cached resources
				// and add them to the master array
				eventables = eventables.concat(eventableSet.items
				.map(function(item) {
					var item = new (Schema.resource(eventableSet.type))(item)

					//convert top level date strings to date objects
					for (p in item){
						if (isDate(item[p])) item[p] = new Date(item[p])
					}

					item.$Event = eventableFormatter.formatEventables([item])[0]
					return item
				}))
			})
			return eventables			
		}
		
		return eventableFetcher
	} // end service creation function
})();


(function () {
	'use strict'

	angular.module('app').provider('TaskBoardViewer', TaskBoardViewerProvider);

	function TaskBoardViewerProvider() {
		return {
			$get: function () {
			},
			createRouteFor: function ($stateProvider, options) {
				var stateUrl = '/' + options.itemType.name.toLowerCase() + '/tasks-for' + '/:id'
				var stateName = 'shell.project.reports.tasks-for-' + options.itemType.name.toLowerCase()
				$stateProvider.state(stateName, {
					views: {
						'@shell': {
							templateUrl: '/app/alignus/layouts/task-board-viewer/task-board-viewer.tmpl.html',
							controller: 'TaskBoardViewerController',
							controllerAs: 'vm'
						}
					},
					url: stateUrl,
					navigationData: {
						breadcrumbTitle: 'onEnter',
					},
					resolve: {
						/* @ngInject */					
						item: ["Schema", "$stateParams", "$q", "localCacheReady", function (Schema, $stateParams, $q, localCacheReady) {
							var promise = $q.defer()
							var item
							var resource = Schema.resource(options.itemType.name)
							//title
							var query = {}
							if ($stateParams.id.length == 24 || !resource.FindByUrlField) {
								query["_id"] = $stateParams.id
							}else{
								query[resource.FindByUrlField] = $stateParams.id.replaceAll('-', ' ')
							}

							Schema.resource(options.itemType.name).query(query).$promise.then(function(res){
								if (res.length >= 1){
									promise.resolve(res[0])
								} else {
									promise.reject('Error getting item: 44', res)
								}
							}, function(err){
								console.error('Error getting item in task board viewer provider: 48', err)
							})

							return promise.promise
						}]
					},
					/* @ngInject */
					onEnter: ["$rootScope", "$state", "$timeout", function ($rootScope, $state, $timeout) {
						//timeout needed to let $state acquire this state (it seems to not have that until AFTER onEnter runs)
						$timeout(function () {
							$state.$current.self.navigationData.breadcrumbTitle = 'Tasks for ' + $state.$current.locals.globals.item.toString()
						})
					}]
				})
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('alignus.layouts', []);
})();
(function () {
	'use strict';

		TaskBoardViewerController.$inject = ["$scope", "item"];
	angular
		.module('alignus.layouts')
		.controller('TaskBoardViewerController', TaskBoardViewerController)

		/* @ngInject */
		function TaskBoardViewerController($scope, item) {
			var vm = this
			vm.item = item
		}

})();
(function () {
	'use strict'

	angular.module('app').provider('SingleItemViewer', SingleItemViewerProvider);

	function SingleItemViewerProvider() {
		return {
			$get: function () {
				console.debug('In single item viewer provider')
			},
			createRouteFor: function ($stateProvider, options) {
				var stateUrl = '/' + options.itemType.name.toLowerCase() + '/:id'
				var stateName = 'single.' + options.itemType.name.toLowerCase()
				$stateProvider.state(stateName, {
					views: {
						'@single': {
							templateUrl: '/app/alignus/layouts/single-item-viewer/single-item-viewer.tmpl.html',
							controller: options.itemType.itemSettings.itemViewer.controller,
							controllerAs: options.itemType.itemSettings.itemViewer.controllerAs,
						}
					},
					itemTemplateUrl: options.itemType.itemSettings.itemViewer.templateUrl,
					url: stateUrl,
					navigationData: {
						breadcrumbTitle: 'onEnter',
					},
					resolve: {
						/* @ngInject */
						itemSettings: ["localCacheReady", "Schema", "$stateParams", "$q", "$rootScope", "$state", "toast", "$timeout", function (localCacheReady, Schema, $stateParams, $q, $rootScope, $state, toast, $timeout) {
							var promise = $q.defer()
							var item
							var resource = Schema.resource(options.itemType.name)
							var wait = $q.resolve(true)

							if (options.itemType.name == 'Organization') {
								wait = $q.resolve([$rootScope.Organization])
							} else {
								wait = Schema.resource(options.itemType.name).query({_id: $stateParams.id}).$httpPromise
							}

							wait.then(function (res) {
								if (res.length >= 1) {
									var item = res[0]

									//set the tab title
									window.document.title = item.toString()
									angular.element(document.body).addClass('single-item')

									//set the url (do this about 1s after load to avoid ui-routeer thrash)
									if (item.CustomUrl) {
										$timeout(function(){
											window.history.pushState(item.CustomUrl, item.CustomUrl, item.CustomUrl)
										},1000)
									}

									//set the tab icon									
									var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
									link.type = 'image/x-icon'
									link.rel = 'shortcut icon'
									link.href = '/assets/images/avatars/' + item.$key + '.png'
									document.getElementsByTagName('head')[0].appendChild(link)

									//adjust the layout so the window scrolls naturally
									angular.element('html, body, .shell').css('overflow', 'inherit')
									poll(function(){//when
										return angular.element('md-content').length
									}, function(){//then
										angular.element('md-content').css('overflow', 'inherit')
									}, angular.noop, 10000, 200)


									//close the window if deleted									
									$rootScope.$on('itemRemoved', function (event, itemRemoved) {
										if (item.$key == itemRemoved.$key && item._id == itemRemoved._id) {
											toast.toast('Access to the opened item was removed!')
											if (window.opener) {
												setTimeout(self.close, 2000)
											} else {
												$state.go('authentication.login')
											}
										}
									})

									promise.resolve({ item: item })
								} else {
									toast.error('Sorry. Your account does not have access to this item.')
									$state.go('authentication.login')
									promise.reject('Error getting item: 44', res)
								}
							}, function (err) {
								console.error('Error getting item in single-item-viewer: 48', err)
							})

							return promise.promise
						}]
					},
					/* @ngInject */
					onEnter: ["$rootScope", "$state", "$timeout", function ($rootScope, $state, $timeout) {
						//timeout needed to let $state acquire this state (it seems to not have that until AFTER onEnter runs)
						$timeout(function () {
							$state.$current.self.navigationData.breadcrumbTitle = $state.$current.locals.globals.itemSettings.item.toString()
						})
					}]
				})
			}
		}
	}
})();
(function () {
	'use strict';

    SelectFilterController.$inject = ["$http", "$scope", "$rootScope", "$timeout", "$interval", "$window", "$state", "$mdDialog", "auUtility", "filterValues"];
    angular.module('app').provider('SelectFilter', SelectFilterProvider);

	angular.module('alignus.layouts')
		.controller('SelectFilterController', SelectFilterController);

	/* @ngInject */
	function SelectFilterController($http, $scope, $rootScope, $timeout, $interval, $window, $state, $mdDialog, auUtility, filterValues) {
		var vm = this;

		//fade in the contents scrolled up
		var el = angular.element('.select-filter md-content')
		auUtility.initPageScrolledDown(el)

		vm.filterValues = filterValues

		//because ui-router does not re-run controllers that have already been loaded, we watch the stateChangeSuccess event and pull needed data off the current state
		$scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
			if (toState.navigationData) attachDataToView()
		})
		function attachDataToView(){
			//expose settings to the view
			vm.landingSettings = $state.$current.landingSettings
			vm.sectionSettings = $state.$current.data.sectionSettings

			//expose the navigation as cards to the view
			vm.filter = $state.$current.navigationData.menuItems
		}
    }

    function SelectFilterProvider() {
		return {
			/* @ngInject */
			$get: function () {
				console.debug('in SelectFilterProvider')
			},
			createRoutes: function ($stateProvider, options) {
				//enforce the url equals the dot notation route name
				var url = options.name.split('.').last()

				//ROUTE 1 - GET THE DATA FOR A LIST
				$stateProvider.state(options.name, {
					url: '/' + url ,

					views: {
						'@shell':{
							templateUrl: '/app/alignus/layouts/select-filter/select-filter.tmpl.html',
							controller: 'SelectFilterController',
							controllerAs: 'vm',
						}
					},

					navigationData: {
						breadcrumbTitle: options.title,
						subTitle: options.subTitle,
						menuItems: {get function(){
							//find the current state by name
							var currentState = $state.get(options.name)

							//get the resolved data for the state
							var currentResolved = $state.$current.path.filter(function (s) { return s.name == options.name })[0].locals.globals

							//reassign the propery to an array of items rather than this getter and return the array
							return currentState.navigationData.menuItems = currentResolved.filterValues.map(options.breadcrumbItemMap)
						}},

					},

					data: {
						fabButtons: options.fabButtons,
						fabIcon:  options.fabIcon || 'zmdi zmdi-plus',
					},

					//enforce naming convention of values
					resolve: {
						filterValues: options.values
					},
					onEnter: options.onEnter
				})
			}
		}//end of return
	}//end of function
})();
(function () {
	'use strict'

	ReportViewerController.$inject = ["$scope", "$filter", "listItems", "ListViewer", "$timeout", "$interval", "$element"];
	angular
		.module('alignus.layouts')
		.controller('ReportViewerController', ReportViewerController)

	/* @ngInject */
	function ReportViewerController($scope, $filter, listItems, ListViewer, $timeout, $interval, $element) {
		var list = this
		
		//turn this into a ListViewer
		ListViewer.create(list, listItems, $scope)

		var lastContents = 0
		var delay = 10
		function ensureGroupsFillScreen(){
			$timeout(function(){
				var rowHeight = angular.element('.report-viewer tr').height()
				var contents = rowHeight * angular.element('.report-viewer tr').filter(':visible').length - 1
				var container = angular.element('.report-viewer tbody.md-body').height()
				if (contents > container || contents == lastContents){
					//do nothing
				} else {
					delay += 10
					ensureGroupsFillScreen()
				}
				lastContents = contents
				list.loadNextGroup()
			}, delay)			
		}

		//keep the body hidden until we have the headers to ensure proper column sizing
		poll(function(){//when
			return $element.find('.th-inner').length > 0
		}, function(){//then
			$scope.$apply(function(){
				list.showReportBody = true
				$scope.$$postDigest(function(){
					$scope.$broadcast('adjust-column-headers')
				})
			})
		}, angular.noop, 100 * 1000, 100)

		//fill screen on first load
		$timeout(function(){
			ensureGroupsFillScreen()
		}, delay)

		//fill screen on re-sorts
		$scope.$on('list.list-grouped', ensureGroupsFillScreen)

		//this array is what the md.data.table binds the row's checkbox to
		list.reportItemsSelected = [];

		//pass the sort order up to the ListViewer
		$scope.sortCol = function(col){
			list.sortBy(col)
		}

		//expand/collapse a set of rows
		list.toggleGroup = function(groupId){
			var groupHeader = angular.element('tr.report-group-header[data-group-id="' + groupId + '"]')[0]
			var display = ""
			var icon = "zmdi-minus-square"

			if (groupHeader.attributes.expanded.value == ""){
				display = "none"
				icon = "zmdi-plus-square"
			}

			angular.element('tr.report-group-header[data-group-id="' + groupId + '"] i').attr("class", "zmdi " + icon)
			angular.element('tr:not(.report-group-header)[data-group-id="' + groupId + '"]').css("display",display)
			groupHeader.attributes.expanded.value = display

			ensureGroupsFillScreen()
		}

		//tell the item viewer this row is selected
		list.rowSelected = function (item, $event) {
			if ($event && !$event.ctrlKey) {
				for (var i = 0; i < listItems.length; i++){
					delete listItems[i].$selected
				}
			}

			item.$selected = true
			list.itemSelected()

			//update the array that md-data-table uses to render the checkboxes
			list.reportItemsSelected = list.getSelected()
		}
		
		//tell the item viewer this row is not selected
		list.rowDeselected = function(item) {
			item.$selected = false
			list.itemSelected()
		}

		//when the one-search emits, "select-all", set the md.data.table's model to whatever is selected
		$scope.$on('select-all',function($event, isSelected){
			list.reportItemsSelected = $filter('filter')(list.listItems, {$selected : true})
		})

		//tell the scroll table to redraw column headers when data changes
		$scope.$on('list.listItems-changed', function(){
			$scope.$broadcast('adjust-column-headers')
		})
	}
})();
// NOTE (m): i am aware of the existence of console.debug; however,
// console.debugs from this file have never worked for me (for some reason)
(function () {
	'use strict';
	videoCallsController.$inject = ["$scope", "$rootScope", "$element", "videoStream", "$timeout", "$mdDialog", "auUtility", "videoCall", "toast", "ActivityLog", "$log", "$q"];
	angular
		.module('app')
		.controller('SidebarTabVideoCallController', videoCallsController)

	/* @ngInject */
	function videoCallsController($scope, $rootScope, $element, videoStream, $timeout, $mdDialog, auUtility, videoCall, toast, ActivityLog, $log, $q) {
		DialogController.$inject = ["$scope", "$mdDialog", "devices", "speakers", "mics", "selectedDevice", "selectedSpeakers"];
		var vm = this
		$rootScope.videoCallController = vm
		vm.numberPeers = 0
		vm.peerSize = 250
		// vm.callInDialog : string

		// list of available video devices
		vm.deviceList = []

		// get missed calls and display as needed
		ActivityLog.GetMissedCallInvite().then(function(missedInvite) {
			if(missedInvite) {
				handleCallInvite(missedInvite)
			}
		})

		// handle video-related items being created
		$scope.$on('itemAdded', function(event, item) {
			// if this is an invite to a call (and this user didn't send the invite) handle it
			if(item.$key == 'ActivityLog' && item.Type == 'VideoUserInvited' && item.Data.Invited == $rootScope.user._id && item.User != $rootScope.user._id) {
				handleCallInvite(item)
			}
		})

		vm.muteSelf = function() {
			// workaround for bug wherein Chrome does not honor "muted" attribute in markup
			poll(function() { // when
				return document.getElementById('my-video')
			}, function() { // then
				// programmatically set "muted" attribute
				document.getElementById('my-video').muted = true
			}, angular.noop, 30000, 500)
		}

		// workaround for bug wherein Chrome does not honor "muted" attribute in markup
		vm.muteSelf()

		// handle an invite to either a video preview or a video call
		function handleCallInvite(invite) {
			if(vm.callInDialog) return;
			
			// tell controller that the dialog is open
			vm.callInDialog = invite.Data.CallId

			// need to assign/reference this later
			var preview

			// asyncPoll(promiseGen, checkPromiseResults, timeout, interval).then()...
			asyncPoll(function() {
				var proms = []
				// find the record for the call itself
				proms.push(ActivityLog.query({_id: invite.Data.CallId}).$httpPromise)
				// find the record for that call's preview
				if(!invite.Data.NoPreview) {
					proms.push(ActivityLog.query({Type: 'VideoPreview', 'Data.CallId': invite.Data.CallId}).$httpPromise)			
				}

				return $q.all(proms)
			}, function(results) {
				var calls = results[0]
				var previews = results[1]
				// if we didn't get the main call record, we need to poll again
				if(!calls || !calls[0]) return false;
				// if we needed a preview call record and didn't get it, we need to poll again
				if(!invite.Data.NoPreview && (!previews || !previews[0])) return false;
				// we got all the call data we need
				return true
			}, 15 * 1000, 2000).then(function(results) {
				// bind these to local vars since the references are pretty confusing
				var callLog = results[0][0]
				if(!invite.Data.NoPreview) {
					var previewLog = results[1][0]
				}

				if(callLog.Data.OnCall.length == 0) throw new Error('Cannot join an empty call')

				if(invite.Data.NoPreview) {
					return showDialog({
						callLog: callLog,
						callWaiting: vm.activeCall,
						invite: invite,
						previewStream: undefined,
						previewNoVideo: true
					}).finally(function() {
						vm.callInDialog = undefined
					})
				}

				// join the preview call
				return videoCall.join({ callLog: previewLog, videoQuality: 'videoNone', beginNoAudio: true }).then(function(previewCall) {
					// store a reference to this; we'll need to leave it to free resources
					// if an error occurs later in the chain
					preview = previewCall
					// reasoning behind time limit:
					// user A calls user B
					// user A refreshes; now nobody is in a position to negotiate with User B when they try to join the preview
					// this promise will hang forever if we don't impose some kind of time limit, which is pretty unacceptable
					return auUtility.timeLimitPromise(previewCall.getStreamByUserId(invite.User), 15*1000, { rejectWith: new Error('Could not connect to the call preview') })					
				}).then(function(previewStream) {
					// show the dialog
					return showDialog({
						callLog: callLog,
						callWaiting: vm.activeCall,
						invite: invite,
						previewStream: previewStream,
						previewNoVideo: invite.Data.NoPreview ? true : videoCall.calls[previewLog._id].peers[invite.User].streamObject.audioOnly
					})
				})
			}).catch(function(error) {
				console.error('Error opening video dialog', error)
				if(preview) preview.leaveCall()
			}).finally(function() {
				vm.callInDialog = undefined				
			})
		}


		function showDialog(options) {
			return $mdDialog.show({
				controller: 'IncomingVideoCallController',
				controllerAs: 'vm',
				templateUrl: '/app/alignus/services/videocall/incoming-video-call.tmpl.html',
				targetEvent: null,
				locals: {
					options: options
				}
			}).finally(function() {
				vm.callInDialog = undefined				
			}) 
		}

		// wrapper function; our vm needs to watch the results of an Object.keys() invocation
		vm.objectKeys = function(object) {
			if(!object) return []
			else return Object.keys(object)
		}

		vm.startNewChat = function (options) {
			// hard limit: you can't be in two calls at once
			if(vm.activeCall) {
				vm.activeCall.leaveCall()
			}
			// if no option was passed, simply make a new video call with default video quality
			if(!options) options = {'videoQuality': 'videoLow'}
			// open the video calling tab of the notifications panel
			$rootScope.notificationsPanelPinned = true
			auUtility.toggleNotificationsTab('zmdi-videocam')
			// if they passed an already-instantiated call, we can just display it in the sidebar UI
			if(options.call) {
				vm.activeCall = options.call
				vm.callGuid = options.call.callGuid
			} else {
				// otherwise, we need to join the call...
				videoCall.join(options)
				.then(function(call) {
					// ...THEN display it in the sidebar UI.
					vm.activeCall = call
					vm.callGuid = call.callGuid
				}).catch(function(error) {
					var errorHtml = 'An error occurred while joining or creating a video call: <b>' + error.name + '</b><br/><br/>'
					// respond to specific "known" errors (the error names are pretty self-explanatory. google's also pretty good)
					switch(error.name) {
						case 'DevicesNotFoundError':
							errorHtml += 'Could not find a valid video device.'
							break;
						case 'PermissionDeniedError':
							errorHtml += 'AlignUs does not have permission to access your camera! Please change this browser setting to enable video calling.'
							break;
						case 'TrackStartError':
							errorHtml += 'This error usually means that your camera itself is not working.'
					}
					// show the name of the error in the dialog -- should aid remote debugging efforts in the future
					$mdDialog.show($mdDialog.alert({
						title: 'Oops!',
						htmlContent: errorHtml,
						ok: 'Got it'
					}))
					// log the error
					$log.error('VideoCallError', error)					
				})
			}
		}

		// display the "select video device" dialog
		vm.showSettings = function ($event) {
			$mdDialog.show({
				template: '<div class="md-padding">' +
							'<div layout="row" layout-align="start center">'+
								'<div>Camera:</div>' +
								'<md-select flex ng-model="selectedDevice" placeholder="Select video device"> ' +
									'<md-option ng-repeat="device in devices" ng-value="device.deviceId">{{device.label}}</md-option>' +
								'</md-select>' +
							'</div>' +
							'<div layout="row" layout-align="start center">'+
								'<div>Microphone:</div>' +
								'<md-select flex ng-model="selectedMic" placeholder="Select microphone"> ' +
									'<md-option ng-repeat="mic in mics" ng-value="mic.deviceId">{{mic.label}}</md-option>' +
								'</md-select>' +
							'</div>' +
							'<div layout="row" layout-align="start center">'+
								'<div>Speakers:</div>' +
								'<md-select flex ng-model="selectedSpeakers" placeholder="Select speakers"> ' +
									'<md-option ng-repeat="device in speakers" ng-value="device.deviceId">{{device.label}}</md-option>' +
								'</md-select>' +
							'</div>' +
							'<md-button ng-click="closeDialog()">Save Settings</md-button>' +
						'</div>',
				locals: {
					devices: vm.cameraList,
					mics: vm.micList,
					speakers: vm.speakerList,
					selectedDevice: vm.activeDevice,
					selectedSpeakers: vm.activeSpeakers
				},
				controller: DialogController,
				parent: angular.element(document.body),
				targetEvent: $event,
				clickOutsideToClose: true
			})
		}

		/* @ngInject */
		function DialogController($scope, $mdDialog, devices, speakers, mics, selectedDevice, selectedSpeakers) {
			// bind options
			$scope.devices = devices
			$scope.mics = mics
			$scope.speakers = speakers
			$scope.selectedDevice = selectedDevice
			$scope.selectedSpeakers = selectedSpeakers
			$scope.closeDialog = function () {
				// if they selected a new video device or mic, reinitializing the stream is necessary
				if($scope.selectedDevice != vm.activeDevice || $scope.selectedMic != vm.activeMic) setNewDevice($scope.selectedDevice, $scope.selectedMic)
				// if they selected new speakers, we don't need to do anything w/the stream, just use those as audio output
				if($scope.selectedSpeakers != vm.activeSpeakers) setNewSpeakers($scope.selectedSpeakers)
				// kill dialog window
				$mdDialog.hide()
			}
		}

		function setNewDevice(newDeviceId) {
			vm.activeDevice = newDeviceId
			// kill existing stream
			vm.activeCall.userStream.getTracks().forEach(function (track) {
				track.stop()
			})
			// change stream to use new device
			videoStream.get({videoType: 'videoLow', videoDeviceId: newDeviceId})
			.then(function(stream) {
				vm.activeCall.setStream(stream);
			}).catch(function(error) {
				toast.error('Could not stream video using the selected device')
			})
		}

		function setNewSpeakers(newSpeakersId) {
			vm.activeSpeakers = newSpeakersId

			var videos = angular.element('video')
			// for every video peer, set their respective video element to use the new speakers
			angular.element.each(videos, function(index, videoEl) {
				videoEl.setSinkId(newSpeakersId).catch(function(error) {
					$log.error('VideoCallError', 'Couldn\'t set speakers')				
				})
			})
		}

		vm.addUser = function ($event) {
			auUtility.selectUsers('Add Users To Video Call', Object.keys(vm.activeCall.peers).concat([$rootScope.user._id]), true).then(function (users) {
				vm.activeCall.inviteUsers(users)
				window.ga('send', {
					hitType: 'event',
					eventCategory: 'VideoCalling',
					eventAction: 'VideoInviteSent',
					eventLabel: 'FromUiElementTabAddUser'
				})
			})
		}

		vm.hangup = function () {
			if(vm.activeCall) vm.activeCall.leaveCall();
			delete vm.activeCall
			vm.numberPeers = 0
			vm.micOff = false
		}

		$rootScope.$on('accept-video-chat', function (event, options) {
			vm.startNewChat(options)
		})

		vm.myEmoji = ""
		vm.showSelectEmoji = function($event){
			//move the selectEmoji div to the document when ready
			var el = angular.element('.my-emoji-options')
			angular.element(document.body).append(el)

			$event.stopPropagation()
			$event.preventDefault()

			el.fadeIn()
			angular.element(document.body).on('click.selectVideoEmoji', function(){
				el.fadeOut()
				angular.element(document.body).off('click.selectVideoEmoji')
			})
		}

		vm.selectEmoji = function(emoji) {
			vm.activeCall.setEmoji(emoji)
		}

		vm.joinLastCall = function() {
			if(!Object.byString($rootScope.user, 'MySettings.LastVideoCall')) return;
			ActivityLog
				.getCache({ _id: $rootScope.user.MySettings.LastVideoCall })
				.$httpPromise
				.then(function(items) {
					vm.hangup()
					vm.startNewChat({ callLog: items[0] })
				})
		}

		// enumerate media devices and categorize them by device type
		// for later use by the controller
		function populateDeviceLists() {
			return navigator.mediaDevices.enumerateDevices()
				.then(function (deviceList) {
					// store available camera devices
					vm.cameraList = deviceList.filter(function (device) {
						return device.kind == 'videoinput'
					})
					// store available mics
					vm.micList = deviceList.filter(function (device) {
						return device.kind == 'audioinput'
					})
					// store available speakers
					vm.speakerList = deviceList.filter(function (device) {
						return device.kind == 'audiooutput'
					})
				})
		}

		populateDeviceLists()

		// watch the number of peers and alter video sizes as appropriate
		var peerMargin = 10
		$scope.$watch('vm.objectKeys(vm.activeCall.peers).length', debounce(updatePeerSize, 100))
		$scope.$on('window-resized', updatePeerSize)

		function updatePeerSize() {
			if(!Object.byString(vm, 'activeCall.peers')) return
			vm.numberPeers = Object.keys(vm.activeCall.peers).length
			if (vm.numberPeers == 0) return			

			poll(function () {//when
				//md-tabs converts the original element to a comment so find from the parent
				if (!$scope.$$phase && !$rootScope.$$phase) $scope.$digest()
				return $element.parent().find('.peers').length > 0
			}, function () {//then
			    
				var el = $element.parent().find('.peers')

				if (el.height() < 0) return

				var keepGoing = true, columns = 1
				do {

					var peersInColumn = vm.numberPeers
					
					if (columns == 1) {
						vm.peerSize = ((el.height() - 30 - (peerMargin * 2 * vm.numberPeers)) / vm.numberPeers)
						if (vm.peerSize > 250) {
							vm.peerSize = 250 //el.width() - (peerMargin * 2)
						}
						if (vm.peerSize < (el.width() - 40 - (peerMargin * 2)) / ( columns + 1 ) ) {
							vm.peerSize = (el.width() - 40 - (peerMargin * 2)) / (columns + 1 )
							peersInColumn = parseInt(vm.numberPeers / (columns+1) )
							if (vm.numberPeers % 2 == 1) {
								peersInColumn++
							}
						}
					} else {
						vm.peerSize = (el.width() - 40 - (peerMargin * 2)) / columns

						peersInColumn = parseInt(vm.numberPeers / columns)
						if (vm.numberPeers % 2 == 1) {
							peersInColumn++
						}
					}

					//when all the peers can fit in the columns provided, keepGoing:false, otherwise, see if another column helps
					if (peersInColumn * ((peerMargin * 2) + vm.peerSize) <= (el.height() - 30)) {
						keepGoing = false
					} else {
						columns++
					}

					//if we get to a single row, keepGoing:false and make all the peers fit in the single row
					if (columns >= vm.numberPeers) {
						keepGoing = false
						vm.peerSize = ((el.width() - 40 - (peerMargin * 2 * vm.numberPeers)) / vm.numberPeers)
					}
				} while (keepGoing)

				vm.whoisFontSize = Math.min(16, vm.peerSize * .1)

				//if the code ran during a debounce or poll, digest
				if (!$scope.$$phase && !$rootScope.$$phase) $scope.$digest()

			}, angular.noop, 30000, 1000)
		}
	}
})();
(function () {
    'use strict'

    SidebarTabHelpController.$inject = ["$rootScope", "$mdSidenav", "$scope", "auTour", "$state", "$interval", "$http", "$window", "toast", "auUtility", "socket", "manageUsers", "User"];
    angular
        .module('alignus.layouts')
        .controller('SidebarTabHelpController', SidebarTabHelpController);

    /* @ngInject */
    function SidebarTabHelpController($rootScope, $mdSidenav, $scope, auTour, $state, $interval, $http, $window, toast, auUtility, socket, manageUsers, User) {
        var vm = this
        // vm.chartDays = []
        // vm.chartLabels = []
        // vm.task = Task
        vm.toggleSideNav = auUtility.toggleSideNav
        vm.disableSwitch = false

        if (manageUsers.getSelectableUsers().length < 2) {
            vm.disableSwitch = true
        }

        vm.initiateTourForCurrentState = function (tour) {
            $mdSidenav('notifications').close()
            auTour.initiateForCurrentState()
        }

        vm.goToUserPage = function (id) {
            $state.go('shell.social.page', { id: id })
        }

        vm.goToGettingStarted = function () {
            $state.go('shell.getting-started')
            $mdSidenav('notifications').close()
        }

        vm.openUserSettings = function () {
            User.getCache({ _id: $rootScope.user._id })[0].open()
        }

        vm.openLoginTab = function () {
            $window.open('/login?uls=true', '_blank')
        }

        vm.openSelectAccount = function () {
            $window.open('/select?uls=true', '_blank')
        }

        vm.logout = function () {
            // remove this user from the list of selectable users in local storage
            manageUsers.removeSelectableUser($rootScope.user._id)

            // post to logout
            $http.post("/api/user/Logout", {})

            // remove localStorage authToken
            sessionStorage.removeItem('authToken')
            localStorage.removeItem('authToken') //cya
            localStorage.removeItem('authToken' + $rootScope.user.Organization)

            $window.authToken = ''

            // close socket connection
            try {
                $rootScope.noAutoReconnect = true
                socket.getSocket().close()
            } catch (e) { }

            // redirect to login screen now that logout process is complete
            $state.go('authentication.login')
        }
    }
})();
(function () {
    SidebarTabConversationsController.$inject = ["$scope", "$rootScope", "$filter", "auUtility", "User", "toast", "chats", "Conversation", "Question", "ItemViewer", "Post", "Page"];
    angular
        .module('alignus.layouts')
        .controller('SidebarTabConversationsController', SidebarTabConversationsController)

    /* @ngInject */
    function SidebarTabConversationsController($scope, $rootScope, $filter, auUtility, User, toast, chats, Conversation, Question, ItemViewer, Post, Page) {
        var vm = this

        vm.auUtility = auUtility
        vm.conversationTop = 0

        vm.showConversations = Conversation.conversations

        vm.openChat = function (item) {
            if (item.$key == 'User') {
                //todo- needs validation - the DB doesn't enforce having only only 1:1 conversation with another user so something should
                Conversation.NewConversation([item._id], '##1:1##')
                    .then(function (newConversation) {
                        chats.openChat(newConversation)
                        Conversation.updateConversations()
                    })
            } else if (item.$key == 'Page') {
                chats.openChat(item, true)
            } else if (item.$key == 'Question') {
                item.open()
            }

            $rootScope.rightSideNavIsOpen = false
        }

        vm.dismiss = function ($event, item) {
            var idx1 = idx2 = sortedIdx = -1

            //get the id of the next item in the ng-repeat
            var sortedConversations = $filter('orderBy')(vm.showConversations, ['-$searchScore', '-LastPostDate', 'toString()'])
            for (var i = 0; i < sortedConversations.length; i++) {
                if (sortedConversations[i]._id == item._id) {
                    sortedIdx = i
                    break;
                }
            }
            var nextId = -1
            if (sortedIdx > -1 && sortedIdx + 1 < sortedConversations.length) {
                nextId = sortedConversations[sortedIdx + 1]._id
            }

            //get the idx of the dismissed item in showConversations
            for (var i = 0; i < vm.showConversations.length; i++) {
                if (vm.showConversations[i]._id == item._id) {
                    idx1 = i
                    break;
                }
            }

            //remove the dismissed conversation from the bound array
            if (idx1 > -1) {
                vm.showConversations.splice(idx1, 1)
            }

            //show the quickbuttons on the next post so the user doesn't have to jiggle the mouse
            if (nextId != -1) for (var i = 0; i < vm.showConversations.length; i++) {
                if (vm.showConversations[i]._id == nextId) {
                    idx2 = i
                    break;
                }
            }
            if (idx2 > -1) {
                vm.showConversations[idx2].$showQuickButtons = true
            }

            item.Dismiss()
        }

        vm.undismiss = function ($event, item) {
            item.Undismiss()
            delete item.$IsDismissed
            toast.success('Conversation moved back to Inbox')
        }

        vm.newConversationFull = Conversation.NewConversationFull

        //show the selectEmoji div adjacent to the button on each convo
        vm.myEmoji = ""
        vm.showSelectEmoji = function ($event, conversation) {
            var el
            poll(function () {//when
                el = angular.element('.send-emoji-options.' + conversation._id)
                return el.length
            }, function () {//then
                //move the selectEmoji div to the document when ready
                angular.element(document.body).append(el)

                //position the top
                el.css("top", $event.originalEvent.pageY - 27)
                el.fadeIn()

                angular.element(document.body).on('click.selectMessageEmoji', function () {
                    el.fadeOut()
                    angular.element(document.body).off('click.selectMessageEmoji')
                })

            }, angular.noop)

            $event.stopPropagation()
            $event.preventDefault()
        }

        vm.sendEmoji = function (emoji, item) {
            //mark page as read
            item.MarkPostsRead()
            
            // make new Post on page
            return new Post({
                Page: item._id,
                PageType: item.Type,
                PageIsEmbedded: item.IsEmbedded,
                Creator: $rootScope.user._id,
                Type: 'Update',
                Data: {
                    Update: '<span style=\"font-size: 28px\">' + emoji + '</span>'
                },
            }).$saveItem()
        }

        var addDimissed = debounce(function () {
            var pageMap = vm.showConversations.map(function(page){
                    return page._id
            })

            //add dismissed items by title
            Page.query({ DismissedFor: $rootScope.user._id, Title__regex: "/{0}/i".format(vm.searchInput) }).$httpPromise.then(function (res) {
                for (var i = 0; i < res.length; i++) {
                    var item = res[i]

                    //skip pages already found
                    if (pageMap.indexOf(item._id) > -1) continue

                    item.$searchScore = 5
                    if (item.Title.startsWith(vm.searchInput)) {
                        item.$searchScore += 10
                    }
                    item.$IsDismissed = true

                    vm.showConversations.push(item)
                }
            })
        }, 300)


        vm.getItemsMatchingSearch = function () {
            //clear results
            if (vm.searchInput.trim() == "") {
                Conversation.conversations.forEach(function (item) {
                    item.$searchScore = -1
                })
                vm.showConversations = Conversation.conversations
            } else {
                vm.showConversations = Page.getCache(function (item) {
                    item.$searchScore = -1
                    if (!Conversation.isConversiblePage(item, 0, [item], true)) return false

                    if (item.DismissedFor && item.DismissedFor.indexOf($rootScope.user._id) > -1) item.$IsDismissed = true
                    
                    if (item.toString().contains(vm.searchInput)) {
                        item.$searchScore += 10

                        if (item.Title == '##1:1##' || item.$key == 'User') {
                            item.$searchScore += 5
                        }
                    }
                    if (item.toString().startsWith(vm.searchInput)) {
                        item.$searchScore += 10
                    }
                    if (item.LastPostText && item.LastPostText.contains(vm.searchInput)) {
                        item.$searchScore += 5
                    }
                    item.Members.forEach(function(member_id){
                        var user = User.getCache({_id: member_id})[0]

                        if (user.FirstName.contains(vm.searchInput) || user.LastName.contains(vm.searchInput)){
                            item.$searchScore += 5
                        }
                    })


                    if (item.$searchScore > -1) return true
                }, false)

                if (vm.searchInput.length > 2) addDimissed()
            }

            vm.conversationTop = 0
        }


    }
})();
(function() {
	'use strict';
		fromTemplateConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(fromTemplateConfig)

		/* @ngInject */
		function fromTemplateConfig($stateProvider) {
			$stateProvider.state('single.newfromtemplate', {
				url: '/newfromtemplate/:itemtype',
				templateUrl: '/app/alignus/layouts/new-from-template/new-from-template.tmpl.html',
				controller: 'NewFromTemplateController',
				controllerAs: 'vm',
				params: {
					itemtype: ''
				},
				resolve: {
					/* @ngInject */
					templates: ["localCacheReady", "$stateParams", "Schema", function(localCacheReady, $stateParams, Schema) {
						var itemType = $stateParams.itemtype.charAt(0).toUpperCase() + $stateParams.itemtype.slice(1)						
						return Schema.resource(itemType).query({ IsGlobalTemplate: true }) // returns all collection items that are either global templates or IsTemplate for this org
					}],
					itemType: ["localCacheReady", "$stateParams", function(localCacheReady, $stateParams) {
						return $stateParams.itemtype.charAt(0).toUpperCase() + $stateParams.itemtype.slice(1)
					}]
				}
			})
		}
})();
(function() {
	'use strict';
		newFromTemplateController.$inject = ["$stateParams", "$scope", "templates", "itemType"];
	angular
		.module('app')
		.controller('NewFromTemplateController', newFromTemplateController)

		/* @ngInject */
		function newFromTemplateController($stateParams, $scope, templates, itemType) {
			var vm = this
			vm.templates = templates
			vm.itemType = itemType
			angular.element(document.body).addClass('single-item')

			$scope.closeWindow = function () {
				window.close()
			}

			vm.cacheBuster = parseInt(Math.random() * 10000000000)
		}
})();
(function () {
	'use strict';

	ListItemViewerController.$inject = ["$scope", "$element", "$rootScope", "$state", "$mdMedia", "ListViewer", "listItems", "$timeout", "$interval"];
	angular
		.module('alignus.layouts')
		.controller('ListItemViewerController', ListItemViewerController);

	/* @ngInject */
	function ListItemViewerController($scope, $element, $rootScope, $state, $mdMedia, ListViewer, listItems, $timeout, $interval) {
		//ensure "this" is present inside functions and create common naming convention between view and controller
		var list = this

		//hook typical list functionality to this controller
		ListViewer.create(list, listItems, $scope)

		var lastContents = 0
		var delay = 10, loadTimes = 0
		function ensureGroupsFillScreen() {
			console.debug('ensureGroupsFillScreen')
			delay += 10
			loadTimes++
			$timeout(function () {
				var contents = angular.element('.ps-container > div').height()
				var container = angular.element('.ps-container').height()
				if (contents > container || loadTimes > 5 || (contents == lastContents && contents > 500)) {
					//do nothing
				} else {
					ensureGroupsFillScreen()
				}
				lastContents = contents
				list.loadNextGroup()
			}, delay)
		}

		//fill screen on first load
		$timeout(function () {
			ensureGroupsFillScreen()
		}, delay)

		//fill screen on re-sorts
		$scope.$on('list.list-grouped', function () { delay = 10; loadTimes = 0; ensureGroupsFillScreen() })

		//expose empty state settings to the view
		list.emptyImage = $state.$current.data.itemType.listSettings.emptyImage || '/assets/images/empty-states/pickone.png'
		list.emptyTitle = $state.$current.data.itemType.listSettings.emptyTitle || 'Nothing Selected'
		list.emptyDescription = $state.$current.data.itemType.listSettings.emptyDescription || 'An item will appear here. Just pick one.'

		//handle show/hide of list on left
		function showHideList() {
			if (!Object.byString($state, "$current.locals.globals.itemSettings.item")) {
				$element.find('.list-pane').css('min-width', '66%')
			} else {
				$element.find('.list-pane').css('min-width', '')
			}
			list.showList = !(Object.byString($state, "$current.locals.globals.itemSettings.item") && $rootScope.windowWidth < 840)
		}
		$scope.$on('window-resized', showHideList)
		$scope.$on('$locationChangeSuccess', showHideList);
		showHideList();

		//this should at least detect the type, etc before refilling the screen
// 		$scope.$on('itemAdded', function (event, item) {
// 			delay = 100
// 			//ensureGroupsFillScreen()
// 		})
	}
})();

(function() {
    'use strict';

    LandingRecentGroupingsController.$inject = ["$http", "$scope", "$rootScope", "$timeout", "$interval", "$window", "$state", "$mdDialog", "ItemViewer", "windowFab", "auUtility", "$parse"];
    angular.module('app').provider('LandingRecentGroupings', LandingRecentGroupingsProvider);

    angular.module('alignus.layouts')
        .controller('LandingRecentGroupingsController', LandingRecentGroupingsController);

    /* @ngInject */
    function LandingRecentGroupingsController($http, $scope, $rootScope, $timeout, $interval, $window, $state, $mdDialog, ItemViewer, windowFab, auUtility, $parse) {
        var vm = this;

        //fade in the contents scrolled up
        var el = angular.element('.landing-recent-groupings md-content')
        auUtility.initPageScrolledDown(el)

        //expose the array of sections on a landing page {title, subtitle, menuItems}
        vm.sections = $state.$current.navigationData.sections        
        if (!$state.$current.navigationData.sections) {
            vm.sections = [
                {
                    title: $state.$current.navigationData.breadcrumbTitle, 
                    subTitle: $state.$current.navigationData.subTitle, 
                    permissionNeeded: $state.$current.navigationData.permissionNeeded, 
                    menuItems: $state.$current.navigationData.menuItems
                }
            ]
        } else {
            //spool all menuItems into a list
            $state.$current.navigationData.menuItems = []
            vm.sections.forEach(function(section){
                $state.$current.navigationData.menuItems.push({sectionHeader: section.title, isSectionHeader: true})
                $state.$current.navigationData.menuItems = $state.$current.navigationData.menuItems.concat(section.menuItems)
            })
        }

        //expose settings to the view
        vm.landingSettings = $state.$current.landingSettings
        vm.sectionSettings = $state.$current.data.sectionSettings

        //replace {{org}} in the subTitle
        vm.sections.forEach(function(section){
            section.subTitle = section.subTitle.replaceAll("{{org}}", $rootScope.Organization.Name)
            
            section.menuItems.forEach(function(card, index) {
                card.title = card.title.replaceAll("{{org}}", $rootScope.Organization.Name)
                card.subtitle = card.subtitle.replaceAll("{{org}}", $rootScope.Organization.Name)
            })
        })

        //in case there was an error with an item, and it can't unload it's fab buttons, force the item fab buttons to nothing when a landing page is navigated to						
        $rootScope.fabButtons = []
        $rootScope.fabIcon = []
        windowFab.setFlipped(false)
        windowFab.setTooltip('Add something new!')
        windowFab.mode = "normal"
        
        vm.cardGo = function(card, $event) {;
            if (card.sref) {
                $state.go(card.sref, card.srefOpts)
                return
            }
            if (card.action) {
                card.action($event)
                return
            }
            if (card.cardFab && card.cardFab[0]) {
                vm.handleMiniFabClick(card.cardFab[0])
            }
        }

        vm.handleMiniFabClick = function handleMiniFabClick(option, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            if (option.sref) {
                $state.go(option.sref, option.srefOpts);
            } else if (option.action) {
                option.action($event);
            }
        }

        vm.openRecentItemDialog = function(item) {
            item.item.open('recent')
        }

        vm.openDialog = function openDialog(dialogName, dashName, $event, locals) {
            $timeout(function() {
                $mdDialog.show({
                    controller: dialogName + 'Controller',
                    controllerAs: 'vm',
                    templateUrl: '/app/structure/' + dashName + '/dialog.tmpl.html',
                    targetEvent: $event,
                    locals: locals
                });
            }, 600)
        }

        $scope.trackByIdAndType = function(item) {
            return item.item._id + '|' + item.itemType.name
        }
    }

    function LandingRecentGroupingsProvider() {
        return {
            /* @ngInject */
            $get: function() {
                console.debug('in LandingRecentGrouping')
            },
            createRoutes: function($stateProvider, options) {
                //enforce the url equals the dot notation route name
                var url = options.name.split('.').last()

                //build the data object here to prevent assigning unassigned values
                var data = {}
                if (options.fabButtons !== undefined) data.fabButtons = options.fabButtons
                if (options.fabIcon) data.fabIcon = options.fabIcon
                if (options.sectionSettings) data.sectionSettings = options.sectionSettings
                if (!options.cardClass) options.cardClass = 'sub-menu-card'

                $stateProvider.state(options.name, {
                    url: '/' + url,

                    views: {
                        '@shell': {
                            templateUrl: '/app/alignus/layouts/landing-recent-groupings/landing.tmpl.html',
                            controller: 'LandingRecentGroupingsController',
                            controllerAs: 'vm',
                        }
                    },

                    data: data,

                    navigationData: {
                        breadcrumbTitle: options.title,
                        subTitle: options.subTitle,
                        menuItems: options.menuItems,
                        sections: options.sections
                    },

                    landingSettings: {
                        cardClass: options.cardClass
                    },

                    resolve: options.resolve,

                    onEnter: options.onEnter
                })
            },
            goToOptimalView: function(routeName) {
                return function() {
                    if ($rootScope.windowWidth > 960) {
                        $state.go(routeName, {view: 'report'})
                    } else {
                        $state.go(routeName)
                    }
                }
            }
        } //end of return
    } //end of function
})();
(function () {
	'use strict';

		KanbanBoardViewerController.$inject = ["$scope", "$state", "$filter", "listItems", "ListViewer"];
	angular
		.module('alignus.layouts')
		.controller('KanbanBoardViewerController', KanbanBoardViewerController)

		/* @ngInject */
		function KanbanBoardViewerController($scope, $state, $filter, listItems, ListViewer) {
			var list = this
			//turn this into an list viewer
			if($state.current.params.view == 'task-kanban') {
				list.initialState = 'KanbanBoard'
			} else if($state.current.params.initialView == '') {
				list.initialState = 'UserBoard'
			}
			ListViewer.create(list, listItems, $scope)
		}
})();
(function () {
	'use strict';

	ConnectionsViewerController.$inject = ["$scope", "$mdDialog", "ListViewer", "listItems"];
	angular
		.module('alignus.layouts')
		.controller('ConnectionsViewerController', ConnectionsViewerController);

	/* @ngInject */
	function ConnectionsViewerController($scope, $mdDialog, ListViewer, listItems) {
		var list = this
		
		//turn this into an list viewer
		ListViewer.create(list, listItems, $scope)
	}
})();
(function() {
    'use strict'

    ComingSoonController.$inject = ["$scope", "$state"];
    angular
        .module('alignus.layouts')
        .controller('ComingSoonController', ComingSoonController)

    /* @ngInject */
    function ComingSoonController($scope, $state) {
        var vm = this
        vm.sectionSettings = $state.$current.data.sectionSettings
    }
})();
(function() {
	'use strict'

	CardViewerController.$inject = ["$scope", "$filter", "listItems", "ListViewer"];
	angular
		.module('alignus.layouts')
		.controller('CardViewerController', CardViewerController)

	/* @ngInject */
	function CardViewerController($scope, $filter, listItems, ListViewer) {
		var list = this

		//turn this into an list viewer
		ListViewer.create(list, listItems, $scope)
	}
})();
(function() {
	'use strict';

	RecentItemsController.$inject = ["$scope", "$rootScope", "$state", "ItemViewer", "$mdDialog", "Schema"];
	angular
		.module('app')
		.controller('RecentItemsController', RecentItemsController);

	/* @ngInject */
	function RecentItemsController($scope, $rootScope, $state, ItemViewer, $mdDialog, Schema) {
		var ri = this;

		$scope.$on('itemRemoved', function($event, item) {
			$rootScope.user.untrackRecentItem(item)
		})

		//track the item and open it
		$scope.$on('openNewItem', function(event, item) {
			item.open()
		})
	}
})();
(function() {
    'use strict'
    
    NotificationsPanelController.$inject = ["$scope", "$timeout"];
    angular
        .module('alignus.layouts')
        .controller('NotificationsPanelController', NotificationsPanelController)

    /* @ngInject */
    function NotificationsPanelController($scope, $timeout) {
        var vm = this;
        $rootScope.notificationsPanelPinned = false
        vm.shownTabs = { }

        // add an event to switch tabs (used when user clicks a menu item before sidebar opens)
        $scope.$on('toolbarSwitchNotificationTab', function ($event, tab) {
            if (tab == parseInt(tab))
                vm.currentTab = tab
            else {
                var tabs = angular.element('.md-sidenav-right md-tab-item md-icon')
                for (var i = 0; i < tabs.length; i++) {
                    if (tabs[i].classList.contains(tab)) {
                        vm.currentTab = i
                        break
                    }
                }    
            }
        })

        $scope.$watch('vm.currentTab', function (newVal, oldVal) {
            if (newVal === undefined) return

            var tabs = angular.element('.md-sidenav-right md-tab-item')
            var tab = tabs[newVal].children[0]
            var tabIcon
            
            for (var i = 0; i < tab.classList.length; i++) {
                if (tab.classList[i].startsWith('zmdi-')) {
                    tabIcon = tab.classList[i]
                    break
                }
            }

            $timeout(function () {
                vm.shownTabs[tabIcon] = true
            }, 500)
        })

        this.pinSidebar = function() {
            $rootScope.notificationsPanelPinned = !$rootScope.notificationsPanelPinned
            if (!$rootScope.notificationsPanelPinned)
                $rootScope.rightSideNavIsOpen = false
        }
    }
})();
'use strict';

/**
 * @ngdoc function
 * @name AdminController
 * @module triAngular
 * @kind function
 *
 * @description
 *
 * Handles the admin view
 */
(function () {
    'use strict';

    ShellLayoutController.$inject = ["$scope", "$element", "$rootScope", "$compile", "$mdMedia", "$mdDialog", "toast", "$timeout", "$state", "$mdSidenav", "$mdUtil", "$window", "$filter", "$stateParams", "$q", "$location", "$interval", "$sce", "auUtility", "ItemViewer", "Schema", "Document", "Task", "oneSearch", "auTour", "tourJSON", "windowFab", "chats", "Conversation", "myTaskTracker", "socket", "Authorization", "User", "Page", "Post", "Organization", "emojiFullscreen"];
    angular
        .module('alignus.layouts')
        .controller('ShellLayoutController', ShellLayoutController);

    /* @ngInject */
    function ShellLayoutController($scope, $element, $rootScope, $compile, $mdMedia, $mdDialog, toast, $timeout, $state, $mdSidenav, $mdUtil, $window, $filter, $stateParams, $q, $location, $interval, $sce, auUtility, ItemViewer, Schema, Document, Task, oneSearch, auTour, tourJSON, windowFab, chats, Conversation, myTaskTracker, socket, Authorization, User, Page, Post, Organization, emojiFullscreen) {
        //do not let contacts or anonymous users into the shell
        if ($rootScope.user.IsContact || $rootScope.user.$AnonymousUser) {
            return $state.go('authentication.login')
        }

        var vm = this
        vm.auTour = auTour
        vm.emojiFullscreen = emojiFullscreen
        $rootScope.isShellPeek = $location.search().shellPeek
        $rootScope.browserTabIsActive = true
        $rootScope.myTaskTracker = myTaskTracker

        oneSearch.initNeeded = true

        function manageNavs() {
            $scope.$on('window-resized', windowResized)
            function windowResized() {
                if ($rootScope.$ingoreWindowResize) return

                $rootScope.notificationsPanelPinned = $rootScope.windowWidth >= 1600
                $rootScope.leftPanelPinned = $rootScope.windowWidth >= 2100
            }
            $rootScope.$watch('notificationsPanelPinned', function () {
                $rootScope.$ingoreWindowResize = true
                $rootScope.$broadcast('window-resized')
                $rootScope.$ingoreWindowResize = false
            })
            $timeout(windowResized, 100)

            vm.goToState = function ($index) {
                $state.go($rootScope.sideNavLinks[$index].link);
                $mdSidenav('left').close();
            }

            $rootScope.sideNavLinks = [{
                title: 'Social',
                icon: 'au-social',
                link: 'shell.social',
                enabled: true
            },
            {
                title: 'Projects',
                icon: 'au-project',
                link: 'shell.project',
                enabled: true
            },
            {
                title: 'Documents',
                icon: 'au-document',
                link: 'shell.documents',
                enabled: true
            },
            {
                title: 'Handbook',
                icon: 'au-handbook',
                link: 'shell.handbook',
                enabled: true
            },
            {
                title: 'Strategy',
                icon: 'au-strategy',
                link: 'shell.strategy',
                enabled: true
            },
            {
                title: 'Philosophy',
                icon: 'au-philosophy',
                link: 'shell.philosophy.list',
                enabled: true
            },
            {
                title: 'Structure',
                icon: 'au-structure',
                link: 'shell.structure',
                enabled: false
            },
            {
                title: 'Fundraising',
                icon: 'au-fundraiser',
                link: 'shell.fundraiser',
                enabled: false
            }]

            $rootScope.updateNavLinks = function () {
                if ($rootScope.user.EffPerms.Users.CanView || $rootScope.user.EffPerms.Teams.CanView) {
                    $rootScope.sideNavLinks[6].enabled = true
                } else {
                    $rootScope.sideNavLinks[6].enabled = false
                }

                if ($rootScope.Organization.Settings.Fundraising.Enabled) {
                    $rootScope.sideNavLinks[7].enabled = true
                } else {
                    $rootScope.sideNavLinks[7].enabled = false
                }
            }

            $rootScope.updateNavLinks()
        }

        //decorate the body tag w/ shell peek for css
        if ($rootScope.isShellPeek) {
            angular.element('body').addClass('isShellPeek')
            $timeout(function () {
                //set the title
                window.document.title = $state.current.navigationData.breadcrumbTitle
            }, 1000)
        } else {
            manageNavs()
        }

        //set the title to the org's name
        window.document.originalTitle = window.document.title = $rootScope.Organization.Name + ' - Align Us'

        function manageToolbar() {
            //todo - examine what needs this in shell / shell$scope
            vm.chats = chats
            $scope.Conversation = Conversation

            vm.toggleSideNav = auUtility.toggleSideNav;
            vm.toggleNotificationsTab = auUtility.toggleNotificationsTab;
            vm.username = $rootScope.user.firstname

            //update the breadcrumbs on every state change
            $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                populateBreadcrumbs()
                $rootScope.itemIsOpen = $state.$current.locals.globals.itemSettings && !!$state.$current.locals.globals.itemSettings.item
            })

            $scope.$on('window-resized', function (event, args) {
                populateBreadcrumbs(true)
            })

            function populateBreadcrumbs(fromResize) {
                //find all paths of the current state where the hideBreadcrumb property is not true
                vm.breadcrumbs = $filter('filter')($state.$current.path, { navigationData: { hideBreadcrumb: '!true' } })
                if ($rootScope.isShellPeek && !fromResize) {
                    window.top.$rootScope.peekTitle = vm.breadcrumbs.last().self.navigationData.breadcrumbTitle
                    window.top.$rootScope.peekOpenNewTabUrl = $location.url().replace('shellPeek=1', '')
                }

                var el = angular.element('#breadcrumb-container')
                if (el.length == 0) return //before the page loads

                //give each breadcrumb equal width, ensuring each is over 150px, dropping left crumbs while their width is less than 150px
                //the css drops the right-most one if it can't fit ensure the user can always go "back" via the breadcrumbs
                var adjustWidth = false
                do {
                    var width = el.width()
                    var crumbCnt = vm.breadcrumbs.length
                    var subtractMargin = crumbCnt * 50
                    width = width - subtractMargin
                    var maxWidth = parseInt(width / crumbCnt)
                    if (maxWidth < 150 && crumbCnt > 2) {
                        adjustWidth = true
                        vm.breadcrumbs.shift()
                    } else {
                        adjustWidth = false
                        if (maxWidth < 150) maxWidth = 150
                        vm.crumbMaxWidth = maxWidth
                    }
                } while (adjustWidth)


                //animate the opacity of the caret
                $timeout(function () {
                    angular.forEach(angular.element(".breadcrumb-container .breadcrumb-menu-icon"), function (el) {
                        el.style.opacity = "1"
                    })
                }, 10, false)

            }
            $scope.go = function (item) {
                if (item.sref) {
                    $state.go(item.sref, item.srefOpts)
                    return
                }
                if (item.action) {
                    item.action()
                    return
                }
            }

            //browser reloads take a bit to get the breadcrumbs right -- third times the charm!
            $interval(populateBreadcrumbs, 1000, 3)

            //browsers prevent tabs in the background from starting to play a sound so play some silence when the shell loads                
            $element.one('click', function () {
                var audio = new Audio('/assets/sounds/silence.mp3');
                audio.play()
            })

            /////////////////////////////////////////////
            ///   Show Send Menu dialogs
            /////////////////////////////////////////////

            //Compose Message
            $rootScope.composeMessage = function (options) {
                $mdDialog.show({
                    controller: 'NewPrivateMessageController',
                    controllerAs: 'vm',
                    templateUrl: '/app/social/dialogs/new-private-message.tmpl.html',
                    locals: {
                        options: options || {}
                    }
                })
            }

            //Send High Five
            $rootScope.sendHighFive = function (options) {
                $mdDialog.show({
                    controller: 'NewHighFiveController',
                    controllerAs: 'vm',
                    templateUrl: '/app/alignus/layouts/_shell/dialogs/high-five-dialog.tmpl.html',
                    locals: {
                        options: options || {}
                    }
                })
            }

            //Post to Page
            $rootScope.postToPage = function (options) {
                $mdDialog.show({
                    controller: 'PostToPageController',
                    controllerAs: 'vm',
                    templateUrl: '/app/alignus/layouts/_shell/dialogs/post-to-page.tmpl.html',
                    locals: {
                        options: options || {}
                    }
                })
            }

            //Ask Question
            $rootScope.askQuestion = function (options) {
                $mdDialog.show({
                    controller: 'AskQuestionDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/social/questions/dialogs/ask-question.tmpl.html',
                    locals: {
                        options: options || {}
                    }
                })
            }

            //Request Approval
            $rootScope.requestApproval = function (options) {
                $mdDialog.show({
                    controller: 'RequestApprovalDialog',
                    controllerAs: 'vm',
                    templateUrl: 'app/alignus/directives/au-workflows/dialogs/request-approval.tmpl.html',
                    locals: {
                        options: options || {}
                    }
                })
            }

            ///////////////////////////////////////////////////
            // watch for the mytasks to open and broadcast events - good to decouple the mytasks directive from the UI
            // and needed because the suspendWhen stops a watch inside the directive from firing until its not suspended
            ///////////////////////////////////////////////////
            $scope.$watch('myTasksIsOpen', function (isOpen, wasOpen) {
                if (isOpen) {
                    $rootScope.$broadcast('my-tasks-make-visible')
                }
            })

            vm.chatReadUpToHere = function (conversationPage) {
                new Post({
                    Creator: $rootScope.user._id,
                    Type: 'Update',
                    Data: {
                        Update: '<p>------ Read Up To Here ------</p>',
                        AutoPost: true
                    },
                    Page: $rootScope.user.NotificationPage,
                    PageType: 'Conversation',
                    PageIsEmbedded: false
                }).$saveItem()
            }
        }
        manageToolbar()

        ////////////////////////////////////////////////////////////////////
        //    LOAD SHELL
        ////////////////////////////////////////////////////////////////////

        function updateConversations() {
            Conversation.updateConversations()
        }

        $scope.$on('updateConversations', updateConversations)

        if ($location.search().open) {
            var open = $location.search().open.split(':')
            if (!open.length == 2) return new Error('invalid open')

            var collection = open[0]
            var id = open[1]

            var item = Schema.resource(collection).getCache({ _id: id })[0]
            item.open()

            //clear the QS
            $location.search('open', null)
        }

        $timeout(function () {
            $rootScope.showMainContent = true
        }, 2000)

        $timeout(function () {
            updateConversations()
        }, 3500)

        $timeout(function () {
            $rootScope.showRecentItems = true
        }, 4000)

        //when chat windows are min/maximized we want to scroll up by 1 to potentially load more posts
        vm.scroll1 = function (idx) {
            setTimeout(function () {
                var st = angular.element('#ChatContent' + idx).scrollTop()
                angular.element('#ChatContent' + idx).scrollTop(st - 1)
            }, 1000)
        }

        ///////////////////////////////////////////////////////////////////////
        // DESKTOP NOTIFICATIONS
        ///////////////////////////////////////////////////////////////////////

        //todo- when a user has multiple browser tabs open, the user gets multiple notifications - use this technique
        //http://stackoverflow.com/questions/28230845/communication-between-tabs-or-windows

        //ckeditor has it's own Notification class which overrides the real one... save the real one... ugh...
        try {
            window.NotificationApi = window.Notification
        } catch (e) { }

        // request permission to show desktop notifications on page load
        setTimeout(function () {
            $rootScope.showBottomChat = true

            if (window.NotificationApi.permission !== "granted")
                window.NotificationApi.requestPermission();
        }, 5000)

        //keep track of browser tab active state
        angular.element(window).on("blur focus", function (e) {
            var prevType = $rootScope.prevBlurFocusType

            if (prevType != e.type) {   //  reduce double fire issues
                switch (e.type) {
                    case "blur":
                        $rootScope.browserTabIsActive = false
                        break;
                    case "focus":
                        $rootScope.browserTabIsActive = true
                        auUtility.endFlashTitle()
                        break;
                }
            }

            $rootScope.prevBlurFocusType = e.type
        })

        //set up desktop notifications
        var lastOnlineState = {}
        var allUsers = User.getCache({}, false)
        allUsers.forEach(function (user) {
            lastOnlineState[user._id] = { IsOnline: user.IsOnline }
        })

        socket.on('user-online', function (user_id, isOnline) {
            if (!window.localCacheReady) return

            console.log('got user-online', user_id, isOnline)

            if (!lastOnlineState[user_id]) lastOnlineState[user_id] = { IsOnline: false };

            //debounce so window refreshes don't cause the message to appear
            clearTimeout(lastOnlineState[user_id].timeout)
            lastOnlineState[user_id].timeout = setTimeout(function () {
                //update the client cache
                var user = User.getCache({ _id: user_id })[0]
                user.IsOnline = isOnline

                if (lastOnlineState[user_id].IsOnline != user.IsOnline) {
                    //skip the current user - they are always online
                    if (user_id == $rootScope.user._id) return;

                    //save the last state
                    lastOnlineState[user_id].IsOnline = user.IsOnline

                    //create and show the notification
                    var notification = new window.NotificationApi(user.toString() + ' is ' + (user.IsOnline ? 'online' : 'offline'), {
                        icon: (user.Photo ? auUtility.s3UrlFromId(user.Photo) : "/assets/images/walkthrough/al.png"),
                        body: moment().format('LT'),
                    });

                    notification.onclick = function () {
                        window.focus()
                    };

                    setTimeout(function () {
                        notification.close()
                    }, 3000)
                }
            }, 15 * 1000)
        })

        //////////////////////////////////////////////////////////////////////////////////
        //  FRESKDESK
        //////////////////////////////////////////////////////////////////////////////////
        $timeout(function () {
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.js";

            s.onload = function () {
                FreshWidget.init("", { "queryString": "&widgetType=popup&helpdesk_ticket[requester]=" + $rootScope.user.Email + "&helpdesk_ticket[subject]=Align+Us+Feedback&formTitle=Feedback&submitThanks=Your+feedback+is+important+to+us+and+will+help+us+improve.+Thank+you+for+your+time!", "utf8": "✓", "widgetType": "popup", "buttonType": "text", "buttonText": "Feedback", "buttonColor": "white", "buttonBg": "#00A79D", "alignment": "4", "offset": "235000px", "submitThanks": "Your opinion is important to us and will help us improve. Thank you for your time!", "formHeight": "500px", "url": "https://alignus.freshdesk.com", "loadOnEvent": 'immediate' });
            }

            document.getElementsByTagName('head')[0].appendChild(s);

        }, 5000, false)

        // prompt the user with the Update Password dialog if they are flagged as needing to update it
        if ($rootScope.user.PasswordResetRequired) {
            $mdDialog.show({
                templateUrl: '/app/alignus/layouts/_shell/dialogs/update-your-password.tmpl.html',
                controller: 'UpdateYourPasswordDialogController',
                controllerAs: 'vm'
            })
        }

        //go to the getting started state if this is their first time
        if (!Object.byString($rootScope, '.user.Settings.Intro.SeenGettingStarted')) {
            $state.go('shell.getting-started')

            //record that they've been to the state
            if (!$rootScope.user.Settings.Intro) {
                $rootScope.user.Settings.Intro = {}
            }
            $rootScope.user.Settings.Intro.SeenGettingStarted = true

            //save to the server
            $rootScope.user.setSetting({ Intro: $rootScope.user.Settings.Intro })
        }


    }


})();
(function() {
	'use strict';

	RemoveItemDialogController.$inject = ["$scope", "$rootScope", "$state", "$timeout", "$mdDialog", "$q", "selectedItems", "showConfirmationSignature", "toast", "httpError"];
	angular
		.module('app')
		.controller('RemoveItemDialogController', RemoveItemDialogController);

	/* @ngInject */
	function RemoveItemDialogController($scope, $rootScope, $state, $timeout, $mdDialog, $q, selectedItems, showConfirmationSignature, toast, httpError) {
		var vm = this;

		//expose objects to the view
		vm.itemCount = angular.copy(selectedItems.length)
		vm.showConfirmationSignature = showConfirmationSignature
		vm.itemType = ''
		angular.forEach(selectedItems, function(item, index){
			if (item.$key != vm.itemType) vm.itemType = item.$key
		})

		//expose hide dialog function for close button
		vm.cancel = $mdDialog.hide

		vm.confirmRemove = function($event) {
			//ensure confirmation signature is valid
			if (vm.showConfirmationSignature) {
				if (vm.confimationSignature != $rootScope.user.FirstName + " " + $rootScope.user.LastName) {
					toast.error('Signature invalid - it must be exactly ' + $rootScope.user.FirstName + " " + $rootScope.user.LastName)
					return false
				}
			}

			vm.removeStarted = true

			//for each selectedItem, execute $removeItem and wait until all remove promises resolve/reject
			var msg = []
			var allComplete = $q.defer();
			var noError = true
			angular.forEach(selectedItems, function(item, index) {
				item.$removeItem().then(function(ok) {
					//push an OK message to display in the event other items produce errors
					msg.push("Item removed OK - " + item.toString())

					//all items have been resolved/rejected
					if (msg.length == vm.itemCount) {
						allComplete.resolve()
					}
				}, function(err) {
					//flag used to quickly determine if an error occured
					noError = false

					//report what item(s) failed and why to the user
					msg.push("Item removal error - " + item.toString() + " - " + httpError.parse(err, true))

					//all items have been resolved/rejected
					if (msg.length == vm.itemCount) {
						allComplete.resolve()
					}
				})
			})


			//wait until all promises have resolved/rejected and then issue OK or error message
			allComplete.promise.then(function(ok) {

				//build error string
				var msgString = msg.join('<br />')

				//close remove dialog
				$mdDialog.hide()

				//if no error, show a success toast, else, show the report of which items failed and succedded
				if (noError) {
					setTimeout(function() {
						toast.success('Successfully removed ' + vm.itemCount + ' item' + (vm.itemCount > 1 ? 's' : '') + '.')
					}, 1000)
				} else {
					$mdDialog.show(
						$mdDialog.alert({
							title: "Removal Report",
							htmlContent: "Please review the following messages.<br /><br />" + msgString,
							ok: "Close"
						}))
				}
			})

		}
	}
})();
(function () {
	'use strict';

	AddItemController.$inject = ["$scope", "$rootScope", "$state", "$stateParams", "$timeout", "$mdDialog", "$q", "$filter", "$http", "toast", "auUtility", "httpError", "itemType", "init", "steps", "Upload", "Schema"];
	angular
		.module('app')
		.controller('AddItemController', AddItemController);

	/* @ngInject */
	function AddItemController($scope, $rootScope, $state, $stateParams, $timeout, $mdDialog, $q, $filter, $http, toast, auUtility, httpError, itemType, init, steps, Upload, Schema) {
		var vm = this;

		vm.itemType = itemType
		vm.currentStep = "intro"
		vm.currentStepIndex = 0
		vm.steps = steps
		vm.stepOrder = ["intro", "typeOrUpload", "type", "review", "complete"]

		//find additional steps and inject them between upload and review (position 4)
		vm.extraSteps = []
		var extraStep = 0
		for (var prop in steps) {
			if (vm.stepOrder.indexOf(prop) == -1) {
				//push the template into the extraSteps array
				vm.extraSteps.push(vm.steps[prop])

				//push the extraStep into the stepOrder at position 3
				vm.stepOrder.splice(3 + extraStep, 0, "extra" + extraStep)

				//increment counter
				extraStep++
			}
		}

		//if we don't have a upload step, remove the choice
		if (!vm.steps.typeOrUpload.upload) {
			vm.stepOrder.splice(1, 1)
		} else {
			//else, toggle the "type" step to "upload" if the user selects to upload
			$scope.$watch('vm.typeOrUpload', function (newVal, oldVal) {
				vm.stepOrder[2] = newVal
			})
		}
		
		vm.typeOrUpload = "type"
		vm.typeFields = []
		
		var ItemConstructor = Schema.resource(itemType.name)
		vm.newItem = new ItemConstructor()
		vm.itemFields = Schema.for(itemType.name).fields

		//review details appear in the order the fields are added so add type in fields here
		for (var i = 0; i < vm.steps.typeOrUpload.type.fields.length; i++) {
			vm.newItem[vm.steps.typeOrUpload.type.fields[i]] = ""
		}

		//call init code if preset
		if (init) init(vm, Schema)

		//push field definitions in from field names
		angular.forEach(vm.steps.typeOrUpload.type.fields, function (field) {
			vm.typeFields.push($filter('filter')(vm.itemFields, { name: field })[0])
		})

		vm.nextStep = function () {
			vm.currentStepIndex++
			vm.currentStep = vm.stepOrder[vm.currentStepIndex]
		}

		vm.prevStep = function () {
			vm.currentStepIndex--
			vm.currentStep = vm.stepOrder[vm.currentStepIndex]

			//reset state variables
			detailCache = null
			vm.finishError = null
			firstFieldFocused = false
			vm.reviewError = null
		}

		var firstFieldFocused = false
		vm.getStepBg = function () {
			switch (vm.currentStep) {
				case "intro":
					return 'url(' + (vm.steps.intro.image || '/assets/images/dialogs/add.png') + ')'
				case "typeOrUpload":
					return 'url(/assets/images/dialogs/addbg.png)'
				case "type":
					return 'url(/assets/images/dialogs/typebg.png)'
				case "upload":
					return 'url(/assets/images/dialogs/uploadbg.png)'
				case "review":
					return 'url(/assets/images/dialogs/confirm.png)'
				case "complete":
					return 'url(/assets/images/dialogs/completed.png)'
				default:
					if (vm.currentStep.substr(0, 5) == "extra") {
						var index = vm.currentStep.substr(5, vm.currentStep.length)
						return 'url(' + vm.extraSteps[parseInt(index)].image + ')'
					}
			}
		}

		function getField(name) {
			return $filter('filter')(vm.itemFields, { name: name })[0]
		}

		var detailCache
		vm.reviewDetails = function () {
			if (detailCache) return detailCache
			var returnVal = []

			//ensure all fields were supplied
			if (vm.typeOrUpload == "type") {
				for (var i = 0; i < vm.steps.typeOrUpload.type.fields.length; i++) {
					if (vm.newItem[vm.steps.typeOrUpload.type.fields[i]] == "") {
						returnVal.push({ name: vm.steps.typeOrUpload.type.fields[i], value: 'Missing! Please go back and fill in this field.' })
					}
				}
			} else {
				if (!vm.file) {
					returnVal.push({ name: 'File Selected', value: 'Missing! Please go back and supply a file to upload.' })
				}
			}
			if (returnVal.length > 0) {
				vm.reviewError = true
				detailCache = returnVal
				return detailCache
			}

			if (vm.typeOrUpload == "type") {
				//iterate over properties
				returnVal.push({ name: 'Type In or Upload', value: 'Type In' })
			} else {
				//show review for upload
				returnVal.push({ name: 'Type In or Upload', value: 'Upload' })
				returnVal.push({ name: 'File Selected', value: vm.file.name })

				//remove the blank "type in" fields
				for (var i = 0; i < vm.steps.typeOrUpload.type.fields.length; i++) {
					delete vm.newItem[vm.steps.typeOrUpload.type.fields[i]]
				}
			}
			for (prop in vm.newItem) {
				if (!vm.newItem.hasOwnProperty(prop)) continue

				var field = getField(prop)
				if (!field) continue
				switch (field.type) {
					case "Array":
						var vals = vm.newItem[prop]
						var rFld = { name: field.display, value: "" }
						for (var i = 0; i < vals.length; i++) {
							if (rFld.value != "") rFld.value += ", "
							rFld.value += Object.byString(vm.newItem, field.displayValue.replace("$index", i))
						}
						if (rFld.value != "") returnVal.push(rFld)
						break
					default:
						returnVal.push({ name: field.display, value: getReviewValue(prop) })
				}
			}

			detailCache = returnVal
			return detailCache
		}

		function getReviewValue(fieldName) {
			if (vm.reviewTextTransforms && vm.reviewTextTransforms[fieldName]) {
				return vm.reviewTextTransforms[fieldName]()
			} else {
				return vm.newItem[fieldName]
			}
		}

		vm.finished = false
		vm.finish = function () {
			vm.finishing = true
			if (vm.typeOrUpload == "type") {
				vm.newItem.$saveItem().then(function (resp) {
					if (Object.byString(resp, "data.error")) {
						return handleError(resp)
					}
					//used by UI tester to know the new id					
					vm.newId = vm.newItem._id

					vm.finished = true
					vm.nextStep()
				}, function (err) {
					handleError(err)
				}).catch(function (err) {
					handleError(err)
				})
			} else {
				//submit for upload
				var reader = new FileReader();
				reader.onload = function (fileContents) {
					var postOptions = {
						csv: fileContents.target.result,
						schema: itemType.name
					}

					//attach items that, hopefully, the upload api can handle
					for (prop in vm.newItem) {
						if (!vm.newItem.hasOwnProperty(prop)) continue

						var field = getField(prop)
						if (!field) continue

						postOptions[prop] = vm.newItem[prop]
					}

					$http.post('/api/uploadCsvToDatabase', postOptions).then(function (res) {
						//res.data format: {"success":true,"kueId":"Ok7aEYIwUUWoy3mkxuM+LQ=="}
						if (res.data.success) {
							vm.finished = true
							vm.nextStep()
						} else {
							handleError(res)
						}
					}, function (err) {
						handleError(err);
					});
				}

				reader.readAsText(vm.file);
			}
		}

		function handleError(err) {
			vm.finishing = false;
			console.error(err);

			vm.finishError = "<h3>Unable to add. Please see below and try again.</h3>" + httpError.parse(err.data, true)
			vm.nextStep()
		}

		vm.close = function () {
			if (vm.finishError || vm.typeOrUpload == "upload") {
				$mdDialog.hide()
			} else {
				//must have been a successful type-in
				$mdDialog.hide(vm.newItem)
			}
		}

		vm.openItem = function () {
			$mdDialog.hide(vm.newItem)
			vm.newItem.open()
		}

		vm.cancel = function () {
			$mdDialog.hide();
			//at least during auto-tests, backdrops tend to get stuck, so clean them up
			//auUtility.cleanUpOldMdBackdrops()
		}
	}

})();
(function () {

	angular.module('app').provider('ListViewer', ListViewer);

	/* @ngInject */
	function ListViewer() {
		return {
			/* @ngInject */
			$get: ["$location", "$stateParams", "$filter", "$state", "$mdDialog", "$timeout", "$rootScope", "Schema", "ItemViewer", "moment", "oneSearch", "auUtility", function ($location, $stateParams, $filter, $state, $mdDialog, $timeout, $rootScope, Schema, ItemViewer, moment, oneSearch, auUtility) {
				this.create = function (list, listItems, $scope) {
					//input error checking
					if (!list) console.error('You must pass list')
					if (!listItems) console.error('You must pass listItems')
					if (!$scope) console.error('You must pass $scope')

					//--- init public api
					list.allSelected = false
					list.searchCriteria = ""
					list.currentItem = null
					list.sortedBy = []
					list.orderedBy = ""
					list.showGroupHeaders = $state.params.showGroupHeaders
					list.listOptions = $state.params.listOptions
					list.showInactive = false

					//expose data to the view
					list.listItems = listItems
					$scope.$on('list.updateListItems', function (event, newListItems) {
						list.listItems = listItems = newListItems
						console.debug('reassigning listItems')
						createItemGroups()
					})

					//expose the settings to the view
					list.listSettings = $state.$current.data.itemType.listSettings
					list.itemSettings = $state.$current.data.itemType.itemSettings

					//expose state settings to the view
					list.sectionSettings = $state.$current.data.sectionSettings

					//see if the itemType has itemFields already (could be a hard-coded list or from a previous run)
					list.itemFields = $state.$current.parent.self.data.itemFields
					if (!list.itemFields) {
						//get the fields from the schema
						list.itemFields = Schema.for($state.$current.data.itemType.name).fields.concat(list.itemSettings.fields || [])
						$state.$current.parent.self.data.itemFields = list.itemFields
					}

					//create the pirmaryItemFields and moreItmeFields on list
					list.primaryItemFields = []
					list.moreItemFields = []
					//separate pirmary and more fields
					list.itemFields.filter(function (field) {
						if (!field.sortable) return false
						if (field.primary) list.primaryItemFields.push(field)
						else list.moreItemFields.push(field)
					})

					//see if the route specified selectedFields (could be a hard-coded list or from a previous run)
					list.selectedFields = $state.$current.parent.self.data.selectedFields
					if (!list.selectedFields) {
						//select the primary fields
						list.selectedFields = $filter('filter')(list.itemFields, { primary: true })
						$state.$current.parent.self.data.selectedFields = list.selectedFields
					}

					//expose convenient function for UI
					var _permissionCache = []
					list.hasPermission = function (permission) {
						return auUtility.hasPermission(permission, list.getSelected())
					}

					//--- user controlled sorting
					//==================================

					//pulic api function
					list.sortBy = function (names) {

						//null out the UI value use by one-search
						list.sortedBy = []

						//ensure we are on the list view - close any current item to prevent the controller from reloading
						list.changeToView($state.$current.locals.globals.$stateParams.view)

						//reset all fields to ascending sort
// 						angular.forEach(list.itemFields, function (field) {
// 							field.sortDirection = "asc"
// 						})

						//create an array of fields
						list.groupItemsBy = getFieldsFromNames(names)

						//sort and group
						createItemGroups()
					}

					//public api function - only used by one-search
					list.sortDirection = function (direction) {
						if (direction == 'asc') {
							list.sortDirectionDesc = false //UI
						} else {
							list.sortDirectionAsc = false //UI
						}

// 						//reset all fields to ascending sort
// 						angular.forEach(list.itemFields, function (field) {
// 							field.sortDirection = "asc"
// 						})

						list.groupItemsBy[0].sortDirection = direction

						//sort and group
						createItemGroups()
					}

					//public api
					list.refresh = function () {
						createItemGroups()
					}

					//generate an array of fields from an array of field names
					function getFieldsFromNames(fieldNames) {
						var returnVal = []

						if (typeof fieldNames == "string") fieldNames = fieldNames.split("|")

						angular.forEach(fieldNames, function (fieldName) {
							//strip off leading minus sign
							var findName = fieldName.replace(/^-/, '')
							//find the field in the itemFields array
							var field = $filter('filter')(list.itemFields, { 'name': findName })[0]
							//add sortDirection to the field if the fieldName started with a minus sign
							if (fieldName.indexOf('-') == 0) field.sortDirection = "desc"
							//add the field to the list.groupItemsBy array
							returnVal.push(field)
						})

						return returnVal
					}

					function setUrlSortBy() {
						var urlSort = ""

						//generate a string from the list.groupItemsBy array
						angular.forEach(list.groupItemsBy, function (field) {
							if (field == "toString()") return //skip this one

							if (urlSort != "") urlSort += '|'
							if (field.sortDirection == 'desc') urlSort += '-'
							urlSort += field.name
						})

						//set the URL to the new value
						$location.search('sortBy', urlSort)
					}

					//--- event handlers
					//==========================================
					$scope.$on('itemUpdated', function (event, item) {
						var found = false
						//find the existing item by the item's _id
						for (var i = 0; i < list.listItems.length; i++) {
							if (list.listItems[i]._id == item._id && list.listItems[i].$key == item.$key) {
								found = true

								//merge new values in - essentially a no-op if the item came from cache but needed in the event of server reconnects
								auUtility.processItemUpdate(item, list.listItems[i])

								// NOTE: THIS IS NOT A GOOD OR UNIVERSAL FIX.
								// the core problem is that using $filter to match currentQuery
								// is no longer always appropriate as our queries now contain $or,
								// $elemMatch, and other mongoables that $filter is clueless about,
								// so things are getting removed from listViewer for no reason
								if (!Object.byString(listItems, 'currentQuery.$or')) {
									//remove the item if they are no longer in the current query						
									var itemMatchesQuery = $filter('filter')([item], listItems.currentQuery)
									if (itemMatchesQuery.length != 1) {
										list.listItems.splice(i, 1)
									}
								}

								//causing flicker when another user updates an item in my list
								//createItemGroups()								

								break
							}
						}

						// basically only for user uploads - remove if it causes any problems and update user documentation instead
						if (!found && Object.byString(Schema.for(item.$key), ".clientCachePolicy.useApiSecurity")) {
							addItem(event, item)
						}

					})


					//add to the listItems when a new item is added
					$scope.$on('itemAdded', addItem)
					function addItem(event, item) {
						if (item.$key != $state.$current.data.itemType.name) return

						var itemMatchesQuery = auUtility.filter([item], listItems.currentQuery || {})
						var itemInList = (list.listItems.filter(function (listItem) {
							return listItem._id == item._id
						}).length != 0)

						if (itemMatchesQuery.length == 1 && !itemInList) {
							listItems.push(item) //so other views see it
							list.listItems.push(item) //so the current view sees it
							createItemGroups()
						}
					}

					//remove from the listItems array
					$scope.$on('itemRemoved', function ($event, item) {
						//clear all selected items
						list.markAllAs(false)

						//remove the item from the view - find the existing item by the item's _id
						for (var i = 0; i < list.listItems.length; i++) {
							if (list.listItems[i]._id == item._id) {

								//remove the item from the input array
								list.listItems.splice(i, 1)

								//remove the item from the item group if we have it (from this list-viewer)
								if (item.$groupIndex) {
									list.itemGroups[item.$groupIndex].items.splice(item.$itemIndex, 1)
								} else {
									//else, this is probably from another client, so just regroup
									createItemGroups()
								}


								//close the item if the selected item was deleted
								if (item._id == $stateParams.itemID) {
									$state.go('^')
								}
								break
							}
						}

						//remove the item from the resolved data
						for (var i = 0; i < listItems.length; i++) {
							if (listItems[i]._id == item._id) {
								listItems.splice(i, 1)
							}
						}
					})

					$scope.$on('closeItem', function (event, item) {
						if (item._id == $stateParams.itemID) {
							$state.go('^')
						}
					})

					// list.markGroupAs = function(groupIndex, selected) {
					$scope.$on('groupSelected', function (event, groupIndex, selected) {
						list.markGroupAs(groupIndex, selected)
					})

					//--- grouping
					//==================================
					list.groupItemsBy = []

					//group the detail list by alpha
					var createItemGroups = debounce(function () {
						console.info('Creating item groups.')
						console.time('Creating item groups took')

						//start with an empty set of groups
						list.itemGroups = []

						//if the UI hasn't specified a sort field, check the state
						if (list.groupItemsBy.length == 0) {
							list.groupItemsBy = getFieldsFromNames($stateParams.sortBy)
						}

						//update the api value (only supports sorting by one field now - only used by md.data.table)
						list.orderedBy = (list.groupItemsBy[0].sortDirection == "desc" ? "-" : "") + list.groupItemsBy[0].name

						//update the Url
						setUrlSortBy()

						//update the one-search UI (and get the orderByFields string, too)
						var groupMethod = ""
						list.orderByFields = list.groupItemsBy.map(function (field) {
							//update UI collection (they all have to be true/false)
							list.sortedBy[field.name] = true

							if (groupMethod == "") {
								groupMethod = field.groupMethod
							}

							//sort by the displayValue rather than the field so we're not sorting by object id if the field's displayValue is something other than the field's value
							var returnVal = field.displayValue

							if (field.sortDirection == "desc") {
								returnVal = "-" + returnVal
								list.sortDirectionDesc = true //UI
								list.sortDirectionAsc = false //UI
							} else {
								list.sortDirectionAsc = true  //UI
								list.sortDirectionDesc = false
							}
							return returnVal
						})

						//after sorting by whatever is in groupItemsBy, also sort by alpha
						list.orderByFields.push('toString()')

						// 						if (!list.showGroupHeaders) groupMethod = "off"

						//sort the items
						list.listItems = $filter('orderBy')(listItems, list.orderByFields)

						//create the groupings based on the groupMethod
						var currentGroup, groupId = 0, itemIndex = 0, groupField = list.groupItemsBy[0], emptyGroup = { groupHeader: groupField.display + ' is empty', groupId: -1, items: [] }
						angular.forEach(list.listItems, function (item) {
							item.$matchesSearch = false
							if (itemMatchesSearch(item)) {
								item.$matchesSearch = true
								//determine the group header by the group method
								var groupHeader = "", isEmpty = false
								switch (Object.byString(item, groupField.displayValue)) {
									case undefined:
									case null:
									case 0:
									case "":
										isEmpty = true
								}
								if (!list.showGroupHeaders || isEmpty) {
									emptyGroup.items.push(item)
								} else {
									var val = Object.byString(item, groupField.displayValue)
									switch (groupMethod) {
										case "off":
											groupHeader = "Sorted By " + groupField.display
											break;
										case "value":
											groupHeader = groupField.display + ': ' + val
											break;
										case "date":
											groupHeader = groupField.display + ' ' + moment(val).format('MM/DD/YYYY')
											break;
										default: //alpha (first letter)
											try {
												groupHeader = groupField.display + ' starts with ' + (val).toUpperCase()[0]
											} catch (e) {
												groupHeader = "?"
											}
									}

									//create the group if needed
									if ($filter('filter')(list.itemGroups, { groupHeader: groupHeader }).length == 0) {
										currentGroup = { groupHeader: groupHeader, groupId: groupId, items: [] }
										list.itemGroups.push(currentGroup)
										groupId++
										itemIndex = 0
									}

									//push the current item into the current group
									currentGroup.items.push(item)

									//put pointers on the item in case it gets updated, these will be needed by the update handler so it can update the group array
									item.$groupIndex = groupId - 1
									item.$itemIndex = itemIndex

									itemIndex++
								}
							}
						})

						//put blank/empty items at the end
						list.itemGroups.push(emptyGroup)

						angular.forEach(emptyGroup.items, function (item, itemIndex) {
							item.$groupIndex = groupId
							item.$itemIndex = itemIndex
						})

						//the UI renders Loaded item groups, so update those
						initLoadedItemGroups()
						loadNextGroup()

						$rootScope.$broadcast('list.list-grouped')

						console.timeEnd('Creating item groups took')
					}, 100)

					//regroup when the http response comes back - the orderBy filter strips the $httpPromise so handle this before creating item groups
					if (listItems.$httpPromise) {
						listItems.$httpPromise.then(function (serverData) {
							createItemGroups();
						})
					}

					//immediately create the groupings
					createItemGroups();

					//--- inifinite scroll support
					//==================================
					function initLoadedItemGroups() {
						list.loadedItemGroups = []
						list.loadedGroupIndex = -1
					}

					//declared as function so it's "pulled up" and ready inside the first time we group
					function loadNextGroup() {
						if (list.loadedGroupIndex === undefined) return

						if (list.itemGroups[list.loadedGroupIndex + 1]) {
							list.loadedItemGroups.push(list.itemGroups[list.loadedGroupIndex + 1])
							list.loadedGroupIndex++

							//some ListViewers need to redraw UI elements such as column headers when more data is displayed
							$rootScope.$broadcast('list.listItems-changed')
						}

						if (!$rootScope.$$phase) $rootScope.$digest()
					}
					list.loadNextGroup = loadNextGroup

					//when selecting all we need to load all records
					list.loadAll = function () {
						//the loadedGroupIndex is -1 and length is +1 so subtract 2 to avoid infinite loops
						while (list.loadedGroupIndex <= list.itemGroups.length - 2) {
							list.loadNextGroup()
						}
					}

					//--- list filtering
					//==================================
					function itemMatchesSearch(item) {
						if (item.IsActive === false && !list.showInactive) return false
						if (list.searchCriteria == "") return true

						for (var i = 0; i < list.selectedFields.length; i++) {
							//if the item's field is filled in, and it's a String on the server, and the searchCriteria is in the field, return true for this item
							if (typeof item[list.selectedFields[i].name] == "string" && list.selectedFields[i].type == "String" && item[list.selectedFields[i].name].toUpperCase().indexOf(list.searchCriteria.toUpperCase()) > -1) {
								return true
							}
						}
						return false
					}

					//public api - search the list
					list.searchItems = function (search) {
						createItemGroups()
						list.loadAll()
					};

					oneSearch.hook($scope, function (searchText) {
						list.searchCriteria = searchText
						list.searchItems(searchText)
					}, 'Filtering list items')

					//--- item viewing (smartly go to the item view from the list)
					//==================================

					// store the state so we can go come back
					var baseState = $state.current.name;

					//strip .item from the inital state if it's there (occurs when loading the browser with an item in the url)
					if (baseState.endsWith('.item')) {
						baseState = baseState.replace(/.item$/, '')
					}

					list.itemClicked = function (item) {
						// if the resource specifies an on onClick action for this type of item,
						// perform that action 
						if (list.listSettings.onClicks && list.listSettings.onClicks[item.$key]) {
							list.listSettings.onClicks[item.$key](list, item)
						} else {
							// otherwise, defer to the default action (opening the item detail)
							list.openItem(item)
						}
					}

					// opens a detail
					list.openItem = function (item) {
						var gotoState = baseState + ".item"
						$state.go(gotoState, { itemID: item._id, item: item, options: list.listOptions })
					}

					//change the view parameter on the current state - deselect all items
					list.changeToView = function (view) {
						if ($state.$current.self.name.split('.').last() == 'item') {
							$state.go('^', { view: view, itemID: null, item: null })
						} else {
							$state.go('.', { view: view })
						}
					}

					function markItemSelected(item, isSelected) {
						item.$selected = isSelected
						$scope.$broadcast('item-selected', item)
					}

					//--- item selection support
					//==================================
					list.markAllAs = function (isSelected) {
						angular.forEach(list.listItems, function (item) {
							markItemSelected(item, isSelected)
						})
					}
					//ensure no items are selected (from another view)
					list.markAllAs(false)

					list.selectAllChanged = function () {
						list.loadAll()
						list.markAllAs(list.allSelected)
						list.itemSelected(true)
						$rootScope.$broadcast('select-all', list.allSelected)
					}

					list.markGroupAs = function (groupIndex, selected) {
						angular.forEach(list.itemGroups[groupIndex].items, function (item) {
							markItemSelected(item, selected)
						})
						list.itemSelected()
					}

					//use a boolean variable because we're binding this to ng-show - the function gets called multiple times a second
					list.atLeastOneSelected = false

					list.itemSelected = function (fromSelectAll) {
						//remove the cache for getSelected
						delete list._selected
						
						//rebuilds the cache
						list.atLeastOneSelected = list.getSelected().length > 0

						if (!fromSelectAll) list.allSelected = false
					}

					list.cardSelected = function ($event, item) {
						//deselect all items unless ctrl+click
						if (!$event.ctrlKey) {
							list.deselectAll()
						}

						item.$selected = !item.$selected
						list.itemSelected()

						$event.stopPropagation()
					}

					list.getSelected = function () {
						if (list._selected == undefined) {
							list._selected = $filter('filter')(list.listItems, { $selected: true })
						}
						return list._selected
					}

					list.deselectAll = function () {
						//remove the $selected property from each item
						for (var i = 0; i < list.listItems.length; i++) {
							delete list.listItems[i].$selected
						}

						list.itemSelected()
					}

					//--- item removal support
					//======================================
					list.removeItems = function (items, $event) {
						$mdDialog.show({
							controller: 'RemoveItemDialogController',
							controllerAs: 'vm',
							locals: {
								selectedItems: items,
								showConfirmationSignature: true
							},
							//bindToController: true,
							templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
							//scope: thisDialogScope,
							clickOutsideToClose: true,
							//fullscreen: useFullScreen,
							targetEvent: $event
						})
					}

					//--- download as csv support
					list.downloadAsCsv = downloadAsCsv
					function downloadAsCsv(selected, $event) {
						var rawData = [makeCsvHeader()]
						list.getSelected().forEach(function (item) {
							rawData.push(makeCsvLine(item))
						})
						exportToCsv(window.location.pathname.replaceAll('/', '-').substr(1) + ".csv", rawData)
						window.toast.success('Successfully produced a download of the selected items.')
					}

					function makeCsvHeader() {
						var csvHeader = []

						for (var i = 0; i < list.itemFields.length; i++) {
							if (isValidCsvProperty(list.itemFields[i].name)) {
								csvHeader.push(list.itemFields[i].name)
							}
						}
						return csvHeader
					}

					function makeCsvLine(item, rawData) {
						var csvLine = []

						for (var i = 0; i < list.itemFields.length; i++) {
							var field = list.itemFields[i]
							if (isValidCsvProperty(field.name)) {

								var returnVal = ""
								switch (field.type) {
									// case "Array":
									// 	if (field.displayValue){
									// 		var vals = item[field.name]
									// 		for (var y = 0; y < vals.length; y++) {
									// 			if (returnVal != "") returnVal += ", "
									// 			returnVal += Object.byString(item, field.displayValue.replace("$index", y))
									// 		}
									// 	} else {
									// 		returnVal = item[field.name].join(',')
									// 	}
									// 	break //out of switch
									default:
										var returnVal = item[field.name]
										console.debug(field.name, returnVal)
								}

								csvLine.push(returnVal)
							}
						}
						return csvLine
					}

					function isValidCsvProperty(property) {
						switch (property[0]) {
							case "$":
							case "_":
								return false;
						}
						return true
					}

					//see: http://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
					function exportToCsv(filename, rows) {
						var processRow = function (row) {
							var finalVal = '';
							for (var j = 0; j < row.length; j++) {
								var innerValue = !row[j] ? '' : row[j].toString();
								if (row[j] instanceof Date) {
									innerValue = row[j].toLocaleString();
								} else if (row[j] instanceof Array && typeof row[j][0] != 'object') {
									innerValue = row[j].toString()
								} else if (typeof (row[j]) == 'object') {
									innerValue = JSON.stringify(row[j])
								}
								var result = innerValue.replace(/"/g, '""');
								if (result.search(/("|,|\n)/g) >= 0)
									result = '"' + result + '"';
								if (j > 0)
									finalVal += ',';
								finalVal += result;
							}
							return finalVal + '\n';
						};

						var csvFile = '';
						for (var i = 0; i < rows.length; i++) {
							csvFile += processRow(rows[i]);
						}

						var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
						if (navigator.msSaveBlob) { // IE 10+
							navigator.msSaveBlob(blob, filename);
						} else {
							var link = document.createElement("a");
							if (link.download !== undefined) { // feature detection
								// Browsers that support HTML5 download attribute
								var url = URL.createObjectURL(blob);
								link.setAttribute("href", url);
								link.setAttribute("download", filename);
								link.style.visibility = 'hidden';
								document.body.appendChild(link);
								link.click();
								document.body.removeChild(link);
							}
						}
					}
				}//end of create function

				return this
			}], // end of $get function

			//create three routes - an abstract parent for data, one for the list view, and one for the item view
			createRoutes: function ($stateProvider, options) {

				//enforce the url equals the dot notation route name
				var url = options.name.split('.').last()

				var data = {
					itemType: options.itemType,
					itemFields: options.itemFields,
					selectedFields: options.selectedFields
				}
				if (options.fabButtons) data.fabButtons = options.fabButtons
				if (options.fabIcon) data.fabIcon = options.fabIcon

				//ROUTE 1 - GET THE DATA FOR A LIST
				$stateProvider.state(options.name, {
					abstract: true,
					url: '/:query',
					reloadOnSearch: false,

					data: data,

					params: {
						query: "all",
						items: null
					},

					//enforce naming convention of listItems
					resolve: {
						listItems: options.listItems
					}
				})

				//ROUTE 2 - RENDER THE LIST AS A VIEW
				$stateProvider.state(options.name + '.list', {
					url: '/' + url + '/:view?:sortBy',
					reloadOnSearch: false,

					navigationData: {
						breadcrumbTitle: options.title
					},

					params: {
						noRecords: false,
						view: options.initialView,
						sortBy: options.initialSortBy,
						showGroupHeaders: (options.showGroupHeaders == undefined ? true : options.showGroupHeaders),
						listOptions: options.listOptions
					},
					views: {
						'@shell': {
							templateUrl: function ($stateParams) {
								if ($stateParams.noRecords) {
									return '/app/alignus/layouts/ListViewer/no-records.tmpl.html'
								}
								switch ($stateParams.view.toLowerCase()) {
									case 'list':
										return '/app/alignus/layouts/list-item-viewer/list-item-viewer.tmpl.html'
									case 'cards':
										return '/app/alignus/layouts/card-viewer/card-viewer.tmpl.html'
									case 'report':
										return '/app/alignus/layouts/report-viewer/report-viewer.tmpl.html'
									case 'connections':
										return '/app/alignus/layouts/connections-viewer/connections-viewer.tmpl.html'
									case 'task-kanban':
									case 'task-user':
										return '/app/alignus/layouts/kanban-board-viewer/kanban-board-viewer.tmpl.html'
									default:
										console.error('Unknown view type', $stateParams.view)
								}
							},
							controllerProvider: ["$stateParams", function ($stateParams) {
								/* @ngInject */
								var noRecordsController = function ($scope, $state, $stateParams) {
									$scope.$on('itemAdded', reloadRoute)
									$scope.$on('itemUpdated', reloadRoute)

									function reloadRoute(event, item) {
										//re-resolve the route data
										console.info('Got item while waiting on noRecords', item, options)
										if (item.$key == options.itemType.name)
											$state.reload($state.$current.parent.name)
									}

									//check if items came in while the state was loading - before this controller started listening for itemAdded
									poll(function () {//when
										return Object.byString($state.$current.locals.globals, ".listItems.length")
									}, function () {//then
										$state.reload($state.$current.parent.name)
									}, angular.noop, 10000, 250)
								}
								noRecordsController.$inject = ["$scope", "$state", "$stateParams"];

								if ($stateParams.noRecords) return noRecordsController

								switch ($stateParams.view.toLowerCase()) {
									case 'list':
										return 'ListItemViewerController as list'
									case 'cards':
										return 'CardViewerController as list'
									case 'report':
										return 'ReportViewerController as list'
									case 'connections':
										return 'ConnectionsViewerController as list'
									case 'task-kanban':
									case 'task-user':
										return 'KanbanBoardViewerController as list'
									default:
										console.error('Unknown view type', $stateParams.view)
								}
							}]
						}
					},
					onEnter: options.onEnter,
					resolve: {
						/* @ngInject */
						noRecords: ["listItems", "$stateParams", function (listItems, $stateParams) {
							$stateParams.noRecords = false
							if (listItems.length == 0) {
								$stateParams.noRecords = true
							}
						}]
					}
				})

				//merge in what the itemViewer wants (controller, controllerProvider, etc.)
				var stateOptions = angular.merge({}, options.itemType.itemSettings.itemViewer, {
					url: '/:itemID',
					templateUrl: options.itemType.itemSettings.itemViewer.templateUrl,
					controller: options.itemType.itemSettings.itemViewer.controller,
					controllerAs: options.itemType.itemSettings.itemViewer.controllerAs,

					params: {
						itemID: "",
						item: null
					},
					navigationData: {
						breadcrumbTitle: "Item"
					},

					resolve: {
						/* @ngInject */
						itemSettings: ["$state", "$stateParams", "$filter", "listItems", function ($state, $stateParams, $filter, listItems) {
							var returnVal = options.itemType.itemSettings

							//if the user clicked an item, it's passed in as an object
							if ($stateParams.item) {
								returnVal.item = $stateParams.item
							} else {
								//else, the view was transitioned to via browser reload

								//if the itemID is blank, the url ended with a / so just go back to the list
								if ($stateParams.itemID == "") {
									$state.go(options.name + '.list')
									returnVal.item = null
								} else {
									//else, find the item by id (in the url)
									var query = options.itemType.resource.getCache({ _id: $stateParams.itemID })
									returnVal.item = query[0]
								}

								//put item in state
								$stateParams.item = returnVal.item
							}

							if (returnVal.item._placeholder) {
								query.$httpPromise.then(function () {
									updateBreadcrumb()
								})
							}
							updateBreadcrumb()
							return returnVal

							function updateBreadcrumb() {
								//update the breadcrumb
								var currentState = $state.get(options.name + '.list.item')
								currentState.navigationData.breadcrumbTitle = returnVal.item.toString()
							}
						}]
					},

					/* @ngInject */
					onEnter: ["$stateParams", "itemSettings", "ItemViewer", function ($stateParams, itemSettings, ItemViewer) {
						//for every viewer except the list-item (two pane viewer), tell ItemViewer to open the item in a dialog
						if ($stateParams.view.toLowerCase() != 'list') {
							ItemViewer.openItemDialog({
								item: itemSettings.item,
								itemType: options.itemType,
								view: 'detail'
							})
						}
					}]
				})

				$stateProvider.state(options.name + '.list.item', stateOptions)
			}

		} //end of provider return
	}
})();
(function () {

    ItemViewer.$inject = ["$timeout", "$rootScope", "$mdDialog", "$mdMedia", "$state", "$interval", "ngDialog", "toast", "$filter", "windowFab", "Schema", "auUtility"];
    angular.module('app').service('ItemViewer', ItemViewer);

    /* @ngInject */
    function ItemViewer($timeout, $rootScope, $mdDialog, $mdMedia, $state, $interval, ngDialog, toast, $filter, windowFab, Schema, auUtility) {
        var ItemViewer = this
        ItemViewer.openItems = {}
        this.create = function (itemController, itemSettings, $scope) {
            //register item with RecentItems
            $rootScope.user.trackRecentItem(itemSettings.item)

            //after angular has compiled the item's template...
            $timeout(function () {
                //show the close item fab
                windowFab.mode = "flip"
                windowFab.setTooltip('Close', true)
                windowFab.setFabToCloseItem()

            }, 1000, false)

            itemController.saveAndClose = function () {
                var dialogClosed = false
                if (itemSettings.itemDialog) {
                    itemSettings.itemDialog.$dialog.close()
                    dialogClosed = true
                }

                itemController.save().then(function (res) {
                    if ($state.$current.self.name.split('.').last() == 'item' && !(itemSettings.itemDialog && itemSettings.itemDialog.view == 'recent')) {
                        $state.go('^')
                    }
                    //if we are in a single item viewer then close the whole tab
                    if ($rootScope.singleItemViewer && !dialogClosed) window.close()
                })
            }

            //assign a backwards reference so the dialog can save when clicked out
            if (itemSettings.itemDialog) {
                itemSettings.itemDialog.saveAndClose = itemController.saveAndClose
            }

            //update the CachedResource
            itemController.save = function () {
                return itemSettings.item.$updateItem().$promise.then(function () {
                    windowFab.setFlipped(true)
                }, function (err) {
                    //pop up a red piece of toast
                    toast.error('Error! Couldn\'t save item.');
                    console.error('when updating item,', err);
                });
            }

            //expose function to flip save to the view			
            itemController.setFabToSave = windowFab.startAutoSaveProgress

            //handle item updates from other clients after server reconnects
            $scope.$on('itemUpdated', function (event, item) {
                if (itemSettings.item.$key == item.$key && itemSettings.item._id == item._id && item != itemSettings.item) {
                    auUtility.processItemUpdate(item, itemSettings.item)
                }
            })

            //set initial state of window fab
            $rootScope.changesSaved = true
            $rootScope.saveProgressValue = 0

            //override the window FAB - it will prefer the $rootScope.fabButtons over $state.data.fabButtons
            //NOTE: we have to push/shift from an array here becuase when switching from one itemviewer to another, the replaced scope is detroyed last and thus if we just set fabBattons to null we'd effectively remove the item that just loaded over me.
            if (!$rootScope.fabButtons) $rootScope.fabButtons = []
            if (!$rootScope.fabIcon) $rootScope.fabIcon = []

            if (itemSettings.fabButtons === undefined) {
                $rootScope.fabButtons.unshift([{
                    title: 'Save',
                    icon: 'zmdi zmdi-save',
                    action: itemController.save
                },
                {
                    title: 'Save and Close Item',
                    icon: 'zmdi zmdi-close',
                    action: itemController.saveAndClose
                }
                ])
                $rootScope.fabIcon.push('zmdi zmdi-save')
            } else {
                $rootScope.fabButtons.push(itemSettings.fabButtons)
                $rootScope.fabIcon.push(itemSettings.fabIcon)
            }

            //stop overriding the window FAB
            $scope.$on('$destroy', function () {
                //because the ui-view actually loads the next view before it unloads this one, we use an array.
                $rootScope.fabButtons.shift()
                $rootScope.fabIcon.shift()
                windowFab.setFlipped(false)

                //if a recent item is opened on top of a list-view item, set the windowFab to close
                if ($state.$current.self.name.split('.').last() == 'item') {
                    windowFab.setTooltip('Close')
                    windowFab.setFabToCloseItem()
                } else {
                    //otherwise, set it back to the blank state
                    windowFab.setTooltip('Add something new!')
                }
                windowFab.mode = "normal"

                //forget this item is open                
                delete ItemViewer.openItems[itemSettings.item.$key + itemSettings.item._id]
            })

            //track that this item is open            
            ItemViewer.openItems[itemSettings.item.$key + itemSettings.item._id] = true

            window.ga('send', {
                hitType: 'pageview',
                page: '/open-item/' + itemSettings.item.$key,
                title: itemSettings.item.toString()
            });
        } //end of create function

        this.openItemDialog = function (options) {
            var item = options.item

            //set values for shell
            $rootScope.recentItemOpen = true
            $rootScope.myTasksIsOpen = false

            //create a new isolate scope
            var thisDialogScope = $rootScope.$new(true)
            thisDialogScope.recentItemPointerRight = -10000

            //because we do not know the name of the controllerAs, we put these values on thisDialogScope so the dialog template can use them
            thisDialogScope.Item = options.item
            thisDialogScope.forceOnTop = options.forceOnTop
            thisDialogScope.ItemDialogTemplate = options.itemType.itemSettings.itemViewer.templateUrl
            thisDialogScope.loaded = false
            thisDialogScope.$state = $state
            //force a 100ms delay before loading the item template to let the browser show the open dialog right away and then load the template
            $timeout(function(){
                    thisDialogScope.loaded = true
            }, 100)

            //remove active class from other item dialogs
            angular.element('.item-dialog-container').removeClass('active')

            //an object we can hold on to and use for communication between the service `open` and `create`			
            var itemDialog = { view: options.view }
            $dialog = ngDialog.open({
                className: 'item-dialog-container' + (options.forceOnTop ? '.force-on-top' : ''),
                appendClassName: item.$key + item._id, 
                template: '/app/alignus/layouts/ListViewer/itemDialog.tmpl.html',
                controller: options.itemType.itemSettings.itemViewer.controller,
                controllerAs: options.itemType.itemSettings.itemViewer.controllerAs,
                resolve: {
                    //required by all item viewers
                    itemSettings: function () {
                        return { item: options.item, itemDialog: itemDialog }
                    },
                    $element: function () {
                        return angular.element('#DialogRecentItem')
                    }
                },
                scope: thisDialogScope,
                width: '100%',
                height: '100%',
                showClose: false,
                name: item.$key + item._id
            })

            angular.element('.item-dialog-container.' + item.$key + item._id).addClass('active')
            if (!$dialog) return

            // if this item is removed while this dialog is open, close this dialog
            thisDialogScope.$on('itemRemoved', function (event, item) {
                if (item.$key == options.item.$key && item._id == options.item._id) {
                    toast.toast('Access to the opened item was removed!')
                    ngDialog.close($dialog.id)
                }
            })

            thisDialogScope.$on('closeItem', function(event, item) {
                if(item.$key == options.item.$key && item._id == options.item._id) {
                    ngDialog.close($dialog.id)
                }
            })

            //assign a $dialog reference so the .create can use the $dialog
            itemDialog.$dialog = $dialog

            $dialog.closePromise.then(function () {
                $rootScope.openedRecentItem = undefined
                if ($state.$current.self.name.split('.').last() == 'item' && options.view != 'recent') {
                    $state.go('^')
                }
                if (ngDialog.getOpenDialogs().length == 0) {
                    $rootScope.recentItemOpen = false
                }
            })

            //force three digest over 1s - not exactly sure why... but sometimes the UI doesn't render otherwise
            $interval(angular.noop, 333, 3)
        }
    }
})();
// tms-selector.js
// angular directive for creating three-state toggles/switches
// primarily used for rating meetings (good, neutral, sucked)
// a modification of nz-toggle, found at https://github.com/tannerlinsley/nz-toggle
(function() {
	'use strict';

	angular
	.module('alignus.directives')
	.directive('tmsToggle', ["$timeout", function($timeout) {
					return {
							restrict: 'E',
							replace: true,
							scope: {
									config: '=?',
									ngModel: '=',
									onToggle: '&',
									disabled: '='
							},
							template: [
									'<div class="tms-toggle-wrap" ng-class="getStyle()" ng-style="wrapStyle">',
									'   <div class="tms-toggle" ng-mousedown="click($event)" ng-mousemove="move($event)">',
									'       <div class="tms-toggle-handle" style="width:45%"></div>',
									'   </div>',
									'   <div class="tms-toggle-tooltip" ng-show="tooltip">',
									'       <span ng-class="{\'active\': showTooltip1}">',
									'           <span ng-show="tipFalse"></span>{{tipFalse}}',
									'       </span>',
									'       <br ng-show="vertical">',
									'       <span ng-class="{\'active\': showTooltip2}" ng-show="triToggle">',
									'           <span ng-show="tipNull"></span>{{tipNull}}',
									'       </span>',
									'       <br ng-show="vertical">',
									'       <span ng-class="{\'active\': showTooltip3}">',
									'           <span ng-show="tipTrue"></span>{{tipTrue}}',
									'       </span>',
									'   </div>',
									'</div>',
							].join(''),
							link: function(scope, el, attrs) {

									// Helpers
									var has = angular.isDefined,
											copy = angular.copy;

									// Defaults
									var defaults = {
											vertical: false,
											valTrue: true,
											valFalse: false,
											valNull: null,
											width: 50,
											height: 25,
											padding: 3,
											colorTrue: '#F15854',
											colorFalse:'#60BD68', 
											colorNull: '#DDD',
											tooltip: false,
									};

									// VM shorthand
									var vm = scope;

									// Scope Props & Methods
									angular.extend(vm, {
											getStyle: getStyle,
											toggle: toggle,
											click: click
									});
									
									init();

									//
									//
									//

									function init() {

											parseOptions();

											if (!has(vm.ngModel)) {
													if (has(vm.valDefault)) {
															vm.ngModel = vm.valDefault;
													} else if (vm.triToggle) {
															vm.ngModel = vm.valNull;
													} else {
															vm.ngModel = vm.valFalse;
													}
											}

											var first = true;

											vm.$watch('ngModel', function() {
													update();
													if (first) {
															first = false;
															return;
													}
													if (vm.onToggle.call) {
															var res = vm.onToggle();
															if (res && res.call) {
																	res(vm.ngModel);
															}
													}
											}, true);
									}

									function parseOptions() {
											/* Extend defaults with config, allow attrs overrides */
											angular.extend(vm, defaults, vm.config || {});

											/* Tri-toggle Setting */
											if (has(attrs.triToggle)) {
													vm.triToggle = true;
											}

											// Allow attribute overrides
											angular.forEach([
													/* Values */
													'valDefault',
													'valTrue',
													'valFalse',
													'valNull',
													/* Dimensions */
													'width',
													'height',
													/* Custom Colors */
													'colorFalse',
													'colorNull',
													'colorTrue',
													/* ToolTips */
													'tipTrue',
													'tipFalse',
													'tipNull',
											], function(prop) {
													if (has(attrs[prop])) {
															vm[prop] = vm.$eval(attrs[prop]);
													}
											});

											// Has tooltips?
											if (vm.tipTrue || attrs.tipFalse || attrs.tipNull) {
													vm.tooltip = true;
											}

											if (has(attrs.vertical)) {
													vm.vertical = true;

													var temp;

													if (vm.tooltip) {
															temp = vm.tipTrue;
															vm.tipTrue = vm.tipFalse;
															vm.tipFalse = temp;
													}

													if ((!vm.$eval(attrs.width) && !vm.$eval(attrs.width)) &&
															(!(vm.config && (vm.config.width || vm.config.height)))) {
															temp = vm.width;
															vm.width = vm.height;
															vm.height = temp;
													}
											}

											// Base Styles
											vm.wrapStyle = {
													width: vm.width + 'px',
													height: vm.height + 'px',
											};

											// Auto Border Radius 
											if (!has(vm.outerRadius)) {
													vm.outerRadius = Math.min(vm.width, vm.height) / 2;
											}
											vm.innerRadius = vm.outerRadius - vm.padding;
									}

									function getStyle() {
											return [!vm.vertical ? 'horizontal' : 'vertical', vm.state];
									}

									/* Switch Position */
									function update() {

											vm.showTooltip1 = false;
											vm.showTooltip2 = false;
											vm.showTooltip3 = false;

											// Truthy
											if (angular.equals(vm.ngModel, vm.valTrue)) {
													vm.wrapStyle.backgroundColor = vm.colorTrue;
													vm.state = 'true';

													if (vm.vertical) {
															vm.showTooltip1 = true;
													} else {
															vm.showTooltip3 = true;
													}

													return;
											}

											// False
											if (angular.equals(vm.ngModel, vm.valFalse)) {
													vm.state = 'false';
													vm.wrapStyle.backgroundColor = vm.colorFalse;

													if (vm.vertical) {
															vm.showTooltip3 = true;
													} else {
															vm.showTooltip1 = true;
													}

													return;
											}

											// Must be the middle
											vm.state = 'null';
											vm.wrapStyle.backgroundColor = vm.colorNull;
											vm.showTooltip2 = true;
									}

									/* Logic */

									function toggle() {
											if (scope.disabled) {
													vm.ngModel = vm.valNull;
													return;
											}

											if (vm.state == 'false') {
													vm.ngModel = vm.triToggle ? vm.valNull : vm.valTrue;
													return;
											}

											if (vm.state == 'null') {
													vm.ngModel = vm.valTrue;
													return;
											}

											vm.ngModel = vm.valFalse;

									}
									
									function click($event) {
											if (scope.disabled)
													return;
											
											if ($event.target.className == 'tms-toggle-handle')
													return;
																									
											
											// http://stackoverflow.com/a/8943024
											var mouseX = 0, mouseY = 0;
											if ($event.offsetX == null) { // Firefox
													mouseX = $event.originalEvent.layerX;
													mouseY = $event.originalEvent.layerY;
											} else {                      // Other browsers
													mouseX = $event.offsetX;
													mouseY = $event.offsetY;
											}
											if (mouseX / el.width() < 1 / 3) {
													vm.ngModel = vm.valFalse;
											} else if (mouseX / el.width() > 2 / 3) {
													vm.ngModel = vm.valTrue;
											} else {
													vm.ngModel = vm.valNull;
											}
									}
									
									function move($event) {
											//if ($event.)
											console.log($event)
									}
									
							},
					};
			}]);
})();
(function() {
    controller.$inject = ["$scope", "$rootScope", "Task"];
    angular
        .module('alignus.directives')
        .directive('task', function() {
            return {
                templateUrl: '/app/alignus/directives/task/au-inline-task.tmpl.html',
                scope: {
                    id: '@'
                },
                controller: controller,
                controllerAs: 'vm',
                restrict: 'E'
            }
        });

    /* @ngInject */
    function controller($scope, $rootScope, Task) {
        var vm = this
        
        $scope.id = $scope.id.replace('docTask', '')
        vm.task = Task.getCache({ _id: $scope.id })[0]

        vm.openTaskFab = function($event, task) {
            //position the task Fab over the checkbox
            var offset = angular.element($event.currentTarget).offset()
            $rootScope.docTask.openFab(offset, vm.task, $event.currentTarget)
        }
    }
})();
(function () {
    'use strict';

    angular
		.module('alignus.directives')
		/**
		 * @ndgoc directive
		 * @module alignus.directives
		 * @name auSidebarWidgets
		 * @restrict AE
		 *
		 * @param {object} widget An array of widgets to display.
		 *
		 * @description
		 * Renders widgets by $compiling and .appending widget directives to a container div.
		 *
		 * @usage
		 * <div au-sidebar-widgets page="vm.page"></div>
		 *
		 * @usage
		 * <au-sidebar-widget page="{ any object that has a sidebarWidgets property }" />
		 *
		 */
		/* @ngInject */
		.directive('auSidebarWidgets', ["$rootScope", "$timeout", "$compile", "$mdDialog", function ($rootScope, $timeout, $compile, $mdDialog) {
			controller.$inject = ["$scope", "$element", "usStates"];
			return {
				scope: {
					page: '='
				},
				controller: controller,
				controllerAs: 'vm',
				templateUrl: '/app/alignus/directives/sidebarWidgets/au-sidebar-widgets.tmpl.html',
				restrict: 'AE'
			}

			/* @ngInject */
			function controller($scope, $element, usStates) {
				var vm = this
				vm.page = $scope.page
				vm.sidebarId = parseInt(Math.random() * 100)

				if (!hasAboutWidget(vm.page)) {
					vm.page.GenerateAboutWidget()
				}

				//after the sortable template renders put the widgets into their correct spot
				$scope.$watch('vm.page.SideBarWidgets.length', function(){
					$timeout(renderWidgets, 1)
				})

				function renderWidgets() {
					angular.forEach(vm.page.SideBarWidgets, function (widget, index) {
						//create html to compile
						var widgetHtml = "<div " + widget.Type + " page='vm.page' index='" + index + "' class='sidebarWidget-container'></div>"

						//append the compiled version to the directive element
						$element.find('#Widget' + index + ' .sidebarWidget-container').remove()
						$element.find('#Widget' + index).append($compile(widgetHtml)($scope))
					})
				}

				vm.dragControlListeners = {
					//stop editing when the user drags a widget
					dragStart: function (event) {
						vm.page.SideBarWidgets[event.source.index].$editing = false
					},
					dragEnd: function (event){
						vm.page.$updateItem()
						renderWidgets()
						console.debug(event)
					},
					containment: '#sidebar-widget-container' + vm.sidebarId,
					containerPositioning: 'relative'
				}

				function hasAboutWidget(page) {
					var hasWidget = false
					angular.forEach(page.SideBarWidgets, function (widget) {
						if (widget.Type == 'au-page-about') hasWidget = true
					})
					return hasWidget
				}
			}
		}]);
})();
(function () {
    'use strict';

    angular
	.module('alignus.directives')
/**
 * @ndgoc directive
 * @module alignus.directives
 * @name auPageAbout
 * @restrict AE
 *
 * @param {object} page A page to show about for.
 *
 * @description
 * Renders the about this page widget.
 *
 * @usage
 * <div au-page-about page="vm.page" data="{color: red}"></div>
 *
 */
	.directive('auPagePoll', ["$rootScope", "$timeout", function($rootScope, $timeout) {
		controller.$inject = ["$scope", "usStates", "$mdDialog", "Schema"];
		return {
			scope: {
				page: '=',
				index: '@'
			},
			controller: controller,
			controllerAs: 'vm',
			link: link,
			templateUrl: '/app/alignus/directives/sidebarWidgets/au-page-poll.tmpl.html',
			restrict: 'AE'
		}

		function link($scope, $element, $attrs, $controller) {
			console.debug('page poll widget link online')
		}

		/* @ngInject */
		function controller($scope, usStates, $mdDialog, Schema) {
			var vm = this

			//get a reference to the widget and use it rather than the index in the future as the index may change but the object ref won't
			vm.widget = $scope.widget = $scope.page.SideBarWidgets[$scope.index]
			vm.page = $scope.page

			init()

			function init(){
				vm.pollBin = []
				fillPollBin()
			}

			function fillPollBin(){
				vm.page.GetPollPosts()
				.then(function(polls){
					vm.pollBin = polls
				})
			}

			$scope.$on('postPoll' + vm.page._id, function() {
				console.debug('filling poll bin')
				fillPollBin()
			})

		}
	}]);
})();
(function () {
    'use strict';

    angular
	.module('alignus.directives')
/**
 * @ndgoc directive
 * @module alignus.directives
 * @name auPageAbout
 * @restrict AE
 *
 * @param {object} page A page to show about for.
 *
 * @description
 * Renders the about this page widget.
 *
 * @usage
 * <div au-page-about page="vm.page" data="{color: red}"></div>
 *
 */
	.directive('auPagePinnedPost', ["$rootScope", "$timeout", function($rootScope, $timeout) {
		controller.$inject = ["$scope", "$state", "$rootScope", "$mdDialog", "Schema"];
		return {
			scope: {
				page: '=',
				index: '@'
			},
			controller: controller,
			controllerAs: 'vm',
			link: link,
			templateUrl: '/app/alignus/directives/sidebarWidgets/au-page-pinned-post.tmpl.html',
			restrict: 'AE'
		}

		function link($scope, $element, $attrs, $controller) {
			console.debug('pinned post widget link online')
		}

		function controller($scope, $state, $rootScope, $mdDialog, Schema) {
			var vm = this
			
			//get a reference to the widget and use it rather than the index in the future as the index may change but the object ref won't
			vm.widget = $scope.widget = $scope.page.SideBarWidgets[$scope.index]
			vm.page = $scope.page

			init()

			function init() {
				vm.postBin = []
				fillPostBin()
			}

			function fillPostBin() {
				vm.page.GetPinnedPosts()
				.then(function(posts) {
					vm.postBin = posts
				})
			}

			$scope.$on('postPinnedOrUnpinned' + vm.page._id, function() {
				console.debug('filling post bin')
				fillPostBin()
			})

			vm.goToPost = function(post) {
				$rootScope.$broadcast('openNewItem', post)
			}

			vm.unpinPost = function(post) {
				post.IsPinned = false
				post.$updateItem()
				$rootScope.$broadcast('postPinnedOrUnpinned' + vm.page._id)
				$rootScope.$broadcast('displayPosts' + vm.page._id + '.pinnedPosts')
				$rootScope.$broadcast('displayPosts' + vm.page._id)
			}
		}
	}]);
})();
(function () {
    'use strict';

    angular
	.module('alignus.directives')

	.directive('auPageFilterPosts', ["$rootScope", "$timeout", "Post", function($rootScope, $timeout, Post) {
		controller.$inject = ["$scope", "$state", "$rootScope", "$mdDialog", "Schema"];
		return {
			scope: {
				page: '=',
				index: '@'
			},
			controller: controller,
			controllerAs: 'vm',
			link: link,
			templateUrl: '/app/alignus/directives/sidebarWidgets/au-page-filter-posts.tmpl.html',
			restrict: 'AE'
		}

		function link($scope, $element, $attrs, $controller) {
			console.debug('filter post widget link online')
		}

		function controller($scope, $state, $rootScope, $mdDialog, Schema) {
			var vm = this
			
			//get a reference to the widget and use it rather than the index in the future as the index may change but the object ref won't
			vm.widget = $scope.widget = $scope.page.SideBarWidgets[$scope.index]
			vm.page = $scope.page

			init()

			function init() {
				if (!vm.widget.Data || vm.widget.Data.length == 0) {
					vm.widget.Data = ['High Priority']
				}
			}

			vm.addLabel = function () {
				vm.addingLabel = true
			}

			vm.cancelAdd = function () {
				vm.addingLabel = false
			}

			vm.completeAdd = function () {
				console.log(vm.widget)
				if (!vm.widget.Data) vm.widget.Data = []

				if (!vm.newLabelName || vm.newLabelName.trim() == "") return toast.toast('Please enter a new label.')
				if (vm.widget.Data.indexOf(vm.newLabelName) != -1) return toast.toast('That label already exists.')

				vm.widget.Data.push(vm.newLabelName.trim())
				vm.page.$updateItem()

				vm.newLabelName = ""
				vm.addingLabel = false
			}

			vm.removeLabel = function(index, $event){
				 $mdDialog.show($mdDialog.confirm({
					title: 'Remove Label',
					htmlContent: "Are you sure you want to remove this label from this page?",
					ok: 'Remove Label',
					cancel: 'Cancel',
					targetEvent: $event
				})).then(function () {
					vm.widget.Data.splice(index, 1)
					vm.page.$updateItem()
				})
			}

			vm.currentLabels = []
			vm.filterByLabel = function(label){
				if (vm.currentLabels.indexOf(label) > -1) {
					vm.currentLabels.splice(vm.currentLabels.indexOf(label), 1)
				} else {
					vm.currentLabels.push(label)
				}

				// get posts on this page which match the search terms
				Post.query({
					Page: vm.page._id,
					Labels__in: vm.currentLabels
				}).$httpPromise
                .then(function (posts) {
                	$rootScope.$broadcast('includePinned' + vm.page._id, vm.currentLabels.length > 0)
					//let the scope pick up the fact we are including posts - the setTimeout is needed
					setTimeout(function(){
						$rootScope.$broadcast('displayPosts' + vm.page._id, posts)	
					})
                })
			}
		}
	}]);
})();
(function () {
    'use strict';

    angular
	.module('alignus.directives')
/**
 * @ndgoc directive
 * @module alignus.directives
 * @name auPageAbout
 * @restrict AE
 *
 * @param {object} page A page to show about for.
 *
 * @description
 * Renders the about this page widget.
 *
 * @usage
 * <div au-page-about page="vm.page" data="{color: red}"></div>
 *
 */
	.directive('auPageEvents', ["$rootScope", "$timeout", "eventableFetcher", function($rootScope, $timeout, eventableFetcher) {
		controller.$inject = ["$scope", "usStates", "$mdDialog", "Schema"];
		return {
			scope: {
				page: '=',
				index: '@'
			},
			controller: controller,
			controllerAs: 'vm',
			link: link,
			templateUrl: '/app/alignus/directives/sidebarWidgets/au-page-events.tmpl.html',
			restrict: 'AE'
		}

		function link($scope, $element, $attrs, $controller) {
			console.debug('events widget link online')
		}

		function controller($scope, usStates, $mdDialog, Schema) {
			var vm = this

			init()

			function init() {
				//get a reference to the widget and use it rather than the index in the future as the index may change but the object ref won't
				vm.widget = $scope.widget = $scope.page.SideBarWidgets[$scope.index]
				vm.page = $scope.page
				vm.widgetEvents = []
				loadEvents()
			}

			function loadEvents() {
				eventableFetcher.getEventsForUser(vm.page._id, true, 'future').then(function(events) {
					vm.widgetEvents = events
				})
			}
		}
	}]);
})();
(function () {
    'use strict';

    angular
		.module('alignus.directives')
		/**
		 * @ndgoc directive
		 * @module alignus.directives
		 * @name auPageAbout
		 * @restrict AE
		 *
		 * @param {object} page A page to show about for.
		 *
		 * @description
		 * Renders the about this page widget.
		 *
		 * @usage
		 * <div au-page-about page="vm.page" data="{color: red}"></div>
		 *
		 */
		.directive('auPageAbout', ["$rootScope", "$timeout", function ($rootScope, $timeout) {
			controller.$inject = ["$scope", "usStates", "$mdDialog", "Schema"];
			return {
				scope: {
					page: '=',
					index: '@'
				},
				controller: controller,
				controllerAs: 'vm',
				link: link,
				templateUrl: '/app/alignus/directives/sidebarWidgets/au-page-about.tmpl.html',
				restrict: 'AE'
			}

			function link($scope, $element, $attrs, $controller) {
				console.debug('about us link online')
			}

			function controller($scope, usStates, $mdDialog, Schema) {
				var vm = this
				vm.orgName = $rootScope.Organization.Name

				// determines whether or not the markup should show the "address" section
				vm.shouldShowAddress = function () {
					// only show the address of organizations, locations, and departments
					// ...and only show it if they have an address listed
					return ((vm.page.Type == 'Organization' || vm.page.Type == 'Location' || vm.page.Type == 'Department') && vm.page.relatedItem.Address)
				}

				vm.showAllFollowers = function (page) {
					vm.visibleFollowers = getVisibleFollowers(page, false)
				}

				// the 'editors' section should contain the Owner of the page
				// as well as all the editors, with the owner being listed first
				// and not being duplicated.
				vm.getEditorsSectionArray = function (page) {
					// owner should be in the first position
					var editorsSectionUsers = [page.Owner]
						// append an array of (all editors minus owner) to the results
						.concat(page.Editors.filter(function (editor) {
							return editor != page.Owner
						}))
					return editorsSectionUsers
				}

				vm.setFollowButtonText = function () {
					vm.followUnfollowButtonText = vm.isCurrentUserFollowing ? "Unfollow" : "Follow"
				}

				vm.changeFollowingStatus = function (page) {
					// if they're following, unfollow
					if (vm.isCurrentUserFollowing) {
						page.Unfollow()
					} else {
						page.Follow()
					}
					vm.isCurrentUserFollowing = !(vm.isCurrentUserFollowing)
					vm.setFollowButtonText()
				}

				vm.getVisibleFollowers = getVisibleFollowers

				function getVisibleFollowers(page, limitResults) {
					// ReportsTo > other members in department > other members in location
					var visibleFollowers = []
					var followerIdsAlreadyTracked = []
					var User = Schema.resource('User')
					var currentUser = $rootScope.user

					// add the ReportsTo to the visible followers first
					visibleFollowers = visibleFollowers.concat(page.Followers.filter(function (follower) {
						// check at least one of them for undefined, otherwise all undefined entries will match
						return (currentUser.ReportsTo && currentUser.ReportsTo == follower.User)
					}))
					// add other members in the same department to the visible followers list
					visibleFollowers = visibleFollowers.concat(page.Followers.filter(function (follower) {
						return (currentUser.Department && User.getCache({ _id: follower.User, Department: currentUser.Department }).length > 0)
					}))
					// add other members in the same location to the visible followers list
					visibleFollowers = visibleFollowers.concat(page.Followers.filter(function (follower) {
						return (currentUser.Location && User.getCache({ _id: follower.User, Location: currentUser.Location }).length > 0)
					}))
					// add all followers
					visibleFollowers = visibleFollowers.concat(page.Followers)
					// kill duplicates
					visibleFollowers = visibleFollowers.filter(function (follower) {
						if (followerIdsAlreadyTracked.indexOf(follower.User) > -1) {
							return false
						} else {
							followerIdsAlreadyTracked.push(follower.User)
							return true
						}
					})
					if (limitResults && visibleFollowers.length > 15) {
						return visibleFollowers.slice(0, 15)
					}
					return visibleFollowers
				}

				vm.openManagePageDialog = function ($event) {
					$mdDialog.show({
						controller: 'PageWizardDialog',
						controllerAs: 'vm',
						templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
						targetEvent: $event,
						locals: { options: { page: $scope.page } }
					}).then(function () {
						//
					})
				}

				vm.addWidget = function ($event) {
					$mdDialog.show({
						controller: 'AddWidgetsWizard',
						controllerAs: 'vm',
						templateUrl: '/app/alignus/directives/sidebarWidgets/dialogs/add-widgets-wizard.tmpl.html',
						targetEvent: $event,
						locals: { page: $scope.page }
					}).then(function () {
						vm.page.SideBarWidgets.last().$editing = true
					})
				}

				vm.getEventMonthString = function () {
					// this sucks
					var months = [
						'January',
						'February',
						'March',
						'April',
						'May',
						'June',
						'July',
						'August',
						'September',
						'October',
						'November',
						'December'
					]
					return months[(new Date(vm.page.Event.Start)).getMonth()]
				}

				vm.getEventDayString = function () {
					return (new Date(vm.page.Event.Start)).getDate().toString()
				}

				vm.getEventDayOfWeekString = function () {
					// this also sucks
					var days = [
						'Sunday',
						'Monday',
						'Tuesday',
						'Wednesday',
						'Thursday',
						'Friday',
						'Saturday',
						'Sunday'
					]
					return days[(new Date(vm.page.Event.Start)).getDay()]
				}

				// 			<span class="month">{{::vm.getEventMonthString()}}</span>
				// <span class="day">{{::vm.getEventDayString()}}</span>
				// <span class="week">{{::vm.getEventDayOfWeekString()}}</span>

				//get a reference to the widget and use it rather than the index in the future as the index may change but the object ref won't
				vm.widget = $scope.widget = $scope.page.SideBarWidgets[$scope.index]
				vm.page = $scope.page
				vm.visibleFollowers = getVisibleFollowers(vm.page, true)
				vm.isCurrentUserFollowing = vm.page.IsUserFollowing($rootScope.user._id)
				vm.setFollowButtonText()
				console.debug('Followers', vm.page.Followers)
			}
		}]);
})();
(function () {
    'use strict';

    angular.module('alignus.directives')
        .directive('oneSearch', function () {
            /* @ngInject */
            controller.$inject = ["$scope", "Schema", "$timeout", "$rootScope", "$sce", "$element", "toast", "ItemViewer", "oneSearch"];
            function controller($scope, Schema, $timeout, $rootScope, $sce, $element, toast, ItemViewer, oneSearch) {
                //todo - bring back support for searching meetings if that is something we want - see prior version for old code

                var vm = this

                vm.isFocused = false
                vm.placeholder = "Search"
                vm.overrideHooks = false
                vm.showingMore = false
                $timeout(function () {
                    vm.suggestBox = $element.find('.one-search-results')
                }, 500)

                var search = debounce(function () {
                    oneSearch.search(vm.oneSearchInput).then(function (results) {
                        vm.results = results
                    })
                }, 250)

                //run the search and show the dropdown                
                vm.getItemsMatchingSearch = function () {
                    if (oneSearch.searchHooks.length == 0 || vm.overrideHooks) {
                        //show the dropdown
                        if (!vm.showResults) {
                            vm.showResults = true
                            vm.results = [{ isSection: true, sectionTitle: 'Searching...' }]
                            vm.suggestIndex = 1

                            //close the dropdown when the document is clicked
                            angular.element(document).one('click', function () {
                                $scope.$apply(function () {
                                    vm.showResults = false
                                    vm.overrideHooks = false
                                    vm.oneSearchInput = ""
                                    vm.showingMore = false
                                })
                            })

                            //log to google analytics                            
                            window.ga('send', {
                                hitType: 'event',
                                eventCategory: 'OneSearch',
                                eventAction: 'SearchOpened'
                            });
                        }

                        //show the results                        
                        search()
                    } else {
                        // if the search has been hooked, use the last hook in the stack of hooks
                        if (!vm.showMessage) {
                            //show the dropdown but don't clear the search because we don't unfilter
                            angular.element(document).one('click', function () {
                                $scope.$apply(function () {
                                    vm.showMessage = false
                                    vm.overrideHooks = false
                                })
                            })
                        }

                        //assign a faux results which will not been seen but since it is a sectionTitle the enter key does nothing
                        vm.results = [{ isSection: true, sectionTitle: 'Searching...' }]
                        vm.suggestIndex = 0

                        //show the "searching XXX - click here to search globally"
                        vm.showMessage = true
                        vm.message = oneSearch.searchMessages.last()

                        //actually execute the hook
                        oneSearch.searchHooks.last()(vm.oneSearchInput)
                        return $q.resolve(true)
                    }
                }

                //handle key presses in the one-search-input                
                vm.keyPressed = function ($event) {
                    switch ($event.keyCode) {
                        case 13:
                            if (vm.results[vm.suggestIndex].isSection) return
                            vm.openItem(vm.results[vm.suggestIndex])
                            break
                        case 27:
                            //handle esc
                            vm.showResults = false
                            vm.oneSearchInput = ""
                        case 40:
                            //arrow down
                            $event.preventDefault();
                            vm.suggestIndex++
                            if (vm.suggestIndex > vm.results.length - 1) vm.suggestIndex = vm.results.length - 1
                            if (vm.results[vm.suggestIndex].isSection) vm.suggestIndex++

                            vm.suggestBox.scrollTop((vm.suggestIndex - 5) * 35)
                            break
                        case 38:
                            //arrow up    
                            $event.preventDefault();

                            vm.suggestIndex--
                            if (vm.results[vm.suggestIndex].isSection) vm.suggestIndex--
                            if (vm.suggestIndex < 1) vm.suggestIndex = 1

                            vm.suggestBox.scrollTop((vm.suggestIndex - 5) * 35)
                            break
                    }
                }

                //when someone clicks "search globally" when hooked                
                vm.overrideHook = function ($event) {
                    //discard the click
                    $event.stopImmediatePropagation();
                    $event.preventDefault();
                    $event.stopPropagation();

                    //close the message and set a flag
                    vm.showMessage = false
                    vm.overrideHooks = true

                    //execute the global search
                    vm.getItemsMatchingSearch()

                    //un-filter any results
                    oneSearch.searchHooks.last()("")

                    //set the cursor back to the input
                    $element.find('#TxtOneSearchInput').focus()
                }

                //open the clicked on item as a recent item                
                vm.openItem = function (searchItem, view) {
                    var searchText

                    Schema.resource(searchItem.ModelName).getCache({ _id: searchItem.DocId })[0].open(view, searchText)                    
                }

                //bold the matched part of the word		
                vm.highlightSuggestion = function (itemText) {
                    var words = vm.oneSearchInput.split(' ')

                    //replace all words with <b>{{word}}</b>
                    var returnVal = itemText
                    words.forEach(function (word, i) {
                        returnVal = returnVal.replace(new RegExp(word, 'gi'), '<b><u>$&</u></b>')
                    })
                    return $sce.trustAsHtml(returnVal)
                }

                //show more
                vm.showMore = function ($event, sectionTitle) {
                    //discard the click
                    $event.stopImmediatePropagation();
                    $event.preventDefault();
                    $event.stopPropagation();

                    var section = sectionTitle.substr(0, sectionTitle.length - 1)
                    oneSearch.search(vm.oneSearchInput, section).then(function (results) {
                        vm.results = results
                        vm.showingMore = true
                    })
                }
            }
            return {
                templateUrl: '/app/alignus/directives/one-search/one-search.tmpl.html',
                scope: {
                    data: '=?',
                    mode: '@'
                },
                controller: controller,
                controllerAs: 'vm'
            }
        });
})();
/* global interact */
(function () {
	'use strict';

	mdDataTableScroll.$inject = ["$filter", "$timeout", "$window", "auUtility"];
	angular
		.module('md.data.table')
		.directive('mdDataTableScroll', mdDataTableScroll)

	function mdDataTableScroll($filter, $timeout, $window, auUtility) {
		return {
			scope: {
				headerHeight: "=",
				atScrollEnd: "&"
			},
			restrict: 'EA',
			link: function (scope, element) {
				function checkForEnd(e) {
					if (angular.element(e.currentTarget).scrollTop() + angular.element(e.currentTarget).innerHeight() >= e.currentTarget.scrollHeight) {
						//we're at the end

						//inject a "loading more..." message so the container doesn't have to create/define it
						var el = element[0]
						auUtility.showLoadingMore(el)

						//call the function passed in to atScrollEnd
						scope.atScrollEnd()
					}
				}

				var parent = element[0]

				// add the css class
				parent.classList.add('md-data-table-scroll')

				// get the contained table
				var $table = parent.querySelector('table')
				var hookedScroll = false

				var wrapHeads = once(function () {
					//wrap the ths -ths can't clip content so put an inner div in each and later set the width on the inner div
					var ths = $table.querySelector('thead').querySelector('tr').querySelectorAll('th')
					angular.forEach(ths, function (v, i) {
						v.innerHTML = "<div class='th-inner'>" + v.innerHTML + "</div>"
					});

					//all cells get an equal width
					var colWidth = parseInt(100 / (ths.length - 2))

					//todo - test this with more data - 20% seems like a good low bound
					if (colWidth < 20) colWidth = 20

					var ss

					//see if an earlier instance created the dynamic stylesheet
					ss = angular.element("style[md-data-table-scroll-dynamic-style]")[0]
					if (ss) {
						//adjust the colWidth
						ss.sheet.rules[0].style.width = colWidth + '%'
					} else {
						//create the style sheet element
						var ss = document.createElement("style")
						ss.setAttribute("md-data-table-scroll-dynamic-style", "")

						//create the rule
						ss.appendChild(document.createTextNode(".md-data-table-scroll table tbody td:not(.md-checkbox-cell) { width: " + colWidth + "%; }"));

						//insert the style sheet
						document.head.appendChild(ss)
					}
				})

				// Adjust the width of thead cells when window resizes				
				function adjustColHeaderWidths() {
					console.log('adjustColHeaderWidths')
					wrapHeads()

					var $bodyCells = angular.element($table).find('tbody tr[md-row]:visible:first td')

					// Get the tbody columns width array
					var colWidth = []
					angular.forEach($bodyCells, function (cell) {
						colWidth.push(angular.element(cell).width())
					})

					if (colWidth.length == 0) return

					// Set the width of thead columns
					angular.forEach($table.querySelector('thead').querySelector('tr').querySelectorAll('th'), function (v, i) {
						var thInner = v.querySelector('.th-inner')
						angular.element(thInner).width(colWidth[i]);
					});

					// if passed a function to execute when the body has scrolled to the end, monitor the scroll position
					if (scope.atScrollEnd && parent.querySelector('tbody') && !hookedScroll) {
						angular.element(parent.querySelector('tbody')).scroll(checkForEnd)
						hookedScroll = true
					}
				}

				scope.$$postDigest(adjustColHeaderWidths)
				$timeout(adjustColHeaderWidths, 1)

				//monitor the window size
				var debounceAdjustColHeaders = debounce(adjustColHeaderWidths, 100)
				angular.element($window).bind('resize', debounceAdjustColHeaders)
				scope.$on('$destroy', function () {
					angular.element($window).unbind('resize', debounceAdjustColHeaders)
				})

				scope.$on('adjust-column-headers', function () {
					adjustColHeaderWidths()
				})
			}//end of link
		}//end of return
	}//end of function
})();
(function() {
    angular
        .module('alignus.directives')
        .directive('auWorkflows', function() {
            controller.$inject = ["$scope", "$element", "$mdDialog", "Schema"];
            return {
                templateUrl: '/app/alignus/directives/au-workflows/au-workflows.tmpl.html',
                scope: {
                    item: '='
                },
                controller: controller,
                controllerAs: 'vm',
                restrict: 'E'
            }

            /* @ngInject */
            function controller($scope, $element, $mdDialog, Schema) {
                var vm = this
                init()

                vm.close = $mdDialog.hide

                function init() {
                    bindScopeVariables()
                    setSortables()
                }

                function bindScopeVariables() {
                    //this is where we will make all the $scope variables vm
                    vm.item = $scope.item
                    vm.workflows = vm.item.Workflows.map(function(flow){
                        return Schema.resource(flow.Type).getCache({_id: flow.LinkId})[0]
                    })
                }

                function setSortables() {
                    vm.sortableBy = [{
                        fieldName: 'Title',
                        display: 'Title'
                    }, {
                        fieldName: 'DateCreated',
                        display: 'Date Added'
                    }, {
                        fieldName: 'CreatedBy',
                        display: 'Who Added'
                    }]
                    vm.sortBy = vm.sortableBy[0]
                }

                vm.setSortBy = function($index) {
                    vm.sortBy = vm.sortableBy[$index]
                }

                vm.openRequestApprovalDialog = function($event) {
                    $mdDialog.show({
                        templateUrl: '/app/alignus/directives/au-workflows/dialogs/request-approval.tmpl.html',
                        controller: 'RequestApprovalDialog',
                        controllerAs: 'vm',
                        targetEvent: $event,
                        locals: {
                            options: {
                                itemToApprove: vm.item
                            }
                        }
                    })
                }

                $scope.$watch('vm.item.Workflows', function(newVal, oldVal){
                    bindScopeVariables()
                }, true)
            }
        });

    
})();
(function() {
    'use strict';

    /**
     * @ndgoc directive
     * @module alignus.directives
     * @name auWizard
     * @restrict AE
     *
     * @description
     * Control a set of steps. Auto-inserts the Review and Finished steps if you don't specify them.
     *
     * @param {type} name Description.
     * @example
     * <md-dialog au-wizard on-step-change="function to run on every change; does not cancel">
     * 	 <au-wizard-step on-next-step="function to run when clicking Next from this step; return `false` to cancel.">
     *     <any></any>
     *   </au-wizard-step>
     *   <au-wizard-step> ... </au-wizard-step>
     * </md-dialog>
     *
     */

    auWizard.$inject = ["$compile"];
    controller.$inject = ["$scope", "$mdDialog", "ngDialog", "httpError"];
    angular
        .module('alignus.directives')
        .directive('auWizard', auWizard);

    /* @ngInject */
    function auWizard($compile) {
        compile = $compile

        var directive = {
            bindToController: {
                dialogTitle: '@',
                onStepChange: '&?',
                onReview: '&',
                onFinish: '&',
                onClose: '&?',
                onInit: '&?',
                disableNext: '=?',
                customReviewStep: '=?'
            },
            link: link,
            controller: controller,
            controllerAs: 'wizard',
            templateUrl: '/app/alignus/directives/au-wizard/au-wizard.tmpl.html',
            restrict: 'AE',
            transclude: true
        };
        return directive;
    }

    var compile
        //the link runs after content has been transcluded
    function link($scope, $element, $attrs, $controller, $transclude, httpError) {
        //init locals
        var foundFinishedStep = false,
            foundReviewStep = false
        var wizard = $controller
        wizard.steps = $element.find('au-wizard-step')
        wizard.steps.getStep = wizard.getStep
        wizard.steps.nextStep = wizard.nextStep
        wizard.element = $element

        var stepContainer = wizard.steps[0].parentElement

        //expose wizard controls via attribute usage such as:
        //<md-dialog au-wizard steps='vm.wizardSteps' disableNext='vm.disableNext'>...</md-dialog>
        if ($attrs.steps) {
            $scope.$eval($attrs.steps + ' = wizard.steps')
        }

        //init visible state and look for review & finished
        angular.forEach(wizard.steps, function(step, i) {
            step.visible = true
            if (step.getAttribute('step-name') == 'review') foundReviewStep = true
            if (step.getAttribute('step-name') == 'finished') foundFinishedStep = true
        })

        //add the default review step if it's not in the markup
        if (!foundReviewStep && !wizard.customReviewStep) {
            //create the dom element
            var addReviewStep = angular.element('<au-wizard-step step-name="review" step-bg="/assets/images/dialogs/review.png"><h3>Review</h3><p class="margin-bottom-20">Please review the following, and if it\'s all good, go ahead and click Finish.</p><table><tr ng-repeat="detail in wizard.getReviewDetails()" style="height: 30px" ng-attr-id="StringReviewDetail{{$index}}"><td class="md-body-1">{{detail.name}}:</td><td class="padding-left-30 md-body-2" dynamic="detail.value"></td></tr></table></au-wizard-step>')

            addReviewStep[0].visible = true

            //add the new element to the container
            stepContainer.appendChild(addReviewStep[0])

            //push the new step into wizard.steps
            wizard.steps.push(addReviewStep[0])

            //tell angular to compile the step to activate any directives in the markup
            compile(addReviewStep)($scope)
        }

        //add the default finished step if it's not in the markup
        if (!foundFinishedStep) {
            //create the dom element
            var addFinishStep = angular.element('<au-wizard-step step-name="finished" step-bg="/assets/images/dialogs/completed.png"><div ng-if="!wizard.finished"><h3>Drumroll, please...</h3><p>Processing your request. This should only take a moment. Please wait.</p></div><div ng-if="wizard.finished"><div ng-if="!wizard.finishError"><h3 id="StringConfirm">You did it!</h3><p ng-bind-html="wizard.finishMessage"></p></div><div ng-if="wizard.finishError"><h3 style="color: red">Oh no! Something went wrong...</h3><p ng-bind-html="wizard.finishError"></p></div></div></au-wizard-step>')

            addFinishStep[0].visible = true

            //add the new element to the container
            stepContainer.appendChild(addFinishStep[0])

            //push the new step into wizard.steps
            wizard.steps.push(addFinishStep[0])

            //tell angular to compile the step to activate any directives in the markup
            compile(addFinishStep)($scope)
        }

        if (wizard.onInit) wizard.onInit()

        //find the first visible step
        for (var i = 0; i < wizard.steps.length; i++) {
            if (wizard.steps[i].visible) break
            wizard.currentStep++
        }

        wizard.showCurrentStep()
    }



    //the controller is instantiated before the transcluded content	(and before the link)
    /* @ngInject */
    function controller($scope, $mdDialog, ngDialog, httpError) {
        var wizard = this

        wizard.steps = []
        wizard.element = null
        wizard.currentStep = 0;
        wizard.showCurrentStep = showCurrentStep;
        wizard.getStep = getStep;
        wizard.nextStep = nextStep;
        wizard.prevStep = prevStep;
        wizard.okToFinish = true;
        wizard.finishing = false;
        wizard.finished = false;
        wizard.finishMessage = ""
        wizard.title = wizard.dialogTitle

        //expect the dialog controller to be 'as vm'
        wizard.newItem = Object.byString($scope, 'vm.newItem')

        //called on each move from step to step
        function showCurrentStep(finishing) {
            //reset state variables
            wizard.reviewDetails = null
            wizard.finishError = null
            wizard.finished = false
            wizard.finishing = false

            //show/hide the correct steps
            var stepNbr = 0
            angular.forEach(wizard.steps, function(step) {
                step = angular.element(step)
                step.hide()

                //if the step is not visible, skip to the next one			
                if (!step[0].visible) {
                    stepNbr++;
                    return
                }

                if (stepNbr == wizard.currentStep) {
                    //show the current step
                    step.fadeIn('fast')

                    //unless we're finishing, which will controll the bg update, update the bg
                    if (!finishing) {
                        var bgImg = step.attr('step-bg') + "".replaceAll('"').replaceAll("'")
                        wizard.element[0].style.backgroundImage = "url(" + bgImg + ")"
                    }

                    if (step.attr('title')) {
                        wizard.title = step.attr('title')
                    } else {
                        wizard.title = wizard.dialogTitle
                    }
                    
                    //find any fields that are md-autofocus
                    $scope.$$postDigest(function() {
                        var focus = wizard.element.find('[md-auto-focus]').filter(':visible')
                        if (focus.length) {
                            focus = angular.element(focus[0])
                            if (!focus.is('input')) {
                                focus = focus.find('input')
                            }
                            if (focus) {
                                focus.focus()
                            }
                        }
                    })
                }

                stepNbr++
            })
        }

        function getStep(indexOrName) {
            if (typeof indexOrName == 'number') {
                return wizard.steps[indexOrName]
            }
            if (indexOrName == 'current') {
                return wizard.currentStep
            }
            for (var i = 0; i < wizard.steps.length; i++) {
                if (wizard.steps[i].getAttribute('step-name') == indexOrName) {
                    return wizard.steps[i]
                }
            }
            return null
        }

        function nextStep() {
            //the step may have specified on-next-step. if so, run it and prevent going Next if it returns false
            var nextOK = true
            if (getStep(wizard.currentStep).getAttribute('on-next-step')) {
                nextOK = $scope.$eval(getStep(wizard.currentStep).getAttribute('on-next-step'))
            }
            if (!nextOK) return

            //go to the next step
            advanceCurrentStep()
            showCurrentStep()

            //if the wizard wants to know about every step change, let it know
            if (wizard.onStepChange) wizard.onStepChange({ currentStep: wizard.currentStep, fromStep: wizard.currentStep - 1 })
        }

        function advanceCurrentStep() {
            wizard.currentStep++
                if (!getStep(wizard.currentStep).visible) {
                    return advanceCurrentStep()
                }
        }

        function regressCurrentStep() {
            wizard.currentStep--
                if (!getStep(wizard.currentStep).visible) {
                    return regressCurrentStep()
                }
        }

        function prevStep() {
            //go to the previous step
            // wizard.currentStep--
            regressCurrentStep()
            showCurrentStep()

            //if the wizard wants to know about every step change, let it know
            if (wizard.onStepChange) wizard.onStepChange({ currentStep: wizard.currentStep, fromStep: wizard.currentStep + 1 })
        }

        //cache and lazy load the review step details from the controller's onReview function
        wizard.reviewDetails = null //{error: false, details: []}
        wizard.getReviewDetails = function() {
            if (!wizard.reviewDetails) {
                try {
                    wizard.reviewDetails = wizard.onReview()
                } catch (e) {
                    wizard.reviewDetails = { details: '' }
                }
            }
            return wizard.reviewDetails.details
        }

        //when the user clicks the Finish button
        wizard.finish = function() {
            //unconditionally go to the next (finished) step - errors and success are presented there
            wizard.currentStep++
                // advanceCurrentStep()

                //pass true to prevent the bg update
                showCurrentStep(true)

            //tell the UI that we're working on it.
            wizard.finishing = true

            //call the function the controller passed in
            wizard.onFinish().then(function(message) {
                //set state variables
                wizard.finishing = false
                wizard.finished = true
                wizard.finishMessage = message

                //set the bg to the bg of the finishing step
                var bgImg = wizard.steps.last().attr('step-bg') + "".replaceAll('"').replaceAll("'")
                wizard.element[0].style.backgroundImage = "url(" + bgImg + ")"
            }, function(err) {
                //something failed, so show the error
                wizard.finishing = false
                wizard.finished = true
                wizard.finishError = httpError.parse(err.data || err)
                wizard.element[0].style.backgroundImage = "url(/assets/images/dialogs/warning.png)"
            })
        }

        wizard.getVisibleSteps = function() {
            return wizard.steps.filter(function(index, step) {
                return step.visible
            }).length
        }

        wizard.openItem = function(){
            if (wizard.newItem._id) wizard.newItem.open()
            $mdDialog.hide(wizard.newItem)
        }

        //the user clicked the Close button
        wizard.close = function() {
            $mdDialog.hide(wizard.newItem)
        }

        //user clicks the X in the dialog or cancel button after an error
        wizard.cancel = function() {
            //ngDialog injects a closeThisDialog function into scope
            if ($scope.closeThisDialog) {
                $scope.closeThisDialog()
            } else {
                //mdDialog doesn't and exposes this service method
                $mdDialog.cancel()
            }
        }
    }

})();
(function() {
    angular
        .module('alignus.directives')
        .directive('auUserHover', function () {
            return {
                templateUrl: '/app/alignus/directives/au-user-hover/au-user-hover.tmpl.html'
            }
        })
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		.directive('auTimer', function () {
			auTimer.$inject = ["$scope", "$element", "$attrs", "$compile", "$interval", "auUtility"];
			return {
				scope: {
					duration: '=',
					startDate: '=',
					format: '@'
				},
				template: '<span ng-bind-html="vm.output"></span>',
				controller: auTimer,
				controllerAs: 'vm',
			} // end directive recipe
			/* @ngInject */
			function auTimer($scope, $element, $attrs, $compile, $interval, auUtility) {
				var vm = this

				vm.output = "0 minutes"
				if (!$scope.format) {
					$scope.format = ""
				}

				$scope.$watch('duration', generateOutput)
				$scope.$watch('startDate', function (newVal, oldVal) {
					if (newVal) {
						startRunning()
					}
					if (oldVal && !newVal) {
						stopRunning()
					}
				})

				vm.intervalHandle = null

				function startRunning() {
					$element.addClass('running')
					$interval.cancel(vm.intervalHandle)
					vm.intervalHandle = $interval(generateOutput, 1000 * 10, 0, false) //update output every 30s
				}

				function stopRunning() {
					$element.removeClass('running')
					$interval.cancel(vm.intervalHandle)
					generateOutput()
				}

				$scope.$on('$destroy', function () {
					$interval.cancel(vm.intervalHandle)
				})

				function generateOutput() {
					var totalDuration, totalDays, totalHours, totalMinutes = 0
					totalDuration = $scope.duration || 0

					//add to the ticking timer
					if ($scope.startDate) {
						totalDuration += (new Date()).getTime() - $scope.startDate.getTime()
					}

					vm.output = auUtility.formatDuration(totalDuration, $scope.format)
					
					if ($element.is(":visible")) {
						 if (!$scope.$$phase && !$rootScope.$$phase) $scope.$digest()
					}

				}


			} // end controller definition
		}) // end directive recipe function scope/call to angular.directive
})();
(function() {
	'use strict';
	angular
		.module('alignus.directives')
		.directive('auTemplateButtons', function() {
			controllerFn.$inject = ["$scope", "$window", "$timeout", "toast"];
			return {
				templateUrl: '/app/alignus/directives/au-template-buttons/au-template-buttons.tmpl.html',
				controller: controllerFn,
				scope: {
					item: '='
				}
			}

			/* @ngInject */
			function controllerFn($scope, $window, $timeout, toast) {
				$scope.toggleTemplate = function($event) {
					// show a dialog asking if the user wants to toggle the 
					// Template-ness of the item in question
					$mdDialog.show($mdDialog.confirm({
						title: $scope.item.IsTemplate ? 'Remove as Template' : 'Convert to Template',
						textContent: 'Are you sure you want to ' + ($scope.item.IsTemplate ? 'remove this item as a template?' : 'convert this item to a template? This will lock the item until you explicitly unlock it again.'),
						ok: 'Do It',
						cancel: 'Nevermind',
						targetEvent: $event
					})).then(function() {
						toast.success('Converting requires the item to re-open. Working...')

						// toggle the IsTemplate property and update the item
						$scope.item.IsTemplate = !$scope.item.IsTemplate
						$scope.item.$updateItem().$promise.then(function() {
							// close and open the item so that template locking/unlocking will apply
							var x = $scope.item.close()
							$timeout(function(){
								$scope.item.open()
								toast.success($scope.item.IsTemplate ? 'Item is now a template' : 'Item is no longer a template', true)
							}, 750)
							
						})
					})
				}
			}
		})
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		.directive('auTaskRow', function () {
			auTaskRow.$inject = ["$scope", "$element", "$timeout", "toast"];
			return {
				scope: {
					task: '<'
				},
				templateUrl: '/app/alignus/directives/au-task-row/au-task-row.tmpl.html',
                controller: auTaskRow,
                controllerAs: 'vm'
			} // end directive recipe
			/* @ngInject */
			function auTaskRow($scope, $element, $timeout, toast) {
				var vm = this
				vm.focused = false

				//save the title to know when to update
				vm.origTitle = $scope.task.Title
				
				//should be in auUtility or, just on $root?!?
				vm.openTaskFab = function ($event, task) {
					//position the task Fab over the checkbox
					var offset = angular.element($event.currentTarget).offset()
					$rootScope.docTask.openFab(offset, task, $event.currentTarget)
				}

				//togle IsRunning state and update (convenience function for the UI)
				vm.playClicked = function (task) {
					if (task.IsRunning) {
						task.Stop()
					} else {
						task.Start()
					}
				}

				//update title on blur and enter key
				vm.update = function () {
					if (!$scope.task.Title) {
						$element.find('textarea').focus()
						$scope.task.Title = vm.origTitle
						return toast.error('Title is required. Click Remove Task if that\'s what you want to do.')
					}

					if (vm.origTitle == $scope.task.Title) return //nothing to update
					
					$scope.task.$updateItem()
					vm.origTitle = $scope.task.Title
				}

				vm.blur = function(){
					$element.find('textarea').blur()
				}

				//after a second, change the no-drag to let users drag-select text
				vm.setFocus = function (val) {
					if (!val) $element.find('textarea').removeAttr('no-drag')
					else {
						$timeout(function () {
							$element.find('textarea').attr('no-drag', 'no-drag')
						}, 1000)
						vm.focused = true
					}
				}

			} // end controller definition
		}) // end directive recipe function scope/call to angular.directive

})();
(function () {
    auTaskQuickviewController.$inject = ["$filter", "$rootScope", "moment", "ItemViewer", "Schema", "Task"];
    angular
        .module('alignus.directives')
        .directive('auTaskQuickview', function () {
            return {
                controller: auTaskQuickviewController,
                controllerAs: 'vm',
                templateUrl: '/app/alignus/directives/au-task-quickview/au-task-quickview.tmpl.html',
                scope: {

                }
            }
        })

    /* @ngInject */
    function auTaskQuickviewController($filter, $rootScope, moment, ItemViewer, Schema, Task) {
        var vm = this
        init()

        function init() {
            var tomorrowStart = moment().add(1, 'days').startOf('day')._d
            var tomorrowEnd = moment().add(1, 'days').endOf('day')._d
            var oneWeekLater = moment().add(7, 'days').startOf('day')._d
            // Today = any task that has a PlannedStartDate of end of day or earlier
            // Tomorrow = the PlannedStartDate is tomorrowEnd
            // Upcoming = the PlannedStartDate is > tomorrow and < 7 days from now
            // Someday = the PlannedStartDate is null or > 7 days from now
            // in the future, to add a task time range, you can just put it here
            // in the same format and the directive does the rest of the work
            vm.taskTabs = {
                'Today': {
                    tasks: [],
                    range: { start: null, end: tomorrowStart },
                    icon: 'zmdi zmdi-brightness-5'
                },
                'Tomorrow': {
                    tasks: [],
                    range: { start: tomorrowStart, end: tomorrowEnd },
                    icon: 'zmdi zmdi-alarm'
                },
                'Upcoming': {
                    tasks: [],
                    range: { start: tomorrowEnd, end: oneWeekLater },
                    icon: 'zmdi zmdi-time-countdown'
                },
                'Someday': {
                    tasks: [],
                    range: { start: oneWeekLater, end: null },
                    icon: 'zmdi zmdi-timer'
                }
            }
            // bind the keys in taskTabs to the display so that ng-repeat
            // can walk over the taskTabs object
            vm.tabKeys = Object.keys(vm.taskTabs)
        }

        // the preconditions here are pretty tightly coupled to this widget
        function getTasksByDateRange(tasks, rangeStart, rangeEnd) {
            return tasks.filter(function (task) {
                var startDate = (task.PlannedStartDate ? new Date(task.PlannedStartDate) : null)
                if (!rangeEnd) {
                    return (!startDate || startDate > rangeStart)
                } else if (!rangeStart && startDate) {
                    return startDate < rangeEnd
                } else {
                    return (startDate && (startDate >= rangeStart) && (startDate < rangeEnd))
                }
            })
        }

        vm.openTask = function (task) {
            task.open('recent')
        }

        //Add Task
            vm.openAddTask = function () {
                $mdDialog.show({
                    controller: 'AddTaskDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/project/dialogs/add-task.tmpl.html',
                    targetEvent: null,
                    locals: {
                        options: {
                            associatedItem: null
                        }
                    }
                })
            }

        vm.loadTasks = function (key) {
            var myTasks = Task.query({ 
                User: $rootScope.user._id, 
                IsActive: true,
                ProjectIsActive: true,
                $or: [
                    {EndDate: null},
                    {EndDate: {$exists: false}},
                    {EndDate: {$gte: moment().subtract(3, 'days')._d}}
                ]
            })

            var start = vm.taskTabs[key].range.start
            var end = vm.taskTabs[key].range.end

            updateTab()
            myTasks.$httpPromise.then(function () {
                updateTab()
            })

            function updateTab() {
                vm.taskTabs[key].tasks = getTasksByDateRange(myTasks, start, end)
            }
        }
    }
})();
(function () {
	'use strict';

	angular.module('alignus.directives')
	.directive('auTaskBoard', function() {
		auTaskBoardController.$inject = ["$scope", "$rootScope", "$q", "$element", "$filter", "ItemViewer", "ListViewer", "Schema", "$mdDialog", "moment"];
		return {
			templateUrl: '/app/alignus/directives/au-task-board/au-task-board.tmpl.html',
			controller: auTaskBoardController,
			controllerAs: 'vm',
			scope: {
				item: '=',
				tasks: '=',
				initialState: '@',
				disableOtherStates: '=',
				excludeUnassigned: '=',
				excludeToolbar: '='
			},
			restrict: 'E'
		}

		/* @ngInject */
		function auTaskBoardController($scope, $rootScope, $q, $element, $filter, ItemViewer, ListViewer, Schema, $mdDialog, moment) {
			var vm = this
			init(true)

			function init(isFirst) {
				// bind scope vars
				vm.item = $scope.item
				vm.excludeToolbar = $scope.excludeToolbar
				vm.excludeUnassigned = $scope.excludeUnassigned
				vm.disableOtherStates = $scope.disableOtherStates
				// initialize the board state to either a user-provided state or the default (UserBoard)
				if(isFirst) _setBoardState($scope.initialState ? $scope.initialState : 'UserBoard')
				// initialize kanban states
				vm.possibleKanbanStates = ['Not Started', 'In Progress', 'Completed']
				// initialize raw tasks
				if(isFirst) vm.rawTasks = []
				_loadUserPool()
				_loadBoard()
				_loadSortOptions()
				_loadTasks()
				.then(function(tasks) {
					vm.rawTasks = tasks
					// make the board model
					_makeBoardModel()
					_sortBoard()
					listenForItemAdded()
					listenForItemUpdated()
					listenForItemRemoved()
				})
			}

			function _loadTasks() {
				// if tasks were provided by the user, simply use those
				if($scope.tasks) {
					return $q.resolve($scope.tasks)
				}
				// if there is an item and it has a GetTasks function, use that
				// (will work for projects/meetings)
				if($scope.item && $scope.item.GetTasks) {
					return $scope.item.GetTasks()
				}
				// could not determine how to get tasks for this data set
			}

			function _loadUserPool() {
				if($scope.tasks) {
					vm.userPool = []
					angular.forEach($scope.tasks, function(task, i){
						if (task.User && vm.userPool.indexOf(task.User) == -1){
							vm.userPool.push(task.User)
						}
					})
					return
				}
				if(vm.item.$key == 'Meeting') {
					// vm.userPool = vm.item.GetAllAttendees(true)
					vm.userPool = vm.item.GetLinkedAttendees()
				}
				if(vm.item.$key == 'Project') {
					vm.userPool = vm.item.GetRawMembers()
				}
				if(vm.item.$key == 'Team') {
					vm.userPool = vm.item.getRawTeamMemberIds()
				}
			}

			function _loadBoard() {
				vm.board = {
					columns: []
				}
			}

			function _loadSortOptions() {
				vm.sortOptions = {
					//restrict move across columns. move only within column.
					/*accept: function (sourceItemHandleScope, destSortableScope) {
					 return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
					 },*/
					itemMoved: function(event) {
						_boardStates[vm.boardState].onTaskColumnChanged(event)
					},
					orderChanged: function(event) {
						_boardStates[vm.boardState].onTaskOrderChanged(event)
					}
					// containment: '#testBoard'
				}
			}

			// arrange the raw task data into a "board"-style object
			function _makeBoardModel() {
				_boardStates[vm.boardState].makeColumns()
			}

			function _sortBoard() {
				vm.board.columns.forEach(function(column) {
					column.tasks.sort(function(taskA, taskB) {
						if(taskA.ProjectPriority < taskB.ProjectPriority) {
							return 1
						} else if(taskA.ProjectPriority > taskB.ProjectPriority) {
							return -1
						}
						return 0
					})
				})
			} 

			var _boardStates = {
				'UserBoard': {
					makeColumns: _makeColumnsUserBoard,
					onTaskColumnChanged: _reassign,
					onTaskOrderChanged: _changePlannedStartDate
				},
				'KanbanBoard': {
					makeColumns: _makeColumnsKanbanBoard,
					onTaskColumnChanged: _changeKanbanState
				}
			}

			function _makeColumnsUserBoard() {
				vm.board.columns = vm.userPool.map(function(member) {
					var populatedMember = Schema.resource('User').getCache({_id: member})[0]
					var memberTasks = _getTasksWhere('User', member)
					return {
						columnTitle: $filter('fullNameFilter')(populatedMember),
						member: populatedMember, 
						tasks: memberTasks,
						groups: _makeUserBoardGroups(memberTasks),
						hoursCompleted: _getTotalEstimatedHours(memberTasks, true),
						hoursTotal: _getTotalEstimatedHours(memberTasks)
					}
				})
				// add 'unassigned' column
				if(!vm.excludeUnassigned) {
					var dummyMember = { LastName: 'Unassigned', _id: undefined }
					var unassignedTasks = _getTasksWhere('User', dummyMember._id)
					vm.board.columns.unshift({
						columnTitle: 'Unassigned',
						member: dummyMember,
						tasks: unassignedTasks,
						groups: _makeUserBoardGroups(unassignedTasks),
						hoursCompleted: _getTotalEstimatedHours(unassignedTasks, true),
						hoursTotal: _getTotalEstimatedHours(unassignedTasks)
					})
				}
			}

			function _makeUserBoardGroups(memberTasks) {
				var tomorrowStart = moment().add(1, 'days').startOf('day')._d
				var tomorrowEnd = moment().add(1, 'days').endOf('day')._d
				var oneWeekLater = moment().add(7, 'days').startOf('day')._d
				var groups = [
					{
						groupHeader: 'Today',
						groupHeaderClasses: 'background-color-700',
						tasks: _getTasksByDateRange(memberTasks, null, tomorrowStart),
						getPlannedStartDate: function() {
							return moment().startOf('day')._d
						}
					},
					{
						groupHeader: 'Tomorrow',
						groupHeaderClasses: 'background-color-600',
						tasks: _getTasksByDateRange(memberTasks, tomorrowStart, tomorrowEnd),
						getPlannedStartDate: function() {
							return moment().add(1, 'days').startOf('day')._d
						}
					},
					{
						groupHeader: 'This Week',
						groupHeaderClasses: 'background-color-500',
						tasks: _getTasksByDateRange(memberTasks, tomorrowEnd, oneWeekLater),
						getPlannedStartDate: function() {
							return moment().add(2, 'days').startOf('day')._d
						}
					},
					{
						groupHeader: 'Someday',
						groupHeaderClasses: 'background-color-400',
						tasks: _getTasksByDateRange(memberTasks, oneWeekLater, null),
						getPlannedStartDate: function() {
							return null
						}
					}
				]
				return groups
			}

			function _getTasksByDateRange(tasks, rangeStart, rangeEnd) {
				return tasks.filter(function(task) {
					var startDate = (task.PlannedStartDate ? new Date(task.PlannedStartDate) : null)
					if(!rangeEnd) {
						return (!startDate || startDate >= rangeStart)
					} else if(!rangeStart && startDate) {
						return startDate < rangeEnd
					} else {
						return (startDate && (startDate >= rangeStart) && (startDate < rangeEnd))
					}
				})
			}

			function _changePlannedStartDate(event) {
				var taskToChangeDateFor = event.source.itemScope.modelValue
			}

			function _getTotalEstimatedHours(tasks, getCompletedHours) {
				var runningTotal = 0
				tasks.forEach(function(task) {
					if(task.EstimatedHours) {
						if(getCompletedHours) {
							if(task.EndDate) {
								runningTotal += task.EstimatedHours								
							}
						} else {
							runningTotal += task.EstimatedHours
						}
					}
				})
				return runningTotal
			}

			function _makeColumnsKanbanBoard() {
				vm.board.columns = vm.possibleKanbanStates.map(function(state) {
					var tasksForState = _getTasksWhere('KanbanState', state)
					return {
						columnTitle: state,
						tasks: tasksForState,
						hoursCompleted: _getTotalEstimatedHours(tasksForState, true),
						hoursTotal: _getTotalEstimatedHours(tasksForState)
					}
				})
			}

			function _getTasksWhere(field, isThis) {
				return vm.rawTasks.filter(function(task) {
					if(task[field] == isThis) return true;
					return false;
				})
			}

			// let's violate the single purpose principle
			function _reassign(event) {
				var taskToReassign = event.source.itemScope.task
				var reassignTo = event.dest.sortableScope.$parent.column.member._id
				var startDate = event.dest.sortableScope.timeRangeGroup.getPlannedStartDate()
				var prom
				// don't reassign the task if it's already assigned to this user
				if(taskToReassign.User != reassignTo) {
					prom = taskToReassign.Reassign(reassignTo)
				} else {
					// set the planned start date to match whatever group it was dragged to
					prom = taskToReassign.SetPlannedStartDate(startDate, true)
				}
				_makeBoardModel()
				prom.then(function() {
					$rootScope.$broadcast('flipFabToSaved')
				})
			}

			function _changeKanbanState(event) {
				var taskToChangeState = event.source.itemScope.task
				taskToChangeState.KanbanState = event.dest.sortableScope.$parent.column.columnTitle
				taskToChangeState.$updateItem()
				_makeBoardModel()
			}

			function changePriorityByEvent(event) {
				var taskToReprioritize = event.source.itemScope.modelValue
				var taskBeforeThat = event.dest.sortableScope.$parent.column.tasks[event.dest.index + 1]
				if(!taskBeforeThat) {
					taskToReprioritize.ProjectPriority = 1
				} else {
					taskToReprioritize.ProjectPriority = taskBeforeThat.ProjectPriority + 1
				}
				taskToReprioritize.$updateItem()
			}

			function listenForItemAdded() {
				//this does more harm than good as any task added (new task, anyone?) adds to the user's MyTask list
				//$scope.$on('itemAdded', itemAddedHandler)
			}

			function itemAddedHandler(event, newItem) {
				if(vm.item && newItem.$key == 'Task') {
					if(newItem[vm.item.$key] == vm.item._id) {
						vm.rawTasks.push(newItem)
						_makeBoardModel()
					}
				}
			}

			function listenForItemRemoved() {
				$scope.$on('itemRemoved', itemRemovedHandler)
			}

			function itemRemovedHandler(event, item) {
				if(item.$key == 'Task') {
					for (var i = 0; i < vm.rawTasks.length; i++){
						if (vm.rawTasks[i]._id == item._id){
							vm.rawTasks.splice(i, 1)
							break;
						}
					}

					_makeBoardModel()
				}
			}

			function listenForItemUpdated() {
				$scope.$on('itemUpdated', itemUpdateHandler)
			}

			function itemUpdateHandler(event, itemUpdated){
				var redraw = false
				if (itemUpdated.$key == 'Task') {
					var task = _getTasksWhere("_id", itemUpdated._id)
					if (task[0]) {
						auUtility.processItemUpdate(itemUpdated, task[0])
						redraw = true
					}
				}

				if (redraw) {
					_makeBoardModel()
					_sortBoard()		
				}
			
			}

			function _setBoardState(state) {
				vm.boardState = state
			}

			vm.setBoardState = function(state) {
				_setBoardState(state)
				init()				
			}

			vm.openTaskAsRecent = function(task) {
				task.open('recent')
			}

			vm.openAddTaskDialog = function ($event, user) {
				$mdDialog.show({
					controller: 'AddTaskDialog',
					controllerAs: 'vm',
					templateUrl: '/app/project/dialogs/add-task.tmpl.html',
					targetEvent: null,
					locals: {
						options: {
							associatedItem: vm.item,
							associatedUser: user ? user._id : null
						}
					}
				})
			}

			vm.openTaskFab = function ($event, task) {
				//position the task Fab over the checkbox
				var offset = angular.element($event.currentTarget).offset()
				$rootScope.docTask.openFab(offset, task, $event.currentTarget)
			}
		}
	})
})();
(function() {
		auStickyNoteController.$inject = ["$scope"];
	angular
		.module('alignus.directives')
		.directive('auStickyNote', function() {
			return {
				templateUrl: '/app/alignus/directives/au-sticky-note/au-sticky-note.tmpl.html',
				controller: auStickyNoteController,
				controllerAs: 'vm',
				scope: {}
			} // end directive configuration
		});

		/* @ngInject */
		function auStickyNoteController($scope) {
			var vm = this
			// StickyNotes is an array of
			// { Text: String, _id: StringifiedDate }
			vm.stickies = $rootScope.user.Settings.StickyNotes || []
			// placeholder model for newest sticky note
			vm.newSticky = {}

			vm.sortOptions = {
				orderChanged: function($event) {
					vm.saveStickies()
				}
			}

			vm.addSticky = function($event) {
				// if the keypress wasn't "enter", forget it
				if($event.keyCode && $event.keyCode != 13) return;
				// make a new sticky id
				vm.newSticky._id = new Date().toString()
				// store a copy of the new sticky in their stickies
				vm.stickies.push(angular.copy(vm.newSticky))
				// save the stickies
				vm.saveStickies()
				vm.newSticky.Text = ''
			}

			vm.removeSticky = function(index) {
				vm.stickies.splice(index, 1)
				return $rootScope.user.setSetting({StickyNotes: vm.stickies})
			}

			vm.saveStickies = function() {
				// the stickies are just a setting
				return $rootScope.user.setSetting({StickyNotes: vm.stickies})
			}
		}
})();
(function() {
	'use strict';
	angular
		.module('alignus.directives')
		.directive('auShareInVideoButton', function() {
			return {
				templateUrl: '/app/alignus/directives/au-share-in-video-button/au-share-in-video-button.tmpl.html',
				scope: {
					item: '='
				}
			}
		})
})();
(function() {
    'use strict';

    angular
        .module('alignus.directives')
        .directive('auShare', function() {
            auShareController.$inject = ["$scope", "$element", "$compile", "Schema", "$mdDialog"];
            return {
                scope: {
                    auShareItems: '<'
                },
                controller: auShareController,
                controllerAs: 'vm'
            } // end directive recipe
            /* @ngInject */
            function auShareController($scope, $element, $compile, Schema, $mdDialog) {
                var vm = this
                var itemsToShare

                itemsToShare = $scope.auShareItems

                // normalize itemsToShare to array
                if(itemsToShare && !(itemsToShare instanceof Array)) {
                    itemsToShare = [itemsToShare]
                }

                //add the ng-click
                $element.wrap($compile('<div ng-click="vm.openShareDialog($event)"></div>')($scope))
                
                vm.openShareDialog = function($event) {
                    $mdDialog.show({
                        controller: 'UniversalShareController',
                        controllerAs: 'vm',
                        templateUrl: '/app/social/dialogs/universal-share.tmpl.html',
                        locals: {
                            options: {
                                itemToShare: itemsToShare      
                            }
                        },
                        targetEvent: $event
                    })
                }
            } // end auShareController
        }) // end call to angular.directive
})();
(function () {
    'use strict';

    controller.$inject = ["$scope", "$rootScope", "$compile", "$element", "toast", "$filter", "$state", "$timeout", "$interval", "$window", "$sce", "$q", "$parse", "s3Service", "ItemViewer", "Schema", "socket", "User", "Task", "windowFab", "oneSearch"];
    angular
        .module('alignus.directives')
        .directive('auRichText', auRichText);

    /* @ngInject */
    function auRichText() {
        var directive = {
            scope: true,
            bindToController: {
                html: '=?',
                scrollbars: '=?',
                trackChanges: '=?',
                stickyToolbar: '@?',
                // doc: '=?',
                // item: '=?',
                // itemField: '@',
                // displayMode: '@',
                // extraPlugins: '@',
                // placeholder: '@',
                // autoSave: '@',
                // autoFocus: '=',
                // projectId: '=?',
                // meetingId: '=?',
                // documentId: '=?',
                // resizeTrigger: '=?',
                height: '@?',
                // canEdit: '=?',
                // acl: '@',
                // processContent: '=',
                // onEnter: '=?',
                // onKeyPress: '=?',
            },
            controller: controller,
            link: link,
            controllerAs: 'vm',
            templateUrl: '/app/alignus/directives/au-rich-text/au-rich-text.tmpl.html',
            restrict: 'A'
        };
        return directive;
    }

    /* @ngInject */
    function controller($scope, $rootScope, $compile, $element, toast, $filter, $state, $timeout, $interval, $window, $sce, $q, $parse, s3Service, ItemViewer, Schema, socket, User, Task, windowFab, oneSearch) {
        var vm = this, scrollHooked = false, toolbarLocked = false

        ///////////////////////////////////////////////////////////////////
        // set up the editor
        ///////////////////////////////////////////////////////////////////

        if (vm.stickyToolbar === undefined) vm.stickyToolbar = true

        var inner = $element.find('.au-rich-text')
        var innerBody = $element.find('.inner-body')
        var outerBody = $element.find('.outer-body')
        var toolbar = $element.find('.toolbar')
        var scrollContainer = $element.scrollParent()
        // text.html()

        var options = {
            element: innerBody[0],
            handleEvents: true,
            currentUser: { id: $rootScope.user._id, name: $rootScope.user.toString() },
            plugins: ['IceAddTitlePlugin', 'Indent', 'IceEmdashPlugin', 'IceCopyPastePlugin']
        }
        var editor = new ice.InlineChangeEditor(options)
        editor.initialize()
        if (vm.trackChanges) editor.enableChangeTracking();

        ///////////////////////////////////////////////////////////////////////
        //  UI/UX handling
        ///////////////////////////////////////////////////////////////////////

        function sizeEditor(init) {
            resetToolbar()
            setTimeout(handleScroll, 1)

            var myWidth = $element.width()
            var myHeight = outerBody.height()
            vm.width = 'small'
            if (myWidth > 640) vm.width = 'medium'
            if (myWidth > 960) vm.width = 'large'
            $element.addClass(vm.width)
            innerBody.addClass(vm.width)

            //set the height of the editor
            if (vm.height) {
                if (vm.height == "fill") {
                    innerBody.css('min-height', $element.parent().height() - parseInt(outerBody.css('margin-top')) - parseInt(innerBody.css('margin-top')) - parseInt(innerBody.css('margin-bottom')))
                } else {
                    innerBody.css('height', vm.height - parseInt(toolbar.height()))
                }
            }

            //either set up for scrolling for making the toolbar sticky
            if (vm.scrollbars) {
                outerBody.css('max-height', parseInt(innerBody.css('min-height')) + parseInt(innerBody.css('margin-top')) + parseInt(innerBody.css('margin-bottom')))
                outerBody.css('overflow-y', 'auto')
                innerBody.css('overflow', 'inherit')
            } else if (vm.stickyToolbar && !scrollHooked) {
                scrollHooked = true
                scrollContainer.on("scroll.auRichText", handleScroll)
            }

        }

        function handleScroll() {
            if ($element.offset().top - scrollContainer.offset().top < parseInt(scrollContainer.css('padding-top'))) {
                if (toolbarLocked || !toolbar.is(":visible")) return

                //the first time the toolbar is about to scroll out, capture the left, height and width within the browser window
                var clientRect = toolbar[0].getClientRects()[0]

                //the fixed is the container's top + border-top + padding-top
                var top = scrollContainer.offset().top
                if (scrollContainer.css('border-top') != '0px') {
                    top += parseInt(scrollContainer.css('border-top'))
                }

                // //clip any content that the container would show because of padding -- primarily for list-item-viewer
                // if (scrollContainer.css('padding-top') != '0px') {
                //     contentClipper.css({ position: 'fixed', top: top, left: clientRect.left, height: clientRect.top - scrollContainer.offset().top + 10, width: clientRect.width - 17 }).fadeIn()
                // }

                //move the toolbar past any padding
                top += parseInt(scrollContainer.css('padding-top'))

                //determine the left of the toolbar
                var toolbarLeft = clientRect.left

                //can we go all the up the parent chain to find something fixed? if yes, don't adjust the left
                //else, can we go all the up the parent chain to find something absolute? if yes, subtract that things left
                var isFixed = isElementPositioned(scrollContainer, 'fixed')
                var isAbsolute = isElementPositioned(scrollContainer, 'absolute')
                if (!isFixed && isAbsolute) toolbarLeft -= scrollContainer.offset().left

                //fix the toolbar to the viewport
                toolbar.css({ position: 'fixed', top: top, left: toolbarLeft, width: clientRect.width, opacity: 1 })

                toolbarLocked = true
            } else {
                resetToolbar()
            }
        }

        function resetToolbar() {
            //reset toolbar so it doesn't float out of place when the window is resized
            toolbar.css({ position: 'absolute', top: "", left: "", right: "", bottom: "", width: "", opacity: "" })
            toolbarLocked = false
        }

        //size the editor on load and window-resize
        sizeEditor()
        $rootScope.$on('window-resized', sizeEditor)

        function isElementPositioned(el, position) {
            var $el = angular.element(el);
            while (!$el.is(document)) {
                if ($el.css("position") === position) {
                    return $el;
                }
                $el = $el.parent();
            }
            return false;
        }






        ////////////////////////////////////////////////////////////////////////
        // ice samples
        ////////////////////////////////////////////////////////////////////////

        vm.hasClass = function (className) {
            return $element.hasClass(className)
        }


        //can read, etc.

        vm.toggleDel = function (el) {
            if (text.hasClass('CT-hide')) {
                text.removeClass('CT-hide');
            } else {
                text.addClass('CT-hide');
            }
        }

        vm.insertSampleImage = function () {
            var range = tracker.getCurrentRange();
            if (!ice.dom.isChildOf(range.startContainer, text)) {
                return false;
            }
            var image = document.createElement('img');
            image.src = "http://graphics8.nytimes.com/images/2012/01/15/business/ONEPERCENT/ONEPERCENT-popup.jpg";
            image.width = 160;
            tracker.insert(image, range);
            text[0].focus();
        }
    } //end controller

    function link(scope, element, attrs, ctrl) {
        var vm = ctrl
        console.log('in link')
    } //end link

})();

(function() {
		auProjectOverviewController.$inject = ["$scope", "$rootScope", "$state"];
	angular
		.module('alignus.directives')
		.directive('auProjectOverview', function() {
			return {
				templateUrl: '/app/alignus/directives/au-project-overview/au-project-overview.tmpl.html',
				controller: auProjectOverviewController,
				controllerAs: 'vm',
				scope: {}
			} // end directive configuration
		});

		/* @ngInject */
		function auProjectOverviewController($scope, $rootScope, $state) {
			var vm = this

			fetchProjects()

// 			$scope.$on('itemAdded', function(event, newItem) {
// 				if(newItem.$key == 'Project' && newItem.UserIsInvolved($rootScope.user._id)) {
// 					fetchProjects()
// 				}
// 			})

			function fetchProjects() {
				vm.projects = $rootScope.user.getMyProjects()
			}

			vm.goToProjects = function() {
				return $rootScope.user.goToUsersProjects()
			}

			vm.openProject = function(project) {
				$rootScope.$broadcast('openNewItem', project)
			}
		}
})();
(function () {
    'use strict';

    angular
        .module('alignus.directives')
        .directive('auProfileImage', ["$filter", "$compile", "$timeout", "User", "auUtility", "auSuspendable", "Schema", function ($filter, $compile, $timeout, User, auUtility, auSuspendable, Schema) {
            return {
                templateUrl: '/app/alignus/directives/au-profile-image/au-profile-image.tmpl.html',
                scope: {
                    user: "<?",
                    item: "<?",
                    itemType: '@?',
                    size: "=?",
                    watchSize: '@'
                },
                link: link,
                transclude: true
            }

            function link($scope, $element, $attrs, $controller) {
                var memberWatcher, itemStringWatcher, itemPhotoWatcher, memberWatcherDebounce, rebind

                //html is required to be <span> so ckEditor believes the element can be inline
                $element.addClass('layout-column');

                var saveWatch
                if ($scope.user) {
                    $scope.$watch('user', bindItem)
                } else {
                    $scope.$watch('item._id', bindItem)
                }

                //we know the first watcher in $$watchers is the one we want to keep ($watch uses unshift)
                //we want to suspend this $scope but always have the first watcher returned (if the item/user changes) like in a virtual-repeat
                $scope.$alwaysWatch = [$scope.$$watchers[0]]
                setTimeout(function () {
                    auSuspendable.suspend($scope)
                }, 1000)

                function bindItem(newVal, oldVal) {
                    rebind = true
                    
                    showProfile()

                    //if in a virtual-repeat, stale the scope to get the $digest to render the current image
                    auSuspendable.stale($scope)
                }

                //in a virtual-repeat, the profile never changes size and we never use hovers in virtual-repeaters
                if (rebind) return

                //the fontSize is calculated based on the size
                if (!$scope.size) $scope.size = 50
                if ($scope.watchSize) {
                    $scope.$watch('size', updateSize)
                    $scope.$alwaysWatch.push($scope.$$watchers[0])
                } else updateSize()
                function updateSize() {
                    $element.css('min-width', $scope.size);
                    $scope.fontSize = (parseInt($scope.size) / 2.0 || '25') + 'px';
                    auSuspendable.stale($scope)
                }

                //find the hover
                $scope.hover = $element.find("hover")
                if ($scope.hover.length) {
                    //after everything is linked, find the hover content
                    $timeout(function () {
                        var container = $element.find(">.au-profile-image-container")
                        container.hover(function () {
                            //on hover
                            if ($scope.item && $scope.item.$selected) {
                                //do nothing
                            } else {
                                showHover()
                            }
                        }, function () {
                            //on un-hover
                            if ($scope.item && $scope.item.$selected) {
                                //do nothing
                            } else {
                                hideHover()
                            }
                        })

                        $scope.$on('item-selected', function (event, item) {
                            if (item != $scope.item) return

                            if (item.$selected) {
                                showHover()
                            } else {
                                hideHover()
                            }
                        })

                        function showHover() {
                            $element.find('> .au-profile-image-container > .normal').addClass('display-none')
                            $element.find('> .au-profile-image-container > .hover').removeClass('display-none')
                        }
                        function hideHover() {
                            $element.find('> .au-profile-image-container > .normal').removeClass('display-none')
                            $element.find('> .au-profile-image-container > .hover').addClass('display-none')
                        }

                    }, 100, false)
                }

                

                //--end link procedurual code -- functions below

                function hideAll() {
                    $scope.showInitials = false;
                    $scope.showPhotoBackground = false;
                    $scope.showCompositeImage = false;
                    $scope.photoBackground = undefined
                    $scope.compositeImage = undefined
                }

                //when the user object changes (like in a virtual repeat), update the profile
                function showProfile() {
                    //defaults
                    hideAll()

                    if (itemStringWatcher) {
                        itemStringWatcher()
                        itemStringWatcher = undefined
                    }
                    if (itemPhotoWatcher) {
                        itemPhotoWatcher()
                        itemPhotoWatcher = undefined
                    }

                    //get a item if passed a user or string
                    if (!$scope.item && $scope.user) {
                        $scope.item = $scope.user
                    }

                    //if the passed data is a string, get a user from it
                    if (typeof $scope.item == "string") {
                        //show Al Linus if the string is all zeros
                        if ($scope.item == '0'.repeat(24)) {
                            $scope.showPhotoBackground = true
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/al.png'
                            return;
                        }

                        //otherwise, get the user by id
                        if ($scope.itemType) {
                            $scope.item = Schema.resource($scope.itemType).getCache({ _id: $scope.item })[0]
                        } else {
                            $scope.item = User.getCache({ _id: $scope.item })[0]
                        }
                    }

                    //if we don't have an item, set up a generic photoBackground
                    if (!$scope.item) {
                        $scope.showPhotoBackground = true
                        $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/au.png'
                        return;
                    }

                    //hook into suspendable
                    $scope.updateOnItem = $scope.item.$key + '-' + $scope.item._id

                    //the notification page should just show Al Linus
                    if ($scope.item.Title == '##AlLinus##') {
                        $scope.showPhotoBackground = true
                        $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/al.png'
                        return
                    }

                    //a page w/ only one member (certainly the current user!) - switch the item to the only member
                    if ($scope.item.$key == "Page" && ($scope.item.Type == 'Conversation' || $scope.item.Type == 'Discussion') && $scope.item.Members.length == 1) {
                        $scope.item = $scope.item.$Members[0]
                    }

                    //register the photo watch in case the user (w/ no Photo) chooses a Photo
                    itemPhotoWatcher = $scope.$watch('item.PhotoLastUpdated', updatePhoto)

                    //if we have a photo, the watch will have used that, no more to do
                    if ($scope.item.Photo) {
                        return
                    } else {
                        //set up static photoBackgrounds for most items (not pages)
                        if ($scope.item.Type == "Event") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/event.png'
                        } else if ($scope.item.$key == "Post") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/post.png'
                        } else if ($scope.item.$key == "Project") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/project.png'
                        } else if ($scope.item.$key == "Task") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/task.png'
                        } else if ($scope.item.$key == "Document") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/document.png'
                        } else if ($scope.item.$key == "Question") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/question.png'
                        } else if ($scope.item.$key == "Meeting") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/meeting.png'
                        } else if ($scope.item.$key == "QuestionTag") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/tag.png'
                        } else if ($scope.item.$key == "Handbook") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/handbook.png'
                        } else if ($scope.item.$key == "HandbookEntry") {
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/handbook.png'
                        }

                        //if we have a photoBackground, we're done
                        if ($scope.photoBackground) {
                            $scope.showPhotoBackground = true
                            return
                        }
                    }

                    //show a compositeImage for the members of the page
                    if ($scope.item.$key == 'Page' && $scope.item.Members.length > 1) {
                        $scope.showCompositeImage = true
                        $scope.compositeImage = buildCompositeProfileImage()
                        return
                    }

                    //since no code above returned, show initials
                    itemStringWatcher = $scope.$watch('item.toString()', function (newVal, oldVal) {
                        //using suspendable does not deregister the watch so we need to look at the variable
                        if (!itemStringWatcher) return

                        if ($scope.item.Photo) return
                        if ($scope.showCompositeImage) return
                        if (newVal == $scope.initials) return

                        if ($scope.item.FirstName) {
                            $scope.initials = $scope.item.FirstName ? $scope.item.FirstName.slice(0, 1).toUpperCase() + $scope.item.LastName.slice(0, 1).toUpperCase() : $scope.item.Name.slice(0, 1).toUpperCase()
                        } else if ($scope.item.Name) {
                            $scope.initials = $scope.item.Name[0]
                        } else if ($scope.item.Title) {
                            $scope.initials = $scope.item.Title[0]
                        } else if ($scope.item.QuestionTitle) {
                            $scope.initials = $scope.item.QuestionTitle[0]
                        } else {
                            //we couldn't determine the initials so show a generic icon
                            $scope.showPhotoBackground = true
                            $scope.photoBackground = 'https://s3.amazonaws.com/alignusstatic/UI/avatars/au.png'
                            return
                        }

                        if ($scope.item.Color) {
                            $scope.color = $scope.item.Color
                        } else {
                            $scope.color = getColor()
                        }

                        hideAll()
                        $scope.showInitials = true
                    })
                } // end showProfile

                function updatePhoto(newVal, oldVal) {
                    //using suspendable does not deregister the watch so we need to look at the variable
                    if (!itemPhotoWatcher) return

                    if (!$scope.item.Photo) return;
                    hideAll()
                    $scope.photoBackground = auUtility.s3UrlFromId($scope.item.Photo)
                    $scope.photoQS = new Date($scope.item.PhotoLastUpdated).getTime()
                    $scope.showPhotoBackground = true
                    auSuspendable.stale($scope)
                }

                function buildCompositeProfileImage() {
                    var imageHtml = '', pageMembers = angular.copy($scope.item.$Members) || []

                    //only show members that fit
                    var photoWidth = parseInt($scope.size) / (pageMembers.length - 1) //subtract one to remove yourself
                    if (photoWidth < 10) photoWidth = 10
                    var maxPhotos = Math.ceil(parseInt($scope.size) / photoWidth)

                    for (var i = 0; i < pageMembers.length && i <= maxPhotos; i++) {
                        var member = pageMembers[i]

                        //skip yourself
                        if (member._id == $rootScope.user._id) continue

                        if (member.Photo) {
                            var photoUrl = auUtility.s3UrlFromId(member.Photo)
                            imageHtml += '<span class="composite-image-slice" style="background-image:url(\'{0}\');width:{1}px;height:{3}px;opacity:{2}"></span>'.format(photoUrl, String(photoWidth), member.IsOnline ? 1 : .3, $scope.size)
                        } else {
                            var inital = member.FirstName ? member.FirstName[0] : '?'
                            imageHtml += '<span class="composite-image-slice initials-image" style="background-color:{0};width:{1}px;font-size:{2};border-radius:0;opacity:{3}">{4}</span>'.format(member.Color, String(photoWidth), $scope.fontSize, member.IsOnline ? 1 : .3, inital)
                        }
                    }
                    return imageHtml
                }

                function getColor() {
                    try {
                        var str = $scope.initials
                        for (var i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash));
                        var color = Math.floor(Math.abs((Math.sin(hash) * 10000) % 1 * 16777216)).toString(16);
                        return '#' + Array(6 - color.length + 1).join('0') + color;
                    } catch (e) {
                        //the color will be red
                    }

                }
            }
        }]);
})();
(function () {
    'use strict';

    controller.$inject = ["$scope", "$element", "$interval", "$rootScope", "$interpolate", "toast", "Schema", "$templateCache", "Page", "ngDialog"];
    angular
        .module('alignus.directives')
        .controller('AuPostController', controller)
        /* @ngInject */
        .directive('auPost',
        function () {
            return {
                scope: {
                    post: '=',
                    hideHeader: '=?'
                },
                controller: 'AuPostController',
                controllerAs: 'vm',
                templateUrl: '/app/alignus/directives/au-posts/au-post.tmpl.html',
                restrict: 'AE'
            }
        });


    /* @ngInject */
    function controller($scope, $element, $interval, $rootScope, $interpolate, toast, Schema, $templateCache, Page, ngDialog) {
        var vm = this
        $scope.toolbarIsOpen = false
        vm.editMode = false

        vm.post = $scope.post
        vm.hideHeader = $scope.hideHeader
        vm.feedType = $element.closest('[au-post-feed]').attr('feed-type')

        //the tmpl was having a hard time using this whole line in an ng-if to show the pin button
        vm.showPinButton = (vm.feedType == 'Page') && vm.post.$Page.IsUserEditor($rootScope.user._id)
        vm.showComments = (vm.post.Comments.length > 0)
        vm.labelsAvailable = vm.post.$Page && (!!vm.post.$Page.SideBarWidgets.filter(function (widget) { return widget.Type == "au-page-filter-posts" }).length)

        if (vm.labelsAvailable) {
            var labelWidget = vm.post.$Page.SideBarWidgets.filter(function (widget) { return widget.Type == "au-page-filter-posts" })[0]
            vm.possibleLabels = labelWidget.Data
        }

        vm.newComment = { 'Comment': '', 'User': $rootScope.user._id, }

        vm.getTemplate = function () {
            if (!vm.post.Type) return null
            return '/app/alignus/directives/au-posts/' + vm.post.Type.toLowerCase() + '.tmpl.html'
        }

        vm.getShareTemplate = function (type) {
            if (!type) return '/app/alignus/directives/au-posts/sharegeneric.tmpl.html'

            var templatePath = '/app/alignus/directives/au-posts/share' + type.toLowerCase() + '.tmpl.html'
            if ($templateCache.get(templatePath)) {
                return templatePath
            } else {
                return '/app/alignus/directives/au-posts/sharegeneric.tmpl.html'
            }
        }

        //this hacky, stange, function is the only time-tested method to actually keep the toolbar open
        vm.keepToolbarOpen = function ($event) {
            $event.stopPropagation()
            $scope.toolbarIsOpen = false
            $scope.toolbarIsOpen = true
        }

        vm.togglePagePinned = function ($event) {
            $element.slideUp()
            vm.post.IsPinned = !vm.post.IsPinned
            vm.post.$updateItem()

            $rootScope.$broadcast('displayPosts' + vm.post.Page + '.pinnedPosts')
            $rootScope.$broadcast('displayPosts' + vm.post.Page)
            $rootScope.$broadcast('postPinnedOrUnpinned' + vm.post.Page)
        }

        vm.toggleUnfPinned = function ($event) {
            //if the user is unpinning it
            if (vm.post.$UNF.Pinned && !vm.post.$userIsTogglingPinned) $element.slideUp()
            else vm.keepToolbarOpen($event)

            vm.post.$UNF.Pinned = !vm.post.$UNF.Pinned
            vm.post.$UNF.$updateItem()

            //indicate that the user must be toggling from read to unread and back
            vm.post.$userIsTogglingPinned = true

            $rootScope.$broadcast('postMoved')
        }

        vm.toggleUnfRead = function ($event) {
            //set the new state and send it to the server
            vm.post.$UNF.Read = !vm.post.$UNF.Read
            vm.post.$UNF.$updateItem()

            //if the user just marked it read
            if (vm.post.$UNF.Read && !vm.post.$userIsTogglingRead) $element.slideUp()
            else vm.keepToolbarOpen($event)

            //indicate that the user must be toggling from read to unread and back
            vm.post.$userIsTogglingRead = true

            //ensure we load more posts
            $rootScope.$broadcast('postMoved')
        }

        // toggles whether or not the user likes this post
        vm.toggleLike = function ($event) {
            // if they like the post, unlike it and show a toast
            if (vm.post.doesCurrentUserLikePost()) {
                vm.post.unlike()
                toast.success('Like removed')
            } else {
                vm.post.like()
                // like button will darken automatically here due to an ng-class on the button
            }
        }

        vm.togglePostLabel = function (label) {
            if (!vm.post.$Page.IsUserEditor($rootScope.user._id)) {
                return toast.toast('You must be a page editor to change a post\'s labels.')
            }

            var idx = vm.post.Labels.indexOf(label)
            if (idx == -1) {
                vm.post.Labels.push(label)
            } else {
                vm.post.Labels.splice(idx, 1)
            }

            //don't use .addComment because that causes a POST, too, and that messes things up
            vm.newComment._id = (new ObjectId()).toString()
            vm.newComment.Comment = (idx == -1 ? 'Added' : 'Removed') + " label <span class='auto-comment-label md-whiteframe-1dp'><i class='zmdi zmdi-label margin-right-5'></i> " + label + "</span>"
            vm.post.Comments.push(angular.copy(vm.newComment))
            vm.newComment.Comment = ''

            vm.post.$updateItem()

            vm.showComments = true
            vm.scrollComments()
        }

        // gets the text displayed on the "like" button
        vm.getLikeButtonText = function () {
            var text = (vm.post.Likes.length.toString() + ((vm.post.Likes.length == 1) ? ' Like' : ' Likes'))
            return text
        }

        vm.getWhoLikesString = function () {
            switch (vm.post.Likes.length) {
                case 0:
                    return
                case 1:
                    return $filter('auItemFilter')(vm.post.Likes[0].User, 'User') + ' liked this'
                default:
                    return $filter('firstNameFilter')(vm.post.Likes[vm.post.Likes.length - 1].User) + ' and ' + (vm.post.Likes.length - 1).toString() + ' others liked this'
            }
        }

        vm.editPost = function ($event) {
            vm.editMode = true
        }

        vm.editComplete = function () {
            vm.editMode = false
        }

        vm.removePost = function ($event) {
            $mdDialog.show($mdDialog.confirm({
                title: 'Remove Post',
                htmlContent: (vm.post.Creator == $rootScope.user._id ? '' : 'As an editor of this page, you are allowed to remove ' + vm.post.$Creator.FirstName + "'s post.<br><br>") + "Are you sure you want to remove this post from the system and everyone's News Feed?",
                ok: 'Remove Post',
                cancel: 'Cancel',
                targetEvent: $event
            })).then(function () {
                // remove the document if they confirmed
                $element.slideUp('slow')
                vm.post.$removeItem().catch(function () {
                    toast.error('Error removing task - permission denied.')
                    $element.slideDown('slow')
                })
            })
        }

        vm.toggleComments = function () {
            vm.showComments = !vm.showComments;
        }

        var commentEl
        vm.scrollComments = function () {
            if (!commentEl) {
                poll(function () {//when
                    return $element.find('.comments-list').length > 0
                }, function () {//then
                    commentEl = $element.find('.comments-list')
                }, angular.noop, 1000, 50)

            }
            $interval(function () {
                commentEl.scrollTop(9999999)
            }, 250, 8, false)
        }

        vm.addCommentClicked = function ($event) {
            //look for mentions - they look like this: <span class="doc-mention Page" data-item-type="Page" data-item-id="589a1be67f7e3f141eee3382" data-cke-filter="off" title="Page">Super User</span>
            if (vm.newComment.Comment.indexOf('doc-mention') > 0) {
                var commentNode = angular.element(vm.newComment.Comment)
                commentNode.find('.doc-mention').each(function (i, mention) {
                    if (this.attributes['data-item-type'].value == 'User') {
                        var user = this.attributes['data-item-id'].value
                        if (!vm.newComment.Tagged) {
                            vm.newComment.Tagged = []
                            vm.newComment.Tagged.push(user)
                        } else if (vm.newComment.Tagged.indexOf(user) == -1) {
                            vm.newComment.Tagged.push(user)
                        }
                    }
                })
            }

            vm.newComment._id = (new ObjectId()).toString()
            vm.post.addComment(angular.copy(vm.newComment))
            vm.newComment.Comment = ''
            vm.scrollComments()

            //discard the new line
            $event.cancel()
        }

        // POLL
        // lots of these should totally be in the resource...
        vm.pollHasUserResponded = function () {
            return vm.poll.AlreadyResponded.map(function (responseObj) {
                return responseObj.User
            }).indexOf($rootScope.user._id) > -1
        }

        vm.pollSubmitResponse = function (isVotingFor) {
            vm.post.pollVoteForResponse(isVotingFor)
                .then(function () {
                    vm.pollInitChartData()
                })
        }

        vm.pollIsPollClosed = function () {
            if (vm.poll)
                return new Date() > new Date(vm.poll.End)
        }

        vm.pollDoesPollHaveResponses = function () {
            return (vm.poll.AlreadyResponded.length > 0)
        }

        vm.pollInitChartLabels = function () {
            vm.pollChartLabels = vm.poll.PossibleResponses.map(function (response) {
                return response.Response
            })
        }

        vm.pollInitChartData = function () {
            vm.pollChartData = vm.poll.PossibleResponses.map(function (response) {
                return response.ResponseCount
            })
        }

        vm.pollGetThisUsersResponse = function () {
            if (!vm.poll.AlreadyResponded) return
            for (var i = 0; i < vm.poll.AlreadyResponded.length; i++) {
                if (vm.poll.AlreadyResponded[i].User == $rootScope.user._id) {
                    return vm.poll.AlreadyResponded[i]
                }
            }
        }

        vm.goToUserPage = function (id) {
            $state.go('shell.social.page', { id: id })
        }

        vm.goToSharedQuestion = function () {
            $state.go('shell.social.question', { id: vm.post.Data.Question })
        }

        vm.goToSharedDocument = function () {
            $state.go('shell.documents.document', { id: vm.post.Data.Document.Document })
        }

        vm.goToSharedTask = function () {
            $state.go('shell.project.task', { id: vm.post.Data.TaskUpdate.Task })
        }

        vm.goToSref = function () {
            ngDialog.close()
            $state.go('shell.' + vm.post.Data.Button.Href)
        }

        vm.goToLink = function () {
            window.open(vm.post.Data.Button.Link, '_blank')
        }

        //Trying to change state to single item view without losing main navigation
        vm.goToMyPage = function () {
            Page.getCache({ _id: $rootScope.user._id })[0].open('new')
        }

        function pollVoteForResponse(response) {
            // find that response
            for (var i = 0; i < vm.poll.PossibleResponses.length; i++) {
                if (vm.poll.PossibleResponses[i].Response == response) {
                    // increment its response count
                    vm.poll.PossibleResponses[i].ResponseCount++
                }
            }
            // refresh the chart data
            vm.pollInitChartData()
        }

        function pollMarkUserResponded() {
            vm.poll.AlreadyResponded.push({
                User: $rootScope.user._id,
                VotedFor: vm.isVotingFor,
                VotedAt: new Date()
            })
        }

        function initPoll() {
            // convenience
            vm.poll = vm.post.Data.Poll
            // lazy-load array of AlreadyResponded
            if (!vm.poll.AlreadyResponded) {
                vm.poll.AlreadyResponded = []
            }
            // vm.$displayPollEnd = new Date(vm.poll.End).toLocaleString()
            // initialize chart model
            vm.pollInitChartLabels()
            vm.pollInitChartData()
        }

        function initTaskUpdate() {
            vm.sharedTask = Schema.resource('Task').getCache({ _id: vm.post.Data.TaskUpdate.Task })[0]
        }

        function initUniversalShare() {
            vm.sharedItems = vm.post.Data.Share.SharedItems.map(function (item) {
                return Schema.resource(item.Type).getCache({ _id: item.Id })[0]
            })
        }

        switch (vm.post.Type) {
            case 'Poll':
                initPoll();
                break;
            case 'Share':
                initUniversalShare()
                break;
            case 'TaskUpdate':
                initTaskUpdate();
                break;
            default:
                break;
        }

        $scope.$on('itemUpdated', function (event, item) {
            if (item.$key == 'Post' && item._id == vm.post._id) {
                switch (item.Type) {
                    case 'Share':
                        initUniversalShare();
                        break;
                    case 'Poll':
                        initPoll();
                        break;
                    default:
                        break;
                }
            }
        })

        $scope.$on('post-removed-from-feed', function (event, item_id) {
            if (vm.post.$UNF && vm.post.$UNF._id == item_id) {
                $element.slideUp()
            }
        })

        vm.getS3ImgUrl = function (document) {
            return auUtility.s3UrlFromId(document.Id)
        }

        //the post-feed will directly ng-include an au-post when a feed.template is used, which has it's own image columns, so don't bother trying to find the container (you're already in it)
        if ($element[0].nodeName != '#comment') {
            poll(function () { //when
                return $element.find('.au-post-container').children().length > 0
            }, determineImgCols, angular.noop, 10000, 500)
        }

        vm.imgCols = 0
        function determineImgCols() {
            vm.elWidth = $element.width()
            vm.imgCols = parseInt(vm.elWidth / 150) || 1
        }

        vm.openDocument = auUtility.peekDocument

        vm.openAddTaskDialog = function ($event) {
            $mdDialog.show({
                controller: 'AddTaskDialog',
                controllerAs: 'vm',
                templateUrl: '/app/project/dialogs/add-task.tmpl.html',
                targetEvent: $event,
                locals: {
                    options: {
                        defaultDetails: "<p>&nbsp;</p><p>&nbsp;</p><p>Reference: <span contenteditable=\"false\" class=\"doc-mention Post\" data-item-type=\"Post\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"{1}\">{1}</span>.</p><div contenteditable=\"false\" class='au-post material-card material-shadow layout-column' style='margin: 0 !important;'><md-card-header class=\"header layout-align-start-center layout-row\"><span class=\"md-body-2 flex-100\" style=\"color:#FFF;\">{3}<span class='md-caption padding-left-20' style='font-weight: normal;'><i class='zmdi zmdi-caret-right' style='font-size: 14px;'></i> &nbsp; {5}</span></span><span class=\"timestamp\" style='text-align: right; white-space: nowrap;'>Posted {4}</span></md-card-header><div style='padding: 20px;'>{2}</div><br/><br/>".format(vm.post._id, vm.post.toString().substr(0, 150), vm.post.Data.Update, vm.post.$Creator.FirstName + ' ' + vm.post.$Creator.LastName, moment(vm.post.DateCreated).format('MMM Do YYYY, h:mm a'), vm.post.$Page.Title),
                        defaultTitle: vm.post.toString().substr(0, 50),
                        skipIntro: true,
                        fromPost: vm.post
                    }
                }
            })
        }
    } //controller end

    //there really is no good event to know when a node is inserted into the dom but this pattern works!
    //https://davidwalsh.name/detect-node-insertion
    function insertListener(event) {
        if (event.animationName == "nodeInserted") {
            angular.element('.comments-list:not(.inited)').each(function (idx, node) {
                setScroll(node)
                node.classList.add('inited')
            })

        }
    }

    function setScroll(el) {
        if (el.scrollHeight > el.clientHeight) {
            el.scrollTop = el.scrollHeight - el.clientHeight
        }
    }

    document.addEventListener("animationstart", insertListener, false); // standard + firefox
    document.addEventListener("MSAnimationStart", insertListener, false); // IE
    document.addEventListener("webkitAnimationStart", insertListener, false); // Chrome + Safari
})();
(function () {
    'use strict';

    angular
        .module('alignus.directives')
        /**
         * @ndgoc directive
         * @module alignus.directives
         * @name auPostFeed
         * @restrict AE
         *
         * @param {object} au-post-feed A collection to query
         * @param {object} query The query to use
         * @param {object} at-scroll-end A
         *
         * @description
         * Renders posts from a collection that match the query.
         *
         * @usage
         * <div au-post-feed="Page" query="{_id: feed.item._id}"></div>
         *
         */
        /* @ngInject */
        .directive('auPostFeed', ["$rootScope", "$timeout", "$compile", "$mdDialog", "$filter", "$q", "$interval", "$interpolate", "$templateCache", "auUtility", "Schema", "ItemViewer", "Post", "Page", "ActivityLog", function ($rootScope, $timeout, $compile, $mdDialog, $filter, $q, $interval, $interpolate, $templateCache, auUtility, Schema, ItemViewer, Post, Page, ActivityLog) {
            controller.$inject = ["$scope", "$element"];
            return {
                scope: {
                    auPostFeed: '=?',
                    pageId: '=',
                    watchScroll: '=?',
                    activityLog: '=?',
                    recentOn: '@',
                    onScroll: '=?',
                    template: '@?',
                    feedType: '@',
                    search: '=?',
                    orderBy: '@?',
                    excludePinned: '=?',
                    postsOnly: '=?',
                    feedId: '@?',
                    noEmptyInstructions: '=?',
                    hideHeaders: '=?'
                },
                controller: controller,
                controllerAs: 'feed',
                templateUrl: '/app/alignus/directives/au-posts/au-post-feed.tmpl.html',
                restrict: 'AE'
            }

            //goal: keep ng-repeat as simple as possible to improve it's otherwise terrible performance
            //expect an ng-repeat to display all feed.visiblePosts tracked by _id
            //expect feed.visiblePosts to be and array of Post resources where the ordinal index is the sort order - so it's up to whatever is hosting the au-post-feed to return posts in the desired display order

            /* @ngInject */
            function controller($scope, $element) {
                var feed = this
                feed.showEmptyState = false
                feed.noEmptyInstructions = $scope.noEmptyInstructions
                feed.template = $scope.template
                feed.feedType = $scope.feedType
                feed.feedId = $scope.feedId
                feed.backstage = $element.find('.backstage')
                feed.loadingPost = { _id: 0, $firstInGroup: true, Type: 'Update', Creator: '0'.repeat(24), Data: { Update: '<div layout="row" layout-align="start center" style="height: 20px"><div class="animated-background" style="height: 5px;width: 200px;"></div></div>' } }
                var postLoaderState = { wait: $q.resolve(), op: 0, post: null, idx: 0, el: null, status: 'initting' }

                //defaults
                if ($scope.recentOn != "bottom") $scope.recentOn = "top"
                var noMorePostsMessage = auUtility.randomEmoji() + auUtility.randomEmoji() + auUtility.randomEmoji()
                    + '<hr/>You\'re at the {0} of the feed.<hr/>'.format($scope.recentOn == "top" ? "bottom" : "top") +
                    auUtility.randomEmoji() + auUtility.randomEmoji() + auUtility.randomEmoji()

                //allow the parent element (news feed is a case) to pass a custom way to retrieve posts - the default is to show posts for a page id
                if ($element.attr('au-post-feed')) {
                    feed.getPosts = $scope.auPostFeed
                } else {
                    feed.getPosts = getPostsAndActivity
                }

                //allow the parent element to order the feed 
                if ($scope.orderBy) {
                    feed.orderBy = $scope.orderBy
                } else {
                    feed.orderBy = '-DateCreated'
                }

                //ng-if was too slow to render/hide these
                if ($scope.recentOn == "top") {
                    $element.find('.fill, .loading-message.top').hide()
                }

                //set references to the page and customize the loading message
                if ($scope.pageId) {
                    feed.pageId = $scope.pageId
                    feed.page = Page.getCache({ _id: feed.pageId })[0]

                    if ($scope.search) {
                        feed.loadingMessage = "Searching {0} for \"{1}\"".format(feed.page._placeholder ? 'this page' : feed.page.toString(), $scope.search)
                    } else {
                        //don't show an initial loading message if we're not watching the scroll (the user will click Load More)
                        if (!$scope.watchScroll) feed.loadingMessage = ""
                        else feed.loadingMessage = "Gathering {0}'s {1}s...".format(feed.page._placeholder ? 'this page' : feed.page.toString(), auUtility.randomAmbiguousTerm())
                    }
                } else {
                    feed.loadingMessage = "Spooling up {0}s, {1}s and {2}...".format(auUtility.randomAmbiguousTerm(), auUtility.randomAmbiguousTerm(), auUtility.randomEmoji())
                }

                //if there is a loading message, wrap it in cute spinnging emojies
                if (!!feed.loadingMessage) feed.loadingMessage = ("<span class='spin-forever'>{0}</span><hr/>" + feed.loadingMessage + "<hr/><span class='spin-forever'>{0}</span>").format(auUtility.randomEmoji())

                ///////////////////////////////////////////////////////////////////
                //     INIT
                ///////////////////////////////////////////////////////////////////
                function init(posts) {
                    console.log('initting post-feed')

                    feed.visiblePosts = [], feed.visiblePostsMap = {}, feed.showEmptyState = false, feed.noMorePosts = false
                    feed.lastPostReturned = 0, feed.pointersQ = [], feed.allPosts = [], feed.allActivity = [], feed.allItems = null, feed.pointersLoaded = false
                    postLoaderState = { wait: $q.resolve(), op: 0, post: null, idx: 0, el: null, status: 'initting' }

                    var getPosts
                    if (posts) {
                        getPosts = function () { return getPostsAndActivity({ items: posts }) }
                    } else getPosts = feed.getPosts

                    //show the post loading placeholder
                    $element.find('.post-placeholder-wrapper').show()
                    if (feed.template) $element.find('.post-placeholder-wrapper .discussion, .post-placeholder-wrapper .card').hide()
                    else if ($scope.recentOn == "top") $element.find('.post-placeholder-wrapper .bottom-chat, .post-placeholder-wrapper .discussion').hide()
                    else $element.find('.post-placeholder-wrapper .bottom-chat, .post-placeholder-wrapper .card').hide()

                    //in sequence... determine how many columns we need, get the posts from the server and then load them in the UI
                    determineCols().then(function () {
                        //this is the best time to scroll the feed down - anything before and it could not be rendered
                        if ($scope.recentOn == "bottom") {
                            $element.scrollParent().scrollTop(999999)
                        }
                        $element.find('.post-placeholder-wrapper .card').css('max-width', (100 / feed.columns.length) + '%')
                    }).then(getPosts).then(loadPosts)
                }

                function setNoMorePosts() {
                    postLoaderState.status = "complete"
                    feed.noMorePosts = true

                    $scope.$emit('no-more-posts')
                    feed.loadingMessage = noMorePostsMessage
                    $element.find('.post-placeholder-wrapper').hide()

                    //if there are no posts at all, show an empty state
                    if (feed.visiblePosts.length == 0) {
                        feed.showEmptyState = true
                    }
                }

                ///////////////////////////////////////////////////////////////////
                //      EVENT HANDLERS
                ///////////////////////////////////////////////////////////////////

                //re-init events
                $scope.$on('updateConversations', function () { init() })
                //$scope.$on('window-resized', debounce(function(){ init() }, 1000))
                $scope.$on('refresh-posts', function () { init() })
                $scope.$on('displayPosts' + (feed.feedId || $scope.pageId), function (event, posts) { init(posts) })

                //load more events
                $scope.$on('postMoved', function () {
                    //let the animation finish before loading`
                    setTimeout(function () {
                        loadMore(1)
                    }, 250)
                })

                // watch for trigger changes (used by au-discussion-board)
                $scope.$on('load-more-posts', function () { loadMore() })

                //attach a scroll listener to the directive container - when we scroll to the bottom we'll get more posts		
                if ($scope.watchScroll !== false) $scope.watchScroll = true
                if ($scope.watchScroll) {
                    var watchScroll
                    $timeout(function () {
                        var viewport
                        if ($element.scrollParent()[0] == document) {
                            viewport = angular.element(window)
                        } else {
                            viewport = $element.scrollParent()
                        }

                        watchScroll = debounce(function (e) {
                            //ignore scroll changes from dialogs          
                            if (angular.element('md-dialog').length) return

                            //if the postLoader is not done, don't trigger events
                            if (postLoaderState.status != "complete") return

                            if ($element.scrollParent().scrollTop() >= $element.scrollParent().height() - (viewport.height() * 2)) {
                                //we're at the end
                                if (Object.byString($scope, "onScroll.atEnd")) $scope.$apply(function () { $scope.onScroll.atEnd() })
                                if ($scope.recentOn == "top") $scope.$apply(function () { loadMore(10) })
                            }

                            if ($element.scrollParent().scrollTop() <= viewport.height()) {
                                //we're at the top
                                if (Object.byString($scope, "onScroll.atTop")) $scope.$apply(function () { $scope.onScroll.atTop() })
                                if ($scope.recentOn == "bottom") $scope.$apply(function () { loadMore(10) })
                            }
                        }, 50)

                        viewport.scroll(watchScroll)
                    }, 1000, false)
                } else {
                    $element.find('.loading-message').hide()
                }

                //add posts to pages in real-time
                if ($scope.pageId) $scope.$on('itemAdded', function (event, item) {
                    if (item.$key != 'Post' || item.Page != $scope.pageId) return

                    var wasAdded = addNewPost(event, item)
                    if (!wasAdded) return

                    //if the postLoader is running, the post will be added by whatever process started it
                    if (postLoaderState.status != "complete") return

                    //set loader state
                    if (postLoaderState.idx > 0) postLoaderState.idx++
                    postLoaderState.wait = $q.resolve()
                    postLoaderState.op = 0
                    postLoaderState.post = item

                    //start it up
                    postLoaderState.status = "starting"
                    nextPostLoaderStep(event)

                    //ensure the empty state disappears when a new post is added
                    feed.showEmptyState = false
                })

                //if a post was read, update chat-heads
                $scope.$on('itemUpdated', function (event, item) {
                    if (item.$key == "Post" && feed.visiblePostsMap[item._id]) {
                        if (feed.pageId) decorateFeed()
                    }
                })

                //load the initial posts if not searching - the page controller will send in posts to show in that case
                if (!$scope.search) {
                    init()
                }

                ///////////////////////////////////////////////////////////////////
                //      POST LOADER
                ///////////////////////////////////////////////////////////////////

                //expect feed.getPosts to return a "list of posts" (/api/page/xxx/Posts | /api/UserNewsFeed/relevance) from the server, and for each id returned, get the appropriate Post object (via getCache) and then finally push the Post into feed.visiblePosts.
                function loadPosts(postPointers) {
                    console.info('Loading posts', postPointers.length)
                    var loadingPromises = []

                    //get out if nothing to do
                    if (postPointers.length == 0) {
                        setNoMorePosts()
                        return $q.resolve(false)
                    }

                    //ensure all the posts are loaded in one server hit
                    postPointers.forEach(function (postPointer) {
                        //skip full documents
                        if (postPointer.$key == "ActivityLog" || postPointer.$key == "Post") return

                        //get posts from pointer
                        loadingPromises.push(Post.getCache({ _id: postPointer.Post }).$httpPromise.then(function (res) {
                            //attach the UNF record if this is from the UNF
                            if (angular.isDefined(postPointer.RelevanceScore)) res[0].$UNF = postPointer
                            delete res[0].$userIsTogglingRead
                            delete res[0].$userIsTogglingPinned
                            return res[0]
                        }))
                    })

                    //after we have all the posts on the client, set up the post loader to load the first one and start it up
                    return $q.all(loadingPromises).then(function (res) {
                        console.info('Got posts from the server', res)

                        var firstPost = null
                        postPointers.forEach(function (postPointer) {
                            var post = postPointer.$key == "ActivityLog" || postPointer.$key == "Post" ? postPointer
                                : Post.getCache({ _id: postPointer.Post })[0]

                            if (!firstPost) firstPost = post
                            addNewPost(null, post)
                        })

                        //set loader state
                        postLoaderState.wait = $q.resolve()
                        postLoaderState.op = 0
                        postLoaderState.post = firstPost

                        //if all posts passed were pinned or otherwise not added, no more posts
                        if (feed.visiblePosts.length == 0) {
                            setNoMorePosts()
                        } else {
                            //start it up!
                            postLoaderState.status = "starting"
                            nextPostLoaderStep()
                        }
                    })
                }

                //a recursive function (one that calls itself) that waits until the last iteration resolves a promise before continuing
                function nextPostLoaderStep(event) {
                    //if the loader timed out, don't keep going
                    if (postLoaderState.status == 'complete') return

                    postLoaderState.wait.then(function () {
                        postLoaderState.wait = $q.resolve() //default
                        postLoaderState.status = "working"

                        switch (postLoaderState.op) {
                            case 0: //move the post from backstage (addNewPost dumps them all there) to the correct column
                                //set the el reference based on the idx of the loader    
                                postLoaderState.el = $element.find('#Post' + postLoaderState.idx)
                                if (!postLoaderState.el.length) {
                                    throw new Error('Error in post-feed:312. Unable to locate post in dom.', postLoaderState.idx)
                                }

                                //determine the column
                                var col = 1
                                if (feed.columns.length > 1) col = getShortestColumn()
                                var colEl = $element.find('.postFeedColumn.col' + col)

                                //determine where to put the post (top or bottom of column)
                                var op
                                if ($scope.recentOn == "bottom") {
                                    if (event) op = "append"
                                    else op = "prepend"
                                } else {
                                    if (event) op = "prepend"
                                    else op = "append"
                                }

                                //append/prepend the post to the correct column
                                colEl[op](postLoaderState.el)

                                //set lastHeight=0 to force a delay of at least one poll (isPostRendered returns false if the height !- lastHeight) so posts "flow" in vs show all at the same time
                                postLoaderState.lastHeight = 0

                                //set wait condition to be when the element's height stops changing (i.e. angular has fully loaded the post)    
                                postLoaderState.wait = $q(function (resolve, reject) {
                                    poll(function () {
                                        return isPostRendered(postLoaderState.el)
                                    }, resolve, resolve, 5000)
                                })
                                break;
                            case 1: //remove the position:fixed class so the post pops into the column and we can scroll down in the same frame
                                //remove the animated post-loading placeholder if this is the first post
                                if (postLoaderState.idx == 0) $element.find('.post-placeholder-wrapper').hide()

                                //the loading-post class makes the post position:fixed and opacity:0 so we can measure the post's height w/o it affecting the parent scroll height
                                postLoaderState.el.removeClass('loading-post').addClass('visible-post').addClass('fade' + ($scope.recentOn == "top" ? "down" : "up"))

                                //let the feed know the post appeared out of thin air (lastHeight was 0)
                                postHeightChanged(postLoaderState.el, 0);

                                //establish a dom mutation observer for the first three seconds of first six posts' life - jschart and other JS may change the height of the post after it's visible and can cause jank otherwise
                                if (postLoaderState.idx < 10) (function (thisEl) { //magic number 10 is the first visit -- buggily, after the first load, jschart, etc render doesn't cause the scroll/height to change...
                                    // Create an observer instance
                                    var observer = new MutationObserver(function (mutationsList) {
                                        if (!thisEl.lastHeight || mutationsList[0].target.classList.contains('toolbar')) return //ignore hovers from the toolbar

                                        //alert that the post height may have changed
                                        postHeightChanged(thisEl, thisEl.lastHeight)
                                        thisEl.lastHeight = thisEl.outerHeight()
                                    });

                                    // Start observing the target node for configured mutations
                                    observer.observe(thisEl[0], { attributes: true, childList: true, subtree: true });
                                    // stop observing after 3 sec (no need for hovers/etc to fire them)
                                    setTimeout(function () { observer.disconnect(); }, 3000)
                                })(postLoaderState.el);
                                break;
                            case 2: //get the next post and start over or be done
                                if (postLoaderState.idx < feed.visiblePosts.length - 1) {
                                    postLoaderState.idx++
                                    postLoaderState.op = -1
                                    postLoaderState.post = feed.visiblePosts[postLoaderState.idx]
                                } else {
                                    console.log('Done loading posts.')
                                    postLoaderState.status = "complete"
                                    clearTimeout(postLoaderState.timeout)
                                    adjustFill()
                                    if ($scope.watchScroll) watchScroll()
                                }
                                break;
                        }

                        //unless the last step let the op go above 2, increment the op and start again
                        if (postLoaderState.op < 2) {
                            postLoaderState.op++
                            nextPostLoaderStep()
                        }
                    }).catch(function (err) {
                        console.error('Error in post-feed: 390', err)
                    })

                    //safety -- if something breaks, declare the machine complete
                    clearTimeout(postLoaderState.timeout)
                    postLoaderState.timeout = setTimeout(function () {
                        console.error('Post loader timed out!')
                        postLoaderState.status = "complete"
                    }, 1000 * 10)
                }

                //if the height hasn't changed and all images are loaded, return true
                function isPostRendered(el) {
                    if (el.height() == 0) return false

                    var returnVal = (el.outerHeight() == el.lastHeight)

                    var imgs = el.find('img')
                    imgs.each(function (img, idx) {
                        if (!this.complete) {
                            returnVal = false
                        }
                    })

                    el.lastHeight = el.outerHeight()

                    return returnVal
                }

                //handle the post's height changing
                function postHeightChanged(el, lastHeight) {
                    if (lastHeight != el.outerHeight()) {
                        if ($scope.recentOn == "bottom") {
                            var diff = el.outerHeight() - lastHeight
                            $element.scrollParent().scrollTop($element.scrollParent().scrollTop() + diff)
                        }
                    }
                }

                //return the 1-based shortest column
                function getShortestColumn() {
                    var lowest = { height: null }

                    //for each column
                    for (var c = 0; c < feed.columns.length; c++) {
                        //add up the height of the posts in the column
                        var col = feed.columns[c]
                        var visibles = $element.find('.postFeedColumn.col' + col + ' .visible-post')
                        var colHeight = 0
                        visibles.each(function (idx, el) {
                            colHeight += el.clientHeight
                        })

                        //if this column is shorter than the last, save this column index
                        if (lowest.height == null || colHeight < lowest.height) {
                            lowest.index = col
                            lowest.height = colHeight
                        }
                    }

                    //set the column index
                    return lowest.index || 1
                }

                //add the post to the backstage and feed.visiblePosts
                function addNewPost(event, item) {
                    //ensure we never process a post twice
                    if (feed.visiblePostsMap[item._id]) return false

                    var add = false
                    if (item.$key == "Post" && (!feed.pageId || item.Page == feed.pageId)) {
                        add = true
                    }
                    if (item.$key == "ActivityLog" && item.Task == feed.pageId) {
                        add = true
                    }
                    if (item.$key == "Post" && $scope.excludePinned && item.IsPinned) {
                        add = false
                    }

                    if (add) {
                        feed.visiblePostsMap[item._id] = true

                        //get a child scope
                        var postScope = $scope.$new()
                        postScope.log = postScope.post = item

                        //get the correct html
                        var html
                        if (item.$key == "ActivityLog") {
                            html = $templateCache.get(item.GetTemplate())
                        } else if (feed.template) {
                            html = $templateCache.get(feed.template)
                        } else if (item.$key == "Post") {
                            html = "<div au-post post='post' " + ($scope.hideHeaders ? 'hide-header="true"' : '') + "></div>"
                        } else {
                            debugger
                        }

                        //attach the chat heads if we're in a discussion or conversation
                        if ((feed.feedType == 'Discussion' || feed.feedType == 'Conversation') && feed.page.Creator != '0'.repeat(24)) {
                            var chatHeads = '<div class="lastread-chat-heads" layout="row" layout-align="center center"><au-profile-image class="grow margin-5" ng-class="{typing: feed.page.$WhosTyping.indexOf(user) > -1}" user="user" size="20" title="{{ user | fullNameFilter }} has read up to here." ng-repeat="user in post.$DisplayReadBy" ng-if="user != $root.user._id"></au-profile-image></div>'
                            html += chatHeads
                        }

                        //compile and insert into dom
                        feed.backstage.append($compile("<div layout='column' id='Post" + feed.visiblePosts.length + "' class='loading-post'>" + html + "</div>")(postScope))

                        //visibile posts is an array, in order, of posts to render so push/unshift to that
                        if (event) feed.visiblePosts.unshift(item)
                        else feed.visiblePosts.push(item)

                        //update the chat heads
                        if (feed.pageId && (feed.feedType == 'Discussion' || feed.feedType == 'Conversation')) decorateFeed()
                    }

                    return add
                }

                //decorate posts w/ $firstInGroup, $lastInGroup, $DisplayReadBy
                function decorateFeed() {
                    //default lastRead to all users in the feed
                    var lastItem, lastRead = {}
                    feed.page.Members.forEach(function (member) {
                        lastRead[member] = null
                    })

                    //process the visiblePosts - currently only supports recentOn:bottom
                    for (var i = feed.visiblePosts.length - 1; i >= 0; i--) {
                        var item = feed.visiblePosts[i]
                        if (item.$key != "Post") return

                        delete item.$firstInGroup
                        delete item.$lastInGroup
                        delete item.$DisplayReadBy

                        if (!lastItem || lastItem.Creator != item.Creator) {
                            item.$firstInGroup = true
                            if (lastItem) lastItem.$lastInGroup = true
                        }

                        item.ReadBy.forEach(function (readById) {
                            lastRead[readById] = i
                        })

                        lastItem = item
                    }
                    if (lastItem) lastItem.$lastInGroup = true

                    // attach $LastReadBys to proper posts
                    Object.keys(lastRead).forEach(function (userId) {
                        if (lastRead[userId] == null) return

                        var targetPost = feed.visiblePosts[lastRead[userId]]
                        if (!targetPost.$DisplayReadBy) {
                            targetPost.$DisplayReadBy = []
                        }
                        targetPost.$DisplayReadBy.push(userId)
                        delete lastRead[userId]
                    })
                }

                //handler called on scroll and from "load more" buttons
                function loadMore(nbrPosts) {
                    if (postLoaderState.status != "complete" || feed.noMorePosts) return

                    postLoaderState.status = "loading-more"
                    feed.loadingMessage = "<span class='spin-forever'>{0}</span><hr/>Getting earlier {1}s...<hr/><span class='spin-forever'>{2}</span>".format(auUtility.randomEmoji(), auUtility.randomAmbiguousTerm(), auUtility.randomEmoji())

                    //load more items in 
                    if (!nbrPosts) nbrPosts = 10
                    feed.getPosts({ returnCount: nbrPosts }).then(function (posts) {
                        loadPosts(posts)

                        if (posts.length < nbrPosts) {
                            setNoMorePosts()
                        }
                    })
                }

                //return a promise that resolves after the correct columns are determined and visible on the page
                function determineCols(alsoClear) {
                    return $q(function (resolve, reject) {
                        poll(function () {
                            return $element.width()
                        }, resolve, reject, 999 * 10 * 1000)
                    }).then(function () {
                        var width = $element.width()
                        var columns = $element.find('.columns')
                        columns.empty()

                        var colsNeeded = parseInt(width / 500) || 1
                        if (colsNeeded < 1) colsNeeded = 1
                        if (feed.feedType == 'Discussion' || feed.feedType == 'Conversation') colsNeeded = 1

                        feed.columns = []
                        for (var i = 1; i <= colsNeeded; i++) {
                            feed.columns.push(i)

                            columns.append('<div class="postFeedColumn layout-column col' + i + '" style="width:' + 100 / colsNeeded + '%; padding-left:' + (i == 1 ? '0px' : '10px') + '; padding-right:' + (i == feed.columns.length ? '0px' : '10px') + '"></div>')
                        }
                    })
                }

                function adjustFill() {
                    if ($scope.recentOn == "top") return

                    var el = $element.scrollParent()
                    var parentHeight = el.height()
                    var feedHeight = $element.find('.postFeedColumn').height()

                    var fill = $element.find('.fill')
                    var currentHeight = fill.outerHeight()

                    //make fill the difference
                    var fill = parentHeight - feedHeight
                    if (fill < 20) fill = 20

                    //adjust height and scrollTop in same frame
                    $element.find('.fill').css('min-height', fill)
                    //el.scrollTop(el.scrollTop() + (fill - currentHeight))
                }

                /////////////////////////////////////////////////////////////////////////////////////////////
                // common feed return for a page - please keep general feed functionality above this
                /////////////////////////////////////////////////////////////////////////////////////////////

                //handle getting posts for this page -- return a set of postPointers (Post_id, DateCreated)
                function getPostsAndActivity(options) {
                    options = options || {}
                    if (!options.returnCount) {
                        options.returnCount = 10
                    }
                    if (options.items) {
                        feed.pointersLoaded = true
                        feed.allItems = null
                        feed.allActivity = []
                        feed.allPosts = options.items
                        feed.pointersQ = $q.resolve()
                    }

                    var promise = $q.defer()

                    //get all posts on first call
                    if (!feed.pointersLoaded) {
                        //we only want to get the post pointers once
                        feed.pointersLoaded = true

                        //get post pointers for the page                    
                        feed.pointersQ.push(feed.page.Posts({ limit: 2000 }).then(function (response) {
                            // response.data contains the array of postPointers (id, DateCreated)
                            var postPointers = response.data.map(function (post) {
                                return { Post: post._id, DateCreated: new Date(post.DateCreated) }
                            })
                            feed.allPosts = postPointers
                        }))

                        //get all activity for this item -- would currently only work for Tasks - refactor activity logs to rename "Task" to "Item"
                        feed.pointersQ.push(ActivityLog.getCache({ Task: feed.pageId }, '-Date', true).$httpPromise.then(function (activity) {
                            feed.allActivity = activity
                        }))
                    }

                    return $q.all(feed.pointersQ).then(function () {
                        if (!feed.allItems) {
                            feed.allItems = feed.allPosts.concat(feed.allActivity)

                            //this could be hardcoded since we only support DateCreated at this time, but the flexibility isn't bad
                            var sortDirection = feed.orderBy.substr(0, 1)
                            var sortField = feed.orderBy.substr(1, feed.orderBy.length)
                            feed.allItems.sort(function (a, b) {
                                var v1 = Object.byString(a, sortField)
                                var v2 = Object.byString(b, sortField)
                                var returnVal = 0

                                if (v1 < v2) returnVal = -1
                                if (v1 > v2) returnVal = 1

                                if (sortDirection == "-") returnVal *= -1
                                return returnVal
                            })
                        }

                        //return the next set of pointers
                        var retVal = feed.allItems.slice(feed.lastPostReturned, feed.lastPostReturned + options.returnCount)
                        feed.lastPostReturned += retVal.length
                        return retVal
                    })

                }
            } //end controller
        }]);
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')

		.directive('auPopover', ["$mdUtil", "$timeout", "$animate", "$document", function ($mdUtil, $timeout, $animate, $document) {
			return {
				template: '<ng-transclude></ng-transclude>',
				scope: {
					// title: '=',
					// description: '=',
					// link: '=',
					// action: '=',
					open: '=?'
				},
				compile: compile,
				restrict: 'E',
				transclude: true
			}

			function compile($element, $attrs) {
				if ($attrs.class) {
					$element.find('.md-primary').removeClass('md-primary').addClass($attrs.class);
				}
				return link;
			}

			function link($scope, $element, $attrs, $controller, $transclude) {
				// more or less modeled after md-menu but its code didn't work for me so i redid it

				var parent = $mdUtil.getParentWithPointerEvents($element);

				$element.detach();

				parent.css('cursor', 'pointer')

				parent.on('click', function ($event) {
					handleClick($event)
					$event.stopPropagation()
				});

				function handleClick($event) {
					if ($scope.open) {
						close();
					} else {
						open();
					}
				}

				$scope.$watch('open', function (nowOpen, wasOpen) {
					if (nowOpen === undefined) return
					if ($scope.ignoreOpenWatch) return
					if (nowOpen && !wasOpen) open()
					if (!nowOpen && wasOpen) close()
				})

				function open() {
					positionTooltip();
					$scope.open = true;
					$scope.ignoreOpenWatch = true

					$timeout(function () {
						$element.addClass('active')
					}, 300)

					$timeout(function () {
						$scope.ignoreOpenWatch = false
					}, 1000)
				}

				function close() {
					$scope.open = false;
					$scope.ignoreOpenWatch = true
					$element.removeClass('active');

					backdrop.remove();

					$timeout(function () {
						$element.detach();
					}, 300);

					$timeout(function () {
						$scope.ignoreOpenWatch = false
					}, 1000)
				}

				var backdrop
				function positionTooltip() {
					var TOOLTIP_WINDOW_EDGE_SPACE = 8;

					// looks like we append the element to get its sizes and stuff
					parent.append($element);

					var body = angular.element('body')
					var tipRect = $mdUtil.offsetRect($element, body);
					var parentRect = $mdUtil.offsetRect(parent, body);

					// then we figure out where it goes
					var newPosition = getPosition();
					newPosition = fitInParent(newPosition);

					// once we know we can remove it from the parent and put it in the root element (body)
					$element.detach();
					body.append($element);

					$element.css({
						left: newPosition.left + 'px',
						top: newPosition.top + 'px'
					});

					// and set up a backdrop so you can't leave it open by accident
					backdrop = $mdUtil.createBackdrop($scope, "_md-menu-backdrop au-popover");
					$animate.enter(backdrop, $document[0].body);
					backdrop.on('click', function () {
						close();
					})

					// here's some positioning stuff
					function fitInParent(pos) {
						var newPosition = { left: pos.left, top: pos.top };
						newPosition.top = Math.min(newPosition.top, body.prop('offsetHeight') - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE);
						newPosition.top = Math.max(newPosition.top, TOOLTIP_WINDOW_EDGE_SPACE);
						if (pos.left + $element.prop('offsetWidth') < body.prop('offsetWidth')) {
							// pointing to left (tooltip on right side)
							newPosition.left = Math.min(newPosition.left, body.prop('offsetWidth') - $element.prop('offsetWidth') + TOOLTIP_WINDOW_EDGE_SPACE * 2);
							newPosition.left = Math.max(newPosition.left, TOOLTIP_WINDOW_EDGE_SPACE);
						} else {
							// pointing to right (tooltip on left side)
							newPosition.left = Math.max(newPosition.left - $element.prop('offsetWidth') - TOOLTIP_WINDOW_EDGE_SPACE * 2 - parentRect.width, TOOLTIP_WINDOW_EDGE_SPACE);
							$element.addClass('left');
						}
						return newPosition;
					}

					function getPosition() {
						return {
							left: parentRect.left + parentRect.width,
							top: parentRect.top + parentRect.height / 2
						}
					}
				}


			}


		}]);
})();
(function () {
    'use strict'

    angular
        .module('alignus.directives')
        /**
         * @ndgoc directive
         * @module alignus.directives
         * @name mdPopoutCardList
         * @restrict AEC
         *
         * @description
         * Directive to make popout-style cards like Google Inbox.
         * Cards must be actual md-cards or they won't show up. For now you
         * can use an ng-repeat but it must be after any static cards.
         * Limited to one popout-card-list per controller.
         *
         * @param {Number} selected binding to retrieve which card is open
         * @example
         * <md-popout-card-list>
         * 	 <md-card>
         *     <p class="md-title">Card Title</p>
         *     <p class="md-subhead description">Card description</p>
         *     <div class="hidden">
         *       <md-divider></md-divider>
         *       <md-card-content>
         *         This content is only visible when expanded
         *       </md-card-content>
         *     </div>
         *   </md-card>
         *   <md-card> ... </md-card>
         * </md-popout-card-list>
         *
         */
        .directive('mdPopoutCardList', function () {
            return {
                priority: 100,
                compile: function (tElement, tAttributes) {
                    var children = tElement.children()
                    var index = 0
                    var selected = tAttributes.selected || -1
                    tElement.elScope = {}
                    var cardScope = tElement.elScope
                    cardScope.hidden = []
                    cardScope.injected = []

                    angular.forEach(children, function (card) {
                        if (card.tagName === "MD-CARD") {
                            var effIndex = String(index)
                            var el = angular.element(card)

                            if (el.attr('ng-repeat'))
                                effIndex = effIndex + ' + "R" + $index'

                            //applying the selected class expands the card
                            el.attr('ng-class', '{ \'selected\': $selected == ' + effIndex + '}')

                            //attach an click handler to the card's header to de/select the card
                            el.find('md-card-content:first').attr('ng-click', 'toggleCard(' + effIndex + ', $event)')

                            //if the markup preselected a card, and these cards are not repeating, apply the class directly to avoid flicker
                            if (index == selected || el.attr('ng-repeat')) {
                                if (index == selected) el.addClass('should-be-selected')
                                cardScope.injected[index] = true
                            } else {
                                //optmization to prevent hidden divs from rendering until they are opened - dramatically improves UX when opening large, complex, detail items like project/meeting/etc.
                                //remove the hidden div from the dom and put it in a scope variable - doesn't work for repeating md-cards, so they are exempt from the optimization
                                var hidden = el.find('.hidden').remove()
                                cardScope.hidden[index] = hidden
                            }

                            index++
                        }
                    })
                }
            }
        })
        .directive('mdPopoutCardList', ["$timeout", "$compile", "$parse", function ($timeout, $compile, $parse) {
            return {
                require: ['^^form'],
                priority: 50,
                link: function ($scope, $element, $attrs, $controllers) {
                    var item = $scope.$eval($attrs.item)
                    var isFullWindow = false
                    $scope.$selected = $attrs.selected || -1

                    if($scope.$selected != -1) {
                        // if a card was pre-selected and this item is a template, we need to lock its UI
                        if (shouldLock(item)) {
                            var wrapper = angular.element('<div au-can-edit="false"></div>')
                            var hidden = $element.find('.should-be-selected>.hidden').remove()
                            $compile(wrapper[0])($scope)
                            wrapper.append(hidden)
                            $element.find('.should-be-selected').append(wrapper)                        
                        }
                        // display the pre-selected card
                        $element.find('.should-be-selected').addClass('selected')                        
                    }

                    function shouldLock(item) {
                        if(Object.byString(item, "IsTemplate") && !$location.search().unlocktemplate) return true;
                        // if(Object.byString(item, "LinkedToRecurring") && item.$key != 'Task') return true;
                        return false
                    }

                    $scope.toggleCard = function (index, $event) {
                        //figure out what element is the scroll container
                        var scrollContainer = angular.element($event.target).scrollParent()
                        var paddingTop = 0
                        if (scrollContainer[0] != document) parseInt(scrollContainer.css('padding-top'))
                        paddingTop += 10 //additional padding

                        //get the card and it's content
                        var mdCard = angular.element($event.target).closest('md-card')[0]

                        //compile and append the card hidden div if needed
                        if (!$element.elScope.injected[index] && !mdCard.attributes['ng-repeat']) {
                            //get the hidden section from memory and compile it
                            var hidden

                            // if an item was supplied and that item is marked as a Template, all of its components should be disabled
                            if(shouldLock(item)) {
                                $element.elScope.hidden[index].wrap('<div au-can-edit="false">')
                                hidden = $compile($element.elScope.hidden[index].parent())($scope)                   
                            } else {
                                hidden = $compile($element.elScope.hidden[index])($scope)
                            }

                            angular.element(mdCard).append(hidden)

                            //add each ng-model field to the parent form (so form validation works)
                            var fields = hidden.find("[ng-model]:not([au-no-attach]):not(.au-cke-document)")
                            fields.each(function (i, el) {
                                $controllers[0].$addControl(angular.element(el).controller('ngModel'))
                            })

                            //mark this card as injected
                            $element.elScope.injected[index] = true
                        }

                        //get the card's hidden div
                        var cardContent = mdCard.querySelector('.hidden')


                        // //md-tabs really try to be as short as possible so force them to 100% when in the itemDialog and full window
                        // if (cardContent && cardContent.closest('md-tab-content')) {
                        // 	if (isFullWindow) {
                        // 		cardContent.closest('md-tab-content').style.height = 'calc(100% - 50px)'
                        // 		cardContent.closest('md-tabs').style.height = 'calc(100% - 68px)'
                        // 		cardContent.closest('md-tabs-content-wrapper').style.height = '100%'
                        // 	} else {
                        // 		cardContent.closest('md-tab-content').style.height = 'auto'
                        // 		cardContent.closest('md-tabs').style.height = 'auto'
                        // 		cardContent.closest('md-tabs-content-wrapper').style.height = 'auto'
                        // 	}
                        // }

                        //if the card should fill the viewport, set the card content height programatically
                        if (cardContent && cardContent.classList.contains('fill-viewport')) {
                            var height = 100
                            if (isFullWindow) height = window.innerHeight - 20 //10 padding on top/bottom
                            else height = scrollContainer.height() + parseInt(scrollContainer.css('padding-bottom'))
                            height -= 120 //the card header and a little extra buffer

                            cardContent.style.minHeight = height + 'px'
                            $scope.viewportHeight = height //can/should be used in the card content to set other element height in markup

                            //remove the scrollbar
                            cardContent.style.overflow = "inherit"
                        }

                        //don't collapse the card content if we're full window
                        if (isFullWindow) return

                        //toggle the $selected class
                        if (index == $scope.$selected) {
                            $scope.$selected = -1
                        } else {
                            $scope.$selected = index

                            if (cardContent && cardContent.attributes['on-visible']) {
                                $scope.$evalAsync(cardContent.attributes['on-visible'].value)
                            }

                            //scroll the container so this card is at the top of the viewport
                            setTimeout(function () {
                                //never scroll to the top of the viewport
                                if (mdCard && mdCard.offsetTop > 0) {
                                    var scrollTo = 0
                                    scrollTo = angular.element(mdCard).offset().top - scrollContainer.offset().top - paddingTop + scrollContainer.scrollTop() - parseInt(scrollContainer.css('padding-top'))

                                    scrollContainer.animate({
                                        scrollTop: scrollTo
                                    }, 500)
                                }
                            }, 500) //run this after the css transitions are done because they change the offsetTop

                            //find the containing item and log that a card was opened
                            var itemType, forItem
                            var parentVm = $rootScope.findInParentScope($scope, 'vm')
                            if (parentVm) forItem = parentVm.item
                            if (forItem) itemType = forItem.$key
                            else itemType = 'Item'    

                            window.ga('send', {
                                hitType: 'event',
                                eventCategory: 'CardOpen',
                                eventAction: itemType,
                                eventLabel: index
                            });
                        }
                    }

                    var originalCardAfter = null,
                        cardContainer, originalCardContainer
                    $scope.toggleFullWindow = function ($event) {
                        $event.stopPropagation()
                        isFullWindow = !isFullWindow
                        var card = angular.element($event.target).closest('md-card')                        

                        card.toggleClass('full-window')
                        if (isFullWindow) {
                            //attach the card to the body to get it out of dialogs
                            originalCardContainer = null
                            originalCardAfter = card.prev()
                            if (originalCardAfter.length == 0) originalCardContainer = card.parent()
                            cardContainer = angular.element('<md-popout-card-list>')
                            cardContainer.append(card)
                            angular.element('body').append(cardContainer)
                            $rootScope.windowFab.hideWindowFab()
                        } else {
                            //attach the card back to it's original parent
                            if (originalCardContainer) originalCardContainer.prepend(card)
                            else card.insertAfter(originalCardAfter)
                            cardContainer.remove()
                            $rootScope.windowFab.setFabToCloseItem()
                        }

                        //click the card (usually just toggleCard)
                        $parse(card.find('md-card-content').attr('ng-click'))($scope, { $event: $event })
                    }
                }
            }
        }])
})();


(function() {
    controller.$inject = ["$scope", "$rootScope", "$window", "$mdDialog", "auUtility", "toast", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auPhilosophyCard', function() {
            return {
                templateUrl: '/app/alignus/directives/au-philosophy-card/au-philosophy-card.tmpl.html',
                scope: {
                    item: '='
                },
                controller: controller,
                controllerAs: 'vm'
            }
        });

    /* @ngInject */
    function controller($scope, $rootScope, $window, $mdDialog, auUtility, toast, Schema) {
        var vm = this

        vm.item = $scope.item.getPhilosophy()    

    }
})();
(function () {
	auMyTasksController.$inject = ["$scope", "$element", "$rootScope", "$mdDialog", "$interval", "$timeout", "Task", "myTaskTracker"];
	angular
		.module('alignus.directives')
		.directive('auMyTasks', function () {
			return {
				templateUrl: '/app/alignus/directives/au-my-tasks/au-my-tasks.tmpl.html',
				controller: auMyTasksController,
				controllerAs: 'vm',
				scope: {}
			} // end directive configuration
		});

	/* @ngInject */
	function auMyTasksController($scope, $element, $rootScope, $mdDialog, $interval, $timeout, Task, myTaskTracker) {
		var vm = this
		vm.myTaskTracker = myTaskTracker
		vm.newTaskTitle = ""

		vm.changeTaskType = function (newType) {
			vm.newTaskType = newType

			vm.newTaskTitle = vm.newTaskTitle.replace('Reminder: ', '').replace('Note: ', '')
			vm.newTitlePlaceholder = "Add a " + vm.newTaskType

			switch (newType) {
				case 'ToDo':
					vm.newTaskTypeIcon = 'zmdi zmdi-square-o'
					vm.newTitlePlaceholder = "Add a To-Do"
					break;
				case 'Reminder':
					vm.newTaskTypeIcon = 'zmdi zmdi-alarm-plus'
					if (!vm.newTaskTitle.startsWith('rem')) vm.newTaskTitle = 'Reminder: ' + vm.newTaskTitle
					break;
				case 'Journal':
					vm.newTaskTypeIcon = 'zmdi zmdi-book'
					vm.newTitlePlaceholder = "What did you do today?"
					break;
				case 'Note':
					vm.newTaskTypeIcon = 'zmdi zmdi-file-text'
					if (!vm.newTaskTitle.startsWith('note')) vm.newTaskTitle = 'Note: ' + vm.newTaskTitle
					break;
			}

			$element.find('.add-task textarea').focus()
		}

		//init with ToDo
		vm.changeTaskType('ToDo')

		vm.showLearnMore = function () {
			$mdDialog.show(
				$mdDialog.alert({
					title: "How different task types work",
					htmlContent: ["Tasks you enter on My Tasks behave differently based on type:<br /><ul>",
						"<li>To-Do: Visible only to you and your ReportsTo.<br/>Automatically posts an 'I just completed...' update when you complete the task.<br/>Use this for most tasks.<br/><br/></li>",
						"<li>Reminder & Note: Visible only to you. No updates posted when you complete the task.<br/>Use these a simple, quick, way to get reminders in your My Tasks list.<br/><br/></li>",
						"<li>Journal Entry: Same as a To-Do, but is entered as a completed task.<br/>Use this as a quick way to share daily updates with your team.</li>",
						"</ul>"
					].join(''),
					ok: "Close"
				})
			)
		}

		vm.addTask = function ($event) {
			var task = new Task()
			task.Type = vm.newTaskType
			task.User = $rootScope.user._id
			task.UserPriority = myTaskTracker.myToDoneTasks.length ? myTaskTracker.myToDoneTasks[0].UserPriority - 1 : 100
			task.Title = vm.newTaskTitle

			switch (task.Type) {
				case 'Reminder': case 'Note':
					task.AutoPostUpdates = false
					break;
				case 'Journal':
					task.KanbanState = "Completed"
					break;
			}

			task.$saveItem()

			//clear out `add task`
			vm.newTaskTitle = ""
			switch (vm.newTaskType) {
				case 'Note': case 'Reminder':
					vm.newTaskTitle = vm.newTaskType + ': '
			}
		}

		var interval
		vm.dragControlListeners = {
			// accept: function (sourceItemHandleScope, destSortableScope) {return boolean}, //override to determine drag is allowed or not. default is true.
			itemMoved: function (event) {
				//set the dropped item's KanbanState to the list-dropped-to's state
				var newState = event.dest.sortableScope.modelValue.currentQuery.KanbanState
				if (newState == "!In Progress")
					newState = "Not Started"
				event.source.itemScope.task.KanbanState = newState

				vm.dragControlListeners.orderChanged(event)
			},
			orderChanged: function (event) {
				var userPriority, lowEnd, hignEnd

				if (event.dest.index == 0) {
					userPriority = safePriority(Object.byString(event.dest.sortableScope, 'modelValue[1].UserPriority'), 0)
					userPriority--
				} else if (event.dest.index == event.dest.sortableScope.modelValue.length - 1) {
					userPriority = safePriority(Object.byString(event.dest.sortableScope, 'modelValue[' + (event.dest.index - 1) + '].UserPriority') , 100)
					userPriority++
				} else {
					lowEnd = safePriority(Object.byString(event.dest.sortableScope, 'modelValue[' + (event.dest.index - 1) + '].UserPriority') , 0)
					hignEnd = safePriority(Object.byString(event.dest.sortableScope, 'modelValue[' + (event.dest.index + 1) + '].UserPriority') , 100)
					userPriority = ((hignEnd - lowEnd) / 2) + lowEnd
					userPriority += .0001
				}

				event.source.itemScope.task.UserPriority = userPriority

				event.source.itemScope.task.$updateItem()
			},
			containment: '.au-my-tasks',
			dragMove: function (itemPosition, containment, eventObj) {

				var below = eventObj.clientY > vm.viewBounds.bottom - 35;
				var above = eventObj.clientY < vm.viewBounds.top + 35;
				if (below || above) {
					if (!interval) {
						interval = $interval(function () {
							$element.scrollParent().scrollTop($element.scrollParent().scrollTop() + (above ? -20 : 20))
						}, 25, 100);
					}
				} else {
					$interval.cancel(interval);
					interval = null;
				}
			}

		};

		function safePriority(up, def) {
			return up == undefined ? def : up
		}

		$scope.$on('my-tasks-make-visible', initVisible)
		function initVisible() {
			//set focus to textbox
			$timeout(function () {
				$element.find('.add-task textarea').focus()
			}, 250)

			//save position
			vm.viewBounds = {
				top: $element.scrollParent().offset().top,
				bottom: $element.scrollParent().offset().top + $element.scrollParent().height()
			};
		}
	}
})();
(function() {
	'use strict';

	angular.module('alignus.directives')
		/**
		 * @ndgoc directive
		 * @module alignus.directives
		 * @name auMenuExpand
		 * @restrict AE
		 *
		 * @param {Integer} selected Index of the selected header
		 *
		 *
		 * @description
		 * use this with au-collapsible-containers to make a
		 * one-item-at-a-time menu list
		 *
		 * @usage
		 * <au-menu-accordion selected="vm.selected">
		 *   <md-button class="au-menu-accordion-header">
		 *     Section 1
		 *   </md-button>
		 *   <au-collapsible-container collapsed="vm.selected != 0">
		 *     Section 1 ($index == 0)
		 *   </au-collapsible-container>
		 * </au-menu-accordion>
		 */
		.directive('auMenuAccordion', ["$compile", function($compile) {
			return {
				scope: {
					selected: '=?'
				},
				restrict: 'AE',
				link: link
			};

			function link($scope, $element, $attrs) {
				$element.find('.au-menu-accordion-header')
					.each(function(index) {
						var arrow = $compile(
							'<md-icon md-font-icon="zmdi zmdi-chevron-right" ' +
							'ng-class="{\'zmdi-hc-rotate-90\': selected == ' + index + '}">' +
							'</md-icon>'
						)($scope)


						$(this)
							.on('click', function() {
								$scope.$apply(function() {
									if ($scope.selected == index) {
										$scope.selected = -1
									} else {
										$scope.selected = index
									}
								})
							}).append(arrow)
					})
			}
		}])
})();
(function() {
    angular
        .module('alignus.directives')
        .directive('auMeetingList', function() {
            controller.$inject = ["$scope", "$element", "$mdDialog", "Schema"];
            return {
                templateUrl: 'app/alignus/directives/au-meeting-list/au-meeting-list.tmpl.html',
                scope: {
                    item: '='
                },
                controller: controller,
                controllerAs: 'vm',
                restrict: 'E'
            }

            /* @ngInject */
            function controller($scope, $element, $mdDialog, Schema) {
                var vm = this
                
                init()

                vm.close = $mdDialog.hide

                function init() {
                    bindScopeVariables()
                    setSortables()
                }

                function bindScopeVariables() {
                    //this is where we will make all the $scope variables vm
                    vm.item = $scope.item
                    vm.meetingList = vm.item.MeetingList.map(function(meeting){
                        return Schema.resource('Meeting').getCache({_id: meeting.LinkId})[0]
                    })
                }

                function setSortables() {
                    vm.sortableBy = [{
                        fieldName: 'MeetingDate',
                        display: 'Meeting Date'
                    }, {
                        fieldName: 'CreatedBy',
                        display: 'Created By'
                    }, {
                        fieldName: 'DateCreated',
                        display: 'Date Added'
                    }]
                    vm.sortBy = vm.sortableBy[0]
                }

                vm.setSortBy = function($index) {
                    vm.sortBy = vm.sortableBy[$index]
                }

                vm.openAddMeetingDialog = function($event) {
                    $mdDialog.show({
                        templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
                        controller: 'AddMeetingDialog',
                        controllerAs: 'vm',
                        targetEvent: $event,
                        locals: {
                            options: {
                                topicItem: vm.item
                            }
                        }
                    })
                }

                $scope.$watchCollection('vm.item.MeetingList', function(newVal, oldVal){
                    bindScopeVariables()
                }, true)
            }
        })
})();
(function() {
    controller.$inject = ["$scope", "$element", "$timeout", "$http", "toast", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auItemSecurityAndSharing', function() {
            return {
                templateUrl: '/app/alignus/directives/au-item-security-and-sharing/au-item-security-and-sharing.tmpl.html',
                scope: {
                    item: '='
                },
                controller: controller,
                controllerAs: 'vm',
                transclude: true
            }
        });

    /* @ngInject */
    function controller($scope, $element, $timeout, $http, toast, Schema) {
        var vm = this

        vm.item = $scope.item     
        
        vm.itemType = Schema.resource(vm.item.$key).getType()    
        
        var allowedChars = '1234567890000-+qwertasdfgzxcvbyiophklnm'
        vm.customUrlKeyPress = function($event){
            switch ($event.key) {
                case 'ArrowRight': case 'ArrowLeft':
                case 'Backspace': case 'Delete':
                    return //okay
            }

            //block other chars and anything over 50 chars long
            if (allowedChars.indexOf($event.key) == -1 || vm.item.CustomUrl.length >= 49){
                $event.preventDefault()
            }
        }

        vm.ensureValidCustomUrl = function() {
            var invalidCustomUrls = ['home', 'project', 'documents', 'handbook', 'strategy', 'philosophy', 'structure', 'fundraiser', 'login', 'select', 'social', 'signup', 'welcome', 'forgot', 'tos']
            if (invalidCustomUrls.indexOf(vm.item.CustomUrl) > -1) {
                toast.error('That is a reserved Align Us url.')
                vm.item.CustomUrl = ""

                return
            }

            debouncedUrlCheck()
        }

        var debouncedUrlCheck = debounce(function(){
            var urlChecked = vm.item.CustomUrl
            $http.post('/api/verifyCustomUrl', { customUrl: vm.item.CustomUrl }).then(function (response) {
                if (!response.data.success) {
                    if (urlChecked == vm.item.CustomUrl) {
                        toast.success('Custom Url is available!')
                    } else {
                        console.log('custom url is available')
                    }               
                } else {
                    toast.error('Sorry but that URL is already taken.')
                    vm.item.CustomUrl = ""
                }
            })
        }, 1500)
    }
})();
(function () {
    controller.$inject = ["$scope", "$element", "toast", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auItemOwnedby', function () {
            return {
                templateUrl: '/app/alignus/directives/au-item-ownedby/au-item-ownedby.tmpl.html',
                scope: {
                    item: '='
                },
                controller: controller,
                controllerAs: 'vm',
                transclude: true
            }
        });

    /* @ngInject */
    function controller($scope, $element, toast, Schema) {
        var vm = this

        vm.item = $scope.item

        vm.itemType = Schema.resource(vm.item.$key).getType()

        vm.openOwner = function (owner) {
            var item = Schema.resource(owner.Type).getCache({ _id: owner.DocId })[0].open()
        }

        vm.addOwner = function () {
            //check they are not already an owner
            for (var i = 0; i < vm.item.OwnedBy.length; i++) {
                var owner = vm.item.OwnedBy[i]
                if (owner.DocId == vm.newOwner.item._id && owner.Type == vm.newOwner.item.$key) {
                    reset()
                    return toast.error('Owner already present.')
                }
            }

            vm.item.OwnedBy.push({ Type: vm.newOwner.item.$key, DocId: vm.newOwner.item._id, Note: vm.newOwnerNote })

            reset()

            function reset(){
                vm.newOwner = null
                vm.newOwnerNote = ""
            }
        }

        vm.removeOwner = function (owner, $event) {
            var confirmDialog = $mdDialog.confirm({
                title: 'Confirm Removal',
                textContent: 'Are you sure you want to remove this owner?',
                ok: 'Yes',
                cancel: 'Nevermind',
                targetEvent: $event
            })
            $mdDialog.show(confirmDialog)
                .then(function () {

                    var idx = -1
                    vm.item.OwnedBy.forEach(function (thisOwner, index) {
                        if (thisOwner.DocId == owner.DocId && thisOwner.Type == owner.Type) {
                            idx = index
                        }
                    })

                    if (idx != -1) {
                        vm.item.OwnedBy.splice(idx, 1)
                    } else {
                        toast.error('Could not remove owner')
                    }
                })
        }
    }
})();
(function() {
    controller.$inject = ["$scope", "$element", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auItemDetailHeaderCard', function() {
            return {
                templateUrl: '/app/alignus/directives/au-item-detail-header-card/au-item-detail-header-card.tmpl.html',
                scope: {
                    item: '=',
                    titleField: '@',
                    allowTitleEdit: '='
                },
                controller: controller,
                controllerAs: 'vm',
                transclude: true
            }
        });

    /* @ngInject */
    function controller($scope, $element, Schema) {
        var vm = this

        vm.item = $scope.item     
        
        vm.itemType = Schema.resource(vm.item.$key).getType()

        //Title editing support
        vm.allowTitleEdit = $scope.allowTitleEdit === undefined ? true : !!$scope.allowTitleEdit
        vm.editingTitle = false
        vm.editTitle = vm.item[$scope.titleField]

        vm.enterEditMode = function(){
            vm.editingTitle = true
            $scope.$$postDigest(function(){
                $element.find('.title-row input').putCursorAtEnd()
            })
            
        }

        vm.titleEdited = function(){
            vm.item[$scope.titleField] = vm.editTitle
        }

    }
})();
(function() {
    controller.$inject = ["$scope", "$rootScope", "$window", "$mdDialog", "auUtility", "toast", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auItemCard', function() {
            return {
                templateUrl: '/app/alignus/directives/au-item-card/au-item-card.tmpl.html',
                scope: {
                    item: '=',
                    showToolbar: '@',
                },
                controller: controller,
                controllerAs: 'vm',
                transclude: true
            }
        });

    /* @ngInject */
    function controller($scope, $rootScope, $window, $mdDialog, auUtility, toast, Schema) {
        var vm = this

        vm.item = $scope.item     

        //vm.itemSubHeads = Schema.for(vm.item.$key).getSubHeads()

        vm.cardClicked = function($event, item){
            var list = $rootScope.findInParentScope($scope, 'list')
            if (list) list.cardSelected($event, item)
        }
    }
})();
(function () {
    controller.$inject = ["$scope", "$rootScope", "$window", "$mdDialog", "$timeout", "auUtility", "toast", "Schema"];
    angular
        .module('alignus.directives')
        .directive('auItemButtons', function () {
            return {
                templateUrl: '/app/alignus/directives/au-item-buttons/au-item-buttons.tmpl.html',
                scope: {
                    item: '=',
                },
                controller: controller,
                controllerAs: 'vm',
                transclude: true
            }
        });

    /* @ngInject */
    function controller($scope, $rootScope, $window, $mdDialog, $timeout, auUtility, toast, Schema) {
        var vm = this

        //adhere to the standard that vm.item works
        vm.item = $scope.item

        //expose the schema to the view to tell if we have disucssion boards, etc.
        vm.itemSchema = Schema.for(vm.item.$key)
        vm.itemType = Schema.resource(vm.item.$key).getType()

        vm.createCopy = function ($event) {
            $mdDialog.show($mdDialog.confirm({
                title: 'Create Copy',
                textContent: 'This will create a new {0} named "{1} (Copy)". Proceed?'.format(vm.item.$key, vm.item.toString()),
                ok: 'Copy',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function () {
                $rootScope.auUtility.newItemFromTemplate(vm.item._id, vm.item.$key)

                //broadcasts a closeItem message if the item is open
                vm.item.close()
            })
        }


        vm.requestUpdate = function ($event) {
            $mdDialog.show({
                controller: 'RequestUpdateController',
                controllerAs: 'vm',
                bindToController: true,
                targetEvent: $event,
                templateUrl: '/app/project/dialogs/request-update.tmpl.html',
                locals: {
                    options: { item: vm.item }
                }
            })
        }

        vm.toggleTemplate = function ($event) {
            // show a dialog asking if the user wants to toggle the 
            // Template-ness of the item in question
            $mdDialog.show($mdDialog.confirm({
                title: vm.item.IsTemplate ? 'Remove as Template' : 'Convert to Template',
                textContent: 'Are you sure you want to ' + (vm.item.IsTemplate ? 'remove this item as a template?' : 'convert this item to a template? This will lock the item until you explicitly unlock it again.'),
                ok: 'Do It',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function () {
                toast.success('Converting requires the item to re-open. Working...')

                // toggle the IsTemplate property and update the item
                vm.item.IsTemplate = !vm.item.IsTemplate
                vm.item.$updateItem().$promise.then(function () {
                    // close and open the item so that template locking/unlocking will apply
                    var x = vm.item.close()
                    $timeout(function () {
                        vm.item.open()
                        toast.success(vm.item.IsTemplate ? 'Item is now a template' : 'Item is no longer a template', true)
                    }, 750)

                })
            })
        }

        vm.showShareDialog = function ($event) {
            $mdDialog.show({
                controller: 'ShareItemController',
                controllerAs: 'vm',
                bindToController: true,
                targetEvent: $event,
                templateUrl: '/app/alignus/directives/au-item-security-and-sharing/dialog/share-dialog.tmpl.html',
                locals: {
                    options: { item: vm.item }
                }
            })
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('alignus.directives')
        .directive('auInlinePost', function () {
            controller.$inject = ["$scope", "$rootScope", "$element", "$timeout", "$q", "auUtility", "toast", "Page", "Post", "ItemViewer", "windowFab"];
            return {
                scope: {
                    item: '=?',
                    pageId: '=?',
                    postType: '=?',
                    options: '=?',
                    onComplete: '=?',
                    beforeAddPost: '=?',
                    noCopy: '=',
                    postLabel: '@',
                    grow: '=',
                    autoFocus: '=',
                    onKeyPress: '=?',
                    startBig: '=?'
                },
                templateUrl: '/app/alignus/directives/au-inline-post/au-inline-post.tmpl.html',
                controller: controller,
                controllerAs: 'vm'
            }

            /* @ngInject */
            function controller($scope, $rootScope, $element, $timeout, $q, auUtility, toast, Page, Post, ItemViewer, windowFab) {
                var vm = this
                vm.pageId = $scope.pageId
                vm.expandPost = false
                vm.resizeEditorTrigger = 0
                vm.postType = $scope.postType
                if (!$scope.options) $scope.options = {}
                vm.options = $scope.options
                vm.item = $scope.item
                if (!$scope.postType) $scope.postType = 'Update'
                if (!$scope.postLabel) $scope.postLabel = 'Post'

                if (!vm.pageId && !vm.item) return

                poll(function () { //when
                    return $element.find('.cke_wysiwyg_div').length > 0
                }, determineWidth, determineWidth, 10000, 500)

                function determineWidth() {
                    vm.wysiwygEl = $element.find('.cke_wysiwyg_div')
                    vm.elWidth = $element.width()
                }

                $scope.$on('window-resized', determineWidth)

                function init() {
                    vm.tagged = []
                    vm.documents = []

                    //should be in options...
                    vm.showCoverPhoto = false
                    vm.showChangePostType = true

                    delete vm.newPost
                    if (vm.item) {
                        if ($scope.noCopy) vm.newPost = $scope.item
                        else vm.newPost = angular.copy($scope.item)
                        if (Object.byString(vm.newPost, "Data.Poll.End")) {
                            vm.newPost.Data.Poll.End = new Date(vm.newPost.Data.Poll.End)
                        }
                    } else {
                        var page = Page.getCache({ _id: vm.pageId })[0]
                        vm.newPost = new Post({
                            Page: vm.pageId,
                            PageType: page.Type,
                            PageIsEmbedded: page.IsEmbedded,
                            Creator: $rootScope.user._id,
                            Type: vm.postType,
                            Comments: [],
                            Likes: [],
                            Tagged: vm.tagged,
                            Documents: [],
                            Data: {
                                Update: '',
                                Poll: {
                                    Question: '',
                                    PossibleResponses: []
                                }
                            }
                        })
                        if (page._placeholder) {
                            page.$httpPromise.then(function () {
                                vm.newPost.PageType = page.Type
                                vm.newPost.PageIsEmbedded = page.IsEmbedded
                            })
                        }
                    }

                    if (vm.options.expandOnLoad) {
                        poll(function () { //when
                            return $element.find('.cke_wysiwyg_div').length > 0
                        }, function () { //then
                            vm.expandEditor()
                            if (vm.newPost.CoverPhoto || vm.newPost.CoverPhotoUrl) {
                                vm.showCoverPhoto = true
                            }
                            if (vm.options.fullscreen) {
                                sizeFullscreen()
                            }
                        }, angular.noop, 30000, 250)
                    }
                }

                function sizeFullscreen() {
                    var height = $element.scrollParent()[0].scrollHeight - 175
                    if (vm.showCoverPhoto) {
                        height -= 150
                    }
                    $element.find('.au-cke-document, .poll').css('min-height', height)
                }

                vm.addPost = function ($event, stayFocused) {
                    if (vm.newPost.Type == 'Poll') {
                        if (vm.newPost.Data.Poll.Question == "") {
                            return toast.toast('Please enter a question.')
                        }
                        if (vm.newPost.Data.Poll.PossibleResponses.filter(function (p) { return p.Response.trim() != "" }).length < 2) {
                            return toast.toast('Please supply at least two choices.')
                        }
                    } else {
                        if (vm.newPost.Data.Update == "" && vm.newPost.Tagged.length == 0 && vm.newPost.Documents.length == 0) {
                            return toast.toast('🎶 You got to express yourself... 🎶')
                        }
                    }

                    //strip empty p tags from the bottom
                    var node = vm.wysiwygEl.children().last()
                    var contentFound = false
                    while (node.length == 1 && !contentFound) {
                        var html = node[0].outerHTML

                        //save the next node before possibly removing this one
                        var nextNode = node.prev()

                        //if we haven't encountered content yet, and the node is empty, remove it
                        if (CKEDITOR.cleanText(node.text()).trim() == "") {
                            var nonTextContent = ['img', 'table', 'task']
                            var empty = nonTextContent.every(function (tag) {
                                return html.indexOf(tag) == -1
                            })
                            if (empty) {
                                node.remove()
                            }
                        } else {
                            contentFound = true
                        }

                        node = nextNode
                    }


                    //let calling code create pages, etc.
                    var wait = $q.resolve(true)
                    if ($scope.beforeAddPost) {
                        wait = $scope.beforeAddPost()
                    }

                    wait.then(function () {
                        vm.newPost.$saveItem().then(function () {
                            init()
                            if (!stayFocused) {
                                vm.shrinkEditor($event)

                                if ($scope.onComplete) {
                                    $scope.onComplete(true)
                                }
                            }
                        }).catch(function (e) {
                            toast.error(e.data.error)
                        })
                    })
                }

                vm.processContent = function () {
                    var mentions = $element.find('.doc-mention[data-item-type="User"]')
                    mentions.each(function (i, mention) {
                        var user = this.attributes['data-item-id'].value
                        if (vm.newPost.Tagged.indexOf(user) == -1) {
                            $scope.$apply(function(){
                                vm.newPost.Tagged.push(user)
                            })
                        }
                    })
                }

                vm.expandEditor = function () {
                    if (vm.expanded) return

                    vm.expanded = true
                    $element.find('.inlineNewPost').removeClass('_animation-complete')
                    $element.find('.inlineNewPost').removeClass('mini')
                    $timeout(function () { vm.resizeEditorTrigger++ }, 550)
                    $timeout(function () { vm.resizeEditorTrigger++ }, 1050)
                    $timeout(function () { vm.resizeEditorTrigger++ }, 1550)
                    var editorName = $element.find('.au-cke-document').attr('ckId')

                    if ($scope.autoFocus) CKEDITOR.instances[editorName].focus()
                }

                vm.shrinkEditor = function (event) {
                    vm.expanded = false

                    if (event) event.stopPropagation()
                    $element.find('.inlineNewPost').addClass('mini')
                    $timeout(function () {
                        $element.find('.inlineNewPost').addClass('_animation-complete')
                    }, 500)

                    //focus on anything but the editor 
                    $timeout(function () { angular.element('body')[0].focus() }, 50)
                }

                vm.cancelPost = function (event) {
                    init()
                    vm.shrinkEditor(event)

                    if ($scope.onComplete) {
                        $scope.onComplete(false)
                    }
                }

                vm.cancelEdit = function (event) {
                    if ($scope.onComplete) {
                        $scope.onComplete(false)
                    }

                    //don't copy the edited post back to the one passed in
                    delete vm.newPost
                }

                vm.savePost = function (event) {
                    //copy this post back to the one passed in
                    auUtility.processItemUpdate(vm.newPost, $scope.item)
                    $scope.item.$updateItem()

                    if ($scope.onComplete) {
                        $scope.onComplete(false)
                    }
                }

                vm.exitFullscreen = function (event) {
                    //copy this post back to the one passed in
                    auUtility.processItemUpdate(vm.newPost, $scope.item)

                    if ($scope.onComplete) {
                        $scope.onComplete(false)
                    }
                }

                vm.openTagUsers = function (event) {
                    auUtility.selectUsers().then(function (users) {
                        users.forEach(function (user) {
                            if (vm.newPost.Tagged.indexOf(user) == -1) {
                                vm.newPost.Tagged.push(user)
                            }
                        })
                    })
                }

                vm.removeTaggedUser = function (index) {
                    var userToRemove = vm.newPost.Tagged[index]
                    if (vm.newPost.Data.Update.indexOf(userToRemove) != -1) {
                        toast.error('Can\t remove users that are in the content.')
                        return
                    }
                    vm.newPost.Tagged.splice(index, 1)
                }

                vm.uploadingQueue = []
                vm.onDocumentsSelected = function ($documents) {
                    console.debug($documents)
                    if (!$documents) return
                    Array.prototype.push.apply(vm.uploadingQueue, $documents)
                    //vm.uploadingQueue.concat($documents)
                }

                vm.onDocumentsUploaded = function (documents) {
                    vm.newPost.AddUserFileTypeDocuments(documents)
                    dequeueDocuments(documents)
                }

                vm.onUploadFail = function (error, documents) {
                    angular.forEach(documents, function (document) {
                        angular.forEach(vm.uploadingQueue, function (uDoc) {
                            if (uDoc.name == document.name) {
                                uDoc.$uploadFailed = true
                            }
                        })
                    })
                    toast.error('Your file(s) could not be uploaded!')
                }

                function dequeueDocuments($documents) {
                    angular.forEach($documents, function (doc) {
                        angular.forEach(vm.uploadingQueue, function (uDoc, index) {
                            var compareFileName = doc.originalFileName || doc.name
                            if (uDoc.name == compareFileName) {
                                vm.uploadingQueue.splice(index, 1)
                            }
                        })
                    })
                }

                vm.toggleCoverPhoto = function () {
                    vm.showCoverPhoto = !vm.showCoverPhoto
                    if (vm.options.fullscreen) {
                        sizeFullscreen()
                    }
                    if (vm.showCoverPhoto) {
                        //click the "change cover photo" button after the element is visible
                        $timeout(function () {
                            $element.find('.new-cover-photo').click()
                        }, 300)
                    } else {
                        vm.newPost.CoverPhoto = null
                        vm.newPost.CoverPhotoUrl = null
                    }
                }

                vm.changePostType = function () {
                    if (vm.newPost.Type == 'Poll') vm.newPost.Type = 'Update'
                    else vm.newPost.Type = 'Poll'
                }

                vm.goFullScreen = function () {
                    $rootScope.openPeek({
                        inlinePost: true,
                        item: vm.newPost
                    })
                }

                vm.ctrlEnter = function (event) {
                    if (Object.byString(event, "data.domEvent.$.ctrlKey")) {
                        vm.addPost(event.data.domEvent.$, true)
                        event.cancel()
                    }
                }

                $scope.$watch('vm.newPost.CoverPhoto + vm.newPost.CoverPhotoUrl', function () {
                    vm.showCoverPhoto = !!(vm.newPost.CoverPhoto || vm.newPost.CoverPhotoUrl)
                })

                //init on load
                init()

                //using ng-click puts an unremoveable tabindex which steals focus so do this via jQuery                
                $element.find('.inlineNewPost').on('click', vm.expandEditor)
            } //end controller
        })
})();
(function () {
	'use strict';

	controller.$inject = ["$scope", "$state", "$mdSidenav", "s3Service", "$http", "$rootScope", "Upload", "Location", "Department", "Team", "toast", "$element"];
	angular
		.module('alignus.directives')
		.directive('auImageUploader', function () {
			return {
				templateUrl: '/app/alignus/directives/au-image-uploader/au-image-uploader.tmpl.html',
				scope: {
					item: "=?",
					allowUpdate: '=?',
					size: '@?'
				},
				controller: controller,
				controllerAs: 'vm'
			}
		});

	/* @ngInject */
	function controller($scope, $state, $mdSidenav, s3Service, $http, $rootScope, Upload, Location, Department, Team, toast, $element) {
		var vm = this
		vm.item = $scope.item

		vm.allowUpdate = false
		if (vm.item.$key == 'User') {
			if (vm.item._id == $rootScope.user._id || $rootScope.user.IsUserAdmin)
				vm.allowUpdate = true
		} else {
			if ($scope.allowUpdate == undefined && vm.item.userHasAcl) {
				vm.item.userHasAcl('U').then(function (hasPerm) {
					if (hasPerm) vm.allowUpdate = true
				})
			} else {
				vm.allowUpdate = $scope.allowUpdate
			}
		}

		vm.size = $scope.size || $element.width()
		
		vm.openUploadPhoto = function () {
			$mdDialog.show({
				controller: 'SelectProfilePhotoController',
				controllerAs: 'vm',
				templateUrl: '/app/social/dialogs/select-profile-photo.tmpl.html',
				targetEvent: event,
				locals: {
					type: vm.item.$key,
					key: vm.item._id
				}
			}).then(function (key) {
				if (!key) return

				vm.item.Photo = key
				vm.item.PhotoLastUpdated = new Date()

				if (vm.item._id && vm.item.$updateItem) {
					vm.item.$updateItem()
				} else {
					$rootScope.$broadcast('itemUpdated', vm.item)
				}
			})
		}
	}
})();



(function () {
	'use strict';

	angular
		.module('alignus.directives')
/**
	* @description Help popup for various things.
	*
	* @example `
	* <md-button>
	*		pls halp
	*		<au-help-popup title="'Hello world'" description="'Lorem ipsum dolor est.'" link="'/'" action="'Xbox go home'"></au-help-popup>
	*	</md-button>
	*
	*
	* <md-button>
	* {{ Help Me }}
	*		<au-help-popup title="vm.title" description="vm.desc" link="vm.url" action="vm.btnCaption"></au-help-popup>
	*	</md-button>
	* `
	* @param title {String} Title of the popup
	* @param description {String} Content of the popup
	* @param link {String} URL to go to
	* @param action {String} Caption of the button
	* @param open {Boolean} Whether or not the card is open. Read-only.
	*/
		.directive('auHelpPopup', ["$mdUtil", "$timeout", "$animate", "$document", "auUtility", function ($mdUtil, $timeout, $animate, $document, auUtility) {
			return {
				templateUrl: '/app/alignus/directives/au-help-popup/au-help-popup.tmpl.html',
				scope: {
          			title: '=',
					description: '=',
				    link: '=',
				    action: '=',
					open: '=?'
				},
				compile: compile,
        restrict: 'E'
			}

			function compile($element, $attrs) {
				if ($attrs.class) {
					$element.find('.md-primary').removeClass('md-primary').addClass($attrs.class);
				}
				return link;
			}

			function link($scope, $element, $attrs, $controller, $transclude) {
				// more or less modeled after md-menu but its code didn't work for me so i redid it

				if ($scope.link == auUtility.freshdeskArticleRoot){
					$scope.hideLink = true
				}

				var parent = $mdUtil.getParentWithPointerEvents($element);

				$element.detach();


				parent.css('overflow', 'visible')

				parent.on('click', function ($event) {
					handleClick($event)
					$event.stopPropagation()
				});

				function handleClick($event) {
					if ($scope.open) {
						close();
					} else {
						open();
					}
				}

				function open() {
					positionTooltip();
					$scope.open = true;
					$timeout(function() {
						$element.addClass('active');
					})
				}

				function close() {
					$scope.open = false;
					$element.removeClass('active');
					$timeout(function() {
						$element.detach();
					}, 300);
				}

				function positionTooltip() {
					var TOOLTIP_WINDOW_EDGE_SPACE = 8;

          // looks like we append the element to get its sizes and stuff
					parent.append($element);

					var body = angular.element('#content-panel');
					if (body.length == 0) {
						// for structure-old only
						body = angular.element('#admin-panel');
					}
					// TODO figure out why we can't treat #content-panel
					// as the body like we did #admin-pane since the switch
					body = angular.element('body')
					var tipRect = $mdUtil.offsetRect($element, body);
					var parentRect = $mdUtil.offsetRect(parent, body);

          // then we figure out where it goes
					var newPosition = getPosition();
					newPosition = fitInParent(newPosition);

          // once we know we can remove it from the parent and put it in the root element (body)
					$element.detach();
					body.append($element);

					$element.css({
						left: newPosition.left + 'px',
						top: newPosition.top + 'px'
					});

          // and set up a backdrop so you can't leave it open by accident
          var backdrop = $mdUtil.createBackdrop($scope, "md-menu-backdrop md-click-catcher");
          $animate.enter(backdrop, $document[0].body);
          backdrop.on('click', function() {
            backdrop.remove();
            close();
          })

          // here's some positioning stuff
					function fitInParent(pos) {
						var newPosition = { left: pos.left, top: pos.top };
						newPosition.top = Math.min(newPosition.top, body.prop('offsetHeight') - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE);
						newPosition.top = Math.max(newPosition.top, TOOLTIP_WINDOW_EDGE_SPACE);
            if (pos.left + $element.prop('offsetWidth') < body.prop('offsetWidth')) {
              // pointing to left (tooltip on right side)
              newPosition.left = Math.min(newPosition.left, body.prop('offsetWidth') - $element.prop('offsetWidth') + TOOLTIP_WINDOW_EDGE_SPACE * 2);
              newPosition.left = Math.max(newPosition.left, TOOLTIP_WINDOW_EDGE_SPACE);
            } else {
              // pointing to right (tooltip on left side)
              newPosition.left = Math.max(newPosition.left - $element.prop('offsetWidth') - TOOLTIP_WINDOW_EDGE_SPACE * 2 - parentRect.width, TOOLTIP_WINDOW_EDGE_SPACE);
              $element.addClass('left');
            }
						return newPosition;
					}

					function getPosition() {
						return {
							left: parentRect.left + parentRect.width,
							top: parentRect.top + parentRect.height / 2
						}
					}
				}


			}


		}]);
})();

(function() {
	'use strict';

	auHelpIcon.$inject = ["helpText", "auUtility"];
	angular
		.module('alignus.directives')
		.directive('auHelpIcon', auHelpIcon);
	/**
	 * @ndgoc directie
	 * @module alignus.directives
	 * @name auHelpIcon
	 * @restrict E
	 *
	 * @description
	 * A help icon directive. It puts an md-icon in an md-icon-button which, when
	 * clicked, opens an au-help-popup with help information. The help popup also
	 * has a link to an external help website. Optionally it may be styled with
	 * md-accent or md-warn.
	 *
	 * Keys and their related strings and links are in
	 * `/app/alignus/values/helpText.js`
	 *
	 * @usage
	 * <hljs>
	 * <md-content>
	 * 	<p>Primary:</p>
	 * 	<au-help-icon key="AddUser.Dialog"></au-help-icon>
	 *
	 * 	<p>Accent:</p>
	 * 	<au-help-icon key="AddUser.Dialog" class="md-accent"></au-help-icon>
	 * </md-content>
	 * </hljs>
	 *
	 * @param {string} key The key to find the information to present in the help popup
	 */

	/* @ngInject */
	function auHelpIcon(helpText, auUtility) {
		return {
			scope: {},
			restrict: 'E',
			templateUrl: '/app/alignus/directives/au-help-icon/au-help-icon.tmpl.html',
			compile: compile
		}

		function compile($element, $attrs) {
			if ($attrs.class) {
				$element.find('.md-primary').removeClass('md-primary').addClass($attrs.class);
			}
			return link;
		}

		function link($scope, $element, $attrs) {
			var baseUrl = auUtility.freshdeskArticleRoot;

			if (!$attrs.key) console.warn('key needed for au-help-icon', $element);

			if ($attrs.class) {
				$element.find('.md-primary').removeClass('md-primary').addClass($attrs.class);
			}

			$element.find('> button').removeClass('md-accent');

			// look up text and link for help
			var content = helpText.filter(function(e) {
				return (e.key === $attrs.key);
			})[0];

			// key is wrong, gg
			if (!content) {
				if (!$attrs.key.startsWith('EDITPERMISSIONS.')) {
					console.warn('Invalid key', $attrs.key, 'for au-help-icon', $element);
				}
				$element.css('display', 'none');
				content = {
					title: '',
					description: '',
					link: ''
				}
			};

			$scope.title = content.title;
			$scope.description = content.description;
			$scope.url = baseUrl + content.link;
			$scope.action = "More info"
		}
	}
})();
(function () {
	controller.$inject = ["$scope", "$timeout", "Page", "toast"];
	angular
		.module('alignus.directives')
		.directive('auFollowStar', function () {
			return {
				templateUrl: '/app/alignus/directives/au-follow-star/au-follow-star.tmpl.html',
				scope: {
					page: '<',
					style: '@'
				},
				controller: controller,
				controllerAs: 'vm'
			}
		});

	/* @ngInject */
	function controller($scope, $timeout, Page, toast) {
		// get a full Page resource if we were given only an ID
		if (typeof $scope.page == 'string') {
			$scope.page = Page.getCache({ _id:  $scope.page })[0]
		}

		$scope.followClicked = function () {
			var isFollowing = !$scope.page.IsCurrentUserFollowing()
			// change the page's following status appropriately
			$scope.page.ChangeFollowingStatus()
				.then(function () {
					toast.success('Page ' + (isFollowing ? 'Followed' : 'Unfollowed'))
				}).catch(function (err) {
					toast.error(err.data.err)
				})
		}
	}
})();
(function () {
	'use strict';

	controller.$inject = ["$element", "$scope", "s3Service", "$timeout"];
	angular
		.module('alignus.directives')
		.directive('auFileUploader', function () {
			return {
				templateUrl: '/app/alignus/directives/au-file-uploader/au-file-uploader.html',
				scope: {
					onUpload: '&',
					onUploadFail: '&',
					onSelect: '&?',
					s3Options: '=?',
					inputId: '@?',
					item: '=?'
				},
				controller: controller,
				controllerAs: 'vm',
				transclude: true
			}
		});

	/* @ngInject */
	function controller($element, $scope, s3Service, $timeout) {
		var vm = this
		vm.files = []

		if(!$scope.inputId) {
			$scope.inputId = 'au-file-uploader'
		}

		if(!$scope.s3Options) {
			$scope.s3Options = {}
		}

		vm.uploadFiles = function ($files) {
			if (!$files || !$files.length) return
			
			if ($scope.onSelect) {
				$scope.onSelect()($files)
			}
			s3Service.uploadSignedFiles(vm.files, $scope.s3Options.key, $scope.s3Options.makePublic, $scope.item)
				.then(function (data) {
					$scope.onUpload()(data)
				}).catch(function(error) {
					$scope.onUploadFail()(error, $files)
				})
		}
	}
})();
(function() {
		auEventListItemController.$inject = ["$scope", "ItemViewer", "Schema"];
	angular
		.module('alignus.directives')
		.directive('auEventListItem', function() {
			return {
				templateUrl: '/app/alignus/directives/au-event-list-item/au-event-list-item.tmpl.html',
				controller: auEventListItemController,
				controllerAs: 'vm',
				scope: {
					event: '='
				}
			} // end directive config
		}); // end .directive definition

		/* @ngInject */
		function auEventListItemController($scope, ItemViewer, Schema) {
			var vm = this
			init()

			function init() {
				vm.event = $scope.event
			}

			vm.openAssociatedItem = function($event, event) {
				event.open()
			}
		} 
})();
(function() {
		auEventCalendarController.$inject = ["$scope", "$state", "$filter", "eventableFetcher", "ItemViewer", "Schema", "toast"];
	angular
		.module('alignus.directives')
		.directive('auEventCalendar', function() {
			return {
				templateUrl: '/app/alignus/directives/au-event-calendar/au-event-calendar.tmpl.html',
				controller: auEventCalendarController,
				controllerAs: 'vm',
				scope: {
					events: '=',
					showOnlyCalendar: '=',
					showOnlyDetails: '='
				}
			} // end directive configuration
		});

		/* @ngInject */
		function auEventCalendarController($scope, $state, $filter, eventableFetcher, ItemViewer, Schema, toast) {
			var vm = this

			init();

			function init() {
				initEventDetails()
				initEvents()
				initCalendarConfig()
			}

			function initEvents() {
				// the calendar accepts an array of event sources which can be functions
				// that retrieve events, static data, etc.
				// in this case there is only one event source, eventSources[0],
				// which is an array of events retrieved from the server
				vm.events = [[]]
				// if preexisting data was already passed into the directive, just use that
				if($scope.events) {
					setEventUi($scope.events)
				} else {
					// if not, fetch the data ourselves
					eventableFetcher.getMyEvents(true, 'future')
					.then(function(events) {
						setEventUi(events)
					})
				}
			}

			function setEventUi(events) {
				vm.events[0] = events
				setEventDetails(events)
			}

			function initEventDetails() {
				vm.eventDetails = []
			}

			function setEventDetails(events) {
				vm.eventDetails = events
				console.debug('vm.eventDetails', vm.eventDetails)
			}

			function initCalendarConfig() {
				vm.calendarConfig = {
					editable: false,
					eventClick: goToAssociatedItem
					// dayRender: dayRenderHook
				}
			}

			function goToAssociatedItem(event, jsEvent) {
				event.open()
			}

			// function dayRenderHook(date, cell) {
			// 	// cell.css('background-color', '#000000')
			// }

			vm.goToAssociatedItem = goToAssociatedItem

		}
})();
(function() {
    controller.$inject = ["$scope", "$window", "$mdDialog", "auUtility", "Document", "toast"];
    angular
        .module('alignus.directives')
        .directive('auDocumentSection', function() {
            return {
                templateUrl: '/app/alignus/directives/au-document-section/au-document-section.tmpl.html',
                scope: {
                    item: '=',
                    onlyList: '=',
                    // prevent-new-documents is passed to the "add document dialog" 
                    // and controls whether the user has the option of creating
                    // a new live doc and adding it (vs. only being able to choose an
                    // existing live doc)
                    preventNewDocuments: '=',
                    // a specific Subtype that, if specified, will be applied to all docs
                    // uploaded using this instance of the uploader.
                    // a Subtype specifies the business purpose of the document 
                    // ('Meeting Notes', etc) as opposed to the Type which is literally 
                    // what type of document model the document is.
                    newDocumentSubtype: '=',
                    // if this field is passed, only documents with this Subtype will
                    // be displayed in the view.
                    displaySubtype: '=',
                    // display custom text on the add/upload buttons
                    buttonTerm: '=',
                    // inline posts lets users upload and needs to share the uploadingQueue
                    uploadingQueue: '=',
                    showToolbar: '@',
                    excludeImages: '=?'
                },
                controller: controller,
                controllerAs: 'vm'
            }
        });

    /* @ngInject */
    function controller($scope, $window, $mdDialog, auUtility, Document, toast) {
        var vm = this
        init()

        vm.close = $mdDialog.hide

        $scope.$watchCollection('item.Documents', function () {
            vm.documents = $filter('filter')(vm.item.Documents, function (doc) {
                if ($scope.excludeImages) {
                    return !auUtility.hasImgExtension(doc.Title)
                } else {
                    return true
                }
            })
         })

        function init() {
            bindScopeVariables()
            setSortables()
        }

        function bindScopeVariables() {
            vm.item = $scope.item
            if (typeof $scope.onlyList === 'function') {
                vm.onlyListProxy = $scope.onlyList
            } else {
                vm.onlyListProxy = function() {
                    return $scope.onlyList
                }
            }
            vm.preventNewDocuments = $scope.preventNewDocuments
            vm.newDocumentSubtype = $scope.newDocumentSubtype
            vm.displaySubtype = $scope.displaySubtype
            vm.buttonTerm = $scope.buttonTerm ? $scope.buttonTerm : 'Document'
            vm.showToolbar = $scope.showToolbar || $scope.showToolbar === false ? false : true
        }

        function setSortables() {
            vm.sortableBy = [{
                fieldName: 'Title',
                display: 'Title'
            }, {
                fieldName: 'DateCreated',
                display: 'Date Added'
            }, {
                fieldName: 'CreatedBy',
                display: 'Who Added'
            }]
            vm.sortBy = vm.sortableBy[0]
        }

        vm.setSortBy = function($index) {
            vm.sortBy = vm.sortableBy[$index]
        }

        vm.openAddDocumentDialog = function($event) {
            $mdDialog.show({
                templateUrl: '/app/alignus/directives/au-document-section/dialog/add-document-dialog.tmpl.html',
                controller: 'AddDocumentDialogController',
                controllerAs: 'vm',
                targetEvent: $event,
                locals: {
                    item: vm.item,
                    options: {
                        preventNewDocuments: vm.preventNewDocuments,
                        documentSubtype: vm.newDocumentSubtype,
                        defaultNewDocTitle: vm.newDocumentSubtype=='Meeting Notes' ? (vm.item.Title + " - " +$rootScope.user.FirstName + '\'s Notes') : ''
                    }
                },
                skipHide: true
            })
        }

        vm.getS3ImgUrl = function(document) {
            return auUtility.s3UrlFromId(document.Id)
        }

        vm.hasImgExtension = auUtility.hasImgExtension

        vm.openDocument = auUtility.peekDocument

        vm.confirmThenRemove = function($event, document) {
            $event.stopPropagation();
            // request confirmation
            $mdDialog.show($mdDialog.confirm({
                title: 'Remove Document',
                textContent: 'Are you sure you want to remove ' + document.Title + ' from this ' + vm.item.$key + '?',
                ok: 'Yes',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function() {
                // remove the document if they confirmed
                vm.item.RemoveDocument(document._id, document.Title)
            }).catch(function() {
                // nada for now
            })
        }

        vm.onDocumentsUploaded = function($documents) {
            vm.item.AddUserFileTypeDocuments($documents, vm.newDocumentSubtype)
            dequeueDocuments($documents)
        }

        vm.onUploadFail = function(error, documents) {
            // dequeueDocuments(documents)
            angular.forEach(documents, function(document) {
                angular.forEach(vm.uploadingQueue, function(uDoc) {
                    if (uDoc.name == document.name) {
                        uDoc.$uploadFailed = true
                    }
                })
            })
            toast.error('Your file(s) could not be uploaded!')
        }

        function dequeueDocuments($documents) {
            angular.forEach($documents, function(doc) {
                angular.forEach(vm.uploadingQueue, function(uDoc, index) {
                    var compareFileName = doc.originalFileName || doc.name
                    if (uDoc.name == compareFileName) {
                        vm.uploadingQueue.splice(index, 1)
                    }
                })
            })
        }

        vm.getTitleFromDocument = function(document) {
            var title = (document.Type == 'Document') ? Document.getCache({ _id: document.Id })[0].Title : document.Title
                // this violates the hell out of the single purpose principal.
                // we basically do this so that we can still use the orderBy filter
                // even if the document is of type 'Document' and therefore doesn't really
                // need its own 'Title' field
            document.Title = title
            return title
        }

        vm.uploadingQueue = $scope.uploadingQueue || []
        vm.onDocumentsSelected = function($documents) {
            console.debug($documents)
            Array.prototype.push.apply(vm.uploadingQueue, $documents)
                //vm.uploadingQueue.concat($documents)
        }

        vm.hideEmptyState = function() {
            //if any documents are for this subtype, return true, else false
            return vm.item.Documents && vm.item.Documents.some(function(doc) {
                return doc.Subtype == vm.displaySubtype
            })
        }

        vm.hasExtension = function (document, extension) {
            return document.Title.toLowerCase().endsWith(extension)
        }

        vm.unknownExtension = function (document) {
            if (document.Title.toLowerCase().endsWith('.csv')
                || document.Title.toLowerCase().endsWith('.docx')
                || document.Title.toLowerCase().endsWith('.rtf')
                || document.Title.toLowerCase().endsWith('.txt')
                || document.Title.toLowerCase().endsWith('.pdf')
                || document.Title.toLowerCase().endsWith('.mov')
                || document.Title.toLowerCase().endsWith('.mp4')
                || document.Title.toLowerCase().endsWith('.mpeg')
                || document.Title.toLowerCase().endsWith('.mp3')
                || document.Title.toLowerCase().endsWith('.ppt')
                || document.Title.toLowerCase().endsWith('.pps')
                || document.Title.toLowerCase().endsWith('.key')
                || document.Title.toLowerCase().endsWith('.css')
                || document.Title.toLowerCase().endsWith('.html')
                || document.Title.toLowerCase().endsWith('.htm')
                || document.Title.toLowerCase().endsWith('.xhtml')
                || document.Title.toLowerCase().endsWith('.php')
                || document.Title.toLowerCase().endsWith('.js')
                || document.Title.toLowerCase().endsWith('.psd')
                || document.Title.toLowerCase().endsWith('.ai')
                || document.Title.toLowerCase().endsWith('.zip')
                || document.Title.toLowerCase().endsWith('.rar')
            ) {
                //known
                return false
            }
            return true
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('alignus.directives')
        .directive('auDiscussionBoard', function() {
            controller.$inject = ["$scope", "$rootScope", "$element", "$timeout", "$mdDialog", "toast", "Page", "Post"];
            return {
                scope: {
                    item: '=',
                    activityLog: '=?'
                },
                templateUrl: '/app/alignus/directives/au-discussion-board/au-discussion-board.tmpl.html',
                controller: controller,
                controllerAs: 'vm',
                restrict: 'E'
            }

            /* @ngInject */
            function controller($scope, $rootScope, $element, $timeout, $mdDialog, toast, Page, Post) {
                var vm = this
                vm.showMorePostsButton = true
                vm.item = $scope.item

                if (!vm.item || !vm.item._id) return

                vm.activityLog = []
                if (vm.item.$key == "Task") {
                    vm.activityLog = vm.item.GetActivity()
                }
                
                vm.loadMorePosts = function() {
                    $scope.$broadcast('load-more-posts')
                }

                $scope.$on('no-more-posts', function() {
                    vm.showMorePostsButton = false
                })

            }
        })
})();
(function () {
    'use strict';

    angular
        .module('alignus.directives')
        /* @ngInject */
        .directive('auCoverPhoto', ["$rootScope", "$timeout", "Page", "s3Service", "s3Url", "auUtility", "toast", function ($rootScope, $timeout, Page, s3Service, s3Url, auUtility, toast) {
            controller.$inject = ["$scope", "$element", "$compile"];
            return {
                scope: {
                    item: '=',
                    page: '=',
                    allowUpdate: '<?'
                },
                controller: controller,
                controllerAs: 'vm',
                restrict: 'AE',
                transclude: false
            }
            /* @ngInject */
            function controller($scope, $element, $compile) {
                var vm = this
                //append a camera to the top left of the element
                $scope.$watch('allowUpdate', function (newVal) {
                    if (!newVal)
                        $element.find('.new-cover-photo').remove()
                    else
                        $element.append($compile('' +
                            '<md-button class="md-icon-button new-cover-photo md-primary md-hue-3" ng-click="vm.updateCoverPhoto($event)">' +
                            '<md-icon class="zmdi zmdi-camera"></md-icon>' +
                            '<md-tooltip md-direction="left">Update Cover Photo</md-tooltip>' +
                            '</md-button>' +
                            '')($scope))
                })

                vm.setCoverPhoto = function () {
                    var url
                    if (!vm.item) vm.item = { placeholder: true }
                    if (vm.item.CoverPhoto) {
                        url = auUtility.s3UrlFromId(vm.item.CoverPhoto) + '?r=' + Math.random()
                    } else if (vm.item.CoverPhotoUrl) {
                        url = vm.item.CoverPhotoUrl
                    } else {
                        url = s3Url + 'empty-states/blank.png'
                    }

                    $element.addClass('background-color-600')
                    $element.css('position', 'relative')
                    $element.css('background-size', 'cover')
                    $element.css('background-position', 'center center')
                    $element.css('background-image', 'url(' + url + ')')
                }


                vm.updateCoverPhoto = function (event) {
                    $mdDialog.show({
                        controller: 'SelectCoverPhotoController',
                        controllerAs: 'vm',
                        templateUrl: '/app/social/dialogs/select-cover-photo.tmpl.html',
                        targetEvent: event
                    }).then(function (url) {
                        if (!url) return

                        vm.item.CoverPhotoUrl = null
                        vm.item.CoverPhoto = null

                        if (url.newUpload) {
                            vm.item.CoverPhoto = url.newUpload
                        } else {
                            vm.item.CoverPhotoUrl = url
                        }

                        if (vm.item._id && vm.item.$updateItem) {
                            vm.item.$updateItem()
                        } else {
                            $rootScope.$broadcast('itemUpdated', vm.item)
                        }
                    })
                }

                // get the page and attach it to scope so that it can be used in link
                if ($scope.page) {
                    Page.getCache({ _id: $scope.page }).$httpPromise.then(function (results) {
                        vm.item = results[0]
                        if (vm.item.IsUserEditor && vm.item.IsUserEditor($rootScope.user._id)) {
                            $scope.allowUpdate = true
                        }
                    })
                } else {
                    $scope.$watch('item', function (item) {
                        vm.item = item
                        if (!vm.item) vm.item = { placeholder: true }

                        if (vm.item.$key == 'User') {
                            if (vm.item._id == $rootScope.user._id || $rootScope.user.IsUserAdmin)
                                vm.allowUpdate = true
                        } else {
                            if (!vm._id) {
                                vm.allowUpdate = true
                                return
                            }
                            vm.item.userHasAcl('U').then(function (hasPerm) {
                                if (hasPerm) vm.allowUpdate = true
                            })
                        }
                    })
                }

                $scope.$watch('vm.item.CoverPhoto + vm.item.CoverPhotoUrl', function () {
                    vm.setCoverPhoto()
                })
            }
        }]);
})();
(function() {
		auCompletionPercentageLink.$inject = ["$scope"];
	angular
		.module('alignus.directives')
		.directive('auCompletionPercentage', function() {
			return {
				templateUrl: '/app/alignus/directives/au-completion-percentage/au-completion-percentage.tmpl.html',
				scope: {
					completionPercentage: '<'
				},
				link: auCompletionPercentageLink,
				restrict: 'E'
			} // end directive config
		});

		/* @ngInject */
		function auCompletionPercentageLink($scope) {
			// todo: change SetCompletedPercentage kue job to reflect the fact
			// that this is now here. move completionText logic to post directive
			var completionPercentage = $scope.completionPercentage
			if(completionPercentage >= 100) {
				$scope.completionPercentage = 100
			} else if(completionPercentage < 100 && completionPercentage >= 75) {
				$scope.completionPercentage = 75
			} else if(completionPercentage < 75 && completionPercentage >= 50) {
				$scope.completionPercentage = 50
			} else if(completionPercentage >= 25 && completionPercentage < 50) {
				$scope.completionPercentage = 25
			} else if(completionPercentage < 25) {
				$scope.completionPercentage = 0
			}
		}
})();
(function() {
	'use strict';

	auCollapsibleContainer.$inject = ["$timeout"];
	angular
		.module('alignus.directives')
		.directive('auCollapsibleContainer', auCollapsibleContainer);

	/**
	 * @ndgoc directive
	 * @module alignus.directives
	 * @name auCollapsibleContainer
	 * @restrict AE
	 *
	 * @description
	 * A jQuery-like directive for smoothly opening and closing divs and other containers.
	 *
	 * @usage
	 * <hljs>
	 * <div au-collapsible-container collapsed="vm.isCollapsed">
	 * 	Hide me!
	 * </div>
	 * </hljs>
	 *
	 * @param {boolean} collapsed Whether or not the container should be collapsed.
	 */

	/* @ngInject */
	function auCollapsibleContainer($timeout) {
		return {
			scope: {
				collapsed: '='
			},
			restrict: 'AE',
			link: link,
		}

		function link($scope, $element, $attrs) {
			$scope.$watch('collapsed', function(old_, new_) {
				if ($scope.collapsed) {
					$element.addClass('collapsed');
				} else {
					$element.css('max-height', 9999);
					$element.removeClass('collapsed');
				}
			})

		}
	}
})();
(function () {
    'use strict';

    /**
     * @ndgoc directive
     * @module alignus.directives
     * @name auCkeDocument
     * @restrict AEC
     *
     * @description
     * Create a live edit ck editor
     *
     *
     */

    controller.$inject = ["$scope", "$rootScope", "$compile", "$element", "toast", "$filter", "$state", "$timeout", "$interval", "$window", "$sce", "$q", "$parse", "s3Service", "ItemViewer", "Schema", "socket", "User", "Task", "windowFab", "oneSearch"];
    angular
        .module('alignus.directives')
        .directive('auCkeDocument', auCkeDocument);

    /* @ngInject */
    function auCkeDocument() {
        var directive = {
            scope: {
                ngModel: '=?',
                doc: '=?',
                item: '=?',
                itemField: '@',
                displayMode: '@',
                extraPlugins: '@',
                placeholder: '@',
                autoSave: '@',
                autoFocus: '=',
                projectId: '=?',
                meetingId: '=?',
                documentId: '=?',
                resizeTrigger: '=?',
                maxHeight: '@?',
                canEdit: '=?',
                acl: '@',
                processContent: '=',
                onEnter: '=?',
                onKeyPress: '=?',
            },
            controller: controller,
            controllerAs: 'auCkeDocument',
            templateUrl: '/app/alignus/directives/au-cke-document/au-cke-document.tmpl.html',
            restrict: 'AEC'
        };
        return directive;
    }

    /* @ngInject */
    function controller($scope, $rootScope, $compile, $element, toast, $filter, $state, $timeout, $interval, $window, $sce, $q, $parse, s3Service, ItemViewer, Schema, socket, User, Task, windowFab, oneSearch) {
        //capture this
        var ThisDoc = $scope

        //accept a few ways to pass in item/content		
        if (ThisDoc.doc) {
            ThisDoc.item = ThisDoc.doc
            ThisDoc.itemField = 'Content'
        } else if (ThisDoc.item) {
            if (!ThisDoc.itemField) throw new Error('itemField must be supplied')
        } else if ($element.attr('ng-model')) {
            ThisDoc.item = { $key: 'ngModel', _id: null }
            ThisDoc.itemField = 'Content'
            ThisDoc.item.Content = ThisDoc.ngModel

            //if these are not defined, set defaults
            if (!$element.attr('can-edit')) ThisDoc.canEdit = true
            if (!$element.attr('auto-save')) ThisDoc.autoSave = false
            if (!$element.attr('display-mode')) ThisDoc.displayMode = 'field'

            ThisDoc.$watch('ngModel', function (newVal, oldVal) {
                //if (ckEditor.focusManager.hasFocus) return
                if (newVal == oldVal) return

                var existingContent = getLocalContent()
                if (newVal == existingContent) return
                setLocalContent(newVal)
            })

            var exp = $element.attr('ng-model')
            var getter = $parse(exp)
            var setter = getter.assign
            var varToFind = exp.split('.')[0]
            var ngModelScope = $rootScope.findInParentScope(ThisDoc, varToFind, true)
            var setNgModel = function (val) { setter(ngModelScope, val) }
        }

        //init globals
        var ckEditor, ckEditor_div, remoteContent = ThisDoc.item[ThisDoc.itemField] || "",
            savedContent = remoteContent,
            typing = false,
            pendingPatches = [],
            sessionRootTagCounter = 0,
            debounceChange, dmp = new diff_match_patch(),
            origReadOnly = false, lastSave = Date.now() + 10000,
            lastSaveTimeout, ignoreItemUpdate = null,
            ignoreItemUpdateTimer, rootScopeListeners = [],
            joinDocInterval, sessionId = new ObjectId().toString()
        ThisDoc.usersInDoc = {}

        //init defaults
        if (!angular.isDefined(ThisDoc.displayMode)) ThisDoc.displayMode = 'document'
        if (!angular.isDefined(ThisDoc.autoSave)) ThisDoc.autoSave = true
        ThisDoc.stickyToolbar = true

        //assign a room id for real-time
        ThisDoc.$roomId = ThisDoc.item.$key + ThisDoc.item._id + ThisDoc.itemField

        //init suggestion box
        var suggestBox = $element.find('.au-suggestions')
        suggestBox.close = function () {
            suggestBox.fadeOut('fast')
            suggestBox.isOpen = false
            suggestBox.appendTo($element)
        }

        suggestBox.open = function (rect) {
            var offset = $element[0].getClientRects()[0]
            var popUp = $rootScope.windowHeight - rect.top < 300
            var popLeft = $rootScope.windowWidth - rect.left < 300

            suggestBox.css('max-width', Math.min($rootScope.windowWidth - rect.left, 400))

            suggestBox.appendTo(document.body)

            if (popLeft) {
                suggestBox.css('left', '')
                suggestBox.css('right', $rootScope.windowWidth - offset.right + 15)
            } else {
                suggestBox.css('right', '')
                suggestBox.css('left', rect.left - 15)
            }

            if (popUp) {
                suggestBox.css('bottom', $rootScope.windowHeight - rect.bottom + 25)
                suggestBox.css('top', "")
                suggestBox.css('max-height', rect.bottom - 100)
            } else {
                suggestBox.css('top', rect.top + 25)
                suggestBox.css('bottom', "")
                suggestBox.css('max-height', $rootScope.windowHeight - rect.top - 50)
            }

            suggestBox.fadeIn('fast')
            suggestBox.isOpen = true
            suggestBox.scrollTop(0)

            //close the dropdown when the document is clicked
            angular.element(document).one('click', function () {
                suggestBox.close()
            })
        }

        //init the ckEditor
        CKEDITOR.dtd.$removeEmpty.span = 0
        CKEDITOR.dtd.$inline['au-profile-image'] = 1
        CKEDITOR.dtd.p['au-profile-image'] = 1
        CKEDITOR.dtd.span['au-profile-image'] = 1
        CKEDITOR.dtd['au-profile-image'] = { 'span': 1 }

        //watch a passed in variable the page hosting this may update to trigger the content to re-center
        if (ThisDoc.resizeTrigger !== undefined) {
            $scope.$watch('resizeTrigger', function () {
                setTimeout(sizeEditor, 1000)
            })
        }

        //apply the displayMode
        $element.addClass(ThisDoc.displayMode)

        //find the root div tag to replace
        var ckDiv = $element.find('.au-cke-document-editor')[0]

        var extraPlugins = "horizontalrule,tab,preview,stylescombo,uploadimage,image2,justify,pagebreak"
        var ckEditorConfig = {
            //ckEditor actively massages the html to ensure that only valid HTML is present - this tells ckEditor what tags[attributes]{styles}(classes); ... are valid see http://docs.ckeditor.com/#!/guide/dev_allowed_content_rules-section-2 for reference
            extraAllowedContent: '*[id]; table(table,table-header,table-striped,table-bordered,table-hover); span div[ng-if,ng-style,style,contenteditable,title,aria-label]{font-family,font-*background-color,width,height,background-image,layout-column,top,left,right,bottom,border,margin-*,border-*,line-height}(remote-cursor,user-*,blinker,blink-link,au-*,initials-image,md-avatar); au-profile-image[*](*); img[src,class]{width,height}', //tell ckeditor ACT to allow the id attribute in p tags 
            extraPlugins: extraPlugins,
            qtWidth: '100%', // Width of the inserted table (default: '500px')
            qtClass: 'table table-bordered table-header table-hover', // Class of the inserted table (default: '')
        }

        //slim down the UI
        if (ThisDoc.displayMode == 'field') {
            ckEditorConfig.toolbarGroups = [
                { name: 'basicstyles', groups: ['basicstyles'] },
                { name: 'styles' },
                { name: 'insert' },

                { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi'] },
                { name: 'links' },
            ];
            ckEditorConfig.removeButtons += ',PageBreak,Anchor,Superscript,Subscript,Styles'

            //slim it down even further
            if ($element.hasClass('md-input')) {
                ckEditorConfig.toolbarGroups = [
                    { name: 'insert' },
                    { name: 'basicstyles', groups: ['basicstyles'] },
                    { name: 'styles' }
                ];

                ckEditorConfig.removeButtons += ',Image,HorizontalRule,Table'
                ThisDoc.stickyToolbar = false
            }
        }

        //fixed with UI
        if (ThisDoc.displayMode == 'document') {
            ckEditorConfig.extraPlugins += ',au-task,tab,indent,indentlist,indentblock,table,quicktable,listblock,tabletools,tableresize'
        }

        //add extra plugins via markup
        if (ThisDoc.extraPlugins) {
            ckEditorConfig.extraPlugins += ',' + ThisDoc.extraPlugins
        }

        //turn the root div tag into a ckEditor
        ckEditor = CKEDITOR.replace(ckDiv, ckEditorConfig)

        //expose a variable that plugins can use to tell the editor to temporarily ignore changes
        ckEditor.ignoreChange = false

        //allow other directives to focus and interact with the ckeditor
        $element.attr('ckId', ckEditor.name)
        ThisDoc.focusEditor = function () {
            setTimeout(function () { ckEditor.focus() })
        }

        //focus the editor when the outer panel is clicked
        $element.on('click', ThisDoc.focusEditor)

        //expose the rootScopeListeners for plugins
        ckEditor.rootScopeListeners = rootScopeListeners

        //init the doc when ckeditor is ready
        ckEditor.on('instanceReady', function instanceReady(event) {
            //set reference to raw dom div - ckEditor.setData and getData are overkill.
            ckEditor_div = $element.find('.cke_wysiwyg_div')

            //remove the annoying title attribute
            ckEditor_div.removeAttr('title')

            //can-edit markup should be like can-edit='$root.User.any' or can-edit='vm.item' acl='U'
            if (!ThisDoc.canEdit) {
                disableEditor()
            } else if (ThisDoc.acl) {
                ThisDoc.canEdit.userHasAcl(ThisDoc.acl).then(function (hasPerm) {
                    if (hasPerm) return //don't disable anything
                    disableEditor()
                })
            } else {
                origReadOnly = false
            }
            function disableEditor() {
                setReadOnly(true)
                origReadOnly = true
            }

            //set the data to the item content
            setLocalContent(remoteContent)

            //establish the placeholder
            updatePlaceholder()

            //adjust UI
            sizeEditor()

            //join the document's room
            joinDocument()

            //set focus
            if (ThisDoc.autoFocus) ckEditor.focus()

            //set up the change/atRest handler
            ckEditor.on('change', function (evt) {
                if (ckEditor.ignoreChange) return

                //if the user was at rest, let the server know they are now busy
                if (!typing && ThisDoc.autoSave) socket.emit('at-rest-document', ThisDoc.$roomId, false)
                typing = true

                //interact with ckeditor toolbar
                updateJustifyButton()

                //show or hide the placeholder
                updatePlaceholder()

                //after the user stops changing things for a moment, declare the user back at rest
                if ($element.attr('ng-model')) {
                    atRest()
                } else {
                    if (debounceChange) clearTimeout(debounceChange)
                    debounceChange = setTimeout(function () {
                        typing = false
                        atRest()
                    }, 250)
                }

                //auto-suggest if the current word starts with # or @
                var currentWord = CKEDITOR.getCurrentWord(ckEditor)
                if (currentWord && (currentWord.indexOf("#") == 0 || currentWord.indexOf("@") == 0 || currentWord.indexOf("+") == 0)) {
                    //open the suggest box by positioning it absolute to the editor
                    if (!suggestBox.isOpen) {
                        var loc = getSelectionCoords()

                        suggestBox.open(loc.rect)
                    }

                    //arrow down/up sometimes cause the change event so make sure the word changed before suggesting again
                    if (currentWord.length == 1 || ThisDoc.searchWord != currentWord.substr(1)) {
                        ThisDoc.$apply(function () {
                            suggest(currentWord.replaceAll('_', ' '))
                        })
                    }
                } else {
                    //all other changes should close the suggest box
                    if (suggestBox.isOpen) {
                        ThisDoc.searchWord = ""
                        suggestBox.close()
                    }
                }
            }); //end change

            ckEditor.on('blur', function (evt) {
                atRest()
            })

            //handle image pastes and drops
            ckEditor.on('fileUploadRequest', function (evt) {
                var file = evt.data.fileLoader.file

                //create an image so we can check the size
                var img = new Image()
                img.src = window.URL.createObjectURL(file)

                img.onload = function () {
                    if (img.height > 200) {
                        var style = 'max-height: 200px !important;'
                    }
                    //upload the file to s3
                    s3Service.uploadSignedFiles([file], null, true).then(function (data) {
                        ckEditor.insertHtml("<img src='{0}' class='user-image' style='{1}' />".format(data[0].publicURL, style), 'unfiltered_html')
                        $rootScope.$broadcast('image2Change')
                    })
                }

                // Prevented default behavior.
                evt.stop();
                evt.cancel();
            }, null, null, 4);

            //highlight a mention when the cursor moves to it (like when the user is backspacing)
            var selectedMention = null
            rootScopeListeners.push(ckEditor.on('selectionChange', function (event) {
                if (event.data.path.lastElement && event.data.path.lastElement.hasClass('doc-mention')) {
                    selectedMention = event.data.path.lastElement
                    selectedMention.addClass('selected')
                } else if (selectedMention) {
                    selectedMention.removeClass('selected')
                    selectedMention = null
                }
            }))

            //auto-suggest key handling - select suggestion w/ keyboard
            rootScopeListeners.push(ckEditor.on('key', function (event) {
                if (ThisDoc.onKeyPress) {
                    ThisDoc.onKeyPress(event)
                }

                if (suggestBox.isOpen) {
                    switch (event.data.keyCode) {
                        case 13:
                            //handle enter key pressed
                            event.cancel();
                            event.stop();

                            if (ThisDoc.suggestItems[ThisDoc.suggestIndex].isSection) return
                            insertMention(ThisDoc.suggestIndex)

                            atRest() //apply
                            break
                        case 27:
                            //handle esc
                            if (suggestBox.isOpen) {
                                event.cancel();
                                event.stop();
                                suggestBox.close();
                            }
                        case 40:
                            //handle arrow down pressed
                            event.cancel();
                            event.stop();

                            ThisDoc.suggestIndex++
                            if (ThisDoc.suggestIndex > ThisDoc.suggestItems.length - 1) ThisDoc.suggestIndex = ThisDoc.suggestItems.length - 1
                            if (ThisDoc.suggestItems[ThisDoc.suggestIndex].isSection) ThisDoc.suggestIndex++
                            $scope.$apply()

                            suggestBox.scrollTop((ThisDoc.suggestIndex - 5) * 35)
                            break
                        case 38:
                            //handle arrow up pressed
                            event.cancel();
                            event.stop();

                            ThisDoc.suggestIndex--
                            if (ThisDoc.suggestItems[ThisDoc.suggestIndex].isSection) ThisDoc.suggestIndex--
                            if (ThisDoc.suggestIndex < 1) ThisDoc.suggestIndex = 1
                            $scope.$apply()

                            suggestBox.scrollTop((ThisDoc.suggestIndex - 5) * 35)
                            break
                    }
                }

                //listen for Enter
                if (ThisDoc.onEnter && !suggestBox.isOpen && !event.shiftKey && (event.data.keyCode == 13 || event.data.keyCode == 1114125)) {
                    atRest()
                    ThisDoc.onEnter(event)

                    if (!$rootScope.$$phase) ThisDoc.$apply()
                }
            }))

            //attach a mouse up event handler to broadcast remote cursor locations
            if (ThisDoc.autoSave) {
                rootScopeListeners.push(ckEditor.editable().on('click', cursorChanged))
                rootScopeListeners.push(ckEditor.on('key', function (event) {
                    if (event.data.keyCode >= 37 && event.data.keyCode <= 40) {
                        //let the keydown come back up to get the proper location
                        setTimeout(cursorChanged, 1)
                    }
                }))
            }

            function cursorChanged() {
                broadcastCursorLocation()
                updateJustifyButton()
                suggestBox.close()
            }

            //immediately declare the editor at rest on load			
            atRest()

        }); // end instanceReady

        function joinDocument() {
            if (ThisDoc.autoSave) {
                socket.emit('join-document', ThisDoc.$roomId)
            }
        }

        //when the user exits the document...
        function unload() {
            //save content if needed
            if (ThisDoc.autoSave) saveContent()

            //unregister global/window event handlers			
            delete window.onbeforeunload
            if (ThisDoc.autoSave) socket.emit('leave-document', ThisDoc.$roomId)
            socket.off('patch-document', patchReceived)
            socket.off('save-document', saveDocument)
            socket.off('remote-cursor-change', remoteCursorChange)
            socket.off('users-in-document', setUsersInDocument)

            angular.element($window).unbind('resize', sizeEditor)

            for (var i = 0; i < rootScopeListeners.length; i++) {
                if (rootScopeListeners[i].removeListener) rootScopeListeners[i].removeListener()
                else rootScopeListeners[i]()
            }

            $element.find('.remote-cursor').remove()

            ckEditor.destroy()
        }
        $scope.$on('$destroy', unload)
        window.onbeforeunload = unload

        if (ThisDoc.autoSave) {
            //immediately show/hide the "holy guacamole"
            $scope.$on('socket-reconnected', function () {
                $element.find('.au-cke-document-disconnected').hide()
                setReadOnly(origReadOnly)
            })

            //set up the socket reconnection handler
            $scope.$on('socket-disconnected', function () {
                setReadOnly(true)
                $element.find('.au-cke-document-disconnected').show()
            })

            //send a socket command after the socket it auth'd (will refactor to joinRoom soon)
            $scope.$on('user-socket-reconnected', function () {
                joinDocument()
            })
        }

        //resize the editor when the window size changes
        angular.element($window).bind('resize', sizeEditor)

        //when the user is at rest...
        function atRest() {
            if (ckEditor.ignoreChange) return

            console.debug('at rest')

            //give each <p> tag a unique identifier (helps dmp identify what changed a little better)			
            tagRoots()

            //if there are other users in this document send patches			
            if (Object.keys(ThisDoc.usersInDoc).length > 1) {
                //first, compare the existing content with the saved content			
                //if there are differences, create a patch against what the user has saved and the existing content 
                //do this before applying any pending patches
                var existingContent = getLocalContent()

                if (contentChanged(savedContent, existingContent)) {
                    //create patch
                    var diff = dmp.diff_main(savedContent, existingContent)
                    dmp.diff_cleanupEfficiency(diff)
                    var patch = dmp.patch_toText(dmp.patch_make(savedContent, diff))

                    //if (patch.length > 60) debugger

                    //send patch
                    console.debug('sending patch', patch)
                    socket.emit('patch-document', ThisDoc.$roomId, patch)

                    //save new content
                    savedContent = existingContent
                }

                //apply any pendingPatches			
                if (pendingPatches.length > 0) {
                    for (var i = 0; i < pendingPatches.length; i++) {
                        //apply patches in the order received
                        var patch = pendingPatches.shift()
                        applyPatch(patch)
                    }

                    //refresh the existing content after patching
                    existingContent = getLocalContent()
                }

                //since the cursor moved, broadcast the cursor location			
                broadcastCursorLocation()

                //let the server know this user is at rest
                socket.emit('at-rest-document', ThisDoc.$roomId, true)
            } else {
                //if this is the only user in the doc, just save like any other item
                //ignoreChanges()
                if (ThisDoc.autoSave) {
                    //super hack to mimic the auto-save fab
                    debounceSave()
                } else {
                    ThisDoc.item[ThisDoc.itemField] = getLocalContent()

                    //parse the ng-model expression and set the correct object property
                    if ($element.attr('ng-model')) {
                        setNgModel(ThisDoc.item[ThisDoc.itemField])
                    }

                    if (!$rootScope.$$phase) ThisDoc.$apply()
                }
            }
        }

        var debounceSave = debounce(function () {
            saveContent()
        }, 3000)

        function markParentFormDirty() {
            //find the form above me and mark it dirty
            throw new Error('Implement markParentFormDirty if you need this!')
        }

        function updatePlaceholder() {
            if (ThisDoc.placeholder && CKEDITOR.cleanText(ckEditor_div.text().trim()) == "" && ckEditor_div.find('img').length == 0) {
                $element.find('.au-cke-document-placeholder').show()
            } else {
                $element.find('.au-cke-document-placeholder').hide()
            }
        }

        //return a copy of the content suitable for diffing and saving		
        function getLocalContent(element) {
            if (!element) element = ckEditor_div

            //get a clone of the existing dom
            var clone = angular.copy(element)

            //turn task widgets into <task> tags			
            clone.find('.au-task').each(function () {
                var This = this
                angular.element(This).parent().replaceWith(function () {
                    return '<task id="' + This.id + '"></task>'
                })
            })

            //turn image widgets into plain <img> tags
            clone.find('.user-image:not(.not-a-widget), .cke_widget_wrapper img[data-widget="image"]').each(function () {
                var This = this,
                    el = this,
                    caption = "",
                    align = "",
                    wrapper

                if (This.nodeName == 'FIGURE') {
                    caption = This.querySelector('figcaption').innerHTML
                    This = This.querySelector('img')
                }

                wrapper = This.closest('.cke_widget_wrapper')

                align = wrapper.style.float
                if (wrapper.style.textAlign == "center") {
                    align = "center"
                }
                if (!align) {
                    var wrapChildren = wrapper.children
                    for (var i = 0; i < wrapChildren.length; i++) {
                        if (wrapChildren[i].style.textAlign == "center") {
                            align = "center"
                        }
                    }
                }

                //TODO: this should carry the max-height, too - can all styles be included?
                angular.element(wrapper).replaceWith(
                    '<img src="{0}" style="width: {1}; max-height: {2}" alt="{3}" caption="{4}" class="user-image not-a-widget" id="{5}" align="{6}"/>'.format(This.src, This.style.width, This.style.maxHeight, This.alt, caption.replaceAll('"', '&quot;'), This.id, align)
                )
            })

            //strip out the remote cursors
            clone.find('.remote-cursor').remove()

            //remove any junk left over from cke-editor - was removing img tags
            clone.find('[data-cke-widget-wrapper]').remove()

            //remove ckeditor cke-hidden stuff
            clone.find('[data-cke-hidden-sel]').remove()

            //allow the directive host to process the content
            if ($element.attr('process-content')) {
                ThisDoc.processContent(clone)
            }

            //convert the dom to a string			
            var existingContent = clone.html()

            //strip out zero width chars put in the ckeditor selection ranges
            existingContent = CKEDITOR.cleanText(existingContent)

            return existingContent
        }
        ckEditor.getLocalContent = getLocalContent

        //process incoming content and decorate it with cursors, tasks, etc.		
        function setLocalContent(content, element) {
            if (element == undefined) element = ckEditor_div

            //-before smashing the content, grab the cursor, image and task dom elements so we can reuse them
            //save the user's current cursor position
            var savedSelection = saveSelection()

            //detach all remote cursors from the current dom
            var remoteCursors = element.find('.remote-cursor')
            remoteCursors.detach()

            //detach all the task widgets from the current dom
            var taskWidgets = element.find('.au-task').parent()
            taskWidgets.detach()

            //detach all the image widgets from the current dom
            var imgWidgets = element.find('.user-image:not(.not-a-widget)').parent()
            imgWidgets.detach()

            //apply content to the dom - by not using ckEditor.setData we can avoid re-initializing all the widgets and freaking ckEditor out that we change all the data constantly
            ignoreChanges()
            element.html(CKEDITOR.cleanText(content))

            //replace the <task> tags with the current task widgets from the dom
            taskWidgets.each(function () {
                var taskId = this.querySelector('.au-task').id
                element.find('task#' + taskId).replaceWith(this)
            })

            //if any <task> tags are present, this is the first time this editor instance has seen them from the DB so replace them with the template and expect the task init to fill the details in
            var inflateTasks = element.find('task')
            angular.forEach(inflateTasks, function (inflateTask) {
                //get the string based template
                var template = $rootScope.docTask.template.replace('NewTask', inflateTask.id)

                //turn the template into a ckeditor node
                template = CKEDITOR.dom.element.createFromHtml(template)

                //replace the <task> tag with the template
                template.replace(CKEDITOR.dom.element.get(inflateTask))

                //turn the template into a widget (and run the init)
                ckEditor.widgets.initOn(template, 'au-task')
            })

            //if any <img> tags are present with the not-a-widget class, turn them into widgets
            var inflateImgs = element.find('img.not-a-widget')
            angular.forEach(inflateImgs, function (inflateImg) {
                //first, search for existing (detached) widgets
                var foundWidget = false
                imgWidgets.each(function (index, imgWidget) {
                    if (imgWidget.querySelector('img').id == inflateImg.id) {
                        //replace the plain <img> with a widget 
                        foundWidget = true
                        inflateImg.replaceWith(imgWidget)

                        //find the widget in the document by element						
                        var widget = ckEditor.widgets.getByElement(CKEDITOR.dom.element.get(imgWidget.children[0]))
                        if (!widget) return

                        //update the widget properties from the <img> properties						
                        if (widget.editables.caption)
                            widget.editables.caption.$.innerHTML = inflateImg.attributes.caption.value
                        widget.setData('width', inflateImg.style.width)
                        widget.setData('height', inflateImg.style.height)
                        widget.setData('align', inflateImg.attributes.align.value)
                        widget.setData('alt', inflateImg.attributes.alt.value)
                    }
                })

                //if the widget was not found, turn the <img> into a widget (like when the doc first loads)				
                if (foundWidget) return

                //start by removing the not-a-widget class because we are turning this into a widget now and don't want to do so again
                inflateImg.classList.remove('not-a-widget')

                //if this is in a caption, we'll add the user-image class to the figure so remove it from the img tag
                if (inflateImg.attributes.caption.value + "" != "") {
                    inflateImg.classList.remove('user-image')
                }

                //get the string version of the inflateImg and set up an empty dat object
                var template = inflateImg.outerHTML,
                    data = {}

                //wrap the image in a figure/caption if needed
                if (inflateImg.attributes.caption.value + "" != "") {
                    template = '<figure class="user-image">' +
                        template +
                        '<figcaption>{0}</figcaption>' +
                        '</figure>'
                    template = template.format(inflateImg.attributes.caption.value)
                }

                //set the data.align to what the tag has
                data.align = inflateImg.attributes.align.value

                //if we need to center this and we don't already have a container from the caption, add a block level container (div)
                if (inflateImg.attributes.align.value + "" == "center" && inflateImg.attributes.caption.value + "" == "") {
                    template = '<div style="text-align:center">' + template + '</div>'
                }

                //turn the string template into a ckeditor node
                template = CKEDITOR.dom.element.createFromHtml(template)

                //replace the <img> tag with the template
                template.replace(CKEDITOR.dom.element.get(inflateImg))

                //turn the template into a widget (and run the init)
                ckEditor.widgets.initOn(template, 'image', data)
            })

            //restore remote cursors back to the dom
            angular.forEach(ThisDoc.usersInDoc, function (user) {
                //for every user...

                if (!user.cursor) return

                //find their cursor in the now detached array of cursors
                var remoteCursor
                remoteCursors.each(function (i, cursor) {
                    if (cursor.id == 'rc' + user.user._id + user.sessionId) {
                        remoteCursor = cursor
                    }
                })
                if (!remoteCursor) return

                //find the startPath of the last known cursor parent
                var newContainer = $element.find(user.cursor.startPath)
                if (!newContainer) return

                //put the cursor back in the dom
                newContainer.prepend(remoteCursor)

                //set the cursor to the last known location
                if (!user.cursor.coords) return
                remoteCursor.style.top = user.cursor.coords.y
                remoteCursor.style.left = user.cursor.coords.x
            })


            //restore this user's (typing) cursor location
            if (savedSelection && content != "") {
                restoreSelection(savedSelection)
            } else {
                //debugger
            }

            if (element != ckEditor_div) return

            //remember what we just applied
            savedContent = getLocalContent()

            //if this was called by something other than atRest, the placeholder may need updating
            updatePlaceholder()
        }
        ckEditor.setLocalContent = setLocalContent

        //compare two sets of content ignoring items that ckEditor often changes on its own		
        function contentChanged(contentA, contentB) {

            //prior to the deflate/inflate pattern, we ignored content - it's here for reference and ideas in the future
            //contentA = ignoreCkContent(contentA)
            //contentB = ignoreCkContent(contentB)

            return contentA != contentB
        }

        function ignoreCkContent(content) {
            var ignores = [
                /data-cke-widget-id=".*?"/g,
                /data-cke-filter=".*?"/g,
                /<div data-cke-hidden-sel="1" data-cke-temp="1" id=".*?<\/div>/g,
                /<span class="cke_reset cke_widget_drag_handler_container.*?<\/span>/g,
                / *cke_widget_editable_focused */g
            ]

            for (var i = 0; i < ignores.length; i++) {
                content = content.replace(ignores[i], '')
            }

            return content
        }

        //give each root tag a unique id		
        function tagRoots() {
            var roots = $element.find('.cke_contents .cke_wysiwyg_div > *:not([id]):not([data-cke-widget-wrapper]), .user-image:not([id])')

            angular.forEach(roots, function (root) {
                root.id = 'au' + sessionId + '_' + sessionRootTagCounter
                sessionRootTagCounter++

                //issue insertNodeAfter(content, afterId)
            })

            if ($element.attr('ng-model')) return

            //ensure the last node is always a paragraph (and thus can be clicked into)
            if (ckEditor_div.children().last()[0].tagName != "P" ||
                ckEditor_div.children().last().html().length > 4) {
                sessionRootTagCounter++
                ckEditor_div.children().last().after('<p id="au' + sessionId + '_' + sessionRootTagCounter + '"><br></p>')
            }
        }

        //when a patch comes in, apply it if the user is at rest, queue it if not		
        socket.on('patch-document', patchReceived)

        function patchReceived(doc_id, patch) {
            if (doc_id == ThisDoc.$roomId) {
                if (typing) {
                    pendingPatches.push(patch)
                } else {
                    applyPatch(patch)
                }
            }
        }

        var saveEvery = 20 //seconds
        //when the server sees all clients at rest, it will send 'save-document' ONLY to the first connected client immediately
        //when the client receives the save-document command, it will become the master content and overwrite all other client content, eventually...
        socket.on('save-document', saveDocument)

        function saveDocument(doc_id) {
            //the server 
            //save several seconds after the first save-document message was received			
            var now = Date.now()
            if (doc_id == ThisDoc.$roomId) {
                clearTimeout(lastSaveTimeout)
                if (now - lastSave > saveEvery * 1000) {
                    saveContent()
                } else {
                    //10 seconds have not elapsed since the last save-document command so start a new time with the remaining time
                    lastSaveTimeout = setTimeout(saveContent, saveEvery * 1000 - (now - lastSave))
                }
            }
        }

        function saveContent() {
            var localContent = getLocalContent()
            if (contentChanged(localContent, remoteContent)) {
                console.debug('saving full content, diff since last save', Date.now() - lastSave)

                //update tracking vars
                remoteContent = localContent
                lastSave = Date.now()

                //since this user just saved, and it's likely that auCacheUpdater will fire an itemUpdate from this update, ignore this item's updates for 10 seconds (we just sent the content and no other clients will) 
                ignoreItemUpdate = ThisDoc.$roomId
                clearTimeout(ignoreItemUpdateTimer)
                ignoreItemUpdateTimer = setTimeout(function () { ignoreItemUpdate = null }, saveEvery * 1000)

                //note that this should be after ignoreItemUpdate is set
                //update the item
                ThisDoc.item[ThisDoc.itemField] = localContent
                ThisDoc.item.$updateItem()
            }
        }

        //ensure the document has a dom element (.remote-cursor) for each user in the document			
        socket.on('users-in-document', setUsersInDocument)

        function setUsersInDocument(doc_id, users) {
            if (doc_id != ThisDoc.$roomId) return

            console.debug('usersInDoc', users)

            //managed object with keys of user_id
            //object has:
            // - user {resource}
            // - cursor {cursorLoc}

            //remove users from the scope that dropped out		
            angular.forEach(ThisDoc.usersInDoc, function (user, key) {
                var foundUser = false
                users.forEach(function (user) {
                    if (user.sessionId == key) {
                        foundUser = true
                    }
                })
                if (!foundUser) {
                    delete ThisDoc.usersInDoc[key]
                }
            })

            //remove remote cursors for users that dropped out			
            $element.find('.remote-cursor').each(function (i, cursor) {
                var orphanCursor = true
                angular.forEach(ThisDoc.usersInDoc, function (user, key) {
                    if (user.user + user.sessionId == cursor.id.substr(2)) {
                        orphanCursor = false
                    }
                })
                if (orphanCursor) {
                    cursor.remove()
                }
            })


            angular.forEach(users, function (user) {
                var user_id = user.user
                if (!ThisDoc.usersInDoc[user.sessionId]) ThisDoc.usersInDoc[user.sessionId] = {}
                if (!ThisDoc.usersInDoc[user.sessionId].user) ThisDoc.usersInDoc[user.sessionId].user = User.getCache({ _id: user_id })[0]
                if (!ThisDoc.usersInDoc[user.sessionId].sessionId) ThisDoc.usersInDoc[user.sessionId].sessionId = user.sessionId
                if (!ThisDoc.usersInDoc[user.sessionId].cursor) ThisDoc.usersInDoc[user.sessionId].cursor = {}
                if (user.sessionId != window.session_id && $element.find('#rc' + user_id + user.sessionId).length == 0) {
                    $element.find('.cke_contents .cke_wysiwyg_div > *:first-child').prepend($compile(
                        '<span contenteditable="false" class="remote-cursor" id="rc' + user_id + user.sessionId + '">' +
                        '<span class="blinker"></span>' +
                        '<span class="blink-link"></span>' +
                        '<au-profile-image class="profile-container" user="\'' + user_id + '\'" size="20"></au-profile-image>' +
                        '<md-tooltip>' + ThisDoc.usersInDoc[user.sessionId].user.toString() + '</md-tooltip>' +
                        '</span>')($scope))
                }
            })
        }

        //move the remote cursor for a user
        socket.on('remote-cursor-change', remoteCursorChange)

        function remoteCursorChange(doc_id, user_id, sessionId, remoteCursorLoc) {
            if (doc_id != ThisDoc.$roomId) return

            //if any variables for this user are missing, rejoin the doc			
            if (!ThisDoc.usersInDoc || !ThisDoc.usersInDoc[sessionId] || !ThisDoc.usersInDoc[sessionId].cursor) {
                joinDocument()
                return
            }

            ThisDoc.usersInDoc[sessionId].cursor = remoteCursorLoc

            //locate the doc .remote-cursor for this user - if it's not there, create it by calling setUsersInDocument			
            var remoteCursor = $element.find('#rc' + user_id + sessionId)
            if (remoteCursor.length == 0) {
                var mappedUsers = []
                for (var p in ThisDoc.usersInDoc) {
                    var u = ThisDoc.usersInDoc[p]
                    mappedUsers.push({ user: u.user._id, sessionId: u.sessionId })
                }
                setUsersInDocument(ThisDoc.$roomId, mappedUsers)
            }

            //attach the remote cursor to the appropriate root tag (usually a <p> tag)			
            var newContainer = $element.find(remoteCursorLoc.startPath)
            if (!newContainer) return

            if (remoteCursor.parent()[0] != newContainer[0]) {
                remoteCursor.detach()

                remoteCursor.css('top', 0)
                remoteCursor.css('left', 0)

                newContainer.prepend(remoteCursor)
            }

            //set the cursor top/left			
            remoteCursor.css('top', Math.max(remoteCursorLoc.coords.y, 0))
            remoteCursor.css('left', Math.max(remoteCursorLoc.coords.x, 0))
        }

        function broadcastCursorLocation() {
            //if you are the only one in the doc, skip this.
            if (Object.keys(ThisDoc.usersInDoc).length == 1) return

            ckEditor.document.$.normalize() //collapse adjacent text nodes

            //get the x/y of the cursor which is an offset from the nearest position:relative tag (typically a root <p> tag)			
            var coords = getSelectionCoords();

            //figure out what root tag they are in			
            var selection = ckEditor.getSelection();
            var range = selection.getRanges()[0];
            if (range) {
                console.debug('broadcasting cursor location')
                var startPath = getPath(range.startContainer.$).split(' > ')[0]
                var offset = angular.element(startPath).offset()

                if (!offset) return

                //subtract the root tag offset from the cursor x/y				
                coords.x -= offset.left
                coords.y -= offset.top

                //send the cursor location to the server				
                socket.emit('document-cursor-change', ThisDoc.$roomId, $rootScope.user._id, window.session_id, {
                    startPath: startPath,
                    coords: coords
                })

            }
        }

        function getSelectionCoords() {
            var x = 0,
                y = 0,
                rect = null
            var sel = window.getSelection();
            var range //= sel.getRanges()[0]
            if (sel.rangeCount) {
                range = sel.getRangeAt(0).cloneRange();
                if (range.getClientRects) {
                    range.collapse(true);
                    var rects = range.getClientRects();
                    if (rects.length > 0) {
                        x = rects[0].left;
                        y = rects[0].top;
                        rect = rects[0]
                    }
                }
            } else {
                //debugger
            }

            return { x: x, y: y, rect: rect };
        }

        function ignoreChanges() {
            //if something else already told this to ignorechanges, let that process stop ignoring, too.
            if (ckEditor.ignoreChange) return

            ckEditor.ignoreChange = true
            $timeout(function () {
                ckEditor.ignoreChange = false
            }, 10, false)
        }

        //         //when the first connected client saves the item content, the standard auCacheUpdater logic kicks in and the other clients
        //         //eventually pick up the new item.		
        //         rootScopeListeners.push($rootScope.$on('itemUpdated', function (event, item) {
        //             if (!ThisDoc.item) return

        //             if (item.$key == ThisDoc.item.$key && item._id == ThisDoc.item._id) {
        //                 //since this method is really just cya as the content should be getting patched along the way, if the user is typing, don't interfere, else, apply the new content
        //                 if (!typing && ignoreItemUpdate != ThisDoc.$roomId) {
        //                     item[ThisDoc.itemField] = item[ThisDoc.itemField] || ""

        //                     //sync all versions of the content with the new item content
        //                     remoteContent = ThisDoc.item[ThisDoc.itemField] = item[ThisDoc.itemField]

        //                     //if the new content is different, update the editor (shouldn't happen unless a conflict occurred)
        //                     if (contentChanged(getLocalContent(), item[ThisDoc.itemField])) {
        //                         console.debug('applying content', item[ThisDoc.itemField].length)
        //                         setLocalContent(item[ThisDoc.itemField])
        //                     }

        //                 } else {
        //                     //debugger
        //                 }
        //             }
        //         }))

        //given a patch, apply it to the existing content`		
        function applyPatch(patch) {
            console.debug('applying patch', patch)

            //use dmp to apply the patch to the saved content (which should be the existing content, too)
            var remoteDiff = dmp.patch_fromText(patch)
            var remotePatchResult = dmp.patch_apply(remoteDiff, savedContent)

            //replace the content - tell the .change event to ignore this change
            setLocalContent(remotePatchResult[0])
        }

        // save cursor position/selection
        function saveSelection() {
            ckEditor.document.$.normalize() //collapse adjacent text nodes
            var selection = ckEditor.getSelection();
            var range = selection.getRanges()[0];
            if (range) {
                try {
                    var startPath = getPath(range.startContainer.$);
                    var endPath = getPath(range.endContainer.$);
                    return {
                        startPath: startPath, //a valid CSS selector - usually something like `p#au12345_1 > div`
                        startOffset: range.startOffset, //where within the text the user is - 0 is the before the first character of the <p> tags content
                        endPath: endPath, //a valid css selector - will equal the startPath unless the user is selecting text
                        endOffset: range.endOffset //usually the same as startOffset unless the user is highlighting/selecting text 
                    }
                } catch (e) {
                    console.debug('error getting paths for selection')
                    return null
                }
            } else {
                return null
            }
        }

        // restore selection
        function restoreSelection(savedSelection) {
            var startElement, endElement, startOffset, endOffset

            //collapse adjacent text nodes
            ckEditor.document.$.normalize()

            //ensure the editor has focus
            ckEditor.focus();

            //all cursors have a start and end - usually they are the same unless content is highlighted but we still have to set both to restore the cursor location

            //set the start path and offset
            try {
                //try to set the cursor to exactly where is was
                startElement = ckEditor.document.findOne(savedSelection.startPath).getFirst()

                //get out if this is not editable
                if (startElement.$.nodeName != "#text") return

                startOffset = savedSelection.startOffset
                if (startOffset > startElement.$.length) startOffset = startElement.$.length
            } catch (e) {
                try {
                    //since the content is volitile, the saved start path and offset may no longer exist (common with blank lines)
                    //expect the first part of the path to be an id and then try to get within that
                    if (e.message == "Cannot read property 'getFirst' of null") {
                        startElement = ckEditor.document.findOne(savedSelection.startPath.split(' > ')[0])
                        startOffset = savedSelection.startOffset
                        if (startOffset > startElement.$.innerText.length) startOffset = startElement.$.length
                    }
                } catch (e) {
                    //the start element was probably removed...
                    //debugger
                    console.error('Cant set selection start', savedSelection.startPath)
                }
            }

            //set the end path and offset			
            try {
                endElement = ckEditor.document.findOne(savedSelection.endPath).getFirst()
                endOffset = savedSelection.endOffset
                if (endOffset > endElement.$.length) endOffset = endElement.$.length
            } catch (e) {
                try {
                    //that element doesn't exist (common with blank lines)
                    //expect the first part of the path to be an id and then try to get within that
                    if (e.message == "Cannot read property 'getFirst' of null") {
                        endElement = ckEditor.document.findOne(savedSelection.endPath.split(' > ')[0])
                        endOffset = savedSelection.endOffset
                        if (endOffset > endElement.$.innerText.length) endOffset = endElement.$.length
                    }
                } catch (e) {
                    //debugger
                    console.error('Cant set selection end', savedSelection.endPath)
                }
            }

            // replace full selection
            if (startElement && endElement) {
                console.log('setting cursor', startElement, endElement)
                var range = ckEditor.createRange();
                try {
                    range.setStart(startElement, startOffset);
                    range.setEnd(endElement, endOffset);
                    var selection = ckEditor.getSelection();
                    selection.selectRanges([range]);
                } catch (e) {
                    //debugger
                    console.log(['FAIL REPLACE RANGE', e]);
                }
            }
        }

        function sizeEditor() {
            if ($element.selector == '#DialogRecentItem' && $element.length == 0) {
                $element = angular.element('#DialogRecentItem')
            }
            var scrollContainer = $element.find('.cke_contents').scrollParent()
            var contentClipper = $element.find('.clip-scrolled-content')
            var toolbar = $element.find('.cke_top')
            var locked = false

            if (ThisDoc.maxHeight) {
                $element.find('.cke_contents').height(ThisDoc.maxHeight)
                ThisDoc.stickyToolbar = false
            } else {
                //let the ckeditor expand naturally as the div fills with content
                $element.find('.cke_contents').height('inherit')
            }

            //we need a min height when:
            // - a document should fill it's scrollContainer
            // - a field containerd in a .cke_match_height should do that
            // - a textarea is styled via scss (min-height: 200px) (no js to do)

            //if this is a field, fix the height
            if (ThisDoc.displayMode == "field") {
                //clip buttons over one line
                toolbar.height(30)

                //ensure the ckeditor is the same height as the container
                var matchHeight = $element.closest('.cke_match_height')
                if (matchHeight.length) {
                    //the height is however far down this field is in the match_height container
                    matchHeight = matchHeight.height() - $element.position().top
                    $element.find('.cke_contents .cke_wysiwyg_div').css('min-height', matchHeight - toolbar.height())
                }
            }

            if (ThisDoc.displayMode == "document") {
                $element.find('.cke_contents .cke_wysiwyg_div').css('min-height', scrollContainer.height() - toolbar.height())
            }

            //make the toolbar sticky - convert the toolbar to absolute position and give the document padding to compensate
            if (ThisDoc.stickyToolbar) {

                //adjust the top padding of the document based on the height of the toolbar
                $element.find('.cke_inner').css('padding-top', toolbar.height() + (ThisDoc.displayMode == "field" ? 0 : 35) + 'px')

                //reset the toolbar to the default css
                toolbar.css({ position: 'absolute', top: 0, left: 0, right: 0, bottom: "", width: "", height: (ThisDoc.displayMode == "field" ? "30px" : "") })

                //make the toolbar sticky
                scrollContainer.off("scroll.ckeDoc") //remove any previous calls
                scrollContainer.on("scroll.ckeDoc", function (e) {
                    if ($element.offset().top - scrollContainer.offset().top < parseInt(scrollContainer.css('padding-top'))) {
                        if (locked || !toolbar.is(":visible")) return

                        //the first time the toolbar is about to scroll out, capture the left, height and width within the browser window
                        var clientRect = toolbar[0].getClientRects()[0]

                        //the fixed is the container's top + border-top + padding-top
                        var top = scrollContainer.offset().top
                        if (scrollContainer.css('border-top') != '0px') {
                            top += parseInt(scrollContainer.css('border-top'))
                        }

                        //clip any content that the container would show because of padding -- primarily for list-item-viewer
                        if (scrollContainer.css('padding-top') != '0px') {
                            contentClipper.css({ position: 'fixed', top: top, left: clientRect.left, height: clientRect.top - scrollContainer.offset().top + 10, width: clientRect.width - 17 }).fadeIn()
                        }

                        //move the toolbar past any padding
                        top += parseInt(scrollContainer.css('padding-top'))

                        //determine the left of the toolbar
                        var toolbarLeft = clientRect.left

                        //can go all the up the parent chain to find something fixed? if yes, don't adjust the left
                        //else, can we go all the up the parent chain to find something absolute? if yes, subtract that things left
                        var isFixed = isElementPositioned(scrollContainer, 'fixed')
                        var isAbsolute = isElementPositioned(scrollContainer, 'absolute')
                        if (!isFixed && isAbsolute) toolbarLeft -= scrollContainer.offset().left

                        //fix the toolbar to the viewport -- the magic numbers are important
                        toolbar.css({ position: 'fixed', top: top, left: toolbarLeft, height: clientRect.height - 9, width: clientRect.width - (ThisDoc.displayMode == "field" ? 16 : 33), opacity: 1 })
                        if (ThisDoc.displayMode == "field") {
                            toolbar[0].style.setProperty('background-color', "white", "important")
                        }

                        locked = true
                    } else {
                        locked = false

                        //reset to the default css
                        toolbar.css({ position: 'absolute', top: 0, left: 0, right: 0, bottom: "", width: "", height: (ThisDoc.displayMode == "field" ? "30px" : ""), opacity: "" })
                        contentClipper.fadeOut()
                    }
                })
            }
        }

        function isElementPositioned(el, position) {
            var $el = angular.element(el);
            while (!$el.is(document)) {
                if ($el.css("position") === position) {
                    return $el;
                }
                $el = $el.parent();
            }
            return false;
        }


        function previousElementSibling(element) {
            if (element.previousElementSibling !== 'undefined') {
                return element.previousElementSibling;
            } else {
                // Loop through ignoring anything not an element
                while (element = element.previousSibling) {
                    if (element.nodeType === 1) {
                        return element;
                    }
                }
            }
        }

        //return a valid css selector for the passed in element
        function getPath(element) {
            if (element.nodeType == 3) { element = element.parentNode }
            if (!(element instanceof HTMLElement)) { return false; }

            var path = [],
                uniqueFound = false
            while (element.nodeType === Node.ELEMENT_NODE) {
                var selector = element.nodeName;
                if (element.id) {
                    selector += ('#' + element.id);
                    uniqueFound = true
                } else if (element.attributes.au) {
                    selector += ('[au=' + element.attributes.au.value + ']');
                    uniqueFound = true
                } else {
                    // Walk backwards until there is no previous sibling
                    var sibling = element;
                    // Will hold nodeName to join for adjacent selection
                    var siblingSelectors = [];
                    while (sibling !== null && sibling.nodeType === Node.ELEMENT_NODE) {
                        siblingSelectors.unshift(sibling.nodeName);
                        sibling = previousElementSibling(sibling);
                    }
                    // :first-child does not apply to HTML
                    if (siblingSelectors[0] !== 'HTML') {
                        siblingSelectors[0] = siblingSelectors[0] + ':first-child';
                    }
                    selector = siblingSelectors.join(' + ');
                }
                path.unshift(selector);
                element = element.parentNode;

                if (uniqueFound) break
            }

            //the > here is the CSS sibling selector
            return path.join(' > ');
        }

        //watch the justify buttons and change the drop-down icon
        function updateJustifyButton() {
            setTimeout(function () {
                var currentAlignment = ""
                if (angular.element('.cke_button.cke_button__justifyleft.cke_button_on').length) {
                    currentAlignment = "left"
                } else if (angular.element('.cke_button.cke_button__justifyright.cke_button_on').length) {
                    currentAlignment = "right"
                } else if (angular.element('.cke_button.cke_button__justifycenter.cke_button_on').length) {
                    currentAlignment = "center"
                } else if (angular.element('.cke_button.cke_button__justifyblock.cke_button_on').length) {
                    currentAlignment = "block"
                } else {
                    currentAlignment = "left"
                }

                try {
                    if (angular.element('.cke_button.cke_button__justify cke_button_icon.cke_button__justifycenter_icon')) {
                        var bgImg = angular.element('.cke_button.cke_button__justify .cke_button_icon.cke_button__justifycenter_icon').css('backgroundImage').replace(/(left|right|center|block)\./g, currentAlignment + '.')
                        angular.element('.cke_button.cke_button__justify .cke_button_icon.cke_button__justifycenter_icon').css('backgroundImage', bgImg)
                    }
                } catch (e) { }

            }, 1)
        }

        //use the onesearch service to find items		
        function suggest(word) {
            if (word.length == 1) {
                var prompt
                switch (word) {
                    case "@":
                        prompt = 'Keep typing to tag a user'
                        break;
                    case "+":
                        prompt = 'Keep typing to tag a task or project'
                        break;
                    default:
                        prompt = 'Keep typing to tag an Align Us item'
                }
                ThisDoc.suggestItems = [{ isSection: true, sectionTitle: prompt }]
                ThisDoc.searchWord = word
                ThisDoc.suggestIndex = 0
                return
            }
            if (word.length == 2) ThisDoc.suggestItems = [{ isSection: true, sectionTitle: 'Searching...' }]
            var searchType
            switch (word.substr(0, 1)) {
                case '@': searchType = 'User'; break;
                case '+': searchType = 'Project,Task'; break;
            }
            var res = oneSearch.search(word.substr(1), searchType, (ThisDoc.doc ? { ModelName: "Document", DocId: ThisDoc.doc._id } : null)).then(function (res) {
                //assign results to scope
                ThisDoc.suggestItems = res
            })

            //save where we are/what we're searching for
            ThisDoc.searchWord = word.substr(1)
            ThisDoc.suggestIndex = 1
        }

        //insert a mention		
        function insertMention(index) {
            //get a ref to the item selected
            var item = ThisDoc.suggestItems[index]

            //if the item is a Task, ask if we should insert a task like [] or a simple mention			
            var promise
            if (item.ModelName == "Task") {
                //lock the editor because it takes a second for mdDialog to grab the focus
                setReadOnly(true)

                //keep OK the link so the resolve always means a simple mention span
                promise = $mdDialog.show($mdDialog.confirm({
                    title: 'Mention Task',
                    textContent: 'Do you want to embed an interactive task or a link to the task?',
                    cancel: 'Interactive Task',
                    ok: 'Link To Task'
                }))
            } else {
                //always resolve to true if not a Task
                promise = $q.resolve(true)
            }

            var mention
            promise.then(function () {
                //create the mention element
                mention = CKEDITOR.dom.element.createFromHtml('<span contenteditable="false" class="doc-mention {0}" data-item-type="{0}" data-item-id="{1}" data-cke-filter="off" title="{3}">{2}</span>'
                    .format(item.ModelName, item.DocId, item.SearchTitle.substr(0, 24) + (item.SearchTitle.length > 25 ? '…' : ''), item.ModelName + ': ' + item.SearchTitle))
            }).catch(function () {
                //the dialog "cancel" rejects the promise to create an interactive task
                mention = $rootScope.docTask.template.replace("NewTask", item.DocId)
            }).finally(function () {
                //close the suggestions and make the editor editable
                suggestBox.close()
                setReadOnly(origReadOnly)

                //replace the current word with the mention
                CKEDITOR.replaceCurrentWord(ckEditor, CKEDITOR.getCurrentWord(ckEditor), mention)

                //restore the cursor after (to the right of) the mention widget and then insert a space for natural typing
                var range = ckEditor.createRange()
                range.moveToClosestEditablePosition(mention, true)
                ckEditor.getSelection().selectRanges([range])
                ckEditor.insertText(" ")
            })


        }
        ThisDoc.insertMention = insertMention

        //bold the matched part of the word		
        ThisDoc.highlightSuggestion = function (text) {
            return $sce.trustAsHtml(text.replace(new RegExp(ThisDoc.searchWord, 'gi'), '<b><u>$&</u></b>'))
        }

        function setReadOnly(val) {
            ckEditor.setReadOnly(val)
            ckEditor.fire('read-only', val)
        }

        CKEDITOR.getCurrentWord = function (editor) {
            var range = editor.getSelection().getRanges()[0]
            if (!range) return null

            var startNode = range.startContainer;
            if (startNode.type == CKEDITOR.NODE_TEXT && range.startOffset) {
                var indexPrevSpace = startNode.getText().lastIndexOf(' ', range.startOffset) + 1;
                var indexNextSpace = startNode.getText().indexOf(' ', range.startOffset);
                if (indexPrevSpace == -1) {
                    indexPrevSpace = 0;
                }
                if (indexNextSpace == -1) {
                    indexNextSpace = startNode.getText().length;
                }

                var filteredWord = CKEDITOR.cleanText(startNode.getText().substring(indexPrevSpace, indexNextSpace).trim())

                // Range at the non-zero position of a text node.

                return filteredWord
            }
            // Selection starts at the 0 index of the text node and/or there's no previous text node in contents.
            return null;
        }

        CKEDITOR.replaceCurrentWord = function (editor, find, replace) {
            var range = editor.getSelection().getRanges()[0],
                startNode = range.startContainer;
            if (startNode.type == CKEDITOR.NODE_TEXT && range.startOffset) {
                //prevent infinite loop - the insertHtml/Element will cause a change event to fire and if the currentWord is # or [] that logic will run again
                ignoreChanges()

                //must insert first, setText looses the cursor
                if (typeof replace == "string") {
                    editor.insertHtml(replace, 'unfiltered_html')
                } else {
                    editor.insertElement(replace)
                }

                //remove the text to find
                startNode.setText(startNode.getText().replace(find, ''))
            }
            return null;
        }

        CKEDITOR.cleanText = function (text) {
            if (!text) return ""
            return text.replace(/\u200B/g, '')
        }

        //returns array of root element id, command where command is:
        // remove, moveAfter(afterId), patch(dmp), new(afterId, content)
        function getDiff(a, b) {
            var oldEl = angular.element(a)
            var newEl = angular.element(b)

            var oldKids = oldEl.children()
            var newKids = newEl.children()
            for (var o = 0; o < oldKids.length; o++) {
                //if the old kid is the same, next
                //if the old kid is different but the id is the same, run dmp on the node content
                //if the old kid is different and the id is different
                //  does the old kid exist in the new document?
                //    no -> we removed old kid
                //    yes -> we moved old kid
                //           get the new kid's previousSibling and moveNode(id, afterId)

            }

            old.children().forEach(function (node) {

            })
        }

    } // end controller

})();
(function() {
	'use strict';
	
	angular
		.module('alignus.directives')
		.directive('auAuditTrail', ["$rootScope", function($rootScope) {
			controller.$inject = ["$scope", "$element", "$compile", "$http"];
			return {
				scope: {
					item: '='
				},
				controller: controller,
				controllerAs: 'vm',
				restrict: 'E',
				templateUrl: '/app/alignus/directives/au-audit-trail/au-audit-trail.tmpl.html'
			}
			function controller($scope, $element, $compile, $http) {
				var vm = this
				vm.auditTrail = []
				vm.item = $scope.item
				
				_getAuditTrailForItem(vm.item)
				
				function _getAuditTrailForItem(item) {
					var url = '/api/' + item.$key + '/' + item._id + '?select=AuditTrail'
					$http.get(url).then(function(response) {
						vm.auditTrail = response.data.AuditTrail
						_formatAuditTrail(vm.auditTrail)
					}).catch(function(error) {
						console.debug('Couldn\'t get audit trail for item', item)
						console.debug('Audit trail error', error)
					})
				}
				
				function _formatAuditTrail(auditTrail) {
					auditTrail.forEach(function(audit) {
						audit.Date = new Date(audit.Date).toString()
					})
				}
			}
		}])
})();
(function() {
	angular
		.module('app')
		.directive('auActivityLog', function() {
			activityLogController.$inject = ["$scope", "ActivityLog"];
			return {
				scope: {
					task: '<?'
				}, // end immediate scope
				controller: activityLogController,
				controllerAs: 'vm',
				restrict: 'E',
				templateUrl: '/app/alignus/directives/au-activity-log/au-activity-log.tmpl.html'
			} // end directive options return

			/* @ngInject */
			function activityLogController($scope, ActivityLog) {
				var vm = this
				vm.task = $scope.task

				vm.activity = vm.task.GetActivity()

				vm.refreshLog = function() {
					vm.activity = vm.task.GetActivity()					
				}
			}
		})
})();
/* global interact */
(function (currentScriptPath) {
	'use strict';

	//if creating an app.js file, the path doesn't help so the developer must define the templatePath	
	orgChart.$inject = ["$filter", "$timeout", "$interval"];
	if (typeof window.angularOrgChartTemplatePath == 'undefined') {
		window.angularOrgChartTemplatePath = currentScriptPath
	}

	angular.module('angularOrgChart', [])

	angular
		.module('angularOrgChart')
		.directive('angularOrgChart', orgChart)

	/**
	 * @ndgoc directive
	 * @module angular-orgChart
	 * @name auOrgChart
	 * @restrict AE
	 * 
	 * @description
	 * The AlignUs Angular org chart is the directive for showing org charts. It's forked
	 * from https://github.com/artbelikov/angular-tree-diagram under the MIT license
	 * 
	 * @usage
	 * <hljs>
	 * 	<au-org-chart nodes="vm.nodes" node-width="150px" node-type="user" on-double-click="vm.editUser()"
	 * 	node-template="">
	 * 	</au-org-chart>
	 * </hljs>
	 * 
	 * @param {number} zoom Zoom scale multiplier. Something like 0.1x to 10x.
	 * @param {object[]} nodes
	 * @param {number} nodeWidth How wide each node should be.
	 * @param {number} nodeHeight How tall each node should be.
	 * @param {string} nodeType I think this is a string of what node it should be, e.g. Organization/User
	 * @param {string} parentIdProperty Which field the ID of the parent is on, probably "ReportsTo"
	 * @param {string} idProperty Which field the ID of the object is on, usually "_id"
	 * @param {string} a property of the node to display in addition to the nodeTemplate
	 * @param {string} nodeTemplate URL where the template to display for each node is.
	 * @param {boolean} enableSelection Whether or not to allow users to select individual nodes.
	 * @param {function} onSelect What to run when a node is selected.
	 * @param {boolean?} enableParentUpdate dunno
	 * @param {function} onDoubleClick What to run when a node is double-clicked
	 */

	/* @ngInject */
	function orgChart($filter, $timeout, $interval) {
		return {
			scope: {
				zoom: "=?",
				nodes: "=",
				nodeWidth: "=?",
				nodeHeight: "=?",
				nodeType: "@?",
				parentIdProperty: "@",
				idProperty: "@",
				displayProperty: "@?",
				nodeTemplate: "=?",
				nodeExpression: "=?",
				enableSelection: "=?",
				onSelect: "&",
				enableParentUpdate: "=?",
				onParentUpdate: "&",
				onDoubleClick: "&",
				chartData: "=?",
				noManagedMembersText: "=?",
				unassignedMembersText: "=?",
				unassignedMemberTemplate: "=?",
				zoomToFitTrigger: "=?"
			},
			restrict: 'EA',
			templateUrl: angularOrgChartTemplatePath + 'org-chart-root.html',
			transclude: true,
			link: function (scope, element) {
				//scope.chartCanvas is the chart canvas
				scope.chartCanvas = scope.chart = element.find('.angular-org-chart')[0]

				var unassignedWrapper = element.find('.unassigned-nodes')[0]
				var unassignedNodeList = angular.element(element.find('.unassigned-nodes .node-list')[0])

				//style the containing div
				var orgChart = element[0]
				orgChart.style.position = "relative"
				if (orgChart.style.overflow == "") orgChart.style.overflow = "hidden"
				orgChart.style.cursor = "move"

				//pass along any data
				scope.chart.data = scope.chartData

				//apply any default zoom
				if (scope.zoom != undefined) {
					scope.chartCanvas.style.transform = "scale(" + scope.zoom + "," + scope.zoom + ")"
					scope.chartCanvas.setAttribute('data-zoom', scope.zoom)
				}

				//expose the currentScriptPath to the view for ng-include
				scope.currentScriptPath = angularOrgChartTemplatePath

				//default values
				if (!scope.nodeHeight) scope.nodeHeight = 75
				if (!scope.nodeWidth) scope.nodeWidth = 150
				if (!scope.nodeType) scope.nodeType = ""
				if (!scope.enableParentUpdate) scope.enableParentUpdate = false
				if (!scope.noManagedMembersText) scope.noManagedMembersText = "No Reporting Hierarchy"
				if (!scope.unassignedMembersText) scope.unassignedMembersText = "Self-Managing Members"
				if (!scope.layoutTemplate)
					scope.layoutTemplate = angularOrgChartTemplatePath + 'org-chart-node.html'
				if (!scope.unassignedMemberTemplate)
					scope.unassignedMemberTemplate = angularOrgChartTemplatePath + 'org-chart-unassigned.tmpl.html'

				//ensure all incoming nodes start off as !OrgChartReady
				for (var i = 0; i < scope.nodes.length; i++) {
					delete scope.nodes[i].$OrgChartReady
				}

				//make the BG draggable
				var ignoreBGClick = false
				if (typeof interact != 'undefined') {
					interact(orgChart)
						.ignoreFrom('a, input, .node, .toggle-button')
						.draggable({
							inertia: true,
							onstart: function (event) { scope.chartCanvas.setAttribute('dragging', 'true') },
							onmove: function (event) { dragMoveListener(event, scope.chartCanvas, true) },
							onend: function (event) { scope.chartCanvas.removeAttribute('dragging'); ignoreBGClick = true; $timeout(function () { ignoreBGClick = false }, 100) }
						})
				}

				if (typeof interact == 'undefined' || scope.enableParentUpdate == false) {
					console.info('Drag/drop disabled.', typeof interact == 'undefined' ? 'Org chart drag/drop requires interact.js.' : 'Parent update disabled.')
				} else {
					var nodeSelector = '.node-type' + scope.nodeType

					//make all nodes draggable
					interact(nodeSelector, {
						context: orgChart,
						ignoreFrom: "input, a, .toggle-button"
					})
						.draggable({
							onstart: dragStartListener,
							onmove: dragMoveListener,
							onend: dragEndListener
						})
						.allowFrom('.node-contents')
						//DEV NOTE - taps/touches only respond to the interact .tap handler but the ng-click, required to test in selenium IDE also fires so the tap sets and clears nodeJustTapped over .25s
						.on('tap', function (event) {
							var item = $filter('filter')(scope.nodes, { $id: event.currentTarget.parentElement.id })[0]
							scope.$apply(function () { scope.selectNode(item, event); nodeJustTapped = true })
							$timeout(function () { nodeJustTapped = false }, 250)
						})

					//make unassigned nodes draggable
					var unassignedSelector = '.unassigned-node' + scope.nodeType
					interact(unassignedSelector, {
						context: orgChart
					}).draggable({
						onstart: dragStartListener,
						onmove: function (event) { dragMoveListener(event, event.target) },
						onend: dragEndListener
					})

					//make all nodes dropzones
					interact(nodeSelector, {
						context: orgChart
					}).dropzone({
						accept: nodeSelector + ', ' + unassignedSelector,
						ondragenter: function (event) { event.target.classList.add('drag-hover') },
						ondragleave: function (event) { event.target.classList.remove('drag-hover') },
						ondrop: dropListener
					});

					//make background droppable for unassigned
					interact('.root', {
						context: orgChart
					}).dropzone({
						accept: unassignedSelector,
						ondragenter: function (event) { event.target.classList.add('drag-hover') },
						ondragleave: function (event) { event.target.classList.remove('drag-hover') },
						ondrop: dropListener
					})

					//drop nodes onto unassigned
					interact(unassignedWrapper, {
						context: scope.chartCanvas
					}).dropzone({
						accept: nodeSelector,
						ondragenter: function (event) {
							event.target.classList.add('drag-hover')
						},
						ondragleave: function (event) { event.target.classList.remove('drag-hover') },
						ondrop: function (event) { event.target.classList.remove('drag-hover'); dropListener(event) }
					})

				}

				function dragStartListener(event, elementToMove) {
					var target = elementToMove || event.target

					// non-angular events needs to happen inside an apply
					scope.$apply(function () {
						// if it's from the left side (i.e. has class "unassigned-node"), stop overflowing the node-list
						if (target.classList.contains('unassigned-node')) {
							scope.leaveUnassigned()
							draggingUnassigned = true

						} else {
							//hide (but take up space) the children
							try {
								target.parentElement.querySelector('.tree-children').style.visibility = "hidden"
							} catch (e) { }
						}

						target.setAttribute('dragging', 'true')
					})
				}

				function dragMoveListener(event, elementToMove, enforceBounds) {
					var target = elementToMove || event.target

					// keep the dragged position in the data-x/data-y attributes
					var zoom = (parseFloat(scope.chartCanvas.getAttribute('data-zoom')) || 1)
					if (elementToMove) zoom = 1 //if passed an elementToMove, it's either the BG or an unassigned node and should not be scaled
					var x = (parseFloat(target.getAttribute('data-x')) || 0) + (event.dx / zoom)
					var y = (parseFloat(target.getAttribute('data-y')) || 0) + (event.dy / zoom)

					// update the position attributes
					target.setAttribute('data-x', x);
					target.setAttribute('data-y', y);

					setTransform(target, enforceBounds)
				}

				function dragEndListener(event, elementToMove) {
					scope.$apply(function () {
						var target = elementToMove || event.target

						target.removeAttribute('dragging')

						//show the children nodes
						try {
							target.parentElement.querySelector('.tree-children').style.visibility = "visible"
						} catch (e) { }

						// update the position attributes
						target.setAttribute('data-x', 0);
						target.setAttribute('data-y', 0);

						setTransform(target)

						//remove drop target styling
						angular.forEach(document.querySelectorAll('.node'), function (node) {
							node.classList.remove('drag-hover');
						})
						document.querySelector('.unassigned-nodes').classList.remove('drag-hover')

						//reset state
						draggingUnassigned = false
						//bunp the unassigned nodes to get it to the natuarl scrollTop
						scope.enterUnassigned()
						scope.leaveUnassigned()
					})
				}

				//
				function dropListener(event) {
					// non-angular events needs to happen inside an apply
					scope.$apply(function () {
						var dropped = event.target
						if (window.getComputedStyle(dropped).visibility == "hidden") return

						var dragged = event.relatedTarget
						var newParent = dropped.parentElement.id
						if (newParent == '') newParent = null
						var id = dragged.parentElement.id || dragged.id

						//get reference to the scope node object
						var node = $filter('filter')(scope.nodes, { $id: id })[0]

						//prevent a node from being dropped onto itself
						if (newParent == id) return false;

						//prevent a node from creating a circular structure
						var keepGoing = true, parentsSeen = [id], nextParent = newParent, loopTimes = 0
						do {
							if (!nextParent) {
								keepGoing = false
								continue
							}

							//if we've seen this parent before, get out - error
							if (parentsSeen.indexOf(nextParent) != -1) {
								keepGoing = false
								debugger
								return false
							}
							parentsSeen.push(nextParent)

							//if we've looped over 100 times, get out - error
							if (loopTimes > 100) {
								keepGoing = false
								debugger
								return false
							}
							loopTimes++

							//get the next parent
							var nextParent = $filter('filter')(scope.nodes, { $id: nextParent })[0][scope.parentIdProperty]
						} while (keepGoing)

						//allow drops onto the background
						if (dropped.classList.contains('root')) {
							node.$isRoot = true
						} else {
							node.$isRoot = false
						}

						//auto zoom and show "no managed members"
						zoomToFit()

						//prevent a node from being dropped on it's pre-existing parent
						if (newParent == node.$parentId) return false

						//if the node is dragged to a new parent, ng-repeat adds a new dom node that causes a stange "fade back to origin" effect unless the node is removed.
						dragged.parentElement.removeChild(dragged)

						//animation after drop
						node.$justDropped = true
						setTimeout(function () {
							delete node.$justDropped
							scope.$apply()
						}, 750)

						var oldParent = node.$parent

						//update the dragged node's parent id
						node.$parentId = newParent; //what the tree UI uses
						node[scope.parentIdProperty] = newParent //what the data model uses
						if (node.$parentId == null && node.$hasChildren) node.$isRoot = true

						//let the controller respond to the update
						scope.onParentUpdate({ node: node, oldParent: oldParent })

						setTimeout(function () {
							//executes after the update below so .$parent is the new parent
							if (node.$parent) {
								node.$parent.$isOpen = true
							} else {
								node.$isOpen = true
							}
						}, 50)
					})
				}

				var relativeViewPortWidth, relativeViewPortHeight
				function setTransform(element, enforceBounds) {
					//pull the existing transforms off the element's data attributes          
					var x = (parseFloat(element.getAttribute('data-x')) || 0)
					var y = (parseFloat(element.getAttribute('data-y')) || 0)
					var zoom = (parseFloat(element.getAttribute('data-zoom')) || 1)

					var boundsTripped = false
					if (enforceBounds) {
						//determine the x and y bounds - if the content is 1000px and the viewPortWidth is 500px, but we're zoomed out to .5, then we really don't want the user to move the chart. On the other hand, if the zoom is 1, we will let them move it 500px.
						relativeViewPortWidth = viewPortWidth / zoom
						relativeViewPortHeight = viewPortHeight / zoom
						var xBound = (relativeViewPortWidth - contentWidth) * zoom
						var yBound = (relativeViewPortHeight - contentHeight) * zoom

						//if the relative view port can show the entire contents, let the user move right but not less than zero
						if (relativeViewPortWidth > contentWidth) {
							if (x > xBound) {
								x = xBound
								boundsTripped = true
							}
							if (x < 0) {
								x = 0
								boundsTripped = true
							}
						} else {
							//else, if the relative view port can't show the entire contents, let the user move left but not greater than zero
							if (x < xBound) {
								x = xBound
								boundsTripped = true
							}
							if (x > 0) {
								x = 0
								boundsTripped = true
							}
						}
						if (boundsTripped) {
							element.setAttribute('data-x', x)
						}

						//same idea, keep the user looking at the content
						boundsTripped = false
						if (relativeViewPortHeight > contentHeight) {
							if (y > yBound) {
								y = yBound
								boundsTripped = true
							}
							if (y < 0) {
								y = 0
								boundsTripped = true
							}
						} else {
							if (y < yBound) {
								y = yBound
								boundsTripped = true
							}
							if (y > 0) {
								y = 0
								boundsTripped = true
							}
						}

						//if we did any adjusting above, reset the data attributes
						if (boundsTripped) {
							element.setAttribute('data-y', y)
						}
					}

					// translate the element
					element.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + zoom + ',' + zoom + ')'
				}

				//mark the clicked upon node as selected
				var nodeJustTapped = null
				scope.selectNode = function (node, event) {
					// let the space key do its thing
					if (event && event.charCode == 32) return;

					//taps/touches only respond to the interact .tap handler but the ng-click also fires so the tap sets and clears nodeJustTapped over .25s
					if (nodeJustTapped) return;

					if (scope.enableSelection == false) {
						return false
					}
					if (event && event.ctrlKey) {
						node.$selected = true
					} else {
						angular.forEach(scope.nodes, function (node) {
							node.$selected = false
						})
						node.$selected = true
					}

					if (event) {
						event.preventDefault();
						event.stopPropagation()
					}

					//let the controller respond to the selection
					var selectedNodes = []
					selectedNodes = $filter('filter')(scope.nodes, { $selected: true })
					scope.onSelect({ nodes: selectedNodes })

					//zooming to a clicked on node
					if (node.$OrgChartReady) {
						var node
						if (event) {
							node = angular.element(event.target).closest('.node-contents')
						} else {
							node = angular.element('#' + node.$id + ' .node-contents')
						}

						if (node.length == 0) return

						//zoom immediately (before transitions even start)
						zoomToNode(node)

						//zoom again after transitions because they tend to change node heights (and therefore the offset)
						$timeout(function () { zoomToNode(node) }, 550)
					} else {
						//background click
						if (!ignoreBGClick) zoomToFit()
					}

				}

				function zoomToNode(node) {
					//the chart may be offset already, and if so, we'll need to add that back to the window's offset
					var offsetLeft = parseInt(scope.chartCanvas.getAttribute('data-x'))
					var offsetTop = parseInt(scope.chartCanvas.getAttribute('data-y'))
					var offsetScale = parseFloat(scope.chartCanvas.getAttribute('data-zoom'))

					//.offset() returns the offset from the window's edge, so subtract the chart left/top and the unassigned node list (150px) and any existing offset, then divide by the offsetScale (the zoom)
					var setLeft = 0
					if (getViewport().width < getContentSize().width) {
						setLeft = ((node.offset().left - angular.element(orgChart).offset().left - 150 - offsetLeft) / offsetScale)
						setLeft -= (viewPortWidth - scope.nodeWidth) / 2
						scope.chartCanvas.setAttribute('data-x', -setLeft)
					} else {
						//center contentWidth
						setLeft = (getViewport().width - getContentSize().width) / 2
						scope.chartCanvas.setAttribute('data-x', setLeft)
					}

					var setTop = 0
					if (getViewport().height < getContentSize().height || offsetScale < 1) {
						setTop = ((node.offset().top - angular.element(orgChart).offset().top - offsetTop) / offsetScale)
						setTop -= Math.max(0, (viewPortHeight - scope.nodeHeight) / 2)
						setTop += 150
						if (setTop < -50) setTop = -50
						scope.chartCanvas.setAttribute('data-y', -setTop)
					}

					//set transform
					scope.chartCanvas.setAttribute('data-zoom', 1)
					setTransform(scope.chartCanvas)
				}

				// Since root nodes are either parentless children or $isRoot, we need a custom filter
				scope.filterRootNodes = function (node) {
					return (node.$OrgChartReady && !node.$parentId && (node.$isRoot || node.$hasChildren))
				}
				// nodes to show in the unassigned nodes panel
				scope.filterUnassignedNodes = function (node) {
					return (node.$OrgChartReady && !node.$isRoot && node.$parentId == null && !node.$hasChildren)
				}

				scope.setOpen = function (node, isOpen) {
					node.$isOpen = isOpen
					zoomToFit()
				}

				var contentWidth, contentHeight, viewPortWidth, viewPortHeight, scaleWidth, scaleHeight, offsetCenter, scale
				var debounceZoomToFit = null
				function zoomToFit() {
					//don't execute zooms when loading
					if (loading) return;

					$timeout.cancel(debounceZoomToFit)
					debounceZoomToFit = $timeout(function () {
						var roots = angular.element('.tree-roots > .tree-parent')
						if (roots.length == 0) {
							scope.noRootNodes = true
							scope.viewportWidth = getViewport().width
							scope.chartCanvas.setAttribute('data-x', 0)
							scope.chartCanvas.setAttribute('data-y', 0)
							setTransform(scope.chartCanvas)
						} else {
							//zoom the new node in from the center
							if (scope.noRootNodes) loadingSequence()

							scope.noRootNodes = false

							var lastContentWidth = 0
							var lastContentHeight = 0
							var timesRenderStable = 0
							var watchContent = null
							watchContent = $interval(function () {
								var contentSize = getContentSize()
								contentWidth = contentSize.width
								contentHeight = contentSize.height

								//if the content hasn't changed for .5sec, consider this watch done and cancel it
								if (lastContentWidth == contentWidth) {
									timesRenderStable += 1
								} else {
									timesRenderStable = 0
								}
								if (timesRenderStable > 5) {
									$interval.cancel(watchContent)
								}

								//--- auto scale the content to fit in the view port
								//determine the scale by determining the smallest ratio, width or height
								var viewportSize = getViewport()

								scaleWidth = viewportSize.width / contentWidth
								scaleHeight = viewportSize.height / contentHeight

								scale = Math.min(scaleWidth, scaleHeight, 1)
								scope.zoom = scale
								scope.chartCanvas.setAttribute('data-zoom', scale)

								//---center the content
								var offsetLeft = 0, offsetTop = 0
								if (viewportSize.width > contentSize.relative.width) {
									offsetLeft = (viewportSize.width - contentSize.relative.width) / 2
								}
								if (viewportSize.height > contentSize.relative.height) {
									offsetTop = (viewportSize.height - contentSize.relative.height) / 2
								}

								scope.chartCanvas.setAttribute('data-x', offsetLeft)
								scope.chartCanvas.setAttribute('data-y', offsetTop)
								setTransform(scope.chartCanvas)

								lastContentWidth = contentWidth
								lastContentHeight = contentHeight
							}, 100, 50)

						}

					}, 100)
					return debounceZoomToFit
				}

				scope.$watch('nodes.length', zoomToFit)

				function getContentSize() {
					//determine the content width by summing the widths of the root node widths because they have actual width
					var roots = angular.element('.tree-roots > .tree-parent')

					contentWidth = 0
					contentHeight = 0

					for (var i = 0; i < roots.length; i++) {
						contentWidth += roots[i].offsetWidth
						if (roots[i].offsetHeight > contentHeight) contentHeight = roots[i].offsetHeight
					}

					//ensure there is enough room to show the last expand checkbox
					contentHeight += 30

					return {
						width: contentWidth,
						height: contentHeight,
						relative: {
							width: contentWidth * scope.zoom,
							height: contentHeight * scope.zoom
						}
					}

				}

				function getViewport() {
					viewPortWidth = scope.chartCanvas.parentElement.offsetWidth
					viewPortHeight = scope.chartCanvas.parentElement.offsetHeight || viewPortWidth //if the height is zero, assume it's the width

					return {
						width: viewPortWidth,
						height: viewPortHeight,
						relativeWidth: viewPortWidth / scope.zoom,
						relativeHeight: viewPortHeight / scope.zoom
					}
				}

				//adjust the unassigned node list from overflow to show/hide scrollbar and to allow drags out of the list				
				var draggingUnassigned = false
				scope.enterUnassigned = function () {
					if (draggingUnassigned) return
					//reset the tranlate because now we're actually scrolling
					unassignedNodeList.css('transform', 'translateY(0px)')
					//assign overflow: auto with a fixed height
					unassignedNodeList.css('overflow', 'auto')
					unassignedNodeList.css('max-height', unassignedNodeList.closest('[angular-org-chart]').height() - 55 + 'px')

				}

				scope.leaveUnassigned = function () {
					if (draggingUnassigned) return
					//after the overflow is removed below, the content will not appear "scrolled-up" so mimic that with a translation
					unassignedNodeList.css('transform', 'translateY(-' + unassignedNodeList.scrollTop() + 'px)')
					//remove overflow so nodes can be dragged outside of the list and hide the scrollbar
					unassignedNodeList.css('overflow', 'inherit')
				}

				//Determine the left and right of the horizontal connector line.
				scope.getLine = function (id) {
					//find all immediate children for this line
					var thisRow = scope.chartCanvas.querySelector('.tree-children.id_' + id)

					if (!thisRow) return "" //node not inserted yet
					thisRow = thisRow.children
					if (thisRow.length < 3) return "" //children not inserted yet

					var firstNode = thisRow[2] //adjust if the DOM is modified
					var lastNode = thisRow[thisRow.length - 1]

					//since the vert-line-top is always in the middle of the child nodes,
					//the left should be offset by the first child's width/2 and
					//the right should be offset by the last child's width/2
					var returnVal = 'left:' + (firstNode.offsetWidth / 2) + 'px; ' +
						'right:' + (lastNode.offsetWidth / 2) + 'px; '

					return returnVal
				}

				//zoom background
				var viewport = scope.chartCanvas.parentElement
				viewport.onmousewheel = wheelHandler //chrome / webkit
				viewport.wheel = wheelHandler	//non-functional / firefox
				interact(orgChart).gesturable({ //touch pinch/zoom
					onmove: function (event) {
						event.detail = event.ds * 1000 //translate input for wheelHandler
						wheelHandler(event) //process zoom
					}
				})

				function wheelHandler(event) {
					var delta, offsetLeft, offsetTop
					event.preventDefault();
					delta = (event.detail || event.wheelDelta) || 0;
					if (scope.zoom == undefined) scope.zoom = 1
					scope.zoom += delta / 1000;
					scope.zoom = Math.min(Math.max(scope.zoom, 0.2), 3);
					scope.chartCanvas.setAttribute('data-zoom', scope.zoom)

					//keep the zoom centered
					relativeViewPortWidth = viewPortWidth / scope.zoom
					offsetLeft = ((relativeViewPortWidth - contentWidth) / 2) * scope.zoom
					scope.chartCanvas.setAttribute('data-x', offsetLeft)

					relativeViewPortHeight = viewPortHeight / scope.zoom
					offsetTop = ((relativeViewPortHeight - contentHeight) / 2) * scope.zoom
					scope.chartCanvas.setAttribute('data-y', offsetTop)


					setTransform(scope.chartCanvas, true)
				}

				//add normalized data fields
				scope.prepNode = function (node) {
					if (node.$OrgChartReady) return ""
					node.$OrgChartReady = true
					node.$id = node[scope.idProperty]
					if (!node.$id) {
						node.$id = parseInt(Math.random() * 10000)
					}

					delete node.$_parentId
					delete node.$lastParentId
					Object.defineProperty(node, "$parentId", {
						get: function () {
							var returnVal = node.$_parentId === undefined ? node[scope.parentIdProperty] : node.$_parentId
							if (node[scope.parentIdProperty] != node.$lastParentId) {
								//find the parent node in this set of nodes
								var parentNode = $filter('filter')(scope.nodes, { _id: node[scope.parentIdProperty] })

								//if the parent is not in the node set, set their parentId to null so the orgChart considers it a root
								if (parentNode.length == 0) {
									returnVal = null
								} else {
									returnVal = node[scope.parentIdProperty]
								}
							}
							node.$_parentId = returnVal
							node.$lastParentId = node[scope.parentIdProperty]
							return returnVal
						},
						set: function (val) {
							node[scope.parentIdProperty] = val
						},
						configurable: true
					})

					//ensure the parentId property at least exists
					if (!node.$parentId) node.$parentId = null

					//invalid reference
					if (node.$parentId == node.$id) node.$parentId = null

					Object.defineProperty(node, "$hasChildren", {
						get: function () {
							var children = $filter('filter')(scope.nodes, {
								$parentId: this.$id
							})
							return (children.length > 0)
						},
						configurable: true
					})
					Object.defineProperty(node, "$children", {
						get: function () {
							var children = $filter('filter')(scope.nodes, {
								$parentId: this.$id
							})
							return children
						},
						configurable: true
					})
					Object.defineProperty(node, "$parent", {
						get: function () {
							if (this.$parentId == null) return null
							var returnVal = $filter('filter')(scope.nodes, {
								$id: this.$parentId
							})[0]
							return returnVal
						},
						configurable: true
					})
					node.$isOpen = true

					if (node.$selected) {
						$timeout(function () { scope.selectNode(node) }, 500)
						scope.noRootNodes = false
					} else {
						zoomToFit()
					}
					return ""
				}

				//--loading sequence
				//set the initial scale of the canvas is .001, so the chart is essentially invisibile and then zoom it in over .75 seconds
				var loading = true
				function loadingSequence() {
					var vp = getViewport()
					scope.chartCanvas.style.transform = "translate(" + vp.width / 2 + "px, " + vp.height / 2 + "px) scale(.001)"
					scope.chartCanvas.style.transition = "transform .5s"
					$timeout(function () {
						loading = false
						zoomToFit()
					}, 250)
					$timeout(function () {
						scope.chartCanvas.style.transition = "transform .25s"
					}, 2000)

					//watch a passed in variable the page hosting this may update to trigger the content to re-center
					if (scope.zoomToFitTrigger !== undefined) {
						scope.$watch('zoomToFitTrigger', zoomToFit)
					}
				}
				loadingSequence()

				return null;
			} //end of link function
		} //end of directive return object
	} //end of directive function

})((function () {
	//pass the path of the script into the directive
	var scripts = document.getElementsByTagName("script");
	var currentScriptPath = scripts[scripts.length - 1].src;
	return currentScriptPath.substring(0, currentScriptPath.lastIndexOf('/') + 1);
})());
(function() {
	'use strict';
		getUserAuthLinkRecipe.$inject = ["$http"];
	angular
		.module('app')
		.service('getUserAuthLink', getUserAuthLinkRecipe)
		/* @ngInject */
		function getUserAuthLinkRecipe($http) {
			return function(user) {
				return $http.get('/api/techSupport/getUserAuthToken?userId=' + user._id + '&org=' + user.Organization)
				.then(function(response) {
					return (window.location.origin + "/home?icu="
						+ encodeURIComponent(response.data.authToken))
				})
			}		
		}
})();
(function() {
	'use strict';
		allUsersRecipe.$inject = ["$http", "User"];
	angular
		.module('app')
		.service('allUsers', allUsersRecipe)

		/* @ngInject */
		function allUsersRecipe($http, User) {
			return {
				search: function(query) {
					return $http.post('/api/techsupport/searchUsers', query)
					.then(function(response) {
						return response.data.map(function(userObject) {
							return new User(userObject)
						})
					})
				},
				searchableBy: ['FirstName', 'LastName', '_id', 'Email', 'Organization']
			}
		}
})();
(function() {
	'use strict';
		allOrgsRecipe.$inject = ["$http", "Organization"];
	angular
		.module('app')
		.service('allOrgs', allOrgsRecipe)

		/* @ngInject */
		function allOrgsRecipe($http, Organization) {
			return {
				get: function() {
					return $http.get('/api/techsupport/getAllOrganizations').then(function(response) {
						return response.data.map(function(organization) {
							return new Organization(organization)
						})
					})
				}
			}
		}
})();
(function() {
	'use strict';
		seeOrgDataConfig.$inject = ["$stateProvider", "ListViewerProvider", "OrganizationProvider"];
	angular
		.module('app')
		.config(seeOrgDataConfig)

		/* @ngInject */
		function seeOrgDataConfig($stateProvider, ListViewerProvider, OrganizationProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.techsupport.viewallorganizations',
				title: 'All Organizations',
				itemTitle: '{{itemSettings.item.Name}}',
				itemType: OrganizationProvider,
				listItems: function(allOrgs) {
					return allOrgs.get()
				},
				initialSortBy: 'Name',
				initialView: 'report',
				showGroupHeaders: true
			})
		}
})();
(function() {
	'use strict';
		techSupportSearchUsersController.$inject = ["allOrgs", "allUsers", "getUserAuthLink", "$mdDialog"];
	angular
		.module('app')
		.controller('TechSupportSearchUsersController', techSupportSearchUsersController)
		
		/* @ngInject */
		function techSupportSearchUsersController(allOrgs, allUsers, getUserAuthLink, $mdDialog) {
			var vm = this
			vm.params = {}
			vm.results = []
			vm.searchApi = allUsers

			vm.getLoginAsClicked = function(user) {
				getUserAuthLink(user)
				.then(function(link) {
					$mdDialog.show($mdDialog.alert({
						title: 'Temporary Login for ' + user.Email,
						textContent: link,
						ok: 'Close'
					}))
				})
			}

			vm.searchClicked = function(params) {
				Object.keys(params).forEach(function(fieldName) {
					if(params[fieldName].trim() == '') {
						delete params[fieldName]
					}
				})
				allUsers.search(params).then(function(users) {
					vm.results = users
				})
			}
		}
})();
(function() {
	'use strict';
		searchUsersConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(searchUsersConfig)
		/* @ngInject */
		function searchUsersConfig($stateProvider) {
			$stateProvider.state('shell.techsupport.searchusers', {
				views: {
					'@shell': {
						templateUrl: '/app/techsupport/search-users/search-users.tmpl.html',
						controller: 'TechSupportSearchUsersController',
						controllerAs: 'vm'
					}
				},
				url: '/searchusers',
				navigationData: {
					breadcrumbTitle: 'Search All Users'
				}
			})
		}
})();
(function() {
	'use strict';
		TechSupportRunMigrationScriptController.$inject = ["$http", "toast"];
	angular
		.module('app')
		.controller('TechSupportRunMigrationScriptController', TechSupportRunMigrationScriptController)
		
		/* @ngInject */
		function TechSupportRunMigrationScriptController($http, toast) {
			var vm = this
			vm.scriptName = "generateOneSearchData.js"

			vm.go = function () {
				var postData 
				if (vm.body) {
					postData = JSON.parse(vm.body)
				} else {
					postData = {}
				}
				postData.scriptName = vm.scriptName

				toast.toast('Script run command sent. Use PM2 logs to view output.')

				return $http.post('/api/techsupport/runMigrationScript', postData).then(function (res) {
					vm.results = res
				})
			}
		}
})();
(function() {
	'use strict';
		searchUsersConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(searchUsersConfig)
		/* @ngInject */
		function searchUsersConfig($stateProvider) {
			$stateProvider.state('shell.techsupport.run-migration-script', {
				views: {
					'@shell': {
						templateUrl: '/app/techsupport/run-migration-script/run-migration-script.tmpl.html',
						controller: 'TechSupportRunMigrationScriptController',
						controllerAs: 'vm'
					}
				},
				url: '/run-migration-script',
				navigationData: {
					breadcrumbTitle: 'Run Migration Script'
				}
			})
		}
})();
(function() {
	'use strict';
		TechSupportMakeGlobalPostController.$inject = ["$http", "$mdDialog"];
	angular
		.module('app')
		.controller('TechSupportMakeGlobalPostController', TechSupportMakeGlobalPostController)
		
		/* @ngInject */
		function TechSupportMakeGlobalPostController($http, $mdDialog) {
            var vm = this
            
            vm.distribute = function() {
				$http.post('/api/techsupport/distributeGlobalPost', { postId: vm.postId }).then(function() {
					vm.postId = ''
					$mdDialog.show($mdDialog.alert({
						title: 'Success',
						content: 'Your post has been distributed to all users',
						ok: 'Okay'
					}))
				})
			}
		}
})();
(function() {
	'use strict';
		makeGlobalPostConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(makeGlobalPostConfig)
		/* @ngInject */
		function makeGlobalPostConfig($stateProvider) {
			$stateProvider.state('shell.techsupport.make-global-post', {
				views: {
					'@shell': {
						templateUrl: '/app/techsupport/make-global-post/make-global-post.tmpl.html',
						controller: 'TechSupportMakeGlobalPostController',
						controllerAs: 'vm'
					}
				},
				url: '/make-global-post',
				navigationData: {
					breadcrumbTitle: 'Make Global Post'
				}
			})
		}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "SingleItemViewerProvider", "UserProvider"];
	angular.module('app').config(configRoutes);

	/* @ngInject */
	function configRoutes($stateProvider, SingleItemViewerProvider, UserProvider) {
		SingleItemViewerProvider.createRouteFor($stateProvider, {
			itemType: UserProvider,
			itemSection: 'structure',
			detailTemplateUrl: '/app/structure/users-and-teams/user/detail.tmpl.html',
			controller: 'UserDetailController'
		})
	}

})();
(function () {
	'use strict';

	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "TeamProvider"];
	angular.module('app').config(configRoutes);

	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, TeamProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.manage-teams',
			title: 'List All Teams and Groups',
			itemTitle: '{{itemSettings.item.name}}',
			itemType: TeamProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Team", function (localCacheReady, Team) {
				return Team.getCache()
			}],
			initialSortBy: 'Name',
			initialView: 'list',
			breadcrumbItemMap: function (listItem) {
				return { title: listItem.Name, sref: '.' }
			}
		})
	}

})();
(function () {
	'use strict';

	//define the routes and menu for this module
    configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "UserProvider"];
	angular.module('app').config(configRoutes);

	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, UserProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.all-users',
			title: 'List All Users',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: UserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "User", function (localCacheReady, User) {
				return User.getCache({IsContact: false})
            }],
			initialSortBy: 'FirstName',
			initialView: 'list'
        })
    }
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "UserProvider"];
	angular.module('app').config(configRoutes);

	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, UserProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.all-contacts',
			title: 'List All Contacts and Users',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: UserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "User", function (localCacheReady, User) {
				return User.getCache()
			}],
			initialSortBy: 'FirstName',
			initialView: 'list',
			itemFields: [
                {
                    display: 'First Name',
                    displayValue: 'FirstName',
                    groupMethod: 'alpha',
                    name: 'FirstName',
                    primary: true,
                    sortable: true,
                    type: 'String'
                },
                {
                    display: 'Last Name',
                    displayValue: 'LastName',
                    groupMethod: 'alpha',
                    name: 'LastName',
                    primary: true,
                    sortable: true,
                    type: 'String'
                },
                {
                    display: 'Email',
                    displayValue: 'Email',
                    groupMethod: 'alpha',
                    name: 'Email',
                    primary: true,
                    sortable: false,
                    type: 'String'
                },
                {
                    display: 'Phone Number',
                    displayValue: 'Phone',
                    groupMethod: 'value',
                    name: 'Phone',
                    primary: true,
                    sortable: false,
                    type: 'Number'
                },
                {
                    display: 'Groups',
                    displayValue: 'Group',
                    displayTemplate: '<span ng-repeat="team in item.$Teams"><span class="md-body-2" ng-if="item.$Teams.length>2 && !$first">, </span>{{team.toString()}}</span>',
                    groupMethod: 'value',
                    name: '$Teams',
                    primary: true,
                    sortable: true,
                    type: 'String'
                },
                {
                    display: 'User Type',
                    displayValue: 'IsContact',
                    displayTemplate: "{{item.IsContact ? '🔐 Contact' : '💸 Full User'}}",
                    groupMethod: 'value',
                    name: 'IsContact',
                    primary: true,
                    sortable: false,
                    type: 'Boolean'
                }
            ]
		})
	}

})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "UserProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, UserProvider) {

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-team',
			title: "By Group or Team",
			subTitle: "List all users in a single group or team. Just pick one.",
			/* @ngInject */
			values: ["localCacheReady", "Team", "$filter", function (localCacheReady, Team, $filter) {
				return Team.getCache().$httpPromise.then(function (teams) {
					var returnVal = $filter('orderBy')(teams, "Name").map(function (value) {
						return { title: value.Name, sref: '.users.list', srefOpts: { query: value._id }, item: value }
					})
					return returnVal
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.structure.by-team.users.list', srefOpts: value.srefOpts }
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-team.users',
			title: 'Users In...',
			itemTitle: '{{itemSettings.item | fullNameFilter}}',
			itemType: UserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "User", "$state", "$stateParams", function (localCacheReady, User, $state, $stateParams) {
				return User.getCache({Teams: $stateParams.query})
			}],
			initialSortBy: 'FirstName',
			initialView: 'report',
			/* @ngInject */
			onEnter: ["$stateParams", "Team", function ($stateParams, Team) {
				//display the team name as the breadcrumb title
				this.navigationData.breadcrumbTitle = Team.getCache({ _id: $stateParams.query })[0].Name
			}]
		})


	}
})();
(function () {
    'use strict';

    //define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "UserProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, UserProvider) {

        SelectFilterProvider.createRoutes($stateProvider, {
            name: 'shell.structure.by-reports-to',
            title: "By Reports-To",
            subTitle: "Show the reporting structure for the organization or a selected superior.",
            /* @ngInject */
            values: ["localCacheReady", "User", "$filter", function (localCacheReady, User, $filter) {
                var superiors = []
                var returnVal = []
                var query = User.query({ ReportsTo__exists: true, ReportsTo__ne: "null" })
                return query.$httpPromise.then(function (users) {
                    angular.forEach(users, function (user) {
                        if ($filter('filter')(superiors, { _id: user.ReportsTo }).length == 0) {
                                superiors.push(user.$ReportsTo)
                        }
                    })
                    returnVal = superiors.map(function (value) {
                        return { title: value.toString(), sref: '.users.list', srefOpts: { query: value._id, view: 'connections' }, item: value }
                    })

                    //add a leading space to sort this to the top (unshift/push results are the same)
                    returnVal.unshift({ title: ' View Entire Organization', sref: 'shell.structure.all-users.list', srefOpts: { view: 'connections' }, item: $rootScope.Organization })

                    return returnVal
                })
            }],
            breadcrumbItemMap: function (value) {
                return { title: value.title, sref: 'shell.structure.by-reports-to.users.list', srefOpts: value.srefOpts }
            }
        })

        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.structure.by-reports-to.users',
            title: 'Users For...',
            itemTitle: '{{itemSettings.item | fullNameFilter}}',
            itemType: UserProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "User", "$state", "$stateParams", "$filter", function (localCacheReady, User, $state, $stateParams, $filter) {
                //should return 1) this user, 2) everyone who reports to this user, 3) everyone that reports to their subordinates
                var listItems = []

                //add this user
                var thisUser = User.getCache({ _id: $stateParams.query })[0]
                //pre-assign the "parentId" property to null (so it's not undefined) so this node effectively is the top node (a root)
                //todo bugfix - this is actually saving/changing the reportsTo of the record
                // 				thisUser.parentId = null
                listItems = listItems.concat(thisUser)

                //recursively add all subordinates down the chain
                var allSubordinates = findSubordinates($stateParams.query)
                listItems = listItems.concat(allSubordinates)

                listItems.currentQuery = { ReportsTo: $stateParams.query }

                return listItems

                function findSubordinates(superior) {
                    var returnVal = []
                    var subordinates = User.getCache({ ReportsTo: superior })
                    for (var i = 0; i < subordinates.length; i++) {
                        delete subordinates[i].parentId //ensure the parentId is not present (potentially was added by a different run when thisUser was the root)
                        returnVal = returnVal.concat(findSubordinates(subordinates[i]._id))
                    }
                    returnVal = returnVal.concat(subordinates)

                    return returnVal
                }
            }],
            initialSortBy: 'FirstName',
            initialView: 'connections',
            /* @ngInject */
            onEnter: ["$stateParams", "$filter", "User", function ($stateParams, $filter, User) {
                //display the user name as the breadcrumb title
                this.navigationData.breadcrumbTitle = User.getCache({ _id: $stateParams.query })[0].toString()
            }]
        })


    }
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "UserProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, UserProvider) {

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-location',
			title: "By Location",
			subTitle: "List all users at a single location. Just pick one.",
			/* @ngInject */
			values: ["localCacheReady", "Location", "$filter", function (localCacheReady, Location, $filter) {
				return Location.getCache().$httpPromise.then(function (locations) {
					var returnVal = [{ title: ' View Org-Chart of All Locations', sref: 'shell.structure.all-locations.list', srefOpts: { view: 'connections' }, item: $rootScope.Organization }]
					returnVal = returnVal.concat($filter('orderBy')(locations, "Name").map(function (value) {
						return { title: value.Name, sref: '.users.list', srefOpts: { query: value._id }, item: value }
					}))
					return returnVal
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.structure.by-location.users.list', srefOpts: value.srefOpts }
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-location.users',
			title: 'Users For...',
			itemTitle: '{{itemSettings.item | fullNameFilter}}',
			itemType: UserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "User", "$state", "$stateParams", function (localCacheReady, User, $state, $stateParams) {
				return User.getCache({Location: $stateParams.query})
			}],
			initialSortBy: 'FirstName',
			initialView: 'list',
			/* @ngInject */
			onEnter: ["$stateParams", "Location", function ($stateParams, Location) {
				//display the location name as the breadcrumb title
				this.navigationData.breadcrumbTitle = Location.getCache({ _id: $stateParams.query })[0].Name
			}]
		})


	}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "UserProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, UserProvider) {

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-department',
			title: "By Department",
			subTitle: "List all users in a single department. Just pick one.",
			/* @ngInject */
			values: ["localCacheReady", "Department", "$filter", function (localCacheReady, Department, $filter) {
				return Department.getCache().$httpPromise.then(function(departments) {
					var returnVal = [{title: ' View Org-Chart of All Departments', sref: 'shell.structure.all-departments.list', srefOpts: {view: 'connections'}, item: $rootScope.Organization}]
					returnVal = returnVal.concat($filter('orderBy')(departments, "Name").map(function (value) {
						return {title: value.Name, sref: '.users.list', srefOpts: {query: value._id}, item: value}
					}))
					return returnVal
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.structure.by-department.users.list', srefOpts: value.srefOpts }
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.by-department.users',
			title: 'Users For...',
			itemType: UserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "User", "$state", "$stateParams", function (localCacheReady, User, $state, $stateParams) {
				return User.getCache({Department: $stateParams.query})
			}],
			initialSortBy: 'FirstName',
			initialView: 'list',
			/* @ngInject */
			onEnter: ["$stateParams", "Department", function ($stateParams, Department) {
				//display the location name as the breadcrumb title
				this.navigationData.breadcrumbTitle = Department.getCache({ _id: $stateParams.query })[0].Name
			}]
		})


	}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "UserProvider", "TeamProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, UserProvider, TeamProvider) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.structure.users-and-teams',
			title: 'Users and Teams',
			subTitle: 'Explore the organization members and their connections in different ways. Select a method below...',
			cardClass: "sub-menu-card",

			fabButtons: [
				{
					title: 'Add User',
					icon: 'zmdi zmdi-account-add',
					action: UserProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
				},
				{
					title: 'Add Contact',
					icon: 'zmdi zmdi-account-add',
					action: function(){
						$mdDialog.show({
							controller: 'AddContactDialog',
							controllerAs: 'vm',
							templateUrl: '/app/structure/users-and-teams/dialogs/add-contact.tmpl.html'
						})
					}
				},
				{
					title: 'Add Team',
					icon: 'zmdi zmdi-accounts-add',
					action: TeamProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Teams.CanCreate'
				},

			],
			fabIcon: 'zmdi zmdi-plus',

			menuItems: [
				{
					title: 'Add Team',
					subtitle: 'Add a new team.',
					image: '/assets/images/cards/slim/add-team.png',
					action: TeamProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Teams.CanCreate'
				},
				{
					title: 'List All Users',
					subtitle: 'Show all users in a single list.',
					image: '/assets/images/cards/slim/user.jpg',
					permissionNeeded: '$root.user.EffPerms.Users.CanView',
					sref: 'shell.structure.users-and-teams.all-users.list'
				},
				{
					title: 'List All Teams',
					subtitle: 'Show all teams and their members.',
					image: '/assets/images/cards/slim/team.jpg',
					permissionNeeded: '$root.user.EffPerms.Teams.CanView',
					sref: 'shell.structure.users-and-teams.manage-teams.list'
				},
				{
					title: 'By Reports-To',
					subtitle: 'Show the organizational reporting hierarchy.',
					image: '/assets/images/cards/slim/connection.jpg',
					permissionNeeded: '$root.user.EffPerms.Users.CanView',
					sref: 'shell.structure.users-and-teams.by-reports-to'
				},
				{
					title: 'By Location',
					subtitle: 'Show users in a selected location.',
					image: '/assets/images/cards/slim/location.jpg',
					permissionNeeded: '$root.user.EffPerms.Users.CanView',
					sref: 'shell.structure.users-and-teams.by-location'
				},
				{
					title: 'By Department',
					subtitle: 'Show users in a selected department.',
					image: '/assets/images/cards/slim/department.jpg',
					permissionNeeded: '$root.user.EffPerms.Users.CanView',
					sref: 'shell.structure.users-and-teams.by-department'					
				}
			]
		})
	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "PermissionPresetProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, PermissionPresetProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: PermissionPresetProvider
        })
    }
})();
//#4 - THE ROUTE - Present a list of resources as a URL
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "PermissionPresetProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, PermissionPresetProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.permission-presets',
			title: 'Permission Presets',
			itemTitle: '{{itemSettings.item | fullNameFilter}}',
			itemType: PermissionPresetProvider,
			fabButtons: [
				{
					title: 'Add Permission Preset',
					icon: 'zmdi zmdi-playlist-plus',
					action: PermissionPresetProvider.addItem
				}
			],
			fabIcon: 'zmdi zmdi-plus',
			/* @ngInject */
			listItems: ["localCacheReady", "PermissionPreset", function (localCacheReady, PermissionPreset) {
				return PermissionPreset.getCache()
			}],
			initialSortBy: 'Name',
			initialView: 'list',
			showGroupHeaders: false,
		})
	}

})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "LocationProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, LocationProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.all-locations',
			title: 'All Locations',
			itemTitle: '{{itemSettings.item.Name}}',
			itemType: LocationProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Location", function (localCacheReady, Location) {
				return Location.getCache()
			}],
			initialSortBy: 'Name',
			initialView: 'list'
		})
	}

})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "DepartmentProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, DepartmentProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.structure.all-departments',
			title: 'All Departments',
			itemTitle: '{{itemSettings.item.Name}}',
			itemType: DepartmentProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Department", function (localCacheReady, Department) {
				return Department.getCache()
			}],
			initialSortBy: 'Name',
			initialView: 'list'
		})
	}

})();
(function () {
	'use strict';

	StrategyItemController.$inject = ["$scope", "$rootScope", "$mdDialog", "ItemViewer", "itemSettings", "socket", "auUtility", "Initiative"];
	angular
		.module('app')
		.controller('StrategyItemController', StrategyItemController);

	/* @ngInject */
	function StrategyItemController($scope, $rootScope, $mdDialog, ItemViewer, itemSettings, socket, auUtility, Initiative) {
		var vm = this;
		vm.orgName = $rootScope.Organization.Name

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item
		
		//create a list of initiatives for this strategy
		vm.initiatives = Initiative.getCache({StrategyId: vm.item._id})

		function setSortables() {
            vm.sortableBy = [{
                fieldName: 'Title',
                display: 'Title'
            }, {
                fieldName: 'Created',
                display: 'Who Added'
            }, {
				fieldName: 'DateCreated',
				display: 'Date Added'
			}]
            vm.sortBy = vm.sortableBy[0]
        }

        vm.setSortBy = function($index) {
            vm.sortBy = vm.sortableBy[$index]
		}
		
		//add new initiative
		vm.openNewInitiativeDialog = function($event){
			$mdDialog.show({
				templateUrl: '/app/strategy/dialogs/add-initiative.tmpl.html',
                controller: 'AddInitiativeDialog',
                controllerAs: 'vm',
                targetEvent: $event,
                locals: {
                    options: {
                        strategy: vm.item
                    }
                }
			})
		}
	}
})();
(function () {
	'use strict';

	InitiativeItemController.$inject = ["$scope", "$rootScope", "$mdDialog", "ItemViewer", "itemSettings", "socket", "auUtility", "Task"];
	angular
		.module('app')
		.controller('InitiativeItemController', InitiativeItemController);

	/* @ngInject */
	function InitiativeItemController($scope, $rootScope, $mdDialog, ItemViewer, itemSettings, socket, auUtility, Task) {
        var vm = this;
        vm.resizeTrigger = 0

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item

        function setSortables() {
            vm.sortableBy = [{
                fieldName: 'Title',
                display: 'Title'
            }, {
                fieldName: 'CreatedBy',
                display: 'Who Added'
            }]
            vm.sortBy = vm.sortableBy[0]
        }

        vm.setSortBy = function($index) {
            vm.sortBy = vm.sortableBy[$index]
        }

        vm.addKPI = function($event) {
            if (!angular.isDefined(vm.item.KPIs))
            vm.item.KPIs = [];
            var term = auUtility.randomAmbiguousTerm()
			vm.item.KPIs.push({
                Title: 'Excel at collecting ' + term + 's',
                CreatedBy: $rootScope.user._id,
                Thresholds: [{
					Name: 'Green Light',
					Emoji: '💚'
				}, {
					Name: 'Yellow Light',
					Emoji: '🔶'
				}, {
					Name: 'Red Light',
					Emoji: '🚫',
				}],
				CollectionProcess: 'We can count the ' + term + 's collected by...',
				RepeatsEvery: {
					IntervalType: 'weekly',
					Interval: 1,
					RepeatDays: {Friday:true},
					DayOfMonth : 1,
				}
            });
        }

        //create list of emoji options
        vm.emojiOptions = ['😊','😐','😩','😥','😵','🎓','💎','👑','👾','🏁','🏆','🏃','🎯','🍕','🍦','🍉','🍏','🔥','📫','📌','🚫','⚠','⚡','⚓','♿','🌙','☀','🌈','🐌','🐞','🐦','🌱','🌴','🌺','✔','✖','🗻','💩','💪','💡','💰','🔶','💚']
        //create list of comparison operations
        vm.operations = [
            {
                word: 'Greater than',
                symbol: '>'
            },
            {
                word: 'Greater than or Equal to',
                symbol: '>='
            },
            {
                word: 'Equal to',
                symbol: '=='
            },
            {
                word: 'Less than or Equal to',
                symbol: '<='
            },
            {
                word: 'Less than',
                symbol: '<'
            },
            {
                word: 'Between',
                symbol: 'btw'
            }
        ]
        
        vm.removeThreshold = function(kpiId, index) {
            var hostKPI = vm.item.KPIs.filter(function(kpi){
                return kpi._id == kpiId
            })
            hostKPI[0].Thresholds.splice(index, 1)
            vm.item.$saveItem()
        }
        vm.addThreshold = function(kpiId) {
            var hostKPI = vm.item.KPIs.filter(function(kpi){
                return kpi._id == kpiId
            })
            hostKPI[0].Thresholds.push({})
            vm.item.$saveItem()            
        }

        //get KPI title
		vm.kpiTitle = function(data) {
			var kpi = vm.item.KPIs.filter(function(kpi){
				return kpi._id == data.KPI_id
			})
			return kpi[0].Title			
		}
        
        //get review task items        
        $scope.$watchCollection('vm.item.ReviewSchedule', function(newVal, oldVal){
            vm.reviewTaskList = []
            newVal.forEach(function(taskId){
                vm.reviewTaskList.push(Task.getCache({_id: taskId})[0])
            })
        })

        //dialogs
        vm.openNewKPIDataDialog = function($event) {
            $mdDialog.show({
                templateUrl: '/app/strategy/dialogs/add-kpi-data.tmpl.html',
                controller: 'AddKPIDataDialog',
                controllerAs: 'vm',
                targetEvent: $event,
                locals: {
                    options: {
                        initiative: vm.item
                    }
                }
            })
        }

        vm.openNewReviewScheduleDialog = function($event) {
            $mdDialog.show({
                templateUrl: '/app/project/dialogs/add-task.tmpl.html',
                controller: 'AddTaskDialog',
                controllerAs: 'vm',
                targetEvent: $event,
                locals: {
                    options: {
                        initiative: vm.item,
                        skipIntro: true
                    }
                }
            })
        }

        vm.confirmThenRemove = function($event, data) {
            var areYouSure
            if (data.KPI_id) areYouSure = 'Are you sure you want to remove data for the KPI ' + vm.item.KPIs.find(function(kpi){return kpi._id == data.KPI_id}).Title + ' from this initiative?'
            else if (data.Comment) areYouSure = 'Are you sure you want to remove this review from this initiative?'
            else areYouSure = 'Are you sure you want to remove the KPI ' + data.Title + ' from this initiative?'

            $mdDialog.show($mdDialog.confirm({
                title: 'Remove',
                textContent: areYouSure,
                ok: 'Yes',
                cancel: 'Nevermind',
                targetEvent: $event
            })).then(function() {
                // remove the data if they confirmed
                if (data.KPI_id) {
                	for (var i = 0; i < vm.item.KPIData.length; i++){
                		var kpiData = vm.item.KPIData[i]
                		if (kpiData._id == data._id) {
                			vm.item.KPIData.splice(i, 1)
                			break
                		}
                	}
                } 
                else if (data.Comment) {
                	vm.item.Reviews.splice(data._id, 1)
                }

                else vm.item.KPIs.splice(data._id, 1)
                vm.item.$updateItem()
            }).catch(function(err) {
                console.log(err)
            })
        }

        //post a review
        vm.postReviewClicked = function($event) {
            vm.item.Reviews.push(vm.workingReview)
            vm.item.$saveItem()
            vm.workingReview = ''
        }
	}
})();
(function() {
	'use strict';

	AddStrategyDialog.$inject = ["$timeout", "$mdDialog", "$state", "Strategy"];
	angular
		.module('app')
		.controller('AddStrategyDialog', AddStrategyDialog);

	/* @ngInject */
	function AddStrategyDialog($timeout, $mdDialog, $state, Strategy) {
        var vm = this;
        
        //create a new blank Strategy
        vm.newItem = vm.strategy = new Strategy()

		//confirm a title was entered	
		vm.confirmTitleEntered = function() {
			return vm.strategy.Title
		}

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Title', value: vm.strategy.Title}
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
            return vm.strategy.$saveItem()
            .then(function(item){
                return "You have successfully added " + item.Title
            })
		}
	}
}
)();
(function() {
	'use strict';

	AddKPIDataDialog.$inject = ["$rootScope", "Initiative", "options"];
	angular
		.module('app')
		.controller('AddKPIDataDialog', AddKPIDataDialog);

	/* @ngInject */
	function AddKPIDataDialog($rootScope, Initiative, options) {
        var vm = this;
        
        //capture Initiative
        vm.initiative = options.initiative

        //create a new KPI Data for this initiative
        vm.kpiData = {CreatedBy: $rootScope.user._id, DateCollected: new Date()}

		//confirm a title was entered	
		vm.confirmDataEntered = function() {
			return vm.kpiData.KPI_id && vm.kpiData.Value
		}
		
		//get KPI title
		vm.kpiTitle = function() {
			var kpi = vm.initiative.KPIs.filter(function(kpi){
				return kpi._id == vm.kpiData.KPI_id
			})
			return kpi[0].Title			
		}

        //calculate result based on thresholds
        vm.calculateResult = function() {
			var kpi = vm.initiative.KPIs.filter(function(kpi){
				return kpi._id == vm.kpiData.KPI_id
			})
			vm.result = null
			kpi[0].Thresholds.forEach(function(threshold){
				if (vm.result != null) return
				
				if (threshold.Operation == 'btw') {
					//check for cases like 'btw 10 and 5' vs 'btw 5 and 10'
					if (eval(threshold.LowValue +'<'+ threshold.HighValue)) {
						if (eval(threshold.LowValue +'<='+ vm.kpiData.Value && vm.kpiData.Value +'<='+ threshold.HighValue)) vm.result = threshold
					} else {
						if (eval(threshold.LowValue +'>='+ vm.kpiData.Value && vm.kpiData.Value +'>='+ threshold.HighValue)) vm.result = threshold
					}
				} else if (eval(vm.kpiData.Value + threshold.Operation + threshold.LowValue)) vm.result = threshold
			})
        }

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
                    {name: 'Date Collected', value: moment(vm.kpiData.DateCollected).format('M/D/YYYY')},
                    {name: 'KPI', value: vm.kpiTitle()},
                    {name: 'Value', value: vm.kpiData.Value},
                    {name: 'Result', value: vm.result.Emoji +' '+ vm.result.Name}
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			vm.kpiData.Emoji = vm.result.Emoji
            vm.initiative.KPIData.unshift(vm.kpiData)
            return vm.initiative.$updateItem().$promise
            .then(function(item){
                return "You have successfully added data for " +vm.kpiTitle()+ " to " + vm.initiative.Title
            })
		}

		//close this dialog
		vm.close = function() {
			$mdDialog.hide()
		}
	}
}
)();
(function() {
	'use strict';

	AddInitiativeDialog.$inject = ["$timeout", "$mdDialog", "$state", "Schema", "Initiative", "Strategy", "options"];
	angular
		.module('app')
		.controller('AddInitiativeDialog', AddInitiativeDialog);

	/* @ngInject */
	function AddInitiativeDialog($timeout, $mdDialog, $state, Schema, Initiative, Strategy, options) {
        var vm = this;
        
        //create a new blank Initiative
        vm.newItem = vm.initiative = new Initiative({Title: '', Creator: $rootScope.user._id})
        if (options.strategy) vm.initiative.StrategyId = options.strategy._id

		//confirm a title was entered	
		vm.confirmTitleEntered = function() {
			return vm.initiative.Title
        }

        //create list of Strategies user can edit
        vm.strategies = Strategy.getCache({Editors: $rootScope.user._id})
        
        //confirm a strategy was chosen
        vm.confirmStrategyChosen = function() {
            return vm.initiative.StrategyId
        }

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
                    {name: 'Title', value: vm.initiative.Title},
                    {name: 'Description', value: vm.initiative.Description},
                    {name: 'Strategy', value: vm.initiative.$StrategyId.toString()}
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
            return vm.initiative.$saveItem()
            .then(function(item){
                return "You have successfully added " + item.Title
            })
		}
	}
}
)();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        // add routes
        $stateProvider
        .state('shell.socialpage', {
            url: '/socialpage',
			// views: { //dev note - sections (like introduction and structure) should use the unnamed view)
			// 	'content@align.us': {
					templateUrl: '/app/social/test/socialpage.tmpl.html',
					controller: 'socialpageController',
					controllerAs: 'vm',
			// 	}
			// },
			data: {
				name: 'Align Us'
			}
        });
    }
})();
(function () {
	'use strict';

	socialpageController.$inject = ["$scope", "$element", "$compile", "$mdDialog"];
	angular
		.module('app')
		.controller('socialpageController', socialpageController);

	/* @ngInject */
	function socialpageController($scope, $element, $compile, $mdDialog) {
		var vm = this;

		$scope.labels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
		$scope.Xdata = [300, 500, 100];

		

	}

})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        // add routes
        $stateProvider
        .state('shell.conversation', {
            url: '/conversation',
			// views: { //dev note - sections (like introduction and structure) should use the unnamed view)
			// 	'content@align.us': {
					templateUrl: '/app/social/test/conversation.tmpl.html',

					controller: 'designConversationController',
					controllerAs: 'vm',
                    
			// 	}
			// },
			data: {
				name: 'Align Us'
			}
        });
    }
})();
(function () {
	'use strict';

	designConversationController.$inject = ["$scope", "$element", "$compile", "$mdDialog", "$mdSidenav"];
	angular
		.module('app')
		.controller('designConversationController', designConversationController);

	/* @ngInject */
	function designConversationController($scope, $element, $compile, $mdDialog, $mdSidenav) {
		var vm = this;

		vm.$mdSidenav = $mdSidenav

	}

})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        // add routes
        $stateProvider
        .state('shell.calendar', {
            url: '/calendar',
			// views: { //dev note - sections (like introduction and structure) should use the unnamed view)
			// 	'content@align.us': {
					templateUrl: '/app/social/test/calendar.tmpl.html',
					controller: 'calendarController',
					controllerAs: 'vm',
			// 	}
			// },
			data: {
				name: 'Align Us'
			}
        });
    }
})();
(function () {
	'use strict';

	calendarController.$inject = ["$scope", "$element", "$compile", "$mdDialog"];
	angular
		.module('app')
		.controller('calendarController', calendarController);

	/* @ngInject */
	function calendarController($scope, $element, $compile, $mdDialog) {
		var vm = this;

		$scope.labels = ["Download Sales", "In-Store Sales", "Mail-Order Sales"];
		$scope.Xdata = [300, 500, 100];

		

	}

})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "QuestionTagProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, QuestionTagProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.tags',
			title: 'List All Tags',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: QuestionTagProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "QuestionTag", function (localCacheReady, QuestionTag) {
				return QuestionTag.getCache()
			}],
			initialSortBy: 'TagText',
			initialView: 'list',

			fabButtons: [
				{
					title: 'Add Tag',
					icon: 'zmdi zmdi-label',
					action: function ($event) {
						$mdDialog.show({
								controller: 'AddTagDialog',
								controllerAs: 'vm',
								templateUrl: '/app/social/questions/dialogs/add-tag.tmpl.html',
								targetEvent: $event,
								locals: {canPass: 'data here'}
						}).then(function (hide) {
							//can run code after dialog closes normally
							})
					}
				}
			],
			fabIcon: 'zmdi zmdi-plus',
		})

		
	}
})(); 
(function () {
	'use strict';

	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "QuestionProvider", "SingleItemViewerProvider", "QuestionTagProvider", "QuestionAnswerProvider", "UserQuestionProvider", "SelectFilterProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, QuestionProvider, SingleItemViewerProvider, QuestionTagProvider, QuestionAnswerProvider, UserQuestionProvider, SelectFilterProvider) {

		$stateProvider
			.state('shell.social.questions.search', {
				url: '/search',
				views: {
					'@shell': {
						templateUrl: '/app/social/questions/search/questionsearch.tmpl.html',
						controller: 'QuestionSearchController',
						controllerAs: 'vm',
					}
				},
				data: {

				},
				navigationData: {
					breadcrumbTitle: 'Search Questions'
				}
			})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.all-questions',
			title: 'List All Questions',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Question", function (localCacheReady, Question) {
				return Question.getCache()
			}],
			initialSortBy: 'QuestionTitle',
			initialView: 'list'
		})

		SingleItemViewerProvider.createRouteFor($stateProvider, {
			itemType: QuestionProvider,
			itemSection: 'social',
			detailTemplateUrl: '/app/structure/questions/question/questions.tmpl.html',
			controller: 'QuestionsController'
		})

		SingleItemViewerProvider.createRouteFor($stateProvider, {
			itemType: QuestionTagProvider,
			itemSection: 'social',
			detailTemplateUrl: '/app/structure/questions/questiontag/questiontag.tmpl.html',
			controller: 'QuestionTagController'
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.all-question-answers',
			title: 'List All Question Answers',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: QuestionAnswerProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "QuestionAnswer", function (localCacheReady, QuestionAnswer) {
				return QuestionAnswer.getCache()
			}],
			initialSortBy: 'Content',
			initialView: 'list'
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.recently-answered',
			title: 'Recently Answered Questions',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Question", function (localCacheReady, Question) {
				var moreRecentThan = new Date((new Date()).getTime() - 1000 * 60 * 60 * 24 * 7)
				return Question.query({
					'LastAnswered__gte': moreRecentThan
				}).$httpPromise
			}],
			initialSortBy: '-LastAnswered',
			initialView: 'list'
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.faq',
			title: 'Frequently Asked Questions',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Question", function (localCacheReady, Question) {
				return Question.getCache({ IsFAQ: true }, true)
			}],
			initialSortBy: 'QuestionTitle',
			initialView: 'list'
		})

		/* BEGIN 'MODERATE MY TAGS' ROUTES */
		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.my-tags',
			title: 'My Moderator Tags',
			subTitle: 'This is a complete list of tags for which you are a Moderator. Click a tag to see a list of all questions bearing that tag.',
			/* @ngInject */
			values: ["localCacheReady", "QuestionTag", "$rootScope", function (localCacheReady, QuestionTag, $rootScope) {
				return QuestionTag.getCache({
					Moderator: $rootScope.user._id
				}).$httpPromise.then(function(tags) {
					return tags.map(function (tag) {
						return {
							title: tag.TagText,
							sref: '.questions.list',
							srefOpts: { query: tag._id },
							item: tag
						}
					})
				})
				
			}],
			breadcrumbItemMap: function (value) {
				return {
					title: 'Questions Tagged ' + value.title,
					sref: 'shell.social.questions.by-tag.questions.list',
					srefOpts: value.srefOpts
				}
			}
		})


		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.my-tags.questions',
			title: 'Questions Tagged...',
			itemTitle: '{{itemSettings.item.QuestionTitle}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "$state", "$stateParams", "Question", function (localCacheReady, $state, $stateParams, Question) {
				return Question.query({
					Tags: $stateParams.query
				}).$httpPromise
			}],
			initialSortBy: '-DateCreated',
			initialView: 'list'
		})

		/* END 'MODERATE MY TAGS' ROUTES */

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.by-tag',
			title: 'Questions Tagged...',
			itemTitle: '{{itemSettings.item.QuestionTitle}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "$state", "$stateParams", "Question", function (localCacheReady, $state, $stateParams, Question) {
				return Question.query({
					Tags: $stateParams.query
				}).$httpPromise
			}],
			initialSortBy: '-DateCreated',
			initialView: 'list'
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.questions.respond',
			title: 'Respond to questions asked to you',
			itemTitle: '{{itemSettings.item.$Question.QuestionTitle}}',
			itemType: QuestionProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "UserQuestion", function (localCacheReady, UserQuestion) {
				return UserQuestion.query()
					.$httpPromise
					.then(function () {
						return UserQuestion.getCache({}, '-DateCreated').map(function (uq) {
							return uq.$Question
						})
					})
			}],
			initialView: 'list',
			initialSortBy: '-DateCreated'
		})


	}
})();
(function() {
    'use strict';
    
    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        // add routes
        $stateProvider	
        .state('shell.social.moderator-detail', {
            url: '/moderator-detail',
			// views: { //dev note - sections (like introduction and structure) should use the unnamed view)
			// 	'content@align.us': {
					templateUrl: '/app/social/questions/moderators/moderators.tmpl.html',
					controller: 'ModeratorsController',
					controllerAs: 'vm',
			// 	}
			// },
			data: {
				name: 'Align Us'
			},
			
			navigationData: {
				breadcrumbTitle: 'Moderator Detail'
			}
            
        });
    }    
})();
(function () {
    'use strict';

	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider) {
        // add routes
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {
            name: 'shell.social.questions',
            title: 'Questions & Answers',
			subTitle: 'Welcome to the knowledge base built and curated by {{org}}!',
			cardClass: "sub-menu-card",

			fabButtons: null,

			menuItems: [
				{
					title: 'Search Q&A',
					subtitle: 'Need something? Start here!',
					image: '/assets/images/cards/slim/social/searchqa.png',
					sref: 'shell.social.questions.search'
				},
				{
					title: 'Respond',
					subtitle: 'Answer questions sent to you.',
					image: '/assets/images/cards/slim/social/pendingresponse.png',
					sref: 'shell.social.questions.respond.list'
				},
				{
					title: 'Recent Answers',
					subtitle: 'View questions that have recently been answered.',
					image: '/assets/images/cards/slim/social/recentlyanswered.png',
					sref: 'shell.social.questions.recently-answered.list'
				},
				{
					title: 'FAQs',
					subtitle: 'View frequently asked questions.',
					image: '/assets/images/cards/slim/social/faq.png',
					sref: 'shell.social.questions.faq.list'
				},
				{
					title: 'Tags',
					subtitle: 'Manage question tags and their moderators.',
					image: '/assets/images/cards/slim/social/tags.png',
					permissionNeeded: '$root.user.EffPerms.QnA.Manager',
					sref: 'shell.social.questions.tags.list'
				},
				{
					title: 'My Tags',
					subtitle: 'Show questions for tags you\'re moderating.',
					image: '/assets/images/cards/slim/social/moderators.png',
					sref: 'shell.social.questions.my-tags'
				}
			]
        })

	}
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ShowPostsProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ShowPostsProvider) {
		ShowPostsProvider.createRoutes($stateProvider, {
			name: 'shell.social.posts.tagged',
			title: "Tagged",
			subTitle: "Posts that I am tagged in."
		})
	}

})(); 
(function () {
	'use strict'
	PostsController.$inject = ["$scope", "$state", "$timeout", "auUtility", "postPointers"];
	angular
		.module('app')
		.controller('PostsController', PostsController)

	/* @ngInject */
	function PostsController($scope, $state, $timeout, auUtility, postPointers) {
		var vm = this;

		//fade in the contents scrolled up
		var el = angular.element('.posts md-content')
		auUtility.initPageScrolledDown(el)

		$timeout(function () {
			vm.title = $state.$current.navigationData.breadcrumbTitle
			vm.subTitle = $state.$current.navigationData.subTitle
		})

		//return the next 10 as a resolved promise
		var lastPostReturned = 0
		vm.getPosts = function (options) {
			options = options || {}
			var nbrPosts = options.returnCount || 10
			var promise = $q.defer()

			var nextPosts = postPointers.data.slice(lastPostReturned, lastPostReturned + nbrPosts)
			lastPostReturned += nextPosts.length

			//map to data structure that au-post-feed can use
			nextPosts = nextPosts.map(function (post) {
                return { Post: post._id, DateCreated: post.DateCreated }
            })

			promise.resolve(nextPosts)
			return promise.promise
		}
	}
})();
(function() {
    'use strict';


    angular.module('app').provider('ShowPosts', ShowPostsProvider);

    function ShowPostsProvider() {
        return {
            /* @ngInject */
            $get: function() {
                console.debug('in ShowPostsProvider')
            },
            createRoutes: function($stateProvider, options) {
                //enforce the url equals the dot notation route name
                var url = options.name.split('.').last()

                //GET THE POSTS FOR A QUERY
                $stateProvider.state(options.name, {
                    url: '/' + url,

                    views: {
                        '@shell': {
                            templateUrl: '/app/social/post/posts.tmpl.html',
                            controller: 'PostsController',
                            controllerAs: 'vm',
                        }
                    },

                    navigationData: {
                        breadcrumbTitle: options.title,
                        subTitle: options.subTitle
                    },

                    //enforce naming convention of values
                    resolve: {
                        /* @ngInject */
                        postPointers: ["localCacheReady", "Post", function(localCacheReady, Post) {
                            return Post.getPostPointers(url)
                        }]
                    },
                    onEnter: options.onEnter
                })
            }
        } //end of return
    } //end of function
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ShowPostsProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ShowPostsProvider) {
		ShowPostsProvider.createRoutes($stateProvider, {
			name: 'shell.social.posts.my-teams',
			title: "My Teams",
			subTitle: "Posts on team pages that I am a member of."
		})
	}

})(); 
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ShowPostsProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ShowPostsProvider) {
		ShowPostsProvider.createRoutes($stateProvider, {
			name: 'shell.social.posts.my-posts',
			title: "My Posts",
			subTitle: "Posts from me on any page."
		})
	}
})(); 
(function () {
	'use strict';

	PostItemController.$inject = ["$scope", "toast", "$filter", "$state", "ItemViewer", "itemSettings"];
	angular
		.module('app')
		.controller('PostItemController', PostItemController);

	/* @ngInject */
	function PostItemController($scope, toast, $filter, $state, ItemViewer, itemSettings) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;
		
	}
})();
(function() {
    'use strict';
    
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider) {
        // add routes
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {	
            name: 'shell.social.posts', 
            title: 'Posts',
			subTitle: 'Find different post feeds related to you.',
			cardClass: "sub-menu-card",

			fabButtons: [
				{
					title: 'Add Page',
					icon: 'zmdi zmdi-view-web',
					action: function () {
						$mdDialog.show({
							controller: 'PageWizardDialog',
							controllerAs: 'vm',
							templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
							targetEvent: null,
							locals: { options: { pageType: 'General' } }
						})
					},
					permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
				},
				{
					title: 'Add Event',
					icon: 'zmdi zmdi-calendar-alt',
					action: function () {
						$mdDialog.show({
							controller: 'PageWizardDialog',
							controllerAs: 'vm',
							templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
							targetEvent: null,
							locals: { options: { pageType: 'Event' } }
						})
					},
					permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
				},
				{
					title: 'Post to Page',
					icon: 'zmdi zmdi-edit',
					action: function () {
						$mdDialog.show({
							controller: 'PostToPageController',
							controllerAs: 'vm',
							templateUrl: '/app/alignus/layouts/_shell/dialogs/post-to-page.tmpl.html',
							targetEvent: null,
							locals: { options: {} }
						})
					}
				}
			],
			fabIcon: 'zmdi zmdi-plus',


			menuItems: [
				{
					title: 'My Posts',
					subtitle: 'Posts from me.',
					image: '/assets/images/cards/slim/social/posts-my.png',
					sref: 'shell.social.posts.my-posts'
				},
				{
					title: 'Tagged',
					subtitle: 'Posts I\'m tagged in.',
					image: '/assets/images/cards/slim/social/posts-tagged.png',
					sref: 'shell.social.posts.tagged'
				},
				{
					title: 'News Feed',
					subtitle: 'Posts on pages I follow.',
					image: '/assets/images/cards/slim/social/posts-feed.png',
					sref: 'shell.social.news-feed'
				},
				{
					title: 'My Teams',
					subtitle: 'Posts from people on my teams.',
					image: '/assets/images/cards/slim/social/posts-my-teams.png',
					sref: 'shell.social.posts.my-teams'
				}
			]
        })
		
	}
})();
(function() {
    configUserPages.$inject = ["PageProvider", "ListViewerProvider", "$stateProvider"];
    angular
        .module('app')
        .config(configUserPages)

    /* @ngInject */
    function configUserPages(PageProvider, ListViewerProvider, $stateProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.user-pages',
            title: 'All User Pages',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function(localCacheReady, Page) {
                return Page.getCache({ Type: 'User' })
            }],
            initialSortBy: 'Title',
            initialView: 'list'
        })
    }
})();
(function() {
    configTeamPages.$inject = ["PageProvider", "ListViewerProvider", "$stateProvider"];
    angular
        .module('app')
        .config(configTeamPages)

    /* @ngInject */
    function configTeamPages(PageProvider, ListViewerProvider, $stateProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.team-pages',
            title: 'All Team Pages',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function(localCacheReady, Page) {
                return Page.getCache({ Type: 'Team' })
            }],
            initialSortBy: 'Title',
            initialView: 'list'
        })
    }
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
	angular.module('app').config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PageProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.pages.my-pages-dir.posted-on',
			title: "Pages I Posted On",
			itemTitle: "{{itemSettings.item.Title}}",
			itemType: PageProvider,
			
            /* @ngInject */
			listItems: ["localCacheReady", "$rootScope", "Page", "Post", "$filter", function (localCacheReady, $rootScope, Page, Post, $filter) {
				var pageIdMap = {}
				
				return Page.PagesIPostedOn()
					.then(function(pageIds) {
						//create a map of key: value where key is the page id and the value is the last post date
						pageIds.forEach(function(page){
							pageIdMap[page._id] = page.lastPost
						})

						//convert page id array to array of strings
						pageIds = pageIds.map(function(page){
							return page._id
						})

						//now that we have all the pages we posted on further filter to exclude Discussion Boards, Conversations, and Embedded pages
						return Page.query({_id__in: (pageIds.length ? pageIds : ['000000000000000000000000']), Type__nin:"Discussion,Conversation", IsEmbedded:false }).$httpPromise
						.then(function(pages){
							//attach the last post property to the page cached reource
							pages.forEach(function(page){
								page.$lastPost = pageIdMap[page._id]
							})
							return pages
						})
					})
			}],
			itemFields: [{
                display: 'Last post date',
                displayValue: '$lastPost',
                groupMethod: 'date',
                name: '$lastPost',
                primary: true,
                sortable: true,
                type: Date
            },
			{
                display: 'Title',
                displayValue: 'Title',
                groupMethod: 'alpha',
                name: 'Title',
                primary: true,
                sortable: true,
                type: String
            },
			{
                display: 'Type',
                displayValue: 'Type',
                groupMethod: 'value',
                name: 'Type',
                primary: true,
                sortable: true,
                type: String
            }],
			initialSortBy: '-$lastPost',
			initialView: 'list',
			showGroupHeaders: true
		})

	}
})(); 
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
	angular.module('app').config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PageProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.pages.my-pages-dir.my-teams',
			title: "My Team Pages",
			itemTitle: "{{itemSettings.item.Title}}",
			itemType: PageProvider,
			
            /* @ngInject */
			listItems: ["localCacheReady", "$rootScope", "Page", "Team", "$filter", function (localCacheReady, $rootScope, Page, Team, $filter) {
				return Team.query({
					$or: [
						{ Owner: $rootScope.user._id },
						{ Nodes: { $elemMatch: { LinkWithUserId: $rootScope.user._id } } }
					]

				}).$httpPromise
				.then(function(teams) {
					var pages = teams.map(function(team) { return team._id })
					if($rootScope.user.Location) pages.push($rootScope.user.Location)
					if($rootScope.user.Department) pages.push($rootScope.user.Department)
					return Page.query({_id__in: (pages.length ? pages : ['000000000000000000000000'])}).$httpPromise
				})
			}],
			initialSortBy: 'Title',
			initialView: 'list'
		})

	}
})(); 
(function() {
    'use strict';

    //define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "PageProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, PageProvider) {

        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.my-pages-dir.my-pages',
            title: 'Pages You Administer',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", "$rootScope", function(localCacheReady, Page, $rootScope) {
                var user = $rootScope.user._id
		//getcache refactor required
                return Page.getCache(function(page) {
                    return (!(page instanceof Array) && (page.Owner == user || page.Editors.indexOf(user) > -1) && !page.IsEmbedded && page.Type != 'Conversation')
                })
            }],
            initialSortBy: 'Type',
            initialView: 'list'
        })

    }
})();
(function() {
    'use strict';

    //define the routes and menu for this module
    configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
    angular.module('app').config(configRoutes);

    /* @ngInject */
    function configRoutes($stateProvider, ListViewerProvider, PageProvider) {

        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.all-pages',
            title: 'All Pages',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function (localCacheReady, Page) {
                return Page.query({ IsEmbedded: false, 'Type__ne': 'Conversation' }).$httpPromise
            }],
            initialSortBy: 'Type',
            initialView: 'list'
        })
    }

})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
	angular.module('app').config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PageProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.pages.my-pages-dir.im-following',
			title: "Pages I\'m Following",
			itemTitle: '{{itemSettings.item.Title}}',
			itemType: PageProvider,

			/* @ngInject */
			listItems: ["localCacheReady", "Page", "$rootScope", function (localCacheReady, Page, $rootScope) {
				//after page follow/unfollow some bug is not uncaching the $$property so delete that
				delete $rootScope.user.$$FollowingPages
				return $rootScope.user.$FollowingPages
			}],
			initialSortBy: 'Type',
			initialView: 'list'
		})

	}
})();
(function() {
    configDiscussionBoards.$inject = ["PageProvider", "ListViewerProvider", "$stateProvider"];
    angular
        .module('app')
        .config(configDiscussionBoards)

    /* @ngInject */
    function configDiscussionBoards(PageProvider, ListViewerProvider, $stateProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.general',
            title: 'All General Pages',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function(localCacheReady, Page) {
                return Page.query({$or: [{ Type: 'General' }, { Type: 'Organization' }] }).$httpPromise
            }],
            initialSortBy: 'Title',
            initialView: 'list'
        })
    }
})();
(function() {
    configDiscussionBoards.$inject = ["PageProvider", "ListViewerProvider", "$stateProvider"];
    angular
        .module('app')
        .config(configDiscussionBoards)

    /* @ngInject */
    function configDiscussionBoards(PageProvider, ListViewerProvider, $stateProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.discussion-boards',
            title: 'All Discussion Boards',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function(localCacheReady, Page) {
                return Page.getCache({ Type: 'Discussion', IsEmbedded: false })
            }],
            initialSortBy: 'Title',
            initialView: 'list'
        })
    }
})();
(function() {
    configDepartmentsLocations.$inject = ["PageProvider", "ListViewerProvider", "$stateProvider"];
    angular
        .module('app')
        .config(configDepartmentsLocations)

    /* @ngInject */
    function configDepartmentsLocations(PageProvider, ListViewerProvider, $stateProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.department-location-pages',
            title: 'Department and Location Pages',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: PageProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Page", function(localCacheReady, Page) {
                return Page.query({ $or: [ { Type: 'Location' }, { Type: 'Department' } ] }).$httpPromise
            }],
            initialSortBy: 'Title',
            initialView: 'list'
        })
    }
})();
(function() {
    'use strict';
    configConversations.$inject = ["$stateProvider", "ListViewerProvider", "ConversationProvider"];
    angular
        .module('app')
        .config(configConversations);

    /* @ngInject */
    function configConversations($stateProvider, ListViewerProvider, ConversationProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.social.messages',
            title: 'Inbox',
            itemTitle: '{{itemSettings.item.Title}}',
            itemType: ConversationProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Conversation", "$timeout", function(localCacheReady, Conversation, $timeout) {
                //debounces over 100ms
                Conversation.updateConversations()

                //so, if there are no conversations, this is a browser refresh so wait for the debounce to finish
                if (Conversation.conversations.length > 0) {
                    return Conversation.conversations
                } else {
                    return $timeout(function(){
                        return Conversation.conversations
                    }, 1000)
                }
                
            }],
            fabButtons: [{
                title: 'Compose Message',
                icon: 'zmdi zmdi-comment',
                action: function($event) {
                    window.$injector
                        .get('Conversation')
                        .NewConversationFull()
                }
            }, {
                title: 'Add Discussion Board',
                icon: 'zmdi zmdi-comments',
                action: function() {
                    $mdDialog.show({
                        controller: 'PageWizardDialog',
                        controllerAs: 'vm',
                        templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                        targetEvent: null,
                        locals: { options: { pageType: 'Discussion' } }
                    })
                },
                permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
            }],
            fabIcon: 'zmdi zmdi-plus',
            itemFields: [{
                display: 'Last message date',
                displayValue: 'LastPostDate',
                groupMethod: 'value',
                name: 'LastPostDate',
                primary: true,
                sortable: true,
                type: 'Number'
            },
			{
                display: 'Title',
                displayValue: 'Title',
                groupMethod: 'alpha',
                name: 'Title',
                primary: true,
                sortable: true,
                type: 'String'
            },
			{
                display: 'Type',
                displayValue: 'Type',
                groupMethod: 'value',
                name: 'Type',
                primary: true,
                sortable: true,
                type: 'String'
            }, {
                display: 'Members',
                displayValue: 'Members',
                groupMethod: 'value',
                name: '$StringMembers',
                primary: true,
                sortable: false,
                type: 'String'
            }],
            initialSortBy: '-LastPostDate',
            initialView: 'list',
            showGroupHeaders: false
        })
    }
})();
(function () {
    'use strict';

    PageItemController.$inject = ["$scope", "$element", "toast", "$injector", "$filter", "$state", "$timeout", "$interval", "auUtility", "ItemViewer", "itemSettings", "Post", "$mdDialog", "$window", "$mdSidenav", "$compile", "stemmer", "$q", "oneSearch", "socket", "windowFab"];
    angular
        .module('app')
        .controller('PageItemController', PageItemController);

    /* @ngInject */
    function PageItemController($scope, $element, toast, $injector, $filter, $state, $timeout, $interval, auUtility, ItemViewer, itemSettings, Post, $mdDialog, $window, $mdSidenav, $compile, stemmer, $q, oneSearch, socket, windowFab) {
        var vm = this;
        vm.showSocialPage = true
        vm.showDiscussionPage = false
        vm.$mdSidenav = $mdSidenav
        vm.excludePinned = true

        //turn this into an item viewer
        ItemViewer.create(vm, itemSettings, $scope)

        //expose the item to the view
        vm.item = itemSettings.item;
        vm.showCoverPhotoButton = vm.item.IsUserEditor($rootScope.user._id)

        // hook oneSearch to enable searching through posts on pages
        oneSearch.hook($scope, searchPage, 'Searching ' + (vm.item.Type == 'Discussion' || vm.item.Type == 'Conversation' ? 'discussion' : 'page'))

        if (vm.item.Type == 'Discussion' || vm.item.Type == 'Conversation' || vm.item.IsEmbedded) {
            vm.showSocialPage = false
            vm.showDiscussionPage = true
            vm.showDiscussionInput = false
        }

        //requery if needed
        if ($element.selector == '#DialogRecentItem') {
            $element = angular.element('#DialogRecentItem')
        }

        //make sure we don't get any item padding
        $element.find('.item-dialog-content').addClass('full-bleed')
        $element.find('.item-include').addClass('full-bleed')
        $element.closest('.item-pane').css('padding-bottom', 0)

        $interval(function () {
            $element.find('.item-dialog-content').addClass('full-bleed')
            $element.find('.item-include').addClass('full-bleed')
            $element.closest('.item-pane').css('padding-bottom', 0)
        }, 50, 5, false)

        //loading sequence
        if (vm.item.Type == 'Discussion' || vm.item.Type == 'Conversation' || vm.item.IsEmbedded) {
            $element.find('.fix-bottom').css('width', $element.find('.discussion-page').width())

            $timeout(function () {
                $element.find('.discussion-page').scrollParent().scroll(function () {
                    vm.dimSaySomething = true
                })
                var pageCoords = $element.find('[au-post-feed]').offset()
                var width = $element.find('.discussion-page').width()

                //set the width of the inline post equal to the width of the discussion page
                $element.find('.fix-bottom').css('width', width)

                //optimize for recent-item of discussion boards
                var fixToolbar = $element.closest('.item-dialog-container, body.single-item').length
                if (fixToolbar) {
                    //--make the settings fixed to the viewport so it sticks w/ o js
                    var toolbar = $element.find('.discussion-page .chat-settings')

                    //put the chat-settings div at the dom root
                    $element.after(toolbar[0])
                    toolbar.css('display', 'flex')

                    toolbar.css('left', pageCoords.left)
                    toolbar.css('width', width)
                }
                var inSingleItem = $element.closest('body.single-item').length
                if (inSingleItem) {
                    toolbar.css('top', 0)
                }

                vm.item.MarkPostsRead()
            }, 2000, false)
        } else {
            function scrollUp() {
                var el = $element.find('.social-page')
                el.removeClass('faux-up')

                el = el.scrollParent()
                el.scrollTop(150)
            }
            poll(function () { //when
                return $element.find('.au-post').length > 1
            }, scrollUp, scrollUp,
                2000, 1000)
        }

        //handle page delete
        vm.deletePageClicked = function ($event) {
            $mdDialog.show({
                controller: 'RemoveItemDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedItems: [vm.item],
                    showConfirmationSignature: true
                },
                templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
                clickOutSideToClose: true,
                targetEvent: $event
            })
                .then(function () {
                    // toast.success('Succes')
                    $window.history.back()
                })
        }

        vm.reduceMargin = function () {
            $element.find('.discussion-page').css('padding-bottom', 80)

            $rootScope.windowFab.forceHide = false
        }

        vm.expandMargin = function () {
            if (!vm.showDiscussionInput) {
                vm.showDiscussionInput = true
                $timeout(angular.noop, 100) //force a digest

                poll(function () {//when
                    return $element.find('.fix-bottom au-inline-post .au-cke-document .cke_wysiwyg_div').length
                }, function () {//then
                    $element.find('.fix-bottom au-inline-post .au-cke-document').click()
                }, angular.noop, 10000, 100)
            }

            var page = $element.find('.discussion-page')

            page.css('padding-bottom', 285)
            page.scrollParent().scrollTop(999999)

            $rootScope.windowFab.forceHide = true
        }

        vm.expandPageInput = function () {
            if (!vm.showPageInput) {
                vm.showPageInput = true
                $timeout(angular.noop, 100) //force a digest

                poll(function () {//when
                    return $element.find('.social-page au-inline-post.new-post .au-cke-document .cke_wysiwyg_div').length
                }, function () {//then
                    $element.find('.social-page au-inline-post.new-post .au-cke-document').click()
                }, angular.noop, 10000, 100)
            }
        }

        vm.scrolledToEnd = function () {
            vm.dimSaySomething = false
        }

        // the 'Editors' section should contain the Owner of the page
        // as well as all the editors, with the owner being listed first
        // and not being duplicated.
        vm.getEditorsSectionArray = function (page) {
            // owner should be in the first position
            var editorsSectionUsers = [page.Owner]
                // append an array of (all editors minus owner) to the results
                .concat(page.Editors.filter(function (editor) {
                    return editor != page.Owner
                }))
            return editorsSectionUsers
        }

        vm.openManagePageDialog = function ($event) {
            $mdDialog.show({
                controller: 'PageWizardDialog',
                controllerAs: 'vm',
                templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                targetEvent: $event,
                locals: { options: { page: vm.item } }
            }).then(function () {
                //
            })
        }

        // if someone wanted to search within this item, do it
        if (itemSettings.searchText) {
            vm.searchText = itemSettings.searchText
            searchPage(itemSettings.searchText)
        }

        function searchPage(originalText) {
            // stem the original text and make an array of regexes from the stems
            var matchedPosts
            var stems = stemmer.getStems(originalText)
            var stemRegExs = stems.map(function (stem) {
                return new RegExp(stem, 'i')
            })

            // get posts on this page which match the search terms
            Post.query({
                Page: vm.item._id,
                limit: 50,
                '$or': [
                    { 'Data.Update': { '$in': stemRegExs } },
                    { 'Data.Poll.Question': { '$in': stemRegExs } },
                    { 'Data.Introduction': { '$in': stemRegExs } }
                ]
            }).$httpPromise
                .then(function (posts) {
                    // tell the post feed for this page to display these posts
                    poll(function () {//when
                        return $element.find('.au-post-feed .loading-message').length > 0
                    }, function () {//then
                        $scope.$broadcast('displayPosts' + vm.item._id, posts)
                    }, angular.noop, 30 * 1000, 100)
                })
        }

        vm.pinnedPosts = Post.getCache({ Page: vm.item._id, IsPinned: true }, 300, "-DateCreated")
        vm.getPinnedPosts = function () {
            vm.loadingPosts = vm.pinnedPosts.$httpPromise

            return next()

            function next() {
                return vm.loadingPosts.then(function () {
                    return vm.pinnedPosts
                })
            }
        }

        $scope.$on('includePinned' + vm.item._id, function (event, val) {
            vm.excludePinned = !val
            if (vm.excludePinned) {
                vm.pinnedPosts = Post.getCache({ Page: vm.item._id, IsPinned: true }, 300, "-DateCreated")
            } else {
                vm.pinnedPosts = []
            }
        })

        $scope.$on('postPinnedOrUnpinned' + vm.item._id, function () {
            vm.pinnedPosts = Post.getCache({ Page: vm.item._id, IsPinned: true }, 300, "-DateCreated", false)
        })

        vm.room = socket.joinRoom('page' + vm.item._id, vm.item.handleTypingIndicators.bind(vm.item))
        $scope.$on('$destroy', function () {
            vm.room.leaveRoom()

            //remove the chat-settings
            $element.next('.chat-settings').remove()
        })
        vm.sendTyping = vm.item.SendWhosTyping.bind(vm.item)
    }
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "PageProvider", "PostProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider, PageProvider, PostProvider) {
        // add routes
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages',
            title: 'Page Directory',
            subTitle: 'Find a page in the {{org}} private social network.',
            cardClass: "sub-menu-card",
            /* @ngInject */
            onEnter: ["$rootScope", "$state", function($rootScope, $state) {
                //put the reports to name on the page
                if ($rootScope.user.$ReportsTo) {
                    this.navigationData.sections[1].menuItems[5].title = this.navigationData.sections[1].menuItems[5].title.replace('{{ReportsTo}}', $rootScope.user.$ReportsTo.FirstName)
                } else {
                    //remove the reports to card if that's not done already
                    if (this.navigationData.sections[1].menuItems.length == 6)
                        this.navigationData.sections[1].menuItems.pop()
                }
            }],

			sectionSettings: {
				title: null // -- removes the recent items
            },
            
            sections: [
                {
                    title: 'Pages and Events',
                    subTitle: 'Stay current with your organization’s activity.',

                    menuItems: [
                        {
                            title: 'All Pages',
                            subtitle: 'List all pages, discussions boards, and events.',
                            image: '/assets/images/cards/slim/social/pages-multiple.png',
                            sref: 'shell.social.pages.all-pages.list'
                        },
                        {
                            title: 'Events',
                            subtitle: 'List of events & meetings you are hosting or attending.',
                            image: '/assets/images/cards/slim/social/calendar.png',
                            sref: 'shell.social.pages.events.upcoming.list'
                        },
                        {
                            title: 'Discussion Boards',
                            subtitle: 'Find interesting topics and get involved!',
                            image: '/assets/images/cards/slim/social/discussion-boards.png',
                            sref: 'shell.social.pages.discussion-boards.list'
                        },
                        {
                            title: 'Users',
                            subtitle: 'See social updates from other users.',
                            image: '/assets/images/cards/slim/social/user.png',
                            sref: 'shell.social.pages.user-pages.list'
                        },
                        {
                            title: 'Teams',
                            subtitle: 'Discover and interact with public Team pages.',
                            image: '/assets/images/cards/slim/social/pages-my-teams.png',
                            sref: 'shell.social.pages.team-pages.list'
                        },
                        {
                            title: 'Departments and Locations',
                            subtitle: 'Find important updates.',
                            image: '/assets/images/cards/slim/social/location.png',
                            sref: 'shell.social.pages.department-location-pages.list'
                        },
                        {
                            title: 'General',
                            subtitle: 'Show other pages users have created.',
                            image: '/assets/images/cards/slim/social/pages.png',
                            sref: 'shell.social.pages.general.list'
                        }
                    ]
                },

                {
                    title: 'My Pages',
                    subTitle: 'Quickly find pages important to you.',

                    menuItems: [ {
                        title: 'My Page',
                        subtitle: 'Your page at {{org}}.',
                        image: '/assets/images/cards/slim/social/pages-my-teams.png',
                        action: function() {
                            $rootScope.user.getPage().open()
                        }
                    },{
                        title: '{{org}} Page',
                        subtitle: 'Quick link to post on the {{org}} page.',
                        image: '/assets/images/cards/slim/social/pages-boss.png',
                        action: function() {
                            $rootScope.Organization.getPage().open()
                        }
                    },
                    {
                        title: 'My Teams',
                        subtitle: 'Browse and post on your team pages.',
                        image: '/assets/images/cards/slim/social/pages-my-teams.png',
                        sref: 'shell.social.pages.my-pages-dir.my-teams.list'
                    },
                    {
                        title: 'Pages You Administer',
                        subtitle: 'Moderate and manage your pages.',
                        image: '/assets/images/cards/slim/social/pages-my.png',
                        sref: 'shell.social.pages.my-pages-dir.my-pages.list'
                    },
                    {
                        title: 'Pages You Follow',
                        subtitle: 'View all the pages you are currently following.',
                        image: '/assets/images/cards/slim/social/pages-following.png',
                        sref: 'shell.social.pages.my-pages-dir.im-following.list'
                    },
                    {
                        title: 'Pages You Posted On',
                        subtitle: 'Continue the conversation!',
                        image: '/assets/images/cards/slim/social/pages-posted-on.png',
                        sref: 'shell.social.pages.my-pages-dir.posted-on.list'
                    },
                    {
                        title: '{{ReportsTo}}\'s Page',
                        subtitle: 'Quick link to your boss.',
                        image: '/assets/images/cards/slim/social/pages-boss.png',
                        action: function() {
                            $rootScope.$broadcast('openNewItem', $rootScope.user.$ReportsTo.getMyPage())
                        }
                    }
                ]
                }
            ],

            fabButtons: [{
                    title: 'Add Page',
                    icon: 'zmdi zmdi-view-web',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'General' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Add Event',
                    icon: 'zmdi zmdi-edit',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'Event' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Add Discussion Board',
                    icon: 'zmdi zmdi-comments',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'Discussion' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                }
            ],
            fabIcon: 'zmdi zmdi-plus',

        })
    }
})();
(function() {
    myPagesConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
    angular
        .module('app')
        .config(myPagesConfig)

    /* @ngInject */
    function myPagesConfig($stateProvider, LandingRecentGroupingsProvider) {
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.my-pages-dir',
            title: 'My Pages',
            subTitle: 'Quickly find pages important to you.',
            cardClass: 'sub-menu-card',
            /* @ngInject */
            onEnter: ["$rootScope", "$state", function($rootScope, $state) {
                //put the reports to name on the page
                if ($rootScope.user.$ReportsTo) {
                    this.navigationData.menuItems[5].title = this.navigationData.menuItems[5].title.replace('{{ReportsTo}}', $rootScope.user.$ReportsTo.FirstName)
                } else {
                    //remove the reports to card if that's not done already
                    if (this.navigationData.menuItems.length == 6)
                        this.navigationData.menuItems.pop()
                }
            }],
            menuItems: [{
                    title: '{{org}} Page',
                    subtitle: 'Quick link to post on the {{org}} page.',
                    image: '/assets/images/cards/slim/social/pages-boss.png',
                    action: function() {
                        $rootScope.$broadcast('openNewItem', $rootScope.Organization.getPage())
                    }
                },
                {
                    title: 'My Teams',
                    subtitle: 'Browse and post on your team pages.',
                    image: '/assets/images/cards/slim/social/pages-my-teams.png',
                    sref: 'shell.social.pages.my-pages-dir.my-teams.list'
                },
                {
                    title: 'Pages You Administer',
                    subtitle: 'Moderate and manage your pages.',
                    image: '/assets/images/cards/slim/social/pages-my.png',
                    sref: 'shell.social.pages.my-pages-dir.my-pages.list'
                },
                {
                    title: 'Pages You Follow',
                    subtitle: 'View all the pages you are currently following.',
                    image: '/assets/images/cards/slim/social/pages-following.png',
                    sref: 'shell.social.pages.my-pages-dir.im-following.list'
                },
                {
                    title: 'Pages You Posted On',
                    subtitle: 'Continue the conversation!',
                    image: '/assets/images/cards/slim/social/pages-posted-on.png',
                    sref: 'shell.social.pages.my-pages-dir.posted-on.list'
                },
                {
                    title: '{{ReportsTo}}\'s Page',
                    subtitle: 'Quick link to your boss.',
                    image: '/assets/images/cards/slim/social/pages-boss.png',
                    action: function() {
                        $rootScope.$broadcast('openNewItem', $rootScope.user.$ReportsTo.getMyPage())
                    }
                }
            ]
        })
    }
})();
(function() {
    configUserPages.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(configUserPages)

    /* @ngInject */
    function configUserPages($stateProvider) {
        // create route for usernewsfeed
        $stateProvider.state('shell.social.news-feed', {
            views: {
                '@shell': {
                    templateUrl: '/app/social/news-feed/tmpl.html',
                    controller: 'NewsFeedController',
                    controllerAs: 'vm'
                }
            },
            url: '/newsfeed',
            navigationData: {
                breadcrumbTitle: 'News Feed'
            }
        })
    }
})();



(function () {
    'use strict'
NewsFeedController.$inject = ["$scope", "$rootScope", "$filter", "$q", "$timeout", "auUtility", "UserNewsFeed", "windowFab"];
    angular
        .module('app')
        .controller('NewsFeedController', NewsFeedController)

    /* @ngInject */
    function NewsFeedController($scope, $rootScope, $filter, $q, $timeout, auUtility, UserNewsFeed, windowFab) {
        var vm = this;
        vm.showRead = false
        vm.showPinned = false

        //fade in the contents scrolled up
        var el = angular.element('.user-news-feed md-content')
        auUtility.initPageScrolledDown(el)

        windowFab.hideWindowFab()

        //on load, get 300 posts and score them - the user can't see more than 300 posts in their news feed
        var posts

        //return the next 10 as a resolved promise
        var lastPostReturned = 0
        vm.getPosts = function (options) {
            options = options || {}
            var nbrPosts = options.returnCount || 10
            if (!posts) {
                var criteria = {}

                if (vm.showPinned) {
                    criteria.Pinned = true
                } else {
                    criteria.Read = vm.showRead
                }
                posts = UserNewsFeed.getCache(criteria, 300, "-DateCreated", false)
            }

            var nextPosts = posts.slice(lastPostReturned, lastPostReturned + nbrPosts)
            lastPostReturned += nextPosts.length

            return $q.resolve(nextPosts)
        }

        vm.toggleNewsFeed = function () {
            vm.showRead = false
            vm.showPinned = false
            refreshPosts()
        }

        vm.toggleRead = function () {
            vm.showRead = true
            vm.showPinned = false
            refreshPosts()
        }

        vm.togglePinned = function () {
            vm.showPinned = true
            vm.showRead = false
            refreshPosts()
        }

        function refreshPosts() {
            //set the post pointer back to 0
            lastPostReturned = 0
            posts = null

            //reset the scroll position to the default
            el.scrollTop($rootScope.minScrollTop)

            angular.element('.user-news-feed md-content').find('[au-post]').show()

            //tell post-feed to clean it's visiblePosts array and call getPosts
            $scope.$broadcast('refresh-posts')
        }

        $scope.$on('updateConversations', function () {
            //set the post pointer back to 0
            lastPostReturned = 0
            posts = null
        })

        $scope.$on('itemUpdated', function (event, item) {
            if (item.$key != "UserNewsFeed" || item.User != $rootScope.user._id) return

            for (var i = 0; i < posts.length; i++) {
                var post = posts[i]
                if (post._id == item._id) {
                    if ((vm.showPinned && !item.Pinned) ||
                        (vm.showRead && !item.Read) ||
                        ((!vm.showRead && !vm.showPinned) && (item.Read || item.Pinned))) {
                        $rootScope.$broadcast('post-removed-from-feed', post._id)
                        break
                    }
                }
            }
        })
}
})();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "MeetingProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, MeetingProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.social.meetings.upcoming',
				title: 'Upcoming Meetings',
				itemTitle: '{{itemSettings.item.toString()}}',
				itemType: MeetingProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "$rootScope", "Meeting", function (localCacheReady, $rootScope, Meeting) {
					var today = new Date()
					today.setHours(0, 0, 0, 0)
					return Meeting.query({
						'StartDate__gte': today,
						'$or': [
							{
								'Creator': $rootScope.user._id 
							},
							{
								'Attendees': {
									$elemMatch: {
										User: $rootScope.user._id
									}
								}
							}
						]
					}).$httpPromise
				}],
				initialSortBy: 'StartDate',
				initialView: 'list'
			})
    }
})();
(function() {
		moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "MeetingProvider"];
	angular
		.module('app')
		.config(moduleConfig)

		/* @ngInject */
		function moduleConfig($stateProvider, SingleItemViewerProvider, MeetingProvider) {
			SingleItemViewerProvider.createRouteFor($stateProvider, {
				itemType: MeetingProvider,
				itemSection: 'social',
				detailTemplateUrl: '/app/meetings/detail.tmpl.html',
				controller: 'MeetingController'
			})
		}
})();
//#4 - THE ROUTE - Present a list of resources as a URL
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "MeetingProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, MeetingProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.meetings.past',
			title: 'Past Meetings',
			itemTitle: '{{itemSettings.item.Title}}',
			itemType: MeetingProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Meeting", function (localCacheReady, Meeting) {
				var today = new Date()
				today.setHours(0, 0, 0, 0)
				return Meeting.query({
					'StartDate__lt': today,
					'$or': [
						{
							'Creator': $rootScope.user._id 
						},
						{
							'Attendees': {
								$elemMatch: {
									User: $rootScope.user._id
								}
							}
						}
					]
				}).$httpPromise
			}],
			initialSortBy: 'StartDate',
			initialView: 'list',
			showGroupHeaders: true,
		})
	}

})();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "MeetingProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, MeetingProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.social.meetings.drafts',
				title: 'Meeting Drafts',
				itemTitle: '{{itemSettings.item.toString()}}',
				itemType: MeetingProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "$rootScope", "Meeting", function (localCacheReady, $rootScope, Meeting) {
					return Meeting.query({
						'StartDate__exists': false,
						'Creator': $rootScope.user._id
					}).$httpPromise
				}],
				initialSortBy: 'Title',
				initialView: 'list'
			})
    }
})();
(function () {
	'use strict';

	MeetingController.$inject = ["$scope", "$rootScope", "$timeout", "$q", "toast", "$filter", "ItemViewer", "itemSettings", "auUtility", "Meeting", "MeetingFeedbackReason", "User", "usStates", "Post", "Schema", "windowFab"];
	angular
		.module('app')
		.controller('MeetingController', MeetingController);

	/* @ngInject */
	function MeetingController($scope, $rootScope, $timeout, $q, toast, $filter, ItemViewer, itemSettings, auUtility, Meeting, MeetingFeedbackReason, User, usStates, Post, Schema, windowFab) {
		var vm = this;
		vm.resizeStoryDoc = 0

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
		vm.item = itemSettings.item

		//expose a masterMeeting to the view
		if (vm.item.LinkedToRecurring) {
			vm.masterMeeting = Meeting.getCache({ _id: vm.item.LinkedToRecurring })[0]
		} else vm.masterMeeting = angular.copy(vm.item)
		$scope.$on('itemUpdated', function(event,item){
				if (item._id == vm.masterMeeting._id && item.$key == 'Meeting') {
					auUtility.processItemUpdate(item, vm.masterMeeting)
				} 
		})

		//allow users to enter their own location or select from an existing one
		vm.searchLocations = function (searchText) {
			return auUtility.searchLocations(searchText).then(function (serverLocations) {
				serverLocations.push({ Name: searchText }, { Name: 'My Desk' }, { Name: 'Align Us Video Call' }, { Name: 'Conference Room' })
				var names = serverLocations.map(function (l) {
					return l.Name
				})
				return names
			})
		}

		vm.requestUpdate = function () {
			$mdDialog.show({
				controller: 'RequestUpdateController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: '/app/project/dialogs/request-update.tmpl.html',
				locals: {
					options: { item: vm.item }
				}
			})
		}

		if (Object.byString(vm.item, "RepeatsEvery.IntervalType")) {
			vm.showRepeatSettings = true
		} else {
			vm.showRepeatSettings = false
		}

		vm.onRepeatingChange = function () {
			if (vm.showRepeatSettings) {
				initRepeat(vm.item)
			} else {
				//clear item value
				vm.item.RepeatsEvery = null
			}
		}

		function initRepeat(item) {
			item.RepeatsEvery = {}
			item.RepeatsEvery.IntervalType = 'weekly'
			item.RepeatsEvery.Interval = 1
			item.RepeatsEvery.RepeatDays = { Wednesday: true }
			item.RepeatsEvery.DayOfMonth = 1
			item.RepeatsEvery.TimeOfDay = new Date("1998-08-01T10:00:00.000")
			item.RepeatsEvery.StartDate = new Date()
		}


		vm.selected = []
		vm.customReasons = []
		vm.states = usStates

		init()

		function init() {
			// initialize new attendee state
			resetNewAttendeeState()
			// initialize the feedback section content
			initalizeFeedbackSection()
		}

		function initalizeFeedbackSection() {
			vm.showVotingFormContent = true
			vm.customReason = new MeetingFeedbackReason({ Score: 0 })
			initializeFeedbackData()
		}

		function initializeFeedbackData() {
			MeetingFeedbackReason.getCache().$httpPromise.then(function (reasons) {
				var defaultReasons = $filter('filter')(reasons, { IsDefault: true })
				vm.feedback = {
					Votes: defaultReasons.map(function (reason) {
						return { Reason: reason._id, GoodText: reason.GoodText, BadText: reason.BadText }
					})
				}
				auUtility.populateSubObjects(vm.item.ReportData.BarChartData, MeetingFeedbackReason.getCache(), '_id', '_id')
				vm.item.ReportData.UserChartData.forEach(function (user, index) {
					auUtility.populateSubObjects(vm.item.ReportData.UserChartData[index].reasonStats, MeetingFeedbackReason.getCache(), 'reason', '_id')
					// populate the user who submitted report, but skip the anonymous users (_id == null)
					if (vm.item.ReportData.UserChartData[index]._id != null) {
						auUtility.populateSubObjects(vm.item.ReportData.UserChartData, User.getCache(), '_id', '_id')
					}
				})
				initializeChartData()
			})
		}

		function initializeChartData() {
			vm.badChartData = [[]] // ain't life great?
			vm.goodChartData = [[]]
			vm.badChartLabels = []
			vm.goodChartLabels = []
			vm.item.ReportData.BarChartData.forEach(function (reason) {
				if (reason.sumPos > reason.sumNeg) {
					vm.goodChartLabels.push(reason.$_id.GoodText)
					vm.goodChartData[0].push(reason.sumPos)
				} else {
					vm.badChartLabels.push(reason.$_id.BadText)
					vm.badChartData[0].push(reason.sumNeg)
				}
			})
		}

		// clears the state of the "New Attendee" and related fields
		// (called to reset the UI once the user has clicked "add")
		function resetNewAttendeeState() {
			vm.newAttendee = { IsRequired: false, IsFacilitator: false, IsPresent: false }
			vm.attendeeSearchText = ''
		}
		vm.resetNewAttendeeState = resetNewAttendeeState

		// saves a single custom reason and resolves
		// that reason as a cached resource back to the caller
		function saveCustomReason(reasonToSave) {
			if (reasonToSave.GoodText || reasonToSave.BadText) {
				return $q(function (resolve, reject) {
					var reason = reasonToSave
					reason.$saveItem()
						.then(function (reason) {
							resolve(reason)
						}).catch(function () {
							// handles case where MeetingFeedbackReason with that text
							// already exists
							MeetingFeedbackReason
								.query(reason)
								.$httpPromise
								.then(function (reasons) {
									reason = reasons[0]
									resolve(reason)
								})
						})
				})
			} else {
				return $q.resolve(true)
			}
		}

		// saves all custom reasons
		function prepareCustomReasons() {
			var reasonData = vm.customReasons.map(function (customReason) {
				return {
					// the Score field on the custom reason placeholder will
					// get destroyed by the server after we create the item
					// since it isn't a valid field on MeetingFeedbackReason
					savedScore: customReason.Score,
					promise: saveCustomReason(customReason)
				}
			})
			reasonData.allPromises = reasonData.map(function (datum) {
				return datum.promise
			})
			return reasonData
		}

		// don't add another custom reason to the UI if they haven't typed anything into
		// the last custom reason they tried to make
		function shouldAddCustomReason() {
			if (!vm.customReasons.last()) return true;
			return (vm.customReasons.last().GoodText || vm.customReasons.last().BadText)
		}

		vm.voteTextClicked = function ($event, vote, clickedScore) {
			vote.Score = clickedScore
		}

		vm.submitFeedback = function () {
			// submit all custom reasons
			var customReasonData = prepareCustomReasons()
			$q.all(customReasonData.allPromises)
				.then(function (reasons) {
					// add each newly saved custom reason to the Votes array
					reasons.forEach(function (reason, index) {
						if (reason._id) {
							reason.Score = customReasonData[index].savedScore
							reason.Reason = reason._id
							vm.feedback.Votes.push(reason)
						}
					})
					// send feedback
					return vm.item.GiveFeedback(vm.feedback)
				})
				.then(function () {
					// show feedback data after their feedback has been submitted
					vm.toggleFeedbackContent()
					initializeFeedbackData()
				})
		}

		// toggles back and forth between the feedback stat content
		// and the voting content
		vm.toggleFeedbackContent = function () {
			vm.showVotingFormContent = !vm.showVotingFormContent
		}

		vm.addAttendee = function (attendee) {
			if (attendee.User && attendee.User.$addNew) return

			// if they didn't select an actual user item, just make whatever
			// they typed in the User. allows "guests" who don't actually exist
			// in the org to be added to meetings
			if (!attendee.User) {
				attendee.WriteInUser = vm.attendeeSearchText
				delete attendee.User //the server doesn't like null
			}

			// windowFab.fadeOut(false)
			// windowFab.setFlipped(false)

			// hit the server and add the attendee
			vm.masterMeeting.AddAttendee(attendee)
			// .$promise.then(function () {
			// 	// show an update occurred since we prevent auto-save-form from doing the work (due to $masterMeeting pattern)
			// 	windowFab.setFlipped(true)
			// })

			// clear the fields
			resetNewAttendeeState()
		}

		vm.saveMasterMeeting = function(){
			vm.masterMeeting.$updateItem()
		}

		vm.newAttendeeChanged = function (item) {
			if (!item || !item.$addNew) return

			//clear out the search
			vm.attendeeSearchText = ""

			//show the correct add item dialog and then add attendee
			auUtility.addNewItem(item.$addNew).then(function (newItem) {
				vm.addAttendee({ User: newItem._id })
			})
		}

		// vm.removeAttendee = function (attendee) {
		// 	vm.item.$masterMeeting.RemoveAttendee(attendee)

		// 	windowFab.fadeOut(false)
		// 	windowFab.setFlipped(true)
		// }

		// per our current business rules, facilitators are always required
		// when someone checks "facilitator" on a checkbox, set that user as required too
		vm.alwaysRequireFacilitator = function (attendee) {
			if (attendee.IsFacilitator) {
				attendee.IsRequired = true
			}
		}

		// when this item is updated, just refresh the feedback data
		// (possible since the feedback data is inside the item itself)
		$scope.$on('itemUpdated', function (event, item) {
			if (item._id == vm.item._id && item.$key == vm.item.$key) {
				initializeFeedbackData()
			}
		})

		vm.addNewReason = function (wasGood) {
			if (!shouldAddCustomReason()) return;
			// we need to assign an HTML id to this reason so that we can focus it
			var htmlId = 'customReason' + vm.customReasons.length
			// create a new MeetingFeedbackReason
			var newCustomReason = new MeetingFeedbackReason({ Score: wasGood ? 1 : -1, htmlId: htmlId })
			// push it into the array of custom reasons.
			// since the UI repeats over this array, this will create a new "custom" feedback
			// field in the UI
			vm.customReasons.push(newCustomReason)
			// wait a bit, then focus the new reason in the UI
			setTimeout(function () {
				angular.element(wasGood ? ('#' + htmlId + 'Good') : ('#' + htmlId + 'Bad')).focus()
			}, 35)
		}

		// direct copy/paste from TMS; controls arrow which shows more reasons
		vm.showMoreReasons = function () {
			angular.element(".hide-excess-reasons").css("max-height", "600px")
			setTimeout(function () {
				angular.element(".hide-excess-reasons").css("max-height", "1000000px")
			}, 1000)
			angular.element(".show-more-reasons").hide()
		}

		vm.createVideoCall = function () {
			$rootScope.$broadcast('accept-video-chat', { userIds: vm.item.GetAllAttendees(true) })
			// alert GA
			window.ga('send', {
				hitType: 'event',
				eventCategory: 'VideoCalling',
				eventAction: 'VideoInviteSent',
				eventLabel: 'FromUiElementMeetingAttendees'
			})
		}

		vm.inviteUsers = function () {
			//create post in the embedded discussion board
			var userString = ""
			var attendees = vm.item.Attendees.filter(function (attendee) {
				return !!attendee.User
			}).map(function (attendee) {
				return User.getCache({_id: attendee.User})[0]
			})
			attendees.forEach(function (attendee, idx) {
				if (userString.length > 0) {
					if (idx == attendees.length - 1) {
						userString += " and "
					} else userString += ", "
				}
				userString += attendee.toString()
			})

			new Post({
				Type: 'Update',
				Data: {
					Update: ("<p>{3} are invited to the meeting <span contenteditable=\"false\" class=\"doc-mention Meeting\" data-item-type=\"Meeting\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"Meeting: {1}\">{1}</span>" + (vm.item.StartDate ? " on {2}" : "") + ". See you there!</p>").format(vm.item._id, vm.item.Title, "{{$root.moment('" + vm.item.StartDate + "').tz($root.user.Settings.Timezone).format('ddd MMM Do YYYY, h:mm A')}}", userString),
					PopOpenChat: true,
					MeetingInvite: true
				},
				Page: vm.item._id,
				PageType: 'Meeting',
				PageIsEmbedded: true
			}).$saveItem()

			if ($rootScope.singleItemViewer) {
				toast.success('User invitations sent')
			}
		}

		vm.openTopicItem = function () {
			Schema.resource(vm.item.TopicItemType).getCache({ _id: vm.item.TopicItemId })[0].open()
		}

		vm.editTopicItem = function () {
			$mdDialog.show({
				controller: 'EditTopicItemController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: '/app/social/dialogs/edit-topic-item.tmpl.html',
				locals: {
					options: { meetings: [vm.item] }
				}
			})
		}
	}
})();
(function() {
    'use strict';
    
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider) {
        // add routes
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {	
            name: 'shell.social.meetings', 
            title: 'Meetings',
			subTitle: 'Digitize meetings at {{org}}. Share agendas and related documents and encourage feedback to help perfect your meetings.',
			cardClass: "sub-menu-card",

			sectionSettings: {
				title: null // -- removes the recent items
			},
           
			fabButtons: [
				{
					title: 'Add Meeting',
					icon: 'au au-meeting',
					action: function ($event) {
						$mdDialog.show({
								controller: 'AddMeetingDialog',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
								targetEvent: $event,
								locals: {
									options: null
								}
						})
					},
					permissionNeeded: '$root.user.EffPerms.Meetings.CanCreate'
				}
			],
			fabIcon: 'zmdi zmdi-plus',

			/* @ngInject */
			onEnter: ["$rootScope", "$state", function($rootScope, $state) {
				//reset the scroll top
				$rootScope.landingRecentGroupingsScrollTop = 150
			}],


			menuItems: [
				{
					title: 'New Meeting',
					subtitle: 'Hosting a meeting? Start here!',
					image: '/assets/images/cards/slim/social/event-new.png',
					action: function ($event) {
						$mdDialog.show({
								controller: 'AddMeetingDialog',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
								targetEvent: $event,
								locals: {
									options: null
								}
						})
					},
					permissionNeeded: '$root.user.EffPerms.Meetings.CanCreate'
				},
				{
					title: 'Upcoming Meetings',
					subtitle: 'Meetings you are hosting or attending.',
					image: '/assets/images/cards/slim/social/meetings.png',
					sref: 'shell.social.meetings.upcoming.list'
				},
				{
					title: 'Past Meetings',
					subtitle: 'View all meetings you have hosted or attended in the past.',
					image: '/assets/images/cards/slim/social/meetings-past.png',
					sref: 'shell.social.meetings.past.list'
				},
				{
					title: 'Meeting Drafts',
					subtitle: 'Unscheduled meetings that have no start date or time.',
					image: '/assets/images/cards/slim/social/meetings-drafts.png',
					sref: 'shell.social.meetings.drafts.list'
				},
				{
					title: 'Reports',
					subtitle: 'View reports about meetings.',
					image: '/assets/images/cards/slim/social/meetings-reports.png',
					sref: 'shell.social.meetings.reports'
				}
			]
        })
		
	}
})();
(function () {
	universalShareController.$inject = ["$scope", "$sce", "$mdDialog", "$q", "oneSearch", "auUtility", "options", "Post", "toast", "Schema", "Page"];
	angular
		.module('app')
		.controller('UniversalShareController', universalShareController)

	/* @ngInject */
	function universalShareController($scope, $sce, $mdDialog, $q, oneSearch, auUtility, options, Post, toast, Schema, Page) {
		var vm = this

		vm.cancel = $mdDialog.hide
		vm.shareOnPages = []
		vm.shareIntro = ''

		if (options.itemToShare) {
			vm.itemToShare = options.itemToShare
		}

		//get the item title - there is always only 1 item in vm.itemToShare
		if (vm.itemToShare[0].$key == 'Post') {
			vm.sharedItemTitle = vm.itemToShare[0].Data.Update || vm.itemToShare[0].Data.Introduction || vm.itemToShare[0].Data.Poll.Question
		} else {
			vm.sharedItemTitle = vm.itemToShare[0].Title
		}

		vm.finish = function () {
			//find out if this is a page or a post
			if (vm.itemToShare[0].$key == 'Page'){
				//create the post content
				var postContent = '<p>I am sharing the Page <span contenteditable=\"false\" class=\"doc-mention Page\" data-item-type=\"Page\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"Page: {1}\">{1}</span>&nbsp;with you. Check it out!</p>'.format(vm.itemToShare[0]._id, vm.sharedItemTitle)
				if (vm.shareIntro) postContent += vm.shareIntro

				//create a conversation page
				new Page({
					Type: 'Conversation',
					Title: 'Share: ' + vm.sharedItemTitle,
					IsPrivate: true,
					Members: vm.shareOnPages,
					IsEmbedded: false
				}).$saveItem().then(function(savedPage){

					//create a post in the convo tagging the sharedItem
					new Post({
						Type: 'Update',
						Data: {
							Update: postContent,
							PopOpenChat: true
						},
						Page: savedPage._id,
						PageType: savedPage.Type,
						PageIsEmbedded: savedPage.IsEmbedded
					}).$saveItem()
				}).finally(function () {
					$mdDialog.hide()
				})
			}

			if (vm.itemToShare[0].$key == 'Post') {
				// for every page they chose to share on, make a post
				return $q.all(vm.shareOnPages.map(function (pageId) {
					return new Post({
						Page: pageId,
						Type: 'Share',
						Data: {
							Introduction: vm.shareIntro,
							Share: {
								SharedItems: formatSharedItems()
							}
						}
					}).$saveItem()
				})).then(function () {
					toast.success('You shared ' + vm.itemToShare[0].toString() + ' with ' + vm.shareOnPages.length + ' users!')
				}).catch(function (err) {
					console.log(err)
					toast.error('Could not create one or more share posts')
				}).finally(function () {
					$mdDialog.hide()
				})
			}

		}

		// convert entire cached resource items into Type:Id pairings
		function formatSharedItems() {
			return vm.itemToShare.map(function(item) {
				return {
					Type: item.$key,
					Id: item._id
				}
			})
		}

	}
})();
(function() {
		SelectUserController.$inject = ["$scope", "auUtility", "$mdDialog", "toast", "options"];
	angular
		.module('app')
		.controller('SelectUserController', SelectUserController)

		/* @ngInject */
		function SelectUserController($scope, auUtility, $mdDialog, toast, options) {
			var vm = this
			
			vm.cancel = $mdDialog.cancel
			vm.selectedUsers = []
			vm.options = options || {}
			if(!(vm.options.disallowIds instanceof Array)) {
				vm.options.disallowIds = []
			}

			vm.searchUsers = function(options) {
				return auUtility.searchUsers(options).then(function(users) {
					return users.filter(function(user) {
						return vm.options.disallowIds.indexOf(user._id) == -1
					})
				})
			}

			if(!vm.options.title) {
				vm.options.title = 'Select User(s)'
			}

			vm.finish = function () {
				if (vm.selectedUsers.length == 0) {
					toast.error('No user selected')
					return
				}

				$mdDialog.hide(vm.selectedUsers)
			}
		}
})();
(function () {
	SelectProfilePhotoController.$inject = ["$scope", "auUtility", "$mdDialog", "toast", "$http", "$timeout", "s3Url", "s3Service", "type", "key"];
	angular
		.module('app')
		.controller('SelectProfilePhotoController', SelectProfilePhotoController)

	/* @ngInject */
	function SelectProfilePhotoController($scope, auUtility, $mdDialog, toast, $http, $timeout, s3Url, s3Service, type, key) {
		var vm = this
		vm.cancel = $mdDialog.cancel
		vm.selected = "NONE"

		switch (type) {
			case "Organization":
				vm.searchResults = ['org/organization.png', 'org/organization1.png', 'org/organization2.png', 'org/storefront.png', 'org/school.png', 'org/government.png', 'org/church.png']
				break;
			case "User":
				vm.searchResults = ['avatars-01.png', 'avatars-02.png', 'avatars-03.png', 'avatars-04.png', 'avatars-05.png', 'avatars-06.png', 'avatars-07.png', 'avatars-08.png', 'avatars-09.png', 'avatars-10.png', 'avatars-11.png', 'avatars-12.png', 'avatars-13.png', 'avatars-14.png', 'avatars-15.png', 'avatars-16.png', 'avatars-17.png', 'avatars-18.png', 'avatars-19.png']
				break;
			case "Project":
				vm.searchResults = ['project/urgent.png', 'project/progress.png', 'project/favorite.png', 'project/check.png', 'project/neutral.png']
				break;
			case "Task":
				vm.searchResults = ['task/urgent.png', 'task/progress.png', 'task/favorite.png', 'task/check.png', 'task/neutral.png']
				break;
			case "Document":
				vm.searchResults = ['document/urgent.png', 'document/progress.png', 'document/favorite.png', 'document/check.png', 'document/neutral.png', 'document/purple.png']
				break;
			case "Page":
				vm.searchResults = ['page/discussion.png', 'page/event.png', 'page/user.png', 'page/location.png', 'page/general.png']
				break;
			case "Meeting":
				vm.searchResults = ['meeting/teal.png', 'meeting/blue.png', 'meeting/purple.png', 'meeting/red.png', 'meeting/green.png', 'meeting/orange.png', 'meeting/pink.png']
				break;
			case "Department":
				vm.searchResults = ['department/support.png', 'department/legal.png', 'department/design.png', 'department/development.png', 'department/management.png', 'department/mouse.png', 'department/hr.png', 'department/piechart.png', 'department/lightbulb.png', 'department/video.png', 'department/glasses.png', 'department/security.png']
				break;
			case "Team":
				vm.searchResults = ['team/blue.png', 'team/red.png', 'team/green.png', 'team/three.png', 'team/trophy.png', 'team/two.png', 'team/arm-lock.png', 'team/hands.png', 'team/puzzle.png']
				break;
			case "Location":
				vm.searchResults = ['location/teal.png', 'location/blue.png', 'location/purple.png', 'location/red.png', 'location/green.png', 'location/orange.png', 'location/pink.png']
				break;
			case "Handbook":
			case "HandbookEntry":
				vm.searchResults = ['handbook/teal.png', 'handbook/blue.png', 'handbook/purple.png', 'handbook/red.png', 'handbook/green.png', 'handbook/orange.png', 'handbook/pink.png']
				break;
			case "Philosophy":
				vm.searchResults = ['avatars-01.png']
				break;
			case "Fundraiser":
				vm.searchResults = ['fundraise/fundraise.png', 'fundraise/piggybank.png', 'fundraise/house.png', 'fundraise/ribbon.png', 'fundraise/blood.png', 'fundraise/plant.png', 'fundraise/pricetag.png', 'fundraise/prize.png', 'fundraise/chart.png', 'fundraise/linechart.png', 'fundraise/clothes.png', 'fundraise/heart.png', ]
				break;
			case "Question":
				vm.searchResults = ['question/teal.png', 'question/blue.png', 'question/purple.png', 'question/red.png', 'question/green.png', 'question/orange.png', 'question/pink.png']
				break;
			case "Strategy":
			case "Initiative":
				vm.searchResults = ['strategy/chess-pawn.png', 'strategy/chess-queen.png', 'strategy/chess-knight.png', 'strategy/target.png', 'strategy/dashboard.png', 'strategy/playbook.png', 'strategy/document-chart.png', 'strategy/piechart.png', 'strategy/lightbulb.png', 'strategy/document-trend.png', 'strategy/easel-chart.png', 'strategy/bar-chart.png', ]
				break;
			default:
				vm.searchResults = ['avatars-01.png', 'avatars-02.png', 'avatars-03.png', 'avatars-04.png', 'avatars-05.png', 'avatars-06.png', 'avatars-07.png', 'avatars-08.png', 'avatars-09.png', 'avatars-10.png', 'avatars-11.png', 'avatars-12.png', 'avatars-13.png', 'avatars-14.png', 'avatars-15.png', 'avatars-16.png', 'avatars-17.png', 'avatars-18.png', 'avatars-19.png','strategy/chess-pawn.png', 'strategy/chess-queen.png', 'strategy/chess-knight.png', 'strategy/target.png', 'strategy/dashboard.png', 'strategy/playbook.png', 'strategy/document-chart.png', 'strategy/piechart.png', 'strategy/lightbulb.png', 'strategy/document-trend.png', 'strategy/easel-chart.png', 'strategy/bar-chart.png','fundraise/fundraise.png', 'fundraise/piggybank.png', 'fundraise/house.png', 'fundraise/ribbon.png', 'fundraise/blood.png', 'fundraise/plant.png', 'fundraise/pricetag.png', 'fundraise/prize.png', 'fundraise/chart.png', 'fundraise/linechart.png', 'fundraise/clothes.png', 'fundraise/heart.png','department/support.png', 'department/legal.png', 'department/design.png', 'department/development.png', 'department/management.png', 'department/mouse.png', 'department/hr.png', 'department/piechart.png', 'department/lightbulb.png', 'department/video.png', 'department/glasses.png', 'department/security.png']
		}


		vm.searchResults = vm.searchResults.map(function (i) {
			return s3Url + 'cover/' + i
		})

		vm.finish = function () {
			if (vm.selected == "NONE") {
				toast.error('Nothing selected')
				return
			}

			//convert data uri to a file object
			var profile = dataURItoBlob(vm.myCroppedImage)
			profile.name = "ProfileImage.png"

			//upload the file to s3
			s3Service.uploadSignedFiles([profile], key, true)
				.then(function (data) {
					//and return url
					$mdDialog.hide(data[0].key)

				}).catch(function (error) {
					console.error('Error in select-profile-photo: 31', error)
				})
		}

		function dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			var byteString;
			if (dataURI.split(',')[0].indexOf('base64') >= 0)
				byteString = atob(dataURI.split(',')[1]);
			else
				byteString = unescape(dataURI.split(',')[1]);

			// separate out the mime component
			var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			var ia = new Uint8Array(byteString.length);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ia], { type: mimeString });
		}

		vm.imgLoadError = function (err) {
			toast.toast('Sorry! Looks like that image is copy protected.')
		}

		vm.search = function (q) {
			vm.start = 1
			vm.searchResults = []
			vm.showSearchResults = true

			vm.loadMore()
		}

		vm.loadMore = function (q) {
			$http.get('https://www.googleapis.com/customsearch/v1?cx=010887965073516089724%3Arcmfzpq4vvc&searchType=image&imgSize=medium&imgType=face&key=AIzaSyDo3w7bEmvR4y3CnDijlBgrWMxVi7N_v3E&safe=high&start=' + vm.start + '&q=' + encodeURIComponent(vm.searchText))
				.then(function (res) {
					vm.searchResults = vm.searchResults.concat(res.data.items.map(function (i) {
						return i.link
					}))
					vm.start += 10
				})
		}

		vm.select = function (url) {
			vm.selected = url
			vm.myImage = '/api/imageProxy?url=' + url + "&r=" + Math.random()
			vm.showSearchResults = false
		}

		vm.myImage = ''
		vm.myCroppedImage = ''

		var handleFileSelect = function (evt) {
			var file = evt.target.files[0];
			var reader = new FileReader();
			reader.onload = function (evt) {
				$scope.$apply(function ($scope) {
					vm.showSearchResults = false
					vm.myImage = evt.target.result;
					vm.selected = "upload"
				});
			};
			reader.readAsDataURL(file);
		};

		poll(function () {//when
			return angular.element(document.querySelector('.select-profile-dialog #fileInput')).length == 1
		}, function () {// then
			angular.element(document.querySelector('.select-profile-dialog #fileInput')).on('change', handleFileSelect);
		}, angular.noop, 3000, 100)

		vm.showSearchResults = true
		vm.selectedImg = false

	}
})();
(function() {
		SelectCoverPhotoController.$inject = ["$scope", "auUtility", "$mdDialog", "toast", "$http", "s3Url"];
	angular
		.module('app')
		.controller('SelectCoverPhotoController', SelectCoverPhotoController)

		/* @ngInject */
		function SelectCoverPhotoController($scope, auUtility, $mdDialog, toast, $http, s3Url) {
			var vm = this
			vm.cancel = $mdDialog.cancel
			vm.selected = "NONE"
			vm.searchResults = ['code.png', 'spring-flower-1.png', 'spring-flower-2.png', 'charts.png', 'project.png', 'meeting.png', 'documents.png', 'speech.png', 'task.png', 'fireworks.png', 'align.jpg', 'design.jpg', 'note.jpg', 'silhouettes.jpg', 'align-desk.png', 'align-tools.png']
			vm.searchResults = vm.searchResults.map(function (i) {
				return s3Url + 'cover/' + i
			})

			vm.finish = function () {
				if (vm.selected == "NONE") {
					toast.error('Nothing selected')
					return
				}

				$mdDialog.hide(vm.selected)
			}

			vm.search = function (q) {
				vm.start = 1
				vm.searchResults = []
				vm.loadMore()
			}

			vm.loadMore = function (q) {
				$http.get('https://www.googleapis.com/customsearch/v1?cx=010887965073516089724%3Arcmfzpq4vvc&searchType=image&imgSize=large&key=AIzaSyDo3w7bEmvR4y3CnDijlBgrWMxVi7N_v3E&safe=high&start=' + vm.start + '&q=' + encodeURIComponent(vm.searchText) )
				.then(function (res) {
					vm.searchResults = vm.searchResults.concat(res.data.items.map(function (i) {
						return i.link
					}))
					vm.start += 10
				})
			}

			vm.select = function (url) {
				vm.selected = url
			}

			vm.onDocumentsSelected = function () {
				vm.uploading = true
			}

			vm.onDocumentsUploaded = function (keys) {
				$mdDialog.hide({newUpload: keys[0].key})
			}			
			
			vm.onUploadFail = function () {
				toast.error('An error occuring uploading. Please try again.')
			}
		}
})();
(function () {
    'use strict';

    PageWizardDialog.$inject = ["$scope", "options", "Page", "Post", "$rootScope", "auUtility", "$window", "$mdDialog", "$state", "$filter", "$timeout", "usStates", "ItemViewer", "Schema"];
    angular
        .module('app')
        .controller('PageWizardDialog', PageWizardDialog);

    /* @ngInject */
    function PageWizardDialog($scope, options, Page, Post, $rootScope, auUtility, $window, $mdDialog, $state, $filter, $timeout, usStates, ItemViewer, Schema) {
        var vm = this;
        vm.pageWasNew = true
        vm.states = usStates
        vm.shareText = ""
        vm.invitedUsers = []

        // expose searchUsers to the view; needed for populating autocomplete fields with users
        if (options.page) {
            vm.page = options.page
            vm.pageWasNew = false
            setTimeout(function () {
                var btnRemovePage = angular.element('#BtnRemovePage').detach()
                var actions = angular.element('md-dialog-actions')
                actions.prepend(angular.element('<span class="flex"></span>'))
                actions.prepend(btnRemovePage)
            }, 100)
        }

        if (options.pageType) vm.pageType = options.pageType
        if (!vm.page && !vm.pageType) return;
        if (!vm.page) createPage()

        vm.newItem = vm.pageWasNew ? vm.page : undefined

        if (vm.page.Type == 'Event') {
            if (!vm.page.Event) vm.page.Event = {}
            if (!vm.pageWasNew) {
                vm.page.Event.Start = new Date(vm.page.Event.Start)
                vm.page.Event.End = new Date(vm.page.Event.End)
            }

            // if they set the event's start date, automatically prefill the end date
            $scope.$watch('vm.page.Event.Start', function (newStartDate, oldStartDate) {
                if (newStartDate && !vm.page.Event.End) {
                    vm.page.Event.End = new Date(newStartDate)
                }
            })
        }

        function createPage() {
            vm.page = new Page()
            vm.page.Type = vm.pageType
            vm.page.Editors = []
            vm.page.Members = []
            vm.page.SideBarWidgets = []
            vm.page.SideBarWidgets.push({
                Type: 'au-page-about',
                Data: {
                    contactEmail: $rootScope.user.Email,
                    contactUser: $rootScope.user._id
                }
            })
            $timeout(function () {
                vm.wizardSteps.getStep('page-profile-photo').visible = false
                if (vm.page.Type != 'Event') {
                    vm.wizardSteps.getStep('page-event-details-3').visible = false
                    if (vm.page.Type != 'Discussion') {
                        vm.wizardSteps.getStep('page-members-and-viewers').visible = false
                    }
                }
            }, 500)

        }

        vm.getPageTypeText = function () {
            var returnVal = ""

            //reduce "Department, Location, etc." to 'Page'
            switch (vm.page.Type) {
                case "Event":
                    returnVal += "Event"
                    break;
                case "Discussion":
                    returnVal += "Discussion Board"
                    break;
                case "Conversation":
                    returnVal += "Conversation"
                    break;
                default:
                    returnVal += "Page"

            }
            return returnVal
        }

        //confirm the Page Title is entered before allowing the user to move on
        vm.confirmTitleEntered = function () {
            return vm.page.Title
        }

        //auto-complete chip entry
        vm.transformEditorsChip = function (user) {
            if (vm.page.Editors.indexOf(user._id) > -1) return null
            return user._id
        }

        vm.transformMembersChip = function (user) {
            if (vm.page.Members.indexOf(user._id) > -1) return null
            return user._id
        }

        vm.transformViewersChip = function (user) {
            if (vm.page.Viewers.indexOf(user._id) > -1) return null
            return user._id
        }

        vm.determineEventStepVisible = function () {
            if (vm.page.Type != 'Event') {
                vm.wizardSteps.getStep('page-event-details').visible = false
                vm.wizardSteps.getStep('page-event-details-2').visible = false
                vm.wizardSteps.getStep('page-event-details-3').visible = false
            }
            // have to do this to appease the directive since this is being called from an on-next-step attribute
            return true
        }

        vm.determinePublicLinkVisible = function () {
            vm.wizardSteps.getStep('public-link').visible = !vm.page.IsPrivate

            return true
        }

        vm.adjustForConversation = function () {
            if (vm.page.Type == 'Conversation') {
                vm.wizardSteps.getStep('page-profile-photo').visible = false
                vm.wizardSteps.getStep('page-event-details-3').visible = false
            }
            // have to do this to appease the directive since this is being called from an on-next-step attribute
            return true
        }

        vm.finish = function () {
            if (vm.page.Photo && vm.page.Photo.Key) {
                vm.page.Photo = vm.page.Photo.Key
            }
            // we need the page's ID to share it, so we need to save/update first
            // THEN call inviteUsers
            return updateOrAdd()
                .then(function () {
                    // if they invite users to the Event
                    if (vm.invitedUsers && vm.invitedUsers != 0) {
                        // ...fire and forget the group message and invitation post creation
                        inviteUsers()
                    }
                    var text
                    if (vm.pageWasNew) {
                        if (vm.page.Type == 'Discussion') {
                            text = 'The {0} Discussion Board is ready to go! Click Open Item below to make your first post.'
                        } else if (vm.page.Type == 'Event') {
                            text = 'The event page for {0} is all set! Click Open Item below to start sprucing it up!'
                        } else {
                            text = 'Everyone is excited to see how the {0} page shapes up! Click Open Item below to start making it your own!'
                        }
                    } else {
                        text = 'The edits to {0} have been applied.'
                    }

                    text = text.format(vm.page.Title)
                    return text
                })
        }

        //Only at the end of an Event page wizard
        function inviteUsers() {
            //create the post content
            var postContent = '<p>You are invited to <span contenteditable=\"false\" class=\"doc-mention Page\" data-item-type=\"Page\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"Page: {1}\">{1}</span> Please RSVP to let me know if you will be there!</p>'.format(vm.page._id, vm.page.Title)
            if (vm.shareText) postContent += vm.shareText

            //create a conversation page
            new Page({
                Type: 'Conversation',
                Title: vm.page.Title,
                IsPrivate: true,
                Members: vm.invitedUsers,
                IsEmbedded: false
            }).$saveItem().then(function (savedPage) {

                //create a post in the convo tagging the Event page
                new Post({
                    Type: 'Update',
                    Data: {
                        Update: postContent
                    },
                    Page: savedPage._id,
                    PageType: savedPage.Type,
                    PageIsEmbedded: savedPage.IsEmbedded
                }).$saveItem()
            })
        }

        function updateOrAdd() {
            var promise
            if (vm.pageWasNew) {
                console.debug('Making new page', vm.page)
                promise = vm.page.$saveItem().then(function () {
                    if (vm.page.Type == 'Discussion' && vm.page.SideBarWidgets[0].Data.PageDescription) {
                        new Post({
                            Page: vm.page._id,
                            Type: 'Discussion',
                            Data: { IsIntro: true, Update: vm.page.SideBarWidgets[0].Data.PageDescription }
                        }).$saveItem()
                    }
                })
            } else {
                console.debug('Updating page', vm.page)
                promise = vm.page.$updateItem().$promise

                //try to find the first post for this page -- getCache wasn't relaying the nested property of Data.IsOnline to the server correctly
                Post.query({ Page: vm.page._id, limit: 1, sort: 'DateCreated' }).$httpPromise.then(function (posts) {
                    if (!posts[0]) return //no posts on page

                    var discussionIntroPost = posts[0]
                    if (Object.byString(discussionIntroPost, "Data.IsIntro") == true) {
                        discussionIntroPost.Data.Update = vm.page.SideBarWidgets[0].Data.PageDescription
                        discussionIntroPost.$updateItem()
                    }
                })
            }
            return promise
        }

        function getDisplayableEditors() {
            return vm.page.Editors.map(function (editorsId) {
                return $filter('fullNameFilter')(editorsId)
            }).join(', ')
        }

        function getDisplayableMembers() {
            return vm.page.Members.map(function (memberId) {
                return $filter('fullNameFilter')(memberId)
            }).join(', ')
        }

        function getDisplayableViewers() {
            return vm.page.Viewers.map(function (viewerId) {
                return $filter('fullNameFilter')(viewerId)
            }).join(', ')
        }

        vm.review = function () {
            var details = [
                { 'name': 'Title', value: vm.page.Title },
                { 'name': 'Description', value: vm.page.SideBarWidgets[0].Data.PageDescription },
                { 'name': 'Editors', value: (vm.page.Editors.length > 0 ? getDisplayableEditors() : 'Just Me') }
            ]
            if (vm.page.Type == 'Discussion' && !vm.page.IsPrivate) {
                details.push({ 'name': 'Members', value: (vm.page.Members.length > 0 ? getDisplayableMembers() : 'Just Me') })
            }
            if (vm.page.Type == 'General' && !vm.pageWasNew) {
                details.push({ 'name': 'Address', value: vm.page.SideBarWidgets[0].Data.contactAddress }),
                    { 'name': 'Email', value: vm.page.SideBarWidgets[0].Data.contactEmail },
                    { 'name': 'Phone', value: vm.page.SideBarWidgets[0].Data.contactPhone }
            }
            if (vm.page.Type == 'Event') {
                details.push({ name: 'Event Start', value: $filter('date')(vm.page.Event.Start, 'medium') })
                details.push({ name: 'Event End', value: $filter('date')(vm.page.Event.End, 'medium') })
                if (vm.page.Event.Location) {
                    details.push({ name: 'Address', value: vm.page.Event.Location.Address1 })
                    details.push({ name: 'City', value: vm.page.Event.Location.City })
                    details.push({ name: 'State', value: vm.page.Event.Location.StateProv })
                    details.push({ name: 'Zip Code', value: vm.page.Event.Location.ZipPostalCode })
                }
            }
            if (vm.page.IsPrivate == true) {
                details.push({ name: 'Privacy', value: 'Editors, Members and Viewers Only' })
                details.push({ name: 'Members', value: (vm.page.Members.length > 0 ? getDisplayableMembers() : 'Just Me') })
                if (vm.page.Viewers.length > 0) {
                    details.push({ name: 'Viewers', value: getDisplayableViewers() })
                }
            }
            return { error: false, details: details }
        }

        vm.removePage = function ($event) {
            $mdDialog.show({
                controller: 'RemoveItemDialogController',
                controllerAs: 'vm',
                locals: {
                    selectedItems: [vm.page],
                    showConfirmationSignature: true
                },
                //bindToController: true,
                templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
                //scope: thisDialogScope,
                clickOutsideToClose: true,
                //fullscreen: useFullScreen,
                targetEvent: $event
            }).then(function () {
                $window.history.back()
            })
        }

    }
})();
(function () {
    newPrivateMessageController.$inject = ["auUtility", "$q", "$mdDialog", "$timeout", "User", "Page", "Post", "toast", "options", "chats"];
    angular
        .module('app')
        .controller('NewPrivateMessageController', newPrivateMessageController)

    /* @ngInject */
    function newPrivateMessageController(auUtility, $q, $mdDialog, $timeout, User, Page, Post, toast, options, chats) {
        var vm = this
        vm.cancel = $mdDialog.cancel

        //normalize plain arrays of strings into users
        if (options.members) options.members = options.members.map(function (member) {
            if (typeof member == "string") {
                var user = User.getCache({ _id: member })[0]
                return { Type: 'User', Id: member, $Display: user.toString(), item: user }
            }
            return member
        })

        //concat any passed in locations/depts/etc
        if (!options.members) options.members = []
        if (options.groups) options.members = options.members.concat(options.groups)

        vm.conversation = new Page({ Type: 'Conversation', Title: options.subject || "" })
        vm.conversation.$UsersAndTeams = options.members
        
        vm.message = new Post({
            Creator: $rootScope.user._id,
            Type: 'Message',
            Comments: [],
            Likes: [],
            Tagged: [],
            Documents: [],
            Data: {
                Update: options.message || '',
                Poll: {
                    Question: '',
                    PossibleResponses: []
                },
                SendAsEmail: false
            },
            PageIsEmbedded: false,
            PageType: 'Conversation'
        })

        vm.editComplete = function () {
            $mdDialog.hide()
        }

        vm.createConversation = function () {
            var pArray = []
            
            if (vm.conversation.$UsersAndTeams.length == 0) {
                toast.toast('Please enter at least one recipient.')
                return $q.reject()
            }

            if (vm.conversation.$UsersAndTeams.length == 1 && vm.conversation.$UsersAndTeams[0].Id == $rootScope.user._id && vm.message.Data.SendAsEmail) {
                toast.toast('Since you are the only recipient, this will send a test message to yourself. Normally, you don\'t get emails you send.', true)
            }

            if (vm.conversation.Title.trim() == "") {
                toast.toast('Please supply a subject.')
                return $q.reject()
            }

            vm.conversation.$UsersAndTeams.forEach(function (item) {
                if (item.Type == 'User') {
                    vm.conversation.Members.push(item.Id)
                }
                if (item.Type == 'Team') {
                    item.item.Nodes.forEach(function (node) {
                        if (node.LinkWithUserId) {
                            vm.conversation.Members.push(node.LinkWithUserId)
                        }
                    })
                }
                if (item.Type == 'Organization') {
                    pArray.push(User.getCache({}, true).$httpPromise)
                }
                if (item.Type == 'Location') {
                    pArray.push(User.getCache({ Location: item.Id }, true).$httpPromise)
                }
                if (item.Type == 'Department') {
                    pArray.push(User.getCache({ Department: item.Id }, true).$httpPromise)
                }
            })

            return $q.all(pArray).then(function (res) {
                res.forEach(function (users) {
                    users.forEach(function (user) {
                        if (vm.conversation.Members.indexOf(user._id)) {
                            vm.conversation.Members.push(user._id)
                        }
                    })
                })

                return vm.conversation.$saveItem()
                    .then(function (savedConversation) {
                        vm.message.Page = savedConversation._id

                        chats.openChat(vm.conversation)

                        setTimeout(function () {
                            $mdDialog.hide()
                        })
                    })
            })


        }

        vm.transformUserChip = function ($chip) {
            return $chip._id
        }
    }
})();
(function () {
    editTopicItemController.$inject = ["$mdDialog", "$scope", "options", "oneSearch", "toast", "Schema"];
    angular
        .module('app')
        .controller('EditTopicItemController', editTopicItemController)

    /* @ngInject */
    function editTopicItemController($mdDialog, $scope, options, oneSearch, toast, Schema) {
        var vm = this
        vm.mdDialog = $mdDialog
        vm.meetings = options.meetings
        vm.selectedTopicItemType = ''

        if (vm.meetings.length == 1) {
            vm.selectedTopicItemType = vm.meetings[0].TopicItemType
            vm.topicItem = Schema.resource(vm.selectedTopicItemType).getCache({_id: vm.meetings[0].TopicItemId})[0]
        }

        //disable the autocomplete until a type is selected
        vm.typeSelected = true

        //this array needs to be updated when we put a Meeting List card on an item
        vm.topicItemTypes = [
            'Project', 'Task', 'Document', 'Team', 'Department', 'Location'
        ]

        $scope.$watch('vm.selectedTopicItemType', function(){
            //enable the autocomplete when a type is selected
            if (vm.selectedTopicItemType != '') return vm.typeSelected = false
        })

        vm.oneSearch = function () {
            if (vm.itemSearchText == "") {
                return;
            }
            return oneSearch.search(vm.itemSearchText, vm.selectedTopicItemType)
                .then(function (searchResults) {
                    var resultsOnly = searchResults.filter(function (result) {
                        if (!result.isSection) return result
                    })
                    return resultsOnly
                })
        }


        vm.finish = function () {
            if (!vm.topicItem) {
                toast.error('Oops! You forgot to choose an item.')
                return
            } else {
                var pArray = []
                vm.meetings.forEach(function(meeting){
                    meeting.TopicItemType = vm.selectedTopicItemType
                    meeting.TopicItemId = vm.topicItem.DocId
                    meeting.Goal = 'Discuss <span contenteditable=\"false\" class=\"doc-mention {0}\" data-item-type=\"{0}\" data-item-id=\"{1}\" data-cke-filter=\"off\" title=\"{0}: {2}\">{2}</span>'.format(meeting.TopicItemType, meeting.TopicItemId, vm.topicItem.SearchTitle)
                    pArray.push(meeting.$saveItem())
                })
                return Promise.all(pArray).then(function () {
                    $mdDialog.hide()
                    toast.success('Topic item updated!', true)
                })
            }
        }
    }
})();
(function() {
	'use strict';

	AddMeetingDialog.$inject = ["$timeout", "$rootScope", "$scope", "$q", "$filter", "toast", "User", "Meeting", "auUtility", "$mdDialog", "usStates", "Location", "options"];
	angular
		.module('app')
		.controller('AddMeetingDialog', AddMeetingDialog);

	/* @ngInject */
	function AddMeetingDialog($timeout, $rootScope, $scope, $q, $filter, toast, User, Meeting, auUtility, $mdDialog, usStates, Location, options) {
		var vm = this;
		vm.newItem = vm.meeting = new Meeting({ Attendees: [ { User: $rootScope.user._id, IsFacilitator: true, IsRequired: true } ] })
		//fill in the passed in options
		if (options) {
			vm.meeting.Title = options.topicItem.toString() + ' Meeting'
			vm.meeting.Goal = 'Discuss <span contenteditable=\"false\" class=\"doc-mention {0}\" data-item-type=\"{0}\" data-item-id=\"{1}\" data-cke-filter=\"off\" title=\"{0}: {2}\">{2}</span>'.format(options.topicItem.$key, options.topicItem._id, options.topicItem.toString())
			
			//the project owner is always a member of the project so if there are more members make them meeting attendees
			if (Object.byString(options, 'topicItem.Members.length') > 1) {
				options.topicItem.Members.forEach(function(member){
					vm.meeting.Attendees.push({
						User: member.LinkWithUserId,
						IsFacilitator: false,
						IsRequired: false
					})
				})
			}

			if (Object.byString(options, 'topicItem.$Members.length') > 1) {
				options.topicItem.$Members.forEach(function(member){
					vm.meeting.Attendees.push({
						User: member._id,
						IsFacilitator: false,
						IsRequired: false
					})
				})
			}
			
			vm.meeting.TopicItemId = options.topicItem._id,
			vm.meeting.TopicItemType = options.topicItem.$key
		}
		vm.states = usStates

		//allow users to enter their own location or select from an existing one
		vm.searchLocations = function(searchText) {
			return auUtility.searchLocations(searchText).then(function(serverLocations){
				serverLocations.push({Name: searchText}, {Name: 'My Desk'}, {Name: 'Align Us Video Call'}, {Name: 'Conference Room'})
				var names = serverLocations.map(function(l){
					return l.Name
				})
				return names
			})
		}

		//user must enter meeting title before proceeding
        vm.confirmTitleGoalEntered = function (){
            return (vm.meeting.Title && vm.meeting.Goal)
        }

		//return an object when the user gets to the review step
		vm.review = function() {
			// console.debug('vm.meeting', vm.meeting)
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{ name: 'Title', value: vm.meeting.Title },
					{ name: 'Goal', value: vm.meeting.Goal },
                    { name: 'Location', value: vm.meeting.Location },
                    { name: 'Start Date', value: $filter('date')(vm.meeting.StartDate, 'medium') },
                    { name: 'End Date', value: $filter('date')(vm.meeting.EndDate, 'medium') }
				]
			}
		}

		function filterSingleAttendee(attendee) {
			return $filter('fullNameFilter')(attendee.User)
		}

		function getDisplayableRegularAttendees() {
			return vm.meeting.GetRegularAttendees().map(filterSingleAttendee).join(', ')
		}

		function getDisplayableFacilitators() {
			return vm.meeting.GetFacilitators().map(filterSingleAttendee).join(', ')
		}

		vm.transformFacilitatorChip = function($chip) {
			// $chip is the raw ID of the user they selected
			return {
				User: $chip,
				IsFacilitator: true,
				IsRequired: true
			}
		}

		vm.transformAttendeeChip = function($chip) {
			// $chip is the raw ID of the user they selected
			return {
				User: $chip
			}
		}

		//complete the user request to finish the dialog
		vm.finish = function(){
            return vm.meeting.$saveItem()
			.then(function(item){
				return "You have successfully added: " + item.toString()
			})
		}

		// if they set the start date, automatically prefill the end date
		$scope.$watch('vm.meeting.StartDate', function(newStartDate, oldStartDate) {
			if (!newStartDate) return

			if (newStartDate.getHours() > 0) {
				if (!vm.meeting.EndDate) {
					return vm.meeting.EndDate = moment(newStartDate).add(30, 'minutes').toDate()
				}

				var diff = moment(vm.meeting.EndDate).diff(oldStartDate, 'minutes')

				vm.meeting.EndDate = moment(newStartDate).add(diff, 'minutes').toDate()
			}
		})
	}
}
)();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PageProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.social.pages.events.upcoming',
				title: 'Upcoming Events',
				itemTitle: '{{itemSettings.item.toString()}}',
				itemType: PageProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "eventableFetcher", function (localCacheReady, eventableFetcher) {
						return eventableFetcher.getMyEvents(false, 'future')
							.then(function(eventables) {
								return $filter('filter')(eventables, {$key: 'Page'})
							})
					}],
					initialView: 'list',
					initialSortBy: '-Event.Start'
				// itemFields: [
				// 	{
				// 		display: 'Title',
				// 		 displayValue: 'Title',
				// 		 groupMethod: 'alpha',
				// 		 name: 'Title',
				// 		 primary: true,
				// 		 sortable: true,
				// 		 type: 'String'
				// 	},
				// 	{
				// 		display: 'Start',
				// 		 displayValue: '$Event.start',
				// 		 groupMethod: 'date',
				// 		 name: 'Start',
				// 		 primary: true,
				// 		 displayTemplate: "{{moment($Event.start).format('MM/DD/YYYY')}}",
				// 		 sortable: true,
				// 		 type: 'Date'
				// 	},
				// 	{
				// 		display: 'Type',
				// 		displayValue: '$Event.type',
				// 		groupMethod: 'alpha',
				// 		name: 'Type',
				// 		primary: true,
				// 		sortable: true,
				// 		type: 'String'
				// 	}
				// ],
				// initialSortBy: 'Start',
				// initialView: 'list'
			})
    }
})();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PageProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PageProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.social.pages.events.past',
				title: 'Past Events',
				itemTitle: '{{itemSettings.item.toString()}}',
				itemType: PageProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "eventableFetcher", "$filter", function (localCacheReady, eventableFetcher, $filter) {
						return eventableFetcher.getMyEvents(false, 'past')
							.then(function(eventables) {
								return $filter('filter')(eventables, {$key: 'Page'})
							})
					}],
				initialSortBy: 'Title',
				initialView: 'list'
			})
    }
})();
(function () {
	'use strict'

	configCalendar.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(configCalendar)

	/* @ngInject */
	function configCalendar($stateProvider) {
		$stateProvider.state('shell.social.pages.events.my-event-calendar', {
			views: {
				'@shell': {
					templateUrl: '/app/social/calendar/calendar.tmpl.html',
					controller: 'CalendarController',
					controllerAs: 'vm'
				}
			},
			url: '/my-event-calendar',
			navigationData:  {
				breadcrumbTitle: 'Calendar'
			},
			resolve: {
				calendarEvents: ["eventableFetcher", function(eventableFetcher) {
					return eventableFetcher.getMyEvents()
				}]
			}
		})
	}
})();
(function () {
	'use strict';

	CalendarController.$inject = ["$scope", "$element", "$compile", "$mdDialog", "calendarEvents"];
	angular
		.module('app')
		.controller('CalendarController', CalendarController);

	/* @ngInject */
	function CalendarController($scope, $element, $compile, $mdDialog, calendarEvents) {
		var vm = this;
		console.debug('calendarEvents', calendarEvents)
		
		init()		
		
		function init() {
			vm.calendarEvents = calendarEvents
		}
		
		function goToEventPage(event, jsEvent, view) {
			$state.go('shell.social.page', {id: event.id})
		}
	}

})();
(function() {
    'use strict';

	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider) {
        // add routes
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {
            name: 'shell.social.pages.events',
            title: 'Events',
			subTitle: 'This is where you can find all events and meetings you are attending.',
			cardClass: "sub-menu-card",

			/* @ngInject */
			onEnter: ["$rootScope", "$state", function($rootScope, $state) {
				//reset the scroll top
				$rootScope.landingRecentGroupingsScrollTop = 150
			}],

			fabButtons: [{
                    title: 'Add Event',
                    icon: 'au au-add-event',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'Event' } }
                        })
					},
					permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Add Meeting',
                    icon: 'au au-meeting',
                    action: function($event) {
                        $mdDialog.show({
                            controller: 'AddMeetingDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
                            targetEvent: $event,
							locals: {
								options: null
							}
                        })
                    },
					permissionNeeded: '$root.user.EffPerms.Meetings.CanCreate'
                }
            ],
            fabIcon: 'zmdi zmdi-plus',

			menuItems: [
				{
					title: 'New Event',
					subtitle: 'Hosting an event? Start here!',
					image: '/assets/images/cards/slim/social/event-new.png',
					action: function ($event) {
						$mdDialog.show({
								controller: 'PageWizardDialog',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
								targetEvent: $event,
								locals: { options: { pageType: 'Event' } }
						})
					},
					permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
				},
				{
					title: 'My Calendar',
					subtitle: 'Events & meetings you are attending in one calendar.',
					image: '/assets/images/cards/slim/social/calendar.png',
					sref: 'shell.social.pages.events.my-event-calendar'
				},
				{
					title: 'Upcoming Events',
					subtitle: 'List of events & meetings you are hosting or attending.',
					image: '/assets/images/cards/slim/social/event-list-upcoming.png',
					sref: 'shell.social.pages.events.upcoming.list'
				},
				{
					title: 'Past Events',
					subtitle: 'List all previously attended/hosted events & meetings.',
					image: '/assets/images/cards/slim/social/event-list-past.png',
					sref: 'shell.social.pages.events.past.list'
				}
			]
        })

	}
})();
(function() {
	'use strict';
		configTasksForItems.$inject = ["$stateProvider", "ListViewerProvider", "TaskProvider"];
	angular
		.module('app')
		.config(configTasksForItems)

		/* @ngInject */
		function configTasksForItems($stateProvider, ListViewerProvider, TaskProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.project.tasks-for',
				title: 'Tasks for...',
				itemType: TaskProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "$stateParams", "Schema", "$q", function(localCacheReady, $stateParams, Schema, $q) {
					if($stateParams.items) {
						return Schema.resource('Task').GetTasksForItems($stateParams.items)
					} else if ($stateParams.query) {
						return Schema.resource('Project').getCache({_id: $stateParams.query})[0].GetTasks()
					}
					
				}],
				initialView: 'task-kanban',
				initialSortBy: 'Title',
				/* @ngInject */
				onEnter: ["$stateParams", "$filter", "$timeout", function($stateParams, $filter, $timeout) {
					var This = this
					
					// change this.navigationData.breadcrumbTitle to something appropriate
					$timeout(function(){
						var items = $state.$current.locals.globals.listItems
						if (items.length == 1){
							This.navigationData.breadcrumbTitle = 'Tasks for ' + items[0].toString()
						} else {
							This.navigationData.breadcrumbTitle = items.length + ' Tasks'
						}
					}, 100)
					
				}] // end onEnter
			}) // end call to createRoutes
		} // end configTasksForItem
})();
(function () {
	'use strict';
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "SelectFilterProvider", "TaskProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, SelectFilterProvider, TaskProvider) {
		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.project.tasks-by-user',
			title: 'Tasks By User',
			subTitle: 'Users who report to me',
			/* @ngInject */
			values: ["localCacheReady", "$rootScope", "Task", "$filter", "User", function (localCacheReady, $rootScope, Task, $filter, User) {
				return $rootScope.user.getSubordinates().$httpPromise.then(function(subordinates) {
					var returnVal = subordinates.map(function (subordinate) {
						return {
							title: '  ' + subordinate.toString(),
							sref: '.tasks.list',
							srefOpts: { query: subordinate._id },
							item: subordinate
						}
					})
					if (returnVal.length > 0) {
						returnVal.push({title: ' All other users', sref: '#'})
					}
					User.getCache({ReportsTo: '!' + $rootScope.user._id}, false).forEach(function(user){
						if (user._id == $rootScope.user._id) return

						returnVal.push(
							{
								title: user.toString(),
								sref: '.tasks.list',
								srefOpts: { query: user._id },
								item: user
							}
						)
					})

					return returnVal
				})
			}],
			breadcrumbItemMap: function (value) {
				return {
					title: value.title,
					sref: 'shell.project.tasks-by-user.tasks.list',
					srefOpts: value.srefOpts
				}
			},
			/* @ngInject */
			onEnter: ["$stateParams", "$filter", "Document", "User", function($stateParams, $filter, Document, User) {
				if (User.getCache({ ReportsTo: $rootScope.user._id }, false).length == 0) {
					this.navigationData.subTitle = 'Select a User'
				}
			}]
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.tasks-by-user.tasks',
			title: 'Tasks for...',
			itemType: TaskProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Task", "$state", "$stateParams", function (localCacheReady, Task, $state, $stateParams) {
				return Task.query({
					User: $stateParams.query,
					IsActive: true,
					ProjectIsActive: true,
					$or: [
						{ EndDate: { $exists: false } },
						{ EndDate: null },
						{ EndDate: { $gte: new Date(moment().subtract(3, 'days')) } }
					],
				}).$httpPromise
			}],
			initialSortBy: 'Title',
			initialView: 'task-kanban',
			/* @ngInject */
			onEnter: ["$stateParams", "$filter", "Task", "User", function ($stateParams, $filter, Task, User) {
				var This = this
				// change the breadcrumb to something appropriate
				User.getCache({ _id: $stateParams.query }).$httpPromise.then(function(results) {
					This.navigationData.breadcrumbTitle = 'Tasks For ' + $filter('auItemFilter')(results[0])				
				})
			}]
		})
	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "TaskProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, TaskProvider) {
			SingleItemViewerProvider.createRouteFor($stateProvider, {
				itemType: TaskProvider,
				itemSection: 'project',
				detailTemplateUrl: '/app/project/task/detail.tmpl.html',
				controller: 'TaskController'
			})
    }
})();
(function () {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "TaskProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, ListViewerProvider, TaskProvider) {
        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell.project.all-tasks',
            title: 'All My Tasks',
            itemTitle: '{{itemSettings.item.toString()}}',
            itemType: TaskProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "Task", "$rootScope", function (localCacheReady, Task, $rootScope) {
                return Task.query({
                    User: $rootScope.user._id,
                    IsActive: true,
					ProjectIsActive: true,
                    $or: [
                        { EndDate: { $exists: false } },
                        { EndDate: null },
                        { EndDate: { $gte: new Date(moment().subtract(3, 'days'))} }
                    ],
                }).$httpPromise
            }],
            initialSortBy: 'Title',
            initialView: 'task-kanban'
        })
    }
})();
(function () {
	'use strict';

	TaskController.$inject = ["$scope", "$rootScope", "toast", "$filter", "$state", "ItemViewer", "itemSettings", "auUtility", "Task", "taskPriorities", "kanbanStates"];
	angular
		.module('app')
		.controller('TaskController', TaskController);

	/* @ngInject */
	function TaskController($scope, $rootScope, toast, $filter, $state, ItemViewer, itemSettings, auUtility, Task, taskPriorities, kanbanStates) {
		var vm = this;
		vm.Task = Task

		vm.possibleStates = kanbanStates
		vm.taskPriorities = taskPriorities

		// turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		vm.item = itemSettings.item
		vm.searchTasks = auUtility.searchTasks
		vm.searchProjects = auUtility.searchProjects
		vm.searchMeetings = auUtility.searchMeetings
		vm.searchItems = auUtility.searchItems
		vm.searchDocuments = auUtility.searchDocuments
		vm.searchTasks = auUtility.searchTasks

		if (Object.byString(vm.item, "RepeatsEvery.IntervalType")) {
			vm.showTaskRepeatSettings = true
		} else {
			vm.showTaskRepeatSettings = false
		}
		
		vm.onRepeatingChange = function () {
			if (vm.showTaskRepeatSettings) {
				initRepeat(vm.item)
			} else {
				//clear item value
				vm.item.RepeatsEvery = null				
			}
		}

		function initRepeat(item) {
			item.RepeatsEvery = {}
			item.RepeatsEvery.IntervalType = 'weekly'
			item.RepeatsEvery.Interval = 1
			item.RepeatsEvery.RepeatDays = {Wednesday:true}
			item.RepeatsEvery.DayOfMonth = 1
		}

		vm.openTaskFab = function ($event, task) {
			//position the task Fab over the checkbox
			var offset = angular.element($event.currentTarget).offset()
			if(typeof task == 'string') task = Task.getCache({_id: task})[0]
			$rootScope.docTask.openFab(offset, task, $event.currentTarget)
		}

		vm.isAssignmentEmpty = function() {
			return (!vm.item.Project && !vm.item.Meeting && !vm.item.Document)
		}

		var _priorityText
		vm.selectedTaskPriority = function(taskPriorityNumber){
			if (!_priorityText) vm.taskPriorities.forEach(function (priority) {
				if (priority.number == taskPriorityNumber){
					_priorityText = priority.text
				}
			})
			return _priorityText
		}
	}
})();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "TaskProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, TaskProvider) {
       
		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.tasks-created-by-me',
			title: 'Tasks I Created',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: TaskProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "$rootScope", "Task", function (localCacheReady, $rootScope, Task) {
				return Task.query({
					Creator: $rootScope.user._id,
					IsActive: true,
					ProjectIsActive: true,
					$or: [
						{ EndDate: { $exists: false } },
						{ EndDate: null },
						{ EndDate: { $gte: new Date(moment().subtract(3, 'days')) } }
					],
				}).$httpPromise
			}],
			initialSortBy: 'Title',
			initialView: 'task-user'
		})
    }
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, ProjectProvider) {

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports.team-projects',
			title: "Team Projects",
			subTitle: "These are all teams, click one to see projects it is linked with.",
			
            /* @ngInject */
			values: ["localCacheReady", "$rootScope", "Project", "Team", "$filter", function (localCacheReady, $rootScope, Project, Team, $filter) {
				var teams = Team.getCache()
				return teams.$httpPromise.then(function() {
					return teams.map(function(team){
						return {title: team.Name, sref: '.project.list', srefOpts: { query: team._id }, item: team}
					})
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.Title, sref: 'shell.project.reports.team-projects', srefOpts: value.srefOpts }
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports.team-projects.project',
			title: 'Projects Assigned To A Team',
			itemType: ProjectProvider,
			/* @ngInject */
            listItems: ["localCacheReady", "Project", "$stateParams", function (localCacheReady, Project, $stateParams) {
				return Project.getCache({
					Team: $stateParams.query
				})
			}],
			initialSortBy: 'Title',
			initialView: 'list'
		})
	}
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "TaskProvider", "TaskBoardViewerProvider", "TeamProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, TaskProvider, TaskBoardViewerProvider, TeamProvider) {
		TaskBoardViewerProvider.createRouteFor($stateProvider, {
			itemType: TeamProvider
		})

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports.tasks-by-team',
			title: "Tasks By Team",
			subTitle: "Choose a team to see tasks assigned to all of its members.",
			
			/* @ngInject */
			values: ["localCacheReady", "$rootScope", "Task", "Team", "$filter", function (localCacheReady, $rootScope, Task, Team, $filter) {
				var teams = Team.getCache()
				return teams.$httpPromise.then(function() {
					return teams.map(function(team) {
						return {
							title: team.toString(),
							sref: 'shell.project.reports.tasks-for-team',
							srefOpts: { id: team._id },
							item: team
						}
					})
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.project.tasks-for-team', srefOpts: value.srefOpts }
			}
		})
	}
})(); 
(function () {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "SingleItemViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, SingleItemViewerProvider, ProjectProvider) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports',
			title: 'Browse',
			subTitle: 'Find projects and tasks based on particular groupings.',
			cardClass: 'sub-menu-card',

			sectionSettings: {
				searchTitle: "Browse",
				color: "rgba(55, 176, 74, 1)",
				image: "projects",
				title: null //removes recent items
			},

			fabButtons: [
				{
					title: 'Add Project',
					icon: 'zmdi zmdi-folder',
					action: function () {
						$mdDialog.show({
							controller: 'AddProjectDialog',
							controllerAs: 'vm',
							templateUrl: '/app/project/dialogs/add-project.tmpl.html',
							targetEvent: null
						})
					},
					permissionNeeded: '$root.user.EffPerms.Projects.CanCreate'
				},
				{
					title: 'Add Task',
					icon: 'au au-task-check',
					action: function(){
						$mdDialog.show({
							controller: 'AddTaskDialog',
							controllerAs: 'vm',
							templateUrl: '/app/project/dialogs/add-task.tmpl.html',
							targetEvent: null,
							locals: {
								options: {}
							}
						})
					}
				}
			],
			fabIcon: 'zmdi zmdi-plus',

			/* @ngInject */
			onEnter: ["$rootScope", "$state", function ($rootScope, $state) {
				//reset the scroll top
				$rootScope.landingRecentGroupingsScrollTop = 150

			}],

			menuItems: [
				{
					title: 'All Projects',
					subtitle: 'All active projects in your organization.',
					image: '/assets/images/cards/slim/projects/projects.png',
					sref: 'shell.project.reports.all-projects.list'
				},
				{
					title: 'Tasks By Project',
					subtitle: 'List all tasks for a project.',
					image: '/assets/images/cards/slim/projects/tasksbyproject.png',
					sref: 'shell.project.reports.by-project'
				},
				{
					title: 'Projects By Team',
					subtitle: 'List all projects assigned to a team of your choice.',
					image: '/assets/images/cards/slim/projects/projectsbyteam.png',
					sref: 'shell.project.reports.team-projects'
				},
				{
					title: 'Tasks By Team',
					subtitle: 'List all tasks assigned to members of a team.',
					image: '/assets/images/cards/slim/projects/tasksbyteam.png',
					sref: 'shell.project.reports.tasks-by-team'
				}
				// ,
				// {
				// 	title: 'Task Activity',
				// 	subtitle: 'List all activity for a certain task.',
				// 	image: '/assets/images/cards/slim/projects/task-activity.png',
				// 	sref: 'shell.project.reports'
				// },
				// {
				// 	title: 'Project Activity',
				// 	subtitle: 'List all activity for a certain project.',
				// 	image: '/assets/images/cards/slim/projects/project-activity.png',
				// 	sref: 'shell.project.reports'
				// }
			]
		})
	}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "ProjectProvider"];
	angular.module('app').config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, ProjectProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports.all-projects',
			title: 'All Projects',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: ProjectProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Project", function (localCacheReady, Project) {
				return Project.getCache()
			}],
			initialSortBy: 'Title',
			initialView: 'list'
		})
    }

})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "TaskProvider", "TaskBoardViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, TaskProvider, TaskBoardViewerProvider, ProjectProvider) {

		TaskBoardViewerProvider.createRouteFor($stateProvider, {
			itemType: ProjectProvider
		})

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.project.reports.by-project',
			title: "Tasks By Project",
			subTitle: "Choose a project to see all its tasks.",
			
			/* @ngInject */
			values: ["localCacheReady", "$rootScope", "Task", "Project", "$filter", function (localCacheReady, $rootScope, Task, Project, $filter) {
				return Project.getCache({}).$httpPromise.then(function(projects) {
					return projects.map(function(project) {
						return {
							title: project.Title,
							sref: 'shell.project.reports.tasks-for-project',
							srefOpts: { id: project._id },
							item: project
						}
					})
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.project.reports.tasks-for-project', srefOpts: value.srefOpts }
			}
		})
	}
})(); 
(function() {
	'use strict';
		moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig)

		/* @ngInject */
		function moduleConfig($stateProvider, ListViewerProvider, ProjectProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.project.projects-for-user',
				title: 'Projects for...',
				itemType: ProjectProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "Project", "$location", function(localCacheReady, Project, $location) {
					return Project.QueryItemsInvolving($location.search().user)
				}],
				initialSortBy: 'Title',
				initialView: 'list',
				/* @ngInject */
				onEnter: ["$filter", "User", "$location", function($filter, User, $location) {
					this.navigationData.breadcrumbTitle = 'Projects For ' + $filter('auItemFilter')(User.getCache({_id: $location.search().user})[0])
				}]
			})
		}
})();

// /project/projects-for-user/:id/
(function () {
	'use strict';
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "SelectFilterProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, SelectFilterProvider, ProjectProvider) {
		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.project.by-owner',
			title: 'By Owner',
			subTitle: 'Select an owner to list their active projects.',
			/* @ngInject */
			values: ["localCacheReady", "$rootScope", "$http", "Project", "Schema", function (localCacheReady, $rootScope, $http, Project, Schema) {
				return $http.post("/api/getAllOwners", { modelName: 'Project' }).then(function (res) {
					return res.data.owners.map(function (owner) {
						var ownerType = Schema.resource(owner.$key)
						var item = new ownerType(owner)
						return {
							title: item.toString(),
							sref: 'shell.project.by-owner.view.list',
							srefOpts: { query: item.$key + '_' + item._id },
							item: item
						}
					})
				}).catch(function () {
					toast.error('Error querying for owners.')
				})
			}],
			breadcrumbItemMap: function (value) {
				return {
					title: value.title,
					sref: 'shell.project.by-owner.view.list',
					srefOpts: value.srefOpts
				}
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.by-owner.view',
			title: 'Projects for...',
			itemType: ProjectProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Project", "$stateParams", function (localCacheReady, Project, $stateParams) {
				var params = $stateParams.query.split('_')
				var $key = params[0]
				var id = params[1]

				return Project.query({
					OwnedBy: { $elemMatch: { Type: $key, DocId: id } }
				}).$httpPromise
			}],
			initialSortBy: 'Title',
			initialView: 'list',
			/* @ngInject */
			onEnter: ["$stateParams", "Schema", function ($stateParams, Schema) {
				var This = this
				var params = $stateParams.query.split('_')
				var $key = params[0]
				var id = params[1]

				var ownerType = Schema.resource($key)
				ownerType.getCache({_id: id}).$httpPromise.then(function(res){
					This.navigationData.breadcrumbTitle = res[0].toString()
				})

			}]
		})
	}
})();
(function () {
	'use strict'

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, ProjectProvider) {
		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.my-projects',
			title: 'My Projects',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: ProjectProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "$rootScope", "Project", function (localCacheReady, $rootScope, Project) {
				return Project.QueryItemsInvolving($rootScope.user._id)
			}],
			initialSortBy: '-$LastModified',
			initialView: 'list'
		})
    }
})();
(function () {
	'use strict';

	//define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "ProjectProvider"];
	angular.module('app').config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, ProjectProvider) {

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.project.all-projects',
			title: 'All Projects',
			itemType: ProjectProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Project", function (localCacheReady, Project) {
				return Project.getCache()
			}],
			initialSortBy: 'Title',
			initialView: 'list'
		})
    }

})();
(function () {
	'use strict';

	/* global moment */

	ProjectController.$inject = ["$scope", "$element", "$timeout", "toast", "$filter", "$state", "$window", "ItemViewer", "itemSettings", "auUtility", "Team", "Page", "$mdDialog", "User", "windowFab"];
	angular
		.module('app')
		.controller('ProjectController', ProjectController);

	/* @ngInject */
	function ProjectController($scope, $element, $timeout, toast, $filter, $state, $window, ItemViewer, itemSettings, auUtility, Team, Page, $mdDialog, User, windowFab) {
		var vm = this;
		vm.item = itemSettings.item
		vm.searchTeams = auUtility.searchTeams
		vm.resizeStoryDoc = 0
		//incrementing this variable will recenter the content
		vm.centerContentTrigger = 0
		vm.showConfirmRemove = false
		vm.sortableBy = [{
			fieldName: 'Title',
			display: 'Title'
		}, {
			fieldName: 'DateCreated',
			display: 'Date Added'
		}, {
			fieldName: 'CreatedBy',
			display: 'Who Added'
		}]
		vm.sortBy = vm.sortableBy[0]
		vm.placeholderActive = vm.item.IsActive
		vm.placeholderPrivacy = vm.item.IsPrivate
		vm.membersWithID = vm.item.Members.filter(function(member){
			return member.LinkWithUserId
		})
		vm.orgName = $rootScope.Organization.Name

		// turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		initDates()

		//handle org chart
		angular.forEach(vm.item.Members, function (member) {
			member.toString = function () { return this.Text }
		})

		vm.transformMemberChip = function ($chip) {
			if (vm.item.Members.indexOf($chip) > -1) return null
			return $chip
		}

		vm.onDocumentsUploaded = function ($documents) {
			console.debug('In ondocumentsuploaded callback')
			vm.item.AddUserFileTypeDocuments($documents)
		}

		vm.showAddMember = function ($event) {
			angular.forEach(vm.item.Members, function (node) {
				node.$selected = false
			})
			var newId = ObjectId()
			vm.item.Members.push({ Text: 'New Member', id: newId, _id: newId, toString: nodeToString, $isRoot: true, $selected: true })
		}

		vm.showRemoveMember = function ($event) {
			var selectedNode = $filter('filter')(vm.item.Members, { $selected: true })
			if (selectedNode.length != 1) {
				toast.error('Exactly one member may be removed at a time.')
				return
			}

			$event.stopPropagation()

			selectedNode = selectedNode[0]

			// show confirm remove button
			vm.showConfirmRemove = true
		}

		vm.showRemoveButton = function () {
			return ($filter('filter')(vm.item.Members, { $selected: true })).length > 0
		}

		vm.confirmRemoval = function ($event) {
			vm.showConfirmRemove = false
			var selectedNode = $filter('filter')(vm.item.Members, { $selected: true })[0]

			// remove the selected team member
			angular.forEach(vm.item.Members, function (node, i) {
				if (node._id == selectedNode._id) {
					vm.item.Members.splice(i, 1)
				}
				if (node.parentId == selectedNode._id) {
					node.parentId = null
					node.$isRoot = true
				}
			})
			vm.item.$updateItem()

			//force the orgchart to re-render all child nodes
			angular.forEach(selectedNode.$children, function (child) {
				delete child.$OrgChartReady
				delete child.$parentId
			})

			vm.centerContentTrigger++
		}

		vm.selectedOwnerChanged = function(user) {
			if (!user || !user.$addNew) return

			if (vm.item.Owner) vm.ownerSearchText = vm.item.Owner.toString()

			auUtility.addNewItem(user.$addNew).then(function (newItem) {
				if (!newItem) return
				vm.item.Owner = newItem._id
			})
		}

		vm.showLinkWithTeam = function ($event) {
			$mdDialog.show({
				controller: 'LinkWithTeamController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: '/app/project/dialogs/link-with-team.tmpl.html',
				locals: {
					options: { team: vm.item.Team }
				}
			}).then(function (team) {
				vm.item.LinkWithTeam(team)
			})
		}

		vm.requestUpdate = function () {
			$mdDialog.show({
				controller: 'RequestUpdateController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: '/app/project/dialogs/request-update.tmpl.html',
				locals: {
					options: { item: vm.item }
				}
			})
		}

		function initDates() {
			if (vm.item.PlannedStartDate) vm.item.PlannedStartDate = new Date(vm.item.PlannedStartDate)
			if (vm.item.PlannedEndDate) vm.item.PlannedEndDate = new Date(vm.item.PlannedEndDate)
			if (vm.item.StartDate) vm.item.StartDate = new Date(vm.item.StartDate)
			if (vm.item.EndDate) vm.item.EndDate = new Date(vm.item.EndDate)
			if (vm.item.DateStarted) vm.item.DateStarted = new Date(vm.item.DateStarted)
			if (vm.item.DateEnded) vm.item.DateEnded = new Date(vm.item.DateEnded)
		}

		//handle org chart - the timesChanged is super hacky but reliable - we want to catch the 3+ changes
		var timesChanged = 0
		$scope.$watchCollection('vm.item.Members', function (newVal, oldVal) {
			angular.forEach(newVal, function (node) {
				node.toString = nodeToString
			})
		})

		function nodeToString() {
			return this.Text
		}
	}

})();
(function() {
    requestUpdateController.$inject = ["$mdDialog", "Post", "options", "toast"];
    angular
        .module('app')
        .controller('RequestUpdateController', requestUpdateController)

    /* @ngInject */
    function requestUpdateController($mdDialog, Post, options, toast) {
        var vm = this
        vm.cancel = $mdDialog.cancel
        vm.item = options.item

        vm.message = new Post({
            Creator: $rootScope.user._id,
            Type: 'Message',
            Comments: [],
            Likes: [],
            Tagged: [],
            Documents: [],
            Data: {
                Update: 'Hello! How\'s it going with <span contenteditable=\"false\" class=\"doc-mention {0}\" data-item-type=\"{0}\" data-item-id=\"{1}\" data-cke-filter=\"off\" title=\"{0}: {2}\">{2}</span> ?'.format( vm.item.$key,  vm.item._id,  vm.item.toString()),
                Poll: {
                    Question: '',
                    PossibleResponses: []
                },
                SendAsEmail: false
            },
            Page:  vm.item._id,
            PageIsEmbedded: true,
            PageType:  vm.item.$key
        })

        vm.save = function() {
            vm.message.$saveItem().then(function(){
                $mdDialog.hide()
                toast.success('You have successfully posted in the discussion board!', true)
            })
        }
        
        vm.close = function () {
            $mdDialog.hide()
        }
    }
})();
(function() {
		LinkWithTeamController.$inject = ["$mdDialog", "auUtility", "options"];
	angular
		.module('app')
		.controller('LinkWithTeamController', LinkWithTeamController);

		/* @ngInject */
		function LinkWithTeamController($mdDialog, auUtility, options) {
			var vm = this
			vm.searchTeams = auUtility.searchTeams
			vm.$mdDialog = $mdDialog
			
			if(options.team) {
				vm.linkWithTeam = options.team
			}
			
			vm.finish = function() {
				$mdDialog.hide(vm.linkWithTeam)
			}
		}
})();
(function() {
    'use strict';

    BatchRequestStatusUpdateController.$inject = ["selectedTasks", "chats", "$mdDialog"];
    angular
        .module('app')
        .controller('BatchRequestStatusUpdateController', BatchRequestStatusUpdateController)

    /* @ngInject */
    function BatchRequestStatusUpdateController(selectedTasks, chats, $mdDialog) {
        var vm = this
        vm.$mdDialog = $mdDialog
        vm.selectedTasks = selectedTasks
        vm.updateRequestMessage = 'Hello! How\'s it going with ' + vm.selectedTasks[0].Title + '? Please message me back. Thanks!'

        vm.sendMessages = function() {
            vm.selectedTasks.forEach(sendUpdateToOwner)
        }

        function sendUpdateToOwner(task) {
            chats.sendMessage([task.User], vm.updateRequestMessage)
            $mdDialog.hide()
        }
    }
})();
(function() {
	'use strict';

		batchReassignTasksController.$inject = ["$mdDialog", "selectedTasks", "auUtility", "$q", "toast", "$filter", "Task"];
	angular
		.module('app')
		.controller('BatchReassignTasksController', batchReassignTasksController);

		/* @ngInject */
		function batchReassignTasksController($mdDialog, selectedTasks, auUtility, $q, toast, $filter, Task) {
			var vm = this
			vm.$mdDialog = $mdDialog
			vm.searchItems = auUtility.searchItems
			// vm.reassignTo = ''
			vm.selectedTasks = selectedTasks
			vm.dummyTask = new Task({})

			var auItemFilter = $filter('auItemFilter')

			vm.finish = function() {
				var updateProm
				// because i like readability
				vm.projectEdited = vm.dummyTask.Project
				vm.meetingEdited = vm.dummyTask.Meeting
				vm.userEdited = vm.dummyTask.User
				// if they selected a project/meeting, update that first
				if(vm.meetingEdited || vm.projectEdited) {
					updateProm = auUtility.allWithErrors(updateFields(), vm.selectedTasks).then(function(results) {
						// store the results of the successful/unsuccessful project/meeting assignments
						// these are Tasks
						vm.successfulGroupingAssignments = results.getSuccessfulData()
						vm.errorGroupingAssignments = results.getErrorData()
						// return this so that the promise chain is not disrupted
						return results		
					})
				}
				// if they want to change the User, two scenarios:
				// 1) they're also changing the project/meeting;
				// 		in this case, we want to wait for that to finish,
				//		then reassign only the tasks that were successfully
				// 		updated.
				// 2) they didn't change the project/meeting;
				//		in this case, we can just update everything.
				if(vm.userEdited) {
					if(updateProm) {
						updateProm = updateProm.then(reassign)
					} else {
						updateProm = reassign()
					}
				}
				return updateProm.then(function(results) {
					var message = ''
					var error = false
					return new $q(function(resolve, reject) {
						// sorry in advance
						if(vm.meetingEdited || vm.projectEdited) {
							vm.projectOrMeeting = vm.projectEdited ? 'Project' : 'Meeting'
							vm.groupingName = vm.projectEdited ? auItemFilter(vm.dummyTask.Project, 'Project') : auItemFilter(vm.dummyTask.Meeting, 'Meeting')
							message += ('Successfully assigned <b>' + vm.successfulGroupingAssignments.length + '</b> Tasks to ' + vm.groupingName + '.')
							if(vm.errorGroupingAssignments.length > 0) {
								error = true
								message += ('<br/> The following <b>' + vm.errorGroupingAssignments.length + '</b> Tasks could not be assigned to ' + groupingName + ':<br/>')
								message += vm.errorGroupingAssignments.map(function(task) {
									return '<b>' + auItemFilter(task, 'Task') + '</b>'
								}).join(', ')
								message += '.<br/>You may not have permission to modify these Tasks.'
								if(vm.userEdited) {
									message += 'You also attempted to assign these Tasks to a new User; however, due to this error, that selection was not applied to the above Tasks.'
								}
							}
						}
						if(vm.userEdited) {
							var userName = auItemFilter(vm.dummyTask.User, 'User')
							if(message) message += '<br/>'
							message += 'Successfully assigned <b>' + vm.successfulUserAssignments.length + '</b> Tasks to ' + userName + '.'
							if(vm.errorUserAssignments.length > 0) {
								error = true
								message += ('<br/>The following <b>' + vm.errorUserAssignments.length + '</b> Tasks could not be assigned to that User:')
								message += vm.errorUserAssignments.map(function(task) {
									return '<b>' + auItemFilter(task, 'Task') + '</b>'
								}).join(', ')
								message += 'You may not have permission to assign those Tasks to that User.'
							}
						}
						if(error) reject(message)
						else resolve(message)
					})
				})
			}

			vm.review = function() {
				var details = []
				if(vm.dummyTask.User) {
					details.push({
						name: 'New User Assignment',
						value: auItemFilter(vm.dummyTask.User, 'User')
					})
				}
				if(vm.dummyTask.Project) {
					details.push({
						name: 'New Project Assignment',
						value: auItemFilter(vm.dummyTask.Project, 'Project')
					})
				}
				if(vm.dummyTask.Meeting) {
					details.push({
						name: 'New Meeting Assignment',
						value: auItemFilter(vm.dummyTask.Meeting, 'Meeting')
					})
				}
				return {
					error: false,
					details: details
				}
			}

			vm.wasAssignmentSelected = function() {
				return (vm.dummyTask.User || vm.dummyTask.Project || vm.dummyTask.Meeting)
			}

			function updateFields() {
				return vm.selectedTasks.map(function(task) {
					if(vm.dummyTask.Meeting) task.Meeting = vm.dummyTask.Meeting
					if(vm.dummyTask.Project) task.Project = vm.dummyTask.Project
					return task.$updateItem().$promise
				})
			}

			function reassign(groupingAssignResults) {
				var taskPool
				if(groupingAssignResults) {
					taskPool = groupingAssignResults.getSuccessfulData()
				} else {
					taskPool = vm.selectedTasks
				}
				return (auUtility.allWithErrors(taskPool.map(function(task) {
					return task.Reassign(vm.dummyTask.User)
				}), taskPool).then(function(results) {
					// store the results of the reassignments
					// these are Tasks
					vm.successfulUserAssignments = results.getSuccessfulData()
					vm.errorUserAssignments = results.getErrorData()
				}))
			}

			// vm.reassign = function() {
			// 	var promises = []
			// 	selectedTasks.forEach(function(taskToReassign) {
			// 		promises.push(taskToReassign.Reassign(vm.reassignTo))
			// 	})
			// 	$q.all(promises)
			// 	.then(function() {
			// 		$mdDialog.hide(('Successfully reassigned ' + vm.selectedTasks.length + (vm.selectedTasks.length > 1 ? ' tasks ' : ' task ') + ' to ' + $filter('fullNameFilter')(vm.reassignTo)))
			// 	})
			// }
		}
})();
(function () {
	batchAddMembersController.$inject = ["auUtility", "$mdDialog", "toast", "projects", "$filter", "Project", "$q"];
	angular
		.module('app')
		.controller('BatchAddMembersController', batchAddMembersController)

	/* @ngInject */
	function batchAddMembersController(auUtility, $mdDialog, toast, projects, $filter, Project, $q) {
		var vm = this

		vm.searchTeams = auUtility.searchTeams
		vm.projects = projects
		vm.$mdDialog = $mdDialog
		vm.dummyProject = new Project({
			Members: []
		})

		vm.finish = function () {
			var newMembers = []
			var promises = vm.projects.map(function(project) {
				vm.dummyProject.Members.map(function(member){
					if (project.Members.findIndex(function(currentMember, index){ if (currentMember.LinkWithUserId == member.LinkWithUserId) return true }) == -1) {
						 newMembers.push(member)
					}
				})
				project.Members = project.Members.concat(newMembers)
				if(vm.dummyProject.Team) {
					project.Team = vm.dummyProject.Team
				}
				return reflect(project.$updateItem().$promise, project)
			})
			return $q.all(promises)
			.then(function(response) {
				return new $q(function(resolve, reject) {
					var errors = response.filter(function(resp) {
						return resp.error
					})
					var successes = response.filter(function(resp) {
						return resp.success
					})
					var message = '' 
					if(successes.length > 0) {
						message += ('Successfully added members to <b>' + successes.length + '</b> projects.')
					}
					if(errors.length > 0) {
						message += '<br/> Those members could not be added to the following <b>' + errors.length + '</b> projects: '
						message += errors.map(function(error) {
							return '<b>' + $filter('auItemFilter')(error.project, 'Project') + '</b>'
						}).join(', ')
						message += '.<br/>You may not have permission to modify those Projects.'
						reject(message)
					}
					resolve(message)
				})
			})
		}

		function reflect(promise, project) {
			return promise.then(function(result) {
				return { result: result, project: project }
			}, function(error) {
				return { error: error, project: project }
			})
		}

		vm.review = function () {
			return {
				error: false,
				details: [
					{ name: 'Link With Team', value: $filter('auItemFilter')(vm.dummyProject.Team, 'Team') },
					{ name: 'New Members', value: vm.dummyProject.GetDisplayableMembers() }
				]
			}
		}

		vm.transformMemberChip = function ($chip) {
			return {
				LinkWithUserId: $chip,
				Text: $filter('auItemFilter')($chip, 'User')
			}
		}
	}
})();
(function () {
	'use strict';

	AddTaskDialog.$inject = ["$filter", "$rootScope", "User", "Task", "$mdDialog", "options", "auUtility", "taskPriorities"];
	angular
		.module('app')
		.controller('AddTaskDialog', AddTaskDialog);

	/* @ngInject */
	function AddTaskDialog($filter, $rootScope, User, Task, $mdDialog, options, auUtility, taskPriorities) {
		var vm = this;

		init()

		function init() {
			vm.newItem = vm.task = new Task({})
			vm.searchItems = auUtility.searchItems
			vm.searchProjects = auUtility.searchProjects
			vm.searchMeetings = auUtility.searchMeetings
			vm.searchDocuments = auUtility.searchDocuments
			vm.associatedItem = options.associatedItem
			vm.associatedUser = options.associatedUser
			vm.task.Details = options.defaultDetails
			vm.task.Title = options.defaultTitle
			vm.taskPriorities = taskPriorities
			initializeAssociatedItems()

			setTimeout(function(){
				if (options.skipIntro) {
					vm.wizardSteps[0].visible = false
					vm.wizardSteps.nextStep()
				}
			}, 1)
			//set up Review Initiative task
			if (options.initiative) {
				vm.task.Title = 'Review Initiative - ' + options.initiative.Title + ' - ' + moment().format('MM-DD-YYYY')
				vm.task.Details = '<p>Please Review and Update Initiative <span contenteditable=\"false\" class=\"doc-mention Initiative\" data-item-type=\"Initiative\" data-item-id=\"{0}\" data-cke-filter=\"off\" title=\"Initiative: {1}\">{1}</span> in Strategy <span contenteditable=\"false\" class=\"doc-mention Strategy\" data-item-type=\"Strategy\" data-item-id=\"{2}\" data-cke-filter=\"off\" title=\"Strategy: {3}\">{3}</span></p><ol><li><strong>Open </strong>the strategy by clicking the tag.</li><li><strong>Review </strong>the strategy description.</li><li><strong>Open </strong>the initiative by clicking the tag.</li><li><strong>Review </strong>the KPIs and their collection process.</li><li><strong>Review </strong>the KPI Data.</li><li><strong>Click </strong>the Review card and type up your review of {1}</li></ol><p><span style=\"font-size: 28px\">✔️</span> Mark this task <strong>complete</strong> when you are finished.</p>'.format(options.initiative._id, options.initiative.Title, options.initiative.StrategyId, options.initiative.$StrategyId.toString())
				vm.task.User = options.initiative.Reviewers[0]
				vm.task.RepeatsEvery = {}
			}
		}

		function initializeAssociatedItems() {
			if (vm.associatedItem) vm.task[vm.associatedItem.$key] = vm.associatedItem._id
			if (vm.associatedUser) vm.task.User = vm.associatedUser
			vm.task.AutoPostUpdates = true
		}

		//the title must be entered for the user to continue
		vm.confirmTitleEntered = function () {
			return vm.task.Title
		}

		function getDisplayableSharedWith() {
			return vm.task.SharedWith.map(function(userId) {
				return $filter('fullNameFilter')(userId)
			}).join(', ')
		}

		vm.checkForNewUser = function(user) {
			if (!user.$addNew) return

			auUtility.addNewItem(user.$addNew).then(function(newItem){
				vm.userSearchText = ""
				vm.task.User = newItem._id
			})
		}

		//return an object when the user gets to the review step		
		vm.review = function () {
			//must be {error: boolean, details: array}
			var retObject = {
				error: false,
				details: [
					{ name: 'Title', value: vm.task.Title }
				]
			}

			if (vm.task.TaskPriority) {
				var priorityText = $rootScope.taskPriorities.filter(function (priorityObj) {
					return priorityObj.number == String(vm.task.TaskPriority)
				})[0].text
				retObject.details.push({ name: 'Task Priority', value: priorityText })
			}
			if (vm.task.Details) retObject.details.push({ name: 'Description', value: vm.task.Details})

			if (vm.task.Meeting == null) delete vm.task.Meeting
			if (vm.task.Project == null) delete vm.task.Project
			if (vm.task.Document == null) delete vm.task.Document

			if (vm.task.User) retObject.details.push({ name: 'User Assignment', value: $filter('fullNameFilter')(vm.task.User) })
			if (vm.task.Project) retObject.details.push({ name: 'Project Assignment', value: $filter('auItemFilter')(vm.task.Project, 'Project') })
			if (vm.task.Meeting) retObject.details.push({ name: 'Meeting Assignment', value: $filter('auItemFilter')(vm.task.Meeting, 'Meeting') })
			if (vm.task.Document) retObject.details.push({ name: 'Document Assignment', value: $filter('auItemFilter')(vm.task.Document, 'Document') })
			if (vm.task.ParentTask) retObject.details.push({ name: 'ParentTask', value: $filter('auItemFilter')(vm.task.ParentTask, 'Task') })

			if (vm.task.EstimatedHours) retObject.details.push({ name: 'Estimated Hours', value: vm.task.EstimatedHours })
			if (vm.task.PlannedStartDate) retObject.details.push({ name: 'Planned Start Date', value: $filter('date')(vm.task.PlannedStartDate, 'medium') })
			if (vm.task.PlannedEndDate) retObject.details.push({ name: 'Planned End Date', value: $filter('date')(vm.task.PlannedEndDate, 'medium') })

			retObject.details.push({ name: 'Auto Post', value: vm.task.AutoPostUpdates ? 'Post when task is complete' : 'Do Not post when task is complete' })
			if (vm.task.SharedWith.length > 0) retObject.details.push({ name: 'Share With', value: getDisplayableSharedWith() })
			
			return retObject
		}

		//complete the user request to finish the dialog		
		vm.finish = function () {
			return vm.task.$saveItem()
				.then(function (item) {
					if (options.fromPost) {
						options.fromPost.addComment({
							_id: (new ObjectId()).toString(),
							User: $rootScope.user._id,
							Comment: 'Created a <span class=\"doc-mention Task\" data-item-type=\"Task\" data-item-id=\"{0}\">task</span> from this post'.format(item._id),
						})
					}

					return "The task \"{0}\" has been created.".format(item.toString())
				})
		}

	}
}
)();
(function () {
    'use strict';

    AddProjectDialog.$inject = ["$timeout", "toast", "User", "$rootScope", "Project", "$filter", "$mdDialog", "auUtility"];
    angular
        .module('app')
        .controller('AddProjectDialog', AddProjectDialog);

    /* @ngInject */
    function AddProjectDialog($timeout, toast, User, $rootScope, Project, $filter, $mdDialog, auUtility) {
        var vm = this;
        vm.newItem = vm.project = new Project(
            { Members: [{LinkWithUserId: $rootScope.user._id, Text: 'Created Project'}], 
            OwnedBy: [{DocId: $rootScope.user._id, Type: 'User', Note: 'Created Project'}] })

        //the toast is super annoying, but you get the idea
        vm.stepChanged = function (currentStep, fromStep) {
            //Pretty sure we don't need this
            // toast.toast('Navigated from ' + fromStep + ' to ' + currentStep)
        }

        vm.confirmTitleEntered = function () {
            // Title field must have a value for the user to continue
            return vm.project.Title
        }

        //return an object when the user gets to the review step
        vm.review = function () {
            //must be {error: boolean, details: array}
            return {
                error: false,
                details: [
                    { name: 'Title', value: vm.project.Title },
                    { name: 'Description', value: vm.project.Description },
                    { name: 'Owners', value: vm.project.OwnedBy.length },
                    { name: 'Searchable', value: vm.project.IsPrivate ? 'To Members Only' : 'To All Users in ' + $rootScope.Organization.Name }
                ]
            }
        }

        //complete the user request to finish the dialog
        vm.finish = function () {
            if (!vm.project.Team) delete vm.project.Team
            return vm.project.$saveItem()
                .then(function (item) {
                    return "You have successfully added:  " + item.toString()
                })
        }

    }
}
)();
(function () {
	'use strict';

	PhilosophyItemController.$inject = ["$scope", "$rootScope", "ItemViewer", "itemSettings", "socket", "auUtility"];
	angular
		.module('app')
		.controller('PhilosophyItemController', PhilosophyItemController);

	/* @ngInject */
	function PhilosophyItemController($scope, $rootScope, ItemViewer, itemSettings, socket, auUtility) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item
        
        vm.addValue = function () {
			var newId = ObjectId()
        	vm.item.Values.push({_id: newId, Rank: vm.item.Values.length + 1})
		}
		
		vm.removeValue = function ($index, $event) {
			var dialog = $mdDialog.confirm({
				title: "Remove Value",
				htmlContent: "Are you sure you want to remove this value? This action is not un-doable.",
				ok: "Do It",
				cancel: "Cancel",
				targetEvent: $event
			});
			$mdDialog.show(dialog)
				.then(function () {
					vm.item.Values.splice($index, 1);
					$scope.editItemForm.$setDirty()
				}, null)
				.finally(function () {
					dialog = undefined;
				});
		}
	}
})();
(function () {
	'use strict';

	HandbookEntryRevisionItemController.$inject = ["$scope", "$rootScope", "ItemViewer", "itemSettings", "socket", "auUtility"];
	angular
		.module('app')
		.controller('HandbookEntryRevisionItemController', HandbookEntryRevisionItemController);

	/* @ngInject */
	function HandbookEntryRevisionItemController($scope, $rootScope, ItemViewer, itemSettings, socket, auUtility) {
		var vm = this;

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item
        
	}
})();
(function () {
	'use strict';

	HandbookItemController.$inject = ["$scope", "$rootScope", "ItemViewer", "itemSettings", "socket", "auUtility"];
	angular
		.module('app')
		.controller('HandbookItemController', HandbookItemController);

	/* @ngInject */
	function HandbookItemController($scope, $rootScope, ItemViewer, itemSettings, socket, auUtility) {
		var vm = this;
		vm.orgName = $rootScope.Organization.Name

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item
        
	}
})();
(function () {
	'use strict';

	HandbookEntryItemController.$inject = ["$scope", "$rootScope", "ItemViewer", "itemSettings", "socket", "auUtility", "HandbookEntryRevision"];
	angular
		.module('app')
		.controller('HandbookEntryItemController', HandbookEntryItemController);

	/* @ngInject */
	function HandbookEntryItemController($scope, $rootScope, ItemViewer, itemSettings, socket, auUtility, HandbookEntryRevision) {
		var vm = this;
		vm.resizeDoc = 0

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
        vm.item = itemSettings.item
        
        vm.revisionHistory = HandbookEntryRevision.getCache({HandbookEntry: vm.item._id})
        $scope.$on('itemAdded', function(event, item){
			if (item.$key == 'HandbookEntryRevision' && item.HandbookEntry == vm.item._id) {
				vm.revisionHistory.push(item)
			}
		})
	}
})();
(function() {
	'use strict';

	AddHandbookDialog.$inject = ["$timeout", "$mdDialog", "$state", "Handbook"];
	angular
		.module('app')
		.controller('AddHandbookDialog', AddHandbookDialog);

	/* @ngInject */
	function AddHandbookDialog($timeout, $mdDialog, $state, Handbook) {
        var vm = this;
        
        //create a new blank Handbook
        vm.newItem = vm.handbook = new Handbook()

		//confirm a title was entered	
		vm.confirmTitleEntered = function() {
			return vm.handbook.Title
		}

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Title', value: vm.handbook.Title}
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			return vm.handbook.$saveItem()
            .then(function(item){
                return "You have successfully added: " + item.Title
            })
		}

	}
}
)();
(function () {
	'use strict';

	FundraiserParticipantController.$inject = ["$scope", "toast", "$filter", "$state", "ItemViewer", "itemSettings", "auUtility"];
	angular
		.module('app')
		.controller('FundraiserParticipantController', FundraiserParticipantController);

	/* @ngInject */
	function FundraiserParticipantController($scope, toast, $filter, $state, ItemViewer, itemSettings, auUtility) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;
	}
})();
(function () {
	'use strict';

	FundraiserItemController.$inject = ["$scope", "$rootScope", "$element", "$location", "$mdDialog", "toast", "$filter", "$state", "$http", "ItemViewer", "itemSettings", "auUtility", "Post", "socket", "FundraiserParticipant", "FundraiserOrder"];
	angular
		.module('app')
		.controller('FundraiserItemController', FundraiserItemController);

	/* @ngInject */
	function FundraiserItemController($scope, $rootScope, $element, $location, $mdDialog, toast, $filter, $state, $http, ItemViewer, itemSettings, auUtility, Post, socket, FundraiserParticipant, FundraiserOrder) {
		var vm = this;
		
		//expose Participnt to view
		vm.FundraiserParticipant = FundraiserParticipant

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
		$rootScope.fundraiser = vm.item = itemSettings.item;

		//add stars to the server key so it doesn't look empty
		vm.item.NewStripeServerKey = "*".repeat(24)

		vm.updateServerKey = function () {
			if (vm.item.NewStripeServerKey != "*".repeat(24)) {
				vm.item.StripeServerKey = vm.item.NewStripeServerKey
			}
		}

		//create an item map to quickly get an item by id
		$scope.$watch('vm.item.AvailableItems.length', function () {
			$rootScope.fundraiser.itemMap = {}
			$rootScope.fundraiser.AvailableItems.forEach(function (item) {
				$rootScope.fundraiser.itemMap[item._id] = item
			})
		})

		//create an item map to quickly get a prize by id
		$scope.$watch('vm.item.AvailablePrizes.length', function () {
			$rootScope.fundraiser.prizeMap = {}
			$rootScope.fundraiser.AvailablePrizes.forEach(function (item) {
				$rootScope.fundraiser.prizeMap[item._id] = item
			})
		})

		if (Object.byString($state, ".params.listOptions.mode") == 'edit' || $scope.ngDialogId) {
			vm.mode = 'edit'

			vm.participants = getParticipants()
			vm.buyNowOrders = getBuyNowOrders()
		} else {
			///////////////////////// PUBLIC VIEW /////////////////////////
			vm.mode = 'view'

			//set page styles
			$element.find('.single-item-viewer').addClass('full-bleed')
			$rootScope.windowFab.forceHide = true

			//create IsOpen and AfterClose vars
			vm.item.IsOpen = false; vm.item.AfterClose = false;
			$scope.$watch('vm.item.OpeningDate', updateIsOpen)
			$scope.$watch('vm.item.ClosingDate', updateIsOpen)
			function updateIsOpen() {
				var now = new Date()
				vm.item.IsOpen = vm.IsOpen = (now > vm.item.OpeningDate) && (now < vm.item.ClosingDate)
				vm.item.AfterClose = vm.AfterClose = now > vm.item.ClosingDate
			}

			//log user in from localStorage or a passed in url
			function connectParticipant() {
				var restoreParticipant = $location.search().participant || $rootScope.fundraiser.getParticipantToken()
				if (restoreParticipant == "null") restoreParticipant = null
				if (restoreParticipant) {
					$location.search('participant', null)
					$http.post("/api/restoreParticipant", { participantToken: restoreParticipant })
						.then(function (res, status) {
							if (res.data.success) {
								$rootScope.fundraiser.setParticipantToken(restoreParticipant)
								var p = new FundraiserParticipant(res.data.participant)
								FundraiserParticipant.addToCache(p)
								vm.item.$currentParticipant = p
							} else {
								throw new Error(res.data.error);
							}
						})
				}
			}

			connectParticipant()
			$rootScope.$on('socket-reconnected', connectParticipant)

		} ////////////////////// END PUBLIC VIEW SET UP ////////////////////////

		function getParticipants() {
			return FundraiserParticipant.getCache({ Fundraiser: vm.item._id }, 9999, 'Title +LastName')
		}

		function getBuyNowOrders() {
			return FundraiserOrder.getCache({ Fundraiser: vm.item._id, Participant: '0'.repeat(24) }, 50, 'BuyerName')
		}

		vm.showFundsNeeded = function () {
			FundraiserParticipant.query({ Fundraiser: vm.item._id, TotalSold__gt: 0, FundsReceived__ne: true, sort: 'Title +LastName' }, 500).$httpPromise.then(function (res) {
				vm.participants = res
				groupParticipants()
			})
		}

		vm.showPickupNeeded = function () {
			FundraiserParticipant.query({ Fundraiser: vm.item._id, TotalSold__gt: 0, OrderPickedUp__ne: true, sort: 'Title +LastName' }, 500).$httpPromise.then(function (res) {
				vm.participants = res
				groupParticipants()
			})

		}

		vm.showBuyNowPickupNeeded = function () {
			vm.searchBuyNow = ""
			FundraiserOrder.query({ Fundraiser: vm.item._id, Participant: '0'.repeat(24), TotalSold__gt: 0, OrderPickedUp__ne: true, sort: 'Title +LastName' }, 500).$httpPromise.then(function (res) {
				vm.buyNowOrders = res
			})

		}

		vm.showPrizesNeeded = function () {
			FundraiserParticipant.query({ Fundraiser: vm.item._id, TotalSold__gt: 0, SelectedPrizes__size: 0, sort: 'Title +LastName' }, 500).$httpPromise.then(function (res) {
				vm.participants = res
				groupParticipants()
			})

		}

		function groupParticipants() {
			var outParticipants = []
			if (!vm.participants || !vm.participants.length) return

			//force sort by Title
			vm.participants = $filter("orderBy")(vm.participants, 'Title')

			var lastTitle = ''
			for (var i = 0; i < vm.participants.length; i++) {
				if (lastTitle != vm.participants[i].Title) {
					outParticipants.push({ Title: vm.participants[i].Title, 'isSectionHeader': true, _id: 'Section' + vm.participants[i].Title })
				}
				outParticipants.push(vm.participants[i])
				lastTitle = vm.participants[i].Title
			}
			vm.participants = outParticipants
		}

		vm.updateParticipants = debounce(function () {
			if (!vm.searchParticipants) {
				vm.participants = getParticipants()
				return
			}

			if (isNumeric(vm.searchParticipants)) {
				return FundraiserParticipant.query({
					Fundraiser: vm.item._id,
					TotalSold: parseFloat(vm.searchParticipants)
				}).$httpPromise.then(function (res) {
					vm.participants = res
				})
			}

			FundraiserParticipant.query({
				Fundraiser: vm.item._id,
				$or: [
					{ LastName: "/^" + vm.searchParticipants.toLowerCase() + "+/gi" },
					{ FirstName: "/^" + vm.searchParticipants.toLowerCase() + "+/gi" }
				]
			}).$httpPromise.then(function (res) {
				vm.participants = res
			})
		}, 200)

		vm.updateBuyNowOrders = debounce(function () {
			if (!vm.searchBuyNow) {
				vm.buyNowOrders = getBuyNowOrders()
				return
			}

			FundraiserOrder.query({
				Fundraiser: vm.item._id,
				Participant: '0'.repeat(24),
				$or: [
					{ BuyerName: "/" + vm.searchBuyNow.toLowerCase() + "+/gi" },
					{ BuyerDetails: "/" + vm.searchBuyNow.toLowerCase() + "+/gi" }
				]
			}).$httpPromise.then(function (res) {
				vm.buyNowOrders = res
			})
		}, 200)

		vm.updateSearchPickup = debounce(function(){
			vm.buyNowOrders = []
			vm.participants = []
			if (!vm.searchPickup) {
				return
			}

			FundraiserOrder.query({
				Fundraiser: vm.item._id,
				$or: [
					{ BuyerName: "/" + vm.searchPickup.toLowerCase() + "+/gi" },
					{ BuyerDetails: "/" + vm.searchPickup.toLowerCase() + "+/gi" }
				]
			}).$httpPromise.then(function (res) {
				vm.buyNowOrders = res
			})

			FundraiserParticipant.query({
				Fundraiser: vm.item._id,
				$or: [
					{ LastName: "/^" + vm.searchPickup.toLowerCase() + "+/gi" },
					{ FirstName: "/^" + vm.searchPickup.toLowerCase() + "+/gi" }
				]
			}).$httpPromise.then(function (res) {
				vm.participants = res
			})
		}, 2000)

		vm.runItemCountReport = function ($event) {
			$http.post("/api/runItemCountReport", { fundraiser: vm.item._id })
				.then(function (res, status) {
					if (!res.data.success) {
						return toast.error('Sorry! An error occurred while running this report. Contact support.')
					}

					vm.reportItems = res.data.items
				})
		}

		vm.particpantPrizeReport = function (prize_id) {
			$http.post("/api/runPrizeParticipantReport", { fundraiser: vm.item._id, prize: prize_id })
				.then(function (res, status) {
					if (!res.data.success) {
						return toast.error('Sorry! An error occurred while running this report. Contact support.')
					}

					vm.participants = res.data.participants
					groupParticipants()

					var logP = []
					vm.participants.forEach(function (participant) {
						if (!participant.isSectionHeader) {
							var qty = 0
							participant.SelectedPrizes.forEach(function (prize) {
								if (prize.Item == prize_id) qty = prize.Qty
							})

							logP.push(participant.Title + ', ' + participant.LastName + ', ' + participant.FirstName + ', ' + qty)
						}

					})
					console.log(logP.join('\n'))

					$mdDialog.show($mdDialog.alert({
						title: 'Prize Report',
						htmlContent: '<table><tr><td><b>Group</b></td><td><b>Last Name</b></td><td><b>First Name</b></td><td><b>Count</b></td></tr><tr><td>' + logP.join('</td></tr><tr><td>').replaceAll(', ', '</td><td>') + '</td></tr></table>',
						ok: 'Close'
					}))
				})
		}

		vm.particpantItemReport = function (item_id) {
			$http.post("/api/runItemParticipantReport", { fundraiser: vm.item._id, item: item_id })
				.then(function (res, status) {
					if (!res.data.success) {
						return toast.error('Sorry! An error occurred while running this report. Contact support.')
					}

					vm.participants = res.data.participants
					groupParticipants()

					var logP = []
					vm.participants.forEach(function (participant) {
						if (!participant.isSectionHeader)
							logP.push(participant.Title + ', ' + participant.LastName + ', ' + participant.FirstName + ', ' + participant.Qty)
					})
					console.log(logP.join('\n'))

					$mdDialog.show($mdDialog.alert({
						title: 'Item Report',
						htmlContent: '<table><tr><td><b>Group</b></td><td><b>Last Name</b></td><td><b>First Name</b></td><td><b>Count</b></td></tr><tr><td>' + logP.join('</td></tr><tr><td>').replaceAll(', ', '</td><td>') + '</td></tr></table>',
						ok: 'Close'
					}))
				})
		}



		vm.getEmails = function ($event) {
			vm.allParticipants = FundraiserParticipant.getCache({ Fundraiser: vm.item._id }, 999)
		}

		vm.editParticipantOrders = function ($event, participant) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/my-orders.tmpl.html',
				controller: 'FundraiserMyOrders',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						participant: participant,
						editable: true
					}
				}
			})

		}

		var printAllParticipants = []
		var bodyHtml = ''
		vm.printAllParticipantOrders = function ($event) {
			bodyHtml = ''

			//get all participants in some logical order
			printAllParticipants = FundraiserParticipant.getCache({ Fundraiser: vm.item._id }, 999, 'LastName')

			var nextPrint = function (idx) {
				if (idx == printAllParticipants.length) return showPrint()

				var participant = printAllParticipants[idx]

				if (!participant.TotalSold) return nextPrint(idx + 1)
				
				$mdDialog.show({
					templateUrl: '/app/fundraiser/dialogs/my-orders.tmpl.html',
					controller: 'FundraiserMyOrders',
					controllerAs: 'vm',
					targetEvent: $event,
					locals: {
						options: {
							participant: participant,
							batchprint: true,
						}
					}
				}).then(function (html) {
					bodyHtml += "<div class='inner'>" + html + "</div>"
					nextPrint(idx + 1)
				})
			}
			nextPrint(0)

			function showPrint() {
				var sHTML = '<html>' +
					'<head>' +
					// baseTag +
					'<title>' + $rootScope.fundraiser.Title + ' - Orders</title>' +
					'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=RobotoDraft:100,100italic,300,300italic,400,500,700,900,400italic">' +
					'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,700,500,300,100">' +
					'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato|Oswald|Roboto+Slab">' +
					'<link rel="stylesheet" href="/fonts/css/alignus.css" />' +
					'<link rel="stylesheet" href="/bower_components/material-design-iconic-font/dist/css/material-design-iconic-font.min.css" />' +
					'<link rel="stylesheet" href="/dist-vendor.css">' +
					'<link rel="stylesheet" href="/styles/app.css?2">' +
					'<style>' +
					'html, body {background-color: white; overflow: initial;}' +
					'body {margin-top: -30px}' +
					'.inner {margin: 25px 25px; padding: 35px 50px; transform: scale(0.5);; transform-origin: top left; width: 175%; page-break-inside: avoid}' +
					'.order-functions { display: none; }' +
					'.ng-hide {display: none !important}' +
					'.print-qty-to-order, .print-header {	display: flex;	}' +
					'.list-items-column { column-count: 2} ' +
					'</style>' +
					'</head><body><div class="fundraiser-dialog">' +
					bodyHtml +
					'</div></body>' +
					'</html>';

				var oWindow = window.open('about:blank', null, 'toolbar=yes,location=no,status=yes,menubar=yes,scrollbars=yes,resizable=yes');

				var doc = oWindow.document;
				doc.open();
				doc.write(sHTML);
				doc.close();
			}
		}


		vm.enterParticipantOrder = function ($event, participant) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/enter-order.tmpl.html',
				controller: 'FundraiserEnterOrder',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						fundraiser: vm.item,
						participant: participant
					}
				}
			})
		}

		/////// public view functions ////////////////


		vm.getPinnedPosts = function () {
			return Post.getCache({ Page: vm.item._id, IsPinned: true }, 300, "-DateCreated").$httpPromise
		}

		vm.addItem = function () {
			vm.item.AvailableItems.push({ _id: (new ObjectId()).toString(), Title: vm.newTitle, Description: vm.newDescription, Cost: vm.newCost })

			reset()

			function reset() {
				vm.newTitle = ""
				vm.newDescription = ""
				vm.newCost = ""
			}
		}

		vm.removeItem = function (idx, $event) {
			var confirmDialog = $mdDialog.confirm({
				title: 'Confirm Removal',
				textContent: 'Are you sure you want to remove this item?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})
			$mdDialog.show(confirmDialog)
				.then(function () {
					vm.item.AvailableItems.splice(idx, 1)
				})
		}

		vm.addPrize = function () {
			vm.item.AvailablePrizes.push({ _id: (new ObjectId()).toString(), Title: vm.newPrizeTitle, Description: vm.newPrizeDescription, Cost: vm.newPrizeCost })

			reset()

			function reset() {
				vm.newPrizeTitle = ""
				vm.newPrizeDescription = ""
				vm.newPrizeCost = ""
			}
		}

		vm.removePrize = function (idx, $event) {
			var confirmDialog = $mdDialog.confirm({
				title: 'Confirm Removal',
				textContent: 'Are you sure you want to remove this prize?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})
			$mdDialog.show(confirmDialog)
				.then(function () {
					vm.item.AvailablePrizes.splice(idx, 1)
				})
		}



		////////////////////////////////
		// public view methods
		////////////////////////////////

		vm.signUp = function ($event, isAdmin) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/new-participant.tmpl.html',
				controller: 'FundraiserNewParticipant',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: { isAdmin: isAdmin }
				}
			})
		}

		vm.logIn = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/login-participant.tmpl.html',
				controller: 'FundraiserLoginParticipant',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {

				}
			})
		}

		vm.logout = function ($event) {
			var confirmDialog = $mdDialog.confirm({
				title: 'Confirm Logout',
				textContent: 'Are you sure you want to log out?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})
			$mdDialog.show(confirmDialog)
				.then(function () {
					$rootScope.fundraiser.setParticipantToken(null)
					delete vm.item.$currentParticipant
				})

			FundraiserOrder.init()
			FundraiserParticipant.init()
		}

		vm.openMyAccount = function ($event, user) {
			if (user) {
				$rootScope.fundraiser.$currentParticipant = user
			}
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/my-account.tmpl.html',
				controller: 'FundraiserMyAccount',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {

				}
			})
		}

		vm.enterOrder = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/enter-order.tmpl.html',
				controller: 'FundraiserEnterOrder',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {}
				}
			})
		}

		vm.myOrders = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/my-orders.tmpl.html',
				controller: 'FundraiserMyOrders',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {}
				}
			})

		}

		vm.shopPrizes = function ($event, participant) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/list-items.tmpl.html',
				controller: 'FundraiserListItems',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						title: 'Shop Prizes',
						intro: vm.item.PrizeIntro,
						items: vm.item.AvailablePrizes,
						size: 100,
						showAddPrizes: true,
						orderBy: 'Cost',
						participant: participant,
						showPrizeSummary: !!participant
					}
				}
			})
		}

		//expose additional methods available on the api
		vm.item.showAvailableItems = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/list-items.tmpl.html',
				controller: 'FundraiserListItems',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						title: 'Available Items',
						intro: '',
						items: vm.item.AvailableItems,
						size: 100,
						showQtySold: true,
						showPrint: true
					}
				}
			})
		}

		vm.item.showAvailblePrizes = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/list-items.tmpl.html',
				controller: 'FundraiserListItems',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						title: 'All Prizes',
						intro: vm.item.PrizeIntro,
						items: vm.item.AvailablePrizes,
						size: 100,
						showQtySelected: true,
						orderBy: 'Cost'
					}
				}
			})
		}

		vm.item.showBuyNow = function ($event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/buy-now.tmpl.html',
				controller: 'FundraiserBuyNow',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
					}
				}
			})
		}

		if ($location.hash() == "buynow") {
			vm.item.showBuyNow()
		}

	}
})();
(function() {
	'use strict';

	FundraiserNewParticipant.$inject = ["$scope", "$rootScope", "$timeout", "$http", "toast", "FundraiserParticipant", "options"];
	angular
		.module('app')
		.controller('FundraiserNewParticipant', FundraiserNewParticipant);

	/* @ngInject */
	function FundraiserNewParticipant($scope, $rootScope, $timeout, $http, toast, FundraiserParticipant, options) {
		var vm = this;
		window.FundraiserNewParticipant = vm //expose to window for recaptcha

		if (options) {
			if (options.isAdmin) {
				vm.isAdmin = true
			}
		}

		vm.setCaptcha = function (resp) {
			$scope.$apply(function () {
				vm.user.captcha = resp
			})
		}

		vm.disableNext = true

		vm.user = {
			Organization: $rootScope.fundraiser.Organization,
			Fundraiser: $rootScope.fundraiser._id
		}
		$scope.$watch('vm.user', function(){
			if ($rootScope.user.$AnonymousUser) {
				vm.disableNext = !(vm.user.FirstName && vm.user.LastName && vm.user.Username && vm.user.Password && vm.user.Password == vm.newParticipantConfirmPassword && vm.user.Email && vm.user.Title && vm.user.captcha)
			} else {
				vm.disableNext = !(vm.user.FirstName && vm.user.LastName && vm.user.Username && vm.user.Title)
			}
		}, true)

		vm.generateUsername = function(){
			vm.user.Username = ('' + (vm.user.FirstName || '') + '.' + (vm.user.LastName || '')).toLowerCase()
			vm.verifyUsername()
		}

		vm.verifyUsername = debounce(function(){
			var checkedUsername = vm.user.Username
			$http.post("/api/verifyParticipantUsername", {Fundraiser: $rootScope.fundraiser._id, Username: vm.user.Username})
            .then(function(res, status) {
				if (!res.data.success && checkedUsername == vm.user.Username) {
					toast.error('Sorry! ' + checkedUsername + ' is already taken for this fundraiser. Try logging in.')
					vm.user.Username += '_' + parseInt(Math.random() * 10)
					vm.verifyUsername()
				}
            })
		}, 1000)


		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'First Name', value: vm.user.FirstName},
					{name: 'Last Name', value: vm.user.LastName},
					{name: 'Recovery Email', value: vm.user.Email},
					{name: 'Group', value: vm.user.Title},
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			//disable button
			vm.disableNext = true

			if (vm.isAdmin) {
				vm.user = new FundraiserParticipant(vm.user)
				vm.user.PasswordHash = Date.now()
				return vm.user.$saveItem() 
			}
			
            return $http.post("/api/newParticipant", vm.user)
            .then(function(res, status) {
				if (res.data.success) {
					$rootScope.fundraiser.setParticipantToken(res.data.participantToken)
					
					vm.user._id = res.data._id
					vm.user.SelectedPrizes = []
					vm.user.TotalSold = 0

					var p = new FundraiserParticipant(vm.user)
					FundraiserParticipant.addToCache(p)

					$rootScope.fundraiser.$currentParticipant = p
					return "Thank you for signing up, " + vm.user.FirstName + "! You're all set to Enter Orders. Go ahead and close this."
                } else {
					throw new Error(res.data.error);
				}
            })
		}
	}
}
)();

//required as a top level function so the callback can happen
function newFundraiserParticipantResp(resp) {
	FundraiserNewParticipant.setCaptcha(resp)
}
(function () {
	'use strict';

	FundraiserMyOrders.$inject = ["$scope", "$rootScope", "$timeout", "$http", "$mdDialog", "toast", "FundraiserOrder", "options"];
	angular
		.module('app')
		.controller('FundraiserMyOrders', FundraiserMyOrders);

	/* @ngInject */
	function FundraiserMyOrders($scope, $rootScope, $timeout, $http, $mdDialog, toast, FundraiserOrder, options) {
		var vm = this;
		vm.cancel = $mdDialog.cancel

		//copy options to vm
		//angular.extend(vm, options)
		vm.orderBy = ''

		if (options.participant) {
			vm.orders = FundraiserOrder.getCache({
				Participant: options.participant._id,
			})
			vm.editable = true
		} else {
			options.participant = $rootScope.fundraiser.$currentParticipant
			vm.orders = FundraiserOrder.getCache({
				Fundraiser: $rootScope.fundraiser._id, //must specify because of api restrictions
				Participant: $rootScope.fundraiser.$currentParticipant._id //the api also specifies but this is needed when you're also an admin
			})
		}
		//expose participant to view
		vm.participant = options.participant

		//was getting double entry errors - because the prize selection is not good
		//this de-dupes the data
		vm.participant.$selectedPrizes = []
		vm.participant.SelectedPrizes.forEach(function(prize){
			if (vm.participant.$selectedPrizes[prize.Item] == undefined) {
				vm.participant.$selectedPrizes[prize.Item] = vm.participant.$selectedPrizes.length
				vm.participant.$selectedPrizes.push(prize)
			}
		})

		vm.orders.$httpPromise.then(function () {
			vm.orderSummary = []
			vm.orders.forEach(function (order) {
				order.Items.forEach(function (item) {
					//Item & Qty
					if (vm.orderSummary[item.Item] == undefined) {
						vm.orderSummary[item.Item] = vm.orderSummary.length
						vm.orderSummary.push($rootScope.fundraiser.itemMap[item.Item])
						vm.orderSummary[vm.orderSummary[item.Item]].SumQty = item.Qty
					} else {
						vm.orderSummary[vm.orderSummary[item.Item]].SumQty += item.Qty
					}
				})

			})

			
			if (options.batchprint) {
				$timeout(function(){
					var divHtml = angular.element('.section-to-print').html()
					$mdDialog.hide(divHtml)
				})
			}
		})

		vm.deleteOrder = function (item, index, $event) {
			$mdDialog.show($mdDialog.confirm({
				title: 'Remove Order?',
				textContent: 'Are you sure you want to remove your order for ' + item.BuyerName + '?',
				ok: 'Yes',
				cancel: 'Nevermind',
				targetEvent: $event
			})).then(function () {
				//server
				$http.post('/api/removeOrder', {
					participantToken: $rootScope.fundraiser.getParticipantToken(),
					Participant: item.Participant,
					Order: item._id
				}).then(function (response) {
					if (response.data.success) {
						//client
						for (var i = 0; i < vm.orders.length; i++) {
							if (vm.orders[i]._id == item._id) {
								vm.orders.splice(i, 1)
								break;
							}
						}
						toast.success('Order removed.')
					} else {
						toast.error('Sorry but an error occured.')
					}
				})
			})
		}

		vm.editOrder = function (order, $event) {
			$mdDialog.show({
				templateUrl: '/app/fundraiser/dialogs/enter-order.tmpl.html',
				controller: 'FundraiserEnterOrder',
				controllerAs: 'vm',
				targetEvent: $event,
				locals: {
					options: {
						order: order
					}
				}
			})
		}

		vm.print = function () {
			var divHtml = angular.element('.section-to-print').html()
			var sHTML = '<html>' +
				'<head>' +
				// baseTag +
				'<title>' + $rootScope.fundraiser.Title + ' - Orders</title>' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=RobotoDraft:100,100italic,300,300italic,400,500,700,900,400italic">' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,700,500,300,100">' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato|Oswald|Roboto+Slab">' +
				'<link rel="stylesheet" href="/fonts/css/alignus.css" />' +
				'<link rel="stylesheet" href="/bower_components/material-design-iconic-font/dist/css/material-design-iconic-font.min.css" />' +
				'<link rel="stylesheet" href="/dist-vendor.css">' +
				'<link rel="stylesheet" href="/styles/app.css?2">' +
				'<style>' +
				'html, body {background-color: white; overflow: initial;}' +
				'body {margin-top: -30px}' +
				'.inner {margin: 25px 25px; padding: 35px 50px; transform: scale(0.5);; transform-origin: top left; width: 175%;}' +
				'.order-functions { display: none; }' +
				'.ng-hide {display: none !important}' +
				'.print-qty-to-order, .print-header {	display: flex;	}' +
				'.list-items-column { column-count: 2} ' +
				'</style>' +
				'</head><body><div class="inner fundraiser-dialog">' +
				divHtml +
				'</div></body>' +
				'<script>setTimeout(function(){window.print();window.close()}, 250);</script>' +
				'</html>';

			var oWindow = window.open('about:blank', null, 'toolbar=yes,location=no,status=yes,menubar=yes,scrollbars=yes,resizable=yes');

			var doc = oWindow.document;
			doc.open();
			doc.write(sHTML);
			doc.close();
		}


	}
}
)();
(function () {
	'use strict';

	FundraiserMyAccount.$inject = ["$scope", "$rootScope", "$timeout", "$http", "toast", "$mdDialog"];
	angular
		.module('app')
		.controller('FundraiserMyAccount', FundraiserMyAccount);

	/* @ngInject */
	function FundraiserMyAccount($scope, $rootScope, $timeout, $http, toast, $mdDialog) {
		var vm = this;
		vm.saveDisabled = true
		vm.changePasswordDisabled = true

		//we're editing the root participant
		vm.user = $rootScope.fundraiser.$currentParticipant
		var origUserName = vm.user.Username

		//remove previous password changes
		delete vm.user.Password
		delete vm.user.participantConfirmPassword

		//update saveDisabled when a change occurs
		$scope.$watch('vm.user', function () {
			vm.saveDisabled = !(vm.user.FirstName && vm.user.LastName && vm.user.Username && vm.user.Email && vm.user.Title)
			vm.changePasswordDisabled = !(vm.user.Password && vm.user.Password == vm.user.participantConfirmPassword)
		}, true)
		
		vm.generateUsername = function () {
			vm.user.Username = vm.user.FirstName.toLowerCase() + '.' + vm.user.LastName.toLowerCase()
			vm.verifyUsername()
		}

		vm.verifyUsername = debounce(function () {
			if (vm.user.Username == origUserName) return

			var checkedUsername = vm.user.Username
			$http.post("/api/verifyParticipantUsername", { Fundraiser: $rootScope.fundraiser._id, Username: vm.user.Username })
				.then(function (res, status) {
					if (!res.data.success && checkedUsername == vm.user.Username) {
						toast.error('Sorry! ' + checkedUsername + ' is already taken for this fundraiser.')
						vm.user.Username += '_' + parseInt(Math.random() * 10)
					}
				})
		}, 1000)

		//complete the user request to finish the dialog		
		vm.saveMyAccount = function () {
			//disable button
			vm.saveDisabled = true

			return $http.post("/api/updateParticipant", {
				participantToken: $rootScope.fundraiser.getParticipantToken() || true,
				participant: vm.user
			}).then(function (res, status) {
				if (res.data.success) {
					toast.success('Account updated.', true)
					$mdDialog.hide()
				} else {
					toast.error('Error updating account.')
				}
			})
		}
	}
}
)();
(function() {
	'use strict';

	FundraiserLoginParticipant.$inject = ["$scope", "$rootScope", "$timeout", "$http", "$mdDialog", "toast", "FundraiserParticipant"];
	angular
		.module('app')
		.controller('FundraiserLoginParticipant', FundraiserLoginParticipant);

	/* @ngInject */
	function FundraiserLoginParticipant($scope, $rootScope, $timeout, $http, $mdDialog, toast, FundraiserParticipant) {
		var vm = this;
		vm.cancel = $mdDialog.cancel
		
		vm.login = function($event){
			if (!vm.username || !vm.password) {
				return toast.error('Enter both username and password.')
			}

			//disable button
			vm.loginDisabled = true
			
            return $http.post("/api/loginParticipant", {
				Fundraiser: $rootScope.fundraiser._id,
				Username: vm.username,
				Password: vm.password
			})
            .then(function(res, status) {
				if (res.data.success) {
					$rootScope.fundraiser.setParticipantToken(res.data.participantToken)
					var p = new FundraiserParticipant(res.data.participant)
					FundraiserParticipant.addToCache(p)
					$rootScope.fundraiser.$currentParticipant = p
					$mdDialog.hide()	
				} else {
					toast.error('Invalid username/password.')
				}
            }).finally(function(){
				vm.loginDisabled = false
			})
		}

		vm.forgot = function($event){
			return $http.post("/api/forgotParticipant", {
				Fundraiser: $rootScope.fundraiser._id,
				Email: vm.email
			})
            .then(function(res) {
				if (res.data.success) {
					$mdDialog.hide();

					$mdDialog.show($mdDialog.alert({
						title: 'Email Sent',
						textContent: 'Please check your email to access your participant account.',
						ok: 'Okay',
						targetEvent: $event
					}))
                } else {
					toast.error('Participant not on file for this fundraiser. Please Sign Up!')
				}
            })
		}
	}
}
)();
(function () {
	'use strict';

	FundraiserListItems.$inject = ["$scope", "$rootScope", "$timeout", "$http", "$mdDialog", "toast", "User", "options"];
	angular
		.module('app')
		.controller('FundraiserListItems', FundraiserListItems);

	/* @ngInject */
	function FundraiserListItems($scope, $rootScope, $timeout, $http, $mdDialog, toast, User, options) {
		var vm = this;
		vm.cancel = $mdDialog.cancel

		//copy options to vm
		angular.extend(vm, options)

		if (!vm.participant) vm.participant = $rootScope.fundraiser.$currentParticipant

		vm.print = function () {
			var divHtml = angular.element('.section-to-print').html()
			var sHTML = '<html>' +
				'<head>' +
				// baseTag +
				'<title>' + $rootScope.fundraiser.Title + ' - Order Form</title>' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=RobotoDraft:100,100italic,300,300italic,400,500,700,900,400italic">' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,700,500,300,100">' +
				'<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Lato|Oswald|Roboto+Slab">' +
				'<link rel="stylesheet" href="/fonts/css/alignus.css" />' +
				'<link rel="stylesheet" href="/bower_components/material-design-iconic-font/dist/css/material-design-iconic-font.min.css" />' +
				'<link rel="stylesheet" href="/dist-vendor.css">' +
				'<link rel="stylesheet" href="/styles/app.css?1">' +
				'<style>' +
				'body {background-color: white;}' +
				'.inner {transform: scale(.5); transform-origin: top left; width: 200%;}' +
				'.ng-hide {display: none !important}' +
				'.print-qty-to-order, .print-header {	display: flex;	}' +
				'.list-items-column { column-count: 2} ' +
				'</style>' +
				'</head><body><div class="inner">' +
				divHtml +
				'</div></body>' +
				'<script>setTimeout("window.print();window.close();",1000)</script>' +
				'</html>';

			var oWindow = window.open('about:blank', null, 'toolbar=yes,location=no,status=yes,menubar=yes,scrollbars=yes,resizable=yes');

			var doc = oWindow.document;
			doc.open();
			doc.write(sHTML);
			doc.close();
		}

		vm.fundsEarned = 0
		$scope.$watch('vm.participant.TotalSold', function () {
			if (!vm.participant) return 0 

			vm.fundsEarned = parseInt(vm.participant.TotalSold * ($rootScope.fundraiser.IncentivePercentage / 100))

			// if they sold anything, but haven't earned a dollar yet, give them a dollar
			if (vm.participant.TotalSold && !vm.fundsEarned) vm.fundsEarned = 1
		})
		vm.fundsSpent = 0

		$scope.$watch('vm.participant.SelectedPrizes', function () {
			if (!vm.participant) return []
			
			var selected = vm.participant.SelectedPrizes
			vm.fundsSpent = 0
			selected.forEach(function (prize) {
				vm.fundsSpent += ($rootScope.fundraiser.prizeMap[prize.Item].Cost * prize.Qty)
			})
		}, true)

		vm.fundsAvailable = function (cost) {
			var avail = vm.fundsEarned - vm.fundsSpent
			if (avail >= cost) return true
			return false
		}

		vm.getQty = function (item_id) {
			for (var i = 0; i < vm.participant.SelectedPrizes.length; i++) {
				if (vm.participant.SelectedPrizes[i].Item == item_id) {
					return vm.participant.SelectedPrizes[i].Qty
				}
			}
			return 0
		}

		vm.updateQty = function (item, qty) {
			var existingItemIdx = -1
			for (var i = 0; i < vm.participant.SelectedPrizes.length; i++) {
				if (vm.participant.SelectedPrizes[i].Item == item._id) {
					existingItemIdx = i
					break
				}
			}

			if (existingItemIdx > -1) {
				vm.participant.SelectedPrizes[existingItemIdx].Qty += qty

				if (vm.participant.SelectedPrizes[existingItemIdx].Qty <= 0) {
					vm.participant.SelectedPrizes.splice(existingItemIdx, 1)
				}
			} else if (qty > 0) {
				vm.participant.SelectedPrizes.push({
					Item: item._id,
					Qty: 1
				})
			}
		}

		vm.savePrizeSelections = function () {
			var participant = vm.participant
			participant.$participantToken = $rootScope.fundraiser.getParticipantToken()

			participant.$updateItem().$promise.then(function () {
				$mdDialog.hide()
				toast.success('Saved Prize Selections 👍', true)
			})
		}
	}
}
)();
(function () {
	'use strict';

	FundraiserEnterOrder.$inject = ["$scope", "$rootScope", "$timeout", "$http", "toast", "FundraiserOrder", "options"];
	angular
		.module('app')
		.controller('FundraiserEnterOrder', FundraiserEnterOrder);

	/* @ngInject */
	function FundraiserEnterOrder($scope, $rootScope, $timeout, $http, toast, FundraiserOrder, options) {
		var vm = this;
		vm.newOrder = {} //for no-good-reason, i use this in the ui rather than the direct array references

		if (options.order) {
			vm.order = options.order
			vm.order.Items.forEach(function (item) {
				vm.newOrder[item.Item] = item.Qty
			})
			updateItem()
		} else {
			//set up new order document
			vm.order = new FundraiserOrder({
				Fundraiser: Object.byString(options, "fundraiser._id") || $rootScope.fundraiser._id,
				Participant: Object.byString(options, "participant._id") || $rootScope.fundraiser.$currentParticipant._id
			})
		}
		if (!options.participant) vm.order.$participantToken = $rootScope.fundraiser.getParticipantToken()

		//disable next per step
		vm.disableNext = true
		$scope.$watch(function () {
			if (!vm.wizardSteps) return //initing

			return vm.wizardSteps.getStep('current')
		}, function () {
			vm.disableNext = true
			disableNextForStep()
		})
		$scope.$watch('vm.order', disableNextForStep, true)
		$scope.$watch('vm.newOrder', disableNextForStep, true)

		function disableNextForStep() {
			if (!vm.wizardSteps) return //initing

			switch (vm.wizardSteps.getStep('current')) {
				case 0:
					if (!vm.order.BuyerName) return
					vm.disableNext = vm.order.BuyerName.length < 3
					break;
				case 1:
					vm.disableNext = Object.keys(vm.newOrder).length == 0
					break;
				case 2:
					vm.disableNext = false
			}
		}

		//update quantity
		vm.updateQty = function (item, qty) {
			if (vm.newOrder[item._id] == undefined) vm.newOrder[item._id] = 0
			vm.newOrder[item._id] += qty
			if (vm.newOrder[item._id] <= 0) delete vm.newOrder[item._id]
			updateItem()
		}

		function updateItem() {

			vm.order.OrderTotal = 0, vm.totalItems = 0, vm.order.Items = []
			for (var item_id in vm.newOrder) {
				vm.order.Items.push({
					Item: item_id,
					Qty: vm.newOrder[item_id]
				})
				vm.totalItems += vm.newOrder[item_id]
				vm.order.OrderTotal += $rootScope.fundraiser.itemMap[item_id].Cost * vm.newOrder[item_id]
			}
		}

		//return an object when the user gets to the review step		
		vm.review = function () {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: []
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function () {
			//disable button
			vm.disableNext = true

			if (!vm.order._id) {
				return vm.order.$saveItem().then(function (order) {
					return 'Order entered! Thank you! Go ahead and click CLOSE.'
				})
			} else {
				return vm.order.$updateItem().$promise.then(function (order) {
					console.log(order)
					return 'Order updated!'

				})
			}
		}
	}
}
)();
(function () {
	'use strict';

	FundraiserBuyNow.$inject = ["$scope", "$rootScope", "$timeout", "$http", "toast", "FundraiserOrder", "options", "$mdDialog", "FundraiserParticipant"];
	angular
		.module('app')
		.controller('FundraiserBuyNow', FundraiserBuyNow);

	/* @ngInject */
	function FundraiserBuyNow($scope, $rootScope, $timeout, $http, toast, FundraiserOrder, options, $mdDialog, FundraiserParticipant) {
		var vm = this;
		vm.cancel = $mdDialog.cancel
		vm.newOrder = {} //use this in the ui rather than the direct array references
		vm.stepNbr = 0

		vm.participants = FundraiserParticipant.getCache({ Fundraiser: $rootScope.fundraiser._id }, 9999)

		vm.order = new FundraiserOrder({
			Fundraiser: $rootScope.fundraiser._id,
			Participant: null
		})
		//disable next per step

		$scope.$watch('vm.order', disableNextForStep, true)
		$scope.$watch('vm.newOrder', disableNextForStep, true)
		$scope.$watch('vm.creditCardOkay', disableNextForStep)

		function disableNextForStep() {
			if (vm.order.OrderTotal) {
				vm.proceedToCheckoutOkay = true

				if (client_secret && vm.order.Participant != null && vm.order.FirstName && vm.order.LastName
					&& vm.order.BuyerEmail && vm.order.BuyerDetails
					&& vm.creditCardOkay) {
					vm.proceedToPayOkay = true
				} else {
					vm.proceedToPayOkay = false
				}
			} else {
				vm.proceedToCheckoutOkay = false
			}
		}

		//update quantity
		vm.updateQty = function (item, qty) {
			if (vm.newOrder[item._id] == undefined) vm.newOrder[item._id] = 0
			vm.newOrder[item._id] += qty
			if (vm.newOrder[item._id] <= 0) delete vm.newOrder[item._id]
			updateItem()
		}

		function updateItem() {
			vm.order.OrderTotal = 0, vm.totalItems = 0, vm.order.Items = []
			for (var item_id in vm.newOrder) {
				vm.order.Items.push({
					Item: item_id,
					Qty: vm.newOrder[item_id]
				})
				vm.totalItems += vm.newOrder[item_id]
				vm.order.OrderTotal += $rootScope.fundraiser.itemMap[item_id].Cost * vm.newOrder[item_id]
			}
		}

		vm.backToItems = function () {
			vm.stepNbr--
		}

		var client_secret, card, stripe

		var setupStripe = true
		vm.proceedToCheckout = function () {
			vm.stepNbr++

			// A reference to Stripe.js initialized with your real test publishable API key.
			$http.post("/api/create-payment-intent", vm.order)
			.then(function (response) {
				client_secret = response.data.clientSecret
			}).catch(function (err) {
				toast.error('An error occurred which requires you to go back.')
				vm.stepNbr--
			})
			
			if (!setupStripe) return
			setupStripe = false
			
			stripe = Stripe($rootScope.fundraiser.StripeClientKey);
			var elements = stripe.elements({
				fonts: [
					{
						cssSrc: 'https://fonts.googleapis.com/css?family=Roboto',
					},
				]
			});

			card = elements.create('card', {
				iconStyle: 'solid',
				style: {
					base: {
						iconColor: 'black',
						color: '#ccc',
						fontWeight: 500,
						fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
						fontSize: '16px',
						fontSmoothing: 'antialiased',

						':-webkit-autofill': {
							color: 'green',
						},
						'::placeholder': {
							color: '#ccc',
						},
					},
					invalid: {
						iconColor: 'red',
						color: 'red',
					},
				},
			});
			card.mount("#card-element")


			card.on("change", function (event) {
				$scope.$apply(function () {
					if (event.complete) {
						vm.creditCardOkay = true
					} else {
						vm.creditCardOkay = false
					}
				})
			});
		}

		vm.backToCheckout = function () {
			vm.stepNbr--
		}

		vm.payNow = function () {
			vm.stepNbr++

			//disable button
			vm.proceedToPayOkay = false

			vm.order.BuyerName = vm.order.FirstName + ' ' + vm.order.LastName

			vm.processingOrder = true
			vm.orderComplete = false
			vm.orderError = null

			stripe.confirmCardPayment(client_secret, {
				payment_method: {
					card: card
				}
				//How to pass the order details or customer email here?
			}).then(function (result) {
				$scope.$apply(function(){
					if (result.error) {
						vm.processingOrder = false
						vm.orderError = result.error.message
					} else {
						if (result.paymentIntent.status == "succeeded") {
							vm.order.ReceivedPayment = true
							vm.order.PaymentReference = result.paymentIntent.id

							$http.post('/api/buy-now-order', vm.order).then(function (response) {
								var order = response.data
								if (order._id) {
									vm.orderComplete = true
									vm.processingOrder = false
								} else {
									vm.processingOrder = false
									vm.orderError = result.error.message
								}
							}).catch(function (err) {
								vm.processingOrder = false
								vm.orderError = err.toString()
							})
						} else {
							vm.processingOrder = false
							vm.orderError = "paymentIntent received with " + result.paymentIntent.status
						}


					}
				})
			});
		}

	}
}
)();
(function () {
	'use strict';

	DocumentItemController.$inject = ["$scope", "$rootScope", "$element", "toast", "$filter", "$state", "$timeout", "ItemViewer", "itemSettings", "socket", "auUtility"];
	angular
		.module('app')
		.controller('DocumentItemController', DocumentItemController);

	/* @ngInject */
	function DocumentItemController($scope, $rootScope, $element, toast, $filter, $state, $timeout, ItemViewer, itemSettings, socket, auUtility) {
		var vm = this;
		vm.resizeDoc = 0
		var card
		vm.orgName = $rootScope.Organization.Name

		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)

		//expose the item to the view
		vm.item = itemSettings.item
		
		vm.requestUpdate = function () {
			$mdDialog.show({
				controller: 'RequestUpdateController',
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: '/app/project/dialogs/request-update.tmpl.html',
				locals: {
					options: { item: vm.item }
				}
			})
		}
	}
})();
(function() {
	'use strict';

	AddDocumentDialog.$inject = ["$timeout", "toast", "User", "Document", "$mdDialog", "auUtility"];
	angular
		.module('app')
		.controller('AddDocumentDialog', AddDocumentDialog);

	/* @ngInject */
	function AddDocumentDialog($timeout, toast, User, Document, $mdDialog, auUtility) {
		var vm = this;
        vm.newItem = vm.document = new Document({
			Editors:[],
		})
		vm.orgName = $rootScope.Organization.Name

		vm.transformChip = function(chip){
			return chip
		}

		vm.confirmTitleEntered = function(){
            return vm.document.Title
        }

		function getDisplayableEditors() {
			return vm.document.Editors.map(function(editorsId) {
				return $filter('fullNameFilter')(editorsId)
			}).join(', ')
		}

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Title', value: vm.document.Title},
					{name: 'Private', value: (vm.document.IsPrivate ? 'Editors only' : 'All Users in ' + vm.orgName)},
                    {name: 'Editors', value: (vm.document.Editors.length > 0 ? getDisplayableEditors() : 'Just Me')}
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			return vm.document.$saveItem()
			.then(function(item){
				return "You have successfully added: " + item.Title
			})
		}

	}
}
)();
(function() {
    'use strict';

    angular
        .module('app.authentication', []);
})();
(function() {
    'use strict';

    ToSController.$inject = ["$scope", "$state", "$mdToast", "$filter", "$http", "$q", "$mdDialog", "$location"];
    angular
        .module('app.authentication')
        .controller('ToSController', ToSController);

    /* @ngInject */
    function ToSController($scope, $state, $mdToast, $filter, $http, $q, $mdDialog, $location) {
        var vm = this;
		
		
    }
})();

(function() {
    'use strict';

    SignupController.$inject = ["$scope", "$state", "$window", "toast", "$http", "$filter", "$rootScope", "$q", "$mdDialog", "httpError", "usStates"];
    angular
        .module('app.authentication')
        .controller('SignupController', SignupController);

    /* @ngInject */
    function SignupController($scope, $state, $window, toast, $http, $filter, $rootScope, $q, $mdDialog, httpError, usStates) {
		//size bg to inside if it's bigger
		document.getElementById('authBG').style.height = (document.getElementById("ui-login").offsetHeight + 20) + 'px'

		var vm = this;
		
		vm.setCaptcha = function (resp) {
			$scope.$apply(function () {
				vm.user.captcha = resp
			})
		}
		window.SignupController = vm //expose this for the callback function at the bottom

        vm.signupClick = signupClick;
        vm.user = {
            firstName: "",
            lastName: "",
            email: "",
            organization: "",
            industry: "",
            city: "",
			state: "",
			signUpGoals: {}
        };
        vm.states = usStates;
        vm.countries = ['murica1', 'murica2', 'murica3'];
        vm.industries = [
			'Start-Up / Small Business',
			'Volunteer / Community Group',
			'School Group',
			'School District',
			'Church / Religious Institution',
			'Family / Personal'
		]

        init()

        ////////////////

        function init() {
            // loadStates()
        }

        function loadStates() {
            $http.get("/api/states")
            .success(function(data) {
                vm.states = data.map(function(stateObj) {
                    return stateObj.name
                })
            })
        }

		function signupClick() {
			//disable button
			$scope.signup.$invalid = true

			$mdDialog.show($mdDialog.alert({
				title: "Account creation in process.",
				textContent: "Redirecting... Please give the app time to load while your organization is being created... (it's fast to load after that!)",
				ok: "Ok"
			}))

            $http.post("/api/signup", vm.user)
            .then(function(res, status) {
                if (res.data.success) {
					window.location = "/loginonce?id=" + encodeURIComponent(res.data.authToken)
                } else {
					var err = httpError.parse(res.data, true);
					signupFailureDialog(err);
				}
            })
            .catch(function(err){
            	signupFailureDialog('Internal error.')
            })

        }

		// Success popup. Returns a promise for when OK is clicked
		function signupSuccessDialog() {
			return $q(function(resolve, reject) {
				var alert = $mdDialog.alert({
					title: "Awesome!",
					textContent: "You have successfully signed up!\n" +
						"\n" +
						"Check your e-mail for your log in link.",
					ok: "Ok"
				});

				$mdDialog.show(alert).finally(function() {
					alert = undefined;
					resolve();
				})
			})
		}

		// Failure popup. Returns a promise when "Go back" is clicked
		function signupFailureDialog(err) {
			return $q(function(resolve, reject) {
				var alert = $mdDialog.alert({
					title: "Oh no!",
					textContent: "Something went wrong!\n" + err + ".",
					ok: "Try again"
				});

				$mdDialog.show(alert).finally(function() {
					alert = undefined;
					resolve();
				});
			})
		}
    }
})();

//required as a top level function so the callback can happen
function recaptchaResp(resp) {
	SignupController.setCaptcha(resp)
}
(function () {
	'use strict';

	SelectController.$inject = ["$scope", "$state", "$http", "$rootScope", "$mdDialog", "$window", "$location", "$filter", "$timeout", "Authorization", "socket", "Schema", "toast", "manageUsers"];
	angular
		.module('app.authentication')
		.controller('SelectController', SelectController);

	/* @ngInject */
	function SelectController($scope, $state, $http, $rootScope, $mdDialog, $window, $location, $filter, $timeout, Authorization, socket, Schema, toast, manageUsers) {
		var vm = this
		vm.showingUserSelect = false

		// try to get the list of selectable users from local state params
		// (should exist if we were redirected from login)
		vm.users = $state.params.localOptions.users

		// if we couldn't get the list of users from local params, it's been
		// encoded and passed in the URL as "udata" (for google auth)
		if (!vm.users && $state.params.udata) {
			vm.users = JSON.parse(atob($state.params.udata))
		}

		// if we were instructed to use the list of users in localStorage, do so
		// for when users click switch accounts
		if (!vm.users || $state.params.uls == 'true') {
			vm.users = manageUsers.getSelectableUsers()
			vm.showingUserSelect = true
		}

		//if something weird happened, just go back to /login
		if (!vm.users.length) {
			return $state.go('authentication.login')
		}

		//convert LastModified.Date to JS Date
		vm.users.forEach(function (user) {
			if (!Object.byString(user, 'LastModified.Date'))
				user.LastModified = { Date: new Date() }
			else user.LastModified.Date = new Date(user.LastModified.Date)
		})

		function showLoginErr(errMsg){
			angular.element('#loading-container').fadeOut('fast')
			errorToLogin(errMsg)
		}

		vm.loginClicked = function (selectedUser) {
			window.updateLoadingMsg("Authenticating...")
			angular.element('#loading-container').fadeIn()

			// if the account they opted to log in as had an auth token stored, simply use that (would have been from switch accounts)
			if (selectedUser.lastToken) {
				window.authToken = selectedUser.lastToken
				Authorization.authorize({ preloadForShell: true }).then(function (ok) {
					if (!ok) return showLoginErr('That token is not valid on this server.')
					Authorization.showUI()
				})

				return
			}

			// if a password was provided, they got here from /login so post the password they just typed in back to /login
			var loginBody
			if (selectedUser.LoginToken) {
				loginBody = { loginToken: selectedUser.LoginToken }
			} else {
				return toast.error('Sorry, our fault, but we couldn\t log you in.')
			}

			//post the body to /login
			return $http.post("/api/login", loginBody, { timeout: 15000 })
				.then(function (res) {
					if (res.data.success) {
						//fade out the page
						angular.element('#authBG').fadeOut()

						Authorization.updateLocalUser(res.data)

						Authorization.showUI()
					} else {
						return showLoginErr(res.data.error)
					}
				}).catch(function (error) {
					angular.element('#loading-container').fadeOut()

					errorToLogin("A fatal error occurred while attempting to log you in. Our fault!")
				})
		}

		//log in directly if only one
		if (vm.users.length == 1) {
			vm.loginClicked(vm.users[0])
		}

		vm.logout = function (user) {
			// remove this user from the list of selectable users in local storage
			manageUsers.removeSelectableUser(user._id)

			// post to logout
			$http.post("/api/user/Logout", {})

			// remove localStorage authToken
			sessionStorage.removeItem('authToken')
			if ($rootScope.user) localStorage.removeItem('authToken' + $rootScope.user.Organization)
			$window.authToken = ''

			for (var i = 0; i < vm.users.length; i++){
				if (vm.users[i]._id == user._id) {
					vm.users.splice(i, 1)
				}
			}
		}

		function errorToLogin(msg) {
			$mdDialog.show($mdDialog.alert({
				title: 'Fatal Error',
				textContent: msg + " -- Please try again.",
				ok: "Okay"
			})).then(function () {
				$state.go('authentication.login')
			})
		}

		vm.closeWindow = function () {
			if (!window.opener) {
				toast.toast('Please close this browser tab')
			} else {
				window.close()
			}
		}
	}
})();
(function () {
    'use strict';

    LoginController.$inject = ["$scope", "$state", "$http", "$rootScope", "$mdDialog", "$window", "$location", "$filter", "$timeout", "Authorization", "socket", "Schema", "ngDialog", "manageUsers"];
    angular
        .module('app.authentication')
        .controller('LoginController', LoginController);

    /* @ngInject */
    function LoginController($scope, $state, $http, $rootScope, $mdDialog, $window, $location, $filter, $timeout, Authorization, socket, Schema, ngDialog, manageUsers) {
        var vm = this;

        if (!$location.search().uls && manageUsers.getSelectableUsers().length > 0 && !Authorization.skippedLogin) {
            Authorization.skippedLogin = true
            $state.go('authentication.select')
        }

        //the socket just disconnected by design so stop the timeout associated with it
        $timeout.cancel(socket.socketTimeout)

        //close any open items
        ngDialog.closeAll()

        // create blank user variable for login form
        vm.user = {
            email: '',
            password: ''
        };

        if ($location.host().indexOf("localhost") > -1) {
            vm.devMode = true;
        }

        // show a dialog if we got an error passed in
        if ($location.search().err) {
            // show the dialog
            var err = $mdDialog.alert({
                title: "Error",
                textContent: $location.search().err,
                ok: "OK"
            })
            $mdDialog.show(err).then(function () {
                // fill in their email for them
                vm.user.email = $location.search().email
                // focus the email
                document.getElementById('email').focus()
            })
        }

        vm.loginClick = loginClick
        vm.loginWith = loginWith

        //if an admin sent this user a password from email, put the email in the input and focus the password - the user is expected to paste the password in
        if ($location.search().redirFromPassReset) {
            vm.user.email = $location.search().redirFromPassReset
            document.getElementById("password").focus()
        }

        //make sure these are all in localStorage
        Schema.query()

        //empty all caches
        Schema.getCache(false).forEach(function (schema) {
            if (schema.schema == "Schema") return
            Schema.resource(schema.schema).init()
        })

        // snsName = "google", "facebook", "twitter"
        function loginWith(snsName) {
            $window.location = "/api/auth/" + snsName
        }

        function loginClick() {
            login()
            function login() {
                // update UI
                window.updateLoadingMsg("Authenticating...")
                angular.element('#loading-container').fadeIn()
                var loginButton = angular.element('#login')
                loginButton.attr('disabled', true);
                loginButton.text('Logging in...');

                if (Authorization.originalUrl) var org_id = Authorization.originalUrl.search().org

                // phone home
                $http.post("/api/login", { email: vm.user.email.trim(), password: vm.user.password.trim(), organization: org_id }, { timeout: 15000 })
                    .then(function (res) {
                        if (res.data.success) {
                            // there was one account matching those credentials, so they're logged in
                            if (!res.data.loginAsOptions) {
                                loginButton.text('Logged in');
                                angular.element('#authBG').fadeOut()
                                Authorization.updateLocalUser(res.data)
                                Authorization.showUI()
                                return
                            } else {
                                angular.element('#loading-container').fadeOut()
                                $state.go('authentication.select', { localOptions: { users: res.data.loginAsOptions } })
                            }
                        } else {
                            dialogController.$inject = ["$scope", "$mdDialog"];
                            angular.element('#loading-container').fadeOut()

                            var err = "Unknown Error";
                            if (res.data.error) {
                                err = res.data.error;
                            } else {
                                err += ". Error code " + res.data.errorCode;
                            }

                            var alert = $mdDialog.alert({
                                template: '<md-dialog style="padding:20px;max-width:350px";>' +
                                '  <md-dialog-content>' +
                                '    <div layout="column" layout-align="center start" style="margin:20px 0px;">' +
                                '	 	<img s3-src="/assets/images/empty-states/error.gif" width="400px">' +
                                '		<h2 class="md-title">Oh No!</h2>' +
                                '		<span>An error occured. ' + err + '</span>' +
                                '    </div>' +
                                '  </md-dialog-content>' +
                                '  <md-dialog-actions>' +
                                '    <md-button ng-click="closeDialog()" class="md-primary md-raised">' +
                                '      Try Again' +
                                '    </md-button>' +
                                '  </md-dialog-actions>' +
                                '</md-dialog>',
                                controller: dialogController
                            });

                            /* @ngInject */
                            function dialogController($scope, $mdDialog) {
                                $scope.closeDialog = $mdDialog.hide
                            }

                            $scope.closeDialog = function () {
                                $mdDialog.hide();
                            }

                            $mdDialog.show(alert).then(function () {
                                if (err.indexOf('password') > -1) {
                                    angular.element('#password').select()
                                    angular.element('#password').focus()
                                } else {
                                    angular.element('#email').select()
                                    angular.element('#email').focus()
                                }
                            })

                            loginButton.text('Log In');
                            loginButton.attr('disabled', false);
                        }
                    })
                    .catch(function (error) {
                        angular.element('#loading-container').fadeOut()

                        var msg = "A fatal error occurred while attempting to log you in. Our fault!"
                        if (error.status == 429) msg = "Too many login attempts have been made. Click Forgot Password to recover your password."

                        $mdDialog.show($mdDialog.alert({
                            title: 'Fatal Error',
                            textContent: msg,
                            ok: "Okay"
                        })).then(function () {
                            loginButton.attr('disabled', false)
                            loginButton.text('Log In')
                        })
                    })
            }
        }
    }
})();
(function () {
    'use strict';

    ForgotController.$inject = ["$scope", "$state", "$mdToast", "$filter", "$http", "$q", "$mdDialog", "$location"];
    angular
        .module('app.authentication')
        .controller('ForgotController', ForgotController);

    /* @ngInject */
    function ForgotController($scope, $state, $mdToast, $filter, $http, $q, $mdDialog, $location) {
        var vm = this;
		
		//size bg to inside if it's bigger
		document.getElementById('authBG').style.height = (document.getElementById("ui-login").offsetHeight + 20) + 'px'
		
        vm.user = {
            email: ''
        };
        vm.resetClick = resetPasswordClick;

        ////////////////

        function resetPasswordClick() {
			var submitButton = angular.element('#reset');
			submitButton.text('Submitting...');
			submitButton.attr('disabled', true);

			$http.post("/api/resetpasswordtrigger", { userEmail: vm.user.email })
				.then(function (res) {
					if (res.data.success) {
						var successAlert = $mdDialog.alert({
							title: "Success!",
							textContent: "Please check your email for the next step.",
							ok: "OK"
						});
						$mdDialog.show(successAlert)
							.then(function () {
								successAlert = undefined; // prevent memory leak
								$state.go("authentication.login");
							})
							.finally(function () {
								successAlert = undefined;
							})

					} else {
						var err = "Unknown Error";
						if (res.data.error)
							err = res.data.error;
						else
							err += ". Error code " + res.data.errorCode;

						var failureAlert = $mdDialog.alert({
							title: "Oh No!",
							textContent: "Something went wrong: " + err,
							ok: "Try Again"
						});
						$mdDialog.show(failureAlert)
							.finally(function () {
								failureAlert = undefined;
							})
					}
				})
				.finally(function () {
					submitButton.text("Password Reset");
					submitButton.attr('disabled', false);
				})
		}
    }
})();

(function() {
	angular.module('app.values', []);
})();
// all html herein must use single quotes for attributes
(function() {
    angular.module('app.values').constant('tourJSON', [
        //Getting Started
        {
            stateName: "shell.getting-started",
            tourtips: [{
                    image: "/assets/images/walkthrough/welcome.png",
                    tourtipHeader: "Welcome to Align Us!",
                    tourtipText: "Hello {{$root.User.FirstName}}! I'm Al Linus, here to welcome you to Align Us – your all-in-one teamwork tool!<br/><br/>Use Align Us to create a project, assign tasks to your team and stay up-to-date with the news feed. Watch the 30 second videos you see here to learn more!",
                    tourtipElement: "#content-panel",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "THANKS"
                }
            ]
        },
        //Home Dashboard widgets
        {
            stateName: "shell.home",
            tourtips: [{
                    image: "/assets/images/walkthrough/welcome.png",
                    tourtipHeader: "Welcome to Align Us!",
                    tourtipText: "Hello {{$root.User.FirstName}}! I'm Al Linus. This is your dashboard, where you can access some of your most important items!",
                    tourtipElement: "#HomeDashboard",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Let's Go!"
                },
                {
                    image: "/assets/images/walkthrough/tools.png",
                    tourtipHeader: "Tools",
                    tourtipText: "The left sidebar gives you access to all the Align Us tools.",
                    tourtipElement: "#shell-navbar",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/task.png",
                    tourtipHeader: "My Tasks",
                    tourtipText: "Quickly add tasks, reminders, and notes here! Use drag & drop to prioritize and edit task details using the magic check box.",
                    tourtipElement: "#BtnMyTasks",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/send.png",
                    tourtipHeader: "Send Menu",
                    tourtipText: "Send a high five, post on a page, send a private message, ask a question, or request approval on an item.",
                    tourtipElement: "#BtnSendMenu",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/add.png",
                    tourtipHeader: "Quick Add",
                    tourtipText: "Add a project, document, task, meeting or page from here. Click the button to access the wizard for each item.",
                    tourtipElement: "#BtnQuickAdd",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/recent.png",
                    tourtipHeader: "Recent Items",
                    tourtipText: "Access all items you've recently opened. Click one to open the item in the recent item viewer, it is always available no matter where you are in Align Us.",
                    tourtipElement: "#BtnRecentItems",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/al.png",
                    tourtipHeader: "Inbox & Video Calling",
                    tourtipText: "All your private, one-on-one messages, as well as task and related items appear here.",
                    tourtipElement: "#BtnMessages",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/profile.png",
                    tourtipHeader: "Profile Setup",
                    tourtipText: "Here you can change your password, edit your profile, and customize your theme. Cool eh? You can also find the help center and this tour if you want to see it again. This is also where you will find quick access your inbox.",
                    tourtipElement: "#BtnUserMenu",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"

                },
                {
                    image: "/assets/images/walkthrough/posts.png",
                    tourtipHeader: "News Feed",
                    tourtipText: "This is a snap shot of what's happening on your news feed. Click on a post to see it in a larger Recent Item viewer. Click the News Feed title bar to go to your news feed.",
                    tourtipElement: "#NewsfeedWidget",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/tags.png",
                    tourtipHeader: "Inbox",
                    tourtipText: "Here are the messages in your inbox, click one to open it as a chat. Click the Inbox title bar to go to your inbox. You can also find your inbox in the messaging panel on the right.",
                    tourtipElement: "#InboxWidget",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/calendar.png",
                    tourtipHeader: "Event List",
                    tourtipText: "Every meeting and event you are attending, task due date, and project deadline will appear in this list automatically. Click the Events title bar to go to your upcoming events list.",
                    tourtipElement: "#EventsWidget",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/happiness.png",
                    tourtipHeader: "Happiness Meter",
                    tourtipText: "Measuring how happy everyone is at their job gives management an important, yet simple, metric about their performance. Use the slider to indicate how happy you are at your job. The graph below shows how everyone in the organization responded over the past four days.",
                    tourtipElement: "#HappinessWidget",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Structure intro, Org Settings card, Add Users card, Permisisons card		
        {
            stateName: "shell.structure",
            tourtips: [{
                    image: "/assets/images/gifs/structure.gif",
                    tourtipHeader: "Structure",
                    tourtipText: "Structure defines your organization.<br/><br/>It's a database of your people and describes how they are connected.<br/><br/>It's a great spot for everyone to look up another user, organize a new team, browse the directory and, generally, learn about the organizational structure of {{$root.Organization.Name}}.",
                    tourtipElement: "#ContentLandingPage",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "Contacts",
                    tourtipText: "The Contacts feature is where you track, message and share items with anyone important to {{$root.Organization.Name}}.<br/><br/>Your subscription supports an unlimited number of contacts.",
                    tourtipElement: ".section0",
                    tourtipPlacement: "center-top",
                    tourtipNextLabel: "NEXT"
                },
                
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "Users",
                    tourtipText: "Users require a license and may use all features of Align Us*.<br/><br/>Users may particpate in the operation of {{$root.Organization.Name}} and each has their own inbox.<br/><br/>Each @User is encouraged to browse the {{$root.Organization.Name}} News Feed, post on their own page, work on +Projects as well as read &Handbooks, connect to $Strategies and the immerse themselves in the %Philosophy of {{$root.Organization.Name}}.<br/><br/>* Depending on permissions set by the {{$root.Organization.Name}} admin.",
                    tourtipElement: ".section1",
                    tourtipPlacement: "center-top",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "Teams and Groups",
                    tourtipText: "Group Contacts and Users into Teams, Committees, etc.<br/><br/>Then, mass message, send event invites and more to all members in a group.",
                    tourtipElement: ".section2",
                    tourtipPlacement: "center-top",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/organization.png",
                    tourtipHeader: "Locations and Departments",
                    tourtipText: "This is where you will manage locations and departments. SysAdmins can add and edit locations and departments to help keep your users organized.",
                    tourtipElement: ".section3",
                    tourtipPlacement: "center-top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                },
                {
                    image: "/assets/images/walkthrough/organization.png",
                    tourtipHeader: "Organization",
                    tourtipText: "Ooohhh.... We've got a SysAdmin here!<br/><br/>Update the Organization Photo and Logo as well as control security.",
                    tourtipElement: ".section5",
                    tourtipPlacement: "center-top",
                    tourtipNextLabel: "ASSUME CONTROL"
                }
            ]
        },
        //Org Settings: Manage Locations, Departments, Org, Permission Presets cards, Add FAB
        {
            stateName: "shell.structure.organization-settings",
            tourtips: [{
                    image: "/assets/images/walkthrough/location.png",
                    tourtipHeader: "Manage Locations",
                    tourtipText: "Manage the details of your organization's locations here. Each location will have a page on the social intranet. Assign users to be administrators for the page, update the location's address and phone number.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/department.png",
                    tourtipHeader: "Manage Departments",
                    tourtipText: "Manage the details of your organization's departments here. Each department will have a page on the social intranet. Assign users to be administrators for the page as well as update the department's address and phone number.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/organization.png",
                    tourtipHeader: "Manage Organziation",
                    tourtipText: "You can edit the details of your organization here. Update the address, phone number, timezone, toolbar color, and profile picture for your entire organization.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/10free.png",
                    tourtipHeader: "Add User Licenses",
                    tourtipText: "The first 10 users added to Align Us are free, then you must purchase a user licenses for additional users. Click here to launch the Add User Licenses wizard to choose how many licenses to purchase and enter your billing info.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/post.png",
                    tourtipHeader: "Add Button",
                    tourtipText: "Click this button to reveal links to add a location, department, or user licenses. When you leave this page, this button will still be in this corner so that you can easily add a location, department, or user licenses.",
                    tourtipElement: "#BtnMainFab",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Locations list view		
        {
            stateName: "shell.structure.organization-settings.all-locations.list",
            stateParams: { view: "list" },
            tourtips: [{
                    image: "/assets/images/walkthrough/location.png",
                    tourtipHeader: "Choose Location",
                    tourtipText: "Click on a card to view all the details of this location. Hover over the profile image to reveal a checkbox. Check one or more location's boxes to reveal buttons for aditional actions.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of locations. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of locations in a different format. Cards will show you each location in a thumbnail, Report will show you the locations in a table with some of the most important info displayed, and Connections will show you the locations in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Locations list Cards view		
        {
            stateName: "shell.structure.organization-settings.all-locations.list",
            stateParams: { view: "cards" },
            tourtips: [{
                    tourtipHeader: "Location Card",
                    tourtipText: "Select one or more cards to reveal buttons for additional actions you can perform on the location(s) such as removing the location(s) and downloading the location(s) to a file with a .csv extention. Double click a location card to open this location's info for editing. This is the same as selecting a card and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of locations. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of locations in a different format. List will show you a two pane view with the list of locations on the left and their info on the right, Report will show you the locations in a table with some of the most important info displayed, and Connections will show you the locations in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]

        },
        //Locations list Report view		
        {
            stateName: "shell.structure.organization-settings.all-locations.list",
            stateParams: { view: "report" },
            tourtips: [{
                    tourtipHeader: "Location",
                    tourtipText: "Check one or more boxes to reveal buttons for actions you can perform on the location such as removing the location(s) and downloading the location(s) to a file with a .csv extention. Double click a location's row to open this location's info for editing. This is the same as checking a box and then clicking the button Open Item.",
                    tourtipElement: "#BtnUserRow00",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of locations. Clicking a category will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Column Header",
                    tourtipText: "Click on a column header to sort this list of locations alphabetically by this column. Click the column header again to sort the locations in reverse alphabetical order.",
                    tourtipElement: "#BtnColumnHeader1",
                    tourtipPlacement: "left",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of locations in a different format. List will show you a two pane view with the list of locations on the left and their info on the right, Cards will show you each location in a thumbnail, and Connections will show you the locations in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Locations list Connections view 		
        {
            stateName: "shell.structure.organization-settings.all-locations.list",
            stateParams: { view: "connections" },
            tourtips: [{
                    tourtipHeader: "Self-Managing",
                    tourtipText: "Drag a location out of the Self-Managing Members box and drop it onto the space to make it a root of the reporting hierarchy. Drop a location on top of another location to make a connection. Or drag locations from the hierarchy into Self-Managing Members to remove them from the chart.",
                    tourtipElement: "#SpaceForSelfManaged",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Location Card",
                    tourtipText: "Drag a location and drop it on top of another location to create a connection. Select a location to reveal buttons for actions you can perform on the location such as removing the location(s) and downloading the location(s) to a file with a .csv extention. Select multiple locations by holding down the Ctrl button while selecting locations. Double click a location card to open this location's info for editing. This is the same as selecting a location and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of locations in a different format. List will show you a two pane view with the list of locations on the left and their info on the right, Cards will show you each location in a thumbnail, and Report will show you the locations in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Departments list view		
        {
            stateName: "shell.structure.organization-settings.all-departments.list",
            stateParams: { view: "list" },
            tourtips: [{
                    image: "/assets/images/walkthrough/department.png",
                    tourtipHeader: "Choose Department",
                    tourtipText: "Click on a card to view all the details of this department. Hover over the profile image to reveal a checkbox. Check one or more department's boxes to reveal buttons for aditional actions.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of departments. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of departments in a different format. Cards will show you each department in a thumbnail, Report will show you the departments in a table with some of the most important info displayed, and Connections will show you the departments in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Departments list Cards view		
        {
            stateName: "shell.structure.organization-settings.all-departments.list",
            stateParams: { view: "cards" },
            tourtips: [{
                    tourtipHeader: "Department Card",
                    tourtipText: "Select one or more cards to reveal buttons for additional actions you can perform on the department(s) such as removing the department(s) and downloading the department(s) to a file with a .csv extention. Double click a department card to open this department's info for editing. This is the same as selecting a card and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of departments. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of departments in a different format. List will show you a two pane view with the list of departments on the left and their info on the right, Report will show you the departments in a table with some of the most important info displayed, and Connections will show you the departments in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]

        },
        //Departments list Report view		
        {
            stateName: "shell.structure.organization-settings.all-departments.list",
            stateParams: { view: "report" },
            tourtips: [{
                    tourtipHeader: "Department",
                    tourtipText: "Check one or more boxes to reveal buttons for actions you can perform on the department such as removing the department(s) and downloading the department(s) to a file with a .csv extention. Double click a department's row to open this department's info for editing. This is the same as checking a box and then clicking the button Open Item.",
                    tourtipElement: "#BtnUserRow00",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of departments. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Column Header",
                    tourtipText: "Click on a column header to sort this list of departments alphabetically by this column. Click the column header again to sort the departments in reverse alohabetical order.",
                    tourtipElement: "#BtnColumnHeader1",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of departments in a different format. List will show you a two pane view with the list of departments on the left and their info on the right, Cards will show you each department in a thumbnail, and Connections will show you the departments in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Departments list Connections view 		
        {
            stateName: "shell.structure.organization-settings.all-departments.list",
            stateParams: { view: "connections" },
            tourtips: [{
                    tourtipHeader: "Self-Managing",
                    tourtipText: "Drag a department out of the Self-Managing Members box and drop it onto the space to make it a root of the reporting hierarchy. Drop a department on top of another department to make a connection. Or drag departments from the hierarchy into Self-Managing Members to remove them from the chart.",
                    tourtipElement: "#SpaceForSelfManaged",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Department Card",
                    tourtipText: "Drag a department and drop it on top of another department to create a connection. Select a department to reveal buttons for actions you can perform on the department such as removing the department(s) and downloading the department(s) to a file with a .csv extention. Select multiple departments by holding down the Ctrl button while selecting departments. Double click a department card to open this department's info for editing. This is the same as selecting a department and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of departments in a different format. List will show you a two pane view with the list of departments on the left and their info on the right, Cards will show you each department in a thumbnail, and Report will show you the departments in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Permission Presets list view		
        {
            stateName: "shell.structure.permission-presets.list",
            stateParams: { view: "list" },
            tourtips: [{
                    image: "/assets/images/walkthrough/permissions.png",
                    tourtipHeader: "Choose Preset",
                    tourtipText: "Click on a permission preset to view all the details of this permission preset you can edit. Check this permission preset's box or multiple permission preset's boxes to reveal buttons for aditional actions such as removing the permission preset(s) and downloading the permission preset(s) to a file with a .csv extention.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of permisison presets. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of permission presets in a different format. Cards will show you each permission preset in a thumbnail and Report will show you the permission presets in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Permission Presets list Cards view		
        {
            stateName: "shell.structure.permission-presets.list",
            stateParams: { view: "cards" },
            tourtips: [{
                    tourtipHeader: "Permission Preset Card",
                    tourtipText: "Select a permission preset card to reveal buttons for additional actions you can perform on the permission preset such as removing the permission preset and downloading the permission preset to a file with a .csv extention. Select multiple permission presets by holding down the Ctrl button while you click the cards. Double click a permission preset card to open this permission preset's info for editing. This is the same as selecting a card and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of permisison presets. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of permission presets in a different format. List will show you a two pane view with the list of permission presets on the left and their info on the right and Report will show you the permission presets in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]

        },
        //Permission Presets list Report view		
        {
            stateName: "shell.structure.permission-presets.list",
            stateParams: { view: "report" },
            tourtips: [{
                    tourtipHeader: "Permission Preset",
                    tourtipText: "Check one or more boxes to reveal buttons for actions you can perform on the permission preset such as removing the permission preset(s) and downloading the permission preset(s) to a file with a .csv extention. Double click a permission preset's row to open this permission preset's info for editing. This is the same as checking a box and then clicking the button Open Item.",
                    tourtipElement: "#BtnUserRow00",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of permission presets. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Column Header",
                    tourtipText: "Click on a column header to sort this list of permission presets alphabetically by this column. Click the column header again to sort the permission presets in reverse alphabetical order.",
                    tourtipElement: "#BtnColumnHeader0",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of permission presets in a different format. List will show you a two pane view with the list of permission presets on the left and their info on the right and Cards will show you each permission preset in a thumbnail.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Users and Teams: landing cards and add fab		
        {
            stateName: "shell.structure.users-and-teams",
            tourtips: [{
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "Add Team",
                    tourtipText: "Click here to launch the Add Team wizard. Teams will let you easily add groups of users to projects.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "List All Users",
                    tourtipText: "Click on this card to view a list of all the users in your organization. If you have permission to edit users, you will be able to do so here. Otherwise you can only view everyone's basic info.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "List All Teams",
                    tourtipText: "Click on this card to view a list of all the teams in your organization. You will be able to edit the teams you created here.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "By Reports-To",
                    tourtipText: "When you click this card you will see a list of users who have other users reporting to them. When you click on a user you will be taken to the hierarchy chart where the selected user is the root.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/location.png",
                    tourtipHeader: "By Location",
                    tourtipText: "When you click on this card you will see your organization's list of locations. When you click on a location you will see the list of users who are assigned to that location.",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/department.png",
                    tourtipHeader: "By Department",
                    tourtipText: "When you click on this card you will see your organization's list of departments. When you click on a department you will see the list of users who are assigned to that department.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/post.png",
                    tourtipHeader: "Add Button",
                    tourtipText: "Click this button to reveal links to add a user or team. When you click on either Add User or Add Team you will launch the wizard that will guide you through the process of adding a user or team. When you leave this page this button will still be in this corner.",
                    tourtipElement: "#BtnMainFab",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Users list view		
        {
            stateName: "shell.structure.users-and-teams.all-users.list",
            stateParams: { view: "list" },
            tourtips: [{
                    tourtipHeader: "Choose User",
                    tourtipText: "Click on a user to view all the details of this user. Hover over the profile image to reveal a checkbox. Click one or more user's boxes to reveal buttons for aditional actions.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of users. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "View this list of users in a different format. Cards will show you each user in a thumbnail, Report will show you the users in a table with some of the most important info displayed, and Connections will show you the users in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //User list Cards view		
        {
            stateName: "shell.structure.users-and-teams.all-users.list",
            stateParams: { view: "card" },
            tourtips: [{
                    tourtipHeader: "User Card",
                    tourtipText: "Select one or more cards to reveal buttons for additional actions you can perform on the user such as removing the user, downloading the user to a file with a .csv extention, sending the user a message, following the user's social page, deactivating the user, reseting the user's password, and reassigning this user's subordinates to a different user. Double click a user card to open this user's info for editing. This is the same as selecting a card and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of users. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of users in a different format. List will show you a two pane view with the list of users on the left and their info on the right, Report will show you the users in a table with some of the most important info displayed, and Connections will show you the users in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]

        },
        //User list Report view		
        {
            stateName: "shell.structure.users-and-teams.all-users.list",
            stateParams: { view: "report" },
            tourtips: [{
                    tourtipHeader: "User",
                    tourtipText: "Check one or more boxes to reveal buttons for actions you can perform on the user such as removing the user and downloading the user to a file with a .csv extention, sending the user a message, following the user's social page, deactivating the user, reseting the user's password, and reassigning this user's subordinates to a different user. Double click a user's row to open this user's info for editing. This is the same as checking a box and then clicking the button Open Item.",
                    tourtipElement: "#BtnUserRow00",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of users. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Column Header",
                    tourtipText: "Click on a column header to sort this list of users alphabetically by this column. Click the column header again to sort the users in reverse alphabetical order.",
                    tourtipElement: "#BtnColumnHeader3",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of users in a different format. List will show you a two pane view with the list of users on the left and their info on the right, Cards will show you each user in a thumbnail, and Connections will show you the users in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //User list Connections view 		
        {
            stateName: "shell.structure.users-and-teams.all-users.list",
            stateParams: { view: "connections" },
            tourtips: [{
                    tourtipHeader: "Self-Managing",
                    tourtipText: "Drag a user out of the Self-Managing Members box and drop it onto the space to make it a root of the reporting hierarchy. Drop a user on top of another user to make a connection. Or drag users from the hierarchy into Self-Managing Members to remove them from the chart.",
                    tourtipElement: "#SpaceForSelfManaged",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "User Card",
                    tourtipText: "Drag a user and drop it on top of another user to create a connection. Select a user to reveal buttons for actions you can perform on the user such as removing the user, downloading the user to a file with a .csv extention, sending the user a message, following the user's social page, deactivating the user, reseting the user's password, and reassigning this user's subordinates to a different user. Select multiple users by holding down the Ctrl button while selecting users. Double click a user card to open this user's info for editing. This is the same as selecting a user and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of users in a different format. List will show you a two pane view with the list of users on the left and their info on the right, Cards will show you each user in a thumbnail, and Report will show you the users in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Teams list view		
        {
            stateName: "shell.structure.users-and-teams.manage-teams.list",
            stateParams: { view: "list" },
            tourtips: [{
                    tourtipHeader: "Choose Team",
                    tourtipText: "Click on a team to view all the details of this team you can edit. Check this team's box or multiple team's boxes to reveal buttons for aditional actions such as removing the team and downloading the team to a file with a .csv extention.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of teams. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of teams in a different format. Report will show you the teams in a table with some of the most important info displayed and Connections will show you the teams in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Teams list Report view		
        {
            stateName: "shell.structure.users-and-teams.manage-teams.list",
            stateParams: { view: "report" },
            tourtips: [{
                    tourtipHeader: "Team",
                    tourtipText: "Check one or more boxes to reveal buttons for actions you can perform on the team such as removing the team and downloading the team to a file with a .csv extention. Double click a team's row to open this team's info for editing. This is the same as checking a box and then clicking the button Open Item.",
                    tourtipElement: "#BtnUserRow00",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of teams. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Column Header",
                    tourtipText: "Click on a column header to sort this list of teams alphabetically by this column. Click the column header again to sort the teams in reverse alphabetical order.",
                    tourtipElement: "#BtnColumnHeader2",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT"
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of teams in a different format. List will show you a two pane view with the list of teams on the left and their info on the right and Connections will show you the teams in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Teams list Connections view 		
        {
            stateName: "shell.structure.users-and-teams.manage-teams.list",
            stateParams: { view: "connections" },
            tourtips: [{
                    tourtipHeader: "Self-Managing",
                    tourtipText: "Drag a team out of the Self-Managing Members box and drop it onto the space to make it a root of the reporting hierarchy. Drop a team on top of another team to make a connection. Or drag teams from the hierarchy into Self-Managing Members to remove them from the chart.",
                    tourtipElement: "#SpaceForSelfManaged",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Team Card",
                    tourtipText: "Drag a team and drop it on top of another team to create a connection. Select a team to reveal buttons for actions you can perform on the team such as removing the team and downloading the team to a file with a .csv extention. Select multiple teams by holding down the Ctrl button while selecting teams. Double click a team card to open this team's info for editing. This is the same as selecting a team and then clicking the button Open Item.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    image: "/assets/images/walkthrough/view.png",
                    tourtipHeader: "View",
                    tourtipText: "Click one of these options to view this list of teams in a different format. List will show you a two pane view with the list of teams on the left and their info on the right and Report will show you the teams in a table with some of the most important info displayed.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //By Reports-To	User list menu	
        {
            stateName: "shell.structure.users-and-teams.by-reports-to",
            tourtips: [{
                tourtipHeader: "By Reports-To",
                tourtipText: "Click on a user to view the reporting hierarchy below them. Or click View Entire Organization to see the reporting hierarchy for all users in your organziation.",
                tourtipElement: "#BtnFilterListOption0",
                tourtipPlacement: "right",
                tourtipNextLabel: "OK"
            }]
        },
        //By Location User list menu	
        {
            stateName: "shell.structure.users-and-teams.by-location",
            tourtips: [{
                tourtipHeader: "By Location",
                tourtipText: "Click on a location to view only the users who are assigned to this location.",
                tourtipElement: "#BtnFilterListOption0",
                tourtipPlacement: "right",
                tourtipNextLabel: "OK"
            }]
        },        
        //By Department menu	
        {
            stateName: "shell.structure.users-and-teams.by-department",
            tourtips: [{
                tourtipHeader: "By Department",
                tourtipText: "Click on a department to see only the users who are assigned to this department.",
                tourtipElement: "#BtnFilterListOption0",
                tourtipPlacement: "right",
                tourtipNextLabel: "OK"
            }]
        },        
        //Social: Landing Page	
        {
            stateName: "shell.social",
            tourtips: [{
                    image: "/assets/images/gifs/social.gif",
                    tourtipHeader: "Social",
                    tourtipText: "Social connects the people in your organization. Post on pages to send public messages, use your inbox to communicate with people privately. View the event calendar to manage your schedule, use the meeting manager to plan the most effective meetings, and ask questions that require a response.",
                    tourtipElement: "#ContentLandingPage",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/posts.png",
                    tourtipHeader: "News Feed",
                    tourtipText: "The news feed is a collection of all posts on pages that you follow. The most recent posts will appear at the top of your news feed so you always know what's up!",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/tags.png",
                    tourtipHeader: "Inbox",
                    tourtipText: "Here you can send messages to anyone in your organization, or participate in discussions about projects, meetings, and tasks.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/page.png",
                    tourtipHeader: "Page Directory",
                    tourtipText: "Pages are a space where people can come together for easy and quick communication. Every user has their own page where you can post public messages to them. Anyone can view, like, comment, or share your posts. Browse pages here.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/calendar.png",
                    tourtipHeader: "Meetings",
                    tourtipText: "The Meeting Manager helps you plan meetings that rock! Enter your meeting details, invite the most crucial people, and get their feedback after the meeting concludes. With so many options for attaching documents and taking notes, your meetings will be a success!",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "Questions & Answers",
                    tourtipText: "Find questions related to your organization asked by your peers. You can browse by questions that have been answered recently, frequesntly asked questions, or questions that are asked directly to you.",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/posts.png",
                    tourtipHeader: "Post Finder",
                    tourtipText: "View different post feeds such as posts you created, posts you were tagged in, and posts form people on your team.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "Thanks for the Tour"
                }
            ]
        },
        //Social: Pages	
        {
            stateName: "shell.social.pages",
            tourtips: [{
                    image: "/assets/images/walkthrough/page.png",
                    tourtipHeader: "My Pages",
                    tourtipText: "Browse pages that are related to you. Here you will find pages you own, pages you follow, and pages you posted on!",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/page.png",
                    tourtipHeader: "All Pages",
                    tourtipText: "View all public pages and event pages from your organization.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/calendar.png",
                    tourtipHeader: "Events",
                    tourtipText: "View your calendar, upcoming and past events you are attending, and create your own event page.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "Discussion Boards",
                    tourtipText: "View a list of discussion boards that are not associated with tasks, projects, or documents.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "Users",
                    tourtipText: "See profile pages for all users in your organization. Follow users to see their updates in your news feed.",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "Teams",
                    tourtipText: "Be in the know and stay current with your team. Browse the social pages of teams in your organization.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/location.png",
                    tourtipHeader: "Departments and Locations",
                    tourtipText: "Be in the know and stay current with the social pages of departments and locations in your organization.",
                    tourtipElement: "#Card6",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/page.png",
                    tourtipHeader: "General",
                    tourtipText: "See a list of all other social pages in your organization.",
                    tourtipElement: "#Card7",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/post.png",
                    tourtipHeader: "Add a Page or Event",
                    tourtipText: "Quickly add a social page or an event page. ",
                    tourtipElement: "#BtnMainFab",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },

        //Social: Pages: My Pages list menu	
        {
            stateName: "shell.social.pages.my-pages-dir",
            tourtips: [
                {
                    image: "/assets/images/walkthrough/organization.png",
                    tourtipHeader: "Organization Page",
                    tourtipText: "Open the main page for your organization.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "My Teams",
                    tourtipText: "Be in the know and stay current with your team. Browse the social pages of teams that you are a member of.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/tools.png",
                    tourtipHeader: "Pages You Administer",
                    tourtipText: "View a list of all pages you created and all pages you edit.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/following.png",
                    tourtipHeader: "Pages You Follow",
                    tourtipText: "View pages from your organization that you've chosen to follow. All posts on these pages appear in your news feed.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/post.png",
                    tourtipHeader: "Pages You Posted On",
                    tourtipText: "View a list of pages you have posted on so you can continue the conversation.",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/users.png",
                    tourtipHeader: "Your Boss's Page",
                    tourtipText: "View your boss's social page and never miss an important update.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                },
            ]
        },
        //Social: Pages: Pages I'm Following list menu	
        {
            stateName: "shell.social.pages.my-pages-dir.im-following.list",
            tourtips: [{
                image: "/assets/images/walkthrough/page.png",
                tourtipHeader: "Pages I'm Following",
                tourtipText: "List of pages you are following. Select an item to view the page.",
                tourtipElement: "#BtnLeftListItem00",
                tourtipPlacement: "right",
                tourtipNextLabel: "THANKS FOR THE TOUR"
            }]
        },
        //Social: Pages: Pages I Posted On list menu	
        {
            stateName: "shell.social.pages.my-pages-dir.posted-on.list",
            tourtips: [{
                image: "/assets/images/walkthrough/page.png",
                tourtipHeader: "Pages I Posted On",
                tourtipText: "When you post on a page, the page will be listed in this section. Continue the conversation by selecting an item.",
                tourtipElement: "#BtnLeftListItem00",
                tourtipPlacement: "right",
                tourtipNextLabel: "THANKS FOR THE TOUR"
            }]
        },
        //Social: Pages: My Teams list menu	
        {
            stateName: "shell.social.pages.my-pages-dir.my-teams.list",
            tourtips: [{
                image: "/assets/images/walkthrough/team.png",
                tourtipHeader: "My Team Pages",
                tourtipText: "Be on the know and stay current with your team. Browse pages that you are a member of. Select an item to view the page.",
                tourtipElement: "#BtnLeftListItem00",
                tourtipPlacement: "right",
                tourtipNextLabel: "THANKS FOR THE TOUR"
            }]
        },
        //Social: Posts landing 
        {
            stateName: "shell.social.posts",
            tourtips: [{
                    image: "/assets/images/walkthrough/posts.png",
                    tourtipHeader: "My Posts",
                    tourtipText: "View a feed of posts that you created. We took all the posts you made on any page put them all together just for you.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/tags.png",
                    tourtipHeader: "Tagged",
                    tourtipText: "Here you will find a feed of all posts that you have been tagged in.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/posts.png",
                    tourtipHeader: "News Feed",
                    tourtipText: "The news feed is a collection of all posts on pages that you follow.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/team.png",
                    tourtipHeader: "My Teams",
                    tourtipText: "Stay current with your team. Here you can view a feed of all posts from teammates.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    image: "/assets/images/walkthrough/post.png",
                    tourtipHeader: "Add a Page or Post",
                    tourtipText: "Quickly add a social or event page, or create a post for one or more pages. ",
                    tourtipElement: "#BtnMainFab",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Social: Post: My Posts	
        {
            stateName: "shell.social.posts.my-posts",
            tourtips: [{
                image: "/assets/images/walkthrough/posts.png",
                tourtipHeader: "My Posts",
                tourtipText: "The following are all the posts that you have created, on any page. Share, delete, and edit your posts from here.",
                tourtipElement: "#PostsPage",
                tourtipPlacement: "center",
                tourtipNextLabel: "Sweet!"
            }]
        },
        //Social: Post: Tagged	
        {
            stateName: "shell.social.posts.tagged",
            tourtips: [{
                image: "/assets/images/walkthrough/tags.png",
                tourtipHeader: "Tagged",
                tourtipText: "View all posts that you are tagged in. To view other tagged users, select the Tagged button at the bottom of the post.",
                tourtipElement: "#PostsPage",
                tourtipPlacement: "center",
                tourtipNextLabel: "Got It"
            }]
        },
        //Social: Post: News Feed	
        {
            stateName: "shell.social.newsfeed",
            tourtips: [{
                image: "/assets/images/walkthrough/posts.png",
                tourtipHeader: "News Feed",
                tourtipText: "The news feed is a collection of all posts on pages that you follow. The most recent posts will appear at the top of your news feed so you always know what's up.",
                tourtipElement: "#UserNewsFeedPage",
                tourtipPlacement: "center",
                tourtipNextLabel: "THANKS FOR THE TOUR"
            }]
        },
        //Social: Post: My Teams	
        {
            stateName: "shell.social.posts.my-teams",
            tourtips: [{
                image: "/assets/images/walkthrough/team.png",
                tourtipHeader: "My Teams",
                tourtipText: "Stay current with your team. View all posts from users who are on the same teams as you.",
                tourtipElement: "#PostsPage",
                tourtipPlacement: "center",
                tourtipNextLabel: "Cool!"
            }]
        },
        //Social: Events	
        {
            stateName: 'shell.social.pages.events',
            tourtips: [{
                image: "/assets/images/walkthrough/post.png",
                tourtipHeader: "New Event Page",
                tourtipText: "Click here to launch the New Event wizard. Create a page to manage an event.",
                tourtipElement: "#Card0",
                tourtipPlacement: "top",
                tourtipNextLabel: "Next"
            },
            {
                image: "/assets/images/walkthrough/calendar.png",
                tourtipHeader: "My Calendar",
                tourtipText: "View events and meetings you are attending as well as task and project due dates for all together on one calendar.",
                tourtipElement: "#Card1",
                tourtipPlacement: "top",
                tourtipNextLabel: "Next"
            },
            {
                image: "/assets/images/walkthrough/page.png",
                tourtipHeader: "Upcoming Events",
                tourtipText: "View pages for future events that you are attending.",
                tourtipElement: "#Card2",
                tourtipPlacement: "top",
                tourtipNextLabel: "Next"
            },
            {
                image: "/assets/images/walkthrough/page.png",
                tourtipHeader: "Past Events",
                tourtipText: "View pages for past events that you are attending.",
                tourtipElement: "#Card3",
                tourtipPlacement: "top",
                tourtipNextLabel: "THANKS FOR THE TOUR"
            }]
        },
        //Social: Events: My Calendar
        {
            stateName: "shell.social.pages.events.my-event-calendar",
            tourtips: [{
                image: "/assets/images/walkthrough/calendar.png",
                tourtipHeader: "Calendar",
                tourtipText: "Every event you are attending, task due date, and project deadline will appear on the calendar automatically. You can select an event from the calendar and it will direct you to the event's page. <br><br>The arrows above the calendar allows you to browse through the months. The “Today” button will take you to the current day. Quickly add events by selecting the button below the calendar.",
                tourtipElement: "#ContentLandingPage",
                tourtipPlacement: "center",
                tourtipNextLabel: "Sweet!"
            }]
        },
        //Social: Questions
        {
            stateName: "shell.social.questions",
            tourtips: [{
                    tourtipHeader: "Questions & Answers",
                    tourtipText: "Explore questions asked by other members of your organization. Submit answers to questions or submit your own questions if you can't find the answer you're looking for.",
                    tourtipElement: "#ContentLandingPage",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Search Q&A",
                    tourtipText: "If you are looking for something specific, use this tool to search all questions asked by members of your organization. Use a few keywords to find questions similar to yours. If you cannot find what you are looking for, this is where you'll be able to submit a new question.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Respond",
                    tourtipText: "Here you will find questions that have been asked directly to you. Anyone can view and respond to these questions, but the asker has directed them to you. Give them the best answers you can.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Recent Answers",
                    tourtipText: "Review questions that have been answered recently. Ensure that users are giving accurate answers by commenting on an answer or submitting your own answer.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Frequently Asked Questions",
                    tourtipText: "Questions that many users have asked will appear here. If you have a general question that may have been asked by others you will probably find it here.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Tags",
                    tourtipText: "This is the list of all tags used for all questions that have been asked. You will find a brief description of the tag and who the tag moderator is. You will not find any questions in this list.",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "My Tags",
                    tourtipText: "As the moderator of a tag you are responsible for all content associated with that tag. This is where you will find the tags you moderate and the list of questions having that tag.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Social: Questions Search
        {
            stateName: "shell.social.questions.search",
            tourtips: [{
                tourtipHeader: "Search Questions",
                tourtipText: "Enter a few keywords related to the question you are looking for. If your words appear in the question, answer, or tag you will see it in the results.",
                tourtipElement: "#content-panel",
                tourtipPlacement: "center",
                tourtipNextLabel: "OK"
            }]
        },
        //Social: Question Detail - How to get here?
        {
            stateName: "shell.social.question",
            tourtips: [{
                    tourtipHeader: "Question",
                    tourtipText: "This is the main idea of the question, the user who asked the question, who they asked it to, and when they asked it. By clicking on this header you can collapse and expand the question card.",
                    tourtipElement: "#BtnQuestionHeader",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Action Buttons",
                    tourtipText: "Certain people will be able to edit and delete the question or mark it as an FAQ. Everyone will be able to flag the question as inappropriate, follow the question to receive updates when something changes, and share the question as a post on a page.",
                    tourtipElement: "#BtnActions",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Question Explanation",
                    tourtipText: "This is the full explanation of the question from the user who originally asked.",
                    tourtipElement: "#StringQuestionBody",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "NEXT"
                },
                {
                    tourtipHeader: "Submit Answer",
                    tourtipText: "Clicking this header will expand the card where you can submit your own answer to the question. The answer's title should briefly answer the question; it will displayed on the header of the answer card after it is submitted. Put your full explanation in the answer's body.",
                    tourtipElement: "#BtnSubmitAnswerHeader",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Social: Questions Respond list
        {
            stateName: "shell.social.questions.respond.list",
            stateParams: { view: "list" },
            tourtips: [{
                    tourtipHeader: "Choose Question",
                    tourtipText: "Click on a question to view all of its details. Check the box or multiple boxes to reveal buttons for aditional actions such as downloading the question to a file with a .csv extention.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of questions. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Social: Questions Recently Answered list
        {
            stateName: "shell.social.questions.recently-answered.list",
            stateParams: { view: "list" },
            tourtips: [{
                    tourtipHeader: "Choose Question",
                    tourtipText: "Click on a question to view all of its details. Check the box or multiple boxes to reveal buttons for aditional actions such as downloading the question to a file with a .csv extention.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of questions. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Social: Questions FAQs
        {
            stateName: "shell.social.questions.faq.list",
            stateParams: { view: "list" },
            tourtips: [{
                    tourtipHeader: "Choose Question",
                    tourtipText: "Click on a question to view all of its details. Check the box or multiple boxes to reveal buttons for aditional actions such as the question to a file with a .csv extention.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of questions. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Social: All Tags
        {
            stateName: "shell.social.questions.tags.list",
            stateParams: { view: "list" },
            tourtips: [{
                    image: "/assets/images/walkthrough/tags.png",
                    tourtipHeader: "Choose a Tag",
                    tourtipText: "Click on a tag to view all of its details. Check the box or multiple boxes to reveal buttons for aditional actions such as downloading tags as .csv file.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "NEXT",
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of tags. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "THANKS FOR THE TOUR",
                }
            ]
        },
        //Social: Questions Moderator Tags
        {
            stateName: "shell.social.questions.my-tags",
            tourtips: [{
                image: "/assets/images/walkthrough/tags.png",
                tourtipHeader: "Moderator Tags",
                tourtipText: "Select from the tags you moderate to view questions that are associated with that tag.",
                tourtipElement: "#BtnFilterListOption0",
                tourtipPlacement: "right",
                tourtipNextLabel: "ROGER THAT"
            }]
        },
        //Meetings: Landing Page	
        {
            stateName: "shell.social.meetings",
            tourtips: [{
                    tourtipHeader: "Meetings",
                    tourtipText: "Your Meeting Manager is the place for all your meeting needs. You can create and set details for the meetings you are hosting, view upcoming and past meetings, and generate meeting reports.",
                    tourtipElement: "#ContentLandingPage",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "New Meeting",
                    tourtipText: "Select this card to create a meeting you are going to host. Here, you can set all the details including the time and location of your meeting.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Upcoming Meetings",
                    tourtipText: "See a list of upcoming meetings you are hosting or attending.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Past Meetings",
                    tourtipText: "Your meeting already ended, but it doesn't have to stop there. Follow up, continue discussions, and review your past meetings here.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Meeting Drafts",
                    tourtipText: "View your unscheduled meetings; meetings you created but did not set a date.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Reports",
                    tourtipText: "Generate reports on your meetings. View charts, graphs, and tables based on feedback from your meetings. ",
                    tourtipElement: "#Card4",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Project: Landing Page	
        {
            stateName: "shell.project",
            tourtips: [{
                    image: "/assets/images/gifs/projects.gif",
                    tourtipHeader: "Project",
                    tourtipText: "Manage your tasks and projects with ease. Create tasks and projects that align to the organization’s strategy on a real-time collaborative platform.",
                    tourtipElement: "#ContentLandingPage",
                    tourtipPlacement: "center",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Add Projects",
                    tourtipText: "Click here to launch the Add Project wizard. Enter a few important details to create a new project.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "My Projects",
                    tourtipText: "View and edit all of projects you are involved with. You have the ability to edit dates, project members, tasks, access documents related to the project, and so much more!",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "My Tasks",
                    tourtipText: "Manage all tasks that you have been assigned. Click a task's check box to reveal a magic toolbar to quickly edit the task.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Tasks I Created",
                    tourtipText: "See all the tasks you've created. Use the task board to switch views from the users that you assigned tasks to, to the progress state of the task.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Browse",
                    tourtipText: "Find more projects and tasks, especially projects and tasks related to your teams.",
                    tourtipElement: "#Card5",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Add a Project or Task",
                    tourtipText: "Use this button to quickly add a new project or a new task. As you navigate around the Projects section this button will always be here.",
                    tourtipElement: "#BtnMainFab",
                    tourtipPlacement: "top-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Project: Browse Projects and Tasks by Team	
        {
            stateName: "shell.project.reports",
            tourtips: [
                {
                    tourtipHeader: "All Projects",
                    tourtipText: "View all public projects in {{$root.Organization.Name}} as well as private projects that you are a member of.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Tasks By Project",
                    tourtipText: "Select a project from the list to see all tasks for that project in a task board.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Projects By Team",
                    tourtipText: "Select a team from the list to see all projects that are linked to that team.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Tasks By Team",
                    tourtipText: "Select a team from the list to see all tasks assigned to members of that team.",
                    tourtipElement: "#Card3",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                }
            ]
        },
        //Documents: Landing Page	
        {
            stateName: "shell.documents",
            tourtips: [
                {
                    tourtipHeader: "Add Document",
                    tourtipText: "Easily create a blank document here. Add edtiors to collaborate with your peers!",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "All Documents",
                    tourtipText: "View a list of all public docs in {{$root.Organization.Name}} as well as private docs that you can edit or view.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Docs by User",
                    tourtipText: "Select a user from the list then view a list of the all their public documents.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Handbook: Landing Page
        {
            stateName: 'shell.handbook',
            tourtips: [
                {
                    tourtipHeader: "Add Handbook",
                    tourtipText: "Easily create a new handbook here. All teams, departments, locations, and the whole org already have a handbook. Check View Handbooks before creating a new one.",
                    tourtipElement: "#Card0",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "View Handbooks",
                    tourtipText: "View a list of all handbooks in {{$root.Organization.Name}}. Then select a specific handbook to view all of its entires.",
                    tourtipElement: "#Card1",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Handbook Settings",
                    tourtipText: "As the editor of a handbook, this is where you can update privacy settings including who else can edit or view a handbook.",
                    tourtipElement: "#Card2",
                    tourtipPlacement: "top",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        },
        //Philosophy: List View
        {
            stateName: 'shell.philosophy.list',
            tourtips: [
                {
                    tourtipHeader: "Philosophy",
                    tourtipText: "Click on a card to view the Mission, Vision, and Values. Hover over the profile image to reveal a checkbox. Select one or more checkbox to reveal buttons for more actions.",
                    tourtipElement: "#BtnLeftListItem00",
                    tourtipPlacement: "right",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Sort",
                    tourtipText: "Click here to reveal a dropdown listing all the different ways to sort this list of philosophies. Clicking one will automatically sort the entire list.",
                    tourtipElement: "#BtnSort",
                    tourtipPlacement: "bottom",
                    tourtipNextLabel: "Next"
                },
                {
                    tourtipHeader: "Views",
                    tourtipText: "Click one of these options to view this list of philosophies in a different format. Cards will show you each philosophy in a thumbnail, Report will show you the philosophies in a table with some of the most important info displayed, and Connections will show you the philosophies in a hierarchy chart that you can rearrange.",
                    tourtipElement: "#ViewContainer",
                    tourtipPlacement: "bottom-left",
                    tourtipNextLabel: "THANKS FOR THE TOUR"
                }
            ]
        }

    ])
})();
(function () {
	"use strict";

	angular.module('app.values').constant('taskPriorities', [
            { text: 'High Priority', number: '1', icon: 'zmdi zmdi-alert-polygon' },
            { text: 'Normal Priority', number: '2', icon: 'zmdi zmdi-alert-circle-o' },
            { text: 'Low Priority', number: '3', icon: 'zmdi zmdi-play-for-work' },
            { text: 'No Priority', number: '4', icon: 'zmdi zmdi-minus' }
        ]);
	
})();
(function() {
	'use strict'
	angular.module('app.values').constant('stopwords', [
		'a',
		'about',
		'above',
		'after',
		'again',
		'against',
		'all',
		'am',
		'an',
		'and',
		'any',
		'are',
		'arent',
		'as',
		'at',
		'be',
		'because',
		'been',
		'before',
		'being',
		'below',
		'between',
		'both',
		'but',
		'by',
		'cant',
		'cannot',
		'could',
		'couldnt',
		'did',
		'didnt',
		'do',
		'does',
		'doesnt',
		'doing',
		'dont',
		'down',
		'during',
		'each',
		'few',
		'for',
		'from',
		'further',
		'had',
		'hadnt',
		'has',
		'hasnt',
		'have',
		'havent',
		'having',
		'he',
		'hed',
		'hell',
		'hes',
		'her',
		'here',
		'heres',
		'hers',
		'herself',
		'him',
		'himself',
		'his',
		'how',
		'hows',
		'i',
		'id',
		'ill',
		'im',
		'ive',
		'if',
		'in',
		'into',
		'is',
		'isnt',
		'it',
		'its',
		'its',
		'itself',
		'lets',
		'me',
		'more',
		'most',
		'mustnt',
		'my',
		'myself',
		'no',
		'nor',
		'not',
		'of',
		'off',
		'on',
		'once',
		'only',
		'or',
		'other',
		'ought',
		'our',
		'ours',
		'ourselves',
		'out',
		'over',
		'own',
		'same',
		'shant',
		'she',
		'shed',
		'shell',
		'shes',
		'should',
		'shouldnt',
		'so',
		'some',
		'such',
		'than',
		'that',
		'thats',
		'the',
		'their',
		'theirs',
		'them',
		'themselves',
		'then',
		'there',
		'theres',
		'these',
		'they',
		'theyd',
		'theyll',
		'theyre',
		'theyve',
		'this',
		'those',
		'through',
		'to',
		'too',
		'under',
		'until',
		'up',
		'very',
		'was',
		'wasnt',
		'we',
		'wed',
		'well',
		'were',
		'weve',
		'were',
		'werent',
		'what',
		'whats',
		'when',
		'whens',
		'where',
		'wheres',
		'which',
		'while',
		'who',
		'whos',
		'whom',
		'why',
		'whys',
		'with',
		'wont',
		'would',
		'wouldnt',
		'you',
		'youd',
		'youll',
		'youre',
		'youve',
		'your',
		'yours',
		'yourself',
		'yourselves'
	])
})();
(function () {
	"use strict";

	angular.module('app.values').constant('usStates', [
		"AL",
		"AK",
		"AZ",
		"AR",
		"CA",
		"CO",
		"CT",
		"DE",
		"FL",
		"GA",
		"HI",
		"IA",
		"ID",
		"IL",
		"IN",
		"KS",
		"KY",
		"LA",
		"ME",
		"MD",
		"MA",
		"MI",
		"MN",
		"MS",
		"MO",
		"MT",
		"NE",
		"NV",
		"NH",
		"NJ",
		"NM",
		"NY",
		"NC",
		"ND",
		"OH",
		"OK",
		"OR",
		"PA",
		"RI",
		"SC",
		"SD",
		"TN",
		"TX",
		"UT",
		"VT",
		"VA",
		"WA",
		"WI",
		"WV",
		"WY"
	].sort()); // #DE48
})();
(function () {
	"use strict";

	angular.module('app.values').constant('s3Url', "https://s3.amazonaws.com/alignusstatic/UI/");
	
	angular.module('app.values').constant('s3UserFilesUrl', "https://s3.amazonaws.com/alignussecure/")
})();
(function () {
	"use strict";

	/**
	 * @value permissionText
	 *
	 * A list of values corresponding to help icons throughout the site.
	 *
	 * Consists of:
	 * @param key {String} The value to use in the HTML in the site
	 * @param link {String} The page name on the freshdesk site
	 * @param title {String} The big text in the popup
	 * @param description {String} The smaller text in the popup
	 */

	angular.module('app.values').constant('permissionText', {

		"SYSADMIN": "User is a System Administrator - grant ALL permissions.",

		"DEPARTMENTS": {
			"TITLE": "Department Permissions",
			"CANMANAGE": "Can create, edit, and delete departments. This does not include moving users between departments."
		},
		//upload file permissions
		// "FILES": {
		// 	"TITLE": "File Permissions",
		// 	"CANCREATE": "Can create files.",
		// 	"CANDELETEALL": "Can delete any file.",
		// 	"CANEDITALL": "Can edit any file."
		// },
		"LOCATIONS": {
			"TITLE": "Location Permissions",
			"CANMANAGE": "Can create, edit, and delete locations/offices. This does not include moving users between locations."
		},
		"CONNECTIONS": {
			"TITLE": "User Connection Permissions",
			"CANCREATE": "Can create teams.",
			"CANDELETEALL": "Can delete any team.",
			"CANEDITALL": "Can edit any team.",
			"CANVIEW": "Can view organization teams and org charts."
		},
		"ORGANIZATION": {
			"TITLE": "Organization Permissions",
			"CANMANAGE": "Can edit the organization's profile and settings.",
			"CANMANAGELICENSES": "Can purchase additional user licenses."
		},
		"PAGES": {
			"TITLE": "Page Permissions",
			"CANCREATE": "Can create pages on the social intranet.",
			"CANDELETEALL": "Can delete any page on the social intranet.",
			"CANEDITALL": "Can edit any page on the social intranet."
		},
		"USERS": {
			"TITLE": "User List Permissions",
			"ISADMINFOR": {
				"TITLE": "User List Administrator",
				"ORG": "User is an organization administrator and can create, edit, and delete users in this organization."
			},
			"CANVIEW": "User can view and search for other users in sections such as the directory (recommended).",
			"CANVIEWEMPLOYMENTINFO": "User can view employment info (salary, hire dates, etc.) for all users who report to them or a subordinate."
		},
		"CONTACTS": {
			"TITLE": "Contacts Permissions",
			"CANCREATE": "Can create contacts for this organization.",
			"CANEDITALL": "Can edit all contacts for this organization.",
			"CANDELETEALL": "Can delete any contact in this organization."
		},
		"TEAMS": {
			"TITLE": "Teams Permissions",
			"CANVIEW": "Can view all teams and their members.",
			"CANCREATE": "Can create a team. This includes editing and deleting that team.",
			"CANEDITALL": "Can edit any team, regardless of who created it.",
			"CANDELETEALL": "Can delete any team, regardless of who created it."
		},
		"QNA": {
			"TITLE": "Questions, Answers, and Tag Permissions",
			"CANCREATE": "Can ask questions to any user.",
			"MANAGER": "Can edit and delete any question. Can create, edit, and delete question tags."
		},
		"PROJECTS": {
			"TITLE": "Project Permissions",
			"CANCREATE": "Can create projects.",
			"CANEDITALL": "Can edit all projects, even if they are not a member.",
			"CANDELETEALL": "Can delete all projects, even if they are not a member."
		},
		"TASKS": {
			"TITLE": "Task Permissions",
			//"CANCREATE": "Can create tasks and assign them to any user.",
			//"CANVIEWALL": "Can view all tasks, even if they are not assigned to the task.",
			"CANEDITALL": "Can edit all tasks, even if they are not assigned to the task.",
			"CANDELETEALL": "Can delete all tasks, even if they are not assigned to the task."
		},
		"MEETINGS": {
			"TITLE": "Meeting Permissions",
			"CANCREATE": "Can create meetings.",
			"CANVIEWALL": "Can view all meetings, even if they are not an attendee or facilitator.",
			"CANEDITALL": "Can edit all meetings, even if they are not a facilitator.",
			"CANDELETEALL": "Can delete all meetings, even if they are not the creator of the meeting."
		},
		"DOCUMENTS": {
			"TITLE": "Document Permissions",
			"CANCREATE": "Can create documents.",
			"CANEDITALL": "Can edit all documents, even if they are not an assigned editor.",
			"CANDELETEALL": "Can delete all documents, even if they are not the creator."
		},
		"HANDBOOK": {
			"TITLE": "Handbook Permissions",
			"CANCREATE": "Can create handbooks.",
			"CANEDITALL": "Can edit all handbooks, even if they are not an assigned editor.",
			"CANDELETEALL": "Can delete any handbook, even if they are not the creator."
		},
		"HANDBOOKENTRY": {
			"TITLE": "Handbook Entry Permissions",
			"CANCREATE": "Can add entries to handbooks where they are an assigned editor.",
			"CANEDITALL": "Can edit all handbook entires, even if they are not an assigned editor of the handbook.",
			"CANDELETEALL": "Can delete any handbook entry, even if they are not an assigned editor of the handbook."
		},
		"PHILOSOPHY": {
			"TITLE": "Philosophy Permissions",
			"CANEDITALL": "Can edit all philosophies, even if they are not an editor.",
			"CANDELETEALL": "Can delete any philosphy, even if they did not create it."
		},
		"STRATEGY": {
			"TITLE": "Strategy Permissions",
			"CANCREATE": "Can create a new strategy.",
			"CANEDITALL": "Can edit all strategies even if they are not an assigned editor.",
			"CANDELETEALL": "Can delete any strategy even if they did not create it."
		},
		"INITIATIVE": {
			"TITLE": "Initiative Permissions",
			"CANCREATE": "Can create a new initiative.",
			"CANEDITALL": "Can edit all initiatives even if they are not an assigned editor.",
			"CANDELETEALL": "Can delete any initiative even if they did not create it."
		}
	}

	);

})();

(function () {
	"use strict";

    angular.module('app.values').constant('kanbanStates', [
        { text: 'Not Started', icon: 'zmdi zmdi-hourglass-outline', iconColor: '#808080' },
        { text: 'In Progress', icon: 'zmdi zmdi-hourglass-alt', iconColor: '#39b54a' },
        { text: 'Completed', icon: 'zmdi zmdi-hourglass', iconColor: '#39b54a' }
    ]);
	
})();
(function () {
    "use strict";

    angular.module('app.values').constant('itemFields', {
        Members: {
            name: '$Members',
            primary: true,
            subheadSortOrder: 3,
            sortDirection: 'asc',
            icon: 'zmdi zmdi-accounts',
            display: 'Members',
            displayValue: '$Members.length', //for sorting
            displayTemplate: '<div layout="row" layout-align="start center"><au-profile-image item="user" ng-repeat="user in item.$Members | limitTo: 9" size="17" class="margin-right-5"></au-profile-image></div>' //for render
        },
        ParentConnections: {
            canEdit: true,
            relationship: { parentIdProperty: 'Parent', idProperty: '_id' },
            unassignedMembersText: "Root Documents",
            noManagedMembersText: "No Hierarchy Found",
            onParentUpdate: function (node, oldParent) {
                $q.all([node.userHasAcl('U'), !oldParent || oldParent.userHasAcl('U'), !node.$Parent || node.$Parent.userHasAcl('U')]).then(function (oks) {
                    if (oks[0] && oks[1] && oks[2]) {
                        node.$updateItem()
                    } else {
                        node.Parent = oldParent ? oldParent._id : null
                        toast.error('Permission denied. You must have update access to the old and new parents as well as the document you are grouping.')
                    }
                })
            }
        }
    });

})();
(function () {
	"use strict";

/**
 * @value helpText
 *
 * A list of values corresponding to help icons throughout the site.
 *
 * Consists of:
 * @param key {String} The value to use in the HTML in the site
 * @param link {String} The page name on the freshdesk site
 * @param title {String} The big text in the popup
 * @param description {String} The smaller text in the popup
 */

	angular.module('app.values').constant('helpText', [
		{
			key: 'AddUser.Dialog',
			link: '6000031513#abc',
			title: 'Add Users',
			description: 'Create users one at a time or upload a CSV file.'
		},
		{
			key: 'EditUser.ReportsTo',
			link: '6000106157#ReportsTo',
            //this should be a HowTo on connections
			title: 'Reports To',
			description: 'Who do you report to? Tag that person here.'
		},
        {
            key: 'EditUser.LoginAsUser',
            link: '6000106157#LoginAsUser',
            title: 'Login As This User',
            description: 'See this user\'s view of Align Us.'
        },
        {
            key: 'EditUser.Deactivate',
            link: '6000106157#AccountStatus',
            title: 'Account Status',
            description: 'This user\'s information will still be available to you, but they will not be able to login.'
        },
        {
            key: 'EditUser.NetworkID',
            link: '6000106157#NetworkID',
            title: 'Network ID',
            description: 'If your organization has Network IDs, you can add this user\'s here.'
        },
        {
            key: 'EditUser.PermissionPresets',
            link: '6000109498',
            title: 'Permission Presets',
            description: 'Choose permisison presets to apply to this user. These presets are created and managed by your organization.'
        },
        {
            key: 'AddUser.LoginInfo',
            link: '6000106157#AddUserOrTeam',
            title: 'Email Login Info',
            description: 'Align Us will send an email to the address provided with a random password to login with.'
        },
        {
            key: 'AddUser.PermissionPresets',
            link: '6000109498',
            title: 'Permission Presets',
            description: 'Choose permisison presets to apply to this user. These presets are created and managed by your organization.'
        },
        {
            key: 'AddUser.Upload',
            link: '6000106157#UploadUsers',
            title: 'Upload Users',
            description: 'The first line of your CSV file must be the headers: FirstName, LastName, Email. See the example file for more details.'
        },
        {
            key: 'Permissions.Members',
            link: '6000106265#PresetMembers',
            title: 'Preset Members',
            description: 'Choose which users this permission preset should be applied to. You can add users by typing their name and then cicking their name when it appears in the dropdown. You can remove users by clicking the X next to their name.'
        },
        {
            key: 'Permissions.AddPreset',
            link: '6000106265#AddPreset',
            title: 'Add Permission Preset',
            description: 'Enter the name of your new permission preset. You will complete the details of this preset after clicking Add Preset.'
        },
        {
            key: 'OrgSettings.Industry',
            link: '6000106506#OrgIndustry',
            title: 'Industry',
            description: 'Telling Align Us the industry that your organization belongs to will help us customize your experience.'
        },
        {
            key: 'OrgSettings.Timezone',
            link: '6000106506#Timezone',
            title: 'Timezone',
            description: 'Choose your organization\'s timezone based on the country and major city in your timezone.'
        },
        {
            key: 'OrgSettings.Color',
            link: '6000106506#ToolbarColor',
            title: 'Toolbar Color',
            description: 'The larger circle represents the main toolbar color and the smaller circle represents the accent color. Entering your own hex color will replace the toolbar color and automatically generate an accent color.'
        },
        {
            key: 'OrgSettings.ProfilePic',
            link: '6000106506#ProfilePic',
            title: 'Profile Picture',
            description: 'This picture will appear on the social intranet to represent your organization.'
        },
        {
            key: 'OrgSettings.AddLicenses.CurrentUsers',
            link: '6000106506#AddLicenses',
            title: 'Current Users',
            description: 'This is the number of users your organization has in Align Us right now.'
        },
        {
            key: 'OrgSettings.AddLicenses.CCV',
            link: '6000106506#AddLicenses',
            title: 'CCV',
            description: 'The three numbers on the back of your card.'
        },
        {
            key: 'OrgSettings.AddLicenses.AddedUsers',
            link: '6000106506#AddLicenses',
            title: 'Users Added',
            description: 'This is the number of user licenses you are adding to your organization.'
        },
        {
            key: 'OrgSettings.AddLicenses.TotalUsers',
            link: '6000106506#AddLicenses',
            title: 'Total Users',
            description: 'This is the total number of users your organization can have in Align Us, including the user licenses that are being added.'
        },
        {
            key: 'OrgSettings.AddLicenses.BillingInfo',
            link: '6000106506#AddLicenses',
            title: 'Billing Info',
            description: 'Verify that your billing info is correct. If not, click the back button to edit your info.'
        },
        {
            key: 'OrgSettings.LocationHead',
            link: '6000106506#LocationHead',
            title: 'Location Head',
            description: 'This user will have administrator access to this location\'s page on the social intranet. They will also be able to assign page editors.'
        },
        {
            key: 'OrgSettings.LocationPageEditor',
            link: '6000106506#PageEditors',
            title: 'Page Editors',
            description: 'These users will be able to edit this location\'s page on the social intranet, create posts as this location, and add users to the location\'s page.'
        },
        {
            key: 'OrgSettings.LocationProfilePic',
            link: '6000106506#LocationImage',
            title: 'Location Image',
            description: 'This picture will appear on the social intranet to represent this location.'
        },
        {
            key: 'OrgSettings.AddLocation',
            link: '6000106506#AddLocation',
            title: 'Add Location',
            description: 'Enter the name of the location you wish to add. You can edit the details of this location after you click Add Location.'
        },
        {
            key: 'OrgSettings.UploadLocations',
            link: '6000106506#UploadLocations',
            title: 'Upload Locations',
            description: 'The first line of your CSV file must be the headers. See the example file for more details.'
        },
        {
            key: 'OrgSettings.DepartmentHead',
            link: '6000106506#DepartmentHead',
            title: 'Department Head',
            description: 'This user will have administrator access to this department\'s page on the social intranet. They will also be able to assign page editors.'
        },
        {
            key: 'OrgSettings.DepartmentPageEditor',
            link: '6000106506#DeptPageEditors',
            title: 'Page Editors',
            description: 'These users will be able to edit this department\'s page on the social intranet, create posts as this department, and add users to the department\'s page.'
        },
        {
            key: 'OrgSettings.DepartmentProfilePic',
            link: '6000106506#DepartmentImage',
            title: 'Department Image',
            description: 'This picture will appear on the social intranet to represent this department.'
        },
        {
            key: 'OrgSettings.AddDepartment',
            link: '6000106506#AddDepartment',
            title: 'Add Department',
            description: 'Enter the name of the department you wish to add. You can edit the details of this department after you click Add Department.'
        },
        {
            key: 'OrgSettings.UploadDepartments',
            link: '6000106506#UploadDepartments',
            title: 'Upload Departments',
            description: 'The first line of your CSV file must be the headers. See the example file for more details.'
        },
        {
            key: 'OrgSettings.TeamPageEditor',
            link: '6000106157#TeamPageEditors',
            title: 'Page Editors',
            description: 'These users will be able to add and remove team members, edit the team\'s page on the social intranet, and create posts as this team on the social intranet.'
        },
        {
            key: 'OrgSettings.TeamProfilePic',
            link: '6000106157#TeamImage',
            title: 'Team Image',
            description: 'This picture will represent this team across Align Us.'
        },
        {
            key: 'EDITPERMISSIONS.USERS.ISADMINFOR.ORG',
            link: '6000106265#Permissions',
            title: 'User List Permission - System Admin',
            description: 'Typically for system administrators, this user can create and delete other users as well as edit all of their information.'
        },
        {
            key: 'EDITPERMISSIONS.USERS.CANVIEW',
            link: '6000106265#Permissions',
            title: 'User List Permission - Standard User',
            description: 'Recommended for all users, this user can search for other users and view their information.'
        },
        {
            key: 'EDITPERMISSIONS.ORGANIZATION.CANMANAGE',
            link: '6000106265#Permissions',
            title: 'Edit Org Profile and Settings - System Admin',
            description: 'Typically for system administrators, this user can edit the organization\'s address, timezone, color scheme, and profile page. The profile page is visible to the entire organization.'
        },
        {
            key: 'EDITPERMISSIONS.ORGANIZATION.CANMANAGELICENSES',
            link: '6000106265#Permissions',
            title: 'Purchase User Licenses - System Admin',
            description: 'Typically for system administrators, this user can purchase additional user licenses for your organization. Billing information is never saved.'
        },
        {
            key: 'EDITPERMISSIONS.DEPARTMENTS.CANMANAGE',
            link: '6000106265#Permissions',
            title: 'Departments - System Admin',
            description: 'Typically for system administrators, this user can create and delete departmants as well as edit department information: address, phone number, profile picture, department head, and page editors.'
        },
        {
            key: 'EDITPERMISSIONS.LOCATIONS.CANMANAGE',
            link: '6000106265#Permissions',
            title: 'Locations - System Admin',
            description: 'Typically for system administrators, this user can add and delete locations as well as edit location information: address, phone number, profile picture, location head, and page editors.'
        },
        {
            key: 'EDITPERMISSIONS.CONNECTIONS.CANVIEW',
            link: '6000106265#Permissions',
            title: 'Organization Teams and Org Charts',
            description: 'Recommended for all users, this user can view all of this organizations\'s teams and org charts.'
        },
        {
            key: 'EDITPERMISSIONS.PAGES.CANCREATE',
            link: '6000106265#Permissions',
            title: 'Social Intranet Pages',
            description: 'Recommended for all users, this user can create pages on the social intranet. Some examples of pages are group pages and event pages.'
        },
        {
            key: 'EDITPERMISSIONS.POSTS.CANCREATE',
            link: '6000106265#Permissions',
            title: 'Social Intranet Posts',
            description: 'Recommended for all users, this user can create posts on the social intranet. They will only be able to post on pages that they have access to.'
        },
        {
            key: 'EDITPERMISSIONS.FILES.CANCREATE',
            link: '6000106265#Permissions',
            title: 'Social Intranet Files',
            description: 'Recommended for all users, this user can create files on the social intranet. Other users can be invited to edit the file. Some examples of files are word documents and spreashsheets.'
        },
        {
            key: 'Project.LinkWithTeam',
            link: '',
            title: 'Link With A Team',
            description: 'When you link a project with a team all members of the team are added as members of this project. You can delete individual members by clicking the X next to their name.'
        },
        {
            key: 'Page.Viewer',
            link: '',
            title: 'Page Viewer',
            description: 'Since this page is private, these users only have access to view this page. They are not able to create posts or edit any sidebar widgets. In order to be notified about being tagged in a post on this page, the user must be a viewer or member.'
        },
        {
            key: 'Page.Member',
            link: '',
            title: 'Page Member',
            description: 'Since this page is private, these users have access to interact with and post on this page. They are not able to edit any sidebar widgets. In order to be notified about being tagged in a post on this page, the user must be a member or viewer.'
        },
        {
            key: 'Page.Editor',
            link: '6000138047#Editors',
            title: 'Page Editor',
            description: 'A page editor has administrative access to this page so they can edit the page details and moderate page activity. Only the system administrator can add and remove page editors.'
        },
        {
            key: 'Page.Followers',
            link: '6000138047#Followers',
            title: 'Page Followers',
            description: 'A page follower sees activity on this page in their news feed. They do not receive notification messages for every update on this page, posts on this page will simply be in their news feed.'
        },
        {
            key: 'Page.Attending',
            link: '',
            title: 'Attending this Event',
            description: 'The users in this section have all RSVP\'d saying they will be attending this event.'
        },
        {
            key: 'Page.SidebarWidget.About',
            link: '6000138047#About',
            title: 'About Page',
            description: 'Give a brief desctiption of the purpose of this page. If this is your profile page, tell everyone a little bit about yourself.'
        },
        {
            key: 'Page.SidebarWidget.Phone',
            link: '6000138047#ContactInfo',
            title: 'Contact Phone',
            description: 'This number is separate from any phone number that is saved in your user info in Structure. This number will be public and anyone who visits this page will be able to see it.'
        },
        {
            key: 'Page.SidebarWidget.Email',
            link: '6000138047#ContactInfo',
            title: 'Contact Email',
            description: 'This email is separate from any emails that are saved in your user info in Structure. This email will be public and anyone who visits this page will be able to see it.'
        },
        {
            key: 'Page.SidebarWidget.Address',
            link: '6000138047#ContactInfo',
            title: 'Contact Address',
            description: 'This address is separate from any addresses you have saved in your user info in Structure. This address will be public and anyone who visits this page will be able to see it.'
        },
        {
            key: 'Question.Answer.Vote',
            link: '6000138032#Vote',
            title: 'Vote Buttons',
            description: 'Use these buttons to vote on whether this was a helpful answer. Click the up arrow to indicate that this answer was accurate for this question. Click the down arrow to indicate that this answer was unhelpful.'
        },
        {
            key: 'Question.Body',
            link: '6000138032#Question',
            title: 'Question Body',
            description: 'This is the full explanation of the question as decsribed by the person who asked this question. You can submit your own answer to the question below or vote and comment on existing answers.'
        },
        {
            key: 'Project.Description',
            link: '',
            title: 'Project Description',
            description: 'Add your brief project description here. Remember that this will quickly explain what this project is all about.  Your project description is searchable in OneSearch too.'
        },
        {
            key: 'Project.Owner',
            link: '',
            title: 'Project Owner',
            description: 'Who\'s in charge of this project?' 
        },
        {
            key: 'Project.OwnerTeam',
            link: '',
            title: 'Project Owned by Team',
            description: 'Declare a team in charge of the project. Doing so syncs the team members to this project if they ever change and makes it easy to see what projects are being worked on by the team.' 
        },
        {
            key: 'Project.PlannedDates',
            link: '',
            title: 'Planned Start and End Dates',
            description: 'These are the dates you plan to begin and finish your project. You can separately record the actual dates you began and finished to compare your reality with your goals.'
        },
        {
            key: 'Project.ActualDates',
            link: '',
            title: 'Actual Start and End Dates',
            description: 'These are the dates that work actually began on the project and when the project was completed. It is helpful to compare these dates to the dates you planned to start and finish for planning future projects.'
        },
        {
            key: 'Project.StoryEditor',
            link: '',
            title: 'Story Editor',
            description: 'The story editor is the foundation for the entire project. Fill out your Story Editor with as much detail as you desire. Add tasks quickly inline by adding [ ] brackets, or tag colleagues by using the @ sign. Tag other projects using the + sign and tag documents using the # sign.'
        },
        {
            key: 'Project.TaskBoard',
            link: '',
            title: 'Task Board',
            description: 'All tasks created through the story editor appear in the task board. You can drag and drop tasks from Unassigned to a user and from one user to another. You can also drag and drop tasks through the kanban board to show their progress.'
        },
        {
            key: 'Project.Discussion',
            link: '',
            title: 'Discussion Board',
            description: 'This is a crucial piece of keeping everyone up-to-date on what is happening with this project. Also, this is an excellent place to post questions to the other project members. This discussion board, like most things, will also be searchable in the powerful OneSearch.'
        },
        {
            key: 'Project.Documents',
            link: '',
            title: 'Documents',
            description: 'Seamlessly connect an Align Us Document to this project or upload other supporting documents for this project. There is no limit to the amount of media that you can attach.'
        },
        {
            key: 'Project.SharedWith',
            link: '',
            title: 'Shared With Users',
            description: 'Users that you share this project with will be able to view all the project details but not edit anything. They will be able to post in the discussion board.'
        },
        {
            key: 'Project.Task.ProjectPriority',
            link: '',
            title: 'Project Priority',
            description: 'The priority level indicates how this task ranks amongst other tasks assigned to you for this project. High priority tasks will be listed higher in your column of the task board for this project.'
        },
        {
            key: 'Project.Task.PersonalPriority',
            link: '',
            title: 'Personal Priority',
            description: 'The priority level indicates how this task ranks compared to all tasks assigned to you. High priority tasks will be listed higher up in your personal task board.'
        },
        {
            key: 'Project.Task.EstimatedHours',
            link: '',
            title: 'Estimated Hours',
            description: 'This is the number of hours that this task should take to complete. This number can help you estimate how long it will take to complete the entire project as well as how many tasks to assign to a user.'
        },
        {
            key: 'Project.Task.UserAssign',
            link: '',
            title: 'User Assignment',
            description: 'Start typing the name of the user this task will be assigned to and select them from the drop down. We will automatically post in the task\'s discussion board and mention the user to let them know that the task has been assigned to them.'
        },
        {
            key: 'Project.Task.ProjectAssign',
            link: '',
            title: 'Project Assignment',
            description: 'If this task is assigned to a project, it will be inserted to the project\'s Story Editor and Task Board. You must be a member of the project to assign tasks to it.'
        },
        {
            key: 'Project.Task.MeetingAssign',
            link: '',
            title: 'Meeting Assignment',
            description: 'If this task is assigned to a meeting, it will be inserted to the meeting\'s Agenda and Task Board. You must be a facilitator of the meeting to assign tasks to it.'
        },
        {
            key: 'Project.Task.DocumentAssign',
            link: '',
            title: 'Document Assignment',
            description: 'If this task is assigned to a document, it will be embedded in the document. You must be an editor of the document to assign tasks to it.'
        },
        {
            key: 'Project.Task.SharedWith',
            link: '',
            title: 'Shared With',
            description: 'Sharing this task with users gives them access to view the task details but not edit anything. They will be able to post in the discussion board.'
        },
        {
            key: 'Project.Task.ParentTask',
            link: '',
            title: 'Parent Task',
            description: 'The parent task houses the task you are working on. Whoever can view and edit the parent task will also be able to view and edit this task.'
        },
        {
            key: 'Project.Active',
            link: '',
            title: 'Active / Inactive',
            description: 'When a project is set to inactive it will not appear in any project lists, only active projects will. You can view inactive projects by clicking on the Sort menu and choosing Show Inactive.'
        },
        {
            key: 'Project.Privacy',
            link: '',
            title: 'Privacy',
            description: 'Keep this project private by clicking the slide bar on the right.  Private means that only you and the other members of this project will be able to view, find, and search for the contents of it.  Public projects are visible to everyone but can only be edited by members.'
        },
        {
            key: 'Meeting.Cost',
            link: '',
            title: 'Estimated Meeting Costs',
            description: "The cost of this meeting is a rough estimate of how much your company will spending for everyone's time in the meeting. The number is based on each attendee's salary and will not display unless three or more attendees with salaries have been declared."
        },
        {
            key: 'Meeting.Location',
            link: '',
            title: 'Meeting Location',
            description: 'You can type in one of you organization\'s locations and select it from the drop down. Otherwise you can type in any location you want! Manage Locations in Structure > Organization Settings.' 
        },
        {
            key: 'Meeting.TopicItem',
            link: '',
            title: 'Topic Item',
            description: 'This item is the topic of this meeting. This item has a Meeting List card and you will find this meeting inside that card along with any other meetings where this item is the topic.'
        },
        {
            key: 'Document.Editors',
            link: '',
            title: 'Document Editors',
            description: 'Editors of this document are able to update the title and all of the content.'
        },
        {
            key: 'Document.Viewers',
            link: '',
            title: 'Shared With Users',
            description: 'Users that you share this document with are able to view the document only, they cannot make any changes.'
        },
        {
            key: 'Document.Inactive',
            link: '',
            title: 'Active / Inactive',
            description: 'When a document is marked Inactive, it will not appear in any lists of documents. You will be able to find it again in a list of documents by opening the Sort menu and choosing Show Inactive.'
        },
        {
            key: 'Document.Discussion',
            link: '',
            title: 'Document Discussion Board',
            description: 'This is a crucial piece of keeping everyone up-to-date on what is happening with this document. Also, this is an excellent place to post questions to the other document editors and viewers.'
        },
        {
            key: 'Philosophy.Mission',
            link: '',
            title: 'Mission',
            description: 'Why does this team, department, or location exist? What do we do? What is our purpose?'
        },
        {
            key: 'Philosophy.Vision',
            link: '',
            title: 'Vision',
            description: 'What is the effect of our mission? What does the world look like after the impact of our mission?'
        },
        {
            key: 'Message.SendAsEmail',
            link: '',
            title: 'Copy to Email',
            description: 'Email an alert to users who will receive this message - Useful if they check email more than Align Us'
        },
        {
            key: 'Task.Recurring',
            link: '',
            title: 'Task Regeneration',
            description: 'If this is a recurring task, Align Us can create a copy with a new due date for you when you complete it.'
        },
        {
            key: 'Initiative.Reviewer',
            link: '',
            title: 'Reviewer',
            description: 'Initiatives should be reviewed periodically. Review tasks will be assigned to users in this list.'
        },
        {
            key: 'OwnedBy.Description',
            link: '',
            title: 'Item Ownership',
            description: 'Listing a user, team, department or location is helpful because it allows users to quickly find items for the respective team, department or location. Members of the owning teams, departments or locations are all granted Read access to the item.'
        },
        {
            key: 'IsPrivate.Description',
            link: '',
            title: 'Internal Privacy',
            description: 'Be default, all items created in Align Us are searchable and visible to users within your organization. Users with view access to this item will see this item in search results and relevant menus / reports.'
        },
        {
            key: 'SharedWith.Description',
            link: '',
            title: 'Align Us Sharing',
            description: 'Sharing an item with a user grants view access and sends a notification link to the shared-with user(s).'
        },
        {
            key: 'CustomUrl.Description',
            link: '',
            title: 'Custom Url',
            description: 'Make it easy for the public to type and remember how to get to your item (project, page, document, etc). Only lower-case letters, numbers and dash (-) are allowed.'
        }

        

	]);

})();

(function () {
	"use strict";

	angular.module('app.values').constant('auMaterialColors', [
  {
    "name": "alignus",
    "color": "#be1e2d",
    "accent": "#b7b0a1"
  },
 {
    "name": "cardinal",
    "color": "#be1e2e",
    "accent": "#ff9800"
  },
 {
    "name": "crimson",
    "color": "#e91e63",
    "accent": "#9c27b0"
  },
 {
    "name": "eminence",
    "color": "#672f8f",
    "accent": "#e91e63"
  },
 {
    "name": "fuschia blue",
    "color": "#673ab7",
    "accent": "#2196f3"
  },
 {
    "name": "matisse",
    "color": "#1c75bc",
    "accent": "#ed1c24"
  },
 {
    "name": "cerulean",
    "color": "#00aeef",
    "accent": "#673ab7"
  },
 {
    "name": "pacific blue",
    "color": "#0099ad",
    "accent": "#ff9800"
  },
 {
    "name": "persian green",
    "color": "#00a69c",
    "accent": "#f69220"
  },
 {
    "name": "chateau green",
    "color": "#37b34a",
    "accent": "#ff9800"
  },
 {
    "name": "sushi",
    "color": "#39b54a",
    "accent": "#009688"
  },
 {
    "name": "sea buckthorn",
    "color": "#f69220",
    "accent": "#ff5722"
  },
 {
    "name": "roman coffee",
    "color": "#795548",
    "accent": "#ff9800"
  },
 {
    "name": "silver chalice",
    "color": "#9e9e9e",
    "accent": "#444444"
  },
 {
    "name": "gothic",
    "color": "#607d8b",
    "accent": "#5d5d5d"
  },
  
].map(function (e) {
		e.lightHighlight = (window.tinycolor(e.color).toHsl().l < 0.53);
		return e;
		})
	);
})();

(function () {

    serviceFunction.$inject = ["$state", "$rootScope", "$timeout", "$interval", "User", "Page"];
    angular.module('app').service('windowFab', serviceFunction);

    /* @ngInject */
    function serviceFunction($state, $rootScope, $timeout, $interval, User, Page) {
        var This = this
        $rootScope.windowFab = This
        $rootScope.fabButtons = []
        $rootScope.fabIcon = []
        $rootScope.fabSettings = []
        This.mode = "normal" // or "flip"
        This.forceHide = false

        this.button = function () {
            return angular.element('.window-fab .flip-container')
        }

        this.progress = function () {
            return angular.element('.window-fab #autoSaveProgress')
        }

        this.hideWindowFab = function () {
            This.fadeOut()
            This.showCloseItem = false
            fabTooltip = ""

            //let the fade out occur, then let then remove the element
            $timeout(function () {
                This.windowFabHidden = true
            }, 2010, false)
        }

        this.isFaded = function () {
            return This.button().hasClass('fadeOut')
        }

        this.fadeOut = function (fadeOut) {
            if (fadeOut == undefined) fadeOut = true
            This.windowFabHidden = false

            if (fadeOut) {
                This.button().addClass('fadeOut')
            } else {
                This.button().removeClass('fadeOut')
            }
        }

        this.setFabToCloseItem = function () {
            This.hideWindowFab()
            This.showCloseItem = true
        }

        this.setFlipped = function (state) {
            //fade this back in
            this.fadeOut(false)

            if (state) {
                This.button().addClass('flipped')
            } else {
                This.button().removeClass('flipped')
            }
        }

        this.setTooltip = function (message, alert) {
            $rootScope.fabTooltip = message

            if (alert) {
                $rootScope.rootTooltipVisible = true
                $timeout(function () {
                    $rootScope.rootTooltipVisible = false
                }, 1500, false)
            }
        }

        var autoSaveTimer
        this.startAutoSaveProgress = function (duration) {
            if (duration == null) duration = 3000

            //show the disk icon
            This.showCloseItem = false
            This.fadeOut(false)
            This.setFlipped(false)
            This.setTooltip('Auto-save in progress...')

            //show the spinner at zero
            $rootScope.saveProgressValue = 0
            This.progress().css('display', 'inherit')

            //debounce saves to 3 seconds			
            if (autoSaveTimer) $interval.cancel(autoSaveTimer)
            autoSaveTimer = $interval(function () {
                //tick the spinner up evenly through the debounce interval - trust the math
                $rootScope.saveProgressValue += 100 / (duration / 500);

                //reset back to the checkmark when autosave is done
                if ($rootScope.saveProgressValue >= 100) {
                    $interval.cancel(autoSaveTimer)
                    This.progress().css('display', 'none')

                    //set back to the checkmark
                    This.setFlipped(true)
                    This.setTooltip('All changes saved.')
                }
            }, 500, 10);
        }

        this.getVisibleButtons = function () {
            if (Object.byString($state, "$current.data.fabButtons")) {
                return $state.$current.data.fabButtons.filter(function (button) {
                    return button.permissionNeeded == undefined || $rootScope.$eval(button.permissionNeeded)
                })
            } else if ($rootScope.getItemFabButtons()) {
                return $rootScope.getItemFabButtons()
            } else {
                return []
            }
        }

        $rootScope.getItemFabButtons = function () {
            if (!$rootScope.fabButtons) return false
            return $rootScope.fabButtons[0] || false
        }
        $rootScope.getItemFabIcon = function () {
            if (!$rootScope.fabIcon) return false
            return $rootScope.fabIcon[0] || false
        }

        $rootScope.closeListItem = function () {
            This.showCloseItem = false
            $state.go('^')
        }

        $rootScope.$on('flipFabToSaved', function (event) {
            This.progress().css('display', 'none')
            //set back to then checkmark
            This.setFlipped(true)
            This.setTooltip('All changes saved.')
        })

    } //end of service function
})(); //end of self-invoking function
(function() {
	'use strict';
		videoStreamRecipe.$inject = ["$q"];
	angular
		.module('app')
		.service('videoStream', videoStreamRecipe)

		/* @ngInject */
		function videoStreamRecipe($q) {
			var constraints = {
				'videoLow': {
					width: { max: 320 },
					height: { max: 240 }
				},
				'videoMedium': {
					width: { max: 640 },
					height: { max: 360 }
				},
				'videoHigh': {
					width: { max: 1280 },
					height: { max: 720 }
				},
				'videoNone': false
			}
			return {
				// options: { videoType, beginMuted, videoDeviceId, audioDeviceId }
				// videoType string 'null' = video stream will be disabled
				get: function(options) {
					var streamPromise = $q.defer()

					var video = false
					var audio = !options.beginNoAudio

					// short-circuit and bail if we don't have good options
					if(!audio && options.videoType == 'videoNone') return $q.resolve(undefined)

					// if they want to use a specific audio device, do so
					if(options.audioDeviceId) audio = { deviceId: options.audioDeviceId }					

					// if they passed a video type...
					if(options.videoType) {
						// grab a constraint that matches that video type
						video = angular.copy(constraints[options.videoType])
						// if they desire video, use either the a caller-provided device ID or don't specify one
						if(options.videoType != 'videoNone') video.deviceId = options.videoDeviceId ? {exact: options.videoDeviceId} : undefined
					}

					navigator.getUserMedia({
						video: video,
						audio: audio
					}, function(stream) {
						if(options.beginMuted) stream.getAudioTracks()[0].enabled = false
						// provide a convenient way for UI/caller to know that the stream is audio only
						if(!options.videoType) stream.audioOnly = true
						streamPromise.resolve(stream)
					}, function(error) {
						console.log('Stream retrieval rejected with error:')
						console.log(error)
						streamPromise.reject(error)
					})
					return streamPromise.promise
				}
			}
		}
})();
(function() {
    'use strict';
    stemmerRecipe.$inject = ["stopwords"];
    angular
    .module('app')
    .service('stemmer', stemmerRecipe)

    /* @ngInject */
    function stemmerRecipe(stopwords) {
        // Reference Javascript Porter Stemmer. This code corresponds to the original
        // 1980 paper available here: http://tartarus.org/martin/PorterStemmer/def.txt
        // The latest version of this code is available at https://github.com/kristopolous/Porter-Stemmer
        //
        // Original comment:
        // Porter stemmer in Javascript. Few comments, but it's easy to follow against the rules in the original
        // paper, in
        //
        //  Porter, 1980, An algorithm for suffix stripping, Program, Vol. 14,
        //  no. 3, pp 130-137,
        //
        // see also http://www.tartarus.org/~martin/PorterStemmer
        var stemmer = (function(){
        var step2list = {
            "ational" : "ate",
            "tional" : "tion",
            "enci" : "ence",
            "anci" : "ance",
            "izer" : "ize",
            "bli" : "ble",
            "alli" : "al",
            "entli" : "ent",
            "eli" : "e",
            "ousli" : "ous",
            "ization" : "ize",
            "ation" : "ate",
            "ator" : "ate",
            "alism" : "al",
            "iveness" : "ive",
            "fulness" : "ful",
            "ousness" : "ous",
            "aliti" : "al",
            "iviti" : "ive",
            "biliti" : "ble",
            "logi" : "log"
            },

            step3list = {
            "icate" : "ic",
            "ative" : "",
            "alize" : "al",
            "iciti" : "ic",
            "ical" : "ic",
            "ful" : "",
            "ness" : ""
            },

            c = "[^aeiou]",          // consonant
            v = "[aeiouy]",          // vowel
            C = c + "[^aeiouy]*",    // consonant sequence
            V = v + "[aeiou]*",      // vowel sequence

            mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
            meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
            mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
            s_v = "^(" + C + ")?" + v;                   // vowel in stem

        function dummyDebug() {}

        function realDebug() {
            console.log(Array.prototype.slice.call(arguments).join(' '));
        }

        return function (w, debug) {
            var
            stem,
            suffix,
            firstch,
            re,
            re2,
            re3,
            re4,
            debugFunction,
            origword = w;

            if (debug) {
            debugFunction = realDebug;
            } else {
            debugFunction = dummyDebug;
            }

            if (w.length < 3) { return w; }

            firstch = w.substr(0,1);
            if (firstch == "y") {
            w = firstch.toUpperCase() + w.substr(1);
            }

            // Step 1a
            re = /^(.+?)(ss|i)es$/;
            re2 = /^(.+?)([^s])s$/;

            if (re.test(w)) { 
            w = w.replace(re,"$1$2"); 
            debugFunction('1a',re, w);

            } else if (re2.test(w)) {
            w = w.replace(re2,"$1$2"); 
            debugFunction('1a',re2, w);
            }

            // Step 1b
            re = /^(.+?)eed$/;
            re2 = /^(.+?)(ed|ing)$/;
            if (re.test(w)) {
            var fp = re.exec(w);
            re = new RegExp(mgr0);
            if (re.test(fp[1])) {
                re = /.$/;
                w = w.replace(re,"");
                debugFunction('1b',re, w);
            }
            } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem = fp[1];
            re2 = new RegExp(s_v);
            if (re2.test(stem)) {
                w = stem;
                debugFunction('1b', re2, w);

                re2 = /(at|bl|iz)$/;
                re3 = new RegExp("([^aeiouylsz])\\1$");
                re4 = new RegExp("^" + C + v + "[^aeiouwxy]$");

                if (re2.test(w)) { 
                w = w + "e"; 
                debugFunction('1b', re2, w);

                } else if (re3.test(w)) { 
                re = /.$/; 
                w = w.replace(re,""); 
                debugFunction('1b', re3, w);

                } else if (re4.test(w)) { 
                w = w + "e"; 
                debugFunction('1b', re4, w);
                }
            }
            }

            // Step 1c
            re = new RegExp("^(.*" + v + ".*)y$");
            if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            w = stem + "i";
            debugFunction('1c', re, w);
            }

            // Step 2
            re = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
            if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            suffix = fp[2];
            re = new RegExp(mgr0);
            if (re.test(stem)) {
                w = stem + step2list[suffix];
                debugFunction('2', re, w);
            }
            }

            // Step 3
            re = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
            if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            suffix = fp[2];
            re = new RegExp(mgr0);
            if (re.test(stem)) {
                w = stem + step3list[suffix];
                debugFunction('3', re, w);
            }
            }

            // Step 4
            re = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
            re2 = /^(.+?)(s|t)(ion)$/;
            if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            re = new RegExp(mgr1);
            if (re.test(stem)) {
                w = stem;
                debugFunction('4', re, w);
            }
            } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem = fp[1] + fp[2];
            re2 = new RegExp(mgr1);
            if (re2.test(stem)) {
                w = stem;
                debugFunction('4', re2, w);
            }
            }

            // Step 5
            re = /^(.+?)e$/;
            if (re.test(w)) {
            var fp = re.exec(w);
            stem = fp[1];
            re = new RegExp(mgr1);
            re2 = new RegExp(meq1);
            re3 = new RegExp("^" + C + v + "[^aeiouwxy]$");
            if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
                w = stem;
                debugFunction('5', re, re2, re3, w);
            }
            }

            re = /ll$/;
            re2 = new RegExp(mgr1);
            if (re.test(w) && re2.test(w)) {
            re = /.$/;
            w = w.replace(re,"");
            debugFunction('5', re, re2, w);
            }

            // and turn initial Y back to y
            if (firstch == "y") {
            w = firstch.toLowerCase() + w.substr(1);
            }


            return w;
        }
        })();

        return {
            getStems: function (text) {
                //split the text on anything that isn't a letter
                //replace apostrophes so we don't break up words like "we've" into two words		
                var words = text.replace(/'/g, "").split(/[^A-z]/)

                //loop through discarding blanks and returning word stems
                var stems = []
                for (var i = 0; i < words.length; i++) {
                    var word = words[i]

                    //ignore blanks and stop words (note that we've, in the stopwords file is weve)
                    if (word == "") continue
                    if (stopwords.indexOf(word) > -1) continue

                    var stem = stemmer(word)
                    
                    stems.push(stem)
                }

                return stems
            }
        }
    }

})();
// this is the minified version of Mozilla's "source-map" library (https://github.com/mozilla/source-map)
// found at https://raw.githubusercontent.com/mozilla/source-map/master/dist/source-map.min.js
// they suggest directly including this file with a script tag; however, they've set the file to the wrong MIME type (nice)
// and Chrome won't execute it as a result. can't serve it from our filesystem as their bower config is incompatible with our gulp setup.
// this was the easiest path.
!function(e,n){"object"==typeof exports&&"object"==typeof module?module.exports=n():"function"==typeof define&&define.amd?define([],n):"object"==typeof exports?exports.sourceMap=n():e.sourceMap=n()}(this,function(){return function(e){function n(t){if(r[t])return r[t].exports;var o=r[t]={exports:{},id:t,loaded:!1};return e[t].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=e,n.c=r,n.p="",n(0)}([function(e,n,r){n.SourceMapGenerator=r(1).SourceMapGenerator,n.SourceMapConsumer=r(7).SourceMapConsumer,n.SourceNode=r(10).SourceNode},function(e,n,r){function t(e){e||(e={}),this._file=i.getArg(e,"file",null),this._sourceRoot=i.getArg(e,"sourceRoot",null),this._skipValidation=i.getArg(e,"skipValidation",!1),this._sources=new s,this._names=new s,this._mappings=new a,this._sourcesContents=null}var o=r(2),i=r(4),s=r(5).ArraySet,a=r(6).MappingList;t.prototype._version=3,t.fromSourceMap=function(e){var n=e.sourceRoot,r=new t({file:e.file,sourceRoot:n});return e.eachMapping(function(e){var t={generated:{line:e.generatedLine,column:e.generatedColumn}};null!=e.source&&(t.source=e.source,null!=n&&(t.source=i.relative(n,t.source)),t.original={line:e.originalLine,column:e.originalColumn},null!=e.name&&(t.name=e.name)),r.addMapping(t)}),e.sources.forEach(function(n){var t=e.sourceContentFor(n);null!=t&&r.setSourceContent(n,t)}),r},t.prototype.addMapping=function(e){var n=i.getArg(e,"generated"),r=i.getArg(e,"original",null),t=i.getArg(e,"source",null),o=i.getArg(e,"name",null);this._skipValidation||this._validateMapping(n,r,t,o),null!=t&&(t=String(t),this._sources.has(t)||this._sources.add(t)),null!=o&&(o=String(o),this._names.has(o)||this._names.add(o)),this._mappings.add({generatedLine:n.line,generatedColumn:n.column,originalLine:null!=r&&r.line,originalColumn:null!=r&&r.column,source:t,name:o})},t.prototype.setSourceContent=function(e,n){var r=e;null!=this._sourceRoot&&(r=i.relative(this._sourceRoot,r)),null!=n?(this._sourcesContents||(this._sourcesContents=Object.create(null)),this._sourcesContents[i.toSetString(r)]=n):this._sourcesContents&&(delete this._sourcesContents[i.toSetString(r)],0===Object.keys(this._sourcesContents).length&&(this._sourcesContents=null))},t.prototype.applySourceMap=function(e,n,r){var t=n;if(null==n){if(null==e.file)throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');t=e.file}var o=this._sourceRoot;null!=o&&(t=i.relative(o,t));var a=new s,u=new s;this._mappings.unsortedForEach(function(n){if(n.source===t&&null!=n.originalLine){var s=e.originalPositionFor({line:n.originalLine,column:n.originalColumn});null!=s.source&&(n.source=s.source,null!=r&&(n.source=i.join(r,n.source)),null!=o&&(n.source=i.relative(o,n.source)),n.originalLine=s.line,n.originalColumn=s.column,null!=s.name&&(n.name=s.name))}var l=n.source;null==l||a.has(l)||a.add(l);var c=n.name;null==c||u.has(c)||u.add(c)},this),this._sources=a,this._names=u,e.sources.forEach(function(n){var t=e.sourceContentFor(n);null!=t&&(null!=r&&(n=i.join(r,n)),null!=o&&(n=i.relative(o,n)),this.setSourceContent(n,t))},this)},t.prototype._validateMapping=function(e,n,r,t){if((!(e&&"line"in e&&"column"in e&&e.line>0&&e.column>=0)||n||r||t)&&!(e&&"line"in e&&"column"in e&&n&&"line"in n&&"column"in n&&e.line>0&&e.column>=0&&n.line>0&&n.column>=0&&r))throw new Error("Invalid mapping: "+JSON.stringify({generated:e,source:r,original:n,name:t}))},t.prototype._serializeMappings=function(){for(var e,n,r,t,s=0,a=1,u=0,l=0,c=0,g=0,p="",h=this._mappings.toArray(),f=0,d=h.length;d>f;f++){if(n=h[f],e="",n.generatedLine!==a)for(s=0;n.generatedLine!==a;)e+=";",a++;else if(f>0){if(!i.compareByGeneratedPositionsInflated(n,h[f-1]))continue;e+=","}e+=o.encode(n.generatedColumn-s),s=n.generatedColumn,null!=n.source&&(t=this._sources.indexOf(n.source),e+=o.encode(t-g),g=t,e+=o.encode(n.originalLine-1-l),l=n.originalLine-1,e+=o.encode(n.originalColumn-u),u=n.originalColumn,null!=n.name&&(r=this._names.indexOf(n.name),e+=o.encode(r-c),c=r)),p+=e}return p},t.prototype._generateSourcesContent=function(e,n){return e.map(function(e){if(!this._sourcesContents)return null;null!=n&&(e=i.relative(n,e));var r=i.toSetString(e);return Object.prototype.hasOwnProperty.call(this._sourcesContents,r)?this._sourcesContents[r]:null},this)},t.prototype.toJSON=function(){var e={version:this._version,sources:this._sources.toArray(),names:this._names.toArray(),mappings:this._serializeMappings()};return null!=this._file&&(e.file=this._file),null!=this._sourceRoot&&(e.sourceRoot=this._sourceRoot),this._sourcesContents&&(e.sourcesContent=this._generateSourcesContent(e.sources,e.sourceRoot)),e},t.prototype.toString=function(){return JSON.stringify(this.toJSON())},n.SourceMapGenerator=t},function(e,n,r){function t(e){return 0>e?(-e<<1)+1:(e<<1)+0}function o(e){var n=1===(1&e),r=e>>1;return n?-r:r}var i=r(3),s=5,a=1<<s,u=a-1,l=a;n.encode=function(e){var n,r="",o=t(e);do n=o&u,o>>>=s,o>0&&(n|=l),r+=i.encode(n);while(o>0);return r},n.decode=function(e,n,r){var t,a,c=e.length,g=0,p=0;do{if(n>=c)throw new Error("Expected more digits in base 64 VLQ value.");if(a=i.decode(e.charCodeAt(n++)),-1===a)throw new Error("Invalid base64 digit: "+e.charAt(n-1));t=!!(a&l),a&=u,g+=a<<p,p+=s}while(t);r.value=o(g),r.rest=n}},function(e,n){var r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");n.encode=function(e){if(e>=0&&e<r.length)return r[e];throw new TypeError("Must be between 0 and 63: "+e)},n.decode=function(e){var n=65,r=90,t=97,o=122,i=48,s=57,a=43,u=47,l=26,c=52;return e>=n&&r>=e?e-n:e>=t&&o>=e?e-t+l:e>=i&&s>=e?e-i+c:e==a?62:e==u?63:-1}},function(e,n){function r(e,n,r){if(n in e)return e[n];if(3===arguments.length)return r;throw new Error('"'+n+'" is a required argument.')}function t(e){var n=e.match(m);return n?{scheme:n[1],auth:n[2],host:n[3],port:n[4],path:n[5]}:null}function o(e){var n="";return e.scheme&&(n+=e.scheme+":"),n+="//",e.auth&&(n+=e.auth+"@"),e.host&&(n+=e.host),e.port&&(n+=":"+e.port),e.path&&(n+=e.path),n}function i(e){var r=e,i=t(e);if(i){if(!i.path)return e;r=i.path}for(var s,a=n.isAbsolute(r),u=r.split(/\/+/),l=0,c=u.length-1;c>=0;c--)s=u[c],"."===s?u.splice(c,1):".."===s?l++:l>0&&(""===s?(u.splice(c+1,l),l=0):(u.splice(c,2),l--));return r=u.join("/"),""===r&&(r=a?"/":"."),i?(i.path=r,o(i)):r}function s(e,n){""===e&&(e="."),""===n&&(n=".");var r=t(n),s=t(e);if(s&&(e=s.path||"/"),r&&!r.scheme)return s&&(r.scheme=s.scheme),o(r);if(r||n.match(_))return n;if(s&&!s.host&&!s.path)return s.host=n,o(s);var a="/"===n.charAt(0)?n:i(e.replace(/\/+$/,"")+"/"+n);return s?(s.path=a,o(s)):a}function a(e,n){""===e&&(e="."),e=e.replace(/\/$/,"");for(var r=0;0!==n.indexOf(e+"/");){var t=e.lastIndexOf("/");if(0>t)return n;if(e=e.slice(0,t),e.match(/^([^\/]+:\/)?\/*$/))return n;++r}return Array(r+1).join("../")+n.substr(e.length+1)}function u(e){return e}function l(e){return g(e)?"$"+e:e}function c(e){return g(e)?e.slice(1):e}function g(e){if(!e)return!1;var n=e.length;if(9>n)return!1;if(95!==e.charCodeAt(n-1)||95!==e.charCodeAt(n-2)||111!==e.charCodeAt(n-3)||116!==e.charCodeAt(n-4)||111!==e.charCodeAt(n-5)||114!==e.charCodeAt(n-6)||112!==e.charCodeAt(n-7)||95!==e.charCodeAt(n-8)||95!==e.charCodeAt(n-9))return!1;for(var r=n-10;r>=0;r--)if(36!==e.charCodeAt(r))return!1;return!0}function p(e,n,r){var t=e.source-n.source;return 0!==t?t:(t=e.originalLine-n.originalLine,0!==t?t:(t=e.originalColumn-n.originalColumn,0!==t||r?t:(t=e.generatedColumn-n.generatedColumn,0!==t?t:(t=e.generatedLine-n.generatedLine,0!==t?t:e.name-n.name))))}function h(e,n,r){var t=e.generatedLine-n.generatedLine;return 0!==t?t:(t=e.generatedColumn-n.generatedColumn,0!==t||r?t:(t=e.source-n.source,0!==t?t:(t=e.originalLine-n.originalLine,0!==t?t:(t=e.originalColumn-n.originalColumn,0!==t?t:e.name-n.name))))}function f(e,n){return e===n?0:e>n?1:-1}function d(e,n){var r=e.generatedLine-n.generatedLine;return 0!==r?r:(r=e.generatedColumn-n.generatedColumn,0!==r?r:(r=f(e.source,n.source),0!==r?r:(r=e.originalLine-n.originalLine,0!==r?r:(r=e.originalColumn-n.originalColumn,0!==r?r:f(e.name,n.name)))))}n.getArg=r;var m=/^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/,_=/^data:.+\,.+$/;n.urlParse=t,n.urlGenerate=o,n.normalize=i,n.join=s,n.isAbsolute=function(e){return"/"===e.charAt(0)||!!e.match(m)},n.relative=a;var v=function(){var e=Object.create(null);return!("__proto__"in e)}();n.toSetString=v?u:l,n.fromSetString=v?u:c,n.compareByOriginalPositions=p,n.compareByGeneratedPositionsDeflated=h,n.compareByGeneratedPositionsInflated=d},function(e,n,r){function t(){this._array=[],this._set=Object.create(null)}var o=r(4),i=Object.prototype.hasOwnProperty;t.fromArray=function(e,n){for(var r=new t,o=0,i=e.length;i>o;o++)r.add(e[o],n);return r},t.prototype.size=function(){return Object.getOwnPropertyNames(this._set).length},t.prototype.add=function(e,n){var r=o.toSetString(e),t=i.call(this._set,r),s=this._array.length;(!t||n)&&this._array.push(e),t||(this._set[r]=s)},t.prototype.has=function(e){var n=o.toSetString(e);return i.call(this._set,n)},t.prototype.indexOf=function(e){var n=o.toSetString(e);if(i.call(this._set,n))return this._set[n];throw new Error('"'+e+'" is not in the set.')},t.prototype.at=function(e){if(e>=0&&e<this._array.length)return this._array[e];throw new Error("No element indexed by "+e)},t.prototype.toArray=function(){return this._array.slice()},n.ArraySet=t},function(e,n,r){function t(e,n){var r=e.generatedLine,t=n.generatedLine,o=e.generatedColumn,s=n.generatedColumn;return t>r||t==r&&s>=o||i.compareByGeneratedPositionsInflated(e,n)<=0}function o(){this._array=[],this._sorted=!0,this._last={generatedLine:-1,generatedColumn:0}}var i=r(4);o.prototype.unsortedForEach=function(e,n){this._array.forEach(e,n)},o.prototype.add=function(e){t(this._last,e)?(this._last=e,this._array.push(e)):(this._sorted=!1,this._array.push(e))},o.prototype.toArray=function(){return this._sorted||(this._array.sort(i.compareByGeneratedPositionsInflated),this._sorted=!0),this._array},n.MappingList=o},function(e,n,r){function t(e){var n=e;return"string"==typeof e&&(n=JSON.parse(e.replace(/^\)\]\}'/,""))),null!=n.sections?new s(n):new o(n)}function o(e){var n=e;"string"==typeof e&&(n=JSON.parse(e.replace(/^\)\]\}'/,"")));var r=a.getArg(n,"version"),t=a.getArg(n,"sources"),o=a.getArg(n,"names",[]),i=a.getArg(n,"sourceRoot",null),s=a.getArg(n,"sourcesContent",null),u=a.getArg(n,"mappings"),c=a.getArg(n,"file",null);if(r!=this._version)throw new Error("Unsupported version: "+r);t=t.map(String).map(a.normalize).map(function(e){return i&&a.isAbsolute(i)&&a.isAbsolute(e)?a.relative(i,e):e}),this._names=l.fromArray(o.map(String),!0),this._sources=l.fromArray(t,!0),this.sourceRoot=i,this.sourcesContent=s,this._mappings=u,this.file=c}function i(){this.generatedLine=0,this.generatedColumn=0,this.source=null,this.originalLine=null,this.originalColumn=null,this.name=null}function s(e){var n=e;"string"==typeof e&&(n=JSON.parse(e.replace(/^\)\]\}'/,"")));var r=a.getArg(n,"version"),o=a.getArg(n,"sections");if(r!=this._version)throw new Error("Unsupported version: "+r);this._sources=new l,this._names=new l;var i={line:-1,column:0};this._sections=o.map(function(e){if(e.url)throw new Error("Support for url field in sections not implemented.");var n=a.getArg(e,"offset"),r=a.getArg(n,"line"),o=a.getArg(n,"column");if(r<i.line||r===i.line&&o<i.column)throw new Error("Section offsets must be ordered and non-overlapping.");return i=n,{generatedOffset:{generatedLine:r+1,generatedColumn:o+1},consumer:new t(a.getArg(e,"map"))}})}var a=r(4),u=r(8),l=r(5).ArraySet,c=r(2),g=r(9).quickSort;t.fromSourceMap=function(e){return o.fromSourceMap(e)},t.prototype._version=3,t.prototype.__generatedMappings=null,Object.defineProperty(t.prototype,"_generatedMappings",{get:function(){return this.__generatedMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__generatedMappings}}),t.prototype.__originalMappings=null,Object.defineProperty(t.prototype,"_originalMappings",{get:function(){return this.__originalMappings||this._parseMappings(this._mappings,this.sourceRoot),this.__originalMappings}}),t.prototype._charIsMappingSeparator=function(e,n){var r=e.charAt(n);return";"===r||","===r},t.prototype._parseMappings=function(e,n){throw new Error("Subclasses must implement _parseMappings")},t.GENERATED_ORDER=1,t.ORIGINAL_ORDER=2,t.GREATEST_LOWER_BOUND=1,t.LEAST_UPPER_BOUND=2,t.prototype.eachMapping=function(e,n,r){var o,i=n||null,s=r||t.GENERATED_ORDER;switch(s){case t.GENERATED_ORDER:o=this._generatedMappings;break;case t.ORIGINAL_ORDER:o=this._originalMappings;break;default:throw new Error("Unknown order of iteration.")}var u=this.sourceRoot;o.map(function(e){var n=null===e.source?null:this._sources.at(e.source);return null!=n&&null!=u&&(n=a.join(u,n)),{source:n,generatedLine:e.generatedLine,generatedColumn:e.generatedColumn,originalLine:e.originalLine,originalColumn:e.originalColumn,name:null===e.name?null:this._names.at(e.name)}},this).forEach(e,i)},t.prototype.allGeneratedPositionsFor=function(e){var n=a.getArg(e,"line"),r={source:a.getArg(e,"source"),originalLine:n,originalColumn:a.getArg(e,"column",0)};if(null!=this.sourceRoot&&(r.source=a.relative(this.sourceRoot,r.source)),!this._sources.has(r.source))return[];r.source=this._sources.indexOf(r.source);var t=[],o=this._findMapping(r,this._originalMappings,"originalLine","originalColumn",a.compareByOriginalPositions,u.LEAST_UPPER_BOUND);if(o>=0){var i=this._originalMappings[o];if(void 0===e.column)for(var s=i.originalLine;i&&i.originalLine===s;)t.push({line:a.getArg(i,"generatedLine",null),column:a.getArg(i,"generatedColumn",null),lastColumn:a.getArg(i,"lastGeneratedColumn",null)}),i=this._originalMappings[++o];else for(var l=i.originalColumn;i&&i.originalLine===n&&i.originalColumn==l;)t.push({line:a.getArg(i,"generatedLine",null),column:a.getArg(i,"generatedColumn",null),lastColumn:a.getArg(i,"lastGeneratedColumn",null)}),i=this._originalMappings[++o]}return t},n.SourceMapConsumer=t,o.prototype=Object.create(t.prototype),o.prototype.consumer=t,o.fromSourceMap=function(e){var n=Object.create(o.prototype),r=n._names=l.fromArray(e._names.toArray(),!0),t=n._sources=l.fromArray(e._sources.toArray(),!0);n.sourceRoot=e._sourceRoot,n.sourcesContent=e._generateSourcesContent(n._sources.toArray(),n.sourceRoot),n.file=e._file;for(var s=e._mappings.toArray().slice(),u=n.__generatedMappings=[],c=n.__originalMappings=[],p=0,h=s.length;h>p;p++){var f=s[p],d=new i;d.generatedLine=f.generatedLine,d.generatedColumn=f.generatedColumn,f.source&&(d.source=t.indexOf(f.source),d.originalLine=f.originalLine,d.originalColumn=f.originalColumn,f.name&&(d.name=r.indexOf(f.name)),c.push(d)),u.push(d)}return g(n.__originalMappings,a.compareByOriginalPositions),n},o.prototype._version=3,Object.defineProperty(o.prototype,"sources",{get:function(){return this._sources.toArray().map(function(e){return null!=this.sourceRoot?a.join(this.sourceRoot,e):e},this)}}),o.prototype._parseMappings=function(e,n){for(var r,t,o,s,u,l=1,p=0,h=0,f=0,d=0,m=0,_=e.length,v=0,C={},y={},A=[],S=[];_>v;)if(";"===e.charAt(v))l++,v++,p=0;else if(","===e.charAt(v))v++;else{for(r=new i,r.generatedLine=l,s=v;_>s&&!this._charIsMappingSeparator(e,s);s++);if(t=e.slice(v,s),o=C[t])v+=t.length;else{for(o=[];s>v;)c.decode(e,v,y),u=y.value,v=y.rest,o.push(u);if(2===o.length)throw new Error("Found a source, but no line and column");if(3===o.length)throw new Error("Found a source and line, but no column");C[t]=o}r.generatedColumn=p+o[0],p=r.generatedColumn,o.length>1&&(r.source=d+o[1],d+=o[1],r.originalLine=h+o[2],h=r.originalLine,r.originalLine+=1,r.originalColumn=f+o[3],f=r.originalColumn,o.length>4&&(r.name=m+o[4],m+=o[4])),S.push(r),"number"==typeof r.originalLine&&A.push(r)}g(S,a.compareByGeneratedPositionsDeflated),this.__generatedMappings=S,g(A,a.compareByOriginalPositions),this.__originalMappings=A},o.prototype._findMapping=function(e,n,r,t,o,i){if(e[r]<=0)throw new TypeError("Line must be greater than or equal to 1, got "+e[r]);if(e[t]<0)throw new TypeError("Column must be greater than or equal to 0, got "+e[t]);return u.search(e,n,o,i)},o.prototype.computeColumnSpans=function(){for(var e=0;e<this._generatedMappings.length;++e){var n=this._generatedMappings[e];if(e+1<this._generatedMappings.length){var r=this._generatedMappings[e+1];if(n.generatedLine===r.generatedLine){n.lastGeneratedColumn=r.generatedColumn-1;continue}}n.lastGeneratedColumn=1/0}},o.prototype.originalPositionFor=function(e){var n={generatedLine:a.getArg(e,"line"),generatedColumn:a.getArg(e,"column")},r=this._findMapping(n,this._generatedMappings,"generatedLine","generatedColumn",a.compareByGeneratedPositionsDeflated,a.getArg(e,"bias",t.GREATEST_LOWER_BOUND));if(r>=0){var o=this._generatedMappings[r];if(o.generatedLine===n.generatedLine){var i=a.getArg(o,"source",null);null!==i&&(i=this._sources.at(i),null!=this.sourceRoot&&(i=a.join(this.sourceRoot,i)));var s=a.getArg(o,"name",null);return null!==s&&(s=this._names.at(s)),{source:i,line:a.getArg(o,"originalLine",null),column:a.getArg(o,"originalColumn",null),name:s}}}return{source:null,line:null,column:null,name:null}},o.prototype.hasContentsOfAllSources=function(){return this.sourcesContent?this.sourcesContent.length>=this._sources.size()&&!this.sourcesContent.some(function(e){return null==e}):!1},o.prototype.sourceContentFor=function(e,n){if(!this.sourcesContent)return null;if(null!=this.sourceRoot&&(e=a.relative(this.sourceRoot,e)),this._sources.has(e))return this.sourcesContent[this._sources.indexOf(e)];var r;if(null!=this.sourceRoot&&(r=a.urlParse(this.sourceRoot))){var t=e.replace(/^file:\/\//,"");if("file"==r.scheme&&this._sources.has(t))return this.sourcesContent[this._sources.indexOf(t)];if((!r.path||"/"==r.path)&&this._sources.has("/"+e))return this.sourcesContent[this._sources.indexOf("/"+e)]}if(n)return null;throw new Error('"'+e+'" is not in the SourceMap.')},o.prototype.generatedPositionFor=function(e){var n=a.getArg(e,"source");if(null!=this.sourceRoot&&(n=a.relative(this.sourceRoot,n)),!this._sources.has(n))return{line:null,column:null,lastColumn:null};n=this._sources.indexOf(n);var r={source:n,originalLine:a.getArg(e,"line"),originalColumn:a.getArg(e,"column")},o=this._findMapping(r,this._originalMappings,"originalLine","originalColumn",a.compareByOriginalPositions,a.getArg(e,"bias",t.GREATEST_LOWER_BOUND));if(o>=0){var i=this._originalMappings[o];if(i.source===r.source)return{line:a.getArg(i,"generatedLine",null),column:a.getArg(i,"generatedColumn",null),lastColumn:a.getArg(i,"lastGeneratedColumn",null)}}return{line:null,column:null,lastColumn:null}},n.BasicSourceMapConsumer=o,s.prototype=Object.create(t.prototype),s.prototype.constructor=t,s.prototype._version=3,Object.defineProperty(s.prototype,"sources",{get:function(){for(var e=[],n=0;n<this._sections.length;n++)for(var r=0;r<this._sections[n].consumer.sources.length;r++)e.push(this._sections[n].consumer.sources[r]);return e}}),s.prototype.originalPositionFor=function(e){var n={generatedLine:a.getArg(e,"line"),generatedColumn:a.getArg(e,"column")},r=u.search(n,this._sections,function(e,n){var r=e.generatedLine-n.generatedOffset.generatedLine;return r?r:e.generatedColumn-n.generatedOffset.generatedColumn}),t=this._sections[r];return t?t.consumer.originalPositionFor({line:n.generatedLine-(t.generatedOffset.generatedLine-1),column:n.generatedColumn-(t.generatedOffset.generatedLine===n.generatedLine?t.generatedOffset.generatedColumn-1:0),bias:e.bias}):{source:null,line:null,column:null,name:null}},s.prototype.hasContentsOfAllSources=function(){return this._sections.every(function(e){return e.consumer.hasContentsOfAllSources()})},s.prototype.sourceContentFor=function(e,n){for(var r=0;r<this._sections.length;r++){var t=this._sections[r],o=t.consumer.sourceContentFor(e,!0);if(o)return o}if(n)return null;throw new Error('"'+e+'" is not in the SourceMap.')},s.prototype.generatedPositionFor=function(e){for(var n=0;n<this._sections.length;n++){var r=this._sections[n];if(-1!==r.consumer.sources.indexOf(a.getArg(e,"source"))){var t=r.consumer.generatedPositionFor(e);if(t){var o={line:t.line+(r.generatedOffset.generatedLine-1),column:t.column+(r.generatedOffset.generatedLine===t.line?r.generatedOffset.generatedColumn-1:0)};return o}}}return{line:null,column:null}},s.prototype._parseMappings=function(e,n){this.__generatedMappings=[],this.__originalMappings=[];for(var r=0;r<this._sections.length;r++)for(var t=this._sections[r],o=t.consumer._generatedMappings,i=0;i<o.length;i++){var s=o[i],u=t.consumer._sources.at(s.source);null!==t.consumer.sourceRoot&&(u=a.join(t.consumer.sourceRoot,u)),this._sources.add(u),u=this._sources.indexOf(u);var l=t.consumer._names.at(s.name);this._names.add(l),l=this._names.indexOf(l);var c={source:u,generatedLine:s.generatedLine+(t.generatedOffset.generatedLine-1),generatedColumn:s.generatedColumn+(t.generatedOffset.generatedLine===s.generatedLine?t.generatedOffset.generatedColumn-1:0),originalLine:s.originalLine,originalColumn:s.originalColumn,name:l};this.__generatedMappings.push(c),"number"==typeof c.originalLine&&this.__originalMappings.push(c)}g(this.__generatedMappings,a.compareByGeneratedPositionsDeflated),g(this.__originalMappings,a.compareByOriginalPositions)},n.IndexedSourceMapConsumer=s},function(e,n){function r(e,t,o,i,s,a){var u=Math.floor((t-e)/2)+e,l=s(o,i[u],!0);return 0===l?u:l>0?t-u>1?r(u,t,o,i,s,a):a==n.LEAST_UPPER_BOUND?t<i.length?t:-1:u:u-e>1?r(e,u,o,i,s,a):a==n.LEAST_UPPER_BOUND?u:0>e?-1:e}n.GREATEST_LOWER_BOUND=1,n.LEAST_UPPER_BOUND=2,n.search=function(e,t,o,i){if(0===t.length)return-1;var s=r(-1,t.length,e,t,o,i||n.GREATEST_LOWER_BOUND);if(0>s)return-1;for(;s-1>=0&&0===o(t[s],t[s-1],!0);)--s;return s}},function(e,n){function r(e,n,r){var t=e[n];e[n]=e[r],e[r]=t}function t(e,n){return Math.round(e+Math.random()*(n-e))}function o(e,n,i,s){if(s>i){var a=t(i,s),u=i-1;r(e,a,s);for(var l=e[s],c=i;s>c;c++)n(e[c],l)<=0&&(u+=1,r(e,u,c));r(e,u+1,c);var g=u+1;o(e,n,i,g-1),o(e,n,g+1,s)}}n.quickSort=function(e,n){o(e,n,0,e.length-1)}},function(e,n,r){function t(e,n,r,t,o){this.children=[],this.sourceContents={},this.line=null==e?null:e,this.column=null==n?null:n,this.source=null==r?null:r,this.name=null==o?null:o,this[u]=!0,null!=t&&this.add(t)}var o=r(1).SourceMapGenerator,i=r(4),s=/(\r?\n)/,a=10,u="$$$isSourceNode$$$";t.fromStringWithSourceMap=function(e,n,r){function o(e,n){if(null===e||void 0===e.source)a.add(n);else{var o=r?i.join(r,e.source):e.source;a.add(new t(e.originalLine,e.originalColumn,o,n,e.name))}}var a=new t,u=e.split(s),l=function(){var e=u.shift(),n=u.shift()||"";return e+n},c=1,g=0,p=null;return n.eachMapping(function(e){if(null!==p){if(!(c<e.generatedLine)){var n=u[0],r=n.substr(0,e.generatedColumn-g);return u[0]=n.substr(e.generatedColumn-g),g=e.generatedColumn,o(p,r),void(p=e)}o(p,l()),c++,g=0}for(;c<e.generatedLine;)a.add(l()),c++;if(g<e.generatedColumn){var n=u[0];a.add(n.substr(0,e.generatedColumn)),u[0]=n.substr(e.generatedColumn),g=e.generatedColumn}p=e},this),u.length>0&&(p&&o(p,l()),a.add(u.join(""))),n.sources.forEach(function(e){var t=n.sourceContentFor(e);null!=t&&(null!=r&&(e=i.join(r,e)),a.setSourceContent(e,t))}),a},t.prototype.add=function(e){if(Array.isArray(e))e.forEach(function(e){this.add(e)},this);else{if(!e[u]&&"string"!=typeof e)throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+e);e&&this.children.push(e)}return this},t.prototype.prepend=function(e){if(Array.isArray(e))for(var n=e.length-1;n>=0;n--)this.prepend(e[n]);else{if(!e[u]&&"string"!=typeof e)throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got "+e);this.children.unshift(e)}return this},t.prototype.walk=function(e){for(var n,r=0,t=this.children.length;t>r;r++)n=this.children[r],n[u]?n.walk(e):""!==n&&e(n,{source:this.source,line:this.line,column:this.column,name:this.name})},t.prototype.join=function(e){var n,r,t=this.children.length;if(t>0){for(n=[],r=0;t-1>r;r++)n.push(this.children[r]),n.push(e);n.push(this.children[r]),this.children=n}return this},t.prototype.replaceRight=function(e,n){var r=this.children[this.children.length-1];return r[u]?r.replaceRight(e,n):"string"==typeof r?this.children[this.children.length-1]=r.replace(e,n):this.children.push("".replace(e,n)),this},t.prototype.setSourceContent=function(e,n){this.sourceContents[i.toSetString(e)]=n},t.prototype.walkSourceContents=function(e){for(var n=0,r=this.children.length;r>n;n++)this.children[n][u]&&this.children[n].walkSourceContents(e);for(var t=Object.keys(this.sourceContents),n=0,r=t.length;r>n;n++)e(i.fromSetString(t[n]),this.sourceContents[t[n]])},t.prototype.toString=function(){var e="";return this.walk(function(n){e+=n}),e},t.prototype.toStringWithSourceMap=function(e){var n={code:"",line:1,column:0},r=new o(e),t=!1,i=null,s=null,u=null,l=null;return this.walk(function(e,o){n.code+=e,null!==o.source&&null!==o.line&&null!==o.column?((i!==o.source||s!==o.line||u!==o.column||l!==o.name)&&r.addMapping({source:o.source,original:{line:o.line,column:o.column},generated:{line:n.line,column:n.column},name:o.name}),i=o.source,s=o.line,u=o.column,l=o.name,t=!0):t&&(r.addMapping({generated:{line:n.line,column:n.column}}),i=null,t=!1);for(var c=0,g=e.length;g>c;c++)e.charCodeAt(c)===a?(n.line++,n.column=0,c+1===g?(i=null,t=!1):t&&r.addMapping({source:o.source,original:{line:o.line,column:o.column},generated:{line:n.line,column:n.column},name:o.name})):n.column++}),this.walkSourceContents(function(e,n){r.setSourceContent(e,n)}),{code:n.code,map:r}},n.SourceNode=t}])});



// i modified this slightly as it was configured to be loaded by require.js

/*
 * sourcemapped-stacktrace.js
 * created by James Salter <iteration@gmail.com> (2014)
 *
 * https://github.com/novocaine/sourcemapped-stacktrace
 *
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */

/*global define */

// note we only include source-map-consumer, not the whole source-map library,
// which includes gear for generating source maps that we don't need

  var global_mapForUri = {};

  /**
   * Re-map entries in a stacktrace using sourcemaps if available.
   *
   * @param {Array} stack - Array of strings from the browser's stack
   *                        representation. Currently only Chrome
   *                        format is supported.
   * @param {function} done - Callback invoked with the transformed stacktrace
   *                          (an Array of Strings) passed as the first
   *                          argument
   * @param {Object} [opts] - Optional options object.
   * @param {Function} [opts.filter] - Filter function applied to each stackTrace line.
   *                                   Lines which do not pass the filter won't be processesd.
   * @param {boolean} [opts.cacheGlobally] - Whether to cache sourcemaps globally across multiple calls.
   */
  var mapStackTrace = function(stack, done, opts) {
    var lines;
    var line;
    var mapForUri = {};
    var rows = {};
    var fields;
    var uri;
    var expected_fields;
    var regex;

    var fetcher = new Fetcher(function() {
      var result = processSourceMaps(lines, rows, fetcher.mapForUri);
      done(result);
    }, opts);

    if (isChromeOrEdge() || isIE11Plus()) {
      regex = /^ +at.+\((.*):([0-9]+):([0-9]+)/;
      expected_fields = 4;
      // (skip first line containing exception message)
      skip_lines = 1;
    } else if (isFirefox() || isSafari()) {
      regex = /@(.*):([0-9]+):([0-9]+)/;
      expected_fields = 4;
      skip_lines = 0;
    } else {
      throw new Error("unknown browser :(");
    }

    lines = stack.split("\n").slice(skip_lines);

    for (var i=0; i < lines.length; i++) {
      line = lines[i];
      if ( opts && opts.filter && !opts.filter(line) ) continue;
      
      fields = line.match(regex);
      if (fields && fields.length === expected_fields) {
        rows[i] = fields;
        uri = fields[1];
        if (!uri.match(/<anonymous>/)) {
          fetcher.fetchScript(uri);
        }
      }
    }

    // if opts.cacheGlobally set, all maps could have been cached already,
    // thus we need to call done callback right away
    if ( fetcher.sem === 0 ) {
      fetcher.done(fetcher.mapForUri);
    }
  };

  var isChromeOrEdge = function() {
    return navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
  };

  var isFirefox = function() {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  };  

  var isSafari = function() {
    return navigator.userAgent.toLowerCase().indexOf('safari') > -1;
  };
		
  var isIE11Plus = function() {
   	return document.documentMode && document.documentMode >= 11;
  };

  var Fetcher = function(done, opts) {
    this.sem = 0;
    this.mapForUri = opts && opts.cacheGlobally ? global_mapForUri : {};
    this.done = done;
  };

  Fetcher.prototype.fetchScript = function(uri) {
    if (!(uri in this.mapForUri)) {
      this.sem++;
      this.mapForUri[uri] = null;
    } else {
      return;
    }

    var xhr = createXMLHTTPObject();
    var that = this;
    xhr.onreadystatechange = function(e) {
      that.onScriptLoad.call(that, e, uri);
    };
    xhr.open("GET", uri, true);
    xhr.send();
  };

  var absUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');

  Fetcher.prototype.onScriptLoad = function(e, uri) {
    if (e.target.readyState !== 4) {
      return;
    }

    if (e.target.status === 200 ||
      (uri.slice(0, 7) === "file://" && e.target.status === 0))
    {
      // find .map in file.
      //
      // attempt to find it at the very end of the file, but tolerate trailing
      // whitespace inserted by some packers.
      var match = e.target.responseText.match("//# [s]ourceMappingURL=(.*)[\\s]*$", "m");
      if (match && match.length === 2) {
        // get the map
        var mapUri = match[1];

        var embeddedSourceMap = mapUri.match("data:application/json;(charset=[^;]+;)?base64,(.*)");

        if (embeddedSourceMap && embeddedSourceMap[2]) {
          this.mapForUri[uri] = new window.sourceMap.SourceMapConsumer(atob(embeddedSourceMap[2]));
          this.done(this.mapForUri);
        } else {
          if (!absUrlRegex.test(mapUri)) {
            // relative url; according to sourcemaps spec is 'source origin'
            var origin;
            var lastSlash = uri.lastIndexOf('/');
            if (lastSlash !== -1) {
              origin = uri.slice(0, lastSlash + 1);
              mapUri = origin + mapUri;
              // note if lastSlash === -1, actual script uri has no slash
              // somehow, so no way to use it as a prefix... we give up and try
              // as absolute
            }
          }

          var xhrMap = createXMLHTTPObject();
          var that = this;
          xhrMap.onreadystatechange = function() {
            if (xhrMap.readyState === 4) {
              that.sem--;
              if (xhrMap.status === 200 ||
                (mapUri.slice(0, 7) === "file://" && xhrMap.status === 0)) {
                that.mapForUri[uri] = new window.sourceMap.SourceMapConsumer(xhrMap.responseText);
              }
              if (that.sem === 0) {
                that.done(that.mapForUri);
              }
            }
          };

          xhrMap.open("GET", mapUri, true);
          xhrMap.send();
        }
      } else {
        // no map
        this.sem--;
      }
    } else {
      // HTTP error fetching uri of the script
      this.sem--;
    }

    if (this.sem === 0) {
      this.done(this.mapForUri);
    }
  };

  var processSourceMaps = function(lines, rows, mapForUri) {
    var result = [];
    var map;
    for (var i=0; i < lines.length; i++) {
      var row = rows[i];
      if (row) {
        var uri = row[1];
        var line = parseInt(row[2], 10);
        var column = parseInt(row[3], 10);
        map = mapForUri[uri];

        if (map) {
          // we think we have a map for that uri. call source-map library
          var origPos = map.originalPositionFor(
            { line: line, column: column });
          result.push(formatOriginalPosition(origPos.source,
            origPos.line, origPos.column, origPos.name || origName(lines[i])));
        } else {
          // we can't find a map for that url, but we parsed the row.
          // reformat unchanged line for consistency with the sourcemapped
          // lines.
          result.push(formatOriginalPosition(uri, line, column, origName(lines[i])));
        }
      } else {
        // we weren't able to parse the row, push back what we were given
        result.push(lines[i]);
      }
    }

    return result;
  };

  function origName(origLine) {
    var match = String(origLine).match((isChromeOrEdge() || isIE11Plus()) ?
      / +at +([^ ]*).*/ :
      /([^@]*)@.*/);
    return match && match[1];
  }

  var formatOriginalPosition = function(source, line, column, name) {
    // mimic chrome's format
    return "    at " + (name ? name : "(unknown)") +
      " (" + source + ":" + line + ":" + column + ")";
  };

  // xmlhttprequest boilerplate
  var XMLHttpFactories = [
	function () {return new XMLHttpRequest();},
	function () {return new ActiveXObject("Msxml2.XMLHTTP");},
	function () {return new ActiveXObject("Msxml3.XMLHTTP");},
	function () {return new ActiveXObject("Microsoft.XMLHTTP");}
  ];

  function createXMLHTTPObject() {
      var xmlhttp = false;
      for (var i=0;i<XMLHttpFactories.length;i++) {
          try {
              xmlhttp = XMLHttpFactories[i]();
          }
          catch (e) {
              continue;
          }
          break;
      }
      return xmlhttp;
  }

(function () {

	// @ngInject
	/**
	 * @ngdoc service
	 * @name socket
	 * @module app
	 *
	 * @description
	 *
	 * Service to keep the socket.io connection
	 */
	socketFunction.$inject = ["$timeout", "$rootScope", "$log", "$injector"];
	angular.module('app').service('socket', socketFunction);

	/* @ngInject */
	function socketFunction($timeout, $rootScope, $log, $injector) {
		var socketService = this
		var socket = io(window.location.origin, { autoConnect: false, transports: ['websocket', 'polling'] })
		socketService.socketTimeout = null
		var reconnectAttempts = 0
		var resetConnectAttempts

		function reconnectHandler() {
			//go to /login if we need to reconnect more than 20 times in 10 seconds
			reconnectAttempts++
			if (reconnectAttempts > 20) {
				$log.info('multiple socket disconnect/reconnects forced logout', reconnectAttempts)
				window.location = '/login'
			}
			clearTimeout(resetConnectAttempts)
			resetConnectAttempts = setInterval(function () { reconnectAttempts = 0 }, 1000 * 10)

			console.log('socket: reconnectHandler', $rootScope.offline, arguments)

			//get recent items if we were disconnected over 10 seconds
			var preloadForShell = $rootScope.getShellDataOnReconnect
			if (!$rootScope.offline) {
				preloadForShell = false
			}

			//after 3 seconds - to let the server it connected to finish starting up...
			//re-auth, refresh caches with the recentItems and update conversations
			var Authorization = $injector.get('Authorization')
			setTimeout(function () {
				$rootScope.$broadcast('socket-reconnected')

				Authorization.authorize({ preloadForShell: preloadForShell }).then(function () {
					$rootScope.$broadcast('user-socket-reconnected')
				})
			}, 3000)

			//hide the 'offline' message
			$rootScope.$apply(function () {
				console.log('socket: applying offline = false')
				$rootScope.offline = false
			})

			//the socket reconnected so cancel the pending offline timeout
			$timeout.cancel(socketService.socketTimeout)
		}

		socket.on('disconnect', function () {
			socket.off('connect')
			socket.off('reconnect')

			if ($rootScope.noAutoReconnect) return

			console.log('socket: disconnect')
			$rootScope.$broadcast('socket-disconnected')

			var oneReconnectHandler = once(reconnectHandler)
			socket.on('connect', oneReconnectHandler)
			socket.on('reconnect', oneReconnectHandler)

			//debounce over 10sec
			$timeout.cancel(socketService.socketTimeout)
			socketService.socketTimeout = $timeout(function () {
				console.log('socket: timeout in disconnect')

				$rootScope.offline = true

				
			}, 10000)
		})

		//check that the socket is connected every 10 seconds
		setInterval(function(){
			if (!$rootScope.offline) return 
			
			//forces a reconnect
			io.managers[Object.keys(io.managers)[0]].connect()
		}, 1000 * 10)

		socket.on('error', function (err) {
			console.error('Error in SocketIO:', err)
		})

		////////////////////////////////////////////////////////////////////
		//    API
		////////////////////////////////////////////////////////////////////

		socketService.getSocket = function () {
			return socket
		}

		socketService.on = function (trigger, fn) {
			socket.on.apply(socket, arguments)
		}

		socketService.off = function (trigger, fn) {
			socket.off(trigger, fn)
		}

		socketService.emit = function () {
			socket.emit.apply(socket, arguments)
		}

		////////////////////////////////////////////////////////////////////
		//    ROOM API
		////////////////////////////////////////////////////////////////////

		//handle joining a room, routing only events sent to this room to the eventHandler
		//returns a "room" object to be used to leave the room
		var roomListeners = {}
		socketService.joinRoom = function (room, eventHandler, noApply) {
			socket.emit('join-room', room)

			var roomId = new ObjectId().toString()

			roomListeners[roomId] = {}
			roomListeners[roomId].room = room

			roomListeners[roomId].eventHandler = function (message) {
				if (room != message.room) return
				eventHandler(message)
				if (!$rootScope.$$phase && !noApply) $rootScope.$apply()
			}

			//re-join the room if the socket disconnects
			roomListeners[roomId].removeReconnectListener = $rootScope.$on('user-socket-reconnected', function () {
				socket.emit('join-room', room)
			})

			socket.on('room-message-' + room, roomListeners[roomId].eventHandler)

			return {
				roomId: roomId,
				leaveRoom: function () {
					socket.off('room-message-' + room, roomListeners[roomId].eventHandler)
					roomListeners[roomId].removeReconnectListener()
					delete roomListeners[roomId]

					//if nothing else in the app is listening for this room, tell the server to stop sending messages
					var leaveRoom = true
					for (var r in roomListeners) {
						if (roomListeners[r].room == room) {
							leaveRoom = false
							break
						}
					}
					if (leaveRoom) {
						socket.emit('leave-room', room)
					}
				},
				sendMessage: function (message) {
					socketService.messageRoom(room, message)
				}
			}
		}

		socketService.messageRoom = function (room, message) {
			message.room = room
			socket.emit('message-room', message)
		}

	}

})();
// s3Service.js
// returns an instance of a service that can be used to upload or retrieve files
// from Amazon s3.
/* @ngInject */
angular.module('app').factory('s3Service', ["$http", "$q", "Upload", function ($http, $q, Upload) {
	var serviceInstance = {}
	// param 'files' = an array of standard DOM file objects
	// param 'makepublic' = whether or not this batch of files should be public
	serviceInstance.uploadSignedFiles = function (files, key, makePublic, item) {
		if (!files) return null

		return $q(function (resolve1, reject1) {
			var pArray = []
			for (var i = 0; i < files.length; i++) {
				var pThisFile = $q(function (resolve2, reject2) {
					var url = "/api/sign_s3?r=" + Date.now()
					//if the user specified a key they are upserting a file
					if (key && i == 0) {
						url += "&key=" + key
					}
					url += "&file_name=" + files[i].name
					url += "&file_type=" + files[i].type
					url += "&method=put"
					url += "&makePublic=" + (makePublic || false)

					if (item) {
						url += "&item_type=" + item.$key
						url += "&item_id=" + item._id
					}

					var currentFile = files[i]
					Upload.applyExifRotation(currentFile).then(function (file) {
						$http.get(url, {}).success(function (data) {
							sendPut(data, file).then(function (resp) {
								data.originalFileName = file.name
								resolve2(data)
							})
						}).error(function (error) {
							reject2(error)
						})
					})

				})
				pArray.push(pThisFile)
			}
			$q.all(pArray).then(function (resp) {
				//done
				resolve1(resp)
			}).catch(function (error) {
				reject1(error)
			})
		})

		function sendPut(putData, file) {
			var reqheaders = {
				'x-amz-acl': 'private',
				'Content-Type': file.type,
				'Cache-Control': "max-age=604800, private"
			}
			if (makePublic) reqheaders['x-amz-acl'] = "public-read"
			return $http.put(putData.signed_request, file, { headers: reqheaders })
				.success(function (data, status) {
					if (status === 200) {
						$http.get("/api/markFileAsUploaded/" + putData.key)
					}
				})
				.error(function (error) {
					console.log(error)
				})
		}
	}

	serviceInstance.getSignedFileUrl = function (key, method, item_type) {
		if (method == undefined) method = "get"
		var url = "/api/sign_s3?r=" + Date.now()
		url += "&method=" + method
		url += "&key=" + key
		if (item_type) url += "&item_type=" + item_type

		return $q(function (resolve, reject) {
			$http.get(url, {})
				.success(function (signedData) {
					resolve(signedData.publicURL || signedData.signed_request)
				}).error(function (error) {
					reject(error)
				})
		})
	}

	return serviceInstance
}]);
(function () {

	serviceFunction.$inject = ["$rootScope", "$http", "$filter", "$q", "Schema"];
	angular.module('app').service('oneSearch', serviceFunction);

	/* @ngInject */
	function serviceFunction($rootScope, $http, $filter, $q, Schema) {
		var This = this
		window.OneSearch = This

		// stack of hooks
		This.searchHooks = []
		This.searchMessages = []

		this.search = function (searchText, searchType, excludeDoc) {
			if (searchText == "") return $q.resolve([{isSection: true, sectionTitle: 'No results'}])
			 
			//create query
			var query = '/api/search?q=' + searchText 
			if (searchType) query += '&searchType=' + searchType		

			//send it to the server
			return $http.get(query).then(function(resp) {

				var recentItemMap = {}
				var topResults = []
				var recentItems = []
				var resultsWithSections = []
				var sectionMap = {}
				var topResultsMap = {}
				var sectionPriorities = ['User', 'Team', 'Department', 'Location', 'Document', 'Project', 'Meeting', 'Page', 'Question', 'Task', 'Post']

				//no results - get out
				if (resp.data.length == 0) {
					return [{isSection: true, sectionTitle: 'No results'}]
				}

				var serverResults = resp.data

				//remove any excluded document
				if (excludeDoc) {
					for (var y = 0; y < serverResults.length; y++){
							if (serverResults[y].ModelName == excludeDoc.ModelName && serverResults[y].DocId == excludeDoc.DocId) {
									serverResults.splice(y,1)
									break;
							}
					}
				}

				//if searching all items, add a top results section
				if (!searchType) {
					topResults = angular.copy(serverResults.slice(0,6))

					// add the "top results" section delimiter
					resultsWithSections.push({ isSection: true, sectionTitle: 'Top Results', icon: 'topresults.png' })         
				
					// combine the recent item results with five top-scoring server results
					resultsWithSections = resultsWithSections.concat(topResults)
				}

				// section all of the other results by type
				serverResults.forEach(function(serverResult) {
					if(!sectionMap[serverResult.ModelName]) {
						sectionMap[serverResult.ModelName] = [serverResult]
					} else {
						sectionMap[serverResult.ModelName].push(serverResult)
					}
				})

				//add sections in priority order
				sectionPriorities.forEach(function(modelName){
					if (sectionMap[modelName]) {
						addSection(modelName)
						delete sectionMap[modelName]
					}
				})

				//if additional sections are left (not given priority above), add them here
				Object.keys(sectionMap).forEach(function(modelName) {
					addSection(modelName)
				})
				function addSection(modelName, matches){
					resultsWithSections.push({ isSection: true, sectionTitle: modelName + 's', icon: modelName.toLowerCase() + '.png' })
					Array.prototype.push.apply(resultsWithSections, (searchType ? sectionMap[modelName] : sectionMap[modelName].slice(0, 6)))
				}

				//add sectionTitle to all item
				var lastSection
				resultsWithSections.forEach(function (item) {
					if (item.isSection) lastSection = item.sectionTitle
					else item.sectionTitle = lastSection
				})

				return resultsWithSections
			})
			
		}

		// push a hook onto OneSearch's internal stack of hooks
		// when there are hooks in the stack, oneSearch will call hook that's
		// on top of the stack rather than hitting the "search" api,
		// allowing other components to customize what happens when the user
		// types in the OneSearch input field
		this.hook = function(hookScope, searchFunction, message) {
			This.searchHooks.push(searchFunction)
			This.searchMessages.push(message)

			// when the scope which attached the hook is destroyed, remove the
			// last hook that was placed. this works, assuming that scopes are
			// destroyed in the same order that they were opened. otherwise,
			// a slightly more complicated solution, like a scope identifier:fn map, could
			// be used.
			hookScope.$on('$destroy', function() {
				This.searchHooks.splice(This.searchHooks.length - 1, 1)
				This.searchMessages.splice(This.searchMessages.length - 1, 1)
			})
		}
	} //end of service function
})(); //end of self-invoking function
(function () {

	myTaskTracker.$inject = ["socket", "$rootScope", "$q", "Task", "$timeout", "Schema"];
	angular.module('app').service('myTaskTracker', myTaskTracker);


	/* @ngInject */
	function myTaskTracker(socket, $rootScope, $q, Task, $timeout, Schema) {
		var myTaskTracker = this

		//get existing tasks from cache and set up event listeners
		updateMyTasks(null, {$key: 'Task'})
		$rootScope.$on('itemUpdated', updateMyTasks)
		$rootScope.$on('itemRemoved', updateMyTasks)
		$rootScope.$on('itemAdded', updateMyTasks)
		function updateMyTasks(event, item) {
			//during browser reload, the itemUpdated event may be fired so ignore that until the localCache is ready
			if (!window.localCacheReady) setTimeout(function(){updateMyTasks(event, item)}, 250)
			if (item.$key != 'Task') return

			//create two arrays so sortable can easily work with them
			myTaskTracker.myInProgressTasks = Task.getCache({ User: $rootScope.user._id, KanbanState: 'In Progress', ProjectIsActive: true }, 'UserPriority', false)
			myTaskTracker.myToDoneTasks = Task.getCache({ User: $rootScope.user._id, KanbanState: '!In Progress', ProjectIsActive: true }, 'UserPriority,-DateCreated', false)
		}

		return myTaskTracker
	}
})();
(function () {
		meetingReports.$inject = ["$http", "MeetingFeedbackReason", "Meeting", "auUtility"];
	angular
		.module('app')
		.service('meetingReports', meetingReports)

		/* @ngInject */
		function meetingReports($http, MeetingFeedbackReason, Meeting, auUtility) {
			var reportFetcher = {}
			var baseApiString = '/api/meetingstat?StartDate='

			// accepts an object that essentially contains parameters that'll be
			// used to query the DB of meeting statistics
			reportFetcher.getStatsFor = function (queryObject) {
				// build the query and hit the API
				return $http.get(buildQuery(queryObject))
					.then(function (response) {
						console.debug('response', response)
						var reports = response.data
						// if we didn't get any matching reports, just bail
						if (reports.length == 0) return reports	
						// if there's more than one report, we need to preprocess them
						if (response.data.length > 1) {
							reports = combineReportsToOne(reports)
						} else {
							// ultimately we just want to send back a single report,
							// so if we only got one back, there's no need for it to
							// be an array
							reports = reports[0]
							// purely for return value consistency
							reports.OriginalReports = [reports]
						}
						// populate the matched meetings in the report
						auUtility.populateArray(reports.MatchedMeetings, Meeting.getCache(), '_id')
						// hack: fiter out meetings we weren't allowed to download
						reports.MatchedMeetings = reports.MatchedMeetings.filter(function(meeting) {
							return (typeof meeting != 'string')
						})
						// populate all the matched meetings in all of the origial reports
						populateAllMeetings(reports.OriginalReports)
						// populate the reasons for each statistic
						auUtility.populateSubObjects(reports.Stats, MeetingFeedbackReason.getCache(), 'reason', '_id')
						// get the total cost of all meetings in the report
						reports.EstimatedTotalCost = calculateTotalCost(reports)
						return reports
					})
			}

			function populateAllMeetings(reports) {
				reports.forEach(function(report) {
					// populate the matched meetings in the report
					auUtility.populateArray(report.MatchedMeetings, Meeting.getCache(), '_id')

					// hack: fiter out meetings we weren't allowed to download
					report.MatchedMeetings = report.MatchedMeetings.filter(function(meeting) {
						return (typeof meeting != 'string')
					})
				})
			}

			// build the actual query URL from the restraints specified by the caller
			function buildQuery(queryObject) {
				// we need the dates as strings, of course
				var startDateString = queryObject.startDate.toString()
				var endDateString = queryObject.endDate.toString()
				// build the date part of the query
				var query = baseApiString + startDateString + '&EndDate=' + endDateString
				if (queryObject.item) {
					// if an item is part of the query, we need to set the query parameter
					// based on the type of item
					switch (queryObject.item.$key) {
						// for locations and departments, it's just...Location/Department
						case 'Location':
						case 'Department':
							query += '&' + queryObject.item.$key + '=' + queryObject.item._id
							break;
						case 'User':
							// for a user, 'Creator' is the proper field name
							query += '&Creator=' + queryObject.item._id
							break;
					}
				}
				return query
			}

			// combines multiple daily reports into a single report.
			// make no mistake: this blows. but since we allow the
			// user to query by any interval of time rather than a hard interval like
			// monthly/weekly that could be easily pre-aggregated and stored, we don't 
			// really have any other option but to do this either here or on the server side. 
			// i picked here.
			function combineReportsToOne(reports) {
				// these are presumably the same for every report, since
				// we queried using these as parameters
				var concatReports = {
					Creator: reports[0].Creator,
					Department: reports[0].Department,
					Location: reports[0].Location,
					Stats: [],
					OriginalReports: reports
				}
				// var blankStat = {
				// 	count: 0,
				// 	totalScore: 0,
				// 	sumNeg: 0,
				// 	sumPos: 0,
				// 	sumNeutral: 0
				// }
				// use key/value pairs for the combination operation to simplify
				// the act of checking if a stat has already been tracked.
				var associativeStats = {}
				var allMatchedMeetings = []
				// walk the array of reports
				reports.forEach(function(report) {
					report.Stats.forEach(function(stat) {
						// if we've already tracked stats for that reason,
						// we've got some adding to do.
						if(associativeStats[stat.reason]) {
							associativeStats[stat.reason].count += stat.count
							associativeStats[stat.reason].totalScore += stat.totalScore
							associativeStats[stat.reason].sumNeg += stat.sumNeg
							associativeStats[stat.reason].sumPos += stat.sumPos
							associativeStats[stat.reason].sumNeutral += stat.sumNeutral
						} else {
							// if we haven't tracked stats for that reason yet,
							// we can begin doing so by just taking this stat.
							associativeStats[stat.reason] = angular.copy(stat)
						}
					})
					report.MatchedMeetings.forEach(function(meeting) {
						// we don't want duplicate matched meetings; only push
						// unique matched meetings
						if(allMatchedMeetings.indexOf(meeting) < 0) {
							allMatchedMeetings.push(meeting)
						}
					})
				})
				// convert associative stats back to an array
				for(key in associativeStats) {
					concatReports.Stats.push(associativeStats[key])
				}
				// add all the matched meetings to our concatenated report
				concatReports.MatchedMeetings = allMatchedMeetings
				return concatReports
			}

			// calculate the estimated total cost of all meetings in the report
			function calculateTotalCost(report) {
				var totalCost = 0
				report.MatchedMeetings.forEach(function(meeting) {
					totalCost += meeting.EstimatedCost
				})
				return totalCost
			}

			return reportFetcher
		}
})();
(function () {
	manageUsersFn.$inject = ["$window"];
	angular
		.module('app')
		.service('manageUsers', manageUsersFn)

	/* @ngInject */
	function manageUsersFn($window) {
		var service = {}

		service.getSelectableUsers = function () {
			//get a string out of localStorage
			var selectableUsers = localStorage.getItem('selectableUsers')

			//if it's not there, return an empty array
			if (!selectableUsers) return []

			//try to parse the localStorage string into an array
			try {
				selectableUsers = JSON.parse(atob(selectableUsers))

				//if the parse worked but we didn't get an array, return an empty array
				if (!selectableUsers.length) selectableUsers = []
			} catch (error) {
				//if we couldn't parse, return an empty array
				console.error('manageUsersError selecting user', error)
				selectableUsers = []
			}

			//if we have users, return them, otherwise clean up localStorage
			if (selectableUsers.length) {
				return selectableUsers
			} else {
				localStorage.removeItem('selectableUsers')
				return []
			}
		}

		service.addSelectableUser = function (user) {
			var selectableUsers = service.getSelectableUsers()

			var localUser = angular.copy(user)
			var found = false

			// never store any of these fields
			delete localUser.MySettings
			delete localUser.Settings
			delete localUser.PasswordHash

			for (var i = 0; i < selectableUsers.length; i++) {
				if (selectableUsers[i]._id == localUser._id) {
					selectableUsers[i] = localUser
					found = true
					break
				}
			}

			if (!found) {
				selectableUsers.push(localUser)
			}

			try {
				localStorage.setItem('selectableUsers', btoa(JSON.stringify(selectableUsers)))
			} catch (error) {
				console.error('manageUsersError adding selectable user', error)
			}
		}

		service.removeSelectableUser = function (id) {
			var selectableUsers = service.getSelectableUsers()
			for (var i = 0; i < selectableUsers.length; i++) {
				if (selectableUsers[i]._id == id) {
					selectableUsers.splice(i, 1)
				}
			}

			localStorage.setItem('selectableUsers', btoa(JSON.stringify(selectableUsers)))
		}

		service.storeAuthToken = function () {
			if ($window.authToken) {
				sessionStorage.setItem('authToken', $window.authToken)
			}
		}

		return service
	}
})();
//intercept all http calls made with $http
// @ngInject
angular.module('app').factory('httpInterceptor',
    ["$q", "$location", "$window", "$rootScope", "$injector", "$templateCache", "$log", "socket", function ($q, $location, $window, $rootScope, $injector, $templateCache, $log, socket) {
        var authRequestCount = 0
        return {
            request: function (request) {
                //disable template caching on nocache.
                if (window.location.host.indexOf('nocache.localhost') > -1) {
                    if (request.method === 'GET' && $templateCache.get(request.url) != undefined && request.url.indexOf('/app') == 0) {
                        $templateCache.remove(request.url);
                    }
                }
                if (request.url.startsWith("/api/")
                    && request.url != '/api/login' && request.url != '/api/authenticate'
                    && request.url != '/api/signup' && request.url != '/api/schema'
                    && request.url != '/api/loginonce' && request.url != '/api/resetpasswordtrigger') {
                    //add headers from the client
                    request.headers['auth-token'] = $window.authToken //|| localStorage.getItem('authToken')
                    request.headers['sessionId'] = $window.session_id
                }
                return request
            },
            responseError: function (rejection) {
                //handle all http requests that result in a 401 unauthorized 
                if (rejection.status === 401 && socket.getSocket().connected) {
                    //if 10 authNeededs are received in 10 seconds, log out
                    authRequestCount++
                    if (authRequestCount > 20) {
                        $log.info('multiple authNeededs forced logout', authRequestCount)
                        debugger
                        window.location = '/login'
                    }
                    setInterval(function () { authRequestCount = 0 }, 1000 * 10)

                    var Authorization = $injector.get('Authorization');

                    //authorize and then retry the request
                    return Authorization.authorize().then(function (authorized) {
                        var $http = $injector.get('$http')
                        return $http(rejection.config)
                    })
                } else {
                    //pass on all other rejections to the request originator
                    return $q.reject(rejection);
                }
            },
            response: function (response) {
                //handle all http requests that are 200s but are authNeeded objects
                if (response && response.data && response.data.authNeeded) {
                    var Authorization = $injector.get('Authorization');

                    //forward the message to the Authorization service
                    return Authorization.authorize()
                } else {
                    //pass all other responses up the chain 
                    return response || $q.when(response);
                }
            }
        };
    }]);
(function() {
	
// @ngInject
/**
 * @ngdoc service
 * @name httpError
 * @module app
 * 
 * @description
 * 
 * Module to handle responses from both Mongoose and general API errors
 */
angular.module('app').service('httpError', httpErrorFunction);

/**
 * Hoping this works
 * @param {string|Object} err The error object. Expect a string or {err: {errors: string[], ...}, ...}
 * or {serverError: "..."}
 * @param {boolean} htmlEncode True to replace newlines with HTML linebreaks
 */
function httpErrorFunction() {
	this.parse = function(err, htmlEncode) {
		var linebreak = htmlEncode ? "<br />" : "\n";
		
		if (typeof err == "string") return err
		if (typeof err.data === "string") {
			return err.data;
		} else if (err == null || err.error == null){
			console.debug('No error object was provided to httpError.parse()');
			return "We can't seem to contact the server right now."
		} else if (typeof err.error === "string") {
			return err.error;
		} else if (err.error.errors && typeof err.error === "object") {
			var result = "";
			if (err.error.message)
				result += linebreak + err.error.message + ":";
			angular.forEach(Object.keys(err.error.errors), function(e) {
				result += linebreak + '- ' + err.error.errors[e].message;
			})
			return result;
		} else if (typeof err.serverError === "string") {
			return "Error: " + err.serverError.replace(/\n/g, linebreak);
		} else {
			return "An unknown error occurred." + linebreak + linebreak +
				"Debug data: " + linebreak +
				JSON.stringify(err.error, null, 2).replace(/\n/g, linebreak);
		}
	}
}
	
})();
(function () {
    emojiFullscreen.$inject = ["$rootScope", "$compile", "$state", "$timeout"];
    angular.module('app').service('emojiFullscreen', emojiFullscreen);


    function emojiFullscreen($rootScope, $compile, $state, $timeout) {
        var emojiFullscreen = this

        //show the emoji fullscreen with an animation
        emojiFullscreen.show = function (type, animation, message) {
            angular.element('.emojiFullscreen').show()

            //use the type to set the image
            angular.element('.emojiFullscreen.content').prepend('<img src="/assets/images/gifs/no-loop/' + type + '.gif" />')
            

            //set the animation
            //if (!animation) { 
            //hardcoded until we allow users to choose
            //update config.routes line 161 when we do
            animation = "zoomInDown"
            //}

            angular.element('.emojiFullscreen.content img, .emojiFullscreen.content .message').addClass(animation)

            //set the message
            angular.element('.emojiFullscreen.content .message').html(message)
            
            setTimeout(function () {
                angular.element('.emojiFullscreen').hide()
                angular.element('.emojiFullscreen.content img').remove()
                angular.element('.emojiFullscreen.content img, .emojiFullscreen.content .message').removeClass(animation)
            }, 2500)
        }
    }
})();
(function () {
    'use strict';
    chatsRecipe.$inject = ["Page", "Post", "$rootScope", "socket", "$filter", "$mdUtil", "$injector", "$timeout", "videoCall", "Schema", "Conversation"];
    angular
        .module('app')
        .service('chats', chatsRecipe)

    /* @ngInject */
    function chatsRecipe(Page, Post, $rootScope, socket, $filter, $mdUtil, $injector, $timeout, videoCall, Schema, Conversation) {
        var chatService = {}
        var chats = []

        var ItemViewer, auUtility

        //cheat the circular reference problem
        $timeout(function(){
                 ItemViewer = $injector.get('ItemViewer')
                 auUtility = $injector.get('auUtility')
        }, 10, false)
        

        chatService.chats = chats

        if (!$rootScope.singleItemViewer) $rootScope.$on('itemAdded', function (event, item) {
            
            //when a new message comes in that I didn't create, pop open the chat window and start flashing the tab/window title
            if (item.$key == 'Post' && (item.ReadBy.indexOf($rootScope.user._id) == -1 && item.Type == 'Message') || Object.byString(item, "Data.PopOpenChat")) {
                // don't pop open unless this item is actually in our list of conversations
                var block = !Conversation.conversations.some(function (conversation) {
                    return conversation.$key == 'Page' && conversation._id == item.Page
                })

                // however, if we're actually supposed to be popping these open as chats, always let them through
                if (item.$Page.Members.indexOf($rootScope.user._id) > -1) block = false
                if (item.$Page.Editors.indexOf($rootScope.user._id) > -1) block = false

                // block if the big discussion is open
                var ItemViewer = $injector.get('ItemViewer')
                if (ItemViewer.openItems['Page' + item.Page]) block = true

                if (Object.byString(item, "Data.PopOpenChat")) block = false

                if (block) return;

                var conversation = Page.getCache({ _id: item.Page })[0]
                chatService.openChat(conversation, true)

                if (!$rootScope.browserTabIsActive && item.Creator != $rootScope.user._id) {
                    auUtility.flashTitle(conversation.toString(true))

                    if (!window.NotificationApi) return

                    if (window.NotificationApi.permission == "granted") {
                        var notification = new window.NotificationApi(item.$Creator.toString() + ' says:', {
                            icon: (item.$Creator.Photo ? auUtility.s3UrlFromId(item.$Creator.Photo) : "/assets/images/walkthrough/al.png"),
                            body: angular.element('<div>' + item.Data.Update + '</div>')[0].innerText,
                        });

                        notification.onclick = function () {
                            window.focus()
                        };

                        setTimeout(function () {
                            notification.close()
                        }, 3000)
                    }
                }
            }
        })

        // constructor for chat object
        // contains data and basic UI properties related to this chat
        function chat(conversation) {
            var This = this
            this.poppedOpen = true
            this.maximized = false
            this.conversationPage = Page.getCache({ _id: conversation._id })[0]
            this.newMessage = ''

            chats.forEach(function (chat) { chat.$isActive = false })
            this.$isActive = true

            this.sendMessage = function (event) {
                if (this.newMessage.trim() != "") {
                    socket.messageRoom('page' + conversation._id, { stopTyping: true })
                    this.conversationPage.SendMessage(String(this.newMessage))
                        .then(function () {
                            //unconditionally scroll to the bottom
                            //otherwise, by design, post-feed will scroll to the bottom only when the user is already at the bottom
                            angular.element('#ChatContent' + indexOfChat(conversation._id)).scrollTop(999999)
                        })
                    this.newMessage = ''
                    event.cancel()
                }
            }.bind(this)

            this.openAsRecentItem = function () {
                if (conversation.IsEmbedded) {
                    this.embeddedDiscussionParentItem = Schema.resource(conversation.Type).getCache({ _id: conversation._id })[0]
                    this.embeddedDiscussionParentItem.open()
                } else {
                    this.conversationPage.open()
                }
                chatService.closeChat(conversation._id)
            }.bind(this)


            this.openManagePageDialog = function ($event) {
                $mdDialog.show({
                    controller: 'PageWizardDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                    targetEvent: $event,
                    locals: { options: { page: this.conversationPage } }
                }).then(function () {
                    //
                })
            }

            this.createVideoCall = function (options) {
                $rootScope.$broadcast('accept-video-chat', options)
                // alert google analytics
                window.ga('send', {
                    hitType: 'event',
                    eventCategory: 'VideoCalling',
                    eventAction: 'VideoInviteSent',
                    eventLabel: 'FromUiElementBottomChat'
                })
            }

            this.room = socket.joinRoom('page' + conversation._id, this.conversationPage.handleTypingIndicators.bind(this.conversationPage))

            this.sendTyping = this.conversationPage.SendWhosTyping.bind(this.conversationPage)
        }

        // retrieves the index of the chat matching conversationId
        // returns -1 if no such chat is open
        function indexOfChat(conversationId) {
            var index = -1
            for (var i = 0; i < chats.length; i++) {
                if (chats[i].conversationPage._id == conversationId) {
                    return i
                }
            }
            return index
        }

        chatService.openChat = function (conversation, forcePopOpen) {
            auUtility.endFlashTitle()

            if (!$rootScope.userIsTypingInChat) chats.forEach(function (chat) { chat.$isActive = false })

            var chatIndex = indexOfChat(conversation._id)
            var itemIsOpen = ItemViewer.openItems[conversation.Type + conversation._id]

            if (itemIsOpen && !forcePopOpen) return
            
            if (chatIndex > -1) {
                if (forcePopOpen) chats[chatIndex].poppedOpen = true
                if (!$rootScope.userIsTypingInChat) chats[chatIndex].$isActive = true
            } else {
                chats.push(new chat(conversation))
            }
            
        }

        chatService.closeChat = function (conversationId) {
            var chatIndex = indexOfChat(conversationId)
            if (chatIndex > -1) {
                chats[chatIndex].conversationPage.MarkPostsRead()
                chats[chatIndex].room.leaveRoom()
                chats.splice(chatIndex, 1)
            }
            auUtility.endFlashTitle()
        }

        chatService.maximizeChat = function (conversationId) {
            var chatIndex = indexOfChat(conversationId)
            if (chatIndex > -1) {
                angular.element('#ChatContent' + chatIndex)
            }
        }

        chatService.setChatTabActive = function (conversationId) {
            chats.forEach(function (chat) {
                chat.$isActive = false

                if (chat.conversationPage._id == conversationId) {
                    chat.$isActive = true

                    //stop flashing the title
                    auUtility.endFlashTitle()
                }
            })
        }

        return chatService
    }
})();
(function () {

    factoryFunction.$inject = ["$rootScope", "$mdToast", "$cookies", "$http", "$state", "$mdDialog", "$window", "$timeout", "$q", "$injector", "$log", "socket", "LogglyLogger", "manageUsers", "$location"];
    angular.module('app').factory('Authorization', factoryFunction);



    // @ngInject
    function factoryFunction($rootScope, $mdToast, $cookies, $http, $state, $mdDialog, $window, $timeout, $q, $injector, $log, socket, LogglyLogger, manageUsers, $location) {
        var returnInstance = {firstHit: true}

        var authRequestCount = 0
        var resetRequestCount
        returnInstance.authorize = function (options) {
            //if 3 authNeededs are received in 10 seconds, log out
            authRequestCount++
            if (authRequestCount > 20) {
                $log.info('multiple authorize requests forced logout', authRequestCount)
                debugger
                window.location = '/login'
            }
            clearTimeout(resetRequestCount)
            resetRequestCount = setInterval(function () { authRequestCount = 0 }, 1000 * 10)

            var authToken = $window.authToken || $location.search().icu || localStorage.getItem("authToken" + window.location.pathname) || localStorage.getItem("authToken" + $location.search().org) || sessionStorage.getItem("authToken")

            //save the originalUrl
            if (returnInstance.firstHit) {
                returnInstance.originalUrl = angular.copy($location)
                returnInstance.firstHit = false
            }

            //pass the user context back to the server
            if (!options) options = {}
            options.ctx = $location.search().ctx
            if (options.ctx == "undefined") delete options.ctx

            options.url = returnInstance.originalUrl.path()

            //otherwise, the user is re-access the application so...
            //send the authToken to the api for authentication
            if (returnInstance.currentAuthRequest) return $q.when(returnInstance.currentAuthRequest)
            returnInstance.currentAuthRequest = $http.post("/api/authenticate", { authToken: authToken, options: options })
                .then(function (res) {
                    setTimeout(function () {
                        delete returnInstance.currentAuthRequest
                    })

                    //if the user was authenticated successfully, set the authToken
                    if (res.data.success) {

                        if (options.preloadForShell) {
                            //before we updateLocalUser, empty all caches as they could all be out of date such as when a computer comes out of suspended/sleeping state - forces all calls to getCache to requery the server
                            var Schema = $injector.get('Schema')
                            Schema.getCache(false).forEach(function (schema) {
                                if (schema.schema == "Schema" || schema.schema == "Organization" || schema.schema == "User") return //don't clear these; this user likely can't edit them, anyway!
                                Schema.resource(schema.schema).init()
                            })
                        }

                        returnInstance.updateLocalUser(res.data)
                    } else {
                        //these didn't work so don't try them again
                        localStorage.removeItem("authToken" + window.location.pathname)
                        localStorage.removeItem("authToken")
                        localStorage.removeItem("authToken" + returnInstance.originalUrl.search().org)
                        sessionStorage.removeItem("authToken")

                        if (options.url.startsWith('/fundraiser/')) {
                           //don't bounce to login
                           return true
                        }

                        //otherwise, send the user to the login screen so they can type their id/password
                        $mdToast.showSimple("Authentication required")
                        
                        //during log out/in scenarios, a pending http action is inevitably waiting for the logged out user
                        //-if we are on the login screen, ignore this request to authorize
                        if ($state.$current.url.source != "/login") {
                            $state.go('authentication.login')
                        }

                        return false
                    }

                    
                    return 'authorized'
                }).catch(function () {
                    delete returnInstance.currentAuthRequest
                })

            return returnInstance.currentAuthRequest
        }

        var permBuilder = null
        returnInstance.updateLocalUser = function (data) {
            //set localStorage - if this user is anonymous, save the authToken for the specific item
            if (data.user.$AnonymousUser)
                localStorage.setItem("authToken" + window.location.pathname, data.authToken)
            else localStorage.setItem("authToken" + data.user.Organization._id, data.authToken)

            $window.authToken = data.authToken
            manageUsers.storeAuthToken(user)

            // since we are authing as this user, make them a selectable user
            if (!data.user.$AnonymousUser && !$location.search().icu) {
                var user = angular.copy(data.user)
                user.lastToken = data.authToken
                manageUsers.addSelectableUser(user)
                delete user.lastToken

                //set a profile image for the public site
                if (user.Photo) {
                    //get the top level domain - align.us, localhost, ifund4.us, etc.
                    var domain = window.location.host.split(':')[0].split('.').reverse().splice(0, 2).reverse().join('.')

                    //set a cookie so we can show the user's profile image on the public website
                    $cookies.put('au-profile-img', user.Organization._id + '/' + user.Photo, { domain: domain, expires: new moment().add(3, 'months').toDate() })
                }
            }

            //assign $rootScope.Organization and then revert user.Organization to an id
            var Organization = $injector.get('Organization')
            var organization = new Organization(data.user.Organization)
            Organization.addToCache(organization)
            $rootScope.Organization = organization

            //revert user Org back to string
            data.user.Organization = $rootScope.Organization._id

            //assign $rootScope.user to the user data received
            var User = $injector.get('User')
            var user = new User(data.user)
            User.addToCache(user) //add the returned user to the cache
            $rootScope.user = user
            $rootScope.user.IsOnline = true

            //load recentItems
            if (data.recentItems) {
                $rootScope.user.loadCacheWithItems(data.recentItems)
                $rootScope.$broadcast('updateConversations')
            }

            //generate a window-wide session_id
            $window.session_id = new ObjectId().toString()

            //reconnect the socket using the new authToken
            if (!socket.getSocket().connected) {
                socket.getSocket().io.opts.query = 'auth-token=' + data.authToken
                socket.getSocket().open()
            }

            //let the server know who this socket is for
            socket.emit('connect-user', $rootScope.user._id, $rootScope.Organization._id, window.session_id);

            //make log analysis much easier
            LogglyLogger.fields({ UserName: $rootScope.user.toString(), UserId: $rootScope.user._id });
        }

        returnInstance.showUI = function () {
                if (returnInstance.originalUrl && returnInstance.originalUrl.path() != '/select') {
                     $location.path(returnInstance.originalUrl.path())       
                } else {
                    $state.go('shell.home') 
                }
                
                $location.$$search = {}
        }

        return returnInstance
    }

})();
(function () {

    serviceFunction.$inject = ["$state", "$filter", "$timeout", "User", "Team", "Page", "s3Url", "s3UserFilesUrl", "$rootScope", "Initiative", "QuestionTag", "Document", "Project", "Meeting", "Task", "Location", "Schema", "$mdUtil", "$mdSidenav", "$q", "$mdDialog", "$injector", "$http", "Department", "s3Service"];
    angular.module('app').service('auUtility', serviceFunction);

    /* @ngInject */
    function serviceFunction($state, $filter, $timeout, User, Team, Page, s3Url, s3UserFilesUrl, $rootScope, Initiative, QuestionTag, Document, Project, Meeting, Task, Location, Schema, $mdUtil, $mdSidenav, $q, $mdDialog, $injector, $http, Department, s3Service) {
        var auUtility = this

        //Global Values
        this.freshdeskArticleRoot = 'https://alignus.freshdesk.com/support/solutions/articles/'

        this.mergeStringArrays = function (a, b) {
            var hash = {};
            var ret = [];

            for (var i = 0; i < a.length; i++) {
                var e = a[i];
                hash[e] = true;
                ret.push(e);
            }

            for (var i = 0; i < b.length; i++) {
                var e2 = b[i];
                if (!hash[e2]) {
                    hash[e2] = true;
                    ret.push(e2);
                }
            }

            return ret;
        }

        // Compare using only the "useful" keys because of cachedResource
        this.cachedResourceChanged = function (a, b, ignoreFields) {
            //concatenate ignored fields onto hardcoded blacklisted keys
            var blacklistKeys = ['LastModified', 'AuditTrail', 'AlreadyNotified', 'MemberCount'].concat(ignoreFields)

            // iterate over the keys of the objects and if a key is different, return true
            var keys = this.mergeStringArrays(Object.keys(a), Object.keys(b))
            for (var k = 0; k < keys.length; k++) {
                var key = keys[k]

                //skip blacklisted fields
                if (blacklistKeys.indexOf(key) > -1) continue

                //skip the field if it starts with $, _ or if the field changed from null <-> undefined
                if (key.indexOf('$') == 0) continue
                if (key.indexOf('_') == 0) continue
                if (a[key] == null && b[key] == undefined) continue
                if (a[key] == undefined && b[key] == null) continue

                if (!angular.equals(a[key], b[key])) {
                    return true
                }
            }

            // all useful keys are same, return false
            return false;
        }

        this.handleItemResolve = function ($stateParams, $filter, listItems, listState) {
            //if the user clicked an item, it's passed in as an object
            if ($stateParams.item) {
                return { item: $stateParams.item }
            } else {
                //else, the view was transitioned to via browser reload
                if ($stateParams.itemID == "") {
                    $state.go(listState)
                    return { item: null }
                } else {
                    //find the item by id (in the url)
                    return { item: $filter('filter')(listItems, { _id: $stateParams.itemID })[0] }
                }
            }
        }

        function sortResults($query) {
            return function (res) {
                var returnVal
                var words = $query.split(' ')
                var len = res.length
                res.forEach(function (item, idx) {
                    item.$score = (len - idx) * 3
                    words.forEach(function (word) {
                        if (item.toString().contains(word)) {
                            item.$score += 250
                        }
                    })
                })

                res = $filter('orderBy')(res, '$score', true)

                return res
            }
        }

        this.searchItems = function (query, resourceType, resourcePool) {
            if (!query) return []
            if (!resourcePool) throw new Error('resourcePool must be supplied')

            if (resourcePool instanceof Array) {
                return resourcePool.filter(function (resource) {
                    return resource.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
                })
            } else {
                return resourcePool.then(function (resources) {
                    return resources.filter(function (resource) {
                        return resource.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
                    })
                })
            }
        }

        this.searchUsers = function (options) {
            var $query = options.query,
                resourcePool = options.resourcePool,
                excludeContacts = options.excludeContacts || false,
                showAdd = options.showAdd || false,
                showInactive = options.showInactive || false

            if (!$query) return $q.resolve([]);

            //if we should exclude contacts

            if (resourcePool) {
                if (resourcePool instanceof Array) {
                    resourcePool = $q.resolve(resourcePool)
                }
                return resourcePool.then(function (resources) {
                    return resources.filter(function (resource) {
                        if (excludeContacts && resource.IsContact) return false
                        return resource.toString().toLowerCase().indexOf($query.toLowerCase()) > -1
                    })
                })

            } else {
                var query = User.query({
                    limit: 50,
                    sort: { 'FirstName': 1, 'LastName': 1 },
                    $or: [
                        { FirstName: "/^" + $query + "/i" },
                        { LastName: "/^" + $query + "/i" }
                    ],
                    IsContact: excludeContacts ? false : undefined,
                    IsActive: showInactive ? undefined : true
                })

                var queryProm = query.$httpPromise

                //add + Add New User/Contact
                if (showAdd) queryProm.then(function (res) {
                    if ($rootScope.user.IsUserAdmin) addNewEntry(res, 'User')
                    if (!excludeContacts && Object.byString(rootScope.user, 'EffPerms.Contacts.CanCreate')) addNewEntry(res, 'User', 'Contact')
                    return res
                })

                return queryProm
            }
        }

        this.searchUsersAndTeams = function ($query, excludeContacts, includeOrganization, includeLocations, includeDepartments) {
            if (!$query) return $q.resolve([]);

            var pArray = []
            pArray.push(User.query({
                limit: 50,
                sort: { 'FirstName': 1, 'LastName': 1 },
                $or: [
                    { FirstName: "/^" + $query + "/i" },
                    { LastName: "/^" + $query + "/i" }
                ],
                IsContact: excludeContacts ? false : undefined
            }).$httpPromise)

            pArray.push(Team.query({
                limit: 50,
                sort: { 'Name': 1 },
                Name__regex: "/" + $query + "/i"
            }).$httpPromise)

            if (includeLocations) {
                pArray.push(Location.query({
                    limit: 50,
                    sort: { 'Name': 1 },
                    Name__regex: "/" + $query + "/i"
                }).$httpPromise)
            }

            if (includeDepartments) {
                pArray.push(Department.query({
                    limit: 50,
                    sort: { 'Name': 1 },
                    Name__regex: "/" + $query + "/i"
                }).$httpPromise)
            }

            return $q.all(pArray).then(function (res) {
                var ret = []
                res.forEach(function(arr){
                    ret = ret.concat(arr)
                })
                
                ret = ret.map(function (item) {
                    return { Type: item.$key, Id: item._id, $Display: item.toString(), item: item }
                })
                if (includeOrganization && (new String('everyone')).indexOf($query.toLowerCase()) > -1) {
                    ret.push({ Type: 'Organization', Id: $rootScope.Organization._id, $Display: 'Everyone In ' + $rootScope.Organization.Name, item: $rootScope.Organization })
                }
                return ret
            })
        }

        this.searchTeams = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Team.query({
                limit: 50,
                sort: { 'Name': 1 },
                Name__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query)) //.then(addNew)
        }

        function addNewEntry(arr, itemType, label) {
            if (!label) label = itemType
            var newItem = new ($injector.get(itemType))
            newItem.toString = function () {
                return '+ Add New ' + label
            }
            newItem.$addNew = label
            arr.push(newItem)
        }

        this.addNewItem = function (itemType) {
            var showDialog
            if (itemType == 'Contact') {
                showDialog = $mdDialog.show({
                    controller: 'AddContactDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/structure/users-and-teams/dialogs/add-contact.tmpl.html',
                    targetEvent: null
                })
            } else {
                showDialog = Schema.resource(itemType).getType().addItem()
            }

            return showDialog
        }

        this.checkForNewItem = function (options) {
            if (!Object.byString(options, 'item.$addNew')) return options.item

            var pThen = function (res) { return res }
            if (options.thenAddToArray) {
                pThen = function (newItem) {
                    if (!newItem) return
                    options.thenAddToArray.push(newItem._id)
                }
            }

            this.addNewItem(options.item.$addNew).then(pThen)

            return null //cancel chip add
        }

        this.searchDepartments = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Department.query({
                limit: 50,
                sort: { 'Name': 1 },
                Name__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchTags = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = QuestionTag.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'TagText': 1 },
                TagText__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchPages = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Page.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
                IsEmbedded: false,
                Type__ne: 'Conversation'
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchDocuments = function ($query, acl) {
            if (!$query) return $q.resolve([]);

            var query = Document.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
                acl: acl //{Type: ['U']}
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchProjects = function ($query, acl) {
            if (!$query) return $q.resolve([]);

            var query = Project.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
                acl: acl //{Type: ['U']}
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchMeetings = function ($query, acl) {
            if (!$query) return $q.resolve([]);

            var query = Meeting.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
                acl: acl //{Type: ['U']}
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchTasks = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Task.query({
                limit: 100,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchLocations = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Location.query({
                limit: 50,
                sort: { 'Name': 1 },
                Name__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query))
        }

        this.searchInitiatives = function ($query) {
            if (!$query) return $q.resolve([]);

            var query = Initiative.query({
                limit: 50,
                sort: { 'LastModified.Date': -1, 'Title': 1 },
                Title__regex: "/(" + $query.replaceAll(' ', '|') + ")+/gi",
            })

            return query.$httpPromise.then(sortResults($query)) //.then(addNew)
        }

        this.getPageFor = function (id) {
            return Page.getCache({ _id: id })[0]
        }

        // emulates the MongoDB concept of "population"
        // populateTo = array of objects
        // leftPath = name of the field that will be populated in each element of populateTo
        // populateFrom = array of objects which will be used to populate populateTo
        // rightPath = name of the field in populateFrom to compare to the key in populateTo
        // example usage, populate Location field of an array of Users:
        // auUtility.populateSubObjects(User.getCache(), Location.getCache(), "Location", "_id")
        this.populateSubObjects = function (populateTo, populateFrom, leftPath, rightPath) {
            var populateFromLookup = {}
            // make a lookup table so that we don't have to loop over populateFrom so many times
            for (var i = 0; i < populateFrom.length; i++) {
                populateFromLookup[populateFrom[i][rightPath]] = populateFrom[i]
            }
            // walk populateTo and populate each element's $leftPath field using the lookup table
            for (var populateToIndex = 0; populateToIndex < populateTo.length; populateToIndex++) {
                var item = angular.copy(populateFromLookup[populateTo[populateToIndex][leftPath]])
                if (item) {
                    populateTo[populateToIndex]['$' + leftPath] = item
                }
            }
        }

        // populates an array of values
        this.populateArray = function (populateTo, populateFrom, rightPath) {
            var populateFromLookup = {}
            // make a lookup table so that we don't have to loop over populateFrom so many times
            for (var i = 0; i < populateFrom.length; i++) {
                populateFromLookup[populateFrom[i][rightPath]] = populateFrom[i]
            }
            // walk populateTo and populate each element using the lookup table
            for (var populateToIndex = 0; populateToIndex < populateTo.length; populateToIndex++) {
                var item = angular.copy(populateFromLookup[populateTo[populateToIndex]])
                if (item) {
                    populateTo[populateToIndex] = item
                }
            }
        }


        this.cleanUpOldMdBackdrops = function () {
            //convert the node-list to a real array and then go remove each
            [].slice.call(document.querySelectorAll('md-backdrop')).forEach(function (node) { node.parentNode.removeChild(node) });
            //md-scroll-mask
            [].slice.call(document.querySelectorAll('.md-scroll-mask')).forEach(function (node) { node.parentNode.removeChild(node) });

        }

        window.cleanUpOldMdBackdrops = this.cleanUpOldMdBackdrops

        //scroll landing pages
        var stateScrollTops = {}
        this.initPageScrolledDown = function (el, noFade) {
            if (!noFade) el.hide()

            //if we get back to a root, init all scrolltops
            if ($state.current.name.split('.').length == 2 && $rootScope.$previousState.name.indexOf($state.current.name) == -1)
                stateScrollTops = {}

            $timeout(function () {
                if (!noFade) el.fadeIn(250)

                //set the scroll top
                var st = stateScrollTops[$state.current.name] || 150
                el.scrollTop(st)
            }, 1, false)

            //save the scroll position
            el.on('scroll', debounce(function () {
                stateScrollTops[$state.current.name] = el.scrollTop()
            }, 100))
        }

        //inject a "loading more" message and show it for 1 second
        this.showLoadingMore = function (el) {
            var loadingMsg = el.querySelector('.infinity-scroll-loading')
            if (!loadingMsg) {
                loadingMsg = document.createElement('div')
                loadingMsg.innerHTML = "Loading More..."
                loadingMsg.className = "infinity-scroll-loading"
                loadingMsg.style.position = "fixed"
                loadingMsg.style.bottom = "0px"
                loadingMsg.style.left = el.offsetLeft + "px"
                loadingMsg.style.width = el.offsetWidth + "px"
                loadingMsg.style.height = "40px"
                loadingMsg.style.backgroundColor = "#666"
                loadingMsg.style.color = "white"
                loadingMsg.style.textAlign = "center"
                loadingMsg.style.border = "1px solid rgb(195, 195, 195)"
                loadingMsg.style.paddingTop = "15px"
                loadingMsg.style.opacity = ".5"
                loadingMsg.style.transition = "all 1s"

                el.appendChild(loadingMsg)
            } else {
                //show the loading message
                loadingMsg.style.opacity = ".5"
                loadingMsg.style.bottom = "0px"
            }
            //hide the loading message
            setTimeout(function () {
                loadingMsg.style.opacity = "0"
                loadingMsg.style.bottom = "-40px"
            }, 1000)
        }

        this.s3UrlFromId = function (id) {
            return (s3UserFilesUrl + $rootScope.Organization._id + '/' + id)
        }

        this._signedUrls = {}
        this.getSignedS3ImgUrl = function (userfile_id) {
            var This = this
            if (!this._signedUrls[userfile_id]) {
                this._signedUrls[userfile_id] = s3Url + "empty-states/stars.png"

                s3Service.getSignedFileUrl(userfile_id).then(function (signed_request) {
                    //reassign the actual URL
                    This._signedUrls[userfile_id] = signed_request
                })
            }

            return this._signedUrls[userfile_id]
        }

        this.toggleSideNav = function (navID) {
            $mdUtil.debounce(function () {
                $mdSidenav(navID).toggle();
            }, 300)();
        }

        this.openSideNav = function (navID) {
            $mdUtil.debounce(function () {
                $mdSidenav(navID).open()
            }, 100)()
        }

        this.toggleNotificationsTab = function (tab) {
            this.toggleSideNav('notifications');
            if ($rootScope.recentItemOpen) $rootScope.notificationsPanelPinned = true

            $mdUtil.debounce(function () {
                $rootScope.$broadcast('toolbarSwitchNotificationTab', tab);
            }, 300)();
        }

        function reflectPromise(promise, data) {
            return promise.then(function (success) {
                return { success: success, data: data }
            }, function (error) {
                return { error: error, data: data }
            })
        }

        function getReflectedErrors(promiseResults) {
            return promiseResults.filter(function (result) {
                return result.hasOwnProperty('error')
            })
        }

        function getReflectedSuccesses(promiseResults) {
            return promiseResults.filter(function (result) {
                return result.hasOwnProperty('success')
            })
        }

        this.allWithErrors = function (promises, data) {
            return $q.all(promises.map(function (promise, index) {
                return reflectPromise(promise, data[index])
            })).then(function (responses) {
                return {
                    'successes': getReflectedSuccesses(responses),
                    'errors': getReflectedErrors(responses),
                    'getSuccessfulData': function () {
                        return this.successes.map(function (success) {
                            return success.data
                        })
                    },
                    'getErrorData': function () {
                        return this.errors.map(function (error) {
                            return error.data
                        })
                    }
                }
            })
        }

        this.selectUsers = function (title, disallowIds, excludeContacts) {
            return $mdDialog.show({
                controller: 'SelectUserController',
                controllerAs: 'vm',
                templateUrl: '/app/social/dialogs/select-user.tmpl.html',
                locals: {
                    options: {
                        title: title,
                        disallowIds: disallowIds,
                        excludeContacts: excludeContacts
                    }
                }
            })
        }

        this.hasImgExtension = function (title) {
            if (!title) return false
            title = title.toLowerCase()
            if ((title.endsWith('.png') || title.endsWith('.jpg') || title.endsWith('.jpeg') || title.endsWith('.gif') || title.endsWith('.bmp') || title.endsWith('.svg'))) {
                return true
            }
            return false
        }

        this.peekDocument = function (document) {
            // document.Type is either UserFile or Document
            switch (document.Type) {
                case 'UserFile':
                    //get the signed url and then open an iframe to it
                    s3Service.getSignedFileUrl(document.Id).then(function (data) {
                        $rootScope.openPeek(data, document.Title)
                    })
                    break;
                case 'Document':
                    $rootScope.openPeek(Document.getCache({ _id: document.Id })[0])
                    break;
                default:
                    toast.toast('Document not found!')
            }
        }

        this.emojisLib = "💑😃😊😉😁😅😈😓😚😒😐😏😍😎😆😚😜😡😤😣😢🍥🍟🍔🍨🌟🌊⛅✨⛄❄✴✳🌠🌏🗻🗿➿"
        this.randomEmoji = function () {
            //emojis are unicode double-byte so always get by even bytes
            var l = parseInt(this.emojisLib.length / 2)
            var r = parseInt(Math.random() * l)
            r = parseInt(r / 2) * 2 //make even
            var returnVal = this.emojisLib.substr(r, 2)
            return returnVal
        }

        //nothing even close to dirty like nuts...
        this.ambiguousTerms = "nibble, bit, soupçon, spoonful, forkful, sliver, drop, dollop, spot, gobbet, tidbit," +
            "droplet, blob, globule, bead, bubble, tear, dot, etche, imprint, thought, carving, stamp," +
            "note, memorandum, memo, email, letter, missive, report, bulletin, communiqué, dispatche," +
            "plan, scheme, design, proposal, suggestion, action point, brainchild, vision," +
            "bit, slice, chunk, segment, section, lump, wedge, block, cake, cube, stick," +
            "fragment, sliver, splinter, wafer, chip, crumb, scrap, remnant, shred, shard, snippet, morsel"

        this.ambiguousTerms = this.ambiguousTerms.split(",")

        this.randomAmbiguousTerm = function () {
            var l = this.ambiguousTerms.length
            var r = parseInt(Math.random() * l)
            var returnVal = this.ambiguousTerms[r].trim()
            return returnVal
        }

        this.flashTitle = function (title) {
            var chatService = $injector.get('chats')
            //this and the endFlashTitle would need to be updated if we start to show more useful titles than always "Align Us"
            clearInterval(chatService.flashTitleId)
            chatService.flashCount = 0
            chatService.flashTitleId = setInterval(function () {
                if (chatService.flashCount % 2 == 0) {
                    document.title = title
                } else {
                    document.title = window.document.originalTitle //'Align Us'
                }
                chatService.flashCount++
            }, 1500)

            if (!chatService.silence) {
                var audio = new Audio('/assets/sounds/new-chat-message.mp3');
                audio.play()

                //don't play for another 3 minutes
                chatService.silence = setTimeout(function () {
                    delete chatService.silence
                }, 3 * 60 * 1000)
            }
        }

        this.endFlashTitle = function () {
            clearInterval($injector.get('chats').flashTitleId)
            document.title = window.document.originalTitle //'Align Us'
        }

        this.timeLimitPromise = function (promise, timeout, opts) {
            var rejectWith = opts && opts.rejectWith;
            var resolveWith = opts && opts.resolveWith;

            var timeoutPromise = new $q(function (resolve, reject) {
                var timer = setTimeout(function () {
                    if (rejectWith !== undefined)
                        reject(rejectWith);
                    else
                        resolve(resolveWith);
                }, timeout);
            });

            return $q.race([timeoutPromise, promise]);
        };

        this.processItemUpdate = function (newItem, existingItem, keyName) {
            var This = this
            var keys = Object.keys(newItem)
            var returnVal = []

            for (var k = 0; k < keys.length; k++) {
                var key = keys[k]

                //skip functions
                if (typeof existingItem[key] == "function") continue

                //convert string dates to object dates
                if (isDate(newItem[key])) {
                    if (new Date(newItem[key]).getTime() != new Date(existingItem[key]).getTime()) {
                        existingItem[key] = newItem[key] = new Date(newItem[key])
                        registerUpdate()
                    }
                    continue
                }

                //skip the field if it starts with $
                if (key.indexOf('$') == 0) continue
                if (key.indexOf('_') == 0) continue

                //handle null
                if (newItem[key] === null && existingItem[key] === null) continue
                if (!newItem[key] && existingItem[key] && key != 'Settings') {
                    existingItem[key] = newItem[key]
                    registerUpdate()
                    continue
                }

                //if this is an array field with _ids, update each element individually to not break references or clobber the whole array
                if (newItem[key] instanceof Array && existingItem[key] instanceof Array && newItem[key].every(function (e) { return !!e._id })) {
                    var nArr = newItem[key], eArr = existingItem[key]

                    //for each element in the new array, find the matching element in the existing array
                    for (var i = 0; i < nArr.length; i++) {
                        var newEl = nArr[i]
                        var existingEl = eArr.find(function (e) {
                            return e._id == newEl._id
                        })

                        if (existingEl) {
                            //update the existing array element with matching id
                            returnVal = returnVal.concat(auUtility.processItemUpdate(newEl, existingEl, key + i))
                        } else {
                            //add a new element to the array
                            eArr.push(newEl)
                            registerUpdate()
                        }
                    }

                    //see if any of the elements in the existing array have been removed
                    for (var i = 0; i < eArr.length; i++) {
                        var existingEl = eArr[i]
                        var found = nArr.find(function (e) {
                            return e._id == existingEl._id
                        })
                        if (!found) {
                            eArr.splice(i, 1)
                        }
                    }
                } else if (typeof existingItem[key] == "object" && typeof newItem[key] == "object") {
                    returnVal = returnVal.concat(auUtility.processItemUpdate(newItem[key], existingItem[key], key))
                } else if (!angular.equals(existingItem[key], newItem[key])) {
                    existingItem[key] = newItem[key]
                    registerUpdate()
                }
            }

            if (returnVal.length && newItem.$key) console.info('fields updated', newItem.$key, returnVal)
            return returnVal

            function registerUpdate() {
                returnVal.push((keyName ? keyName + '.' : '') + key)
            }
        }

        this.formatDuration = function (duration, format) {

            var totalDuration, totalDays, totalHours, totalMinutes = 0
            var returnVal = ""

            totalDuration = duration || 0

            totalDays = parseInt(totalDuration / (1000 * 60 * 60 * 24))
            totalDuration = totalDuration - (totalDays * 1000 * 60 * 60 * 24)
            if (totalDays < 10) totalDays = "0" + totalDays

            totalHours = parseInt(totalDuration / (1000 * 60 * 60))
            totalDuration = totalDuration - (totalHours * 1000 * 60 * 60)
            if (totalHours < 10) totalHours = "0" + totalHours

            totalMinutes = parseInt(totalDuration / (1000 * 60))
            if (totalMinutes < 10) totalMinutes = "0" + totalMinutes

            switch (format) {
                case 'short':
                    if (totalDays != "00") returnVal += totalDays + '<u>:</u>'
                    returnVal += totalHours + '<u>:</u>' + totalMinutes

                    break
                default:
                    if (totalDays != "00") {
                        returnVal += parseInt(totalDays) + ' day'
                        if (totalDays != "01") returnVal += 's'
                        returnVal += ' <u>:</u> '
                    }

                    returnVal += parseInt(totalHours) + ' hour'
                    if (totalHours != "01") returnVal += 's'
                    returnVal += ' <u>:</u> '

                    returnVal += parseInt(totalMinutes) + ' minutes'
            }

            return returnVal
        }

        this.preventDuplicates = function (arr, $chip) {
            if (arr.indexOf($chip) > -1) return null
            return $chip
        }

        this.requiresAclGeneration = function (cacheItem, item) {
            //invalide the acl promise if a field that impactsACL changed
            for (var i = 0; i < Schema.for(cacheItem.$key).fields.length; i++) {
                var field = Schema.for(cacheItem.$key).fields[i]
                if (field.impactsACL && Object.byString(cacheItem, field.name) != Object.byString(item, field.name)) {
                    return true
                }
            }
            return false
        }

        this.newItemFromTemplate = function (templateId, modelName, replaceWindow) {
            toast.toast('Creating Copy... Working...')
            return $http.post('/api/copyItem', { modelName: modelName, itemId: templateId }).then(function (response) {
                $injector.get(modelName).getCache({ _id: response.data.copyId }).$httpPromise.then(function (items) {
                    var item = items[0]

                    //close new from template window
                    if (replaceWindow) {
                        window.location.replace(item.getHref())
                    } else {
                        item.open()
                    }
                })
            })
        }

        this.unlockRepeatingItem = function (item) {
            item.LinkedToRecurring = null;
            item.$updateItem().$promise.then(function () {
                // close and open the item so that locking/unlocking will apply
                item.close()
                item.open()
            })
        }

        this.filter = function (arr, conditions) {
            //the point is to process $ors - please expand as possible!
            var idsInOr, inOr = []
            if (conditions.$or) {
                var usedOr = true
                //first find all documents that meet those conditions.
                conditions.$or.forEach(function (or) {
                    inOr = inOr.concat($filter('filter')(arr, or))
                })
                idsInOr = inOr.map(function (doc) {
                    return doc._id
                })
            }
            delete conditions.$or
            if (Object.keys(conditions).length == 0 && typeof conditions != "function") {
                return inOr
            } else {
                var inCondition = $filter('filter')(arr, conditions)
                if (usedOr) inCondition = inCondition.filter(function (doc) {
                    return idsInOr.indexOf(doc._id) > -1
                })
                return inCondition
            }
        }

        this.ordinal_suffix_of = function (i, onlySuffix) {
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return (onlySuffix ? "" : i) + "st";
            }
            if (j == 2 && k != 12) {
                return (onlySuffix ? "" : i) + "nd";
            }
            if (j == 3 && k != 13) {
                return (onlySuffix ? "" : i) + "rd";
            }
            return (onlySuffix ? "" : i) + "th";
        }

        this.linkNodeWithUser = function (node, user) {
            if (user && user.$addNew) {
                node.LinkWithUserId = null
                return auUtility.addNewItem(user.$addNew).then(function (newItem) {
                    if (!newItem) return
                    node.Text = newItem.toString()
                    node.LinkWithUserId = newItem._id
                })
            }

            //if the user didn't change the role/title, update it to the user's name
            if (node.LinkWithUserId && (node.Text == "New Member" || node.Text == "")) {
                node.Text = User.getCache({ _id: user })[0].toString()
            }
        }

        this.hasPermission = function (permission, items) {
            if (permission === true || permission == undefined) return true

            if (!items.$hasPermissionCache) items.$hasPermissionCache = {}

            //if (items.$hasPermissionCache[permission] == undefined) {
            if (typeof permission == 'string') {
                items.$hasPermissionCache[permission] = (permission == undefined
                    || $rootScope.$eval(permission)
                    || false)
            }

            if (typeof permission == 'function') {
                //send each selected item through the function passed in.
                var hasPermission = true
                if (items instanceof Array) {
                    angular.forEach(items, function (item) {
                        if (!permission(item)) hasPermission = false
                    })
                } else {
                    hasPermission = permission(items)
                }

                //if all calls results in true, the user has permission
                items.$hasPermissionCache[permission] = hasPermission
            }
            //}

            this.confirm = function (title, prompt, $event) {
                return $mdDialog.show($mdDialog.confirm({
                    title: title,
                    htmlContent: prompt,
                    ok: 'Do It',
                    cancel: 'Cancel',
                    targetEvent: $event
                }))
            }


            return items.$hasPermissionCache[permission]
        }

        //copy mention support
        this.copyMentionTooltipText = "Click to Copy"
        this.copyMention = function ($event) {
            var This = this
            $event.stopPropagation()
            try {
                var el = angular.element($event.target).closest('.copy-mention')[0]
                var range = document.createRange();
                range.selectNode(el);
                window.getSelection().removeAllRanges()
                window.getSelection().addRange(range);
                document.execCommand("copy")
                
                window.getSelection().removeAllRanges()

                this.copyMentionTooltipText = "Copied Okay!"
                $timeout(function () {
                    toast.success('Now, paste the mention anywhere you want!')
                }, 1000)
                $timeout(function () {
                    This.copyMentionTooltipText = "Click to Copy"
                }, 3000)
            } catch (err) {
                toast.error("Hmmm... your browser prevented copying the mention to your clipboard.")
            }
        }

        this.getAllOwners = function(itemType){
            return $http.post('/api/getAllOwners', { modelName: itemType }).then(function (response) {
                $injector.get(modelName).getCache({ _id: response.data.copyId }).$httpPromise.then(function (items) {
                    var item = items[0]

                    //close new from template window
                    if (replaceWindow) {
                        window.location.replace(item.getHref())
                    } else {
                        item.open()
                    }
                })
            })
        }

        this.getElementText = function(el){
            var range = document.createRange() // create new range object
            range.selectNodeContents(el) // set range to encompass desired element text
            var selection = window.getSelection() // get Selection object from currently user selected text
            selection.removeAllRanges() // unselect any user selected text (if any)
            selection.addRange(range) // add range to Selection object to select it
            return selection.toString()
        }
    }//end service function
})();
(function() {
    auTour.$inject = ["$rootScope", "$compile", "$state", "$timeout", "$mdDialog", "tourJSON"];
    angular.module('app').service('auTour', auTour);

    function auTour($rootScope, $compile, $state, $timeout, $mdDialog, tourJSON) {
        var auTour = this
        auTour.currentTour = []
        auTour.isOpen = false

        //tourJSON is an array, so find the element with the state name & params
        auTour.getTourForState = function(state) {
            for (var i = 0; i < tourJSON.length; i++) {
                if (tourJSON[i].stateName == state.name &&
                    (tourJSON[i].stateParams === undefined || $filter('filter')([state.params], tourJSON[i].stateParams).length == 1)) {
                    return tourJSON[i].tourtips
                }
            }
            return false
        }

        //start the tour for the current state        
        auTour.initiateForCurrentState = function() {
            //get a ref to the tourtip element if we need it
            if (!auTour.tip) auTour.tip = angular.element('.tour-tip')

            //get the tour or the "no tour" tour
            auTour.currentTour = auTour.getTourForState($state.current) || noTour

            //initiate the tour for this state
            auTour.currentStep = 0
            auTour.play()
        }

        auTour.nextStep = function() {
            auTour.currentStep++;
            auTour.play()
        }

        //show the tourtip for the current step        
        auTour.play = function() {
            //get the tip's data
            var tip = auTour.currentTour[auTour.currentStep]

            //if there is no data, we're at the end - close
            if (!tip) return auTour.markCurrentStateDone()

            //get a ref to the target element
            var targetElement = angular.element(tip.tourtipElement)

            //get out if we can't find it            
            if (targetElement == null || targetElement.length === 0)
                return auTour.nextStep()

            //copy all the properties from the tip onto the currentTour
            delete auTour.currentTour.image
            angular.extend(auTour.currentTour, tip)

            //open the tip			
            auTour.isOpen = true

            //after angular shows the tour, update it's position
            $timeout(function() {
                updatePosition(targetElement)
            },1)
        }

        //save that the user went through this tour        
        auTour.markCurrentStateDone = function() {
            closeTour()

            $rootScope.user.setTourSeenFor($state.current.name)
        }

        //default tip when no tour is available        
        noTour = [{
            tourtipHeader: "There's no tour for this page!",
            tourtipText: "But you can visit our <b><a href='https://alignus.freshdesk.com/support/home'>help center</a></b> at any time.",
            tourtipElement: "body",
            tourtipPlacement: "center",
            tourtipNextLabel: "Okay"
        }]

        //attach a state listener when not testing (tests set localStorage tourDoneForever)        
        if (localStorage.getItem('tourDoneForever') != 'true') {
            var killStateChangeListener = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                    handleStateChange(toState)
                })
                //when shell is loaded, handle a state change event
            poll(function() { //when
                return angular.element('#TxtOneSearchInput[aria-invalid="false"]').length > 0
            }, function() { //then
                handleStateChange($state.current)
            }, angular.noop, 30000, 1000)

        }

        function handleStateChange(toState) {
            //close any current tour on navigation
            if (auTour.isOpen) closeTour()

            //if this is the first time the user has been to the state, show the tour (after it loads)             
            if (!isTourMarkedDoneFor(toState.name) && auTour.getTourForState(toState)) {
                $timeout(function() {
                    auTour.initiateForCurrentState()
                }, 500)
            }
        }

        //remove the active-element border, close the tip and move the tip back to the body (so it stays compiled)        
        function closeTour() {
            angular.element('.tour-element-active').removeClass('tour-element-active')
            auTour.isOpen = false
            angular.element(document.body).append(auTour.tip)
        }

        //check if the user has been to a state        
        function isTourMarkedDoneFor(stateName) {
            if (!$rootScope.user || !$rootScope.user.Settings) return false //likely from an auth failure
            if (!$rootScope.user.Settings.TourSeenFor) return false;
            return $rootScope.user.Settings.TourSeenFor.indexOf(stateName) > -1
        }

        //move the tip
        function updatePosition(targetElement) {
            //get a ref to the container/parent
            var parent = targetElement.scrollParent()
            var op = "position"
            if (parent[0] == document) {
                parent = angular.element(document.body)
                op = "offset"
            }

            //attach the targetElement to the parent
            parent.append(auTour.tip)

            var targetTop = targetElement[op]().top + parent.scrollTop() // - parentOffset.top
            var targetLeft = targetElement[op]().left  //- parentOffset.left

            //start the tip at the top/left of the target            
            var css = { top: "", left: "", "margin-top": "", "margin-left": "" }
            css.top = targetTop
            css.left = targetLeft

            //based on the deisred tip placement, adjust the top/left
            switch (auTour.currentTour.tourtipPlacement) {
                case 'center':
                    //simply center it on screen    
                    css.top = targetTop + (targetElement.height() / 2)
                    css.left = targetLeft + (targetElement.width() / 2)
                    css['margin-top'] = "-100px"
                    css['margin-left'] = "-200px"
                    break;
                case 'center-top':
                    //center near top of target    
                    css.top = targetTop + 50
                    css.left = targetLeft + (targetElement.width() / 2)
                    css['margin-left'] = "-200px"
                    break;
                case 'bottom':
                    css.top += targetElement.height()
                    break;
                case 'bottom-left':
                    css.top += targetElement.height()
                    css.left -= auTour.tip.width() - targetElement.width()
                    break;
                case 'top':
                    css.top -= auTour.tip.height()
                    break;
                case 'top-left':
                    css.top -= auTour.tip.height()
                    css.left -= auTour.tip.width() - targetElement.width()
                    break;
                case 'right':
                    css.left += targetElement.width()
                    break;
                case 'left':
                    css.left -= auTour.tip.width()
                    break;
            }

            //apply the position of the tourtip
            auTour.tip.css(css)

            //now check that it fits on screen and then adjust if needed
            if (parseInt(auTour.tip.css('left')) + auTour.tip.width() > parent.width()) {
                auTour.currentTour.tourtipPlacement = "left"
                updatePosition(targetElement)
            }
            if (parseInt(auTour.tip.css('left')) < 0) {
                auTour.currentTour.tourtipPlacement = "center"
                updatePosition(targetElement)
            }

            //highlight the target element
            angular.element('.tour-element-active').removeClass('tour-element-active')
            targetElement.addClass('tour-element-active')

            //scroll if needed
            if (parent[0] == document.body) { //auTour.currentTour.tourtipPlacement == "center" ||
                parent.scrollTop(0)
            } else {
                parent.animate({
                    scrollTop: Math.max(targetTop - auTour.tip.height() - 40, 0)
                })
            }
        };
    }
})();
(function () {
	auTheme.$inject = ["$injector", "auMaterialPaletteGen", "themeProvider"];
	angular.module('app')
		.service('auTheme', auTheme);

	function auTheme($injector, auMaterialPaletteGen, themeProvider) {
		this.loadTheme = function (color, dark) {
			if (!color) return;

			try {
				// generate color scheme
				var newTheme = auMaterialPaletteGen.generate(color);

				var accentColor = auMaterialPaletteGen.getAccentColor(color);

				var accentTheme = auMaterialPaletteGen.generate(accentColor);

				// remove existing themes
				angular.element('style[md-theme-style]').remove()

				// redefine main theme
				themeProvider.definePalette('main', newTheme);
				themeProvider.definePalette('accent', accentTheme);
				var theme = themeProvider.theme('default')
					.primaryPalette('main', {
						'hue-2': 'A700'
					})
					.accentPalette('accent', {
						'default': '500', // default is the main accent color
						'hue-1': '800', // hue 1 is dark red
						'hue-2': '200', // hue 2 is light (for black text)
						'hue-3': 'A200' // hue 3 is almost white
					})
					.warnPalette('deep-orange');
					if (dark) theme.dark()

				// reload themes
				themeProvider.reloadThemes($injector);
			} catch (e) {
				console.error(e);
				console.info('Unable to update themes')
			}


		}
		window.theme = this.loadTheme
	}
})();
(function () {
	auMaterialPaletteGen.$inject = ["auMaterialColors"];
	angular.module('app')
		.factory('auMaterialPaletteGen', auMaterialPaletteGen);

	function auMaterialPaletteGen(auMaterialColors) {

		return {
			generate: function (baseColor) {
				return calculatePalettes(baseColor);
			},
			getAccentColor: function (color) {
				// attempt to match given color an a defined one
				var indexedColor = auMaterialColors.filter(function(e) {
					return window.tinycolor(e.color).toHexString() == window.tinycolor(color).toHexString();
				});

				// if a match then return the corresponding accent
				if (indexedColor.length == 1) {
					return indexedColor[0].accent;
				}


				// else we'll come up with one
				var accentColor = window.tinycolor(color)

				var accentHue = accentColor.toHsv().h;

				// try to avoid yellow to green accent colors
				if (accentHue > 180 && accentHue < 359 || accentHue < 0) {
					return accentColor.spin(60).saturate(100).desaturate(10).toHexString();
				} else {
					return accentColor.spin(-60).saturate(100).desaturate(10).toHexString();
				}
			}
		};

		function calculatePalettes(hex) {
			// TODO: this can clip into white, something that goes closer to white
			// without hititng it would be better
			var colors = [
				{ hex: window.tinycolor(hex).lighten(52).toHexString(), name: '50' },
				{ hex: window.tinycolor(hex).lighten(37).toHexString(), name: '100' },
				{ hex: window.tinycolor(hex).lighten(26).toHexString(), name: '200' },
				{ hex: window.tinycolor(hex).lighten(12).toHexString(), name: '300' },
				{ hex: window.tinycolor(hex).lighten(6).toHexString(), name: '400' },
				{ hex: window.tinycolor(hex).toHexString(), name: '500' },
				{ hex: window.tinycolor(hex).darken(6).toHexString(), name: '600' },
				{ hex: window.tinycolor(hex).darken(12).toHexString(), name: '700' },
				{ hex: window.tinycolor(hex).darken(18).toHexString(), name: '800' },
				{ hex: window.tinycolor(hex).darken(24).toHexString(), name: '900' },
				{ hex: window.tinycolor(hex).lighten(52).toHexString(), name: 'A100' },
				{ hex: window.tinycolor(hex).lighten(37).toHexString(), name: 'A200' },
				{ hex: window.tinycolor(hex).lighten(6).toHexString(), name: 'A400' },
				{ hex: window.tinycolor(hex).darken(12).toHexString(), name: 'A700' }
			];

			if (window.tinycolor(hex).lighten(52).toHexString().toLowerCase() == "#ffffff") {
				// Darken it and try again
				colors[0].hex = window.tinycolor(hex).lighten(42).toHexString();
			}

			var newPalette = {};
			newPalette.contrastDefaultColor = 'light';
			newPalette.contrastDarkColors = [];

			angular.forEach(colors, function (color) {
				newPalette[color.name] = color.hex.replace('#', '');
				if (window.tinycolor(color.hex).toHsl().l > 0.75) {
					newPalette.contrastDarkColors.push(color.name);
				}
			})

			return newPalette;
		}
	}

})();


(function() {
		attachedDocumentManager.$inject = ["$http", "$q", "$rootScope"];
	angular
		.module('app')
		.service('attachedDocumentManager', attachedDocumentManager)

		/* @ngInject */
		function attachedDocumentManager($http, $q, $rootScope) {
			var adm = {}

			adm.manage = function(resource) {
				var type = resource.$key.toLowerCase() + '/'
				resource.prototype.RemoveDocument = removeDocument 
				resource.prototype.AddUserFileTypeDocuments = addUserFileTypeDocuments 
				resource.prototype.AddDocumentTypeDocument = addDocumentTypeDocuments
				resource.prototype._removeDocumentByField = _removeDocumentByField
				resource.prototype._removeUnsavedDocument = _removeUnsavedDocument
				resource.prototype._removeSavedDocument = _removeSavedDocument

				function removeDocument(documentId, documentTitle) {
					var This = this
					if(documentId) {
						return This._removeSavedDocument(documentId)
					} else {
						return This._removeUnsavedDocument(documentTitle)
					}
				}

				function _removeSavedDocument(documentId) {
					var This = this
					return $http.post('/api/' + type + this._id + '/RemoveDocument', {documentId: documentId})
						.then(function() {
							This._removeDocumentByField(documentId, '_id')
						})
				}

				function _removeUnsavedDocument(title) {
					this._removeDocumentByField(title, 'Title')
					return $q.resolve(true)
				}

				function _removeDocumentByField(query, fieldName) {
					var This = this
					var i, found = false
					for(i = 0; i < This.Documents.length && !found; i++) {
						if(This.Documents[i][fieldName] == query) {
							found = true; break;
						}
					}
					if(found) {
						This.Documents.splice(i, 1)
						$rootScope.$broadcast('itemUpdated', This)
					}
				}

				function addUserFileTypeDocuments(documents, subtype) {
					var This = this
					// console.debug('Adding user file document', This)
					documents = documents.map(function(document) {
						return {
							Title: document.originalFileName,
							Id: document.key,
							Type: 'UserFile',
							Subtype: subtype,
							// the server always sets this anyways
							CreatedBy: $rootScope.user._id
						}
					})
					return addDocuments(This, documents)
				}

				function addDocumentTypeDocuments(title, id, subtype) {
					var This = this
					var document = {
						Title: title,
						Id: id,
						Type: 'Document',
						Subtype: subtype,
						// the server always sets this anyways
						CreatedBy: $rootScope.user._id
					}
					return addDocuments(This, [document])
				}

				function addDocuments(This, documents) {
					if(!This.Documents) { This.Documents = [] }
					This.Documents = This.Documents.concat(documents)
					$rootScope.$broadcast('itemUpdated', This)

					if(This._id) {
						return $http.post('/api/' + type + This._id + '/AddDocuments', {documents: documents})
					} else {						
						// meaningless, just preserves thenability
						return $q.resolve(true)
					}
				}
			}

			return adm
		}
})();
/**
 *  logglyLogger is a module which will send your log messages to a configured
 *  [Loggly](http://loggly.com) connector.
 *
 *  Major credit should go to Thomas Burleson, who's highly informative blog
 *  post on [Enhancing AngularJs Logging using Decorators](http://bit.ly/1pOI0bb)
 *  provided the foundation (if not the majority of the brainpower) for this
 *  module.
 *
 *  @version 0.3.0
 *  @author A.J. Brown <aj@ajbrown.org>
 *  @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function( angular ) {
  "use strict";

  angular.module( 'logglyLogger.logger', [] )
    .provider( 'LogglyLogger', function() {
      var self = this;

      var logLevels = [ 'DEBUG', 'INFO', 'WARN', 'ERROR' ];

      var https = true;
      var extra = {};
      var includeCurrentUrl = false;
      var includeTimestamp = false;
      var includeUserAgent = false;
      var tag = null;
      var sendConsoleErrors = false;
      var logToConsole = true;
      var loggingEnabled = true;
      var labels = {};
      var deleteHeaders = false;

      // The minimum level of messages that should be sent to loggly.
      var level = 0;

      var token = null;
      var endpoint = '://logs-01.loggly.com/inputs/';

        var buildUrl = function () {
          return (https ? 'https' : 'http') + endpoint + token + '/tag/' + (tag ? tag : 'AngularJS' ) + '/';
        };

      this.setExtra = function (d) {
        extra = d;
        return self;
      };

      this.fields = function ( d ) {
        if( angular.isDefined( d ) ) {
          angular.extend(extra, d);
          return self;
        }

        return extra;
      };

      this.labels = function(l) {
        if (angular.isObject(l)) {
          labels = l;
          return self;
        }

        return labels;
      };

      this.inputToken = function ( s ) {
        if (angular.isDefined(s)) {
          token = s;
          return self;
        }

        return token;
      };

      this.useHttps = function (flag) {
        if (angular.isDefined(flag)) {
          https = !!flag;
          return self;
        }

        return https;
      };

      this.includeUrl = function (flag) {
        if (angular.isDefined(flag)) {
          includeCurrentUrl = !!flag;
          return self;
        }

        return includeCurrentUrl;
      };

      this.includeTimestamp = function (flag) {
        if (angular.isDefined(flag)) {
          includeTimestamp = !!flag;
          return self;
        }

        return includeTimestamp;
      };

      this.includeUserAgent = function (flag) {
        if (angular.isDefined(flag)) {
          includeUserAgent = !!flag;
          return self;
        }

        return includeUserAgent;
      };

      this.inputTag = function (usrTag){
        if (angular.isDefined(usrTag)) {
          tag = usrTag;
          return self;
        }

        return tag;
      };

      this.sendConsoleErrors = function (flag){
        if (angular.isDefined(flag)) {
          sendConsoleErrors = !!flag;
          return self;
        }

        return sendConsoleErrors;
      };

      this.level = function ( name ) {

        if( angular.isDefined( name ) ) {
          var newLevel = logLevels.indexOf( name.toUpperCase() );

          if( newLevel < 0 ) {
            throw "Invalid logging level specified: " + name;
          } else {
            level = newLevel;
          }

          return self;
        }

        return logLevels[level];
      };

      this.isLevelEnabled = function( name ) {
        return logLevels.indexOf( name.toUpperCase() ) >= level;
      };

      this.loggingEnabled = function (flag) {
          if (angular.isDefined(flag)) {
              loggingEnabled = !!flag;
              return self;
          }

          return loggingEnabled;
      };


      this.logToConsole = function (flag) {
        if (angular.isDefined(flag)) {
          logToConsole = !!flag;
          return self;
        }

        return logToConsole;
      };

      this.deleteHeaders = function (flag) {
        if (angular.isDefined(flag)) {
          deleteHeaders = !!flag;
          return self;
        }

        return deleteHeaders;
      };



      this.$get = [ '$injector', function ($injector) {

        var lastLog = null;


        /**
         * Send the specified data to loggly as a json message.
         * @param data
         */
        var sendMessage = function (data) {
          //If a token is not configured, don't do anything.
          if (!token || !loggingEnabled) {
            return;
          }

          //TODO we're injecting this here to resolve circular dependency issues.  Is this safe?
          var $window = $injector.get( '$window' );
          var $location = $injector.get( '$location' );
		   //we're injecting $http
          var $http = $injector.get( '$http' );

          lastLog = new Date();

          var sentData = angular.extend({}, extra, data);

          if (includeCurrentUrl) {
            sentData.url = $location.absUrl();
          }

          if( includeTimestamp ) {
            sentData.timestamp = lastLog.toISOString();
          }

          if( includeUserAgent ) {
            sentData.userAgent = $window.navigator.userAgent;
          }

          //Loggly's API doesn't send us cross-domain headers, so we can't interact directly
           //Set header
          var config = {
            headers: {
             'Content-Type': 'text/plain'
            },
            withCredentials: false
          };

          if (deleteHeaders) {
            //Delete other headers - this tells browser it's no need to pre-flight OPTIONS request
            var headersToDelete = Object.keys($http.defaults.headers.common).concat(Object.keys($http.defaults.headers.post));
            headersToDelete = headersToDelete.filter(function(item) {
              return item !== 'Accept' && item !== 'Content-Type';
            });

            for (var index = 0; index < headersToDelete.length; index++) {
              var headerName = headersToDelete[index];
              config.headers[headerName] = undefined;
            }
          }

          // Apply labels
          for (var label in labels) {
            if (label in sentData) {
              sentData[labels[label]] = sentData[label];
              delete sentData[label];
            }
          }

          //Ajax call to send data to loggly
          $http.post(buildUrl(),sentData,config);
        };

        var attach = function() {
        };

        var inputToken = function(s) {
          if (angular.isDefined(s)) {
            token = s;
          }

          return token;
        };

        return {
          lastLog: function(){ return lastLog; },
          sendConsoleErrors: function(){ return sendConsoleErrors; },
          level : function() { return level; },
          loggingEnabled: self.loggingEnabled,
          isLevelEnabled : self.isLevelEnabled,
          inputTag: self.inputTag,
          attach: attach,
          sendMessage: sendMessage,
          logToConsole: logToConsole,
          inputToken: inputToken,

          /**
           * Get or set the fields to be sent with all logged events.
           * @param d
           * @returns {*}
           */
          fields: function( d ) {
            if( angular.isDefined( d ) ) {
              self.fields( d );
            }
            return self.fields();
          }
        };
      }];

    } );


  angular.module( 'logglyLogger', ['logglyLogger.logger'] )
    .config( [ '$provide', function( $provide ) {

      $provide.decorator('$log', [ "$delegate", '$injector', function ( $delegate, $injector ) {

        var logger = $injector.get('LogglyLogger');

        // install a window error handler
        if(logger.sendConsoleErrors() === true) {
          var _onerror = window.onerror;

          //send console error messages to Loggly
          window.onerror = function (msg, url, line, col, error) {
            if(error && error.stack) {
              window.mapStackTrace(error.stack, function(mappedStack) {
                logger.sendMessage({
                  level : 'ERROR',
                  message: msg,
                  line: line,
                  col: col,
                  stack: mappedStack
                });
              })
            } else {
              logger.sendMessage({
                level : 'ERROR',
                message: msg,
                line: line,
                col: col,
                stack: error && error.stack
              });
            }

            if (_onerror && typeof _onerror === 'function') {
              _onerror.apply(window, arguments);
            }
          };
        }

        var wrapLogFunction = function(logFn, level, loggerName) {

          var wrappedFn = function () {
            var args = Array.prototype.slice.call(arguments);

            if(logger.logToConsole) {
              logFn.apply(null, args);
            }

            // Skip messages that have a level that's lower than the configured level for this logger.
            if(!logger.loggingEnabled() || !logger.isLevelEnabled( level ) ) {
              return;
            }

            var msg = (args.length === 1 ? args[0] : args) || {};
            var sending = { level: level };

            if(angular.isDefined(msg.stack) || (angular.isDefined(msg[0]) && angular.isDefined(msg[0].stack))) {
              //handling console errors
              if(logger.sendConsoleErrors() === true) {
                sending.message = msg.message ? msg.message : (msg[0] && msg[0].message) ? msg[0].message : null;
                sending.stack = msg.stack || msg[0].stack;
              }
              else {
                return;
              }
            }
            else if(angular.isObject(msg)) {
              //handling JSON objects
              sending = angular.extend({}, msg, sending);
            }
            else{
              //sending plain text
              sending.message = msg;
            }

            if( loggerName ) {
              sending.logger = msg;
            }

            //Send the message to through the loggly sender
            logger.sendMessage( sending );
          };

          wrappedFn.logs = [];

          return wrappedFn;
        };

        var _$log = (function ($delegate) {
          return {
            log: $delegate.log,
            info: $delegate.info,
            warn: $delegate.warn,
            error: $delegate.error
          };
        })($delegate);

        var getLogger = function ( name ) {
          return {
            log:    wrapLogFunction( _$log.log, 'INFO', name ),
            debug:  wrapLogFunction( _$log.debug, 'DEBUG', name ),
            info:   wrapLogFunction( _$log.info, 'INFO', name ),
            warn:   wrapLogFunction( _$log.warn, 'WARN', name ),
            error:  wrapLogFunction( _$log.error, 'ERROR', name )
          };
        };

        //wrap the existing API
        $delegate.log =    wrapLogFunction($delegate.log, 'INFO');
        $delegate.debug =  wrapLogFunction($delegate.debug, 'DEBUG');
        $delegate.info =   wrapLogFunction($delegate.info, 'INFO');
        $delegate.warn =   wrapLogFunction($delegate.warn, 'WARN');
        $delegate.error =  wrapLogFunction($delegate.error, 'ERROR');

        //Add some methods
        $delegate.getLogger = getLogger;

        return $delegate;
      }]);

    }]);



})(window.angular);

//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'UserQuestion'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.toString = function () {
						return this.Question
					}

					this.resource.getType = function () {
						return Type
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
				}
				return this.resource
			}], //end of $get
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/questions/question/questions.tmpl.html',
					controller: 'QuestionsController',
					controllerAs: 'vm'
				}
			},
			listSettings: {
				//indicate what permission is needed to remove an item

				//define what views should be availble for this resource
				viewTypes: ['list'],

				emptyTitle: "Select A Question", 
				emptyDescription: "Pick a question from the left.", 
			}
		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'UserNewsFeed'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.toString = function () {
						return this.Name
					}

					this.resource.getType = function () {
						return Type
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
				}
				
				return this.resource

			}], //end of $get

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
(function () {
    var resourceName = 'User'

    var apiRoute = '/api/' + resourceName + '/'
    angular.module('app').provider(resourceName, Resource)

    function Resource() {
        this.resource = null

        var Type = {
            name: resourceName,

            //$get functions are available when used as a service/factory
            /* @ngInject */
            $get: ["$cachedResource", "$filter", "$http", "$mdDialog", "toast", "Schema", "PopulateResource", "$state", "$window", "attachedDocumentManager", "$rootScope", "$timeout", "$interval", "Page", "socket", function ($cachedResource, $filter, $http, $mdDialog, toast, Schema, PopulateResource, $state, $window, attachedDocumentManager, $rootScope, $timeout, $interval, Page, socket) {
                if (!this.resource) {
                    this.resource = $cachedResource(resourceName, apiRoute.toLowerCase() + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

                    this.resource.prototype.$section = 'structure'

                    this.resource.prototype.toString = function () {
                        return (this.FirstName || '') + ' ' + (this.LastName || '')
                    }

                    this.resource.getType = function () {
                        return Type
                    }

                    //add the alignus 00000000 user
                    //                     this.resource.addToCache(new this.resource({
                    //                         _id: "000000000000000000000000",
                    //                         FirstName: "Al",
                    //                         LastName: "Linus",
                    //                         Email: "mr.service@align.us",
                    //                         Photo: "000000000000000000000000"
                    //                     }))

                    this.resource.prototype.$trackBy = ['Structure', 'Users and Teams']

                    //add functions for ref fields here
                    PopulateResource.populate(this.resource)

                    this.resource.prototype.removePermission = function (name) {
                        return $http.post(apiRoute + this._id + '/RemovePermission', {
                            name: name
                        })
                    }

                    this.resource.prototype.setPermission = function (permSet) {
                        return $http.post(apiRoute + this._id + '/SetPermission', permSet)
                    }

                    this.resource.prototype.setTourSeenFor = function (stateName) {
                        if (!this.Settings.TourSeenFor) {
                            this.Settings.TourSeenFor = []
                            this.setSetting({ TourSeenFor: [] })
                        }
                        this.Settings.TourSeenFor.push(stateName)
                        return this.setSetting({ TourSeenFor: this.Settings.TourSeenFor })
                    }

                    this.resource.prototype.hasSeenState = function (stateName) {
                        if (!this.Settings.VisitedStates) return false;
                        if (this.Settings.VisitedStates.indexOf(stateName) < 0) return false;
                        return true;
                    }

                    this.resource.prototype.canSeeOrgSettingsSection = function () {
                        return (this.EffPerms.Organization.CanManage || this.managesLocations() ||
                            this.managesDepartments() ||
                            this.EffPerms.Organization.CanManageLicenses)
                    }

                    this.resource.prototype.managesLocations = function () {
                        return this.EffPerms.Locations.CanManage || $injector.get('Location').getCache({ Head: this._id }, false).length > 0
                    }

                    this.resource.prototype.managesDepartments = function () {
                        return this.EffPerms.Departments.CanManage || $injector.get('Department').getCache({ Head: this._id }, false).length > 0
                    }

                    //recreate virtual field from server on client
                    Object.defineProperty(this.resource.prototype, 'IsUserAdmin', {
                        get: function () {
                            return this.EffPerms.Users.IsAdminFor.Org
                        }
                    })

                    this.resource.prototype.setSetting = debounce(function (setting) {
                        if ($rootScope.user.$AnonymousUser) return

                        angular.merge(this.Settings, setting)
                        return $http.post(apiRoute + this._id + '/SetSetting', setting)
                    }, 100)

                    this.resource.prototype.getSettings = function () {
                        return $http.get(apiRoute + this._id + '/GetSettings')
                    }

                    this.resource.prototype.addToGroup = function (groupid) {
                        return $http.post(apiRoute + this._id + '/AddToGroup', groupid)
                    }

                    this.resource.prototype.removeFromGroup = function (groupid) {
                        return $http.post(apiRoute + this._id + '/RemoveFromGroup', groupid)
                    }

                    this.resource.prototype.setPassword = function (newPassword, sendEmail, self) {
                        return $http.post(apiRoute + this._id + "/SetPassword", {
                            newPassword: newPassword,
                            sendEmail: sendEmail,
                            self: self
                        })
                    }

                    this.resource.prototype.setPhoto = function (newPhotoId) {
                        return $http.post(apiRoute + this._id + "/SetPhoto", { photoId: newPhotoId })
                    }

                    this.resource.prototype.effectivePermissions = function () {
                        return $http.get(apiRoute + this._id + '/EffectivePermissions')
                    }

                    this.resource.prototype.message = function (message) {
                        $injector.get('Conversation').NewConversationFull({ members: [this._id] })
                    }

                    this.resource.prototype.follow = function () {
                        return Schema.resource('Page').getCache({ _id: this._id })[0].Follow()
                    }

                    this.resource.prototype.visit = function () {
                        $window.open('/page/' + this._id)
                    }

                    this.resource.prototype.visitPageRecentItem = function () {
                        Page.getCache({ _id: this._id })[0].open('recent')
                    }

                    this.resource.prototype.showProfile = function () {
                        this.open('recent')
                    }

                    this.resource.prototype.reassignSubordinates = function (reassignTo, clearBoss) {
                        var This = this
                        return $http.post(apiRoute + this._id + "/ReassignSubordinates", {
                            newReportsTo: reassignTo,
                            clearBoss: clearBoss
                        }).then(function (res) {
                            //clear the cached variable hasSubordinates for the old and new bosses
                            //bad smell but a quick way around a timing issue
                            //the issue is that we won't get the item udpates for the users for a little and, until we do, getSubordinates will return invalid results
                            $interval(function () {
                                delete This._hasSubordinates
                                $rootScope.$broadcast('itemUpdated', This)

                                var newBoss = Schema.resource('User').getCache({ _id: reassignTo })[0]
                                delete newBoss._hasSubordinates
                                $rootScope.$broadcast('itemUpdated', newBoss)
                            }, 1000, 5)

                            return res
                        })
                    }

                    this.resource.prototype.setIsActive = function (newIsActive) {
                        return $http.post(apiRoute + this._id + "/SetIsActive", {
                            newIsActive: newIsActive
                        })
                    }

                    // get this user's subordinates
                    this.resource.prototype.getSubordinates = function (alsoQuery) {
                        var me = this._id
                        return Schema.resource('User').getCache({ ReportsTo: me }, alsoQuery)
                    }

                    // does this user have any subordinates - for binding expressions only
                    this.resource.prototype.hasSubordinates = function () {
                        if (this._hasSubordinates === undefined) {
                            this._hasSubordinates = false
                            this._hasSubordinates = this.getSubordinates(false).length > 0
                        }
                        return this._hasSubordinates
                    }

                    //does this user edit a Handbook?
                    this.resource.prototype.editsHandbook = function () {
                        var This = this
                        if (this.$editsHandbook == undefined) {
                            this.$editsHandbook = false

                            if (this.EffPerms.Handbook.CanEditAll) this.$editsHandbook = true
                            else {
                                Schema.resource('Handbook').getCache({ Editors: this._id }).$httpPromise.then(function (editableBooks) {
                                    if (editableBooks.length > 0) This.$editsHandbook = true
                                })
                            }
                        }

                        return this.$editsHandbook
                    }

                    this.resource.prototype.goToUsersTasksView = function () {
                        $window.open('/project/tasks-by-user/' + this._id + '/tasks/task-kanban?sortBy=Title&shellPeek=true')
                    }

                    //does this user edit a Strategy?
                    this.resource.prototype.editsStrategy = function () {
                        return (this.EffPerms.Strategy.CanEditAll || Schema.resource('Strategy').getCache({Editors: this._id}).length > 0)
                    }

                    this.resource.prototype.goToUsersTasksView = function () {        
                        $window.open('/project/tasks-by-user/' + this._id + '/tasks/task-kanban?sortBy=Title')
                    }

                    this.resource.prototype.goToUsersProjects = function () {
                        $window.open('/project/all/projects-for-user/list?shellPeek=true&user=' + this._id )
                    }

                    this.resource.prototype.goToUsersDocuments = function () {
                        $window.open('/documents/documents-for-user/' + this._id + '/list/list?sortBy=Title&shellPeek=true')
                    }

                    this.resource.prototype.getMyProjects = function () {
                        var This = this
                        //projects are preloaded for the shell so pass false to getCache to avoid a server hit
                        return Schema.resource('Project').getCache(function (project) {
                            // return all projects the user is involved with that aren't done and are active
                            return (project.UserIsInvolved(This._id) && !project.DateEnded && project.IsActive)
                        }, '-LastPercentCompleted', false)
                    }

                    this.resource.prototype.untrackRecentItem = function (item) {
                        var recentItems = this.Settings.RecentItems || {}
                        Object.keys(recentItems).forEach(function (key) {
                            //remove the item from the array
                            for (var i = 0; i < recentItems[key].length; i++) {
                                if (item._id == recentItems[key][i].id && item.$key == recentItems[key][i].type) {
                                    recentItems[key].splice(i, 1)
                                    break
                                }
                            }
                        })

                        //save the recent items to the cached resource (user) and server
                        this.setSetting({ RecentItems: recentItems })

                        //invalidate the UI cache
                        this.itemCacheIsValid = false

                        $rootScope.$broadcast('updateSuspended', 'recent')
                    }

                    this.itemCacheIsValid = false
                    this.resource.prototype.trackRecentItem = function (item, name) {
                        if (!name) name = 'last25'
                        if (!item || !item.$key || !item._id) return //if a null item is passed in, don't track it

                        //get a reference to the recent items
                        var recentItems = this.Settings.RecentItems
                        if (!recentItems) {
                            this.Settings.RecentItems = {}
                            recentItems = this.Settings.RecentItems
                        }

                        //create a new set of recent items if needed
                        if (!recentItems[name]) {
                            this.Settings.RecentItems[name] = []
                        }

                        //get the array to work with
                        var categoryArray = this.Settings.RecentItems[name]

                        //create a new item to push onto the recent items array
                        var thisItem = { type: item.$key, id: item._id }

                        //if this item is already in the array, remove it
                        var existingItemIndex = -1
                        for (var i = 0; i < categoryArray.length; i++) {
                            if (categoryArray[i].type == thisItem.type && categoryArray[i].id == thisItem.id) {
                                existingItemIndex = i
                                break;
                            }
                        }
                        if (existingItemIndex > -1) {
                            categoryArray.splice(existingItemIndex, 1)
                        }

                        //add this item to the beginning of the array
                        categoryArray.unshift(thisItem)

                        //truncate the array to 25
                        if (categoryArray.length > 25) {
                            categoryArray.splice(26, categoryArray.length)
                        }

                        //save the recent items to the cached resource (user) and server
                        this.setSetting({ RecentItems: recentItems })

                        var This = this

                        // if this was being tracked in the 'general'/'last25' category...
                        if (name == 'last25' && item.$trackBy) {
                            // ...track it by all other applicable categories as well.
                            angular.forEach(item.$trackBy, function (trackByTag) {
                                This.trackRecentItem(item, trackByTag)
                            })
                        }

                        //invalidate the UI cache
                        this.itemCacheIsValid = false

                        $rootScope.$broadcast('updateSuspended', 'recent')
                    }

                    this.resource.prototype.loadCacheWithItems = function (itemMap) {
                        //prevent itemupdates that honor this (like conversations) from responding to itemUpdated
                        window.localCacheReady = false

                        for (var type in itemMap) {
                            var Resource = Schema.resource(type)
                            for (var i = 0; i < itemMap[type].length; i++) {
                                //patch catch will add but not announce itemAdded
                                Resource.patchCache(new Resource(itemMap[type][i]))
                            }
                        }

                        window.localCacheReady = true
                    }

                    //because angular calls this during it's digest cycle (read: 40+ times just to render the page), keep a cache of the items and invalidate the cache only when a new item is tracked.
                    this.resource.prototype.getRecentItems = function () {
                        var This = this
                        //return the cache if valid
                        if (This.itemCacheIsValid) {
                            return This.$recentItemCache
                        }

                        if (!This.Settings.RecentItems) {
                            return {}
                        }

                        //build a new cache by instantiating the resource by name and then querying its cache by id
                        var returnVal = {}

                        // for each category of recent items
                        Object.keys(This.Settings.RecentItems).forEach(function (arrayName) {
                            // initialize an empty array for this category of recent items
                            var currentCategoryArray = returnVal[arrayName] = []
                            // get a reference to this array in the 'actual' recent items
                            var actualRecentItemsCategory = This.Settings.RecentItems[arrayName]
                            // for every item in this category
                            angular.forEach(actualRecentItemsCategory, function (item) {
                                var collection = Schema.resource(item.type)
                                if (item.type == "Organization") {
                                    currentCategoryArray.push({ item: $rootScope.Organization, itemType: collection.getType() })
                                } else {
                                    if (collection) var newItem = collection.getCache({ _id: item.id }, false)
                                    if (newItem && newItem.length > 0) currentCategoryArray.push({ item: newItem[0], itemType: collection.getType() })
                                }
                            })
                        })

                        //set caching variables
                        This.$recentItemCache = returnVal
                        This.itemCacheIsValid = true

                        //return the array of cachedResources
                        return returnVal
                    }

                    this.resource.prototype.patchRecentItemCache = function (item) {
                        angular.forEach($rootScope.user.$recentItemCache, function (state) {
                            angular.forEach(state, function (cache) {
                                if (Object.byString(cache, "item._id") == item._id && Object.byString(cache, "item.$key") == item.$key) {
                                    cache.item = item
                                }
                            })
                        })
                    }

                    this.resource.prototype.clearRecentItemCache = function () {
                        delete this.$recentItemCache
                        $rootScope.user.itemCacheIsValid = false
                    }

                    // convenience function for getting the uncategorized 'last25' recent items
                    this.resource.prototype.getGeneralRecentItems = function () {
                        var retValue = this.getRecentItems().last25 || []
                        return retValue
                    }

                    this.resource.prototype.invalidateRecentItemCache = function () {
                        this.itemCacheIsValid = false
                    }

                    this.resource.prototype.getMyPage = function () {
                        return (Schema.resource('Page').getCache({ _id: this._id })[0])
                    }

                    //HighFives is just an array of User, DateCreated
                    this.resource.prototype.getMyRecentHighFives = function () {
                        var recentHighFives = this.HighFives.filter(function (highFive) {
                            return new Date(highFive.DateCreated) > new Date((new Date().getTime()) - (1000 * 60 * 60 * 24 * 30))
                        })
                        return recentHighFives
                    }

                    //dev note: while functional as of 3/27/17, this was moved to the server/authorization/preloadForShell feature and this function is not used                   
                    this.resource.prototype.getInboxData = function () {
                        var This = this

                        //the server only returns the current user's inbox so prevent confusion when your inbox is returned when this is invoked on anyone other than you
                        if (This._id != $rootScope.user._id) throw new Error('Unable to get other users inbox.')

                        //prevent circular dependency
                        var userResource = Schema.resource('User')
                        var pageResource = Schema.resource('Page')
                        var postResource = Schema.resource('Post')
                        var userQuestionResource = Schema.resource('UserQuestion')
                        var questionResource = Schema.resource('Question')
                        var answerResource = Schema.resource('QuestionAnswer')

                        //return server hit to 
                        return $http.get('/api/user/GetInboxData')
                            .then(function (res) {
                                //patch cache will add to the cache, but not fire itemAdded, if it's not already in the cache
                                res.data.pages.forEach(function (page) {
                                    pageResource.patchCache(new pageResource(page))
                                })
                                res.data.posts.forEach(function (post) {
                                    postResource.patchCache(new pageResource(post))
                                })
                                res.data.userQuestions.forEach(function (userQuestion) {
                                    userQuestionResource.patchCache(new userQuestionResource(userQuestion))
                                })
                                res.data.questions.forEach(function (question) {
                                    questionResource.patchCache(new questionResource(question))
                                })
                                res.data.answers.forEach(function (answer) {
                                    answerResource.patchCache(new answerResource(answer))
                                })
                                return res.data
                            })
                    }

                    this.resource.prototype.HighFive = function () {
                        var This = this
                        window.showDialog({
                            controller: 'NewHighFiveController',
                            controllerAs: 'vm',
                            templateUrl: '/app/alignus/layouts/_shell/dialogs/high-five-dialog.tmpl.html',
                            locals: {
                                options: {
                                    sendTo: This
                                }
                            }
                        })
                    }

                    this.resource.prototype.destroyMyTasks = function () {
                        if (!this.$myTasks || this.$myTasks.length == 0) return;
                        this.$myTasks.splice(0, this.$myTasks.length)
                    }

                    // save the original update function, 'cause we're gonna hook it
                    var originalUpdate = this.resource.prototype.$updateItem

                    // basically:
                    // any attempt to update $rootScope.user will actually fail with
                    // status 413 'request entity too large' because the user has an
                    // enormous amount of "extras" (recent items, etc)
                    // decorating it. occam's razor: let's transparently hook $update
                    // with a function that gets rid of all that stuff, calls
                    // the original update function, then reattaches it all
                    // i chose this because in the future we might want to update $rootScope.user
                    // from more than one place in the code base, so having a single point where
                    // this occurs is ideal
                    this.resource.prototype.$updateItem = function () {
                        var This = this;
                        // if this isn't $rootScope.user, it doesn't have any of that
                        // stuff on it anyways, so just return
                        if (This != $rootScope.user) {
                            return originalUpdate.bind(This)()
                        } else {
                            // clear their recent item cache
                            This.clearRecentItemCache()
                            // these will drop off automatically when we call $update,
                            // as the server removes them. they aren't that big anyways
                            var settings = This.Settings
                            var effPerms = This.EffPerms
                            var organization = This.Organization
                            var ret = originalUpdate.bind(This)()
                            // replace the original promise with a promise to
                            // put all the data back in place after the update call returns
                            //ret.$promise = ret.$promise.then(function(data) {
                            // set all that data back
                            This.Settings = settings
                            This.getSettings()
                            This.EffPerms = effPerms
                            This.Organization = organization
                            //})
                            // return the original value
                            return ret
                        }
                    }

                    socket.on('refreshPermissions', function (permissions) {
                        $rootScope.user.EffPerms = permissions
                    })

                    attachedDocumentManager.manage(this.resource)

                }

                return this.resource
            }], //end of $get

            //-- provider functions are available at application config and are associated with all view runs
            itemSettings: {
                itemViewer: {
                    templateUrl: '/app/structure/users-and-teams/user/detail.tmpl.html',
                    controller: 'UserDetailController',
                    controllerAs: 'vm',
                },
                itemButtons: [
                    {
                        tooltip: 'Message',
                        action: function (item, $event) { item.message() },
                        icon: 'zmdi zmdi-comment-alt'
                    },
                    {
                        tooltip: 'High Five',
                        permissionNeeded: '!item.IsContact',
                        action: function (item, $event) {
                            $mdDialog.show({
                                controller: 'NewHighFiveController',
                                controllerAs: 'vm',
                                templateUrl: '/app/alignus/layouts/_shell/dialogs/high-five-dialog.tmpl.html',
                                locals: {
                                    options: {
                                        sendTo: item
                                    }
                                }
                            })
                        },
                        icon: 'au au-highfive'
                    },
                    
                    {
                        tooltip: 'View Tasks',
                        permissionNeeded: '!item.IsContact',
                        action: function (item, $event) { item.goToUsersTasksView() },
                        icon: 'zmdi zmdi-assignment-account'
                    },
                    {
                        tooltip: 'View Projects',
                        permissionNeeded: '!item.IsContact',
                        action: function (item, $event) { item.goToUsersProjects() },
                        icon: 'au au-project2'
                    },
                    {
                        tooltip: 'View Documents',
                        permissionNeeded: '!item.IsContact',
                        action: function (item, $event) { item.goToUsersDocuments() },
                        icon: 'au au-document'
                    },


                    {
                        tooltip: 'Follow',
                        permissionNeeded: '!item.IsContact',
                        dynamic: '<au-follow-star page="item._id" class="scale userbutton"></au-follow-star>'
                    },
                    {
                        tooltip: 'View Page',
                        permissionNeeded: '!item.IsContact',
                        icon: 'zmdi zmdi-face',
                        action: function (item, $event) {
                            item.visitPageRecentItem()
                        }
                    },
                    {
                        tooltip: 'Reassign Subordinates',
                        permissionNeeded: '$root.user.IsUserAdmin && !item.IsContact && item.hasSubordinates()',
                        action: function (item, $event) {
                            Type.reassignSubordinates([item], $event)
                        },
                        icon: 'au au-reassign'
                    }
                ],
            },
            listSettings: {
                batchActions: {
                    message: {
                        icon: "zmdi zmdi-comment-alt",
                        text: "Send Message",
                        action: function (selected, $event) {
                            var selectedIds = selected.map(function (user) { return user._id })
                            $injector.get('Conversation').NewConversationFull({ members: selectedIds })
                            //conversations.focusChat(chat)
                        },
                        permissionNeeded: '$root.user.EffPerms.Users.CanView'
                    },
                    follow: {
                        icon: "zmdi zmdi-star",
                        text: "Follow Social Pages",
                        action: function (selected, $event) {
                            selected.forEach(function (user) {
                                user.follow()
                            })
                            toast.success('You followed ' + selected.length + ' users!')
                        },
                        permissionNeeded: '$root.user.EffPerms.Users.CanView'
                    },
                    deactivate: {
                        icon: "au au-deactivate",
                        text: "Deactivate Users",
                        action: function (selected, $event) { Type.deactivate(selected, $event) },
                        permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
                    },
                    resetPassword: {
                        icon: "au au-reset-password",
                        text: "Reset Passwords",
                        action: function (selected, $event) { Type.resetPassword(selected, $event) },
                        permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
                    },
                    reassignSubordinates: {
                        icon: "au au-reassign",
                        text: "Reassign Subordinates",
                        action: function (selected, $event) { Type.reassignSubordinates(selected, $event) },
                        permissionNeeded: '!item.hasSubordinates() && $root.user.IsUserAdmin'
                    },
                    changeDepartment: {
                        icon: 'au au-reassign',
                        text: 'Change Department / Location',
                        action: function (selected, $event) {
                            $mdDialog.show({
                                controller: 'BatchChangeDepartmentLocationController',
                                controllerAs: 'vm',
                                templateUrl: '/app/structure/organization-settings/dialogs/batch-change-department-location.tmpl.html',
                                targetEvent: event,
                                locals: {
                                    options: { users: selected }
                                }
                            }).then(function (result) {
                                toast.success(result)
                            })
                        },
                        permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
                    },
                    addToTeam: {
                        icon: 'au au-reassign',
                        text: 'Add to Team',
                        action: function (selected, $event) {
                            $mdDialog.show({
                                controller: 'BatchAddToTeamController',
                                controllerAs: 'vm',
                                templateUrl: '/app/structure/organization-settings/dialogs/batch-add-to-team.tmpl.html',
                                targetEvent: event,
                                locals: {
                                    options: { users: selected }
                                }
                            }).then(function (result) {
                                toast.success(result)
                            })
                        },
                        permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
                    }
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: '$root.user.IsUserAdmin',

                //define what views should be availble for this resource
                viewTypes: ['list', 'cards', 'report', 'connections'],

                connections: {
                    canEdit: function () { return window.$rootScope.user.IsUserAdmin }, //defer execution until route loads
                    relationship: { parentIdProperty: 'ReportsTo', idProperty: '_id' },
                    onParentUpdate: function (node, oldParent) {
                        node.$updateItem()
                        delete oldParent._hasSubordinates
                    }
                },
                emptyTitle: "Select A User",
                emptyDescription: "Pick a user from the left.",
            },

            //Open the add user dialog
            addItem: function ($event) {
                var _licenseText = null
                return window.showDialog({ //you can use window level convenience functions...
                    controller: 'AddItemController',
                    controllerAs: 'vm',
                    templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
                    targetEvent: $event,
                    locals: {
                        itemType: Type,
                        init: function (vm, Schema) {
                            vm.newItem.PermissionPresets = []
                            vm.possiblePermissionPresets = Schema.resource('PermissionPreset').getCache()
                            vm.newItem.$sendAccountInfo = true
                            vm.itemFields.push({ name: '$sendAccountInfo', display: 'Send Account Info' })
                            vm.newItem.IsContact = false
                        },
                        steps: {
                            intro: {
                                text: '<div layout="row" layout-align="start start">' +
                                    '<div flex="70">Welcome to the new user wizard. For Align Us to be most effective, all employees, consultants, and internal associates of your organization should have user accounts. This allows them to participate directly in your organization\'s project tracking and social networking.</br></br>' +
                                    "<span ng-bind-html='vm.steps.intro.licenseText(vm)'></span>" +
                                    '</div>' +
                                    '<div flex="30" class="grow" style="text-align:center;"><img src="https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/add-users.png"></div></div>',
                                //image: "some/file.png",
                                licenseText: function (vm) {
                                    if (_licenseText) return _licenseText
                                    _licenseText = "Checking available licenses. Please wait..."

                                    //we can (should?) get this directly from $root.Organization.OrgSettings.Subscription.UserLicenses
                                    //but perhaps checking the server is better?
                                    window.$rootScope.Organization.getStat("User.AvailableLicenses")
                                        .then(function (res) {
                                            if (res.data.value.remaining < 1) {
                                                _licenseText = "<h3 class='text-dark'>Unfortunately, your organization already has " + res.data.value.activeUsers + " active users, which is your current limit.</h3><br/>Authorized users may deactivate or remove users. Or, better yet, purchase additional licenses for just $1/month from Structure > Organization Settings."
                                                vm.finishing = true
                                            } else {
                                                _licenseText = "Your organization is using " + res.data.value.activeUsers + " of " + res.data.value.licenses + " licenses available.</br> You have <b>" + res.data.value.remaining + " remaining</b>.<br/><br/><span class='introEmphasis'>Click Next to get started.</span>"
                                            }
                                        }, function (err) {
                                            _licenseText = "There was an error retrieving the available licenses. Proceed at your own risk."
                                        })
                                }
                            },
                            typeOrUpload: {
                                type: {
                                    text: "Add a User",
                                    //image: "some/file.png",
                                    fields: ['FirstName', 'LastName', 'Email'],
                                    successText: "You have successfully added the user to your organization."
                                },
                                upload: {
                                    text: "Upload User",
                                    //image: "some/file.png",
                                    example: "https://alignusstatic.s3.amazonaws.com/files/example_users.csv",
                                    successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
                                }
                            },
                            PermissionPresets: {
                                contents: '<h3>Assign Permission Presets.</h3>' +
                                    '<p>Easily apply presets of permissions which define what this user can see and do.</p>' +
                                    '<p>Authorized users can manage these from Structure > Permission Presets.</p>' +
                                    '<div class="padding-30"></div>' +
                                    '<au-groups-list user="vm.newItem" groups="vm.possiblePermissionPresets" direction="row"></au-groups-list>',
                                image: '/assets/images/dialogs/permissions.png'
                            },
                            LetThemKnow: {
                                contents: '<h3>Let them know.</h3>' +
                                    '<p>Would you like to send the user their login information at the completion of this wizard?</p>' +
                                    '<div class="padding-50"></div>' +
                                    '<md-checkbox ng-model="vm.newItem.$sendAccountInfo" aria-label="send account info">' +
                                    '   Email user their account information' +
                                    '</md-checkbox>',
                                image: '/assets/images/dialogs/email.png'
                            }
                        }
                    }
                })
            }, //end of addItem

            //Deactivate a selected set of users.
            deactivate: function (selected, $event) {
                var dialog = window.$mdDialog.confirm({
                    title: "Deactivate Users?",
                    htmlContent: "A deactivated user account can be viewed and edited for informational purposes, but the user will not be able to log ito the account. Are you sure you want to deactivate the selected users?",
                    ok: "Yes - Deactivate",
                    cancel: "Cancel",
                    targetEvent: $event
                })
                window.showDialog(dialog)
                    .then(function () {
                        // they hit "Ok" on the confirmation dialog; perform the batch deactivate
                        var pArray = []

                        selected.forEach(function (user) {
                            var prom = user.setIsActive(false)
                                .then(function (result) {
                                    user.$updateItem()
                                })
                            pArray.push(prom)
                        })
                        window.$q.all(pArray).then(function () {
                            window.toast.success('Successfully deactivated the selected users!')
                        }, function (data) {
                            window.toast.error('Failed to deactivate one or more of the selected users!\n' + data.data.error)
                        })
                    }, function () {
                        // they chose not to deactivate the accounts
                    })
            }, //end of deactivate

            //Reset password.
            resetPassword: function (selected, $event) {
                window.showDialog({
                    controller: 'ResetPasswordsDialogController',
                    controllerAs: 'vm',
                    locals: {
                        users: selected
                    },
                    bindToController: true,
                    templateUrl: '/app/structure/users-and-teams/dialogs/reset-passwords-dialog.tmpl.html',
                    clickOutsideToClose: false,
                    targetEvent: $event
                })
            }, //end of resetPassword

            //Reassign Subordinates
            reassignSubordinates: function (selected, $event) {
                if (selected.length != 1) {
                    toast.error('Please select only one user.')
                    return
                }

                window.showDialog({
                    controller: 'ReassignSubordinatesDialogController',
                    controllerAs: 'vm',
                    locals: {
                        selectedUser: selected[0],
                    },
                    bindToController: true,
                    templateUrl: '/app/structure/users-and-teams/dialogs/reassign-subordinates-dialog.tmpl.html',
                    clickOutsideToClose: false,
                    targetEvent: $event
                }).then(function (result) {
                    $mdDialog.show($mdDialog.alert({
                        title: 'Success',
                        textContent: result.data.modified + ' users were modified.',
                        ok: 'Ok'
                    }))
                }, function (err) {
                    $mdDialog.show($mdDialog.alert({
                        title: 'Error',
                        textContent: httpError.parse(err),
                        ok: 'Ok'
                    }))
                });
            } //end of reassign subordinates

        } //end of Type
        return Type

        //--simple functions become part of the User provider closure but are not exposed as properties, if that's helpful
    } //end of User function


})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
    Resource.$inject = ["itemFields"];
    var resourceName = 'Team'

    var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
    angular.module('app').provider(resourceName, Resource)

    /* @ngInject */
    function Resource(itemFields) {
        this.resource = null

        var Type = {
            name: resourceName,

            //return a resource when injected as ResourceName
            /* @ngInject */
            $get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", "chats", "Schema", "Philosophy", function ($q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager, chats, Schema, Philosophy) {
                if (!this.resource) {
                    this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

                    this.resource.prototype.$section = 'structure'

                    this.resource.prototype.toString = function () {
                        return this.Name
                    }

                    this.resource.getType = function () {
                        return Type
                    }

                    this.resource.prototype.$trackBy = ['Structure', 'Users and Teams']

                    //create $Collection getters
                    PopulateResource.populate(this.resource)

                    this.resource.prototype.addTeamMember = function (text, linkWithUserId) {
                        return $http.post(apiRoute + this._id + "/AddTeamMember", {
                            text: text,
                            linkWithUserId: linkWithUserId
                        })
                    }

                    this.resource.prototype.removeTeamMember = function (entryToRemove) {
                        return $http.post(apiRoute + this._id + "/RemoveTeamMember", {
                            entryToRemove: entryToRemove
                        })
                    }

                    this.resource.prototype.getRawTeamMemberIds = function () {
                        var ids = []
                        for (var i = 0; i < this.Nodes.length; i++) {
                            if (this.Nodes[i].LinkWithUserId) {
                                ids.push(this.Nodes[i].LinkWithUserId)
                            }
                        }
                        return ids
                    }

                    this.resource.prototype.isUserMember = function (userId) {
                        return (this.getRawTeamMemberIds().indexOf(userId) > -1 || this.Owner == userId)
                    }

                    this.resource.prototype.message = function () {
                        $injector.get('Conversation').NewConversationFull({ members: this.getRawTeamMemberIds() })
                    }

                    this.resource.prototype.GetTasks = function () {
                        var members = this.getRawTeamMemberIds()
                        var query = { User__in: members.toString() }
                        return Schema.resource('Task')
                            .query(query)
                            .$httpPromise
                            .then(function (data) {
                                return Schema.resource('Task').getCache(function (task) {
                                    return (members.indexOf(task.User) > -1)
                                })
                            })
                    }

                    //go to team page
                    this.resource.prototype.visit = function () {
                        window.open('/page/' + this._id)
                    }

                    //go to team handbook entries
                    this.resource.prototype.goToHandbook = function () {
                        $state.go('shell.handbook.all-handbooks.handbook.list', { query: this._id })
                    }

                    //open team philosophy as recent item
                    this.resource.prototype.openPhilosophy = function () {
                        Philosophy.getCache({ _id: this._id })[0].open('recent')
                    }

                    //only good for binding expressions where subsequent evaluation (digest) will correct the initial 0 count
					Object.defineProperty(this.resource.prototype, '$Members', {
						get: function () {
							var This = this
							var User = Schema.resource('User')
							
							return This.getRawTeamMemberIds().map(function(id){
								return User.getCache({ _id: id })[0]
							})
						}
                    })
                    
                    this.resource.prototype.onUpdate = function onUpdate(fields){
                        if (fields.indexOf('Nodes') > -1) {
                            this.$MembersDirty = true
                        }
                    }
                }

                attachedDocumentManager.manage(this.resource)

                return this.resource

            }], //end of $get

            //settings for the ItemViewer
            itemSettings: {
                itemViewer: {
                    templateUrl: '/app/structure/users-and-teams/team/item.tmpl.html',
                    controller: 'TeamItemController',
                    controllerAs: 'vm',
                },

                itemButtons: [
                    {
                        tooltip: 'Message',
                        action: function (item, $event) { item.message() },
                        icon: 'zmdi zmdi-comment-alt'
                    }
                ]
            },

            //settings for the ListViewer
            listSettings: {
                batchActions: {
                    message: {
                        icon: "zmdi zmdi-comment-alt",
                        text: "Message team",
                        action: function (selected, $event) {
                            var allUsers = []
                            selected.forEach(function (team) {
                                team.Nodes.filter(function (member) {
                                    if (allUsers.indexOf(member.LinkWithUserId) == -1) {
                                        allUsers.push(member.LinkWithUserId)
                                    }
                                })
                            })
                            $injector.get('Conversation').NewConversationFull({ members: allUsers })
                        },
                        permissionNeeded: '$root.user.EffPerms.Users.CanView'
                    },
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: function (item) {
                    if ($rootScope.user.EffPerms.CanDeleteAll) return true
                    if (item.Owner == $rootScope.user._id) return true
                    return false
                },

                viewTypes: ['list', 'report', 'cards', 'connections'],

                //because the member org-chart is important, limit the width
                maxWidth: '300px',

                connections: itemFields.ParentConnections,

                emptyTitle: "Select a Team",
                emptyDescription: "An item will appear here. Just pick one."
            },

            //addItem
            addItem: function ($event) {
                window.showDialog({
                    controller: 'AddItemController',
                    controllerAs: 'vm',
                    templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
                    targetEvent: $event,
                    locals: {
                        itemType: Type,
                        init: function (vm, Schema) {
                            vm.newItem.Owner = window.$rootScope.user._id
                            vm.reviewTextTransforms = {
                                'Owner': function () {
                                    return $filter('fullNameFilter')(vm.newItem.Owner)
                                }
                            }
                        },
                        steps: {
                            intro: {
                                //image: "some/file.png", // supply a custom bg if desired
                                text: '<div>Teams are a great way to group users together and organize them visually. Align Us supports an unlimited number of teams in your organization. Anyone can create a team and add actual users or simply generic \"nodes\" on an org-chart to express roles/titles/etc.</br><div>' +
                                    '<div layout="row" layout-align="center center" style="text-align: center;">' +
                                    '<div flex="33"><img src="https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/org-chart.png"></div>' +
                                    '<div flex="33"><img src="https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/teams.png"></div>' +
                                    '<div flex="33"><img src="https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/add-users.png"></div></div>' +
                                    '<div layout="row" class="md-caption" style="text-align: center;">' +
                                    '<div class="padding-20" flex="33">Group users together and organize them visually.</div>' +
                                    '<div class="padding-20" flex="33">We support an unlimited number of teams.</div>' +
                                    '<div class="padding-20" flex="33">Anyone can create a team and add actual users.</div></div>',
                                // "<span class='introEmphasis'>Click Next to get started.</span>",
                            },
                            typeOrUpload: {
                                type: {
                                    //image: "some/file.png",  // supply a custom bg if desired
                                    fields: ['Name'], //list fields by name you require the user to fill in
                                    successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
                                },
                                upload: {
                                    //image: "some/file.png",  // supply a custom bg if desired
                                    example: "https://alignusstatic.s3.amazonaws.com/files/example_teams.csv",
                                    successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
                                }
                            }
                        }
                    }
                })
            }

        } //end of Type
        return Type
    }
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Task'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$rootScope", "$cachedResource", "$filter", "$http", "PopulateResource", "Schema", "attachedDocumentManager", "$mdDialog", "$injector", function ($q, $rootScope, $cachedResource, $filter, $http, PopulateResource, Schema, attachedDocumentManager, $mdDialog, $injector) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					var ownResource = this.resource

					this.resource.prototype.$section = 'project'

					this.resource.prototype.toString = function () {
						return this.Title
					}

					this.resource.getType = function () {
						return Type
					}

					this.resource.prototype.Start = function () {
						if (this.IsRunning) return
						this.IsRunning = true

						//optimize for UX - the server does this, too
						this.KanbanState = 'In Progress'

						return this.$updateItem().$promise
					}

					this.resource.prototype.Stop = function () {
						if (!this.IsRunning) return
						this.IsRunning = false
						return this.$updateItem().$promise
					}

					this.resource.prototype.Reassign = function (newUser, plannedStartDate) {
						var This = this
						// reassign the task to the desired user
						This.User = newUser
						if (plannedStartDate) This.PlannedStartDate = plannedStartDate
						return $http.post('/api/task/' + this._id + '/Reassign', { newUser: newUser, plannedStartDate: plannedStartDate })
							.then(function () {
								if (!newUser) delete This.User
								else This.User = newUser._id || newUser
								if (plannedStartDate) This.PlannedStartDate = plannedStartDate
							})
					}

					this.resource.prototype.LinkWithProject = function (newProjectId) {
						var This = this
						if (This.Project == newProjectId) return;
						else {
							This.Project = newProjectId
							return This.$updateItem().$promise
						}
					}

					this.resource.prototype.SetFinished = function (endDate) {
						var This = this
						if (endDate == 'now') endDate = Date.now()

						//optimize UX, the server does this, too
						This.KanbanState = 'Completed'
						This.EndDate = endDate
						var myToDoneTasks = $injector.get('myTaskTracker').myToDoneTasks
						This.UserPriority = myToDoneTasks.length ? myToDoneTasks[myToDoneTasks.length - 1].UserPriority + 1 : 100
					}

					this.resource.prototype.SetPlannedStartDate = function (plannedStartDate, save) {
						this.PlannedStartDate = plannedStartDate
						if (save) return this.$updateItem().$promise
					}

					//override the parent field w/ a function
					this.resource.prototype.Parent = function () {
						if (this.ParentTask) return this.$ParentTask
						if (this.Document) return this.$Document
						if (this.Meeting) return this.$Meeting
						if (this.Project) return this.$Project

						return null
					}

					this.resource.prototype.GetActivity = function () {
						return Schema.resource('ActivityLog').getCache({ Task: this._id }, true)
					}

					// get all tasks for an array containing items of any type(s).
					// created to minimize API hits; most task-bearing items have a
					// .GetTasks() method which hits the server and could be used
					// to obtain the same information, but then you're making one API
					// call per item, which blows. this generates a single 'in' query
					// for each type of item that you're querying.
					this.resource.GetTasksForItems = function (items) {
						var proms = []
						var types = {}
						var currentType
						// walk the list of items
						items.forEach(function (item) {
							currentType = item.$key
							// if we haven't already gotten all the tasks for this type...
							if (!types[currentType]) {
								// ...get every item of this type's guid
								var itemIds = items.filter(function (itemToFilter) {
									return itemToFilter.$key == item.$key
								}).map(function (itemToMap) {
									return itemToMap._id
								})
								// ...construct an 'in' query to feed getCache
								var query = {}
								// node-restful recognizes this query syntax
								query[currentType + '__in'] = itemIds.toString()
								proms.push(Schema.resource('Task').getCache(query, true).$httpPromise)
								types[currentType] = true
							}
						})
						return $q.all(proms)
							.then(function (allTasks) {
								// allTasks is an array of arrays of tasks, so
								// let's flatten that to a single array of tasks
								return [].concat.apply([], allTasks)
							})
					}

					this.resource.prototype.Deactivate = function () {
						this.IsActive = false
						return this.$updateItem().$promise
					}

					var currentUserCanEdit
					this.resource.prototype.CanEdit = function () {
						if (currentUserCanEdit === undefined) {
							currentUserCanEdit = false
							this.userHasAcl('U').then(function (hasPerm) {
								currentUserCanEdit = !!hasPerm
							})
						}

						return currentUserCanEdit
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)

					this.resource.prototype.$trackBy = ['Projects']
				}

				attachedDocumentManager.manage(this.resource)

				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/project/task/detail.tmpl.html',
					controller: 'TaskController',
					controllerAs: 'vm',
				},
				fields: [
					{
						name: 'Parent',
						subheadSortOrder: 1,
						sortDirection: 'asc',
						icon: 'zmdi zmdi-folder',
						display: 'Regarding',
						displayValue: 'Parent().toString()', //for sorting
						displayTemplate: '{{item.Parent().toString()}}' //for render
					}
				],

			},

			//settings for the ListViewer
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					assignToUser: {
						icon: 'au au-reassign',
						text: 'Edit Assignments',
						action: function (selected, $event) {
							var promises = []
							$mdDialog.show({
								controller: 'BatchReassignTasksController',
								controllerAs: 'vm',
								locals: {
									selectedTasks: selected
								},
								bindToController: true,
								templateUrl: '/app/project/dialogs/batch-reassign-tasks.tmpl.html'
							})
								.then(function (res) {
									if (res) $injector.get('toast').success(res)
								})
						},
						permissionNeeded: function (task) {
							return task.CanEdit()
						}
					},
					requestStatusUpdate: {
						icon: 'zmdi zmdi-comment-alt',
						text: 'Request Status Updates',
						action: function (tasks, $event) {
							if (tasks.some(function (task) {
								return task.User != tasks[0].User
							})) {
								// indicate that not all tasks are for the same user
								$mdDialog.show($mdDialog.alert({
									title: 'Error',
									textContent: 'Not all of those tasks are assigned to the same user.',
									ok: 'ok'
								}))
							} else {
								var message = 'Hi {0},<br><br>How\'s it going with'.format(tasks[0].$User.toString())
								var taskHtml = tasks.length == 1 ? ' ' + makeTaskMention(task) + '?<br><br>' : (':<ul>' + tasks.map(function (task) {
									return '<li>' + makeTaskMention(task) + '</li>'
								}).join('') + '</ul>')
								message += taskHtml
							}
							message += 'Thanks, <br>' + $rootScope.user.FirstName
							$injector.get('Conversation').NewConversationFull({ members: [tasks[0].User], message: message, subject: 'Task Update Request' })

							function makeTaskMention(task) {
								return '<span contenteditable="false" class="doc-mention Task selected" data-item-type="Task" data-item-id="{0}" data-cke-filter="off" title="Task">{1}</span>'.format(task._id, task.toString())
							}
						},
						permissionNeeded: function (task) {
							return task.Creator == $rootScope.user._id
						}
					},
					markAsComplete: {
						icon: 'zmdi zmdi-check',
						text: 'Mark as Complete',
						action: function (selected, $event) {
							$mdDialog.show($mdDialog.confirm({
								title: 'Mark as Complete',
								textContent: 'Are you sure you want to mark ' + selected.length + ' Task(s) as completed?',
								ok: 'Do It',
								cancel: 'Cancel',
								targetEvent: $event
							})).then(function () {
								$q.all(selected.map(function (task) {
									task.SetFinished('now')
									return task.$updateItem()
								})).then(function () {
									$injector.get('toast').success('Marked ' + selected.length + ' Tasks complete!')
								})
							})
						},
						permissionNeeded: function (task) {
							return (task.User == $rootScope.user._id)
						}
					},
					deactivate: {
						icon: "zmdi zmdi-power-setting",
						text: "Set as Inactive",
						//wire me up
						action: function (selected, $event) {
							var proms = []
							selected.forEach(function (task) {
								proms.push(task.Deactivate())
							})
							$q.all(proms)
								.then(function () {
									toast.success('Deactivated ' + selected.length + ' tasks!')
								})
						},
						permissionNeeded: function (task) {
							return task.CanEdit()
						}
					}
				},

				//indicate what permission is needed to remove an item
				removePermissionNeeded: function (task) {
					return task.CanEdit()
				},

				viewTypes: ['list', 'cards', 'task-kanban', 'report', 'connections'],

				connections: {
					canEdit: true,
					relationship: { parentIdProperty: 'ParentTask', idProperty: '_id' },
					unassignedMembersText: "Root Tasks",
					noManagedMembersText: "No Hierarchy Found",
					onParentUpdate: function (node, oldParent) {
						$q.all([node.userHasAcl('U'), !oldParent || oldParent.userHasAcl('U'), !node.$Parent || node.$Parent.userHasAcl('U')]).then(function (oks) {
							if (oks[0] && oks[1] && oks[2]) {
								node.$updateItem()
							} else {
								node.Parent = oldParent ? oldParent._id : null
								toast.error('Permission denied. You must have update access to the old and new parents as well as the document you are grouping.')
							}
						})
						node.$updateItem()
					}
				},

				emptyTitle: "Select a Task",
				emptyDescription: "An item will appear here. Just pick one."
			},

			addItem: function ($event) {
				$mdDialog.show({
					controller: 'AddTaskDialog',
					controllerAs: 'vm',
					templateUrl: '/app/project/dialogs/add-task.tmpl.html',
					targetEvent: $event,
					locals: {
						options: {}
					}
				})
			},


		} //end of Type
		return Type
		//--functions below here also become part of the provider closure
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Strategy'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'
				
                    //delete button on detail
                    this.resource.prototype.DeleteMe = function () {
						var This = this
						$mdDialog.show({
							controller: 'RemoveItemDialogController',
							controllerAs: 'vm',
							locals: {
								selectedItems: [This],
								showConfirmationSignature: true
							},
							templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
							clickOutsideToClose: true
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Strategy.CanDeleteAll',
				
				viewTypes: ['list', 'cards', 'report'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			}
		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
(function () {
	angular.module('app').provider('Schema', Schema)

	function Schema() {
		this.resource = null

		return {
			/* @ngInject */
			$get: ["$cachedResource", "$filter", "$http", "$rootScope", "$injector", "$q", function ($cachedResource, $filter, $http, $rootScope, $injector, $q) {
				if (!this.resource) {
					this.resource = $cachedResource('Schema', '/api/schema', { id: "@_id" }, { update: { method: 'PUT' } })

					//return the schema CachedResource for a given name
					this.resource.for = function (resourceName) {
						return this._cache[resourceName]
					}

					//return a CachedResource for a given name
					this.resource.resource = function (resourceName) {
						var r = null
						try {
							r = $injector.get(resourceName)
						} catch (e) { }
						return r
					}
				}

				return this.resource
			}],
			//these functions can be called in config stages
			log: function () {
				//what does this look like?
				console.debug('Schema this is ', this)
			}
		}
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'QuestionTag'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.$section = 'social'

					this.resource.prototype.toString = function () {
						return this.TagText
					}

					this.resource.getType = function () {
						return Type
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
		
					this.resource.prototype.$trackBy = ['Social']
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/questions/questiontag/questiontag.tmpl.html',
					controller: 'QuestionTagController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Users.CanView',
				
				viewTypes: ['list'],
				
				itemButtons: [
					//because Type doesn't exist at the time of compilation, wrap calls in an anonymous function
					{ click: function (item, $event) { console.debug(arguments) }, icon: 'zmdi zmdi-star' },
					{ click: null, icon: 'zmdi zmdi-comment-alt' }
				],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},
		} //end of Type
		return Type
		//--functions below here also become part of the provider closure
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'QuestionAnswer'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "$rootScope", "attachedDocumentManager", function ($q, $cachedResource, $filter, $http, PopulateResource, $rootScope, attachedDocumentManager) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.toString = function () {
						return this.AnswerTitle
					}

					this.resource.getType = function () {
						return Type
					}

					this.resource.prototype.DidCurrentUserFlag = function() {
						var currentUser = $rootScope.user._id
						return (this.FlaggedBy.indexOf(currentUser) > -1)
					}

					this.resource.prototype.Flag = function() {
						var currentUser = $rootScope.user._id
						if(!this.DidCurrentUserFlag()) {
							this.FlaggedBy.push(currentUser)
						}
						return $http.post('/api/questionanswer/' + this._id + '/flag', {})
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
		
					this.resource.prototype.$trackBy = ['Social']
				}

				this.resource.prototype.DidCurrentUserAlreadyVote = function() {
					var currentUser = $rootScope.user._id
					for (var i = 0; i < this.Votes.length; i++) {
						if (this.Votes[i].Voter == currentUser) {
							return true
						}
					}
					return false
				}

				this.resource.prototype.Vote = function(upOrDown) {
					var currentUser = $rootScope.user._id
					if(upOrDown != 1 && upOrDown != -1) {
						return false
					}
					this.Votes.push({
						Voter: currentUser,
						UpOrDown: upOrDown
					})
					this.VoteTotal = this._GetVoteTotal()
					return $http.post('/api/questionanswer/' + this._id + '/vote', { vote: upOrDown })
				}

				this.resource.prototype._GetVoteTotal = function() {
					var runningTotal = 0
					this.Votes.forEach(function(vote) {
						runningTotal += vote.UpOrDown
					})
					return runningTotal
				}

				this.resource.prototype.Comment = function(content) {
					var This = this
					var currentUser = $rootScope.user._id
					This.Comments.push({
						Creator: currentUser,
						Content: content,
						DateCreated: new Date()
					})
					return $http.post('/api/questionanswer/' + this._id + '/comment', { content: content }).then(function(response) {
						// we want to make sure the comment's newly generated ID is present locally
						// so that it can be deleted (answers aren't kept in sync with cache updater so
						// this wouldn't otherwise occur)
						This.Comments.last()._id = response.data.data;
					})
				}

				this.resource.prototype.RemoveComment = function(commentId) {
					var This = this
					This.Comments = This.Comments.filter(function(comment) {
						return comment._id != commentId
					})
					return $http.post('/api/questionanswer/' + This._id + '/removecomment', {commentId: commentId})
				}
				
				this.resource.prototype.CanCurrentUserEdit = function() {
					var currentUser = $rootScope.user._id
					if(this.IsCurrentUserTagModerator()) {return true}
					if($rootScope.user.EffPerms.QnA.Manager) {return true}
					if(currentUser == this.Creator) {return true}
					return false
				}

				// pardon the clutter here; this is called frequently by the UI,
				// so i targeted it for some optimizations.
				var isCurrentUserTagModerator = undefined
				var timesCalled = 0
				this.resource.prototype.IsCurrentUserTagModerator = function() {
					timesCalled++
					if(isCurrentUserTagModerator != undefined && timesCalled < 10) {
						return isCurrentUserTagModerator
					} else {
						timesCalled = 0
					}
					var currentUser = $rootScope.user._id
					for(var i = 0; i < this.$Question.$Tags.length; i++) {
						if(currentUser == this.$Question.$Tags[i].Moderator) {
							isCurrentUserTagModerator = true
							return true
						}
					}
					isCurrentUserTagModerator = false
					return false
				}

				this.resource.prototype.ShouldUIShowAsFlagged = function() {
					return (this.FlaggedBy.length > 0 && this.IsCurrentUserTagModerator())
				}

				attachedDocumentManager.manage(this.resource)

				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/questions/questionanswer/questionanswer.tmpl.html',
					controller: 'QuestionAnswerController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Users.CanView',
				
				viewTypes: ['list', 'cards', 'report'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},
		} //end of Type
		return Type
		//--functions below here also become part of the provider closure
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Question'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "$rootScope", "QuestionTag", "attachedDocumentManager", "$mdDialog", "QuestionAnswer", "$injector", function ($q, $cachedResource, $filter, $http, PopulateResource, $rootScope, QuestionTag, attachedDocumentManager, $mdDialog, QuestionAnswer, $injector) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.$section = 'social'
					this.resource.prototype.$trackBy = ['Social'] //'Structure', 'Organization Settings'

					this.resource.search = function(searchText) {
						return $http.get('/api/question/search?searchText=' + searchText)
					}

					this.resource.getRecentlyAnswered = function() {
						return $http.get('/api/question/recentlyAnswered')
					}

					// this.resource.getFaq = function() {
					// 	return ($http.get('/api/question?IsFAQ=true'))
					// }

					this.resource.prototype.toString = function () {
						return this.QuestionTitle || ""
					}

					this.resource.getType = function () {
						return Type
					}

					this.resource.prototype.SetFaq = function(newIsFaq) {
						this.IsFAQ = newIsFaq
						return $http.post('/api/question/' + this._id + '/SetFaq', {newIsFaq: newIsFaq})
					}

					this.resource.prototype.IsThisUserFollowing = function () {
						var userId = $rootScope.user._id
						return (this.Followers.indexOf(userId) > -1)
					}

					this.resource.prototype.Follow = function() {
						var userId = $rootScope.user._id
						if(!this.IsThisUserFollowing(userId)) {
            				this.Followers.push(userId)
						}
						return $http.post('/api/question/' + this._id + '/follow', {})
					}

					this.resource.prototype.Unfollow = function() {
						var index = this.Followers.indexOf($rootScope.user._id)
						if(index > -1) this.Followers.splice(index, 1)
						return $http.post('/api/question/' + this._id + '/unfollow', {})
					}

					this.resource.prototype.DidCurrentUserFlag = function() {
						var currentUser = $rootScope.user._id
						return (this.FlaggedBy.indexOf(currentUser) > -1)
					}

					this.resource.prototype.Flag = function() {
						var currentUser = $rootScope.user._id
						if(!this.DidCurrentUserFlag()) {
							this.FlaggedBy.push(currentUser)
						}
						return $http.post('/api/question/' + this._id + '/flag', {})
					}

					this.resource.prototype.AcceptAnswer = function(answerId) {
						this.AcceptedAnswer = answerId
						return $http.post('/api/question/' + this._id + '/acceptanswer', {questionAnswer: answerId})
					}

					this.resource.prototype.CanCurrentUserEdit = function() {
						var currentUser = $rootScope.user._id
						if(this.IsCurrentUserTagModerator()) return true
						if($rootScope.user.EffPerms.QnA.Manager) return true
						if(currentUser == this.Creator) return true
						return false
					}

					Object.defineProperty(this.resource.prototype, '$Answers', {
						get: function(){
							var This = this
							if (!This._$Answers || This.$AnswersDirty) {
								This._$Answers = QuestionAnswer.getCache({Question: This._id}, true)
								This.$AnswersDirty = false
							}
							return This._$Answers
						}
					})

					$rootScope.$on('itemRemoved', dirtyAnswers)
					$rootScope.$on('itemUpdated', dirtyAnswers)
					$rootScope.$on('itemAdded', dirtyAnswers)

					function dirtyAnswers(event, item) {
						if(item.$key == 'QuestionAnswer') {
							($injector.get('Question').getCache({_id: item.Question}, false)[0] || {}).$AnswersDirty = true
						}
					}

					// pardon the clutter here; this is called frequently by the UI,
					// so i targeted it for some optimizations.
					var isCurrentUserTagModerator = undefined
					var timesCalled = 0
					this.resource.prototype.IsCurrentUserTagModerator = function() {
						timesCalled++
						if(isCurrentUserTagModerator != undefined && timesCalled < 10) {
							return isCurrentUserTagModerator
						} else {
							timesCalled = 0
						}
						var currentUser = $rootScope.user._id						
						for(var i = 0; i < this.$Tags.length; i++) {
							if(currentUser == this.$Tags[i].Moderator) {
								isCurrentUserTagModerator = true
								return true
							}
						}
						isCurrentUserTagModerator = false
						return false
					}

					this.resource.prototype.ShouldUIShowAsFlagged = function() {
						return (this.FlaggedBy.length > 0 && this.IsCurrentUserTagModerator())
					}

					attachedDocumentManager.manage(this.resource)

					//create $Collection getters
					PopulateResource.populate(this.resource)
		
					this.resource.prototype.$trackBy = ['Social']
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/questions/question/questions.tmpl.html',
					controller: 'QuestionsController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					faq : {
						icon: "zmdi zmdi-star",
						text: "Mark as FAQ",
						action: function (selected, $event) {
							var proms = []
							selected.forEach(function(question) {
								proms.push(question.SetFaq(true))
							})
							$q.all(proms)
							.then(function() {
								toast.success('Successfully marked ' + selected.length + ' ' + (selected.length > 1 ? 'questions' : 'question') + ' as an FAQ.')
							})
						},
						permissionNeeded: function (question) {
							if (question.CanCurrentUserEdit()) return true
						}
					},
					flag : {
						icon: "zmdi zmdi-flag",
						text: "Flag as Inappropriate",
						action: function (selected, $event) {
							var properPlurality = selected.length > 1 ? 'questions' : 'question'
							var confirmDialog = $mdDialog.confirm({
								title: 'Flag as Inappropriate',
								textContent: 'Are you sure you want to flag ' + selected.length + ' ' + ' selected ' + properPlurality + ' as inappropriate?',
								ok: 'Yes',
								cancel: 'Nevermind',
								targetEvent: $event
							})
							$mdDialog.show(confirmDialog)
							.then(function() {
								var proms = []
								selected.forEach(function(question) {
									proms.push(question.Flag())
								})
								return $q.all(proms)
							})
							.then(function() {
								toast.success('Flagged ' + selected.length + ' ' + properPlurality + ' as inappropriate.')
							})
						},
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
					follow: {
						icon: 'zmdi zmdi-alarm-plus',
						text: 'Follow',
						action: function(selected, $event) {
							var followProms = []
							selected.forEach(function(question) {
								followProms.push(question.Follow())
							})
							$q.all(followProms)
							.then(function() {
								window.toast.success('You successfully followed ' + followProms.length + ' questions')
							})
						},
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					}
				},
				
				//user must be Creator, Moderator, or have the permission
				removePermissionNeeded: function (question) {
					if (question.CanCurrentUserEdit()) return true
				},
				
				viewTypes: ['list'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},
		} //end of Type
		return Type
		//--functions below here also become part of the provider closure
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
    Resource.$inject = ["itemFields"];
    var resourceName = 'Project'

    var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
    angular.module('app').provider(resourceName, Resource)

    /* @ngInject */
    function Resource(itemFields) {
        this.resource = null

        var Type = {
            name: resourceName,

            //return a resource when injected as ResourceName
            /* @ngInject */
            $get: ["$q", "$rootScope", "$state", "$mdDialog", "$cachedResource", "$filter", "$http", "$injector", "PopulateResource", "Schema", "attachedDocumentManager", "chats", function ($q, $rootScope, $state, $mdDialog, $cachedResource, $filter, $http, $injector, PopulateResource, Schema, attachedDocumentManager, chats) {
                if (!this.resource) {
                    this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

                    this.resource.prototype.$section = 'project'

                    this.resource.prototype.toString = function () {
                        return this.Title
                    }

                    this.resource.getType = function () {
                        return Type
                    }

                    Object.defineProperty(this.resource.prototype, '$Tasks', {
						get: function(){
							var This = this
                            if (!This._$Tasks || This.$TasksDirty) {
                                var Task = $injector.get('Task')
								This._$Tasks = Task.getCache({Project: This._id}, true)
								This.$TasksDirty = false
							}
							return This._$Tasks
						}
					})

					$rootScope.$on('itemRemoved', dirty$Tasks)
					$rootScope.$on('itemUpdated', dirty$Tasks)
					$rootScope.$on('itemAdded', dirty$Tasks)
					function dirty$Tasks(event, item) {
						if(item.$key == 'Task') {
							($injector.get('Project').getCache({_id: item.Project}, false)[0] || {}).$TasksDirty = true
						}
					}

                    this.resource.prototype.LinkWithTeam = function (teamToLink) {
                        var This = this
                        return $http.post('/api/project/' + this._id + '/LinkWithTeam', { teamToLink: teamToLink })
                            .then(function (response) {
                                This.Members = This.Members.concat(response.data.data)
                                This.Members.forEach(function (member) {
                                    member.toString = function () { return this.Text }
                                    member.toString = member.toString.bind(member)
                                })
                                This.Team = teamToLink
                            })
                    }

                    this.resource.prototype.LinkWithTeamLocal = function (teamToLink) {
                        var This = this,
                            newMembers = [],
                            index = 0

                        if (teamToLink) {
                            var team = Schema.resource('Team').getCache({ _id: teamToLink })[0]

                            if (team) {
                                team.Nodes.map(function (member) {
                                    if (This.Members.findIndex(function (currentMember, index) { if (currentMember.LinkWithUserId == member.LinkWithUserId) return true }) == -1) {
                                        newMembers.push(member)
                                    }
                                })

                                This.Members = This.Members.concat(newMembers)
                                This.Members.forEach(function (member) {
                                    member.toString = function () { return this.Text }
                                    member.toString = member.toString.bind(member)
                                })

                                This.Team = teamToLink
                            }

                        }
                    }

                    this.resource.prototype.GetRawMembers = function () {
                        return this.Members.filter(function (member) {
                            return member.LinkWithUserId
                        }).map(function (member) {
                            return member.LinkWithUserId
                        })
                    }

                    this.resource.prototype.GetRawSharedWith = function () {
                        return this.SharedWith.map(function (user) {
                            return user.toString()
                        })
                    }

                    this.resource.prototype.GetTasks = function () {
                        var This = this
                        return Schema.resource('Task').getCache({ Project: This._id }, true).$httpPromise
                    }

                    this.resource.prototype.message = function () {
                        var toUsers = []
                        this.GetRawMembers().forEach(function (user) {
                            toUsers.push($filter('auItemFilter')(user, 'User'))
                        })
                        $injector.get('Conversation').NewConversationFull({ members: toUsers })
                    }

                    this.resource.prototype.UserIsMember = function (userId) {
                        return (this.GetRawMembers().indexOf(userId) > -1)
                    }

                    this.resource.prototype.UserIsOwner = function (userId) {
                        return userId == this.Owner
                    }

                    this.resource.prototype.UserIsInvolved = function (userId) {
                        return this.UserIsMember(userId) || this.UserIsOwner(userId)
                    }

                    this.resource.prototype.CanEdit = function () {
                        return this.CanUserEdit($rootScope.user._id)
                    }

                    this.resource.prototype.GetDisplayableMembers = function () {
                        return this.Members.map(function (member) {
                            return $filter('fullNameFilter')(member.LinkWithUserId)
                        }).join(', ')
                    }

                    this.resource.prototype.CanUserEdit = function (userId) {
                        return (userId == this.Owner || this.UserIsMember(userId) || $rootScope.user.EffPerms.Projects.CanEditAll)
                    }

                    this.resource.prototype.QueryInvolvedUsers = function () {
                        return Schema.resource('User').query({ '_id__in': (this.GetRawMembers().concat([this.Owner])).toString() }).$httpPromise
                    }

                    this.resource.QueryItemsInvolving = function (userId) {
                        return this.query({
                          Members: {
								'$elemMatch': {
									'LinkWithUserId': userId
								}
							}
                        }).$httpPromise
                    }

                    this.resource.prototype.Deactivate = function () {
                        this.IsActive = false
                        this.$updateItem().$promise
                    }

                    attachedDocumentManager.manage(this.resource)

                    //create $Collection getters
                    PopulateResource.populate(this.resource)

                    this.resource.prototype.$trackBy = ['Projects']
                }

                return this.resource

            }], //end of $get

            //settings for the ItemViewer
            itemSettings: {
                itemViewer: {
                    templateUrl: '/app/project/projects/detail.tmpl.html',
                    controller: 'ProjectController',
                    controllerAs: 'vm',
                },

                fields: [
                    {
                        name: 'Status',
                        primary: true,
                        subheadSortOrder: -1,
                        sortDirection: 'asc',
                        icon: 'zmdi zmdi-accounts',
                        display: 'Status',
                        displayValue: 'LastPercentCompleted', //for sorting
                        displayTemplate: "{{item.CompletedTaskCount}} of {{item.TaskCount}} ({{(item.LastPercentCompleted || 0).toFixed(1)}}%) Tasks Completed" //for render    
                    }
                ],

                itemButtons: [
                    {
                        tooltip: 'Open Tasks in New Window',
                        action: function (item, $event) { 
                            var href = $state.href('shell.project.tasks-for.list', { query: item._id })
                            href += '&shellPeek=true'
                            window.open(href)
                        },
                        icon: 'zmdi zmdi-assignment-check'
                    },
                ]
            },

            //settings for the ListViewer
            listSettings: {
                batchActions: { //put as many batch actions as you want here
                    deactivate: {
                        icon: "zmdi zmdi-power-setting",
                        text: "Set as Inactive",
                        //wire me up
                        action: function (selected, $event) {
                            var proms = []
                            selected.forEach(function (project) {
                                proms.push(project.Deactivate())
                            })
                            $q.all(proms)
                                .then(function () {
                                    toast.success('Deactivated ' + selected.length + ' projects!')
                                })
                        },
                        permissionNeeded: function (project) {
                            return project.UserIsOwner($rootScope.user._id)
                        }
                    },
                    showTasks: {
                        icon: "zmdi zmdi-grid",
                        text: "Show Tasks",
                        action: function (selected, $event) {
                            $state.go('shell.project.tasks-for.list', { items: selected })
                        },
                        permissionNeeded: 'true'
                    },
                    addMembers: {
                        icon: "zmdi zmdi-account-add",
                        text: "Add Members",
                        action: function (selected, $event) {
                            $mdDialog.show({
                                controller: 'BatchAddMembersController',
                                controllerAs: 'vm',
                                templateUrl: '/app/project/dialogs/batch-add-members.tmpl.html',
                                targetEvent: $event,
                                locals: { projects: selected }
                            })
                        },
                        permissionNeeded: 'true'
                    }
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: function (projectItem) {
                    return ($rootScope.user.EffPerms.Projects.CanDeleteAll || projectItem.UserIsOwner($rootScope.user._id))
                },

                viewTypes: ['list', 'report', 'cards', 'connections'],

                connections: itemFields.ParentConnections,

                itemButtons: [
                    //because Type doesn't exist at the time of compilation, wrap calls in an anonymous function
                    {
                        click: function (item, $event) {
                            $state.go('shell.project.tasks-for.list', { items: [item] })
                        }, tooltip: 'Show Tasks', icon: 'zmdi zmdi-grid'
                    }
                ],

                emptyTitle: "Select a Project",
                emptyDescription: "An item will appear here. Just pick one."
            },

            addItem: function ($event) {
                $mdDialog.show({
                    controller: 'AddProjectDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/project/dialogs/add-project.tmpl.html',
                    targetEvent: $event
                })
            }
        } //end of Type
        return Type
        //--functions below here also become part of the provider closure
    }
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
    var resourceName = 'Post'

    var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
    angular.module('app').provider(resourceName, Resource)

    function Resource() {
        this.resource = null

        var Type = {
            name: resourceName,

            //return a resource when injected as ResourceName
            /* @ngInject */
            $get: ["$q", "$cachedResource", "$filter", "$http", "$rootScope", "$injector", "PopulateResource", "attachedDocumentManager", function ($q, $cachedResource, $filter, $http, $rootScope, $injector, PopulateResource, attachedDocumentManager) {
                if (!this.resource) {
                    this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

                    this.resource.prototype.$section = 'social'

                    this.resource.prototype._string = null
                    this.resource.prototype.toString = function () {
                        if (this._placeholder) return "Loading..."
                        if (this.Data && !this._string) {
                            //this will, at least, always be a blank string
                            if (this.Data.Poll)
                                this._string = this.Data.Poll.Question
                            if (this.Data.Event)
                                this._string = this.Data.Event.EventName
                            if (Object.byString(this, "Data.Update.Update"))
                                this._string = this.Data.Update.Update
                            if (Object.byString(this, "Data.Update") || Object.byString(this, "Data.Introduction")) {
                                var updateWithoutImgs = (Object.byString(this, "Data.Update.Update") || this.Data.Update || this.Data.Introduction).replace(/<img([\w\W]+?)[\/]?>/g, ' [an image] ')            
                                var el = angular.element('<div>' + updateWithoutImgs + '</div>')
                                if (el) {                     
                                    this._string = el.text()
                                } else {
                                    this._string = this.Data.Update
                                }
                            }
                            if (this.Data.Document)
                                this._string = this.Data.Document.Title
                        }

                        return this._string
                    }

                    this.resource.getType = function () {
                        return Type
                    }

                    this.resource.prototype.$trackBy = ['Social']

                    this.resource.getPostPointers = function (query, createdBefore, limit) {
                        if (!limit) limit = 300
                        if (!createdBefore) createdBefore = Date.now()
                        return $http.get('/api/post/query', { params: { createdBefore: createdBefore, limit: limit, query: query } })
                    }


                    //instance variable to cache responses for the function below
                    this.resource.prototype.doesCurrentUserLikePost = function () {
                        if (this.$doesCurrentUserLikePost === undefined) {

                            this.$doesCurrentUserLikePost = false

                            for (var i = 0; i < this.Likes.length; i++) {
                                if ($rootScope.user._id == this.Likes[i].User) this.$doesCurrentUserLikePost = true
                            }
                        }

                        return this.$doesCurrentUserLikePost
                    }

                    this.resource.prototype.like = function () {

                        // if they already like the post, don't do anything
                        if (this.doesCurrentUserLikePost()) return $q.resolve(true)
                        else {
                            this.$doesCurrentUserLikePost = true
                            this.Likes.push({ User: $rootScope.user._id, DateCreated: new Date() })
                            return $http.get('/api/post/' + this._id + '/like')
                        }
                    }

                    this.resource.prototype.unlike = function () {
                        this.$doesCurrentUserLikePost = false

                        this.Likes = this.Likes.filter(function (like) {
                            return like.User != $rootScope.user._id
                        })
                        return $http.get('/api/post/' + this._id + '/unlike')
                    }

                    this.resource.prototype.addComment = function (comment) {
                        this.Comments.push(angular.copy(comment))
                        return $http.post('/api/post/' + this._id + '/addComment', comment)
                    }

                    this.resource.prototype.removeComment = function (commentId) {
                        this.Comments = this.Comments.filter(function (comment) {
                            return comment._id != commentId
                        })
                        if (commentId.length != 24) return;
                        return $http.post('/api/post/' + this._id + '/removeComment', { commentId: commentId })
                    }

                    this.resource.prototype.canRemove = function () {
                        var currentUser = $rootScope.user
                        if (this.Creator == currentUser._id) return true
                        if (!this.$Page) return false
                        if (this.$Page.Editors.indexOf(currentUser._id) > -1) return true
                    }

                    this.resource.prototype.pollVoteForResponse = function (response) {
                        var This = this
                        return $http.post('/api/post/' + this._id + '/pollvote', { response: response })
                            .then(function () {
                                var currentUser = $rootScope.user._id
                                var poll = This.Data.Poll
                                for (var i = 0; i < poll.PossibleResponses.length; i++) {
                                    if (poll.PossibleResponses[i].Response == response) {
                                        poll.PossibleResponses[i].ResponseCount++
                                    }
                                }
                                This.pollMarkUserResponded(response)
                            })
                    }

                    this.resource.prototype.pollMarkUserResponded = function (response) {
                        this.Data.Poll.AlreadyResponded.push({
                            User: $rootScope.user._id,
                            VotedFor: response,
                            VotedAt: new Date()
                        })
                    }


                    //create $Collection getters
                    PopulateResource.populate(this.resource)

                    this.resource.prototype.canEdit = function () {
                        if (this.Type == 'SharePost' || this.Type == 'Share') return false
						if (Object.byString(this, "$Page.Editors")) return this.$Page.Editors.indexOf($rootScope.user._id) > -1;
                        return false
                    }

                    this.resource.prototype.filterImgDocuments = function (getImg) {
                        var auUtility = $injector.get('auUtility')
                        return $filter('filter')(this.Documents, function (doc) {
                            if (getImg) {
                                return auUtility.hasImgExtension(doc.Title)
                            } else {
                                return !auUtility.hasImgExtension(doc.Title)
                            }
                        })
                    }
                }

                attachedDocumentManager.manage(this.resource)

                return this.resource

            }], //end of $get

            //settings for the ItemViewer
            itemSettings: {
                itemViewer: {
                    templateUrl: '/app/social/post/detail.tmpl.html',
                    controller: resourceName + 'ItemController',
                    controllerAs: 'vm',
                }
            },

            //settings for the ListViewer 
            listSettings: {
                batchActions: { //put as many batch actions as you want here
                    message: {
                        icon: "zmdi zmdi-comment-alt",
                        text: "Something cool",
                        action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") }
                    },
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: '$root.user.EffPerms.Users.CanView',

                emptyTitle: "Select An Item",
                emptyDescription: "An item will appear here. Just pick one.",

                // viewTypes: ['list', 'cards', 'report']
            },

            //add Item
            addItem: function ($event) {
                var _moreText = null
                window.showDialog({ //you can use window level convenience functions...
                    controller: 'AddItemController',
                    controllerAs: 'vm',
                    templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
                    targetEvent: $event,
                    locals: {
                        itemType: Type,
                        init: function (vm, Schema) {
                            //function required to be present
                        },
                        steps: {
                            intro: {
                                //image: "some/file.png", // supply a custom bg if desired
                                text: "<p>This is a generic Add Post wizard. It's not very useful right now. We'll revisit it when we're ready to specific Post types (events, polls, etc.).</p><p class='dialogEmphasis'>Click next to get started.</p>",
                                moreText: function (vm) {
                                    if (_moreText) return _moreText
                                }
                            },
                            typeOrUpload: {
                                type: {
                                    //image: "some/file.png",  // supply a custom bg if desired
                                    fields: ['Update', 'Page'], //list fields by name you require the user to fill in
                                    successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
                                },
                                upload: {
                                    //image: "some/file.png",  // supply a custom bg if desired
                                    example: "https://alignusstatic.s3.amazonaws.com/files/example_users.csv",
                                    successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
                                }
                            }
                        }
                    }
                })
            } //end of addItem

        } //end of Type
        return Type

        //--functions below here also become part of the provider closure


    }
})();
(function () {

	PopulateResource.$inject = ["$filter", "$q", "Schema"];
    angular.module('app').service('PopulateResource', PopulateResource);

    function PopulateResource($filter, $q, Schema) {
    	var This = this

		this.populate = function(resource){
				//console.info('Populating', resource.$key)

				var schema = Schema.for(resource.$key) 

		        if (!schema.wait) {
		        	create$Fields(schema)
		        } else {
		        	schema.wait.then(function(res){
		        		create$Fields(schema)
					})
		        }
		        
		        function create$Fields(schema) {
					//console.info('Generating $Fields for', resource.$key)
					//console.time('generate ' + resource.$key)
					angular.forEach(schema.fields, function (field) {
						if (field.ref && Schema._cache[field.ref]) {
							    //define the $Property
							    //console.info('Attaching', field.name, 'to', resource.$key)
								Object.defineProperty(resource.prototype, '$' + field.name, {
									enumberable: true,
									get: function () {
										if (this[field.name] == null) return undefined

										//invalidate the cache for this field if the resource changed or the field's value has
										if ((this['$$' + field.name] && this['$$' + field.name]._id && this['$$' + field.name]._id != this[field.name]) || (this.LastModified && this.LastModified.Date && (!this.$$LastModifiedDate || this.$$LastModifiedDate != this.LastModified.Date))) { 
											this['$$' + field.name] = null
										}

										//lazy load the reference
										if (!this['$$' + field.name]) {
											if (field.type == 'Array'){
												var returnVal = [], foundIds = {}
												for (var f = 0; f < this[field.name].length; f++){
													if (!foundIds[this[field.name][f]]) {
														//find the right side
														var ref = Schema.resource(field.ref).getCache({ _id: this[field.name][f] })
														returnVal.push(ref[0])
														foundIds[this[field.name][f]] = true
													}
												}
												this['$$' + field.name] = returnVal
											}

											if (typeof this[field.name] == "string"){
												var ref = Schema.resource(field.ref).getCache({ _id: this[field.name] })
												this['$$' + field.name] = ref[0]
											}

											if (this.LastModified){
												this.$$LastModifiedDate = this.LastModified.Date
											} else {
												this.$$LastModifiedDate = new Date()
											}

										}
										return this['$$' + field.name]
									}

								})
							
						}
					})
					//console.timeEnd('generate ' + resource.$key)
				} // end create$Fields
		}

	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Philosophy'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", function ($q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
                }
                
				attachedDocumentManager.manage(this.resource)
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//philosophies cannot be deleted by the user
				removePermissionNeeded: false,
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			}

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'PermissionPreset'

	var apiRoute = '/api/' + resourceName + '/'
	angular.module('app').provider(resourceName, Resource)

	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//$get functions are available when used as a service/factory
			/* @ngInject */
			$get: ["$q", "$rootScope", "User", "$cachedResource", "$filter", "$http", "toast", "Schema", "PopulateResource", function ($q, $rootScope, User, $cachedResource, $filter, $http, toast, Schema, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.$section = 'structure'

					this.resource.prototype.toString = function () {
						return this.Name
					}

					this.resource.getType = function () {
						return Type
					}

					//add functions for ref fields here
					PopulateResource.populate(this.resource)

					//add and remove members
					this.resource.prototype.addMember = function (userId) {
						var p = $http.post(apiRoute + this._id + '/AddToGroup', {
							userId: userId
						})

						//for really fast UI
						this.$MembersDirty = true
						$rootScope.$broadcast('itemUpdated', this)

						return p
					}
					this.resource.prototype.removeMember = function (userId) {
						var p = $http.post(apiRoute + this._id + '/RemoveFromGroup', {
							userId: userId._id
						})

						//for really fast UI
						this.$MembersDirty = true
						$rootScope.$broadcast('itemUpdated', this)
						
						return p
					}

					//return existing members
					this.resource.prototype.getUsers = function () {
						return $http.get(apiRoute + this._id + '/GetUsersInGroup').then(function (members) {
							return members.data.map(function (user) {
								return new User(user)
							})
						})
					}

					//only good for binding expressions where subsequent evaluation (digest) will correct the initial 0 count
					Object.defineProperty(this.resource.prototype, '$Members', {
						get: function(){
							var This = this

							if (This.$$Members == undefined || This.$MembersDirty) {
								var query = User.query({PermissionPresets__in: [This._id]}, true)
								This.$$Members = query
								query.$httpPromise.then(function(){
									$rootScope.$broadcast('itemUpdated', This)
								})

								This.$MembersDirty = false
							}
	
							return This.$$Members
						}
					})
					
					this.resource.prototype.onUpdate = function onUpdate(fields){
                        if (fields.indexOf('MemberCount') > -1) {
                            this.$MembersDirty = true
                        }
                    }

					// Set/Remove permissions are copy/pasted from User
					this.resource.prototype.removePermission = function (name) {
						return $http.post(apiRoute + this._id + '/RemovePermission', {
							name: name
						})
					}

					this.resource.prototype.setPermission = function (permSet) {
						return $http.post(apiRoute + this._id + '/SetPermission', permSet)
					}

					this.resource.prototype.effectivePermissions = function () {
						return $http.get(apiRoute + this._id + '/EffectivePermissions')
					}
				}

				return this.resource
			}], //end of $get

			//specify what the item viewer looks like
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/structure/permission-presets/detail/detail.tmpl.html',
					controller: 'PermissionPresetDetailController',
					controllerAs: 'vm',
				},
				fields: [
					itemFields.Members
				]
			},

			//define what views are available
			listSettings: {
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.IsUserAdmin',

				viewTypes: ['list', 'cards', 'report'],

				emptyTitle: "Select A Permission Preset",
				emptyDescription: "A permission preset makes it easy to apply consistent permissions to many users."
			},


			//addItem
			addItem: function ($event) {
				window.showDialog({
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//init must be declared
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Permission Presets make it easy to apply consistent sets of permissions to many users. Align Us supports an unlimited number of presets.<br><br><span class='introEmphasis'>Click Next to get started.</span> "
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['Name'],
									successText: "You have successfully added the Permission Preset to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_permission_presets.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							}
						}
					}
				})
			}
		} //end of Type
		return Type
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
    var resourceName = 'Page'

    var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
    angular.module('app').provider(resourceName, Resource)

    function Resource() {
        this.resource = null

        var Type = {
            name: resourceName,

            //return a resource when injected as ResourceName
            /* @ngInject */
            $get: ["$rootScope", "$q", "$cachedResource", "$filter", "$http", "PopulateResource", "Schema", "$window", "toast", "$mdDialog", "socket", "$mdUtil", function ($rootScope, $q, $cachedResource, $filter, $http, PopulateResource, Schema, $window, toast, $mdDialog, socket, $mdUtil) {
                if (!this.resource) {

                    this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } }, function (item) {
                        //called to init an item instance (`new Page()` or `Page.getCache()`)
                        item.$WhosTyping = []

                        //use instance level debounce functions so the debounce is isolate to the instance
                        item.sendStartTyping = debounce(function (pageId) {
                            $rootScope.userIsTypingInChat = true
                            socket.messageRoom('page' + pageId, { startTyping: true })
                        }, 3000, true)
                        item.watchStopTyping = debounce(function (pageId) {
                            $rootScope.userIsTypingInChat = false
                            socket.messageRoom('page' + pageId, { stopTyping: true })
                        }, 3000)

                    })

                    this.resource.prototype.$section = 'social'

                    this.resource.prototype.toString = function (suppressPrefix) {
                        if (this.Title == '##1:1##') {
                            if (this.Members.length != 2) return "1:1"
                            if (this.Members[0] == $rootScope.user._id) return (suppressPrefix ? '' : 'Chat with ') + this.$Members[1].toString()
                            else return (suppressPrefix ? '' : 'Chat with ') + this.$Members[0].toString()
                        } else if (this.Title == '##AlLinus##') {
                            return 'Notifications from Al Linus'
                        } else if (this.Type == 'User') {
                            return (suppressPrefix ? '' : 'Page for ') + this.Title
                        } else {
                            return this.Title
                        }
                    }

                    this.resource.getType = function () {
                        return Type
                    }

                    this.resource.FindByUrlField = "Title"
                    this.resource.prototype.$trackBy = ['Social', 'Pages']

                    this.resource.prototype.GetCoverPhotoUrl = function () {
                        if (this.CoverPhoto) {
                            return window.$injector.get('auUtility').s3UrlFromId(this.CoverPhoto)
                        } else {
                            return this.CoverPhotoUrl
                        }
                    }

                    this.resource.prototype.Unfollow = function () {
                        var This = this
                        var retPromise = $http.post(apiRoute + this._id + '/unfollow')
                        retPromise.then(function () {
                            var indexCurrentUser = This.Followers.map(function (follower) {
                                return follower.User
                            }).indexOf($rootScope.user._id)
                            This.Followers.splice(indexCurrentUser, 1)
                        })
                        return retPromise
                    }

                    this.resource.prototype.Follow = function () {
                        var This = this
                        retPromise = $http.post(apiRoute + this._id + '/follow')
                        retPromise.then(function () {
                            This.Followers.push({
                                User: $rootScope.user._id,
                                StartedFollowingDate: new Date()
                            })
                        })
                        return retPromise
                    }

                    this.resource.prototype.CanUserDelete = function (userId) {
                        // per current spec, profile pages and conversations cannot be deleted
                        // org page should never be deleted
                        if (this.Type == 'User' || this.Type == 'Conversation' || this.Type == 'Organization') return false;
                        else return this.IsUserOwner(userId)
                    }

                    this.resource.prototype.IsUserEditor = function (userId) {
                        return ($rootScope.user.EffPerms.Pages.CanEditAll || this.IsUserOwner(userId) || this.Editors.indexOf(userId) > -1)
                    }

                    this.resource.prototype.IsUserMember = function (userId) {
                        return this.Members.concat(this.Editors).concat([this.Owner]).indexOf(userId) != -1
                    }

                    this.resource.prototype.ListAllMembers = function () {
                        var allMembers = this.Members.concat(this.Editors).concat([this.Owner]).concat(this.SharedWith)
                        var memberNames = []
                        allMembers.forEach(function (member) {
                            if (memberNames.indexOf($filter('firstNameFilter')(member)) == -1) {
                                memberNames.push($filter('firstNameFilter')(member))
                            }
                        })
                        //get rid of any blanks
                        if (memberNames.indexOf('') > -1) memberNames.splice(memberNames.indexOf(''), 1)
                        //use the word 'and' for two members, otherwise use commas
                        if (memberNames.length == 2) return (memberNames[0].toString() + ' and ' + memberNames[1].toString())
                        else return memberNames.join(", ").toString()
                    }

                    this.resource.prototype.GenerateAboutWidget = function () {
                        this.SideBarWidgets.unshift({
                            Type: 'au-page-about',
                            Data: {
                                contactUser: this.Owner
                            }
                        })
                        this.$updateItem()
                    }

                    this.resource.prototype.IsUserOwner = function (userId) {
                        return $rootScope.user.EffPerms.Pages.CanEditAll || userId == this.Owner
                    }

                    this.resource.prototype.IsUserFollowing = function (userId) {
                        if (!this.Followers) return false
                        return (this.Followers.filter(function (follower) {
                            return follower.User == userId
                        }).length > 0)
                    }

                    this.resource.prototype.IsCurrentUserFollowing = function () {
                        return this.IsUserFollowing($rootScope.user._id)
                    }

                    this.resource.prototype.ChangeFollowingStatus = function () {
                        if (this.IsCurrentUserFollowing()) {
                            console.debug('Unfollowing')
                            return this.Unfollow()
                        } else {
                            console.debug('Following')
                            return this.Follow()
                        }
                    }

                    this.resource.prototype.Posts = function (params) {
                        return $http.get(apiRoute + this._id + '/posts', { params: params })
                    }

                    this.resource.prototype.IsEvent = function () {
                        return this.Type == 'Event'
                    }

                    this.resource.prototype.EventHasUserResponded = function () {
                        var currentUserId = $rootScope.user._id
                        return (this.Event.Attending.filter(function (response) {
                            return (response.User == currentUserId)
                        }).length >= 1)
                    }

                    this.resource.prototype.EventIsUserAttending = function () {
                        var currentUserId = $rootScope.user._id
                        var userResponse = (this.Event.Attending.filter(function (response) {
                            return (response.User == currentUserId)
                        }))[0]
                        return userResponse ? userResponse.Response : null
                    }

                    this.resource.prototype.EventRespond = function (Response) {
                        $http.post('/api/page/' + this._id + '/eventRespond', { rsvp: Response })
                    }

                    this.resource.prototype.EventDidUserSelect = function (didUserSelect) {
                        var isUserAttending = this.EventIsUserAttending()
                        if (!isUserAttending) return false
                        return (isUserAttending == didUserSelect)
                    }

                    this.resource.prototype.EventGetConfirmedAttendees = function () {
                        var result = (this.Event.Attending.filter(function (response) {
                            return (response.Response == 'Yes')
                        }).map(function (response) {
                            return response.User
                        }))
                        return result
                    }

                    this.resource.prototype.GetPinnedPosts = function () {
                        return Schema.resource('Post').query({ Page: this._id, IsPinned: true }, true).$httpPromise
                    }

                    this.resource.prototype.GetPollPosts = function () {
                        return Schema.resource('Post').query({ Page: this._id, Type: 'Poll' }).$httpPromise
                    }


                    this.resource.prototype.goToMeInTab = function () {
                        $window.open('/social/page/' + this._id, '_blank')
                    }

                    this.resource.prototype.AddX = function (x, users) {
                        return $http.post('/api/page/' + this._id + '/addX', { x: x, users: users })
                    }

                    this.resource.prototype.AddMembers = function (members) {
                        return $http.post('/api/page/' + this._id + '/addMembers', members)
                    }

                    this.resource.prototype.postToPage = function (pageId, $event) {
                        $mdDialog.show({
                            controller: 'PostToPageController',
                            controllerAs: 'vm',
                            templateUrl: '/app/alignus/layouts/_shell/dialogs/post-to-page.tmpl.html',
                            targetEvent: $event,
                            locals: {
                                options: {
                                    page: pageId
                                }
                            }
                        })
                    }

                    this.resource.prototype.sharePage = function (item, $event) {
                        item = [item]
                        $mdDialog.show({
                            controller: 'UniversalShareController',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/universal-share.tmpl.html',
                            targetEvent: $event,
                            locals: {
                                options: {
                                    itemsToShare: item
                                }
                            }
                        })
                    }

                    this.resource.prototype.SendMessage = function (message) {
                        this.MarkPostsRead()

                        var Post = $injector.get('Post')
                        return new Post({
                            Page: this._id,
                            Type: 'Message',
                            Data: {
                                Update: message
                            },
                            ReadBy: [$rootScope.user._id],
                            PageIsEmbedded: this.IsEmbedded,
                            PageType: this.Type
                        }).$saveItem()
                    }

                    //typing status handling -------------------------------
                    //a function to bind to a socket.on, for example
                    this.resource.prototype.handleTypingIndicators = function (message) {
                        console.log('got message for room' + message.room)
                        if (message.from == $rootScope.user._id) return

                        if (message.startTyping) {
                            this.AddWhosTyping(message.from)
                        }

                        if (message.stopTyping) {
                            this.RemoveWhosTyping(message.from)
                        }
                    }

                    this.resource.prototype.SendWhosTyping = function () {
                        this.sendStartTyping(this._id)
                        this.watchStopTyping(this._id)
                    }

                    this.resource.prototype.RemoveWhosTyping = function (userId) {
                        this.$WhosTyping.splice(this.$WhosTyping.indexOf(userId), 1)
                    }

                    this.resource.prototype.AddWhosTyping = function (userId) {
                        if (this.$WhosTyping.indexOf(userId) == -1) {
                            this.$WhosTyping.push(userId)
                        }
                    }

                    this.resource.prototype.MarkPostsRead = function () {
                        //init if needed
                        if (!this.UnreadCounts) this.UnreadCounts = {}

                        //do nothing if nothing to update
                        if (this.UnreadCounts[$rootScope.user._id] == 0) return

                        //update on server
                        $http.post('/api/page/' + this._id + '/markPostsRead', {})

                        //update localcopy ($updateItem will fail for any posts this user did not create)
                        if (!this.UnreadCounts) this.UnreadCounts = {}
                        this.UnreadCounts[$rootScope.user._id] = 0
                        $rootScope.$broadcast('itemUpdated', this)

                        Schema.resource('Post').getCache({ Page: this._id }, false).forEach(function (post) {
                            var i = post.ReadBy.indexOf($rootScope.user._id)
                            if (i == -1) {
                                post.ReadBy.push($rootScope.user._id)
                            }
                        })

                        //refresh the unread count
                        $injector.get('Conversation').updateConversations()
                    }

                    this.resource.PagesIPostedOn = function () {
                        return $http.get('/api/page/pagesIPostedOn')
                            .then(function (response) {
                                return response.data
                            })
                    }

                    this.resource.prototype.HasDefaultConversationTitle = function () {
                        if (this.Members.length != 2) return false
                        var copiedMembers = angular.copy(this.Members)
                        if (copiedMembers.map(function (userId) {
                            return $filter('fullNameFilter')(userId)
                        }).join(', ') == this.Title) {
                            return true
                        }
                        copiedMembers.reverse()
                        if (copiedMembers.map(function (userId) {
                            return $filter('fullNameFilter')(userId)
                        }).join(', ') == this.Title) {
                            return true
                        }
                        return false
                    }

                    this.resource.prototype.Dismiss = function () {
                        var This = this

                        //update local copy for fast UI
                        this.DismissedFor.push($rootScope.user._id)
                        
                        //make the api actually save this due to permissions
                        return $http.get('/api/Page/' + this._id + '/dismiss').then(function(){
                            This.MarkPostsRead()
                        })
                    }

                    this.resource.prototype.Undismiss = function () {
                        $injector.get('Conversation').conversations.push(this)
                        return $http.get('/api/Page/' + this._id + '/undismiss')
                    }

                    this.resource._addXAction = function (x, selectedPages, excludeContacts) {
                        var auUtility = window.$injector.get('auUtility'),
                            xLowerCase = x.toLowerCase(),
                            message = 'Successfully added {0} to all {1} pages!'.format(xLowerCase, selectedPages.length)
                        auUtility
                            .selectUsers(null, null, excludeContacts)
                            .then(function (users) {
                                return auUtility.allWithErrors(
                                    selectedPages.map(function (page) {
                                        return page.AddX(x, users)
                                    }), selectedPages)
                            })
                            .then(function (results) {
                                if (results.successes.length == 0) {
                                    message = 'Could not add {0} to any of the selected pages.'.format(xLowerCase)
                                } else if (results.errors.length > 0) {
                                    message = 'Failed to add {0} to the following {1} pages: {2}{3}'.format(xLowerCase, results.getErrorData().length,
                                        results.getErrorData().map(function (page) {
                                            return page.Title
                                        }).join(', '),
                                        '.')
                                }
                                $mdDialog.show($mdDialog.alert({
                                    title: 'Add {0}'.format(x),
                                    textContent: message,
                                    ok: 'Ok'
                                }))
                            })
                    }

                    //create $Collection getters
                    PopulateResource.populate(this.resource)

                    Object.defineProperty(this.resource.prototype, "$relatedItem", {
                        get: function () {
                            if (!this._relatedItem) {
                                switch (this.Type) {
                                    case "Organization":
                                        this._relatedItem = $rootScope.Organization
                                        break;
                                    case "Location":
                                    case "Department":
                                    case "User":
                                    case "Team":
                                        var relatedItemQuery = Schema.resource(this.Type).getCache({ _id: this._id })
                                        this._relatedItem = relatedItemQuery[0]
                                        // enable calling code to wait on something in the event that
                                        // getCache must make a server hit
                                        this._relatedItem.$httpPromise = relatedItemQuery.$httpPromise
                                        break;
                                    default:
                                        this._relatedItem = null
                                }
                            }
                            return this._relatedItem
                        }
                    });
                }

                return this.resource

            }], //end of $get

            //settings for the ItemViewer
            itemSettings: {
                itemViewer: {
                    templateUrl: '/app/social/page/tmpl.html',
                    controller: resourceName + 'ItemController',
                    controllerAs: 'vm',
                }
            },

            //settings for the ListViewer
            listSettings: {
                batchActions: {
                    managePage: {
                        icon: "zmdi zmdi-edit",
                        text: "Manage Page",
                        action: function (selectedPages, $event) {
                            if (selectedPages.length > 1) {
                                return toast.toast('Sorry. You can only manage one page at a time.')
                            }
                            $mdDialog.show({
                                controller: 'PageWizardDialog',
                                controllerAs: 'vm',
                                templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                                targetEvent: $event,
                                locals: { options: { page: selectedPages[0] } }
                            })
                        },
                        permissionNeeded: function (item) {
                            return item.IsUserEditor($rootScope.user._id)
                        }
                    },
                    addMembers: {
                        icon: "zmdi zmdi-accounts-add",
                        text: "Add Members",
                        action: function (selectedPages, $event) {
                            $injector.get('Page')._addXAction('Members', selectedPages)
                        },
                        permissionNeeded: function (item) {
                            return item.IsUserEditor($rootScope.user._id)
                        }
                    },
                    //should this actually be Share??
                    addViewers: {
                        icon: 'zmdi zmdi-accounts-add',
                        text: 'Add Viewers aka Share',
                        action: function (selectedPages, $event) {
                            $injector.get('Page')._addXAction('Viewers', selectedPages)
                        },
                        permissionNeeded: function (item) {
                            return item.IsUserEditor($rootScope.user._id)
                        }
                    }
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: function (item) {
                    return item.CanUserDelete($rootScope.user._id)
                },

                viewTypes: ['list', 'cards', 'report'],

                itemHeadline: '{{item.toString(true)}}', //supress 'Page For' prefix

                emptyTitle: "Select An Item",
                emptyDescription: "An item will appear here. Just pick one."
            },

            //add Item
            addItem: function ($event) {
                $mdDialog.show({
                    controller: 'PageWizardDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                    targetEvent: null,
                    locals: { options: { pageType: 'General' } }
                })
            }

        } //end of Type
        return Type

        //--functions below here also become part of the provider closure


    }
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Organization'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$rootScope", "$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", "Schema", "Page", function ($rootScope, $q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager, Schema, Page) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { query: { method: 'GET', isArray: false } })

					this.resource.prototype.toString = function () {
						return this.Name
					}

					this.resource.getType = function () {
						return Type
					}
					
					this.resource.prototype.$trackBy = ['Structure', 'Organization Settings']

					//create $Collection getters
					PopulateResource.populate(this.resource)
						
					this.resource.prototype.getStat = function(name){
						return $http.get('/api/getstat/' + name)
					}
					
					this.resource.prototype.getSettings = function(){
						var This = this
						return $http.get('/api/organization/GetSettings').then(function(res) {
							This.Settings = res.data
						})
					}
										
					this.resource.prototype.setSetting = function(setting){
						angular.merge(this.Settings, setting)
						$rootScope.updateNavLinks()
						
						return $http.post("/api/organization/SetSetting", setting)
					}

					this.resource.prototype.getPage = function () {
                        return (Schema.resource('Page').getCache({ _id: this._id })[0])
                    }
				}

				attachedDocumentManager.manage(this.resource)
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/structure/organization-settings/organization/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				itemButtons: [
					{
                        tooltip: 'Quick Post to Page',
                        action: function (item, $event) { 
							$rootScope.postToPage({page: item._id})
						},
                        icon: 'zmdi zmdi-comment-alt'
                    },

				],
			},

			//settings for the ListViewer 
			listSettings: {
				//indicate what permission is needed to remove an item
				removePermissionNeeded: 'never.ever',
				
				viewTypes: ['list', 'report'],
			},
			

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'MeetingFeedbackReason'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "Schema", function ($q, $cachedResource, $filter, $http, PopulateResource, Schema) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					// this.resource.prototype.$trackBy = ['Social', 'MeetingFeedbackReasons']

					this.resource.prototype.toString = function () {
						return (this.GoodText || this.BadText)
					}

					this.resource.getType = function () {
						return Type
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
		
					//expose additional methods available on the api
				
					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
				}
				
				return this.resource

			}], //end of $get YOU NEED A COMMA HERE

			// settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/meetings/detail.tmpl.html',
					controller: 'MeetingController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Users.CanView',
				
				viewTypes: ['list', 'report'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},
			
		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'Meeting'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$rootScope", "$cachedResource", "$filter", "$http", "$mdDialog", "PopulateResource", "Schema", "attachedDocumentManager", function ($q, $rootScope, $cachedResource, $filter, $http, $mdDialog, PopulateResource, Schema, attachedDocumentManager) {
				if (!this.resource) {

					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					//create $Collection getters
					PopulateResource.populate(this.resource)
					this.resource.prototype.$trackBy = ['Social', 'Meetings']
					this.resource.prototype.$section = 'social'
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.getType = function () { return Type }

					this.resource.prototype.RecalculateEstimatedCost = function () {
						var This = this
						return $http.post('/api/meeting/EstimateCost', { Users: this.GetAllAttendees(true), LengthInHours: this.GetLengthInHours() })
							.then(function (response) {
								This.EstimatedCost = response.data.data
							})
					}

					this.resource.prototype.GetLengthInHours = function () {
						return (new Date(this.EndDate) - new Date(this.StartDate)) / (60 * 60 * 1000)
					}

					this.resource.prototype.GetAllAttendees = function (asRawIds) {
						var attendees = this.Attendees
						if (asRawIds) {
							attendees = attendees.map(function (attendee) {
								// return attendee && attendee.User
								return attendee.User
							})
						}
						return attendees
					}

					this.resource.prototype.GetLinkedAttendees = function () {
						return this.GetAllAttendees(true).filter(function (user) {
							// only return user entries that represent a valid
							// object ID
							return (user.length == 24)
						})
					}

					this.resource.prototype.IsUserAttendee = function (userId) {
						// get the raw ids of all attendees and search for userId
						return this.GetAllAttendees(true).indexOf(userId) > 0
					}

					this.resource.prototype.IsUserFacilitator = function (userId) {
						return (this.Creator == $rootScope.user._id || this.GetFacilitators(true).indexOf(userId) > -1)
					}

					this.resource.prototype.CanCurrentUserEdit = function () {
						var currentUser = $rootScope.user
						return (currentUser.EffPerms.Meetings.CanEditAll || this.IsUserFacilitator(currentUser._id))
					}

					this.resource.prototype.UserIsInvolved = function (userId) {
						return (this.Creator == userId || this.IsUserAttendee(userId))
					}

					this.resource.prototype.IsUpcoming = function () {
						var today = new Date()
						today.setHours(0, 0, 0, 0)
						return (new Date(this.StartDate)) >= today
					}

					this.resource.prototype.GetFacilitators = function (asRawIds) {
						var facilitators = this.Attendees.filter(function (attendee) {
							return attendee && attendee.IsFacilitator
						})
						if (asRawIds) {
							facilitators = facilitators.map(function (facilitator) { return facilitator.User })
						}
						return facilitators
					}

					this.resource.prototype.GetRegularAttendees = function (asRawIds) {
						var attendees = this.Attendees.filter(function (attendee) { return attendee && !attendee.IsFacilitator })
						if (asRawIds) {
							attendees = attendees.map(function (attendee) { return attendee.User })
						}
						return attendees
					}

					this.resource.prototype.GetTasks = function () {
						var This = this
						return Schema.resource('Task').getCache({ Meeting: This._id }, true).$httpPromise
					}

					this.resource.prototype.AddAttendee = function (newAttendee) {
						var This = this
						if (!newAttendee.WriteInUser) for (i = 0; i < This.Attendees.length; i++) {
							if (This.Attendees[i].User == newAttendee.User) {
								return {$promise: $q.resolve(true)}
							}
						}

						This.Attendees.push(newAttendee)
					}

					this.resource.prototype.RemoveAttendee = function (attendee) {
						var This = this
						var found = false
						var i
						for (i = 0; i < This.Attendees.length; i++) {
							if (This.Attendees[i]._id == attendee._id) {
								found = true
								break;
							}
						}
						if (found) {
							This.Attendees.splice(i, 1)
						}
					}

					this.resource.prototype.DidUserAttend = function (attendeeId) {
						for (var i = 0; i < this.Attendees.length; i++) {
							if (this.Attendees[i].User == attendeeId && this.Attendees[i].IsPresent) return true;
						}
						return false;
					}

					this.resource.prototype.DidUserGiveFeedback = function (userId) {
						return this.AlreadyGaveFeedback.indexOf(userId) > -1
					}

					this.resource.prototype.GiveFeedback = function (feedback) {
						return $http.post('/api/meeting/' + this._id + '/GiveFeedback', feedback)
					}

					this.resource.prototype.QueryInvolvedUsers = function () {
						var ids = this.GetAllAttendees(true).concat(this.Owner)
						return window.$injector.get('User').query({ '_id__in': ids.toString() }).$httpPromise
					}

					this.resource.QueryItemsInvolving = function (userId) {
						return this.query({
							$or: [{ Creator: userId }, { Attendees: { $elemMatch: { User: userId } } }]
						}).$httpPromise
					}

					//if the meeting is recurring warn the users
					this.resource.prototype._origDelete = this.resource.prototype.DeleteMe
					this.resource.prototype.DeleteMe = function () {
						var This = this
						if (This.RepeatsEvery) $mdDialog.show($mdDialog.confirm({
							title: 'Delete All Future Instances?',
							textContent: 'Deleting a recurring meeting will remove all instances of this meeting scheduled in the future. Past meetings will not be removed.',
							cancel: 'Cancel - Do not delete',
							ok: 'Proceed To Delete'
						})).then(function () {
							This._origDelete()
						})
						else This._origDelete()
					}
				}

				attachedDocumentManager.manage(this.resource)

				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/social/meetings/detail.tmpl.html',
					controller: 'MeetingController',
					controllerAs: 'vm',
				},
				itemButtons: [
					{
						tooltip: 'Attach to Item',
						action: function (item, $event) {
							$mdDialog.show({
								controller: 'EditTopicItemController',
								controllerAs: 'vm',
								bindToController: true,
								templateUrl: '/app/social/dialogs/edit-topic-item.tmpl.html',
								locals: {
									options: { meetings: [item] }
								}
							})
						},
						icon: 'zmdi zmdi-label-alt-outline'
					},

				],
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: {
					//edit topic item
					editTopicItem: {
						icon: "zmdi zmdi-label-alt-outline",
						text: "Edit Topic Item",
						action: function (selected, $event) {
							$mdDialog.show({
								controller: 'EditTopicItemController',
								controllerAs: 'vm',
								bindToController: true,
								templateUrl: '/app/social/dialogs/edit-topic-item.tmpl.html',
								locals: {
									options: { meetings: selected }
								}
							})
						},
						permissionNeeded: function (item) {
							return item.IsUserFacilitator($rootScope.user._id)
						}
					}
				},

				//indicate what permission is needed to remove an item
				removePermissionNeeded: function (meetingItem) {
					return ($rootScope.user.EffPerms.Meetings.CanDeleteAll || meetingItem.Creator == $rootScope.user._id)
				},

				viewTypes: ['list', 'report', 'cards', 'connections'],

				emptyTitle: "Select a Meeting",
				emptyDescription: "An item will appear here. Just pick one.",

				connections: itemFields.ParentConnections
			},

			addItem: function ($event) {
				$mdDialog.show({
					controller: 'AddMeetingDialog',
					controllerAs: 'vm',
					templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
					targetEvent: $event,
					locals: {
						options: null
					}
				})
			}

		} //end of Type
		return Type

		//--functions below here also become part of the provider closure


	}
})();
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'Location'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)
			
	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", "User", function ($q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager, User) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Name }
					this.resource.prototype.$trackBy = ['Structure', 'Organization Settings']
					this.resource.prototype.$section = 'structure'

					//only good for binding expressions where subsequent evaluation (digest) will correct the initial 0 count
					Object.defineProperty(this.resource.prototype, '$Members', {
						get: function () {
							var This = this

							if (This.$$Members == undefined || This.$MembersDirty) {
								var query = User.getCache({ Location: This._id }, true)
								This.$$Members = query
								query.$httpPromise.then(function () {
									$rootScope.$broadcast('itemUpdated', This)
								})

								This.$MembersDirty = false
							}

							return This.$$Members
						}
					})

					this.resource.prototype.onUpdate = function onUpdate(fields) {
						if (fields.indexOf('MemberCount') > -1) {
							this.$MembersDirty = true
						}
					}

				}

				attachedDocumentManager.manage(this.resource)

				return this.resource
			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/structure/organization-settings/location/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [
					itemFields.Members
				],

				itemButtons: [
					{
						tooltip: 'Quick Post to Page',
						action: function (item, $event) {
							$rootScope.postToPage({ page: item._id })
						},
						icon: 'zmdi zmdi-comment-alt'
					},
					{
						tooltip: 'Message Members',
						action: function (item, $event) {
							$mdDialog.show({
								controller: 'NewPrivateMessageController',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/new-private-message.tmpl.html',
								locals: {
									options: {groups:  [{ Type: 'Location', Id: item._id, $Display: item.toString(), item: item }]}
								}
							})
						},
						icon: 'zmdi zmdi-comments'
					},

				],
			},

			//settings for the ListViewer
			listSettings: {
				viewTypes: ['list', 'cards', 'report', 'connections'],

				removePermissionNeeded: '$root.user.EffPerms.Locations.CanManage',

				emptyTitle: "Select A Location",
				emptyDescription: "Locations can be buildings, offices, regions or any place else that people work.",

				connections: {
					canEdit: function () { return window.$rootScope.user.EffPerms.Location.CanManage }, //defer execution until route loads
					relationship: { parentIdProperty: 'Parent', idProperty: '_id' },
					unassignedMembersText: "Self-Managing Locations",
					noManagedMembersText: "No Reporting Hierarchy Found",
					onParentUpdate: function (node, oldParent) {
						node.$updateItem()
					}
				},
			},

			//addItem
			addItem: function ($event) {
				window.showDialog({
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//init must be declared
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Locations may represent any place in your organization people work. Typically: buildings, shops, offices, regions, etc. Align Us supports an unlimited number of locations in your organization.<br><br><span class='introEmphasis'>Click Next to get started.</span>"
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['Name'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_locations.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							},
						}
					}
				})
			}
		} //end of Type
		return Type
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'Initiative'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = ['Strategy'] //'Structure', 'Organization Settings'
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/strategy/' + resourceName.toLowerCase() + '/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Ideas wanted",
						action: function (selected, $event) { toast.toast("Please tell us what you'd like to do here!") }
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Initiative.CanDeleteAll',
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				connections: itemFields.ParentConnections,
			
				emptyTitle: "Select an Initiative",
				emptyDescription: "An item will appear here. Just pick one."
			}
		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'HandbookEntryRevision'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					this.resource.prototype.toString = function () {
						return this.$HandbookEntry.Title + ' #' + this.RevisionNumber
					}

					this.resource.getType = function () {
						return Type
					}

					//create $Collection getters
					PopulateResource.populate(this.resource)
		
					//expose additional methods available on the api

				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/handbook/revision/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: function(item){
                    return $root.user.EffPerms.HandbookEntry.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'HandbookEntry'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "auUtility", "PopulateResource", function ($q, $cachedResource, $filter, $http, auUtility, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = ['Handbook'] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//Publish methods calls the API
					this.resource.prototype.Publish = function ($event) {
						var This = this 

						return auUtility.confirm("Publish", "Are you sure you want to publish a new version?", $event).then(function(){
							return $http.post('/api/handbookentry/' + This._id + '/Publish')
							.then(function(){
								toast.success(This.Title + ' was successfully published!')
							}).catch(function(err){
								toast.error(err)
							})
						})
					}

					//delete button on detail
					this.resource.prototype.DeleteMe = function () {
						var This = this
						$mdDialog.show({
							controller: 'RemoveItemDialogController',
							controllerAs: 'vm',
							locals: {
								selectedItems: [This],
								showConfirmationSignature: true
							},
							templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
							clickOutsideToClose: true
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/handbook/' + resourceName.toLowerCase() + '/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				itemButtons: [
					{
						tooltip: 'Publish as New Version',
						dynamic: '<md-button ng-click=\'item.Publish($event)\'><md-icon md-font-icon="zmdi zmdi-rss"></md-icon>Publish</md-button>',
						permissionNeeded: function(item){
							return item.userHasPermission('U')
						}
					},

				],
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "In development",
						action: function (selected, $event) { toast.toast("Please let us know what would be useful to do here!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: function(item){
                    return $rootScope.user.EffPerms.HandbookEntry.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Handbook'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", function ($q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//call addEntry api
					this.resource.prototype.addEntry = function (title) {
						var This = this 
						$http.post(apiRoute + This._id + '/addEntry', {title: title})
					}

					//delete button on detail
					this.resource.prototype.DeleteMe = function () {
						var This = this
						$mdDialog.show({
							controller: 'RemoveItemDialogController',
							controllerAs: 'vm',
							locals: {
								selectedItems: [This],
								showConfirmationSignature: true
							},
							templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
							clickOutsideToClose: true
						})
					}
				}
				
				attachedDocumentManager.manage(this.resource)
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/detail.tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					// message : {
					// 	icon: "zmdi zmdi-comment-alt",
					// 	text: "Something cool",
					// 	action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
					// 	permissionNeeded: '$root.user.EffPerms.Users.CanView'
					// },
				},
				
				removePermissionNeeded: function(item){
					//handbooks linked to an item cannot be deleted by the user
					var handbookTypes = ['Team', 'Department', 'Location', 'Organization']
					if (handbookTypes.indexOf(item.Type)) return false
					//stand alone handbooks can be deleted by the creator
					else return $root.user.EffPerms.Handbook.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],
				
				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},

			addItem: function ($event) {
                $mdDialog.show({
                    controller: 'AddHandbookDialog',
                    controllerAs: 'vm',
                    templateUrl: '/app/handbook/dialogs/add-handbook.tmpl.html',
                    targetEvent: $event
                })
            }
		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'FundraiserParticipant'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/fundraiser/participant/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [],

				itemButtions: []
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item -- shouldn't this just always ask the .hasPermission('D')
				removePermissionNeeded: function(item){
                    return $rootScope.user.EffPerms.Fundraiser.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select an item",
				emptyDescription: "Just pick one."
			},
			
			//add Item
			addItem: function($event){
				var _moreText = null
				window.showDialog({ //you can use window level convenience functions...
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//EXAMPLES OF WHAT YOU CAN DO WHEN THE DIALOG OPENS/INITIALIZES
							vm.newItem.property = [] //init a property on vm.newItem
							vm.possiblePermissionPresets = Schema.resource('PermissionPreset').getCache() //query any collection and put values on vm
							vm.newItem.$sendAccountInfo = true //add additional fields to newItem with default values
							vm.itemFields.push({ name: '$sendAccountInfo', display: 'Send Account Info' }) //format additional field on "revew"
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Click next to get started and select if you'll type in a single item or upload a list.<span ng-bind-html='vm.steps.intro.moreText(vm)'></span>",
								moreText: function (vm) {
									if (_moreText) return _moreText
									_moreText = "Checking stat. Please wait..."

									window.$rootScope.Organization.getStat("User.AvailableLicenses")
										.then(function (res) {
											_moreText = "The stat is " + JSON.toString(res.data)		
										}, function (err) { 
											_moreText = "There was an error retrieving the stat. Proceed at your own risk."
										})
								}
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['FirstName', 'LastName', 'Email'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_users.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							},
							//add additional steps by creating a key that is not an existing step and inlining the template. if you don't need additional steps, just remove these.
							PermissionPresets: {
								contents: '<h3>Assign Permission Presets.</h3>' +
								'<p>Easily apply presets of permissions which define what what this user can see and do.</p>' +
								'<p>Authorized users can manage these from Structure > Permission Presets.</p>' +
								'<div class="padding-30"></div>' +
								'<au-groups-list user="vm.newItem" groups="vm.possiblePermissionPresets" direction="row"></au-groups-list>',
								image: '/assets/images/dialogs/permissions.png'},
							LetThemKnow: {contents: '<h3>Let them know.</h3>' +
								'<p>Would you like to send the user their login information at the completion of this wizard?</p>' +
								'<div class="padding-50"></div>' +
								'<md-checkbox ng-model="vm.newItem.$sendAccountInfo" aria-label="send account info">' +
								'   Email user their account information' +
								'</md-checkbox>',
								image: '/assets/images/dialogs/email.png'}
						}
					}
				})				
			}//end of addItem

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'FundraiserOrder'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = ['Fundraiser'] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [],

				itemButtions: []
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item -- shouldn't this just always ask the .hasPermission('D')
				removePermissionNeeded: function(item){
                    return $rootScope.user.EffPerms.Fundraiser.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select an item",
				emptyDescription: "Just pick one."
			},
			
			//add Item
			addItem: function($event){
				var _moreText = null
				window.showDialog({ //you can use window level convenience functions...
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//EXAMPLES OF WHAT YOU CAN DO WHEN THE DIALOG OPENS/INITIALIZES
							vm.newItem.property = [] //init a property on vm.newItem
							vm.possiblePermissionPresets = Schema.resource('PermissionPreset').getCache() //query any collection and put values on vm
							vm.newItem.$sendAccountInfo = true //add additional fields to newItem with default values
							vm.itemFields.push({ name: '$sendAccountInfo', display: 'Send Account Info' }) //format additional field on "revew"
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Click next to get started and select if you'll type in a single item or upload a list.<span ng-bind-html='vm.steps.intro.moreText(vm)'></span>",
								moreText: function (vm) {
									if (_moreText) return _moreText
									_moreText = "Checking stat. Please wait..."

									window.$rootScope.Organization.getStat("User.AvailableLicenses")
										.then(function (res) {
											_moreText = "The stat is " + JSON.toString(res.data)		
										}, function (err) { 
											_moreText = "There was an error retrieving the stat. Proceed at your own risk."
										})
								}
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['FirstName', 'LastName', 'Email'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_users.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							},
							//add additional steps by creating a key that is not an existing step and inlining the template. if you don't need additional steps, just remove these.
							PermissionPresets: {
								contents: '<h3>Assign Permission Presets.</h3>' +
								'<p>Easily apply presets of permissions which define what what this user can see and do.</p>' +
								'<p>Authorized users can manage these from Structure > Permission Presets.</p>' +
								'<div class="padding-30"></div>' +
								'<au-groups-list user="vm.newItem" groups="vm.possiblePermissionPresets" direction="row"></au-groups-list>',
								image: '/assets/images/dialogs/permissions.png'},
							LetThemKnow: {contents: '<h3>Let them know.</h3>' +
								'<p>Would you like to send the user their login information at the completion of this wizard?</p>' +
								'<div class="padding-50"></div>' +
								'<md-checkbox ng-model="vm.newItem.$sendAccountInfo" aria-label="send account info">' +
								'   Email user their account information' +
								'</md-checkbox>',
								image: '/assets/images/dialogs/email.png'}
						}
					}
				})				
			}//end of addItem

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Fundraiser'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'

					this.resource.prototype.setParticipantToken = function (token) {
						window.localStorage.setItem('participantToken' + this._id, token)
					}
			
					this.resource.prototype.getParticipantToken = function () {
						return window.localStorage.getItem('participantToken' + this._id)
					}

					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [],

				itemButtions: []
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: '$root.user.EffPerms.Users.CanView',
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},
			
			//add Item
			addItem: function($event){
				var _moreText = null
				window.showDialog({ //you can use window level convenience functions...
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							vm.newItem.OwnedBy = [{DocId: $rootScope.user._id, Type: 'User', Note: 'Created Fundraiser'}]
						},
						steps: {
							intro: {
								text: "Click next to create a new Fundraiser. Let's raise some funding!"
							},
							typeOrUpload: {
								type: {
									fields: ['Title'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: false
							}
						}
					}
				})				
			}//end of addItem

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'Eventable'

	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//required but never called
			$get: function () {
				console.error('No instance of ' + resourceName)
			}, //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl:function($stateParams){
						var Schema = $injector.get('Schema')
						var Type = Schema.resource($stateParams.item.$key).getType()

						return Type.itemSettings.itemViewer.templateUrl
					},
					controllerProvider: function($stateParams){
						var Schema = $injector.get('Schema')
						var Type = Schema.resource($stateParams.item.$key).getType()
						
						return Type.itemSettings.itemViewer.controller
					}, 
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer 
			listSettings: {
				get batchActions() {
					//possibly... we could get all selected items, if they are all the same, return their batch actions...
					return {} //for now, return no actions
				},
				
				//indicate what permission is needed to remove an item
				removePermissionNeeded: function(item) {
					var Schema = $injector.get('Schema')
					var Type = Schema.resource(item.$key).getType()

					return Type.listSettings.removePermissionNeeded;
				},
				
				viewTypes: ['list', 'cards', 'report'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one."
			},

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'Document'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "$rootScope", "Schema", function ($q, $cachedResource, $filter, $http, PopulateResource, $rootScope, Schema) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$section = 'documents'
					this.resource.prototype.$trackBy = ['Documents']

					// task parent interface
					this.resource.prototype.GetTasks = function () {
						var This = this
						return Schema.resource('Task').getCache({ Document: This._id }).$httpPromise
					}
				}

				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				}
			},

			//settings for the ListViewer
			listSettings: {
				batchActions: { //put as many batch actions as you want here
				},

				//indicate what permission is needed to remove an item
				removePermissionNeeded: function (item) {
					if ($rootScope.user.EffPerms.SysAdmin) return true
					if (item.Owner == $rootScope.user._id) return true
					return false
				},

				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select An Item",
				emptyDescription: "An item will appear here. Just pick one.",

				connections: itemFields.ParentConnections,
			},

			//add Item
			addItem: function ($event) {
				$mdDialog.show({
					controller: 'AddDocumentDialog',
					controllerAs: 'vm',
					templateUrl: '/app/document/dialogs/add-doc.tmpl.html',
					targetEvent: $event
				})
			}

		} //end of Type
		return Type

		//--functions below here also become part of the provider closure


	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	Resource.$inject = ["itemFields"];
	var resourceName = 'Department'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	/* @ngInject */
	function Resource(itemFields) {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", "attachedDocumentManager", "Philosophy", "User", function ($q, $cachedResource, $filter, $http, PopulateResource, attachedDocumentManager, Philosophy, User) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Name }
					this.resource.prototype.$trackBy = ['Structure', 'Organization Settings']
					this.resource.prototype.$section = 'structure'

					//only good for binding expressions where subsequent evaluation (digest) will correct the initial 0 count
					Object.defineProperty(this.resource.prototype, '$Members', {
						get: function () {
							var This = this

							if (This.$$Members == undefined || This.$MembersDirty) {
								var query = User.getCache({ Department: This._id }, true)
								This.$$Members = query
								query.$httpPromise.then(function () {
									$rootScope.$broadcast('itemUpdated', This)
								})

								This.$MembersDirty = false
							}

							return This.$$Members
						}
					})

                    this.resource.prototype.onUpdate = function onUpdate(fields){
                        if (fields.indexOf('MemberCount') > -1) {
                            this.$MembersDirty = true
                        }
                    }

				}

				attachedDocumentManager.manage(this.resource)



				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/structure/organization-settings/department/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [
					itemFields.Members
				],

				itemButtons: [
					{
						tooltip: 'Quick Post to Page',
						action: function (item, $event) {
							$rootScope.postToPage({ page: item._id })
						},
						icon: 'zmdi zmdi-comment-alt'
					},
					{
						tooltip: 'Message Members',
						action: function (item, $event) {
							$mdDialog.show({
								controller: 'NewPrivateMessageController',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/new-private-message.tmpl.html',
								locals: {
									options: {groups:  [{ Type: 'Department', Id: item._id, $Display: item.toString(), item: item }]}
								}
							})
						},
						icon: 'zmdi zmdi-comments'
					},

				],
			},

			//settings for the ListViewer
			listSettings: {
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select A Department",
				emptyDescription: "A Department will appear here. Just pick one.",

				removePermissionNeeded: '$root.user.EffPerms.Departments.CanManage',

				connections: {
					canEdit: function () { return window.$rootScope.user.EffPerms.Department.CanManage },
					relationship: { parentIdProperty: 'Parent', idProperty: '_id' },
					unassignedMembersText: "Self-Managing Departments",
					noManagedMembersText: "No Reporting Hierarchy Found",
					onParentUpdate: function (node, oldParent) {
						node.$updateItem()
					}
				},
			},

			//add Item
			addItem: function ($event) {
				window.showDialog({ //you can use window level convenience functions...
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//must be defined
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Departments group people in your organization by function. Typically: finance, sales, human resources, etc. Align Us supports an unlimited number of departments in your organization.<br><br><span class='introEmphasis'>Click Next to get started.</span>"
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['Name'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_departments.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							}
						}
					}
				})
			}//end of addItem

		} //end of Type
		return Type

		//--functions below here also become part of the provider closure


	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
    var resourceName = 'Conversation'

    angular.module('app').provider(resourceName, Resource)

    function Resource() {
        this.resource = null

        var Type = {
            name: resourceName,

            /* @ngInject */
            $get: ["$injector", "$q", "$rootScope", "$mdDialog", "socket", "$filter", "$timeout", function ($injector, $q, $rootScope, $mdDialog, socket, $filter, $timeout) {
                if (!this.resource) {
                    // <.<"
                    this.resource = {
                        getCache: function (query) {
                            var Page = $injector.get('Page')
                            return Page.getCache(query)
                        }
                    }
                    var conversationResource = this.resource
                    conversationResource.conversations = []

                    //avoid circular dependencies
                    var Page = $injector.get('Page')
                    var Post = $injector.get('Post')
                    var User = $injector.get('User')
                    var UserQuestion = $injector.get('UserQuestion')

                    $rootScope.$on('itemRemoved', processItemEvent)
                    $rootScope.$on('itemAdded', processItemEvent)
                    $rootScope.$on('itemUpdated', processItemEvent)
                    function processItemEvent(event, item) {
                        //during browser reload, the itemUpdated event may be fired so ignore that until the localCache is ready
                        if (!window.localCacheReady) return

                        switch (true) {
                            case item.$key == 'Page' && event.name == 'itemRemoved': //page was deleted
                            case item.$key == 'Page' && isConversiblePage(item): //page added/updated
                            case item.$key == 'Question': //new question or question updated
                                conversationResource.updateConversations()
                        }
                    }

                    function isConversiblePage(page, idx, arr, includeDismissed) {
                        //don't show if the user is not a member/editor
                        var pageUsers = (page.Members || []).concat(page.Editors || [])
                        if (pageUsers.indexOf($rootScope.user._id) < 0) return false

                        //don't show if the user dismissed the page
                        if (page.DismissedFor && page.DismissedFor.indexOf($rootScope.user._id) != -1) return !!includeDismissed

                        //show all conversations (even those w/ no posts)
                        if (page.Type == 'Conversation') return true

                        //show discussion boards w/ at least one post
                        if ((page.Type == 'Discussion' || page.IsEmbedded) && page.PostCount > 0) return true

                        //else the page should not be in our inbox
                        return false
                    }
                    conversationResource.isConversiblePage = isConversiblePage

                    //update the .conversations array
                    conversationResource.updateConversations = function () {
                        console.debug('starting updateConversations')
                        console.time('finished updateConversations')
                        //process the data in cache - shell does the initial population on connect/re-connect

                        var conversations = Page.getCache(isConversiblePage, false)
                        conversations.forEach(function (page) {
                            var fromUserText = ''
                            // decorate last message
                            if (page.LastPostUser) {
                                if (page.LastPostUser == $rootScope.user._id) page.$fromUserText = "You said: "
                                else if (page.LastPostUser == '000000000000000000000000') page.$fromUserText = "Al says: "
                                else page.$fromUserText = page.$LastPostUser.FirstName + " says: "
                            }

                            if (page.Title == '##1:1##' && !page.$StringMembers) {
                                // add stringified Members field for list viewer searching
                                page.$StringMembers = page.Members.map(function (memberId) {
                                    return $filter('fullNameFilter')(memberId)
                                }).toString()
                            }
                        })

                        //todo - if we dismiss a 1:1 and then click to chat, we get two conversations.
                        var usersIHaventChattedWith = User.getCache(function (user) {
                            // never return ourself
                            if (user._id == $rootScope.user._id) {
                                return false
                            }

                            // return users we don't have a 1:1 message with -- this will, eventually, fail to scale after, guessing, 100s of users are added, would we really want to Click To Chat will all of them?
                            if (Page.getCache(function (conversation) {
                                return conversation.Type == 'Conversation' && conversation.Title == '##1:1##' && conversation.Members.length == 2 && conversation.Members.indexOf(user._id) > -1
                            }, false).length == 0) {
                                user.UnreadCounts = {}
                                user.LastPostDate = 0
                                user.LastPostText = "Click to chat"
                                return user
                            }
                        }, false)

                        var userQuestions = UserQuestion.getCache(false)

                        var questions = userQuestions.map(function (userQuestion) {
                            return userQuestion.$Question
                        }).filter(function (question) {
                            //do not show if: (on the server: the question was sent to the user over 30 days ago or there is an accepted answer)
                            //do not show if: the user submitted an answer, comment or upvote (just a downvote doesn't get it out of their inbox)

                            var answers = question.$Answers
                            var answerUsers = [], commentUsers = [], upvoteUsers = []

                            answers.forEach(function (answer) {
                                answerUsers = answerUsers.concat(answer.Creator)

                                commentUsers = commentUsers.concat(answer.Comments.map(function (comment) {
                                    return comment.Creator
                                }))

                                upvoteUsers = upvoteUsers.concat(answer.Votes.filter(function (vote) {
                                    return vote.UpOrDown == 1
                                }).map(function (vote) {
                                    return vote.Voter
                                }))
                            })

                            if (answerUsers.indexOf($rootScope.user._id) > -1 || commentUsers.indexOf($rootScope.user._id) > -1 || upvoteUsers.indexOf($rootScope.user._id) > -1) {
                                return false
                            }

                            question.UnreadCounts = {}
                            question.LastPostDate = question.DateCreated
                            question.LastPostText = "Click to view"

                            return true
                        })

                        conversationResource.TotalUnreadPosts = 0

                        //without assigning a new reference, empty and then fill the conversations array
                        conversationResource.conversations.splice(0, conversationResource.conversations.length)

                        conversations.concat(usersIHaventChattedWith).concat(questions).forEach(function (c) {
                            //tally the unread post count
                            if (c.UnreadCounts)
                                conversationResource.TotalUnreadPosts += c.UnreadCounts[$rootScope.user._id] || 0

                            conversationResource.conversations.push(c)
                        })

                        //update the list viewer if the user is looking at it
                        if ($state.current.name.startsWith("shell.social.messages.list")) {
                            $rootScope.$broadcast('list.updateListItems', conversationResource.conversations)
                        }

                        console.timeEnd('finished updateConversations')
                    }

                    conversationResource.NewConversation = function (initialUsers, title) {
                        var auUtility = $injector.get('auUtility')
                        var fullNameFilter = $filter('fullNameFilter')
                        var getUsers

                        if (initialUsers) {
                            getUsers = $q.resolve(initialUsers)
                        } else {
                            getUsers = auUtility.selectUsers('New Conversation')
                        }

                        return getUsers
                            .then(function (selectedUsers) {
                                selectedUsers.push($rootScope.user._id)

                                if (!title) title = selectedUsers.map(function (userId) {
                                    return fullNameFilter(userId)
                                }).join(', ')

                                // make Conversation
                                return new Page({
                                    Type: 'Conversation',
                                    Members: selectedUsers,
                                    Title: title
                                }).$saveItem()
                            })
                    }

                    conversationResource.NewConversationFull = function (options) {
                        $mdDialog.show({
                            controller: 'NewPrivateMessageController',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/new-private-message.tmpl.html',
                            locals: {
                                options: options || {}
                            }
                        })
                    }

                    conversationResource.RemoveConversation = function (conversationId) {
                        for (var i = 0; i < conversationResource.conversations.length; i++) {
                            if (conversationResource.conversations[i]._id == conversationId) {
                                var removedConversation = conversationResource.conversations[i]
                                conversationResource.conversations.splice(i, 1)
                                break;
                            }
                        }
                    }

                } //end if !resource
                return conversationResource
            }], //end of $get

            //settings for the ItemViewer
            itemSettings: {
                itemViewer: {
                    templateUrl: function ($stateParams) {
                        var Schema = $injector.get('Schema')
                        var Type = Schema.resource($stateParams.item.$key).getType()

                        return Type.itemSettings.itemViewer.templateUrl
                    },
                    /* @ngInject */
                    controllerProvider: ["$stateParams", function ($stateParams) {
                        var Schema = $injector.get('Schema')
                        var Type = Schema.resource($stateParams.item.$key).getType()

                        return Type.itemSettings.itemViewer.controller
                    }],
                    controllerAs: 'vm',
                }                
            },

            //settings for the ListViewer 
            listSettings: {
                get batchActions() {
                    var returnVal = {}
                    var selectedItems = $state.$current.locals.globals.listItems.filter(function (item) { return item.$selected })
                    if (!selectedItems || selectedItems.length == 0) return {}

                    if (selectedItems.length == 1 && selectedItems[0].$key == 'Page' && selectedItems[0].IsUserEditor($rootScope.user._id)) {
                        returnVal.managePage = $injector.get('Page').getType().listSettings.batchActions.managePage
                    }
                    if (selectedItems.length > 0 && selectedItems.every(function (item) { return item.$key == 'Page' && item.IsUserEditor($rootScope.user._id) })) {
                        returnVal.addMembers = $injector.get('Page').getType().listSettings.batchActions.addMembers
                    }
                    returnVal.markDone = Type.markDone

                    return returnVal
                },

                //indicate what permission is needed to remove an item
                removePermissionNeeded: function (item) {
                    if (item.$key != 'Page') return false

                    var Schema = $injector.get('Schema')
                    var Type = Schema.resource('Page').getType()

                    return Type.listSettings.removePermissionNeeded(item);
                },

                viewTypes: ['list', 'cards'],

                itemHeadline: "<span ng-style='{\"font-weight\": (item.UnreadCounts[$root.user._id] ? \"bold\" : \"\") }'>{{item.toString()}}<span ng-if='item.UnreadCounts[$root.user._id]'> ({{item.UnreadCounts[$root.user._id]}})</span></span>",

                emptyTitle: "Select a Conversation",
                emptyDescription: "An item will appear here. Just pick one.",
                onClicks: {
                    'User': function (list, clickedItem) {
                        if (clickedItem.$key == 'User') {
                            // launch new conversation with this user
                            //todo- needs validation - the DB doesn't enforce having only only 1:1 conversation with another user so something should
                            var Conversation = $injector.get('Conversation')
                            Conversation.NewConversation([clickedItem._id], '##1:1##')
                                .then(function (newConversation) {
                                    Conversation.updateConversations()
                                    list.openItem(newConversation)
                                })
                        }
                    }
                }
            },
            markDone: {
                icon: 'zmdi zmdi-check-all',
                text: 'Mark Done',
                action: function (selectedPages, $event) {
                    $mdDialog.show($mdDialog.confirm({
                        title: 'Mark Done',
                        textContent: 'Are you sure you want to mark these messages as done?',
                        ok: 'Mark Done',
                        cancel: 'Cancel',
                        targetEvent: $event
                    })).then(function () {
                        selectedPages.forEach(function (page) {
                            if (page.$key != 'Page') return
                            if (page.Title != '##1:1##' && page.Title != '##AlLinus##') page.Dismiss()
                        })
                    })
                },
                permissionNeeded: true
            }

        } //end of Type

        //--functions below here also become part of the provider closure

        return Type

    }
})();
(function () {
	angular.module('app').provider('$cachedResource', CachedResource)

	function CachedResource() {

		var Type = {
			/* @ngInject */
			$get: ["$resource", "$timeout", "$q", "$rootScope", "$filter", "$injector", "$window", "s3Url", "socket", "toast", "manageUsers", function ($resource, $timeout, $q, $rootScope, $filter, $injector, $window, s3Url, socket, toast, manageUsers) {
				var DEFAULT_ACTIONS = {
					get: {
						method: 'GET'
					},
					query: {
						method: 'GET',
						isArray: true
					},
					save: {
						method: 'POST'
					},
					remove: {
						method: 'DELETE'
					},
					delete: {
						method: 'DELETE'
					},
					update: {
						method: 'PUT'
					}
				};

				return function ($key, url, params, actions, itemInit) {
					console.debug('Creating new resource', $key)

					//contructor (new CachedResource(item))					
					var CachedResource = function CachedResource() {
						var This = this

						//create empty array fields on the resource as they are typically bound to and have .length checks that like to bomb if the field is undefined
						if (CachedResource.schema) {
							CachedResource.schema.fields.forEach(function (field) {
								if (field.type == 'Array') {
									Object.setByString(This, field.name, [])
								}
							})
						}

						angular.extend(This, arguments[0]);
						fixDates(This)

						//if the item has an init function, run it, after the localCacheReady
						if (itemInit) {
							if (window.localCacheReady) {
								itemInit(This)	
							} else {
								poll(function(){//when
									return window.localCacheReady
								}, function(){//then
									itemInit(This)
								}, angular.noop, 10000, 100)
							}
						}
					}

					//inherit/extend from $resource
					actions = angular.merge(actions, DEFAULT_ACTIONS)
					CachedResource.$resource = $resource(url, params, actions)

					//add our own properties
					CachedResource.$key = $key;
					CachedResource.prototype.$key = $key
					CachedResource.prototype.$resource = CachedResource.$resource

					CachedResource.init = function () {
						CachedResource._cache = {}
						CachedResource._queries = {}
						CachedResource._trackedUpdateTransactionIds = []
					}
					CachedResource.init()

					//you can't try to get Schema because that would cause an infinite loop - Schema could be initing and trying to get it would cause this to run forever
					if ($key != 'Schema') {
						var Schema = $injector.get('Schema')
						CachedResource.schema = Schema.for($key)
					}

					//////////////////////////////////////////////////////////////
					// methods on item instances
					//////////////////////////////////////////////////////////////

					Object.defineProperty(CachedResource.prototype, '$LastModifiedDate', {
						get: function(){
							return this.LastModified.Date
						}
					})

					CachedResource.prototype.userHasAcl = function (type) {
						var This = this

						//if the use has a needed static permission, use that...
						var hasStaticPerm = false

						if (Schema.for(CachedResource.$key).staticPerms) {
							var permString = 'EffPerms.' + Schema.for(CachedResource.$key).staticPerms[type]
							if (permString == 'EffPerms.Everyone') hasStaticPerm = true
							else hasStaticPerm = Object.byString($rootScope.user, permString)
						}

						if (hasStaticPerm) {
							return $q.resolve(true)
						}

						//...otherwise, check the acls on the server
						if (!This.$canEditPromise) {
							This.$canEditPromise = Schema.resource('AccessControlList')
								.query({
									DocId: This._id,
									ModelName: $key
								}, true).$httpPromise
						}

						return $q.when(This.$canEditPromise).then(function (acls) {
							return acls.filter(function (acl) {
								return acl.Type.indexOf(type) > -1
							}).length
						})
					}

					CachedResource.prototype.userHasPermission = function (type) {
						var This = this

						if (This.$userHasPermission === undefined) {
							This.$userHasPermission = {}
						}

						if (This.$userHasPermission[type] === undefined) {
							This.$userHasPermission[type] = false
							this.userHasAcl(type).then(function (hasPerm) {
								This.$userHasPermission[type] = !!hasPerm
							})
						}

						return This.$userHasPermission[type]
					}

					CachedResource.prototype.invalidateAclCache = function () {
						delete this.$canEditPromise
					}

					CachedResource.prototype.getSref = function () {
						return 'single.' + this.$key.toLowerCase()
					}

					CachedResource.prototype.getHref = function () {
						return window.$state.href(this.getSref(), { id: this._id })
					}

					CachedResource.prototype.close = function () {
						$rootScope.$broadcast('closeItem', this)
					}

					CachedResource.prototype.getPage = function () {
						return Schema.resource('Page').getCache({ _id: this._id })[0]
					}

					CachedResource.prototype.open = function (openAs, queryString) {
						var This = this

						//don't show the window if this is a placeholder
						if (This._placeholder && This._undefined) {
							return toast.error('Sorry! This is an Unauthorized Item.')
						} else if (This._placeholder) {
							toast.toast('Loading...')
							$q.when(This.$httpPromise).then(function () {
								This.open(openAs)
							}).catch(function (err) {
								console.error('Error opening item: 120', err)
							})

							return
						}

						var ItemViewer = window.$injector.get('ItemViewer')
						// default to recent item view
						if (openAs === undefined) openAs = 'recent'
						// allow someone to pass "true" to open the item as the topmost recent item
						if (openAs === true) {
							var forceOnTop = true
							openAs = 'recent'
						}
						// display in a different fashion based on openAs
						switch (openAs) {
							case 'recent':
								ItemViewer.openItemDialog({
									item: This,
									itemType: window.$injector.get(This.$key).getType(),
									view: 'recent',
									forceOnTop: forceOnTop
								})
								break;
							case 'state':
								window.$state.go(This.getSref(), { id: This._id })
								break;
							case 'new':
								// make sure that we open this window while authed as the proper user
								manageUsers.storeAuthToken(window.authToken)
								window.open(This.getHref() + (queryString ? queryString : ''))
								break;
							case 'peek':
								window.$rootScope.openPeek(This.getHref())
								break;
						}
					}

					CachedResource.prototype.DeleteMe = function () {
						var This = this
						$mdDialog.show({
							controller: 'RemoveItemDialogController',
							controllerAs: 'vm',
							locals: {
								selectedItems: [This],
								showConfirmationSignature: true
							},
							templateUrl: '/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html',
							clickOutsideToClose: true
						})
					}

					CachedResource.prototype.getScreenshotUrl = function () {
						var This = this
						if (!This.$screenshotUrl) {
							//show a loading message
							This.$screenshotUrl = s3Url + "empty-states/stars.png"

							var s3Service = $injector.get('s3Service')
							s3Service.getSignedFileUrl(This._id, 'get-screenshot', This.$key).then(function (signed_request) {
								//reassign the actual URL
								This.$screenshotUrl = signed_request
							})
						}

						return This.$screenshotUrl
					}

					CachedResource.prototype.getSubHeads = function () {
						var This = this
						if (!This.$subHeads) {
							var computedSubheads = CachedResource.getType().itemSettings.fields || []
							computedSubheads.forEach(function(subhead){
								if (!subhead.subheadSortOrder) subhead.subheadSortOrder = 1
							})
							var schemaSubheads = CachedResource.schema.fields.filter(function (field) {
								var fieldVal = Object.byString(This, field.displayValue)

								var returnVal = field.sortable && !field.excludeAsSubhead && (field.type == 'Array' ? Object.byString(This, field.name) > 0 : !!fieldVal)
								return returnVal
							})

							This.$subHeads = computedSubheads.concat(schemaSubheads)
								.sort(function (a, b) {
									var v1, v2, returnVal = 0
									v1 = a.subheadSortOrder || (a.primary ? 998 : 999)
									v2 = b.subheadSortOrder || (a.primary ? 998 : 999)

									if (v1 > v2) returnVal = 1
									if (v1 < v2) returnVal = -1
									return returnVal
								}).map(function (field) {
									var returnVal = "<div layout='row' layout-align='start center' title=\"{1}{2}\">{0}<div class='text-ellipsis' flex layout='row'>{1}{3}</div></div>"

									var icon = "<md-icon md-font-icon='{0}'></md-icon>".format(field.icon || 'zmdi zmdi-circle')

									if (field.ref == 'User' && field.type != 'Array') {
										icon = '<au-profile-image user="item.{0}" size="13" class="margin-right-5"></au-profile-image>'.format(field.name)
									}

									var display = field.display.trim()
									if (display) {
										display += ':&nbsp;'
									}

									return returnVal.format(
										icon,
										display,
										field.displayValue == field.name ? field.displayTemplate : '{{item.' + field.displayValue + '}}',
										field.displayTemplate
									)
								})
						}

						return this.$subHeads

					}

					CachedResource.prototype.toJSON = function () {
						var data;
						data = angular.extend({}, this);
						delete data.$promise;
						delete data.$httpPromise;
						delete data.__v
						return data;
					};

					//////////////////////////////////////////////////////////////////////////////////////////
					//
					//	QUERY - Does the following: 
					//          1. If the query has been run before and is in cache, return a resolved promise of an array of CachedResources.
					//          2. If we need to hit the server, return an $httpPromise and when we get the results...
					//			   a. update the returned array of CachedResources matching the query
					//             b. store the results (just ids) in _queries by this query's key
					//			   c. for each item returned, go and get all linked (ref'd) items not already on the client and put them in their respective caches. 
					//			   d. resolve $httpPromise with the query results when all that's done.
					//
					//////////////////////////////////////////////////////////////////////////////////////////


					CachedResource.query = function (query, forceQuery, skipPopulate) {
						var returnVal

						if (!query) query = {}

						//generate a key for this query
						var queryKey = angular.copy(query)
						queryKey = JSON.stringify(query)

						//check the query cache						
						var cachedIds = CachedResource._queries[queryKey]
						if (cachedIds && !forceQuery) {
							//we have a cache of this, use it
							returnVal = []
							console.time('Returning query from cache for {0} -> {1}'.format($key, queryKey))
							cachedIds.forEach(function (id) {
								returnVal.push(CachedResource.getCache({ _id: id })[0])
							})
							console.timeEnd('Returning query from cache for {0} -> {1}'.format($key, queryKey))

							//return an $httpPromise for this							
							return { $promise: $q.resolve(returnVal), $httpPromise: $q.resolve(returnVal), currentQuery: query }
						}

						//send the query to the server						
						var queryResults = []
						returnVal = CachedResource.$resource.query(query)
						returnVal.currentQuery = query

						//when the results come back...
						returnVal.$httpPromise = returnVal.$promise.then(function (res) {
							var Schema = $injector.get('Schema')
							var pArray = []
							//needIds is a map of CollectionName:[array of ids not on the client already]
							var needIds = {}, collectionOrder = []

							for (var i = 0; i < res.length; i++) {
								//turn results into CachedResources
								var item = res[i] = new CachedResource(res[i])

								//add but don't announce
								CachedResource.patchCache(item)

								//store the result in the query cache
								queryResults.push(item._id)

								//get all linked (ref'd) items from the server that are not already on the client								
								if (skipPopulate || !CachedResource.schema) continue
								CachedResource.schema.fields.forEach(function (field) {
									if (field.ref && Schema._cache[field.ref] && item[field.name] && field.name != "Organization" && item[field.name] != '--Not Authorized--') {

										//get a reference to the ref'd collection
										var RefResource = Schema.resource(field.ref)
										if (!RefResource) return //next field

										//if the linkedId is not already on the client and not already being requested, add to needIds
										if (field.type == 'Array' && item[field.name] instanceof Array) {
											item[field.name].forEach(pushNeededId)
										} else {
											pushNeededId(item[field.name])
										}

										function pushNeededId(linkedId) {
											if (!linkedId) return;
											if (!needIds[field.ref]) needIds[field.ref] = []
											if (!RefResource._cache[linkedId] && linkedId.length == 24 && linkedId != '000000000000000000000000' && needIds[field.ref].indexOf(linkedId) == -1) {
												needIds[field.ref].push(linkedId)
											}
										}
									}
								})
							}

							//save query results to _queries cache
							if (!query._id) {
								CachedResource._queries[queryKey] = queryResults
							}

							//get populated fields for collection/ids found above					
							Object.keys(needIds).forEach(function (collection) {
								if (needIds[collection].length) {
									console.time('Requesting population of', collection, needIds[collection])
									collectionOrder.push(collection)
									pArray.push(Schema.resource(collection).query({ _id__in: needIds[collection] }))
								}
							})

							//when all populate queries return
							return $q.all(pArray).then(function (populated) {
								collectionOrder.forEach(function (collection, idx) {
									//get the ref'd collection
									var RefResource = Schema.resource(collection)

									//for each item retured
									var populatedItems = populated[idx]
									if (!(populatedItems instanceof Array)) return;
									populatedItems.forEach(function (item) {
										console.info('Received item from populate', $key, item._id)

										//turn it into a cached resource and patchCache (don't announce)
										item = new RefResource(item)
										RefResource.patchCache(item)
									})
									console.time('Requesting population of', collection, needIds[collection])
								})

								return returnVal
							}).catch(function (err) {
								console.error('Error querying: 289', err)
								throw err
							})
						})
						return returnVal
					}

					CachedResource.addToCache = function (item) {
						//update in memory Cache
						CachedResource._cache[item._id] = item
						$rootScope.$broadcast('itemAdded', item)

						update_queries(item)
					};

					CachedResource.patchCache = function (item) {
						var cacheItem = CachedResource._cache[item._id]

						if (cacheItem) {
							//apply properties of the incoming item to the cacheItem
							var updatedFields = $injector.get('auUtility').processItemUpdate(item, cacheItem)
							if (cacheItem.onUpdate && updatedFields.length) {
								cacheItem.onUpdate(updatedFields)
							}

							//during the Schema load, $rootScope.user is an empty object - don't call patchRecentItemCache then
							if (Object.byString($rootScope, 'user.patchRecentItemCache'))
								$rootScope.user.patchRecentItemCache(item)

							$rootScope.$broadcast('itemUpdated', item, updatedFields)
						} else {
							//add but don't announce
							CachedResource._cache[item._id] = item
						}

						//track that we processed an update
						if (item.$updateTransactionId) {
							CachedResource.trackUpdateTransaction(item.$updateTransactionId)
						}

						//invalidate lazy loaded properties
						CachedResource._cache[item._id].$subHeads = null

						update_queries(item)

						return updatedFields
					}

					//after a catch add/patch, we have to remove cached queries because the results may have changed					
					//except for the "all records" query - add to those
					function update_queries(item) {
						Object.keys(CachedResource._queries).forEach(function (key) {

							//if the key has only limit and support, consider this an "all records" query and update the stored results
							keyObj = JSON.parse(key)
							if (key == "{}" || (Object.keys(keyObj).length == 2 && keyObj.sort && keyObj.limit)) {
								//if the new result is not in the cache, add it
								if (CachedResource._queries[key].indexOf(item._id) == -1)
									CachedResource._queries[key].push(item._id)
							} else {
								//query results are no longer valid, data changed
								console.info('removing from _queries', $key, key)
								delete CachedResource._queries[key]
							}
						})
					}

					CachedResource.removeFromCache = function (id) {
						//remove from memory
						$rootScope.$broadcast('itemRemoved', { _id: id, $key: $key })
						delete CachedResource._cache[id]
						CachedResource._queries = {}
					}

					CachedResource.trackUpdateTransaction = function (id) {
						if (!id) return true
						var idx = CachedResource._trackedUpdateTransactionIds.indexOf(id)
						if (idx == -1) {
							CachedResource._trackedUpdateTransactionIds.push(id)
							return true
						}

						return false
					}

					CachedResource.prototype.$saveItem = function () {
						var This = this

						return this.$resource.save(this.toJSON()).$promise.then(function (res) {
							This._id = res._id
							$injector.get('auUtility').processItemUpdate(res, This)

							if (itemInit) itemInit(This)
							CachedResource.addToCache(This)
							CachedResource.trackUpdateTransaction(res.$updateTransactionId)

							return This
						})
					}

					CachedResource.prototype.$updateItem = function () {
						var This = this

						//update other instances of this item currently open
						var updatedFields = CachedResource.patchCache(This)

						//invalidate related/populated resources
						This.$$LastModifiedDate = null

						//send the update to the server
						var update = CachedResource.$resource.update({ id: This._id }, This.toJSON())
						update.$promise.then(function (res) {
							CachedResource.patchCache(res)

							//HACK -- LastModified dates are ignored? They are coming back from the server okay...
							This.LastModified = {Date: new Date(), ByUser: $rootScope.user._id}
							return This
						}).catch(function (err) {
							console.error(err)
							return err
						})

						return update
					}

					CachedResource.prototype.$removeItem = function () {
						var This = this

						//execute the xhr DELETE action
						var p = this.$resource.remove({ id: This._id }).$promise

						//process the DELETE response
						p.then(function (res) {
							CachedResource.removeFromCache(This._id)
						}, function (err) {
							console.error(err)
						})

						//return the promise to let callers .then
						return p
					}

					//////////////////////////////////////////////////////////////////////////////////////////
					//
					// SPOOLIDS - When .getCache is hit with many _id queries, we can spool them up over a 20ms
					//		      debounce and fetch all requested ids at once. This is an order of magnitude faster!
					//
					//////////////////////////////////////////////////////////////////////////////////////////

					var spooledIds = []
					var spooledIdsTimeout
					var spooledPromises = {}
					function spoolIdQuery(id) {
						console.info('Spooling _id', $key, id)

						//add to the spooledIds
						if (id.toString() == "undefined") debugger
						if (spooledIds.indexOf(id) == -1) spooledIds.push(id)

						//even if the requsted id is already being requested, we still need to return and resolve a promise for this call
						//spooledPromises is a map of id:array of promises for the id
						var promise = $q.defer()
						if (!spooledPromises[id]) spooledPromises[id] = []
						spooledPromises[id].push(promise)

						//debounce over 20ms
						if (spooledIdsTimeout) clearTimeout(spooledIdsTimeout)
						spooledIdsTimeout = setTimeout(function () {
							console.info('Querying spooled ids', $key, spooledIds)
							if (!spooledIds || !spooledIds.length || spooledIds.toString() == "undefined") debugger

							//send the server a list of ids
							var query = CachedResource.query({ _id__in: spooledIds })
							spooledIds = [] //empty the spool

							//when the server responds...							
							console.time('spoolId query')
							query.$httpPromise.then(function (remoteRes) {
								console.timeEnd('spoolId query')

								//for each resource returned, resolve the promises with the resource requested
								for (var i = 0; i < remoteRes.length; i++) {
									console.log('Got spooled _id', remoteRes[i]._id)

									//multiple calls could have come in for the same id, resolve them all with the same result									
									spooledPromises[remoteRes[i]._id].forEach(function (idPromise) {
										idPromise.resolve(remoteRes[i])
									})

									//remove the spooledpromises for this id
									delete spooledPromises[remoteRes[i]._id]
								}

								rejectRemaining()

								console.info('Spooling _ids completed for ' + $key)
							}).catch(function (err) {
								console.error('Error querying: 468', err)
								rejectRemaining()
							})

							function rejectRemaining() {
								//if there are spooledPromises remaining, then they should be rejected
								for (var p in spooledPromises) {
									spooledPromises[p].forEach(function (idPromise) {
										idPromise.reject('nothing returned')
									})
								}

							}
						}, 20, false)

						return promise.promise
					}

					////////////////////////////////////////////////////////////////////////////////
					//
					// GETCACHE - Return resources from _cache with client-side filtering, ordering, limiting and skipping.
					//			  Highly optimized for restful backend against items with primary key of _id as in Align Us.
					//
					//            Note: in the event you KNOW that all data you need is already on the client,
					//            pass "false" as the last argument to avoid a server hit. If there is no filter,
					//			  a server hit will download the most recent 100 documents in the collection.
					//		      This only happens the first time getCache is called with no filter because .query caches queryKeys and their results.
					//            In .query, the "all records" queries are kept around even after add/patchCache.
					//
					////////////////////////////////////////////////////////////////////////////////

					CachedResource.getCache = function () {
						var filter, limit, skip, orderBy, alsoQuery
						var args = Array.prototype.slice.call(arguments)

						if (typeof args[0] == 'object' || typeof args[0] == 'function') {
							filter = args[0]
							args.shift()
						}
						if (typeof args[0] == 'number') {
							limit = args[0]
							args.shift()
						}
						if (typeof args[0] == 'number') {
							skip = args[0]
							args.shift()
						}
						if (typeof args[0] == 'string') {
							orderBy = args[0]
							orderBy = orderBy.split(',')
							args.shift()
						}
						if (typeof args[0] == 'boolean') {
							alsoQuery = args[0]
							args.shift()
						}

						if (alsoQuery === undefined) alsoQuery = true

						//post-process cached result
						var returnVal

						////////////////////////////////////////////////////////////////////////////////
						//filter - pass an object to filter items by as the first argument: {_id: xxx}  
						////////////////////////////////////////////////////////////////////////////////

						if (filter && (Object.keys(filter).length > 0 || typeof filter == 'function')) {
							//if we're looking by id... optimize
							if (filter._id) {
								if (filter._id.length != 24) return [{ _placeholder: true, _undefined: true, $httpPromise: $q.resolve(), currentQuery: filter }]

								//try to get this from memory
								returnVal = CachedResource._cache[filter._id]

								// if we're querying for the "system" user, provide that (there will never be an _id:[24 zeros]
								// anyway, so the server hit is useless)
								if (filter._id == '0'.repeat(24) && CachedResource.$key == 'User') {
									returnVal = new CachedResource({ _id: '0'.repeat(24), FirstName: 'Al', LastName: 'Linus' })
								}
								if (filter._id == '9'.repeat(24) && CachedResource.$key == 'User') {
									returnVal = new CachedResource({ _id: '9'.repeat(24), FirstName: 'Anonymous', LastName: 'User' + parseInt(Math.random() * 100) })
								}

								//if this is in the cache, return it immediately
								if (returnVal) {
									returnVal = [returnVal]
									returnVal.$httpPromise = $q.resolve(returnVal)
									returnVal.currentQuery = filter
									return returnVal
								} else {
									if (!alsoQuery) {
										return [] //when querying by id w/ alsoQuery:false, return an empty array if there is nothing in memory
									}

									//create a faux item and return it - it will be updated when the server responds
									console.info('creating placeholder for', $key, filter._id)
									returnVal = CachedResource._cache[filter._id] = new CachedResource({ _id: filter._id })
									returnVal.LastModified = { Date: new Date() }
									returnVal._placeholder = true
									returnVal.currentQuery = filter

									//wrap in array because getCache always returns an array
									returnVal = [returnVal]

									//spool up _id queries for 20ms									
									returnVal.$httpPromise = spoolIdQuery(filter._id).then(function (updatedItem) {
										console.info('Got spooled id back', filter._id, updatedItem)

										//update item in returned array
										$injector.get('auUtility').processItemUpdate(updatedItem, returnVal[0])
										delete returnVal[0]._placeholder
										return returnVal
									}).catch(function (error) {
										console.error('query for _id returned error', $key, filter._id)
										returnVal[0]._undefined = true
										returnVal[0].toString = function () { return 'Unauthorized Item' }
									}).then(function () {
										return returnVal
									})
									returnVal[0].$httpPromise = returnVal.$httpPromise

									return returnVal
								}
							} else {
								//filtering for something other than id - run the entier _cache through $filter
								returnVal = $filter("filter")(Object.values(CachedResource._cache), filter, true)
							}
						} else {
							//not filtering - get entire cache
							returnVal = Object.values(CachedResource._cache)
						}

						////////////////////////////////////////////////////////////////////////////////
						//orderBy - pass a string as the last argument to sort
						////////////////////////////////////////////////////////////////////////////////
						if (orderBy) {
							returnVal = $filter("orderBy")(returnVal, orderBy)
						}

						////////////////////////////////////////////////////////////////////////////////
						//limit & skip - pass numbers as the 2nd and optionally 3rd arguments to limit and skip, respectively returned results
						////////////////////////////////////////////////////////////////////////////////
						if (limit) {
							returnVal = $filter("limitTo")(returnVal, limit, skip)
						} else {
							limit = 100
						}

						////////////////////////////////////////////////////////////////////////////////
						//also run a query and attach an $httpPromise to the result
						////////////////////////////////////////////////////////////////////////////////
						if (alsoQuery) {
							var serverQuery
							if (typeof filter == "function") {
								serverQuery = {}
							} else {
								//append the order and limit to the server query
								serverQuery = angular.copy(filter) || {}
							}

							if (orderBy) serverQuery.sort = orderBy
							if (limit) serverQuery.limit = limit

							console.time('Querying ' + $key + ' with ' + JSON.stringify(serverQuery))
							var q = CachedResource.query(serverQuery)
							returnVal.$httpPromise = q.$httpPromise

							//.query returns CachedResources - no casting required
							returnVal.$httpPromise.then(function (remoteRes) {
								console.timeEnd('Querying ' + $key + ' with ' + JSON.stringify(serverQuery))

								//for every CachedResource returned, either update what was returned from _cache before or add it to the returned array
								for (var i = 0; i < remoteRes.length; i++) {
									//see if this item was already in the returned array
									var inReturnVal = -1
									returnVal.forEach(function (ret, idx) {
										if (ret._id == remoteRes[i]._id) {
											inReturnVal = idx
										}
									})

									if (inReturnVal > -1) {
										//update the returned value if it's a placeholder
										if (returnVal[inReturnVal]._placeholder) {
											console.info('Updated', returnVal[inReturnVal])

											//update item in returned array
											$injector.get('auUtility').processItemUpdate(remoteRes[i], returnVal[inReturnVal])
										}
									} else {
										//add to returned array
										if (!filter || $filter("filter")([remoteRes[i]], filter, true).length > 0) {
											console.info('Added to return', remoteRes[i])
											returnVal.push(remoteRes[i])
										}
									}
								}
					
								return returnVal
							}).catch(function (err) {
								console.error('Error querying: 660', err, serverQuery)
							})
						}

						////////////////////////////////////////////////////////////////////////////////
						//ensure we always have a $httpPromise and currentQuery
						////////////////////////////////////////////////////////////////////////////////
						if (!returnVal.$httpPromise) returnVal.$httpPromise = $q.resolve(returnVal)
						if (!returnVal.currentQuery) returnVal.currentQuery = filter || function(){return true}

						//return array
						return returnVal
					}

					////////////////////////////////////////////////////////////////////////////////
					// SOCKET UPDATE FUNCTIONS
					////////////////////////////////////////////////////////////////////////////////

					var socketQueue = [], userIsIdle = true, idleTimeout

//	THIS CODE CAUSES A BUG WITH INLINE TASK UPDATES 
// 					//only apply update when the user is idle
// 					document.addEventListener('mousemove', watchForIdle)
// 					document.addEventListener('keypress', watchForIdle)

// 					function watchForIdle() {
// 						userIsIdle = false
// 						clearTimeout(idleTimeout);
// 						idleTimeout = setTimeout(function () {
// 							userIsIdle = true
// 							while (userIsIdle && socketQueue.length > 0) {
// 								var args = socketQueue.shift()
// 								consumeUpdate.apply(this, args)
// 							}
// 						}, 1000)
// 					}

					//the server sends itemUpdated for all .saves (even if the item is new)
					var ItemViewer
					socket.on('itemUpdated', function (collectionName, generatedByUser, sessionId, document, wasNew, everyone, updateTransactionId) {
						if (collectionName != $key) return

						if (!ItemViewer) ItemViewer = $injector.get('ItemViewer')

						//ignore socket update where changes originated from this client and the item is open because those changes should have come back from the save/update
						if (!CachedResource.trackUpdateTransaction(updateTransactionId)) {
							console.log('Ignoring socket because we already processed that transaction.', collectionName, document._id, updateTransactionId)
							return
						}

						//ALWAYS TRUE AT THIS TIME DUE TO BUG WITH INLINE TASK UPDATES
						if (userIsIdle) {
							consumeUpdate.apply(this, arguments)
						} else {
							console.log('deferring update for', $key)
							socketQueue.push(arguments)
						}
					})

					//note: keep the function signature here in sync with the socket:itemUpdated (above)
					function consumeUpdate(collectionName, generatedByUser, sessionId, document, wasNew, everyone, updateTransactionId) {
						if (typeof document == "string") {
							console.log('Got socket ItemUpdate - no document', document, collectionName)

							CachedResource.query({ _id: document }, true)
							return
						}

						if (!document) return //invalid update

						var item = new CachedResource(document)
						var cacheItem = CachedResource._cache[document._id]
						if (cacheItem) {
							console.log('Got socket ItemUpdate - patchCache', collectionName, cacheItem._id, updateTransactionId, document)

							//ensure the item is no longer considered a placeholder
							if (cacheItem._placeholder) {
								delete cacheItem._placeholder
								delete cacheItem._undefined
							}

							//if a field changed that required acl generation, invalidateAclCache								
							if (auUtility.requiresAclGeneration(cacheItem, item)) {
								cacheItem.invalidateAclCache()
							}

							//if the screenshot changed, remove it
							if (document.$wasFromScreenshot) {
								delete cacheItem.$screenshotUrl
							}

							//patch the catch with the new item data
							CachedResource.patchCache(item)
						} else {
							console.log('Got socket ItemUpdate - addToCache', collectionName, document)
							CachedResource.addToCache(item)
						}
						debounceDigest()
					}

					socket.on('itemRemoved', function (collectionName, id) {
						if (collectionName != $key) return
						console.log('Got socket itemRemoved', collectionName, id)

						$rootScope.$apply(function () {
							CachedResource.removeFromCache(id)
						})
					})

					socket.on('itemAclChanged', function (collectionName, id, rUsers) {
						if (collectionName != $key) return

						//if the user is no longer in rUsers, removeFromCache
						if (($rootScope.user.$AnonymousUser && rUsers.indexOf("Anonymous") == -1) || (rUsers.indexOf("Everyone") == -1 && rUsers.indexOf($rootScope.user._id) == -1)) {
							return $rootScope.$apply(function () {
								CachedResource.removeFromCache(id)
							})
						}

						if (CachedResource._cache[id]) CachedResource._cache[id].invalidateAclCache()
					})

					////////////////////////////////////////////////////////////////////////////////
					// UTILITY FUNCTIONS
					////////////////////////////////////////////////////////////////////////////////

					function fixDates(item) {
						var keys = Object.keys(item)
						for (var k = 0; k < keys.length; k++) {
							var key = keys[k]

							//convert string dates to object dates
							if (isDate(item[key])) item[key] = new Date(item[key])

							//if the field is an array of objects, fix the array
							if (item[key] instanceof Array && item[key][0] instanceof Object) {
								item[key].forEach(fixDates)
							}

							//if the field is an object, fix it
							if (item[key] instanceof Object && !(item[key] instanceof Array) && !(item[key] instanceof Date)) {
								fixDates(item[key])
							}
						}
					}

					var debounceDigest = debounce(function () {
						if (!$rootScope.$$phase) $rootScope.$digest()
					}, 250)



					return CachedResource
				} //end resource
			}]
		}
		return Type
	}
})();



//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function() {
    var resourceName = 'ActivityLog'

    var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
    angular.module('app').provider(resourceName, Resource)

    function Resource() {
        this.resource = null

        var Type = {
                name: resourceName,

                //return a resource when injected as ResourceName
                /* @ngInject */
                $get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function($q, $cachedResource, $filter, $http, PopulateResource) {
                    if (!this.resource) {
                        this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

                        this.resource.prototype.toString = function() {
                            // return this.Name
                        }

                        Object.defineProperty(this.resource.prototype, 'DateCreated', {
                            get: function() {
                                return this.Date
                            }
                        })

                        this.resource.getType = function() {
                            return Type
                        }

                        // returns a call invite that you just barely missed (a la from an untimely refresh)
                        // "missed" = invite occurred in the last 50 seconds and you didn't join it
                        this.resource.GetMissedCallInvite = function() {
                            var This = this
                            var fiftySecondsAgo = new Date(new Date().getTime() - 50000)
                            var invitesInInterval
                            // get all invites from 50 seconds ago or less
                            return This.query({
                                Date__gte: fiftySecondsAgo,
                                Type: 'VideoUserInvited',
                                'Data.Invited': $rootScope.user._id,
                                sort: 'Date'
                            }).$httpPromise
                            .then(function(invites) {
                                // if no invites were sent to us in the last 50 seconds, we can short-circuit right here...
                                if(!invites || !invites[0]) {
                                    return $q.resolve(undefined)
                                } else {
                                    invitesInInterval = invites
                                    // ...but if some were sent in the last 50 seconds, see if we actually responded  to them
                                    return This.query({
                                        '$or': [
                                            { Type: 'VideoUserJoined' },
                                            { Type: 'VideoUserDeclined' }
                                        ],
                                        User: $rootScope.user._id,
                                        'Data.CallId': invites[0].Data.CallId
                                    }).$httpPromise
                                }
                            }).then(function(respondedToInvites) {
                                // if we already responded to those invites or there were no invites, return undefined
                                if((respondedToInvites && respondedToInvites.length > 0) || !respondedToInvites) {
                                    return $q.resolve(undefined)
                                } else {
                                    // if we didn't respond, the invite was "missed"; return it
                                    return invitesInInterval[0]
                                }
                            })
                        }

                        this.resource.prototype.GetTemplate = function() {
                            if (this.Type) {
                                return '/app/alignus/directives/au-activity-log/' + this.Type.toLowerCase() + '.tmpl.html'
                            } else {
                                return '/app/alignus/directives/au-activity-log/startstop.tmpl.html'
                            }
                        }

                        this.resource.prototype.IsNewVideoCall = function() {
                            if(this.Type == 'VideoCall' && this.InvitedToCall() && this.User != $rootScope.user._id) {
                                return (this.InvitedToCall() && this.User != $rootScope.user._id)                                
                            }
                            // technically previews *are* video calls, but we don't want them handled by the UI
                            return false
                        }

                        this.resource.prototype.IsNewPreviewCall = function() {
                            return (this.Type == 'VideoPreview' && this.User != $rootScope.user._id)
                        }

                        this.resource.prototype.InvitedToCall = function() {
                            return (this.Data.Invited.indexOf($rootScope.user._id) > -1)
                        }

                        this.resource.prototype.IsOnCall = function(userId) {
                            return (this.Data.OnCall.indexOf(userId) > -1)
                        }


                        this.resource.prototype.AlertUserDropped = function(userId) {
                            $http.post('/api/ActivityLog/' + this._id + '/AlertUserDropped', { droppedUserId: userId })
                        }

                        this.resource.prototype.VideoInviteUsers = function(invitedUserIds, noPreview) {
                            return $http.post('/api/ActivityLog/' + this._id + '/VideoInviteUsers', { invitedUserIds: invitedUserIds, noPreview: noPreview })
                        }

                        this.resource.prototype.VideoUserMissedCall = function(userId) {
                            return $http.post('/api/ActivityLog/' + this._id + '/VideoUserMissedCall', { userId: userId })
                        }

                        //create $Collection getters
                        PopulateResource.populate(this.resource)

                        //expose additional methods available on the api

                    }

                    return this.resource

                }], //end of $get

                //settings for the ItemViewer
                itemSettings: {
                    itemViewer: {
                        templateUrl: '/app/' + resourceName.toLowerCase() + '/item/tmpl.html',
                        controller: resourceName + 'ItemController',
                        controllerAs: 'vm',
                    }
                },

                //settings for the ListViewer 
                listSettings: {
                    batchActions: { //put as many batch actions as you want here
                        message: {
                            icon: "zmdi zmdi-comment-alt",
                            text: "Something cool",
                            action: function(selected, $event) { toast.toast("You'll be able to use this function soon!") },
                            permissionNeeded: '$root.user.EffPerms.Users.CanView'
                        },
                    },

                    //indicate what permission is needed to remove an item
                    removePermissionNeeded: '$root.user.EffPerms.Users.CanView',

                    viewTypes: ['list', 'cards', 'report', 'connections'],

                    emptyTitle: "Select An Item",
                    emptyDescription: "An item will appear here. Just pick one."
                }

                
            } //end of Type
        return Type

        //--functions below here also become part of the provider closure


    }
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = 'AccessControlList'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })
				}
				
				return this.resource

			}], //end of $get

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
	}
})();
//#3 - THE RESOURCE - Consume the api and describe the UX around it (like how it should be rendered and what actions can be taken with it)
(function () {
	var resourceName = '_Template'

	var apiRoute = '/api/' + resourceName.toLowerCase() + '/'
	angular.module('app').provider(resourceName, Resource)

	function Resource() {
		this.resource = null

		var Type = {
			name: resourceName,

			//return a resource when injected as ResourceName
			/* @ngInject */
			$get: ["$q", "$cachedResource", "$filter", "$http", "PopulateResource", function ($q, $cachedResource, $filter, $http, PopulateResource) {
				if (!this.resource) {
					this.resource = $cachedResource(resourceName, apiRoute + ':id', { id: "@_id" }, { update: { method: 'PUT' } })

					PopulateResource.populate(this.resource)
					this.resource.getType = function () { return Type }
					this.resource.prototype.toString = function () { return this.Title }
					this.resource.prototype.$trackBy = [resourceName] //'Structure', 'Organization Settings'
		
					//expose additional methods available on the api
				
					//EXAMPLE_METHOD
					this.resource.prototype.EXAMPLE_METHOD = function () {
						var This = this //expose this to the promise
						//return the .data field rather than the whole response
						return $q(function (resolve, reject) {
							$http.get(apiRoute + This._id + '/EXAMPLE_METHOD')
								.then(function (members) {
									resolve(members.data)
								},
									function (err) {
										reject(err)
									})
						})
					}
				}
				
				return this.resource

			}], //end of $get

			//settings for the ItemViewer
			itemSettings: {
				itemViewer: {
					templateUrl: '/app/' + resourceName.toLowerCase() + '/item/tmpl.html',
					controller: resourceName + 'ItemController',
					controllerAs: 'vm',
				},

				fields: [],

				itemButtions: []
			},

			//settings for the ListViewer 
			listSettings: {
				batchActions: { //put as many batch actions as you want here
					message : {
						icon: "zmdi zmdi-comment-alt",
						text: "Something cool",
						action: function (selected, $event) { toast.toast("You'll be able to use this function soon!") },
						permissionNeeded: '$root.user.EffPerms.Users.CanView'
					},
				},
				
				//indicate what permission is needed to remove an item -- shouldn't this just always ask the .hasPermission('D')
				removePermissionNeeded: function(item){
                    return $rootScope.user.EffPerms.Fundraiser.CanDeleteAll || item.Creator == $root.user._id
                },
				
				viewTypes: ['list', 'cards', 'report', 'connections'],

				emptyTitle: "Select an item",
				emptyDescription: "Just pick one."
			},
			
			//add Item
			addItem: function($event){
				var _moreText = null
				window.showDialog({ //you can use window level convenience functions...
					controller: 'AddItemController',
					controllerAs: 'vm',
					templateUrl: '/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html',
					targetEvent: $event,
					locals: {
						itemType: Type,
						init: function (vm, Schema) {
							//EXAMPLES OF WHAT YOU CAN DO WHEN THE DIALOG OPENS/INITIALIZES
							vm.newItem.property = [] //init a property on vm.newItem
							vm.possiblePermissionPresets = Schema.resource('PermissionPreset').getCache() //query any collection and put values on vm
							vm.newItem.$sendAccountInfo = true //add additional fields to newItem with default values
							vm.itemFields.push({ name: '$sendAccountInfo', display: 'Send Account Info' }) //format additional field on "revew"
						},
						steps: {
							intro: {
								//image: "some/file.png", // supply a custom bg if desired
								text: "Click next to get started and select if you'll type in a single item or upload a list.<span ng-bind-html='vm.steps.intro.moreText(vm)'></span>",
								moreText: function (vm) {
									if (_moreText) return _moreText
									_moreText = "Checking stat. Please wait..."

									window.$rootScope.Organization.getStat("User.AvailableLicenses")
										.then(function (res) {
											_moreText = "The stat is " + JSON.toString(res.data)		
										}, function (err) { 
											_moreText = "There was an error retrieving the stat. Proceed at your own risk."
										})
								}
							},
							typeOrUpload: {
								type: {
									//image: "some/file.png",  // supply a custom bg if desired
									fields: ['FirstName', 'LastName', 'Email'], //list fields by name you require the user to fill in
									successText: "You have successfully added the " + Type.name.toLowerCase() + " to your organization."
								},
								upload: {
									//image: "some/file.png",  // supply a custom bg if desired
									example: "https://alignusstatic.s3.amazonaws.com/files/example_users.csv",
									successText: "Your file upload is in progress. Align Us will notify you momentarially with the results."
								}
							},
							//add additional steps by creating a key that is not an existing step and inlining the template. if you don't need additional steps, just remove these.
							PermissionPresets: {
								contents: '<h3>Assign Permission Presets.</h3>' +
								'<p>Easily apply presets of permissions which define what what this user can see and do.</p>' +
								'<p>Authorized users can manage these from Structure > Permission Presets.</p>' +
								'<div class="padding-30"></div>' +
								'<au-groups-list user="vm.newItem" groups="vm.possiblePermissionPresets" direction="row"></au-groups-list>',
								image: '/assets/images/dialogs/permissions.png'},
							LetThemKnow: {contents: '<h3>Let them know.</h3>' +
								'<p>Would you like to send the user their login information at the completion of this wizard?</p>' +
								'<div class="padding-50"></div>' +
								'<md-checkbox ng-model="vm.newItem.$sendAccountInfo" aria-label="send account info">' +
								'   Email user their account information' +
								'</md-checkbox>',
								image: '/assets/images/dialogs/email.png'}
						}
					}
				})				
			}//end of addItem

		} //end of Type
		return Type
		
		//--functions below here also become part of the provider closure
		
		
	}
})();
if (!document) var document = { cookie: '' }; // fix crashes on node

/**
 * Javascript class that mimics how WCF serializes a object of type MongoDB.Bson.ObjectId
 * and converts between that format and the standard 24 character representation.
*/
var ObjectId = (function () {
    var increment = Math.floor(Math.random() * (16777216));
    var pid = Math.floor(Math.random() * (65536));
    var machine = Math.floor(Math.random() * (16777216));

    var setMachineCookie = function() {
        var cookieList = document.cookie.split('; ');
        for (var i in cookieList) {
            var cookie = cookieList[i].split('=');
            var cookieMachineId = parseInt(cookie[1], 10);
            if (cookie[0] == 'mongoMachineId' && cookieMachineId && cookieMachineId >= 0 && cookieMachineId <= 16777215) {
                machine = cookieMachineId;
                break;
            }
        }
        document.cookie = 'mongoMachineId=' + machine + ';expires=Tue, 19 Jan 2038 05:00:00 GMT;path=/';
    };
    if (typeof (localStorage) != 'undefined') {
        try {
            var mongoMachineId = parseInt(localStorage['mongoMachineId']);
            if (mongoMachineId >= 0 && mongoMachineId <= 16777215) {
                machine = Math.floor(localStorage['mongoMachineId']);
            }
            // Just always stick the value in.
            localStorage['mongoMachineId'] = machine;
        } catch (e) {
            setMachineCookie();
        }
    }
    else {
        setMachineCookie();
    }

    function ObjId() {
        if (!(this instanceof ObjectId)) {
            return new ObjectId(arguments[0], arguments[1], arguments[2], arguments[3]).toString();
        }

        if (typeof (arguments[0]) == 'object') {
            this.timestamp = arguments[0].timestamp;
            this.machine = arguments[0].machine;
            this.pid = arguments[0].pid;
            this.increment = arguments[0].increment;
        }
        else if (typeof (arguments[0]) == 'string' && arguments[0].length == 24) {
            this.timestamp = Number('0x' + arguments[0].substr(0, 8)),
            this.machine = Number('0x' + arguments[0].substr(8, 6)),
            this.pid = Number('0x' + arguments[0].substr(14, 4)),
            this.increment = Number('0x' + arguments[0].substr(18, 6))
        }
        else if (arguments.length == 4 && arguments[0] != null) {
            this.timestamp = arguments[0];
            this.machine = arguments[1];
            this.pid = arguments[2];
            this.increment = arguments[3];
        }
        else {
            this.timestamp = Math.floor(new Date().valueOf() / 1000);
            this.machine = machine;
            this.pid = pid;
            this.increment = increment++;
            if (increment > 0xffffff) {
                increment = 0;
            }
        }
    };
    return ObjId;
})();

ObjectId.prototype.getDate = function () {
    return new Date(this.timestamp * 1000);
};

ObjectId.prototype.toArray = function () {
    var strOid = this.toString();
    var array = [];
    var i;
    for(i = 0; i < 12; i++) {
        array[i] = parseInt(strOid.slice(i*2, i*2+2), 16);
    }
    return array;
};

/**
* Turns a WCF representation of a BSON ObjectId into a 24 character string representation.
*/
ObjectId.prototype.toString = function () {
    if (this.timestamp === undefined
        || this.machine === undefined
        || this.pid === undefined
        || this.increment === undefined) {
        return 'Invalid ObjectId';
    }

    var timestamp = this.timestamp.toString(16);
    var machine = this.machine.toString(16);
    var pid = this.pid.toString(16);
    var increment = this.increment.toString(16);
    return '00000000'.substr(0, 8 - timestamp.length) + timestamp +
           '000000'.substr(0, 6 - machine.length) + machine +
           '0000'.substr(0, 4 - pid.length) + pid +
           '000000'.substr(0, 6 - increment.length) + increment;
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.

// // Usage
// var myEfficientFn = debounce(function() {
// 	// All the taxing stuff you do
// }, 250);
// window.addEventListener('resize', myEfficientFn);
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// // Usage:  ensure element is visible
// poll(
//     function() {
//         return document.getElementById('lightbox').offsetWidth > 0;
//     },
//     function() {
//         // Done, success callback
//     },
//     function() {
//         // Error, failure callback
//     }
// );
function poll(fn, callback, errback, timeout, interval) {
    var endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;

    (function p() {
            // If the condition is met, we're done! 
            if(fn()) {
                callback();
            }
            // If the condition isn't met but the timeout hasn't elapsed, go again
            else if (Number(new Date()) < endTime) {
                setTimeout(p, interval);
            }
            // Didn't match and too much time, reject!
            else {
                errback(new Error('timed out for ' + fn + ': ' + arguments));
            }
    })();
}


// Usage
// var canOnlyFireOnce = once(function() {
// 	console.log('Fired!');
// });

// canOnlyFireOnce(); // "Fired!"
// canOnlyFireOnce(); // nada
function once(fn, context) { 
	var result;

	return function() { 
		if(fn) {
			result = fn.apply(context || this, arguments);
			fn = null;
		}

		return result;
	};
}

// // Usage
// getAbsoluteUrl('/something'); // https://davidwalsh.name/something
var getAbsoluteUrl = (function() {
	var a;

	return function(url) {
		if(!a) a = document.createElement('a');
		a.href = url;

		return a.href;
	};
})();

// Usage
// sheet.insertRule("header { float: left; opacity: 0.8; }", 1);
var sheet = (function() {
	// Create the <style> tag
	var style = document.createElement('style');

	// Add a media (and/or media query) here if you'd like!
	// style.setAttribute('media', 'screen')
	// style.setAttribute('media', 'only screen and (max-width : 1024px)')

	// WebKit hack :(
	style.appendChild(document.createTextNode(''));

	// Add the <style> element to the page
	document.head.appendChild(style);

	return style.sheet;
})();

// Usage
// matchesSelector(document.getElementById('myDiv'), 'div.someSelector[some-attribute=true]')
function matchesSelector(el, selector) {
	var p = Element.prototype;
	var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
		return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
	};
	return f.call(el, selector);
}

function isDate(val) {
    if (!val) return false
    if (val instanceof Date) return true
    if (val.length != 24) return false
    return moment(val, moment.ISO_8601, true).isValid()
}

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

//serializes regex objects
RegExp.prototype.toJSON = function(){
  return this.toString()	
} 

//scrollParent definition
jQuery.fn.scrollParent = function(excludeElement) {
	var overflowRegex = /(auto|scroll)/,
		position = this.css("position"),
		excludeStaticParent = position === "absolute",
		scrollParent = this.parents().filter(function() {
			var parent = $(this)
			if (excludeStaticParent && parent.css("position") === "static") {
				return false
			}
			//hack just for this implementation - md-content is given overflow:auto by material design even if it's not scrollable
			//TODO: improve this by detecting if the element is scrollable in a more reliable way
			if (parent[0].tagName == excludeElement)
				return false
			var overflows = (overflowRegex).test(parent.css("overflow") + parent.css("overflow-y") + parent.css("overflow-x"))
			if (overflows && parent.parent()[0] && parent.parent()[0].style && parent.parent()[0].style.height == "inherit")
				return false
			return overflows
		}).eq(0)

	return position === "fixed" || !scrollParent.length ? $((this.length ? this[0].ownerDocument : null) || document) : scrollParent
}

function asyncPoll(fn, checkFn, timeout, interval) {
    var endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100

    var checkCondition = function(resolve, reject) { 
        // execute async code
        var prom = fn()
        prom.then( function(response){
            // if the response data meets the caller's conditions, we're done
            if(checkFn(response)) {
                // return the caller the data
                resolve(response); 
                return;
            }
            // if the response didn't meet the caller's conditions, but there's still time left, poll again
            else if (Number(new Date()) < endTime) {
                setTimeout(checkCondition, interval, resolve, reject)
            }
            // if the response didn't meet the caller's conditions and no time is left, bail
            else {
                reject(new Error('timed out for ' + fn + ': ' + arguments))
            }
        });
    };

    return new Promise(checkCondition);
}

jQuery.fn.putCursorAtEnd = function() {

    return this.each(function() {
      
      // Cache references
      var $el = $(this),
          el = this;
  
      // Only focus if input isn't already
      if (!$el.is(":focus")) {
       $el.focus();
      }
  
      // If this function exists... (IE 9+)
      if (el.setSelectionRange) {
  
        // Double the length because Opera is inconsistent about whether a carriage return is one character or two.
        var len = $el.val().length * 2;
        
        // Timeout seems to be required for Blink
        setTimeout(function() {
          el.setSelectionRange(len, len);
        }, 1);
      
      } else {
        
        // As a fallback, replace the contents with itself
        // Doesn't work in Chrome, but Chrome supports setSelectionRange
        $el.val($el.val());
        
      }
  
      // Scroll to the bottom, in case we're in a tall textarea
      // (Necessary for Firefox and Chrome)
      this.scrollTop = 999999;
  
    });
  
  };
//put this code directly on the window
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position){
      position = position || 0;
      return this.substr(position, searchString.length).toLowerCase() === searchString.toLowerCase();
  };
}

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString, position) {
		var subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position -= searchString.length;
		var lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}

if(typeof String.prototype.trim !== 'function') {
  String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, ''); 
  }
}

/*! https://mths.be/repeat v0.2.0 by @mathias */
if (!String.prototype.repeat) {
	(function () {
		'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
		var defineProperty = (function () {
			// IE 8 only supports `Object.defineProperty` on DOM elements
			try {
				var object = {};
				var $defineProperty = Object.defineProperty;
				var result = $defineProperty(object, object, object) && $defineProperty;
			} catch (error) { }
			return result;
		} ());
		var repeat = function (count) {
			if (this == null) {
				throw TypeError();
			}
			var string = String(this);
			// `ToInteger`
			var n = count ? Number(count) : 0;
			if (n != n) { // better `isNaN`
				n = 0;
			}
			// Account for out-of-bounds indices
			if (n < 0 || n == Infinity) {
				throw RangeError();
			}
			var result = '';
			while (n) {
				if (n % 2 == 1) {
					result += string;
				}
				if (n > 1) {
					string += string;
				}
				n >>= 1;
			}
			return result;
		};
		if (defineProperty) {
			defineProperty(String.prototype, 'repeat', {
				'value': repeat,
				'configurable': true,
				'writable': true
			});
		} else {
			String.prototype.repeat = repeat;
		}
	} ());
}

if (!String.prototype.replaceAll) {
	String.prototype.replaceAll = function (find, replace) {
		var thisString = this.toString();

		return thisString.split(find).join(replace)
	};
}

if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) { 
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}

if (!String.prototype.contains) {
  String.prototype.contains = function(text) {
    return this.toLowerCase().indexOf(text.toLowerCase()) > -1
  };
}
//! http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key

/**
 * Given an object, gets the nested property defined by path.
 * @param {Object} object The input object
 * @param {String} path The path of the nested key to pull out of the object
 *
 * @example
 * var a = {b: {c: {d: true}}}
 * return Object.byString(a, "b.c.d"); // true
 */
Object.byString = function (object, path) {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, '');           // strip a leading dot
    var keyArray = path.split('.');
    for (var i = 0, n = keyArray.length; i < n; ++i) {

        if (object == undefined) {
            return ''
        }

        var key = keyArray[i];
        if (typeof object == 'object' && key in object) {
            object = object[key];
        } else {
            return;
        }
    }
    return object;
}

Object.setByString = function (object, path, value) {
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, '');           // strip a leading dot
    var keyArray = path.split('.');
    if (keyArray.length == 1) return object[path] = value

    var lastObj
    for (var i = 0, n = keyArray.length; i < n; ++i) {

        if (object == undefined) {
            return ''
        }

        var key = keyArray[i];
        if (typeof object == 'object' && key in object) {
            lastObj = object
        } else {
            return;
        }
    }
    lastObj = value
}

if (!Object.values) {
    Object.values = function (obj) {
        return Object.keys(obj).map(function (e) {
            return obj[e]
        })
    }
}
/**
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */

/**
 * Class containing the diff, match and patch methods.
 * @constructor
 */
function diff_match_patch() {

  // Defaults.
  // Redefine these in your program to override the defaults.

  // Number of seconds to map a diff before giving up (0 for infinity).
  this.Diff_Timeout = 1.0;
  // Cost of an empty edit operation in terms of edit characters.
  this.Diff_EditCost = 4;
  // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
  this.Match_Threshold = 0.5;
  // How far to search for a match (0 = exact location, 1000+ = broad match).
  // A match this many characters away from the expected location will add
  // 1.0 to the score (0.0 is a perfect match).
  this.Match_Distance = 1000;
  // When deleting a large block of text (over ~64 characters), how close do
  // the contents have to be to match the expected contents. (0.0 = perfection,
  // 1.0 = very loose).  Note that Match_Threshold controls how closely the
  // end points of a delete need to match.
  this.Patch_DeleteThreshold = 0.5;
  // Chunk size for context length.
  this.Patch_Margin = 4;

  // The number of bits in an int.
  this.Match_MaxBits = 32;
}


//  DIFF FUNCTIONS


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;

/** @typedef {{0: number, 1: string}} */
diff_match_patch.Diff;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */
diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines,
    opt_deadline) {
  // Set a deadline by which time the diff must be complete.
  if (typeof opt_deadline == 'undefined') {
    if (this.Diff_Timeout <= 0) {
      opt_deadline = Number.MAX_VALUE;
    } else {
      opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
  }
  var deadline = opt_deadline;

  // Check for null inputs.
  if (text1 == null || text2 == null) {
    throw new Error('Null input. (diff_main)');
  }

  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  if (typeof opt_checklines == 'undefined') {
    opt_checklines = true;
  }
  var checklines = opt_checklines;

  // Trim off common prefix (speedup).
  var commonlength = this.diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = this.diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = this.diff_compute_(text1, text2, checklines, deadline);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  this.diff_cleanupMerge(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines,
    deadline) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = this.diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
    var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  if (checklines && text1.length > 100 && text2.length > 100) {
    return this.diff_lineMode_(text1, text2, deadline);
  }

  return this.diff_bisect_(text1, text2, deadline);
};


/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
  // Scan the text on a line-by-line basis first.
  var a = this.diff_linesToChars_(text1, text2);
  text1 = a.chars1;
  text2 = a.chars2;
  var linearray = a.lineArray;

  var diffs = this.diff_main(text1, text2, false, deadline);

  // Convert the diff back to original text.
  this.diff_charsToLines_(diffs, linearray);
  // Eliminate freak matches (e.g. blank lines)
  this.diff_cleanupSemantic(diffs);

  // Rediff any replacement blocks, this time character-by-character.
  // Add a dummy entry at the end.
  diffs.push([DIFF_EQUAL, '']);
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete >= 1 && count_insert >= 1) {
          // Delete the offending records and add the merged ones.
          diffs.splice(pointer - count_delete - count_insert,
                       count_delete + count_insert);
          pointer = pointer - count_delete - count_insert;
          var a = this.diff_main(text_delete, text_insert, false, deadline);
          for (var j = a.length - 1; j >= 0; j--) {
            diffs.splice(pointer, 0, a[j]);
          }
          pointer = pointer + a.length;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
    pointer++;
  }
  diffs.pop();  // Remove the dummy entry at the end.

  return diffs;
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Bail out if deadline is reached.
    if ((new Date()).getTime() > deadline) {
      break;
    }

    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */
diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y,
    deadline) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = this.diff_main(text1a, text2a, false, deadline);
  var diffsb = this.diff_main(text1b, text2b, false, deadline);

  return diffs.concat(diffsb);
};


/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */
diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
  var lineArray = [];  // e.g. lineArray[4] == 'Hello\n'
  var lineHash = {};   // e.g. lineHash['Hello\n'] == 4

  // '\x00' is a valid character, but various debuggers don't like it.
  // So we'll insert a junk entry to avoid generating a null character.
  lineArray[0] = '';

  /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */
  function diff_linesToCharsMunge_(text) {
    var chars = '';
    // Walk the text, pulling out a substring for each line.
    // text.split('\n') would would temporarily double our memory footprint.
    // Modifying text would create many large strings to garbage collect.
    var lineStart = 0;
    var lineEnd = -1;
    // Keeping our own length variable is faster than looking it up.
    var lineArrayLength = lineArray.length;
    while (lineEnd < text.length - 1) {
      lineEnd = text.indexOf('\n', lineStart);
      if (lineEnd == -1) {
        lineEnd = text.length - 1;
      }
      var line = text.substring(lineStart, lineEnd + 1);
      lineStart = lineEnd + 1;

      if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) :
          (lineHash[line] !== undefined)) {
        chars += String.fromCharCode(lineHash[line]);
      } else {
        chars += String.fromCharCode(lineArrayLength);
        lineHash[line] = lineArrayLength;
        lineArray[lineArrayLength++] = line;
      }
    }
    return chars;
  }

  var chars1 = diff_linesToCharsMunge_(text1);
  var chars2 = diff_linesToCharsMunge_(text2);
  return {chars1: chars1, chars2: chars2, lineArray: lineArray};
};


/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */
diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
  for (var x = 0; x < diffs.length; x++) {
    var chars = diffs[x][1];
    var text = [];
    for (var y = 0; y < chars.length; y++) {
      text[y] = lineArray[chars.charCodeAt(y)];
    }
    diffs[x][1] = text.join('');
  }
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */
diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  // Eliminate the null case.
  if (text1_length == 0 || text2_length == 0) {
    return 0;
  }
  // Truncate the longer string.
  if (text1_length > text2_length) {
    text1 = text1.substring(text1_length - text2_length);
  } else if (text1_length < text2_length) {
    text2 = text2.substring(0, text1_length);
  }
  var text_length = Math.min(text1_length, text2_length);
  // Quick check for the worst case.
  if (text1 == text2) {
    return text_length;
  }

  // Start by looking for a single character match
  // and increase length until no match is found.
  // Performance analysis: http://neil.fraser.name/news/2010/11/04/
  var best = 0;
  var length = 1;
  while (true) {
    var pattern = text1.substring(text_length - length);
    var found = text2.indexOf(pattern);
    if (found == -1) {
      return best;
    }
    length += found;
    if (found == 0 || text1.substring(text_length - length) ==
        text2.substring(0, length)) {
      best = length;
      length++;
    }
  }
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */
diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
  if (this.Diff_Timeout <= 0) {
    // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
  }
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }
  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = dmp.diff_commonPrefix(longtext.substring(i),
                                               shorttext.substring(j));
      var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i),
                                               shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Number of characters that changed prior to the equality.
  var length_insertions1 = 0;
  var length_deletions1 = 0;
  // Number of characters that changed after the equality.
  var length_insertions2 = 0;
  var length_deletions2 = 0;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      equalities[equalitiesLength++] = pointer;
      length_insertions1 = length_insertions2;
      length_deletions1 = length_deletions2;
      length_insertions2 = 0;
      length_deletions2 = 0;
      lastequality = diffs[pointer][1];
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_INSERT) {
        length_insertions2 += diffs[pointer][1].length;
      } else {
        length_deletions2 += diffs[pointer][1].length;
      }
      // Eliminate an equality that is smaller or equal to the edits on both
      // sides of it.
      if (lastequality && (lastequality.length <=
          Math.max(length_insertions1, length_deletions1)) &&
          (lastequality.length <= Math.max(length_insertions2,
                                           length_deletions2))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        // Throw away the equality we just deleted.
        equalitiesLength--;
        // Throw away the previous equality (it needs to be reevaluated).
        equalitiesLength--;
        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
        length_insertions1 = 0;  // Reset the counters.
        length_deletions1 = 0;
        length_insertions2 = 0;
        length_deletions2 = 0;
        lastequality = null;
        changes = true;
      }
    }
    pointer++;
  }

  // Normalize the diff.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
  this.diff_cleanupSemanticLossless(diffs);

  // Find any overlaps between deletions and insertions.
  // e.g: <del>abcxxx</del><ins>xxxdef</ins>
  //   -> <del>abc</del>xxx<ins>def</ins>
  // e.g: <del>xxxabc</del><ins>defxxx</ins>
  //   -> <ins>def</ins>xxx<del>abc</del>
  // Only extract an overlap if it is as big as the edit ahead or behind it.
  pointer = 1;
  while (pointer < diffs.length) {
    if (diffs[pointer - 1][0] == DIFF_DELETE &&
        diffs[pointer][0] == DIFF_INSERT) {
      var deletion = diffs[pointer - 1][1];
      var insertion = diffs[pointer][1];
      var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
      var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
      if (overlap_length1 >= overlap_length2) {
        if (overlap_length1 >= deletion.length / 2 ||
            overlap_length1 >= insertion.length / 2) {
          // Overlap found.  Insert an equality and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, insertion.substring(0, overlap_length1)]);
          diffs[pointer - 1][1] =
              deletion.substring(0, deletion.length - overlap_length1);
          diffs[pointer + 1][1] = insertion.substring(overlap_length1);
          pointer++;
        }
      } else {
        if (overlap_length2 >= deletion.length / 2 ||
            overlap_length2 >= insertion.length / 2) {
          // Reverse overlap found.
          // Insert an equality and swap and trim the surrounding edits.
          diffs.splice(pointer, 0,
              [DIFF_EQUAL, deletion.substring(0, overlap_length2)]);
          diffs[pointer - 1][0] = DIFF_INSERT;
          diffs[pointer - 1][1] =
              insertion.substring(0, insertion.length - overlap_length2);
          diffs[pointer + 1][0] = DIFF_DELETE;
          diffs[pointer + 1][1] =
              deletion.substring(overlap_length2);
          pointer++;
        }
      }
      pointer++;
    }
    pointer++;
  }
};


/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
  /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */
  function diff_cleanupSemanticScore_(one, two) {
    if (!one || !two) {
      // Edges are the best.
      return 6;
    }

    // Each port of this function behaves slightly differently due to
    // subtle differences in each language's definition of things like
    // 'whitespace'.  Since this function's purpose is largely cosmetic,
    // the choice has been made to use each language's native features
    // rather than force total conformity.
    var char1 = one.charAt(one.length - 1);
    var char2 = two.charAt(0);
    var nonAlphaNumeric1 = char1.match(diff_match_patch.nonAlphaNumericRegex_);
    var nonAlphaNumeric2 = char2.match(diff_match_patch.nonAlphaNumericRegex_);
    var whitespace1 = nonAlphaNumeric1 &&
        char1.match(diff_match_patch.whitespaceRegex_);
    var whitespace2 = nonAlphaNumeric2 &&
        char2.match(diff_match_patch.whitespaceRegex_);
    var lineBreak1 = whitespace1 &&
        char1.match(diff_match_patch.linebreakRegex_);
    var lineBreak2 = whitespace2 &&
        char2.match(diff_match_patch.linebreakRegex_);
    var blankLine1 = lineBreak1 &&
        one.match(diff_match_patch.blanklineEndRegex_);
    var blankLine2 = lineBreak2 &&
        two.match(diff_match_patch.blanklineStartRegex_);

    if (blankLine1 || blankLine2) {
      // Five points for blank lines.
      return 5;
    } else if (lineBreak1 || lineBreak2) {
      // Four points for line breaks.
      return 4;
    } else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) {
      // Three points for end of sentences.
      return 3;
    } else if (whitespace1 || whitespace2) {
      // Two points for whitespace.
      return 2;
    } else if (nonAlphaNumeric1 || nonAlphaNumeric2) {
      // One point for non-alphanumeric.
      return 1;
    }
    return 0;
  }

  var pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      var equality1 = diffs[pointer - 1][1];
      var edit = diffs[pointer][1];
      var equality2 = diffs[pointer + 1][1];

      // First, shift the edit as far left as possible.
      var commonOffset = this.diff_commonSuffix(equality1, edit);
      if (commonOffset) {
        var commonString = edit.substring(edit.length - commonOffset);
        equality1 = equality1.substring(0, equality1.length - commonOffset);
        edit = commonString + edit.substring(0, edit.length - commonOffset);
        equality2 = commonString + equality2;
      }

      // Second, step character by character right, looking for the best fit.
      var bestEquality1 = equality1;
      var bestEdit = edit;
      var bestEquality2 = equality2;
      var bestScore = diff_cleanupSemanticScore_(equality1, edit) +
          diff_cleanupSemanticScore_(edit, equality2);
      while (edit.charAt(0) === equality2.charAt(0)) {
        equality1 += edit.charAt(0);
        edit = edit.substring(1) + equality2.charAt(0);
        equality2 = equality2.substring(1);
        var score = diff_cleanupSemanticScore_(equality1, edit) +
            diff_cleanupSemanticScore_(edit, equality2);
        // The >= encourages trailing rather than leading whitespace on edits.
        if (score >= bestScore) {
          bestScore = score;
          bestEquality1 = equality1;
          bestEdit = edit;
          bestEquality2 = equality2;
        }
      }

      if (diffs[pointer - 1][1] != bestEquality1) {
        // We have an improvement, save it back to the diff.
        if (bestEquality1) {
          diffs[pointer - 1][1] = bestEquality1;
        } else {
          diffs.splice(pointer - 1, 1);
          pointer--;
        }
        diffs[pointer][1] = bestEdit;
        if (bestEquality2) {
          diffs[pointer + 1][1] = bestEquality2;
        } else {
          diffs.splice(pointer + 1, 1);
          pointer--;
        }
      }
    }
    pointer++;
  }
};

// Define some regex patterns for matching boundaries.
diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
diff_match_patch.whitespaceRegex_ = /\s/;
diff_match_patch.linebreakRegex_ = /[\r\n]/;
diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;

/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
  var changes = false;
  var equalities = [];  // Stack of indices where equalities are found.
  var equalitiesLength = 0;  // Keeping our own length var is faster in JS.
  /** @type {?string} */
  var lastequality = null;
  // Always equal to diffs[equalities[equalitiesLength - 1]][1]
  var pointer = 0;  // Index of current position.
  // Is there an insertion operation before the last equality.
  var pre_ins = false;
  // Is there a deletion operation before the last equality.
  var pre_del = false;
  // Is there an insertion operation after the last equality.
  var post_ins = false;
  // Is there a deletion operation after the last equality.
  var post_del = false;
  while (pointer < diffs.length) {
    if (diffs[pointer][0] == DIFF_EQUAL) {  // Equality found.
      if (diffs[pointer][1].length < this.Diff_EditCost &&
          (post_ins || post_del)) {
        // Candidate found.
        equalities[equalitiesLength++] = pointer;
        pre_ins = post_ins;
        pre_del = post_del;
        lastequality = diffs[pointer][1];
      } else {
        // Not a candidate, and can never become one.
        equalitiesLength = 0;
        lastequality = null;
      }
      post_ins = post_del = false;
    } else {  // An insertion or deletion.
      if (diffs[pointer][0] == DIFF_DELETE) {
        post_del = true;
      } else {
        post_ins = true;
      }
      /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */
      if (lastequality && ((pre_ins && pre_del && post_ins && post_del) ||
                           ((lastequality.length < this.Diff_EditCost / 2) &&
                            (pre_ins + pre_del + post_ins + post_del) == 3))) {
        // Duplicate record.
        diffs.splice(equalities[equalitiesLength - 1], 0,
                     [DIFF_DELETE, lastequality]);
        // Change second copy to insert.
        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
        equalitiesLength--;  // Throw away the equality we just deleted;
        lastequality = null;
        if (pre_ins && pre_del) {
          // No changes made which could affect previous entry, keep going.
          post_ins = post_del = true;
          equalitiesLength = 0;
        } else {
          equalitiesLength--;  // Throw away the previous equality.
          pointer = equalitiesLength > 0 ?
              equalities[equalitiesLength - 1] : -1;
          post_ins = post_del = false;
        }
        changes = true;
      }
    }
    pointer++;
  }

  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */
diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = this.diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = this.diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    this.diff_cleanupMerge(diffs);
  }
};


/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */
diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
  var chars1 = 0;
  var chars2 = 0;
  var last_chars1 = 0;
  var last_chars2 = 0;
  var x;
  for (x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {  // Equality or deletion.
      chars1 += diffs[x][1].length;
    }
    if (diffs[x][0] !== DIFF_DELETE) {  // Equality or insertion.
      chars2 += diffs[x][1].length;
    }
    if (chars1 > loc) {  // Overshot the location.
      break;
    }
    last_chars1 = chars1;
    last_chars2 = chars2;
  }
  // Was the location was deleted?
  if (diffs.length != x && diffs[x][0] === DIFF_DELETE) {
    return last_chars2;
  }
  // Add the remaining character length.
  return last_chars2 + (loc - last_chars1);
};


/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */
diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
  var html = [];
  var pattern_amp = /&/g;
  var pattern_lt = /</g;
  var pattern_gt = />/g;
  var pattern_para = /\n/g;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];    // Operation (insert, delete, equal)
    var data = diffs[x][1];  // Text of change.
    var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;')
        .replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
    switch (op) {
      case DIFF_INSERT:
        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
        break;
      case DIFF_DELETE:
        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
        break;
      case DIFF_EQUAL:
        html[x] = '<span>' + text + '</span>';
        break;
    }
  }
  return html.join('');
};


/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */
diff_match_patch.prototype.diff_text1 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_INSERT) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */
diff_match_patch.prototype.diff_text2 = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    if (diffs[x][0] !== DIFF_DELETE) {
      text[x] = diffs[x][1];
    }
  }
  return text.join('');
};


/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */
diff_match_patch.prototype.diff_levenshtein = function(diffs) {
  var levenshtein = 0;
  var insertions = 0;
  var deletions = 0;
  for (var x = 0; x < diffs.length; x++) {
    var op = diffs[x][0];
    var data = diffs[x][1];
    switch (op) {
      case DIFF_INSERT:
        insertions += data.length;
        break;
      case DIFF_DELETE:
        deletions += data.length;
        break;
      case DIFF_EQUAL:
        // A deletion and an insertion is one substitution.
        levenshtein += Math.max(insertions, deletions);
        insertions = 0;
        deletions = 0;
        break;
    }
  }
  levenshtein += Math.max(insertions, deletions);
  return levenshtein;
};


/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */
diff_match_patch.prototype.diff_toDelta = function(diffs) {
  var text = [];
  for (var x = 0; x < diffs.length; x++) {
    switch (diffs[x][0]) {
      case DIFF_INSERT:
        text[x] = '+' + encodeURI(diffs[x][1]);
        break;
      case DIFF_DELETE:
        text[x] = '-' + diffs[x][1].length;
        break;
      case DIFF_EQUAL:
        text[x] = '=' + diffs[x][1].length;
        break;
    }
  }
  return text.join('\t').replace(/%20/g, ' ');
};


/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
  var diffs = [];
  var diffsLength = 0;  // Keeping our own length var is faster in JS.
  var pointer = 0;  // Cursor in text1
  var tokens = delta.split(/\t/g);
  for (var x = 0; x < tokens.length; x++) {
    // Each token begins with a one character parameter which specifies the
    // operation of this token (delete, insert, equality).
    var param = tokens[x].substring(1);
    switch (tokens[x].charAt(0)) {
      case '+':
        try {
          diffs[diffsLength++] = [DIFF_INSERT, decodeURI(param)];
        } catch (ex) {
          // Malformed URI sequence.
          throw new Error('Illegal escape in diff_fromDelta: ' + param);
        }
        break;
      case '-':
        // Fall through.
      case '=':
        var n = parseInt(param, 10);
        if (isNaN(n) || n < 0) {
          throw new Error('Invalid number in diff_fromDelta: ' + param);
        }
        var text = text1.substring(pointer, pointer += n);
        if (tokens[x].charAt(0) == '=') {
          diffs[diffsLength++] = [DIFF_EQUAL, text];
        } else {
          diffs[diffsLength++] = [DIFF_DELETE, text];
        }
        break;
      default:
        // Blank tokens are ok (from a trailing \t).
        // Anything else is an error.
        if (tokens[x]) {
          throw new Error('Invalid diff operation in diff_fromDelta: ' +
                          tokens[x]);
        }
    }
  }
  if (pointer != text1.length) {
    throw new Error('Delta length (' + pointer +
        ') does not equal source text length (' + text1.length + ').');
  }
  return diffs;
};


//  MATCH FUNCTIONS


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */
diff_match_patch.prototype.match_main = function(text, pattern, loc) {
  // Check for null inputs.
  if (text == null || pattern == null || loc == null) {
    throw new Error('Null input. (match_main)');
  }

  loc = Math.max(0, Math.min(loc, text.length));
  if (text == pattern) {
    // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
  } else if (!text.length) {
    // Nothing to match.
    return -1;
  } else if (text.substring(loc, loc + pattern.length) == pattern) {
    // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
  } else {
    // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
  }
};


/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */
diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
  if (pattern.length > this.Match_MaxBits) {
    throw new Error('Pattern too long for this browser.');
  }

  // Initialise the alphabet.
  var s = this.match_alphabet_(pattern);

  var dmp = this;  // 'this' becomes 'window' in a closure.

  /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */
  function match_bitapScore_(e, x) {
    var accuracy = e / pattern.length;
    var proximity = Math.abs(loc - x);
    if (!dmp.Match_Distance) {
      // Dodge divide by zero error.
      return proximity ? 1.0 : accuracy;
    }
    return accuracy + (proximity / dmp.Match_Distance);
  }

  // Highest score beyond which we give up.
  var score_threshold = this.Match_Threshold;
  // Is there a nearby exact match? (speedup)
  var best_loc = text.indexOf(pattern, loc);
  if (best_loc != -1) {
    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    // What about in the other direction? (speedup)
    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
    if (best_loc != -1) {
      score_threshold =
          Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
  }

  // Initialise the bit arrays.
  var matchmask = 1 << (pattern.length - 1);
  best_loc = -1;

  var bin_min, bin_mid;
  var bin_max = pattern.length + text.length;
  var last_rd;
  for (var d = 0; d < pattern.length; d++) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from 'loc' we can stray at this
    // error level.
    bin_min = 0;
    bin_mid = bin_max;
    while (bin_min < bin_mid) {
      if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) {
        bin_min = bin_mid;
      } else {
        bin_max = bin_mid;
      }
      bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
    }
    // Use the result from this iteration as the maximum for the next.
    bin_max = bin_mid;
    var start = Math.max(1, loc - bin_mid + 1);
    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;

    var rd = Array(finish + 2);
    rd[finish + 1] = (1 << d) - 1;
    for (var j = finish; j >= start; j--) {
      // The alphabet (s) is a sparse hash, so the following line generates
      // warnings.
      var charMatch = s[text.charAt(j - 1)];
      if (d === 0) {  // First pass: exact match.
        rd[j] = ((rd[j + 1] << 1) | 1) & charMatch;
      } else {  // Subsequent passes: fuzzy match.
        rd[j] = (((rd[j + 1] << 1) | 1) & charMatch) |
                (((last_rd[j + 1] | last_rd[j]) << 1) | 1) |
                last_rd[j + 1];
      }
      if (rd[j] & matchmask) {
        var score = match_bitapScore_(d, j - 1);
        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (score <= score_threshold) {
          // Told you so.
          score_threshold = score;
          best_loc = j - 1;
          if (best_loc > loc) {
            // When passing loc, don't exceed our current distance from loc.
            start = Math.max(1, 2 * loc - best_loc);
          } else {
            // Already passed loc, downhill from here on in.
            break;
          }
        }
      }
    }
    // No hope for a (better) match at greater error levels.
    if (match_bitapScore_(d + 1, loc) > score_threshold) {
      break;
    }
    last_rd = rd;
  }
  return best_loc;
};


/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */
diff_match_patch.prototype.match_alphabet_ = function(pattern) {
  var s = {};
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] = 0;
  }
  for (var i = 0; i < pattern.length; i++) {
    s[pattern.charAt(i)] |= 1 << (pattern.length - i - 1);
  }
  return s;
};


//  PATCH FUNCTIONS


/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */
diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
  if (text.length == 0) {
    return;
  }
  var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
  var padding = 0;

  // Look for the first and last matches of pattern in text.  If two different
  // matches are found, increase the pattern length.
  while (text.indexOf(pattern) != text.lastIndexOf(pattern) &&
         pattern.length < this.Match_MaxBits - this.Patch_Margin -
         this.Patch_Margin) {
    padding += this.Patch_Margin;
    pattern = text.substring(patch.start2 - padding,
                             patch.start2 + patch.length1 + padding);
  }
  // Add one chunk for good luck.
  padding += this.Patch_Margin;

  // Add the prefix.
  var prefix = text.substring(patch.start2 - padding, patch.start2);
  if (prefix) {
    patch.diffs.unshift([DIFF_EQUAL, prefix]);
  }
  // Add the suffix.
  var suffix = text.substring(patch.start2 + patch.length1,
                              patch.start2 + patch.length1 + padding);
  if (suffix) {
    patch.diffs.push([DIFF_EQUAL, suffix]);
  }

  // Roll back the start points.
  patch.start1 -= prefix.length;
  patch.start2 -= prefix.length;
  // Extend the lengths.
  patch.length1 += prefix.length + suffix.length;
  patch.length2 += prefix.length + suffix.length;
};


/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
  var text1, diffs;
  if (typeof a == 'string' && typeof opt_b == 'string' &&
      typeof opt_c == 'undefined') {
    // Method 1: text1, text2
    // Compute diffs from text1 and text2.
    text1 = /** @type {string} */(a);
    diffs = this.diff_main(text1, /** @type {string} */(opt_b), true);
    if (diffs.length > 2) {
      this.diff_cleanupSemantic(diffs);
      this.diff_cleanupEfficiency(diffs);
    }
  } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' &&
      typeof opt_c == 'undefined') {
    // Method 2: diffs
    // Compute text1 from diffs.
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(a);
    text1 = this.diff_text1(diffs);
  } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' &&
      typeof opt_c == 'undefined') {
    // Method 3: text1, diffs
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_b);
  } else if (typeof a == 'string' && typeof opt_b == 'string' &&
      opt_c && typeof opt_c == 'object') {
    // Method 4: text1, text2, diffs
    // text2 is not used.
    text1 = /** @type {string} */(a);
    diffs = /** @type {!Array.<!diff_match_patch.Diff>} */(opt_c);
  } else {
    throw new Error('Unknown call format to patch_make.');
  }

  if (diffs.length === 0) {
    return [];  // Get rid of the null case.
  }
  var patches = [];
  var patch = new diff_match_patch.patch_obj();
  var patchDiffLength = 0;  // Keeping our own length var is faster in JS.
  var char_count1 = 0;  // Number of characters into the text1 string.
  var char_count2 = 0;  // Number of characters into the text2 string.
  // Start with text1 (prepatch_text) and apply the diffs until we arrive at
  // text2 (postpatch_text).  We recreate the patches one by one to determine
  // context info.
  var prepatch_text = text1;
  var postpatch_text = text1;
  for (var x = 0; x < diffs.length; x++) {
    var diff_type = diffs[x][0];
    var diff_text = diffs[x][1];

    if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
      // A new patch starts here.
      patch.start1 = char_count1;
      patch.start2 = char_count2;
    }

    switch (diff_type) {
      case DIFF_INSERT:
        patch.diffs[patchDiffLength++] = diffs[x];
        patch.length2 += diff_text.length;
        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text +
                         postpatch_text.substring(char_count2);
        break;
      case DIFF_DELETE:
        patch.length1 += diff_text.length;
        patch.diffs[patchDiffLength++] = diffs[x];
        postpatch_text = postpatch_text.substring(0, char_count2) +
                         postpatch_text.substring(char_count2 +
                             diff_text.length);
        break;
      case DIFF_EQUAL:
        if (diff_text.length <= 2 * this.Patch_Margin &&
            patchDiffLength && diffs.length != x + 1) {
          // Small equality inside a patch.
          patch.diffs[patchDiffLength++] = diffs[x];
          patch.length1 += diff_text.length;
          patch.length2 += diff_text.length;
        } else if (diff_text.length >= 2 * this.Patch_Margin) {
          // Time for a new patch.
          if (patchDiffLength) {
            this.patch_addContext_(patch, prepatch_text);
            patches.push(patch);
            patch = new diff_match_patch.patch_obj();
            patchDiffLength = 0;
            // Unlike Unidiff, our patch lists have a rolling context.
            // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
            // Update prepatch text & pos to reflect the application of the
            // just completed patch.
            prepatch_text = postpatch_text;
            char_count1 = char_count2;
          }
        }
        break;
    }

    // Update the current character count.
    if (diff_type !== DIFF_INSERT) {
      char_count1 += diff_text.length;
    }
    if (diff_type !== DIFF_DELETE) {
      char_count2 += diff_text.length;
    }
  }
  // Pick up the leftover patch if not empty.
  if (patchDiffLength) {
    this.patch_addContext_(patch, prepatch_text);
    patches.push(patch);
  }

  return patches;
};


/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */
diff_match_patch.prototype.patch_deepCopy = function(patches) {
  // Making deep copies is hard in JavaScript.
  var patchesCopy = [];
  for (var x = 0; x < patches.length; x++) {
    var patch = patches[x];
    var patchCopy = new diff_match_patch.patch_obj();
    patchCopy.diffs = [];
    for (var y = 0; y < patch.diffs.length; y++) {
      patchCopy.diffs[y] = patch.diffs[y].slice();
    }
    patchCopy.start1 = patch.start1;
    patchCopy.start2 = patch.start2;
    patchCopy.length1 = patch.length1;
    patchCopy.length2 = patch.length2;
    patchesCopy[x] = patchCopy;
  }
  return patchesCopy;
};


/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */
diff_match_patch.prototype.patch_apply = function(patches, text) {
  if (patches.length == 0) {
    return [text, []];
  }

  // Deep copy the patches so that no changes are made to originals.
  patches = this.patch_deepCopy(patches);

  var nullPadding = this.patch_addPadding(patches);
  text = nullPadding + text + nullPadding;

  this.patch_splitMax(patches);
  // delta keeps track of the offset between the expected and actual location
  // of the previous patch.  If there are patches expected at positions 10 and
  // 20, but the first patch was found at 12, delta is 2 and the second patch
  // has an effective expected position of 22.
  var delta = 0;
  var results = [];
  for (var x = 0; x < patches.length; x++) {
    var expected_loc = patches[x].start2 + delta;
    var text1 = this.diff_text1(patches[x].diffs);
    var start_loc;
    var end_loc = -1;
    if (text1.length > this.Match_MaxBits) {
      // patch_splitMax will only provide an oversized pattern in the case of
      // a monster delete.
      start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits),
                                  expected_loc);
      if (start_loc != -1) {
        end_loc = this.match_main(text,
            text1.substring(text1.length - this.Match_MaxBits),
            expected_loc + text1.length - this.Match_MaxBits);
        if (end_loc == -1 || start_loc >= end_loc) {
          // Can't find valid trailing context.  Drop this patch.
          start_loc = -1;
        }
      }
    } else {
      start_loc = this.match_main(text, text1, expected_loc);
    }
    if (start_loc == -1) {
      // No match found.  :(
      results[x] = false;
      // Subtract the delta for this failed patch from subsequent patches.
      delta -= patches[x].length2 - patches[x].length1;
    } else {
      // Found a match.  :)
      results[x] = true;
      delta = start_loc - expected_loc;
      var text2;
      if (end_loc == -1) {
        text2 = text.substring(start_loc, start_loc + text1.length);
      } else {
        text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
      }
      if (text1 == text2) {
        // Perfect match, just shove the replacement text in.
        text = text.substring(0, start_loc) +
               this.diff_text2(patches[x].diffs) +
               text.substring(start_loc + text1.length);
      } else {
        // Imperfect match.  Run a diff to get a framework of equivalent
        // indices.
        var diffs = this.diff_main(text1, text2, false);
        if (text1.length > this.Match_MaxBits &&
            this.diff_levenshtein(diffs) / text1.length >
            this.Patch_DeleteThreshold) {
          // The end points match, but the content is unacceptably bad.
          results[x] = false;
        } else {
          this.diff_cleanupSemanticLossless(diffs);
          var index1 = 0;
          var index2;
          for (var y = 0; y < patches[x].diffs.length; y++) {
            var mod = patches[x].diffs[y];
            if (mod[0] !== DIFF_EQUAL) {
              index2 = this.diff_xIndex(diffs, index1);
            }
            if (mod[0] === DIFF_INSERT) {  // Insertion
              text = text.substring(0, start_loc + index2) + mod[1] +
                     text.substring(start_loc + index2);
            } else if (mod[0] === DIFF_DELETE) {  // Deletion
              text = text.substring(0, start_loc + index2) +
                     text.substring(start_loc + this.diff_xIndex(diffs,
                         index1 + mod[1].length));
            }
            if (mod[0] !== DIFF_DELETE) {
              index1 += mod[1].length;
            }
          }
        }
      }
    }
  }
  // Strip the padding off.
  text = text.substring(nullPadding.length, text.length - nullPadding.length);
  return [text, results];
};


/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */
diff_match_patch.prototype.patch_addPadding = function(patches) {
  var paddingLength = this.Patch_Margin;
  var nullPadding = '';
  for (var x = 1; x <= paddingLength; x++) {
    nullPadding += String.fromCharCode(x);
  }

  // Bump all the patches forward.
  for (var x = 0; x < patches.length; x++) {
    patches[x].start1 += paddingLength;
    patches[x].start2 += paddingLength;
  }

  // Add some padding on start of first diff.
  var patch = patches[0];
  var diffs = patch.diffs;
  if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.unshift([DIFF_EQUAL, nullPadding]);
    patch.start1 -= paddingLength;  // Should be 0.
    patch.start2 -= paddingLength;  // Should be 0.
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[0][1].length) {
    // Grow first equality.
    var extraLength = paddingLength - diffs[0][1].length;
    diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
    patch.start1 -= extraLength;
    patch.start2 -= extraLength;
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  // Add some padding on end of last diff.
  patch = patches[patches.length - 1];
  diffs = patch.diffs;
  if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
    // Add nullPadding equality.
    diffs.push([DIFF_EQUAL, nullPadding]);
    patch.length1 += paddingLength;
    patch.length2 += paddingLength;
  } else if (paddingLength > diffs[diffs.length - 1][1].length) {
    // Grow last equality.
    var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
    diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
    patch.length1 += extraLength;
    patch.length2 += extraLength;
  }

  return nullPadding;
};


/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */
diff_match_patch.prototype.patch_splitMax = function(patches) {
  var patch_size = this.Match_MaxBits;
  for (var x = 0; x < patches.length; x++) {
    if (patches[x].length1 <= patch_size) {
      continue;
    }
    var bigpatch = patches[x];
    // Remove the big old patch.
    patches.splice(x--, 1);
    var start1 = bigpatch.start1;
    var start2 = bigpatch.start2;
    var precontext = '';
    while (bigpatch.diffs.length !== 0) {
      // Create one of several smaller patches.
      var patch = new diff_match_patch.patch_obj();
      var empty = true;
      patch.start1 = start1 - precontext.length;
      patch.start2 = start2 - precontext.length;
      if (precontext !== '') {
        patch.length1 = patch.length2 = precontext.length;
        patch.diffs.push([DIFF_EQUAL, precontext]);
      }
      while (bigpatch.diffs.length !== 0 &&
             patch.length1 < patch_size - this.Patch_Margin) {
        var diff_type = bigpatch.diffs[0][0];
        var diff_text = bigpatch.diffs[0][1];
        if (diff_type === DIFF_INSERT) {
          // Insertions are harmless.
          patch.length2 += diff_text.length;
          start2 += diff_text.length;
          patch.diffs.push(bigpatch.diffs.shift());
          empty = false;
        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 &&
                   patch.diffs[0][0] == DIFF_EQUAL &&
                   diff_text.length > 2 * patch_size) {
          // This is a large deletion.  Let it pass in one chunk.
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          empty = false;
          patch.diffs.push([diff_type, diff_text]);
          bigpatch.diffs.shift();
        } else {
          // Deletion or equality.  Only take as much as we can stomach.
          diff_text = diff_text.substring(0,
              patch_size - patch.length1 - this.Patch_Margin);
          patch.length1 += diff_text.length;
          start1 += diff_text.length;
          if (diff_type === DIFF_EQUAL) {
            patch.length2 += diff_text.length;
            start2 += diff_text.length;
          } else {
            empty = false;
          }
          patch.diffs.push([diff_type, diff_text]);
          if (diff_text == bigpatch.diffs[0][1]) {
            bigpatch.diffs.shift();
          } else {
            bigpatch.diffs[0][1] =
                bigpatch.diffs[0][1].substring(diff_text.length);
          }
        }
      }
      // Compute the head context for the next patch.
      precontext = this.diff_text2(patch.diffs);
      precontext =
          precontext.substring(precontext.length - this.Patch_Margin);
      // Append the end context for this patch.
      var postcontext = this.diff_text1(bigpatch.diffs)
                            .substring(0, this.Patch_Margin);
      if (postcontext !== '') {
        patch.length1 += postcontext.length;
        patch.length2 += postcontext.length;
        if (patch.diffs.length !== 0 &&
            patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) {
          patch.diffs[patch.diffs.length - 1][1] += postcontext;
        } else {
          patch.diffs.push([DIFF_EQUAL, postcontext]);
        }
      }
      if (!empty) {
        patches.splice(++x, 0, patch);
      }
    }
  }
};


/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */
diff_match_patch.prototype.patch_toText = function(patches) {
  var text = [];
  for (var x = 0; x < patches.length; x++) {
    text[x] = patches[x];
  }
  return text.join('');
};


/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */
diff_match_patch.prototype.patch_fromText = function(textline) {
  var patches = [];
  if (!textline) {
    return patches;
  }
  var text = textline.split('\n');
  var textPointer = 0;
  var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
  while (textPointer < text.length) {
    var m = text[textPointer].match(patchHeader);
    if (!m) {
      throw new Error('Invalid patch string: ' + text[textPointer]);
    }
    var patch = new diff_match_patch.patch_obj();
    patches.push(patch);
    patch.start1 = parseInt(m[1], 10);
    if (m[2] === '') {
      patch.start1--;
      patch.length1 = 1;
    } else if (m[2] == '0') {
      patch.length1 = 0;
    } else {
      patch.start1--;
      patch.length1 = parseInt(m[2], 10);
    }

    patch.start2 = parseInt(m[3], 10);
    if (m[4] === '') {
      patch.start2--;
      patch.length2 = 1;
    } else if (m[4] == '0') {
      patch.length2 = 0;
    } else {
      patch.start2--;
      patch.length2 = parseInt(m[4], 10);
    }
    textPointer++;

    while (textPointer < text.length) {
      var sign = text[textPointer].charAt(0);
      try {
        var line = decodeURI(text[textPointer].substring(1));
      } catch (ex) {
        // Malformed URI sequence.
        throw new Error('Illegal escape in patch_fromText: ' + line);
      }
      if (sign == '-') {
        // Deletion.
        patch.diffs.push([DIFF_DELETE, line]);
      } else if (sign == '+') {
        // Insertion.
        patch.diffs.push([DIFF_INSERT, line]);
      } else if (sign == ' ') {
        // Minor equality.
        patch.diffs.push([DIFF_EQUAL, line]);
      } else if (sign == '@') {
        // Start of next patch.
        break;
      } else if (sign === '') {
        // Blank line?  Whatever.
      } else {
        // WTF?
        throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
      }
      textPointer++;
    }
  }
  return patches;
};


/**
 * Class representing one patch operation.
 * @constructor
 */
diff_match_patch.patch_obj = function() {
  /** @type {!Array.<!diff_match_patch.Diff>} */
  this.diffs = [];
  /** @type {?number} */
  this.start1 = null;
  /** @type {?number} */
  this.start2 = null;
  /** @type {number} */
  this.length1 = 0;
  /** @type {number} */
  this.length2 = 0;
};


/**
 * Emmulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indicies are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */
diff_match_patch.patch_obj.prototype.toString = function() {
  var coords1, coords2;
  if (this.length1 === 0) {
    coords1 = this.start1 + ',0';
  } else if (this.length1 == 1) {
    coords1 = this.start1 + 1;
  } else {
    coords1 = (this.start1 + 1) + ',' + this.length1;
  }
  if (this.length2 === 0) {
    coords2 = this.start2 + ',0';
  } else if (this.length2 == 1) {
    coords2 = this.start2 + 1;
  } else {
    coords2 = (this.start2 + 1) + ',' + this.length2;
  }
  var text = ['@@ -' + coords1 + ' +' + coords2 + ' @@\n'];
  var op;
  // Escape the body of the patch with %xx notation.
  for (var x = 0; x < this.diffs.length; x++) {
    switch (this.diffs[x][0]) {
      case DIFF_INSERT:
        op = '+';
        break;
      case DIFF_DELETE:
        op = '-';
        break;
      case DIFF_EQUAL:
        op = ' ';
        break;
    }
    text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
  }
  return text.join('').replace(/%20/g, ' ');
};


// Export these global variables so that they survive Google's JS compiler.
// In a browser, 'this' will be 'window'.
// Users of node.js should 'require' the uncompressed version since Google's
// JS compiler may break the following exports for non-browser environments.
this['diff_match_patch'] = diff_match_patch;
this['DIFF_DELETE'] = DIFF_DELETE;
this['DIFF_INSERT'] = DIFF_INSERT;
this['DIFF_EQUAL'] = DIFF_EQUAL;

//return the last element in an array
if (!Array.prototype.last) {
    Array.prototype.last = function(){
        return this[this.length - 1];
    };
};

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

if (!Array.prototype.contains) {
	Array.prototype.contains = function (query) {
		return this.indexOf(query) > -1
	}
};
(function () {
	'use strict';
	
/**
 * fullLocationFilter
 * 
 * Line one is Addr1, Addr2
 * Line two is City, State, Zip, Country
 * 
 * Defaults to line two if no parameter
 * 
 * usage:
 * - {{ user | fullLocationFilter}}
 * - {{ location | fullLocationFilter : 'Line1' }}
 * - {{ department | fullLocationFilter : 'Line2' }}
 */

	angular
		.module('app')
		.filter('viewicon', viewicon);

	function viewicon() {
		return filterFilter;

		////////////////

		function filterFilter(viewname) {
			if (!viewname) return ''
			switch (viewname.toLowerCase()) {
				case 'list':
					return 'au au-view-list'
				case 'cards':
					return 'au au-view-cards'
				case 'report':
					return 'au au-view-report'
				case 'connections':
					return 'au au-view-connections'
				case 'task-kanban':
				case 'task-user':
					return 'zmdi zmdi-view-column'
			}

		}
	}

})();
(function () {
	'use strict';

	teamFilter.$inject = ["Team", "$filter"];
	angular
		.module('app')
		.filter('teamFilter', teamFilter);

	function teamFilter(Team, $filter) {
		function filterFilter(team, param) {
			if (typeof team == 'string') {
				// populate the user
				team = Team.getCache({ _id: team })[0]
			}

			if (team._placeholder) return team.$httpPromise.then(function (res) {
				return res[0].Name
			})

			return team.Name
		}
		filterFilter.$stateful = true

		return filterFilter;
	}
})();
(function () {
	'use strict';

	questionTagFilter.$inject = ["QuestionTag", "$filter"];
	angular
		.module('app')
		.filter('questionTagFilter', questionTagFilter);

	function questionTagFilter(QuestionTag, $filter) {
		function filterFilter(tag, param) {
			if (typeof tag == 'string') {
				var origTag = tag
				tag = QuestionTag.getCache({ _id: tag })[0]
			}

			if (tag._placeholder) return tag.$httpPromise.then(function (res) {
				return res[0].TagText
			})

			return tag.TagText
		}
		filterFilter.$stateful = true

		return filterFilter;
	}
})();
(function() {
    'use strict';

    angular
        .module('app')
        .filter('replaceText', replaceFn);

    /* @ngInject */
    function replaceFn() {
        return filterFunction;

        ////////////////

        function filterFunction(value, find, replace) {
            if (!value) {
                return '';
            }

            return value.toString().replaceAll(find, replace)
        }
    }

})();
(function () {
	'use strict';

	projectFilter.$inject = ["Project", "$filter"];
	angular
		.module('app')
		.filter('projectFilter', projectFilter);

	function projectFilter(Project, $filter) {
		function filterFilter(project) {
			if (typeof project == 'string') {
				// populate the user
				project = Project.getCache({_id: project})[0]
			}

			if (project._placeholder) return project.$httpPromise.then(function(res){
				return res[0].Title
			})
			
			return project.Title
		}
		filterFilter.$stateful = true

		return filterFilter;
	}
})();
(function () {
	'use strict';

	priorityFilter.$inject = ["$filter"];
	angular
		.module('app')
		.filter('priorityFilter', priorityFilter);
	
	/* @ngInject */
	function priorityFilter($filter) {
		return function(priority, param) {
			switch(priority) {
				case 1:
					return 'High Priority'
				case 2:
					return 'Normal Priority'
				case 3:
					return 'Low Priority'
				default:
					return 'No Priority'
			}
		}
	}

})();
(function () {
	'use strict';

	pageFilter.$inject = ["Page", "$filter"];
	angular
		.module('app')
		.filter('pageFilter', pageFilter);

	function pageFilter(Page, $filter) {
		function filterFilter(page, param) {
			if (typeof page == 'string') {
				// populate the user
				page = Page.getCache({ _id: page })[0]
			}

			if (page._placeholder) return page.$httpPromise.then(function (res) {
				return res[0].Title
			})

			return page.Title
		}
		filterFilter.$stateful = true

		return filterFilter;
	}

})();
(function () {
	'use strict';

	angular
		.module('app')
		.filter('modFilter', modFilter);

	function modFilter() {
		return filterFilter;

		////////////////

		function filterFilter(input, inColumn, nbrCols) {
			var out = []

			for (var i = 0; i < input.length; i++){
				if ((i % nbrCols) + 1 == inColumn){
					out.push(input[i])
				}
			}

			return out
			
		}
	}

})();
(function () {
	'use strict';

	meetingFilter.$inject = ["Meeting", "$filter"];
	angular
		.module('app')
		.filter('meetingFilter', meetingFilter);

	function meetingFilter(Meeting, $filter) {
		function filterFilter(meeting, param) {
			if (typeof meeting == 'string') {
				// populate the meeting
				meeting = Meeting.getCache({_id: meeting})[0]
			}

			if (meeting._placeholder) return meeting.$httpPromise.then(function(res){
				return res[0].Title
			})

			return meeting.Title
		}
		filterFilter.$stateful = true

		return filterFilter;
	}

})();
(function () {
	'use strict';

	fullNameFilter.$inject = ["User", "$rootScope"];
	angular
		.module('app')
		.filter('fullNameFilter', fullNameFilter);
	/* @ngInject */
	function fullNameFilter(User, $rootScope) {
		$rootScope.fullName = filterFilter
		return filterFilter;

		function filterFilter(item) {
			if (!item || item.toString() == "undefined" ) return ""
			var origItem = item
			if (typeof item == 'string') {
				if (item == '000000000000000000000000') {
					return 'Al Linus'
				} else {
					var query = User.getCache({ _id: item })
					item = query[0]
					
					if (query._placeholder) return query.$httpPromise.then(function (res) {
						return res[0].toString()
					})
				}
			}

			return item.toString()
		}
	}

})();
(function () {
	'use strict';
	
/**
 * fullLocationFilter
 * 
 * Line one is Addr1, Addr2
 * Line two is City, State, Zip, Country
 * 
 * Defaults to line two if no parameter
 * 
 * usage:
 * - {{ user | fullLocationFilter}}
 * - {{ location | fullLocationFilter : 'Line1' }}
 * - {{ department | fullLocationFilter : 'Line2' }}
 */

	angular
		.module('app')
		.filter('fullLocationFilter', fullLocationFilter);

	function fullLocationFilter() {
		return filterFilter;

		function filterFilter(detail, param) {
			var locationString = "";

			if(param == 'full') {
				locationString = makeLineOne(detail) + ', ' + makeLineTwo(detail)
			} else if ((typeof param == "string" && param.toLowerCase() == "line1") ||
					(typeof param == "number" && param == 1)) {
						locationString += makeLineOne(detail)	
			} else {
				locationString += makeLineTwo(detail)
			}

			return locationString
		}

		function makeLineOne(detail) {
			var lineOne = ''
			if (detail.Address1)
				lineOne += detail.Address1;
				
			if (detail.Address2) {
				if (lineOne) lineOne += ", ";
				lineOne += detail.Address2;
			}
			return lineOne;
		}

		function makeLineTwo(detail) {
			var lineTwo = ''
			if (detail.City)
				lineTwo += detail.City;

			if (detail.StateProv) {
				if (lineTwo) lineTwo += ", ";
				lineTwo += detail.StateProv;
			}
			
			if (detail.ZipPostalCode) {
				if (lineTwo) lineTwo += ", ";
				lineTwo += detail.ZipPostalCode;
			}

			if (detail.Country) {
				if (lineTwo) lineTwo += ", ";
				lineTwo += detail.Country;
			}
	
			return lineTwo;
		}
	}

})();
(function () {
	'use strict';

	firstNameFilter.$inject = ["User", "$rootScope"];
	angular
		.module('app')
		.filter('firstNameFilter', firstNameFilter);
	/* @ngInject */
	function firstNameFilter(User, $rootScope) {
		return filterFilter;

		function filterFilter(item) {
			if (!item) return ""
			var origItem = item
			if (typeof item == 'string') {
				if (item == '000000000000000000000000') {
					return 'Al Linus'
				} else {
					var query = User.getCache({ _id: item })
					item = query[0]
					if (item._placeholder) {
						return origItem
					}
				}
			}

			return item.FirstName || 'Al Linus'
		}
	}

})();
(function () {
	'use strict';

/**
 * Filters a list of users such that the logged in user
 * is not included
 *
 * @usage:
 * <div ng-repeat="user in vm.users | everyoneButMe">
 * 	{{ user | auItemFilter: 'User' }}
 * </div>
 */

	everyoneButMeFilter.$inject = ["$rootScope"];
	angular
		.module('app')
		.filter('everyoneButMe', everyoneButMeFilter);

	function everyoneButMeFilter($rootScope) {
		return filterFilter;

		////////////////

		function filterFilter(array, expression, comparator) {
			if (array.length <= 1) {
				// we only have one user, use that
				return array
			} else if (array.length == 2 && angular.equals(array[0], array[1])) {
				// both people are the same, usually when you talk to yourself
				return [array[0]]
			} else {
				// return everyone that isn't us
				return array.filter(function(user) {
					if (typeof user === 'undefined') return false;

					var userId = typeof user == 'string' ? user : user._id
					return (userId != $rootScope.user._id)
				})
			}


		}
	}

})();
(function () {
	angular
		.module('app')
		.filter('durationFilter', function () {
			return function (millseconds) {
				var oneSecond = 1000;
				var oneMinute = oneSecond * 60;
				var oneHour = oneMinute * 60;
				var oneDay = oneHour * 24;

				var seconds = Math.floor((millseconds % oneMinute) / oneSecond);
				var minutes = Math.floor((millseconds % oneHour) / oneMinute);
				var hours = Math.floor((millseconds % oneDay) / oneHour);
				var days = Math.floor(millseconds / oneDay);

				var timeString = '';
				if (days !== 0) {
					timeString += (days !== 1) ? (days + ' days ') : (days + ' day ');
				}
				if (hours !== 0) {
					timeString += (hours !== 1) ? (hours + ' hours ') : (hours + ' hour ');
				}
				if (minutes !== 0) {
					timeString += (minutes !== 1) ? (minutes + ' minutes ') : (minutes + ' minute ');
				}
				if (seconds !== 0 || millseconds < 1000) {
					timeString += (seconds !== 1) ? (seconds + ' seconds ') : (seconds + ' second ');
				}

				return timeString;
			};
		});
})();

(function() {
    'use strict';

    angular
        .module('app')
        .filter('cut', cut);

    /* @ngInject */
    function cut() {
        return filterFunction;

        ////////////////

        function filterFunction(value, wordwise, max, tail) {
            if (!value) {
                return '';
            }

            max = parseInt(max, 10);
            if (!max) {
                return value;
            }
            if (value.length <= max) {
                return value;
            }

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        }
    }

})();
(function () {
	'use strict';

	completedTaskFilter.$inject = ["Project", "$filter"];
	angular
		.module('app')
		.filter('completedTaskFilter', completedTaskFilter);

	function completedTaskFilter(Project, $filter) {
		return function(input) {
			if(!input || input.length == 0) return []
			return input.filter(function(task) {
				return !task.EndDate
			})
		}
	}

})();
(function () {
	'use strict';

/**
 * TODO document this
 */

	angular
		.module('app')
		.filter('bystring', bystring);

	function bystring() {
		return filterFilter;

		////////////////

		function filterFilter(detail, param) {
			var returnVal = Object.byString(detail, param)
			if (returnVal == undefined) return ''
			return returnVal

		}
	}

})();
(function () {
	'use strict';
	auItemFilter.$inject = ["Schema", "$rootScope"];
	angular
		.module('app')
		.filter('auItemFilter', auItemFilter)
	/* @ngInject */
	function auItemFilter(Schema, $rootScope) {
		function filterFilter(item, type) {
			// this likely isn't necessary if we use $populated properties liberally,
			// but just in case someone passes a raw ID instead of a cached resource.
			// note that this will fail to locate a non-cached item.
			if (typeof item == 'string' && type) {
				// this is ugly, but since we don't cache Organization, little choice
				if (type == 'Organization') {
					return $rootScope.Organization.Name
				} else {
					var origItem = angular.copy(item)
					if (origItem.length == 24) //protect against bad data
						item = Schema.resource(type).getCache({ _id: item })[0]
				}
			}

			// bad; get out.
			if (!item || !item.$key) {
				return origItem
			}

			if (item._placeholder)
				return origItem

			// force the item to filter itself.
			return item.toString()
		}
		filterFilter.$stateful = true

		return filterFilter
	}
	
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		.directive('validateColor', validateColor);

/**
 * @ndgoc directive
 * @module alignus.directives
 * @name validateColor
 * @restrict AC
 * 
 * @description
 * Checks if an inputted color can be parsed as a real color.
 * Colors can be things like #0033FF, red, rgba(0, 0, 0, 0.87), etc.
 * 
 * @usage
 * <hljs>
 * <md-input-container>
 * 	<input type="text" ng-model="vm.color" validate-color />
 * 	<div ng-message="color">
 * 		Please enter a valid color.
 * 	</div>
 * </md-input-container>
 * </hljs>
 * 
 *
 * @param {} 
 */
	function validateColor() {
		return {
			require: "ngModel",
			link: function (scope, element, attributes, ngModel) {
				ngModel.$validators.color = function (modelValue, viewValue) {
					return window.tinycolor(ngModel.$viewValue).isValid();
				};
			}
		};
}
})();
(function() {
	"use strict";
	usersPermissionsTree.$inject = ["$compile", "$filter", "$http", "toast", "permissionText"];
	angular
		.module('alignus.directives')
		.directive('usersPermissionsTree', usersPermissionsTree);

	function usersPermissionsTree($compile, $filter, $http, toast, permissionText) {
		/**
		 * Directive to recursively create a set of nested levels
		 * of permissions with checkboxes that can correctly bind
		 * to the permission they correspond to. Supports il8n.
		 * 
		 * @param {Object} permissions Effective Permissions object to render.
		 * @param {string} basePerm The base actual permission object.
		 * @param {boolean} canDeny Whether or not the deny option is shown.
		 */
		var perms = '';
		return {
			restrict: 'E',
			link: link,
			template: '',
			scope: {
				detail: '='
			}
		};

		// function compile(tElem, tAttr) {
		function link($scope, tElem, tAttr) {

			$scope.pathToObject = function(path, value) {
				// lol this hack
				var arr = path.replace('detail.Permissions.', '').split('.');
				return JSON.parse('{"' + arr.join('": {"') + '": ' + value + '' + '}'.repeat(arr.length));
			}

			$scope.setPermission = function(path, value) {
				console.debug('setPermission', arguments)
				switch (path) {
					case "detail.Permissions.Users.CanViewEmploymentInfo":
						$scope.detail.setPermission({ "Users": { "CanViewEmploymentInfo": value, "CanViewEmploymentInfoCriteria": { "ReportsTo": ['PermissionHolder'] } } })
						break
					default:
						var permObj = $scope.pathToObject(path, value);
						$scope.detail.setPermission(permObj);
				}
			}

			$scope.removePermission = function(path) {
				return $scope.detail.removePermission(path.replace('detail.Permissions.', ''))
					.then(function() {
						$http.get('/api/user/' + $scope.detail._id + '/EffectivePermissions')
							.then(function(res) {
								$scope.detail.effectivePermissions = res.data;
							})
					});
			}

			$scope.toggleSysAdmin = function() {
				try { // long object chains are dangerous
					if ($scope.detail.Permissions.SysAdmin) {
						$scope.removePermission('SysAdmin')
							.catch(function(response) {
								// this catch handles the case where there is only 1
								// remaining sysadmin
								$scope.detail.Permissions.SysAdmin = true
								toast.error(response.data.err)
							})
					} else {
						$scope.setPermission('SysAdmin', true);
					}
				} catch (err) {
					console.warn('No SysAdmin permission found, assuming unset (i.e. false). Setting to true.')
					$scope.setPermission('SysAdmin', true);
				}
			}

			$scope.strGrant = "Grant"
			$scope.strDeny = "Deny"

			var base = "detail.Permissions."

			var canDeny = ((tAttr.canDeny == 'true') || (tAttr.canDeny === undefined));

			$scope.detail.effectivePermissions()
				.then(function(res) {
					$scope.effectivePermissions = res.data

					// recursively add containers and stuff to make html
					var child = weMustGoDeeper(res.data, 0, '', base, canDeny);
					child.attr('class', tAttr.class); // pass classes along
					tElem.append($compile(child)($scope));

				})
		}

		// recursively figure out what the hell the dom is supposed to do
		function weMustGoDeeper(remainingTree, level, pathSoFar, base, canDeny) {
			if (!level) level = 0;
			if (!pathSoFar) pathSoFar = '';
			var lvl = level + 1;

			//do not attempt to render criteria or list permissions (for dynamic permissions)
			if (pathSoFar.substr(pathSoFar.length - 8) == "Criteria" || pathSoFar.substr(pathSoFar.length - 4) == "List") return

			var path = 'EDITPERMISSIONS.' + pathSoFar.toUpperCase();

			if (typeof remainingTree === "boolean") { // reached a permission
				var html;
				switch (level) {
					case 1:
						html = '<md-list-item><md-checkbox aria-label="' + path + '" ng-model="::' + perms + base + pathSoFar + '" ng-click="toggleSysAdmin()" class="md-accent"></md-checkbox><span class="md-body-1">' + Object.byString(permissionText, path.replace('EDITPERMISSIONS.', '')) + '</span></md-list-item>';
						break;
					case 2:
					case 3:
						html = '<md-list-item layout="column" layout-align="center start">' +
							'<div layout="row"><h3 class="md-body-1">' + (Object.byString(permissionText, path.replace('EDITPERMISSIONS.', '')) || path) + '</h3><au-help-icon key="' + path + '"></au-help-icon></div>' +
							'<md-radio-group layout="row" layout-wrap ng-model="::' + perms + base + pathSoFar + '">' +
							'<md-radio-button id="Rdo' + path + '0" aria-label="Grant" ng-value="true" class="md-accent" ng-click="setPermission(\'' + base + pathSoFar + '\', true)">' +
							'<span class="md-body-1">Grant</span>' +
							'</md-radio-button>' +
							(canDeny ? '<md-radio-button id="Rdo' + path + '1" aria-label="Deny" ng-value="false" class="md-accent" ng-click="setPermission(\'' + base + pathSoFar + '\', false)">' +
								'<span class="md-body-1">Deny</span>' +
								'</md-radio-button>' : '') +
							'<md-radio-button id="Rdo' + path + '2" aria-label="Inherit" ng-value="undefined" class="md-accent" ng-click="removePermission(\'' + base + pathSoFar + '\')">' +
							'<span class="md-body-1">' +
							'<span>Default</span>' +
							'<span ng-if="' + perms + base + pathSoFar + '==undefined">' +
							' ({{' + perms + 'effectivePermissions.' + pathSoFar + ' ? strGrant : strDeny}})' +
							'</span>' +
							'</span>' +
							'</md-radio-button>' +
							'</md-radio-group>' +
							'</md-list-item>';
						break;
				}
				return angular.element(html)
			} else if (typeof remainingTree === "object") { // we must go deeper!

				var container;
				switch (level) {
					case 0:
						container = angular.element('<div class="perms-container">');
						break;
					case 1:
						container = angular.element('<md-list ng-if="!detail.Permissions.SysAdmin"><span class="md-title">' + (Object.byString(permissionText, path.replace('EDITPERMISSIONS.', '') + '.TITLE') || path) + '</span></md-list>');
						break;
					case 2:
						container = angular.element('<span/>');
						break;
				}
				angular.forEach(Object.keys(remainingTree), function(branch) {
					// this property contains more properties
					var dot = level != 0 ? '.' : ''; // dots between levels
					var child = weMustGoDeeper(remainingTree[branch], lvl, pathSoFar + dot + branch, base, canDeny);
					if (level == 0 && branch != 'SysAdmin') container.append(angular.element('<md-divider ng-if="!detail.Permissions.SysAdmin">'));
					container.append(child);
				})
				return container;
			} else {
				console.error('We found an invalid thing in our EffectivePermissions for usersPermissionsTree');
				console.error('Types "object" or "boolean" expected but "' + typeof remainingTree + '" found');
			}
		}

	}
})();
(function() {
	'use strict';

	s3Src.$inject = ["s3Url"];
	angular
		.module('alignus.directives')
		.directive('s3Src', s3Src);

	/**
	 * @ndgoc directive
	 * @module alignus.directives
	 * @name s3Src
	 * @restrict A
	 * 
	 * @description
	 * Called s3Src internally. Allows pictures to easily be displayed from
	 * our Amazon S3 storage instance.
	 * 
	 * @usage
	 * <hljs>
	 * 	<img s3-src="/assets/images/login" />
	 * </hljs> 
	 */

	/* @ngInject */
	function s3Src(s3Url) {
		var directive = {
			link: link,
			restrict: 'A'
		};
		return directive;

		//expect that everything in /assets/images/ is also on S3 in our "UI" folder
		function link($scope, $element, $attrs, $ctrl) {
			$attrs.$observe('s3Src', setUrl)
			function setUrl() {
				var finalSrc = $attrs.s3Src				
				if(window.getImagesFromS3) {
					finalSrc = finalSrc.replace('/assets/images/', '')
					finalSrc = s3Url + finalSrc
					$element.attr('src', finalSrc)
				} else {
					$element.attr('src', finalSrc)
				}
			}
		}
	}
})();
(function() {
	'use strict';

	s3Background.$inject = ["s3Url"];
	angular
		.module('alignus.directives')
		.directive('s3Background', s3Background);

	/**
	 * @ndgoc directive
	 * @module alignus.directives
	 * @name s3Src
	 * @restrict A
	 * 
	 * @description
	 * Called s3Src internally. Allows pictures to easily be displayed from
	 * our Amazon S3 storage instance.
	 * 
	 * @usage
	 * <hljs>
	 * 	<img s3-background="/assets/images/login" />
	 * </hljs> 
	 */

	/* @ngInject */
	function s3Background(s3Url) {
		var directive = {
			link: link,
			restrict: 'A'
		};
		return directive;

		//expect that everything in /assets/images/ is also on S3 in our "UI" folder
		function link($scope, $element, $attrs, $ctrl) {
			var finalSrc = $attrs.s3Background

			if(window.getImagesFromS3) {
				finalSrc = finalSrc.replace('/assets/images/', '')
				finalSrc = s3Url + finalSrc
				$element.css('background-image', 'url(' + finalSrc + ')')
			} else {
				$element.css('background-image', 'url(' + finalSrc + ')')
			}

		}
	}
})();

/* global Ps */
angular.module('app')
	.directive('perfectScrollbar', ['$parse', '$timeout', 'auUtility', '$interval', function ($parse, $timeout, auUtility, $interval) {
		return {
			restrict: 'EA',
			transclude: true,
			template: '<div><div ng-transclude></div></div>',
			scope: {
				atScrollEnd: "&?"
			},
			replace: true,
			link: function (scope, elem, attr) {
				var scroll_opts = $parse(attr['opts'])(scope);
				var el = elem[0];
				var scrollEndDebounce

				Ps.initialize(el, scroll_opts);

				var obs_opts = {
					childList: true,
					subtree: true,
					characterData: true,
				};

				if (typeof MutationObserver === "function") {
					var obs = new MutationObserver(function () {
						Ps.update(el);
					});
					obs.observe(el, obs_opts);
				} else {
					console.warn(module.exports + ': Your browser does not support MutationObserver.')
				}

				if (scope.atScrollEnd) {
					$timeout(function () {
						scope.$evalAsync(function () {
							document.addEventListener('ps-y-reach-end', scrollEndDebounce)
						})
					}, 1000)
				}

				var lastScrollTop
				// debounce the "at scroll end" function
				scrollEndDebounce = debounce(function() {
					if (el.scrollTop == 0) return
					// flash the "loading more" tip
					auUtility.showLoadingMore(el)
					// call the user-provided function
					scope.atScrollEnd();				
				}, 100, true)

				scope.$watch('update', function (n, o) {
					if (n) {
						Ps.update(el);
						scope.update = false;
					}
				});

				scope.$on('destroy', function () {
					obs.disconnect();
					Ps.destroy(el);

					//stop listening for the atScrollEnd event
					if (scope.atScrollEnd) {
						document.removeEventListener('ps-y-reach-end', scrollEndDebounce)
					}
				});
			}
		};
	}]);
(function () {
	'use strict';
  
	angular.module('app').directive("ngInject", ["$parse", "$interpolate", "$controller", "$compile", function($parse, $interpolate, $controller, $compile) {
		return {
		  terminal: true,
		  transclude: true,
		  priority: 510,
		  link: function(scope, element, attrs, ctrls, transclude) {
	  
			if (!attrs.ngController) {
			  element.removeAttr("ng-inject");
			  $compile(element)(scope);
			  return;
			}
	  
			var controllerName = attrs.ngController;
	  
			var newScope = scope.$new(false);
	  
			var locals = $parse(attrs.ngInject)(scope);
			locals.$scope = newScope;
			locals.$element = element
	  
			var controller = $controller(controllerName, locals);
	  
			element.data("ngControllerController", controller);
	  
			element.removeAttr("ng-inject").removeAttr("ng-controller");
			$compile(element)(newScope);
			transclude(newScope, function(clone){
			  element.append(clone);
			});
			// restore to hide tracks
			element.attr("ng-controller", controllerName); 
		  }
		};
	  }]);
  
  })();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		.directive('ngEnterKey', ["$parse", function ($parse) {
			return function (scope, element, attrs) {
				element.bind("keydown keypress", function (event) {
					if (event.which === 13) {
						scope.$apply(function () {
							var exp = $parse(attrs.ngEnterKey)
							exp(scope, {$event: event})
							//could just be: scope.$eval(attrs.ngEnterKey); but I wanted to pass the event (to detech shift/ctrl/etc)
						});

						event.preventDefault();
					}
				});
			};
		}]);

})();
(function () {
  'use strict';

  angular.module('app').directive('ngCompiledInclude', [
    '$compile',
    '$templateCache',
    function ($compile, $templateCache) {
      return {
        restrict: 'A',
        priority: 400,
        compile: function (element, attrs) {
          var templateName = attrs.ngCompiledInclude;
          var template = $templateCache.get(templateName);
          element.html(template);
        }
      };
    }
  ]);

})();
(function () {
    'use strict';
    angular
        .module('alignus.directives')
        .directive('inputMatch', inputMatch);

/**
 * @ndgoc directive
 * @module alignus.directives
 * @name inputMatch
 * @restrict A
 * 
 * @description
 * based on http://odetocode.com/blogs/scott/archive/2014/10/13/confirm-password-validation-in-angularjs.aspx
 * Makes sure two text fields match. Useful for confirming passwords.
 * 
 * 
 * @usage
 * <hljs>
 * <input type="password" ng-model="vm.user.password" />
 * <input type="password" ng-model="vm.pwconfirm" other-model-value="vm.user.password" />
 * </hljs>
 *
 * @param {} 
 */
	function inputMatch() {
		return {
			require: "ngModel",
			scope: {
				otherModelValue: "=inputMatch"
			},
			link: function(scope, element, attributes, ngModel) {
				
				ngModel.$validators.inputMatch = function(modelValue) {
					return modelValue == scope.otherModelValue;
				};
	
				scope.$watch("otherModelValue", function() {
					ngModel.$validate();
				});
			}
		};
	}
})();
(function () {
    'use strict';

	controller.$inject = ["$scope", "$attrs"];
    angular
	.module('alignus.directives')
/**
 * @ndgoc directive
 * @module alignus.directives
 * @name auGroupsList
 * @restrict ACE
 * 
 * @description
 * Displays a list of groups with checkboxes.
 * 
 * @usage
 * <hljs>
 * 	<au-groups-list
 * 		groups="vm.availableGroups"
 * 		user="vm.user"
 * 		direction="column">
 * 	</au-groups-list>
 * </hljs>
 *
 * @param {$resource[]} groups List of groups to display
 * @param {$resource} user User to bind the list of groups to
 * @param {string} direction "row" or "column", the layout-direction to display the list in
 */
	.directive('auGroupsList', function() {
		return {
			scope: {
				'groups': '=',
				'user': '=',
				'direction': '='
			},
			template: '' +
				'<div layout="{{gvm.direction}}" layout-wrap>' +
					'<md-checkbox ng-repeat="group in gvm.groups track by group._id" ng-checked="gvm.groupExists(group, gvm.user.PermissionPresets)" ng-click="gvm.groupToggle(group, gvm.user.PermissionPresets)" ng-attr-id="CbxPreset{{$index}}">' +
						'{{ group.Name }}' +
					'</md-checkbox>' +
				'</div>',
			link: link,
			controller: controller,
			controllerAs: 'gvm', // groups viewmodel
			bindToControler: true // gvm.attr instead of $scope.attr
		}
	});
	
	function link($scope, $element, $attrs, $controller) {
		$scope.layout = $attrs.layout || "column";
		
	}

	/* @ngInject */
	function controller($scope, $attrs) {
		var gvm = this;
		
		gvm.groupExists = groupExists;
		gvm.groupToggle = groupToggle;
		
		gvm.user = $scope.user;
		gvm.groups = $scope.groups;
		
		gvm.direction = $attrs.direction || "column";
	}
	
	function groupExists(group, groupList) {
		// double-check any groups at all are available
		if (!groupList) return false;
		// Iterate through available groups. Check if the _id of
		// the group matches any _id's of the group list. If it
		// does, return that index position. Note: If for some
		// reason a group is in the groups list twice it will
		// return the later one, but hopefully that won't happen.
		return groupList.reduce(function (prev, curr, index) {
			return (group._id == curr) ? index : prev;
		}, -1) > -1;
	}

	function groupToggle(group, groupList) {
		// double-check any groups at all are available
		if (!groupList) return false;
		// get index based off of "user" IDs of the groups.
		// We can't use indexOf since one's a cachedResource and the
		// other is a normal mongoose-populated Group object
		var index = groupList.reduce(function (prev, curr, index) {
			return (group._id == curr) ? index : prev;
		}, -1);
		// If the group isn't already on the user append it
		if (index > -1) {
			groupList.splice(index, 1);
			// Otherwise we're unchecking and want to remove it.
		} else {
			groupList.push(group._id);
		}
	}
})();
(function () {
	'use strict';
	

angular.module('app').directive('dynamic', ["$compile", "$parse", function ($compile, $parse) {
  return {
    restrict: 'A',
    replace: true,
    link: function (scope, ele, attrs) {
      var exp = attrs.dynamic
      var oneTime = false
      if (exp.substr(0, 2) == "::") {
		exp = exp.substr(2)
		oneTime = true
      }
      var unWatch = scope.$watch(exp, set);

      function set(html) {
        ele.html(html);
        $compile(ele.contents())(scope);
        if (oneTime && html) {
        	unWatch()
        }
      }
    }
  };
}]);

})();

(function () {
    'use strict';

    angular
	.module('alignus.directives')
	.directive('datePickerContainer', ["$rootScope", "$timeout", "$compile", function($rootScope, $timeout, $compile) {
		return {
			scope: {
				input: "=?"
			},
			link: link,
			restrict: 'AE'
		}

		function link($scope, $element, $attrs, $controller) {
			$element.addClass('date-picker-container')

			//find the date picker
			var input = $element.find('input')[0]
			input.onfocus = function(){$scope.$apply(function(){
				$scope.isFocused = true
			})}
			
			input.onblur = function(){$scope.$apply(function(){
				$scope.isFocused = false
			})}
			$scope.input = input

			//apply the ng-class to the label
			var label = $element.find('label')
			label.attr('ng-class', "{'hasContent' : input.value.length > 0 || isFocused}")
			$compile(label[0])($scope)
		}
	}]);
})();
(function() {
	'use strict';

	autoSaveForm.$inject = ["$timeout", "auUtility"];
	angular
		.module('alignus.directives')
		.directive('autoSaveForm', autoSaveForm)

	function autoSaveForm($timeout, auUtility) {
		/**
		 * @ndgoc directive
		 * @module alignus.directives
		 * @name autoSafeForm
		 * @restrict A
		 * @require form
		 * 
		 * @description
		 * Autosaves a form after 3 seconds of inactivity.
		 * Also autosaves when the form is about to be unloaded.
		 * 
		 * @usage
		 * <hljs>
		 * <form auto-save-form="vm.save()" cached-resource="vm.user">
		 * 	<input type="text" ng-model="vm.user.FirstName" />
		 * </form>
		 * </hljs>
		 *
		 * @param {function} autoSaveForm The function to call when the form wants to save.
		 * @param {number} debounceDelay How long to wait before saving the form. Default 3000.
		 * @param {$resource} cachedResource The resource that's being edited in the field
		 * @param {string[]} ignoreFields List of strings of names of fields to not monitor for changes. 
		 */
		return {
			require: ['form'],
			scope: {
				autoSaveForm: "&",
				debounceDelay: "=?",
				cachedResource: "=",
				ignoreFields: "=?",
				autoSaveOnDirty: "&?"
			},
			link: function($scope, $element, $attrs, $ctrl) {
				//locals
				var pendingTimeout;

				//put a reference to the form on scope so we can watch it
				$scope.formCtrl = $ctrl[0]

				//default the saved state to true
				$scope.formCtrl.$saved = true

				//default the debounceDelay to 3 seconds
				if ($scope.debounceDelay == undefined) $scope.debounceDelay = 3000

				//keep with a copy of the cachedResource we are watching in memory so we can check if it changes
				var savedVmDetail = angular.copy($scope.cachedResource)

                $scope.$root.findInParentScope($scope, 'vm', true).editItemForm = $scope.formCtrl

				//watch the form's $pristine value which changes immediately and is cheap to watch because it's just a boolean
				var isPristine = true
				$scope.$watch(function(){
					//don't react to changes if the form is not visible
					if (!$element.is(':visible')) return

					//get out if the cachedResource didn't change 
					if (!auUtility.cachedResourceChanged($scope.cachedResource, savedVmDetail, $scope.ignoreFields)) {
						return
					}

					//if a field that impacts acl changed, invalidate the acl cache
					if (auUtility.requiresAclGeneration($scope.cachedResource, savedVmDetail)) $scope.cachedResource.invalidateAclCache()
					
					//notify of dirty state
					if ($scope.autoSaveOnDirty) $scope.autoSaveOnDirty()

					//write a property to the form so we can save on close if the timeout doesn't fire in time
					$scope.formCtrl.$saved = false

					//save a copy to the new reference
					savedVmDetail = angular.copy($scope.cachedResource)

					//clear any other wait we established
					if (pendingTimeout) 
						$timeout.cancel(pendingTimeout);

					//wait for a bit and then execute our save
					pendingTimeout = $timeout(function() {
						//call whatever function was passed in to auto save
						$scope.autoSaveForm()

						//since we just saved, keep a new copy
						savedVmDetail = angular.copy($scope.cachedResource)

						//mark the form as $saved
						$scope.formCtrl.$saved = true
					}, $scope.debounceDelay);
				}, angular.noop)

				//update the savedVmDetail when the item changes outside of the controller
				$scope.$on('itemUpdated', function(event, item){
					if (item.$key != $scope.cachedResource.$key || item._id != $scope.cachedResource._id) return

					savedVmDetail = angular.copy($scope.cachedResource)
				})

				//persist any pending saves when the form is closed
				$scope.$on('$destroy', function() {
					if (!$scope.formCtrl.$saved) $scope.autoSaveForm()
				})
			}
		};
	}

})();
(function () {
    'use strict';

    serviceFn.$inject = ["$rootScope"];
    angular
        .module('alignus.directives')
        .directive('auSuspendable', ["$rootScope", "$interpolate", "auSuspendable", function ($rootScope, $interpolate, auSuspendable) {
            return {
                //traverse via the $childHead of my element <rg-repeat ... au-suspendable .../>
                scope: true,
                priority: 10000, //be the last directive in line
                restrict: 'A',
                link: linkFn($rootScope, $interpolate, auSuspendable)
            }
        }])
        .directive('auSuspendable', ["$rootScope", "$interpolate", "auSuspendable", function ($rootScope, $interpolate, auSuspendable) {
            return {
                //transclude all child elements so we can access them via $childHead when used as an element <au-suspendable .../>
                scope: true,
                restrict: 'E',
                transclude: true,
                template: '<ng-transclude></ng-transclude>',
                link: linkFn($rootScope, $interpolate, auSuspendable)
            }
        }]);

    angular.module('app').service('auSuspendable', serviceFn);

    function serviceFn($rootScope) {
        var This = this

        //api
        This.suspend = suspend
        This.resume = resume
        This.stale = stale

        //function definitions
        function suspend(myScope) {
            initScope(myScope)

            //propagate to my children
            var child = myScope.$$childHead
            while (child && !child.hasOwnProperty('$isAuSuspendable')) {
                suspend(child)
                child = child.$$nextSibling
            }
        }

        function resume(myScope) {
            myScope.suspended = false

            var child = myScope.$$childHead
            while (child && !child.hasOwnProperty('$isAuSuspendable')) {
                resume(child)
                child = child.$$nextSibling
            }
        }

        function stale(myScope) {
            //console.debug('staling scope', myScope.$id, 'stale/suspended/initing', myScope.stale, myScope.suspended, myScope.initing)
            myScope.stale = true

            var child = myScope.$$childHead
            while (child && !child.hasOwnProperty('$isAuSuspendable')) {
                stale(child)
                child = child.$$nextSibling
            }
        }

        function initScope(myScope) {
            //save the $$watchers...
            if (!myScope.hasOwnProperty('watchers')) {
                if (myScope.watchers === null) myScope.watchers = []
                else myScope.watchers = myScope.$$watchers || []

                //... and then tell $digest there is nothing to watch here!
                //redefine the $$watchers property as a function to pick and choose when to return things to $digest
                delete myScope.$$watchers
                Object.defineProperty(myScope, '$$watchers', {
                    get: get$$watchers,
                    set: set$$watchers,
                    configurable: true
                })

                myScope.initing = true
                setTimeout(function () { myScope.initing = false }, 3000)

                if (myScope.updateOnEvent) myScope.$on('updateSuspended', function updateSuspended(event, eventName) {
                    if (myScope.updateOnEvent == eventName) {
                        updateScope()
                    }
                });

                if (myScope.updateOnItem) myScope.$on('itemUpdated', function updateItem(event, item) {
                    if (myScope.updateOnItem == item.$key + '-' + item._id) {
                        updateScope()
                    }
                })

                //stale the scope and then digest the scope
                function updateScope() {
                    stale(myScope)
                    try {
                        if (!myScope.$$phase && !$rootScope.$$phase) myScope.$digest()
                    } catch (e) { }
                }
            }

            myScope.stale = false
            myScope.suspended = true


            if (myScope.hasOwnProperty('$alwaysWatch')) {
                myScope.myWatchers = myScope.$alwaysWatch
            } else {
                myScope.myWatchers = []
            }
            myScope.myWatchers.unshift = watcherUnshift.bind(myScope)

        }

        function set$$watchers(val) {
            this.watchers = val
        }

        function get$$watchers() {
            var This = this

            //due to scope prototypical inheritance, luckily, new scopes created by ng-repeat and others already have $$watchers as a get function, init new scopes
            if (!This.hasOwnProperty('watchers')) {
                initScope(This)
            }

            if (This.stale || !This.suspended || This.initing) {
                //console.debug('not suspended', This.$id, 'stale/suspended/initing', This.stale, This.suspended, This.initing)

                if (!This.initing) This.stale = false
                return This.watchers
            } else {
                return This.myWatchers
            }
        }

        function watcherUnshift(val) {
            var This = this
            if (This.watchers === null) This.watchers = []
            This.watchers.unshift(val)

            This.stale = true
            This.initing = true
            setTimeout(function () { This.initing = false }, 3000)
        }

        var totalWatchers, totalScopes = 0
        $rootScope.printAllWatchers = function () {
            totalWatchers = 0, totalScopes = 0
            printWatchers($rootScope)
            console.info('=== TOTAL WATCHERS / SCOPES ===', totalWatchers, totalScopes)
        }

        function printWatchers(myScope) {
            console.log('--- scope id ' + myScope.$id, (myScope.$$watchers || []).length)
            totalWatchers += (myScope.$$watchers || []).length
            totalScopes++

            var child = myScope.$$childHead
            while (child) {
                printWatchers(child)
                child = child.$$nextSibling
            }
        }
    }

    function linkFn($rootScope, $interpolate, auSuspendable) {
        return function (scope, element, attributes, ngModel) {
            //set a property to tell which scope started the suspension
            scope.$isAuSuspendable = true
            scope.initing = true

            //listen for an event value (ex: $rootScope.$broadcast('updateSuspended', 'recent'))
            if (element.attr('update-on-event')) {
                scope.updateOnEvent = $interpolate(element.attr('update-on-event'))(scope)
                if (scope.updateOnEvent !== element.attr('update-on-event')) {
                    scope.interpolationUsed = true
                }
            }

            if (element.attr('update-on-item')) {
                scope.updateOnItem = $interpolate(element.attr('update-on-item'))(scope)
            }

            //create a watch, to save lots of watches when an expression is true (ex: !root.isRightSidebarOpen)
            //when the expression evaluates to false the scope becomes "live" - the internal .watchers array is always returned until the expression evaluates back to true and suspened
            if (element.attr('suspend-when')) {
                scope.suspendWhen = element.attr('suspend-when')
            } else {
                scope.suspendWhen = null
            }

            //run on start up
            if (scope.suspendWhen) {
                setTimeout(function () {
                    //ironically, create a watch which will always be returned
                    scope.$watch(scope.suspendWhen, function (newVal, oldVal) {
                        if (newVal) {
                            scope.$$postDigest(function () {
                                auSuspendable.suspend(scope)
                            })
                        } else {
                            auSuspendable.resume(scope)
                        }
                    })

                    //save this watch to return only it when $$watchers is retuned
                    scope.$alwaysWatch = [scope.$$watchers[0]]
                }, 1000)

            } else {
                //wait for 1sec, giving angular plenty of time to compile, transclude, etc. before suspending the scope
                setTimeout(function () {
                    auSuspendable.suspend(scope)
                }, 1000)
            }

        }
    }
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		.directive('auGrowTextarea', auGrowTextarea);

	/* @ngInject */
	function auGrowTextarea() {
		var directive = {
			link: link,
			restrict: 'A'
		};
		return directive;

		function link($scope, $element, $attrs, $ctrl) {
			$element.css('overflow-y', 'hidden')
			$element.css('height', 'auto')

			$scope.$watch($attrs.ngModel, setThisHeight)
			$element.click(setThisHeight)
			$element.one('mouseenter', setThisHeight)
			$element.one('focus', setThisHeight)

			function setThisHeight(){
				setHeight($element[0])
			}
		}
	}

	//there really is no good event to know when a node is inserted into the dom but this pattern works!
	//https://davidwalsh.name/detect-node-insertion
	function insertListener(event){
		if (event.animationName == "nodeInserted") {
			angular.element('textarea[au-grow-textarea]:not(.inited)').each(function(idx, node){
				setHeight(node)
				node.classList.add('inited')
			})
			
		}
	}

	function setHeight(el){
		el.style.height = 'auto'
		el.style.height = Math.max(24, el.scrollHeight - 0) + 'px'
	}

	document.addEventListener("animationstart", insertListener, false); // standard + firefox
	document.addEventListener("MSAnimationStart", insertListener, false); // IE
	document.addEventListener("webkitAnimationStart", insertListener, false); // Chrome + Safari

})();
(function () {
    'use strict';

    angular
	.module('alignus.directives')
/**
 * @ndgoc directive
 * @module alignus.directives
 * @name auFocusOnLoad
 * @restrict A
 * 
 * @description
 * Makes an element take focus once it's ready. This was in response
 * to a bug with focus between $mdDialog and mdFabSpeedDial but it's
 * pretty useful for setting initial focus anywhere.
 * 
 * @usage
 * <hljs>
 * <input ng-model="vm.userName" au-focus-on-load />
 * </hljs>
 */
	.directive('auFocusOnLoad', function() {
		return {
			link: link,
			restrict: 'A'
		}
	});
	
	function link($scope, $element, $attrs, $controller) {
		$element.ready(function() {
			$element.focus()
		})
	}
})();
(function () {
	'use strict';

	angular
		.module('alignus.directives')
		/**
		 * @ndgoc directive
		 * @module alignus.directives
		 * @name auCanEdit
		 * @restrict A
		 *
		 * @param {String} auCanEdit The permission needed to edit a field or set of fields
		 *
		 * @description
		 * Sets a field or set of fields to be editable or not based on
		 * a given system permission.
		 *
		 * @usage
		 * <div au-can-edit="Users.CanEdit">
		 *   <input ng-model="something" />
		 * </div>
		 *
		 * @usage
		 * <input ng-model="something" au-can-edit="Users.CanEdit" />
		 *
		 */
		.directive('auCanEdit', ["$rootScope", "$timeout", "$q", function ($rootScope, $timeout, $q) {
			return {
				scope: {
					auCanEdit: '=',
					acl: '@'

				},
				link: link,
				restrict: 'A'
			}

			function link($scope, $element, $attrs, $controller) {
				if ($scope.acl) {
					var item = $scope.auCanEdit
					item.userHasAcl('U').then(function (hasPerm) {
						if (hasPerm) return //don't disable anything
						ensureDisabled()
					})
				} else {
					if ($scope.auCanEdit) return
					ensureDisabled()
				}

				function ensureDisabled() {
					// run this a few times in case any directives take that long to appear/compile
					$timeout(disableAll, 100)
					$timeout(disableAll, 1100)
					$timeout(disableAll, 2000)
					$timeout(disableAll, 5000)
				}

				function disableAll() {
					$element.attr('readonly', true)
					$element.find('md-datepicker').attr('ngDisabled', true)
					// mdp-date-picker has a custom attribute called "mdp-disabled"
					// that could be used to disable the datepicker the "approved"
					// way, but it's only applied on link, which means using it to
					// programmatically disable mdp-date-pickers would necessitate
					// recompiling all of them. so i used this.
					// the >>> is not great, but...
					$element.find('mdp-date-picker>>>input').attr('disabled', true)
					$element.find('mdp-time-picker>>>input').attr('disabled', true)
					$element.find('button,md-radio-button,md-checkbox,au-image-uploader>div').attr('disabled', true)
					$element.find('.au-can-edit-button').css('pointer-events', 'none')
					// we never want to disable "open a document" buttons from
					// the auDocumentSection directive
					angular.element(angular.element.find('[id^=StringDoc]')).find('button').attr('disabled', false)
					angular.element(angular.element.find('[id^=BtnSortAttachedDocs]')).attr('disabled', false)
					$element.find('input,md-chips').attr('readonly', true)
					$element.find('textarea').attr('readonly', true)
					$element.find('md-select').replaceWith(function () {
						if (this.innerText != undefined && this.innerText != 'undefined') {
							return '<p>' + this.innerText + '</p>'
						} else {
							return '<p>' + '' + '</p>'
						}
					})
					$element.find('[contenteditable=true]').attr('contenteditable', false)
					$element.find('[ngf-select]').attr('disabled', true)
					$element.find('md-switch').attr('disabled', true)
					$element.find('.usercard-button, .tms-toggle-wrap').css('pointer-events', 'none')					
				}

			}
		}]);
})();
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.0.7
 */
(function (window, angular, undefined) {
    "use strict";

    (function () {
        "use strict";

        angular.module('ngMaterial', ["ng", "ngAnimate", "material.core", "material.core.gestures", "material.core.layout", "material.core.theming.palette", "material.core.theming", "material.core.animate", "material.components.autocomplete", "material.components.backdrop", "material.components.bottomSheet", "material.components.button", "material.components.card", "material.components.checkbox", "material.components.chips", "material.components.content", "material.components.datepicker", "material.components.dialog", "material.components.divider", "material.components.fabActions", "material.components.fabShared", "material.components.fabSpeedDial", "material.components.fabToolbar", "material.components.fabTrigger", "material.components.gridList", "material.components.icon", "material.components.input", "material.components.list", "material.components.menu", "material.components.menuBar", "material.components.progressCircular", "material.components.progressLinear", "material.components.radioButton", "material.components.select", "material.components.showHide", "material.components.sidenav", "material.components.slider", "material.components.sticky", "material.components.swipe", "material.components.subheader", "material.components.switch", "material.components.tabs", "material.components.toast", "material.components.toolbar", "material.components.tooltip", "material.components.virtualRepeat", "material.components.whiteframe"]);
    })();
    (function () {
        "use strict";

        /**
         * Initialization function that validates environment
         * requirements.
         */
        angular
            .module('material.core', [
                'ngAnimate',
                'material.core.animate',
                'material.core.layout',
                'material.core.gestures',
                'material.core.theming'
            ])
            .config(MdCoreConfigure)
            .run(DetectNgTouch);


        /**
         * Detect if the ng-Touch module is also being used.
         * Warn if detected.
         * @ngInject
         */
        function DetectNgTouch($log, $injector) {
            if ($injector.has('$swipe')) {
                var msg = "" +
                    "You are using the ngTouch module. \n" +
                    "Angular Material already has mobile click, tap, and swipe support... \n" +
                    "ngTouch is not supported with Angular Material!";
                $log.warn(msg);
            }
        }
        DetectNgTouch.$inject = ["$log", "$injector"];

        /**
         * @ngInject
         */
        function MdCoreConfigure($provide, $mdThemingProvider) {

            $provide.decorator('$$rAF', ["$delegate", rAFDecorator]);

            $mdThemingProvider.theme('default')
                .primaryPalette('indigo')
                .accentPalette('pink')
                .warnPalette('deep-orange')
                .backgroundPalette('grey');
        }
        MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];

        /**
         * @ngInject
         */
        function rAFDecorator($delegate) {
            /**
             * Use this to throttle events that come in often.
             * The throttled function will always use the *last* invocation before the
             * coming frame.
             *
             * For example, window resize events that fire many times a second:
             * If we set to use an raf-throttled callback on window resize, then
             * our callback will only be fired once per frame, with the last resize
             * event that happened before that frame.
             *
             * @param {function} callback function to debounce
             */
            $delegate.throttle = function (cb) {
                var queuedArgs, alreadyQueued, queueCb, context;
                return function debounced() {
                    queuedArgs = arguments;
                    context = this;
                    queueCb = cb;
                    if (!alreadyQueued) {
                        alreadyQueued = true;
                        $delegate(function () {
                            queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
                            alreadyQueued = false;
                        });
                    }
                };
            };
            return $delegate;
        }
        rAFDecorator.$inject = ["$delegate"];

    })();
    (function () {
        "use strict";

        angular.module('material.core')
            .directive('mdAutofocus', MdAutofocusDirective)

            // Support the deprecated md-auto-focus and md-sidenav-focus as well
            .directive('mdAutoFocus', MdAutofocusDirective)
            .directive('mdSidenavFocus', MdAutofocusDirective);

        /**
         * @ngdoc directive
         * @name mdAutofocus
         * @module material.core.util
         *
         * @description
         *
         * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
         * `$mdBottomSheet`, or `$mdSidenav` opens or upon page load for input-like elements.
         *
         * When one of these opens, it will find the first nested element with the `[md-autofocus]`
         * attribute directive and optional expression. An expression may be specified as the directive
         * value to enable conditional activation of the autofocus.
         *
         * @usage
         *
         * ### Dialog
         * <hljs lang="html">
         * <md-dialog>
         *   <form>
         *     <md-input-container>
         *       <label for="testInput">Label</label>
         *       <input id="testInput" type="text" md-autofocus>
         *     </md-input-container>
         *   </form>
         * </md-dialog>
         * </hljs>
         *
         * ### Bottomsheet
         * <hljs lang="html">
         * <md-bottom-sheet class="md-list md-has-header">
         *  <md-subheader>Comment Actions</md-subheader>
         *  <md-list>
         *    <md-list-item ng-repeat="item in items">
         *
         *      <md-button md-autofocus="$index == 2">
         *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
         *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
         *      </md-button>
         *
         *    </md-list-item>
         *  </md-list>
         * </md-bottom-sheet>
         * </hljs>
         *
         * ### Autocomplete
         * <hljs lang="html">
         *   <md-autocomplete
         *       md-autofocus
         *       md-selected-item="selectedItem"
         *       md-search-text="searchText"
         *       md-items="item in getMatches(searchText)"
         *       md-item-text="item.display">
         *     <span md-highlight-text="searchText">{{item.display}}</span>
         *   </md-autocomplete>
         * </hljs>
         *
         * ### Sidenav
         * <hljs lang="html">
         * <div layout="row" ng-controller="MyController">
         *   <md-sidenav md-component-id="left" class="md-sidenav-left">
         *     Left Nav!
         *   </md-sidenav>
         *
         *   <md-content>
         *     Center Content
         *     <md-button ng-click="openLeftMenu()">
         *       Open Left Menu
         *     </md-button>
         *   </md-content>
         *
         *   <md-sidenav md-component-id="right"
         *     md-is-locked-open="$mdMedia('min-width: 333px')"
         *     class="md-sidenav-right">
         *     <form>
         *       <md-input-container>
         *         <label for="testInput">Test input</label>
         *         <input id="testInput" type="text"
         *                ng-model="data" md-autofocus>
         *       </md-input-container>
         *     </form>
         *   </md-sidenav>
         * </div>
         * </hljs>
         **/
        function MdAutofocusDirective() {
            return {
                restrict: 'A',

                link: postLink
            }
        }

        function postLink(scope, element, attrs) {
            var attr = attrs.mdAutoFocus || attrs.mdAutofocus || attrs.mdSidenavFocus;

            // Setup a watcher on the proper attribute to update a class we can check for in $mdUtil
            scope.$watch(attr, function (canAutofocus) {
                element.toggleClass('_md-autofocus', canAutofocus);
            });
        }

    })();
    (function () {
        "use strict";

        angular.module('material.core')
            .factory('$mdConstant', MdConstantFactory);

        /**
         * Factory function that creates the grab-bag $mdConstant service.
         * @ngInject
         */
        function MdConstantFactory($sniffer) {

            var webkit = /webkit/i.test($sniffer.vendorPrefix);

            function vendorProperty(name) {
                return webkit ? ('webkit' + name.charAt(0).toUpperCase() + name.substring(1)) : name;
            }

            return {
                KEY_CODE: {
                    COMMA: 188,
                    SEMICOLON: 186,
                    ENTER: 13,
                    ESCAPE: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT_ARROW: 37,
                    UP_ARROW: 38,
                    RIGHT_ARROW: 39,
                    DOWN_ARROW: 40,
                    TAB: 9,
                    BACKSPACE: 8,
                    DELETE: 46
                },
                CSS: {
                    /* Constants */
                    TRANSITIONEND: 'transitionend' + (webkit ? ' webkitTransitionEnd' : ''),
                    ANIMATIONEND: 'animationend' + (webkit ? ' webkitAnimationEnd' : ''),

                    TRANSFORM: vendorProperty('transform'),
                    TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
                    TRANSITION: vendorProperty('transition'),
                    TRANSITION_DURATION: vendorProperty('transitionDuration'),
                    ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
                    ANIMATION_DURATION: vendorProperty('animationDuration'),
                    ANIMATION_NAME: vendorProperty('animationName'),
                    ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
                    ANIMATION_DIRECTION: vendorProperty('animationDirection')
                },
                /**
                 * As defined in core/style/variables.scss
                 *
                 * $layout-breakpoint-xs:     600px !default;
                 * $layout-breakpoint-sm:     960px !default;
                 * $layout-breakpoint-md:     1280px !default;
                 * $layout-breakpoint-lg:     1920px !default;
                 *
                 */
                MEDIA: {
                    'xs': '(max-width: 599px)',
                    'gt-xs': '(min-width: 600px)',
                    'sm': '(min-width: 600px) and (max-width: 959px)',
                    'gt-sm': '(min-width: 960px)',
                    'md': '(min-width: 960px) and (max-width: 1279px)',
                    'gt-md': '(min-width: 1280px)',
                    'lg': '(min-width: 1280px) and (max-width: 1919px)',
                    'gt-lg': '(min-width: 1920px)',
                    'xl': '(min-width: 1920px)',
                    'print': 'print'
                },
                MEDIA_PRIORITY: [
                    'xl',
                    'gt-lg',
                    'lg',
                    'gt-md',
                    'md',
                    'gt-sm',
                    'sm',
                    'gt-xs',
                    'xs',
                    'print'
                ]
            };
        }
        MdConstantFactory.$inject = ["$sniffer"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.core')
            .config(["$provide", function ($provide) {
                $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {
                    /**
                     * Inject the iterator facade to easily support iteration and accessors
                     * @see iterator below
                     */
                    $delegate.iterator = MdIterator;

                    return $delegate;
                }]);
            }]);

        /**
         * iterator is a list facade to easily support iteration and accessors
         *
         * @param items Array list which this iterator will enumerate
         * @param reloop Boolean enables iterator to consider the list as an endless reloop
         */
        function MdIterator(items, reloop) {
            var trueFn = function () { return true; };

            if (items && !angular.isArray(items)) {
                items = Array.prototype.slice.call(items);
            }

            reloop = !!reloop;
            var _items = items || [];

            // Published API
            return {
                items: getItems,
                count: count,

                inRange: inRange,
                contains: contains,
                indexOf: indexOf,
                itemAt: itemAt,

                findBy: findBy,

                add: add,
                remove: remove,

                first: first,
                last: last,
                next: angular.bind(null, findSubsequentItem, false),
                previous: angular.bind(null, findSubsequentItem, true),

                hasPrevious: hasPrevious,
                hasNext: hasNext

            };

            /**
             * Publish copy of the enumerable set
             * @returns {Array|*}
             */
            function getItems() {
                return [].concat(_items);
            }

            /**
             * Determine length of the list
             * @returns {Array.length|*|number}
             */
            function count() {
                return _items.length;
            }

            /**
             * Is the index specified valid
             * @param index
             * @returns {Array.length|*|number|boolean}
             */
            function inRange(index) {
                return _items.length && (index > -1) && (index < _items.length);
            }

            /**
             * Can the iterator proceed to the next item in the list; relative to
             * the specified item.
             *
             * @param item
             * @returns {Array.length|*|number|boolean}
             */
            function hasNext(item) {
                return item ? inRange(indexOf(item) + 1) : false;
            }

            /**
             * Can the iterator proceed to the previous item in the list; relative to
             * the specified item.
             *
             * @param item
             * @returns {Array.length|*|number|boolean}
             */
            function hasPrevious(item) {
                return item ? inRange(indexOf(item) - 1) : false;
            }

            /**
             * Get item at specified index/position
             * @param index
             * @returns {*}
             */
            function itemAt(index) {
                return inRange(index) ? _items[index] : null;
            }

            /**
             * Find all elements matching the key/value pair
             * otherwise return null
             *
             * @param val
             * @param key
             *
             * @return array
             */
            function findBy(key, val) {
                return _items.filter(function (item) {
                    return item[key] === val;
                });
            }

            /**
             * Add item to list
             * @param item
             * @param index
             * @returns {*}
             */
            function add(item, index) {
                if (!item) return -1;

                if (!angular.isNumber(index)) {
                    index = _items.length;
                }

                _items.splice(index, 0, item);

                return indexOf(item);
            }

            /**
             * Remove item from list...
             * @param item
             */
            function remove(item) {
                if (contains(item)) {
                    _items.splice(indexOf(item), 1);
                }
            }

            /**
             * Get the zero-based index of the target item
             * @param item
             * @returns {*}
             */
            function indexOf(item) {
                return _items.indexOf(item);
            }

            /**
             * Boolean existence check
             * @param item
             * @returns {boolean}
             */
            function contains(item) {
                return item && (indexOf(item) > -1);
            }

            /**
             * Return first item in the list
             * @returns {*}
             */
            function first() {
                return _items.length ? _items[0] : null;
            }

            /**
             * Return last item in the list...
             * @returns {*}
             */
            function last() {
                return _items.length ? _items[_items.length - 1] : null;
            }

            /**
             * Find the next item. If reloop is true and at the end of the list, it will go back to the
             * first item. If given, the `validate` callback will be used to determine whether the next item
             * is valid. If not valid, it will try to find the next item again.
             *
             * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
             * @param {*} item The item whose subsequent item we are looking for
             * @param {Function=} validate The `validate` function
             * @param {integer=} limit The recursion limit
             *
             * @returns {*} The subsequent item or null
             */
            function findSubsequentItem(backwards, item, validate, limit) {
                validate = validate || trueFn;

                var curIndex = indexOf(item);
                while (true) {
                    if (!inRange(curIndex)) return null;

                    var nextIndex = curIndex + (backwards ? -1 : 1);
                    var foundItem = null;
                    if (inRange(nextIndex)) {
                        foundItem = _items[nextIndex];
                    } else if (reloop) {
                        foundItem = backwards ? last() : first();
                        nextIndex = indexOf(foundItem);
                    }

                    if ((foundItem === null) || (nextIndex === limit)) return null;
                    if (validate(foundItem)) return foundItem;

                    if (angular.isUndefined(limit)) limit = nextIndex;

                    curIndex = nextIndex;
                }
            }
        }


    })();
    (function () {
        "use strict";

        angular.module('material.core')
            .factory('$mdMedia', mdMediaFactory);

        /**
         * @ngdoc service
         * @name $mdMedia
         * @module material.core
         *
         * @description
         * `$mdMedia` is used to evaluate whether a given media query is true or false given the
         * current device's screen / window size. The media query will be re-evaluated on resize, allowing
         * you to register a watch.
         *
         * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
         *
         *  <table class="md-api-table">
         *    <thead>
         *    <tr>
         *      <th>Breakpoint</th>
         *      <th>mediaQuery</th>
         *    </tr>
         *    </thead>
         *    <tbody>
         *    <tr>
         *      <td>xs</td>
         *      <td>(max-width: 599px)</td>
         *    </tr>
         *    <tr>
         *      <td>gt-xs</td>
         *      <td>(min-width: 600px)</td>
         *    </tr>
         *    <tr>
         *      <td>sm</td>
         *      <td>(min-width: 600px) and (max-width: 959px)</td>
         *    </tr>
         *    <tr>
         *      <td>gt-sm</td>
         *      <td>(min-width: 960px)</td>
         *    </tr>
         *    <tr>
         *      <td>md</td>
         *      <td>(min-width: 960px) and (max-width: 1279px)</td>
         *    </tr>
         *    <tr>
         *      <td>gt-md</td>
         *      <td>(min-width: 1280px)</td>
         *    </tr>
         *    <tr>
         *      <td>lg</td>
         *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
         *    </tr>
         *    <tr>
         *      <td>gt-lg</td>
         *      <td>(min-width: 1920px)</td>
         *    </tr>
         *    <tr>
         *      <td>xl</td>
         *      <td>(min-width: 1920px)</td>
         *    </tr>
         *    <tr>
         *      <td>print</td>
         *      <td>print</td>
         *    </tr>
         *    </tbody>
         *  </table>
         *
         *  See Material Design's <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">Layout - Adaptive UI</a> for more details.
         *
         *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
         *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
         *  </a>
         *
         * @returns {boolean} a boolean representing whether or not the given media query is true or false.
         *
         * @usage
         * <hljs lang="js">
         * app.controller('MyController', function($mdMedia, $scope) {
         *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
         *     $scope.bigScreen = big;
         *   });
         *
         *   $scope.screenIsSmall = $mdMedia('sm');
         *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
         *   $scope.anotherCustom = $mdMedia('max-width: 300px');
         * });
         * </hljs>
         * @ngInject
         */

        function mdMediaFactory($mdConstant, $rootScope, $window) {
            var queries = {};
            var mqls = {};
            var results = {};
            var normalizeCache = {};

            $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
            $mdMedia.getQuery = getQuery;
            $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;

            return $mdMedia;

            function $mdMedia(query) {
                var validated = queries[query];
                if (angular.isUndefined(validated)) {
                    validated = queries[query] = validate(query);
                }

                var result = results[validated];
                if (angular.isUndefined(result)) {
                    result = add(validated);
                }

                return result;
            }

            function validate(query) {
                return $mdConstant.MEDIA[query] ||
                    ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
            }

            function add(query) {
                var result = mqls[query];
                if (!result) {
                    result = mqls[query] = $window.matchMedia(query);
                }

                result.addListener(onQueryChange);
                return (results[result.media] = !!result.matches);
            }

            function onQueryChange(query) {
                $rootScope.$evalAsync(function () {
                    results[query.media] = !!query.matches;
                });
            }

            function getQuery(name) {
                return mqls[name];
            }

            function getResponsiveAttribute(attrs, attrName) {
                for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
                    var mediaName = $mdConstant.MEDIA_PRIORITY[i];
                    if (!mqls[queries[mediaName]].matches) {
                        continue;
                    }

                    var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
                    if (attrs[normalizedName]) {
                        return attrs[normalizedName];
                    }
                }

                // fallback on unprefixed
                return attrs[getNormalizedName(attrs, attrName)];
            }

            function watchResponsiveAttributes(attrNames, attrs, watchFn) {
                var unwatchFns = [];
                attrNames.forEach(function (attrName) {
                    var normalizedName = getNormalizedName(attrs, attrName);
                    if (angular.isDefined(attrs[normalizedName])) {
                        unwatchFns.push(
                            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
                    }

                    for (var mediaName in $mdConstant.MEDIA) {
                        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
                        if (angular.isDefined(attrs[normalizedName])) {
                            unwatchFns.push(
                                attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
                        }
                    }
                });

                return function unwatch() {
                    unwatchFns.forEach(function (fn) { fn(); })
                };
            }

            // Improves performance dramatically
            function getNormalizedName(attrs, attrName) {
                return normalizeCache[attrName] ||
                    (normalizeCache[attrName] = attrs.$normalize(attrName));
            }
        }
        mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];

    })();
    (function () {
        "use strict";

        /*
         * This var has to be outside the angular factory, otherwise when
         * there are multiple material apps on the same page, each app
         * will create its own instance of this array and the app's IDs
         * will not be unique.
         */
        var nextUniqueId = 0;

        /**
         * @ngdoc module
         * @name material.core.util
         * @description
         * Util
         */
        angular
            .module('material.core')
            .factory('$mdUtil', UtilFactory);

        /**
         * @ngInject
         */
        function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window) {
            // Setup some core variables for the processTemplate method
            var startSymbol = $interpolate.startSymbol(),
                endSymbol = $interpolate.endSymbol(),
                usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));

            /**
             * Checks if the target element has the requested style by key
             * @param {DOMElement|JQLite} target Target element
             * @param {string} key Style key
             * @param {string=} expectedVal Optional expected value
             * @returns {boolean} Whether the target element has the style or not
             */
            var hasComputedStyle = function (target, key, expectedVal) {
                var hasValue = false;

                if (target && target.length) {
                    var computedStyles = $window.getComputedStyle(target[0]);
                    hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
                }

                return hasValue;
            };

            var $mdUtil = {
                dom: {},
                now: window.performance ?
                    angular.bind(window.performance, window.performance.now) : Date.now || function () {
                        return new Date().getTime();
                    },

                /**
                 * Bi-directional accessor/mutator used to easily update an element's
                 * property based on the current 'dir'ectional value.
                 */
                bidi: function (element, property, lValue, rValue) {
                    var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');

                    // If accessor
                    if (arguments.length == 0) return ltr ? 'ltr' : 'rtl';

                    // If mutator
                    if (ltr && angular.isDefined(lValue)) {
                        angular.element(element).css(property, validate(lValue));
                    } else if (!ltr && angular.isDefined(rValue)) {
                        angular.element(element).css(property, validate(rValue));
                    }

                    // Internal utils

                    function validate(value) {
                        return !value ? '0' :
                            hasPx(value) ? value : value + 'px';
                    }

                    function hasPx(value) {
                        return String(value).indexOf('px') > -1;
                    }
                },

                clientRect: function (element, offsetParent, isOffsetRect) {
                    var node = getNode(element);
                    offsetParent = getNode(offsetParent || node.offsetParent || document.body);
                    var nodeRect = node.getBoundingClientRect();

                    // The user can ask for an offsetRect: a rect relative to the offsetParent,
                    // or a clientRect: a rect relative to the page
                    var offsetRect = isOffsetRect ?
                        offsetParent.getBoundingClientRect() : { left: 0, top: 0, width: 0, height: 0 };
                    return {
                        left: nodeRect.left - offsetRect.left,
                        top: nodeRect.top - offsetRect.top,
                        width: nodeRect.width,
                        height: nodeRect.height
                    };
                },
                offsetRect: function (element, offsetParent) {
                    return $mdUtil.clientRect(element, offsetParent, true);
                },

                // Annoying method to copy nodes to an array, thanks to IE
                nodesToArray: function (nodes) {
                    nodes = nodes || [];

                    var results = [];
                    for (var i = 0; i < nodes.length; ++i) {
                        results.push(nodes.item(i));
                    }
                    return results;
                },

                /**
                 * Calculate the positive scroll offset
                 * TODO: Check with pinch-zoom in IE/Chrome;
                 *       https://code.google.com/p/chromium/issues/detail?id=496285
                 */
                scrollTop: function (element) {
                    element = angular.element(element || $document[0].body);

                    var body = (element[0] == $document[0].body) ? $document[0].body : undefined;
                    var scrollTop = body ? body.scrollTop + body.parentElement.scrollTop : 0;

                    // Calculate the positive scroll offset
                    return scrollTop || Math.abs(element[0].getBoundingClientRect().top);
                },

                /**
                 * Finds the proper focus target by searching the DOM.
                 *
                 * @param containerEl
                 * @param attributeVal
                 * @returns {*}
                 */
                findFocusTarget: function (containerEl, attributeVal) {
                    var AUTO_FOCUS = '[md-autofocus]';
                    var elToFocus;

                    elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);

                    if (!elToFocus && attributeVal != AUTO_FOCUS) {
                        // Scan for deprecated attribute
                        elToFocus = scanForFocusable(containerEl, '[md-auto-focus]');

                        if (!elToFocus) {
                            // Scan for fallback to 'universal' API
                            elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
                        }
                    }

                    return elToFocus;

                    /**
                     * Can target and nested children for specified Selector (attribute)
                     * whose value may be an expression that evaluates to True/False.
                     */
                    function scanForFocusable(target, selector) {
                        var elFound, items = target[0].querySelectorAll(selector);

                        // Find the last child element with the focus attribute
                        if (items && items.length) {
                            items.length && angular.forEach(items, function (it) {
                                it = angular.element(it);

                                // Check the element for the _md-autofocus class to ensure any associated expression
                                // evaluated to true.
                                var isFocusable = it.hasClass('_md-autofocus');
                                if (isFocusable) elFound = it;
                            });
                        }
                        return elFound;
                    }
                },

                // Disables scroll around the passed element.
                disableScrollAround: function (element, parent) {
                    $mdUtil.disableScrollAround._count = $mdUtil.disableScrollAround._count || 0;
                    ++$mdUtil.disableScrollAround._count;
                    if ($mdUtil.disableScrollAround._enableScrolling) return $mdUtil.disableScrollAround._enableScrolling;
                    element = angular.element(element);
                    var body = $document[0].body,
                        restoreBody = disableBodyScroll(),
                        restoreElement = disableElementScroll(parent);

                    return $mdUtil.disableScrollAround._enableScrolling = function () {
                        if (!--$mdUtil.disableScrollAround._count) {
                            restoreBody();
                            restoreElement();
                            delete $mdUtil.disableScrollAround._enableScrolling;
                        }
                    };

                    // Creates a virtual scrolling mask to absorb touchmove, keyboard, scrollbar clicking, and wheel events
                    function disableElementScroll(element) {
                        element = angular.element(element || body)[0];
                        var scrollMask = angular.element(
                            '<div class="md-scroll-mask">' +
                            '  <div class="md-scroll-mask-bar"></div>' +
                            '</div>');
                        element.appendChild(scrollMask[0]);

                        scrollMask.on('wheel', preventDefault);
                        scrollMask.on('touchmove', preventDefault);

                        return function restoreScroll() {
                            scrollMask.off('wheel');
                            scrollMask.off('touchmove');
                            scrollMask[0].parentNode.removeChild(scrollMask[0]);
                            delete $mdUtil.disableScrollAround._enableScrolling;
                        };

                        function preventDefault(e) {
                            e.preventDefault();
                        }
                    }

                    // Converts the body to a position fixed block and translate it to the proper scroll
                    // position
                    function disableBodyScroll() {
                        var htmlNode = body.parentNode;
                        var restoreHtmlStyle = htmlNode.style.cssText || '';
                        var restoreBodyStyle = body.style.cssText || '';
                        var scrollOffset = $mdUtil.scrollTop(body);
                        var clientWidth = body.clientWidth;

                        if (body.scrollHeight > body.clientHeight + 1) {
                            applyStyles(body, {
                                position: 'fixed',
                                width: '100%',
                                top: -scrollOffset + 'px'
                            });

                            applyStyles(htmlNode, {
                                overflowY: 'scroll'
                            });
                        }

                        if (body.clientWidth < clientWidth) applyStyles(body, { overflow: 'hidden' });

                        return function restoreScroll() {
                            body.style.cssText = restoreBodyStyle;
                            htmlNode.style.cssText = restoreHtmlStyle;
                            body.scrollTop = scrollOffset;
                            htmlNode.scrollTop = scrollOffset;
                        };
                    }

                    function applyStyles(el, styles) {
                        for (var key in styles) {
                            el.style[key] = styles[key];
                        }
                    }
                },
                enableScrolling: function () {
                    var method = this.disableScrollAround._enableScrolling;
                    method && method();
                },
                floatingScrollbars: function () {
                    if (this.floatingScrollbars.cached === undefined) {
                        var tempNode = angular.element('<div><div></div></div>').css({
                            width: '100%',
                            'z-index': -1,
                            position: 'absolute',
                            height: '35px',
                            'overflow-y': 'scroll'
                        });
                        tempNode.children().css('height', '60px');

                        $document[0].body.appendChild(tempNode[0]);
                        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
                        tempNode.remove();
                    }
                    return this.floatingScrollbars.cached;
                },

                // Mobile safari only allows you to set focus in click event listeners...
                forceFocus: function (element) {
                    var node = element[0] || element;

                    document.addEventListener('click', function focusOnClick(ev) {
                        if (ev.target === node && ev.$focus) {
                            node.focus();
                            ev.stopImmediatePropagation();
                            ev.preventDefault();
                            node.removeEventListener('click', focusOnClick);
                        }
                    }, true);

                    var newEvent = document.createEvent('MouseEvents');
                    newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
                        false, false, false, false, 0, null);
                    newEvent.$material = true;
                    newEvent.$focus = true;
                    node.dispatchEvent(newEvent);
                },

                /**
                 * facade to build md-backdrop element with desired styles
                 * NOTE: Use $compile to trigger backdrop postLink function
                 */
                createBackdrop: function (scope, addClass) {
                    return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
                },

                /**
                 * supplant() method from Crockford's `Remedial Javascript`
                 * Equivalent to use of $interpolate; without dependency on
                 * interpolation symbols and scope. Note: the '{<token>}' can
                 * be property names, property chains, or array indices.
                 */
                supplant: function (template, values, pattern) {
                    pattern = pattern || /\{([^\{\}]*)\}/g;
                    return template.replace(pattern, function (a, b) {
                        var p = b.split('.'),
                            r = values;
                        try {
                            for (var s in p) {
                                if (p.hasOwnProperty(s)) {
                                    r = r[p[s]];
                                }
                            }
                        } catch (e) {
                            r = a;
                        }
                        return (typeof r === 'string' || typeof r === 'number') ? r : a;
                    });
                },

                fakeNgModel: function () {
                    return {
                        $fake: true,
                        $setTouched: angular.noop,
                        $setViewValue: function (value) {
                            this.$viewValue = value;
                            this.$render(value);
                            this.$viewChangeListeners.forEach(function (cb) {
                                cb();
                            });
                        },
                        $isEmpty: function (value) {
                            return ('' + value).length === 0;
                        },
                        $parsers: [],
                        $formatters: [],
                        $viewChangeListeners: [],
                        $render: angular.noop
                    };
                },

                // Returns a function, that, as long as it continues to be invoked, will not
                // be triggered. The function will be called after it stops being called for
                // N milliseconds.
                // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
                // @param invokeApply should the $timeout trigger $digest() dirty checking
                debounce: function (func, wait, scope, invokeApply) {
                    var timer;

                    return function debounced() {
                        var context = scope,
                            args = Array.prototype.slice.call(arguments);

                        $timeout.cancel(timer);
                        timer = $timeout(function () {

                            timer = undefined;
                            func.apply(context, args);

                        }, wait || 10, invokeApply);
                    };
                },

                // Returns a function that can only be triggered every `delay` milliseconds.
                // In other words, the function will not be called unless it has been more
                // than `delay` milliseconds since the last call.
                throttle: function throttle(func, delay) {
                    var recent;
                    return function throttled() {
                        var context = this;
                        var args = arguments;
                        var now = $mdUtil.now();

                        if (!recent || (now - recent > delay)) {
                            func.apply(context, args);
                            recent = now;
                        }
                    };
                },

                /**
                 * Measures the number of milliseconds taken to run the provided callback
                 * function. Uses a high-precision timer if available.
                 */
                time: function time(cb) {
                    var start = $mdUtil.now();
                    cb();
                    return $mdUtil.now() - start;
                },

                /**
                 * Create an implicit getter that caches its `getter()`
                 * lookup value
                 */
                valueOnUse: function (scope, key, getter) {
                    var value = null,
                        args = Array.prototype.slice.call(arguments);
                    var params = (args.length > 3) ? args.slice(3) : [];

                    Object.defineProperty(scope, key, {
                        get: function () {
                            if (value === null) value = getter.apply(scope, params);
                            return value;
                        }
                    });
                },

                /**
                 * Get a unique ID.
                 *
                 * @returns {string} an unique numeric string
                 */
                nextUid: function () {
                    return '' + nextUniqueId++;
                },

                // Stop watchers and events from firing on a scope without destroying it,
                // by disconnecting it from its parent and its siblings' linked lists.
                disconnectScope: function disconnectScope(scope) {
                    if (!scope) return;

                    // we can't destroy the root scope or a scope that has been already destroyed
                    if (scope.$root === scope) return;
                    if (scope.$$destroyed) return;

                    var parent = scope.$parent;
                    scope.$$disconnected = true;

                    // See Scope.$destroy
                    if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
                    if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
                    if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
                    if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;

                    scope.$$nextSibling = scope.$$prevSibling = null;

                },

                // Undo the effects of disconnectScope above.
                reconnectScope: function reconnectScope(scope) {
                    if (!scope) return;

                    // we can't disconnect the root node or scope already disconnected
                    if (scope.$root === scope) return;
                    if (!scope.$$disconnected) return;

                    var child = scope;

                    var parent = child.$parent;
                    child.$$disconnected = false;
                    // See Scope.$new for this logic...
                    child.$$prevSibling = parent.$$childTail;
                    if (parent.$$childHead) {
                        parent.$$childTail.$$nextSibling = child;
                        parent.$$childTail = child;
                    } else {
                        parent.$$childHead = parent.$$childTail = child;
                    }
                },

                /*
                 * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
                 *
                 * @param el Element to start walking the DOM from
                 * @param tagName Tag name to find closest to el, such as 'form'
                 * @param onlyParent Only start checking from the parent element, not `el`.
                 */
                getClosest: function getClosest(el, tagName, onlyParent) {
                    if (el instanceof angular.element) el = el[0];
                    tagName = tagName.toUpperCase();
                    if (onlyParent) el = el.parentNode;
                    if (!el) return null;
                    do {
                        if (el.nodeName === tagName) {
                            return el;
                        }
                    } while (el = el.parentNode);
                    return null;
                },

                /**
                 * Build polyfill for the Node.contains feature (if needed)
                 */
                elementContains: function (node, child) {
                    var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
                    var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function (arg) {
                        // compares the positions of two nodes and returns a bitmask
                        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
                    });

                    return findFn(child);
                },

                /**
                 * Functional equivalent for $element.filter(‘md-bottom-sheet’)
                 * useful with interimElements where the element and its container are important...
                 *
                 * @param {[]} elements to scan
                 * @param {string} name of node to find (e.g. 'md-dialog')
                 * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
                 * @param {boolean=} optional flag to enable log warnings; defaults to false
                 */
                extractElementByName: function (element, nodeName, scanDeep, warnNotFound) {
                    var found = scanTree(element);
                    if (!found && !!warnNotFound) {
                        $log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.", [nodeName, element[0].outerHTML]));
                    }

                    return angular.element(found || element);

                    /**
                     * Breadth-First tree scan for element with matching `nodeName`
                     */
                    function scanTree(element) {
                        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
                    }

                    /**
                     * Case-insensitive scan of current elements only (do not descend).
                     */
                    function scanLevel(element) {
                        if (element) {
                            for (var i = 0, len = element.length; i < len; i++) {
                                if (element[i].nodeName.toLowerCase() === nodeName) {
                                    return element[i];
                                }
                            }
                        }
                        return null;
                    }

                    /**
                     * Scan children of specified node
                     */
                    function scanChildren(element) {
                        var found;
                        if (element) {
                            for (var i = 0, len = element.length; i < len; i++) {
                                var target = element[i];
                                if (!found) {
                                    for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
                                        found = found || scanTree([target.childNodes[j]]);
                                    }
                                }
                            }
                        }
                        return found;
                    }

                },

                /**
                 * Give optional properties with no value a boolean true if attr provided or false otherwise
                 */
                initOptionalProperties: function (scope, attr, defaults) {
                    defaults = defaults || {};
                    angular.forEach(scope.$$isolateBindings, function (binding, key) {
                        if (binding.optional && angular.isUndefined(scope[key])) {
                            var attrIsDefined = angular.isDefined(attr[binding.attrName]);
                            scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
                        }
                    });
                },

                /**
                 * Alternative to $timeout calls with 0 delay.
                 * nextTick() coalesces all calls within a single frame
                 * to minimize $digest thrashing
                 *
                 * @param callback
                 * @param digest
                 * @returns {*}
                 */
                nextTick: function (callback, digest, scope) {
                    //-- grab function reference for storing state details
                    var nextTick = $mdUtil.nextTick;
                    var timeout = nextTick.timeout;
                    var queue = nextTick.queue || [];

                    //-- add callback to the queue
                    queue.push(callback);

                    //-- set default value for digest
                    if (digest == null) digest = true;

                    //-- store updated digest/queue values
                    nextTick.digest = nextTick.digest || digest;
                    nextTick.queue = queue;

                    //-- either return existing timeout or create a new one
                    return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

                    /**
                     * Grab a copy of the current queue
                     * Clear the queue for future use
                     * Process the existing queue
                     * Trigger digest if necessary
                     */
                    function processQueue() {
                        var skip = scope && scope.$$destroyed;
                        var queue = !skip ? nextTick.queue : [];
                        var digest = !skip ? nextTick.digest : null;

                        nextTick.queue = [];
                        nextTick.timeout = null;
                        nextTick.digest = false;

                        queue.forEach(function (callback) {
                            callback();
                        });

                        if (digest) $rootScope.$digest();
                    }
                },

                /**
                 * Processes a template and replaces the start/end symbols if the application has
                 * overriden them.
                 *
                 * @param template The template to process whose start/end tags may be replaced.
                 * @returns {*}
                 */
                processTemplate: function (template) {
                    if (usesStandardSymbols) {
                        return template;
                    } else {
                        if (!template || !angular.isString(template)) return template;
                        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
                    }
                },

                /**
                 * Scan up dom hierarchy for enabled parent;
                 */
                getParentWithPointerEvents: function (element) {
                    var parent = element.parent();

                    // jqLite might return a non-null, but still empty, parent; so check for parent and length
                    while (hasComputedStyle(parent, 'pointer-events', 'none')) {
                        parent = parent.parent();
                    }

                    return parent;
                },

                getNearestContentElement: function (element) {
                    var current = element.parent()[0];
                    // Look for the nearest parent md-content, stopping at the rootElement.
                    while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
                        current = current.parentNode;
                    }
                    return current;
                },

                /**
                 * Parses an attribute value, mostly a string.
                 * By default checks for negated values and returns `false´ if present.
                 * Negated values are: (native falsy) and negative strings like:
                 * `false` or `0`.
                 * @param value Attribute value which should be parsed.
                 * @param negatedCheck When set to false, won't check for negated values.
                 * @returns {boolean}
                 */
                parseAttributeBoolean: function (value, negatedCheck) {
                    return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
                },

                hasComputedStyle: hasComputedStyle
            };

            // Instantiate other namespace utility methods

            $mdUtil.dom.animator = $$mdAnimate($mdUtil);

            return $mdUtil;

            function getNode(el) {
                return el[0] || el;
            }

        }
        UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window"];

        /*
         * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
         * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
         */

        angular.element.prototype.focus = angular.element.prototype.focus || function () {
            if (this.length) {
                this[0].focus();
            }
            return this;
        };
        angular.element.prototype.blur = angular.element.prototype.blur || function () {
            if (this.length) {
                this[0].blur();
            }
            return this;
        };


    })();
    (function () {
        "use strict";


        angular.module('material.core')
            .service('$mdAria', AriaService);

        /*
         * @ngInject
         */
        function AriaService($$rAF, $log, $window, $interpolate) {

            return {
                expect: angular.noop, //expect,
                expectAsync: angular.noop, // expectAsync,
                expectWithText: angular.noop //expectWithText
            };

            /**
             * Check if expected attribute has been specified on the target element or child
             * @param element
             * @param attrName
             * @param {optional} defaultValue What to set the attr to if no value is found
             */
            function expect(element, attrName, defaultValue) {

                var node = angular.element(element)[0] || element;

                // if node exists and neither it nor its children have the attribute
                if (node &&
                    ((!node.hasAttribute(attrName) ||
                        node.getAttribute(attrName).length === 0) &&
                        !childHasAttribute(node, attrName))) {

                    defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
                    if (defaultValue.length) {
                        element.attr(attrName, defaultValue);
                    } else {
                        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
                    }

                }
            }

            function expectAsync(element, attrName, defaultValueGetter) {
                // Problem: when retrieving the element's contents synchronously to find the label,
                // the text may not be defined yet in the case of a binding.
                // There is a higher chance that a binding will be defined if we wait one frame.
                $$rAF(function () {
                    expect(element, attrName, defaultValueGetter());
                });
            }

            function expectWithText(element, attrName) {
                var content = getText(element) || "";
                var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

                if (hasBinding) {
                    expectAsync(element, attrName, function () {
                        return getText(element);
                    });
                } else {
                    expect(element, attrName, content);
                }
            }

            function getText(element) {
                return (element.text() || "").trim();
            }

            function childHasAttribute(node, attrName) {
                var hasChildren = node.hasChildNodes(),
                    hasAttr = false;

                function isHidden(el) {
                    var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
                    return (style.display === 'none');
                }

                if (hasChildren) {
                    var children = node.childNodes;
                    for (var i = 0; i < children.length; i++) {
                        var child = children[i];
                        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
                            if (!isHidden(child)) {
                                hasAttr = true;
                            }
                        }
                    }
                }
                return hasAttr;
            }
        }
        AriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.core')
            .service('$mdCompiler', mdCompilerService);

        function mdCompilerService($q, $http, $injector, $compile, $controller, $templateCache) {
            /* jshint validthis: true */

            /*
             * @ngdoc service
             * @name $mdCompiler
             * @module material.core
             * @description
             * The $mdCompiler service is an abstraction of angular's compiler, that allows the developer
             * to easily compile an element with a templateUrl, controller, and locals.
             *
             * @usage
             * <hljs lang="js">
             * $mdCompiler.compile({
             *   templateUrl: 'modal.html',
             *   controller: 'ModalCtrl',
             *   locals: {
             *     modal: myModalInstance;
             *   }
             * }).then(function(compileData) {
             *   compileData.element; // modal.html's template in an element
             *   compileData.link(myScope); //attach controller & scope to element
             * });
             * </hljs>
             */

            /*
             * @ngdoc method
             * @name $mdCompiler#compile
             * @description A helper to compile an HTML template/templateUrl with a given controller,
             * locals, and scope.
             * @param {object} options An options object, with the following properties:
             *
             *    - `controller` - `{(string=|function()=}` Controller fn that should be associated with
             *      newly created scope or the name of a registered controller if passed as a string.
             *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
             *      published to scope under the `controllerAs` name.
             *    - `template` - `{string=}` An html template as a string.
             *    - `templateUrl` - `{string=}` A path to an html template.
             *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
             *      it is loaded. It will be given the template string as a parameter, and should
             *      return a a new string representing the transformed template.
             *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
             *      be injected into the controller. If any of these dependencies are promises, the compiler
             *      will wait for them all to be resolved, or if one is rejected before the controller is
             *      instantiated `compile()` will fail..
             *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
             *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
             *        Otherwise if function, then it is injected and the return value is treated as the
             *        dependency. If the result is a promise, it is resolved before its value is
             *        injected into the controller.
             *
             * @returns {object=} promise A promise, which will be resolved with a `compileData` object.
             * `compileData` has the following properties:
             *
             *   - `element` - `{element}`: an uncompiled element matching the provided template.
             *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
             *     the element and instantiate the provided controller (if given).
             *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
             *     called. If `bindToController` is true, they will be coppied to the ctrl instead
             *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
             */
            this.compile = function (options) {
                var templateUrl = options.templateUrl;
                var template = options.template || '';
                var controller = options.controller;
                var controllerAs = options.controllerAs;
                var resolve = angular.extend({}, options.resolve || {});
                var locals = angular.extend({}, options.locals || {});
                var transformTemplate = options.transformTemplate || angular.identity;
                var bindToController = options.bindToController;

                // Take resolve values and invoke them.
                // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
                // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
                angular.forEach(resolve, function (value, key) {
                    if (angular.isString(value)) {
                        resolve[key] = $injector.get(value);
                    } else {
                        resolve[key] = $injector.invoke(value);
                    }
                });
                //Add the locals, which are just straight values to inject
                //eg locals: { three: 3 }, will inject three into the controller
                angular.extend(resolve, locals);

                if (templateUrl) {
                    resolve.$template = $http.get(templateUrl, { cache: $templateCache })
                        .then(function (response) {
                            return response.data;
                        });
                } else {
                    resolve.$template = $q.when(template);
                }

                // Wait for all the resolves to finish if they are promises
                return $q.all(resolve).then(function (locals) {

                    var compiledData;
                    var template = transformTemplate(locals.$template, options);
                    var element = options.element || angular.element('<div>').html(template.trim()).contents();
                    var linkFn = $compile(element);

                    // Return a linking function that can be used later when the element is ready
                    return compiledData = {
                        locals: locals,
                        element: element,
                        link: function link(scope) {
                            locals.$scope = scope;

                            //Instantiate controller if it exists, because we have scope
                            if (controller) {
                                var invokeCtrl = $controller(controller, locals, true);
                                if (bindToController) {
                                    angular.extend(invokeCtrl.instance, locals);
                                }
                                var ctrl = invokeCtrl();
                                //See angular-route source for this logic
                                element.data('$ngControllerController', ctrl);
                                element.children().data('$ngControllerController', ctrl);

                                if (controllerAs) {
                                    scope[controllerAs] = ctrl;
                                }

                                // Publish reference to this controller
                                compiledData.controller = ctrl;
                            }
                            return linkFn(scope);
                        }
                    };
                });

            };
        }
        mdCompilerService.$inject = ["$q", "$http", "$injector", "$compile", "$controller", "$templateCache"];

    })();
    (function () {
        "use strict";

        var HANDLERS = {};

        /* The state of the current 'pointer'
         * The pointer represents the state of the current touch.
         * It contains normalized x and y coordinates from DOM events,
         * as well as other information abstracted from the DOM.
         */

        var pointer, lastPointer, forceSkipClickHijack = false;

        /**
         * The position of the most recent click if that click was on a label element.
         * @type {{x: number, y: number}?}
         */
        var lastLabelClickPos = null;

        // Used to attach event listeners once when multiple ng-apps are running.
        var isInitialized = false;

        angular
            .module('material.core.gestures', [])
            .provider('$mdGesture', MdGestureProvider)
            .factory('$$MdGestureHandler', MdGestureHandler)
            .run(attachToDocument);

        /**
         * @ngdoc service
         * @name $mdGestureProvider
         * @module material.core.gestures
         *
         * @description
         * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
         * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
         * devices.
         *
         * <hljs lang="js">
         *   app.config(function($mdGestureProvider) {
         *
         *     // For mobile devices without jQuery loaded, do not
         *     // intercept click events during the capture phase.
         *     $mdGestureProvider.skipClickHijack();
         *
         *   });
         * </hljs>
         *
         */
        function MdGestureProvider() { }

        MdGestureProvider.prototype = {

            // Publish access to setter to configure a variable  BEFORE the
            // $mdGesture service is instantiated...
            skipClickHijack: function () {
                return forceSkipClickHijack = true;
            },

            /**
             * $get is used to build an instance of $mdGesture
             * @ngInject
             */
            $get: ["$$MdGestureHandler", "$$rAF", "$timeout", function ($$MdGestureHandler, $$rAF, $timeout) {
                return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
            }]
        };



        /**
         * MdGesture factory construction function
         * @ngInject
         */
        function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            var isIos = userAgent.match(/ipad|iphone|ipod/i);
            var isAndroid = userAgent.match(/android/i);
            var hasJQuery = (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

            var self = {
                handler: addHandler,
                register: register,
                // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
                isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
            };

            if (self.isHijackingClicks) {
                var maxClickDistance = 6;
                self.handler('click', {
                    options: {
                        maxDistance: maxClickDistance
                    },
                    onEnd: checkDistanceAndEmit('click')
                });

                self.handler('focus', {
                    options: {
                        maxDistance: maxClickDistance
                    },
                    onEnd: function (ev, pointer) {
                        if (pointer.distance < this.state.options.maxDistance) {
                            if (canFocus(ev.target)) {
                                this.dispatchEvent(ev, 'focus', pointer);
                                ev.target.focus();
                            }
                        }

                        function canFocus(element) {
                            var focusableElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'];

                            return (element.getAttribute('tabindex') != '-1') &&
                                !element.hasAttribute('DISABLED') &&
                                (element.hasAttribute('tabindex') || element.hasAttribute('href') ||
                                    (focusableElements.indexOf(element.nodeName) != -1));
                        }
                    }
                });

                self.handler('mouseup', {
                    options: {
                        maxDistance: maxClickDistance
                    },
                    onEnd: checkDistanceAndEmit('mouseup')
                });

                self.handler('mousedown', {
                    onStart: function (ev) {
                        this.dispatchEvent(ev, 'mousedown');
                    }
                });
            }

            function checkDistanceAndEmit(eventName) {
                return function (ev, pointer) {
                    if (pointer.distance < this.state.options.maxDistance) {
                        this.dispatchEvent(ev, eventName, pointer);
                    }
                };
            }

            /*
             * Register an element to listen for a handler.
             * This allows an element to override the default options for a handler.
             * Additionally, some handlers like drag and hold only dispatch events if
             * the domEvent happens inside an element that's registered to listen for these events.
             *
             * @see GestureHandler for how overriding of default options works.
             * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
             */
            function register(element, handlerName, options) {
                var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
                if (!handler) {
                    throw new Error('Failed to register element with handler ' + handlerName + '. ' +
                        'Available handlers: ' + Object.keys(HANDLERS).join(', '));
                }
                return handler.registerElement(element, options);
            }

            /*
             * add a handler to $mdGesture. see below.
             */
            function addHandler(name, definition) {
                var handler = new $$MdGestureHandler(name);
                angular.extend(handler, definition);
                HANDLERS[name] = handler;

                return self;
            }

            /*
             * Register handlers. These listen to touch/start/move events, interpret them,
             * and dispatch gesture events depending on options & conditions. These are all
             * instances of GestureHandler.
             * @see GestureHandler 
             */
            return self
                /*
                 * The press handler dispatches an event on touchdown/touchend.
                 * It's a simple abstraction of touch/mouse/pointer start and end.
                 */
                .handler('press', {
                    onStart: function (ev, pointer) {
                        this.dispatchEvent(ev, '$md.pressdown');
                    },
                    onEnd: function (ev, pointer) {
                        this.dispatchEvent(ev, '$md.pressup');
                    }
                })

                /*
                 * The hold handler dispatches an event if the user keeps their finger within
                 * the same <maxDistance> area for <delay> ms.
                 * The hold handler will only run if a parent of the touch target is registered
                 * to listen for hold events through $mdGesture.register()
                 */
                .handler('hold', {
                    options: {
                        maxDistance: 6,
                        delay: 500
                    },
                    onCancel: function () {
                        $timeout.cancel(this.state.timeout);
                    },
                    onStart: function (ev, pointer) {
                        // For hold, require a parent to be registered with $mdGesture.register()
                        // Because we prevent scroll events, this is necessary.
                        if (!this.state.registeredParent) return this.cancel();

                        this.state.pos = { x: pointer.x, y: pointer.y };
                        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
                            this.dispatchEvent(ev, '$md.hold');
                            this.cancel(); //we're done!
                        }), this.state.options.delay, false);
                    },
                    onMove: function (ev, pointer) {
                        // Don't scroll while waiting for hold.
                        // If we don't preventDefault touchmove events here, Android will assume we don't
                        // want to listen to anymore touch events. It will start scrolling and stop sending
                        // touchmove events.
                        ev.preventDefault();

                        // If the user moves greater than <maxDistance> pixels, stop the hold timer
                        // set in onStart
                        var dx = this.state.pos.x - pointer.x;
                        var dy = this.state.pos.y - pointer.y;
                        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
                            this.cancel();
                        }
                    },
                    onEnd: function () {
                        this.onCancel();
                    }
                })

                /*
                 * The drag handler dispatches a drag event if the user holds and moves his finger greater than
                 * <minDistance> px in the x or y direction, depending on options.horizontal.
                 * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
                 * the perpindicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
                 * pixels vertically, this handler won't consider the move part of a drag.
                 */
                .handler('drag', {
                    options: {
                        minDistance: 6,
                        horizontal: true,
                        cancelMultiplier: 1.5
                    },
                    onStart: function (ev) {
                        // For drag, require a parent to be registered with $mdGesture.register()
                        if (!this.state.registeredParent) this.cancel();
                    },
                    onMove: function (ev, pointer) {
                        var shouldStartDrag, shouldCancel;
                        // Don't scroll while deciding if this touchmove qualifies as a drag event.
                        // If we don't preventDefault touchmove events here, Android will assume we don't
                        // want to listen to anymore touch events. It will start scrolling and stop sending
                        // touchmove events.
                        ev.preventDefault();

                        if (!this.state.dragPointer) {
                            if (this.state.options.horizontal) {
                                shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
                                shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
                            } else {
                                shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
                                shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
                            }

                            if (shouldStartDrag) {
                                // Create a new pointer representing this drag, starting at this point where the drag started.
                                this.state.dragPointer = makeStartPointer(ev);
                                updatePointerState(ev, this.state.dragPointer);
                                this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);

                            } else if (shouldCancel) {
                                this.cancel();
                            }
                        } else {
                            this.dispatchDragMove(ev);
                        }
                    },
                    // Only dispatch dragmove events every frame; any more is unnecessray
                    dispatchDragMove: $$rAF.throttle(function (ev) {
                        // Make sure the drag didn't stop while waiting for the next frame
                        if (this.state.isRunning) {
                            updatePointerState(ev, this.state.dragPointer);
                            this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
                        }
                    }),
                    onEnd: function (ev, pointer) {
                        if (this.state.dragPointer) {
                            updatePointerState(ev, this.state.dragPointer);
                            this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
                        }
                    }
                })

                /*
                 * The swipe handler will dispatch a swipe event if, on the end of a touch,
                 * the velocity and distance were high enough.
                 */
                .handler('swipe', {
                    options: {
                        minVelocity: 0.65,
                        minDistance: 10
                    },
                    onEnd: function (ev, pointer) {
                        var eventType;

                        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
                            Math.abs(pointer.distanceX) > this.state.options.minDistance) {
                            eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
                            this.dispatchEvent(ev, eventType);
                        } else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
                            Math.abs(pointer.distanceY) > this.state.options.minDistance) {
                            eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
                            this.dispatchEvent(ev, eventType);
                        }
                    }
                });

        }
        MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];

        /**
         * MdGestureHandler
         * A GestureHandler is an object which is able to dispatch custom dom events
         * based on native dom {touch,pointer,mouse}{start,move,end} events.
         *
         * A gesture will manage its lifecycle through the start,move,end, and cancel
         * functions, which are called by native dom events.
         *
         * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
         * overridden by elements registering through $mdGesture.register()
         */
        function GestureHandler(name) {
            this.name = name;
            this.state = {};
        }

        function MdGestureHandler() {
            var hasJQuery = (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

            GestureHandler.prototype = {
                options: {},
                // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
                // differently when jQuery is loaded
                dispatchEvent: hasJQuery ? jQueryDispatchEvent : nativeDispatchEvent,

                // These are overridden by the registered handler
                onStart: angular.noop,
                onMove: angular.noop,
                onEnd: angular.noop,
                onCancel: angular.noop,

                // onStart sets up a new state for the handler, which includes options from the
                // nearest registered parent element of ev.target.
                start: function (ev, pointer) {
                    if (this.state.isRunning) return;
                    var parentTarget = this.getNearestParent(ev.target);
                    // Get the options from the nearest registered parent
                    var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};

                    this.state = {
                        isRunning: true,
                        // Override the default options with the nearest registered parent's options
                        options: angular.extend({}, this.options, parentTargetOptions),
                        // Pass in the registered parent node to the state so the onStart listener can use
                        registeredParent: parentTarget
                    };
                    this.onStart(ev, pointer);
                },
                move: function (ev, pointer) {
                    if (!this.state.isRunning) return;
                    this.onMove(ev, pointer);
                },
                end: function (ev, pointer) {
                    if (!this.state.isRunning) return;
                    this.onEnd(ev, pointer);
                    this.state.isRunning = false;
                },
                cancel: function (ev, pointer) {
                    this.onCancel(ev, pointer);
                    this.state = {};
                },

                // Find and return the nearest parent element that has been registered to
                // listen for this handler via $mdGesture.register(element, 'handlerName').
                getNearestParent: function (node) {
                    var current = node;
                    while (current) {
                        if ((current.$mdGesture || {})[this.name]) {
                            return current;
                        }
                        current = current.parentNode;
                    }
                    return null;
                },

                // Called from $mdGesture.register when an element reigsters itself with a handler.
                // Store the options the user gave on the DOMElement itself. These options will
                // be retrieved with getNearestParent when the handler starts.
                registerElement: function (element, options) {
                    var self = this;
                    element[0].$mdGesture = element[0].$mdGesture || {};
                    element[0].$mdGesture[this.name] = options || {};
                    element.on('$destroy', onDestroy);

                    return onDestroy;

                    function onDestroy() {
                        delete element[0].$mdGesture[self.name];
                        element.off('$destroy', onDestroy);
                    }
                }
            };

            return GestureHandler;

            /*
             * Dispatch an event with jQuery
             * TODO: Make sure this sends bubbling events
             *
             * @param srcEvent the original DOM touch event that started this.
             * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
             * @param eventPointer the pointer object that matches this event.
             */
            function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
                eventPointer = eventPointer || pointer;
                var eventObj = new angular.element.Event(eventType);

                eventObj.$material = true;
                eventObj.pointer = eventPointer;
                eventObj.srcEvent = srcEvent;

                angular.extend(eventObj, {
                    clientX: eventPointer.x,
                    clientY: eventPointer.y,
                    screenX: eventPointer.x,
                    screenY: eventPointer.y,
                    pageX: eventPointer.x,
                    pageY: eventPointer.y,
                    ctrlKey: srcEvent.ctrlKey,
                    altKey: srcEvent.altKey,
                    shiftKey: srcEvent.shiftKey,
                    metaKey: srcEvent.metaKey
                });
                angular.element(eventPointer.target).trigger(eventObj);
            }

            /*
             * NOTE: nativeDispatchEvent is very performance sensitive.
             * @param srcEvent the original DOM touch event that started this.
             * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
             * @param eventPointer the pointer object that matches this event.
             */
            function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
                eventPointer = eventPointer || pointer;
                var eventObj;

                if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown') {
                    eventObj = document.createEvent('MouseEvents');
                    eventObj.initMouseEvent(
                        eventType, true, true, window, srcEvent.detail,
                        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
                        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
                        srcEvent.button, srcEvent.relatedTarget || null
                    );

                } else {
                    eventObj = document.createEvent('CustomEvent');
                    eventObj.initCustomEvent(eventType, true, true, {});
                }
                eventObj.$material = true;
                eventObj.pointer = eventPointer;
                eventObj.srcEvent = srcEvent;
                eventPointer.target.dispatchEvent(eventObj);
            }

        }

        /**
         * Attach Gestures: hook document and check shouldHijack clicks
         * @ngInject
         */
        function attachToDocument($mdGesture, $$MdGestureHandler) {

            // Polyfill document.contains for IE11.
            // TODO: move to util
            document.contains || (document.contains = function (node) {
                return document.body.contains(node);
            });

            if (!isInitialized && $mdGesture.isHijackingClicks) {
                /*
                 * If hijack clicks is true, we preventDefault any click that wasn't
                 * sent by ngMaterial. This is because on older Android & iOS, a false, or 'ghost',
                 * click event will be sent ~400ms after a touchend event happens.
                 * The only way to know if this click is real is to prevent any normal
                 * click events, and add a flag to events sent by material so we know not to prevent those.
                 * 
                 * Two exceptions to click events that should be prevented are:
                 *  - click events sent by the keyboard (eg form submit)
                 *  - events that originate from an Ionic app
                 */
                document.addEventListener('click', clickHijacker, true);
                document.addEventListener('mouseup', mouseInputHijacker, true);
                document.addEventListener('mousedown', mouseInputHijacker, true);
                document.addEventListener('focus', mouseInputHijacker, true);

                isInitialized = true;
            }

            function mouseInputHijacker(ev) {
                var isKeyClick = !ev.clientX && !ev.clientY;
                if (!isKeyClick && !ev.$material && !ev.isIonicTap &&
                    !isInputEventFromLabelClick(ev)) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }

            function clickHijacker(ev) {
                var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
                if (!isKeyClick && !ev.$material && !ev.isIonicTap &&
                    !isInputEventFromLabelClick(ev)) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    lastLabelClickPos = null;
                } else {
                    lastLabelClickPos = null;
                    if (ev.target.tagName.toLowerCase() == 'label') {
                        lastLabelClickPos = { x: ev.x, y: ev.y };
                    }
                }
            }


            // Listen to all events to cover all platforms.
            var START_EVENTS = 'mousedown touchstart pointerdown';
            var MOVE_EVENTS = 'mousemove touchmove pointermove';
            var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';

            angular.element(document)
                .on(START_EVENTS, gestureStart)
                .on(MOVE_EVENTS, gestureMove)
                .on(END_EVENTS, gestureEnd)
                // For testing
                .on('$$mdGestureReset', function gestureClearCache() {
                    lastPointer = pointer = null;
                });

            /*
             * When a DOM event happens, run all registered gesture handlers' lifecycle
             * methods which match the DOM event.
             * Eg when a 'touchstart' event happens, runHandlers('start') will call and
             * run `handler.cancel()` and `handler.start()` on all registered handlers.
             */
            function runHandlers(handlerEvent, event) {
                var handler;
                for (var name in HANDLERS) {
                    handler = HANDLERS[name];
                    if (handler instanceof $$MdGestureHandler) {

                        if (handlerEvent === 'start') {
                            // Run cancel to reset any handlers' state
                            handler.cancel();
                        }
                        handler[handlerEvent](event, pointer);

                    }
                }
            }

            /*
             * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
             * If it is legitimate, we initiate the pointer state and mark the current pointer's type
             * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
             * won't effect it.
             */
            function gestureStart(ev) {
                // If we're already touched down, abort
                if (pointer) return;

                var now = +Date.now();

                // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
                // If <400ms have passed, don't allow an event of a different type than the previous event
                if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
                    return;
                }

                pointer = makeStartPointer(ev);

                runHandlers('start', ev);
            }
            /*
             * If a move event happens of the right type, update the pointer and run all the move handlers.
             * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
             */
            function gestureMove(ev) {
                if (!pointer || !typesMatch(ev, pointer)) return;

                updatePointerState(ev, pointer);
                runHandlers('move', ev);
            }
            /*
             * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
             */
            function gestureEnd(ev) {
                if (!pointer || !typesMatch(ev, pointer)) return;

                updatePointerState(ev, pointer);
                pointer.endTime = +Date.now();

                runHandlers('end', ev);

                lastPointer = pointer;
                pointer = null;
            }

        }
        attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];

        // ********************
        // Module Functions
        // ********************

        /*
         * Initiate the pointer. x, y, and the pointer's type.
         */
        function makeStartPointer(ev) {
            var point = getEventPoint(ev);
            var startPointer = {
                startTime: +Date.now(),
                target: ev.target,
                // 'p' for pointer events, 'm' for mouse, 't' for touch
                type: ev.type.charAt(0)
            };
            startPointer.startX = startPointer.x = point.pageX;
            startPointer.startY = startPointer.y = point.pageY;
            return startPointer;
        }

        /*
         * return whether the pointer's type matches the event's type.
         * Eg if a touch event happens but the pointer has a mouse type, return false.
         */
        function typesMatch(ev, pointer) {
            return ev && pointer && ev.type.charAt(0) === pointer.type;
        }

        /**
         * Gets whether the given event is an input event that was caused by clicking on an
         * associated label element.
         *
         * This is necessary because the browser will, upon clicking on a label element, fire an
         * *extra* click event on its associated input (if any). mdGesture is able to flag the label
         * click as with `$material` correctly, but not the second input click.
         *
         * In order to determine whether an input event is from a label click, we compare the (x, y) for
         * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
         * click occurs). Unfortunately, there are no event properties that tie the input and the label
         * together (such as relatedTarget).
         *
         * @param {MouseEvent} event
         * @returns {boolean}
         */
        function isInputEventFromLabelClick(event) {
            return lastLabelClickPos &&
                lastLabelClickPos.x == event.x &&
                lastLabelClickPos.y == event.y;
        }

        /*
         * Update the given pointer based upon the given DOMEvent.
         * Distance, velocity, direction, duration, etc
         */
        function updatePointerState(ev, pointer) {
            var point = getEventPoint(ev);
            var x = pointer.x = point.pageX;
            var y = pointer.y = point.pageY;

            pointer.distanceX = x - pointer.startX;
            pointer.distanceY = y - pointer.startY;
            pointer.distance = Math.sqrt(
                pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
            );

            pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
            pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';

            pointer.duration = +Date.now() - pointer.startTime;
            pointer.velocityX = pointer.distanceX / pointer.duration;
            pointer.velocityY = pointer.distanceY / pointer.duration;
        }

        /*
         * Normalize the point where the DOM event happened whether it's touch or mouse.
         * @returns point event obj with pageX and pageY on it.
         */
        function getEventPoint(ev) {
            ev = ev.originalEvent || ev; // support jQuery events
            return (ev.touches && ev.touches[0]) ||
                (ev.changedTouches && ev.changedTouches[0]) ||
                ev;
        }

    })();
    (function () {
        "use strict";

        angular.module('material.core')
            .provider('$$interimElement', InterimElementProvider);

        /*
         * @ngdoc service
         * @name $$interimElement
         * @module material.core
         *
         * @description
         *
         * Factory that contructs `$$interimElement.$service` services.
         * Used internally in material design for elements that appear on screen temporarily.
         * The service provides a promise-like API for interacting with the temporary
         * elements.
         *
         * ```js
         * app.service('$mdToast', function($$interimElement) {
         *   var $mdToast = $$interimElement(toastDefaultOptions);
         *   return $mdToast;
         * });
         * ```
         * @param {object=} defaultOptions Options used by default for the `show` method on the service.
         *
         * @returns {$$interimElement.$service}
         *
         */

        function InterimElementProvider() {
            createInterimElementProvider.$get = InterimElementFactory;

            InterimElementFactory.$inject = ["$document", "$q", "$$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector"];
            return createInterimElementProvider;

            /**
             * Returns a new provider which allows configuration of a new interimElement
             * service. Allows configuration of default options & methods for options,
             * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
             */
            function createInterimElementProvider(interimFactoryName) {
                var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];

                var customMethods = {};
                var providerConfig = {
                    presets: {}
                };

                var provider = {
                    setDefaults: setDefaults,
                    addPreset: addPreset,
                    addMethod: addMethod,
                    $get: factory
                };

                /**
                 * all interim elements will come with the 'build' preset
                 */
                provider.addPreset('build', {
                    methods: ['controller', 'controllerAs', 'resolve',
                        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent'
                    ]
                });


                factory.$inject = ["$$interimElement", "$injector"];
                return provider;

                /**
                 * Save the configured defaults to be used when the factory is instantiated
                 */
                function setDefaults(definition) {
                    providerConfig.optionsFactory = definition.options;
                    providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
                    return provider;
                }

                /**
                 * Add a method to the factory that isn't specific to any interim element operations
                 */

                function addMethod(name, fn) {
                    customMethods[name] = fn;
                    return provider;
                }

                /**
                 * Save the configured preset to be used when the factory is instantiated
                 */
                function addPreset(name, definition) {
                    definition = definition || {};
                    definition.methods = definition.methods || [];
                    definition.options = definition.options || function () { return {}; };

                    if (/^cancel|hide|show$/.test(name)) {
                        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
                    }
                    if (definition.methods.indexOf('_options') > -1) {
                        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
                    }
                    providerConfig.presets[name] = {
                        methods: definition.methods.concat(EXPOSED_METHODS),
                        optionsFactory: definition.options,
                        argOption: definition.argOption
                    };
                    return provider;
                }

                function addPresetMethod(presetName, methodName, method) {
                    providerConfig.presets[presetName][methodName] = method;
                }

                /**
                 * Create a factory that has the given methods & defaults implementing interimElement
                 */
                /* @ngInject */
                function factory($$interimElement, $injector) {
                    var defaultMethods;
                    var defaultOptions;
                    var interimElementService = $$interimElement();

                    /*
                     * publicService is what the developer will be using.
                     * It has methods hide(), cancel(), show(), build(), and any other
                     * presets which were set during the config phase.
                     */
                    var publicService = {
                        hide: interimElementService.hide,
                        cancel: interimElementService.cancel,
                        show: showInterimElement,

                        // Special internal method to destroy an interim element without animations
                        // used when navigation changes causes a $scope.$destroy() action
                        destroy: destroyInterimElement
                    };


                    defaultMethods = providerConfig.methods || [];
                    // This must be invoked after the publicService is initialized
                    defaultOptions = invokeFactory(providerConfig.optionsFactory, {});

                    // Copy over the simple custom methods
                    angular.forEach(customMethods, function (fn, name) {
                        publicService[name] = fn;
                    });

                    angular.forEach(providerConfig.presets, function (definition, name) {
                        var presetDefaults = invokeFactory(definition.optionsFactory, {});
                        var presetMethods = (definition.methods || []).concat(defaultMethods);

                        // Every interimElement built with a preset has a field called `$type`,
                        // which matches the name of the preset.
                        // Eg in preset 'confirm', options.$type === 'confirm'
                        angular.extend(presetDefaults, { $type: name });

                        // This creates a preset class which has setter methods for every
                        // method given in the `.addPreset()` function, as well as every
                        // method given in the `.setDefaults()` function.
                        //
                        // @example
                        // .setDefaults({
                        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
                        //   options: dialogDefaultOptions
                        // })
                        // .addPreset('alert', {
                        //   methods: ['title', 'ok'],
                        //   options: alertDialogOptions
                        // })
                        //
                        // Set values will be passed to the options when interimElement.show() is called.
                        function Preset(opts) {
                            this._options = angular.extend({}, presetDefaults, opts);
                        }
                        angular.forEach(presetMethods, function (name) {
                            Preset.prototype[name] = function (value) {
                                this._options[name] = value;
                                return this;
                            };
                        });

                        // Create shortcut method for one-linear methods
                        if (definition.argOption) {
                            var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
                            publicService[methodName] = function (arg) {
                                var config = publicService[name](arg);
                                return publicService.show(config);
                            };
                        }

                        // eg $mdDialog.alert() will return a new alert preset
                        publicService[name] = function (arg) {
                            // If argOption is supplied, eg `argOption: 'content'`, then we assume
                            // if the argument is not an options object then it is the `argOption` option.
                            //
                            // @example `$mdToast.simple('hello')` // sets options.content to hello
                            //                                     // because argOption === 'content'
                            if (arguments.length && definition.argOption &&
                                !angular.isObject(arg) && !angular.isArray(arg)) {

                                return (new Preset())[definition.argOption](arg);

                            } else {
                                return new Preset(arg);
                            }

                        };
                    });

                    return publicService;

                    /**
                     *
                     */
                    function showInterimElement(opts) {
                        // opts is either a preset which stores its options on an _options field,
                        // or just an object made up of options
                        opts = opts || {};
                        if (opts._options) opts = opts._options;

                        return interimElementService.show(
                            angular.extend({}, defaultOptions, opts)
                        );
                    }

                    /**
                     *  Special method to hide and destroy an interimElement WITHOUT
                     *  any 'leave` or hide animations ( an immediate force hide/remove )
                     *
                     *  NOTE: This calls the onRemove() subclass method for each component...
                     *  which must have code to respond to `options.$destroy == true`
                     */
                    function destroyInterimElement(opts) {
                        return interimElementService.destroy(opts);
                    }

                    /**
                     * Helper to call $injector.invoke with a local of the factory name for
                     * this provider.
                     * If an $mdDialog is providing options for a dialog and tries to inject
                     * $mdDialog, a circular dependency error will happen.
                     * We get around that by manually injecting $mdDialog as a local.
                     */
                    function invokeFactory(factory, defaultVal) {
                        var locals = {};
                        locals[interimFactoryName] = publicService;
                        return $injector.invoke(factory || function () { return defaultVal; }, {}, locals);
                    }

                }

            }

            /* @ngInject */
            function InterimElementFactory($document, $q, $$q, $rootScope, $timeout, $rootElement, $animate,
                $mdUtil, $mdCompiler, $mdTheming, $injector) {
                return function createInterimElementService() {
                    var SHOW_CANCELLED = false;

                    /*
                     * @ngdoc service
                     * @name $$interimElement.$service
                     *
                     * @description
                     * A service used to control inserting and removing an element into the DOM.
                     *
                     */
                    var service, stack = [];

                    // Publish instance $$interimElement service;
                    // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect

                    return service = {
                        show: show,
                        hide: hide,
                        cancel: cancel,
                        destroy: destroy,
                        $injector_: $injector
                    };

                    /*
                     * @ngdoc method
                     * @name $$interimElement.$service#show
                     * @kind function
                     *
                     * @description
                     * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
                     * with hide or cancel, respectively. To external cancel/hide, developers should use the
                     *
                     * @param {*} options is hashMap of settings
                     * @returns a Promise
                     *
                     */
                    function show(options) {
                        options = options || {};
                        var interimElement = new InterimElement(options || {});
                        // var hideExisting = !options.skipHide && stack.length ? service.hide() : $q.when(true);

                        // // This hide()s only the current interim element before showing the next, new one
                        // // NOTE: this is not reversible (e.g. interim elements are not stackable)

                        // hideExisting.finally(function () {

                        stack.push(interimElement);
                        interimElement
                            .show()
                            .catch(function (reason) {
                                //$log.error("InterimElement.show() error: " + reason );
                                return reason;
                            });

                        // });

                        // Return a promise that will be resolved when the interim
                        // element is hidden or cancelled...

                        return interimElement.deferred.promise;
                    }

                    /*
                     * @ngdoc method
                     * @name $$interimElement.$service#hide
                     * @kind function
                     *
                     * @description
                     * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
                     *
                     * @param {*} resolveParam Data to resolve the promise with
                     * @returns a Promise that will be resolved after the element has been removed.
                     *
                     */
                    function hide(reason, options) {
                        if (!stack.length) return $q.when(reason);
                        options = options || {};

                        if (options.closeAll) {
                            var promise = $q.all(stack.reverse().map(closeElement));
                            stack = [];
                            return promise;
                        } else if (options.closeTo !== undefined) {
                            return $q.all(stack.splice(options.closeTo).map(closeElement));
                        } else {
                            var interim = stack.pop();
                            return closeElement(interim);
                        }

                        function closeElement(interim) {
                            interim
                                .remove(reason, false, options || {})
                                .catch(function (reason) {
                                    //$log.error("InterimElement.hide() error: " + reason );
                                    return reason;
                                });
                            return interim.deferred.promise;
                        }
                    }

                    /*
                     * @ngdoc method
                     * @name $$interimElement.$service#cancel
                     * @kind function
                     *
                     * @description
                     * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
                     *
                     * @param {*} reason Data to reject the promise with
                     * @returns Promise that will be resolved after the element has been removed.
                     *
                     */
                    function cancel(reason, options) {
                        var interim = stack.pop();
                        if (!interim) return $q.when(reason);

                        interim
                            .remove(reason, true, options || {})
                            .catch(function (reason) {
                                //$log.error("InterimElement.cancel() error: " + reason );
                                return reason;
                            });

                        return interim.deferred.promise;
                    }

                    /*
                     * Special method to quick-remove the interim element without animations
                     * Note: interim elements are in "interim containers"
                     */
                    function destroy(target) {
                        var interim = !target ? stack.shift() : null;
                        var cntr = angular.element(target).length ? angular.element(target)[0].parentNode : null;

                        if (cntr) {
                            // Try to find the interim element in the stack which corresponds to the supplied DOM element.
                            var filtered = stack.filter(function (entry) {
                                if (!entry.options.element) return false
                                var currNode = entry.options.element[0];
                                return (currNode === cntr);
                            });

                            // Note: this function might be called when the element already has been removed, in which
                            //       case we won't find any matches. That's ok.
                            if (filtered.length > 0) {
                                interim = filtered[0];
                                stack.splice(stack.indexOf(interim), 1);
                            }
                        }

                        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) : $q.when(SHOW_CANCELLED);
                    }

                    /*
                     * Internal Interim Element Object
                     * Used internally to manage the DOM element and related data
                     */
                    function InterimElement(options) {
                        var self, element, showAction = $q.when(true);

                        options = configureScopeAndTransitions(options);

                        return self = {
                            options: options,
                            deferred: $q.defer(),
                            show: createAndTransitionIn,
                            remove: transitionOutAndRemove
                        };

                        /**
                         * Compile, link, and show this interim element
                         * Use optional autoHided and transition-in effects
                         */
                        function createAndTransitionIn() {
                            return $q(function (resolve, reject) {

                                compileElement(options)
                                    .then(function (compiledData) {
                                        element = linkElement(compiledData, options);

                                        showAction = showElement(element, options, compiledData.controller)
                                            .then(resolve, rejectAll);

                                    }, rejectAll);

                                function rejectAll(fault) {
                                    // Force the '$md<xxx>.show()' promise to reject
                                    self.deferred.reject(fault);

                                    // Continue rejection propagation
                                    reject(fault);
                                }
                            });
                        }

                        /**
                         * After the show process has finished/rejected:
                         * - announce 'removing',
                         * - perform the transition-out, and
                         * - perform optional clean up scope.
                         */
                        function transitionOutAndRemove(response, isCancelled, opts) {

                            // abort if the show() and compile failed
                            if (!element) return $q.when(false);

                            options = angular.extend(options || {}, opts || {});
                            options.cancelAutoHide && options.cancelAutoHide();
                            options.element.triggerHandler('$mdInterimElementRemove');

                            if (options.$destroy === true) {

                                return hideElement(options.element, options).then(function () {
                                    (isCancelled && rejectAll(response)) || resolveAll(response);
                                });

                            } else {

                                $q.when(showAction)
                                    .finally(function () {
                                        hideElement(options.element, options).then(function () {

                                            (isCancelled && rejectAll(response)) || resolveAll(response);

                                        }, rejectAll);
                                    });

                                return self.deferred.promise;
                            }


                            /**
                             * The `show()` returns a promise that will be resolved when the interim
                             * element is hidden or cancelled...
                             */
                            function resolveAll(response) {
                                self.deferred.resolve(response);
                            }

                            /**
                             * Force the '$md<xxx>.show()' promise to reject
                             */
                            function rejectAll(fault) {
                                self.deferred.reject(fault);
                            }
                        }

                        /**
                         * Prepare optional isolated scope and prepare $animate with default enter and leave
                         * transitions for the new element instance.
                         */
                        function configureScopeAndTransitions(options) {
                            options = options || {};
                            if (options.template) {
                                options.template = $mdUtil.processTemplate(options.template);
                            }

                            return angular.extend({
                                preserveScope: false,
                                cancelAutoHide: angular.noop,
                                scope: options.scope || $rootScope.$new(options.isolateScope),

                                /**
                                 * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
                                 */
                                onShow: function transitionIn(scope, element, options) {
                                    return $animate.enter(element, options.parent);
                                },

                                /**
                                 * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
                                 */
                                onRemove: function transitionOut(scope, element) {
                                    // Element could be undefined if a new element is shown before
                                    // the old one finishes compiling.
                                    return element && $animate.leave(element) || $q.when();
                                }
                            }, options);

                        }

                        /**
                         * Compile an element with a templateUrl, controller, and locals
                         */
                        function compileElement(options) {

                            var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;

                            return compiled || $q(function (resolve) {
                                resolve({
                                    locals: {},
                                    link: function () {
                                        return options.element;
                                    }
                                });
                            });
                        }

                        /**
                         *  Link an element with compiled configuration
                         */
                        function linkElement(compileData, options) {
                            angular.extend(compileData.locals, options);

                            var element = compileData.link(options.scope);

                            // Search for parent at insertion time, if not specified
                            options.element = element;
                            options.parent = findParent(element, options);
                            if (options.themable) $mdTheming(element);

                            return element;
                        }

                        /**
                         * Search for parent at insertion time, if not specified
                         */
                        function findParent(element, options) {
                            var parent = options.parent;

                            // Search for parent at insertion time, if not specified
                            if (angular.isFunction(parent)) {
                                parent = parent(options.scope, element, options);
                            } else if (angular.isString(parent)) {
                                parent = angular.element($document[0].querySelector(parent));
                            } else {
                                parent = angular.element(parent);
                            }

                            // If parent querySelector/getter function fails, or it's just null,
                            // find a default.
                            if (!(parent || {}).length) {
                                var el;
                                if ($rootElement[0] && $rootElement[0].querySelector) {
                                    el = $rootElement[0].querySelector(':not(svg) > body');
                                }
                                if (!el) el = $rootElement[0];
                                if (el.nodeName == '#comment') {
                                    el = $document[0].body;
                                }
                                return angular.element(el);
                            }

                            return parent;
                        }

                        /**
                         * If auto-hide is enabled, start timer and prepare cancel function
                         */
                        function startAutoHide() {
                            var autoHideTimer, cancelAutoHide = angular.noop;

                            if (options.hideDelay) {
                                autoHideTimer = $timeout(service.hide, options.hideDelay);
                                cancelAutoHide = function () {
                                    $timeout.cancel(autoHideTimer);
                                }
                            }

                            // Cache for subsequent use
                            options.cancelAutoHide = function () {
                                cancelAutoHide();
                                options.cancelAutoHide = undefined;
                            }
                        }

                        /**
                         * Show the element ( with transitions), notify complete and start
                         * optional auto-Hide
                         */
                        function showElement(element, options, controller) {
                            // Trigger onShowing callback before the `show()` starts
                            var notifyShowing = options.onShowing || angular.noop;
                            // Trigger onComplete callback when the `show()` finishes
                            var notifyComplete = options.onComplete || angular.noop;

                            notifyShowing(options.scope, element, options, controller);

                            return $q(function (resolve, reject) {
                                try {
                                    // Start transitionIn
                                    $q.when(options.onShow(options.scope, element, options, controller))
                                        .then(function () {
                                            notifyComplete(options.scope, element, options);
                                            startAutoHide();

                                            resolve(element);

                                        }, reject);

                                } catch (e) {
                                    reject(e.message);
                                }
                            });
                        }

                        function hideElement(element, options) {
                            var announceRemoving = options.onRemoving || angular.noop;

                            return $$q(function (resolve, reject) {
                                try {
                                    // Start transitionIn
                                    var action = $$q.when(options.onRemove(options.scope, element, options) || true);

                                    // Trigger callback *before* the remove operation starts
                                    announceRemoving(element, action);

                                    if (options.$destroy == true) {

                                        // For $destroy, onRemove should be synchronous
                                        resolve(element);

                                    } else {

                                        // Wait until transition-out is done
                                        action.then(function () {

                                            if (!options.preserveScope && options.scope) {
                                                options.scope.$destroy();
                                            }

                                            resolve(element);

                                        }, reject);
                                    }

                                } catch (e) {
                                    reject(e.message);
                                }
                            });
                        }

                    }
                };

            }

        }

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            var $mdUtil, $interpolate, $log;

            var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
            var WHITESPACE = /\s+/g;

            var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow'];
            var LAYOUT_OPTIONS = ['row', 'column'];
            var ALIGNMENT_MAIN_AXIS = ["", "start", "center", "end", "stretch", "space-around", "space-between"];
            var ALIGNMENT_CROSS_AXIS = ["", "start", "center", "end", "stretch"];

            var config = {
                /**
                 * Enable directive attribute-to-class conversions
                 * Developers can use `<body md-layout-css />` to quickly
                 * disable the Layout directives and prohibit the injection of Layout classNames
                 */
                enabled: true,

                /**
                 * List of mediaQuery breakpoints and associated suffixes
                 *
                 *   [
                 *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
                 *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
                 *   ]
                 */
                breakpoints: []
            };

            registerLayoutAPI(angular.module('material.core.layout', ['ng']));

            /**
             *   registerLayoutAPI()
             *
             *   The original ngMaterial Layout solution used attribute selectors and CSS.
             *
             *  ```html
             *  <div layout="column"> My Content </div>
             *  ```
             *
             *  ```css
             *  [layout] {
             *    box-sizing: border-box;
             *    display:flex;
             *  }
             *  [layout=column] {
             *    flex-direction : column
             *  }
             *  ```
             *
             *  Use of attribute selectors creates significant performance impacts in some
             *  browsers... mainly IE.
             *
             *  This module registers directives that allow the same layout attributes to be
             *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
             *  contains a Layout directive.
             *
             * ```html
             *   <div layout="column" class="layout layout-column"> My Content </div>
             *```
             *
             *  ```css
             *  .layout {
             *    box-sizing: border-box;
             *    display:flex;
             *  }
             *  .layout-column {
             *    flex-direction : column
             *  }
             *  ```
             */
            function registerLayoutAPI(module) {
                var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
                var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;

                // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
                var BREAKPOINTS = ["", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print"];
                var API_WITH_VALUES = ["layout", "flex", "flex-order", "flex-offset", "layout-align"];
                var API_NO_VALUES = ["show", "hide", "layout-padding", "layout-margin"];


                // Build directive registration functions for the standard Layout API... for all breakpoints.
                angular.forEach(BREAKPOINTS, function (mqb) {

                    // Attribute directives with expected, observable value(s)
                    angular.forEach(API_WITH_VALUES, function (name) {
                        var fullName = mqb ? name + "-" + mqb : name;
                        module.directive(directiveNormalize(fullName), attributeWithObserve(fullName));
                    });

                    // Attribute directives with no expected value(s)
                    angular.forEach(API_NO_VALUES, function (name) {
                        var fullName = mqb ? name + "-" + mqb : name;
                        module.directive(directiveNormalize(fullName), attributeWithoutValue(fullName));
                    });

                });

                // Register other, special directive functions for the Layout features:
                module
                    .directive('mdLayoutCss', disableLayoutDirective)
                    .directive('ngCloak', buildCloakInterceptor('ng-cloak'))

                    .directive('layoutWrap', attributeWithoutValue('layout-wrap'))
                    .directive('layoutNowrap', attributeWithoutValue('layout-nowrap'))
                    .directive('layoutNoWrap', attributeWithoutValue('layout-no-wrap'))
                    .directive('layoutFill', attributeWithoutValue('layout-fill'))

                    // !! Deprecated attributes: use the `-lt` (aka less-than) notations

                    .directive('layoutLtMd', warnAttrNotSupported('layout-lt-md', true))
                    .directive('layoutLtLg', warnAttrNotSupported('layout-lt-lg', true))
                    .directive('flexLtMd', warnAttrNotSupported('flex-lt-md', true))
                    .directive('flexLtLg', warnAttrNotSupported('flex-lt-lg', true))

                    .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
                    .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
                    .directive('flexOrderLtMd', warnAttrNotSupported('flex-order-lt-md'))
                    .directive('flexOrderLtLg', warnAttrNotSupported('flex-order-lt-lg'))
                    .directive('offsetLtMd', warnAttrNotSupported('flex-offset-lt-md'))
                    .directive('offsetLtLg', warnAttrNotSupported('flex-offset-lt-lg'))

                    .directive('hideLtMd', warnAttrNotSupported('hide-lt-md'))
                    .directive('hideLtLg', warnAttrNotSupported('hide-lt-lg'))
                    .directive('showLtMd', warnAttrNotSupported('show-lt-md'))
                    .directive('showLtLg', warnAttrNotSupported('show-lt-lg'));

                /**
                 * Converts snake_case to camelCase.
                 * Also there is special case for Moz prefix starting with upper case letter.
                 * @param name Name to normalize
                 */
                function directiveNormalize(name) {
                    return name
                        .replace(PREFIX_REGEXP, '')
                        .replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
                            return offset ? letter.toUpperCase() : letter;
                        });
                }

            }

            /**
             * Special directive that will disable ALL Layout conversions of layout
             * attribute(s) to classname(s).
             *
             * <link rel="stylesheet" href="angular-material.min.css">
             * <link rel="stylesheet" href="angular-material.layout.css">
             *
             * <body md-layout-css>
             *  ...
             * </body>
             *
             * Note: Using md-layout-css directive requires the developer to load the Material
             * Layout Attribute stylesheet (which only uses attribute selectors):
             *
             *       `angular-material.layout.css`
             *
             * Another option is to use the LayoutProvider to configure and disable the attribute
             * conversions; this would obviate the use of the `md-layout-css` directive
             *
             */
            function disableLayoutDirective() {
                return {
                    restrict: 'A',
                    priority: '900',
                    compile: function (element, attr) {
                        config.enabled = false;
                        return angular.noop;
                    }
                };
            }

            /**
             * Tail-hook ngCloak to delay the uncloaking while Layout transformers
             * finish processing. Eliminates flicker with Material.Layoouts
             */
            function buildCloakInterceptor(className) {
                return ['$timeout', function ($timeout) {
                    return {
                        restrict: 'A',
                        priority: -10, // run after normal ng-cloak
                        compile: function (element) {
                            if (!config.enabled) return angular.noop;

                            // Re-add the cloak
                            element.addClass(className);

                            return function (scope, element) {
                                // Wait while layout injectors configure, then uncloak
                                // NOTE: $rAF does not delay enough... and this is a 1x-only event,
                                //       $timeout is acceptable.
                                $timeout(function () {
                                    element.removeClass(className);
                                }, 10, false);
                            };
                        }
                    };
                }];
            }


            // *********************************************************************************
            //
            // These functions create registration functions for ngMaterial Layout attribute directives
            // This provides easy translation to switch ngMaterial attribute selectors to
            // CLASS selectors and directives; which has huge performance implications
            // for IE Browsers
            //
            // *********************************************************************************

            /**
             * Creates a directive registration function where a possible dynamic attribute
             * value will be observed/watched.
             * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
             */
            function attributeWithObserve(className) {

                return ['$mdUtil', '$interpolate', "$log", function (_$mdUtil_, _$interpolate_, _$log_) {
                    $mdUtil = _$mdUtil_;
                    $interpolate = _$interpolate_;
                    $log = _$log_;

                    return {
                        restrict: 'A',
                        compile: function (element, attr) {
                            var linkFn;
                            if (config.enabled) {
                                // immediately replace static (non-interpolated) invalid values...

                                validateAttributeUsage(className, attr, element, $log);

                                validateAttributeValue(className,
                                    getNormalizedAttrValue(className, attr, ""),
                                    buildUpdateFn(element, className, attr)
                                );

                                linkFn = translateWithValueToCssClass;
                            }

                            // Use for postLink to account for transforms after ng-transclude.
                            return linkFn || angular.noop;
                        }
                    };
                }];

                /**
                 * Add as transformed class selector(s), then
                 * remove the deprecated attribute selector
                 */
                function translateWithValueToCssClass(scope, element, attrs) {
                    var updateFn = updateClassWithValue(element, className, attrs);
                    var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);

                    updateFn(getNormalizedAttrValue(className, attrs, ""));
                    scope.$on("$destroy", function () { unwatch() });
                }
            }

            /**
             * Creates a registration function for ngMaterial Layout attribute directive.
             * This is a `simple` transpose of attribute usage to class usage; where we ignore
             * any attribute value
             */
            function attributeWithoutValue(className) {
                return ['$mdUtil', '$interpolate', "$log", function (_$mdUtil_, _$interpolate_, _$log_) {
                    $mdUtil = _$mdUtil_;
                    $interpolate = _$interpolate_;
                    $log = _$log_;

                    return {
                        restrict: 'A',
                        compile: function (element, attr) {
                            var linkFn;
                            if (config.enabled) {
                                // immediately replace static (non-interpolated) invalid values...

                                validateAttributeValue(className,
                                    getNormalizedAttrValue(className, attr, ""),
                                    buildUpdateFn(element, className, attr)
                                );

                                translateToCssClass(null, element);

                                // Use for postLink to account for transforms after ng-transclude.
                                linkFn = translateToCssClass;
                            }

                            return linkFn || angular.noop;
                        }
                    };
                }];

                /**
                 * Add as transformed class selector, then
                 * remove the deprecated attribute selector
                 */
                function translateToCssClass(scope, element) {
                    element.addClass(className);
                }
            }



            /**
             * After link-phase, do NOT remove deprecated layout attribute selector.
             * Instead watch the attribute so interpolated data-bindings to layout
             * selectors will continue to be supported.
             *
             * $observe() the className and update with new class (after removing the last one)
             *
             * e.g. `layout="{{layoutDemo.direction}}"` will update...
             *
             * NOTE: The value must match one of the specified styles in the CSS.
             * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
             * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
             *
             */
            function updateClassWithValue(element, className) {
                var lastClass;

                return function updateClassFn(newValue) {
                    var value = validateAttributeValue(className, newValue || "");
                    if (angular.isDefined(value)) {
                        if (lastClass) element.removeClass(lastClass);
                        lastClass = !value ? className : className + "-" + value.replace(WHITESPACE, "-");
                        element.addClass(lastClass);
                    }
                };
            }

            /**
             * Provide console warning that this layout attribute has been deprecated
             *
             */
            function warnAttrNotSupported(className) {
                var parts = className.split("-");
                return ["$log", function ($log) {
                    $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
                    return angular.noop;
                }];
            }

            /**
             * Centralize warnings for known flexbox issues (especially IE-related issues)
             */
            function validateAttributeUsage(className, attr, element, $log) {
                var message, usage, url;
                var nodeName = element[0].nodeName.toLowerCase();

                switch (className.replace(SUFFIXES, "")) {
                    case "flex":
                        if ((nodeName == "md-button") || (nodeName == "fieldset")) {
                            // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
                            // Use <div flex> wrapper inside (preferred) or outside

                            usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
                            url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
                            message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";

                            $log.warn($mdUtil.supplant(message, [usage, url]));
                        }
                }

            }


            /**
             * For the Layout attribute value, validate or replace with default
             * fallback value
             */
            function validateAttributeValue(className, value, updateFn) {
                var origValue = value;

                if (!needsInterpolation(value)) {
                    switch (className.replace(SUFFIXES, "")) {
                        case 'layout':
                            if (!findIn(value, LAYOUT_OPTIONS)) {
                                value = LAYOUT_OPTIONS[0]; // 'row';
                            }
                            break;

                        case 'flex':
                            if (!findIn(value, FLEX_OPTIONS)) {
                                if (isNaN(value)) {
                                    value = '';
                                }
                            }
                            break;

                        case 'flex-offset':
                        case 'flex-order':
                            if (!value || isNaN(+value)) {
                                value = '0';
                            }
                            break;

                        case 'layout-align':
                            var axis = extractAlignAxis(value);
                            value = $mdUtil.supplant("{main}-{cross}", axis);
                            break;

                        case 'layout-padding':
                        case 'layout-margin':
                        case 'layout-fill':
                        case 'layout-wrap':
                        case 'layout-nowrap':
                        case 'layout-nowrap':
                            value = '';
                            break;
                    }

                    if (value != origValue) {
                        (updateFn || angular.noop)(value);
                    }
                }

                return value;
            }

            /**
             * Replace current attribute value with fallback value
             */
            function buildUpdateFn(element, className, attrs) {
                return function updateAttrValue(fallback) {
                    if (!needsInterpolation(fallback)) {
                        // Do not modify the element's attribute value; so
                        // uses '<ui-layout layout="/api/sidebar.html" />' will not
                        // be affected. Just update the attrs value.
                        attrs[attrs.$normalize(className)] = fallback;
                    }
                };
            }

            /**
             * See if the original value has interpolation symbols:
             * e.g.  flex-gt-md="{{triggerPoint}}"
             */
            function needsInterpolation(value) {
                return (value || "").indexOf($interpolate.startSymbol()) > -1;
            }

            function getNormalizedAttrValue(className, attrs, defaultVal) {
                var normalizedAttr = attrs.$normalize(className);
                return attrs[normalizedAttr] ? attrs[normalizedAttr].replace(WHITESPACE, "-") : defaultVal || null;
            }

            function findIn(item, list, replaceWith) {
                item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;

                var found = false;
                if (item) {
                    list.forEach(function (it) {
                        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
                        found = found || (it === item);
                    });
                }
                return found;
            }

            function extractAlignAxis(attrValue) {
                var axis = {
                    main: "start",
                    cross: "stretch"
                },
                    values;

                attrValue = (attrValue || "");

                if (attrValue.indexOf("-") == 0 || attrValue.indexOf(" ") == 0) {
                    // For missing main-axis values
                    attrValue = "none" + attrValue;
                }

                values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
                if (values.length && (values[0] === "space")) {
                    // for main-axis values of "space-around" or "space-between"
                    values = [values[0] + "-" + values[1], values[2]];
                }

                if (values.length > 0) axis.main = values[0] || axis.main;
                if (values.length > 1) axis.cross = values[1] || axis.cross;

                if (ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0) axis.main = "start";
                if (ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0) axis.cross = "stretch";

                return axis;
            }


        })();

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.core.componentRegistry
         *
         * @description
         * A component instance registration service.
         * Note: currently this as a private service in the SideNav component.
         */
        angular.module('material.core')
            .factory('$mdComponentRegistry', ComponentRegistry);

        /*
         * @private
         * @ngdoc factory
         * @name ComponentRegistry
         * @module material.core.componentRegistry
         *
         */
        function ComponentRegistry($log, $q) {

            var self;
            var instances = [];
            var pendings = {};

            return self = {
                /**
                 * Used to print an error when an instance for a handle isn't found.
                 */
                notFoundError: function (handle) {
                    $log.error('No instance found for handle', handle);
                },
                /**
                 * Return all registered instances as an array.
                 */
                getInstances: function () {
                    return instances;
                },

                /**
                 * Get a registered instance.
                 * @param handle the String handle to look up for a registered instance.
                 */
                get: function (handle) {
                    if (!isValidID(handle)) return null;

                    var i, j, instance;
                    for (i = 0, j = instances.length; i < j; i++) {
                        instance = instances[i];
                        if (instance.$$mdHandle === handle) {
                            return instance;
                        }
                    }
                    return null;
                },

                /**
                 * Register an instance.
                 * @param instance the instance to register
                 * @param handle the handle to identify the instance under.
                 */
                register: function (instance, handle) {
                    if (!handle) return angular.noop;

                    instance.$$mdHandle = handle;
                    instances.push(instance);
                    resolveWhen();

                    return deregister;

                    /**
                     * Remove registration for an instance
                     */
                    function deregister() {
                        var index = instances.indexOf(instance);
                        if (index !== -1) {
                            instances.splice(index, 1);
                        }
                    }

                    /**
                     * Resolve any pending promises for this instance
                     */
                    function resolveWhen() {
                        var dfd = pendings[handle];
                        if (dfd) {
                            dfd.forEach(function (promise) {
                                promise.resolve(instance);
                            });
                            delete pendings[handle];
                        }
                    }
                },

                /**
                 * Async accessor to registered component instance
                 * If not available then a promise is created to notify
                 * all listeners when the instance is registered.
                 */
                when: function (handle) {
                    if (isValidID(handle)) {
                        var deferred = $q.defer();
                        var instance = self.get(handle);

                        if (instance) {
                            deferred.resolve(instance);
                        } else {
                            if (pendings[handle] === undefined) {
                                pendings[handle] = [];
                            }
                            pendings[handle].push(deferred);
                        }

                        return deferred.promise;
                    }
                    return $q.reject("Invalid `md-component-id` value.");
                }

            };

            function isValidID(handle) {
                return handle && (handle !== "");
            }

        }
        ComponentRegistry.$inject = ["$log", "$q"];

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc service
             * @name $mdButtonInkRipple
             * @module material.core
             *
             * @description
             * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
             *
             * @param {object=} scope Scope within the current context
             * @param {object=} element The element the ripple effect should be applied to
             * @param {object=} options (Optional) Configuration options to override the default ripple configuration
             */

            angular.module('material.core')
                .factory('$mdButtonInkRipple', MdButtonInkRipple);

            function MdButtonInkRipple($mdInkRipple) {
                return {
                    attach: function attachRipple(scope, element, options) {
                        options = angular.extend(optionsForElement(element), options);

                        return $mdInkRipple.attach(scope, element, options);
                    }
                };

                function optionsForElement(element) {
                    if (element.hasClass('md-icon-button')) {
                        return {
                            isMenuItem: element.hasClass('md-menu-item'),
                            fitRipple: true,
                            center: true
                        };
                    } else {
                        return {
                            isMenuItem: element.hasClass('md-menu-item'),
                            dimBackground: true
                        }
                    }
                };
            }
            MdButtonInkRipple.$inject = ["$mdInkRipple"];;
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc service
             * @name $mdCheckboxInkRipple
             * @module material.core
             *
             * @description
             * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
             *
             * @param {object=} scope Scope within the current context
             * @param {object=} element The element the ripple effect should be applied to
             * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
             */

            angular.module('material.core')
                .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);

            function MdCheckboxInkRipple($mdInkRipple) {
                return {
                    attach: attach
                };

                function attach(scope, element, options) {
                    return $mdInkRipple.attach(scope, element, angular.extend({
                        center: true,
                        dimBackground: false,
                        fitRipple: true
                    }, options));
                };
            }
            MdCheckboxInkRipple.$inject = ["$mdInkRipple"];;
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc service
             * @name $mdListInkRipple
             * @module material.core
             *
             * @description
             * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
             *
             * @param {object=} scope Scope within the current context
             * @param {object=} element The element the ripple effect should be applied to
             * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
             */

            angular.module('material.core')
                .factory('$mdListInkRipple', MdListInkRipple);

            function MdListInkRipple($mdInkRipple) {
                return {
                    attach: attach
                };

                function attach(scope, element, options) {
                    return $mdInkRipple.attach(scope, element, angular.extend({
                        center: false,
                        dimBackground: true,
                        outline: false,
                        rippleSize: 'full'
                    }, options));
                };
            }
            MdListInkRipple.$inject = ["$mdInkRipple"];;
        })();

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.core.ripple
         * @description
         * Ripple
         */
        angular.module('material.core')
            .factory('$mdInkRipple', InkRippleService)
            .directive('mdInkRipple', InkRippleDirective)
            .directive('mdNoInk', attrNoDirective)
            .directive('mdNoBar', attrNoDirective)
            .directive('mdNoStretch', attrNoDirective);

        var DURATION = 450;

        /**
         * @ngdoc directive
         * @name mdInkRipple
         * @module material.core.ripple
         *
         * @description
         * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
         *
         * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
         *
         * @usage
         * ### String values
         * <hljs lang="html">
         *   <ANY md-ink-ripple="#FF0000">
         *     Ripples in red
         *   </ANY>
         *
         *   <ANY md-ink-ripple="false">
         *     Not rippling
         *   </ANY>
         * </hljs>
         *
         * ### Interpolated values
         * <hljs lang="html">
         *   <ANY md-ink-ripple="{{ randomColor() }}">
         *     Ripples with the return value of 'randomColor' function
         *   </ANY>
         *
         *   <ANY md-ink-ripple="{{ canRipple() }}">
         *     Ripples if 'canRipple' function return value is not 'false' or '0'
         *   </ANY>
         * </hljs>
         */
        function InkRippleDirective($mdButtonInkRipple, $mdCheckboxInkRipple) {
            return {
                controller: angular.noop,
                link: function (scope, element, attr) {
                    attr.hasOwnProperty('mdInkRippleCheckbox') ?
                        $mdCheckboxInkRipple.attach(scope, element) :
                        $mdButtonInkRipple.attach(scope, element);
                }
            };
        }
        InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];

        /**
         * @ngdoc service
         * @name $mdInkRipple
         * @module material.core.ripple
         *
         * @description
         * `$mdInkRipple` is a service for adding ripples to any element
         *
         * @usage
         * <hljs lang="js">
         * app.factory('$myElementInkRipple', function($mdInkRipple) {
         *   return {
         *     attach: function (scope, element, options) {
         *       return $mdInkRipple.attach(scope, element, angular.extend({
         *         center: false,
         *         dimBackground: true
         *       }, options));
         *     }
         *   };
         * });
         *
         * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
         *   $scope.onClick = function (ev) {
         *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
         *   }
         * });
         * </hljs>
         */

        /**
         * @ngdoc method
         * @name $mdInkRipple#attach
         *
         * @description
         * Attaching given scope, element and options to inkRipple controller
         *
         * @param {object=} scope Scope within the current context
         * @param {object=} element The element the ripple effect should be applied to
         * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
         * * `center` -  Whether the ripple should start from the center of the container element
         * * `dimBackground` - Whether the background should be dimmed with the ripple color
         * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
         * * `fitRipple` - Whether the ripple should fill the element
         */
        function InkRippleService($injector) {
            return { attach: attach };

            function attach(scope, element, options) {
                if (element.controller('mdNoInk')) return angular.noop;
                return $injector.instantiate(InkRippleCtrl, {
                    $scope: scope,
                    $element: element,
                    rippleOptions: options
                });
            }
        }
        InkRippleService.$inject = ["$injector"];

        /**
         * Controller used by the ripple service in order to apply ripples
         * @ngInject
         */
        function InkRippleCtrl($scope, $element, rippleOptions, $window, $timeout, $mdUtil) {
            this.$window = $window;
            this.$timeout = $timeout;
            this.$mdUtil = $mdUtil;
            this.$scope = $scope;
            this.$element = $element;
            this.options = rippleOptions;
            this.mousedown = false;
            this.ripples = [];
            this.timeout = null; // Stores a reference to the most-recent ripple timeout
            this.lastRipple = null;

            $mdUtil.valueOnUse(this, 'container', this.createContainer);

            this.$element.addClass('md-ink-ripple');

            // attach method for unit tests
            ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
            ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);

            this.bindEvents();
        }
        InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil"];


        /**
         * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
         * mouseup or mouseleave event)
         */
        function autoCleanup(self, cleanupFn) {

            if (self.mousedown || self.lastRipple) {
                self.mousedown = false;
                self.$mdUtil.nextTick(angular.bind(self, cleanupFn), false);
            }

        }


        /**
         * Returns the color that the ripple should be (either based on CSS or hard-coded)
         * @returns {string}
         */
        InkRippleCtrl.prototype.color = function (value) {
            var self = this;

            // If assigning a color value, apply it to background and the ripple color
            if (angular.isDefined(value)) {
                self._color = self._parseColor(value);
            }

            // If color lookup, use assigned, defined, or inherited
            return self._color || self._parseColor(self.inkRipple()) || self._parseColor(getElementColor());

            /**
             * Finds the color element and returns its text color for use as default ripple color
             * @returns {string}
             */
            function getElementColor() {
                var items = self.options && self.options.colorElement ? self.options.colorElement : [];
                var elem = items.length ? items[0] : self.$element[0];

                return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
            }
        };

        /**
         * Updating the ripple colors based on the current inkRipple value
         * or the element's computed style color
         */
        InkRippleCtrl.prototype.calculateColor = function () {
            return this.color();
        };


        /**
         * Takes a string color and converts it to RGBA format
         * @param color {string}
         * @param [multiplier] {int}
         * @returns {string}
         */

        InkRippleCtrl.prototype._parseColor = function parseColor(color, multiplier) {
            multiplier = multiplier || 1;

            if (!color) return;
            if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
            if (color.indexOf('rgb') === 0) return rgbToRGBA(color);
            if (color.indexOf('#') === 0) return hexToRGBA(color);

            /**
             * Converts hex value to RGBA string
             * @param color {string}
             * @returns {string}
             */
            function hexToRGBA(color) {
                var hex = color[0] === '#' ? color.substr(1) : color,
                    dig = hex.length / 3,
                    red = hex.substr(0, dig),
                    green = hex.substr(dig, dig),
                    blue = hex.substr(dig * 2);
                if (dig === 1) {
                    red += red;
                    green += green;
                    blue += blue;
                }
                return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
            }

            /**
             * Converts an RGB color to RGBA
             * @param color {string}
             * @returns {string}
             */
            function rgbToRGBA(color) {
                return color.replace(')', ', 0.1)').replace('(', 'a(');
            }

        };

        /**
         * Binds events to the root element for
         */
        InkRippleCtrl.prototype.bindEvents = function () {
            this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
            this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
            this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
            //this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
        };

        /**
         * Create a new ripple on every mousedown event from the root element
         * @param event {MouseEvent}
         */
        InkRippleCtrl.prototype.handleMousedown = function (event) {
            if (this.mousedown) return;

            // When jQuery is loaded, we have to get the original event
            if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
            this.mousedown = true;
            if (this.options.center) {
                this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
            } else {

                // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
                if (event.srcElement !== this.$element[0]) {
                    var layerRect = this.$element[0].getBoundingClientRect();
                    var layerX = event.clientX - layerRect.left;
                    var layerY = event.clientY - layerRect.top;

                    this.createRipple(layerX, layerY);
                } else {
                    this.createRipple(event.offsetX, event.offsetY);
                }
            }
        };

        /**
         * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
         * mouseup, touchend or mouseleave event)
         */
        InkRippleCtrl.prototype.handleMouseup = function () {
            autoCleanup(this, this.clearRipples);
        };

        /**
         * Either remove or unlock any remaining ripples when the user mouses off of the element (by
         * touchmove)
         */
        InkRippleCtrl.prototype.handleTouchmove = function () {
            autoCleanup(this, this.deleteRipples);
        };

        /**
         * Cycles through all ripples and attempts to remove them.
         */
        InkRippleCtrl.prototype.deleteRipples = function () {
            for (var i = 0; i < this.ripples.length; i++) {
                this.ripples[i].remove();
            }
        };

        /**
         * Cycles through all ripples and attempts to remove them with fade.
         * Depending on logic within `fadeInComplete`, some removals will be postponed.
         */
        InkRippleCtrl.prototype.clearRipples = function () {
            for (var i = 0; i < this.ripples.length; i++) {
                this.fadeInComplete(this.ripples[i]);
            }
        };

        /**
         * Creates the ripple container element
         * @returns {*}
         */
        InkRippleCtrl.prototype.createContainer = function () {
            var container = angular.element('<div class="md-ripple-container"></div>');
            this.$element.append(container);
            return container;
        };

        InkRippleCtrl.prototype.clearTimeout = function () {
            if (this.timeout) {
                this.$timeout.cancel(this.timeout);
                this.timeout = null;
            }
        };

        InkRippleCtrl.prototype.isRippleAllowed = function () {
            var element = this.$element[0];
            do {
                if (!element.tagName || element.tagName === 'BODY') break;

                if (element && angular.isFunction(element.hasAttribute)) {
                    if (element.hasAttribute('disabled')) return false;
                    if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
                }

            } while (element = element.parentNode);
            return true;
        };

        /**
         * The attribute `md-ink-ripple` may be a static or interpolated
         * color value OR a boolean indicator (used to disable ripples)
         */
        InkRippleCtrl.prototype.inkRipple = function () {
            return this.$element.attr('md-ink-ripple');
        };

        /**
         * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
         * @param left
         * @param top
         */
        InkRippleCtrl.prototype.createRipple = function (left, top) {
            if (!this.isRippleAllowed()) return;

            var ctrl = this;
            var ripple = angular.element('<div class="md-ripple"></div>');
            var width = this.$element.prop('clientWidth');
            var height = this.$element.prop('clientHeight');
            var x = Math.max(Math.abs(width - left), left) * 2;
            var y = Math.max(Math.abs(height - top), top) * 2;
            var size = getSize(this.options.fitRipple, x, y);
            var color = this.calculateColor();

            ripple.css({
                left: left + 'px',
                top: top + 'px',
                background: 'black',
                width: size + 'px',
                height: size + 'px',
                backgroundColor: rgbaToRGB(color),
                borderColor: rgbaToRGB(color)
            });
            this.lastRipple = ripple;

            // we only want one timeout to be running at a time
            this.clearTimeout();
            this.timeout = this.$timeout(function () {
                ctrl.clearTimeout();
                if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
            }, DURATION * 0.35, false);

            if (this.options.dimBackground) this.container.css({ backgroundColor: color });
            this.container.append(ripple);
            this.ripples.push(ripple);
            ripple.addClass('md-ripple-placed');

            this.$mdUtil.nextTick(function () {

                ripple.addClass('md-ripple-scaled md-ripple-active');
                ctrl.$timeout(function () {
                    ctrl.clearRipples();
                }, DURATION, false);

            }, false);

            function rgbaToRGB(color) {
                return color ?
                    color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')') :
                    'rgb(0,0,0)';
            }

            function getSize(fit, x, y) {
                return fit ?
                    Math.max(x, y) :
                    Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
            }
        };



        /**
         * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
         * @param ripple
         */
        InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
            if (this.lastRipple === ripple) {
                if (!this.timeout && !this.mousedown) {
                    this.removeRipple(ripple);
                }
            } else {
                this.removeRipple(ripple);
            }
        };

        /**
         * Kicks off the animation for removing a ripple
         * @param ripple {Element}
         */
        InkRippleCtrl.prototype.removeRipple = function (ripple) {
            var ctrl = this;
            var index = this.ripples.indexOf(ripple);
            if (index < 0) return;
            this.ripples.splice(this.ripples.indexOf(ripple), 1);
            ripple.removeClass('md-ripple-active');
            if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
            // use a 2-second timeout in order to allow for the animation to finish
            // we don't actually care how long the animation takes
            this.$timeout(function () {
                ctrl.fadeOutComplete(ripple);
            }, DURATION, false);
        };

        /**
         * Removes the provided ripple from the DOM
         * @param ripple
         */
        InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
            ripple.remove();
            this.lastRipple = null;
        };

        /**
         * Used to create an empty directive.  This is used to track flag-directives whose children may have
         * functionality based on them.
         *
         * Example: `md-no-ink` will potentially be used by all child directives.
         */
        function attrNoDirective() {
            return { controller: angular.noop };
        }

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc service
             * @name $mdTabInkRipple
             * @module material.core
             *
             * @description
             * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
             *
             * @param {object=} scope Scope within the current context
             * @param {object=} element The element the ripple effect should be applied to
             * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
             */

            angular.module('material.core')
                .factory('$mdTabInkRipple', MdTabInkRipple);

            function MdTabInkRipple($mdInkRipple) {
                return {
                    attach: attach
                };

                function attach(scope, element, options) {
                    return $mdInkRipple.attach(scope, element, angular.extend({
                        center: false,
                        dimBackground: true,
                        outline: false,
                        rippleSize: 'full'
                    }, options));
                };
            }
            MdTabInkRipple.$inject = ["$mdInkRipple"];;
        })();

    })();
    (function () {
        "use strict";

        angular.module('material.core.theming.palette', [])
            .constant('$mdColorPalette', {
                'red': {
                    '50': '#ffebee',
                    '100': '#ffcdd2',
                    '200': '#ef9a9a',
                    '300': '#e57373',
                    '400': '#ef5350',
                    '500': '#f44336',
                    '600': '#e53935',
                    '700': '#d32f2f',
                    '800': '#c62828',
                    '900': '#b71c1c',
                    'A100': '#ff8a80',
                    'A200': '#ff5252',
                    'A400': '#ff1744',
                    'A700': '#d50000',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 300 A100',
                    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
                },
                'pink': {
                    '50': '#fce4ec',
                    '100': '#f8bbd0',
                    '200': '#f48fb1',
                    '300': '#f06292',
                    '400': '#ec407a',
                    '500': '#e91e63',
                    '600': '#d81b60',
                    '700': '#c2185b',
                    '800': '#ad1457',
                    '900': '#880e4f',
                    'A100': '#ff80ab',
                    'A200': '#ff4081',
                    'A400': '#f50057',
                    'A700': '#c51162',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '500 600 A200 A400 A700'
                },
                'purple': {
                    '50': '#f3e5f5',
                    '100': '#e1bee7',
                    '200': '#ce93d8',
                    '300': '#ba68c8',
                    '400': '#ab47bc',
                    '500': '#9c27b0',
                    '600': '#8e24aa',
                    '700': '#7b1fa2',
                    '800': '#6a1b9a',
                    '900': '#4a148c',
                    'A100': '#ea80fc',
                    'A200': '#e040fb',
                    'A400': '#d500f9',
                    'A700': '#aa00ff',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400 A200 A400 A700'
                },
                'deep-purple': {
                    '50': '#ede7f6',
                    '100': '#d1c4e9',
                    '200': '#b39ddb',
                    '300': '#9575cd',
                    '400': '#7e57c2',
                    '500': '#673ab7',
                    '600': '#5e35b1',
                    '700': '#512da8',
                    '800': '#4527a0',
                    '900': '#311b92',
                    'A100': '#b388ff',
                    'A200': '#7c4dff',
                    'A400': '#651fff',
                    'A700': '#6200ea',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400 A200'
                },
                'indigo': {
                    '50': '#e8eaf6',
                    '100': '#c5cae9',
                    '200': '#9fa8da',
                    '300': '#7986cb',
                    '400': '#5c6bc0',
                    '500': '#3f51b5',
                    '600': '#3949ab',
                    '700': '#303f9f',
                    '800': '#283593',
                    '900': '#1a237e',
                    'A100': '#8c9eff',
                    'A200': '#536dfe',
                    'A400': '#3d5afe',
                    'A700': '#304ffe',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400 A200 A400'
                },
                'blue': {
                    '50': '#e3f2fd',
                    '100': '#bbdefb',
                    '200': '#90caf9',
                    '300': '#64b5f6',
                    '400': '#42a5f5',
                    '500': '#2196f3',
                    '600': '#1e88e5',
                    '700': '#1976d2',
                    '800': '#1565c0',
                    '900': '#0d47a1',
                    'A100': '#82b1ff',
                    'A200': '#448aff',
                    'A400': '#2979ff',
                    'A700': '#2962ff',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 300 400 A100',
                    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
                },
                'light-blue': {
                    '50': '#e1f5fe',
                    '100': '#b3e5fc',
                    '200': '#81d4fa',
                    '300': '#4fc3f7',
                    '400': '#29b6f6',
                    '500': '#03a9f4',
                    '600': '#039be5',
                    '700': '#0288d1',
                    '800': '#0277bd',
                    '900': '#01579b',
                    'A100': '#80d8ff',
                    'A200': '#40c4ff',
                    'A400': '#00b0ff',
                    'A700': '#0091ea',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '600 700 800 900 A700',
                    'contrastStrongLightColors': '600 700 800 A700'
                },
                'cyan': {
                    '50': '#e0f7fa',
                    '100': '#b2ebf2',
                    '200': '#80deea',
                    '300': '#4dd0e1',
                    '400': '#26c6da',
                    '500': '#00bcd4',
                    '600': '#00acc1',
                    '700': '#0097a7',
                    '800': '#00838f',
                    '900': '#006064',
                    'A100': '#84ffff',
                    'A200': '#18ffff',
                    'A400': '#00e5ff',
                    'A700': '#00b8d4',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '700 800 900',
                    'contrastStrongLightColors': '700 800 900'
                },
                'teal': {
                    '50': '#e0f2f1',
                    '100': '#b2dfdb',
                    '200': '#80cbc4',
                    '300': '#4db6ac',
                    '400': '#26a69a',
                    '500': '#009688',
                    '600': '#00897b',
                    '700': '#00796b',
                    '800': '#00695c',
                    '900': '#004d40',
                    'A100': '#a7ffeb',
                    'A200': '#64ffda',
                    'A400': '#1de9b6',
                    'A700': '#00bfa5',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '500 600 700 800 900',
                    'contrastStrongLightColors': '500 600 700'
                },
                'green': {
                    '50': '#e8f5e9',
                    '100': '#c8e6c9',
                    '200': '#a5d6a7',
                    '300': '#81c784',
                    '400': '#66bb6a',
                    '500': '#4caf50',
                    '600': '#43a047',
                    '700': '#388e3c',
                    '800': '#2e7d32',
                    '900': '#1b5e20',
                    'A100': '#b9f6ca',
                    'A200': '#69f0ae',
                    'A400': '#00e676',
                    'A700': '#00c853',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '500 600 700 800 900',
                    'contrastStrongLightColors': '500 600 700'
                },
                'light-green': {
                    '50': '#f1f8e9',
                    '100': '#dcedc8',
                    '200': '#c5e1a5',
                    '300': '#aed581',
                    '400': '#9ccc65',
                    '500': '#8bc34a',
                    '600': '#7cb342',
                    '700': '#689f38',
                    '800': '#558b2f',
                    '900': '#33691e',
                    'A100': '#ccff90',
                    'A200': '#b2ff59',
                    'A400': '#76ff03',
                    'A700': '#64dd17',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '700 800 900',
                    'contrastStrongLightColors': '700 800 900'
                },
                'lime': {
                    '50': '#f9fbe7',
                    '100': '#f0f4c3',
                    '200': '#e6ee9c',
                    '300': '#dce775',
                    '400': '#d4e157',
                    '500': '#cddc39',
                    '600': '#c0ca33',
                    '700': '#afb42b',
                    '800': '#9e9d24',
                    '900': '#827717',
                    'A100': '#f4ff81',
                    'A200': '#eeff41',
                    'A400': '#c6ff00',
                    'A700': '#aeea00',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '900',
                    'contrastStrongLightColors': '900'
                },
                'yellow': {
                    '50': '#fffde7',
                    '100': '#fff9c4',
                    '200': '#fff59d',
                    '300': '#fff176',
                    '400': '#ffee58',
                    '500': '#ffeb3b',
                    '600': '#fdd835',
                    '700': '#fbc02d',
                    '800': '#f9a825',
                    '900': '#f57f17',
                    'A100': '#ffff8d',
                    'A200': '#ffff00',
                    'A400': '#ffea00',
                    'A700': '#ffd600',
                    'contrastDefaultColor': 'dark'
                },
                'amber': {
                    '50': '#fff8e1',
                    '100': '#ffecb3',
                    '200': '#ffe082',
                    '300': '#ffd54f',
                    '400': '#ffca28',
                    '500': '#ffc107',
                    '600': '#ffb300',
                    '700': '#ffa000',
                    '800': '#ff8f00',
                    '900': '#ff6f00',
                    'A100': '#ffe57f',
                    'A200': '#ffd740',
                    'A400': '#ffc400',
                    'A700': '#ffab00',
                    'contrastDefaultColor': 'dark'
                },
                'orange': {
                    '50': '#fff3e0',
                    '100': '#ffe0b2',
                    '200': '#ffcc80',
                    '300': '#ffb74d',
                    '400': '#ffa726',
                    '500': '#ff9800',
                    '600': '#fb8c00',
                    '700': '#f57c00',
                    '800': '#ef6c00',
                    '900': '#e65100',
                    'A100': '#ffd180',
                    'A200': '#ffab40',
                    'A400': '#ff9100',
                    'A700': '#ff6d00',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '800 900',
                    'contrastStrongLightColors': '800 900'
                },
                'deep-orange': {
                    '50': '#fbe9e7',
                    '100': '#ffccbc',
                    '200': '#ffab91',
                    '300': '#ff8a65',
                    '400': '#ff7043',
                    '500': '#ff5722',
                    '600': '#f4511e',
                    '700': '#e64a19',
                    '800': '#d84315',
                    '900': '#bf360c',
                    'A100': '#ff9e80',
                    'A200': '#ff6e40',
                    'A400': '#ff3d00',
                    'A700': '#dd2c00',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 300 400 A100 A200',
                    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
                },
                'brown': {
                    '50': '#efebe9',
                    '100': '#d7ccc8',
                    '200': '#bcaaa4',
                    '300': '#a1887f',
                    '400': '#8d6e63',
                    '500': '#795548',
                    '600': '#6d4c41',
                    '700': '#5d4037',
                    '800': '#4e342e',
                    '900': '#3e2723',
                    'A100': '#d7ccc8',
                    'A200': '#bcaaa4',
                    'A400': '#8d6e63',
                    'A700': '#5d4037',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200',
                    'contrastStrongLightColors': '300 400'
                },
                'grey': {
                    '50': '#fafafa',
                    '100': '#f5f5f5',
                    '200': '#eeeeee',
                    '300': '#e0e0e0',
                    '400': '#bdbdbd',
                    '500': '#9e9e9e',
                    '600': '#757575',
                    '700': '#616161',
                    '800': '#424242',
                    '900': '#212121',
                    'A100': '#ffffff',
                    'A200': '#000000',
                    'A400': '#303030',
                    'A700': '#616161',
                    'contrastDefaultColor': 'dark',
                    'contrastLightColors': '600 700 800 900'
                },
                'blue-grey': {
                    '50': '#eceff1',
                    '100': '#cfd8dc',
                    '200': '#b0bec5',
                    '300': '#90a4ae',
                    '400': '#78909c',
                    '500': '#607d8b',
                    '600': '#546e7a',
                    '700': '#455a64',
                    '800': '#37474f',
                    '900': '#263238',
                    'A100': '#cfd8dc',
                    'A200': '#b0bec5',
                    'A400': '#78909c',
                    'A700': '#455a64',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 300 700',
                    'contrastStrongLightColors': '400 500 700'
                }
            });

    })();
    (function () {
        "use strict";

        angular.module('material.core.theming', ['material.core.theming.palette'])
            .directive('mdTheme', ThemingDirective)
            .directive('mdThemable', ThemableDirective)
            .provider('$mdTheming', ThemingProvider)
        //.run(generateAllThemes);

        /**
         * @ngdoc service
         * @name $mdThemingProvider
         * @module material.core.theming
         *
         * @description Provider to configure the `$mdTheming` service.
         */

        /**
         * @ngdoc method
         * @name $mdThemingProvider#setNonce
         * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
         * Setting a value allows the use CSP policy without using the unsafe-inline directive.
         */

        /**
         * @ngdoc method
         * @name $mdThemingProvider#setDefaultTheme
         * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
         */

        /**
         * @ngdoc method
         * @name $mdThemingProvider#alwaysWatchTheme
         * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
         * classes when they change. Default is `false`. Enabling can reduce performance.
         */

        /* Some Example Valid Theming Expressions
         * =======================================
         *
         * Intention group expansion: (valid for primary, accent, warn, background)
         *
         * {{primary-100}} - grab shade 100 from the primary palette
         * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
         * {{primary-100-contrast}} - grab shade 100's contrast color
         * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
         * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
         * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
         * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
         * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
         * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
         *
         * Foreground expansion: Applies rgba to black/white foreground text
         *
         * {{foreground-1}} - used for primary text
         * {{foreground-2}} - used for secondary text/divider
         * {{foreground-3}} - used for disabled text
         * {{foreground-4}} - used for dividers
         *
         */

        // In memory generated CSS rules; registered by theme.name
        var GENERATED = {};

        // In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
        var PALETTES;
        var THEMES;

        var DARK_FOREGROUND = {
            name: 'dark',
            '1': 'rgba(0,0,0,0.87)',
            '2': 'rgba(0,0,0,0.54)',
            '3': 'rgba(0,0,0,0.38)',
            '4': 'rgba(0,0,0,0.12)'
        };
        var LIGHT_FOREGROUND = {
            name: 'light',
            '1': 'rgba(255,255,255,1.0)',
            '2': 'rgba(255,255,255,0.7)',
            '3': 'rgba(255,255,255,0.5)',
            '4': 'rgba(255,255,255,0.12)'
        };

        var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
        var LIGHT_SHADOW = '';

        var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
        var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
        var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');

        var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
        var DEFAULT_COLOR_TYPE = 'primary';

        // A color in a theme will use these hues by default, if not specified by user.
        var LIGHT_DEFAULT_HUES = {
            'accent': {
                'default': 'A200',
                'hue-1': 'A100',
                'hue-2': 'A400',
                'hue-3': 'A700'
            },
            'background': {
                'default': '50',
                'hue-1': 'A100',
                'hue-2': '100',
                'hue-3': '300'
            }
        };

        var DARK_DEFAULT_HUES = {
            'background': {
                'default': 'A400',
                'hue-1': '800',
                'hue-2': '900',
                'hue-3': 'A200'
            }
        };
        THEME_COLOR_TYPES.forEach(function (colorType) {
            // Color types with unspecified default hues will use these default hue values
            var defaultDefaultHues = {
                'default': '500',
                'hue-1': '300',
                'hue-2': '800',
                'hue-3': 'A100'
            };
            if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
            if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
        });

        var VALID_HUE_VALUES = [
            '50', '100', '200', '300', '400', '500', '600',
            '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
        ];

        // Whether or not themes are to be generated on-demand (vs. eagerly).
        var generateOnDemand = false;

        // Nonce to be added as an attribute to the generated themes style tags.
        var nonce = null;

        function ThemingProvider($mdColorPalette) {
            PALETTES = {};
            THEMES = {};

            var themingProvider;
            var defaultTheme = 'default';
            var alwaysWatchTheme = false;

            // Load JS Defined Palettes
            angular.extend(PALETTES, $mdColorPalette);

            // Default theme defined in core.js


            ThemingService.$inject = ["$rootScope", "$log"];
            return themingProvider = {
                definePalette: definePalette,
                extendPalette: extendPalette,
                theme: registerTheme,
                reloadThemes: generateAllThemes, // allow reloading themes

                setNonce: function (nonceValue) {
                    nonce = nonceValue;
                },
                setDefaultTheme: function (theme) {
                    defaultTheme = theme;
                },
                alwaysWatchTheme: function (alwaysWatch) {
                    alwaysWatchTheme = alwaysWatch;
                },
                generateThemesOnDemand: function (onDemand) {
                    generateOnDemand = onDemand;
                },
                $get: ThemingService,
                _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
                _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
                _PALETTES: PALETTES,
                _THEMES: THEMES,
                _parseRules: parseRules,
                _rgba: rgba
            };

            // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
            function definePalette(name, map) {
                map = map || {};
                PALETTES[name] = checkPaletteValid(name, map);
                return themingProvider;
            }

            // Returns an new object which is a copy of a given palette `name` with variables from
            // `map` overwritten
            // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
            function extendPalette(name, map) {
                return checkPaletteValid(name, angular.extend({}, PALETTES[name] || {}, map));
            }

            // Make sure that palette has all required hues
            function checkPaletteValid(name, map) {
                var missingColors = VALID_HUE_VALUES.filter(function (field) {
                    return !map[field];
                });
                if (missingColors.length) {
                    throw new Error("Missing colors %1 in palette %2!"
                        .replace('%1', missingColors.join(', '))
                        .replace('%2', name));
                }

                return map;
            }

            // Register a theme (which is a collection of color palettes to use with various states
            // ie. warn, accent, primary )
            // Optionally inherit from an existing theme
            // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
            function registerTheme(name, inheritFrom) {
                if (THEMES[name]) return THEMES[name];

                inheritFrom = inheritFrom || 'default';

                var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
                var theme = new Theme(name);

                if (parentTheme) {
                    angular.forEach(parentTheme.colors, function (color, colorType) {
                        theme.colors[colorType] = {
                            name: color.name,
                            // Make sure a COPY of the hues is given to the child color,
                            // not the same reference.
                            hues: angular.extend({}, color.hues)
                        };
                    });
                }
                THEMES[name] = theme;

                return theme;
            }

            function Theme(name) {
                var self = this;
                self.name = name;
                self.colors = {};

                self.dark = setDark;
                setDark(false);

                function setDark(isDark) {
                    isDark = arguments.length === 0 ? true : !!isDark;

                    // If no change, abort
                    if (isDark === self.isDark) return;

                    self.isDark = isDark;

                    self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
                    self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;

                    // Light and dark themes have different default hues.
                    // Go through each existing color type for this theme, and for every
                    // hue value that is still the default hue value from the previous light/dark setting,
                    // set it to the default hue value from the new light/dark setting.
                    var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
                    var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
                    angular.forEach(newDefaultHues, function (newDefaults, colorType) {
                        var color = self.colors[colorType];
                        var oldDefaults = oldDefaultHues[colorType];
                        if (color) {
                            for (var hueName in color.hues) {
                                if (color.hues[hueName] === oldDefaults[hueName]) {
                                    color.hues[hueName] = newDefaults[hueName];
                                }
                            }
                        }
                    });

                    return self;
                }

                THEME_COLOR_TYPES.forEach(function (colorType) {
                    var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
                    self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
                        var color = self.colors[colorType] = {
                            name: paletteName,
                            hues: angular.extend({}, defaultHues, hues)
                        };

                        Object.keys(color.hues).forEach(function (name) {
                            if (!defaultHues[name]) {
                                throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
                                    .replace('%1', name)
                                    .replace('%2', self.name)
                                    .replace('%3', paletteName)
                                    .replace('%4', Object.keys(defaultHues).join(', '))
                                );
                            }
                        });
                        Object.keys(color.hues).map(function (key) {
                            return color.hues[key];
                        }).forEach(function (hueValue) {
                            if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
                                throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
                                    .replace('%1', hueValue)
                                    .replace('%2', self.name)
                                    .replace('%3', colorType)
                                    .replace('%4', paletteName)
                                    .replace('%5', VALID_HUE_VALUES.join(', '))
                                );
                            }
                        });
                        return self;
                    };

                    self[colorType + 'Color'] = function () {
                        var args = Array.prototype.slice.call(arguments);
                        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
                            'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
                        return self[colorType + 'Palette'].apply(self, args);
                    };
                });
            }

            /**
             * @ngdoc service
             * @name $mdTheming
             *
             * @description
             *
             * Service that makes an element apply theming related classes to itself.
             *
             * ```js
             * app.directive('myFancyDirective', function($mdTheming) {
             *   return {
             *     restrict: 'e',
             *     link: function(scope, el, attrs) {
             *       $mdTheming(el);
             *     }
             *   };
             * });
             * ```
             * @param {el=} element to apply theming to
             */
            /* @ngInject */
            function ThemingService($rootScope, $log) {
                // Allow us to be invoked via a linking function signature.
                var applyTheme = function (scope, el) {
                    if (el === undefined) {
                        el = scope;
                        scope = undefined;
                    }
                    if (scope === undefined) { scope = $rootScope; }
                    applyTheme.inherit(el, el);
                };

                applyTheme.THEMES = angular.extend({}, THEMES);
                applyTheme.inherit = inheritTheme;
                applyTheme.registered = registered;
                applyTheme.defaultTheme = function () { return defaultTheme; };
                applyTheme.generateTheme = function (name) { generateTheme(name, nonce); };

                return applyTheme;

                /**
                 * Determine is specified theme name is a valid, registered theme
                 */
                function registered(themeName) {
                    if (themeName === undefined || themeName === '') return true;
                    return applyTheme.THEMES[themeName] !== undefined;
                }

                /**
                 * Get theme name for the element, then update with Theme CSS class
                 */
                function inheritTheme(el, parent) {
                    var ctrl = parent.controller('mdTheme');
                    var attrThemeValue = el.attr('md-theme-watch');
                    var watchTheme = (alwaysWatchTheme || angular.isDefined(attrThemeValue)) && attrThemeValue != 'false';

                    updateThemeClass(lookupThemeName());

                    el.on('$destroy', watchTheme ? $rootScope.$watch(lookupThemeName, updateThemeClass) : angular.noop);

                    /**
                     * Find the theme name from the parent controller or element data
                     */
                    function lookupThemeName() {
                        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
                        ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
                        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
                    }

                    /**
                     * Remove old theme class and apply a new one
                     * NOTE: if not a valid theme name, then the current name is not changed
                     */
                    function updateThemeClass(theme) {
                        if (!theme) return;
                        if (!registered(theme)) {
                            $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
                                'Register it with $mdThemingProvider.theme().');
                        }

                        var oldTheme = el.data('$mdThemeName');
                        if (oldTheme) el.removeClass('md-' + oldTheme + '-theme');
                        el.addClass('md-' + theme + '-theme');
                        el.data('$mdThemeName', theme);
                        if (ctrl) {
                            el.data('$mdThemeController', ctrl);
                        }
                    }
                }

            }
        }
        ThemingProvider.$inject = ["$mdColorPalette"];

        function ThemingDirective($mdTheming, $interpolate, $log) {
            return {
                priority: 100,
                link: {
                    pre: function (scope, el, attrs) {
                        var ctrl = {
                            $setTheme: function (theme) {
                                if (!$mdTheming.registered(theme)) {
                                    $log.warn('attempted to use unregistered theme \'' + theme + '\'');
                                }
                                ctrl.$mdTheme = theme;
                            }
                        };
                        el.data('$mdThemeController', ctrl);
                        ctrl.$setTheme($interpolate(attrs.mdTheme)(scope));
                        attrs.$observe('mdTheme', ctrl.$setTheme);
                    }
                }
            };
        }
        ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$log"];

        function ThemableDirective($mdTheming) {
            return $mdTheming;
        }
        ThemableDirective.$inject = ["$mdTheming"];

        function parseRules(theme, colorType, rules) {
            checkValidPalette(theme, colorType);

            rules = rules.replace(/THEME_NAME/g, theme.name);
            var generatedRules = [];
            var color = theme.colors[colorType];

            var themeNameRegex = new RegExp('.md-' + theme.name + '-theme', 'g');
            // Matches '{{ primary-color }}', etc
            var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?', 'g');
            var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
            var palette = PALETTES[color.name];

            // find and replace simple variables where we use a specific hue, not an entire palette
            // eg. "{{primary-100}}"
            //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
            rules = rules.replace(simpleVariableRegex, function (match, colorType, hue, opacity, contrast) {
                if (colorType === 'foreground') {
                    if (hue == 'shadow') {
                        return theme.foregroundShadow;
                    } else {
                        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
                    }
                }
                if (hue.indexOf('hue') === 0) {
                    hue = theme.colors[colorType].hues[hue];
                }
                return rgba((PALETTES[theme.colors[colorType].name][hue] || '')[contrast ? 'contrast' : 'value'], opacity);
            });

            // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
            angular.forEach(color.hues, function (hueValue, hueName) {
                var newRule = rules
                    .replace(hueRegex, function (match, _, colorType, hueType, opacity) {
                        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
                    });
                if (hueName !== 'default') {
                    newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
                }

                // Don't apply a selector rule to the default theme, making it easier to override
                // styles of the base-component
                if (theme.name == 'default') {
                    var themeRuleRegex = /((?:(?:(?: |>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)+) )?)((?:(?:\w|\.|-)+)?)\.md-default-theme((?: |>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;
                    newRule = newRule.replace(themeRuleRegex, function (match, prefix, target, suffix) {
                        return match + ', ' + prefix + target + suffix;
                    });
                }
                generatedRules.push(newRule);
            });

            return generatedRules;
        }

        var rulesByType = {};

        function repeat(s, count) {
            var str = "";
            for (var i = 0; i < count; i++) {
                str = str + s;
            }
            return str
        }

        // Generate our themes at run time given the state of THEMES and PALETTES
        function generateAllThemes($injector) {
            var head = document.head;
            var firstChild = head ? head.firstElementChild : null;
            var theirCss = $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';

            var ourCss = [
                ".background-primary { background-color: '{{primary-color}}' !important; color: '{{primary-contrast}}' !important; }",
                ".background-accent { background-color: '{{accent-500}}' !important; color: '{{accent-contrast}}' !important; }",

                // tab notification background
                ".notification-panel-pinned .notifications-panel md-tabs-canvas { background-color: '{{primary-color}}' !important; }",
                ".notification-panel-pinned .notifications-panel md-tabs-canvas * { color: rgba(255, 255, 255, 0.87) !important; }",

                // help tooltip corner:
                "au-help-popup md-toolbar:before { border-color: '{{primary-color}}'; }", // toolbars are primary by default
                "au-help-popup md-toolbar.md-accent:before { border-color: '{{accent-color}}'; }",
                "au-help-popup md-toolbar.md-warn:before { border-color: '{{warn-color}}'; }",

                // org chart drag target:
                ".angular-org-chart .node.drag-hover > .node-contents md-toolbar { background-color: '{{primary-color}}' !important; color: '{{primary-contrast}}' }",
                ".angular-org-chart .node.drag-hover > .node-contents md-card { background-color: '{{primary-color}}'; color: '{{primary-contrast}}' }",
                ".angular-org-chart .node.drag-hover > .node-contents md-card-content { background-color: '{{primary-color}}'; color: '{{primary-contrast}}' }",

                //breadcrumbs:
                ".breadcrumb-menu { background-color: '{{primary-color}}' !important; color: '{{primary-contrast}}' }",
                ".breadcrumb-menu md-icon { color: '{{primary-contrast}}' }",

                //borders:
                ".border-top-color { border-top-color: '{{primary-color}}' }",
                ".border-bottom-color { border-bottom-color: '{{primary-color}}' }",
                ".border-right-color { border-right-color: '{{primary-color}}' }",
                ".border-left-color { border-left-color: '{{primary-color}}' }",

                ".border-top-color-contrast { border-top-color: '{{accent-500}}' }",
                ".border-bottom-color-contrast { border-bottom-color: '{{accent-500}}' }",
                ".border-right-color-contrast { border-right-color: '{{accent-500}}' }",
                ".border-left-color-contrast { border-left-color: '{{accent-500}}' }",

                // normal links:
                "a { color: '{{primary-color}}' }",
                "a:visited { color: '{{primary-color}}' }",

            ]

            angular.forEach([50, 100, 200, 300, 400, 500, 600, 700, 800, 900], function (hue, index) {
                // backgrounds for the monopoly cards in the org chart
                ourCss.push('.AngularOrgChart ' + repeat('.node-container ', index + 1) + 'md-toolbar.background-banner { background-color: \'{{primary-' + hue + '}}\';}');

                // themed backgrounds
                ourCss.push('.background-color-' + hue + ' { background-color: \'{{primary-' + hue + '}}\' !important; color: \'{{primary-' + hue + 'contrast}}\' }');
                ourCss.push('.background-accent-' + hue + ' { background-color: \'{{accent-' + hue + '}}\' !important; color: \'{{accent-' + hue + 'contrast}}\' }');
                ourCss.push('.font-color-' + hue + ' { color: \'{{primary-' + hue + '}}\' !important; }');
                ourCss.push('md-icon.font-color-' + hue + '::before { color: \'{{primary-' + hue + '}}\' !important; }');
                ourCss.push('.font-color-accent-' + hue + ' { color: \'{{accent-' + hue + '}}\' !important; }');
            });

            angular.forEach(ourCss, function (line, index) {
                ourCss[index] = ".md-THEME_NAME-theme " + line;
            });

            var themeCss = theirCss + ourCss.join('');

            if (!firstChild) return;
            if (themeCss.length === 0) return; // no rules, so no point in running this expensive task

            // Expose contrast colors for palettes to ensure that text is always readable
            angular.forEach(PALETTES, sanitizePalette);

            // MD_THEME_CSS is a string generated by the build process that includes all the themable
            // components as templates

            // Break the CSS into individual rules
            var rules = themeCss
                .split(/\}(?!(\}|'|"|;))/)
                .filter(function (rule) { return rule && rule.length; })
                .map(function (rule) { return rule.trim() + '}'; });


            var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');

            THEME_COLOR_TYPES.forEach(function (type) {
                rulesByType[type] = '';
            });


            // Sort the rules based on type, allowing us to do color substitution on a per-type basis
            rules.forEach(function (rule) {
                var match = rule.match(ruleMatchRegex);
                // First: test that if the rule has '.md-accent', it goes into the accent set of rules
                for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
                    if (rule.indexOf('.md-' + type) > -1) {
                        return rulesByType[type] += rule;
                    }
                }

                // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
                // there
                for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
                    if (rule.indexOf(type) > -1) {
                        return rulesByType[type] += rule;
                    }
                }

                // Default to the primary array
                return rulesByType[DEFAULT_COLOR_TYPE] += rule;
            });

            // If themes are being generated on-demand, quit here. The user will later manually
            // call generateTheme to do this on a theme-by-theme basis.
            if (generateOnDemand) return;

            angular.forEach(THEMES, function (theme) {
                if (!GENERATED[theme.name]) {
                    generateTheme(theme.name, nonce);
                }
            });


            // *************************
            // Internal functions
            // *************************

            // The user specifies a 'default' contrast color as either light or dark,
            // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
            function sanitizePalette(palette, name) {
                var defaultContrast = palette.contrastDefaultColor;
                var lightColors = palette.contrastLightColors || [];
                var strongLightColors = palette.contrastStrongLightColors || [];
                var darkColors = palette.contrastDarkColors || [];

                // These colors are provided as space-separated lists
                if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
                if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
                if (typeof darkColors === 'string') darkColors = darkColors.split(' ');

                // Cleanup after ourselves
                delete palette.contrastDefaultColor;
                delete palette.contrastLightColors;
                delete palette.contrastStrongLightColors;
                delete palette.contrastDarkColors;

                // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
                angular.forEach(palette, function (hueValue, hueName) {
                    if (angular.isObject(hueValue)) return; // Already converted
                    // Map everything to rgb colors
                    var rgbValue = colorToRgbaArray(hueValue);
                    if (!rgbValue) {
                        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                            .replace('%1', hueValue)
                            .replace('%2', palette.name)
                            .replace('%3', hueName));
                    }

                    palette[hueName] = {
                        value: rgbValue,
                        contrast: getContrastColor()
                    };

                    function getContrastColor() {
                        if (defaultContrast === 'light') {
                            if (darkColors.indexOf(hueName) > -1) {
                                return DARK_CONTRAST_COLOR;
                            } else {
                                return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR :
                                    LIGHT_CONTRAST_COLOR;
                            }
                        } else {
                            if (lightColors.indexOf(hueName) > -1) {
                                return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR :
                                    LIGHT_CONTRAST_COLOR;
                            } else {
                                return DARK_CONTRAST_COLOR;
                            }
                        }
                    }
                });
            }
        }
        generateAllThemes.$inject = ["$injector"];

        function generateTheme(name, nonce) {
            var theme = THEMES[name];
            var head = document.head;
            var firstChild = head ? head.firstElementChild : null;

            if (!GENERATED[name]) {
                // For each theme, use the color palettes specified for
                // `primary`, `warn` and `accent` to generate CSS rules.
                THEME_COLOR_TYPES.forEach(function (colorType) {
                    var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
                    while (styleStrings.length) {
                        var styleContent = styleStrings.shift();
                        if (styleContent) {
                            var style = document.createElement('style');
                            style.setAttribute('md-theme-style', '');
                            if (nonce) {
                                style.setAttribute('nonce', nonce);
                            }
                            style.appendChild(document.createTextNode(styleContent));
                            head.insertBefore(style, firstChild);
                        }
                    }
                });


                if (theme.colors.primary.name == theme.colors.accent.name) {
                    console.warn('$mdThemingProvider: Using the same palette for primary and' +
                        ' accent. This violates the material design spec.');
                }
                // prevent optimization to allow themes to be reloaded later
                GENERATED[theme.name] = false;
            }

        }


        function checkValidPalette(theme, colorType) {
            // If theme attempts to use a palette that doesnt exist, throw error
            if (!PALETTES[(theme.colors[colorType] || {}).name]) {
                throw new Error(
                    "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
                        .replace('%1', theme.name)
                        .replace('%2', colorType)
                        .replace('%3', Object.keys(PALETTES).join(', '))
                );
            }
        }

        function colorToRgbaArray(clr) {
            if (angular.isArray(clr) && clr.length == 3) return clr;
            if (/^rgb/.test(clr)) {
                return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function (value, i) {
                    return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
                });
            }
            if (clr.charAt(0) == '#') clr = clr.substring(1);
            if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;

            var dig = clr.length / 3;
            var red = clr.substr(0, dig);
            var grn = clr.substr(dig, dig);
            var blu = clr.substr(dig * 2);
            if (dig === 1) {
                red += red;
                grn += grn;
                blu += blu;
            }
            return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
        }

        function rgba(rgbArray, opacity) {
            if (!rgbArray) return "rgb('0,0,0')";

            if (rgbArray.length == 4) {
                rgbArray = angular.copy(rgbArray);
                opacity ? rgbArray.pop() : opacity = rgbArray.pop();
            }
            return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
                'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
                'rgb(' + rgbArray.join(',') + ')';
        }

    })();
    (function () {
        "use strict";

        // Polyfill angular < 1.4 (provide $animateCss)
        angular
            .module('material.core')
            .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function ($q, $timeout, $mdConstant, $animateCss) {

                // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
                // to subsequently inject $mdUtil as an argument to the AnimateDomUtils

                return function ($mdUtil) {
                    return AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss);
                };
            }]);

        /**
         * Factory function that requires special injections
         */
        function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
            var self;
            return self = {
                /**
                 *
                 */
                translate3d: function (target, from, to, options) {
                    return $animateCss(target, {
                        from: from,
                        to: to,
                        addClass: options.transitionInClass
                    })
                        .start()
                        .then(function () {
                            // Resolve with reverser function...
                            return reverseTranslate;
                        });

                    /**
                     * Specific reversal of the request translate animation above...
                     */
                    function reverseTranslate(newFrom) {
                        return $animateCss(target, {
                            to: newFrom || from,
                            addClass: options.transitionOutClass,
                            removeClass: options.transitionInClass
                        }).start();

                    }
                },

                /**
                 * Listen for transitionEnd event (with optional timeout)
                 * Announce completion or failure via promise handlers
                 */
                waitTransitionEnd: function (element, opts) {
                    var TIMEOUT = 3000; // fallback is 3 secs

                    return $q(function (resolve, reject) {
                        opts = opts || {};

                        var timer = $timeout(finished, opts.timeout || TIMEOUT);
                        element.on($mdConstant.CSS.TRANSITIONEND, finished);

                        /**
                         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
                         * NOTE: Make sure this transitionEnd didn't bubble up from a child
                         */
                        function finished(ev) {
                            if (ev && ev.target !== element[0]) return;

                            if (ev) $timeout.cancel(timer);
                            element.off($mdConstant.CSS.TRANSITIONEND, finished);

                            // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
                            resolve();

                        }

                    });
                },

                /**
                 * Calculate the zoom transform from dialog to origin.
                 *
                 * We use this to set the dialog position immediately;
                 * then the md-transition-in actually translates back to
                 * `translate3d(0,0,0) scale(1.0)`...
                 *
                 * NOTE: all values are rounded to the nearest integer
                 */
                calculateZoomToOrigin: function (element, originator) {
                    var origin = originator.element;
                    var bounds = originator.bounds;

                    var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
                    var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);
                    var zoomStyle = buildZoom({ centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5 });

                    if (origin || bounds) {
                        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
                        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
                        var dialogCenterPt = self.centerPointFor(dialogRect);
                        var originCenterPt = self.centerPointFor(originBnds);

                        // Build the transform to zoom from the dialog center to the origin center

                        zoomStyle = buildZoom({
                            centerX: originCenterPt.x - dialogCenterPt.x,
                            centerY: originCenterPt.y - dialogCenterPt.y,
                            scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
                            scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
                        });
                    }

                    return zoomStyle;

                    /**
                     * This is a fallback if the origin information is no longer valid, then the
                     * origin bounds simply becomes the current bounds for the dialogContainer's parent
                     */
                    function currentBounds() {
                        var cntr = element ? element.parent() : null;
                        var parent = cntr ? cntr.parent() : null;

                        return parent ? self.clientRect(parent) : null;
                    }
                },

                /**
                 * Enhance raw values to represent valid css stylings...
                 */
                toCss: function (raw) {
                    var css = {};
                    var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';

                    angular.forEach(raw, function (value, key) {
                        if (angular.isUndefined(value)) return;

                        if (lookups.indexOf(key) >= 0) {
                            css[key] = value + 'px';
                        } else {
                            switch (key) {
                                case 'transition':
                                    convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
                                    break;
                                case 'transform':
                                    convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
                                    break;
                                case 'transformOrigin':
                                    convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
                                    break;
                            }
                        }
                    });

                    return css;

                    function convertToVendor(key, vendor, value) {
                        angular.forEach(vendor.split(' '), function (key) {
                            css[key] = value;
                        });
                    }
                },

                /**
                 * Convert the translate CSS value to key/value pair(s).
                 */
                toTransformCss: function (transform, addTransition, transition) {
                    var css = {};
                    angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
                        css[key] = transform;
                    });

                    if (addTransition) {
                        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
                        css['transition'] = transition;
                    }

                    return css;
                },

                /**
                 *  Clone the Rect and calculate the height/width if needed
                 */
                copyRect: function (source, destination) {
                    if (!source) return null;

                    destination = destination || {};

                    angular.forEach('left top right bottom width height'.split(' '), function (key) {
                        destination[key] = Math.round(source[key])
                    });

                    destination.width = destination.width || (destination.right - destination.left);
                    destination.height = destination.height || (destination.bottom - destination.top);

                    return destination;
                },

                /**
                 * Calculate ClientRect of element; return null if hidden or zero size
                 */
                clientRect: function (element) {
                    var bounds = angular.element(element)[0].getBoundingClientRect();
                    var isPositiveSizeClientRect = function (rect) {
                        return rect && (rect.width > 0) && (rect.height > 0);
                    };

                    // If the event origin element has zero size, it has probably been hidden.
                    return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
                },

                /**
                 *  Calculate 'rounded' center point of Rect
                 */
                centerPointFor: function (targetRect) {
                    return targetRect ? {
                        x: Math.round(targetRect.left + (targetRect.width / 2)),
                        y: Math.round(targetRect.top + (targetRect.height / 2))
                    } : { x: 0, y: 0 };
                }

            };
        };


    })();
    (function () {
        "use strict";

        "use strict";

        if (angular.version.minor >= 4) {
            angular.module('material.core.animate', []);
        } else {
            (function () {

                var forEach = angular.forEach;

                var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
                var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
                var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
                var PREFIX = WEBKIT ? '-webkit-' : '';

                var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
                var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';

                var $$ForceReflowFactory = ['$document', function ($document) {
                    return function () {
                        return $document[0].body.clientWidth + 1;
                    }
                }];

                var $$rAFMutexFactory = ['$$rAF', function ($$rAF) {
                    return function () {
                        var passed = false;
                        $$rAF(function () {
                            passed = true;
                        });
                        return function (fn) {
                            passed ? fn() : $$rAF(fn);
                        };
                    };
                }];

                var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function ($q, $$rAFMutex) {
                    var INITIAL_STATE = 0;
                    var DONE_PENDING_STATE = 1;
                    var DONE_COMPLETE_STATE = 2;

                    function AnimateRunner(host) {
                        this.setHost(host);

                        this._doneCallbacks = [];
                        this._runInAnimationFrame = $$rAFMutex();
                        this._state = 0;
                    }

                    AnimateRunner.prototype = {
                        setHost: function (host) {
                            this.host = host || {};
                        },

                        done: function (fn) {
                            if (this._state === DONE_COMPLETE_STATE) {
                                fn();
                            } else {
                                this._doneCallbacks.push(fn);
                            }
                        },

                        progress: angular.noop,

                        getPromise: function () {
                            if (!this.promise) {
                                var self = this;
                                this.promise = $q(function (resolve, reject) {
                                    self.done(function (status) {
                                        status === false ? reject() : resolve();
                                    });
                                });
                            }
                            return this.promise;
                        },

                        then: function (resolveHandler, rejectHandler) {
                            return this.getPromise().then(resolveHandler, rejectHandler);
                        },

                        'catch': function (handler) {
                            return this.getPromise()['catch'](handler);
                        },

                        'finally': function (handler) {
                            return this.getPromise()['finally'](handler);
                        },

                        pause: function () {
                            if (this.host.pause) {
                                this.host.pause();
                            }
                        },

                        resume: function () {
                            if (this.host.resume) {
                                this.host.resume();
                            }
                        },

                        end: function () {
                            if (this.host.end) {
                                this.host.end();
                            }
                            this._resolve(true);
                        },

                        cancel: function () {
                            if (this.host.cancel) {
                                this.host.cancel();
                            }
                            this._resolve(false);
                        },

                        complete: function (response) {
                            var self = this;
                            if (self._state === INITIAL_STATE) {
                                self._state = DONE_PENDING_STATE;
                                self._runInAnimationFrame(function () {
                                    self._resolve(response);
                                });
                            }
                        },

                        _resolve: function (response) {
                            if (this._state !== DONE_COMPLETE_STATE) {
                                forEach(this._doneCallbacks, function (fn) {
                                    fn(response);
                                });
                                this._doneCallbacks.length = 0;
                                this._state = DONE_COMPLETE_STATE;
                            }
                        }
                    };

                    return AnimateRunner;
                }];

                angular
                    .module('material.core.animate', [])
                    .factory('$$forceReflow', $$ForceReflowFactory)
                    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
                    .factory('$$rAFMutex', $$rAFMutexFactory)
                    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout',
                        function ($window, $$rAF, $$AnimateRunner, $$forceReflow, $$jqLite, $timeout) {

                            function init(element, options) {

                                var temporaryStyles = [];
                                var node = getDomNode(element);

                                if (options.transitionStyle) {
                                    temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
                                }

                                if (options.keyframeStyle) {
                                    temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
                                }

                                if (options.delay) {
                                    temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
                                }

                                if (options.duration) {
                                    temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
                                }

                                var hasCompleteStyles = options.keyframeStyle ||
                                    (options.to && (options.duration > 0 || options.transitionStyle));
                                var hasCompleteClasses = !!options.addClass || !!options.removeClass;
                                var hasCompleteAnimation = hasCompleteStyles || hasCompleteClasses;

                                blockTransition(element, true);
                                applyAnimationFromStyles(element, options);

                                var animationClosed = false;
                                var events, eventFn;

                                return {
                                    close: $window.close,
                                    start: function () {
                                        var runner = new $$AnimateRunner();
                                        waitUntilQuiet(function () {
                                            blockTransition(element, false);
                                            if (!hasCompleteAnimation) {
                                                return close();
                                            }

                                            forEach(temporaryStyles, function (entry) {
                                                var key = entry[0];
                                                var value = entry[1];
                                                node.style[camelCase(key)] = value;
                                            });

                                            applyClasses(element, options);

                                            var timings = computeTimings(element);
                                            if (timings.duration === 0) {
                                                return close();
                                            }

                                            var moreStyles = [];

                                            if (options.easing) {
                                                if (timings.transitionDuration) {
                                                    moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
                                                }
                                                if (timings.animationDuration) {
                                                    moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
                                                }
                                            }

                                            if (options.delay && timings.animationDelay) {
                                                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
                                            }

                                            if (options.duration && timings.animationDuration) {
                                                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
                                            }

                                            forEach(moreStyles, function (entry) {
                                                var key = entry[0];
                                                var value = entry[1];
                                                node.style[camelCase(key)] = value;
                                                temporaryStyles.push(entry);
                                            });

                                            var maxDelay = timings.delay;
                                            var maxDelayTime = maxDelay * 1000;
                                            var maxDuration = timings.duration;
                                            var maxDurationTime = maxDuration * 1000;
                                            var startTime = Date.now();

                                            events = [];
                                            if (timings.transitionDuration) {
                                                events.push(TRANSITION_EVENTS);
                                            }
                                            if (timings.animationDuration) {
                                                events.push(ANIMATION_EVENTS);
                                            }
                                            events = events.join(' ');
                                            eventFn = function (event) {
                                                event.stopPropagation();
                                                var ev = event.originalEvent || event;
                                                var timeStamp = ev.timeStamp || Date.now();
                                                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
                                                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                                                    close();
                                                }
                                            };
                                            element.on(events, eventFn);

                                            applyAnimationToStyles(element, options);

                                            $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
                                        });

                                        return runner;

                                        function close() {
                                            if (animationClosed) return;
                                            animationClosed = true;

                                            if (events && eventFn) {
                                                element.off(events, eventFn);
                                            }
                                            applyClasses(element, options);
                                            applyAnimationStyles(element, options);
                                            forEach(temporaryStyles, function (entry) {
                                                node.style[camelCase(entry[0])] = '';
                                            });
                                            runner.complete(true);
                                            return runner;
                                        }
                                    }
                                }
                            }

                            function applyClasses(element, options) {
                                if (options.addClass) {
                                    $$jqLite.addClass(element, options.addClass);
                                    options.addClass = null;
                                }
                                if (options.removeClass) {
                                    $$jqLite.removeClass(element, options.removeClass);
                                    options.removeClass = null;
                                }
                            }

                            function computeTimings(element) {
                                var node = getDomNode(element);
                                var cs = $window.getComputedStyle(node)
                                var tdr = parseMaxTime(cs[prop('transitionDuration')]);
                                var adr = parseMaxTime(cs[prop('animationDuration')]);
                                var tdy = parseMaxTime(cs[prop('transitionDelay')]);
                                var ady = parseMaxTime(cs[prop('animationDelay')]);

                                adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
                                var duration = Math.max(adr, tdr);
                                var delay = Math.max(ady, tdy);

                                return {
                                    duration: duration,
                                    delay: delay,
                                    animationDuration: adr,
                                    transitionDuration: tdr,
                                    animationDelay: ady,
                                    transitionDelay: tdy
                                };

                                function prop(key) {
                                    return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1) :
                                        key;
                                }
                            }

                            function parseMaxTime(str) {
                                var maxValue = 0;
                                var values = (str || "").split(/\s*,\s*/);
                                forEach(values, function (value) {
                                    // it's always safe to consider only second values and omit `ms` values since
                                    // getComputedStyle will always handle the conversion for us
                                    if (value.charAt(value.length - 1) == 's') {
                                        value = value.substring(0, value.length - 1);
                                    }
                                    value = parseFloat(value) || 0;
                                    maxValue = maxValue ? Math.max(value, maxValue) : value;
                                });
                                return maxValue;
                            }

                            var cancelLastRAFRequest;
                            var rafWaitQueue = [];

                            function waitUntilQuiet(callback) {
                                if (cancelLastRAFRequest) {
                                    cancelLastRAFRequest(); //cancels the request
                                }
                                rafWaitQueue.push(callback);
                                cancelLastRAFRequest = $$rAF(function () {
                                    cancelLastRAFRequest = null;

                                    // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
                                    // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
                                    var pageWidth = $$forceReflow();

                                    // we use a for loop to ensure that if the queue is changed
                                    // during this looping then it will consider new requests
                                    for (var i = 0; i < rafWaitQueue.length; i++) {
                                        rafWaitQueue[i](pageWidth);
                                    }
                                    rafWaitQueue.length = 0;
                                });
                            }

                            function applyAnimationStyles(element, options) {
                                applyAnimationFromStyles(element, options);
                                applyAnimationToStyles(element, options);
                            }

                            function applyAnimationFromStyles(element, options) {
                                if (options.from) {
                                    element.css(options.from);
                                    options.from = null;
                                }
                            }

                            function applyAnimationToStyles(element, options) {
                                if (options.to) {
                                    element.css(options.to);
                                    options.to = null;
                                }
                            }

                            function getDomNode(element) {
                                for (var i = 0; i < element.length; i++) {
                                    if (element[i].nodeType === 1) return element[i];
                                }
                            }

                            function blockTransition(element, bool) {
                                var node = getDomNode(element);
                                var key = camelCase(PREFIX + 'transition-delay');
                                node.style[key] = bool ? '-9999s' : '';
                            }

                            return init;
                        }
                    ]);

                /**
                 * Older browsers [FF31] expect camelCase
                 * property keys.
                 * e.g.
                 *  animation-duration --> animationDuration
                 */
                function camelCase(str) {
                    return str.replace(/-[a-z]/g, function (str) {
                        return str.charAt(1).toUpperCase();
                    });
                }

            })();

        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.autocomplete
         */
        /*
         * @see js folder for autocomplete implementation
         */
        angular.module('material.components.autocomplete', [
            'material.core',
            'material.components.icon',
            'material.components.virtualRepeat'
        ]);

    })();
    (function () {
        "use strict";

        /*
         * @ngdoc module
         * @name material.components.backdrop
         * @description Backdrop
         */

        /**
         * @ngdoc directive
         * @name mdBackdrop
         * @module material.components.backdrop
         *
         * @restrict E
         *
         * @description
         * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
         * Apply class `opaque` to make the backdrop use the theme backdrop color.
         *
         */

        angular
            .module('material.components.backdrop', ['material.core'])
            .directive('mdBackdrop', ["$mdTheming", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $animate, $rootElement, $window, $log, $$rAF, $document) {
                var ERROR_CSS_POSITION = "<md-backdrop> may not work properly in a scrolled, static-positioned parent container.";

                return {
                    restrict: 'E',
                    link: postLink
                };

                function postLink(scope, element, attrs) {

                    // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
                    // adjust the 'backdrop' height to account for the fixed 'body' top offset
                    var body = $window.getComputedStyle($document[0].body);
                    if (body.position == 'fixed') {
                        var hViewport = parseInt(body.height, 10) + Math.abs(parseInt(body.top, 10));
                        element.css({
                            height: hViewport + 'px'
                        });
                    }

                    // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
                    if ($animate.pin) $animate.pin(element, $rootElement);

                    $$rAF(function () {

                        // Often $animate.enter() is used to append the backDrop element
                        // so let's wait until $animate is done...
                        var parent = element.parent()[0];
                        if (parent) {

                            if (parent.nodeName == 'BODY') {
                                element.css({ position: 'fixed' });
                            }

                            var styles = $window.getComputedStyle(parent);
                            if (styles.position == 'static') {
                                // backdrop uses position:absolute and will not work properly with parent position:static (default)
                                $log.warn(ERROR_CSS_POSITION);
                            }
                        }

                        // Only inherit the parent if the backdrop has a parent.
                        if (element.parent().length) {
                            $mdTheming.inherit(element, element.parent());
                        }
                    });

                }

            }]);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.bottomSheet
         * @description
         * BottomSheet
         */
        angular
            .module('material.components.bottomSheet', [
                'material.core',
                'material.components.backdrop'
            ])
            .directive('mdBottomSheet', MdBottomSheetDirective)
            .provider('$mdBottomSheet', MdBottomSheetProvider);

        /* @ngInject */
        function MdBottomSheetDirective($mdBottomSheet) {
            return {
                restrict: 'E',
                link: function postLink(scope, element, attr) {
                    // When navigation force destroys an interimElement, then
                    // listen and $destroy() that interim instance...
                    scope.$on('$destroy', function () {
                        $mdBottomSheet.destroy();
                    });
                }
            };
        }
        MdBottomSheetDirective.$inject = ["$mdBottomSheet"];


        /**
         * @ngdoc service
         * @name $mdBottomSheet
         * @module material.components.bottomSheet
         *
         * @description
         * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
         *
         * ## Restrictions
         *
         * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
         * - Add the `md-grid` class to the bottom sheet for a grid layout.
         * - Add the `md-list` class to the bottom sheet for a list layout.
         *
         * @usage
         * <hljs lang="html">
         * <div ng-controller="MyController">
         *   <md-button ng-click="openBottomSheet()">
         *     Open a Bottom Sheet!
         *   </md-button>
         * </div>
         * </hljs>
         * <hljs lang="js">
         * var app = angular.module('app', ['ngMaterial']);
         * app.controller('MyController', function($scope, $mdBottomSheet) {
         *   $scope.openBottomSheet = function() {
         *     $mdBottomSheet.show({
         *       template: '<md-bottom-sheet>Hello!</md-bottom-sheet>'
         *     });
         *   };
         * });
         * </hljs>
         */

        /**
         * @ngdoc method
         * @name $mdBottomSheet#show
         *
         * @description
         * Show a bottom sheet with the specified options.
         *
         * @param {object} options An options object, with the following properties:
         *
         *   - `templateUrl` - `{string=}`: The url of an html template file that will
         *   be used as the content of the bottom sheet. Restrictions: the template must
         *   have an outer `md-bottom-sheet` element.
         *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
         *   template string.
         *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
         *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
         *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
         *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
         *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
         *   be used as names of values to inject into the controller. For example,
         *   `locals: {three: 3}` would inject `three` into the controller with the value
         *   of 3.
         *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
         *     close it. Default true.
         *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
         *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
         *     Default true.
         *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
         *   and the bottom sheet will not open until the promises resolve.
         *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
         *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
         *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
         *   e.g. angular.element(document.getElementById('content')) or "#content"
         *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
         *     Default true.
         *
         * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
         * rejected with `$mdBottomSheet.cancel()`.
         */

        /**
         * @ngdoc method
         * @name $mdBottomSheet#hide
         *
         * @description
         * Hide the existing bottom sheet and resolve the promise returned from
         * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if any).
         *
         * @param {*=} response An argument for the resolved promise.
         *
         */

        /**
         * @ngdoc method
         * @name $mdBottomSheet#cancel
         *
         * @description
         * Hide the existing bottom sheet and reject the promise returned from
         * `$mdBottomSheet.show()`.
         *
         * @param {*=} response An argument for the rejected promise.
         *
         */

        function MdBottomSheetProvider($$interimElementProvider) {
            // how fast we need to flick down to close the sheet, pixels/ms
            var CLOSING_VELOCITY = 0.5;
            var PADDING = 80; // same as css


            bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture"];
            return $$interimElementProvider('$mdBottomSheet')
                .setDefaults({
                    methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
                    options: bottomSheetDefaults
                });

            /* @ngInject */
            function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement, $mdGesture) {
                var backdrop;

                return {
                    themable: true,
                    onShow: onShow,
                    onRemove: onRemove,
                    disableBackdrop: false,
                    escapeToClose: true,
                    clickOutsideToClose: true,
                    disableParentScroll: true
                };


                function onShow(scope, element, options, controller) {

                    element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');

                    // prevent tab focus or click focus on the bottom-sheet container
                    element.attr('tabindex', "-1");

                    if (!options.disableBackdrop) {
                        // Add a backdrop that will close on click
                        backdrop = $mdUtil.createBackdrop(scope, "_md-bottom-sheet-backdrop md-opaque");

                        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
                        // This allows clicks on backdrop to propogate to the $rootElement and
                        // ESC key events to be detected properly.

                        backdrop[0].tabIndex = -1;

                        if (options.clickOutsideToClose) {
                            backdrop.on('click', function () {
                                $mdUtil.nextTick($mdBottomSheet.cancel, true);
                            });
                        }

                        $mdTheming.inherit(backdrop, options.parent);

                        $animate.enter(backdrop, options.parent, null);
                    }

                    var bottomSheet = new BottomSheet(element, options.parent);
                    options.bottomSheet = bottomSheet;

                    $mdTheming.inherit(bottomSheet.element, options.parent);

                    if (options.disableParentScroll) {
                        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
                    }

                    return $animate.enter(bottomSheet.element, options.parent, backdrop)
                        .then(function () {
                            var focusable = $mdUtil.findFocusTarget(element) || angular.element(
                                element[0].querySelector('button') ||
                                element[0].querySelector('a') ||
                                element[0].querySelector('[ng-click]')
                            ) || backdrop;

                            if (options.escapeToClose) {
                                options.rootElementKeyupCallback = function (e) {
                                    if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
                                        $mdUtil.nextTick($mdBottomSheet.cancel, true);
                                    }
                                };

                                $rootElement.on('keyup', options.rootElementKeyupCallback);
                                focusable && focusable.focus();
                            }
                        });

                }

                function onRemove(scope, element, options) {

                    var bottomSheet = options.bottomSheet;

                    if (!options.disableBackdrop) $animate.leave(backdrop);
                    return $animate.leave(bottomSheet.element).then(function () {
                        if (options.disableParentScroll) {
                            options.restoreScroll();
                            delete options.restoreScroll;
                        }

                        bottomSheet.cleanup();
                    });
                }

                /**
                 * BottomSheet class to apply bottom-sheet behavior to an element
                 */
                function BottomSheet(element, parent) {
                    var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
                    parent.on('$md.dragstart', onDragStart)
                        .on('$md.drag', onDrag)
                        .on('$md.dragend', onDragEnd);

                    return {
                        element: element,
                        cleanup: function cleanup() {
                            deregister();
                            parent.off('$md.dragstart', onDragStart);
                            parent.off('$md.drag', onDrag);
                            parent.off('$md.dragend', onDragEnd);
                        }
                    };

                    function onDragStart(ev) {
                        // Disable transitions on transform so that it feels fast
                        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
                    }

                    function onDrag(ev) {
                        var transform = ev.pointer.distanceY;
                        if (transform < 5) {
                            // Slow down drag when trying to drag up, and stop after PADDING
                            transform = Math.max(-PADDING, transform / 2);
                        }
                        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
                    }

                    function onDragEnd(ev) {
                        if (ev.pointer.distanceY > 0 &&
                            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
                            var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
                            var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
                            element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
                            $mdUtil.nextTick($mdBottomSheet.cancel, true);
                        } else {
                            element.css($mdConstant.CSS.TRANSITION_DURATION, '');
                            element.css($mdConstant.CSS.TRANSFORM, '');
                        }
                    }
                }

            }

        }
        MdBottomSheetProvider.$inject = ["$$interimElementProvider"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.button
         * @description
         *
         * Button
         */
        angular
            .module('material.components.button', ['material.core'])
            .directive('mdButton', MdButtonDirective);

        /**
         * @ngdoc directive
         * @name mdButton
         * @module material.components.button
         *
         * @restrict E
         *
         * @description
         * `<md-button>` is a button directive with optional ink ripples (default enabled).
         *
         * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it will
         * become a `<button>` element. As per the [Material Design specifications](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
         * the FAB button background is filled with the accent color [by default]. The primary color palette may be used with
         * the `md-primary` class.
         *
         * @param {boolean=} md-no-ink If present, disable ripple ink effects.
         * @param {boolean=} md-no-focus-style If present, disable focus style on button
         * @param {expression=} ng-disabled En/Disable based on the expression
         * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
         * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
         * If no default text is found, a warning will be logged.
         *
         * @usage
         *
         * Regular buttons:
         *
         * <hljs lang="html">
         *  <md-button> Flat Button </md-button>
         *  <md-button href="http://google.com"> Flat link </md-button>
         *  <md-button class="md-raised"> Raised Button </md-button>
         *  <md-button ng-disabled="true"> Disabled Button </md-button>
         *  <md-button>
         *    <md-icon md-svg-src="your/icon.svg"></md-icon>
         *    Register Now
         *  </md-button>
         * </hljs>
         *
         * FAB buttons:
         *
         * <hljs lang="html">
         *  <md-button class="md-fab" aria-label="FAB">
         *    <md-icon md-svg-src="your/icon.svg"></md-icon>
         *  </md-button>
         *  <!-- mini-FAB -->
         *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
         *    <md-icon md-svg-src="your/icon.svg"></md-icon>
         *  </md-button>
         *  <!-- Button with SVG Icon -->
         *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
         *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
         *  </md-button>
         * </hljs>
         */
        function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $timeout) {

            return {
                restrict: 'EA',
                replace: true,
                transclude: true,
                template: getTemplate,
                link: postLink
            };

            function isAnchor(attr) {
                return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
            }

            function getTemplate(element, attr) {
                if (isAnchor(attr)) {
                    return '<a class="md-button" ng-transclude></a>';
                } else {
                    //If buttons don't have type="button", they will submit forms automatically.
                    var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
                    return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
                }
            }

            function postLink(scope, element, attr) {
                $mdTheming(element);
                $mdButtonInkRipple.attach(scope, element);

                // Use async expect to support possible bindings in the button label
                $mdAria.expectWithText(element, 'aria-label');

                // For anchor elements, we have to set tabindex manually when the
                // element is disabled
                if (isAnchor(attr) && angular.isDefined(attr.ngDisabled)) {
                    scope.$watch(attr.ngDisabled, function (isDisabled) {
                        element.attr('tabindex', isDisabled ? -1 : 0);
                    });
                }

                // disabling click event when disabled is true
                element.on('click', function (e) {
                    if (attr.disabled === true) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                    }
                });

                if (!angular.isDefined(attr.mdNoFocusStyle)) {
                    // restrict focus styles to the keyboard
                    scope.mouseActive = false;
                    element.on('mousedown', function () {
                        scope.mouseActive = true;
                        $timeout(function () {
                            scope.mouseActive = false;
                        }, 100);
                    })
                        .on('focus', function () {
                            if (scope.mouseActive === false) {
                                element.addClass('md-focused');
                            }
                        })
                        .on('blur', function (ev) {
                            element.removeClass('md-focused');
                        });
                }
            }

        }
        MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$timeout"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.card
         *
         * @description
         * Card components.
         */
        angular.module('material.components.card', [
            'material.core'
        ])
            .directive('mdCard', mdCardDirective);


        /**
         * @ngdoc directive
         * @name mdCard
         * @module material.components.card
         *
         * @restrict E
         *
         * @description
         * The `<md-card>` directive is a container element used within `<md-content>` containers.
         *
         * An image included as a direct descendant will fill the card's width, while the `<md-card-content>`
         * container will wrap text content and provide padding. An `<md-card-footer>` element can be
         * optionally included to put content flush against the bottom edge of the card.
         *
         * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
         * You can then position buttons using layout attributes.
         *
         * Card is built with:
         * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
         *  - `<md-card-avatar>` - Card avatar
         *    - `md-user-avatar` - Class for user image
         *    - `<md-icon>`
         *  - `<md-card-header-text>` - Contains elements for the card description
         *    - `md-title` - Class for the card title
         *    - `md-subhead` - Class for the card sub header
         * * `<img>` - Image for the card
         * * `<md-card-title>` - Card content title
         *  - `<md-card-title-text>`
         *    - `md-headline` - Class for the card content title
         *    - `md-subhead` - Class for the card content sub header
         *  - `<md-card-title-media>` - Squared image within the title
         *    - `md-media-sm` - Class for small image
         *    - `md-media-md` - Class for medium image
         *    - `md-media-lg` - Class for large image
         * * `<md-card-content>` - Card content
         *  - `md-media-xl` - Class for extra large image
         * * `<md-card-actions>` - Card actions
         *  - `<md-card-icon-actions>` - Icon actions
         *
         * Cards have constant width and variable heights; where the maximum height is limited to what can
         * fit within a single view on a platform, but it can temporarily expand as needed.
         *
         * @usage
         * ### Card with optional footer
         * <hljs lang="html">
         * <md-card>
         *  <img src="card-image.png" class="md-card-image" alt="image caption">
         *  <md-card-content>
         *    <h2>Card headline</h2>
         *    <p>Card content</p>
         *  </md-card-content>
         *  <md-card-footer>
         *    Card footer
         *  </md-card-footer>
         * </md-card>
         * </hljs>
         *
         * ### Card with actions
         * <hljs lang="html">
         * <md-card>
         *  <img src="card-image.png" class="md-card-image" alt="image caption">
         *  <md-card-content>
         *    <h2>Card headline</h2>
         *    <p>Card content</p>
         *  </md-card-content>
         *  <md-card-actions layout="row" layout-align="end center">
         *    <md-button>Action 1</md-button>
         *    <md-button>Action 2</md-button>
         *  </md-card-actions>
         * </md-card>
         * </hljs>
         *
         * ### Card with header, image, title actions and content
         * <hljs lang="html">
         * <md-card>
         *   <md-card-header>
         *     <md-card-avatar>
         *       <img class="md-user-avatar" src="avatar.png"/>
         *     </md-card-avatar>
         *     <md-card-header-text>
         *       <span class="md-title">Title</span>
         *       <span class="md-subhead">Sub header</span>
         *     </md-card-header-text>
         *   </md-card-header>
         *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
         *   <md-card-title>
         *     <md-card-title-text>
         *       <span class="md-headline">Card headline</span>
         *       <span class="md-subhead">Card subheader</span>
         *     </md-card-title-text>
         *   </md-card-title>
         *   <md-card-actions layout="row" layout-align="start center">
         *     <md-button>Action 1</md-button>
         *     <md-button>Action 2</md-button>
         *     <md-card-icon-actions>
         *       <md-button class="md-icon-button" aria-label="icon">
         *         <md-icon md-svg-icon="icon"></md-icon>
         *       </md-button>
         *     </md-card-icon-actions>
         *   </md-card-actions>
         *   <md-card-content>
         *     <p>
         *      Card content
         *     </p>
         *   </md-card-content>
         * </md-card>
         * </hljs>
         */
        function mdCardDirective($mdTheming) {
            return {
                restrict: 'E',
                link: function ($scope, $element) {
                    $mdTheming($element);
                }
            };
        }
        mdCardDirective.$inject = ["$mdTheming"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.checkbox
         * @description Checkbox module!
         */
        angular
            .module('material.components.checkbox', ['material.core'])
            .directive('mdCheckbox', MdCheckboxDirective);

        /**
         * @ngdoc directive
         * @name mdCheckbox
         * @module material.components.checkbox
         * @restrict E
         *
         * @description
         * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
         *
         * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
         * the checkbox is in the accent color by default. The primary color palette may be used with
         * the `md-primary` class.
         *
         * @param {string} ng-model Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {expression=} ng-true-value The value to which the expression should be set when selected.
         * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
         * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
         * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
         * @param {string=} aria-label Adds label to checkbox for accessibility.
         *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
         * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
         *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
         *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
         *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time. 
         *     When a checkbox is indeterminate that overrides any checked/unchecked rendering logic.
         *
         * @usage
         * <hljs lang="html">
         * <md-checkbox ng-model="isChecked" aria-label="Finished?">
         *   Finished ?
         * </md-checkbox>
         *
         * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
         *   No Ink Effects
         * </md-checkbox>
         *
         * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
         *   Disabled
         * </md-checkbox>
         *
         * </hljs>
         *
         */
        function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $timeout) {
            inputDirective = inputDirective[0];
            var CHECKED_CSS = 'md-checked';

            return {
                restrict: 'E',
                transclude: true,
                require: '?ngModel',
                priority: 210, // Run before ngAria
                template: '<div class="_md-container" md-ink-ripple md-ink-ripple-checkbox>' +
                    '<div class="_md-icon"></div>' +
                    '</div>' +
                    '<div ng-transclude class="_md-label"></div>',
                compile: compile
            };

            // **********************************************************
            // Private Methods
            // **********************************************************

            function compile(tElement, tAttrs) {
                var container = tElement.children();
                var mdIndeterminateStateEnabled = tAttrs.hasOwnProperty('mdIndeterminate');

                tAttrs.type = 'checkbox';
                tAttrs.tabindex = tAttrs.tabindex || '0';
                tElement.attr('role', tAttrs.type);

                // Attach a click handler in compile in order to immediately stop propagation
                // (especially for ng-click) when the checkbox is disabled.
                tElement.on('click', function (event) {
                    if (this.hasAttribute('disabled')) {
                        event.stopImmediatePropagation();
                    }
                });

                // Redirect focus events to the root element, because IE11 is always focusing the container element instead
                // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
                container.on('focus', function () {
                    tElement.focus();
                });

                return function postLink(scope, element, attr, ngModelCtrl) {
                    var isIndeterminate;
                    ngModelCtrl = ngModelCtrl || $mdUtil.fakeNgModel();
                    $mdTheming(element);
                    if (mdIndeterminateStateEnabled) {
                        setIndeterminateState();
                        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
                    }

                    if (attr.ngChecked) {
                        scope.$watch(
                            scope.$eval.bind(scope, attr.ngChecked),
                            ngModelCtrl.$setViewValue.bind(ngModelCtrl)
                        );
                    }

                    $$watchExpr('ngDisabled', 'tabindex', {
                        true: '-1',
                        false: attr.tabindex
                    });

                    $mdAria.expectWithText(element, 'aria-label');

                    // Reuse the original input[type=checkbox] directive from Angular core.
                    // This is a bit hacky as we need our own event listener and own render
                    // function.
                    inputDirective.link.pre(scope, {
                        on: angular.noop,
                        0: {}
                    }, attr, [ngModelCtrl]);

                    scope.mouseActive = false;
                    element.on('click', listener)
                        .on('keypress', keypressHandler)
                        .on('mousedown', function () {
                            scope.mouseActive = true;
                            $timeout(function () {
                                scope.mouseActive = false;
                            }, 100);
                        })
                        .on('focus', function () {
                            if (scope.mouseActive === false) {
                                element.addClass('md-focused');
                            }
                        })
                        .on('blur', function () {
                            element.removeClass('md-focused');
                        });

                    ngModelCtrl.$render = render;

                    function $$watchExpr(expr, htmlAttr, valueOpts) {
                        if (attr[expr]) {
                            scope.$watch(attr[expr], function (val) {
                                if (valueOpts[val]) {
                                    element.attr(htmlAttr, valueOpts[val]);
                                }
                            });
                        }
                    }

                    function keypressHandler(ev) {
                        var keyCode = ev.which || ev.keyCode;
                        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
                            ev.preventDefault();

                            if (!element.hasClass('md-focused')) {
                                element.addClass('md-focused');
                            }

                            listener(ev);
                        }
                    }

                    function listener(ev) {
                        if (element[0].hasAttribute('disabled')) {
                            return;
                        }

                        scope.$apply(function () {
                            // Toggle the checkbox value...
                            var viewValue = attr.ngChecked ? attr.checked : !ngModelCtrl.$viewValue;

                            ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
                            ngModelCtrl.$render();
                        });
                    }

                    function render() {
                        if (ngModelCtrl.$viewValue && !isIndeterminate) {
                            element.addClass(CHECKED_CSS);
                        } else {
                            element.removeClass(CHECKED_CSS);
                        }
                    }

                    function setIndeterminateState(newValue) {
                        isIndeterminate = newValue !== false;
                        if (isIndeterminate) {
                            element.attr('aria-checked', 'mixed');
                        }
                        element.toggleClass('md-indeterminate', isIndeterminate);
                    }
                };
            }
        }
        MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$timeout"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.chips
         */
        /*
         * @see js folder for chips implementation
         */
        angular.module('material.components.chips', [
            'material.core',
            'material.components.autocomplete'
        ]);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.content
         *
         * @description
         * Scrollable content
         */
        angular.module('material.components.content', [
            'material.core'
        ])
            .directive('mdContent', mdContentDirective);

        /**
         * @ngdoc directive
         * @name mdContent
         * @module material.components.content
         *
         * @restrict E
         *
         * @description
         *
         * The `<md-content>` directive is a container element useful for scrollable content. It achieves
         * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
         *
         * In general, `<md-content>` components are not designed to be nested inside one another. If
         * possible, it is better to make them siblings. This often results in a better user experience as
         * having nested scrollbars may confuse the user.
         *
         * ## Troubleshooting
         *
         * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
         * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
         * SVG icons and some other components.
         *
         * @usage
         *
         * Add the `[layout-padding]` attribute to make the content padded.
         *
         * <hljs lang="html">
         *  <md-content layout-padding>
         *      Lorem ipsum dolor sit amet, ne quod novum mei.
         *  </md-content>
         * </hljs>
         *
         */

        function mdContentDirective($mdTheming) {
            return {
                restrict: 'E',
                controller: ['$scope', '$element', ContentController],
                link: function (scope, element, attr) {
                    var node = element[0];

                    $mdTheming(element);
                    scope.$broadcast('$mdContentLoaded', element);

                    iosScrollFix(element[0]);
                }
            };

            function ContentController($scope, $element) {
                this.$scope = $scope;
                this.$element = $element;
            }
        }
        mdContentDirective.$inject = ["$mdTheming"];

        function iosScrollFix(node) {
            // IOS FIX:
            // If we scroll where there is no more room for the webview to scroll,
            // by default the webview itself will scroll up and down, this looks really
            // bad.  So if we are scrolling to the very top or bottom, add/subtract one
            angular.element(node).on('$md.pressdown', function (ev) {
                // Only touch events
                if (ev.pointer.type !== 't') return;
                // Don't let a child content's touchstart ruin it for us.
                if (ev.$materialScrollFixed) return;
                ev.$materialScrollFixed = true;

                if (node.scrollTop === 0) {
                    node.scrollTop = 1;
                } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
                    node.scrollTop -= 1;
                }
            });
        }

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc module
             * @name material.components.datepicker
             * @description Datepicker
             */
            angular.module('material.components.datepicker', [
                'material.core',
                'material.components.icon',
                'material.components.virtualRepeat'
            ]).directive('mdCalendar', calendarDirective);


            // POST RELEASE
            // TODO(jelbourn): Mac Cmd + left / right == Home / End
            // TODO(jelbourn): Clicking on the month label opens the month-picker.
            // TODO(jelbourn): Minimum and maximum date
            // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
            // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
            // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
            // TODO(jelbourn): Scroll snapping (virtual repeat)
            // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
            // TODO(jelbourn): Month headers stick to top when scrolling.
            // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
            // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
            //     announcement and key handling).
            // Read-only calendar (not just date-picker).

            /**
             * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
             * subsequently used for scrolling to specific months.
             */
            var TBODY_HEIGHT = 265;

            /**
             * Height of a calendar month with a single row. This is needed to calculate the offset for
             * rendering an extra month in virtual-repeat that only contains one row.
             */
            var TBODY_SINGLE_ROW_HEIGHT = 45;

            function calendarDirective() {
                return {
                    template: '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
                        '<div class="md-calendar-scroll-mask">' +
                        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
                        'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
                        '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
                        '<tbody role="rowgroup" md-virtual-repeat="i in ctrl.items" md-calendar-month ' +
                        'md-month-offset="$index" class="md-calendar-month" ' +
                        'md-start-index="ctrl.getSelectedMonthIndex()" ' +
                        'md-item-size="' + TBODY_HEIGHT + '"></tbody>' +
                        '</table>' +
                        '</md-virtual-repeat-container>' +
                        '</div>',
                    scope: {
                        minDate: '=mdMinDate',
                        maxDate: '=mdMaxDate',
                        dateFilter: '=mdDateFilter',
                    },
                    require: ['ngModel', 'mdCalendar'],
                    controller: CalendarCtrl,
                    controllerAs: 'ctrl',
                    bindToController: true,
                    link: function (scope, element, attrs, controllers) {
                        var ngModelCtrl = controllers[0];
                        var mdCalendarCtrl = controllers[1];
                        mdCalendarCtrl.configureNgModel(ngModelCtrl);
                    }
                };
            }

            /** Class applied to the selected date cell/. */
            var SELECTED_DATE_CLASS = 'md-calendar-selected-date';

            /** Class applied to the focused date cell/. */
            var FOCUSED_DATE_CLASS = 'md-focus';

            /** Next identifier for calendar instance. */
            var nextUniqueId = 0;

            /** The first renderable date in the virtual-scrolling calendar (for all instances). */
            var firstRenderableDate = null;

            /**
             * Controller for the mdCalendar component.
             * @ngInject @constructor
             */
            function CalendarCtrl($element, $attrs, $scope, $animate, $q, $mdConstant,
                $mdTheming, $$mdDateUtil, $mdDateLocale, $mdInkRipple, $mdUtil) {
                $mdTheming($element);
                /**
                 * Dummy array-like object for virtual-repeat to iterate over. The length is the total
                 * number of months that can be viewed. This is shorter than ideal because of (potential)
                 * Firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
                 */
                this.items = { length: 2000 };

                if (this.maxDate && this.minDate) {
                    // Limit the number of months if min and max dates are set.
                    var numMonths = $$mdDateUtil.getMonthDistance(this.minDate, this.maxDate) + 1;
                    numMonths = Math.max(numMonths, 1);
                    // Add an additional month as the final dummy month for rendering purposes.
                    numMonths += 1;
                    this.items.length = numMonths;
                }

                /** @final {!angular.$animate} */
                this.$animate = $animate;

                /** @final {!angular.$q} */
                this.$q = $q;

                /** @final */
                this.$mdInkRipple = $mdInkRipple;

                /** @final */
                this.$mdUtil = $mdUtil;

                /** @final */
                this.keyCode = $mdConstant.KEY_CODE;

                /** @final */
                this.dateUtil = $$mdDateUtil;

                /** @final */
                this.dateLocale = $mdDateLocale;

                /** @final {!angular.JQLite} */
                this.$element = $element;

                /** @final {!angular.Scope} */
                this.$scope = $scope;

                /** @final {HTMLElement} */
                this.calendarElement = $element[0].querySelector('.md-calendar');

                /** @final {HTMLElement} */
                this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

                /** @final {Date} */
                this.today = this.dateUtil.createDateAtMidnight();

                /** @type {Date} */
                this.firstRenderableDate = this.dateUtil.incrementMonths(this.today, -this.items.length / 2);

                if (this.minDate && this.minDate > this.firstRenderableDate) {
                    this.firstRenderableDate = this.minDate;
                } else if (this.maxDate) {
                    // Calculate the difference between the start date and max date.
                    // Subtract 1 because it's an inclusive difference and 1 for the final dummy month.
                    //
                    var monthDifference = this.items.length - 2;
                    this.firstRenderableDate = this.dateUtil.incrementMonths(this.maxDate, -(this.items.length - 2));
                }


                /** @final {number} Unique ID for this calendar instance. */
                this.id = nextUniqueId++;

                /** @type {!angular.NgModelController} */
                this.ngModelCtrl = null;

                /**
                 * The selected date. Keep track of this separately from the ng-model value so that we
                 * can know, when the ng-model value changes, what the previous value was before it's updated
                 * in the component's UI.
                 *
                 * @type {Date}
                 */
                this.selectedDate = null;

                /**
                 * The date that is currently focused or showing in the calendar. This will initially be set
                 * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
                 * to other months. The cell corresponding to the displayDate does not necesarily always have
                 * focus in the document (such as for cases when the user is scrolling the calendar).
                 * @type {Date}
                 */
                this.displayDate = null;

                /**
                 * The date that has or should have focus.
                 * @type {Date}
                 */
                this.focusDate = null;

                /** @type {boolean} */
                this.isInitialized = false;

                /** @type {boolean} */
                this.isMonthTransitionInProgress = false;

                // Unless the user specifies so, the calendar should not be a tab stop.
                // This is necessary because ngAria might add a tabindex to anything with an ng-model
                // (based on whether or not the user has turned that particular feature on/off).
                if (!$attrs['tabindex']) {
                    $element.attr('tabindex', '-1');
                }

                var self = this;

                /**
                 * Handles a click event on a date cell.
                 * Created here so that every cell can use the same function instance.
                 * @this {HTMLTableCellElement} The cell that was clicked.
                 */
                this.cellClickHandler = function () {
                    var cellElement = this;
                    if (this.hasAttribute('data-timestamp')) {
                        $scope.$apply(function () {
                            var timestamp = Number(cellElement.getAttribute('data-timestamp'));
                            self.setNgModelValue(self.dateUtil.createDateAtMidnight(timestamp));
                        });
                    }
                };

                this.attachCalendarEventListeners();
            }
            CalendarCtrl.$inject = ["$element", "$attrs", "$scope", "$animate", "$q", "$mdConstant", "$mdTheming", "$$mdDateUtil", "$mdDateLocale", "$mdInkRipple", "$mdUtil"];


            /*** Initialization ***/

            /**
             * Sets up the controller's reference to ngModelController.
             * @param {!angular.NgModelController} ngModelCtrl
             */
            CalendarCtrl.prototype.configureNgModel = function (ngModelCtrl) {
                this.ngModelCtrl = ngModelCtrl;

                var self = this;
                ngModelCtrl.$render = function () {
                    self.changeSelectedDate(self.ngModelCtrl.$viewValue);
                };
            };

            /**
             * Initialize the calendar by building the months that are initially visible.
             * Initialization should occur after the ngModel value is known.
             */
            CalendarCtrl.prototype.buildInitialCalendarDisplay = function () {
                this.buildWeekHeader();
                this.hideVerticalScrollbar();

                this.displayDate = this.selectedDate || this.today;
                this.isInitialized = true;
            };

            /**
             * Hides the vertical scrollbar on the calendar scroller by setting the width on the
             * calendar scroller and the `overflow: hidden` wrapper around the scroller, and then setting
             * a padding-right on the scroller equal to the width of the browser's scrollbar.
             *
             * This will cause a reflow.
             */
            CalendarCtrl.prototype.hideVerticalScrollbar = function () {
                var element = this.$element[0];

                var scrollMask = element.querySelector('.md-calendar-scroll-mask');
                var scroller = this.calendarScroller;

                var headerWidth = element.querySelector('.md-calendar-day-header').clientWidth;
                var scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;

                scrollMask.style.width = headerWidth + 'px';
                scroller.style.width = (headerWidth + scrollbarWidth) + 'px';
                scroller.style.paddingRight = scrollbarWidth + 'px';
            };


            /** Attach event listeners for the calendar. */
            CalendarCtrl.prototype.attachCalendarEventListeners = function () {
                // Keyboard interaction.
                this.$element.on('keydown', angular.bind(this, this.handleKeyEvent));
            };

            /*** User input handling ***/

            /**
             * Handles a key event in the calendar with the appropriate action. The action will either
             * be to select the focused date or to navigate to focus a new date.
             * @param {KeyboardEvent} event
             */
            CalendarCtrl.prototype.handleKeyEvent = function (event) {
                var self = this;
                this.$scope.$apply(function () {
                    // Capture escape and emit back up so that a wrapping component
                    // (such as a date-picker) can decide to close.
                    if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
                        self.$scope.$emit('md-calendar-close');

                        if (event.which == self.keyCode.TAB) {
                            event.preventDefault();
                        }

                        return;
                    }

                    // Remaining key events fall into two categories: selection and navigation.
                    // Start by checking if this is a selection event.
                    if (event.which === self.keyCode.ENTER) {
                        self.setNgModelValue(self.displayDate);
                        event.preventDefault();
                        return;
                    }

                    // Selection isn't occuring, so the key event is either navigation or nothing.
                    var date = self.getFocusDateFromKeyEvent(event);
                    if (date) {
                        date = self.boundDateByMinAndMax(date);
                        event.preventDefault();
                        event.stopPropagation();

                        // Since this is a keyboard interaction, actually give the newly focused date keyboard
                        // focus after the been brought into view.
                        self.changeDisplayDate(date).then(function () {
                            self.focus(date);
                        });
                    }
                });
            };

            /**
             * Gets the date to focus as the result of a key event.
             * @param {KeyboardEvent} event
             * @returns {Date} Date to navigate to, or null if the key does not match a calendar shortcut.
             */
            CalendarCtrl.prototype.getFocusDateFromKeyEvent = function (event) {
                var dateUtil = this.dateUtil;
                var keyCode = this.keyCode;

                switch (event.which) {
                    case keyCode.RIGHT_ARROW:
                        return dateUtil.incrementDays(this.displayDate, 1);
                    case keyCode.LEFT_ARROW:
                        return dateUtil.incrementDays(this.displayDate, -1);
                    case keyCode.DOWN_ARROW:
                        return event.metaKey ?
                            dateUtil.incrementMonths(this.displayDate, 1) :
                            dateUtil.incrementDays(this.displayDate, 7);
                    case keyCode.UP_ARROW:
                        return event.metaKey ?
                            dateUtil.incrementMonths(this.displayDate, -1) :
                            dateUtil.incrementDays(this.displayDate, -7);
                    case keyCode.PAGE_DOWN:
                        return dateUtil.incrementMonths(this.displayDate, 1);
                    case keyCode.PAGE_UP:
                        return dateUtil.incrementMonths(this.displayDate, -1);
                    case keyCode.HOME:
                        return dateUtil.getFirstDateOfMonth(this.displayDate);
                    case keyCode.END:
                        return dateUtil.getLastDateOfMonth(this.displayDate);
                    default:
                        return null;
                }
            };

            /**
             * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
             * @returns {number}
             */
            CalendarCtrl.prototype.getSelectedMonthIndex = function () {
                return this.dateUtil.getMonthDistance(this.firstRenderableDate,
                    this.selectedDate || this.today);
            };

            /**
             * Scrolls to the month of the given date.
             * @param {Date} date
             */
            CalendarCtrl.prototype.scrollToMonth = function (date) {
                if (!this.dateUtil.isValidDate(date)) {
                    return;
                }

                var monthDistance = this.dateUtil.getMonthDistance(this.firstRenderableDate, date);
                this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
            };

            /**
             * Sets the ng-model value for the calendar and emits a change event.
             * @param {Date} date
             */
            CalendarCtrl.prototype.setNgModelValue = function (date) {
                this.$scope.$emit('md-calendar-change', date);
                this.ngModelCtrl.$setViewValue(date);
                this.ngModelCtrl.$render();
            };

            /**
             * Focus the cell corresponding to the given date.
             * @param {Date=} opt_date
             */
            CalendarCtrl.prototype.focus = function (opt_date) {
                var date = opt_date || this.selectedDate || this.today;

                var previousFocus = this.calendarElement.querySelector('.md-focus');
                if (previousFocus) {
                    previousFocus.classList.remove(FOCUSED_DATE_CLASS);
                }

                var cellId = this.getDateId(date);
                var cell = document.getElementById(cellId);
                if (cell) {
                    cell.classList.add(FOCUSED_DATE_CLASS);
                    cell.focus();
                } else {
                    this.focusDate = date;
                }
            };

            /**
             * If a date exceeds minDate or maxDate, returns date matching minDate or maxDate, respectively.
             * Otherwise, returns the date.
             * @param {Date} date
             * @return {Date}
             */
            CalendarCtrl.prototype.boundDateByMinAndMax = function (date) {
                var boundDate = date;
                if (this.minDate && date < this.minDate) {
                    boundDate = new Date(this.minDate.getTime());
                }
                if (this.maxDate && date > this.maxDate) {
                    boundDate = new Date(this.maxDate.getTime());
                }
                return boundDate;
            };

            /*** Updating the displayed / selected date ***/

            /**
             * Change the selected date in the calendar (ngModel value has already been changed).
             * @param {Date} date
             */
            CalendarCtrl.prototype.changeSelectedDate = function (date) {
                var self = this;
                var previousSelectedDate = this.selectedDate;
                this.selectedDate = date;
                this.changeDisplayDate(date).then(function () {

                    // Remove the selected class from the previously selected date, if any.
                    if (previousSelectedDate) {
                        var prevDateCell =
                            document.getElementById(self.getDateId(previousSelectedDate));
                        if (prevDateCell) {
                            prevDateCell.classList.remove(SELECTED_DATE_CLASS);
                            prevDateCell.setAttribute('aria-selected', 'false');
                        }
                    }

                    // Apply the select class to the new selected date if it is set.
                    if (date) {
                        var dateCell = document.getElementById(self.getDateId(date));
                        if (dateCell) {
                            dateCell.classList.add(SELECTED_DATE_CLASS);
                            dateCell.setAttribute('aria-selected', 'true');
                        }
                    }
                });
            };


            /**
             * Change the date that is being shown in the calendar. If the given date is in a different
             * month, the displayed month will be transitioned.
             * @param {Date} date
             */
            CalendarCtrl.prototype.changeDisplayDate = function (date) {
                // Initialization is deferred until this function is called because we want to reflect
                // the starting value of ngModel.
                if (!this.isInitialized) {
                    this.buildInitialCalendarDisplay();
                    return this.$q.when();
                }

                // If trying to show an invalid date or a transition is in progress, do nothing.
                if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
                    return this.$q.when();
                }

                this.isMonthTransitionInProgress = true;
                var animationPromise = this.animateDateChange(date);

                this.displayDate = date;

                var self = this;
                animationPromise.then(function () {
                    self.isMonthTransitionInProgress = false;
                });

                return animationPromise;
            };

            /**
             * Animates the transition from the calendar's current month to the given month.
             * @param {Date} date
             * @returns {angular.$q.Promise} The animation promise.
             */
            CalendarCtrl.prototype.animateDateChange = function (date) {
                this.scrollToMonth(date);
                return this.$q.when();
            };

            /*** Constructing the calendar table ***/

            /**
             * Builds and appends a day-of-the-week header to the calendar.
             * This should only need to be called once during initialization.
             */
            CalendarCtrl.prototype.buildWeekHeader = function () {
                var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
                var shortDays = this.dateLocale.shortDays;

                var row = document.createElement('tr');
                for (var i = 0; i < 7; i++) {
                    var th = document.createElement('th');
                    th.textContent = shortDays[(i + firstDayOfWeek) % 7];
                    row.appendChild(th);
                }

                this.$element.find('thead').append(row);
            };

            /**
             * Gets an identifier for a date unique to the calendar instance for internal
             * purposes. Not to be displayed.
             * @param {Date} date
             * @returns {string}
             */
            CalendarCtrl.prototype.getDateId = function (date) {
                return [
                    'md',
                    this.id,
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                ].join('-');
            };
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';


            angular.module('material.components.datepicker')
                .directive('mdCalendarMonth', mdCalendarMonthDirective);


            /**
             * Private directive consumed by md-calendar. Having this directive lets the calender use
             * md-virtual-repeat and also cleanly separates the month DOM construction functions from
             * the rest of the calendar controller logic.
             */
            function mdCalendarMonthDirective() {
                return {
                    require: ['^^mdCalendar', 'mdCalendarMonth'],
                    scope: { offset: '=mdMonthOffset' },
                    controller: CalendarMonthCtrl,
                    controllerAs: 'mdMonthCtrl',
                    bindToController: true,
                    link: function (scope, element, attrs, controllers) {
                        var calendarCtrl = controllers[0];
                        var monthCtrl = controllers[1];

                        monthCtrl.calendarCtrl = calendarCtrl;
                        monthCtrl.generateContent();

                        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
                        // of repeated items that are linked, and then those elements have their bindings updataed.
                        // Since the months are not generated by bindings, we simply regenerate the entire thing
                        // when the binding (offset) changes.
                        scope.$watch(function () { return monthCtrl.offset; }, function (offset, oldOffset) {
                            if (offset != oldOffset) {
                                monthCtrl.generateContent();
                            }
                        });
                    }
                };
            }

            /** Class applied to the cell for today. */
            var TODAY_CLASS = 'md-calendar-date-today';

            /** Class applied to the selected date cell/. */
            var SELECTED_DATE_CLASS = 'md-calendar-selected-date';

            /** Class applied to the focused date cell/. */
            var FOCUSED_DATE_CLASS = 'md-focus';

            /**
             * Controller for a single calendar month.
             * @ngInject @constructor
             */
            function CalendarMonthCtrl($element, $$mdDateUtil, $mdDateLocale) {
                this.dateUtil = $$mdDateUtil;
                this.dateLocale = $mdDateLocale;
                this.$element = $element;
                this.calendarCtrl = null;

                /**
                 * Number of months from the start of the month "items" that the currently rendered month
                 * occurs. Set via angular data binding.
                 * @type {number}
                 */
                this.offset;

                /**
                 * Date cell to focus after appending the month to the document.
                 * @type {HTMLElement}
                 */
                this.focusAfterAppend = null;
            }
            CalendarMonthCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];

            /** Generate and append the content for this month to the directive element. */
            CalendarMonthCtrl.prototype.generateContent = function () {
                var calendarCtrl = this.calendarCtrl;
                var date = this.dateUtil.incrementMonths(calendarCtrl.firstRenderableDate, this.offset);

                this.$element.empty();
                this.$element.append(this.buildCalendarForMonth(date));

                if (this.focusAfterAppend) {
                    this.focusAfterAppend.classList.add(FOCUSED_DATE_CLASS);
                    this.focusAfterAppend.focus();
                    this.focusAfterAppend = null;
                }
            };

            /**
             * Creates a single cell to contain a date in the calendar with all appropriate
             * attributes and classes added. If a date is given, the cell content will be set
             * based on the date.
             * @param {Date=} opt_date
             * @returns {HTMLElement}
             */
            CalendarMonthCtrl.prototype.buildDateCell = function (opt_date) {
                var calendarCtrl = this.calendarCtrl;

                // TODO(jelbourn): cloneNode is likely a faster way of doing this.
                var cell = document.createElement('td');
                cell.tabIndex = -1;
                cell.classList.add('md-calendar-date');
                cell.setAttribute('role', 'gridcell');

                if (opt_date) {
                    cell.setAttribute('tabindex', '-1');
                    cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
                    cell.id = calendarCtrl.getDateId(opt_date);

                    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
                    cell.setAttribute('data-timestamp', opt_date.getTime());

                    // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
                    // It may be better to finish the construction and then query the node and add the class.
                    if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
                        cell.classList.add(TODAY_CLASS);
                    }

                    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
                        this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
                        cell.classList.add(SELECTED_DATE_CLASS);
                        cell.setAttribute('aria-selected', 'true');
                    }

                    var cellText = this.dateLocale.dates[opt_date.getDate()];

                    if (this.isDateEnabled(opt_date)) {
                        // Add a indicator for select, hover, and focus states.
                        var selectionIndicator = document.createElement('span');
                        cell.appendChild(selectionIndicator);
                        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
                        selectionIndicator.textContent = cellText;

                        cell.addEventListener('click', calendarCtrl.cellClickHandler);

                        if (calendarCtrl.focusDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.focusDate)) {
                            this.focusAfterAppend = cell;
                        }
                    } else {
                        cell.classList.add('md-calendar-date-disabled');
                        cell.textContent = cellText;
                    }
                }

                return cell;
            };

            /**
             * Check whether date is in range and enabled
             * @param {Date=} opt_date
             * @return {boolean} Whether the date is enabled.
             */
            CalendarMonthCtrl.prototype.isDateEnabled = function (opt_date) {
                return this.dateUtil.isDateWithinRange(opt_date,
                    this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
                    (!angular.isFunction(this.calendarCtrl.dateFilter) ||
                        this.calendarCtrl.dateFilter(opt_date));
            }

            /**
             * Builds a `tr` element for the calendar grid.
             * @param rowNumber The week number within the month.
             * @returns {HTMLElement}
             */
            CalendarMonthCtrl.prototype.buildDateRow = function (rowNumber) {
                var row = document.createElement('tr');
                row.setAttribute('role', 'row');

                // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
                // to prevent the entire row being read aloud when the user moves between rows.
                // See http://community.nvda-project.org/ticket/4643.
                row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));

                return row;
            };

            /**
             * Builds the <tbody> content for the given date's month.
             * @param {Date=} opt_dateInMonth
             * @returns {DocumentFragment} A document fragment containing the <tr> elements.
             */
            CalendarMonthCtrl.prototype.buildCalendarForMonth = function (opt_dateInMonth) {
                var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();

                var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
                var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
                var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);

                // Store rows for the month in a document fragment so that we can append them all at once.
                var monthBody = document.createDocumentFragment();

                var rowNumber = 1;
                var row = this.buildDateRow(rowNumber);
                monthBody.appendChild(row);

                // If this is the final month in the list of items, only the first week should render,
                // so we should return immediately after the first row is complete and has been
                // attached to the body.
                var isFinalMonth = this.offset === this.calendarCtrl.items.length - 1;

                // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
                // goes on a row above the first of the month. Otherwise, the month label takes up the first
                // two cells of the first row.
                var blankCellOffset = 0;
                var monthLabelCell = document.createElement('td');
                monthLabelCell.classList.add('md-calendar-month-label');
                // If the entire month is after the max date, render the label as a disabled state.
                if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
                    monthLabelCell.classList.add('md-calendar-month-label-disabled');
                }
                monthLabelCell.textContent = this.dateLocale.monthHeaderFormatter(date);
                if (firstDayOfTheWeek <= 2) {
                    monthLabelCell.setAttribute('colspan', '7');

                    var monthLabelRow = this.buildDateRow();
                    monthLabelRow.appendChild(monthLabelCell);
                    monthBody.insertBefore(monthLabelRow, row);

                    if (isFinalMonth) {
                        return monthBody;
                    }
                } else {
                    blankCellOffset = 2;
                    monthLabelCell.setAttribute('colspan', '2');
                    row.appendChild(monthLabelCell);
                }

                // Add a blank cell for each day of the week that occurs before the first of the month.
                // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
                // The blankCellOffset is needed in cases where the first N cells are used by the month label.
                for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
                    row.appendChild(this.buildDateCell());
                }

                // Add a cell for each day of the month, keeping track of the day of the week so that
                // we know when to start a new row.
                var dayOfWeek = firstDayOfTheWeek;
                var iterationDate = firstDayOfMonth;
                for (var d = 1; d <= numberOfDaysInMonth; d++) {
                    // If we've reached the end of the week, start a new row.
                    if (dayOfWeek === 7) {
                        // We've finished the first row, so we're done if this is the final month.
                        if (isFinalMonth) {
                            return monthBody;
                        }
                        dayOfWeek = 0;
                        rowNumber++;
                        row = this.buildDateRow(rowNumber);
                        monthBody.appendChild(row);
                    }

                    iterationDate.setDate(d);
                    var cell = this.buildDateCell(iterationDate);
                    row.appendChild(cell);

                    dayOfWeek++;
                }

                // Ensure that the last row of the month has 7 cells.
                while (row.childNodes.length < 7) {
                    row.appendChild(this.buildDateCell());
                }

                // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
                // requires that all items have exactly the same height.
                while (monthBody.childNodes.length < 6) {
                    var whitespaceRow = this.buildDateRow();
                    for (var i = 0; i < 7; i++) {
                        whitespaceRow.appendChild(this.buildDateCell());
                    }
                    monthBody.appendChild(whitespaceRow);
                }

                return monthBody;
            };

            /**
             * Gets the day-of-the-week index for a date for the current locale.
             * @private
             * @param {Date} date
             * @returns {number} The column index of the date in the calendar.
             */
            CalendarMonthCtrl.prototype.getLocaleDay_ = function (date) {
                return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7
            };
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc service
             * @name $mdDateLocaleProvider
             * @module material.components.datepicker
             *
             * @description
             * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
             * This provider that allows the user to specify messages, formatters, and parsers for date
             * internationalization. The `$mdDateLocale` service itself is consumed by Angular Material
             * components that deal with dates.
             *
             * @property {(Array<string>)=} months Array of month names (in order).
             * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
             * @property {(Array<string>)=} days Array of the days of the week (in order).
             * @property {(Array<string>)=} shortDays Array of abbreviated dayes of the week.
             * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
             *     using a numeral system other than [1, 2, 3...].
             * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
             *    etc.
             * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
             * @property {(function(Date): string)=} formatDate Function to format a date object to a string.
             * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
             *     a month given a date.
             * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
             *     a week given the week number.
             * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
             * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
             *     current locale.
             *
             * @usage
             * <hljs lang="js">
             *   myAppModule.config(function($mdDateLocaleProvider) {
             *
             *     // Example of a French localization.
             *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
             *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
             *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
             *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
             *
             *     // Can change week display to start on Monday.
             *     $mdDateLocaleProvider.firstDayOfWeek = 1;
             *
             *     // Optional.
             *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
             *
             *     // Example uses moment.js to parse and format dates.
             *     $mdDateLocaleProvider.parseDate = function(dateString) {
             *       var m = moment(dateString, 'L', true);
             *       return m.isValid() ? m.toDate() : new Date(NaN);
             *     };
             *
             *     $mdDateLocaleProvider.formatDate = function(date) {
             *       return moment(date).format('L');
             *     };
             *
             *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
             *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
             *     };
             *
             *     // In addition to date display, date components also need localized messages
             *     // for aria-labels for screen-reader users.
             *
             *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
             *       return 'Semaine ' + weekNumber;
             *     };
             *
             *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
             *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
             *
             * });
             * </hljs>
             *
             */

            angular.module('material.components.datepicker').config(["$provide", function ($provide) {
                // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.

                /** @constructor */
                function DateLocaleProvider() {
                    /** Array of full month names. E.g., ['January', 'Febuary', ...] */
                    this.months = null;

                    /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
                    this.shortMonths = null;

                    /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
                    this.days = null;

                    /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
                    this.shortDays = null;

                    /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
                    this.dates = null;

                    /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
                    this.firstDayOfWeek = 0;

                    /**
                     * Function that converts the date portion of a Date to a string.
                     * @type {(function(Date): string)}
                     */
                    this.formatDate = null;

                    /**
                     * Function that converts a date string to a Date object (the date portion)
                     * @type {function(string): Date}
                     */
                    this.parseDate = null;

                    /**
                     * Function that formats a Date into a month header string.
                     * @type {function(Date): string}
                     */
                    this.monthHeaderFormatter = null;

                    /**
                     * Function that formats a week number into a label for the week.
                     * @type {function(number): string}
                     */
                    this.weekNumberFormatter = null;

                    /**
                     * Function that formats a date into a long aria-label that is read
                     * when the focused date changes.
                     * @type {function(Date): string}
                     */
                    this.longDateFormatter = null;

                    /**
                     * ARIA label for the calendar "dialog" used in the datepicker.
                     * @type {string}
                     */
                    this.msgCalendar = '';

                    /**
                     * ARIA label for the datepicker's "Open calendar" buttons.
                     * @type {string}
                     */
                    this.msgOpenCalendar = '';
                }

                /**
                 * Factory function that returns an instance of the dateLocale service.
                 * @ngInject
                 * @param $locale
                 * @returns {DateLocale}
                 */
                DateLocaleProvider.prototype.$get = function ($locale) {
                    /**
                     * Default date-to-string formatting function.
                     * @param {!Date} date
                     * @returns {string}
                     */
                    function defaultFormatDate(date) {
                        if (!date) {
                            return '';
                        }

                        // All of the dates created through ng-material *should* be set to midnight.
                        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
                        // we have run into an issue with DST where we need to increment the hour by one:
                        // var d = new Date(1992, 9, 8, 0, 0, 0);
                        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
                        var localeTime = date.toLocaleTimeString();
                        var formatDate = date;
                        if (date.getHours() == 0 &&
                            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
                            formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
                        }

                        return formatDate.toLocaleDateString();
                    }

                    /**
                     * Default string-to-date parsing function.
                     * @param {string} dateString
                     * @returns {!Date}
                     */
                    function defaultParseDate(dateString) {
                        return new Date(dateString);
                    }

                    /**
                     * Default function to determine whether a string makes sense to be
                     * parsed to a Date object.
                     *
                     * This is very permissive and is just a basic sanity check to ensure that
                     * things like single integers aren't able to be parsed into dates.
                     * @param {string} dateString
                     * @returns {boolean}
                     */
                    function defaultIsDateComplete(dateString) {
                        dateString = dateString.trim();

                        // Looks for three chunks of content (either numbers or text) separated
                        // by delimiters.
                        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ \.,]+|[\/\-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
                        return re.test(dateString);
                    }

                    /**
                     * Default date-to-string formatter to get a month header.
                     * @param {!Date} date
                     * @returns {string}
                     */
                    function defaultMonthHeaderFormatter(date) {
                        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
                    }

                    /**
                     * Default week number formatter.
                     * @param number
                     * @returns {string}
                     */
                    function defaultWeekNumberFormatter(number) {
                        return 'Week ' + number;
                    }

                    /**
                     * Default formatter for date cell aria-labels.
                     * @param {!Date} date
                     * @returns {string}
                     */
                    function defaultLongDateFormatter(date) {
                        // Example: 'Thursday June 18 2015'
                        return [
                            service.days[date.getDay()],
                            service.months[date.getMonth()],
                            service.dates[date.getDate()],
                            date.getFullYear()
                        ].join(' ');
                    }

                    // The default "short" day strings are the first character of each day,
                    // e.g., "Monday" => "M".
                    var defaultShortDays = $locale.DATETIME_FORMATS.DAY.map(function (day) {
                        return day[0];
                    });

                    // The default dates are simply the numbers 1 through 31.
                    var defaultDates = Array(32);
                    for (var i = 1; i <= 31; i++) {
                        defaultDates[i] = i;
                    }

                    // Default ARIA messages are in English (US).
                    var defaultMsgCalendar = 'Calendar';
                    var defaultMsgOpenCalendar = 'Open calendar';

                    var service = {
                        months: this.months || $locale.DATETIME_FORMATS.MONTH,
                        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
                        days: this.days || $locale.DATETIME_FORMATS.DAY,
                        shortDays: this.shortDays || defaultShortDays,
                        dates: this.dates || defaultDates,
                        firstDayOfWeek: this.firstDayOfWeek || 0,
                        formatDate: this.formatDate || defaultFormatDate,
                        parseDate: this.parseDate || defaultParseDate,
                        isDateComplete: this.isDateComplete || defaultIsDateComplete,
                        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
                        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
                        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
                        msgCalendar: this.msgCalendar || defaultMsgCalendar,
                        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar
                    };

                    return service;
                };
                DateLocaleProvider.prototype.$get.$inject = ["$locale"];

                $provide.provider('$mdDateLocale', new DateLocaleProvider());
            }]);
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            // POST RELEASE
            // TODO(jelbourn): Demo that uses moment.js
            // TODO(jelbourn): make sure this plays well with validation and ngMessages.
            // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
            // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
            // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
            // TODO(jelbourn): input behavior (masking? auto-complete?)
            // TODO(jelbourn): UTC mode
            // TODO(jelbourn): RTL


            angular.module('material.components.datepicker')
                .directive('mdDatepicker', datePickerDirective);

            /**
             * @ngdoc directive
             * @name mdDatepicker
             * @module material.components.datepicker
             *
             * @param {Date} ng-model The component's model. Expects a JavaScript Date object.
             * @param {expression=} ng-change Expression evaluated when the model value changes.
             * @param {Date=} md-min-date Expression representing a min date (inclusive).
             * @param {Date=} md-max-date Expression representing a max date (inclusive).
             * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
             * @param {String=} md-placeholder The date input placeholder value.
             * @param {boolean=} ng-disabled Whether the datepicker is disabled.
             * @param {boolean=} ng-required Whether a value is required for the datepicker.
             *
             * @description
             * `<md-datepicker>` is a component used to select a single date.
             * For information on how to configure internationalization for the date picker,
             * see `$mdDateLocaleProvider`.
             *
             * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
             * Supported attributes are:
             * * `required`: whether a required date is not set.
             * * `mindate`: whether the selected date is before the minimum allowed date.
             * * `maxdate`: whether the selected date is after the maximum allowed date.
             *
             * @usage
             * <hljs lang="html">
             *   <md-datepicker ng-model="birthday"></md-datepicker>
             * </hljs>
             *
             */
            function datePickerDirective() {
                return {
                    template:
                        // Buttons are not in the tab order because users can open the calendar via keyboard
                        // interaction on the text input, and multiple tab stops for one component (picker)
                        // may be confusing.
                        '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
                        'tabindex="-1" aria-hidden="true" ' +
                        'ng-click="ctrl.openCalendarPane($event)">' +
                        '<md-icon class="md-datepicker-calendar-icon" md-svg-icon="md-calendar"></md-icon>' +
                        '</md-button>' +
                        '<div class="md-datepicker-input-container" ' +
                        'ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
                        '<input class="md-datepicker-input" aria-haspopup="true" ' +
                        'ng-focus="ctrl.setFocused(true)" ng-blur="ctrl.setFocused(false)">' +
                        '<md-button type="button" md-no-ink ' +
                        'class="md-datepicker-triangle-button md-icon-button" ' +
                        'ng-click="ctrl.openCalendarPane($event)" ' +
                        'aria-label="{{::ctrl.dateLocale.msgOpenCalendar}}">' +
                        '<div class="md-datepicker-expand-triangle"></div>' +
                        '</md-button>' +
                        '</div>' +

                        // This pane will be detached from here and re-attached to the document body.
                        '<div class="md-datepicker-calendar-pane md-whiteframe-z1">' +
                        '<div class="md-datepicker-input-mask">' +
                        '<div class="md-datepicker-input-mask-opaque"></div>' +
                        '</div>' +
                        '<div class="md-datepicker-calendar">' +
                        '<md-calendar role="dialog" aria-label="{{::ctrl.dateLocale.msgCalendar}}" ' +
                        'md-min-date="ctrl.minDate" md-max-date="ctrl.maxDate"' +
                        'md-date-filter="ctrl.dateFilter"' +
                        'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
                        '</md-calendar>' +
                        '</div>' +
                        '</div>',
                    require: ['ngModel', 'mdDatepicker', '?^mdInputContainer'],
                    scope: {
                        minDate: '=mdMinDate',
                        maxDate: '=mdMaxDate',
                        placeholder: '@mdPlaceholder',
                        dateFilter: '=mdDateFilter'
                    },
                    controller: DatePickerCtrl,
                    controllerAs: 'ctrl',
                    bindToController: true,
                    link: function (scope, element, attr, controllers) {
                        var ngModelCtrl = controllers[0];
                        var mdDatePickerCtrl = controllers[1];

                        var mdInputContainer = controllers[2];
                        if (mdInputContainer) {
                            throw Error('md-datepicker should not be placed inside md-input-container.');
                        }

                        mdDatePickerCtrl.configureNgModel(ngModelCtrl);
                    }
                };
            }

            /** Additional offset for the input's `size` attribute, which is updated based on its content. */
            var EXTRA_INPUT_SIZE = 3;

            /** Class applied to the container if the date is invalid. */
            var INVALID_CLASS = 'md-datepicker-invalid';

            /** Default time in ms to debounce input event by. */
            var DEFAULT_DEBOUNCE_INTERVAL = 500;

            /**
             * Height of the calendar pane used to check if the pane is going outside the boundary of
             * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
             * also added to space the pane away from the exact edge of the screen.
             *
             *  This is computed statically now, but can be changed to be measured if the circumstances
             *  of calendar sizing are changed.
             */
            var CALENDAR_PANE_HEIGHT = 368;

            /**
             * Width of the calendar pane used to check if the pane is going outside the boundary of
             * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
             * also added to space the pane away from the exact edge of the screen.
             *
             *  This is computed statically now, but can be changed to be measured if the circumstances
             *  of calendar sizing are changed.
             */
            var CALENDAR_PANE_WIDTH = 360;

            /**
             * Controller for md-datepicker.
             *
             * @ngInject @constructor
             */
            function DatePickerCtrl($scope, $element, $attrs, $compile, $timeout, $window,
                $mdConstant, $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF) {
                /** @final */
                this.$compile = $compile;

                /** @final */
                this.$timeout = $timeout;

                /** @final */
                this.$window = $window;

                /** @final */
                this.dateLocale = $mdDateLocale;

                /** @final */
                this.dateUtil = $$mdDateUtil;

                /** @final */
                this.$mdConstant = $mdConstant;

                /* @final */
                this.$mdUtil = $mdUtil;

                /** @final */
                this.$$rAF = $$rAF;

                /**
                 * The root document element. This is used for attaching a top-level click handler to
                 * close the calendar panel when a click outside said panel occurs. We use `documentElement`
                 * instead of body because, when scrolling is disabled, some browsers consider the body element
                 * to be completely off the screen and propagate events directly to the html element.
                 * @type {!angular.JQLite}
                 */
                this.documentElement = angular.element(document.documentElement);

                /** @type {!angular.NgModelController} */
                this.ngModelCtrl = null;

                /** @type {HTMLInputElement} */
                this.inputElement = $element[0].querySelector('input');

                /** @final {!angular.JQLite} */
                this.ngInputElement = angular.element(this.inputElement);

                /** @type {HTMLElement} */
                this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

                /** @type {HTMLElement} Floating calendar pane. */
                this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

                /** @type {HTMLElement} Calendar icon button. */
                this.calendarButton = $element[0].querySelector('.md-datepicker-button');

                /**
                 * Element covering everything but the input in the top of the floating calendar pane.
                 * @type {HTMLElement}
                 */
                this.inputMask = $element[0].querySelector('.md-datepicker-input-mask-opaque');

                /** @final {!angular.JQLite} */
                this.$element = $element;

                /** @final {!angular.Attributes} */
                this.$attrs = $attrs;

                /** @final {!angular.Scope} */
                this.$scope = $scope;

                /** @type {Date} */
                this.date = null;

                /** @type {boolean} */
                this.isFocused = false;

                /** @type {boolean} */
                this.isDisabled;
                this.setDisabled($element[0].disabled || angular.isString($attrs['disabled']));

                /** @type {boolean} Whether the date-picker's calendar pane is open. */
                this.isCalendarOpen = false;

                /**
                 * Element from which the calendar pane was opened. Keep track of this so that we can return
                 * focus to it when the pane is closed.
                 * @type {HTMLElement}
                 */
                this.calendarPaneOpenedFrom = null;

                this.calendarPane.id = 'md-date-pane' + $mdUtil.nextUid();

                $mdTheming($element);

                /** Pre-bound click handler is saved so that the event listener can be removed. */
                this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

                /** Pre-bound resize handler so that the event listener can be removed. */
                this.windowResizeHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

                // Unless the user specifies so, the datepicker should not be a tab stop.
                // This is necessary because ngAria might add a tabindex to anything with an ng-model
                // (based on whether or not the user has turned that particular feature on/off).
                if (!$attrs['tabindex']) {
                    $element.attr('tabindex', '-1');
                }

                this.installPropertyInterceptors();
                this.attachChangeListeners();
                this.attachInteractionListeners();

                var self = this;
                $scope.$on('$destroy', function () {
                    self.detachCalendarPane();
                });
            }
            DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$compile", "$timeout", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF"];

            /**
             * Sets up the controller's reference to ngModelController.
             * @param {!angular.NgModelController} ngModelCtrl
             */
            DatePickerCtrl.prototype.configureNgModel = function (ngModelCtrl) {
                this.ngModelCtrl = ngModelCtrl;

                var self = this;
                ngModelCtrl.$render = function () {
                    var value = self.ngModelCtrl.$viewValue;

                    if (value && !(value instanceof Date)) {
                        throw Error('The ng-model for md-datepicker must be a Date instance. ' +
                            'Currently the model is a: ' + (typeof value));
                    }

                    self.date = value;
                    self.inputElement.value = self.dateLocale.formatDate(value);
                    self.resizeInputElement();
                    self.updateErrorState();
                };
            };

            /**
             * Attach event listeners for both the text input and the md-calendar.
             * Events are used instead of ng-model so that updates don't infinitely update the other
             * on a change. This should also be more performant than using a $watch.
             */
            DatePickerCtrl.prototype.attachChangeListeners = function () {
                var self = this;

                self.$scope.$on('md-calendar-change', function (event, date) {
                    self.ngModelCtrl.$setViewValue(date);
                    self.date = date;
                    self.inputElement.value = self.dateLocale.formatDate(date);
                    self.closeCalendarPane();
                    self.resizeInputElement();
                    self.updateErrorState();
                });

                self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));
                // TODO(chenmike): Add ability for users to specify this interval.
                self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
                    DEFAULT_DEBOUNCE_INTERVAL, self));
            };

            /** Attach event listeners for user interaction. */
            DatePickerCtrl.prototype.attachInteractionListeners = function () {
                var self = this;
                var $scope = this.$scope;
                var keyCodes = this.$mdConstant.KEY_CODE;

                // Add event listener through angular so that we can triggerHandler in unit tests.
                self.ngInputElement.on('keydown', function (event) {
                    if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
                        self.openCalendarPane(event);
                        $scope.$digest();
                    }
                });

                $scope.$on('md-calendar-close', function () {
                    self.closeCalendarPane();
                });
            };

            /**
             * Capture properties set to the date-picker and imperitively handle internal changes.
             * This is done to avoid setting up additional $watches.
             */
            DatePickerCtrl.prototype.installPropertyInterceptors = function () {
                var self = this;

                if (this.$attrs['ngDisabled']) {
                    // The expression is to be evaluated against the directive element's scope and not
                    // the directive's isolate scope.
                    var scope = this.$scope.$parent;

                    if (scope) {
                        scope.$watch(this.$attrs['ngDisabled'], function (isDisabled) {
                            self.setDisabled(isDisabled);
                        });
                    }
                }

                Object.defineProperty(this, 'placeholder', {
                    get: function () { return self.inputElement.placeholder; },
                    set: function (value) { self.inputElement.placeholder = value || ''; }
                });
            };

            /**
             * Sets whether the date-picker is disabled.
             * @param {boolean} isDisabled
             */
            DatePickerCtrl.prototype.setDisabled = function (isDisabled) {
                this.isDisabled = isDisabled;
                this.inputElement.disabled = isDisabled;
                this.calendarButton.disabled = isDisabled;
            };

            /**
             * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
             *   - mindate: whether the selected date is before the minimum date.
             *   - maxdate: whether the selected flag is after the maximum date.
             *   - filtered: whether the selected date is allowed by the custom filtering function.
             *   - valid: whether the entered text input is a valid date
             *
             * The 'required' flag is handled automatically by ngModel.
             *
             * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
             */
            DatePickerCtrl.prototype.updateErrorState = function (opt_date) {
                var date = opt_date || this.date;

                // Clear any existing errors to get rid of anything that's no longer relevant.
                this.clearErrorState();

                if (this.dateUtil.isValidDate(date)) {
                    // Force all dates to midnight in order to ignore the time portion.
                    date = this.dateUtil.createDateAtMidnight(date);

                    if (this.dateUtil.isValidDate(this.minDate)) {
                        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
                        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
                    }

                    if (this.dateUtil.isValidDate(this.maxDate)) {
                        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
                        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
                    }

                    if (angular.isFunction(this.dateFilter)) {
                        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
                    }
                } else {
                    // The date is seen as "not a valid date" if there is *something* set
                    // (i.e.., not null or undefined), but that something isn't a valid date.
                    this.ngModelCtrl.$setValidity('valid', date == null);
                }

                // TODO(jelbourn): Change this to classList.toggle when we stop using PhantomJS in unit tests
                // because it doesn't conform to the DOMTokenList spec.
                // See https://github.com/ariya/phantomjs/issues/12782.
                if (!this.ngModelCtrl.$valid) {
                    this.inputContainer.classList.add(INVALID_CLASS);
                }
            };

            /** Clears any error flags set by `updateErrorState`. */
            DatePickerCtrl.prototype.clearErrorState = function () {
                this.inputContainer.classList.remove(INVALID_CLASS);
                ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function (field) {
                    this.ngModelCtrl.$setValidity(field, true);
                }, this);
            };

            /** Resizes the input element based on the size of its content. */
            DatePickerCtrl.prototype.resizeInputElement = function () {
                this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
            };

            /**
             * Sets the model value if the user input is a valid date.
             * Adds an invalid class to the input element if not.
             */
            DatePickerCtrl.prototype.handleInputEvent = function () {
                var inputString = this.inputElement.value;
                var parsedDate = inputString ? this.dateLocale.parseDate(inputString) : null;
                this.dateUtil.setDateTimeToMidnight(parsedDate);

                // An input string is valid if it is either empty (representing no date)
                // or if it parses to a valid date that the user is allowed to select.
                var isValidInput = inputString == '' || (
                    this.dateUtil.isValidDate(parsedDate) &&
                    this.dateLocale.isDateComplete(inputString) &&
                    this.isDateEnabled(parsedDate)
                );

                // The datepicker's model is only updated when there is a valid input.
                if (isValidInput) {
                    this.ngModelCtrl.$setViewValue(parsedDate);
                    this.date = parsedDate;
                }

                this.updateErrorState(parsedDate);
            };

            /**
             * Check whether date is in range and enabled
             * @param {Date=} opt_date
             * @return {boolean} Whether the date is enabled.
             */
            DatePickerCtrl.prototype.isDateEnabled = function (opt_date) {
                return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
                    (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
            };

            /** Position and attach the floating calendar to the document. */
            DatePickerCtrl.prototype.attachCalendarPane = function () {
                var calendarPane = this.calendarPane;
                calendarPane.style.transform = '';
                this.$element.addClass('md-datepicker-open');

                var elementRect = this.inputContainer.getBoundingClientRect();
                var bodyRect = document.body.getBoundingClientRect();

                // Check to see if the calendar pane would go off the screen. If so, adjust position
                // accordingly to keep it within the viewport.
                var paneTop = elementRect.top - bodyRect.top;
                var paneLeft = elementRect.left - bodyRect.left;

                // If ng-material has disabled body scrolling (for example, if a dialog is open),
                // then it's possible that the already-scrolled body has a negative top/left. In this case,
                // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
                // though, the top of the viewport should just be the body's scroll position.
                var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
                    -bodyRect.top :
                    document.body.scrollTop;

                var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
                    -bodyRect.left :
                    document.body.scrollLeft;

                var viewportBottom = viewportTop + this.$window.innerHeight;
                var viewportRight = viewportLeft + this.$window.innerWidth;

                // If the right edge of the pane would be off the screen and shifting it left by the
                // difference would not go past the left edge of the screen. If the calendar pane is too
                // big to fit on the screen at all, move it to the left of the screen and scale the entire
                // element down to fit.
                if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
                    if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
                        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
                    } else {
                        paneLeft = viewportLeft;
                        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
                        calendarPane.style.transform = 'scale(' + scale + ')';
                    }

                    calendarPane.classList.add('md-datepicker-pos-adjusted');
                }

                // If the bottom edge of the pane would be off the screen and shifting it up by the
                // difference would not go past the top edge of the screen.
                if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
                    viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
                    paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
                    calendarPane.classList.add('md-datepicker-pos-adjusted');
                }

                calendarPane.style.left = paneLeft + 'px';
                calendarPane.style.top = paneTop + 'px';
                document.body.appendChild(calendarPane);

                // The top of the calendar pane is a transparent box that shows the text input underneath.
                // Since the pane is floating, though, the page underneath the pane *adjacent* to the input is
                // also shown unless we cover it up. The inputMask does this by filling up the remaining space
                // based on the width of the input.
                this.inputMask.style.left = elementRect.width + 'px';

                // Add CSS class after one frame to trigger open animation.
                this.$$rAF(function () {
                    calendarPane.classList.add('md-pane-open');
                });
            };

            /** Detach the floating calendar pane from the document. */
            DatePickerCtrl.prototype.detachCalendarPane = function () {
                this.$element.removeClass('md-datepicker-open');
                this.calendarPane.classList.remove('md-pane-open');
                this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

                if (this.isCalendarOpen) {
                    this.$mdUtil.enableScrolling();
                }

                if (this.calendarPane.parentNode) {
                    // Use native DOM removal because we do not want any of the angular state of this element
                    // to be disposed.
                    this.calendarPane.parentNode.removeChild(this.calendarPane);
                }
            };

            /**
             * Open the floating calendar pane.
             * @param {Event} event
             */
            DatePickerCtrl.prototype.openCalendarPane = function (event) {
                if (!this.isCalendarOpen && !this.isDisabled) {
                    this.isCalendarOpen = true;
                    this.calendarPaneOpenedFrom = event.target;

                    // Because the calendar pane is attached directly to the body, it is possible that the
                    // rest of the component (input, etc) is in a different scrolling container, such as
                    // an md-content. This means that, if the container is scrolled, the pane would remain
                    // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
                    // also matches the native behavior for things like `<select>` on Mac and Windows.
                    this.$mdUtil.disableScrollAround(this.calendarPane);

                    this.attachCalendarPane();
                    this.focusCalendar();

                    // Attach click listener inside of a timeout because, if this open call was triggered by a
                    // click, we don't want it to be immediately propogated up to the body and handled.
                    var self = this;
                    this.$mdUtil.nextTick(function () {
                        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
                        // events aren't propogated under most circumstances.
                        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                        self.documentElement.on('click touchstart', self.bodyClickHandler);
                    }, false);

                    window.addEventListener('resize', this.windowResizeHandler);
                }
            };

            /** Close the floating calendar pane. */
            DatePickerCtrl.prototype.closeCalendarPane = function () {
                if (this.isCalendarOpen) {
                    this.detachCalendarPane();
                    this.isCalendarOpen = false;
                    this.calendarPaneOpenedFrom.focus();
                    this.calendarPaneOpenedFrom = null;

                    this.ngModelCtrl.$setTouched();

                    this.documentElement.off('click touchstart', this.bodyClickHandler);
                    window.removeEventListener('resize', this.windowResizeHandler);
                }
            };

            /** Gets the controller instance for the calendar in the floating pane. */
            DatePickerCtrl.prototype.getCalendarCtrl = function () {
                return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
            };

            /** Focus the calendar in the floating pane. */
            DatePickerCtrl.prototype.focusCalendar = function () {
                // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
                var self = this;
                this.$mdUtil.nextTick(function () {
                    self.getCalendarCtrl().focus();
                }, false);
            };

            /**
             * Sets whether the input is currently focused.
             * @param {boolean} isFocused
             */
            DatePickerCtrl.prototype.setFocused = function (isFocused) {
                if (!isFocused) {
                    this.ngModelCtrl.$setTouched();
                }
                this.isFocused = isFocused;
            };

            /**
             * Handles a click on the document body when the floating calendar pane is open.
             * Closes the floating calendar pane if the click is not inside of it.
             * @param {MouseEvent} event
             */
            DatePickerCtrl.prototype.handleBodyClick = function (event) {
                if (this.isCalendarOpen) {
                    // TODO(jelbourn): way want to also include the md-datepicker itself in this check.
                    var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');
                    if (!isInCalendar) {
                        this.closeCalendarPane();
                    }

                    this.$scope.$digest();
                }
            };
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * Utility for performing date calculations to facilitate operation of the calendar and
             * datepicker.
             */
            angular.module('material.components.datepicker').factory('$$mdDateUtil', function () {
                return {
                    getFirstDateOfMonth: getFirstDateOfMonth,
                    getNumberOfDaysInMonth: getNumberOfDaysInMonth,
                    getDateInNextMonth: getDateInNextMonth,
                    getDateInPreviousMonth: getDateInPreviousMonth,
                    isInNextMonth: isInNextMonth,
                    isInPreviousMonth: isInPreviousMonth,
                    getDateMidpoint: getDateMidpoint,
                    isSameMonthAndYear: isSameMonthAndYear,
                    getWeekOfMonth: getWeekOfMonth,
                    incrementDays: incrementDays,
                    incrementMonths: incrementMonths,
                    getLastDateOfMonth: getLastDateOfMonth,
                    isSameDay: isSameDay,
                    getMonthDistance: getMonthDistance,
                    isValidDate: isValidDate,
                    setDateTimeToMidnight: setDateTimeToMidnight,
                    createDateAtMidnight: createDateAtMidnight,
                    isDateWithinRange: isDateWithinRange
                };

                /**
                 * Gets the first day of the month for the given date's month.
                 * @param {Date} date
                 * @returns {Date}
                 */
                function getFirstDateOfMonth(date) {
                    return new Date(date.getFullYear(), date.getMonth(), 1);
                }

                /**
                 * Gets the number of days in the month for the given date's month.
                 * @param date
                 * @returns {number}
                 */
                function getNumberOfDaysInMonth(date) {
                    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
                }

                /**
                 * Get an arbitrary date in the month after the given date's month.
                 * @param date
                 * @returns {Date}
                 */
                function getDateInNextMonth(date) {
                    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
                }

                /**
                 * Get an arbitrary date in the month before the given date's month.
                 * @param date
                 * @returns {Date}
                 */
                function getDateInPreviousMonth(date) {
                    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
                }

                /**
                 * Gets whether two dates have the same month and year.
                 * @param {Date} d1
                 * @param {Date} d2
                 * @returns {boolean}
                 */
                function isSameMonthAndYear(d1, d2) {
                    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
                }

                /**
                 * Gets whether two dates are the same day (not not necesarily the same time).
                 * @param {Date} d1
                 * @param {Date} d2
                 * @returns {boolean}
                 */
                function isSameDay(d1, d2) {
                    return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
                }

                /**
                 * Gets whether a date is in the month immediately after some date.
                 * @param {Date} startDate The date from which to compare.
                 * @param {Date} endDate The date to check.
                 * @returns {boolean}
                 */
                function isInNextMonth(startDate, endDate) {
                    var nextMonth = getDateInNextMonth(startDate);
                    return isSameMonthAndYear(nextMonth, endDate);
                }

                /**
                 * Gets whether a date is in the month immediately before some date.
                 * @param {Date} startDate The date from which to compare.
                 * @param {Date} endDate The date to check.
                 * @returns {boolean}
                 */
                function isInPreviousMonth(startDate, endDate) {
                    var previousMonth = getDateInPreviousMonth(startDate);
                    return isSameMonthAndYear(endDate, previousMonth);
                }

                /**
                 * Gets the midpoint between two dates.
                 * @param {Date} d1
                 * @param {Date} d2
                 * @returns {Date}
                 */
                function getDateMidpoint(d1, d2) {
                    return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
                }

                /**
                 * Gets the week of the month that a given date occurs in.
                 * @param {Date} date
                 * @returns {number} Index of the week of the month (zero-based).
                 */
                function getWeekOfMonth(date) {
                    var firstDayOfMonth = getFirstDateOfMonth(date);
                    return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
                }

                /**
                 * Gets a new date incremented by the given number of days. Number of days can be negative.
                 * @param {Date} date
                 * @param {number} numberOfDays
                 * @returns {Date}
                 */
                function incrementDays(date, numberOfDays) {
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
                }

                /**
                 * Gets a new date incremented by the given number of months. Number of months can be negative.
                 * If the date of the given month does not match the target month, the date will be set to the
                 * last day of the month.
                 * @param {Date} date
                 * @param {number} numberOfMonths
                 * @returns {Date}
                 */
                function incrementMonths(date, numberOfMonths) {
                    // If the same date in the target month does not actually exist, the Date object will
                    // automatically advance *another* month by the number of missing days.
                    // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
                    // So, we check if the month overflowed and go to the last day of the target month instead.
                    var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
                    var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
                    if (numberOfDaysInMonth < date.getDate()) {
                        dateInTargetMonth.setDate(numberOfDaysInMonth);
                    } else {
                        dateInTargetMonth.setDate(date.getDate());
                    }

                    return dateInTargetMonth;
                }

                /**
                 * Get the integer distance between two months. This *only* considers the month and year
                 * portion of the Date instances.
                 *
                 * @param {Date} start
                 * @param {Date} end
                 * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
                 *     chronologically, this number will be negative.
                 */
                function getMonthDistance(start, end) {
                    return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
                }

                /**
                 * Gets the last day of the month for the given date.
                 * @param {Date} date
                 * @returns {Date}
                 */
                function getLastDateOfMonth(date) {
                    return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
                }

                /**
                 * Checks whether a date is valid.
                 * @param {Date} date
                 * @return {boolean} Whether the date is a valid Date.
                 */
                function isValidDate(date) {
                    return date != null && date.getTime && !isNaN(date.getTime());
                }

                /**
                 * Sets a date's time to midnight.
                 * @param {Date} date
                 */
                function setDateTimeToMidnight(date) {
                    if (isValidDate(date)) {
                        date.setHours(0, 0, 0, 0);
                    }
                }

                /**
                 * Creates a date with the time set to midnight.
                 * Drop-in replacement for two forms of the Date constructor:
                 * 1. No argument for Date representing now.
                 * 2. Single-argument value representing number of seconds since Unix Epoch
                 * or a Date object.
                 * @param {number|Date=} opt_value
                 * @return {Date} New date with time set to midnight.
                 */
                function createDateAtMidnight(opt_value) {
                    var date;
                    if (angular.isUndefined(opt_value)) {
                        date = new Date();
                    } else {
                        date = new Date(opt_value);
                    }
                    setDateTimeToMidnight(date);
                    return date;
                }

                /**
                 * Checks if a date is within a min and max range, ignoring the time component.
                 * If minDate or maxDate are not dates, they are ignored.
                 * @param {Date} date
                 * @param {Date} minDate
                 * @param {Date} maxDate
                 */
                function isDateWithinRange(date, minDate, maxDate) {
                    var dateAtMidnight = createDateAtMidnight(date);
                    var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
                    var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
                    return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
                        (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
                }
            });
        })();

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.dialog
         */
        angular
            .module('material.components.dialog', [
                'material.core',
                'material.components.backdrop'
            ])
            .directive('mdDialog', MdDialogDirective)
            .provider('$mdDialog', MdDialogProvider);

        /**
         * @ngdoc directive
         * @name mdDialog
         * @module material.components.dialog
         *
         * @restrict E
         *
         * @description
         * `<md-dialog>` - The dialog's template must be inside this element.
         *
         * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
         * an `<md-dialog-actions>` element for the dialog's actions.
         *
         * ## CSS
         * - `.md-dialog-content` - class that sets the padding on the content as the spec file
         *
         * ## Notes
         * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
         * prefixed with `dialogContent_`.
         *
         * @usage
         * ### Dialog template
         * <hljs lang="html">
         * <md-dialog aria-label="List dialog">
         *   <md-dialog-content>
         *     <md-list>
         *       <md-list-item ng-repeat="item in items">
         *         <p>Number {{item}}</p>
         *       </md-list-item>
         *     </md-list>
         *   </md-dialog-content>
         *   <md-dialog-actions>
         *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
         *   </md-dialog-actions>
         * </md-dialog>
         * </hljs>
         */
        function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
            return {
                restrict: 'E',
                link: function (scope, element, attr) {
                    $mdTheming(element);
                    $$rAF(function () {
                        var images;
                        var content = element[0].querySelector('md-dialog-content');

                        if (content) {
                            images = content.getElementsByTagName('img');
                            addOverflowClass();
                            //-- delayed image loading may impact scroll height, check after images are loaded
                            angular.element(images).on('load', addOverflowClass);
                        }

                        scope.$on('$destroy', function () {
                            $mdDialog.destroy(element);
                        });

                        /**
                         *
                         */
                        function addOverflowClass() {
                            element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
                        }


                    });
                }
            };
        }
        MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];

        /**
         * @ngdoc service
         * @name $mdDialog
         * @module material.components.dialog
         *
         * @description
         * `$mdDialog` opens a dialog over the app to inform users about critical information or require
         *  them to make decisions. There are two approaches for setup: a simple promise API
         *  and regular object syntax.
         *
         * ## Restrictions
         *
         * - The dialog is always given an isolate scope.
         * - The dialog's template must have an outer `<md-dialog>` element.
         *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
         *   an `<md-dialog-actions>` element for the dialog's actions.
         * - Dialogs must cover the entire application to keep interactions inside of them.
         * Use the `parent` option to change where dialogs are appended.
         *
         * ## Sizing
         * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
         * - Default max-width is 80% of the `rootElement` or `parent`.
         *
         * ## CSS
         * - `.md-dialog-content` - class that sets the padding on the content as the spec file
         *
         * @usage
         * <hljs lang="html">
         * <div  ng-app="demoApp" ng-controller="EmployeeController">
         *   <div>
         *     <md-button ng-click="showAlert()" class="md-raised md-warn">
         *       Employee Alert!
         *       </md-button>
         *   </div>
         *   <div>
         *     <md-button ng-click="showDialog($event)" class="md-raised">
         *       Custom Dialog
         *       </md-button>
         *   </div>
         *   <div>
         *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
         *       Close Alert
         *     </md-button>
         *   </div>
         *   <div>
         *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
         *       Greet Employee
         *       </md-button>
         *   </div>
         * </div>
         * </hljs>
         *
         * ### JavaScript: object syntax
         * <hljs lang="js">
         * (function(angular, undefined){
         *   "use strict";
         *
         *   angular
         *    .module('demoApp', ['ngMaterial'])
         *    .controller('AppCtrl', AppController);
         *
         *   function AppController($scope, $mdDialog) {
         *     var alert;
         *     $scope.showAlert = showAlert;
         *     $scope.showDialog = showDialog;
         *     $scope.items = [1, 2, 3];
         *
         *     // Internal method
         *     function showAlert() {
         *       alert = $mdDialog.alert({
         *         title: 'Attention',
         *         textContent: 'This is an example of how easy dialogs can be!',
         *         ok: 'Close'
         *       });
         *
         *       $mdDialog
         *         .show( alert )
         *         .finally(function() {
         *           alert = undefined;
         *         });
         *     }
         *
         *     function showDialog($event) {
         *        var parentEl = angular.element(document.body);
         *        $mdDialog.show({
         *          parent: parentEl,
         *          targetEvent: $event,
         *          template:
         *            '<md-dialog aria-label="List dialog">' +
         *            '  <md-dialog-content>'+
         *            '    <md-list>'+
         *            '      <md-list-item ng-repeat="item in items">'+
         *            '       <p>Number {{item}}</p>' +
         *            '      </md-item>'+
         *            '    </md-list>'+
         *            '  </md-dialog-content>' +
         *            '  <md-dialog-actions>' +
         *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
         *            '      Close Dialog' +
         *            '    </md-button>' +
         *            '  </md-dialog-actions>' +
         *            '</md-dialog>',
         *          locals: {
         *            items: $scope.items
         *          },
         *          controller: DialogController
         *       });
         *       function DialogController($scope, $mdDialog, items) {
         *         $scope.items = items;
         *         $scope.closeDialog = function() {
         *           $mdDialog.hide();
         *         }
         *       }
         *     }
         *   }
         * })(angular);
         * </hljs>
         *
         * ### JavaScript: promise API syntax, custom dialog template
         * <hljs lang="js">
         * (function(angular, undefined){
         *   "use strict";
         *
         *   angular
         *     .module('demoApp', ['ngMaterial'])
         *     .controller('EmployeeController', EmployeeEditor)
         *     .controller('GreetingController', GreetingController);
         *
         *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
         *
         *   function EmployeeEditor($scope, $mdDialog) {
         *     var alert;
         *
         *     $scope.showAlert = showAlert;
         *     $scope.closeAlert = closeAlert;
         *     $scope.showGreeting = showCustomGreeting;
         *
         *     $scope.hasAlert = function() { return !!alert };
         *     $scope.userName = $scope.userName || 'Bobby';
         *
         *     // Dialog #1 - Show simple alert dialog and cache
         *     // reference to dialog instance
         *
         *     function showAlert() {
         *       alert = $mdDialog.alert()
         *         .title('Attention, ' + $scope.userName)
         *         .textContent('This is an example of how easy dialogs can be!')
         *         .ok('Close');
         *
         *       $mdDialog
         *           .show( alert )
         *           .finally(function() {
         *             alert = undefined;
         *           });
         *     }
         *
         *     // Close the specified dialog instance and resolve with 'finished' flag
         *     // Normally this is not needed, just use '$mdDialog.hide()' to close
         *     // the most recent dialog popup.
         *
         *     function closeAlert() {
         *       $mdDialog.hide( alert, "finished" );
         *       alert = undefined;
         *     }
         *
         *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
         *
         *     function showCustomGreeting($event) {
         *         $mdDialog.show({
         *           targetEvent: $event,
         *           template:
         *             '<md-dialog>' +
         *
         *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
         *
         *             '  <md-dialog-actions>' +
         *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
         *             '      Close Greeting' +
         *             '    </md-button>' +
         *             '  </md-dialog-actions>' +
         *             '</md-dialog>',
         *           controller: 'GreetingController',
         *           onComplete: afterShowAnimation,
         *           locals: { employee: $scope.userName }
         *         });
         *
         *         // When the 'enter' animation finishes...
         *
         *         function afterShowAnimation(scope, element, options) {
         *            // post-show code here: DOM element focus, etc.
         *         }
         *     }
         *
         *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
         *     //             Here we used ng-controller="GreetingController as vm" and
         *     //             $scope.vm === <controller instance>
         *
         *     function showCustomGreeting() {
         *
         *        $mdDialog.show({
         *           clickOutsideToClose: true,
         *
         *           scope: $scope,        // use parent scope in template
         *           preserveScope: true,  // do not forget this if use parent scope

         *           // Since GreetingController is instantiated with ControllerAs syntax
         *           // AND we are passing the parent '$scope' to the dialog, we MUST
         *           // use 'vm.<xxx>' in the template markup
         *
         *           template: '<md-dialog>' +
         *                     '  <md-dialog-content>' +
         *                     '     Hi There {{vm.employee}}' +
         *                     '  </md-dialog-content>' +
         *                     '</md-dialog>',
         *
         *           controller: function DialogController($scope, $mdDialog) {
         *             $scope.closeDialog = function() {
         *               $mdDialog.hide();
         *             }
         *           }
         *        });
         *     }
         *
         *   }
         *
         *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
         *
         *   function GreetingController($scope, $mdDialog, employee) {
         *     // Assigned from construction <code>locals</code> options...
         *     $scope.employee = employee;
         *
         *     $scope.closeDialog = function() {
         *       // Easily hides most recent dialog shown...
         *       // no specific instance reference is needed.
         *       $mdDialog.hide();
         *     };
         *   }
         *
         * })(angular);
         * </hljs>
         */

        /**
         * @ngdoc method
         * @name $mdDialog#alert
         *
         * @description
         * Builds a preconfigured dialog with the specified message.
         *
         * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
         *
         * - $mdDialogPreset#title(string) - Sets the alert title.
         * - $mdDialogPreset#textContent(string) - Sets the alert message.
         * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
         *     module to be loaded. HTML is not run through Angular's compiler.
         * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
         * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
         * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
         *     the location of the click will be used as the starting point for the opening animation
         *     of the the dialog.
         *
         */

        /**
         * @ngdoc method
         * @name $mdDialog#confirm
         *
         * @description
         * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
         * will be resolved only if the user clicks the confirm action on the dialog.
         *
         * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
         *
         * Additionally, it supports the following methods:
         *
         * - $mdDialogPreset#title(string) - Sets the confirm title.
         * - $mdDialogPreset#textContent(string) - Sets the confirm message.
         * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
         *     module to be loaded. HTML is not run through Angular's compiler.
         * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
         * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
         * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
         * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
         *     the location of the click will be used as the starting point for the opening animation
         *     of the the dialog.
         *
         */

        /**
         * @ngdoc method
         * @name $mdDialog#prompt
         *
         * @description
         * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
         * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
         *
         * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
         *
         * Additionally, it supports the following methods:
         *
         * - $mdDialogPreset#title(string) - Sets the prompt title.
         * - $mdDialogPreset#textContent(string) - Sets the prompt message.
         * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
         *     module to be loaded. HTML is not run through Angular's compiler.
         * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
         * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
         * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
         * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
         * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
         *     the location of the click will be used as the starting point for the opening animation
         *     of the the dialog.
         *
         */

        /**
         * @ngdoc method
         * @name $mdDialog#show
         *
         * @description
         * Show a dialog with the specified options.
         *
         * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
         * `confirm()`, or an options object with the following properties:
         *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
         *   of the dialog.
         *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
         *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
         *      This template should **never** be constructed with any kind of user input or user data.
         *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
         *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
         *     custom dialog directive.
         *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
         *     the location of the click will be used as the starting point for the opening animation
         *     of the the dialog.
         *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
         *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
         *     originate.
         *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
         *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
         *     target.
         *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
         *     it will create a new isolate scope.
         *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
         *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
         *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
         *     Default true.
         *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
         *     Default true.
         *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
         *     close it. Default false.
         *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
         *     Default true.
         *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
         *     focusing some other way, as focus management is required for dialogs to be accessible.
         *     Defaults to true.
         *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
         *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
         *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
         *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
         *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
         *     copied to the controller instead.
         *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
         *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values, and the
         *     dialog will not open until all of the promises resolve.
         *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
         *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
         *     to the root element of the application.
         *   - `onShowing` `{function=} Callback function used to announce the show() action is
         *     starting.
         *   - `onComplete` `{function=}`: Callback function used to announce when the show() action is
         *     finished.
         *   - `onRemoving` `{function=}`: Callback function used to announce the close/hide() action is
         *     starting. This allows developers to run custom animations in parallel the close animations.
         *   - `fullscreen` `{boolean=}`: An option to apply `.md-dialog-fullscreen` class on open.
         * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
         * rejected with `$mdDialog.cancel()`.
         */

        /**
         * @ngdoc method
         * @name $mdDialog#hide
         *
         * @description
         * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
         *
         * @param {*=} response An argument for the resolved promise.
         *
         * @returns {promise} A promise that is resolved when the dialog has been closed.
         */

        /**
         * @ngdoc method
         * @name $mdDialog#cancel
         *
         * @description
         * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
         *
         * @param {*=} response An argument for the rejected promise.
         *
         * @returns {promise} A promise that is resolved when the dialog has been closed.
         */

        function MdDialogProvider($$interimElementProvider) {
            // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
            var topFocusTrap, bottomFocusTrap;


            advancedDialogOptions.$inject = ["$mdDialog", "$mdTheming", "$mdConstant"];
            dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector"];
            return $$interimElementProvider('$mdDialog')
                .setDefaults({
                    methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
                        'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen'
                    ],
                    options: dialogDefaultOptions
                })
                .addPreset('alert', {
                    methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
                        'css'
                    ],
                    options: advancedDialogOptions
                })
                .addPreset('confirm', {
                    methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
                        'theme', 'css'
                    ],
                    options: advancedDialogOptions
                })
                .addPreset('prompt', {
                    methods: ['title', 'htmlContent', 'textContent', 'content', 'placeholder', 'ariaLabel',
                        'ok', 'cancel', 'theme', 'css'
                    ],
                    options: advancedDialogOptions
                });

            /* @ngInject */
            function advancedDialogOptions($mdDialog, $mdTheming, $mdConstant) {
                return {
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">{{ dialog.title }}</h2>',
                        '    <div ng-if="::dialog.mdHtmlContent" class="_md-dialog-content-body" ',
                        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
                        '    <div ng-if="::!dialog.mdHtmlContent" class="_md-dialog-content-body">',
                        '      <p>{{::dialog.mdTextContent}}</p>',
                        '    </div>',
                        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
                        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" placeholder="{{::dialog.placeholder}}">',
                        '    </md-input-container>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
                        '               ng-click="dialog.abort()" class="md-primary">',
                        '      {{ dialog.cancel }}',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.hide()" class="md-primary" md-autofocus="dialog.$type===\'alert\'">',
                        '      {{ dialog.ok }}',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    controller: function mdDialogCtrl() {
                        this.hide = function () {
                            $mdDialog.hide(this.$type === 'prompt' ? this.result : true);
                        };
                        this.abort = function () {
                            $mdDialog.cancel();
                        };
                        this.keypress = function ($event) {
                            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                                $mdDialog.hide(this.result)
                            }
                        }
                    },
                    controllerAs: 'dialog',
                    bindToController: true,
                    theme: $mdTheming.defaultTheme()
                };
            }

            /* @ngInject */
            function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement, $rootScope, $log, $injector) {
                return {
                    hasBackdrop: true,
                    isolateScope: true,
                    onShow: onShow,
                    onShowing: beforeShow,
                    onRemove: onRemove,
                    clickOutsideToClose: false,
                    escapeToClose: true,
                    targetEvent: null,
                    closeTo: null,
                    openFrom: null,
                    focusOnOpen: true,
                    disableParentScroll: true,
                    autoWrap: true,
                    fullscreen: false,
                    transformTemplate: function (template, options) {
                        // Make the dialog container focusable, because otherwise the focus will be always redirected to
                        // an element outside of the container, and the focus trap won't work probably..
                        // Also the tabindex is needed for the `escapeToClose` functionality, because
                        // the keyDown event can't be triggered when the focus is outside of the container.
                        return '<div class="md-dialog-container" tabindex="-1">' + validatedTemplate(template) + '</div>';

                        /**
                         * The specified template should contain a <md-dialog> wrapper element....
                         */
                        function validatedTemplate(template) {
                            if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
                                return '<md-dialog>' + (template || '') + '</md-dialog>';
                            } else {
                                return template || '';
                            }
                        }
                    }
                };

                function beforeShow(scope, element, options, controller) {
                    if (controller) {
                        controller.mdHtmlContent = controller.htmlContent || options.htmlContent || '';
                        controller.mdTextContent = controller.textContent || options.textContent ||
                            controller.content || options.content || '';

                        if (controller.mdHtmlContent && !($injector || window.$injector).has('$sanitize')) {
                            throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
                        }

                        if (controller.mdHtmlContent && controller.mdTextContent) {
                            throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
                        }
                    }
                }

                /** Show method for dialogs */
                function onShow(scope, element, options, controller) {
                    angular.element($document[0].body).addClass('md-dialog-is-showing');

                    $rootScope.$mdDialogOpen = true

                    captureParentAndFromToElements(options);
                    configureAria(element.find('md-dialog'), options);
                    //showBackdrop(scope, element, options);

                    return dialogPopIn(element, options)
                        .then(function () {
                            activateListeners(element, options);
                            lockScreenReader(element, options);
                            warnDeprecatedActions();
                            focusOnOpen();
                        });

                    /**
                     * Check to see if they used the deprecated .md-actions class and log a warning
                     */
                    function warnDeprecatedActions() {
                        var badActions = element[0].querySelectorAll('.md-actions');

                        if (badActions.length > 0) {
                            $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
                        }
                    }

                    /**
                     * For alerts, focus on content... otherwise focus on
                     * the close button (or equivalent)
                     */
                    function focusOnOpen() {
                        if (options.focusOnOpen) {
                            var target = $mdUtil.findFocusTarget(element) || findCloseButton();
                            target.focus();
                        }

                        /**
                         * If no element with class dialog-close, try to find the last
                         * button child in md-actions and assume it is a close button.
                         *
                         * If we find no actions at all, log a warning to the console.
                         */
                        function findCloseButton() {
                            var closeButton = element[0].querySelector('.dialog-close');
                            if (!closeButton) {
                                var actionButtons = element[0].querySelectorAll('.md-actions button, md-dialog-actions button');
                                closeButton = actionButtons[actionButtons.length - 1];
                            }
                            return angular.element(closeButton);
                        }
                    }
                }

                /**
                 * Remove function for all dialogs
                 */
                function onRemove(scope, element, options) {
                    $rootScope.$mdDialogOpen = false
                    options.deactivateListeners();
                    options.unlockScreenReader();
                    //options.hideBackdrop(options.$destroy);

                    // Remove the focus traps that we added earlier for keeping focus within the dialog.
                    if (topFocusTrap && topFocusTrap.parentNode) {
                        topFocusTrap.parentNode.removeChild(topFocusTrap);
                    }

                    if (bottomFocusTrap && bottomFocusTrap.parentNode) {
                        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
                    }

                    // For navigation $destroy events, do a quick, non-animated removal,
                    // but for normal closes (from clicks, etc) animate the removal
                    return !!options.$destroy ? detachAndClean() : animateRemoval().then(detachAndClean);

                    /**
                     * For normal closes, animate the removal.
                     * For forced closes (like $destroy events), skip the animations
                     */
                    function animateRemoval() {
                        return dialogPopOut(element, options);
                    }

                    /**
                     * Detach the element
                     */
                    function detachAndClean() {
                        element.remove();
                        if (angular.element('md-dialog').length == 0) {
                                 angular.element($document[0].body).removeClass('md-dialog-is-showing');
                        }
                        
                       
                        

                        if (!options.$destroy) options.origin.focus();
                    }
                }

                /**
                 * Capture originator/trigger/from/to element information (if available)
                 * and the parent container for the dialog; defaults to the $rootElement
                 * unless overridden in the options.parent
                 */
                function captureParentAndFromToElements(options) {
                    options.origin = angular.extend({
                        element: null,
                        bounds: null,
                        focus: angular.noop
                    }, options.origin || {});

                    options.parent = getDomElement(options.parent, $rootElement);
                    options.closeTo = getBoundingClientRect(getDomElement(options.closeTo));
                    options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));

                    if (options.targetEvent) {
                        options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
                    }

                    /**
                     * Identify the bounding RECT for the target element
                     *
                     */
                    function getBoundingClientRect(element, orig) {
                        var source = angular.element((element || {}));
                        if (source && source.length) {
                            // Compute and save the target element's bounding rect, so that if the
                            // element is hidden when the dialog closes, we can shrink the dialog
                            // back to the same position it expanded from.
                            //
                            // Checking if the source is a rect object or a DOM element
                            var bounds = { top: 0, left: 0, height: 0, width: 0 };
                            var hasFn = angular.isFunction(source[0].getBoundingClientRect);

                            return angular.extend(orig || {}, {
                                element: hasFn ? source : undefined,
                                bounds: hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
                                focus: angular.bind(source, source.focus),
                            });
                        }
                    }

                    /**
                     * If the specifier is a simple string selector, then query for
                     * the DOM element.
                     */
                    function getDomElement(element, defaultElement) {
                        if (angular.isString(element)) {
                            var simpleSelector = element,
                                container = $document[0].querySelectorAll(simpleSelector);
                            element = container.length ? container[0] : null;
                        }

                        // If we have a reference to a raw dom element, always wrap it in jqLite
                        return angular.element(element || defaultElement);
                    }

                }

                /**
                 * Listen for escape keys and outside clicks to auto close
                 */
                function activateListeners(element, options) {
                    var window = angular.element($window);
                    var onWindowResize = $mdUtil.debounce(function () {
                        stretchDialogContainerToViewport(element, options);
                    }, 60);

                    var removeListeners = [];
                    var smartClose = function () {
                        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
                        // cancel or fallback to hide.
                        var closeFn = (options.$type == 'alert') ? $mdDialog.hide : $mdDialog.cancel;
                        $mdUtil.nextTick(closeFn, true);
                    };

                    if (options.escapeToClose) {
                        var parentTarget = options.parent;
                        var keyHandlerFn = function (ev) {
                            if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
                                ev.stopPropagation();
                                ev.preventDefault();

                                smartClose();
                            }
                        };

                        // Add keydown listeners
                        element.on('keydown', keyHandlerFn);
                        parentTarget.on('keydown', keyHandlerFn);

                        // Queue remove listeners function
                        removeListeners.push(function () {

                            element.off('keydown', keyHandlerFn);
                            parentTarget.off('keydown', keyHandlerFn);

                        });
                    }

                    // Register listener to update dialog on window resize
                    window.on('resize', onWindowResize);

                    removeListeners.push(function () {
                        window.off('resize', onWindowResize);
                    });

                    if (options.clickOutsideToClose) {
                        var target = element;
                        var sourceElem;

                        // Keep track of the element on which the mouse originally went down
                        // so that we can only close the backdrop when the 'click' started on it.
                        // A simple 'click' handler does not work,
                        // it sets the target object as the element the mouse went down on.
                        var mousedownHandler = function (ev) {
                            sourceElem = ev.target;
                        };

                        // We check if our original element and the target is the backdrop
                        // because if the original was the backdrop and the target was inside the dialog
                        // we don't want to dialog to close.
                        var mouseupHandler = function (ev) {
                            if (sourceElem === target[0] && ev.target === target[0]) {
                                ev.stopPropagation();
                                ev.preventDefault();

                                smartClose();
                            }
                        };

                        // Add listeners
                        target.on('mousedown', mousedownHandler);
                        target.on('mouseup', mouseupHandler);

                        // Queue remove listeners function
                        removeListeners.push(function () {
                            target.off('mousedown', mousedownHandler);
                            target.off('mouseup', mouseupHandler);
                        });
                    }

                    // Attach specific `remove` listener handler
                    options.deactivateListeners = function () {
                        removeListeners.forEach(function (removeFn) {
                            removeFn();
                        });
                        options.deactivateListeners = null;
                    };
                }

                /**
                 * Show modal backdrop element...
                 */
                function showBackdrop(scope, element, options) {

                    if (options.disableParentScroll) {
                        // !! DO this before creating the backdrop; since disableScrollAround()
                        //    configures the scroll offset; which is used by mdBackDrop postLink()
                        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
                    }

                    if (options.hasBackdrop) {
                        options.backdrop = $mdUtil.createBackdrop(scope, "_md-dialog-backdrop md-opaque");
                        $animate.enter(options.backdrop, options.parent);
                    }

                    /**
                     * Hide modal backdrop element...
                     */
                    options.hideBackdrop = function hideBackdrop($destroy) {
                        if (options.backdrop) {
                            if (!!$destroy) options.backdrop.remove();
                            else $animate.leave(options.backdrop);
                        }

                        if (options.disableParentScroll) {
                            options.restoreScroll();
                            delete options.restoreScroll;
                        }

                        options.hideBackdrop = null;
                    }
                }

                /**
                 * Inject ARIA-specific attributes appropriate for Dialogs
                 */
                function configureAria(element, options) {

                    var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
                    var dialogContent = element.find('md-dialog-content');
                    var dialogContentId = 'dialogContent_' + (element.attr('id') || $mdUtil.nextUid());

                    element.attr({
                        'role': role,
                        'tabIndex': '-1'
                    });

                    if (dialogContent.length === 0) {
                        dialogContent = element;
                    }

                    dialogContent.attr('id', dialogContentId);
                    element.attr('aria-describedby', dialogContentId);

                    if (options.ariaLabel) {
                        $mdAria.expect(element, 'aria-label', options.ariaLabel);
                    } else {
                        $mdAria.expectAsync(element, 'aria-label', function () {
                            var words = dialogContent.text().split(/\s+/);
                            if (words.length > 3) words = words.slice(0, 3).concat('...');
                            return words.join(' ');
                        });
                    }

                    // Set up elements before and after the dialog content to capture focus and
                    // redirect back into the dialog.
                    topFocusTrap = document.createElement('div');
                    topFocusTrap.classList.add('_md-dialog-focus-trap');
                    topFocusTrap.tabIndex = 0;

                    bottomFocusTrap = topFocusTrap.cloneNode(false);

                    // When focus is about to move out of the dialog, we want to intercept it and redirect it
                    // back to the dialog element.
                    var focusHandler = function () {
                        element.focus();
                    };
                    topFocusTrap.addEventListener('focus', focusHandler);
                    bottomFocusTrap.addEventListener('focus', focusHandler);

                    // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
                    // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
                    element[0].parentNode.insertBefore(topFocusTrap, element[0]);
                    element.after(bottomFocusTrap);
                }

                /**
                 * Prevents screen reader interaction behind modal window
                 * on swipe interfaces
                 */
                function lockScreenReader(element, options) {
                    var isHidden = true;

                    // get raw DOM node
                    walkDOM(element[0]);

                    options.unlockScreenReader = function () {
                        isHidden = false;
                        walkDOM(element[0]);

                        options.unlockScreenReader = null;
                    };

                    /**
                     * Walk DOM to apply or remove aria-hidden on sibling nodes
                     * and parent sibling nodes
                     *
                     */
                    function walkDOM(element) {
                        while (element.parentNode) {
                            if (element === document.body) {
                                return;
                            }
                            var children = element.parentNode.children;
                            for (var i = 0; i < children.length; i++) {
                                // skip over child if it is an ascendant of the dialog
                                // or a script or style tag
                                if (element !== children[i] && !isNodeOneOf(children[i], ['SCRIPT', 'STYLE'])) {
                                    children[i].setAttribute('aria-hidden', isHidden);
                                }
                            }

                            walkDOM(element = element.parentNode);
                        }
                    }
                }

                /**
                 * Ensure the dialog container fill-stretches to the viewport
                 */
                function stretchDialogContainerToViewport(container, options) {
                    var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
                    var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
                    var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;

                    container.css({
                        top: (isFixed ? $mdUtil.scrollTop(options.parent) : 0) + 'px',
                        height: height ? height + 'px' : '100%'
                    });

                    return container;
                }

                /**
                 *  Dialog open and pop-in animation
                 */
                function dialogPopIn(container, options) {
                    // Add the `md-dialog-container` to the DOM
                    options.parent.append(container);
                    stretchDialogContainerToViewport(container, options);

                    var dialogEl = container.find('md-dialog');
                    var animator = $mdUtil.dom.animator;
                    var buildTranslateToOrigin = animator.calculateZoomToOrigin;
                    var translateOptions = { transitionInClass: '_md-transition-in', transitionOutClass: '_md-transition-out' };
                    var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
                    var to = animator.toTransformCss(""); // defaults to center display (or parent or $rootElement)

                    if (options.fullscreen) {
                        dialogEl.addClass('md-dialog-fullscreen');
                    }

                    return animator
                        .translate3d(dialogEl, from, to, translateOptions)
                        .then(function (animateReversal) {
                            // Build a reversal translate function synched to this translation...
                            options.reverseAnimate = function () {
                                delete options.reverseAnimate;

                                if (options.closeTo) {
                                    // Using the opposite classes to create a close animation to the closeTo element
                                    translateOptions = { transitionInClass: '_md-transition-out', transitionOutClass: '_md-transition-in' };
                                    from = to;
                                    to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));

                                    return animator
                                        .translate3d(dialogEl, from, to, translateOptions);
                                }

                                return animateReversal(
                                    animator.toTransformCss(
                                        // in case the origin element has moved or is hidden,
                                        // let's recalculate the translateCSS
                                        buildTranslateToOrigin(dialogEl, options.origin)
                                    )
                                );

                            };
                            return true;
                        });
                }

                /**
                 * Dialog close and pop-out animation
                 */
                function dialogPopOut(container, options) {
                    return options.reverseAnimate();
                }

                /**
                 * Utility function to filter out raw DOM nodes
                 */
                function isNodeOneOf(elem, nodeTypeArray) {
                    if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
                        return true;
                    }
                }

            }
        }
        MdDialogProvider.$inject = ["$$interimElementProvider"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.divider
         * @description Divider module!
         */
        angular.module('material.components.divider', [
            'material.core'
        ])
            .directive('mdDivider', MdDividerDirective);

        /**
         * @ngdoc directive
         * @name mdDivider
         * @module material.components.divider
         * @restrict E
         *
         * @description
         * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
         *
         * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
         * @usage
         * <hljs lang="html">
         * <md-divider></md-divider>
         *
         * <md-divider md-inset></md-divider>
         * </hljs>
         *
         */
        function MdDividerDirective($mdTheming) {
            return {
                restrict: 'E',
                link: $mdTheming
            };
        }
        MdDividerDirective.$inject = ["$mdTheming"];

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc module
             * @name material.components.fabActions
             */
            angular
                .module('material.components.fabActions', ['material.core'])
                .directive('mdFabActions', MdFabActionsDirective);

            /**
             * @ngdoc directive
             * @name mdFabActions
             * @module material.components.fabActions
             *
             * @restrict E
             *
             * @description
             * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
             * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
             * proper event listeners.
             *
             * @usage
             * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
             */
            function MdFabActionsDirective() {
                return {
                    restrict: 'E',

                    require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],

                    compile: function (element, attributes) {
                        var children = element.children();

                        var hasNgRepeat = false;

                        angular.forEach(['', 'data-', 'x-'], function (prefix) {
                            hasNgRepeat = hasNgRepeat || (children.attr(prefix + 'ng-repeat') ? true : false);
                        });

                        // Support both ng-repeat and static content
                        if (hasNgRepeat) {
                            children.addClass('md-fab-action-item');
                        } else {
                            // Wrap every child in a new div and add a class that we can scale/fling independently
                            children.wrap('<div class="md-fab-action-item">');
                        }
                    }
                }
            }

        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            angular.module('material.components.fabShared', ['material.core'])
                .controller('MdFabController', MdFabController);

            function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
                var vm = this;

                // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops

                vm.open = function () {
                    $scope.$evalAsync("vm.isOpen = true");
                };

                vm.close = function () {
                    // Async eval to avoid conflicts with existing digest loops
                    $scope.$evalAsync("vm.isOpen = false");

                    // Focus the trigger when the element closes so users can still tab to the next item
                    //!Bug!: prevends dialog focus?
                    //$element.find('md-fab-trigger')[0].focus();
                };

                // Toggle the open/close state when the trigger is clicked
                vm.toggle = function () {
                    $scope.$evalAsync("vm.isOpen = !vm.isOpen");
                };

                setupDefaults();
                setupListeners();
                setupWatchers();

                var initialAnimationAttempts = 0;
                fireInitialAnimations();

                function setupDefaults() {
                    // Set the default direction to 'down' if none is specified
                    vm.direction = vm.direction || 'down';

                    // Set the default to be closed
                    vm.isOpen = vm.isOpen || false;

                    // Start the keyboard interaction at the first action
                    resetActionIndex();

                    // Add an animations waiting class so we know not to run
                    $element.addClass('_md-animations-waiting');
                }

                function setupListeners() {
                    var eventTypes = [
                        'click', 'focusin', 'focusout'
                    ];

                    // Add our listeners
                    angular.forEach(eventTypes, function (eventType) {
                        $element.on(eventType, parseEvents);
                    });

                    // Remove our listeners when destroyed
                    $scope.$on('$destroy', function () {
                        angular.forEach(eventTypes, function (eventType) {
                            $element.off(eventType, parseEvents);
                        });

                        // remove any attached keyboard handlers in case element is removed while
                        // speed dial is open
                        disableKeyboard();
                    });
                }

                var closeTimeout;

                function parseEvents(event) {
                    // If the event is a click, just handle it
                    if (event.type == 'click') {
                        handleItemClick(event);
                    }

                    // If we focusout, set a timeout to close the element
                    if (event.type == 'focusout' && !closeTimeout) {
                        closeTimeout = $timeout(function () {
                            vm.close();
                        }, 100, false);
                    }

                    // If we see a focusin and there is a timeout about to run, cancel it so we stay open
                    if (event.type == 'focusin' && closeTimeout) {
                        $timeout.cancel(closeTimeout);
                        closeTimeout = null;
                    }
                }

                function resetActionIndex() {
                    vm.currentActionIndex = -1;
                }

                function setupWatchers() {
                    // Watch for changes to the direction and update classes/attributes
                    $scope.$watch('vm.direction', function (newDir, oldDir) {
                        // Add the appropriate classes so we can target the direction in the CSS
                        $animate.removeClass($element, 'md-' + oldDir);
                        $animate.addClass($element, 'md-' + newDir);

                        // Reset the action index since it may have changed
                        resetActionIndex();
                    });

                    var trigger, actions;

                    // Watch for changes to md-open
                    $scope.$watch('vm.isOpen', function (isOpen) {
                        // Reset the action index since it may have changed
                        resetActionIndex();

                        // We can't get the trigger/actions outside of the watch because the component hasn't been
                        // linked yet, so we wait until the first watch fires to cache them.
                        if (!trigger || !actions) {
                            trigger = getTriggerElement();
                            actions = getActionsElement();
                        }

                        if (isOpen) {
                            enableKeyboard();
                        } else {
                            disableKeyboard();
                        }

                        var toAdd = isOpen ? 'md-is-open' : '';
                        var toRemove = isOpen ? '' : 'md-is-open';

                        // Set the proper ARIA attributes
                        trigger.attr('aria-haspopup', true);
                        trigger.attr('aria-expanded', isOpen);
                        actions.attr('aria-hidden', !isOpen);

                        // Animate the CSS classes
                        $animate.setClass($element, toAdd, toRemove);
                    });
                }

                function fireInitialAnimations() {
                    // If the element is actually visible on the screen
                    if ($element[0].scrollHeight > 0) {
                        // Fire our animation
                        $animate.addClass($element, '_md-animations-ready').then(function () {
                            // Remove the waiting class
                            $element.removeClass('_md-animations-waiting');
                        });
                    }

                    // Otherwise, try for up to 1 second before giving up
                    else if (initialAnimationAttempts < 10) {
                        $timeout(fireInitialAnimations, 100);

                        // Increment our counter
                        initialAnimationAttempts = initialAnimationAttempts + 1;
                    }
                }

                function enableKeyboard() {
                    $element.on('keydown', keyPressed);

                    // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
                    // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
                    $mdUtil.nextTick(function () {
                        angular.element(document).on('click touchend', checkForOutsideClick);
                    });

                    // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
                    // this breaks accessibility, especially on mobile, since you have no arrow keys to press
                    //resetActionTabIndexes();
                }

                function disableKeyboard() {
                    $element.off('keydown', keyPressed);
                    angular.element(document).off('click touchend', checkForOutsideClick);
                }

                function checkForOutsideClick(event) {
                    if (event.target) {
                        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
                        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');

                        if (!closestTrigger && !closestActions) {
                            vm.close();
                        }
                    }
                }

                function keyPressed(event) {
                    switch (event.which) {
                        case $mdConstant.KEY_CODE.ESCAPE:
                            vm.close();
                            event.preventDefault();
                            return false;
                        case $mdConstant.KEY_CODE.LEFT_ARROW:
                            doKeyLeft(event);
                            return false;
                        case $mdConstant.KEY_CODE.UP_ARROW:
                            doKeyUp(event);
                            return false;
                        case $mdConstant.KEY_CODE.RIGHT_ARROW:
                            doKeyRight(event);
                            return false;
                        case $mdConstant.KEY_CODE.DOWN_ARROW:
                            doKeyDown(event);
                            return false;
                    }
                }

                function doActionPrev(event) {
                    focusAction(event, -1);
                }

                function doActionNext(event) {
                    focusAction(event, 1);
                }

                function focusAction(event, direction) {
                    var actions = resetActionTabIndexes();

                    // Increment/decrement the counter with restrictions
                    vm.currentActionIndex = vm.currentActionIndex + direction;
                    vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
                    vm.currentActionIndex = Math.max(0, vm.currentActionIndex);

                    // Focus the element
                    var focusElement = angular.element(actions[vm.currentActionIndex]).children()[0];
                    angular.element(focusElement).attr('tabindex', 0);
                    focusElement.focus();

                    // Make sure the event doesn't bubble and cause something else
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }

                function resetActionTabIndexes() {
                    // Grab all of the actions
                    var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');

                    // Disable all other actions for tabbing
                    angular.forEach(actions, function (action) {
                        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
                    });

                    return actions;
                }

                function doKeyLeft(event) {
                    if (vm.direction === 'left') {
                        doActionNext(event);
                    } else {
                        doActionPrev(event);
                    }
                }

                function doKeyUp(event) {
                    if (vm.direction === 'down') {
                        doActionPrev(event);
                    } else {
                        doActionNext(event);
                    }
                }

                function doKeyRight(event) {
                    if (vm.direction === 'left') {
                        doActionPrev(event);
                    } else {
                        doActionNext(event);
                    }
                }

                function doKeyDown(event) {
                    if (vm.direction === 'up') {
                        doActionPrev(event);
                    } else {
                        doActionNext(event);
                    }
                }

                function isTrigger(element) {
                    return $mdUtil.getClosest(element, 'md-fab-trigger');
                }

                function isAction(element) {
                    return $mdUtil.getClosest(element, 'md-fab-actions');
                }

                function handleItemClick(event) {
                    if (isTrigger(event.target)) {
                        vm.toggle();
                    }

                    if (isAction(event.target)) {
                        vm.close();
                    }
                }

                function getTriggerElement() {
                    return $element.find('md-fab-trigger');
                }

                function getActionsElement() {
                    return $element.find('md-fab-actions');
                }
            }
            MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * The duration of the CSS animation in milliseconds.
             *
             * @type {number}
             */
            var cssAnimationDuration = 300;

            /**
             * @ngdoc module
             * @name material.components.fabSpeedDial
             */
            angular
                // Declare our module
                .module('material.components.fabSpeedDial', [
                    'material.core',
                    'material.components.fabShared',
                    'material.components.fabTrigger',
                    'material.components.fabActions'
                ])

                // Register our directive
                .directive('mdFabSpeedDial', MdFabSpeedDialDirective)

                // Register our custom animations
                .animation('.md-fling', MdFabSpeedDialFlingAnimation)
                .animation('.md-scale', MdFabSpeedDialScaleAnimation)

                // Register a service for each animation so that we can easily inject them into unit tests
                .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
                .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);

            /**
             * @ngdoc directive
             * @name mdFabSpeedDial
             * @module material.components.fabSpeedDial
             *
             * @restrict E
             *
             * @description
             * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
             * `<md-button>`s) for quick access to common actions.
             *
             * There are currently two animations available by applying one of the following classes to
             * the component:
             *
             *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
             *    appropriate positions.
             *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
             *
             * You may also easily position the trigger by applying one one of the following classes to the
             * `<md-fab-speed-dial>` element:
             *  - `md-fab-top-left`
             *  - `md-fab-top-right`
             *  - `md-fab-bottom-left`
             *  - `md-fab-bottom-right`
             *
             * These CSS classes use `position: absolute`, so you need to ensure that the container element
             * also uses `position: absolute` or `position: relative` in order for them to work.
             *
             * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
             * open or close the speed dial. However, if you wish to allow users to hover over the empty
             * space where the actions will appear, you must also add the `md-hover-full` class to the speed
             * dial element. Without this, the hover effect will only occur on top of the trigger.
             *
             * See the demos for more information.
             *
             * ## Troubleshooting
             *
             * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
             * the parent container to ensure that it is only visible once ready. We have plans to remove this
             * necessity in the future.
             *
             * @usage
             * <hljs lang="html">
             * <md-fab-speed-dial md-direction="up" class="md-fling">
             *   <md-fab-trigger>
             *     <md-button aria-label="Add..."><md-icon icon="/img/icons/plus.svg"></md-icon></md-button>
             *   </md-fab-trigger>
             *
             *   <md-fab-actions>
             *     <md-button aria-label="Add User">
             *       <md-icon icon="/img/icons/user.svg"></md-icon>
             *     </md-button>
             *
             *     <md-button aria-label="Add Group">
             *       <md-icon icon="/img/icons/group.svg"></md-icon>
             *     </md-button>
             *   </md-fab-actions>
             * </md-fab-speed-dial>
             * </hljs>
             *
             * @param {string} md-direction From which direction you would like the speed dial to appear
             * relative to the trigger element.
             * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
             */
            function MdFabSpeedDialDirective() {
                return {
                    restrict: 'E',

                    scope: {
                        direction: '@?mdDirection',
                        isOpen: '=?mdOpen'
                    },

                    bindToController: true,
                    controller: 'MdFabController',
                    controllerAs: 'vm',

                    link: FabSpeedDialLink
                };

                function FabSpeedDialLink(scope, element) {
                    // Prepend an element to hold our CSS variables so we can use them in the animations below
                    element.prepend('<div class="_md-css-variables"></div>');
                }
            }

            function MdFabSpeedDialFlingAnimation($timeout) {
                function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

                function runAnimation(element) {
                    // Don't run if we are still waiting and we are not ready
                    if (element.hasClass('_md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
                        return;
                    }

                    var el = element[0];
                    var ctrl = element.controller('mdFabSpeedDial');
                    var items = el.querySelectorAll('.md-fab-action-item');

                    // Grab our trigger element
                    var triggerElement = el.querySelector('md-fab-trigger');

                    // Grab our element which stores CSS variables
                    var variablesElement = el.querySelector('._md-css-variables');

                    // Setup JS variables based on our CSS variables
                    var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

                    // Always reset the items to their natural position/state
                    angular.forEach(items, function (item, index) {
                        var styles = item.style;

                        styles.transform = styles.webkitTransform = '';
                        styles.transitionDelay = '';
                        styles.opacity = 1;

                        // Make the items closest to the trigger have the highest z-index
                        styles.zIndex = (items.length - index) + startZIndex;
                    });

                    // Set the trigger to be above all of the actions so they disappear behind it.
                    triggerElement.style.zIndex = startZIndex + items.length + 1;

                    // If the control is closed, hide the items behind the trigger
                    if (!ctrl.isOpen) {
                        angular.forEach(items, function (item, index) {
                            var newPosition, axis;
                            var styles = item.style;

                            // Make sure to account for differences in the dimensions of the trigger verses the items
                            // so that we can properly center everything; this helps hide the item's shadows behind
                            // the trigger.
                            var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
                            var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;

                            switch (ctrl.direction) {
                                case 'up':
                                    newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
                                    axis = 'Y';
                                    break;
                                case 'down':
                                    newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
                                    axis = 'Y';
                                    break;
                                case 'left':
                                    newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
                                    axis = 'X';
                                    break;
                                case 'right':
                                    newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
                                    axis = 'X';
                                    break;
                            }

                            var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';

                            styles.transform = styles.webkitTransform = newTranslate;
                        });
                    }
                }

                return {
                    addClass: function (element, className, done) {
                        if (element.hasClass('md-fling')) {
                            runAnimation(element);
                            delayDone(done);
                        } else {
                            done();
                        }
                    },
                    removeClass: function (element, className, done) {
                        runAnimation(element);
                        delayDone(done);
                    }
                }
            }
            MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];

            function MdFabSpeedDialScaleAnimation($timeout) {
                function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

                var delay = 65;

                function runAnimation(element) {
                    var el = element[0];
                    var ctrl = element.controller('mdFabSpeedDial');
                    var items = el.querySelectorAll('.md-fab-action-item');

                    // Grab our element which stores CSS variables
                    var variablesElement = el.querySelector('._md-css-variables');

                    // Setup JS variables based on our CSS variables
                    var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

                    // Always reset the items to their natural position/state
                    angular.forEach(items, function (item, index) {
                        var styles = item.style,
                            offsetDelay = index * delay;

                        styles.opacity = ctrl.isOpen ? 1 : 0;
                        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
                        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';

                        // Make the items closest to the trigger have the highest z-index
                        styles.zIndex = (items.length - index) + startZIndex;
                    });
                }

                return {
                    addClass: function (element, className, done) {
                        runAnimation(element);
                        delayDone(done);
                    },

                    removeClass: function (element, className, done) {
                        runAnimation(element);
                        delayDone(done);
                    }
                }
            }
            MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
        })();

    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc module
             * @name material.components.fabToolbar
             */
            angular
                // Declare our module
                .module('material.components.fabToolbar', [
                    'material.core',
                    'material.components.fabShared',
                    'material.components.fabTrigger',
                    'material.components.fabActions'
                ])

                // Register our directive
                .directive('mdFabToolbar', MdFabToolbarDirective)

                // Register our custom animations
                .animation('.md-fab-toolbar', MdFabToolbarAnimation)

                // Register a service for the animation so that we can easily inject it into unit tests
                .service('mdFabToolbarAnimation', MdFabToolbarAnimation);

            /**
             * @ngdoc directive
             * @name mdFabToolbar
             * @module material.components.fabToolbar
             *
             * @restrict E
             *
             * @description
             *
             * The `<md-fab-toolbar>` directive is used present a toolbar of elements (usually `<md-button>`s)
             * for quick access to common actions when a floating action button is activated (via click or
             * keyboard navigation).
             *
             * You may also easily position the trigger by applying one one of the following classes to the
             * `<md-fab-toolbar>` element:
             *  - `md-fab-top-left`
             *  - `md-fab-top-right`
             *  - `md-fab-bottom-left`
             *  - `md-fab-bottom-right`
             *
             * These CSS classes use `position: absolute`, so you need to ensure that the container element
             * also uses `position: absolute` or `position: relative` in order for them to work.
             *
             * @usage
             *
             * <hljs lang="html">
             * <md-fab-toolbar md-direction='left'>
             *   <md-fab-trigger>
             *     <md-button aria-label="Add..."><md-icon icon="/img/icons/plus.svg"></md-icon></md-button>
             *   </md-fab-trigger>
             *
             *   <md-fab-actions>
             *     <md-button aria-label="Add User">
             *       <md-icon icon="/img/icons/user.svg"></md-icon>
             *     </md-button>
             *
             *     <md-button aria-label="Add Group">
             *       <md-icon icon="/img/icons/group.svg"></md-icon>
             *     </md-button>
             *   </md-fab-actions>
             * </md-fab-toolbar>
             * </hljs>
             *
             * @param {string} md-direction From which direction you would like the toolbar items to appear
             * relative to the trigger element. Supports `left` and `right` directions.
             * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
             */
            function MdFabToolbarDirective() {
                return {
                    restrict: 'E',
                    transclude: true,
                    template: '<div class="_md-fab-toolbar-wrapper">' +
                        '  <div class="_md-fab-toolbar-content" ng-transclude></div>' +
                        '</div>',

                    scope: {
                        direction: '@?mdDirection',
                        isOpen: '=?mdOpen'
                    },

                    bindToController: true,
                    controller: 'MdFabController',
                    controllerAs: 'vm',

                    link: link
                };

                function link(scope, element, attributes) {
                    // Add the base class for animations
                    element.addClass('md-fab-toolbar');

                    // Prepend the background element to the trigger's button
                    element.find('md-fab-trigger').find('button')
                        .prepend('<div class="_md-fab-toolbar-background"></div>');
                }
            }

            function MdFabToolbarAnimation() {

                function runAnimation(element, className, done) {
                    // If no className was specified, don't do anything
                    if (!className) {
                        return;
                    }

                    var el = element[0];
                    var ctrl = element.controller('mdFabToolbar');

                    // Grab the relevant child elements
                    var backgroundElement = el.querySelector('._md-fab-toolbar-background');
                    var triggerElement = el.querySelector('md-fab-trigger button');
                    var toolbarElement = el.querySelector('md-toolbar');
                    var iconElement = el.querySelector('md-fab-trigger button md-icon');
                    var actions = element.find('md-fab-actions').children();

                    // If we have both elements, use them to position the new background
                    if (triggerElement && backgroundElement) {
                        // Get our variables
                        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
                        var width = el.offsetWidth;
                        var height = el.offsetHeight;

                        // Make it twice as big as it should be since we scale from the center
                        var scale = 2 * (width / triggerElement.offsetWidth);

                        // Set some basic styles no matter what animation we're doing
                        backgroundElement.style.backgroundColor = color;
                        backgroundElement.style.borderRadius = width + 'px';

                        // If we're open
                        if (ctrl.isOpen) {
                            // Turn on toolbar pointer events when closed
                            toolbarElement.style.pointerEvents = 'inherit';

                            backgroundElement.style.width = triggerElement.offsetWidth + 'px';
                            backgroundElement.style.height = triggerElement.offsetHeight + 'px';
                            backgroundElement.style.transform = 'scale(' + scale + ')';

                            // Set the next close animation to have the proper delays
                            backgroundElement.style.transitionDelay = '0ms';
                            iconElement && (iconElement.style.transitionDelay = '.3s');

                            // Apply a transition delay to actions
                            angular.forEach(actions, function (action, index) {
                                action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
                            });
                        } else {
                            // Turn off toolbar pointer events when closed
                            toolbarElement.style.pointerEvents = 'none';

                            // Scale it back down to the trigger's size
                            backgroundElement.style.transform = 'scale(1)';

                            // Reset the position
                            backgroundElement.style.top = '0';

                            if (element.hasClass('md-right')) {
                                backgroundElement.style.left = '0';
                                backgroundElement.style.right = null;
                            }

                            if (element.hasClass('md-left')) {
                                backgroundElement.style.right = '0';
                                backgroundElement.style.left = null;
                            }

                            // Set the next open animation to have the proper delays
                            backgroundElement.style.transitionDelay = '200ms';
                            iconElement && (iconElement.style.transitionDelay = '0ms');

                            // Apply a transition delay to actions
                            angular.forEach(actions, function (action, index) {
                                action.style.transitionDelay = 200 + (index * 25) + 'ms';
                            });
                        }
                    }
                }

                return {
                    addClass: function (element, className, done) {
                        runAnimation(element, className, done);
                        done();
                    },

                    removeClass: function (element, className, done) {
                        runAnimation(element, className, done);
                        done();
                    }
                }
            }
        })();
    })();
    (function () {
        "use strict";

        (function () {
            'use strict';

            /**
             * @ngdoc module
             * @name material.components.fabTrigger
             */
            angular
                .module('material.components.fabTrigger', ['material.core'])
                .directive('mdFabTrigger', MdFabTriggerDirective);

            /**
             * @ngdoc directive
             * @name mdFabTrigger
             * @module material.components.fabSpeedDial
             *
             * @restrict E
             *
             * @description
             * The `<md-fab-trigger>` directive is used inside of a `<md-fab-speed-dial>` or
             * `<md-fab-toolbar>` directive to mark an element (or elements) as the trigger and setup the
             * proper event listeners.
             *
             * @usage
             * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
             */
            function MdFabTriggerDirective() {
                // TODO: Remove this completely?
                return {
                    restrict: 'E',

                    require: ['^?mdFabSpeedDial', '^?mdFabToolbar']
                };
            }
        })();


    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.gridList
         */
        angular.module('material.components.gridList', ['material.core'])
            .directive('mdGridList', GridListDirective)
            .directive('mdGridTile', GridTileDirective)
            .directive('mdGridTileFooter', GridTileCaptionDirective)
            .directive('mdGridTileHeader', GridTileCaptionDirective)
            .factory('$mdGridLayout', GridLayoutFactory);

        /**
         * @ngdoc directive
         * @name mdGridList
         * @module material.components.gridList
         * @restrict E
         * @description
         * Grid lists are an alternative to standard list views. Grid lists are distinct
         * from grids used for layouts and other visual presentations.
         *
         * A grid list is best suited to presenting a homogenous data type, typically
         * images, and is optimized for visual comprehension and differentiating between
         * like data types.
         *
         * A grid list is a continuous element consisting of tessellated, regular
         * subdivisions called cells that contain tiles (`md-grid-tile`).
         *
         * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
         *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
         * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
         *    style="width: 300px; height: auto;" alt="Grid concepts legend">
         *
         * Cells are arrayed vertically and horizontally within the grid.
         *
         * Tiles hold content and can span one or more cells vertically or horizontally.
         *
         * ### Responsive Attributes
         *
         * The `md-grid-list` directive supports "responsive" attributes, which allow
         * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
         * currently matching media query.
         *
         * In order to set a responsive attribute, first define the fallback value with
         * the standard attribute name, then add additional attributes with the
         * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
         * (ie. `md-cols-lg="8"`)
         *
         * @param {number} md-cols Number of columns in the grid.
         * @param {string} md-row-height One of
         * <ul>
         *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
         *   <li>`{width}:{height}` - Ratio of width to height (eg.
         *   `md-row-height="16:9"`)</li>
         *   <li>`"fit"` - Height will be determined by subdividing the available
         *   height by the number of rows</li>
         * </ul>
         * @param {string=} md-gutter The amount of space between tiles in CSS units
         *     (default 1px)
         * @param {expression=} md-on-layout Expression to evaluate after layout. Event
         *     object is available as `$event`, and contains performance information.
         *
         * @usage
         * Basic:
         * <hljs lang="html">
         * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
         *   <md-grid-tile></md-grid-tile>
         * </md-grid-list>
         * </hljs>
         *
         * Fixed-height rows:
         * <hljs lang="html">
         * <md-grid-list md-cols="4" md-row-height="200px" ...>
         *   <md-grid-tile></md-grid-tile>
         * </md-grid-list>
         * </hljs>
         *
         * Fit rows:
         * <hljs lang="html">
         * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
         *   <md-grid-tile></md-grid-tile>
         * </md-grid-list>
         * </hljs>
         *
         * Using responsive attributes:
         * <hljs lang="html">
         * <md-grid-list
         *     md-cols-sm="2"
         *     md-cols-md="4"
         *     md-cols-lg="8"
         *     md-cols-gt-lg="12"
         *     ...>
         *   <md-grid-tile></md-grid-tile>
         * </md-grid-list>
         * </hljs>
         */
        function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
            return {
                restrict: 'E',
                controller: GridListController,
                scope: {
                    mdOnLayout: '&'
                },
                link: postLink
            };

            function postLink(scope, element, attrs, ctrl) {
                // Apply semantics
                element.attr('role', 'list');

                // Provide the controller with a way to trigger layouts.
                ctrl.layoutDelegate = layoutDelegate;

                var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
                    unwatchAttrs = watchMedia();
                scope.$on('$destroy', unwatchMedia);

                /**
                 * Watches for changes in media, invalidating layout as necessary.
                 */
                function watchMedia() {
                    for (var mediaName in $mdConstant.MEDIA) {
                        $mdMedia(mediaName); // initialize
                        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
                            .addListener(invalidateLayout);
                    }
                    return $mdMedia.watchResponsiveAttributes(
                        ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
                }

                function unwatchMedia() {
                    ctrl.layoutDelegate = angular.noop;

                    unwatchAttrs();
                    for (var mediaName in $mdConstant.MEDIA) {
                        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
                            .removeListener(invalidateLayout);
                    }
                }

                /**
                 * Performs grid layout if the provided mediaName matches the currently
                 * active media type.
                 */
                function layoutIfMediaMatch(mediaName) {
                    if (mediaName == null) {
                        // TODO(shyndman): It would be nice to only layout if we have
                        // instances of attributes using this media type
                        ctrl.invalidateLayout();
                    } else if ($mdMedia(mediaName)) {
                        ctrl.invalidateLayout();
                    }
                }

                var lastLayoutProps;

                /**
                 * Invokes the layout engine, and uses its results to lay out our
                 * tile elements.
                 *
                 * @param {boolean} tilesInvalidated Whether tiles have been
                 *    added/removed/moved since the last layout. This is to avoid situations
                 *    where tiles are replaced with properties identical to their removed
                 *    counterparts.
                 */
                function layoutDelegate(tilesInvalidated) {
                    var tiles = getTileElements();
                    var props = {
                        tileSpans: getTileSpans(tiles),
                        colCount: getColumnCount(),
                        rowMode: getRowMode(),
                        rowHeight: getRowHeight(),
                        gutter: getGutter()
                    };

                    if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
                        return;
                    }

                    var performance =
                        $mdGridLayout(props.colCount, props.tileSpans, tiles)
                            .map(function (tilePositions, rowCount) {
                                return {
                                    grid: {
                                        element: element,
                                        style: getGridStyle(props.colCount, rowCount,
                                            props.gutter, props.rowMode, props.rowHeight)
                                    },
                                    tiles: tilePositions.map(function (ps, i) {
                                        return {
                                            element: angular.element(tiles[i]),
                                            style: getTileStyle(ps.position, ps.spans,
                                                props.colCount, rowCount,
                                                props.gutter, props.rowMode, props.rowHeight)
                                        }
                                    })
                                }
                            })
                            .reflow()
                            .performance();

                    // Report layout
                    scope.mdOnLayout({
                        $event: {
                            performance: performance
                        }
                    });

                    lastLayoutProps = props;
                }

                // Use $interpolate to do some simple string interpolation as a convenience.

                var startSymbol = $interpolate.startSymbol();
                var endSymbol = $interpolate.endSymbol();

                // Returns an expression wrapped in the interpolator's start and end symbols.
                function expr(exprStr) {
                    return startSymbol + exprStr + endSymbol;
                }

                // The amount of space a single 1x1 tile would take up (either width or height), used as
                // a basis for other calculations. This consists of taking the base size percent (as would be
                // if evenly dividing the size between cells), and then subtracting the size of one gutter.
                // However, since there are no gutters on the edges, each tile only uses a fration
                // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
                // tile, and then breaking up the extra gutter on the edge evenly among the cells).
                var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');

                // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
                // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
                // row/column (offset).
                var POSITION = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');

                // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
                // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
                // in the space that the gutter would normally have used (which was already accounted for in
                // the base unit calculation).
                var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');

                /**
                 * Gets the styles applied to a tile element described by the given parameters.
                 * @param {{row: number, col: number}} position The row and column indices of the tile.
                 * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
                 * @param {number} colCount The number of columns.
                 * @param {number} rowCount The number of rows.
                 * @param {string} gutter The amount of space between tiles. This will be something like
                 *     '5px' or '2em'.
                 * @param {string} rowMode The row height mode. Can be one of:
                 *     'fixed': all rows have a fixed size, given by rowHeight,
                 *     'ratio': row height defined as a ratio to width, or
                 *     'fit': fit to the grid-list element height, divinding evenly among rows.
                 * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
                 *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
                 * @returns {Object} Map of CSS properties to be applied to the style element. Will define
                 *     values for top, left, width, height, marginTop, and paddingTop.
                 */
                function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
                    // TODO(shyndman): There are style caching opportunities here.

                    // Percent of the available horizontal space that one column takes up.
                    var hShare = (1 / colCount) * 100;

                    // Fraction of the gutter size that each column takes up.
                    var hGutterShare = (colCount - 1) / colCount;

                    // Base horizontal size of a column.
                    var hUnit = UNIT({ share: hShare, gutterShare: hGutterShare, gutter: gutter });

                    // The width and horizontal position of each tile is always calculated the same way, but the
                    // height and vertical position depends on the rowMode.
                    var style = {
                        left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
                        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
                        // resets
                        paddingTop: '',
                        marginTop: '',
                        top: '',
                        height: ''
                    };

                    switch (rowMode) {
                        case 'fixed':
                            // In fixed mode, simply use the given rowHeight.
                            style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
                            style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
                            break;

                        case 'ratio':
                            // Percent of the available vertical space that one row takes up. Here, rowHeight holds
                            // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
                            var vShare = hShare / rowHeight;

                            // Base veritcal size of a row.
                            var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

                            // padidngTop and marginTop are used to maintain the given aspect ratio, as
                            // a percentage-based value for these properties is applied to the *width* of the
                            // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
                            style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter });
                            style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
                            break;

                        case 'fit':
                            // Fraction of the gutter size that each column takes up.
                            var vGutterShare = (rowCount - 1) / rowCount;

                            // Percent of the available vertical space that one row takes up.
                            var vShare = (1 / rowCount) * 100;

                            // Base vertical size of a row.
                            var vUnit = UNIT({ share: vShare, gutterShare: vGutterShare, gutter: gutter });

                            style.top = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
                            style.height = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter });
                            break;
                    }

                    return style;
                }

                function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
                    var style = {};

                    switch (rowMode) {
                        case 'fixed':
                            style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
                            style.paddingBottom = '';
                            break;

                        case 'ratio':
                            // rowHeight is width / height
                            var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
                                hShare = (1 / colCount) * 100,
                                vShare = hShare * (1 / rowHeight),
                                vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

                            style.height = '';
                            style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter });
                            break;

                        case 'fit':
                            // noop, as the height is user set
                            break;
                    }

                    return style;
                }

                function getTileElements() {
                    return [].filter.call(element.children(), function (ele) {
                        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
                    });
                }

                /**
                 * Gets an array of objects containing the rowspan and colspan for each tile.
                 * @returns {Array<{row: number, col: number}>}
                 */
                function getTileSpans(tileElements) {
                    return [].map.call(tileElements, function (ele) {
                        var ctrl = angular.element(ele).controller('mdGridTile');
                        return {
                            row: parseInt(
                                $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
                            col: parseInt(
                                $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
                        };
                    });
                }

                function getColumnCount() {
                    var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
                    if (isNaN(colCount)) {
                        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
                    }
                    return colCount;
                }

                function getGutter() {
                    return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
                }

                function getRowHeight() {
                    var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
                    if (!rowHeight) {
                        throw 'md-grid-list: md-row-height attribute was not found';
                    }

                    switch (getRowMode()) {
                        case 'fixed':
                            return applyDefaultUnit(rowHeight);
                        case 'ratio':
                            var whRatio = rowHeight.split(':');
                            return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
                        case 'fit':
                            return 0; // N/A
                    }
                }

                function getRowMode() {
                    var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
                    if (!rowHeight) {
                        throw 'md-grid-list: md-row-height attribute was not found';
                    }

                    if (rowHeight == 'fit') {
                        return 'fit';
                    } else if (rowHeight.indexOf(':') !== -1) {
                        return 'ratio';
                    } else {
                        return 'fixed';
                    }
                }

                function applyDefaultUnit(val) {
                    return /\D$/.test(val) ? val : val + 'px';
                }
            }
        }
        GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];

        /* @ngInject */
        function GridListController($mdUtil) {
            this.layoutInvalidated = false;
            this.tilesInvalidated = false;
            this.$timeout_ = $mdUtil.nextTick;
            this.layoutDelegate = angular.noop;
        }
        GridListController.$inject = ["$mdUtil"];

        GridListController.prototype = {
            invalidateTiles: function () {
                this.tilesInvalidated = true;
                this.invalidateLayout();
            },

            invalidateLayout: function () {
                if (this.layoutInvalidated) {
                    return;
                }
                this.layoutInvalidated = true;
                this.$timeout_(angular.bind(this, this.layout));
            },

            layout: function () {
                try {
                    this.layoutDelegate(this.tilesInvalidated);
                } finally {
                    this.layoutInvalidated = false;
                    this.tilesInvalidated = false;
                }
            }
        };


        /* @ngInject */
        function GridLayoutFactory($mdUtil) {
            var defaultAnimator = GridTileAnimator;

            /**
             * Set the reflow animator callback
             */
            GridLayout.animateWith = function (customAnimator) {
                defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
            };

            return GridLayout;

            /**
             * Publish layout function
             */
            function GridLayout(colCount, tileSpans) {
                var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;

                layoutTime = $mdUtil.time(function () {
                    layoutInfo = calculateGridFor(colCount, tileSpans);
                });

                return self = {

                    /**
                     * An array of objects describing each tile's position in the grid.
                     */
                    layoutInfo: function () {
                        return layoutInfo;
                    },

                    /**
                     * Maps grid positioning to an element and a set of styles using the
                     * provided updateFn.
                     */
                    map: function (updateFn) {
                        mapTime = $mdUtil.time(function () {
                            var info = self.layoutInfo();
                            gridStyles = updateFn(info.positioning, info.rowCount);
                        });
                        return self;
                    },

                    /**
                     * Default animator simply sets the element.css( <styles> ). An alternate
                     * animator can be provided as an argument. The function has the following
                     * signature:
                     *
                     *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
                     */
                    reflow: function (animatorFn) {
                        reflowTime = $mdUtil.time(function () {
                            var animator = animatorFn || defaultAnimator;
                            animator(gridStyles.grid, gridStyles.tiles);
                        });
                        return self;
                    },

                    /**
                     * Timing for the most recent layout run.
                     */
                    performance: function () {
                        return {
                            tileCount: tileSpans.length,
                            layoutTime: layoutTime,
                            mapTime: mapTime,
                            reflowTime: reflowTime,
                            totalTime: layoutTime + mapTime + reflowTime
                        };
                    }
                };
            }

            /**
             * Default Gridlist animator simple sets the css for each element;
             * NOTE: any transitions effects must be manually set in the CSS.
             * e.g.
             *
             *  md-grid-tile {
             *    transition: all 700ms ease-out 50ms;
             *  }
             *
             */
            function GridTileAnimator(grid, tiles) {
                grid.element.css(grid.style);
                tiles.forEach(function (t) {
                    t.element.css(t.style);
                })
            }

            /**
             * Calculates the positions of tiles.
             *
             * The algorithm works as follows:
             *    An Array<Number> with length colCount (spaceTracker) keeps track of
             *    available tiling positions, where elements of value 0 represents an
             *    empty position. Space for a tile is reserved by finding a sequence of
             *    0s with length <= than the tile's colspan. When such a space has been
             *    found, the occupied tile positions are incremented by the tile's
             *    rowspan value, as these positions have become unavailable for that
             *    many rows.
             *
             *    If the end of a row has been reached without finding space for the
             *    tile, spaceTracker's elements are each decremented by 1 to a minimum
             *    of 0. Rows are searched in this fashion until space is found.
             */
            function calculateGridFor(colCount, tileSpans) {
                var curCol = 0,
                    curRow = 0,
                    spaceTracker = newSpaceTracker();

                return {
                    positioning: tileSpans.map(function (spans, i) {
                        return {
                            spans: spans,
                            position: reserveSpace(spans, i)
                        };
                    }),
                    rowCount: curRow + Math.max.apply(Math, spaceTracker)
                };

                function reserveSpace(spans, i) {
                    if (spans.col > colCount) {
                        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
                        '(' + spans.col + ') that exceeds the column count ' +
                        '(' + colCount + ')';
                    }

                    var start = 0,
                        end = 0;

                    // TODO(shyndman): This loop isn't strictly necessary if you can
                    // determine the minimum number of rows before a space opens up. To do
                    // this, recognize that you've iterated across an entire row looking for
                    // space, and if so fast-forward by the minimum rowSpan count. Repeat
                    // until the required space opens up.
                    while (end - start < spans.col) {
                        if (curCol >= colCount) {
                            nextRow();
                            continue;
                        }

                        start = spaceTracker.indexOf(0, curCol);
                        if (start === -1 || (end = findEnd(start + 1)) === -1) {
                            start = end = 0;
                            nextRow();
                            continue;
                        }

                        curCol = end + 1;
                    }

                    adjustRow(start, spans.col, spans.row);
                    curCol = start + spans.col;

                    return {
                        col: start,
                        row: curRow
                    };
                }

                function nextRow() {
                    curCol = 0;
                    curRow++;
                    adjustRow(0, colCount, -1); // Decrement row spans by one
                }

                function adjustRow(from, cols, by) {
                    for (var i = from; i < from + cols; i++) {
                        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
                    }
                }

                function findEnd(start) {
                    var i;
                    for (i = start; i < spaceTracker.length; i++) {
                        if (spaceTracker[i] !== 0) {
                            return i;
                        }
                    }

                    if (i === spaceTracker.length) {
                        return i;
                    }
                }

                function newSpaceTracker() {
                    var tracker = [];
                    for (var i = 0; i < colCount; i++) {
                        tracker.push(0);
                    }
                    return tracker;
                }
            }
        }
        GridLayoutFactory.$inject = ["$mdUtil"];

        /**
         * @ngdoc directive
         * @name mdGridTile
         * @module material.components.gridList
         * @restrict E
         * @description
         * Tiles contain the content of an `md-grid-list`. They span one or more grid
         * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
         * display secondary content.
         *
         * ### Responsive Attributes
         *
         * The `md-grid-tile` directive supports "responsive" attributes, which allow
         * different `md-rowspan` and `md-colspan` values depending on the currently
         * matching media query.
         *
         * In order to set a responsive attribute, first define the fallback value with
         * the standard attribute name, then add additional attributes with the
         * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
         * (ie. `md-colspan-sm="4"`)
         *
         * @param {number=} md-colspan The number of columns to span (default 1). Cannot
         *    exceed the number of columns in the grid. Supports interpolation.
         * @param {number=} md-rowspan The number of rows to span (default 1). Supports
         *     interpolation.
         *
         * @usage
         * With header:
         * <hljs lang="html">
         * <md-grid-tile>
         *   <md-grid-tile-header>
         *     <h3>This is a header</h3>
         *   </md-grid-tile-header>
         * </md-grid-tile>
         * </hljs>
         *
         * With footer:
         * <hljs lang="html">
         * <md-grid-tile>
         *   <md-grid-tile-footer>
         *     <h3>This is a footer</h3>
         *   </md-grid-tile-footer>
         * </md-grid-tile>
         * </hljs>
         *
         * Spanning multiple rows/columns:
         * <hljs lang="html">
         * <md-grid-tile md-colspan="2" md-rowspan="3">
         * </md-grid-tile>
         * </hljs>
         *
         * Responsive attributes:
         * <hljs lang="html">
         * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
         * </md-grid-tile>
         * </hljs>
         */
        function GridTileDirective($mdMedia) {
            return {
                restrict: 'E',
                require: '^mdGridList',
                template: '<figure ng-transclude></figure>',
                transclude: true,
                scope: {},
                // Simple controller that exposes attributes to the grid directive
                controller: ["$attrs", function ($attrs) {
                    this.$attrs = $attrs;
                }],
                link: postLink
            };

            function postLink(scope, element, attrs, gridCtrl) {
                // Apply semantics
                element.attr('role', 'listitem');

                // If our colspan or rowspan changes, trigger a layout
                var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
                    attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));

                // Tile registration/deregistration
                gridCtrl.invalidateTiles();
                scope.$on('$destroy', function () {
                    // Mark the tile as destroyed so it is no longer considered in layout,
                    // even if the DOM element sticks around (like during a leave animation)
                    element[0].$$mdDestroyed = true;
                    unwatchAttrs();
                    gridCtrl.invalidateLayout();
                });

                if (angular.isDefined(scope.$parent.$index)) {
                    scope.$watch(function () { return scope.$parent.$index; },
                        function indexChanged(newIdx, oldIdx) {
                            if (newIdx === oldIdx) {
                                return;
                            }
                            gridCtrl.invalidateTiles();
                        });
                }
            }
        }
        GridTileDirective.$inject = ["$mdMedia"];


        function GridTileCaptionDirective() {
            return {
                template: '<figcaption ng-transclude></figcaption>',
                transclude: true
            };
        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.icon
         * @description
         * Icon
         */
        angular.module('material.components.icon', ['material.core']);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.input
         */

        angular.module('material.components.input', [
            'material.core'
        ])
            .directive('mdInputContainer', mdInputContainerDirective)
            .directive('label', labelDirective)
            .directive('input', inputTextareaDirective)
            .directive('textarea', inputTextareaDirective)
            .directive('mdMaxlength', mdMaxlengthDirective)
            .directive('placeholder', placeholderDirective)
            .directive('ngMessages', ngMessagesDirective)
            .directive('ngMessage', ngMessageDirective)
            .directive('ngMessageExp', ngMessageDirective)
            .directive('mdSelectOnFocus', mdSelectOnFocusDirective)

            .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
            .animation('.md-input-messages-animation', ngMessagesAnimation)
            .animation('.md-input-message-animation', ngMessageAnimation);

        /**
         * @ngdoc directive
         * @name mdInputContainer
         * @module material.components.input
         *
         * @restrict E
         *
         * @description
         * `<md-input-container>` is the parent of any input or textarea element.
         *
         * Input and textarea elements will not behave properly unless the md-input-container
         * parent is provided.
         *
         * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
         *
         * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
         * you may combine these with other inputs.
         *
         * @param md-is-error {expression=} When the given expression evaluates to true, the input container
         *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
         * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
         *   labels.
         *
         * @usage
         * <hljs lang="html">
         *
         * <md-input-container>
         *   <label>Username</label>
         *   <input type="text" ng-model="user.name">
         * </md-input-container>
         *
         * <md-input-container>
         *   <label>Description</label>
         *   <textarea ng-model="user.description"></textarea>
         * </md-input-container>
         *
         * </hljs>
         *
         * <h3>When disabling floating labels</h3>
         * <hljs lang="html">
         *
         * <md-input-container md-no-float>
         *   <input type="text" placeholder="Non-Floating Label">
         * </md-input-container>
         *
         * </hljs>
         */
        function mdInputContainerDirective($mdTheming, $parse) {

            var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];

            var LEFT_SELECTORS = INPUT_TAGS.reduce(function (selectors, isel) {
                return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
            }, []).join(",");

            var RIGHT_SELECTORS = INPUT_TAGS.reduce(function (selectors, isel) {
                return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
            }, []).join(",");


            ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
            return {
                restrict: 'E',
                link: postLink,
                controller: ContainerCtrl
            };

            function postLink(scope, element) {
                $mdTheming(element);

                // Check for both a left & right icon
                var leftIcon = element[0].querySelector(LEFT_SELECTORS);
                var rightIcon = element[0].querySelector(RIGHT_SELECTORS);

                if (leftIcon) { element.addClass('md-icon-left'); }
                if (rightIcon) { element.addClass('md-icon-right'); }
            }

            function ContainerCtrl($scope, $element, $attrs, $animate) {
                var self = this;

                self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

                self.delegateClick = function () {
                    self.input.focus();
                };
                self.element = $element;
                self.setFocused = function (isFocused) {
                    $element.toggleClass('md-input-focused', !!isFocused);
                };
                self.setHasValue = function (hasValue) {
                    $element.toggleClass('md-input-has-value', !!hasValue);
                };
                self.setHasPlaceholder = function (hasPlaceholder) {
                    $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
                };
                self.setInvalid = function (isInvalid) {
                    if (isInvalid) {
                        $animate.addClass($element, 'md-input-invalid');
                    } else {
                        $animate.removeClass($element, 'md-input-invalid');
                    }
                };
                $scope.$watch(function () {
                    return self.label && self.input;
                }, function (hasLabelAndInput) {
                    if (hasLabelAndInput && !self.label.attr('for')) {
                        self.label.attr('for', self.input.attr('id'));
                    }
                });
            }
        }
        mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];

        function labelDirective() {
            return {
                restrict: 'E',
                require: '^?mdInputContainer',
                link: function (scope, element, attr, containerCtrl) {
                    if (!containerCtrl || attr.mdNoFloat || element.hasClass('_md-container-ignore')) return;

                    containerCtrl.label = element;
                    scope.$on('$destroy', function () {
                        containerCtrl.label = null;
                    });
                }
            };
        }

        /**
         * @ngdoc directive
         * @name mdInput
         * @restrict E
         * @module material.components.input
         *
         * @description
         * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
         * allows you to build complex forms for data entry.
         *
         * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
         *   specified, a character counter will be shown underneath the input.<br/><br/>
         *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
         *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
         *   or maxlength attributes.<br/><br/>
         *   **Note:** Only valid for text/string inputs (not numeric).
         *
         * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
         *   will be logged in the console if not present.
         * @param {string=} placeholder An alternative approach to using aria-label when the label is not
         *   PRESENT. The placeholder text is copied to the aria-label attribute.
         * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
         * @param md-no-asterisk {boolean=} When present, asterisk will not be appended to required inputs label
         * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
         *   revealed after being hidden. This is off by default for performance reasons because it
         *   guarantees a reflow every digest cycle.
         *
         * @usage
         * <hljs lang="html">
         * <md-input-container>
         *   <label>Color</label>
         *   <input type="text" ng-model="color" required md-maxlength="10">
         * </md-input-container>
         * </hljs>
         *
         * <h3>With Errors</h3>
         *
         * `md-input-container` also supports errors using the standard `ng-messages` directives and
         * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
         * the `ngShow`/`ngHide` events.
         *
         * By default, the messages will be hidden until the input is in an error state. This is based off
         * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
         * fill out the form before the errors become visible.
         *
         * <hljs lang="html">
         * <form name="colorForm">
         *   <md-input-container>
         *     <label>Favorite Color</label>
         *     <input name="favoriteColor" ng-model="favoriteColor" required>
         *     <div ng-messages="userForm.lastName.$error">
         *       <div ng-message="required">This is required!</div>
         *     </div>
         *   </md-input-container>
         * </form>
         * </hljs>
         *
         * We automatically disable this auto-hiding functionality if you provide any of the following
         * visibility directives on the `ng-messages` container:
         *
         *  - `ng-if`
         *  - `ng-show`/`ng-hide`
         *  - `ng-switch-when`/`ng-switch-default`
         *
         * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
         * to the `ng-messages` container. This may be helpful if you always want to see the error messages
         * or if you are building your own visibilty directive.
         *
         * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
         * initialization of the `ng-messages` directive to see if it equals the string `false`._
         *
         * <hljs lang="html">
         * <form name="userForm">
         *   <md-input-container>
         *     <label>Last Name</label>
         *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
         *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
         *       <div ng-message="required">This is required!</div>
         *       <div ng-message="md-maxlength">That's too long!</div>
         *       <div ng-message="minlength">That's too short!</div>
         *     </div>
         *   </md-input-container>
         *   <md-input-container>
         *     <label>Biography</label>
         *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
         *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
         *       <div ng-message="required">This is required!</div>
         *       <div ng-message="md-maxlength">That's too long!</div>
         *     </div>
         *   </md-input-container>
         *   <md-input-container>
         *     <input aria-label='title' ng-model='title'>
         *   </md-input-container>
         *   <md-input-container>
         *     <input placeholder='title' ng-model='title'>
         *   </md-input-container>
         * </form>
         * </hljs>
         *
         * <h3>Notes</h3>
         *
         * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
         * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
         *
         * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
         * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
         * `<md-input-container>` tags. Instead, use relative or absolute positioning.
         *
         */

        function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout) {
            return {
                restrict: 'E',
                require: ['^?mdInputContainer', '?ngModel'],
                link: postLink
            };

            function postLink(scope, element, attr, ctrls) {

                var containerCtrl = ctrls[0];
                var hasNgModel = !!ctrls[1];
                var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
                var isReadonly = angular.isDefined(attr.readonly);
                var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);


                if (!containerCtrl) return;
                if (attr.type === 'hidden') {
                    element.attr('aria-hidden', 'true');
                    return;
                } else if (containerCtrl.input) {
                    throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
                }
                containerCtrl.input = element;

                setupAttributeWatchers();

                // Add an error spacer div after our input to provide space for the char counter and any ng-messages
                var errorsSpacer = angular.element('<div class="md-errors-spacer">');
                element.after(errorsSpacer);

                if (!containerCtrl.label) {
                    $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
                }

                element.addClass('md-input');
                if (!element.attr('id')) {
                    element.attr('id', 'input_' + $mdUtil.nextUid());
                }

                if (element[0].tagName.toLowerCase() === 'textarea') {
                    setupTextarea();
                }

                // If the input doesn't have an ngModel, it may have a static value. For that case,
                // we have to do one initial check to determine if the container should be in the
                // "has a value" state.
                if (!hasNgModel) {
                    inputCheckValue();
                }

                var isErrorGetter = containerCtrl.isErrorGetter || function () {
                    return ngModelCtrl.$invalid && (ngModelCtrl.$touched || isParentFormSubmitted());
                };

                var isParentFormSubmitted = function () {
                    var parent = $mdUtil.getClosest(element, 'form');
                    var form = parent ? angular.element(parent).controller('form') : null;

                    return form ? form.$submitted : false;
                };

                scope.$watch(isErrorGetter, containerCtrl.setInvalid);

                ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
                ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

                element.on('input', inputCheckValue);

                if (!isReadonly) {
                    element
                        .on('focus', function (ev) {
                            $mdUtil.nextTick(function () {
                                containerCtrl.setFocused(true);
                            });
                        })
                        .on('blur', function (ev) {
                            $mdUtil.nextTick(function () {
                                containerCtrl.setFocused(false);
                                inputCheckValue();
                            });
                        });
                }

                //ngModelCtrl.$setTouched();
                //if( ngModelCtrl.$invalid ) containerCtrl.setInvalid();

                scope.$on('$destroy', function () {
                    containerCtrl.setFocused(false);
                    containerCtrl.setHasValue(false);
                    containerCtrl.input = null;
                });

                /**
                 *
                 */
                function ngModelPipelineCheckValue(arg) {
                    containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                    return arg;
                }

                function setupAttributeWatchers() {
                    if (containerCtrl.label) {
                        attr.$observe('required', function (value) {
                            // We don't need to parse the required value, it's always a boolean because of angular's
                            // required directive.
                            containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
                        });
                    }
                }

                function inputCheckValue() {
                    // An input's value counts if its length > 0,
                    // or if the input's validity state says it has bad input (eg string in a number input)
                    containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
                }

                function setupTextarea() {
                    if (attr.hasOwnProperty('mdNoAutogrow')) {
                        return;
                    }

                    // Can't check if height was or not explicity set,
                    // so rows attribute will take precedence if present
                    var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
                    var lineHeight = null;
                    var node = element[0];

                    // This timeout is necessary, because the browser needs a little bit
                    // of time to calculate the `clientHeight` and `scrollHeight`.
                    $timeout(function () {
                        $mdUtil.nextTick(growTextarea);
                    }, 10, false);

                    // We can hook into Angular's pipeline, instead of registering a new listener.
                    // Note that we should use `$parsers`, as opposed to `$viewChangeListeners` which
                    // was used before, because `$viewChangeListeners` don't fire if the input is
                    // invalid.
                    if (hasNgModel) {
                        ngModelCtrl.$formatters.unshift(pipelineListener);
                        ngModelCtrl.$parsers.unshift(pipelineListener);
                    } else {
                        // Note that it's safe to use the `input` event since we're not supporting IE9 and below.
                        element.on('input', growTextarea);
                    }

                    if (!minRows) {
                        element
                            .attr('rows', 1)
                            .on('scroll', onScroll);
                    }

                    angular.element($window).on('resize', growTextarea);

                    scope.$on('$destroy', function () {
                        angular.element($window).off('resize', growTextarea);
                    });

                    function growTextarea() {
                        // temporarily disables element's flex so its height 'runs free'
                        element
                            .addClass('md-no-flex')
                            .attr('rows', 1);

                        if (minRows) {
                            if (!lineHeight) {
                                node.style.minHeight = 0;
                                lineHeight = element.prop('clientHeight');
                                node.style.minHeight = null;
                            }

                            var newRows = Math.round(Math.round(getHeight() / lineHeight));
                            var rowsToSet = Math.max(newRows, minRows);

                            element
                                .css('height', lineHeight * rowsToSet + 'px')
                                .attr('rows', rowsToSet)
                                .toggleClass('_md-textarea-scrollable', newRows >= minRows);

                        } else {
                            element.css('height', 'auto');
                            node.scrollTop = 0;
                            var height = getHeight();
                            if (height) element.css('height', height + 'px');
                        }

                        element.removeClass('md-no-flex');
                    }

                    function getHeight() {
                        var offsetHeight = node.offsetHeight;
                        var line = node.scrollHeight - offsetHeight;
                        return offsetHeight + (line > 0 ? line : 0);
                    }

                    function onScroll(e) {
                        node.scrollTop = 0;
                        // for smooth new line adding
                        var line = node.scrollHeight - node.offsetHeight;
                        var height = node.offsetHeight + line;
                        node.style.height = height + 'px';
                    }

                    function pipelineListener(value) {
                        growTextarea();
                        return value;
                    }

                    // Attach a watcher to detect when the textarea gets shown.
                    if (attr.hasOwnProperty('mdDetectHidden')) {

                        var handleHiddenChange = function () {
                            var wasHidden = false;

                            return function () {
                                var isHidden = node.offsetHeight === 0;

                                if (isHidden === false && wasHidden === true) {
                                    growTextarea();
                                }

                                wasHidden = isHidden;
                            };
                        }();

                        // Check every digest cycle whether the visibility of the textarea has changed.
                        // Queue up to run after the digest cycle is complete.
                        scope.$watch(function () {
                            $mdUtil.nextTick(handleHiddenChange, false);
                            return true;
                        });
                    }
                }
            }
        }
        inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout"];

        function mdMaxlengthDirective($animate, $mdUtil) {
            return {
                restrict: 'A',
                require: ['ngModel', '^mdInputContainer'],
                link: postLink
            };

            function postLink(scope, element, attr, ctrls) {
                var maxlength;
                var ngModelCtrl = ctrls[0];
                var containerCtrl = ctrls[1];
                var charCountEl, errorsSpacer;

                // Wait until the next tick to ensure that the input has setup the errors spacer where we will
                // append our counter
                $mdUtil.nextTick(function () {
                    errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
                    charCountEl = angular.element('<div class="md-char-counter">');

                    // Append our character counter inside the errors spacer
                    errorsSpacer.append(charCountEl);

                    // Stop model from trimming. This makes it so whitespace
                    // over the maxlength still counts as invalid.
                    attr.$set('ngTrim', 'false');

                    ngModelCtrl.$formatters.push(renderCharCount);
                    ngModelCtrl.$viewChangeListeners.push(renderCharCount);
                    element.on('input keydown keyup', function () {
                        renderCharCount(); //make sure it's called with no args
                    });

                    scope.$watch(attr.mdMaxlength, function (value) {
                        maxlength = value;
                        if (angular.isNumber(value) && value > 0) {
                            if (!charCountEl.parent().length) {
                                $animate.enter(charCountEl, errorsSpacer);
                            }
                            renderCharCount();
                        } else {
                            $animate.leave(charCountEl);
                        }
                    });

                    ngModelCtrl.$validators['md-maxlength'] = function (modelValue, viewValue) {
                        if (!angular.isNumber(maxlength) || maxlength < 0) {
                            return true;
                        }
                        return (modelValue || element.val() || viewValue || '').length <= maxlength;
                    };
                });

                function renderCharCount(value) {
                    // If we have not been appended to the body yet; do not render
                    if (!charCountEl.parent) {
                        return value;
                    }

                    // Force the value into a string since it may be a number,
                    // which does not have a length property.
                    charCountEl.text(String(element.val() || value || '').length + '/' + maxlength);
                    return value;
                }
            }
        }
        mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];

        function placeholderDirective($log) {
            return {
                restrict: 'A',
                require: '^^?mdInputContainer',
                priority: 200,
                link: postLink
            };

            function postLink(scope, element, attr, inputContainer) {
                // If there is no input container, just return
                if (!inputContainer) return;

                var label = inputContainer.element.find('label');
                var hasNoFloat = angular.isDefined(inputContainer.element.attr('md-no-float'));

                // If we have a label, or they specify the md-no-float attribute, just return
                if ((label && label.length) || hasNoFloat) {
                    // Add a placeholder class so we can target it in the CSS
                    inputContainer.setHasPlaceholder(true);
                    return;
                }

                // Otherwise, grab/remove the placeholder
                var placeholderText = attr.placeholder;
                element.removeAttr('placeholder');

                // And add the placeholder text as a separate label
                if (inputContainer.input && inputContainer.input[0].nodeName != 'MD-SELECT') {
                    var placeholder = '<label ng-click="delegateClick()">' + placeholderText + '</label>';

                    inputContainer.element.addClass('md-icon-float');
                    inputContainer.element.prepend(placeholder);
                }
            }
        }
        placeholderDirective.$inject = ["$log"];

        /**
         * @ngdoc directive
         * @name mdSelectOnFocus
         * @module material.components.input
         *
         * @restrict A
         *
         * @description
         * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
         *
         * <h3>Notes</h3>
         * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
         *
         * @usage
         * <h3>Using with an Input</h3>
         * <hljs lang="html">
         *
         * <md-input-container>
         *   <label>Auto Select</label>
         *   <input type="text" md-select-on-focus>
         * </md-input-container>
         * </hljs>
         *
         * <h3>Using with a Textarea</h3>
         * <hljs lang="html">
         *
         * <md-input-container>
         *   <label>Auto Select</label>
         *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
         * </md-input-container>
         *
         * </hljs>
         */
        function mdSelectOnFocusDirective($timeout) {

            return {
                restrict: 'A',
                link: postLink
            };

            function postLink(scope, element, attr) {
                if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;

                var preventMouseUp = false;

                element
                    .on('focus', onFocus)
                    .on('mouseup', onMouseUp);

                scope.$on('$destroy', function () {
                    element
                        .off('focus', onFocus)
                        .off('mouseup', onMouseUp);
                });

                function onFocus() {
                    preventMouseUp = true;

                    $timeout(function () {
                        // Use HTMLInputElement#select to fix firefox select issues.
                        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
                        element[0].select();

                        // This should be reset from inside the `focus`, because the event might
                        // have originated from something different than a click, e.g. a keyboard event.
                        preventMouseUp = false;
                    }, 1, false);
                }

                // Prevents the default action of the first `mouseup` after a focus.
                // This is necessary, because browsers fire a `mouseup` right after the element
                // has been focused. In some browsers (Firefox in particular) this can clear the
                // selection. There are examples of the problem in issue #7487.
                function onMouseUp(event) {
                    if (preventMouseUp) {
                        event.preventDefault();
                    }
                }
            }
        }
        mdSelectOnFocusDirective.$inject = ["$timeout"];

        var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];

        function ngMessagesDirective() {
            return {
                restrict: 'EA',
                link: postLink,

                // This is optional because we don't want target *all* ngMessage instances, just those inside of
                // mdInputContainer.
                require: '^^?mdInputContainer'
            };

            function postLink(scope, element, attrs, inputContainer) {
                // If we are not a child of an input container, don't do anything
                if (!inputContainer) return;

                // Add our animation class
                element.toggleClass('md-input-messages-animation', true);

                // Add our md-auto-hide class to automatically hide/show messages when container is invalid
                element.toggleClass('md-auto-hide', true);

                // If we see some known visibility directives, remove the md-auto-hide class
                if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
                    element.toggleClass('md-auto-hide', false);
                }
            }

            function hasVisibiltyDirective(attrs) {
                return visibilityDirectives.some(function (attr) {
                    return attrs[attr];
                });
            }
        }

        function ngMessageDirective($mdUtil) {
            return {
                restrict: 'EA',
                compile: compile,
                priority: 100
            };

            function compile(element) {
                var inputContainer = $mdUtil.getClosest(element, "md-input-container");

                // If we are not a child of an input container, don't do anything
                if (!inputContainer) return;

                // Add our animation class
                element.toggleClass('md-input-message-animation', true);

                return {};
            }
        }
        ngMessageDirective.$inject = ["$mdUtil"];

        function mdInputInvalidMessagesAnimation($q, $animateCss) {
            return {
                addClass: function (element, className, done) {
                    var messages = getMessagesElement(element);

                    if (className == "md-input-invalid" && messages.hasClass('md-auto-hide')) {
                        showInputMessages(element, $animateCss, $q).finally(done);
                    } else {
                        done();
                    }
                }

                // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
            };
        }
        mdInputInvalidMessagesAnimation.$inject = ["$q", "$animateCss"];

        function ngMessagesAnimation($q, $animateCss) {
            return {
                enter: function (element, done) {
                    showInputMessages(element, $animateCss, $q).finally(done);
                },

                leave: function (element, done) {
                    hideInputMessages(element, $animateCss, $q).finally(done);
                },

                addClass: function (element, className, done) {
                    if (className == "ng-hide") {
                        hideInputMessages(element, $animateCss, $q).finally(done);
                    } else {
                        done();
                    }
                },

                removeClass: function (element, className, done) {
                    if (className == "ng-hide") {
                        showInputMessages(element, $animateCss, $q).finally(done);
                    } else {
                        done();
                    }
                }
            }
        }
        ngMessagesAnimation.$inject = ["$q", "$animateCss"];

        function ngMessageAnimation($animateCss) {
            return {
                enter: function (element, done) {
                    var messages = getMessagesElement(element);

                    // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
                    if (messages.hasClass('md-auto-hide')) {
                        done();
                        return;
                    }

                    return showMessage(element, $animateCss);
                },

                leave: function (element, done) {
                    return hideMessage(element, $animateCss);
                }
            }
        }
        ngMessageAnimation.$inject = ["$animateCss"];

        function showInputMessages(element, $animateCss, $q) {
            var animators = [],
                animator;
            var messages = getMessagesElement(element);

            angular.forEach(messages.children(), function (child) {
                animator = showMessage(angular.element(child), $animateCss);

                animators.push(animator.start());
            });

            return $q.all(animators);
        }

        function hideInputMessages(element, $animateCss, $q) {
            var animators = [],
                animator;
            var messages = getMessagesElement(element);

            angular.forEach(messages.children(), function (child) {
                animator = hideMessage(angular.element(child), $animateCss);

                animators.push(animator.start());
            });

            return $q.all(animators);
        }

        function showMessage(element, $animateCss) {
            var height = element[0].offsetHeight;

            return $animateCss(element, {
                event: 'enter',
                structural: true,
                from: { "opacity": 0, "margin-top": -height + "px" },
                to: { "opacity": 1, "margin-top": "0" },
                duration: 0.3
            });
        }

        function hideMessage(element, $animateCss) {
            var height = element[0].offsetHeight;
            var styles = window.getComputedStyle(element[0]);

            // If we are already hidden, just return an empty animation
            if (styles.opacity == 0) {
                return $animateCss(element, {});
            }

            // Otherwise, animate
            return $animateCss(element, {
                event: 'leave',
                structural: true,
                from: { "opacity": 1, "margin-top": 0 },
                to: { "opacity": 0, "margin-top": -height + "px" },
                duration: 0.3
            });
        }

        function getInputElement(element) {
            var inputContainer = element.controller('mdInputContainer');

            return inputContainer.element;
        }

        function getMessagesElement(element) {
            var input = getInputElement(element);

            return angular.element(input[0].querySelector('.md-input-messages-animation'));
        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.list
         * @description
         * List module
         */
        angular.module('material.components.list', [
            'material.core'
        ])
            .controller('MdListController', MdListController)
            .directive('mdList', mdListDirective)
            .directive('mdListItem', mdListItemDirective);

        /**
         * @ngdoc directive
         * @name mdList
         * @module material.components.list
         *
         * @restrict E
         *
         * @description
         * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
         *
         * @usage
         * <hljs lang="html">
         * <md-list>
         *   <md-list-item class="md-2-line" ng-repeat="item in todos">
         *     <md-checkbox ng-model="item.done"></md-checkbox>
         *     <div class="md-list-item-text">
         *       <h3>{{item.title}}</h3>
         *       <p>{{item.description}}</p>
         *     </div>
         *   </md-list-item>
         * </md-list>
         * </hljs>
         */

        function mdListDirective($mdTheming) {
            return {
                restrict: 'E',
                compile: function (tEl) {
                    tEl[0].setAttribute('role', 'list');
                    return $mdTheming;
                }
            };
        }
        mdListDirective.$inject = ["$mdTheming"];
        /**
         * @ngdoc directive
         * @name mdListItem
         * @module material.components.list
         *
         * @restrict E
         *
         * @description
         * The `<md-list-item>` directive is a container intended for row items in a `<md-list>` container.
         * The `md-2-line` and `md-3-line` classes can be added to a `<md-list-item>`
         * to increase the height with 22px and 40px respectively.
         *
         * ## CSS
         * `.md-avatar` - class for image avatars
         *
         * `.md-avatar-icon` - class for icon avatars
         *
         * `.md-offset` - on content without an avatar
         *
         * @usage
         * <hljs lang="html">
         *  <md-list>
         *    <md-list-item>
         *      <img class="md-avatar" ng-src="path/to/img"/>
         *      <span>Item content in list</span>
         *    </md-list-item>
         *    <md-list-item>
         *      <md-icon class="md-avatar-icon" md-svg-icon="communication:phone"></md-icon>
         *      <span>Item content in list</span>
         *    </md-list-item>
         *  </md-list>
         * </hljs>
         *
         * _**Note:** We automatically apply special styling when the inner contents are wrapped inside
         * of a `<md-button>` tag. This styling is automatically ignored for `class="md-secondary"` buttons
         * and you can include a class of `class="md-exclude"` if you need to use a non-secondary button
         * that is inside the list, but does not wrap the contents._
         */
        function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
            var proxiedTypes = ['md-checkbox', 'md-switch'];
            return {
                restrict: 'E',
                controller: 'MdListController',
                compile: function (tEl, tAttrs) {

                    // Check for proxy controls (no ng-click on parent, and a control inside)
                    var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
                    var hasProxiedElement;
                    var proxyElement;
                    var itemContainer = tEl;

                    tEl[0].setAttribute('role', 'listitem');

                    if (tAttrs.ngClick || tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
                        wrapIn('button');
                    } else {
                        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
                            if (proxyElement = tEl[0].querySelector(type)) {
                                hasProxiedElement = true;
                                break;
                            }
                        }
                        if (hasProxiedElement) {
                            wrapIn('div');
                        } else if (!tEl[0].querySelector('md-button:not(.md-secondary):not(.md-exclude)')) {
                            tEl.addClass('_md-no-proxy');
                        }
                    }
                    wrapSecondaryItems();
                    setupToggleAria();


                    function setupToggleAria() {
                        var toggleTypes = ['md-switch', 'md-checkbox'];
                        var toggle;

                        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
                            if (toggle = tEl.find(toggleType)[0]) {
                                if (!toggle.hasAttribute('aria-label')) {
                                    var p = tEl.find('p')[0];
                                    if (!p) return;
                                    toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
                                }
                            }
                        }
                    }

                    function wrapIn(type) {
                        if (type == 'div') {
                            itemContainer = angular.element('<div class="_md-no-style _md-list-item-inner">');
                            itemContainer.append(tEl.contents());
                            tEl.addClass('_md-proxy-focus');
                        } else {
                            // Element which holds the default list-item content.
                            itemContainer = angular.element(
                                '<div class="md-button _md-no-style">' +
                                '   <div class="_md-list-item-inner"></div>' +
                                '</div>'
                            );

                            // Button which shows ripple and executes primary action.
                            var buttonWrap = angular.element(
                                '<md-button class="_md-no-style" md-no-focus-style></md-button>'
                            );

                            //buttonWrap[0].setAttribute('aria-label', tEl[0].textContent);
                            copyAttributes(tEl[0], buttonWrap[0]);

                            // Append the button wrap before our list-item content, because it will overlay in relative.
                            itemContainer.prepend(buttonWrap);
                            itemContainer.children().eq(1).append(tEl.contents());

                            tEl.addClass('_md-button-wrap');
                        }

                        tEl[0].setAttribute('tabindex', '-1');
                        tEl.append(itemContainer);
                    }

                    function wrapSecondaryItems() {
                        var secondaryItemsWrapper = angular.element('<div class="_md-secondary-container">');

                        angular.forEach(secondaryItems, function (secondaryItem) {
                            wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
                        });

                        // Since the secondary item container is static we need to fill the remaing space.
                        var spaceFiller = angular.element('<div class="flex"></div>');
                        itemContainer.append(spaceFiller);

                        itemContainer.append(secondaryItemsWrapper);
                    }

                    function wrapSecondaryItem(secondaryItem, container) {
                        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {
                            $mdAria.expect(secondaryItem, 'aria-label');
                            var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');
                            copyAttributes(secondaryItem, buttonWrapper[0]);
                            secondaryItem.setAttribute('tabindex', '-1');
                            buttonWrapper.append(secondaryItem);
                            secondaryItem = buttonWrapper[0];
                        }

                        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
                            // In this case we remove the secondary class, so we can identify it later, when we searching for the
                            // proxy items.
                            angular.element(secondaryItem).removeClass('md-secondary');
                        }

                        tEl.addClass('md-with-secondary');
                        container.append(secondaryItem);
                    }

                    function copyAttributes(item, wrapper) {
                        var copiedAttrs = ['ng-if', 'ng-click', 'aria-label', 'ng-disabled',
                            'ui-sref', 'href', 'ng-href', 'ng-attr-ui-sref', 'ui-sref-opts'
                        ];

                        angular.forEach(copiedAttrs, function (attr) {
                            if (item.hasAttribute(attr)) {
                                wrapper.setAttribute(attr, item.getAttribute(attr));
                                item.removeAttribute(attr);
                            }
                        });
                    }

                    function isProxiedElement(el) {
                        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
                    }

                    function isButton(el) {
                        var nodeName = el.nodeName.toUpperCase();

                        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
                    }

                    function hasClickEvent(element) {
                        var attr = element.attributes;
                        for (var i = 0; i < attr.length; i++) {
                            if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
                        }
                        return false;
                    }

                    return postLink;

                    function postLink($scope, $element, $attr, ctrl) {

                        var proxies = [],
                            firstElement = $element[0].firstElementChild,
                            isButtonWrap = $element.hasClass('_md-button-wrap'),
                            clickChild = isButtonWrap ? firstElement.firstElementChild : firstElement,
                            hasClick = clickChild && hasClickEvent(clickChild);

                        computeProxies();
                        computeClickable();

                        if ($element.hasClass('_md-proxy-focus') && proxies.length) {
                            angular.forEach(proxies, function (proxy) {
                                proxy = angular.element(proxy);

                                $scope.mouseActive = false;
                                proxy.on('mousedown', function () {
                                    $scope.mouseActive = true;
                                    $timeout(function () {
                                        $scope.mouseActive = false;
                                    }, 100);
                                })
                                    .on('focus', function () {
                                        if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
                                        proxy.on('blur', function proxyOnBlur() {
                                            $element.removeClass('md-focused');
                                            proxy.off('blur', proxyOnBlur);
                                        });
                                    });
                            });
                        }


                        function computeProxies() {
                            if (firstElement && firstElement.children && !hasClick) {

                                angular.forEach(proxiedTypes, function (type) {

                                    // All elements which are not capable for being used a proxy have the .md-secondary class
                                    // applied. These items had been sorted out in the secondary wrap function.
                                    angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function (child) {
                                        proxies.push(child);
                                    });
                                });

                            }
                        }

                        function computeClickable() {
                            if (proxies.length == 1 || hasClick) {
                                $element.addClass('md-clickable');

                                if (!hasClick) {
                                    ctrl.attachRipple($scope, angular.element($element[0].querySelector('._md-no-style')));
                                }
                            }
                        }

                        var clickChildKeypressListener = function (e) {
                            if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
                                var keyCode = e.which || e.keyCode;
                                if (keyCode == $mdConstant.KEY_CODE.SPACE) {
                                    if (clickChild) {
                                        clickChild.click();
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }
                            }
                        };

                        if (!hasClick && !proxies.length) {
                            clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
                        }

                        $element.off('click');
                        $element.off('keypress');

                        if (proxies.length == 1 && clickChild) {
                            $element.children().eq(0).on('click', function (e) {
                                var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
                                if (!parentButton && clickChild.contains(e.target)) {
                                    angular.forEach(proxies, function (proxy) {
                                        if (e.target !== proxy && !proxy.contains(e.target)) {
                                            angular.element(proxy).triggerHandler('click');
                                        }
                                    });
                                }
                            });
                        }

                        $scope.$on('$destroy', function () {
                            clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
                        });
                    }
                }
            };
        }
        mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];

        /*
         * @private
         * @ngdoc controller
         * @name MdListController
         * @module material.components.list
         *
         */
        function MdListController($scope, $element, $mdListInkRipple) {
            var ctrl = this;
            ctrl.attachRipple = attachRipple;

            function attachRipple(scope, element) {
                var options = {};
                $mdListInkRipple.attach(scope, element, options);
            }
        }
        MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];


    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.menu
         */

        angular.module('material.components.menu', [
            'material.core',
            'material.components.backdrop'
        ]);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.menu-bar
         */

        angular.module('material.components.menuBar', [
            'material.core',
            'material.components.menu'
        ]);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.progressCircular
         * @description Module for a circular progressbar
         */

        angular.module('material.components.progressCircular', ['material.core']);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.progressLinear
         * @description Linear Progress module!
         */
        angular.module('material.components.progressLinear', [
            'material.core'
        ])
            .directive('mdProgressLinear', MdProgressLinearDirective);

        /**
         * @ngdoc directive
         * @name mdProgressLinear
         * @module material.components.progressLinear
         * @restrict E
         *
         * @description
         * The linear progress directive is used to make loading content
         * in your app as delightful and painless as possible by minimizing
         * the amount of visual change a user sees before they can view
         * and interact with content.
         *
         * Each operation should only be represented by one activity indicator
         * For example: one refresh operation should not display both a
         * refresh bar and an activity circle.
         *
         * For operations where the percentage of the operation completed
         * can be determined, use a determinate indicator. They give users
         * a quick sense of how long an operation will take.
         *
         * For operations where the user is asked to wait a moment while
         * something finishes up, and it’s not necessary to expose what's
         * happening behind the scenes and how long it will take, use an
         * indeterminate indicator.
         *
         * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
         *
         * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
         * will be auto-applied as the mode.
         *
         * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
         * then `md-mode="determinate"` would be auto-injected instead.
         * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
         * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
         * @param {boolean=} ng-disabled Determines whether to disable the progress element.
         *
         * @usage
         * <hljs lang="html">
         * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
         *
         * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
         *
         * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
         *
         * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
         *
         * <md-progress-linear md-mode="query"></md-progress-linear>
         * </hljs>
         */
        function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
            var MODE_DETERMINATE = "determinate";
            var MODE_INDETERMINATE = "indeterminate";
            var MODE_BUFFER = "buffer";
            var MODE_QUERY = "query";
            var DISABLED_CLASS = "_md-progress-linear-disabled";

            return {
                restrict: 'E',
                template: '<div class="_md-container">' +
                    '<div class="_md-dashed"></div>' +
                    '<div class="_md-bar _md-bar1"></div>' +
                    '<div class="_md-bar _md-bar2"></div>' +
                    '</div>',
                compile: compile
            };

            function compile(tElement, tAttrs, transclude) {
                tElement.attr('aria-valuemin', 0);
                tElement.attr('aria-valuemax', 100);
                tElement.attr('role', 'progressbar');

                return postLink;
            }

            function postLink(scope, element, attr) {
                $mdTheming(element);

                var lastMode;
                var isDisabled = attr.hasOwnProperty('disabled');
                var toVendorCSS = $mdUtil.dom.animator.toCss;
                var bar1 = angular.element(element[0].querySelector('._md-bar1'));
                var bar2 = angular.element(element[0].querySelector('._md-bar2'));
                var container = angular.element(element[0].querySelector('._md-container'));

                element
                    .attr('md-mode', mode())
                    .toggleClass(DISABLED_CLASS, isDisabled);

                validateMode();
                watchAttributes();

                /**
                 * Watch the value, md-buffer-value, and md-mode attributes
                 */
                function watchAttributes() {
                    attr.$observe('value', function (value) {
                        var percentValue = clamp(value);
                        element.attr('aria-valuenow', percentValue);

                        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
                    });

                    attr.$observe('mdBufferValue', function (value) {
                        animateIndicator(bar1, clamp(value));
                    });

                    attr.$observe('disabled', function (value) {
                        if (value === true || value === false) {
                            isDisabled = value;
                        } else {
                            isDisabled = angular.isDefined(value);
                        }

                        element.toggleClass(DISABLED_CLASS, !!isDisabled);
                    });

                    attr.$observe('mdMode', function (mode) {
                        if (lastMode) container.removeClass(lastMode);

                        switch (mode) {
                            case MODE_QUERY:
                            case MODE_BUFFER:
                            case MODE_DETERMINATE:
                            case MODE_INDETERMINATE:
                                container.addClass(lastMode = "_md-mode-" + mode);
                                break;
                            default:
                                container.addClass(lastMode = "_md-mode-" + MODE_INDETERMINATE);
                                break;
                        }
                    });
                }

                /**
                 * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
                 */
                function validateMode() {
                    if (angular.isUndefined(attr.mdMode)) {
                        var hasValue = angular.isDefined(attr.value);
                        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
                        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";

                        //$log.debug( $mdUtil.supplant(info, [mode]) );

                        element.attr("md-mode", mode);
                        attr.mdMode = mode;
                    }
                }

                /**
                 * Is the md-mode a valid option?
                 */
                function mode() {
                    var value = (attr.mdMode || "").trim();
                    if (value) {
                        switch (value) {
                            case MODE_DETERMINATE:
                            case MODE_INDETERMINATE:
                            case MODE_BUFFER:
                            case MODE_QUERY:
                                break;
                            default:
                                value = MODE_INDETERMINATE;
                                break;
                        }
                    }
                    return value;
                }

                /**
                 * Manually set CSS to animate the Determinate indicator based on the specified
                 * percentage value (0-100).
                 */
                function animateIndicator(target, value) {
                    if (isDisabled || !mode()) return;

                    var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [(value - 100) / 2, value / 100]);
                    var styles = toVendorCSS({ transform: to });
                    angular.element(target).css(styles);
                }
            }

            /**
             * Clamps the value to be between 0 and 100.
             * @param {number} value The value to clamp.
             * @returns {number}
             */
            function clamp(value) {
                return Math.max(0, Math.min(value || 0, 100));
            }
        }
        MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];


    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.radioButton
         * @description radioButton module!
         */
        angular.module('material.components.radioButton', [
            'material.core'
        ])
            .directive('mdRadioGroup', mdRadioGroupDirective)
            .directive('mdRadioButton', mdRadioButtonDirective);

        /**
         * @ngdoc directive
         * @module material.components.radioButton
         * @name mdRadioGroup
         *
         * @restrict E
         *
         * @description
         * The `<md-radio-group>` directive identifies a grouping
         * container for the 1..n grouped radio buttons; specified using nested
         * `<md-radio-button>` tags.
         *
         * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
         * the radio button is in the accent color by default. The primary color palette may be used with
         * the `md-primary` class.
         *
         * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
         * than the native `<input type='radio'>` controls. Whereas the native controls
         * force the user to tab through all the radio buttons, `<md-radio-group>`
         * is focusable, and by default the `<md-radio-button>`s are not.
         *
         * @param {string} ng-model Assignable angular expression to data-bind to.
         * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
         *
         * @usage
         * <hljs lang="html">
         * <md-radio-group ng-model="selected">
         *
         *   <md-radio-button
         *        ng-repeat="d in colorOptions"
         *        ng-value="d.value" aria-label="{{ d.label }}">
         *
         *          {{ d.label }}
         *
         *   </md-radio-button>
         *
         * </md-radio-group>
         * </hljs>
         *
         */
        function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
            RadioGroupController.prototype = createRadioGroupControllerProto();

            return {
                restrict: 'E',
                controller: ['$element', RadioGroupController],
                require: ['mdRadioGroup', '?ngModel'],
                link: { pre: linkRadioGroup }
            };

            function linkRadioGroup(scope, element, attr, ctrls) {
                $mdTheming(element);
                var rgCtrl = ctrls[0];
                var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();

                rgCtrl.init(ngModelCtrl);

                scope.mouseActive = false;
                element.attr({
                    'role': 'radiogroup',
                    'tabIndex': element.attr('tabindex') || '0'
                })
                    .on('keydown', keydownListener)
                    .on('mousedown', function (event) {
                        scope.mouseActive = true;
                        $timeout(function () {
                            scope.mouseActive = false;
                        }, 100);
                    })
                    .on('focus', function () {
                        if (scope.mouseActive === false) { rgCtrl.$element.addClass('md-focused'); }
                    })
                    .on('blur', function () { rgCtrl.$element.removeClass('md-focused'); });

                /**
                 *
                 */
                function setFocus() {
                    if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
                }

                /**
                 *
                 */
                function keydownListener(ev) {
                    var keyCode = ev.which || ev.keyCode;

                    // Only listen to events that we originated ourselves
                    // so that we don't trigger on things like arrow keys in
                    // inputs.

                    if (keyCode != $mdConstant.KEY_CODE.ENTER &&
                        ev.currentTarget != ev.target) {
                        return;
                    }

                    switch (keyCode) {
                        case $mdConstant.KEY_CODE.LEFT_ARROW:
                        case $mdConstant.KEY_CODE.UP_ARROW:
                            ev.preventDefault();
                            rgCtrl.selectPrevious();
                            setFocus();
                            break;

                        case $mdConstant.KEY_CODE.RIGHT_ARROW:
                        case $mdConstant.KEY_CODE.DOWN_ARROW:
                            ev.preventDefault();
                            rgCtrl.selectNext();
                            setFocus();
                            break;

                        case $mdConstant.KEY_CODE.ENTER:
                            var form = angular.element($mdUtil.getClosest(element[0], 'form'));
                            if (form.length > 0) {
                                form.triggerHandler('submit');
                            }
                            break;
                    }

                }
            }

            function RadioGroupController($element) {
                this._radioButtonRenderFns = [];
                this.$element = $element;
            }

            function createRadioGroupControllerProto() {
                return {
                    init: function (ngModelCtrl) {
                        this._ngModelCtrl = ngModelCtrl;
                        this._ngModelCtrl.$render = angular.bind(this, this.render);
                    },
                    add: function (rbRender) {
                        this._radioButtonRenderFns.push(rbRender);
                    },
                    remove: function (rbRender) {
                        var index = this._radioButtonRenderFns.indexOf(rbRender);
                        if (index !== -1) {
                            this._radioButtonRenderFns.splice(index, 1);
                        }
                    },
                    render: function () {
                        this._radioButtonRenderFns.forEach(function (rbRender) {
                            rbRender();
                        });
                    },
                    setViewValue: function (value, eventType) {
                        this._ngModelCtrl.$setViewValue(value, eventType);
                        // update the other radio buttons as well
                        this.render();
                    },
                    getViewValue: function () {
                        return this._ngModelCtrl.$viewValue;
                    },
                    selectNext: function () {
                        return changeSelectedButton(this.$element, 1);
                    },
                    selectPrevious: function () {
                        return changeSelectedButton(this.$element, -1);
                    },
                    setActiveDescendant: function (radioId) {
                        this.$element.attr('aria-activedescendant', radioId);
                    }
                };
            }
            /**
             * Change the radio group's selected button by a given increment.
             * If no button is selected, select the first button.
             */
            function changeSelectedButton(parent, increment) {
                // Coerce all child radio buttons into an array, then wrap then in an iterator
                var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);

                if (buttons.count()) {
                    var validate = function (button) {
                        // If disabled, then NOT valid
                        return !angular.element(button).attr("disabled");
                    };

                    var selected = parent[0].querySelector('md-radio-button.md-checked');
                    var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();

                    // Activate radioButton's click listener (triggerHandler won't create a real click event)
                    angular.element(target).triggerHandler('click');


                }
            }

        }
        mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];

        /**
         * @ngdoc directive
         * @module material.components.radioButton
         * @name mdRadioButton
         *
         * @restrict E
         *
         * @description
         * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
         *
         * While similar to the `<input type="radio" ng-model="" value="">` directive,
         * the `<md-radio-button>` directive provides ink effects, ARIA support, and
         * supports use within named radio groups.
         *
         * @param {string} ngModel Assignable angular expression to data-bind to.
         * @param {string=} ngChange Angular expression to be executed when input changes due to user
         *    interaction with the input element.
         * @param {string} ngValue Angular expression which sets the value to which the expression should
         *    be set when selected.
         * @param {string} value The value to which the expression should be set when selected.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} aria-label Adds label to radio button for accessibility.
         * Defaults to radio button's text. If no text content is available, a warning will be logged.
         *
         * @usage
         * <hljs lang="html">
         *
         * <md-radio-button value="1" aria-label="Label 1">
         *   Label 1
         * </md-radio-button>
         *
         * <md-radio-button ng-model="color" ng-value="specialValue" aria-label="Green">
         *   Green
         * </md-radio-button>
         *
         * </hljs>
         *
         */
        function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {

            var CHECKED_CSS = 'md-checked';

            return {
                restrict: 'E',
                require: '^mdRadioGroup',
                transclude: true,
                template: '<div class="_md-container" md-ink-ripple md-ink-ripple-checkbox>' +
                    '<div class="_md-off"></div>' +
                    '<div class="_md-on"></div>' +
                    '</div>' +
                    '<div ng-transclude class="_md-label"></div>',
                link: link
            };

            function link(scope, element, attr, rgCtrl) {
                var lastChecked;

                $mdTheming(element);
                configureAria(element, scope);

                initialize();

                /**
                 *
                 */
                function initialize(controller) {
                    if (!rgCtrl) {
                        throw 'RadioGroupController not found.';
                    }

                    rgCtrl.add(render);
                    attr.$observe('value', render);

                    element
                        .on('click', listener)
                        .on('$destroy', function () {
                            rgCtrl.remove(render);
                        });
                }

                /**
                 *
                 */
                function listener(ev) {
                    if (element[0].hasAttribute('disabled')) return;

                    scope.$apply(function () {
                        rgCtrl.setViewValue(attr.value, ev && ev.type);
                    });
                }

                /**
                 *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
                 *  Update the `aria-activedescendant` attribute.
                 */
                function render() {
                    var checked = (rgCtrl.getViewValue() == attr.value);
                    if (checked === lastChecked) {
                        return;
                    }

                    lastChecked = checked;
                    element.attr('aria-checked', checked);

                    if (checked) {
                        markParentAsChecked(true);
                        element.addClass(CHECKED_CSS);

                        rgCtrl.setActiveDescendant(element.attr('id'));

                    } else {
                        markParentAsChecked(false);
                        element.removeClass(CHECKED_CSS);
                    }

                    /**
                     * If the radioButton is inside a div, then add class so highlighting will work...
                     */
                    function markParentAsChecked(addClass) {
                        if (element.parent()[0].nodeName != "MD-RADIO-GROUP") {
                            element.parent()[!!addClass ? 'addClass' : 'removeClass'](CHECKED_CSS);
                        }

                    }
                }

                /**
                 * Inject ARIA-specific attributes appropriate for each radio button
                 */
                function configureAria(element, scope) {
                    scope.ariaId = buildAriaID();

                    element.attr({
                        'id': scope.ariaId,
                        'role': 'radio',
                        'aria-checked': 'false'
                    });

                    $mdAria.expectWithText(element, 'aria-label');

                    /**
                     * Build a unique ID for each radio button that will be used with aria-activedescendant.
                     * Preserve existing ID if already specified.
                     * @returns {*|string}
                     */
                    function buildAriaID() {
                        return attr.id || ('radio' + "_" + $mdUtil.nextUid());
                    }
                }
            }
        }
        mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.select
         */

        /***************************************************

         ### TODO - POST RC1 ###
         - [ ] Abstract placement logic in $mdSelect service to $mdMenu service

         ***************************************************/

        var SELECT_EDGE_MARGIN = 8;
        var selectNextId = 0;
        var CHECKBOX_SELECTION_INDICATOR =
            angular.element('<div class="_md-container"><div class="_md-icon"></div></div>');

        angular.module('material.components.select', [
            'material.core',
            'material.components.backdrop'
        ])
            .directive('mdSelect', SelectDirective)
            .directive('mdSelectMenu', SelectMenuDirective)
            .directive('mdOption', OptionDirective)
            .directive('mdOptgroup', OptgroupDirective)
            .provider('$mdSelect', SelectProvider);

        /**
         * @ngdoc directive
         * @name mdSelect
         * @restrict E
         * @module material.components.select
         *
         * @description Displays a select box, bound to an ng-model.
         *
         * @param {expression} ng-model The model!
         * @param {boolean=} multiple Whether it's multiple.
         * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
         * @param {expression=} md-on-open Expression to be evaluated when opening the select.
         * Will hide the select options and show a spinner until the evaluated promise resolves.
         * @param {expression=} md-selected-text Expression to be evaluated that will return a string
         * to be displayed as a placeholder in the select input box when it is closed.
         * @param {string=} placeholder Placeholder hint text.
         * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
         * explicit label is present.
         * @param {string=} md-container-class Class list to get applied to the `._md-select-menu-container`
         * element (for custom styling).
         *
         * @usage
         * With a placeholder (label and aria-label are added dynamically)
         * <hljs lang="html">
         *   <md-input-container>
         *     <md-select
         *       ng-model="someModel"
         *       placeholder="Select a state">
         *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
         *     </md-select>
         *   </md-input-container>
         * </hljs>
         *
         * With an explicit label
         * <hljs lang="html">
         *   <md-input-container>
         *     <label>State</label>
         *     <md-select
         *       ng-model="someModel">
         *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
         *     </md-select>
         *   </md-input-container>
         * </hljs>
         *
         * ## Selects and object equality
         * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
         * equality. Consider the following example:
         * <hljs lang="js">
         * angular.controller('MyCtrl', function($scope) {
         *   $scope.users = [
         *     { id: 1, name: 'Bob' },
         *     { id: 2, name: 'Alice' },
         *     { id: 3, name: 'Steve' }
         *   ];
         *   $scope.selectedUser = { id: 1, name: 'Bob' };
         * });
         * </hljs>
         * <hljs lang="html">
         * <div ng-controller="MyCtrl">
         *   <md-select ng-model="selectedUser">
         *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
         *   </md-select>
         * </div>
         * </hljs>
         *
         * At first one might expect that the select should be populated with "Bob" as the selected user. However,
         * this is not true. To determine whether something is selected,
         * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
         *
         * Javascript's `==` operator does not check for deep equality (ie. that all properties
         * on the object are the same), but instead whether the objects are *the same object in memory*.
         * In this case, we have two instances of identical objects, but they exist in memory as unique
         * entities. Because of this, the select will have no value populated for a selected user.
         *
         * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
         * expression which will be used for the equality operator. As such, we can update our `html` to
         * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
         * element. This converts our equality expression to be
         * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
         * which results in Bob being selected as desired.
         *
         * Working HTML:
         * <hljs lang="html">
         * <div ng-controller="MyCtrl">
         *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
         *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
         *   </md-select>
         * </div>
         * </hljs>
         */
        function SelectDirective($mdSelect, $mdUtil, $mdTheming, $mdAria, $compile, $parse) {
            return {
                restrict: 'E',
                require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
                compile: compile,
                controller: function () { } // empty placeholder controller to be initialized in link
            };

            function compile(element, attr) {
                // add the select value that will hold our placeholder or selected option value
                var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
                valueEl.append('<span class="_md-select-icon" aria-hidden="true"></span>');
                valueEl.addClass('_md-select-value');
                if (!valueEl[0].hasAttribute('id')) {
                    valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
                }

                // There's got to be an md-content inside. If there's not one, let's add it.
                if (!element.find('md-content').length) {
                    element.append(angular.element('<md-content>').append(element.contents()));
                }


                // Add progress spinner for md-options-loading
                if (attr.mdOnOpen) {

                    // Show progress indicator while loading async
                    // Use ng-hide for `display:none` so the indicator does not interfere with the options list
                    element
                        .find('md-content')
                        .prepend(angular.element(
                            '<div>' +
                            ' <md-progress-circular md-mode="indeterminate" ng-if="!$$loadingAsyncDone" md-diameter="25px"></md-progress-circular>' +
                            '</div>'
                        ));

                    // Hide list [of item options] while loading async
                    element
                        .find('md-option')
                        .attr('ng-show', '$$loadingAsyncDone');
                }

                if (attr.name) {
                    var autofillClone = angular.element('<select class="_md-visually-hidden">');
                    autofillClone.attr({
                        'name': '.' + attr.name,
                        'ng-model': attr.ngModel,
                        'aria-hidden': 'true',
                        'tabindex': '-1'
                    });
                    var opts = element.find('md-option');
                    angular.forEach(opts, function (el) {
                        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
                        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
                        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
                        autofillClone.append(newEl);
                    });

                    element.parent().append(autofillClone);
                }

                var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);

                // Use everything that's left inside element.contents() as the contents of the menu
                var multipleContent = isMultiple ? 'multiple' : '';
                var selectTemplate = '' +
                    '<div class="_md-select-menu-container" aria-hidden="true">' +
                    '<md-select-menu {0}>{1}</md-select-menu>' +
                    '</div>';

                selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
                element.empty().append(valueEl);
                element.append(selectTemplate);

                if (!attr.tabindex) {
                    attr.$set('tabindex', 0);
                }

                return function postLink(scope, element, attr, ctrls) {
                    var untouched = true;
                    var isDisabled, ariaLabelBase;

                    var containerCtrl = ctrls[0];
                    var mdSelectCtrl = ctrls[1];
                    var ngModelCtrl = ctrls[2];
                    var formCtrl = ctrls[3];
                    // grab a reference to the select menu value label
                    var valueEl = element.find('md-select-value');
                    var isReadonly = angular.isDefined(attr.readonly);

                    if (containerCtrl) {
                        var isErrorGetter = containerCtrl.isErrorGetter || function () {
                            return ngModelCtrl.$invalid && ngModelCtrl.$touched;
                        };

                        if (containerCtrl.input) {
                            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
                        }

                        containerCtrl.input = element;
                        if (!containerCtrl.label) {
                            $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
                        }

                        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
                    }

                    var selectContainer, selectScope, selectMenuCtrl;

                    findSelectContainer();
                    $mdTheming(element);

                    if (attr.name && formCtrl) {
                        var selectEl = element.parent()[0].querySelector('select[name=".' + attr.name + '"]');
                        $mdUtil.nextTick(function () {
                            var controller = angular.element(selectEl).controller('ngModel');
                            if (controller) {
                                formCtrl.$removeControl(controller);
                            }
                        });
                    }

                    if (formCtrl && angular.isDefined(attr.multiple)) {
                        $mdUtil.nextTick(function () {
                            var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
                            if (hasModelValue) {
                                formCtrl.$setPristine();
                            }
                        });
                    }

                    var originalRender = ngModelCtrl.$render;
                    ngModelCtrl.$render = function () {
                        originalRender();
                        syncLabelText();
                        syncAriaLabel();
                        inputCheckValue();
                    };


                    attr.$observe('placeholder', ngModelCtrl.$render);


                    mdSelectCtrl.setLabelText = function (text) {
                        mdSelectCtrl.setIsPlaceholder(!text);

                        if (attr.mdSelectedText) {
                            text = $parse(attr.mdSelectedText)(scope);
                        } else {
                            // Use placeholder attribute, otherwise fallback to the md-input-container label
                            var tmpPlaceholder = attr.placeholder ||
                                (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');
                            text = text || tmpPlaceholder || '';
                        }

                        var target = valueEl.children().eq(0);
                        target.html(text);
                    };

                    mdSelectCtrl.setIsPlaceholder = function (isPlaceholder) {
                        if (isPlaceholder) {
                            valueEl.addClass('_md-select-placeholder');
                            if (containerCtrl && containerCtrl.label) {
                                containerCtrl.label.addClass('_md-placeholder');
                            }
                        } else {
                            valueEl.removeClass('_md-select-placeholder');
                            if (containerCtrl && containerCtrl.label) {
                                containerCtrl.label.removeClass('_md-placeholder');
                            }
                        }
                    };

                    if (!isReadonly) {
                        element
                            .on('focus', function (ev) {
                                // only set focus on if we don't currently have a selected value. This avoids the "bounce"
                                // on the label transition because the focus will immediately switch to the open menu.
                                if (containerCtrl && containerCtrl.element.hasClass('md-input-has-value')) {
                                    containerCtrl.setFocused(true);
                                }
                            });

                        // Attach before ngModel's blur listener to stop propagation of blur event
                        // to prevent from setting $touched.
                        element.on('blur', function (event) {
                            if (untouched) {
                                untouched = false;
                                if (selectScope.isOpen) {
                                    event.stopImmediatePropagation();
                                }
                            }

                            if (selectScope.isOpen) return;
                            containerCtrl && containerCtrl.setFocused(false);
                            inputCheckValue();
                        });
                    }

                    mdSelectCtrl.triggerClose = function () {
                        $parse(attr.mdOnClose)(scope);
                    };

                    scope.$$postDigest(function () {
                        initAriaLabel();
                        syncLabelText();
                        syncAriaLabel();
                    });

                    function initAriaLabel() {
                        var labelText = element.attr('aria-label') || element.attr('placeholder');
                        if (!labelText && containerCtrl && containerCtrl.label) {
                            labelText = containerCtrl.label.text();
                        }
                        ariaLabelBase = labelText;
                        $mdAria.expect(element, 'aria-label', labelText);
                    }

                    scope.$watch(selectMenuCtrl.selectedLabels, syncLabelText);

                    function syncLabelText() {
                        if (selectContainer) {
                            selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
                            mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
                        }
                    }

                    function syncAriaLabel() {
                        if (!ariaLabelBase) return;
                        var ariaLabels = selectMenuCtrl.selectedLabels({ mode: 'aria' });
                        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
                    }

                    var deregisterWatcher;
                    attr.$observe('ngMultiple', function (val) {
                        if (deregisterWatcher) deregisterWatcher();
                        var parser = $parse(val);
                        deregisterWatcher = scope.$watch(function () {
                            return parser(scope);
                        }, function (multiple, prevVal) {
                            if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
                            if (multiple) {
                                element.attr('multiple', 'multiple');
                            } else {
                                element.removeAttr('multiple');
                            }
                            element.attr('aria-multiselectable', multiple ? 'true' : 'false');
                            if (selectContainer) {
                                selectMenuCtrl.setMultiple(multiple);
                                originalRender = ngModelCtrl.$render;
                                ngModelCtrl.$render = function () {
                                    originalRender();
                                    syncLabelText();
                                    syncAriaLabel();
                                    inputCheckValue();
                                };
                                ngModelCtrl.$render();
                            }
                        });
                    });

                    attr.$observe('disabled', function (disabled) {
                        if (angular.isString(disabled)) {
                            disabled = true;
                        }
                        // Prevent click event being registered twice
                        if (isDisabled !== undefined && isDisabled === disabled) {
                            return;
                        }
                        isDisabled = disabled;
                        if (disabled) {
                            element
                                .attr({ 'aria-disabled': 'true' })
                                .removeAttr('tabindex')
                                .off('click', openSelect)
                                .off('keydown', handleKeypress);
                        } else {
                            element
                                .attr({ 'tabindex': attr.tabindex, 'aria-disabled': 'false' })
                                .on('click', openSelect)
                                .on('keydown', handleKeypress);
                        }
                    });

                    if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
                        element.attr({ 'aria-disabled': 'false' });
                        element.on('click', openSelect);
                        element.on('keydown', handleKeypress);
                    }

                    var ariaAttrs = {
                        role: 'listbox',
                        'aria-expanded': 'false',
                        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
                    };

                    if (!element[0].hasAttribute('id')) {
                        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
                    }

                    var containerId = 'select_container_' + $mdUtil.nextUid();
                    selectContainer.attr('id', containerId);
                    ariaAttrs['aria-owns'] = containerId;
                    element.attr(ariaAttrs);

                    scope.$on('$destroy', function () {
                        $mdSelect
                            .destroy()
                            .finally(function () {
                                if (containerCtrl) {
                                    containerCtrl.setFocused(false);
                                    containerCtrl.setHasValue(false);
                                    containerCtrl.input = null;
                                }
                                ngModelCtrl.$setTouched();
                            });
                    });



                    function inputCheckValue() {
                        // The select counts as having a value if one or more options are selected,
                        // or if the input's validity state says it has bad input (eg string in a number input)
                        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
                    }

                    function findSelectContainer() {
                        selectContainer = angular.element(
                            element[0].querySelector('._md-select-menu-container')
                        );
                        selectScope = scope;
                        if (attr.mdContainerClass) {
                            var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
                            selectContainer[0].setAttribute('class', value);
                        }
                        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
                        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
                        element.on('$destroy', function () {
                            selectContainer.remove();
                        });
                    }

                    function handleKeypress(e) {
                        var allowedCodes = [32, 13, 38, 40];
                        if (allowedCodes.indexOf(e.keyCode) != -1) {
                            // prevent page scrolling on interaction
                            e.preventDefault();
                            openSelect(e);
                        } else {
                            if (e.keyCode <= 90 && e.keyCode >= 31) {
                                e.preventDefault();
                                var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
                                if (!node) return;
                                var optionCtrl = angular.element(node).controller('mdOption');
                                if (!selectMenuCtrl.isMultiple) {
                                    selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
                                }
                                selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
                                selectMenuCtrl.refreshViewValue();
                            }
                        }
                    }

                    function openSelect() {
                        selectScope.isOpen = true;
                        element.attr('aria-expanded', 'true');

                        $mdSelect.show({
                            scope: selectScope,
                            preserveScope: true,
                            skipCompile: true,
                            element: selectContainer,
                            target: element[0],
                            selectCtrl: mdSelectCtrl,
                            preserveElement: true,
                            hasBackdrop: true,
                            loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
                        }).finally(function () {
                            selectScope.isOpen = false;
                            element.focus();
                            element.attr('aria-expanded', 'false');
                            ngModelCtrl.$setTouched();
                        });
                    }
                };
            }
        }
        SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdTheming", "$mdAria", "$compile", "$parse"];

        function SelectMenuDirective($parse, $mdUtil, $mdTheming) {


            SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
            return {
                restrict: 'E',
                require: ['mdSelectMenu'],
                scope: true,
                controller: SelectMenuController,
                link: { pre: preLink }
            };

            // We use preLink instead of postLink to ensure that the select is initialized before
            // its child options run postLink.
            function preLink(scope, element, attr, ctrls) {
                var selectCtrl = ctrls[0];

                $mdTheming(element);
                element.on('click', clickListener);
                element.on('keypress', keyListener);

                function keyListener(e) {
                    if (e.keyCode == 13 || e.keyCode == 32) {
                        clickListener(e);
                    }
                }

                function clickListener(ev) {
                    var option = $mdUtil.getClosest(ev.target, 'md-option');
                    var optionCtrl = option && angular.element(option).data('$mdOptionController');
                    if (!option || !optionCtrl) return;
                    if (option.hasAttribute('disabled')) {
                        ev.stopImmediatePropagation();
                        return false;
                    }

                    var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
                    var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);

                    scope.$apply(function () {
                        if (selectCtrl.isMultiple) {
                            if (isSelected) {
                                selectCtrl.deselect(optionHashKey);
                            } else {
                                selectCtrl.select(optionHashKey, optionCtrl.value);
                            }
                        } else {
                            if (!isSelected) {
                                selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
                                selectCtrl.select(optionHashKey, optionCtrl.value);
                            }
                        }
                        selectCtrl.refreshViewValue();
                    });
                }
            }

            function SelectMenuController($scope, $attrs, $element) {
                var self = this;
                self.isMultiple = angular.isDefined($attrs.multiple);
                // selected is an object with keys matching all of the selected options' hashed values
                self.selected = {};
                // options is an object with keys matching every option's hash value,
                // and values matching every option's controller.
                self.options = {};

                $scope.$watchCollection(function () {
                    return self.options;
                }, function () {
                    self.ngModel.$render();
                });

                var deregisterCollectionWatch;
                var defaultIsEmpty;
                self.setMultiple = function (isMultiple) {
                    var ngModel = self.ngModel;
                    defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;

                    self.isMultiple = isMultiple;
                    if (deregisterCollectionWatch) deregisterCollectionWatch();

                    if (self.isMultiple) {
                        ngModel.$validators['md-multiple'] = validateArray;
                        ngModel.$render = renderMultiple;

                        // watchCollection on the model because by default ngModel only watches the model's
                        // reference. This allowed the developer to also push and pop from their array.
                        $scope.$watchCollection(self.modelBinding, function (value) {
                            if (validateArray(value)) renderMultiple(value);
                            self.ngModel.$setPristine();
                        });

                        ngModel.$isEmpty = function (value) {
                            return !value || value.length === 0;
                        };
                    } else {
                        delete ngModel.$validators['md-multiple'];
                        ngModel.$render = renderSingular;
                    }

                    function validateArray(modelValue, viewValue) {
                        // If a value is truthy but not an array, reject it.
                        // If value is undefined/falsy, accept that it's an empty array.
                        return angular.isArray(modelValue || viewValue || []);
                    }
                };

                var searchStr = '';
                var clearSearchTimeout, optNodes, optText;
                var CLEAR_SEARCH_AFTER = 300;
                self.optNodeForKeyboardSearch = function (e) {
                    clearSearchTimeout && clearTimeout(clearSearchTimeout);
                    clearSearchTimeout = setTimeout(function () {
                        clearSearchTimeout = undefined;
                        searchStr = '';
                        optText = undefined;
                        optNodes = undefined;
                    }, CLEAR_SEARCH_AFTER);
                    searchStr += String.fromCharCode(e.keyCode);
                    var search = new RegExp('^' + searchStr, 'i');
                    if (!optNodes) {
                        optNodes = $element.find('md-option');
                        optText = new Array(optNodes.length);
                        angular.forEach(optNodes, function (el, i) {
                            optText[i] = el.textContent.trim();
                        });
                    }
                    for (var i = 0; i < optText.length; ++i) {
                        if (search.test(optText[i])) {
                            return optNodes[i];
                        }
                    }
                };

                self.init = function (ngModel, binding) {
                    self.ngModel = ngModel;
                    self.modelBinding = binding;

                    // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
                    // that we can properly compare objects set on the model to the available options
                    if (ngModel.$options && ngModel.$options.trackBy) {
                        var trackByLocals = {};
                        var trackByParsed = $parse(ngModel.$options.trackBy);
                        self.hashGetter = function (value, valueScope) {
                            trackByLocals.$value = value;
                            return trackByParsed(valueScope || $scope, trackByLocals);
                        };
                        // If the user doesn't provide a trackBy, we automatically generate an id for every
                        // value passed in
                    } else {
                        self.hashGetter = function getHashValue(value) {
                            if (angular.isObject(value)) {
                                return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
                            }
                            return value;
                        };
                    }
                    self.setMultiple(self.isMultiple);
                };

                self.selectedLabels = function (opts) {
                    opts = opts || {};
                    var mode = opts.mode || 'html';
                    var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
                    if (selectedOptionEls.length) {
                        var mapFn;

                        if (mode == 'html') {
                            // Map the given element to its innerHTML string. If the element has a child ripple
                            // container remove it from the HTML string, before returning the string.
                            mapFn = function (el) {
                                var html = el.innerHTML;
                                // Remove the ripple container from the selected option, copying it would cause a CSP violation.
                                var rippleContainer = el.querySelector('.md-ripple-container');
                                return rippleContainer ? html.replace(rippleContainer.outerHTML, '') : html;
                            };
                        } else if (mode == 'aria') {
                            mapFn = function (el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
                        }
                        return selectedOptionEls.map(mapFn).join(', ');
                    } else {
                        return '';
                    }
                };

                self.select = function (hashKey, hashedValue) {
                    var option = self.options[hashKey];
                    option && option.setSelected(true);
                    self.selected[hashKey] = hashedValue;
                };
                self.deselect = function (hashKey) {
                    var option = self.options[hashKey];
                    option && option.setSelected(false);
                    delete self.selected[hashKey];
                };

                self.addOption = function (hashKey, optionCtrl) {
                    if (angular.isDefined(self.options[hashKey])) {
                        throw new Error('Duplicate md-option values are not allowed in a select. ' +
                            'Duplicate value "' + optionCtrl.value + '" found.');
                    }
                    self.options[hashKey] = optionCtrl;

                    // If this option's value was already in our ngModel, go ahead and select it.
                    if (angular.isDefined(self.selected[hashKey])) {
                        self.select(hashKey, optionCtrl.value);
                        self.refreshViewValue();
                    }
                };
                self.removeOption = function (hashKey) {
                    delete self.options[hashKey];
                    // Don't deselect an option when it's removed - the user's ngModel should be allowed
                    // to have values that do not match a currently available option.
                };

                self.refreshViewValue = function () {
                    var values = [];
                    var option;
                    for (var hashKey in self.selected) {
                        // If this hashKey has an associated option, push that option's value to the model.
                        if ((option = self.options[hashKey])) {
                            values.push(option.value);
                        } else {
                            // Otherwise, the given hashKey has no associated option, and we got it
                            // from an ngModel value at an earlier time. Push the unhashed value of
                            // this hashKey to the model.
                            // This allows the developer to put a value in the model that doesn't yet have
                            // an associated option.
                            values.push(self.selected[hashKey]);
                        }
                    }
                    var usingTrackBy = self.ngModel.$options && self.ngModel.$options.trackBy;

                    var newVal = self.isMultiple ? values : values[0];
                    var prevVal = self.ngModel.$modelValue;

                    if (usingTrackBy ? !angular.equals(prevVal, newVal) : prevVal != newVal) {
                        self.ngModel.$setViewValue(newVal);
                        self.ngModel.$render();
                    }
                };

                function renderMultiple() {
                    var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
                    if (!angular.isArray(newSelectedValues)) return;

                    var oldSelected = Object.keys(self.selected);

                    var newSelectedHashes = newSelectedValues.map(self.hashGetter);
                    var deselected = oldSelected.filter(function (hash) {
                        return newSelectedHashes.indexOf(hash) === -1;
                    });

                    deselected.forEach(self.deselect);
                    newSelectedHashes.forEach(function (hashKey, i) {
                        self.select(hashKey, newSelectedValues[i]);
                    });
                }

                function renderSingular() {
                    var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
                    Object.keys(self.selected).forEach(self.deselect);
                    self.select(self.hashGetter(value), value);
                }
            }

        }
        SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdTheming"];

        function OptionDirective($mdButtonInkRipple, $mdUtil) {


            OptionController.$inject = ["$element"];
            return {
                restrict: 'E',
                require: ['mdOption', '^^mdSelectMenu'],
                controller: OptionController,
                compile: compile
            };

            function compile(element, attr) {
                // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
                element.append(angular.element('<div class="_md-text">').append(element.contents()));

                element.attr('tabindex', attr.tabindex || '0');
                return postLink;
            }

            function postLink(scope, element, attr, ctrls) {
                var optionCtrl = ctrls[0];
                var selectCtrl = ctrls[1];

                if (selectCtrl.isMultiple) {
                    element.addClass('_md-checkbox-enabled');
                    element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
                }

                if (angular.isDefined(attr.ngValue)) {
                    scope.$watch(attr.ngValue, setOptionValue);
                } else if (angular.isDefined(attr.value)) {
                    setOptionValue(attr.value);
                } else {
                    scope.$watch(function () {
                        return element.text().trim();
                    }, setOptionValue);
                }

                attr.$observe('disabled', function (disabled) {
                    if (disabled) {
                        element.attr('tabindex', '-1');
                    } else {
                        element.attr('tabindex', '0');
                    }
                });

                scope.$$postDigest(function () {
                    attr.$observe('selected', function (selected) {
                        if (!angular.isDefined(selected)) return;
                        if (typeof selected == 'string') selected = true;
                        if (selected) {
                            if (!selectCtrl.isMultiple) {
                                selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
                            }
                            selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
                        } else {
                            selectCtrl.deselect(optionCtrl.hashKey);
                        }
                        selectCtrl.refreshViewValue();
                    });
                });

                $mdButtonInkRipple.attach(scope, element);
                configureAria();

                function setOptionValue(newValue, oldValue, prevAttempt) {
                    if (!selectCtrl.hashGetter) {
                        if (!prevAttempt) {
                            scope.$$postDigest(function () {
                                setOptionValue(newValue, oldValue, true);
                            });
                        }
                        return;
                    }
                    var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
                    var newHashKey = selectCtrl.hashGetter(newValue, scope);

                    optionCtrl.hashKey = newHashKey;
                    optionCtrl.value = newValue;

                    selectCtrl.removeOption(oldHashKey, optionCtrl);
                    selectCtrl.addOption(newHashKey, optionCtrl);
                }

                scope.$on('$destroy', function () {
                    selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
                });

                function configureAria() {
                    var ariaAttrs = {
                        'role': 'option',
                        'aria-selected': 'false'
                    };

                    if (!element[0].hasAttribute('id')) {
                        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
                    }
                    element.attr(ariaAttrs);
                }
            }

            function OptionController($element) {
                this.selected = false;
                this.setSelected = function (isSelected) {
                    if (isSelected && !this.selected) {
                        $element.attr({
                            'selected': 'selected',
                            'aria-selected': 'true'
                        });
                    } else if (!isSelected && this.selected) {
                        $element.removeAttr('selected');
                        $element.attr('aria-selected', 'false');
                    }
                    this.selected = isSelected;
                };
            }

        }
        OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil"];

        function OptgroupDirective() {
            return {
                restrict: 'E',
                compile: compile
            };

            function compile(el, attrs) {
                var labelElement = el.find('label');
                if (!labelElement.length) {
                    labelElement = angular.element('<label>');
                    el.prepend(labelElement);
                }
                labelElement.addClass('_md-container-ignore');
                if (attrs.label) labelElement.text(attrs.label);
            }
        }

        function SelectProvider($$interimElementProvider) {

            selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
            return $$interimElementProvider('$mdSelect')
                .setDefaults({
                    methods: ['target'],
                    options: selectDefaultOptions
                });

            /* @ngInject */
            function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
                var ERRROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
                var animator = $mdUtil.dom.animator;

                return {
                    parent: 'body',
                    themable: true,
                    onShow: onShow,
                    onRemove: onRemove,
                    hasBackdrop: true,
                    disableParentScroll: true
                };

                /**
                 * Interim-element onRemove logic....
                 */
                function onRemove(scope, element, opts) {
                    opts = opts || {};
                    opts.cleanupInteraction();
                    opts.cleanupResizing();
                    opts.hideBackdrop();

                    // For navigation $destroy events, do a quick, non-animated removal,
                    // but for normal closes (from clicks, etc) animate the removal

                    return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);

                    /**
                     * For normal closes (eg clicks), animate the removal.
                     * For forced closes (like $destroy events from navigation),
                     * skip the animations
                     */
                    function animateRemoval() {
                        return $animateCss(element, { addClass: '_md-leave' }).start();
                    }

                    /**
                     * Restore the element to a closed state
                     */
                    function cleanElement() {

                        element.removeClass('_md-active');
                        element.attr('aria-hidden', 'true');
                        element[0].style.display = 'none';

                        announceClosed(opts);

                        if (!opts.$destroy && opts.restoreFocus) {
                            opts.target.focus();
                        }
                    }

                }

                /**
                 * Interim-element onShow logic....
                 */
                function onShow(scope, element, opts) {

                    watchAsyncLoad();
                    sanitizeAndConfigure(scope, opts);

                    opts.hideBackdrop = showBackdrop(scope, element, opts);

                    return showDropDown(scope, element, opts)
                        .then(function (response) {
                            element.attr('aria-hidden', 'false');
                            opts.alreadyOpen = true;
                            opts.cleanupInteraction = activateInteraction();
                            opts.cleanupResizing = activateResizing();

                            return response;
                        }, opts.hideBackdrop);

                    // ************************************
                    // Closure Functions
                    // ************************************

                    /**
                     *  Attach the select DOM element(s) and animate to the correct positions
                     *  and scalings...
                     */
                    function showDropDown(scope, element, opts) {
                        opts.parent.append(element);

                        return $q(function (resolve, reject) {

                            try {

                                $animateCss(element, { removeClass: '_md-leave', duration: 0 })
                                    .start()
                                    .then(positionAndFocusMenu)
                                    .then(resolve);

                            } catch (e) {
                                reject(e);
                            }

                        });
                    }

                    /**
                     * Initialize container and dropDown menu positions/scale, then animate
                     * to show... and autoFocus.
                     */
                    function positionAndFocusMenu() {
                        return $q(function (resolve) {
                            if (opts.isRemoved) return $q.reject(false);

                            var info = calculateMenuPositions(scope, element, opts);

                            info.container.element.css(animator.toCss(info.container.styles));
                            info.dropDown.element.css(animator.toCss(info.dropDown.styles));

                            $$rAF(function () {
                                element.addClass('_md-active');
                                info.dropDown.element.css(animator.toCss({ transform: '' }));

                                autoFocus(opts.focusedNode);
                                resolve();
                            });

                        });
                    }

                    /**
                     * Show modal backdrop element...
                     */
                    function showBackdrop(scope, element, options) {

                        // If we are not within a dialog...
                        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
                            // !! DO this before creating the backdrop; since disableScrollAround()
                            //    configures the scroll offset; which is used by mdBackDrop postLink()
                            options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
                        } else {
                            options.disableParentScroll = false;
                        }

                        if (options.hasBackdrop) {
                            // Override duration to immediately show invisible backdrop
                            options.backdrop = $mdUtil.createBackdrop(scope, "_md-select-backdrop _md-click-catcher");
                            $animate.enter(options.backdrop, $document[0].body, null, { duration: 0 });
                        }

                        /**
                         * Hide modal backdrop element...
                         */
                        return function hideBackdrop() {
                            if (options.backdrop) options.backdrop.remove();
                            if (options.disableParentScroll) options.restoreScroll();

                            delete options.restoreScroll;
                        };
                    }

                    /**
                     *
                     */
                    function autoFocus(focusedNode) {
                        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
                            focusedNode.focus();
                        }
                    }

                    /**
                     * Check for valid opts and set some sane defaults
                     */
                    function sanitizeAndConfigure(scope, options) {
                        var selectEl = element.find('md-select-menu');

                        if (!options.target) {
                            throw new Error($mdUtil.supplant(ERRROR_TARGET_EXPECTED, [options.target]));
                        }

                        angular.extend(options, {
                            isRemoved: false,
                            target: angular.element(options.target), //make sure it's not a naked dom node
                            parent: angular.element(options.parent),
                            selectEl: selectEl,
                            contentEl: element.find('md-content'),
                            optionNodes: selectEl[0].getElementsByTagName('md-option')
                        });
                    }

                    /**
                     * Configure various resize listeners for screen changes
                     */
                    function activateResizing() {
                        var debouncedOnResize = (function (scope, target, options) {

                            return function () {
                                if (options.isRemoved) return;

                                var updates = calculateMenuPositions(scope, target, options);
                                var container = updates.container;
                                var dropDown = updates.dropDown;

                                container.element.css(animator.toCss(container.styles));
                                dropDown.element.css(animator.toCss(dropDown.styles));
                            };

                        })(scope, element, opts);

                        var window = angular.element($window);
                        window.on('resize', debouncedOnResize);
                        window.on('orientationchange', debouncedOnResize);

                        // Publish deactivation closure...
                        return function deactivateResizing() {

                            // Disable resizing handlers
                            window.off('resize', debouncedOnResize);
                            window.off('orientationchange', debouncedOnResize);
                        };
                    }

                    /**
                     *  If asynchronously loading, watch and update internal
                     *  '$$loadingAsyncDone' flag
                     */
                    function watchAsyncLoad() {
                        if (opts.loadingAsync && !opts.isRemoved) {
                            scope.$$loadingAsyncDone = false;

                            $q.when(opts.loadingAsync)
                                .then(function () {
                                    scope.$$loadingAsyncDone = true;
                                    delete opts.loadingAsync;
                                }).then(function () {
                                    $$rAF(positionAndFocusMenu);
                                });
                        }
                    }

                    /**
                     *
                     */
                    function activateInteraction() {
                        if (opts.isRemoved) return;

                        var dropDown = opts.selectEl;
                        var selectCtrl = dropDown.controller('mdSelectMenu') || {};

                        element.addClass('_md-clickable');

                        // Close on backdrop click
                        opts.backdrop && opts.backdrop.on('click', onBackdropClick);

                        // Escape to close
                        // Cycling of options, and closing on enter
                        dropDown.on('keydown', onMenuKeyDown);
                        dropDown.on('click', checkCloseMenu);

                        return function cleanupInteraction() {
                            opts.backdrop && opts.backdrop.off('click', onBackdropClick);
                            dropDown.off('keydown', onMenuKeyDown);
                            dropDown.off('click', checkCloseMenu);

                            element.removeClass('_md-clickable');
                            opts.isRemoved = true;
                        };

                        // ************************************
                        // Closure Functions
                        // ************************************

                        function onBackdropClick(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            opts.restoreFocus = false;
                            $mdUtil.nextTick($mdSelect.hide, true);
                        }

                        function onMenuKeyDown(ev) {
                            var keyCodes = $mdConstant.KEY_CODE;
                            ev.preventDefault();
                            ev.stopPropagation();

                            switch (ev.keyCode) {
                                case keyCodes.UP_ARROW:
                                    return focusPrevOption();
                                case keyCodes.DOWN_ARROW:
                                    return focusNextOption();
                                case keyCodes.SPACE:
                                case keyCodes.ENTER:
                                    var option = $mdUtil.getClosest(ev.target, 'md-option');
                                    if (option) {
                                        dropDown.triggerHandler({
                                            type: 'click',
                                            target: option
                                        });
                                        ev.preventDefault();
                                    }
                                    checkCloseMenu(ev);
                                    break;
                                case keyCodes.TAB:
                                case keyCodes.ESCAPE:
                                    ev.stopPropagation();
                                    ev.preventDefault();
                                    opts.restoreFocus = true;
                                    $mdUtil.nextTick($mdSelect.hide, true);
                                    break;
                                default:
                                    if (ev.keyCode >= 31 && ev.keyCode <= 90) {
                                        var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
                                        opts.focusedNode = optNode || opts.focusedNode;
                                        optNode && optNode.focus();
                                    }
                            }
                        }

                        function focusOption(direction) {
                            var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
                            var index = optionsArray.indexOf(opts.focusedNode);

                            var newOption;

                            do {
                                if (index === -1) {
                                    // We lost the previously focused element, reset to first option
                                    index = 0;
                                } else if (direction === 'next' && index < optionsArray.length - 1) {
                                    index++;
                                } else if (direction === 'prev' && index > 0) {
                                    index--;
                                }
                                newOption = optionsArray[index];
                                if (newOption.hasAttribute('disabled')) newOption = undefined;
                            } while (!newOption && index < optionsArray.length - 1 && index > 0);
                            newOption && newOption.focus();
                            opts.focusedNode = newOption;
                        }

                        function focusNextOption() {
                            focusOption('next');
                        }

                        function focusPrevOption() {
                            focusOption('prev');
                        }

                        function checkCloseMenu(ev) {
                            if (ev && (ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
                            if (mouseOnScrollbar()) return;

                            var option = $mdUtil.getClosest(ev.target, 'md-option');
                            if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                if (!selectCtrl.isMultiple) {
                                    opts.restoreFocus = true;

                                    $mdUtil.nextTick(function () {
                                        $mdSelect.hide(selectCtrl.ngModel.$viewValue);
                                    }, true);
                                }
                            }
                            /**
                             * check if the mouseup event was on a scrollbar
                             */
                            function mouseOnScrollbar() {
                                var clickOnScrollbar = false;
                                if (ev && (ev.currentTarget.children.length > 0)) {
                                    var child = ev.currentTarget.children[0];
                                    var hasScrollbar = child.scrollHeight > child.clientHeight;
                                    if (hasScrollbar && child.children.length > 0) {
                                        var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
                                        if (relPosX > child.querySelector('md-option').offsetWidth)
                                            clickOnScrollbar = true;
                                    }
                                }
                                return clickOnScrollbar;
                            }
                        }
                    }

                }

                /**
                 * To notify listeners that the Select menu has closed,
                 * trigger the [optional] user-defined expression
                 */
                function announceClosed(opts) {
                    var mdSelect = opts.selectCtrl;
                    if (mdSelect) {
                        var menuController = opts.selectEl.controller('mdSelectMenu');
                        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
                        mdSelect.triggerClose();
                    }
                }


                /**
                 * Calculate the
                 */
                function calculateMenuPositions(scope, element, opts) {
                    var
                        containerNode = element[0],
                        targetNode = opts.target[0].children[0], // target the label
                        parentNode = $document[0].body,
                        selectNode = opts.selectEl[0],
                        contentNode = opts.contentEl[0],
                        parentRect = parentNode.getBoundingClientRect(),
                        targetRect = targetNode.getBoundingClientRect(),
                        shouldOpenAroundTarget = false,
                        bounds = {
                            left: parentRect.left + SELECT_EDGE_MARGIN,
                            top: SELECT_EDGE_MARGIN,
                            bottom: parentRect.height - SELECT_EDGE_MARGIN,
                            right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
                        },
                        spaceAvailable = {
                            top: targetRect.top - bounds.top,
                            left: targetRect.left - bounds.left,
                            right: bounds.right - (targetRect.left + targetRect.width),
                            bottom: bounds.bottom - (targetRect.top + targetRect.height)
                        },
                        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
                        selectedNode = selectNode.querySelector('md-option[selected]'),
                        optionNodes = selectNode.getElementsByTagName('md-option'),
                        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
                        isScrollable = calculateScrollable(element, contentNode),
                        centeredNode;

                    var loading = isPromiseLike(opts.loadingAsync);
                    if (!loading) {
                        // If a selected node, center around that
                        if (selectedNode) {
                            centeredNode = selectedNode;
                            // If there are option groups, center around the first option group
                        } else if (optgroupNodes.length) {
                            centeredNode = optgroupNodes[0];
                            // Otherwise - if we are not loading async - center around the first optionNode
                        } else if (optionNodes.length) {
                            centeredNode = optionNodes[0];
                            // In case there are no options, center on whatever's in there... (eg progress indicator)
                        } else {
                            centeredNode = contentNode.firstElementChild || contentNode;
                        }
                    } else {
                        // If loading, center on progress indicator
                        centeredNode = contentNode.firstElementChild || contentNode;
                    }

                    if (contentNode.offsetWidth > maxWidth) {
                        contentNode.style['max-width'] = maxWidth + 'px';
                    } else {
                        contentNode.style.maxWidth = null;
                    }
                    if (shouldOpenAroundTarget) {
                        contentNode.style['min-width'] = targetRect.width + 'px';
                    }

                    // Remove padding before we compute the position of the menu
                    if (isScrollable) {
                        selectNode.classList.add('_md-overflow');
                    }

                    var focusedNode = centeredNode;
                    if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
                        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
                        centeredNode = focusedNode;
                    }
                    // Cache for autoFocus()
                    opts.focusedNode = focusedNode;

                    // Get the selectMenuRect *after* max-width is possibly set above
                    containerNode.style.display = 'block';
                    var selectMenuRect = selectNode.getBoundingClientRect();
                    var centeredRect = getOffsetRect(centeredNode);

                    if (centeredNode) {
                        var centeredStyle = $window.getComputedStyle(centeredNode);
                        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
                        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
                    }

                    if (isScrollable) {
                        var scrollBuffer = contentNode.offsetHeight / 2;
                        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;

                        if (spaceAvailable.top < scrollBuffer) {
                            contentNode.scrollTop = Math.min(
                                centeredRect.top,
                                contentNode.scrollTop + scrollBuffer - spaceAvailable.top
                            );
                        } else if (spaceAvailable.bottom < scrollBuffer) {
                            contentNode.scrollTop = Math.max(
                                centeredRect.top + centeredRect.height - selectMenuRect.height,
                                contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
                            );
                        }
                    }

                    var left, top, transformOrigin, minWidth;
                    if (shouldOpenAroundTarget) {
                        left = targetRect.left;
                        top = targetRect.top + targetRect.height;
                        transformOrigin = '50% 0';
                        if (top + selectMenuRect.height > bounds.bottom) {
                            top = targetRect.top - selectMenuRect.height;
                            transformOrigin = '50% 100%';
                        }
                    } else {
                        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
                        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
                            centeredRect.top + contentNode.scrollTop) + 2;

                        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
                            (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';

                        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);
                    }

                    // Keep left and top within the window
                    var containerRect = containerNode.getBoundingClientRect();
                    var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
                    var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;

                    return {
                        container: {
                            element: angular.element(containerNode),
                            styles: {
                                left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
                                top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
                                'min-width': minWidth
                            }
                        },
                        dropDown: {
                            element: angular.element(selectNode),
                            styles: {
                                transformOrigin: transformOrigin,
                                transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
                            }
                        }
                    };

                }

            }

            function isPromiseLike(obj) {
                return obj && angular.isFunction(obj.then);
            }

            function clamp(min, n, max) {
                return Math.max(min, Math.min(n, max));
            }

            function getOffsetRect(node) {
                return node ? {
                    left: node.offsetLeft,
                    top: node.offsetTop,
                    width: node.offsetWidth,
                    height: node.offsetHeight
                } : { left: 0, top: 0, width: 0, height: 0 };
            }

            function calculateScrollable(element, contentNode) {
                var isScrollable = false;

                try {
                    var oldDisplay = element[0].style.display;

                    // Set the element's display to block so that this calculation is correct
                    element[0].style.display = 'block';

                    isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;

                    // Reset it back afterwards
                    element[0].style.display = oldDisplay;
                } finally {
                    // Nothing to do
                }
                return isScrollable;
            }
        }
        SelectProvider.$inject = ["$$interimElementProvider"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.showHide
         */

        // Add additional handlers to ng-show and ng-hide that notify directives
        // contained within that they should recompute their size.
        // These run in addition to Angular's built-in ng-hide and ng-show directives.
        angular.module('material.components.showHide', [
            'material.core'
        ])
            .directive('ngShow', createDirective('ngShow', true))
            .directive('ngHide', createDirective('ngHide', false));


        function createDirective(name, targetValue) {
            return ['$mdUtil', function ($mdUtil) {
                return {
                    restrict: 'A',
                    multiElement: true,
                    link: function ($scope, $element, $attr) {
                        var unregister = $scope.$on('$md-resize-enable', function () {
                            unregister();

                            $scope.$watch($attr[name], function (value) {
                                if (!!value === targetValue) {
                                    $mdUtil.nextTick(function () {
                                        $scope.$broadcast('$md-resize');
                                    });
                                    $mdUtil.dom.animator.waitTransitionEnd($element).then(function () {
                                        $scope.$broadcast('$md-resize');
                                    });
                                }
                            });
                        });
                    }
                };
            }];
        }
    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.sidenav
         *
         * @description
         * A Sidenav QP component.
         */
        angular
            .module('material.components.sidenav', [
                'material.core',
                'material.components.backdrop'
            ])
            .factory('$mdSidenav', SidenavService)
            .directive('mdSidenav', SidenavDirective)
            .directive('mdSidenavFocus', SidenavFocusDirective)
            .controller('$mdSidenavController', SidenavController);


        /**
         * @ngdoc service
         * @name $mdSidenav
         * @module material.components.sidenav
         *
         * @description
         * `$mdSidenav` makes it easy to interact with multiple sidenavs
         * in an app.
         *
         * @usage
         * <hljs lang="js">
         * // Async lookup for sidenav instance; will resolve when the instance is available
         * $mdSidenav(componentId).then(function(instance) {
         *   $log.debug( componentId + "is now ready" );
         * });
         * // Async toggle the given sidenav;
         * // when instance is known ready and lazy lookup is not needed.
         * $mdSidenav(componentId)
         *    .toggle()
         *    .then(function(){
         *      $log.debug('toggled');
         *    });
         * // Async open the given sidenav
         * $mdSidenav(componentId)
         *    .open()
         *    .then(function(){
         *      $log.debug('opened');
         *    });
         * // Async close the given sidenav
         * $mdSidenav(componentId)
         *    .close()
         *    .then(function(){
         *      $log.debug('closed');
         *    });
         * // Sync check to see if the specified sidenav is set to be open
         * $mdSidenav(componentId).isOpen();
         * // Sync check to whether given sidenav is locked open
         * // If this is true, the sidenav will be open regardless of close()
         * $mdSidenav(componentId).isLockedOpen();
         * </hljs>
         */
        function SidenavService($mdComponentRegistry, $q) {
            return function (handle) {

                // Lookup the controller instance for the specified sidNav instance
                var self;
                var errorMsg = "SideNav '" + handle + "' is not available!";
                var instance = $mdComponentRegistry.get(handle);

                if (!instance) {
                    $mdComponentRegistry.notFoundError(handle);
                }

                return self = {
                    // -----------------
                    // Sync methods
                    // -----------------
                    isOpen: function () {
                        return instance && instance.isOpen();
                    },
                    isLockedOpen: function () {
                        return instance && instance.isLockedOpen();
                    },
                    // -----------------
                    // Async methods
                    // -----------------
                    toggle: function () {
                        return instance ? instance.toggle() : $q.reject(errorMsg);
                    },
                    open: function () {
                        return instance ? instance.open() : $q.reject(errorMsg);
                    },
                    close: function () {
                        return instance ? instance.close() : $q.reject(errorMsg);
                    },
                    then: function (callbackFn) {
                        var promise = instance ? $q.when(instance) : waitForInstance();
                        return promise.then(callbackFn || angular.noop);
                    }
                };

                /**
                 * Deferred lookup of component instance using $component registry
                 */
                function waitForInstance() {
                    return $mdComponentRegistry
                        .when(handle)
                        .then(function (it) {
                            instance = it;
                            return it;
                        });
                }
            };
        }
        SidenavService.$inject = ["$mdComponentRegistry", "$q"];
        /**
         * @ngdoc directive
         * @name mdSidenavFocus
         * @module material.components.sidenav
         *
         * @restrict A
         *
         * @description
         * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
         * This is completely optional, as the sidenav itself is focused by default.
         *
         * @usage
         * <hljs lang="html">
         * <md-sidenav>
         *   <form>
         *     <md-input-container>
         *       <label for="testInput">Label</label>
         *       <input id="testInput" type="text" md-sidenav-focus>
         *     </md-input-container>
         *   </form>
         * </md-sidenav>
         * </hljs>
         **/
        function SidenavFocusDirective() {
            return {
                restrict: 'A',
                require: '^mdSidenav',
                link: function (scope, element, attr, sidenavCtrl) {
                    // @see $mdUtil.findFocusTarget(...)
                }
            };
        }
        /**
         * @ngdoc directive
         * @name mdSidenav
         * @module material.components.sidenav
         * @restrict E
         *
         * @description
         *
         * A Sidenav component that can be opened and closed programatically.
         *
         * By default, upon opening it will slide out on top of the main content area.
         *
         * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
         * It can be overridden with the `md-autofocus` directive on the child element you want focused.
         *
         * @usage
         * <hljs lang="html">
         * <div layout="row" ng-controller="MyController">
         *   <md-sidenav md-component-id="left" class="md-sidenav-left">
         *     Left Nav!
         *   </md-sidenav>
         *
         *   <md-content>
         *     Center Content
         *     <md-button ng-click="openLeftMenu()">
         *       Open Left Menu
         *     </md-button>
         *   </md-content>
         *
         *   <md-sidenav md-component-id="right"
         *     md-is-locked-open="$mdMedia('min-width: 333px')"
         *     class="md-sidenav-right">
         *     <form>
         *       <md-input-container>
         *         <label for="testInput">Test input</label>
         *         <input id="testInput" type="text"
         *                ng-model="data" md-autofocus>
         *       </md-input-container>
         *     </form>
         *   </md-sidenav>
         * </div>
         * </hljs>
         *
         * <hljs lang="js">
         * var app = angular.module('myApp', ['ngMaterial']);
         * app.controller('MyController', function($scope, $mdSidenav) {
         *   $scope.openLeftMenu = function() {
         *     $mdSidenav('left').toggle();
         *   };
         * });
         * </hljs>
         *
         * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
         * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
         * @param {string=} md-component-id componentId to use with $mdSidenav service.
         * @param {expression=} md-is-locked-open When this expression evalutes to true,
         * the sidenav 'locks open': it falls into the content's flow instead
         * of appearing over it. This overrides the `md-is-open` attribute.
         *
         * The $mdMedia() servic  e is exposed to the is-locked-open attribute, which
         * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
         * Examples:
         *
         *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
         *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
         *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
         */
        function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $animate, $compile, $parse, $log, $q, $document) {
            return {
                restrict: 'E',
                scope: {
                    isOpen: '=?mdIsOpen'
                },
                controller: '$mdSidenavController',
                compile: function (element) {
                    element.addClass('_md-closed');
                    element.attr('tabIndex', '-1');
                    return postLink;
                }
            };

            /**
             * Directive Post Link function...
             */
            function postLink(scope, element, attr, sidenavCtrl) {
                var lastParentOverFlow;
                var backdrop;
                var triggeringElement = null;
                var promise = $q.when(true);
                var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
                var isLocked = function () {
                    return isLockedOpenParsed(scope.$parent, {
                        $media: function (arg) {
                            $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
                            return $mdMedia(arg);
                        },
                        $mdMedia: $mdMedia
                    });
                };

                // Only create the backdrop if the backdrop isn't disabled.
                if (!angular.isDefined(attr.mdDisableBackdrop)) {
                    backdrop = $mdUtil.createBackdrop(scope, "_md-sidenav-backdrop md-opaque ng-enter");
                }

                $mdTheming(element);

                // The backdrop should inherit the sidenavs theme,
                // because the backdrop will take its parent theme by default.
                if (backdrop) $mdTheming.inherit(backdrop, element);

                element.on('$destroy', function () {
                    backdrop && backdrop.remove();
                    sidenavCtrl.destroy();
                });

                scope.$on('$destroy', function () {
                    backdrop && backdrop.remove()
                });

                scope.$watch(isLocked, updateIsLocked);
                scope.$watch('isOpen', updateIsOpen);


                // Publish special accessor for the Controller instance
                sidenavCtrl.$toggleOpen = toggleOpen;

                /**
                 * Toggle the DOM classes to indicate `locked`
                 * @param isLocked
                 */
                function updateIsLocked(isLocked, oldValue) {
                    scope.isLockedOpen = isLocked;
                    if (isLocked === oldValue) {
                        element.toggleClass('_md-locked-open', !!isLocked);
                    } else {
                        $animate[isLocked ? 'addClass' : 'removeClass'](element, '_md-locked-open');
                    }
                    if (backdrop) {
                        backdrop.toggleClass('_md-locked-open', !!isLocked);
                    }
                }

                /**
                 * Toggle the SideNav view and attach/detach listeners
                 * @param isOpen
                 */
                function updateIsOpen(isOpen) {
                    // Support deprecated md-sidenav-focus attribute as fallback
                    var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element, '[md-sidenav-focus]') || element;
                    var parent = element.parent();

                    parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
                    if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);

                    if (isOpen) {
                        // Capture upon opening..
                        triggeringElement = $document[0].activeElement;
                    }

                    disableParentScroll(isOpen);

                    return promise = $q.all([
                        isOpen && backdrop ? $animate.enter(backdrop, parent) :
                            backdrop ? $animate.leave(backdrop) : $q.when(true),
                        $animate[isOpen ? 'removeClass' : 'addClass'](element, '_md-closed')
                    ])
                        .then(function () {
                            // Perform focus when animations are ALL done...
                            if (scope.isOpen) {
                                focusEl && focusEl.focus();
                            }
                        });
                }

                /**
                 * Prevent parent scrolling (when the SideNav is open)
                 */
                function disableParentScroll(disabled) {
                    var parent = element.parent();
                    if (disabled && !lastParentOverFlow) {

                        lastParentOverFlow = parent.css('overflow');
                        parent.css('overflow', 'hidden');

                    } else if (angular.isDefined(lastParentOverFlow)) {

                        parent.css('overflow', lastParentOverFlow);
                        lastParentOverFlow = undefined;

                    }
                }

                /**
                 * Toggle the sideNav view and publish a promise to be resolved when
                 * the view animation finishes.
                 *
                 * @param isOpen
                 * @returns {*}
                 */
                function toggleOpen(isOpen) {
                    if (scope.isOpen == isOpen) {

                        return $q.when(true);

                    } else {
                        return $q(function (resolve) {
                            // Toggle value to force an async `updateIsOpen()` to run
                            scope.isOpen = isOpen;

                            $mdUtil.nextTick(function () {
                                // When the current `updateIsOpen()` animation finishes
                                promise.then(function (result) {

                                    if (!scope.isOpen) {
                                        // reset focus to originating element (if available) upon close
                                        triggeringElement && triggeringElement.focus();
                                        triggeringElement = null;
                                    }

                                    resolve(result);
                                });
                            });

                        });

                    }
                }

                /**
                 * Auto-close sideNav when the `escape` key is pressed.
                 * @param evt
                 */
                function onKeyDown(ev) {
                    var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
                    return isEscape ? close(ev) : $q.when(true);
                }

                /**
                 * With backdrop `clicks` or `escape` key-press, immediately
                 * apply the CSS close transition... Then notify the controller
                 * to close() and perform its own actions.
                 */
                function close(ev) {
                    ev.preventDefault();

                    return sidenavCtrl.close();
                }

            }
        }
        SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$animate", "$compile", "$parse", "$log", "$q", "$document"];

        /*
         * @private
         * @ngdoc controller
         * @name SidenavController
         * @module material.components.sidenav
         *
         */
        function SidenavController($scope, $element, $attrs, $mdComponentRegistry, $q) {

            var self = this;

            // Use Default internal method until overridden by directive postLink

            // Synchronous getters
            self.isOpen = function () { return !!$scope.isOpen; };
            self.isLockedOpen = function () { return !!$scope.isLockedOpen; };

            // Async actions
            self.open = function () { return self.$toggleOpen(true); };
            self.close = function () { return self.$toggleOpen(false); };
            self.toggle = function () { return self.$toggleOpen(!$scope.isOpen); };
            self.$toggleOpen = function (value) { return $q.when($scope.isOpen = value); };

            self.destroy = $mdComponentRegistry.register(self, $attrs.mdComponentId);
        }
        SidenavController.$inject = ["$scope", "$element", "$attrs", "$mdComponentRegistry", "$q"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.slider
         */
        angular.module('material.components.slider', [
            'material.core'
        ])
            .directive('mdSlider', SliderDirective)
            .directive('mdSliderContainer', SliderContainerDirective);

        /**
         * @ngdoc directive
         * @name mdSliderContainer
         * @module material.components.slider
         * @restrict E
         * @description
         * The `<md-slider-container>` contains slider with two other elements.
         *
         *
         * @usage
         * <h4>Normal Mode</h4>
         * <hljs lang="html">
         * </hljs>
         */
        function SliderContainerDirective() {
            return {
                controller: function () { },
                compile: function (elem) {
                    var slider = elem.find('md-slider');

                    if (!slider) {
                        return;
                    }

                    var vertical = slider.attr('md-vertical');

                    if (vertical !== undefined) {
                        elem.attr('md-vertical', '');
                    }

                    if (!slider.attr('flex')) {
                        slider.attr('flex', '');
                    }

                    return function (scope, element, attr, ctrl) {

                        // We have to manually stop the $watch on ngDisabled because it exists
                        // on the parent scope, and won't be automatically destroyed when
                        // the component is destroyed.
                        function setDisable(value) {
                            element.children().attr('disabled', value);
                            element.find('input').attr('disabled', value);
                        }

                        var stopDisabledWatch = angular.noop;
                        if (attr.disabled) {
                            setDisable(true);
                        } else if (attr.ngDisabled) {
                            stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
                                setDisable(value);
                            });
                        }

                        scope.$on('$destroy', function () {
                            stopDisabledWatch();
                        });

                        var initialMaxWidth;

                        ctrl.fitInputWidthToTextLength = function (length) {
                            var input = element.find('md-input-container');
                            var computedStyle = getComputedStyle(input[0]);
                            var minWidth = parseInt(computedStyle['min-width']);
                            var padding = parseInt(computedStyle['padding']) * 2;
                            initialMaxWidth = initialMaxWidth || parseInt(computedStyle['max-width']);

                            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

                            input.css('max-width', newMaxWidth + 'px');
                        };
                    }
                }
            }
        }

        /**
         * @ngdoc directive
         * @name mdSlider
         * @module material.components.slider
         * @restrict E
         * @description
         * The `<md-slider>` component allows the user to choose from a range of
         * values.
         *
         * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
         * the slider is in the accent color by default. The primary color palette may be used with
         * the `md-primary` class.
         *
         * It has two modes: 'normal' mode, where the user slides between a wide range
         * of values, and 'discrete' mode, where the user slides between only a few
         * select values.
         *
         * To enable discrete mode, add the `md-discrete` attribute to a slider,
         * and use the `step` attribute to change the distance between
         * values the user is allowed to pick.
         *
         * @usage
         * <h4>Normal Mode</h4>
         * <hljs lang="html">
         * <md-slider ng-model="myValue" min="5" max="500">
         * </md-slider>
         * </hljs>
         * <h4>Discrete Mode</h4>
         * <hljs lang="html">
         * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
         * </md-slider>
         * </hljs>
         *
         * @param {boolean=} md-discrete Whether to enable discrete mode.
         * @param {number=} step The distance between values the user is allowed to pick. Default 1.
         * @param {number=} min The minimum value the user is allowed to pick. Default 0.
         * @param {number=} max The maximum value the user is allowed to pick. Default 100.
         * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
         */
        function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
            return {
                scope: {},
                require: ['?ngModel', '?^mdSliderContainer'],
                template: '<div class="_md-slider-wrapper">' +
                    '<div class="_md-slider-content">' +
                    '<div class="_md-track-container">' +
                    '<div class="_md-track"></div>' +
                    '<div class="_md-track _md-track-fill"></div>' +
                    '<div class="_md-track-ticks"></div>' +
                    '</div>' +
                    '<div class="_md-thumb-container">' +
                    '<div class="_md-thumb"></div>' +
                    '<div class="_md-focus-thumb"></div>' +
                    '<div class="_md-focus-ring"></div>' +
                    '<div class="_md-sign">' +
                    '<span class="_md-thumb-text"></span>' +
                    '</div>' +
                    '<div class="_md-disabled-thumb"></div>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                compile: compile
            };

            // **********************************************************
            // Private Methods
            // **********************************************************

            function compile(tElement, tAttrs) {
                var wrapper = angular.element(tElement[0].getElementsByClassName('_md-slider-wrapper'));

                var tabIndex = tAttrs.tabindex || 0;
                wrapper.attr('tabindex', tabIndex);

                if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

                wrapper.attr('role', 'slider');

                $mdAria.expect(tElement, 'aria-label');

                return postLink;
            }

            function postLink(scope, element, attr, ctrls) {
                $mdTheming(element);
                var ngModelCtrl = ctrls[0] || {
                    // Mock ngModelController if it doesn't exist to give us
                    // the minimum functionality needed
                    $setViewValue: function (val) {
                        this.$viewValue = val;
                        this.$viewChangeListeners.forEach(function (cb) { cb(); });
                    },
                    $parsers: [],
                    $formatters: [],
                    $viewChangeListeners: []
                };

                var containerCtrl = ctrls[1];
                var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
                var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
                    return element[0].hasAttribute('disabled');
                };

                var thumb = angular.element(element[0].querySelector('._md-thumb'));
                var thumbText = angular.element(element[0].querySelector('._md-thumb-text'));
                var thumbContainer = thumb.parent();
                var trackContainer = angular.element(element[0].querySelector('._md-track-container'));
                var activeTrack = angular.element(element[0].querySelector('._md-track-fill'));
                var tickContainer = angular.element(element[0].querySelector('._md-track-ticks'));
                var wrapper = angular.element(element[0].getElementsByClassName('_md-slider-wrapper'));
                var content = angular.element(element[0].getElementsByClassName('_md-slider-content'));
                var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

                // Default values, overridable by attrs
                var DEFAULT_ROUND = 3;
                var vertical = angular.isDefined(attr.mdVertical);
                var discrete = angular.isDefined(attr.mdDiscrete);
                angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
                angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
                angular.isDefined(attr.step) ? attr.$observe('step', updateStep) : updateStep(1);
                angular.isDefined(attr.round) ? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);

                // We have to manually stop the $watch on ngDisabled because it exists
                // on the parent scope, and won't be automatically destroyed when
                // the component is destroyed.
                var stopDisabledWatch = angular.noop;
                if (attr.ngDisabled) {
                    stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
                }

                $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

                scope.mouseActive = false;

                wrapper
                    .on('keydown', keydownListener)
                    .on('mousedown', mouseDownListener)
                    .on('focus', focusListener)
                    .on('blur', blurListener)
                    .on('$md.pressdown', onPressDown)
                    .on('$md.pressup', onPressUp)
                    .on('$md.dragstart', onDragStart)
                    .on('$md.drag', onDrag)
                    .on('$md.dragend', onDragEnd);

                // On resize, recalculate the slider's dimensions and re-render
                function updateAll() {
                    refreshSliderDimensions();
                    ngModelRender();
                }
                setTimeout(updateAll, 0);

                var debouncedUpdateAll = $$rAF.throttle(updateAll);
                angular.element($window).on('resize', debouncedUpdateAll);

                scope.$on('$destroy', function () {
                    angular.element($window).off('resize', debouncedUpdateAll);
                });

                ngModelCtrl.$render = ngModelRender;
                ngModelCtrl.$viewChangeListeners.push(ngModelRender);
                ngModelCtrl.$formatters.push(minMaxValidator);
                ngModelCtrl.$formatters.push(stepValidator);

                /**
                 * Attributes
                 */
                var min;
                var max;
                var step;
                var round;

                function updateMin(value) {
                    min = parseFloat(value);
                    element.attr('aria-valuemin', value);
                    updateAll();
                }

                function updateMax(value) {
                    max = parseFloat(value);
                    element.attr('aria-valuemax', value);
                    updateAll();
                }

                function updateStep(value) {
                    step = parseFloat(value);
                }

                function updateRound(value) {
                    // Set max round digits to 6, after 6 the input uses scientific notation
                    round = minMaxValidator(parseInt(value), 0, 6);
                }

                function updateAriaDisabled() {
                    element.attr('aria-disabled', !!isDisabled());
                }

                // Draw the ticks with canvas.
                // The alternative to drawing ticks with canvas is to draw one element for each tick,
                // which could quickly become a performance bottleneck.
                var tickCanvas, tickCtx;

                function redrawTicks() {
                    if (!discrete || isDisabled()) return;
                    if (angular.isUndefined(step)) return;

                    if (step <= 0) {
                        var msg = 'Slider step value must be greater than zero when in discrete mode';
                        $log.error(msg);
                        throw new Error(msg);
                    }

                    var numSteps = Math.floor((max - min) / step);
                    if (!tickCanvas) {
                        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
                        tickContainer.append(tickCanvas);

                        tickCtx = tickCanvas[0].getContext('2d');
                    }

                    var dimensions = getSliderDimensions();

                    // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
                    if (dimensions && !dimensions.height && !dimensions.width) {
                        refreshSliderDimensions();
                        dimensions = sliderDimensions;
                    }

                    tickCanvas[0].width = dimensions.width;
                    tickCanvas[0].height = dimensions.height;

                    var distance;
                    for (var i = 0; i <= numSteps; i++) {
                        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
                        tickCtx.fillStyle = trackTicksStyle.color || 'black';

                        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

                        tickCtx.fillRect(vertical ? 0 : distance - 1,
                            vertical ? distance - 1 : 0,
                            vertical ? dimensions.width : 2,
                            vertical ? 2 : dimensions.height);
                    }
                }

                function clearTicks() {
                    if (tickCanvas && tickCtx) {
                        var dimensions = getSliderDimensions();
                        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
                    }
                }

                /**
                 * Refreshing Dimensions
                 */
                var sliderDimensions = {};
                refreshSliderDimensions();

                function refreshSliderDimensions() {
                    sliderDimensions = trackContainer[0].getBoundingClientRect();
                }

                function getSliderDimensions() {
                    throttledRefreshDimensions();
                    return sliderDimensions;
                }

                /**
                 * left/right/up/down arrow listener
                 */
                function keydownListener(ev) {
                    if (isDisabled()) return;

                    var changeAmount;
                    if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
                        changeAmount = -step;
                    } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
                        changeAmount = step;
                    }
                    if (changeAmount) {
                        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
                            changeAmount *= 4;
                        }
                        ev.preventDefault();
                        ev.stopPropagation();
                        scope.$evalAsync(function () {
                            setModelValue(ngModelCtrl.$viewValue + changeAmount);
                        });
                    }
                }

                function mouseDownListener() {
                    redrawTicks();

                    scope.mouseActive = true;
                    wrapper.removeClass('md-focused');

                    $timeout(function () {
                        scope.mouseActive = false;
                    }, 100);
                }

                function focusListener() {
                    if (scope.mouseActive === false) {
                        wrapper.addClass('md-focused');
                    }
                }

                function blurListener() {
                    wrapper.removeClass('md-focused');
                    element.removeClass('_md-active');
                    clearTicks();
                }

                /**
                 * ngModel setters and validators
                 */
                function setModelValue(value) {
                    ngModelCtrl.$setViewValue(minMaxValidator(stepValidator(value)));
                }

                function ngModelRender() {
                    if (isNaN(ngModelCtrl.$viewValue)) {
                        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
                    }

                    ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

                    var percent = (ngModelCtrl.$viewValue - min) / (max - min);
                    scope.modelValue = ngModelCtrl.$viewValue;
                    element.attr('aria-valuenow', ngModelCtrl.$viewValue);
                    setSliderPercent(percent);
                    thumbText.text(ngModelCtrl.$viewValue);
                }

                function minMaxValidator(value, minValue, maxValue) {
                    if (angular.isNumber(value)) {
                        minValue = angular.isNumber(minValue) ? minValue : min;
                        maxValue = angular.isNumber(maxValue) ? maxValue : max;

                        return Math.max(minValue, Math.min(maxValue, value));
                    }
                }

                function stepValidator(value) {
                    if (angular.isNumber(value)) {
                        var formattedValue = (Math.round((value - min) / step) * step + min);
                        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

                        if (containerCtrl && containerCtrl.fitInputWidthToTextLength) {
                            $mdUtil.debounce(function () {
                                containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
                            }, 100)();
                        }

                        return formattedValue;
                    }
                }

                /**
                 * @param percent 0-1
                 */
                function setSliderPercent(percent) {

                    percent = clamp(percent);

                    var thumbPosition = (percent * 100) + '%';

                    thumbContainer.css(vertical ? 'bottom' : 'left', thumbPosition);
                    activeTrack.css(vertical ? 'height' : 'width', thumbPosition);

                    element.toggleClass('_md-min', percent === 0);
                    element.toggleClass('_md-max', percent === 1);
                }

                /**
                 * Slide listeners
                 */
                var isDragging = false;

                function onPressDown(ev) {
                    if (isDisabled()) return;

                    element.addClass('_md-active');
                    element[0].focus();
                    refreshSliderDimensions();

                    var exactVal = percentToValue(positionToPercent(vertical ? ev.pointer.y : ev.pointer.x));
                    var closestVal = minMaxValidator(stepValidator(exactVal));
                    scope.$apply(function () {
                        setModelValue(closestVal);
                        setSliderPercent(valueToPercent(closestVal));
                    });
                }

                function onPressUp(ev) {
                    if (isDisabled()) return;

                    element.removeClass('_md-dragging');

                    var exactVal = percentToValue(positionToPercent(vertical ? ev.pointer.y : ev.pointer.x));
                    var closestVal = minMaxValidator(stepValidator(exactVal));
                    scope.$apply(function () {
                        setModelValue(closestVal);
                        ngModelRender();
                    });
                }

                function onDragStart(ev) {
                    if (isDisabled()) return;
                    isDragging = true;

                    ev.stopPropagation();

                    element.addClass('_md-dragging');
                    setSliderFromEvent(ev);
                }

                function onDrag(ev) {
                    if (!isDragging) return;
                    ev.stopPropagation();
                    setSliderFromEvent(ev);
                }

                function onDragEnd(ev) {
                    if (!isDragging) return;
                    ev.stopPropagation();
                    isDragging = false;
                }

                function setSliderFromEvent(ev) {
                    // While panning discrete, update only the
                    // visual positioning but not the model value.
                    if (discrete) adjustThumbPosition(vertical ? ev.pointer.y : ev.pointer.x);
                    else doSlide(vertical ? ev.pointer.y : ev.pointer.x);
                }

                /**
                 * Slide the UI by changing the model value
                 * @param x
                 */
                function doSlide(x) {
                    scope.$evalAsync(function () {
                        setModelValue(percentToValue(positionToPercent(x)));
                    });
                }

                /**
                 * Slide the UI without changing the model (while dragging/panning)
                 * @param x
                 */
                function adjustThumbPosition(x) {
                    var exactVal = percentToValue(positionToPercent(x));
                    var closestVal = minMaxValidator(stepValidator(exactVal));
                    setSliderPercent(positionToPercent(x));
                    thumbText.text(closestVal);
                }

                /**
                 * Clamps the value to be between 0 and 1.
                 * @param {number} value The value to clamp.
                 * @returns {number}
                 */
                function clamp(value) {
                    return Math.max(0, Math.min(value || 0, 1));
                }

                /**
                 * Convert position on slider to percentage value of offset from beginning...
                 * @param position
                 * @returns {number}
                 */
                function positionToPercent(position) {
                    var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
                    var size = vertical ? sliderDimensions.height : sliderDimensions.width;
                    var calc = (position - offset) / size;

                    return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
                }

                /**
                 * Convert percentage offset on slide to equivalent model value
                 * @param percent
                 * @returns {*}
                 */
                function percentToValue(percent) {
                    return (min + percent * (max - min));
                }

                function valueToPercent(val) {
                    return (val - min) / (max - min);
                }
            }
        }
        SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.sticky
         * @description
         * Sticky effects for md
         *
         */
        angular
            .module('material.components.sticky', [
                'material.core',
                'material.components.content'
            ])
            .factory('$mdSticky', MdSticky);

        /**
         * @ngdoc service
         * @name $mdSticky
         * @module material.components.sticky
         *
         * @description
         * The `$mdSticky`service provides a mixin to make elements sticky.
         *
         * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
         * parameter, in the same scope as the actual element lives.
         *
         *
         * <h3>Notes</h3>
         * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
         * you should compile the clone yourself using the plain template.<br/><br/>
         * See the right usage below:
         * <hljs lang="js">
         *   angular.module('myModule')
         *     .directive('stickySelect', function($mdSticky, $compile) {
         *       var SELECT_TEMPLATE =
         *         '<md-select ng-model="selected">' +
         *           '<md-option>Option 1</md-option>' +
         *         '</md-select>';
         *
         *       return {
         *         restrict: 'E',
         *         replace: true,
         *         template: SELECT_TEMPLATE,
         *         link: function(scope,element) {
         *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
         *         }
         *       };
         *     });
         * </hljs>
         *
         * @usage
         * <hljs lang="js">
         *   angular.module('myModule')
         *     .directive('stickyText', function($mdSticky, $compile) {
         *       return {
         *         restrict: 'E',
         *         template: '<span>Sticky Text</span>',
         *         link: function(scope,element) {
         *           $mdSticky(scope, element);
         *         }
         *       };
         *     });
         * </hljs>
         *
         * @returns A `$mdSticky` function that takes three arguments:
         *   - `scope`
         *   - `element`: The element that will be 'sticky'
         *   - `elementClone`: A clone of the element, that will be shown
         *     when the user starts scrolling past the original element.
         *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
         */
        function MdSticky($document, $mdConstant, $$rAF, $mdUtil, $compile) {

            var browserStickySupport = checkStickySupport();

            /**
             * Registers an element as sticky, used internally by directives to register themselves
             */
            return function registerStickyElement(scope, element, stickyClone) {
                var contentCtrl = element.controller('mdContent');
                if (!contentCtrl) return;

                if (browserStickySupport) {
                    element.css({
                        position: browserStickySupport,
                        top: 0,
                        'z-index': 2
                    });
                } else {
                    var $$sticky = contentCtrl.$element.data('$$sticky');
                    if (!$$sticky) {
                        $$sticky = setupSticky(contentCtrl);
                        contentCtrl.$element.data('$$sticky', $$sticky);
                    }

                    // Compile our cloned element, when cloned in this service, into the given scope.
                    var cloneElement = stickyClone || $compile(element.clone())(scope);

                    var deregister = $$sticky.add(element, cloneElement);
                    scope.$on('$destroy', deregister);
                }
            };

            function setupSticky(contentCtrl) {
                var contentEl = contentCtrl.$element;

                // Refresh elements is very expensive, so we use the debounced
                // version when possible.
                var debouncedRefreshElements = $$rAF.throttle(refreshElements);

                // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
                // more reliable than `scroll` on android.
                setupAugmentedScrollEvents(contentEl);
                contentEl.on('$scrollstart', debouncedRefreshElements);
                contentEl.on('$scroll', onScroll);

                var self;
                return self = {
                    prev: null,
                    current: null, //the currently stickied item
                    next: null,
                    items: [],
                    add: add,
                    refreshElements: refreshElements
                };

                /***************
                 * Public
                 ***************/
                // Add an element and its sticky clone to this content's sticky collection
                function add(element, stickyClone) {
                    stickyClone.addClass('_md-sticky-clone');

                    var item = {
                        element: element,
                        clone: stickyClone
                    };
                    self.items.push(item);

                    $mdUtil.nextTick(function () {
                        contentEl.prepend(item.clone);
                    });

                    debouncedRefreshElements();

                    return function remove() {
                        self.items.forEach(function (item, index) {
                            if (item.element[0] === element[0]) {
                                self.items.splice(index, 1);
                                item.clone.remove();
                            }
                        });
                        debouncedRefreshElements();
                    };
                }

                function refreshElements() {
                    // Sort our collection of elements by their current position in the DOM.
                    // We need to do this because our elements' order of being added may not
                    // be the same as their order of display.
                    self.items.forEach(refreshPosition);
                    self.items = self.items.sort(function (a, b) {
                        return a.top < b.top ? -1 : 1;
                    });

                    // Find which item in the list should be active, 
                    // based upon the content's current scroll position
                    var item;
                    var currentScrollTop = contentEl.prop('scrollTop');
                    for (var i = self.items.length - 1; i >= 0; i--) {
                        if (currentScrollTop > self.items[i].top) {
                            item = self.items[i];
                            break;
                        }
                    }
                    setCurrentItem(item);
                }

                /***************
                 * Private
                 ***************/

                // Find the `top` of an item relative to the content element,
                // and also the height.
                function refreshPosition(item) {
                    // Find the top of an item by adding to the offsetHeight until we reach the 
                    // content element.
                    var current = item.element[0];
                    item.top = 0;
                    item.left = 0;
                    item.right = 0;
                    while (current && current !== contentEl[0]) {
                        item.top += current.offsetTop;
                        item.left += current.offsetLeft;
                        if (current.offsetParent) {
                            item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
                        }
                        current = current.offsetParent;
                    }
                    item.height = item.element.prop('offsetHeight');

                    var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
                    $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
                    $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
                }

                // As we scroll, push in and select the correct sticky element.
                function onScroll() {
                    var scrollTop = contentEl.prop('scrollTop');
                    var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);

                    // Store the previous scroll so we know which direction we are scrolling
                    onScroll.prevScrollTop = scrollTop;

                    //
                    // AT TOP (not scrolling)
                    //
                    if (scrollTop === 0) {
                        // If we're at the top, just clear the current item and return
                        setCurrentItem(null);
                        return;
                    }

                    //
                    // SCROLLING DOWN (going towards the next item)
                    //
                    if (isScrollingDown) {

                        // If we've scrolled down past the next item's position, sticky it and return
                        if (self.next && self.next.top <= scrollTop) {
                            setCurrentItem(self.next);
                            return;
                        }

                        // If the next item is close to the current one, push the current one up out of the way
                        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
                            translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
                            return;
                        }
                    }

                    //
                    // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
                    //
                    if (!isScrollingDown) {

                        // If we've scrolled up past the previous item's position, sticky it and return
                        if (self.current && self.prev && scrollTop < self.current.top) {
                            setCurrentItem(self.prev);
                            return;
                        }

                        // If the next item is close to the current one, pull the current one down into view
                        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
                            translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
                            return;
                        }
                    }

                    //
                    // Otherwise, just move the current item to the proper place (scrolling up or down)
                    //
                    if (self.current) {
                        translate(self.current, scrollTop);
                    }
                }

                function setCurrentItem(item) {
                    if (self.current === item) return;
                    // Deactivate currently active item
                    if (self.current) {
                        translate(self.current, null);
                        setStickyState(self.current, null);
                    }

                    // Activate new item if given
                    if (item) {
                        setStickyState(item, 'active');
                    }

                    self.current = item;
                    var index = self.items.indexOf(item);
                    // If index === -1, index + 1 = 0. It works out.
                    self.next = self.items[index + 1];
                    self.prev = self.items[index - 1];
                    setStickyState(self.next, 'next');
                    setStickyState(self.prev, 'prev');
                }

                function setStickyState(item, state) {
                    if (!item || item.state === state) return;
                    if (item.state) {
                        item.clone.attr('sticky-prev-state', item.state);
                        item.element.attr('sticky-prev-state', item.state);
                    }
                    item.clone.attr('sticky-state', state);
                    item.element.attr('sticky-state', state);
                    item.state = state;
                }

                function translate(item, amount) {
                    if (!item) return;
                    if (amount === null || amount === undefined) {
                        if (item.translateY) {
                            item.translateY = null;
                            item.clone.css($mdConstant.CSS.TRANSFORM, '');
                        }
                    } else {
                        item.translateY = amount;

                        $mdUtil.bidi(item.clone, $mdConstant.CSS.TRANSFORM,
                            'translate3d(' + item.left + 'px,' + amount + 'px,0)',
                            'translateY(' + amount + 'px)'
                        );
                    }
                }
            }

            // Function to check for browser sticky support
            function checkStickySupport($el) {
                var stickyProp;
                var testEl = angular.element('<div>');
                $document[0].body.appendChild(testEl[0]);

                var stickyProps = ['sticky', '-webkit-sticky'];
                for (var i = 0; i < stickyProps.length; ++i) {
                    testEl.css({ position: stickyProps[i], top: 0, 'z-index': 2 });
                    if (testEl.css('position') == stickyProps[i]) {
                        stickyProp = stickyProps[i];
                        break;
                    }
                }
                testEl.remove();
                return stickyProp;
            }

            // Android 4.4 don't accurately give scroll events.
            // To fix this problem, we setup a fake scroll event. We say:
            // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
            //   then send a `$scroll` event every animationFrame.
            // Additionally, we add $scrollstart and $scrollend events.
            function setupAugmentedScrollEvents(element) {
                var SCROLL_END_DELAY = 200;
                var isScrolling;
                var lastScrollTime;
                element.on('scroll touchmove', function () {
                    if (!isScrolling) {
                        isScrolling = true;
                        $$rAF.throttle(loopScrollEvent);
                        element.triggerHandler('$scrollstart');
                    }
                    element.triggerHandler('$scroll');
                    lastScrollTime = +$mdUtil.now();
                });

                function loopScrollEvent() {
                    if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
                        isScrolling = false;
                        element.triggerHandler('$scrollend');
                    } else {
                        element.triggerHandler('$scroll');
                        $$rAF.throttle(loopScrollEvent);
                    }
                }
            }

        }
        MdSticky.$inject = ["$document", "$mdConstant", "$$rAF", "$mdUtil", "$compile"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.swipe
         * @description Swipe module!
         */
        /**
         * @ngdoc directive
         * @module material.components.swipe
         * @name mdSwipeLeft
         *
         * @restrict A
         *
         * @description
         * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
         * left.
         *
         * @usage
         * <hljs lang="html">
         * <div md-swipe-left="onSwipeLeft()">Swipe me left!</div>
         * </hljs>
         */
        /**
         * @ngdoc directive
         * @module material.components.swipe
         * @name mdSwipeRight
         *
         * @restrict A
         *
         * @description
         * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
         * right.
         *
         * @usage
         * <hljs lang="html">
         * <div md-swipe-right="onSwipeRight()">Swipe me right!</div>
         * </hljs>
         */
        /**
         * @ngdoc directive
         * @module material.components.swipe
         * @name mdSwipeUp
         *
         * @restrict A
         *
         * @description
         * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
         * up.
         *
         * @usage
         * <hljs lang="html">
         * <div md-swipe-up="onSwipeUp()">Swipe me up!</div>
         * </hljs>
         */
        /**
         * @ngdoc directive
         * @module material.components.swipe
         * @name mdSwipeDown
         *
         * @restrict A
         *
         * @description
         * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
         * down.
         *
         * @usage
         * <hljs lang="html">
         * <div md-swipe-down="onSwipDown()">Swipe me down!</div>
         * </hljs>
         */

        angular.module('material.components.swipe', ['material.core'])
            .directive('mdSwipeLeft', getDirective('SwipeLeft'))
            .directive('mdSwipeRight', getDirective('SwipeRight'))
            .directive('mdSwipeUp', getDirective('SwipeUp'))
            .directive('mdSwipeDown', getDirective('SwipeDown'));

        function getDirective(name) {
            var directiveName = 'md' + name;
            var eventName = '$md.' + name.toLowerCase();


            DirectiveFactory.$inject = ["$parse"];
            return DirectiveFactory;

            /* @ngInject */
            function DirectiveFactory($parse) {
                return { restrict: 'A', link: postLink };

                function postLink(scope, element, attr) {
                    var fn = $parse(attr[directiveName]);
                    element.on(eventName, function (ev) {
                        scope.$apply(function () { fn(scope, { $event: ev }); });
                    });
                }
            }
        }



    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.subheader
         * @description
         * SubHeader module
         *
         *  Subheaders are special list tiles that delineate distinct sections of a
         *  list or grid list and are typically related to the current filtering or
         *  sorting criteria. Subheader tiles are either displayed inline with tiles or
         *  can be associated with content, for example, in an adjacent column.
         *
         *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
         *  pinned until pushed on or off screen by the next subheader. @see [Material
         *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
         *
         *  > To improve the visual grouping of content, use the system color for your subheaders.
         *
         */
        angular
            .module('material.components.subheader', [
                'material.core',
                'material.components.sticky'
            ])
            .directive('mdSubheader', MdSubheaderDirective);

        /**
         * @ngdoc directive
         * @name mdSubheader
         * @module material.components.subheader
         *
         * @restrict E
         *
         * @description
         * The `<md-subheader>` directive is a subheader for a section. By default it is sticky.
         * You can make it not sticky by applying the `md-no-sticky` class to the subheader.
         *
         *
         * @usage
         * <hljs lang="html">
         * <md-subheader>Online Friends</md-subheader>
         * </hljs>
         */

        function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil) {
            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                template: (
                    '<div class="md-subheader">' +
                    '  <div class="_md-subheader-inner">' +
                    '    <span class="_md-subheader-content"></span>' +
                    '  </div>' +
                    '</div>'
                ),
                link: function postLink(scope, element, attr, controllers, transclude) {
                    $mdTheming(element);
                    var outerHTML = element[0].outerHTML;

                    function getContent(el) {
                        return angular.element(el[0].querySelector('._md-subheader-content'));
                    }

                    // Transclude the user-given contents of the subheader
                    // the conventional way.
                    transclude(scope, function (clone) {
                        getContent(element).append(clone);
                    });

                    // Create another clone, that uses the outer and inner contents
                    // of the element, that will be 'stickied' as the user scrolls.
                    if (!element.hasClass('md-no-sticky')) {
                        transclude(scope, function (clone) {
                            // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
                            // compiled clone below will only be a comment tag (since they replace their elements with
                            // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
                            // DIV to ensure we have something $mdSticky can use
                            var wrapperHtml = '<div class="_md-subheader-wrapper">' + outerHTML + '</div>';
                            var stickyClone = $compile(wrapperHtml)(scope);

                            // Append the sticky
                            $mdSticky(scope, element, stickyClone);

                            // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
                            // attempting to create the clone
                            $mdUtil.nextTick(function () {
                                getContent(stickyClone).append(clone);
                            });
                        });
                    }
                }
            }
        }
        MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil"];

    })();
    (function () {
        "use strict";

        /**
         * @private
         * @ngdoc module
         * @name material.components.switch
         */

        angular.module('material.components.switch', [
            'material.core',
            'material.components.checkbox'
        ])
            .directive('mdSwitch', MdSwitch);

        /**
         * @private
         * @ngdoc directive
         * @module material.components.switch
         * @name mdSwitch
         * @restrict E
         *
         * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
         *
         * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
         * the switch is in the accent color by default. The primary color palette may be used with
         * the `md-primary` class.
         *
         * @param {string} ng-model Assignable angular expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {expression=} ng-true-value The value to which the expression should be set when selected.
         * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
         * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
         * @param {expression=} ng-disabled En/Disable based on the expression.
         * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
         * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
         *
         * @usage
         * <hljs lang="html">
         * <md-switch ng-model="isActive" aria-label="Finished?">
         *   Finished ?
         * </md-switch>
         *
         * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
         *   No Ink Effects
         * </md-switch>
         *
         * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
         *   Disabled
         * </md-switch>
         *
         * </hljs>
         */
        function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture) {
            var checkboxDirective = mdCheckboxDirective[0];

            return {
                restrict: 'E',
                priority: 210, // Run before ngAria
                transclude: true,
                template: '<div class="_md-container">' +
                    '<div class="_md-bar"></div>' +
                    '<div class="_md-thumb-container">' +
                    '<div class="_md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
                    '</div>' +
                    '</div>' +
                    '<div ng-transclude class="_md-label"></div>',
                require: '?ngModel',
                compile: mdSwitchCompile
            };

            function mdSwitchCompile(element, attr) {
                var checkboxLink = checkboxDirective.compile(element, attr);
                // No transition on initial load.
                element.addClass('_md-dragging');

                return function (scope, element, attr, ngModel) {
                    ngModel = ngModel || $mdUtil.fakeNgModel();

                    var disabledGetter = null;
                    if (attr.disabled != null) {
                        disabledGetter = function () { return true; };
                    } else if (attr.ngDisabled) {
                        disabledGetter = $parse(attr.ngDisabled);
                    }

                    var thumbContainer = angular.element(element[0].querySelector('._md-thumb-container'));
                    var switchContainer = angular.element(element[0].querySelector('._md-container'));
                    var labelContainer = angular.element(element[0].querySelector('._md-label'));

                    // no transition on initial load
                    $$rAF(function () {
                        element.removeClass('_md-dragging');
                    });

                    checkboxLink(scope, element, attr, ngModel);

                    if (disabledGetter) {
                        scope.$watch(disabledGetter, function (isDisabled) {
                            element.attr('tabindex', isDisabled ? -1 : 0);
                        });
                    }

                    attr.$observe('mdInvert', function (newValue) {
                        var isInverted = $mdUtil.parseAttributeBoolean(newValue);
                        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);
                        // Toggle a CSS class to update the margin.
                        element.toggleClass('md-inverted', isInverted);
                    });

                    // These events are triggered by setup drag
                    $mdGesture.register(switchContainer, 'drag');
                    switchContainer
                        .on('$md.dragstart', onDragStart)
                        .on('$md.drag', onDrag)
                        .on('$md.dragend', onDragEnd);

                    var drag;

                    function onDragStart(ev) {
                        // Don't go if the switch is disabled.
                        if (disabledGetter && disabledGetter(scope)) return;
                        ev.stopPropagation();

                        element.addClass('_md-dragging');
                        drag = { width: thumbContainer.prop('offsetWidth') };
                    }

                    function onDrag(ev) {
                        if (!drag) return;
                        ev.stopPropagation();
                        ev.srcEvent && ev.srcEvent.preventDefault();

                        var percent = ev.pointer.distanceX / drag.width;

                        //if checked, start from right. else, start from left
                        var translate = ngModel.$viewValue ? 1 + percent : percent;
                        // Make sure the switch stays inside its bounds, 0-1%
                        translate = Math.max(0, Math.min(1, translate));

                        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100 * translate) + '%,0,0)');
                        drag.translate = translate;
                    }

                    function onDragEnd(ev) {
                        if (!drag) return;
                        ev.stopPropagation();

                        element.removeClass('_md-dragging');
                        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');

                        // We changed if there is no distance (this is a click a click),
                        // or if the drag distance is >50% of the total.
                        var isChanged = ngModel.$viewValue ? drag.translate > 0.5 : drag.translate < 0.5;
                        if (isChanged) {
                            applyModelValue(!ngModel.$viewValue);
                        }
                        drag = null;
                    }

                    function applyModelValue(newValue) {
                        scope.$apply(function () {
                            ngModel.$setViewValue(newValue);
                            ngModel.$render();
                        });
                    }

                };
            }


        }
        MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.tabs
         * @description
         *
         *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
         *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
         *
         *  Features include support for:
         *
         *  - static or dynamic tabs,
         *  - responsive designs,
         *  - accessibility support (ARIA),
         *  - tab pagination,
         *  - external or internal tab content,
         *  - focus indicators and arrow-key navigations,
         *  - programmatic lookup and access to tab controllers, and
         *  - dynamic transitions through different tab contents.
         *
         */
        /*
         * @see js folder for tabs implementation
         */
        angular.module('material.components.tabs', [
            'material.core',
            'material.components.icon'
        ]);

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.toast
         * @description
         * Toast
         */
        angular.module('material.components.toast', [
            'material.core',
            'material.components.button'
        ])
            .directive('mdToast', MdToastDirective)
            .provider('$mdToast', MdToastProvider);

        /* @ngInject */
        function MdToastDirective($mdToast) {
            return {
                restrict: 'E',
                link: function postLink(scope, element, attr) {
                    // When navigation force destroys an interimElement, then
                    // listen and $destroy() that interim instance...
                    scope.$on('$destroy', function () {
                        $mdToast.destroy();
                    });
                }
            };
        }
        MdToastDirective.$inject = ["$mdToast"];

        /**
         * @ngdoc service
         * @name $mdToast
         * @module material.components.toast
         *
         * @description
         * `$mdToast` is a service to build a toast notification on any position
         * on the screen with an optional duration, and provides a simple promise API.
         *
         * The toast will be always positioned at the `bottom`, when the screen size is
         * between `600px` and `959px` (`sm` breakpoint)
         *
         * ## Restrictions on custom toasts
         * - The toast's template must have an outer `<md-toast>` element.
         * - For a toast action, use element with class `md-action`.
         * - Add the class `md-capsule` for curved corners.
         *
         * ## Parent container notes
         *
         * The toast is positioned using absolute positioning relative to it's first non-static parent
         * container. Thus, if the requested parent container uses static positioning, we will temporarily
         * set it's positioning to `relative` while the toast is visible and reset it when the toast is
         * hidden.
         *
         * Because of this, it is usually best to ensure that the parent container has a fixed height and
         * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
         * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
         *
         * You can, however, have a scrollable element inside of the container; just make sure the
         * container itself does not scroll.
         *
         * <hljs lang="html">
         * <div layout-fill id="toast-container">
         *   <md-content>
         *     I can have lots of content and scroll!
         *   </md-content>
         * </div>
         * </hljs>
         *
         * @usage
         * <hljs lang="html">
         * <div ng-controller="MyController">
         *   <md-button ng-click="openToast()">
         *     Open a Toast!
         *   </md-button>
         * </div>
         * </hljs>
         *
         * <hljs lang="js">
         * var app = angular.module('app', ['ngMaterial']);
         * app.controller('MyController', function($scope, $mdToast) {
         *   $scope.openToast = function($event) {
         *     $mdToast.show($mdToast.simple().textContent('Hello!'));
         *     // Could also do $mdToast.showSimple('Hello');
         *   };
         * });
         * </hljs>
         */

        /**
         * @ngdoc method
         * @name $mdToast#showSimple
         * 
         * @param {string} message The message to display inside the toast
         * @description
         * Convenience method which builds and shows a simple toast.
         *
         * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
         * rejected with `$mdToast.cancel()`.
         *
         */

        /**
         * @ngdoc method
         * @name $mdToast#simple
         *
         * @description
         * Builds a preconfigured toast.
         *
         * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
         *
         * _**Note:** These configuration methods are provided in addition to the methods provided by
         * the `build()` and `show()` methods below._
         *
         * <table class="md-api-table methods">
         *    <thead>
         *      <tr>
         *        <th>Method</th>
         *        <th>Description</th>
         *      </tr>
         *    </thead>
         *    <tbody>
         *      <tr>
         *        <td>`.textContent(string)`</td>
         *        <td>Sets the toast content to the specified string</td>
         *      </tr>
         *      <tr>
         *        <td>`.action(string)`</td>
         *        <td>
         *          Adds an action button. <br/>
         *          If clicked, the promise (returned from `show()`)
         *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
         *          timeout
         *        </td>
         *      </tr>
         *      <tr>
         *        <td>`.highlightAction(boolean)`</td>
         *        <td>
         *          Whether or not the action button will have an additional highlight class.<br/>
         *          By default the `accent` color will be applied to the action button.
         *        </td>
         *      </tr>
         *      <tr>
         *        <td>`.highlightClass(string)`</td>
         *        <td>
         *          If set, the given class will be applied to the highlighted action button.<br/>
         *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
         *          and `md-accent`
         *        </td>
         *      </tr>
         *      <tr>
         *        <td>`.capsule(boolean)`</td>
         *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
         *      </tr>
         *      <tr>
         *        <td>`.theme(string)`</td>
         *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
         *      </tr>
         *    </tbody>
         * </table>
         *
         */

        /**
         * @ngdoc method
         * @name $mdToast#updateTextContent
         *
         * @description
         * Updates the content of an existing toast. Useful for updating things like counts, etc.
         *
         */

        /**
         * @ngdoc method
         * @name $mdToast#build
         *
         * @description
         * Creates a custom `$mdToastPreset` that you can configure.
         *
         * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
         */

        /**
         * @ngdoc method
         * @name $mdToast#show
         *
         * @description Shows the toast.
         *
         * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
         * and `build()`, or an options object with the following properties:
         *
         *   - `templateUrl` - `{string=}`: The url of an html template file that will
         *     be used as the content of the toast. Restrictions: the template must
         *     have an outer `md-toast` element.
         *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
         *     template string.
         *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
         *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
         *     custom toast directive.
         *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
         *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
         *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
         *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
         *     active before automatically closing.  Set to 0 or false to have the toast stay open until
         *     closed manually. Default: 3000.
         *   - `position` - `{string=}`: Where to place the toast. Available: any combination
         *     of 'bottom', 'left', 'top', 'right'. Default: 'bottom left'.
         *   - `controller` - `{string=}`: The controller to associate with this toast.
         *     The controller will be injected the local `$mdToast.hide( )`, which is a function
         *     used to hide the toast.
         *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
         *     be used as names of values to inject into the controller. For example,
         *     `locals: {three: 3}` would inject `three` into the controller with the value
         *     of 3.
         *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
         *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
         *     and the toast will not open until the promises resolve.
         *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
         *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
         *     to the root element of the application.
         *
         * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
         * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
         * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
         * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
         */

        /**
         * @ngdoc method
         * @name $mdToast#hide
         *
         * @description
         * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
         *
         * @param {*=} response An argument for the resolved promise.
         *
         * @returns {promise} a promise that is called when the existing element is removed from the DOM.
         * The promise is resolved with either a Boolean value == 'true' or the value passed as the
         * argument to `.hide()`.
         *
         */

        /**
         * @ngdoc method
         * @name $mdToast#cancel
         *
         * @description
         * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
         * As such, there isn't any reason to also allow that promise to be rejected,
         * since it's not clear what the difference between resolve and reject would be.
         *
         * Hide the existing toast and reject the promise returned from
         * `$mdToast.show()`.
         *
         * @param {*=} response An argument for the rejected promise.
         *
         * @returns {promise} a promise that is called when the existing element is removed from the DOM
         * The promise is resolved with a Boolean value == 'false'.
         *
         */

        function MdToastProvider($$interimElementProvider) {
            // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
            var ACTION_RESOLVE = 'ok';

            var activeToastContent;
            var $mdToast = $$interimElementProvider('$mdToast')
                .setDefaults({
                    methods: ['position', 'hideDelay', 'capsule', 'parent', 'position'],
                    options: toastDefaultOptions
                })
                .addPreset('simple', {
                    argOption: 'textContent',
                    methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent'],
                    options: /* @ngInject */["$mdToast", "$mdTheming", function ($mdToast, $mdTheming) {
                        return {
                            template: '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
                                '  <div class="md-toast-content">' +
                                '    <span flex class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
                                '      {{ toast.content }}' +
                                '    </span>' +
                                '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
                                '        ng-class="highlightClasses">' +
                                '      {{ toast.action }}' +
                                '    </md-button>' +
                                '  </div>' +
                                '</md-toast>',
                            controller: /* @ngInject */["$scope", function mdToastCtrl($scope) {
                                var self = this;

                                if (self.highlightAction) {
                                    $scope.highlightClasses = [
                                        'md-highlight',
                                        self.highlightClass
                                    ]
                                }

                                $scope.$watch(function () { return activeToastContent; }, function () {
                                    self.content = activeToastContent;
                                });

                                this.resolve = function () {
                                    $mdToast.hide(ACTION_RESOLVE);
                                };
                            }],
                            theme: $mdTheming.defaultTheme(),
                            controllerAs: 'toast',
                            bindToController: true
                        };
                    }]
                })
                .addMethod('updateTextContent', updateTextContent)
                .addMethod('updateContent', updateTextContent);

            function updateTextContent(newContent) {
                activeToastContent = newContent;
            }


            toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
            return $mdToast;

            /* @ngInject */
            function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
                var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
                return {
                    onShow: onShow,
                    onRemove: onRemove,
                    position: 'bottom left',
                    themable: true,
                    hideDelay: 3000,
                    autoWrap: true,
                    transformTemplate: function (template, options) {
                        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);

                        if (shouldAddWrapper) {
                            // Root element of template will be <md-toast>. We need to wrap all of its content inside of
                            // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
                            // content (meaning we're not attempting to guard against XSS).
                            var templateRoot = document.createElement('md-template');
                            templateRoot.innerHTML = template;

                            for (var i = 0; i < templateRoot.children.length; i++) {
                                if (templateRoot.children[i].nodeName === 'MD-TOAST') {
                                    var wrapper = angular.element('<div class="md-toast-content">');
                                    wrapper.append(templateRoot.children[i].children);
                                    templateRoot.children[i].appendChild(wrapper[0]);
                                }
                            }


                            return templateRoot.outerHTML;
                        }

                        return template || '';
                    }
                };

                function onShow(scope, element, options) {
                    activeToastContent = options.textContent || options.content; // support deprecated #content method

                    var isSmScreen = !$mdMedia('gt-sm');

                    element = $mdUtil.extractElementByName(element, 'md-toast', true);
                    options.element = element;

                    options.onSwipe = function (ev, gesture) {
                        //Add the relevant swipe class to the element so it can animate correctly
                        var swipe = ev.type.replace('$md.', '');
                        var direction = swipe.replace('swipe', '');

                        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
                        // Unless the screen is small, then the toast always on bottom
                        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
                            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
                            return;
                        }

                        if ((direction === 'left' || direction === 'right') && isSmScreen) {
                            return;
                        }

                        element.addClass('_md-' + swipe);
                        $mdUtil.nextTick($mdToast.cancel);
                    };
                    options.openClass = toastOpenClass(options.position);


                    // 'top left' -> 'md-top md-left'
                    options.parent.addClass(options.openClass);

                    // static is the default position
                    if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
                        options.parent.css('position', 'relative');
                    }

                    element.on(SWIPE_EVENTS, options.onSwipe);
                    element.addClass(isSmScreen ? '_md-bottom' : options.position.split(' ').map(function (pos) {
                        return '_md-' + pos;
                    }).join(' '));

                    if (options.parent) options.parent.addClass('_md-toast-animating');
                    return $animate.enter(element, options.parent).then(function () {
                        if (options.parent) options.parent.removeClass('_md-toast-animating');
                    });
                }

                function onRemove(scope, element, options) {
                    element.off(SWIPE_EVENTS, options.onSwipe);
                    if (options.parent) options.parent.addClass('_md-toast-animating');
                    if (options.openClass) options.parent.removeClass(options.openClass);

                    return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
                        .then(function () {
                            if (options.parent) options.parent.removeClass('_md-toast-animating');
                            if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
                                options.parent.css('position', '');
                            }
                        });
                }

                function toastOpenClass(position) {
                    // For mobile, always open full-width on bottom
                    if (!$mdMedia('gt-xs')) {
                        return '_md-toast-open-bottom';
                    }

                    return '_md-toast-open-' +
                        (position.indexOf('top') > -1 ? 'top' : 'bottom');
                }
            }

        }
        MdToastProvider.$inject = ["$$interimElementProvider"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.toolbar
         */
        angular.module('material.components.toolbar', [
            'material.core',
            'material.components.content'
        ])
            .directive('mdToolbar', mdToolbarDirective);

        /**
         * @ngdoc directive
         * @name mdToolbar
         * @module material.components.toolbar
         * @restrict E
         * @description
         * `md-toolbar` is used to place a toolbar in your app.
         *
         * Toolbars are usually used above a content area to display the title of the
         * current page, and show relevant action buttons for that page.
         *
         * You can change the height of the toolbar by adding either the
         * `md-medium-tall` or `md-tall` class to the toolbar.
         *
         * @usage
         * <hljs lang="html">
         * <div layout="column" layout-fill>
         *   <md-toolbar>
         *
         *     <div class="md-toolbar-tools">
         *       <span>My App's Title</span>
         *
         *       <!-- fill up the space between left and right area -->
         *       <span flex></span>
         *
         *       <md-button>
         *         Right Bar Button
         *       </md-button>
         *     </div>
         *
         *   </md-toolbar>
         *   <md-content>
         *     Hello!
         *   </md-content>
         * </div>
         * </hljs>
         *
         * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
         * the user scrolls down, and reveal itself as the user scrolls up.
         *
         * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
         * `md-content` element, placed before it. See the scroll shrink demo._
         *
         * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
         * initialization, it does not watch for scope changes._
         *
         *
         * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
         * shrinking by. For example, if 0.25 is given then the toolbar will shrink
         * at one fourth the rate at which the user scrolls down. Default 0.5.
         */

        function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
            var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');

            return {
                template: '',

                restrict: 'E',

                link: function (scope, element, attr) {

                    $mdTheming(element);

                    if (angular.isDefined(attr.mdScrollShrink)) {
                        setupScrollShrink();
                    }

                    function setupScrollShrink() {

                        var toolbarHeight;
                        var contentElement;
                        var disableScrollShrink = angular.noop;

                        // Current "y" position of scroll
                        // Store the last scroll top position
                        var y = 0;
                        var prevScrollTop = 0;
                        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;

                        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
                        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);

                        // Wait for $mdContentLoaded event from mdContent directive.
                        // If the mdContent element is a sibling of our toolbar, hook it up
                        // to scroll events.

                        scope.$on('$mdContentLoaded', onMdContentLoad);

                        // If the toolbar is used inside an ng-if statement, we may miss the
                        // $mdContentLoaded event, so we attempt to fake it if we have a
                        // md-content close enough.

                        attr.$observe('mdScrollShrink', onChangeScrollShrink);

                        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
                        // and not wait for $mdUtil.debounce to happen

                        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
                        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }

                        // If the scope is destroyed (which could happen with ng-if), make sure
                        // to disable scroll shrinking again

                        scope.$on('$destroy', disableScrollShrink);

                        /**
                         *
                         */
                        function onChangeScrollShrink(shrinkWithScroll) {
                            var closestContent = element.parent().find('md-content');

                            // If we have a content element, fake the call; this might still fail
                            // if the content element isn't a sibling of the toolbar

                            if (!contentElement && closestContent.length) {
                                onMdContentLoad(null, closestContent);
                            }

                            // Evaluate the expression
                            shrinkWithScroll = scope.$eval(shrinkWithScroll);

                            // Disable only if the attribute's expression evaluates to false
                            if (shrinkWithScroll === false) {
                                disableScrollShrink();
                            } else {
                                disableScrollShrink = enableScrollShrink();
                            }
                        }

                        /**
                         *
                         */
                        function onMdContentLoad($event, newContentEl) {
                            // Toolbar and content must be siblings
                            if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
                                // unhook old content event listener if exists
                                if (contentElement) {
                                    contentElement.off('scroll', debouncedContentScroll);
                                }

                                contentElement = newContentEl;
                                disableScrollShrink = enableScrollShrink();
                            }
                        }

                        /**
                         *
                         */
                        function onContentScroll(e) {
                            var scrollTop = e ? e.target.scrollTop : prevScrollTop;

                            debouncedUpdateHeight();

                            y = Math.min(
                                toolbarHeight / shrinkSpeedFactor,
                                Math.max(0, y + scrollTop - prevScrollTop)
                            );

                            element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
                            contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));

                            prevScrollTop = scrollTop;

                            $mdUtil.nextTick(function () {
                                var hasWhiteFrame = element.hasClass('md-whiteframe-z1');

                                if (hasWhiteFrame && !y) {
                                    $animate.removeClass(element, 'md-whiteframe-z1');
                                } else if (!hasWhiteFrame && y) {
                                    $animate.addClass(element, 'md-whiteframe-z1');
                                }
                            });

                        }

                        /**
                         *
                         */
                        function enableScrollShrink() {
                            if (!contentElement) return angular.noop; // no md-content

                            contentElement.on('scroll', debouncedContentScroll);
                            contentElement.attr('scroll-shrink', 'true');

                            $$rAF(updateToolbarHeight);

                            return function disableScrollShrink() {
                                contentElement.off('scroll', debouncedContentScroll);
                                contentElement.attr('scroll-shrink', 'false');

                                $$rAF(updateToolbarHeight);
                            }
                        }

                        /**
                         *
                         */
                        function updateToolbarHeight() {
                            toolbarHeight = element.prop('offsetHeight');
                            // Add a negative margin-top the size of the toolbar to the content el.
                            // The content will start transformed down the toolbarHeight amount,
                            // so everything looks normal.
                            //
                            // As the user scrolls down, the content will be transformed up slowly
                            // to put the content underneath where the toolbar was.
                            var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';

                            contentElement.css({
                                "margin-top": margin,
                                "margin-bottom": margin
                            });

                            onContentScroll();
                        }

                    }

                }
            };

        }
        mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.tooltip
         */
        angular
            .module('material.components.tooltip', ['material.core'])
            .directive('mdTooltip', MdTooltipDirective);

        /**
         * @ngdoc directive
         * @name mdTooltip
         * @module material.components.tooltip
         * @description
         * Tooltips are used to describe elements that are interactive and primarily graphical (not textual).
         *
         * Place a `<md-tooltip>` as a child of the element it describes.
         *
         * A tooltip will activate when the user focuses, hovers over, or touches the parent.
         *
         * @usage
         * <hljs lang="html">
         * <md-button class="md-fab md-accent" aria-label="Play">
         *   <md-tooltip>
         *     Play Music
         *   </md-tooltip>
         *   <md-icon icon="img/icons/ic_play_arrow_24px.svg"></md-icon>
         * </md-button>
         * </hljs>
         *
         * @param {expression=} md-visible Boolean bound to whether the tooltip is currently visible.
         * @param {number=} md-delay How many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the parent. Defaults to 0ms.
         * @param {boolean=} md-autohide If present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus
         * @param {string=} md-direction Which direction would you like the tooltip to go?  Supports left, right, top, and bottom.  Defaults to bottom.
         */
        function MdTooltipDirective($timeout, $window, $$rAF, $document, $mdUtil, $mdTheming, $rootElement,
            $animate, $q) {

            var TOOLTIP_SHOW_DELAY = 0;
            var TOOLTIP_WINDOW_EDGE_SPACE = 8;

            return {
                restrict: 'E',
                transclude: true,
                priority: 210, // Before ngAria
                template: '<div class="_md-content" ng-transclude></div>',
                scope: {
                    delay: '=?mdDelay',
                    visible: '=?mdVisible',
                    autohide: '=?mdAutohide',
                    direction: '@?mdDirection' // only expect raw or interpolated string value; not expression
                },
                link: postLink
            };

            function postLink(scope, element, attr) {
                if (navigator.userAgent.toLowerCase().indexOf('mobile') > -1) {
                    element.remove()
                    scope.$destroy()
                }

                var parent = $mdUtil.getParentWithPointerEvents(element),
                    content = angular.element(element[0].getElementsByClassName('_md-content')[0]),
                    tooltipParent = angular.element(document.body),
                    debouncedOnResize = $$rAF.throttle(function () { updatePosition(); });

                //if ($animate.pin) $animate.pin(element, parent);

                // Initialize element

                setDefaults();
                manipulateElement();
                bindEvents();

                // Default origin transform point is 'center top'
                // positionTooltip() is always relative to center top
                updateContentOrigin();

                configureWatchers();
                //addAriaLabel();


                function setDefaults() {
                    scope.delay = scope.delay || TOOLTIP_SHOW_DELAY;
                }

                function updateContentOrigin() {
                    var origin = 'center top';
                    switch (scope.direction) {
                        case 'left':
                            origin = 'right center';
                            break;
                        case 'right':
                            origin = 'left center';
                            break;
                        case 'top':
                            origin = 'center bottom';
                            break;
                        case 'bottom':
                            origin = 'center top';
                            break;
                    }
                    content.css('transform-origin', origin);
                }

                function configureWatchers() {
                    scope.$on('$destroy', function () {
                        scope.visible = false;
                        element.remove();
                        angular.element($window).off('resize', debouncedOnResize);
                    });

                    // scope.$watch('visible', function (isVisible) {
                    //     if (isVisible) showTooltip();
                    //     else hideTooltip();
                    // });

                    //scope.$watch('direction', updatePosition);
                }

                function addAriaLabel() {
                    if (!parent.attr('aria-label') && !parent.text().trim()) {
                        parent.attr('aria-label', element.text().trim());
                    }
                }

                function manipulateElement() {
                    element.detach();
                    element.attr('role', 'tooltip');
                }

                function bindEvents() {
                    var mouseActive = false;

                    var ngWindow = angular.element($window);

                    // add an mutationObserver when there is support for it
                    // and the need for it in the form of viable host(parent[0])
                    if (parent[0] && 'MutationObserver' in $window) {
                        // use an mutationObserver to tackle #2602
                        var attributeObserver = new MutationObserver(function (mutations) {
                            mutations.forEach(function (mutation) {
                                if (mutation.attributeName === 'disabled' && parent[0].disabled) {
                                    setVisible(false);
                                    scope.$digest(); // make sure the elements gets updated
                                }
                            });
                        });

                        attributeObserver.observe(parent[0], { attributes: true });
                    }

                    // Store whether the element was focused when the window loses focus.
                    var windowBlurHandler = function () {
                        elementFocusedOnWindowBlur = document.activeElement === parent[0];
                    };
                    var elementFocusedOnWindowBlur = false;

                    function windowScrollHandler() {
                        setVisible(false);
                    }

                    ngWindow.on('blur', windowBlurHandler);
                    ngWindow.on('resize', debouncedOnResize);
                    document.addEventListener('scroll', windowScrollHandler, true);
                    scope.$on('$destroy', function () {
                        ngWindow.off('blur', windowBlurHandler);
                        ngWindow.off('resize', debouncedOnResize);
                        document.removeEventListener('scroll', windowScrollHandler, true);
                        attributeObserver && attributeObserver.disconnect();
                    });

                    var enterHandler = function (e) {
                        // Prevent the tooltip from showing when the window is receiving focus.
                        if (e.type === 'focus' && elementFocusedOnWindowBlur) {
                            elementFocusedOnWindowBlur = false;
                            return;
                        }
                        parent.on('blur mouseleave touchend touchcancel', leaveHandler);
                        setVisible(true);
                    };
                    var leaveHandler = function () {
                        var autohide = scope.hasOwnProperty('autohide') ? scope.autohide : attr.hasOwnProperty('mdAutohide');
                        if (autohide || mouseActive || ($document[0].activeElement !== parent[0])) {
                            parent.off('blur mouseleave touchend touchcancel', leaveHandler);
                            parent.triggerHandler("blur");
                            setVisible(false);
                        }
                        mouseActive = false;
                    };

                    // to avoid `synthetic clicks` we listen to mousedown instead of `click`
                    parent.on('mousedown', function () { mouseActive = true; });
                    parent.on('focus mouseenter', enterHandler);


                }

                function setVisible(value) {
                    // break if passed value is already in queue or there is no queue and passed value is current in the scope
                    if (!!scope.visible === !!value) return;

                    setVisible.value = !!value;
                    if (value) {
                        showTooltip()

                        //force the tooltip to close after 3seconds
                        setTimeout(hideTooltip, 3000)
                    } else {
                        hideTooltip()
                    }
                }

                function showTooltip() {
                    // Insert the element before positioning it, so we can get the position
                    // and check if we should display it
                    tooltipParent.append(element);

                    scope.visible = true

                    updatePosition();

                    angular.forEach([element, content], function (element) {
                        element.addClass('_md-show')
                    });
                }

                function hideTooltip() {
                    scope.visible = false
                    element.detach();
                }

                function updatePosition() {
                    if (!scope.visible) return;

                    updateContentOrigin();
                    positionTooltip();
                }

                function positionTooltip() {
                    var tipRect = $mdUtil.offsetRect(element, tooltipParent);
                    var parentRect = $mdUtil.offsetRect(parent, tooltipParent);
                    var newPosition = getPosition(scope.direction);
                    var offsetParent = element.prop('offsetParent');

                    // If the user provided a direction, just nudge the tooltip onto the screen
                    // Otherwise, recalculate based on 'top' since default is 'bottom'
                    if (scope.direction) {
                        newPosition = fitInParent(newPosition);
                    } else if (offsetParent && newPosition.top > offsetParent.scrollHeight - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE) {
                        newPosition = fitInParent(getPosition('top'));
                    }

                    element.css({
                        left: newPosition.left + 'px',
                        top: newPosition.top + 'px'
                    });

                    function fitInParent(pos) {
                        var newPosition = { left: pos.left, top: pos.top };
                        newPosition.left = Math.min(newPosition.left, tooltipParent.prop('scrollWidth') - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE);
                        newPosition.left = Math.max(newPosition.left, TOOLTIP_WINDOW_EDGE_SPACE);
                        newPosition.top = Math.min(newPosition.top, tooltipParent.prop('scrollHeight') - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE);
                        newPosition.top = Math.max(newPosition.top, TOOLTIP_WINDOW_EDGE_SPACE);
                        return newPosition;
                    }

                    function getPosition(dir) {
                        return dir === 'left' ? {
                            left: parentRect.left - tipRect.width - TOOLTIP_WINDOW_EDGE_SPACE,
                            top: parentRect.top + parentRect.height / 2 - tipRect.height / 2
                        } :
                            dir === 'right' ? {
                                left: parentRect.left + parentRect.width + TOOLTIP_WINDOW_EDGE_SPACE,
                                top: parentRect.top + parentRect.height / 2 - tipRect.height / 2
                            } :
                                dir === 'top' ? {
                                    left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
                                    top: parentRect.top - tipRect.height - TOOLTIP_WINDOW_EDGE_SPACE
                                } : {
                                        left: parentRect.left + parentRect.width / 2 - tipRect.width / 2,
                                        top: parentRect.top + parentRect.height + TOOLTIP_WINDOW_EDGE_SPACE
                                    };
                    }
                }

            }

        }
        MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$mdUtil", "$mdTheming", "$rootElement", "$animate", "$q"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.virtualRepeat
         */
        angular.module('material.components.virtualRepeat', [
            'material.core',
            'material.components.showHide'
        ])
            .directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
            .directive('mdVirtualRepeat', VirtualRepeatDirective);


        /**
         * @ngdoc directive
         * @name mdVirtualRepeatContainer
         * @module material.components.virtualRepeat
         * @restrict E
         * @description
         * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
         *
         * Virtual repeat is a limited substitute for ng-repeat that renders only
         * enough dom nodes to fill the container and recycling them as the user scrolls.
         *
         * @usage
         * <hljs lang="html">
         *
         * <md-virtual-repeat-container md-top-index="topIndex">
         *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
         * </md-virtual-repeat-container>
         * </hljs>
         *
         * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
         *     container to $scope. It can both read and set the scroll position.
         * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
         *     (defaults to orientation and scrolling vertically).
         * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
         *     the number of items when that number is less than its original size.
         * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
         *     will shrink to (default: 0).
         */
        function VirtualRepeatContainerDirective() {
            return {
                controller: VirtualRepeatContainerController,
                template: virtualRepeatContainerTemplate,
                compile: function virtualRepeatContainerCompile($element, $attrs) {
                    $element
                        .addClass('md-virtual-repeat-container')
                        .addClass($attrs.hasOwnProperty('mdOrientHorizontal') ?
                            'md-orient-horizontal' :
                            'md-orient-vertical');
                }
            };
        }


        function virtualRepeatContainerTemplate($element) {
            return '<div class="md-virtual-repeat-scroller">' +
                '<div class="md-virtual-repeat-sizer"></div>' +
                '<div class="md-virtual-repeat-offsetter">' +
                $element[0].innerHTML +
                '</div></div>';
        }

        /**
         * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
         * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
         * *compute* this value, but Firefox always reports an element to have a size of zero if it
         * goes over the max, meaning that we'd have to binary search for the value.
         * @const {number}
         */
        var MAX_ELEMENT_SIZE = 1533917;

        /**
         * Number of additional elements to render above and below the visible area inside
         * of the virtual repeat container. A higher number results in less flicker when scrolling
         * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
         * @const {number}
         */
        var NUM_EXTRA = 3;

        /** @ngInject */
        function VirtualRepeatContainerController(
            $$rAF, $mdUtil, $parse, $rootScope, $window, $scope, $element, $attrs) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$element = $element;
            this.$attrs = $attrs;

            /** @type {number} The width or height of the container */
            this.size = 0;
            /** @type {number} The scroll width or height of the scroller */
            this.scrollSize = 0;
            /** @type {number} The scrollLeft or scrollTop of the scroller */
            this.scrollOffset = 0;
            /** @type {boolean} Whether the scroller is oriented horizontally */
            this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
            /** @type {!VirtualRepeatController} The repeater inside of this container */
            this.repeater = null;
            /** @type {boolean} Whether auto-shrink is enabled */
            this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
            /** @type {number} Minimum number of items to auto-shrink to */
            this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
            /** @type {?number} Original container size when shrank */
            this.originalSize = null;
            /** @type {number} Amount to offset the total scroll size by. */
            this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
            /** @type {?string} height or width element style on the container prior to auto-shrinking. */
            this.oldElementSize = null;

            if (this.$attrs.mdTopIndex) {
                /** @type {function(angular.Scope): number} Binds to topIndex on Angular scope */
                this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
                /** @type {number} The index of the item that is at the top of the scroll container */
                this.topIndex = this.bindTopIndex(this.$scope);

                if (!angular.isDefined(this.topIndex)) {
                    this.topIndex = 0;
                    this.bindTopIndex.assign(this.$scope, 0);
                }

                this.$scope.$watch(this.bindTopIndex, angular.bind(this, function (newIndex) {
                    if (newIndex !== this.topIndex) {
                        this.scrollToIndex(newIndex);
                    }
                }));
            } else {
                this.topIndex = 0;
            }

            this.scroller = $element[0].getElementsByClassName('md-virtual-repeat-scroller')[0];
            this.sizer = this.scroller.getElementsByClassName('md-virtual-repeat-sizer')[0];
            this.offsetter = this.scroller.getElementsByClassName('md-virtual-repeat-offsetter')[0];

            // After the dom stablizes, measure the initial size of the container and
            // make a best effort at re-measuring as it changes.
            var boundUpdateSize = angular.bind(this, this.updateSize);

            $$rAF(angular.bind(this, function () {
                boundUpdateSize();

                var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
                var jWindow = angular.element($window);

                // Make one more attempt to get the size if it is 0.
                // This is not by any means a perfect approach, but there's really no
                // silver bullet here.
                if (!this.size) {
                    debouncedUpdateSize();
                }

                jWindow.on('resize', debouncedUpdateSize);
                $scope.$on('$destroy', function () {
                    jWindow.off('resize', debouncedUpdateSize);
                });

                $scope.$emit('$md-resize-enable');
                $scope.$on('$md-resize', boundUpdateSize);
            }));
        }
        VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];


        /** Called by the md-virtual-repeat inside of the container at startup. */
        VirtualRepeatContainerController.prototype.register = function (repeaterCtrl) {
            this.repeater = repeaterCtrl;

            angular.element(this.scroller)
                .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
        };


        /** @return {boolean} Whether the container is configured for horizontal scrolling. */
        VirtualRepeatContainerController.prototype.isHorizontal = function () {
            return this.horizontal;
        };


        /** @return {number} The size (width or height) of the container. */
        VirtualRepeatContainerController.prototype.getSize = function () {
            return this.size;
        };


        /**
         * Resizes the container.
         * @private
         * @param {number} The new size to set.
         */
        VirtualRepeatContainerController.prototype.setSize_ = function (size) {
            var dimension = this.getDimensionName_();

            this.size = size;
            this.$element[0].style[dimension] = size + 'px';
        };


        VirtualRepeatContainerController.prototype.unsetSize_ = function () {
            this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
            this.oldElementSize = null;
        };


        /** Instructs the container to re-measure its size. */
        VirtualRepeatContainerController.prototype.updateSize = function () {
            if (this.originalSize) return;

            this.size = this.isHorizontal() ?
                this.$element[0].clientWidth :
                this.$element[0].clientHeight;

            // Recheck the scroll position after updating the size. This resolves
            // problems that can result if the scroll position was measured while the
            // element was display: none or detached from the document.
            this.handleScroll_();

            this.repeater && this.repeater.containerUpdated();
        };


        /** @return {number} The container's scrollHeight or scrollWidth. */
        VirtualRepeatContainerController.prototype.getScrollSize = function () {
            return this.scrollSize;
        };


        VirtualRepeatContainerController.prototype.getDimensionName_ = function () {
            return this.isHorizontal() ? 'width' : 'height';
        };


        /**
         * Sets the scroller element to the specified size.
         * @private
         * @param {number} size The new size.
         */
        VirtualRepeatContainerController.prototype.sizeScroller_ = function (size) {
            var dimension = this.getDimensionName_();
            var crossDimension = this.isHorizontal() ? 'height' : 'width';

            // Clear any existing dimensions.
            this.sizer.innerHTML = '';

            // If the size falls within the browser's maximum explicit size for a single element, we can
            // set the size and be done. Otherwise, we have to create children that add up the the desired
            // size.
            if (size < MAX_ELEMENT_SIZE) {
                this.sizer.style[dimension] = size + 'px';
            } else {
                this.sizer.style[dimension] = 'auto';
                this.sizer.style[crossDimension] = 'auto';

                // Divide the total size we have to render into N max-size pieces.
                var numChildren = Math.floor(size / MAX_ELEMENT_SIZE);

                // Element template to clone for each max-size piece.
                var sizerChild = document.createElement('div');
                sizerChild.style[dimension] = MAX_ELEMENT_SIZE + 'px';
                sizerChild.style[crossDimension] = '1px';

                for (var i = 0; i < numChildren; i++) {
                    this.sizer.appendChild(sizerChild.cloneNode(false));
                }

                // Re-use the element template for the remainder.
                sizerChild.style[dimension] = (size - (numChildren * MAX_ELEMENT_SIZE)) + 'px';
                this.sizer.appendChild(sizerChild);
            }
        };


        /**
         * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
         * @private
         * @param {number} size The new size.
         */
        VirtualRepeatContainerController.prototype.autoShrink_ = function (size) {
            var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());
            if (this.autoShrink && shrinkSize !== this.size) {
                if (this.oldElementSize === null) {
                    this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
                }

                var currentSize = this.originalSize || this.size;
                if (!currentSize || shrinkSize < currentSize) {
                    if (!this.originalSize) {
                        this.originalSize = this.size;
                    }

                    this.setSize_(shrinkSize);
                } else if (this.originalSize !== null) {
                    this.unsetSize_();
                    this.originalSize = null;
                    this.updateSize();
                }

                this.repeater.containerUpdated();
            }
        };


        /**
         * Sets the scrollHeight or scrollWidth. Called by the repeater based on
         * its item count and item size.
         * @param {number} itemsSize The total size of the items.
         */
        VirtualRepeatContainerController.prototype.setScrollSize = function (itemsSize) {
            var size = itemsSize + this.offsetSize;
            if (this.scrollSize === size) return;

            this.sizeScroller_(size);
            this.autoShrink_(size);
            this.scrollSize = size;
        };


        /** @return {number} The container's current scroll offset. */
        VirtualRepeatContainerController.prototype.getScrollOffset = function () {
            return this.scrollOffset;
        };

        /**
         * Scrolls to a given scrollTop position.
         * @param {number} position
         */
        VirtualRepeatContainerController.prototype.scrollTo = function (position) {
            this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
            this.handleScroll_();
        };

        /**
         * Scrolls the item with the given index to the top of the scroll container.
         * @param {number} index
         */
        VirtualRepeatContainerController.prototype.scrollToIndex = function (index) {
            var itemSize = this.repeater.getItemSize();
            var itemsLength = this.repeater.itemsLength;
            if (index > itemsLength) {
                index = itemsLength - 1;
            }
            this.scrollTo(itemSize * index);
        };

        VirtualRepeatContainerController.prototype.resetScroll = function () {
            this.scrollTo(0);
        };


        VirtualRepeatContainerController.prototype.handleScroll_ = function () {
            var doc = angular.element(document)[0];
            var ltr = doc.dir != 'rtl' && doc.body.dir != 'rtl';
            if (!ltr && !this.maxSize) {
                this.scroller.scrollLeft = this.scrollSize;
                this.maxSize = this.scroller.scrollLeft;
            }
            var offset = this.isHorizontal() ?
                (ltr ? this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft) :
                this.scroller.scrollTop;
            if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;

            var itemSize = this.repeater.getItemSize();
            if (!itemSize) return;

            var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);

            var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
                (!this.isHorizontal() || ltr ? (numItems * itemSize) : -(numItems * itemSize)) + 'px)';

            this.scrollOffset = offset;
            this.offsetter.style.webkitTransform = transform;
            this.offsetter.style.transform = transform;

            if (this.bindTopIndex) {
                var topIndex = Math.floor(offset / itemSize);
                if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
                    this.topIndex = topIndex;
                    this.bindTopIndex.assign(this.$scope, topIndex);
                    if (!this.$rootScope.$$phase) this.$scope.$digest();
                }
            }

            this.repeater.containerUpdated();
        };


        /**
         * @ngdoc directive
         * @name mdVirtualRepeat
         * @module material.components.virtualRepeat
         * @restrict A
         * @priority 1000
         * @description
         * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
         *
         * Virtual repeat is a limited substitute for ng-repeat that renders only
         * enough dom nodes to fill the container and recycling them as the user scrolls.
         * Arrays, but not objects are supported for iteration.
         * Track by, as alias, and (key, value) syntax are not supported.
         *
         * @usage
         * <hljs lang="html">
         * <md-virtual-repeat-container>
         *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
         * </md-virtual-repeat-container>
         *
         * <md-virtual-repeat-container md-orient-horizontal>
         *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
         * </md-virtual-repeat-container>
         * </hljs>
         *
         * @param {number=} md-item-size The height or width of the repeated elements (which must be
         *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
         *   but still assumes that all repeated nodes have same height or width.
         * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
         *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
         * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
         *   that can fetch rows rather than an array.
         *
         *   **NOTE:** This object must implement the following interface with two (2) methods:
         *
         *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
         *     loaded (it should start downloading the item in that case).
         *   - `getLength: function() [number]` The data length to which the repeater container
         *     should be sized. Ideally, when the count is known, this method should return it.
         *     Otherwise, return a higher number than the currently loaded items to produce an
         *     infinite-scroll behavior.
         */
        function VirtualRepeatDirective($parse) {
            return {
                controller: VirtualRepeatController,
                priority: 1000,
                require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
                restrict: 'A',
                terminal: true,
                transclude: 'element',
                compile: function VirtualRepeatCompile($element, $attrs) {
                    var expression = $attrs.mdVirtualRepeat;
                    var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
                    var repeatName = match[1];
                    var repeatListExpression = $parse(match[2]);
                    var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);

                    return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
                        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
                    };
                }
            };
        }
        VirtualRepeatDirective.$inject = ["$parse"];


        /** @ngInject */
        function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
            $$rAF, $mdUtil) {
            this.$scope = $scope;
            this.$element = $element;
            this.$attrs = $attrs;
            this.$browser = $browser;
            this.$document = $document;
            this.$rootScope = $rootScope;
            this.$$rAF = $$rAF;

            /** @type {boolean} Whether we are in on-demand mode. */
            this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
            /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
            this.browserCheckUrlChange = $browser.$$checkUrlChange;
            /** @type {number} Most recent starting repeat index (based on scroll offset) */
            this.newStartIndex = 0;
            /** @type {number} Most recent ending repeat index (based on scroll offset) */
            this.newEndIndex = 0;
            /** @type {number} Most recent end visible index (based on scroll offset) */
            this.newVisibleEnd = 0;
            /** @type {number} Previous starting repeat index (based on scroll offset) */
            this.startIndex = 0;
            /** @type {number} Previous ending repeat index (based on scroll offset) */
            this.endIndex = 0;
            // TODO: measure width/height of first element from dom if not provided.
            // getComputedStyle?
            /** @type {?number} Height/width of repeated elements. */
            this.itemSize = $scope.$eval($attrs.mdItemSize) || null;

            /** @type {boolean} Whether this is the first time that items are rendered. */
            this.isFirstRender = true;

            /**
             * @private {boolean} Whether the items in the list are already being updated. Used to prevent
             *     nested calls to virtualRepeatUpdate_.
             */
            this.isVirtualRepeatUpdating_ = false;

            /** @type {number} Most recently seen length of items. */
            this.itemsLength = 0;

            /**
             * @type {!Function} Unwatch callback for item size (when md-items-size is
             *     not specified), or angular.noop otherwise.
             */
            this.unwatchItemSize_ = angular.noop;

            /**
             * Presently rendered blocks by repeat index.
             * @type {Object<number, !VirtualRepeatController.Block}
             */
            this.blocks = {};
            /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
            this.pooledBlocks = [];
        }
        VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];


        /**
         * An object representing a repeated item.
         * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
         */
        VirtualRepeatController.Block;


        /**
         * Called at startup by the md-virtual-repeat postLink function.
         * @param {!VirtualRepeatContainerController} container The container's controller.
         * @param {!Function} transclude The repeated element's bound transclude function.
         * @param {string} repeatName The left hand side of the repeat expression, indicating
         *     the name for each item in the array.
         * @param {!Function} repeatListExpression A compiled expression based on the right hand side
         *     of the repeat expression. Points to the array to repeat over.
         * @param {string|undefined} extraName The optional extra repeatName.
         */
        VirtualRepeatController.prototype.link_ =
            function (container, transclude, repeatName, repeatListExpression, extraName) {
                this.container = container;
                this.transclude = transclude;
                this.repeatName = repeatName;
                this.rawRepeatListExpression = repeatListExpression;
                this.extraName = extraName;
                this.sized = false;

                this.repeatListExpression = angular.bind(this, this.repeatListExpression_);

                this.container.register(this);
            };


        /** @private Attempts to set itemSize by measuring a repeated element in the dom */
        VirtualRepeatController.prototype.readItemSize_ = function () {
            if (this.itemSize) {
                // itemSize was successfully read in a different asynchronous call.
                return;
            }

            this.items = this.repeatListExpression(this.$scope);
            this.parentNode = this.$element[0].parentNode;
            var block = this.getBlock_(0);
            if (!block.element[0].parentNode) {
                this.parentNode.appendChild(block.element[0]);
            }

            this.itemSize = block.element[0][
                this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'
            ] || null;

            this.blocks[0] = block;
            this.poolBlock_(0);

            if (this.itemSize) {
                this.containerUpdated();
            }
        };


        /**
         * Returns the user-specified repeat list, transforming it into an array-like
         * object in the case of infinite scroll/dynamic load mode.
         * @param {!angular.Scope} The scope.
         * @return {!Array|!Object} An array or array-like object for iteration.
         */
        VirtualRepeatController.prototype.repeatListExpression_ = function (scope) {
            var repeatList = this.rawRepeatListExpression(scope);

            if (this.onDemand && repeatList) {
                var virtualList = new VirtualRepeatModelArrayLike(repeatList);
                virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
                return virtualList;
            } else {
                return repeatList;
            }
        };


        /**
         * Called by the container. Informs us that the containers scroll or size has
         * changed.
         */
        VirtualRepeatController.prototype.containerUpdated = function () {
            // If itemSize is unknown, attempt to measure it.
            if (!this.itemSize) {
                this.unwatchItemSize_ = this.$scope.$watchCollection(
                    this.repeatListExpression,
                    angular.bind(this, function (items) {
                        if (items && items.length) {
                            this.$$rAF(angular.bind(this, this.readItemSize_));
                        }
                    }));
                if (!this.$rootScope.$$phase) this.$scope.$digest();

                return;
            } else if (!this.sized) {
                this.items = this.repeatListExpression(this.$scope);
            }

            if (!this.sized) {
                this.unwatchItemSize_();
                this.sized = true;
                this.$scope.$watchCollection(this.repeatListExpression,
                    angular.bind(this, function (items, oldItems) {
                        if (!this.isVirtualRepeatUpdating_) {
                            this.virtualRepeatUpdate_(items, oldItems);
                        }
                    }));
            }

            this.updateIndexes_();

            if (this.newStartIndex !== this.startIndex ||
                this.newEndIndex !== this.endIndex ||
                this.container.getScrollOffset() > this.container.getScrollSize()) {
                if (this.items instanceof VirtualRepeatModelArrayLike) {
                    this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
                }
                this.virtualRepeatUpdate_(this.items, this.items);
            }
        };


        /**
         * Called by the container. Returns the size of a single repeated item.
         * @return {?number} Size of a repeated item.
         */
        VirtualRepeatController.prototype.getItemSize = function () {
            return this.itemSize;
        };


        /**
         * Called by the container. Returns the size of a single repeated item.
         * @return {?number} Size of a repeated item.
         */
        VirtualRepeatController.prototype.getItemCount = function () {
            return this.itemsLength;
        };


        /**
         * Updates the order and visible offset of repeated blocks in response to scrolling
         * or items updates.
         * @private
         */
        VirtualRepeatController.prototype.virtualRepeatUpdate_ = function (items, oldItems) {
            this.isVirtualRepeatUpdating_ = true;

            var itemsLength = items && items.length || 0;
            var lengthChanged = false;

            //             // If the number of items shrank, scroll up to the top.
            //             if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
            //                 this.items = items;
            //                 this.container.resetScroll();
            //                 return;
            //             }

            if (itemsLength !== this.itemsLength) {
                lengthChanged = true;
                this.itemsLength = itemsLength;
            }

            this.items = items;
            if (items !== oldItems || lengthChanged) {
                this.updateIndexes_();
            }

            this.parentNode = this.$element[0].parentNode;

            if (lengthChanged) {
                this.container.setScrollSize(itemsLength * this.itemSize);
            }

            if (this.isFirstRender) {
                this.isFirstRender = false;
                var startIndex = this.$attrs.mdStartIndex ?
                    this.$scope.$eval(this.$attrs.mdStartIndex) :
                    this.container.topIndex;
                this.container.scrollToIndex(startIndex);
            }

            // Detach and pool any blocks that are no longer in the viewport.
            Object.keys(this.blocks).forEach(function (blockIndex) {
                var index = parseInt(blockIndex, 10);
                if (index < this.newStartIndex || index >= this.newEndIndex) {
                    this.poolBlock_(index);
                }
            }, this);

            // Add needed blocks.
            // For performance reasons, temporarily block browser url checks as we digest
            // the restored block scopes ($$checkUrlChange reads window.location to
            // check for changes and trigger route change, etc, which we don't need when
            // trying to scroll at 60fps).
            this.$browser.$$checkUrlChange = angular.noop;

            var i, block,
                newStartBlocks = [],
                newEndBlocks = [];

            // Collect blocks at the top.
            for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
                block = this.getBlock_(i);
                this.updateBlock_(block, i);
                newStartBlocks.push(block);
            }

            // Update blocks that are already rendered.
            for (; this.blocks[i] != null; i++) {
                this.updateBlock_(this.blocks[i], i);
            }
            var maxIndex = i - 1;

            // Collect blocks at the end.
            for (; i < this.newEndIndex; i++) {
                block = this.getBlock_(i);
                this.updateBlock_(block, i);
                newEndBlocks.push(block);
            }

            // Attach collected blocks to the document.
            if (newStartBlocks.length) {
                this.parentNode.insertBefore(
                    this.domFragmentFromBlocks_(newStartBlocks),
                    this.$element[0].nextSibling);
            }
            if (newEndBlocks.length) {
                this.parentNode.insertBefore(
                    this.domFragmentFromBlocks_(newEndBlocks),
                    this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
            }

            // Restore $$checkUrlChange.
            this.$browser.$$checkUrlChange = this.browserCheckUrlChange;

            this.startIndex = this.newStartIndex;
            this.endIndex = this.newEndIndex;

            this.isVirtualRepeatUpdating_ = false;
        };


        /**
         * @param {number} index Where the block is to be in the repeated list.
         * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
         * @private
         */
        VirtualRepeatController.prototype.getBlock_ = function (index) {
            if (this.pooledBlocks.length) {
                return this.pooledBlocks.pop();
            }

            var block;
            this.transclude(angular.bind(this, function (clone, scope) {
                block = {
                    element: clone,
                    new: true,
                    scope: scope
                };

                this.updateScope_(scope, index);
                this.parentNode.appendChild(clone[0]);
            }));

            return block;
        };


        /**
         * Updates and if not in a digest cycle, digests the specified block's scope to the data
         * at the specified index.
         * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
         * @param {number} index The index to set.
         * @private
         */
        VirtualRepeatController.prototype.updateBlock_ = function (block, index) {
            this.blocks[index] = block;

            if (!block.new &&
                (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
                return;
            }
            block.new = false;

            // Update and digest the block's scope.
            this.updateScope_(block.scope, index);

            // Perform digest before reattaching the block.
            // Any resulting synchronous dom mutations should be much faster as a result.
            // This might break some directives, but I'm going to try it for now.
            if (!this.$rootScope.$$phase) {
                block.scope.$digest();
            }
        };


        /**
         * Updates scope to the data at the specified index.
         * @param {!angular.Scope} scope The scope which should be updated.
         * @param {number} index The index to set.
         * @private
         */
        VirtualRepeatController.prototype.updateScope_ = function (scope, index) {
            scope.$index = index;
            scope[this.repeatName] = this.items && this.items[index];
            if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
        };


        /**
         * Pools the block at the specified index (Pulls its element out of the dom and stores it).
         * @param {number} index The index at which the block to pool is stored.
         * @private
         */
        VirtualRepeatController.prototype.poolBlock_ = function (index) {
            this.pooledBlocks.push(this.blocks[index]);
            this.parentNode.removeChild(this.blocks[index].element[0]);
            delete this.blocks[index];
        };


        /**
         * Produces a dom fragment containing the elements from the list of blocks.
         * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
         *     should be added to the document fragment.
         * @return {DocumentFragment}
         * @private
         */
        VirtualRepeatController.prototype.domFragmentFromBlocks_ = function (blocks) {
            var fragment = this.$document[0].createDocumentFragment();
            blocks.forEach(function (block) {
                fragment.appendChild(block.element[0]);
            });
            return fragment;
        };


        /**
         * Updates start and end indexes based on length of repeated items and container size.
         * @private
         */
        VirtualRepeatController.prototype.updateIndexes_ = function () {
            var itemsLength = this.items ? this.items.length : 0;
            var containerLength = Math.ceil(this.container.getSize() / this.itemSize);

            this.newStartIndex = Math.max(0, Math.min(
                itemsLength - containerLength,
                Math.floor(this.container.getScrollOffset() / this.itemSize)));
            this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
            this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
            this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
        };

        /**
         * This VirtualRepeatModelArrayLike class enforces the interface requirements
         * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
         * interface must implement the following interface with two (2) methods:
         *
         * getItemAtIndex: function(index) -> item at that index or null if it is not yet
         *     loaded (It should start downloading the item in that case).
         *
         * getLength: function() -> number The data legnth to which the repeater container
         *     should be sized. Ideally, when the count is known, this method should return it.
         *     Otherwise, return a higher number than the currently loaded items to produce an
         *     infinite-scroll behavior.
         *
         * @usage
         * <hljs lang="html">
         *  <md-virtual-repeat-container md-orient-horizontal>
         *    <div md-virtual-repeat="i in items" md-on-demand>
         *      Hello {{i}}!
         *    </div>
         *  </md-virtual-repeat-container>
         * </hljs>
         *
         */
        function VirtualRepeatModelArrayLike(model) {
            if (!angular.isFunction(model.getItemAtIndex) ||
                !angular.isFunction(model.getLength)) {
                throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
                    'functions getItemAtIndex() and getLength() ');
            }

            this.model = model;
        }


        VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function (start, end) {
            for (var i = start; i < end; i++) {
                if (!this.hasOwnProperty(i)) {
                    this[i] = this.model.getItemAtIndex(i);
                }
            }
            this.length = this.model.getLength();
        };


        function abstractMethod() {
            throw Error('Non-overridden abstract method called.');
        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc module
         * @name material.components.whiteframe
         */
        angular
            .module('material.components.whiteframe', ['material.core'])
            .directive('mdWhiteframe', MdWhiteframeDirective);

        /**
         * @private
         * @ngdoc directive
         * @module material.components.whiteframe
         * @name mdWhiteframe
         * @restrict A
         *
         * @description
         * The md-whiteframe directive allows you to apply an elevation shadow to an element.
         *
         * The attribute values needs to be a number between 1 and 24.
         *
         * ### Notes
         * - If there is no value specified it defaults to 4dp.
         * - If the value is not valid it defaults to 4dp.

         * @usage
         * <hljs lang="html">
         * <div md-whiteframe="3">
         *   <span>Elevation of 3dp</span>
         * </div>
         * </hljs>
         */
        function MdWhiteframeDirective($log) {
            var MIN_DP = 1;
            var MAX_DP = 24;
            var DEFAULT_DP = 4;

            return {
                restrict: 'A',
                link: postLink
            };

            function postLink(scope, element, attr) {
                var elevation = parseInt(attr.mdWhiteframe, 10) || DEFAULT_DP;

                if (elevation > MAX_DP || elevation < MIN_DP) {
                    $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
                    elevation = DEFAULT_DP;
                }

                element.addClass('md-whiteframe-' + elevation + 'dp');
            }
        }
        MdWhiteframeDirective.$inject = ["$log"];


    })();
    (function () {
        "use strict";

        angular
            .module('material.components.autocomplete')
            .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);

        var ITEM_HEIGHT = 41,
            MAX_HEIGHT = 5.5 * ITEM_HEIGHT,
            MENU_PADDING = 8,
            INPUT_PADDING = 2; // Padding provided by `md-input-container`

        function MdAutocompleteCtrl($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
            $animate, $rootElement, $attrs, $q, $timeout) {
            //-- private variables
            var ctrl = this,
                itemParts = $scope.itemsExpr.split(/ in /i),
                itemExpr = itemParts[1],
                elements = null,
                cache = {},
                noBlur = false,
                selectedItemWatchers = [],
                hasFocus = false,
                lastCount = 0,
                fetchesInProgress = 0,
                ignoringWatchers = false;

            //-- public variables with handlers
            defineProperty('hidden', handleHiddenChange, true);

            //-- public variables
            ctrl.scope = $scope;
            ctrl.parent = $scope.$parent;
            ctrl.itemName = itemParts[0];
            ctrl.matches = [];
            ctrl.loading = false;
            ctrl.hidden = true;
            ctrl.index = null;
            ctrl.messages = [];
            ctrl.id = $mdUtil.nextUid();
            ctrl.isDisabled = null;
            ctrl.isRequired = null;
            ctrl.isReadonly = null;
            ctrl.hasNotFound = false;

            //-- public methods
            ctrl.keydown = keydown;
            ctrl.blur = blur;
            ctrl.focus = focus;
            ctrl.clear = clearValue;
            ctrl.select = select;
            ctrl.listEnter = onListEnter;
            ctrl.listLeave = onListLeave;
            ctrl.mouseUp = onMouseup;
            ctrl.getCurrentDisplayValue = getCurrentDisplayValue;
            ctrl.registerSelectedItemWatcher = registerSelectedItemWatcher;
            ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
            ctrl.notFoundVisible = notFoundVisible;
            ctrl.loadingIsVisible = loadingIsVisible;

            return init();

            //-- initialization methods

            /**
             * Initialize the controller, setup watchers, gather elements
             */
            function init() {
                $mdUtil.initOptionalProperties($scope, $attrs, { searchText: null, selectedItem: null });
                $mdTheming($element);
                configureWatchers();
                $mdUtil.nextTick(function () {
                    gatherElements();
                    moveDropdown();
                    focusElement();
                    $element.on('focus', focusElement);
                });
            }

            /**
             * Calculates the dropdown's position and applies the new styles to the menu element
             * @returns {*}
             */
            function positionDropdown() {
                if (!elements) return $mdUtil.nextTick(positionDropdown, false, $scope);
                var hrect = elements.wrap.getBoundingClientRect(),
                    vrect = elements.snap.getBoundingClientRect(),
                    root = elements.root.getBoundingClientRect(),
                    top = vrect.bottom - root.top,
                    bot = root.bottom - vrect.top,
                    left = hrect.left - root.left,
                    width = hrect.width,
                    offset = getVerticalOffset(),
                    styles;
                // Adjust the width to account for the padding provided by `md-input-container`
                if ($attrs.mdFloatingLabel) {
                    left += INPUT_PADDING;
                    width -= INPUT_PADDING * 2;
                }
                styles = {
                    left: left + 'px',
                    minWidth: width + 'px',
                    maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
                };
                if (top > bot && root.height - hrect.bottom - MENU_PADDING < MAX_HEIGHT) {
                    styles.top = 'auto';
                    styles.bottom = bot + 'px';
                    styles.maxHeight = Math.min(MAX_HEIGHT, hrect.top - root.top - MENU_PADDING) + 'px';
                } else {
                    styles.top = (top - offset) + 'px';
                    styles.bottom = 'auto';
                    styles.maxHeight = Math.min(MAX_HEIGHT, root.bottom + $mdUtil.scrollTop() - hrect.bottom - MENU_PADDING) + 'px';
                }

                elements.$.scrollContainer.css(styles);
                $mdUtil.nextTick(correctHorizontalAlignment, false);

                /**
                 * Calculates the vertical offset for floating label examples to account for ngMessages
                 * @returns {number}
                 */
                function getVerticalOffset() {
                    var offset = 0;
                    var inputContainer = $element.find('md-input-container');
                    if (inputContainer.length) {
                        var input = inputContainer.find('input');
                        offset = inputContainer.prop('offsetHeight');
                        offset -= input.prop('offsetTop');
                        offset -= input.prop('offsetHeight');
                        // add in the height left up top for the floating label text
                        offset += inputContainer.prop('offsetTop');
                    }
                    return offset;
                }

                /**
                 * Makes sure that the menu doesn't go off of the screen on either side.
                 */
                function correctHorizontalAlignment() {
                    var dropdown = elements.scrollContainer.getBoundingClientRect(),
                        styles = {};
                    if (dropdown.right > root.right - MENU_PADDING) {
                        styles.left = (hrect.right - dropdown.width) + 'px';
                    }
                    elements.$.scrollContainer.css(styles);
                }
            }

            /**
             * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
             */
            function moveDropdown() {
                if (!elements.$.root.length) return;
                $mdTheming(elements.$.scrollContainer);
                elements.$.scrollContainer.detach();
                elements.$.root.append(elements.$.scrollContainer);
                if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
            }

            /**
             * Sends focus to the input element.
             */
            function focusElement() {
                if ($scope.autofocus) elements.input.focus();
            }

            /**
             * Sets up any watchers used by autocomplete
             */
            function configureWatchers() {
                var wait = parseInt($scope.delay, 10) || 150;
                $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
                $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
                $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });
                $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
                $scope.$watch('selectedItem', selectedItemChange);
                angular.element($window).on('resize', positionDropdown);
                $scope.$on('$destroy', cleanup);
            }

            /**
             * Removes any events or leftover elements created by this controller
             */
            function cleanup() {
                if (!ctrl.hidden) {
                    $mdUtil.enableScrolling();
                }

                angular.element($window).off('resize', positionDropdown);
                if (elements) {
                    var items = 'ul scroller scrollContainer input'.split(' ');
                    angular.forEach(items, function (key) {
                        elements.$[key].remove();
                    });
                }
            }

            /**
             * Gathers all of the elements needed for this controller
             */
            function gatherElements() {
                elements = {
                    main: $element[0],
                    scrollContainer: $element[0].getElementsByClassName('md-virtual-repeat-container')[0],
                    scroller: $element[0].getElementsByClassName('md-virtual-repeat-scroller')[0],
                    ul: $element.find('ul')[0],
                    input: $element.find('input')[0],
                    wrap: $element.find('md-autocomplete-wrap')[0],
                    root: document.body
                };
                elements.li = elements.ul.getElementsByTagName('li');
                elements.snap = getSnapTarget();
                elements.$ = getAngularElements(elements);
                if (angular.isFunction($scope.onEnter)) {
                    angular.element(elements.input).keyup(function (e) {
                        if (e.keyCode == 13) {
                            $scope.onEnter()
                        }
                    })
                }
            }

            /**
             * Finds the element that the menu will base its position on
             * @returns {*}
             */
            function getSnapTarget() {
                for (var element = $element; element.length; element = element.parent()) {
                    if (angular.isDefined(element.attr('md-autocomplete-snap'))) return element[0];
                }
                return elements.wrap;
            }

            /**
             * Gathers angular-wrapped versions of each element
             * @param elements
             * @returns {{}}
             */
            function getAngularElements(elements) {
                var obj = {};
                for (var key in elements) {
                    if (elements.hasOwnProperty(key)) obj[key] = angular.element(elements[key]);
                }
                return obj;
            }

            //-- event/change handlers

            /**
             * Handles changes to the `hidden` property.
             * @param hidden
             * @param oldHidden
             */
            function handleHiddenChange(hidden, oldHidden) {
                if (!hidden && oldHidden) {
                    positionDropdown();

                    if (elements) {
                        $mdUtil.nextTick(function () {
                            $mdUtil.disableScrollAround(elements.ul);
                        }, false, $scope);
                    }
                } else if (hidden && !oldHidden) {
                    $mdUtil.nextTick(function () {
                        $mdUtil.enableScrolling();
                    }, false, $scope);
                }
            }

            /**
             * When the user mouses over the dropdown menu, ignore blur events.
             */
            function onListEnter() {
                noBlur = true;
            }

            /**
             * When the user's mouse leaves the menu, blur events may hide the menu again.
             */
            function onListLeave() {
                if (!hasFocus) elements.input.focus();
                noBlur = false;
                //ctrl.hidden = shouldHide();
            }

            /**
             * When the mouse button is released, send focus back to the input field.
             */
            function onMouseup() {
                elements.input.focus();
            }

            /**
             * Handles changes to the selected item.
             * @param selectedItem
             * @param previousSelectedItem
             */
            function selectedItemChange(selectedItem, previousSelectedItem) {
                if (selectedItem) {
                    getDisplayValue(selectedItem).then(function (val) {
                        $scope.searchText = val;
                        handleSelectedItemChange(selectedItem, previousSelectedItem);
                    });
                } else {
                    $scope.searchText = ""
                }

                if (selectedItem !== previousSelectedItem) announceItemChange();
            }

            /**
             * Use the user-defined expression to announce changes each time a new item is selected
             */
            function announceItemChange() {
                angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
            }

            /**
             * Use the user-defined expression to announce changes each time the search text is changed
             */
            function announceTextChange() {
                angular.isFunction($scope.textChange) && $scope.textChange();
            }

            /**
             * Calls any external watchers listening for the selected item.  Used in conjunction with
             * `registerSelectedItemWatcher`.
             * @param selectedItem
             * @param previousSelectedItem
             */
            function handleSelectedItemChange(selectedItem, previousSelectedItem) {
                selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
            }

            /**
             * Register a function to be called when the selected item changes.
             * @param cb
             */
            function registerSelectedItemWatcher(cb) {
                if (selectedItemWatchers.indexOf(cb) == -1) {
                    selectedItemWatchers.push(cb);
                }
            }

            /**
             * Unregister a function previously registered for selected item changes.
             * @param cb
             */
            function unregisterSelectedItemWatcher(cb) {
                var i = selectedItemWatchers.indexOf(cb);
                if (i != -1) {
                    selectedItemWatchers.splice(i, 1);
                }
            }

            /**
             * Handles changes to the searchText property.
             * @param searchText
             * @param previousSearchText
             */
            function handleSearchText(searchText, previousSearchText) {
                ctrl.index = getDefaultIndex();
                // do nothing on init
                if (searchText === previousSearchText) return;

                //au-update - many loops cause issues setting the value to null
                if (ignoringWatchers) return;

                //au-update - nulling out wasn't causing the form to dirty
                if (searchText == "" && previousSearchText) {
                    var ngModel = elements.$.input.controller('ngModel');
                    if (!ngModel) return

                    $scope.selectedItem = null
                    ngModel.$setViewValue(null);
                    ngModel.$render();
                }

                getDisplayValue($scope.selectedItem).then(function (val) {
                    if (searchText !== val) {
                        //au-fix: $scope.selectedItem = null;

                        // trigger change event if available
                        if (searchText !== previousSearchText) announceTextChange();

                        // cancel results if search text is not long enough
                        if (!isMinLengthMet()) {
                            ctrl.matches = [];
                            setLoading(false);
                            updateMessages();
                        } else {
                            handleQuery();
                        }
                    }
                });
            }

            function ignoreWatchers() {
                if (ignoringWatchers) return
                ignoringWatchers = true
                setTimeout(function () { ignoringWatchers = false }, 10)
            }

            /**
             * Handles input blur event, determines if the dropdown should hide.
             */
            function blur() {
                hasFocus = false;

                if (!noBlur) {

                    ctrl.hidden = true //shouldHide();

                    //let other code finish and then reset the text
                    $timeout(function () {
                        if ($scope.selectedItem) {
                            getDisplayValue($scope.selectedItem).then(function (val) {
                                $scope.searchText = val
                            })
                        }
                    }, 50)
                }
            }

            /**
             * Force blur on input element
             * @param forceBlur
             */
            function doBlur(forceBlur) {
                if (forceBlur) {
                    noBlur = false;
                    hasFocus = false;
                }
                elements.input.blur();
            }

            /**
             * Handles input focus event, determines if the dropdown should show.
             */
            function focus() {
                hasFocus = true;
                //-- if searchText is null, let's force it to be a string
                if (!angular.isString($scope.searchText)) $scope.searchText = '';
                ctrl.hidden = true // shouldHide();
                if (!ctrl.hidden) handleQuery();
            }

            /**
             * Handles keyboard input.
             * @param event
             */
            function keydown(event) {
                switch (event.keyCode) {
                    case $mdConstant.KEY_CODE.DOWN_ARROW:
                        if (ctrl.loading) return;
                        event.stopPropagation();
                        event.preventDefault();
                        ctrl.index = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
                        updateScroll();
                        updateMessages();
                        break;
                    case $mdConstant.KEY_CODE.UP_ARROW:
                        if (ctrl.loading) return;
                        event.stopPropagation();
                        event.preventDefault();
                        ctrl.index = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
                        updateScroll();
                        updateMessages();
                        break;
                    case $mdConstant.KEY_CODE.TAB:
                    case $mdConstant.KEY_CODE.ENTER:
                        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
                        if (hasSelection()) return;
                        event.stopPropagation();
                        event.preventDefault();
                        select(ctrl.index);
                        break;
                    case $mdConstant.KEY_CODE.ESCAPE:
                        event.stopPropagation();
                        event.preventDefault();
                        clearValue();

                        // Force the component to blur if they hit escape
                        doBlur(true);

                        break;
                    default:
                }
            }

            //-- getters

            /**
             * Returns the minimum length needed to display the dropdown.
             * @returns {*}
             */
            function getMinLength() {
                return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
            }

            /**
             * Returns the display value for an item.
             * @param item
             * @returns {*}
             */
            function getDisplayValue(item) {
                return $q.when(getItemText(item) || item);

                /**
                 * Getter function to invoke user-defined expression (in the directive)
                 * to convert your object to a single string.
                 */
                function getItemText(item) {
                    return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
                }
            }

            /**
             * Returns the locals object for compiling item templates.
             * @param item
             * @returns {{}}
             */
            function getItemAsNameVal(item) {
                if (!item) return undefined;

                var locals = {};
                if (ctrl.itemName) locals[ctrl.itemName] = item;

                return locals;
            }

            /**
             * Returns the default index based on whether or not autoselect is enabled.
             * @returns {number}
             */
            function getDefaultIndex() {
                return $scope.autoselect ? 0 : -1;
            }

            /**
             * Sets the loading parameter and updates the hidden state.
             * @param value {boolean} Whether or not the component is currently loading.
             */
            function setLoading(value) {
                if (ctrl.loading != value) {
                    ctrl.loading = value;
                }

                // Always refresh the hidden variable as something else might have changed
                //ctrl.hidden = shouldHide();
            }

            /**
             * Determines if the menu should be hidden.
             * @returns {boolean}
             */
            function shouldHide() {
                if (ctrl.loading && !hasMatches()) return true; // Hide while loading initial matches
                else if (hasSelection()) return true; // Hide if there is already a selection
                else if (!hasFocus) return true; // Hide if the input does not have focus
                else return !shouldShow(); // Defer to standard show logic
            }

            /**
             * Determines if the menu should be shown.
             * @returns {boolean}
             */
            function shouldShow() {
                return (isMinLengthMet() && hasMatches()) || notFoundVisible();
            }

            /**
             * Returns true if the search text has matches.
             * @returns {boolean}
             */
            function hasMatches() {
                return ctrl.matches.length ? true : false;
            }

            /**
             * Returns true if the autocomplete has a valid selection.
             * @returns {boolean}
             */
            function hasSelection() {
                return ctrl.scope.selectedItem ? true : false;
            }

            /**
             * Returns true if the loading indicator is, or should be, visible.
             * @returns {boolean}
             */
            function loadingIsVisible() {
                return ctrl.loading && !hasSelection();
            }

            /**
             * Returns the display value of the current item.
             * @returns {*}
             */
            function getCurrentDisplayValue() {
                return getDisplayValue(ctrl.matches[ctrl.index]);
            }

            /**
             * Determines if the minimum length is met by the search text.
             * @returns {*}
             */
            function isMinLengthMet() {
                return ($scope.searchText || '').length >= getMinLength();
            }

            //-- actions

            /**
             * Defines a public property with a handler and a default value.
             * @param key
             * @param handler
             * @param value
             */
            function defineProperty(key, handler, value) {
                Object.defineProperty(ctrl, key, {
                    get: function () { return value; },
                    set: function (newValue) {
                        var oldValue = value;
                        value = newValue;
                        handler(newValue, oldValue);
                    }
                });
            }

            /**
             * Selects the item at the given index.
             * @param index
             */
            function select(index) {
                //-- force form to update state for validation
                $mdUtil.nextTick(function () {
                    getDisplayValue(ctrl.matches[index]).then(function (val) {
                        var ngModel = elements.$.input.controller('ngModel');
                        ngModel.$setViewValue(val);
                        ngModel.$render();
                    }).finally(function () {
                        //au-updates - ignore watchers and assume we want the _id if there is one
                        ignoreWatchers()
                        var selectedItem = ctrl.matches[index];
                        if (selectedItem) $scope.selectedItem = $scope.returnObject || ctrl.matches[index]._id === undefined ? ctrl.matches[index] : ctrl.matches[index]._id;
                        else $scope.selectedItem = undefined;
                        setLoading(false);
                        ctrl.hidden = true
                    });
                }, false);
            }

            /**
             * Clears the searchText value and selected item.
             */
            function clearValue() {
                // Set the loading to true so we don't see flashes of content.
                // The flashing will only occour when an async request is running.
                // So the loading process will stop when the results had been retrieved.
                setLoading(true);

                // Reset our variables
                ctrl.index = 0;
                ctrl.matches = [];
                $scope.searchText = '';

                // Per http://www.w3schools.com/jsref/event_oninput.asp
                var eventObj = document.createEvent('CustomEvent');
                eventObj.initCustomEvent('input', true, true, { value: $scope.searchText });
                elements.input.dispatchEvent(eventObj);

                elements.input.focus();
            }

            /**
             * Fetches the results for the provided search text.
             * @param searchText
             */
            function fetchResults(searchText) {
                var items = $scope.$parent.$eval(itemExpr),
                    term = searchText.toLowerCase(),
                    isList = angular.isArray(items),
                    isPromise = !!items.then; // Every promise should contain a `then` property

                if (isList) handleResults(items);
                else if (isPromise) handleAsyncResults(items);

                function handleAsyncResults(items) {
                    if (!items) return;

                    items = $q.when(items);
                    fetchesInProgress++;
                    setLoading(true);

                    $mdUtil.nextTick(function () {
                        items
                            .then(handleResults)
                            .finally(function () {
                                if (--fetchesInProgress === 0) {
                                    setLoading(false);
                                }
                            });
                    }, true, $scope);
                }

                function handleResults(matches) {
                    cache[term] = matches;
                    if ((searchText || '') !== ($scope.searchText || '')) return; //-- just cache the results if old request

                    ctrl.matches = matches;

                    // If loading is in progress, then we'll end the progress. This is needed for example,
                    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
                    if (ctrl.loading) setLoading(false);

                    if ($scope.selectOnMatch) selectItemOnMatch();

                    updateMessages();
                    positionDropdown();

                    ctrl.hidden = false;
                }
            }

            /**
             * Updates the ARIA messages
             */
            function updateMessages() {
                getCurrentDisplayValue().then(function (msg) {
                    ctrl.messages = [getCountMessage(), msg];
                });
            }

            /**
             * Returns the ARIA message for how many results match the current query.
             * @returns {*}
             */
            function getCountMessage() {
                if (lastCount === ctrl.matches.length) return '';
                lastCount = ctrl.matches.length;
                switch (ctrl.matches.length) {
                    case 0:
                        return 'There are no matches available.';
                    case 1:
                        return 'There is 1 match available.';
                    default:
                        return 'There are ' + ctrl.matches.length + ' matches available.';
                }
            }

            /**
             * Makes sure that the focused element is within view.
             */
            function updateScroll() {
                if (!elements.li[0]) return;
                var height = elements.li[0].offsetHeight,
                    top = height * ctrl.index,
                    bot = top + height,
                    hgt = elements.scroller.clientHeight,
                    scrollTop = elements.scroller.scrollTop;
                if (top < scrollTop) {
                    scrollTo(top);
                } else if (bot > scrollTop + hgt) {
                    scrollTo(bot - hgt);
                }
            }

            function isPromiseFetching() {
                return fetchesInProgress !== 0;
            }

            function scrollTo(offset) {
                elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
            }

            function notFoundVisible() {
                var textLength = (ctrl.scope.searchText || '').length;

                return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
            }

            /**
             * Starts the query to gather the results for the current searchText.  Attempts to return cached
             * results first, then forwards the process to `fetchResults` if necessary.
             */
            function handleQuery() {
                var searchText = $scope.searchText || '',
                    term = searchText.toLowerCase();
                //-- if results are cached, pull in cached results
                if (!$scope.noCache && cache[term]) {
                    ctrl.matches = cache[term];
                    updateMessages();
                } else {
                    fetchResults(searchText);
                }

                ctrl.hidden = false //shouldHide();
            }

            /**
             * If there is only one matching item and the search text matches its display value exactly,
             * automatically select that item.  Note: This function is only called if the user uses the
             * `md-select-on-match` flag.
             */
            function selectItemOnMatch() {
                var searchText = $scope.searchText,
                    matches = ctrl.matches,
                    item = matches[0];
                if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
                    var isMatching = searchText == displayValue;
                    if ($scope.matchInsensitive && !isMatching) {
                        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
                    }

                    if (isMatching) select(0);
                });
            }

        }
        MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$timeout"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.autocomplete')
            .directive('mdAutocomplete', MdAutocomplete);

        /**
         * @ngdoc directive
         * @name mdAutocomplete
         * @module material.components.autocomplete
         *
         * @description
         * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
         *     custom query. This component allows you to provide real-time suggestions as the user types
         *     in the input area.
         *
         * To start, you will need to specify the required parameters and provide a template for your
         *     results. The content inside `md-autocomplete` will be treated as a template.
         *
         * In more complex cases, you may want to include other content such as a message to display when
         *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
         *     adding a tag for `md-not-found`.  An example of this is shown below.
         *
         * ### Validation
         *
         * You can use `ng-messages` to include validation the same way that you would normally validate;
         *     however, if you want to replicate a standard input with a floating label, you will have to
         *     do the following:
         *
         * - Make sure that your template is wrapped in `md-item-template`
         * - Add your `ng-messages` code inside of `md-autocomplete`
         * - Add your validation properties to `md-autocomplete` (ie. `required`)
         * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
         *
         * There is an example below of how this should look.
         *
         *
         * @param {expression} md-items An expression in the format of `item in items` to iterate over
         *     matches for your search.
         * @param {expression=} md-selected-item-change An expression to be run each time a new item is
         *     selected
         * @param {expression=} md-search-text-change An expression to be run each time the search text
         *     updates
         * @param {expression=} md-search-text A model to bind the search query text to
         * @param {object=} md-selected-item A model to bind the selected item to
         * @param {expression=} md-item-text An expression that will convert your object to a single string.
         * @param {string=} placeholder Placeholder text that will be forwarded to the input.
         * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete
         * @param {boolean=} ng-disabled Determines whether or not to disable the input field
         * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
         *     make suggestions
         * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
         *     for results
         * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
         *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
         *     Also the autocomplete will immediately focus the input element.
         * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label
         * @param {boolean=} md-autoselect If true, the first item will be selected by default
         * @param {string=} md-menu-class This will be applied to the dropdown menu for styling
         * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
         *     `md-input-container`
         * @param {string=} md-input-name The name attribute given to the input element to be used with
         *     FormController
         * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
         *     on focus.
         * @param {string=} md-input-id An ID to be added to the input element
         * @param {number=} md-input-minlength The minimum length for the input's value for validation
         * @param {number=} md-input-maxlength The maximum length for the input's value for validation
         * @param {boolean=} md-select-on-match When set, autocomplete will automatically select exact
         *     the item if the search text is an exact match
         * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
         *     will select on case-insensitive match
         *
         * @usage
         * ### Basic Example
         * <hljs lang="html">
         *   <md-autocomplete
         *       md-selected-item="selectedItem"
         *       md-search-text="searchText"
         *       md-items="item in getMatches(searchText)"
         *       md-item-text="item.display">
         *     <span md-highlight-text="searchText">{{item.display}}</span>
         *   </md-autocomplete>
         * </hljs>
         *
         * ### Example with "not found" message
         * <hljs lang="html">
         * <md-autocomplete
         *     md-selected-item="selectedItem"
         *     md-search-text="searchText"
         *     md-items="item in getMatches(searchText)"
         *     md-item-text="item.display">
         *   <md-item-template>
         *     <span md-highlight-text="searchText">{{item.display}}</span>
         *   </md-item-template>
         *   <md-not-found>
         *     No matches found.
         *   </md-not-found>
         * </md-autocomplete>
         * </hljs>
         *
         * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
         *     different parts that make up our component.
         *
         * ### Example with validation
         * <hljs lang="html">
         * <form name="autocompleteForm">
         *   <md-autocomplete
         *       required
         *       md-input-name="autocomplete"
         *       md-selected-item="selectedItem"
         *       md-search-text="searchText"
         *       md-items="item in getMatches(searchText)"
         *       md-item-text="item.display">
         *     <md-item-template>
         *       <span md-highlight-text="searchText">{{item.display}}</span>
         *     </md-item-template>
         *     <div ng-messages="autocompleteForm.autocomplete.$error">
         *       <div ng-message="required">This field is required</div>
         *     </div>
         *   </md-autocomplete>
         * </form>
         * </hljs>
         *
         * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
         *     different parts that make up our component.
         */

        function MdAutocomplete() {

            return {
                controller: 'MdAutocompleteCtrl',
                controllerAs: '$mdAutocompleteCtrl',
                scope: {
                    inputName: '@mdInputName',
                    inputMinlength: '@mdInputMinlength',
                    inputMaxlength: '@mdInputMaxlength',
                    searchText: '=?mdSearchText',
                    selectedItem: '=?mdSelectedItem',
                    itemsExpr: '@mdItems',
                    itemText: '&mdItemText',
                    placeholder: '@placeholder',
                    noCache: '=?mdNoCache',
                    selectOnMatch: '=?mdSelectOnMatch',
                    matchInsensitive: '=?mdMatchCaseInsensitive',
                    itemChange: '&?mdSelectedItemChange',
                    textChange: '&?mdSearchTextChange',
                    minLength: '=?mdMinLength',
                    delay: '=?mdDelay',
                    autofocus: '=?mdAutofocus',
                    floatingLabel: '@?mdFloatingLabel',
                    autoselect: '=?mdAutoselect',
                    menuClass: '@?mdMenuClass',
                    inputId: '@?mdInputId',
                    returnObject: '=?auReturnObject',
                    onEnter: '&?auOnEnter'
                },
                link: function (scope, element, attrs, controller) {
                    // Retrieve the state of using a md-not-found template by using our attribute, which will
                    // be added to the element in the template function.
                    controller.hasNotFound = !!element.attr('md-has-not-found');
                },
                template: function (element, attr) {
                    var noItemsTemplate = getNoItemsTemplate(),
                        itemTemplate = getItemTemplate(),
                        leftover = element.html(),
                        tabindex = attr.tabindex;

                    // Set our attribute for the link function above which runs later.
                    // We will set an attribute, because otherwise the stored variables will be trashed when
                    // removing the element is hidden while retrieving the template. For example when using ngIf.
                    if (noItemsTemplate) element.attr('md-has-not-found', true);

                    // Always set our tabindex of the autocomplete directive to -1, because our input
                    // will hold the actual tabindex.
                    element.attr('tabindex', '-1');

                    return '\
        <md-autocomplete-wrap\
            layout="row"\
            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \'md-menu-showing\': !$mdAutocompleteCtrl.hidden }"\
            role="listbox">\
          ' + getInputElement() + '\
          <md-progress-linear\
              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
              md-mode="indeterminate"></md-progress-linear>\
          <md-virtual-repeat-container\
              md-auto-shrink\
              md-auto-shrink-min="1"\
              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
              ng-hide="$mdAutocompleteCtrl.hidden"\
              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
              role="presentation">\
            <ul class="md-autocomplete-suggestions"\
                ng-class="::menuClass"\
                id="ul-{{$mdAutocompleteCtrl.id}}">\
              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
                  ng-click="$mdAutocompleteCtrl.select($index)"\
                  md-extra-name="$mdAutocompleteCtrl.itemName">\
                  ' + itemTemplate + '\
                  </li>' + noItemsTemplate + '\
            </ul>\
          </md-virtual-repeat-container>\
        </md-autocomplete-wrap>\
        <aria-status\
            class="_md-visually-hidden"\
            role="status"\
            aria-live="assertive">\
          <p ng-repeat="message in $mdAutocompleteCtrl.messages track by $index" ng-if="message">{{message}}</p>\
        </aria-status>';

                    function getItemTemplate() {
                        var templateTag = element.find('md-item-template').detach(),
                            html = templateTag.length ? templateTag.html() : element.html();
                        if (!templateTag.length) element.empty();
                        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
                    }

                    function getNoItemsTemplate() {
                        var templateTag = element.find('md-not-found').detach(),
                            template = templateTag.length ? templateTag.html() : '';
                        return template ?
                            '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
                         md-autocomplete-parent-scope>' + template + '</li>' :
                            '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
                         md-autocomplete-parent-scope>No matches</li>';

                    }

                    function getInputElement() {
                        if (attr.mdFloatingLabel) {
                            return '\
            <md-input-container flex ng-if="floatingLabel">\
              <label>{{floatingLabel}}</label>\
              <input type="search"\
                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
                  name="{{inputName}}"\
                  autocomplete="off"\
                  ng-required="$mdAutocompleteCtrl.isRequired"\
                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                  ng-minlength="inputMinlength"\
                  ng-maxlength="inputMaxlength"\
                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                  ng-blur="$mdAutocompleteCtrl.blur()"\
                  ' + (attr.mdNoAsterisk != null ? 'md-no-asterisk="' + attr.mdNoAsterisk + '"' : '') + '\
                  ng-focus="$mdAutocompleteCtrl.focus()"\
                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                  ' + (attr.mdSelectOnFocus != null ? 'md-select-on-focus=""' : '') + '\
                  aria-label="{{floatingLabel}}"\
                  aria-autocomplete="list"\
                  aria-haspopup="true"\
                  aria-activedescendant=""\
                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
            </md-input-container>';
                        } else {
                            return '\
            <input flex type="search"\
                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
                name="{{inputName}}"\
                ng-if="!floatingLabel"\
                autocomplete="off"\
                ng-required="$mdAutocompleteCtrl.isRequired"\
                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                ng-model="$mdAutocompleteCtrl.scope.searchText"\
                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                ng-blur="$mdAutocompleteCtrl.blur()"\
                ng-focus="$mdAutocompleteCtrl.focus()"\
                placeholder="{{placeholder}}"\
                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                ' + (attr.mdSelectOnFocus != null ? 'md-select-on-focus=""' : '') + '\
                aria-label="{{placeholder}}"\
                aria-autocomplete="list"\
                aria-haspopup="true"\
                aria-activedescendant=""\
                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
            <button\
                type="button"\
                tabindex="-1"\
                ng-if="$mdAutocompleteCtrl.scope.searchText && !$mdAutocompleteCtrl.isDisabled"\
                ng-click="$mdAutocompleteCtrl.clear()">\
              <md-icon md-svg-icon="md-close"></md-icon>\
              <span class="_md-visually-hidden">Clear</span>\
            </button>\
                ';
                        }
                    }
                }
            };
        }

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.autocomplete')
            .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);

        function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
            return {
                restrict: 'AE',
                compile: compile,
                terminal: true,
                transclude: 'element'
            };

            function compile(tElement, tAttr, transclude) {
                return function postLink(scope, element, attr) {
                    var ctrl = scope.$mdAutocompleteCtrl;
                    var newScope = ctrl.parent.$new();
                    var itemName = ctrl.itemName;

                    // Watch for changes to our scope's variables and copy them to the new scope
                    watchVariable('$index', '$index');
                    watchVariable('item', itemName);

                    // Ensure that $digest calls on our scope trigger $digest on newScope.
                    connectScopes();

                    // Link the element against newScope.
                    transclude(newScope, function (clone) {
                        element.after(clone);
                    });

                    /**
                     * Creates a watcher for variables that are copied from the parent scope
                     * @param variable
                     * @param alias
                     */
                    function watchVariable(variable, alias) {
                        newScope[alias] = scope[variable];

                        scope.$watch(variable, function (value) {
                            $mdUtil.nextTick(function () {
                                newScope[alias] = value;
                            });
                        });
                    }

                    /**
                     * Creates watchers on scope and newScope that ensure that for any
                     * $digest of scope, newScope is also $digested.
                     */
                    function connectScopes() {
                        var scopeDigesting = false;
                        var newScopeDigesting = false;

                        scope.$watch(function () {
                            if (newScopeDigesting || scopeDigesting) {
                                return;
                            }

                            scopeDigesting = true;
                            scope.$$postDigest(function () {
                                if (!newScopeDigesting) {
                                    newScope.$digest();
                                }

                                scopeDigesting = newScopeDigesting = false;
                            });
                        });

                        newScope.$watch(function () {
                            newScopeDigesting = true;
                        });
                    }
                };
            }
        }
        MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];
    })();
    (function () {
        "use strict";

        angular
            .module('material.components.autocomplete')
            .controller('MdHighlightCtrl', MdHighlightCtrl);

        function MdHighlightCtrl($scope, $element, $attrs) {
            this.init = init;

            function init(termExpr, unsafeTextExpr) {
                var text = null,
                    regex = null,
                    flags = $attrs.mdHighlightFlags || '',
                    watcher = $scope.$watch(function ($scope) {
                        return {
                            term: termExpr($scope),
                            unsafeText: unsafeTextExpr($scope)
                        };
                    }, function (state, prevState) {
                        if (text === null || state.unsafeText !== prevState.unsafeText) {
                            text = angular.element('<div>').text(state.unsafeText).html()
                        }
                        if (regex === null || state.term !== prevState.term) {
                            regex = getRegExp(state.term, flags);
                        }

                        $element.html(text.replace(regex, '<span class="highlight">$&</span>'));
                    }, true);
                $element.on('$destroy', watcher);
            }

            function sanitize(term) {
                return term && term.replace(/[\\\^\$\*\+\?\.\(\)\|\{}\[\]]/g, '\\$&');
            }

            function getRegExp(text, flags) {
                var str = '';
                if (flags.indexOf('^') >= 1) str += '^';
                str += text;
                if (flags.indexOf('$') >= 1) str += '$';
                return new RegExp(sanitize(str), flags.replace(/[\$\^]/g, ''));
            }
        }
        MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.autocomplete')
            .directive('mdHighlightText', MdHighlight);

        /**
         * @ngdoc directive
         * @name mdHighlightText
         * @module material.components.autocomplete
         *
         * @description
         * The `md-highlight-text` directive allows you to specify text that should be highlighted within
         *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
         *     be styled through CSS.  Please note that child elements may not be used with this directive.
         *
         * @param {string} md-highlight-text A model to be searched for
         * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
         * #### **Supported flags**:
         * - `g`: Find all matches within the provided text
         * - `i`: Ignore case when searching for matches
         * - `$`: Only match if the text ends with the search term
         * - `^`: Only match if the text begins with the search term
         *
         * @usage
         * <hljs lang="html">
         * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
         * <ul>
         *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
         *     {{result.text}}
         *   </li>
         * </ul>
         * </hljs>
         */

        function MdHighlight($interpolate, $parse) {
            return {
                terminal: true,
                controller: 'MdHighlightCtrl',
                compile: function mdHighlightCompile(tElement, tAttr) {
                    var termExpr = $parse(tAttr.mdHighlightText);
                    var unsafeTextExpr = $interpolate(tElement.html());

                    return function mdHighlightLink(scope, element, attr, ctrl) {
                        ctrl.init(termExpr, unsafeTextExpr);
                    };
                }
            };
        }
        MdHighlight.$inject = ["$interpolate", "$parse"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .controller('MdChipCtrl', MdChipCtrl);

        /**
         * Controller for the MdChip component. Responsible for handling keyboard
         * events and editting the chip if needed.
         *
         * @param $scope
         * @param $element
         * @param $mdConstant
         * @param $timeout
         * @param $mdUtil
         * @constructor
         */
        function MdChipCtrl($scope, $element, $mdConstant, $timeout, $mdUtil) {
            /**
             * @type {$scope}
             */
            this.$scope = $scope;

            /**
             * @type {$element}
             */
            this.$element = $element;

            /**
             * @type {$mdConstant}
             */
            this.$mdConstant = $mdConstant;

            /**
             * @type {$timeout}
             */
            this.$timeout = $timeout;

            /**
             * @type {$mdUtil}
             */
            this.$mdUtil = $mdUtil;

            /**
             * @type {boolean}
             */
            this.isEditting = false;

            /**
             * @type {MdChipsCtrl}
             */
            this.parentController = undefined;

            /**
             * @type {boolean}
             */
            this.enableChipEdit = false;
        }
        MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];


        /**
         * @param {MdChipsCtrl} controller
         */
        MdChipCtrl.prototype.init = function (controller) {
            this.parentController = controller;
            this.enableChipEdit = this.parentController.enableChipEdit;

            if (this.enableChipEdit) {
                this.$element.on('keydown', this.chipKeyDown.bind(this));
                this.$element.on('mousedown', this.chipMouseDown.bind(this));
                this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
            }
        };


        /**
         * @return {Object}
         */
        MdChipCtrl.prototype.getChipContent = function () {
            var chipContents = this.$element[0].getElementsByClassName('_md-chip-content');
            return angular.element(chipContents[0]);
        };


        /**
         * @return {Object}
         */
        MdChipCtrl.prototype.getContentElement = function () {
            return angular.element(this.getChipContent().children()[0]);
        };


        /**
         * @return {number}
         */
        MdChipCtrl.prototype.getChipIndex = function () {
            return parseInt(this.$element.attr('index'));
        };


        /**
         * Presents an input element to edit the contents of the chip.
         */
        MdChipCtrl.prototype.goOutOfEditMode = function () {
            if (!this.isEditting) return;

            this.isEditting = false;
            this.$element.removeClass('_md-chip-editing');
            this.getChipContent()[0].contentEditable = 'false';
            var chipIndex = this.getChipIndex();

            var content = this.getContentElement().text();
            if (content) {
                this.parentController.updateChipContents(
                    chipIndex,
                    this.getContentElement().text()
                );

                this.$mdUtil.nextTick(function () {
                    if (this.parentController.selectedChip === chipIndex) {
                        this.parentController.focusChip(chipIndex);
                    }
                }.bind(this));
            } else {
                this.parentController.removeChipAndFocusInput(chipIndex);
            }
        };


        /**
         * Given an HTML element. Selects contents of it.
         * @param node
         */
        MdChipCtrl.prototype.selectNodeContents = function (node) {
            var range, selection;
            if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(node);
                range.select();
            } else if (window.getSelection) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(node);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        };


        /**
         * Presents an input element to edit the contents of the chip.
         */
        MdChipCtrl.prototype.goInEditMode = function () {
            this.isEditting = true;
            this.$element.addClass('_md-chip-editing');
            this.getChipContent()[0].contentEditable = 'true';
            this.getChipContent().on('blur', function () {
                this.goOutOfEditMode();
            }.bind(this));

            this.selectNodeContents(this.getChipContent()[0]);
        };


        /**
         * Handles the keydown event on the chip element. If enable-chip-edit attribute is
         * set to true, space or enter keys can trigger going into edit mode. Enter can also
         * trigger submitting if the chip is already being edited.
         * @param event
         */
        MdChipCtrl.prototype.chipKeyDown = function (event) {
            if (!this.isEditting &&
                (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
                    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
                event.preventDefault();
                this.goInEditMode();
            } else if (this.isEditting &&
                event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
                event.preventDefault();
                this.goOutOfEditMode();
            }
        };


        /**
         * Handles the double click event
         */
        MdChipCtrl.prototype.chipMouseDown = function () {
            if (this.getChipIndex() == this.parentController.selectedChip &&
                this.enableChipEdit &&
                !this.isEditting) {
                this.goInEditMode();
            }
        };

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .directive('mdChip', MdChip);

        /**
         * @ngdoc directive
         * @name mdChip
         * @module material.components.chips
         *
         * @description
         * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
         * chips.
         *
         *
         * @usage
         * <hljs lang="html">
         *   <md-chip>{{$chip}}</md-chip>
         * </hljs>
         *
         */

        // This hint text is hidden within a chip but used by screen readers to
        // inform the user how they can interact with a chip.
        var DELETE_HINT_TEMPLATE = '\
    <span ng-if="!$mdChipsCtrl.readonly" class="_md-visually-hidden">\
      {{$mdChipsCtrl.deleteHint}}\
    </span>';

        /**
         * MDChip Directive Definition
         *
         * @param $mdTheming
         * @param $mdUtil
         * @ngInject
         */
        function MdChip($mdTheming, $mdUtil) {
            var hintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);

            return {
                restrict: 'E',
                require: ['^?mdChips', 'mdChip'],
                compile: compile,
                controller: 'MdChipCtrl'
            };

            function compile(element, attr) {
                // Append the delete template
                element.append($mdUtil.processTemplate(hintTemplate));

                return function postLink(scope, element, attr, ctrls) {
                    var chipsController = ctrls.shift();
                    var chipController = ctrls.shift();
                    $mdTheming(element);

                    if (chipsController) {
                        chipController.init(chipsController);

                        angular.element(element[0].querySelector('._md-chip-content'))
                            .on('blur', function () {
                                chipsController.selectedChip = -1;
                                chipsController.$scope.$applyAsync();
                            });
                    }
                };
            }
        }
        MdChip.$inject = ["$mdTheming", "$mdUtil"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .directive('mdChipRemove', MdChipRemove);

        /**
         * @ngdoc directive
         * @name mdChipRemove
         * @module material.components.chips
         *
         * @description
         * `<md-chip-remove>`
         * Designates an element to be used as the delete button for a chip. This
         * element is passed as a child of the `md-chips` element.
         *
         * @usage
         * <hljs lang="html">
         *   <md-chips><button md-chip-remove>DEL</button></md-chips>
         * </hljs>
         */


        /**
         * MdChipRemove Directive Definition.
         * 
         * @param $compile
         * @param $timeout
         * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
         * @constructor
         */
        function MdChipRemove($timeout) {
            return {
                restrict: 'A',
                require: '^mdChips',
                scope: false,
                link: postLink
            };

            function postLink(scope, element, attr, ctrl) {
                element.on('click', function (event) {
                    scope.$apply(function () {
                        ctrl.removeChip(scope.$$replacedScope.$index);
                    });
                });

                // Child elements aren't available until after a $timeout tick as they are hidden by an
                // `ng-if`. see http://goo.gl/zIWfuw
                $timeout(function () {
                    element.attr({ tabindex: -1, 'aria-hidden': true });
                    element.find('button').attr('tabindex', '-1');
                });
            }
        }
        MdChipRemove.$inject = ["$timeout"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .controller('MdChipsCtrl', MdChipsCtrl);

        /**
         * Controller for the MdChips component. Responsible for adding to and
         * removing from the list of chips, marking chips as selected, and binding to
         * the models of various input components.
         *
         * @param $scope
         * @param $mdConstant
         * @param $log
         * @param $element
         * @param $mdUtil
         * @constructor
         */
        function MdChipsCtrl($scope, $mdConstant, $log, $element, $timeout, $mdUtil) {
            /** @type {$timeout} **/
            this.$timeout = $timeout;

            /** @type {Object} */
            this.$mdConstant = $mdConstant;

            /** @type {angular.$scope} */
            this.$scope = $scope;

            /** @type {angular.$scope} */
            this.parent = $scope.$parent;

            /** @type {$log} */
            this.$log = $log;

            /** @type {$element} */
            this.$element = $element;

            /** @type {angular.NgModelController} */
            this.ngModelCtrl = null;

            /** @type {angular.NgModelController} */
            this.userInputNgModelCtrl = null;

            /** @type {Element} */
            this.userInputElement = null;

            /** @type {Array.<Object>} */
            this.items = [];

            /** @type {number} */
            this.selectedChip = -1;

            /** @type {boolean} */
            this.hasAutocomplete = false;

            /** @type {string} */
            this.enableChipEdit = $mdUtil.parseAttributeBoolean(this.mdEnableChipEdit);

            /**
             * Hidden hint text for how to delete a chip. Used to give context to screen readers.
             * @type {string}
             */
            this.deleteHint = 'Press delete to remove this chip.';

            /**
             * Hidden label for the delete button. Used to give context to screen readers.
             * @type {string}
             */
            this.deleteButtonLabel = 'Remove';

            /**
             * Model used by the input element.
             * @type {string}
             */
            this.chipBuffer = '';

            /**
             * Whether to use the onAppend expression to transform the chip buffer
             * before appending it to the list.
             * @type {boolean}
             *
             *
             * @deprecated Will remove in 1.0.
             */
            this.useOnAppend = false;

            /**
             * Whether to use the transformChip expression to transform the chip buffer
             * before appending it to the list.
             * @type {boolean}
             */
            this.useTransformChip = false;

            /**
             * Whether to use the onAdd expression to notify of chip additions.
             * @type {boolean}
             */
            this.useOnAdd = false;

            /**
             * Whether to use the onRemove expression to notify of chip removals.
             * @type {boolean}
             */
            this.useOnRemove = false;

            /**
             * Whether to use the onSelect expression to notify the component's user
             * after selecting a chip from the list.
             * @type {boolean}
             */
            this.useOnSelect = false;
        }
        MdChipsCtrl.$inject = ["$scope", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];

        /**
         * Handles the keydown event on the input element: by default <enter> appends
         * the buffer to the chip list, while backspace removes the last chip in the
         * list if the current buffer is empty.
         * @param event
         */
        MdChipsCtrl.prototype.inputKeydown = function (event) {
            var chipBuffer = this.getChipBuffer();

            // If we have an autocomplete, and it handled the event, we have nothing to do
            if (this.hasAutocomplete && event.isDefaultPrevented && event.isDefaultPrevented()) {
                return;
            }

            if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
                if (chipBuffer) return;
                event.preventDefault();
                event.stopPropagation();
                if (this.items.length) this.selectAndFocusChipSafe(this.items.length - 1);
                return;
            }

            // By default <enter> appends the buffer to the chip list.
            if (!this.separatorKeys || this.separatorKeys.length < 1) {
                this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
            }

            // Support additional separator key codes in an array of `md-separator-keys`.
            if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
                if ((this.hasAutocomplete && this.requireMatch) || !chipBuffer) return;
                event.preventDefault();

                // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
                if (this.hasMaxChipsReached()) return;

                this.appendChip(chipBuffer.trim());
                this.resetChipBuffer();
            }
        };


        /**
         * Updates the content of the chip at given index
         * @param chipIndex
         * @param chipContents
         */
        MdChipsCtrl.prototype.updateChipContents = function (chipIndex, chipContents) {
            if (chipIndex >= 0 && chipIndex < this.items.length) {
                this.items[chipIndex] = chipContents;
                this.ngModelCtrl.$setDirty();
            }
        };


        /**
         * Returns true if a chip is currently being edited. False otherwise.
         * @return {boolean}
         */
        MdChipsCtrl.prototype.isEditingChip = function () {
            return !!this.$element[0].getElementsByClassName('_md-chip-editing').length;
        };


        /**
         * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
         * keys switch which chips is active
         * @param event
         */
        MdChipsCtrl.prototype.chipKeydown = function (event) {
            if (this.getChipBuffer()) return;
            if (this.isEditingChip()) return;

            switch (event.keyCode) {
                case this.$mdConstant.KEY_CODE.BACKSPACE:
                case this.$mdConstant.KEY_CODE.DELETE:
                    if (this.selectedChip < 0) return;
                    event.preventDefault();
                    this.removeAndSelectAdjacentChip(this.selectedChip);
                    break;
                case this.$mdConstant.KEY_CODE.LEFT_ARROW:
                    event.preventDefault();
                    if (this.selectedChip < 0) this.selectedChip = this.items.length;
                    if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
                    break;
                case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
                    event.preventDefault();
                    this.selectAndFocusChipSafe(this.selectedChip + 1);
                    break;
                case this.$mdConstant.KEY_CODE.ESCAPE:
                case this.$mdConstant.KEY_CODE.TAB:
                    if (this.selectedChip < 0) return;
                    event.preventDefault();
                    this.onFocus();
                    break;
            }
        };

        /**
         * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
         * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
         * always.
         */
        MdChipsCtrl.prototype.getPlaceholder = function () {
            // Allow `secondary-placeholder` to be blank.
            var useSecondary = (this.items.length &&
                (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
            return useSecondary ? this.secondaryPlaceholder : this.placeholder;
        };

        /**
         * Removes chip at {@code index} and selects the adjacent chip.
         * @param index
         */
        MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function (index) {
            var selIndex = this.getAdjacentChipIndex(index);
            this.removeChip(index);
            this.$timeout(angular.bind(this, function () {
                this.selectAndFocusChipSafe(selIndex);
            }));
        };

        /**
         * Sets the selected chip index to -1.
         */
        MdChipsCtrl.prototype.resetSelectedChip = function () {
            this.selectedChip = -1;
        };

        /**
         * Gets the index of an adjacent chip to select after deletion. Adjacency is
         * determined as the next chip in the list, unless the target chip is the
         * last in the list, then it is the chip immediately preceding the target. If
         * there is only one item in the list, -1 is returned (select none).
         * The number returned is the index to select AFTER the target has been
         * removed.
         * If the current chip is not selected, then -1 is returned to select none.
         */
        MdChipsCtrl.prototype.getAdjacentChipIndex = function (index) {
            var len = this.items.length - 1;
            return (len == 0) ? -1 :
                (index == len) ? index - 1 : index;
        };

        /**
         * Append the contents of the buffer to the chip list. This method will first
         * call out to the md-transform-chip method, if provided.
         *
         * @param newChip
         */
        MdChipsCtrl.prototype.appendChip = function (newChip) {
            if (this.useTransformChip && this.transformChip) {
                var transformedChip = this.transformChip({ '$chip': newChip });

                // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
                // they want the string version.
                if (angular.isDefined(transformedChip)) {
                    newChip = transformedChip;
                }
            }

            // If items contains an identical object to newChip, do not append
            if (angular.isObject(newChip)) {
                var identical = this.items.some(function (item) {
                    return angular.equals(newChip, item);
                });
                if (identical) return;
            }

            // Check for a null (but not undefined), or existing chip and cancel appending
            if (newChip == null || this.items.indexOf(newChip) + 1) return;

            // Append the new chip onto our list
            var index = this.items.push(newChip);

            // Update model validation
            this.ngModelCtrl.$setDirty();
            this.validateModel();

            // If they provide the md-on-add attribute, notify them of the chip addition
            if (this.useOnAdd && this.onAdd) {
                this.onAdd({ '$chip': newChip, '$index': index });
            }
        };

        /**
         * Sets whether to use the md-on-append expression. This expression is
         * bound to scope and controller in {@code MdChipsDirective} as
         * {@code onAppend}. Due to the nature of directive scope bindings, the
         * controller cannot know on its own/from the scope whether an expression was
         * actually provided.
         *
         * @deprecated
         *
         * TODO: Remove deprecated md-on-append functionality in 1.0
         */
        MdChipsCtrl.prototype.useOnAppendExpression = function () {
            this.$log.warn("md-on-append is deprecated; please use md-transform-chip or md-on-add instead");
            if (!this.useTransformChip || !this.transformChip) {
                this.useTransformChip = true;
                this.transformChip = this.onAppend;
            }
        };

        /**
         * Sets whether to use the md-transform-chip expression. This expression is
         * bound to scope and controller in {@code MdChipsDirective} as
         * {@code transformChip}. Due to the nature of directive scope bindings, the
         * controller cannot know on its own/from the scope whether an expression was
         * actually provided.
         */
        MdChipsCtrl.prototype.useTransformChipExpression = function () {
            this.useTransformChip = true;
        };

        /**
         * Sets whether to use the md-on-add expression. This expression is
         * bound to scope and controller in {@code MdChipsDirective} as
         * {@code onAdd}. Due to the nature of directive scope bindings, the
         * controller cannot know on its own/from the scope whether an expression was
         * actually provided.
         */
        MdChipsCtrl.prototype.useOnAddExpression = function () {
            this.useOnAdd = true;
        };

        /**
         * Sets whether to use the md-on-remove expression. This expression is
         * bound to scope and controller in {@code MdChipsDirective} as
         * {@code onRemove}. Due to the nature of directive scope bindings, the
         * controller cannot know on its own/from the scope whether an expression was
         * actually provided.
         */
        MdChipsCtrl.prototype.useOnRemoveExpression = function () {
            this.useOnRemove = true;
        };

        /*
         * Sets whether to use the md-on-select expression. This expression is
         * bound to scope and controller in {@code MdChipsDirective} as
         * {@code onSelect}. Due to the nature of directive scope bindings, the
         * controller cannot know on its own/from the scope whether an expression was
         * actually provided.
         */
        MdChipsCtrl.prototype.useOnSelectExpression = function () {
            this.useOnSelect = true;
        };

        /**
         * Gets the input buffer. The input buffer can be the model bound to the
         * default input item {@code this.chipBuffer}, the {@code selectedItem}
         * model of an {@code md-autocomplete}, or, through some magic, the model
         * bound to any inpput or text area element found within a
         * {@code md-input-container} element.
         * @return {Object|string}
         */
        MdChipsCtrl.prototype.getChipBuffer = function () {
            return !this.userInputElement ? this.chipBuffer :
                this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
                    this.userInputElement[0].value;
        };

        /**
         * Resets the input buffer for either the internal input or user provided input element.
         */
        MdChipsCtrl.prototype.resetChipBuffer = function () {
            if (this.userInputElement) {
                if (this.userInputNgModelCtrl) {
                    this.userInputNgModelCtrl.$setViewValue('');
                    this.userInputNgModelCtrl.$render();
                } else {
                    this.userInputElement[0].value = '';
                }
            } else {
                this.chipBuffer = '';
            }
        };

        MdChipsCtrl.prototype.hasMaxChipsReached = function () {
            if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;

            return this.maxChips > 0 && this.items.length >= this.maxChips;
        };

        /**
         * Updates the validity properties for the ngModel.
         */
        MdChipsCtrl.prototype.validateModel = function () {
            this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
        };

        /**
         * Removes the chip at the given index.
         * @param index
         */
        MdChipsCtrl.prototype.removeChip = function (index) {
            var removed = this.items.splice(index, 1);

            // Update model validation
            this.ngModelCtrl.$setDirty();
            this.validateModel();

            if (removed && removed.length && this.useOnRemove && this.onRemove) {
                this.onRemove({ '$chip': removed[0], '$index': index });
            }
        };

        MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
            this.removeChip(index);
            this.onFocus();
        };
        /**
         * Selects the chip at `index`,
         * @param index
         */
        MdChipsCtrl.prototype.selectAndFocusChipSafe = function (index) {
            if (!this.items.length) {
                this.selectChip(-1);
                this.onFocus();
                return;
            }
            if (index === this.items.length) return this.onFocus();
            index = Math.max(index, 0);
            index = Math.min(index, this.items.length - 1);
            this.selectChip(index);
            this.focusChip(index);
        };

        /**
         * Marks the chip at the given index as selected.
         * @param index
         */
        MdChipsCtrl.prototype.selectChip = function (index) {
            if (index >= -1 && index <= this.items.length) {
                this.selectedChip = index;

                // Fire the onSelect if provided
                if (this.useOnSelect && this.onSelect) {
                    this.onSelect({ '$chip': this.items[this.selectedChip] });
                }
            } else {
                this.$log.warn('Selected Chip index out of bounds; ignoring.');
            }
        };

        /**
         * Selects the chip at `index` and gives it focus.
         * @param index
         */
        MdChipsCtrl.prototype.selectAndFocusChip = function (index) {
            this.selectChip(index);
            if (index != -1) {
                this.focusChip(index);
            }
        };

        /**
         * Call `focus()` on the chip at `index`
         */
        MdChipsCtrl.prototype.focusChip = function (index) {
            this.$element[0].querySelector('md-chip[index="' + index + '"] ._md-chip-content').focus();
        };

        /**
         * Configures the required interactions with the ngModel Controller.
         * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
         * @param ngModelCtrl
         */
        MdChipsCtrl.prototype.configureNgModel = function (ngModelCtrl) {
            this.ngModelCtrl = ngModelCtrl;

            var self = this;
            ngModelCtrl.$render = function () {
                // model is updated. do something.
                self.items = self.ngModelCtrl.$viewValue;
            };
        };

        MdChipsCtrl.prototype.onFocus = function () {
            var input = this.$element[0].querySelector('input');
            input && input.focus();
            this.resetSelectedChip();
        };

        MdChipsCtrl.prototype.onInputFocus = function () {
            this.inputHasFocus = true;
            this.resetSelectedChip();
        };

        MdChipsCtrl.prototype.onInputBlur = function () {
            this.inputHasFocus = false;
        };

        /**
         * Configure event bindings on a user-provided input element.
         * @param inputElement
         */
        MdChipsCtrl.prototype.configureUserInput = function (inputElement) {
            this.userInputElement = inputElement;

            // Find the NgModelCtrl for the input element
            var ngModelCtrl = inputElement.controller('ngModel');
            // `.controller` will look in the parent as well.
            if (ngModelCtrl != this.ngModelCtrl) {
                this.userInputNgModelCtrl = ngModelCtrl;
            }

            var scope = this.$scope;
            var ctrl = this;

            // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
            var scopeApplyFn = function (event, fn) {
                scope.$evalAsync(angular.bind(ctrl, fn, event));
            };

            // Bind to keydown and focus events of input
            inputElement
                .attr({ tabindex: 0 })
                .on('keydown', function (event) { scopeApplyFn(event, ctrl.inputKeydown) })
                .on('focus', function (event) { scopeApplyFn(event, ctrl.onInputFocus) })
                .on('blur', function (event) { scopeApplyFn(event, ctrl.onInputBlur) })
        };

        MdChipsCtrl.prototype.configureAutocomplete = function (ctrl) {
            if (ctrl) {
                this.hasAutocomplete = true;

                ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
                    if (item) {
                        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
                        if (this.hasMaxChipsReached()) return;

                        this.appendChip(item);
                        this.resetChipBuffer();
                    }
                }));

                this.$element.find('input')
                    .on('focus', angular.bind(this, this.onInputFocus))
                    .on('blur', angular.bind(this, this.onInputBlur));
            }
        };

        MdChipsCtrl.prototype.hasFocus = function () {
            return this.inputHasFocus || this.selectedChip >= 0;
        };

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .directive('mdChips', MdChips);

        /**
         * @ngdoc directive
         * @name mdChips
         * @module material.components.chips
         *
         * @description
         * `<md-chips>` is an input component for building lists of strings or objects. The list items are
         * displayed as 'chips'. This component can make use of an `<input>` element or an 
         * `<md-autocomplete>` element.
         *
         * ### Custom templates
         * A custom template may be provided to render the content of each chip. This is achieved by
         * specifying an `<md-chip-template>` element containing the custom content as a child of
         * `<md-chips>`.
         *
         * Note: Any attributes on
         * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
         * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
         * the chip object and its index in the list of chips, respectively.
         * To override the chip delete control, include an element (ideally a button) with the attribute
         * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
         * is also placed as a sibling to the chip content (on which there are also click listeners) to
         * avoid a nested ng-click situation.
         *
         * <h3> Pending Features </h3>
         * <ul style="padding-left:20px;">
         *
         *   <ul>Style
         *     <li>Colours for hover, press states (ripple?).</li>
         *   </ul>
         *
         *   <ul>Validation
         *     <li>allow a validation callback</li>
         *     <li>hilighting style for invalid chips</li>
         *   </ul>
         *
         *   <ul>Item mutation
         *     <li>Support `
         *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
         *       click?
         *     </li>
         *   </ul>
         *
         *   <ul>Truncation and Disambiguation (?)
         *     <li>Truncate chip text where possible, but do not truncate entries such that two are
         *     indistinguishable.</li>
         *   </ul>
         *
         *   <ul>Drag and Drop
         *     <li>Drag and drop chips between related `<md-chips>` elements.
         *     </li>
         *   </ul>
         * </ul>
         *
         *  <span style="font-size:.8em;text-align:center">
         *    Warning: This component is a WORK IN PROGRESS. If you use it now,
         *    it will probably break on you in the future.
         *  </span>
         *
         * @param {string=|object=} ng-model A model to bind the list of items to
         * @param {string=} placeholder Placeholder text that will be forwarded to the input.
         * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
         *    displayed when there is at least one item in the list
         * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
         *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
         *    marked as readonly.
         * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can 
         *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
         *    supported for chips with basic template.
         * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
         *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
         *    amount is reached.
         * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
         *    expects one of the following return values:
         *    - an object representing the `$chip` input string
         *    - `undefined` to simply add the `$chip` input string, or
         *    - `null` to prevent the chip from being appended
         * @param {expression=} md-on-add An expression which will be called when a chip has been
         *    added.
         * @param {expression=} md-on-remove An expression which will be called when a chip has been
         *    removed.
         * @param {expression=} md-on-select An expression which will be called when a chip is selected.
         * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
         *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
         * @param {string=} delete-hint A string read by screen readers instructing users that pressing
         *    the delete key will remove the chip.
         * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
         *    screen readers.
         * @param {expression=} md-separator-keys An array of key codes used to separate chips.
         *
         * @usage
         * <hljs lang="html">
         *   <md-chips
         *       ng-model="myItems"
         *       placeholder="Add an item"
         *       readonly="isReadOnly">
         *   </md-chips>
         * </hljs>
         *
         * <h3>Validation</h3>
         * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
         * on our custom validators.
         * <hljs lang="html">
         *   <form name="userForm">
         *     <md-chips
         *       name="fruits"
         *       ng-model="myItems"
         *       placeholder="Add an item"
         *       md-max-chips="5">
         *     </md-chips>
         *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
         *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
         *    </div>
         *   </form>
         * </hljs>
         *
         */


        var MD_CHIPS_TEMPLATE = '\
      <md-chips-wrap\
          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}"\
          class="md-chips">\
        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
            index="{{$index}}"\
            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
          <div class="_md-chip-content"\
              tabindex="-1"\
              aria-hidden="true"\
              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
          <div ng-if="!$mdChipsCtrl.readonly"\
               class="_md-chip-remove-container"\
               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
        </md-chip>\
        <div class="_md-chip-input-container">\
          <div ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl"\
               md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
        </div>\
      </md-chips-wrap>';

        var CHIP_INPUT_TEMPLATE = '\
        <input\
            class="md-input"\
            tabindex="0"\
            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
            aria-label="{{$mdChipsCtrl.getPlaceholder()}}"\
            ng-model="$mdChipsCtrl.chipBuffer"\
            ng-focus="$mdChipsCtrl.onInputFocus()"\
            ng-blur="$mdChipsCtrl.onInputBlur()"\
            ng-trim="false"\
            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';

        var CHIP_DEFAULT_TEMPLATE = '\
      <span>{{$chip}}</span>';

        var CHIP_REMOVE_TEMPLATE = '\
      <button\
          class="_md-chip-remove"\
          ng-if="!$mdChipsCtrl.readonly"\
          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
          type="button"\
          aria-hidden="true"\
          tabindex="-1">\
        <md-icon md-svg-icon="md-close"></md-icon>\
        <span class="_md-visually-hidden">\
          {{$mdChipsCtrl.deleteButtonLabel}}\
        </span>\
      </button>';

        /**
         * MDChips Directive Definition
         */
        function MdChips($mdTheming, $mdUtil, $compile, $log, $timeout) {
            // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
            var templates = getTemplates();

            return {
                template: function (element, attrs) {
                    // Clone the element into an attribute. By prepending the attribute
                    // name with '$', Angular won't write it into the DOM. The cloned
                    // element propagates to the link function via the attrs argument,
                    // where various contained-elements can be consumed.
                    attrs['$mdUserTemplate'] = element.clone();
                    return templates.chips;
                },
                require: ['mdChips'],
                restrict: 'E',
                controller: 'MdChipsCtrl',
                controllerAs: '$mdChipsCtrl',
                bindToController: true,
                compile: compile,
                scope: {
                    readonly: '=readonly',
                    placeholder: '@',
                    mdEnableChipEdit: '@',
                    secondaryPlaceholder: '@',
                    maxChips: '@mdMaxChips',
                    transformChip: '&mdTransformChip',
                    onAppend: '&mdOnAppend',
                    onAdd: '&mdOnAdd',
                    onRemove: '&mdOnRemove',
                    onSelect: '&mdOnSelect',
                    deleteHint: '@',
                    deleteButtonLabel: '@',
                    separatorKeys: '=?mdSeparatorKeys',
                    requireMatch: '=?mdRequireMatch'
                }
            };

            /**
             * Builds the final template for `md-chips` and returns the postLink function.
             *
             * Building the template involves 3 key components:
             * static chips
             * chip template
             * input control
             *
             * If no `ng-model` is provided, only the static chip work needs to be done.
             *
             * If no user-passed `md-chip-template` exists, the default template is used. This resulting
             * template is appended to the chip content element.
             *
             * The remove button may be overridden by passing an element with an md-chip-remove attribute.
             *
             * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
             * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
             * If no user input is provided, a default one is appended to the input container node in the
             * template.
             *
             * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
             * transclusion in the `postLink` function.
             *
             *
             * @param element
             * @param attr
             * @returns {Function}
             */
            function compile(element, attr) {
                // Grab the user template from attr and reset the attribute to null.
                var userTemplate = attr['$mdUserTemplate'];
                attr['$mdUserTemplate'] = null;

                var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');

                // Set the chip remove, chip contents and chip input templates. The link function will put
                // them on the scope for transclusion later.
                var chipRemoveTemplate = getTemplateByQuery('md-chips>*[md-chip-remove]') || templates.remove,
                    chipContentsTemplate = chipTemplate || templates.default,
                    chipInputTemplate = getTemplateByQuery('md-chips>md-autocomplete') ||
                        getTemplateByQuery('md-chips>input') ||
                        templates.input,
                    staticChips = userTemplate.find('md-chip');

                // Warn of malformed template. See #2545
                if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
                    $log.warn('invalid placement of md-chip-remove within md-chip-template.');
                }

                function getTemplateByQuery(query) {
                    if (!attr.ngModel) return;
                    var element = userTemplate[0].querySelector(query);
                    return element && element.outerHTML;
                }

                /**
                 * Configures controller and transcludes.
                 */
                return function postLink(scope, element, attrs, controllers) {
                    $mdUtil.initOptionalProperties(scope, attr);

                    $mdTheming(element);
                    var mdChipsCtrl = controllers[0];
                    if (chipTemplate) {
                        // Chip editing functionality assumes we are using the default chip template.
                        mdChipsCtrl.enableChipEdit = false;
                    }

                    mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
                    mdChipsCtrl.chipRemoveTemplate = chipRemoveTemplate;
                    mdChipsCtrl.chipInputTemplate = chipInputTemplate;

                    element
                        .attr({ 'aria-hidden': true, tabindex: -1 })
                        .on('focus', function () { mdChipsCtrl.onFocus(); });

                    if (attr.ngModel) {
                        mdChipsCtrl.configureNgModel(element.controller('ngModel'));

                        // If an `md-transform-chip` attribute was set, tell the controller to use the expression
                        // before appending chips.
                        if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();

                        // If an `md-on-append` attribute was set, tell the controller to use the expression
                        // when appending chips.
                        //
                        // DEPRECATED: Will remove in official 1.0 release
                        if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();

                        // If an `md-on-add` attribute was set, tell the controller to use the expression
                        // when adding chips.
                        if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();

                        // If an `md-on-remove` attribute was set, tell the controller to use the expression
                        // when removing chips.
                        if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();

                        // If an `md-on-select` attribute was set, tell the controller to use the expression
                        // when selecting chips.
                        if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();

                        // The md-autocomplete and input elements won't be compiled until after this directive
                        // is complete (due to their nested nature). Wait a tick before looking for them to
                        // configure the controller.
                        if (chipInputTemplate != templates.input) {
                            // The autocomplete will not appear until the readonly attribute is not true (i.e.
                            // false or undefined), so we have to watch the readonly and then on the next tick
                            // after the chip transclusion has run, we can configure the autocomplete and user
                            // input.
                            scope.$watch('$mdChipsCtrl.readonly', function (readonly) {
                                if (!readonly) {
                                    $mdUtil.nextTick(function () {
                                        if (chipInputTemplate.indexOf('<md-autocomplete') === 0)
                                            mdChipsCtrl
                                                .configureAutocomplete(element.find('md-autocomplete')
                                                    .controller('mdAutocomplete'));
                                        mdChipsCtrl.configureUserInput(element.find('input'));
                                    });
                                }
                            });
                        }

                        // At the next tick, if we find an input, make sure it has the md-input class
                        $mdUtil.nextTick(function () {
                            var input = element.find('input');

                            input && input.toggleClass('md-input', true);
                        });
                    }

                    // Compile with the parent's scope and prepend any static chips to the wrapper.
                    if (staticChips.length > 0) {
                        var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
                        $timeout(function () { element.find('md-chips-wrap').prepend(compiledStaticChips); });
                    }
                };
            }

            function getTemplates() {
                return {
                    chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
                    input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
                    default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
                    remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
                };
            }
        }
        MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .directive('mdChipTransclude', MdChipTransclude);

        function MdChipTransclude($compile) {
            return {
                restrict: 'EA',
                terminal: true,
                link: link,
                scope: false
            };

            function link(scope, element, attr) {
                var ctrl = scope.$parent.$mdChipsCtrl,
                    newScope = ctrl.parent.$new(false, ctrl.parent);
                newScope.$$replacedScope = scope;
                newScope.$chip = scope.$chip;
                newScope.$index = scope.$index;
                newScope.$mdChipsCtrl = ctrl;

                var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);

                element.html(newHtml);
                $compile(element.contents())(newScope);
            }
        }
        MdChipTransclude.$inject = ["$compile"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .controller('MdContactChipsCtrl', MdContactChipsCtrl);



        /**
         * Controller for the MdContactChips component
         * @constructor
         */
        function MdContactChipsCtrl() {
            /** @type {Object} */
            this.selectedItem = null;

            /** @type {string} */
            this.searchText = '';
        }


        MdContactChipsCtrl.prototype.queryContact = function (searchText) {
            var results = this.contactQuery({ '$query': searchText });
            return this.filterSelected ?
                results.filter(angular.bind(this, this.filterSelectedContacts)) : results;
        };


        MdContactChipsCtrl.prototype.itemName = function (item) {
            return item[this.contactName];
        };


        MdContactChipsCtrl.prototype.filterSelectedContacts = function (contact) {
            return this.contacts.indexOf(contact) == -1;
        };

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.chips')
            .directive('mdContactChips', MdContactChips);

        /**
         * @ngdoc directive
         * @name mdContactChips
         * @module material.components.chips
         *
         * @description
         * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
         * `md-autocomplete` element. The component allows the caller to supply a query expression which
         * returns  a list of possible contacts. The user can select one of these and add it to the list of
         * chips.
         *
         * You may also use the `md-highlight-text` directive along with its parameters to control the
         * appearance of the matched text inside of the contacts' autocomplete popup.
         *
         * @param {string=|object=} ng-model A model to bind the list of items to
         * @param {string=} placeholder Placeholder text that will be forwarded to the input.
         * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
         *    displayed when there is at least on item in the list
         * @param {expression} md-contacts An expression expected to return contacts matching the search
         *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
         *    waiting for it to resolve.
         * @param {string} md-contact-name The field name of the contact object representing the
         *    contact's name.
         * @param {string} md-contact-email The field name of the contact object representing the
         *    contact's email address.
         * @param {string} md-contact-image The field name of the contact object representing the
         *    contact's image.
         *
         *
         * @param {expression=} filter-selected Whether to filter selected contacts from the list of
         *    suggestions shown in the autocomplete. This attribute has been removed but may come back.
         *
         *
         *
         * @usage
         * <hljs lang="html">
         *   <md-contact-chips
         *       ng-model="ctrl.contacts"
         *       md-contacts="ctrl.querySearch($query)"
         *       md-contact-name="name"
         *       md-contact-image="image"
         *       md-contact-email="email"
         *       placeholder="To">
         *   </md-contact-chips>
         * </hljs>
         *
         */


        var MD_CONTACT_CHIPS_TEMPLATE = '\
      <md-chips class="md-contact-chips"\
          ng-model="$mdContactChipsCtrl.contacts"\
          md-require-match="$mdContactChipsCtrl.requireMatch"\
          md-autocomplete-snap>\
          <md-autocomplete\
              md-menu-class="md-contact-chips-suggestions"\
              md-selected-item="$mdContactChipsCtrl.selectedItem"\
              md-search-text="$mdContactChipsCtrl.searchText"\
              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
              md-item-text="$mdContactChipsCtrl.itemName(item)"\
              md-no-cache="true"\
              md-autoselect\
              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
            <div class="md-contact-suggestion">\
              <img \
                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
                {{item[$mdContactChipsCtrl.contactName]}}\
              </span>\
              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
            </div>\
          </md-autocomplete>\
          <md-chip-template>\
            <div class="md-contact-avatar">\
              <img \
                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
            </div>\
            <div class="md-contact-name">\
              {{$chip[$mdContactChipsCtrl.contactName]}}\
            </div>\
          </md-chip-template>\
      </md-chips>';


        /**
         * MDContactChips Directive Definition
         *
         * @param $mdTheming
         * @returns {*}
         * @ngInject
         */
        function MdContactChips($mdTheming, $mdUtil) {
            return {
                template: function (element, attrs) {
                    return MD_CONTACT_CHIPS_TEMPLATE;
                },
                restrict: 'E',
                controller: 'MdContactChipsCtrl',
                controllerAs: '$mdContactChipsCtrl',
                bindToController: true,
                compile: compile,
                scope: {
                    contactQuery: '&mdContacts',
                    placeholder: '@',
                    secondaryPlaceholder: '@',
                    contactName: '@mdContactName',
                    contactImage: '@mdContactImage',
                    contactEmail: '@mdContactEmail',
                    contacts: '=ngModel',
                    requireMatch: '=?mdRequireMatch',
                    highlightFlags: '@?mdHighlightFlags'
                }
            };

            function compile(element, attr) {
                return function postLink(scope, element, attrs, controllers) {

                    $mdUtil.initOptionalProperties(scope, attr);
                    $mdTheming(element);

                    element.attr('tabindex', '-1');
                };
            }
        }
        MdContactChips.$inject = ["$mdTheming", "$mdUtil"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.icon')
            .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', mdIconDirective]);

        /**
         * @ngdoc directive
         * @name mdIcon
         * @module material.components.icon
         *
         * @restrict E
         *
         * @description
         * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
         * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
         *
         * Icons should be consider view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
         * inside a `md-button` to add hover and click features.
         *
         * ### Icon fonts
         * Icon fonts are a technique in which you use a font where the glyphs in the font are
         * your icons instead of text. Benefits include a straightforward way to bundle everything into a
         * single HTTP request, simple scaling, easy color changing, and more.
         *
         * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
         * by name rather than character code.
         *
         * ### SVG
         * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
         * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
         * animation.
         *
         * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
         * document. The most straightforward way of referencing an SVG icon is via URL, just like a
         * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
         * reference it by name instead of URL throughout your templates.
         *
         * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
         * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
         * also be given a name, which acts as a namespace for individual icons, so you can reference them
         * like `"social:cake"`.
         *
         * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
         * easily loaded and used.When use font-icons, developers must following three (3) simple steps:
         *
         * <ol>
         * <li>Load the font library. e.g.<br/>
         *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
         *    rel="stylesheet">`
         * </li>
         * <li>
         *   Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using
         *   its textual name
         * </li>
         * <li>
         *   Use `<md-icon md-font-icon="classname" />` or <br/>
         *   use `<md-icon md-font-set="font library classname or alias"> textual_name </md-icon>` or <br/>
         *   use `<md-icon md-font-set="font library classname or alias"> numerical_character_reference </md-icon>`
         * </li>
         * </ol>
         *
         * Full details for these steps can be found:
         *
         * <ul>
         * <li>http://google.github.io/material-design-icons/</li>
         * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
         * </ul>
         *
         * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
         * Material Design Icons:
         *
         * <ul>
         * <li>http://www.google.com/design/icons/</li>
         * <li>https://www.google.com/design/icons/#ic_accessibility</li>
         * </ul>
         *
         * <h2 id="material_design_icons">Material Design Icons</h2>
         * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
         * determine its textual name and character reference code. Click on any icon to see the slide-up information
         * panel with details regarding a SVG download or information on the font-icon usage.
         *
         * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
         * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
         *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
         * </a>
         *
         * <span class="image_caption">
         *  Click on the image above to link to the
         *  <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
         * </span>
         *
         * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
         * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
         * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
         * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
         * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
         * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
         *     external SVG.
         * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
         *     interpolated strings or expressions may also be used. Specific set names can be used with
         *     the syntax `<set name>:<icon name>`.<br/><br/>
         * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
         * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
         * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
         * nor a label on the parent element, a warning will be logged to the console.
         * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
         * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
         * nor a label on the parent element, a warning will be logged to the console.
         *
         * @usage
         * When using SVGs:
         * <hljs lang="html">
         *
         *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
         *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
         *
         *  <!-- Icon urls; may be preloaded in templateCache -->
         *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
         *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
         *
         * </hljs>
         *
         * Use the <code>$mdIconProvider</code> to configure your application with
         * svg iconsets.
         *
         * <hljs lang="js">
         *  angular.module('appSvgIconSets', ['ngMaterial'])
         *    .controller('DemoCtrl', function($scope) {})
         *    .config(function($mdIconProvider) {
         *      $mdIconProvider
         *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
         *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
         *     });
         * </hljs>
         *
         *
         * When using Font Icons with classnames:
         * <hljs lang="html">
         *
         *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
         *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
         *
         * </hljs>
         *
         * When using Material Font Icons with ligatures:
         * <hljs lang="html">
         *  <!--
         *  For Material Design Icons
         *  The class '.material-icons' is auto-added if a style has NOT been specified
         *  since `material-icons` is the default fontset. So your markup:
         *  -->
         *  <md-icon> face </md-icon>
         *  <!-- becomes this at runtime: -->
         *  <md-icon md-font-set="material-icons"> face </md-icon>
         *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
         *  <md-icon> &#xE87C; </md-icon>
         *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
         *  <md-icon class="material-icons md-light md-48"> face </md-icon>
         * </hljs>
         *
         * When using other Font-Icon libraries:
         *
         * <hljs lang="js">
         *  // Specify a font-icon style alias
         *  angular.config(function($mdIconProvider) {
         *    $mdIconProvider.fontSet('md', 'material-icons');
         *  });
         * </hljs>
         *
         * <hljs lang="html">
         *  <md-icon md-font-set="md">favorite</md-icon>
         * </hljs>
         *
         */
        function mdIconDirective($mdIcon, $mdTheming, $mdAria) {

            return {
                restrict: 'E',
                link: postLink
            };


            /**
             * Directive postLink
             * Supports embedded SVGs, font-icons, & external SVGs
             */
            function postLink(scope, element, attr) {
                $mdTheming(element);

                prepareForFontIcon();

                // If using a font-icon, then the textual name of the icon itself
                // provides the aria-label.

                var label = attr.alt || attr.mdFontIcon || attr.mdSvgIcon || element.text();
                var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');

                if (!attr['aria-label']) {

                    if (label !== '' && !parentsHaveText()) {

                        $mdAria.expect(element, 'aria-label', label);
                        $mdAria.expect(element, 'role', 'img');

                    } else if (!element.text()) {
                        // If not a font-icon with ligature, then
                        // hide from the accessibility layer.

                        $mdAria.expect(element, 'aria-hidden', 'true');
                    }
                }

                if (attrName) {
                    // Use either pre-configured SVG or URL source, respectively.
                    attr.$observe(attrName, function (attrVal) {

                        element.empty();
                        if (attrVal) {
                            $mdIcon(attrVal)
                                .then(function (svg) {
                                    element.empty();
                                    element.append(svg);
                                });
                        }

                    });
                }

                function parentsHaveText() {
                    var parent = element.parent();
                    if (parent.attr('aria-label') || parent.text()) {
                        return true;
                    } else if (parent.parent().attr('aria-label') || parent.parent().text()) {
                        return true;
                    }
                    return false;
                }

                function prepareForFontIcon() {
                    if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
                        if (attr.mdFontIcon) {
                            element.addClass('md-font ' + attr.mdFontIcon);
                        }
                        element.addClass($mdIcon.fontSet(attr.mdFontSet));
                    }
                }
            }
        }

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.icon')
            .provider('$mdIcon', MdIconProvider);

        /**
         * @ngdoc service
         * @name $mdIconProvider
         * @module material.components.icon
         *
         * @description
         * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
         * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
         * directives are compiled.
         *
         * If using font-icons, the developer is responsible for loading the fonts.
         *
         * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
         * internally by the `$mdIcon` service using the `$http` service. When an SVG is requested by name/ID,
         * the `$mdIcon` service searches its registry for the associated source URL;
         * that URL is used to on-demand load and parse the SVG dynamically.
         *
         * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
         *  In such cases you are not able to use the icon's ligature name - Like so:
         *
         *  <hljs lang="html">
         *    <md-icon md-font-set="fa">fa-bell</md-icon>
         *  </hljs>
         *
         * You should instead use the given unicode, instead of the ligature name.
         *
         * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
         *  ```html
         *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
         *  ```
         *
         * All unicode ligatures are prefixed with the `&#x` string.
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Configure URLs for icons specified by [set:]id.
         *
         *     $mdIconProvider
         *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
         *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
         *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
         *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
         *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
         *   });
         * </hljs>
         *
         * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
         * **startup** process (shown below):
         *
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Register a default set of SVG icon definitions
         *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
         *
         *   })
         *   .run(function($http, $templateCache){
         *
         *     // Pre-fetch icons sources by URL and cache in the $templateCache...
         *     // subsequent $http calls will look there first.
         *
         *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
         *
         *     angular.forEach(urls, function(url) {
         *       $http.get(url, {cache: $templateCache});
         *     });
         *
         *   });
         *
         * </hljs>
         *
         * NOTE: the loaded SVG data is subsequently cached internally for future requests.
         *
         */

        /**
         * @ngdoc method
         * @name $mdIconProvider#icon
         *
         * @description
         * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
         * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
         *
         * @param {string} id Icon name/id used to register the icon
         * @param {string} url specifies the external location for the data file. Used internally by `$http` to load the
         * data or as part of the lookup in `$templateCache` if pre-loading was configured.
         * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
         * It is ignored for icons with an existing viewBox. Default size is 24.
         *
         * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Configure URLs for icons specified by [set:]id.
         *
         *     $mdIconProvider
         *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
         *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
         *   });
         * </hljs>
         *
         */
        /**
         * @ngdoc method
         * @name $mdIconProvider#iconSet
         *
         * @description
         * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
         * has an icon id. Individual icons can be subsequently retrieved from this cached set using
         * `$mdIcon(<icon set name>:<icon name>)`
         *
         * @param {string} id Icon name/id used to register the iconset
         * @param {string} url specifies the external location for the data file. Used internally by `$http` to load the
         * data or as part of the lookup in `$templateCache` if pre-loading was configured.
         * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
         * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
         * Default value is 24.
         *
         * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
         *
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Configure URLs for icons specified by [set:]id.
         *
         *     $mdIconProvider
         *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
         *   });
         * </hljs>
         *
         */
        /**
         * @ngdoc method
         * @name $mdIconProvider#defaultIconSet
         *
         * @description
         * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
         * subsequent lookups of icons will failover to search this 'default' icon set.
         * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
         *
         * @param {string} url specifies the external location for the data file. Used internally by `$http` to load the
         * data or as part of the lookup in `$templateCache` if pre-loading was configured.
         * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
         * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
         * Default value is 24.
         *
         * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Configure URLs for icons specified by [set:]id.
         *
         *     $mdIconProvider
         *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
         *   });
         * </hljs>
         *
         */
        /**
         * @ngdoc method
         * @name $mdIconProvider#defaultFontSet
         *
         * @description
         * When using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically
         * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
         * class style that should be applied to the `<md-icon>`.
         *
         * Configuring the default means that the attributes
         * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
         * `<md-icon>` markup. For example:
         *
         *  `<md-icon> face </md-icon>`
         *  will render as
         *  `<span class="material-icons"> face </span>`, and
         *
         *  `<md-icon md-font-set="fa"> face </md-icon>`
         *  will render as
         *  `<span class="fa"> face </span>`
         *
         * @param {string} name of the font-library style that should be applied to the md-icon DOM element
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *     $mdIconProvider.defaultFontSet( 'fa' );
         *   });
         * </hljs>
         *
         */

        /**
         * @ngdoc method
         * @name $mdIconProvider#fontSet
         *
         * @description
         * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
         * attribute. If the fonset className is really long, your markup may become cluttered... an easy
         * solution is to define an `alias` for your fontset:
         *
         * @param {string} alias of the specified fontset.
         * @param {string} className of the fontset.
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *     // In this case, we set an alias for the `material-icons` fontset.
         *     $mdIconProvider.fontSet('md', 'material-icons');
         *   });
         * </hljs>
         *
         */

        /**
         * @ngdoc method
         * @name $mdIconProvider#defaultViewBoxSize
         *
         * @description
         * While `<md-icon />` markup can also be style with sizing CSS, this method configures
         * the default width **and** height used for all icons; unless overridden by specific CSS.
         * The default sizing is (24px, 24px).
         * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
         * All icons in a set should be the same size. The default value is 24.
         *
         * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
         *
         * @usage
         * <hljs lang="js">
         *   app.config(function($mdIconProvider) {
         *
         *     // Configure URLs for icons specified by [set:]id.
         *
         *     $mdIconProvider
         *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
         *   });
         * </hljs>
         *
         */

        var config = {
            defaultViewBoxSize: 24,
            defaultFontSet: 'material-icons',
            fontSets: []
        };

        function MdIconProvider() { }

        MdIconProvider.prototype = {
            icon: function (id, url, viewBoxSize) {
                if (id.indexOf(':') == -1) id = '$default:' + id;

                config[id] = new ConfigurationItem(url, viewBoxSize);
                return this;
            },

            iconSet: function (id, url, viewBoxSize) {
                config[id] = new ConfigurationItem(url, viewBoxSize);
                return this;
            },

            defaultIconSet: function (url, viewBoxSize) {
                var setName = '$default';

                if (!config[setName]) {
                    config[setName] = new ConfigurationItem(url, viewBoxSize);
                }

                config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;

                return this;
            },

            defaultViewBoxSize: function (viewBoxSize) {
                config.defaultViewBoxSize = viewBoxSize;
                return this;
            },

            /**
             * Register an alias name associated with a font-icon library style ;
             */
            fontSet: function fontSet(alias, className) {
                config.fontSets.push({
                    alias: alias,
                    fontSet: className || alias
                });
                return this;
            },

            /**
             * Specify a default style name associated with a font-icon library
             * fallback to Material Icons.
             *
             */
            defaultFontSet: function defaultFontSet(className) {
                config.defaultFontSet = !className ? '' : className;
                return this;
            },

            defaultIconSize: function defaultIconSize(iconSize) {
                config.defaultIconSize = iconSize;
                return this;
            },

            preloadIcons: function ($templateCache) {
                var iconProvider = this;
                var svgRegistry = [{
                    id: 'md-tabs-arrow',
                    url: 'md-tabs-arrow.svg',
                    svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><polygon points="15.4,7.4 14,6 8,12 14,18 15.4,16.6 10.8,12 "/></g></svg>'
                },
                {
                    id: 'md-close',
                    url: 'md-close.svg',
                    svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"/></g></svg>'
                },
                {
                    id: 'md-cancel',
                    url: 'md-cancel.svg',
                    svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><g><path d="M12 2c-5.53 0-10 4.47-10 10s4.47 10 10 10 10-4.47 10-10-4.47-10-10-10zm5 13.59l-1.41 1.41-3.59-3.59-3.59 3.59-1.41-1.41 3.59-3.59-3.59-3.59 1.41-1.41 3.59 3.59 3.59-3.59 1.41 1.41-3.59 3.59 3.59 3.59z"/></g></svg>'
                },
                {
                    id: 'md-menu',
                    url: 'md-menu.svg',
                    svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 24 24"><path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" /></svg>'
                },
                {
                    id: 'md-toggle-arrow',
                    url: 'md-toggle-arrow-svg',
                    svg: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 48 48"><path d="M24 16l-12 12 2.83 2.83 9.17-9.17 9.17 9.17 2.83-2.83z"/><path d="M0 0h48v48h-48z" fill="none"/></svg>'
                },
                {
                    id: 'md-calendar',
                    url: 'md-calendar.svg',
                    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/></svg>'
                }
                ];

                svgRegistry.forEach(function (asset) {
                    iconProvider.icon(asset.id, asset.url);
                    $templateCache.put(asset.url, asset.svg);
                });

            },

            $get: ['$http', '$q', '$log', '$templateCache', '$mdUtil', function ($http, $q, $log, $templateCache, $mdUtil) {
                this.preloadIcons($templateCache);
                return MdIconService(config, $http, $q, $log, $templateCache, $mdUtil);
            }]
        };

        /**
         *  Configuration item stored in the Icon registry; used for lookups
         *  to load if not already cached in the `loaded` cache
         */
        function ConfigurationItem(url, viewBoxSize) {
            this.url = url;
            this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
        }

        /**
         * @ngdoc service
         * @name $mdIcon
         * @module material.components.icon
         *
         * @description
         * The `$mdIcon` service is a function used to lookup SVG icons.
         *
         * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
         * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
         * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
         *
         * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
         * using the `$mdIconProvider`.
         *
         * @returns {obj} Clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file.
         *
         * @usage
         * <hljs lang="js">
         * function SomeDirective($mdIcon) {
         *
         *   // See if the icon has already been loaded, if not
         *   // then lookup the icon from the registry cache, load and cache
         *   // it for future requests.
         *   // NOTE: ID queries require configuration with $mdIconProvider
         *
         *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
         *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
         *
         *   // Load and cache the external SVG using a URL
         *
         *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
         *     element.append(iconEl);
         *   });
         * };
         * </hljs>
         *
         * NOTE: The `<md-icon />  ` directive internally uses the `$mdIcon` service to query, loaded, and instantiate
         * SVG DOM elements.
         */

        /* @ngInject */
        function MdIconService(config, $http, $q, $log, $templateCache, $mdUtil) {
            var iconCache = {};
            var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
            var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;

            Icon.prototype = { clone: cloneSVG, prepare: prepareAndStyle };
            getIcon.fontSet = findRegisteredFontSet;

            // Publish service...
            return getIcon;

            /**
             * Actual $mdIcon service is essentially a lookup function
             */
            function getIcon(id) {
                id = id || '';

                // If already loaded and cached, use a clone of the cached icon.
                // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.

                if (iconCache[id]) return $q.when(transformClone(iconCache[id]));
                if (urlRegex.test(id) || dataUrlRegex.test(id)) return loadByURL(id).then(cacheIcon(id));
                if (id.indexOf(':') == -1) id = '$default:' + id;

                var load = config[id] ? loadByID : loadFromIconSet;
                return load(id)
                    .then(cacheIcon(id));
            }

            /**
             * Lookup registered fontSet style using its alias...
             * If not found,
             */
            function findRegisteredFontSet(alias) {
                var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
                if (useDefault) return config.defaultFontSet;

                var result = alias;
                angular.forEach(config.fontSets, function (it) {
                    if (it.alias == alias) result = it.fontSet || result;
                });

                return result;
            }

            function transformClone(cacheElement) {
                var clone = cacheElement.clone();
                var cacheSuffix = '_cache' + $mdUtil.nextUid();

                // We need to modify for each cached icon the id attributes.
                // This is needed because SVG id's are treated as normal DOM ids
                // and should not have a duplicated id.
                if (clone.id) clone.id += cacheSuffix;
                angular.forEach(clone.querySelectorAll('[id]'), function (item) {
                    item.id += cacheSuffix;
                });

                return clone;
            }

            /**
             * Prepare and cache the loaded icon for the specified `id`
             */
            function cacheIcon(id) {

                return function updateCache(icon) {
                    iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);

                    return iconCache[id].clone();
                };
            }

            /**
             * Lookup the configuration in the registry, if !registered throw an error
             * otherwise load the icon [on-demand] using the registered URL.
             *
             */
            function loadByID(id) {
                var iconConfig = config[id];
                return loadByURL(iconConfig.url).then(function (icon) {
                    return new Icon(icon, iconConfig);
                });
            }

            /**
             *    Loads the file as XML and uses querySelector( <id> ) to find
             *    the desired node...
             */
            function loadFromIconSet(id) {
                var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
                var iconSetConfig = config[setName];

                return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);

                function extractFromSet(set) {
                    var iconName = id.slice(id.lastIndexOf(':') + 1);
                    var icon = set.querySelector('#' + iconName);
                    return !icon ? announceIdNotFound(id) : new Icon(icon, iconSetConfig);
                }

                function announceIdNotFound(id) {
                    var msg = 'icon ' + id + ' not found';
                    $log.warn(msg);

                    return $q.reject(msg || id);
                }
            }

            /**
             * Load the icon by URL (may use the $templateCache).
             * Extract the data for later conversion to Icon
             */
            function loadByURL(url) {
                /* Load the icon from embedded data URL. */
                function loadByDataUrl(url) {
                    var results = dataUrlRegex.exec(url);
                    var isBase64 = /base64/i.test(url);
                    var data = isBase64 ? window.atob(results[2]) : results[2];
                    return $q.when(angular.element(data)[0]);
                }

                /* Load the icon by URL using HTTP. */
                function loadByHttpUrl(url) {
                    return $http
                        .get(url, { cache: $templateCache })
                        .then(function (response) {
                            return angular.element('<div>').append(response.data).find('svg')[0];
                        }).catch(announceNotFound);
                }

                return dataUrlRegex.test(url) ?
                    loadByDataUrl(url) :
                    loadByHttpUrl(url);
            }

            /**
             * Catch HTTP or generic errors not related to incorrect icon IDs.
             */
            function announceNotFound(err) {
                var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
                $log.warn(msg);

                return $q.reject(msg);
            }

            /**
             * Check target signature to see if it is an Icon instance.
             */
            function isIcon(target) {
                return angular.isDefined(target.element) && angular.isDefined(target.config);
            }

            /**
             *  Define the Icon class
             */
            function Icon(el, config) {
                if (el && el.tagName != 'svg') {
                    el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el)[0];
                }

                // Inject the namespace if not available...
                if (!el.getAttribute('xmlns')) {
                    el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
                }

                this.element = el;
                this.config = config;
                this.prepare();
            }

            /**
             *  Prepare the DOM element that will be cached in the
             *  loaded iconCache store.
             */
            function prepareAndStyle() {
                var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
                angular.forEach({
                    'fit': '',
                    'height': '100%',
                    'width': '100%',
                    'preserveAspectRatio': 'xMidYMid meet',
                    'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
                    'focusable': false // Disable IE11s default behavior to make SVGs focusable
                }, function (val, attr) {
                    this.element.setAttribute(attr, val);
                }, this);
            }

            /**
             * Clone the Icon DOM element.
             */
            function cloneSVG() {
                // If the element or any of its children have a style attribute, then a CSP policy without
                // 'unsafe-inline' in the style-src directive, will result in a violation.
                return this.element.cloneNode(true);
            }

        }
        MdIconService.$inject = ["config", "$http", "$q", "$log", "$templateCache", "$mdUtil"];

    })();
    (function () {
        "use strict";



        angular
            .module('material.components.menu')
            .controller('mdMenuCtrl', MenuController);

        /**
         * @ngInject
         */
        function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q) {

            var menuContainer;
            var self = this;
            var triggerElement;

            this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;

            /**
             * Called by our linking fn to provide access to the menu-content
             * element removed during link
             */
            this.init = function init(setMenuContainer, opts) {
                opts = opts || {};
                menuContainer = setMenuContainer;
                // Default element for ARIA attributes has the ngClick or ngMouseenter expression
                triggerElement = $element[0].querySelector('[ng-click],[ng-mouseenter]');
                triggerElement.setAttribute('aria-expanded', 'false');

                this.isInMenuBar = opts.isInMenuBar;
                this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));

                menuContainer.on('$mdInterimElementRemove', function () {
                    self.isOpen = false;
                });

                var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
                menuContainer.attr('id', menuContainerId);
                angular.element(triggerElement).attr({
                    'aria-owns': menuContainerId,
                    'aria-haspopup': 'true'
                });

                $scope.$on('$destroy', this.disableHoverListener);
                menuContainer.on('$destroy', function () {
                    $mdMenu.destroy();
                });
            };

            var openMenuTimeout, menuItems, deregisterScopeListeners = [];
            this.enableHoverListener = function () {
                deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function (event, el) {
                    if (menuContainer[0].contains(el[0])) {
                        self.currentlyOpenMenu = el.controller('mdMenu');
                        self.isAlreadyOpening = false;
                        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
                    }
                }));
                deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function (event, el) {
                    if (menuContainer[0].contains(el[0])) {
                        self.currentlyOpenMenu = undefined;
                    }
                }));
                menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
                menuItems.on('mouseenter', self.handleMenuItemHover);
                menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
            };

            this.disableHoverListener = function () {
                while (deregisterScopeListeners.length) {
                    deregisterScopeListeners.shift()();
                }
                menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
                menuItems && menuItems.off('mouseleave', self.handleMenuMouseLeave);
            };

            this.handleMenuItemHover = function (event) {
                if (self.isAlreadyOpening) return;
                var nestedMenu = (
                    event.target.querySelector('md-menu') ||
                    $mdUtil.getClosest(event.target, 'MD-MENU')
                );
                openMenuTimeout = $timeout(function () {
                    if (nestedMenu) {
                        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
                    }

                    if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
                        var closeTo = self.nestLevel + 1;
                        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
                        self.isAlreadyOpening = !!nestedMenu;
                        nestedMenu && nestedMenu.open();
                    } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
                        self.isAlreadyOpening = !!nestedMenu;
                        nestedMenu && nestedMenu.open();
                    }
                }, nestedMenu ? 100 : 250);
                var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
                focusableTarget && focusableTarget.focus();
            };

            this.handleMenuItemMouseLeave = function () {
                if (openMenuTimeout) {
                    $timeout.cancel(openMenuTimeout);
                    openMenuTimeout = undefined;
                }
            };


            /**
             * Uses the $mdMenu interim element service to open the menu contents
             */
            this.open = function openMenu(ev) {
                ev && ev.stopPropagation();
                ev && ev.preventDefault();
                if (self.isOpen) return;
                self.enableHoverListener();
                self.isOpen = true;
                triggerElement = triggerElement || (ev ? ev.target : $element[0]);
                triggerElement.setAttribute('aria-expanded', 'true');
                $scope.$emit('$mdMenuOpen', $element);
                $mdMenu.show({
                    scope: $scope,
                    mdMenuCtrl: self,
                    nestLevel: self.nestLevel,
                    element: menuContainer,
                    target: triggerElement,
                    preserveElement: true,
                    parent: 'body'
                }).finally(function () {
                    triggerElement.setAttribute('aria-expanded', 'false');
                    self.disableHoverListener();
                });
            };

            // Expose a open function to the child scope for html to use
            $scope.$mdOpenMenu = this.open;

            $scope.$watch(function () { return self.isOpen; }, function (isOpen) {
                if (isOpen) {
                    menuContainer.attr('aria-hidden', 'false');
                    $element[0].classList.add('_md-open');
                    angular.forEach(self.nestedMenus, function (el) {
                        el.classList.remove('_md-open');
                    });
                } else {
                    menuContainer.attr('aria-hidden', 'true');
                    $element[0].classList.remove('_md-open');
                }
                $scope.$mdMenuIsOpen = self.isOpen;
            });

            this.focusMenuContainer = function focusMenuContainer() {
                var focusTarget = menuContainer[0].querySelector('[md-menu-focus-target]');
                if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button');
                focusTarget.focus();
            };

            this.registerContainerProxy = function registerContainerProxy(handler) {
                this.containerProxy = handler;
            };

            this.triggerContainerProxy = function triggerContainerProxy(ev) {
                this.containerProxy && this.containerProxy(ev);
            };

            this.destroy = function () {
                return self.isOpen ? $mdMenu.destroy() : $q.when(false);
            };

            // Use the $mdMenu interim element service to close the menu contents
            this.close = function closeMenu(skipFocus, closeOpts) {
                if (!self.isOpen) return;
                self.isOpen = false;

                var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
                $scope.$emit('$mdMenuClose', $element, eventDetails);
                $mdMenu.hide(null, closeOpts);

                if (!skipFocus) {
                    var el = self.restoreFocusTo || $element.find('button')[0];
                    if (el instanceof angular.element) el = el[0];
                    if (el) el.focus();
                }
            };

            /**
             * Build a nice object out of our string attribute which specifies the
             * target mode for left and top positioning
             */
            this.positionMode = function positionMode() {
                var attachment = ($attrs.mdPositionMode || 'target').split(' ');

                // If attachment is a single item, duplicate it for our second value.
                // ie. 'target' -> 'target target'
                if (attachment.length == 1) {
                    attachment.push(attachment[0]);
                }

                return {
                    left: attachment[0],
                    top: attachment[1]
                };
            };

            /**
             * Build a nice object out of our string attribute which specifies
             * the offset of top and left in pixels.
             */
            this.offsets = function offsets() {
                var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
                if (position.length == 2) {
                    return {
                        left: position[0],
                        top: position[1]
                    };
                } else if (position.length == 1) {
                    return {
                        top: position[0],
                        left: position[0]
                    };
                } else {
                    throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
                }
            };
        }
        MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc directive
         * @name mdMenu
         * @module material.components.menu
         * @restrict E
         * @description
         *
         * Menus are elements that open when clicked. They are useful for displaying
         * additional options within the context of an action.
         *
         * Every `md-menu` must specify exactly two child elements. The first element is what is
         * left in the DOM and is used to open the menu. This element is called the trigger element.
         * The trigger element's scope has access to `$mdOpenMenu($event)`
         * which it may call to open the menu. By passing $event as argument, the
         * corresponding event is stopped from propagating up the DOM-tree.
         *
         * The second element is the `md-menu-content` element which represents the
         * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
         * but you can do custom content as well.
         *
         * <hljs lang="html">
         * <md-menu>
         *  <!-- Trigger element is a md-button with an icon -->
         *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button" aria-label="Open sample menu">
         *    <md-icon md-svg-icon="call:phone"></md-icon>
         *  </md-button>
         *  <md-menu-content>
         *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
         *  </md-menu-content>
         * </md-menu>
         * </hljs>

         * ## Sizing Menus
         *
         * The width of the menu when it is open may be specified by specifying a `width`
         * attribute on the `md-menu-content` element.
         * See the [Material Design Spec](http://www.google.com/design/spec/components/menus.html#menus-specs)
         * for more information.
         *
         *
         * ## Aligning Menus
         *
         * When a menu opens, it is important that the content aligns with the trigger element.
         * Failure to align menus can result in jarring experiences for users as content
         * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
         * with alignment.
         *
         * ### Target Mode
         *
         * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
         * designated child elements in both the trigger and the menu content.
         *
         * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
         * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
         * will be used as the origin element.
         *
         * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
         * `md-menu-item` to specify the node that it should try and align with.
         *
         * In this example code, we specify an icon to be our origin element, and an
         * icon in our menu content to be our alignment target. This ensures that both
         * icons are aligned when the menu opens.
         *
         * <hljs lang="html">
         * <md-menu>
         *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button" aria-label="Open some menu">
         *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
         *  </md-button>
         *  <md-menu-content>
         *    <md-menu-item>
         *      <md-button ng-click="doSomething()" aria-label="Do something">
         *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
         *        Do Something
         *      </md-button>
         *    </md-menu-item>
         *  </md-menu-content>
         * </md-menu>
         * </hljs>
         *
         * Sometimes we want to specify alignment on the right side of an element, for example
         * if we have a menu on the right side a toolbar, we want to right align our menu content.
         *
         * We can specify the origin by using the `md-position-mode` attribute on both
         * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
         * You may specify the default mode of `target target` or
         * `target-right target` to specify a right-oriented alignment target. See the
         * position section of the demos for more examples.
         *
         * ### Menu Offsets
         *
         * It is sometimes unavoidable to need to have a deeper level of control for
         * the positioning of a menu to ensure perfect alignment. `md-menu` provides
         * the `md-offset` attribute to allow pixel level specificty of adjusting the
         * exact positioning.
         *
         * This offset is provided in the format of `x y` or `n` where `n` will be used
         * in both the `x` and `y` axis.
         *
         * For example, to move a menu by `2px` from the top, we can use:
         * <hljs lang="html">
         * <md-menu md-offset="2 0">
         *   <!-- menu-content -->
         * </md-menu>
         * </hljs>

         * ### Preventing close
         *
         * Sometimes you would like to be able to click on a menu item without having the menu
         * close. To do this, ngMaterial exposes the `md-prevent-menu-close` attribute which
         * can be added to a button inside a menu to stop the menu from automatically closing.
         * You can then close the menu programatically by injecting `$mdMenu` and calling 
         * `$mdMenu.hide()`.
         *
         * <hljs lang="html">
         * <md-menu-item>
         *   <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
         *     <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
         *     Do Something
         *   </md-button>
         * </md-menu-item>
         * </hljs>
         *
         * @usage
         * <hljs lang="html">
         * <md-menu>
         *  <md-button ng-click="$mdOpenMenu($event)" class="md-icon-button">
         *    <md-icon md-svg-icon="call:phone"></md-icon>
         *  </md-button>
         *  <md-menu-content>
         *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
         *  </md-menu-content>
         * </md-menu>
         * </hljs>
         *
         * @param {string} md-position-mode The position mode in the form of
         *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
         *           also suppports `target-right`.
         * @param {string} md-offset An offset to apply to the dropdown after positioning
         *           `x`, `y`. Default value is `0`,`0`.
         *
         */

        angular
            .module('material.components.menu')
            .directive('mdMenu', MenuDirective);

        /**
         * @ngInject
         */
        function MenuDirective($mdUtil) {
            var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
            return {
                restrict: 'E',
                require: ['mdMenu', '?^mdMenuBar'],
                controller: 'mdMenuCtrl', // empty function to be built by link
                scope: true,
                compile: compile
            };

            function compile(templateElement) {
                templateElement.addClass('md-menu');
                var triggerElement = templateElement.children()[0];
                if (!triggerElement.hasAttribute('ng-click')) {
                    triggerElement = triggerElement.querySelector('[ng-click],[ng-mouseenter]') || triggerElement;
                }
                if (triggerElement && (
                    triggerElement.nodeName == 'MD-BUTTON' ||
                    triggerElement.nodeName == 'BUTTON'
                ) && !triggerElement.hasAttribute('type')) {
                    triggerElement.setAttribute('type', 'button');
                }

                if (templateElement.children().length != 2) {
                    throw Error(INVALID_PREFIX + 'Expected two children elements.');
                }

                // Default element for ARIA attributes has the ngClick or ngMouseenter expression
                triggerElement && triggerElement.setAttribute('aria-haspopup', 'true');

                var nestedMenus = templateElement[0].querySelectorAll('md-menu');
                var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
                if (nestedMenus) {
                    angular.forEach($mdUtil.nodesToArray(nestedMenus), function (menuEl) {
                        if (!menuEl.hasAttribute('md-position-mode')) {
                            menuEl.setAttribute('md-position-mode', 'cascade');
                        }
                        menuEl.classList.add('_md-nested-menu');
                        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
                    });
                }
                return link;
            }

            function link(scope, element, attrs, ctrls) {
                var mdMenuCtrl = ctrls[0];
                var isInMenuBar = ctrls[1] != undefined;
                // Move everything into a md-menu-container and pass it to the controller
                var menuContainer = angular.element(
                    '<div class="_md-open-menu-container md-whiteframe-z2"></div>'
                );
                var menuContents = element.children()[1];
                if (!menuContents.hasAttribute('role')) {
                    menuContents.setAttribute('role', 'menu');
                }
                menuContainer.append(menuContents);

                element.on('$destroy', function () {
                    menuContainer.remove();
                });

                element.append(menuContainer);
                menuContainer[0].style.display = 'none';
                mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });
            }
        }
        MenuDirective.$inject = ["$mdUtil"];

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.menu')
            .provider('$mdMenu', MenuProvider);

        /*
         * Interim element provider for the menu.
         * Handles behavior for a menu while it is open, including:
         *    - handling animating the menu opening/closing
         *    - handling key/mouse events on the menu element
         *    - handling enabling/disabling scroll while the menu is open
         *    - handling redrawing during resizes and orientation changes
         *
         */

        function MenuProvider($$interimElementProvider) {
            var MENU_EDGE_MARGIN = 8;


            menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate"];
            return $$interimElementProvider('$mdMenu')
                .setDefaults({
                    methods: ['target'],
                    options: menuDefaultOptions
                });

            /* @ngInject */
            function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF, $animateCss, $animate) {
                var animator = $mdUtil.dom.animator;

                return {
                    parent: 'body',
                    onShow: onShow,
                    onRemove: onRemove,
                    hasBackdrop: true,
                    disableParentScroll: true,
                    skipCompile: true,
                    preserveScope: true,
                    skipHide: true,
                    themable: true
                };

                /**
                 * Show modal backdrop element...
                 * @returns {function(): void} A function that removes this backdrop
                 */
                function showBackdrop(scope, element, options) {
                    if (options.nestLevel) return angular.noop;

                    // If we are not within a dialog...
                    if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
                        // !! DO this before creating the backdrop; since disableScrollAround()
                        //    configures the scroll offset; which is used by mdBackDrop postLink()
                        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
                    } else {
                        options.disableParentScroll = false;
                    }

                    if (options.hasBackdrop) {
                        options.backdrop = $mdUtil.createBackdrop(scope, "_md-menu-backdrop _md-click-catcher");

                        $animate.enter(options.backdrop, $document[0].body, angular.element('md-backdrop').last()[0]);
                    }

                    /**
                     * Hide and destroys the backdrop created by showBackdrop()
                     */
                    return function hideBackdrop() {
                        if (options.backdrop) options.backdrop.remove();
                        if (options.disableParentScroll) options.restoreScroll();
                    };
                }

                /**
                 * Removing the menu element from the DOM and remove all associated event listeners
                 * and backdrop
                 */
                function onRemove(scope, element, opts) {
                    opts.cleanupInteraction();
                    opts.cleanupResizing();
                    opts.hideBackdrop();

                    // For navigation $destroy events, do a quick, non-animated removal,
                    // but for normal closes (from clicks, etc) animate the removal

                    return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then(detachAndClean);

                    /**
                     * For normal closes, animate the removal.
                     * For forced closes (like $destroy events), skip the animations
                     */
                    function animateRemoval() {
                        return $animateCss(element, { addClass: '_md-leave' }).start();
                    }

                    /**
                     * Detach the element
                     */
                    function detachAndClean() {
                        element.removeClass('_md-active');
                        detachElement(element, opts);
                        opts.alreadyOpen = false;
                    }

                }

                /**
                 * Inserts and configures the staged Menu element into the DOM, positioning it,
                 * and wiring up various interaction events
                 */
                function onShow(scope, element, opts) {
                    sanitizeAndConfigure(opts);

                    // Wire up theming on our menu element
                    $mdTheming.inherit(opts.menuContentEl, opts.target);

                    // Register various listeners to move menu on resize/orientation change
                    opts.cleanupResizing = startRepositioningOnResize();
                    opts.hideBackdrop = showBackdrop(scope, element, opts);

                    // Return the promise for when our menu is done animating in
                    return showMenu()
                        .then(function (response) {
                            opts.alreadyOpen = true;
                            opts.cleanupInteraction = activateInteraction();
                            return response;
                        });

                    /**
                     * Place the menu into the DOM and call positioning related functions
                     */
                    function showMenu() {
                        opts.parent.append(element);
                        element[0].style.display = '';

                        return $q(function (resolve) {
                            var position = calculateMenuPosition(element, opts);

                            element.removeClass('_md-leave');

                            // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
                            // to normal scale.
                            $animateCss(element, {
                                addClass: '_md-active',
                                from: animator.toCss(position),
                                to: animator.toCss({ transform: '' })
                            })
                                .start()
                                .then(resolve);

                        });
                    }

                    /**
                     * Check for valid opts and set some sane defaults
                     */
                    function sanitizeAndConfigure() {
                        if (!opts.target) {
                            throw Error(
                                '$mdMenu.show() expected a target to animate from in options.target'
                            );
                        }
                        angular.extend(opts, {
                            alreadyOpen: false,
                            isRemoved: false,
                            target: angular.element(opts.target), //make sure it's not a naked dom node
                            parent: angular.element(opts.parent),
                            menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
                        });
                    }

                    /**
                     * Configure various resize listeners for screen changes
                     */
                    function startRepositioningOnResize() {

                        var repositionMenu = (function (target, options) {
                            return $$rAF.throttle(function () {
                                if (opts.isRemoved) return;
                                var position = calculateMenuPosition(target, options);

                                target.css(animator.toCss(position));
                            });
                        })(element, opts);

                        $window.addEventListener('resize', repositionMenu);
                        $window.addEventListener('orientationchange', repositionMenu);

                        return function stopRepositioningOnResize() {

                            // Disable resizing handlers
                            $window.removeEventListener('resize', repositionMenu);
                            $window.removeEventListener('orientationchange', repositionMenu);

                        }
                    }

                    /**
                     * Activate interaction on the menu. Wire up keyboard listerns for
                     * clicks, keypresses, backdrop closing, etc.
                     */
                    function activateInteraction() {
                        element.addClass('_md-clickable');

                        // close on backdrop click
                        if (opts.backdrop) opts.backdrop.on('click', onBackdropClick);

                        // Wire up keyboard listeners.
                        // - Close on escape,
                        // - focus next item on down arrow,
                        // - focus prev item on up
                        opts.menuContentEl.on('keydown', onMenuKeyDown);
                        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);

                        // kick off initial focus in the menu on the first element
                        var focusTarget = opts.menuContentEl[0].querySelector('[md-menu-focus-target]');
                        if (!focusTarget) {
                            var firstChild = opts.menuContentEl[0].firstElementChild;

                            focusTarget = firstChild && (firstChild.querySelector('.md-button:not([disabled])') || firstChild.firstElementChild);
                        }

                        focusTarget && focusTarget.focus();

                        return function cleanupInteraction() {
                            element.removeClass('_md-clickable');
                            if (opts.backdrop) opts.backdrop.off('click', onBackdropClick);
                            opts.menuContentEl.off('keydown', onMenuKeyDown);
                            opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
                        };

                        // ************************************
                        // internal functions
                        // ************************************

                        function onMenuKeyDown(ev) {
                            var handled;
                            switch (ev.keyCode) {
                                case $mdConstant.KEY_CODE.ESCAPE:
                                    opts.mdMenuCtrl.close(false, { closeAll: true });
                                    handled = true;
                                    break;
                                case $mdConstant.KEY_CODE.UP_ARROW:
                                    if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
                                        opts.mdMenuCtrl.triggerContainerProxy(ev);
                                    }
                                    handled = true;
                                    break;
                                case $mdConstant.KEY_CODE.DOWN_ARROW:
                                    if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
                                        opts.mdMenuCtrl.triggerContainerProxy(ev);
                                    }
                                    handled = true;
                                    break;
                                case $mdConstant.KEY_CODE.LEFT_ARROW:
                                    if (opts.nestLevel) {
                                        opts.mdMenuCtrl.close();
                                    } else {
                                        opts.mdMenuCtrl.triggerContainerProxy(ev);
                                    }
                                    handled = true;
                                    break;
                                case $mdConstant.KEY_CODE.RIGHT_ARROW:
                                    var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
                                    if (parentMenu && parentMenu != opts.parent[0]) {
                                        ev.target.click();
                                    } else {
                                        opts.mdMenuCtrl.triggerContainerProxy(ev);
                                    }
                                    handled = true;
                                    break;
                            }
                            if (handled) {
                                ev.preventDefault();
                                ev.stopImmediatePropagation();
                            }
                        }

                        function onBackdropClick(e) {
                            e.preventDefault();
                            e.stopPropagation();
                            scope.$apply(function () {
                                opts.mdMenuCtrl.close(true, { closeAll: true });
                            });
                        }

                        // Close menu on menu item click, if said menu-item is not disabled
                        function captureClickListener(e) {
                            var target = e.target;
                            // Traverse up the event until we get to the menuContentEl to see if
                            // there is an ng-click and that the ng-click is not disabled
                            do {
                                if (target == opts.menuContentEl[0]) return;
                                if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
                                    target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
                                    var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
                                    if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
                                        close();
                                    }
                                    break;
                                }
                            } while (target = target.parentNode)

                            function close() {
                                scope.$apply(function () {
                                    opts.mdMenuCtrl.close(true, { closeAll: true });
                                });
                            }

                            function hasAnyAttribute(target, attrs) {
                                if (!target) return false;
                                for (var i = 0, attr; attr = attrs[i]; ++i) {
                                    var altForms = [attr, 'data-' + attr, 'x-' + attr];
                                    for (var j = 0, rawAttr; rawAttr = altForms[j]; ++j) {
                                        if (target.hasAttribute(rawAttr)) {
                                            return true;
                                        }
                                    }
                                }
                                return false;
                            }
                        }

                        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);

                        return function cleanupInteraction() {
                            element.removeClass('_md-clickable');
                            opts.menuContentEl.off('keydown');
                            opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
                        };
                    }
                }

                /**
                 * Takes a keypress event and focuses the next/previous menu
                 * item from the emitting element
                 * @param {event} e - The origin keypress event
                 * @param {angular.element} menuEl - The menu element
                 * @param {object} opts - The interim element options for the mdMenu
                 * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
                 */
                function focusMenuItem(e, menuEl, opts, direction) {
                    var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');

                    var items = $mdUtil.nodesToArray(menuEl[0].children);
                    var currentIndex = items.indexOf(currentItem);

                    // Traverse through our elements in the specified direction (+/-1) and try to
                    // focus them until we find one that accepts focus
                    var didFocus;
                    for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
                        var focusTarget = items[i].querySelector('.md-button');
                        didFocus = attemptFocus(focusTarget);
                        if (didFocus) {
                            break;
                        }
                    }
                    return didFocus;
                }

                /**
                 * Attempts to focus an element. Checks whether that element is the currently
                 * focused element after attempting.
                 * @param {HTMLElement} el - the element to attempt focus on
                 * @returns {bool} - whether the element was successfully focused
                 */
                function attemptFocus(el) {
                    if (el && el.getAttribute('tabindex') != -1) {
                        el.focus();
                        return ($document[0].activeElement == el);
                    }
                }

                /**
                 * Use browser to remove this element without triggering a $destroy event
                 */
                function detachElement(element, opts) {
                    if (!opts.preserveElement) {
                        if (toNode(element).parentNode === toNode(opts.parent)) {
                            toNode(opts.parent).removeChild(toNode(element));
                        }
                    } else {
                        toNode(element).style.display = 'none';
                    }
                }

                /**
                 * Computes menu position and sets the style on the menu container
                 * @param {HTMLElement} el - the menu container element
                 * @param {object} opts - the interim element options object
                 */
                function calculateMenuPosition(el, opts) {

                    var containerNode = el[0],
                        openMenuNode = el[0].firstElementChild,
                        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
                        boundryNode = $document[0].body,
                        boundryNodeRect = boundryNode.getBoundingClientRect();

                    var menuStyle = $window.getComputedStyle(openMenuNode);

                    var originNode = opts.target[0].querySelector('[md-menu-origin]') || opts.target[0],
                        originNodeRect = originNode.getBoundingClientRect();

                    var bounds = {
                        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
                        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
                        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
                        right: boundryNodeRect.right - MENU_EDGE_MARGIN
                    };

                    var alignTarget, alignTargetRect = { top: 0, left: 0, right: 0, bottom: 0 },
                        existingOffsets = { top: 0, left: 0, right: 0, bottom: 0 };
                    var positionMode = opts.mdMenuCtrl.positionMode();

                    if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
                        alignTarget = firstVisibleChild();
                        if (alignTarget) {
                            // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
                            alignTarget = alignTarget.firstElementChild || alignTarget;
                            alignTarget = alignTarget.querySelector('[md-menu-align-target]') || alignTarget;
                            alignTargetRect = alignTarget.getBoundingClientRect();

                            existingOffsets = {
                                top: parseFloat(containerNode.style.top || 0),
                                left: parseFloat(containerNode.style.left || 0)
                            };
                        }
                    }

                    var position = {};
                    var transformOrigin = 'top ';

                    switch (positionMode.top) {
                        case 'target':
                            position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
                            break;
                        case 'cascade':
                            position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
                            break;
                        case 'bottom':
                            position.top = originNodeRect.top + originNodeRect.height;
                            break;
                        default:
                            throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
                    }

                    var rtl = ($mdUtil.bidi() == 'rtl');

                    switch (positionMode.left) {
                        case 'target':
                            position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
                            transformOrigin += rtl ? 'right' : 'left';
                            break;
                        case 'target-left':
                            position.left = originNodeRect.left;
                            transformOrigin += 'left';
                            break;
                        case 'target-right':
                            position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
                            transformOrigin += 'right';
                            break;
                        case 'cascade':
                            var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
                            position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
                            transformOrigin += willFitRight ? 'left' : 'right';
                            break;
                        case 'left':
                            if (rtl) {
                                position.left = originNodeRect.right - openMenuNodeRect.width;
                                transformOrigin += 'right';
                            } else {
                                position.left = originNodeRect.left;
                                transformOrigin += 'left';
                            }
                            break;
                        default:
                            throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
                    }

                    var offsets = opts.mdMenuCtrl.offsets();
                    position.top += offsets.top;
                    position.left += offsets.left;

                    clamp(position);

                    var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
                    var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;

                    return {
                        top: Math.round(position.top),
                        left: Math.round(position.left),
                        // Animate a scale out if we aren't just repositioning
                        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
                        transformOrigin: transformOrigin
                    };

                    /**
                     * Clamps the repositioning of the menu within the confines of
                     * bounding element (often the screen/body)
                     */
                    function clamp(pos) {
                        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
                        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
                    }

                    /**
                     * Gets the first visible child in the openMenuNode
                     * Necessary incase menu nodes are being dynamically hidden
                     */
                    function firstVisibleChild() {
                        for (var i = 0; i < openMenuNode.children.length; ++i) {
                            if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
                                return openMenuNode.children[i];
                            }
                        }
                    }
                }
            }

            function toNode(el) {
                if (el instanceof angular.element) {
                    el = el[0];
                }
                return el;
            }
        }
        MenuProvider.$inject = ["$$interimElementProvider"];

    })();
    (function () {
        "use strict";


        angular
            .module('material.components.menuBar')
            .controller('MenuBarController', MenuBarController);

        var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];

        /**
         * @ngInject
         */
        function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
            this.$element = $element;
            this.$attrs = $attrs;
            this.$mdConstant = $mdConstant;
            this.$mdUtil = $mdUtil;
            this.$document = $document;
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$timeout = $timeout;

            var self = this;
            angular.forEach(BOUND_MENU_METHODS, function (methodName) {
                if (self[methodName]) self[methodName] = angular.bind(self, self[methodName]);
            });
        }
        MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];

        MenuBarController.prototype.init = function () {
            var $element = this.$element;
            var $mdUtil = this.$mdUtil;
            var $scope = this.$scope;

            var self = this;
            var deregisterFns = [];
            $element.on('keydown', this.handleKeyDown);
            this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');

            deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function (event, el) {
                if (self.getMenus().indexOf(el[0]) != -1) {
                    $element[0].classList.add('_md-open');
                    el[0].classList.add('_md-open');
                    self.currentlyOpenMenu = el.controller('mdMenu');
                    self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
                    self.enableOpenOnHover();
                }
            }));

            deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function (event, el, opts) {
                var rootMenus = self.getMenus();
                if (rootMenus.indexOf(el[0]) != -1) {
                    $element[0].classList.remove('_md-open');
                    el[0].classList.remove('_md-open');
                }

                if ($element[0].contains(el[0])) {
                    var parentMenu = el[0];
                    while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
                        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
                    }
                    if (parentMenu) {
                        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
                        self.currentlyOpenMenu = undefined;
                        self.disableOpenOnHover();
                        self.setKeyboardMode(true);
                    }
                }
            }));

            $scope.$on('$destroy', function () {
                while (deregisterFns.length) {
                    deregisterFns.shift()();
                }
            });


            this.setKeyboardMode(true);
        };

        MenuBarController.prototype.setKeyboardMode = function (enabled) {
            if (enabled) this.$element[0].classList.add('_md-keyboard-mode');
            else this.$element[0].classList.remove('_md-keyboard-mode');
        };

        MenuBarController.prototype.enableOpenOnHover = function () {
            if (this.openOnHoverEnabled) return;
            this.openOnHoverEnabled = true;

            var parentToolbar;
            if (parentToolbar = this.parentToolbar) {
                parentToolbar.dataset.mdRestoreStyle = parentToolbar.getAttribute('style');
                parentToolbar.style.position = 'relative';
                parentToolbar.style.zIndex = 100;
            }
            angular
                .element(this.getMenus())
                .on('mouseenter', this.handleMenuHover);
        };

        MenuBarController.prototype.handleMenuHover = function (e) {
            this.setKeyboardMode(false);
            if (this.openOnHoverEnabled) {
                this.scheduleOpenHoveredMenu(e);
            }
        };


        MenuBarController.prototype.disableOpenOnHover = function () {
            if (!this.openOnHoverEnabled) return;
            this.openOnHoverEnabled = false;
            var parentToolbar;
            if (parentToolbar = this.parentToolbar) {
                parentToolbar.style.cssText = parentToolbar.dataset.mdRestoreStyle || '';
            }
            angular
                .element(this.getMenus())
                .off('mouseenter', this.handleMenuHover);
        };

        MenuBarController.prototype.scheduleOpenHoveredMenu = function (e) {
            var menuEl = angular.element(e.currentTarget);
            var menuCtrl = menuEl.controller('mdMenu');
            this.setKeyboardMode(false);
            this.scheduleOpenMenu(menuCtrl);
        };

        MenuBarController.prototype.scheduleOpenMenu = function (menuCtrl) {
            var self = this;
            var $timeout = this.$timeout;
            if (menuCtrl != self.currentlyOpenMenu) {
                $timeout.cancel(self.pendingMenuOpen);
                self.pendingMenuOpen = $timeout(function () {
                    self.pendingMenuOpen = undefined;
                    if (self.currentlyOpenMenu) {
                        self.currentlyOpenMenu.close(true, { closeAll: true });
                    }
                    menuCtrl.open();
                }, 200, false);
            }
        };

        MenuBarController.prototype.handleKeyDown = function (e) {
            var keyCodes = this.$mdConstant.KEY_CODE;
            var currentMenu = this.currentlyOpenMenu;
            var wasOpen = currentMenu && currentMenu.isOpen;
            this.setKeyboardMode(true);
            var handled, newMenu, newMenuCtrl;
            switch (e.keyCode) {
                case keyCodes.DOWN_ARROW:
                    if (currentMenu) {
                        currentMenu.focusMenuContainer();
                    } else {
                        this.openFocusedMenu();
                    }
                    handled = true;
                    break;
                case keyCodes.UP_ARROW:
                    currentMenu && currentMenu.close();
                    handled = true;
                    break;
                case keyCodes.LEFT_ARROW:
                    newMenu = this.focusMenu(-1);
                    if (wasOpen) {
                        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
                        this.scheduleOpenMenu(newMenuCtrl);
                    }
                    handled = true;
                    break;
                case keyCodes.RIGHT_ARROW:
                    newMenu = this.focusMenu(+1);
                    if (wasOpen) {
                        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
                        this.scheduleOpenMenu(newMenuCtrl);
                    }
                    handled = true;
                    break;
            }
            if (handled) {
                e && e.preventDefault && e.preventDefault();
                e && e.stopImmediatePropagation && e.stopImmediatePropagation();
            }
        };

        MenuBarController.prototype.focusMenu = function (direction) {
            var menus = this.getMenus();
            var focusedIndex = this.getFocusedMenuIndex();

            if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }

            var changed = false;

            if (focusedIndex == -1) {
                focusedIndex = 0;
                changed = true;
            } else if (
                direction < 0 && focusedIndex > 0 ||
                direction > 0 && focusedIndex < menus.length - direction
            ) {
                focusedIndex += direction;
                changed = true;
            }
            if (changed) {
                menus[focusedIndex].querySelector('button').focus();
                return menus[focusedIndex];
            }
        };

        MenuBarController.prototype.openFocusedMenu = function () {
            var menu = this.getFocusedMenu();
            menu && angular.element(menu).controller('mdMenu').open();
        };

        MenuBarController.prototype.getMenus = function () {
            var $element = this.$element;
            return this.$mdUtil.nodesToArray($element[0].children)
                .filter(function (el) { return el.nodeName == 'MD-MENU'; });
        };

        MenuBarController.prototype.getFocusedMenu = function () {
            return this.getMenus()[this.getFocusedMenuIndex()];
        };

        MenuBarController.prototype.getFocusedMenuIndex = function () {
            var $mdUtil = this.$mdUtil;
            var focusedEl = $mdUtil.getClosest(
                this.$document[0].activeElement,
                'MD-MENU'
            );
            if (!focusedEl) return -1;

            var focusedIndex = this.getMenus().indexOf(focusedEl);
            return focusedIndex;

        };

        MenuBarController.prototype.getOpenMenuIndex = function () {
            var menus = this.getMenus();
            for (var i = 0; i < menus.length; ++i) {
                if (menus[i].classList.contains('_md-open')) return i;
            }
            return -1;
        };









    })();
    (function () {
        "use strict";

        /**
         * @ngdoc directive
         * @name mdMenuBar
         * @module material.components.menu-bar
         * @restrict E
         * @description
         *
         * Menu bars are containers that hold multiple menus. They change the behavior and appearence
         * of the `md-menu` directive to behave similar to an operating system provided menu.
         *
         * @usage
         * <hljs lang="html">
         * <md-menu-bar>
         *   <md-menu>
         *     <button ng-click="$mdOpenMenu()">
         *       File
         *     </button>
         *     <md-menu-content>
         *       <md-menu-item>
         *         <md-button ng-click="ctrl.sampleAction('share', $event)">
         *           Share...
         *         </md-button>
         *       </md-menu-item>
         *       <md-menu-divider></md-menu-divider>
         *       <md-menu-item>
         *       <md-menu-item>
         *         <md-menu>
         *           <md-button ng-click="$mdOpenMenu()">New</md-button>
         *           <md-menu-content>
         *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
         *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
         *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
         *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
         *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
         *           </md-menu-content>
         *         </md-menu>
         *       </md-menu-item>
         *     </md-menu-content>
         *   </md-menu>
         * </md-menu-bar>
         * </hljs>
         *
         * ## Menu Bar Controls
         *
         * You may place `md-menu-items` that function as controls within menu bars.
         * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
         * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
         * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
         * to the `string` value of the `value` attribute. If you need non-string values, you can use
         * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
         *
         * <hljs lang="html">
         * <md-menu-bar>
         *  <md-menu>
         *    <button ng-click="$mdOpenMenu()">
         *      Sample Menu
         *    </button>
         *    <md-menu-content>
         *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
         *      <md-menu-divider></md-menu-divider>
         *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
         *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
         *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
         *    </md-menu-content>
         *  </md-menu>
         * </md-menu-bar>
         * </hljs>
         *
         *
         * ### Nesting Menus
         *
         * Menus may be nested within menu bars. This is commonly called cascading menus.
         * To nest a menu place the nested menu inside the content of the `md-menu-item`.
         * <hljs lang="html">
         * <md-menu-item>
         *   <md-menu>
         *     <button ng-click="$mdOpenMenu()">New</md-button>
         *     <md-menu-content>
         *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
         *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
         *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
         *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
         *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
         *     </md-menu-content>
         *   </md-menu>
         * </md-menu-item>
         * </hljs>
         *
         */

        angular
            .module('material.components.menuBar')
            .directive('mdMenuBar', MenuBarDirective);

        /* @ngInject */
        function MenuBarDirective($mdUtil, $mdTheming) {
            return {
                restrict: 'E',
                require: 'mdMenuBar',
                controller: 'MenuBarController',

                compile: function compile(templateEl, templateAttrs) {
                    if (!templateAttrs.ariaRole) {
                        templateEl[0].setAttribute('role', 'menubar');
                    }
                    angular.forEach(templateEl[0].children, function (menuEl) {
                        if (menuEl.nodeName == 'MD-MENU') {
                            if (!menuEl.hasAttribute('md-position-mode')) {
                                menuEl.setAttribute('md-position-mode', 'left bottom');
                                menuEl.querySelector('button,a').setAttribute('role', 'menuitem');
                            }
                            var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
                            angular.forEach(contentEls, function (contentEl) {
                                contentEl.classList.add('_md-menu-bar-menu');
                                contentEl.classList.add('md-dense');
                                if (!contentEl.hasAttribute('width')) {
                                    contentEl.setAttribute('width', 5);
                                }
                            });
                        }
                    });

                    return function postLink(scope, el, attrs, ctrl) {
                        $mdTheming(scope, el);
                        ctrl.init();
                    };
                }
            };

        }
        MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];

    })();
    (function () {
        "use strict";


        angular
            .module('material.components.menuBar')
            .directive('mdMenuDivider', MenuDividerDirective);


        function MenuDividerDirective() {
            return {
                restrict: 'E',
                compile: function (templateEl, templateAttrs) {
                    if (!templateAttrs.role) {
                        templateEl[0].setAttribute('role', 'separator');
                    }
                }
            };
        }

    })();
    (function () {
        "use strict";


        angular
            .module('material.components.menuBar')
            .controller('MenuItemController', MenuItemController);


        /**
         * @ngInject
         */
        function MenuItemController($scope, $element, $attrs) {
            this.$element = $element;
            this.$attrs = $attrs;
            this.$scope = $scope;
        }
        MenuItemController.$inject = ["$scope", "$element", "$attrs"];

        MenuItemController.prototype.init = function (ngModel) {
            var $element = this.$element;
            var $attrs = this.$attrs;

            this.ngModel = ngModel;
            if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
                this.mode = $attrs.type;
                this.iconEl = $element[0].children[0];
                this.buttonEl = $element[0].children[1];
                if (ngModel) {
                    // Clear ngAria set attributes
                    this.initClickListeners();
                }
            }
        };

        // ngAria auto sets attributes on a menu-item with a ngModel.
        // We don't want this because our content (buttons) get the focus
        // and set their own aria attributes appropritately. Having both
        // breaks NVDA / JAWS. This undeoes ngAria's attrs.
        MenuItemController.prototype.clearNgAria = function () {
            var el = this.$element[0];
            var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
            angular.forEach(clearAttrs, function (attr) {
                el.removeAttribute(attr);
            });
        };

        MenuItemController.prototype.initClickListeners = function () {
            var self = this;
            var ngModel = this.ngModel;
            var $scope = this.$scope;
            var $attrs = this.$attrs;
            var $element = this.$element;
            var mode = this.mode;

            this.handleClick = angular.bind(this, this.handleClick);

            var icon = this.iconEl;
            var button = angular.element(this.buttonEl);
            var handleClick = this.handleClick;

            $attrs.$observe('disabled', setDisabled);
            setDisabled($attrs.disabled);

            ngModel.$render = function render() {
                self.clearNgAria();
                if (isSelected()) {
                    icon.style.display = '';
                    button.attr('aria-checked', 'true');
                } else {
                    icon.style.display = 'none';
                    button.attr('aria-checked', 'false');
                }
            };

            $scope.$$postDigest(ngModel.$render);

            function isSelected() {
                if (mode == 'radio') {
                    var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
                    return ngModel.$modelValue == val;
                } else {
                    return ngModel.$modelValue;
                }
            }

            function setDisabled(disabled) {
                if (disabled) {
                    button.off('click', handleClick);
                } else {
                    button.on('click', handleClick);
                }
            }
        };

        MenuItemController.prototype.handleClick = function (e) {
            var mode = this.mode;
            var ngModel = this.ngModel;
            var $attrs = this.$attrs;
            var newVal;
            if (mode == 'checkbox') {
                newVal = !ngModel.$modelValue;
            } else if (mode == 'radio') {
                newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
            }
            ngModel.$setViewValue(newVal);
            ngModel.$render();
        };

    })();
    (function () {
        "use strict";


        angular
            .module('material.components.menuBar')
            .directive('mdMenuItem', MenuItemDirective);

        /* @ngInject */
        function MenuItemDirective() {
            return {
                require: ['mdMenuItem', '?ngModel'],
                priority: 210, // ensure that our post link runs after ngAria
                compile: function (templateEl, templateAttrs) {
                    if (templateAttrs.type == 'checkbox' || templateAttrs.type == 'radio') {
                        var text = templateEl[0].textContent;
                        var buttonEl = angular.element('<md-button type="button"></md-button>');
                        buttonEl.html(text);
                        buttonEl.attr('tabindex', '0');

                        templateEl.html('');
                        templateEl.append(angular.element('<md-icon md-svg-icon="check"></md-icon>'));
                        templateEl.append(buttonEl);
                        templateEl[0].classList.add('md-indent');

                        setDefault('role', (templateAttrs.type == 'checkbox') ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
                        angular.forEach(['ng-disabled'], moveAttrToButton);

                    } else {
                        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button,button,a'));
                    }


                    return function (scope, el, attrs, ctrls) {
                        var ctrl = ctrls[0];
                        var ngModel = ctrls[1];
                        ctrl.init(ngModel);
                    };

                    function setDefault(attr, val, el) {
                        el = el || templateEl;
                        if (el instanceof angular.element) {
                            el = el[0];
                        }
                        if (!el.hasAttribute(attr)) {
                            el.setAttribute(attr, val);
                        }
                    }

                    function moveAttrToButton(attr) {
                        if (templateEl[0].hasAttribute(attr)) {
                            var val = templateEl[0].getAttribute(attr);
                            buttonEl[0].setAttribute(attr, val);
                            templateEl[0].removeAttribute(attr);
                        }
                    }
                },
                controller: 'MenuItemController'
            };
        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc directive
         * @name mdProgressCircular
         * @module material.components.progressCircular
         * @restrict E
         *
         * @description
         * The circular progress directive is used to make loading content in your app as delightful and
         * painless as possible by minimizing the amount of visual change a user sees before they can view
         * and interact with content.
         *
         * For operations where the percentage of the operation completed can be determined, use a
         * determinate indicator. They give users a quick sense of how long an operation will take.
         *
         * For operations where the user is asked to wait a moment while something finishes up, and it’s
         * not necessary to expose what's happening behind the scenes and how long it will take, use an
         * indeterminate indicator.
         *
         * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
         *
         * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
         * will be auto-applied as the mode.
         *
         * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
         * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
         * @param {number=} value In determinate mode, this number represents the percentage of the
         *     circular progress. Default: 0
         * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
         * should be a pixel-size value (eg '100'). If this attribute is
         * not present then a default value of '50px' is assumed.
         *
         * @param {boolean=} ng-disabled Determines whether to disable the progress element.
         *
         * @usage
         * <hljs lang="html">
         * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
         *
         * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
         *
         * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
         *
         * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
         * </hljs>
         */

        angular
            .module('material.components.progressCircular')
            .directive('mdProgressCircular', MdProgressCircularDirective);

        /* @ngInject */
        function MdProgressCircularDirective($$rAF, $window, $mdProgressCircular, $mdTheming,
            $mdUtil, $interval, $log) {

            var DEGREE_IN_RADIANS = $window.Math.PI / 180;
            var MODE_DETERMINATE = 'determinate';
            var MODE_INDETERMINATE = 'indeterminate';
            var DISABLED_CLASS = '_md-progress-circular-disabled';
            var INDETERMINATE_CLASS = '_md-mode-indeterminate';

            return {
                restrict: 'E',
                scope: {
                    value: '@',
                    mdDiameter: '@',
                    mdMode: '@'
                },
                template: '<svg xmlns="http://www.w3.org/2000/svg">' +
                    '<path fill="none"/>' +
                    '</svg>',
                compile: function (element, attrs) {
                    element.attr({
                        'aria-valuemin': 0,
                        'aria-valuemax': 100,
                        'role': 'progressbar'
                    });

                    if (angular.isUndefined(attrs.mdMode)) {
                        var hasValue = angular.isDefined(attrs.value);
                        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
                        var info = "Auto-adding the missing md-mode='{0}' to the ProgressCircular element";

                        // $log.debug( $mdUtil.supplant(info, [mode]) );
                        attrs.$set('mdMode', mode);
                    } else {
                        attrs.$set('mdMode', attrs.mdMode.trim());
                    }

                    return MdProgressCircularLink;
                }
            };

            function MdProgressCircularLink(scope, element, attrs) {
                var node = element[0];
                var svg = angular.element(node.querySelector('svg'));
                var path = angular.element(node.querySelector('path'));
                var startIndeterminate = $mdProgressCircular.startIndeterminate;
                var endIndeterminate = $mdProgressCircular.endIndeterminate;
                var rotationIndeterminate = 0;
                var lastAnimationId = 0;
                var lastDrawFrame;
                var interval;

                $mdTheming(element);
                element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));

                // If the mode is indeterminate, it doesn't need to
                // wait for the next digest. It can start right away.
                if (scope.mdMode === MODE_INDETERMINATE) {
                    startIndeterminateAnimation();
                }

                scope.$on('$destroy', function () {
                    cleanupIndeterminateAnimation(true);
                });

                scope.$watchGroup(['value', 'mdMode', function () {
                    var isDisabled = node.disabled;

                    // Sometimes the browser doesn't return a boolean, in
                    // which case we should check whether the attribute is
                    // present.
                    if (isDisabled === true || isDisabled === false) {
                        return isDisabled;
                    }
                    return angular.isDefined(element.attr('disabled'));

                }], function (newValues, oldValues) {
                    var mode = newValues[1];
                    var isDisabled = newValues[2];
                    var wasDisabled = oldValues[2];

                    if (isDisabled !== wasDisabled) {
                        element.toggleClass(DISABLED_CLASS, !!isDisabled);
                    }

                    if (isDisabled) {
                        cleanupIndeterminateAnimation();
                    } else {
                        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
                            mode = MODE_INDETERMINATE;
                            attrs.$set('mdMode', mode);
                        }

                        if (mode === MODE_INDETERMINATE) {
                            startIndeterminateAnimation();
                        } else {
                            var newValue = clamp(newValues[0]);

                            cleanupIndeterminateAnimation(true);

                            element.attr('aria-valuenow', newValue);
                            renderCircle(clamp(oldValues[0]), newValue);
                        }
                    }

                });

                // This is in a separate watch in order to avoid layout, unless
                // the value has actually changed.
                scope.$watch('mdDiameter', function (newValue) {
                    var diameter = getSize(newValue);
                    var strokeWidth = getStroke(diameter);
                    var transformOrigin = (diameter / 2) + 'px';
                    var dimensions = {
                        width: diameter + 'px',
                        height: diameter + 'px'
                    };

                    // The viewBox has to be applied via setAttribute, because it is
                    // case-sensitive. If jQuery is included in the page, `.attr` lowercases
                    // all attribute names.
                    svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);

                    // Usually viewBox sets the dimensions for the SVG, however that doesn't
                    // seem to be the case on IE10.
                    // Important! The transform origin has to be set from here and it has to
                    // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
                    // IE and Edge, because they don't account for the stroke width when
                    // rotating. Also "center" doesn't help in this case, it has to be a
                    // precise value.
                    svg
                        .css(dimensions)
                        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);

                    element.css(dimensions);
                    path.css('stroke-width', strokeWidth + 'px');
                });

                function renderCircle(animateFrom, animateTo, easing, duration, rotation) {
                    var id = ++lastAnimationId;
                    var startTime = $mdUtil.now();
                    var changeInValue = animateTo - animateFrom;
                    var diameter = getSize(scope.mdDiameter);
                    var pathDiameter = diameter - getStroke(diameter);
                    var ease = easing || $mdProgressCircular.easeFn;
                    var animationDuration = duration || $mdProgressCircular.duration;

                    // No need to animate it if the values are the same
                    if (animateTo === animateFrom) {
                        path.attr('d', getSvgArc(animateTo, diameter, pathDiameter, rotation));
                    } else {
                        lastDrawFrame = $$rAF(function animation(now) {
                            var currentTime = $window.Math.max(0, $window.Math.min((now || $mdUtil.now()) - startTime, animationDuration));

                            path.attr('d', getSvgArc(
                                ease(currentTime, animateFrom, changeInValue, animationDuration),
                                diameter,
                                pathDiameter,
                                rotation
                            ));

                            lastDrawFrame && lastDrawFrame();

                            // Do not allow overlapping animations
                            if (id === lastAnimationId && currentTime < animationDuration) {
                                lastDrawFrame = $$rAF(animation);
                            }
                        });
                    }
                }

                function animateIndeterminate() {
                    renderCircle(
                        startIndeterminate,
                        endIndeterminate,
                        $mdProgressCircular.easeFnIndeterminate,
                        $mdProgressCircular.durationIndeterminate,
                        rotationIndeterminate
                    );

                    // The % 100 technically isn't necessary, but it keeps the rotation
                    // under 100, instead of becoming a crazy large number.
                    rotationIndeterminate = (rotationIndeterminate + endIndeterminate) % 100;

                    var temp = startIndeterminate;
                    startIndeterminate = -endIndeterminate;
                    endIndeterminate = -temp;
                }

                function startIndeterminateAnimation() {
                    if (!interval) {
                        // Note that this interval isn't supposed to trigger a digest.
                        interval = $interval(
                            animateIndeterminate,
                            $mdProgressCircular.durationIndeterminate + 50,
                            0,
                            false
                        );

                        animateIndeterminate();

                        element
                            .addClass(INDETERMINATE_CLASS)
                            .removeAttr('aria-valuenow');
                    }
                }

                function cleanupIndeterminateAnimation(clearLastFrames) {
                    if (interval) {
                        $interval.cancel(interval);
                        interval = null;
                        element.removeClass(INDETERMINATE_CLASS);
                    }

                    if (clearLastFrames === true) {
                        lastDrawFrame && lastDrawFrame();
                        lastDrawFrame = undefined;
                    }
                }
            }

            /**
             * Generates an arc following the SVG arc syntax.
             * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
             *
             * @param {number} current Current value between 0 and 100.
             * @param {number} diameter Diameter of the container.
             * @param {number} pathDiameter Diameter of the path element.
             * @param {number=0} rotation The point at which the semicircle should start rendering.
             * Used for doing the indeterminate animation.
             *
             * @returns {string} String representation of an SVG arc.
             */
            function getSvgArc(current, diameter, pathDiameter, rotation) {
                // The angle can't be exactly 360, because the arc becomes hidden.
                var maximumAngle = 359.99 / 100;
                var startPoint = rotation || 0;
                var radius = diameter / 2;
                var pathRadius = pathDiameter / 2;

                var startAngle = startPoint * maximumAngle;
                var endAngle = current * maximumAngle;
                var start = polarToCartesian(radius, pathRadius, startAngle);
                var end = polarToCartesian(radius, pathRadius, endAngle + startAngle);
                var arcSweep = endAngle < 0 ? 0 : 1;
                var largeArcFlag;

                if (endAngle < 0) {
                    largeArcFlag = endAngle >= -180 ? 0 : 1;
                } else {
                    largeArcFlag = endAngle <= 180 ? 0 : 1;
                }

                return 'M' + start + 'A' + pathRadius + ',' + pathRadius +
                    ' 0 ' + largeArcFlag + ',' + arcSweep + ' ' + end;
            }

            /**
             * Converts Polar coordinates to Cartesian.
             *
             * @param {number} radius Radius of the container.
             * @param {number} pathRadius Radius of the path element
             * @param {number} angleInDegress Angle at which to place the point.
             *
             * @returns {string} Cartesian coordinates in the format of `x,y`.
             */
            function polarToCartesian(radius, pathRadius, angleInDegrees) {
                var angleInRadians = (angleInDegrees - 90) * DEGREE_IN_RADIANS;

                return (radius + (pathRadius * $window.Math.cos(angleInRadians))) +
                    ',' + (radius + (pathRadius * $window.Math.sin(angleInRadians)));
            }

            /**
             * Limits a value between 0 and 100.
             */
            function clamp(value) {
                return $window.Math.max(0, $window.Math.min(value || 0, 100));
            }

            /**
             * Determines the size of a progress circle, based on the provided
             * value in the following formats: `X`, `Ypx`, `Z%`.
             */
            function getSize(value) {
                var defaultValue = $mdProgressCircular.progressSize;

                if (value) {
                    var parsed = parseFloat(value);

                    if (value.lastIndexOf('%') === value.length - 1) {
                        parsed = (parsed / 100) * defaultValue;
                    }

                    return parsed;
                }

                return defaultValue;
            }

            /**
             * Determines the circle's stroke width, based on
             * the provided diameter.
             */
            function getStroke(diameter) {
                return $mdProgressCircular.strokeWidth / 100 * diameter;
            }
        }
        MdProgressCircularDirective.$inject = ["$$rAF", "$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc service
         * @name $mdProgressCircular
         * @module material.components.progressCircular
         *
         * @description
         * Allows the user to specify the default options for the `progressCircular` directive.
         *
         * @property {number} progressSize Diameter of the progress circle in pixels.
         * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
         * @property {number} duration Length of the circle animation in milliseconds.
         * @property {function} easeFn Default easing animation function.
         * @property {object} easingPresets Collection of pre-defined easing functions.
         *
         * @property {number} durationIndeterminate Duration of the indeterminate animation.
         * @property {number} startIndeterminate Indeterminate animation start point.
         * @property {number} endIndeterminate Indeterminate animation end point.
         * @property {function} easeFnIndeterminate Easing function to be used when animating
         * between the indeterminate values.
         *
         * @property {(function(object): object)} configure Used to modify the default options.
         *
         * @usage
         * <hljs lang="js">
         *   myAppModule.config(function($mdProgressCircularProvider) {
         *
         *     // Example of changing the default progress options.
         *     $mdProgressCircularProvider.configure({
         *       progressSize: 100,
         *       strokeWidth: 20,
         *       duration: 800
         *     });
         * });
         * </hljs>
         *
         */

        angular
            .module('material.components.progressCircular')
            .provider("$mdProgressCircular", MdProgressCircularProvider);

        function MdProgressCircularProvider() {
            var progressConfig = {
                progressSize: 50,
                strokeWidth: 10,
                duration: 100,
                easeFn: linearEase,

                durationIndeterminate: 500,
                startIndeterminate: 3,
                endIndeterminate: 80,
                easeFnIndeterminate: materialEase,

                easingPresets: {
                    linearEase: linearEase,
                    materialEase: materialEase
                }
            };

            return {
                configure: function (options) {
                    progressConfig = angular.extend(progressConfig, options || {});
                    return progressConfig;
                },
                $get: function () { return progressConfig; }
            };

            function linearEase(t, b, c, d) {
                return c * t / d + b;
            }

            function materialEase(t, b, c, d) {
                // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
                // with settings of [0, 0, 1, 1]
                var ts = (t /= d) * t;
                var tc = ts * t;
                return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
            }
        }

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc directive
         * @name mdTab
         * @module material.components.tabs
         *
         * @restrict E
         *
         * @description
         * Use the `<md-tab>` a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
         *
         * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
         * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
         * markup of the `<md-tab>` is used as the tab header markup.
         *
         * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
         * is to define a clear separation between the tab content and the tab label.
         *
         * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
         * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
         * be initiated via data binding changes, programmatic invocation, or user gestures.
         *
         * @param {string=} label Optional attribute to specify a simple string as the tab label
         * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
         * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
         * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
         * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
         *
         *
         * @usage
         *
         * <hljs lang="html">
         * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
         *   <h3>My Tab content</h3>
         * </md-tab>
         *
         * <md-tab >
         *   <md-tab-label>
         *     <h3>My Tab content</h3>
         *   </md-tab-label>
         *   <md-tab-body>
         *     <p>
         *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
         *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
         *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
         *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
         *     </p>
         *   </md-tab-body>
         * </md-tab>
         * </hljs>
         *
         */
        angular
            .module('material.components.tabs')
            .directive('mdTab', MdTab);

        function MdTab() {
            return {
                require: '^?mdTabs',
                terminal: true,
                compile: function (element, attr) {
                    var label = firstChild(element, 'md-tab-label'),
                        body = firstChild(element, 'md-tab-body');

                    if (label.length == 0) {
                        label = angular.element('<md-tab-label></md-tab-label>');
                        if (attr.label) label.text(attr.label);
                        else label.append(element.contents());

                        if (body.length == 0) {
                            var contents = element.contents().detach();
                            body = angular.element('<md-tab-body></md-tab-body>');
                            body.append(contents);
                        }
                    }

                    element.append(label);
                    if (body.html()) element.append(body);

                    return postLink;
                },
                scope: {
                    active: '=?mdActive',
                    disabled: '=?ngDisabled',
                    select: '&?mdOnSelect',
                    deselect: '&?mdOnDeselect'
                }
            };

            function postLink(scope, element, attr, ctrl) {
                if (!ctrl) return;
                var index = ctrl.getTabElementIndex(element),
                    body = firstChild(element, 'md-tab-body').remove(),
                    label = firstChild(element, 'md-tab-label').remove(),
                    data = ctrl.insertTab({
                        scope: scope,
                        parent: scope.$parent,
                        index: index,
                        element: element,
                        template: body.html(),
                        label: label.html()
                    }, index);

                scope.select = scope.select || angular.noop;
                scope.deselect = scope.deselect || angular.noop;

                scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
                scope.$watch('disabled', function () { ctrl.refreshIndex(); });
                scope.$watch(
                    function () {
                        return ctrl.getTabElementIndex(element);
                    },
                    function (newIndex) {
                        data.index = newIndex;
                        ctrl.updateTabOrder();
                    }
                );
                scope.$on('$destroy', function () { ctrl.removeTab(data); });
            }

            function firstChild(element, tagName) {
                var children = element[0].children;
                for (var i = 0, len = children.length; i < len; i++) {
                    var child = children[i];
                    if (child.tagName === tagName.toUpperCase()) return angular.element(child);
                }
                return angular.element();
            }
        }

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.tabs')
            .directive('mdTabItem', MdTabItem);

        function MdTabItem() {
            return {
                require: '^?mdTabs',
                link: function link(scope, element, attr, ctrl) {
                    if (!ctrl) return;
                    ctrl.attachRipple(scope, element);
                }
            };
        }

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.tabs')
            .directive('mdTabLabel', MdTabLabel);

        function MdTabLabel() {
            return { terminal: true };
        }


    })();
    (function () {
        "use strict";

        angular
            .module('material.components.tabs')
            .controller('MdTabsController', MdTabsController);

        /**
         * @ngInject
         */
        function MdTabsController($scope, $element, $window, $mdConstant, $mdTabInkRipple,
            $mdUtil, $animateCss, $attrs, $compile, $mdTheming) {
            // define private properties
            var ctrl = this,
                locked = false,
                elements = getElements(),
                queue = [],
                destroyed = false,
                loaded = false;

            // define one-way bindings
            defineOneWayBinding('stretchTabs', handleStretchTabs);

            // define public properties with change handlers
            defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
            defineProperty('offsetLeft', handleOffsetChange, 0);
            defineProperty('hasContent', handleHasContent, false);
            defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
            defineProperty('shouldPaginate', handleShouldPaginate, false);

            // define boolean attributes
            defineBooleanAttribute('noInkBar', handleInkBar);
            defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
            defineBooleanAttribute('noPagination');
            defineBooleanAttribute('swipeContent');
            defineBooleanAttribute('noDisconnect');
            defineBooleanAttribute('autoselect');
            defineBooleanAttribute('noSelectClick');
            defineBooleanAttribute('centerTabs', handleCenterTabs, false);
            defineBooleanAttribute('enableDisconnect');

            // define public properties
            ctrl.scope = $scope;
            ctrl.parent = $scope.$parent;
            ctrl.tabs = [];
            ctrl.lastSelectedIndex = null;
            ctrl.hasFocus = false;
            ctrl.lastClick = true;
            ctrl.shouldCenterTabs = shouldCenterTabs();

            // define public methods
            ctrl.updatePagination = $mdUtil.debounce(updatePagination, 100);
            ctrl.redirectFocus = redirectFocus;
            ctrl.attachRipple = attachRipple;
            ctrl.insertTab = insertTab;
            ctrl.removeTab = removeTab;
            ctrl.select = select;
            ctrl.scroll = scroll;
            ctrl.nextPage = nextPage;
            ctrl.previousPage = previousPage;
            ctrl.keydown = keydown;
            ctrl.canPageForward = canPageForward;
            ctrl.canPageBack = canPageBack;
            ctrl.refreshIndex = refreshIndex;
            ctrl.incrementIndex = incrementIndex;
            ctrl.getTabElementIndex = getTabElementIndex;
            ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
            ctrl.updateTabOrder = $mdUtil.debounce(updateTabOrder, 100);

            init();

            /**
             * Perform initialization for the controller, setup events and watcher(s)
             */
            function init() {
                ctrl.selectedIndex = ctrl.selectedIndex || 0;
                compileTemplate();
                configureWatchers();
                bindEvents();
                $mdTheming($element);
                $mdUtil.nextTick(function () {
                    updateHeightFromContent();
                    adjustOffset();
                    updateInkBarStyles();
                    ctrl.tabs[ctrl.selectedIndex] && ctrl.tabs[ctrl.selectedIndex].scope.select();
                    loaded = true;
                    updatePagination();
                });
            }

            /**
             * Compiles the template provided by the user.  This is passed as an attribute from the tabs
             * directive's template function.
             */
            function compileTemplate() {
                var template = $attrs.$mdTabsTemplate,
                    element = angular.element(elements.data);
                element.html(template);
                $compile(element.contents())(ctrl.parent);
                delete $attrs.$mdTabsTemplate;
            }

            /**
             * Binds events used by the tabs component.
             */
            function bindEvents() {
                angular.element($window).on('resize', handleWindowResize);
                $scope.$on('$destroy', cleanup);
            }

            /**
             * Configure watcher(s) used by Tabs
             */
            function configureWatchers() {
                $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
            }

            /**
             * Creates a one-way binding manually rather than relying on Angular's isolated scope
             * @param key
             * @param handler
             */
            function defineOneWayBinding(key, handler) {
                var attr = $attrs.$normalize('md-' + key);
                if (handler) defineProperty(key, handler);
                $attrs.$observe(attr, function (newValue) { ctrl[key] = newValue; });
            }

            /**
             * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
             * will be treated as being truthy)
             * @param key
             * @param handler
             */
            function defineBooleanAttribute(key, handler) {
                var attr = $attrs.$normalize('md-' + key);
                if (handler) defineProperty(key, handler);
                if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
                $attrs.$observe(attr, updateValue);

                function updateValue(newValue) {
                    ctrl[key] = newValue !== 'false';
                }
            }

            /**
             * Remove any events defined by this controller
             */
            function cleanup() {
                destroyed = true;
                angular.element($window).off('resize', handleWindowResize);
            }

            // Change handlers

            /**
             * Toggles stretch tabs class and updates inkbar when tab stretching changes
             * @param stretchTabs
             */
            function handleStretchTabs(stretchTabs) {
                angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
                updateInkBarStyles();
            }

            function handleCenterTabs(newValue) {
                ctrl.shouldCenterTabs = shouldCenterTabs();
            }

            function handleMaxTabWidth(newWidth, oldWidth) {
                if (newWidth !== oldWidth) {
                    angular.forEach(elements.tabs, function (tab) {
                        tab.style.maxWidth = newWidth + 'px';
                    });
                    $mdUtil.nextTick(ctrl.updateInkBarStyles);
                }
            }

            function handleShouldPaginate(newValue, oldValue) {
                if (newValue !== oldValue) {
                    ctrl.maxTabWidth = getMaxTabWidth();
                    ctrl.shouldCenterTabs = shouldCenterTabs();
                    $mdUtil.nextTick(function () {
                        ctrl.maxTabWidth = getMaxTabWidth();
                        adjustOffset(ctrl.selectedIndex);
                    });
                }
            }

            /**
             * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
             * @param hasContent
             */
            function handleHasContent(hasContent) {
                $element[hasContent ? 'removeClass' : 'addClass']('md-no-tab-content');
            }

            /**
             * Apply ctrl.offsetLeft to the paging element when it changes
             * @param left
             */
            function handleOffsetChange(left) {
                var newValue = ctrl.shouldCenterTabs ? '' : '-' + left + 'px';
                angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
                $scope.$broadcast('$mdTabsPaginationChanged');
            }

            /**
             * Update the UI whenever `ctrl.focusIndex` is updated
             * @param newIndex
             * @param oldIndex
             */
            function handleFocusIndexChange(newIndex, oldIndex) {
                if (newIndex === oldIndex) return;
                if (!elements.tabs[newIndex]) return;
                adjustOffset();
                redirectFocus();
            }

            /**
             * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
             * @param newValue
             * @param oldValue
             */
            function handleSelectedIndexChange(newValue, oldValue) {
                if (newValue === oldValue) return;

                ctrl.selectedIndex = getNearestSafeIndex(newValue);
                ctrl.lastSelectedIndex = oldValue;
                ctrl.updateInkBarStyles();
                updateHeightFromContent();
                adjustOffset(newValue);
                $scope.$broadcast('$mdTabsChanged');
                ctrl.tabs[oldValue] && ctrl.tabs[oldValue].scope.deselect();
                ctrl.tabs[newValue] && ctrl.tabs[newValue].scope.select();
            }

            function getTabElementIndex(tabEl) {
                var tabs = $element[0].getElementsByTagName('md-tab');
                return Array.prototype.indexOf.call(tabs, tabEl[0]);
            }

            /**
             * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
             * hidden.
             */
            function handleResizeWhenVisible() {
                // if there is already a watcher waiting for resize, do nothing
                if (handleResizeWhenVisible.watcher) return;
                // otherwise, we will abuse the $watch function to check for visible
                handleResizeWhenVisible.watcher = $scope.$watch(function () {
                    // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
                    $mdUtil.nextTick(function () {
                        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
                        if (!handleResizeWhenVisible.watcher) return;

                        if ($element.prop('offsetParent')) {
                            handleResizeWhenVisible.watcher();
                            handleResizeWhenVisible.watcher = null;

                            handleWindowResize();
                        }
                    }, false);
                });
            }

            // Event handlers / actions

            /**
             * Handle user keyboard interactions
             * @param event
             */
            function keydown(event) {
                switch (event.keyCode) {
                    case $mdConstant.KEY_CODE.LEFT_ARROW:
                        event.preventDefault();
                        incrementIndex(-1, true);
                        break;
                    case $mdConstant.KEY_CODE.RIGHT_ARROW:
                        event.preventDefault();
                        incrementIndex(1, true);
                        break;
                    case $mdConstant.KEY_CODE.SPACE:
                    case $mdConstant.KEY_CODE.ENTER:
                        event.preventDefault();
                        if (!locked) ctrl.selectedIndex = ctrl.focusIndex;
                        break;
                }
                ctrl.lastClick = false;
            }

            /**
             * Update the selected index. Triggers a click event on the original `md-tab` element in order
             * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
             * @param index
             * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
             */
            function select(index, canSkipClick) {
                if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
                ctrl.lastClick = true;
                // skip the click event if noSelectClick is enabled
                if (canSkipClick && ctrl.noSelectClick) return;
                // nextTick is required to prevent errors in user-defined click events
                $mdUtil.nextTick(function () {
                    ctrl.tabs[index].element.triggerHandler('click');
                }, false);
            }

            /**
             * When pagination is on, this makes sure the selected index is in view.
             * @param event
             */
            function scroll(event) {
                if (!ctrl.shouldPaginate) return;
                event.preventDefault();
                ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
            }

            /**
             * Slides the tabs over approximately one page forward.
             */
            function nextPage() {
                var viewportWidth = elements.canvas.clientWidth,
                    totalWidth = viewportWidth + ctrl.offsetLeft,
                    i, tab;
                for (i = 0; i < elements.tabs.length; i++) {
                    tab = elements.tabs[i];
                    if (tab.offsetLeft + tab.offsetWidth > totalWidth) break;
                }
                ctrl.offsetLeft = fixOffset(tab.offsetLeft);
            }

            /**
             * Slides the tabs over approximately one page backward.
             */
            function previousPage() {
                var i, tab;
                for (i = 0; i < elements.tabs.length; i++) {
                    tab = elements.tabs[i];
                    if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) break;
                }
                ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.canvas.clientWidth);
            }

            /**
             * Update size calculations when the window is resized.
             */
            function handleWindowResize() {
                ctrl.lastSelectedIndex = ctrl.selectedIndex;
                ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
                $mdUtil.nextTick(function () {
                    ctrl.updateInkBarStyles();
                    updatePagination();
                });
            }

            function handleInkBar(hide) {
                angular.element(elements.inkBar).toggleClass('ng-hide', hide);
            }

            /**
             * Toggle dynamic height class when value changes
             * @param value
             */
            function handleDynamicHeight(value) {
                $element.toggleClass('md-dynamic-height', value);
            }

            /**
             * Remove a tab from the data and select the nearest valid tab.
             * @param tabData
             */
            function removeTab(tabData) {
                if (destroyed) return;
                var selectedIndex = ctrl.selectedIndex,
                    tab = ctrl.tabs.splice(tabData.getIndex(), 1)[0];
                refreshIndex();
                // when removing a tab, if the selected index did not change, we have to manually trigger the
                //   tab select/deselect events
                if (ctrl.selectedIndex === selectedIndex) {
                    tab.scope.deselect();
                    ctrl.tabs[ctrl.selectedIndex] && ctrl.tabs[ctrl.selectedIndex].scope.select();
                }
                $mdUtil.nextTick(function () {
                    updatePagination();
                    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
                });
            }

            /**
             * Create an entry in the tabs array for a new tab at the specified index.
             * @param tabData
             * @param index
             * @returns {*}
             */
            function insertTab(tabData, index) {
                var hasLoaded = loaded;
                var proto = {
                    getIndex: function () { return ctrl.tabs.indexOf(tab); },
                    isActive: function () { return this.getIndex() === ctrl.selectedIndex; },
                    isLeft: function () { return this.getIndex() < ctrl.selectedIndex; },
                    isRight: function () { return this.getIndex() > ctrl.selectedIndex; },
                    shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
                    hasFocus: function () {
                        return !ctrl.lastClick &&
                            ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
                    },
                    id: $mdUtil.nextUid()
                },
                    tab = angular.extend(proto, tabData);
                if (angular.isDefined(index)) {
                    ctrl.tabs.splice(index, 0, tab);
                } else {
                    ctrl.tabs.push(tab);
                }
                processQueue();
                updateHasContent();
                $mdUtil.nextTick(function () {
                    updatePagination();
                    // if autoselect is enabled, select the newly added tab
                    if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
                        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
                    });
                });
                return tab;
            }

            // Getter methods

            /**
             * Gathers references to all of the DOM elements used by this controller.
             * @returns {{}}
             */
            function getElements() {
                var elements = {};

                // gather tab bar elements
                elements.wrapper = $element[0].getElementsByTagName('md-tabs-wrapper')[0];
                elements.data = $element[0].getElementsByTagName('md-tab-data')[0];
                elements.canvas = elements.wrapper.getElementsByTagName('md-tabs-canvas')[0];
                elements.paging = elements.canvas.getElementsByTagName('md-pagination-wrapper')[0];
                elements.tabs = elements.paging.getElementsByTagName('md-tab-item');
                elements.dummies = elements.canvas.getElementsByTagName('md-dummy-tab');
                elements.inkBar = elements.paging.getElementsByTagName('md-ink-bar')[0];

                // gather tab content elements
                elements.contentsWrapper = $element[0].getElementsByTagName('md-tabs-content-wrapper')[0];
                elements.contents = elements.contentsWrapper.getElementsByTagName('md-tab-content');

                return elements;
            }

            /**
             * Determines whether or not the left pagination arrow should be enabled.
             * @returns {boolean}
             */
            function canPageBack() {
                return ctrl.offsetLeft > 0;
            }

            /**
             * Determines whether or not the right pagination arrow should be enabled.
             * @returns {*|boolean}
             */
            function canPageForward() {
                var lastTab = elements.tabs[elements.tabs.length - 1];
                return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
                    ctrl.offsetLeft;
            }

            /**
             * Determines if the UI should stretch the tabs to fill the available space.
             * @returns {*}
             */
            function shouldStretchTabs() {
                switch (ctrl.stretchTabs) {
                    case 'always':
                        return true;
                    case 'never':
                        return false;
                    default:
                        return !ctrl.shouldPaginate &&
                            $window.matchMedia('(max-width: 600px)').matches;
                }
            }

            /**
             * Determines if the tabs should appear centered.
             * @returns {string|boolean}
             */
            function shouldCenterTabs() {
                return ctrl.centerTabs && !ctrl.shouldPaginate;
            }

            /**
             * Determines if pagination is necessary to display the tabs within the available space.
             * @returns {boolean}
             */
            function shouldPaginate() {
                if (ctrl.noPagination || !loaded) return false;
                var canvasWidth = $element.prop('clientWidth');
                angular.forEach(getElements().dummies, function (tab) { canvasWidth -= tab.offsetWidth; });
                return canvasWidth < 0;
            }

            /**
             * Finds the nearest tab index that is available.  This is primarily used for when the active
             * tab is removed.
             * @param newIndex
             * @returns {*}
             */
            function getNearestSafeIndex(newIndex) {
                if (newIndex === -1) return -1;
                var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
                    i, tab;
                for (i = 0; i <= maxOffset; i++) {
                    tab = ctrl.tabs[newIndex + i];
                    if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
                    tab = ctrl.tabs[newIndex - i];
                    if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
                }
                return newIndex;
            }

            // Utility methods

            /**
             * Defines a property using a getter and setter in order to trigger a change handler without
             * using `$watch` to observe changes.
             * @param key
             * @param handler
             * @param value
             */
            function defineProperty(key, handler, value) {
                Object.defineProperty(ctrl, key, {
                    get: function () { return value; },
                    set: function (newValue) {
                        var oldValue = value;
                        value = newValue;
                        handler && handler(newValue, oldValue);
                    }
                });
            }

            /**
             * Updates whether or not pagination should be displayed.
             */
            function updatePagination() {
                updatePagingWidth();
                ctrl.maxTabWidth = getMaxTabWidth();
                ctrl.shouldPaginate = shouldPaginate();
            }

            /**
             * Sets or clears fixed width for md-pagination-wrapper depending on if tabs should stretch.
             */
            function updatePagingWidth() {
                if (shouldStretchTabs()) {
                    angular.element(elements.paging).css('width', '');
                } else {
                    angular.element(elements.paging).css('width', calcPagingWidth() + 'px');
                }
            }

            /**
             * @returns {number}
             */
            function calcPagingWidth() {
                var width = 1;

                angular.forEach(getElements().dummies, function (element) {
                    //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
                    //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
                    //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
                    //   of a dialog)
                    width += Math.max(element.offsetWidth, element.getBoundingClientRect().width);
                });

                return Math.ceil(width);
            }

            function getMaxTabWidth() {
                return $element.prop('clientWidth');
            }

            /**
             * Re-orders the tabs and updates the selected and focus indexes to their new positions.
             * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
             */
            function updateTabOrder() {
                var selectedItem = ctrl.tabs[ctrl.selectedIndex],
                    focusItem = ctrl.tabs[ctrl.focusIndex];
                ctrl.tabs = ctrl.tabs.sort(function (a, b) {
                    return a.index - b.index;
                });
                ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
                ctrl.focusIndex = ctrl.tabs.indexOf(focusItem);
            }

            /**
             * This moves the selected or focus index left or right.  This is used by the keydown handler.
             * @param inc
             */
            function incrementIndex(inc, focus) {
                var newIndex,
                    key = focus ? 'focusIndex' : 'selectedIndex',
                    index = ctrl[key];
                for (newIndex = index + inc; ctrl.tabs[newIndex] && ctrl.tabs[newIndex].scope.disabled; newIndex += inc) { }
                if (ctrl.tabs[newIndex]) {
                    ctrl[key] = newIndex;
                }
            }

            /**
             * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
             * issues when attempting to focus an item that is out of view.
             */
            function redirectFocus() {
                getElements().dummies[ctrl.focusIndex].focus();
            }

            /**
             * Forces the pagination to move the focused tab into view.
             */
            function adjustOffset(index) {
                if (index == null) index = ctrl.focusIndex;
                if (!elements.tabs[index]) return;
                if (ctrl.shouldCenterTabs) return;
                var tab = elements.tabs[index],
                    left = tab.offsetLeft,
                    right = tab.offsetWidth + left;
                ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
                ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
            }

            /**
             * Iterates through all queued functions and clears the queue.  This is used for functions that
             * are called before the UI is ready, such as size calculations.
             */
            function processQueue() {
                queue.forEach(function (func) { $mdUtil.nextTick(func); });
                queue = [];
            }

            /**
             * Determines if the tab content area is needed.
             */
            function updateHasContent() {
                var hasContent = false;
                angular.forEach(ctrl.tabs, function (tab) {
                    if (tab.template) hasContent = true;
                });
                ctrl.hasContent = hasContent;
            }

            /**
             * Moves the indexes to their nearest valid values.
             */
            function refreshIndex() {
                ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
                ctrl.focusIndex = getNearestSafeIndex(ctrl.focusIndex);
            }

            /**
             * Calculates the content height of the current tab.
             * @returns {*}
             */
            function updateHeightFromContent() {
                if (!ctrl.dynamicHeight) return $element.css('height', '');
                if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);

                var tabContent = elements.contents[ctrl.selectedIndex],
                    contentHeight = tabContent ? tabContent.offsetHeight : 0,
                    tabsHeight = elements.wrapper.offsetHeight,
                    newHeight = contentHeight + tabsHeight,
                    currentHeight = $element.prop('clientHeight');

                if (currentHeight === newHeight) return;

                // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
                // positioning.  This should probably be cleaned up if a cleaner solution is possible.
                if ($element.attr('md-align-tabs') === 'bottom') {
                    currentHeight -= tabsHeight;
                    newHeight -= tabsHeight;
                    // Need to include bottom border in these calculations
                    if ($element.attr('md-border-bottom') !== undefined)++currentHeight;
                }

                // Lock during animation so the user can't change tabs
                locked = true;

                var fromHeight = { height: currentHeight + 'px' },
                    toHeight = { height: newHeight + 'px' };

                // Set the height to the current, specific pixel height to fix a bug on iOS where the height
                // first animates to 0, then back to the proper height causing a visual glitch
                $element.css(fromHeight);

                // Animate the height from the old to the new
                $animateCss($element, {
                    from: fromHeight,
                    to: toHeight,
                    easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
                    duration: 0.5
                }).start().done(function () {
                    // Then (to fix the same iOS issue as above), disable transitions and remove the specific
                    // pixel height so the height can size with browser width/content changes, etc.
                    $element.css({
                        transition: 'none',
                        height: ''
                    });

                    // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
                    // enough to batch it for us instead of doing it immediately, which undoes the original
                    // transition: none)
                    $mdUtil.nextTick(function () {
                        $element.css('transition', '');
                    });

                    // And unlock so tab changes can occur
                    locked = false;
                });
            }

            /**
             * Repositions the ink bar to the selected tab.
             * @returns {*}
             */
            function updateInkBarStyles() {
                if (!elements.tabs[ctrl.selectedIndex]) {
                    angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
                    return;
                }
                if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
                // if the element is not visible, we will not be able to calculate sizes until it is
                // we should treat that as a resize event rather than just updating the ink bar
                if (!$element.prop('offsetParent')) return handleResizeWhenVisible();
                var index = ctrl.selectedIndex,
                    totalWidth = elements.paging.offsetWidth,
                    tab = elements.tabs[index],
                    left = tab.offsetLeft,
                    right = totalWidth - left - tab.offsetWidth,
                    tabWidth;
                if (ctrl.shouldCenterTabs) {
                    tabWidth = Array.prototype.slice.call(elements.tabs).reduce(function (value, element) {
                        return value + element.offsetWidth;
                    }, 0);
                    if (totalWidth > tabWidth) $mdUtil.nextTick(updateInkBarStyles, false);
                }
                updateInkBarClassName();
                angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
            }

            /**
             * Adds left/right classes so that the ink bar will animate properly.
             */
            function updateInkBarClassName() {
                var newIndex = ctrl.selectedIndex,
                    oldIndex = ctrl.lastSelectedIndex,
                    ink = angular.element(elements.inkBar);
                if (!angular.isNumber(oldIndex)) return;
                ink
                    .toggleClass('md-left', newIndex < oldIndex)
                    .toggleClass('md-right', newIndex > oldIndex);
            }

            /**
             * Takes an offset value and makes sure that it is within the min/max allowed values.
             * @param value
             * @returns {*}
             */
            function fixOffset(value) {
                if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
                var lastTab = elements.tabs[elements.tabs.length - 1],
                    totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
                value = Math.max(0, value);
                value = Math.min(totalWidth - elements.canvas.clientWidth, value);
                return value;
            }

            /**
             * Attaches a ripple to the tab item element.
             * @param scope
             * @param element
             */
            function attachRipple(scope, element) {
                var options = { colorElement: angular.element(elements.inkBar) };
                $mdTabInkRipple.attach(scope, element, options);
            }
        }
        MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming"];

    })();
    (function () {
        "use strict";

        angular.module('material.components.tabs')
            .directive('mdTabScroll', MdTabScroll);

        function MdTabScroll($parse) {
            return {
                restrict: 'A',
                compile: function ($element, attr) {
                    var fn = $parse(attr.mdTabScroll, null, true);
                    return function ngEventHandler(scope, element) {
                        element.on('mousewheel', function (event) {
                            scope.$apply(function () { fn(scope, { $event: event }); });
                        });
                    };
                }
            }
        }
        MdTabScroll.$inject = ["$parse"];

    })();
    (function () {
        "use strict";

        /**
         * @ngdoc directive
         * @name mdTabs
         * @module material.components.tabs
         *
         * @restrict E
         *
         * @description
         * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to produces a Tabs components.
         * In turn, the nested `<md-tab>` directive is used to specify a tab label for the **header button** and a [optional] tab view
         * content that will be associated with each tab button.
         *
         * Below is the markup for its simplest usage:
         *
         *  <hljs lang="html">
         *  <md-tabs>
         *    <md-tab label="Tab #1"></md-tab>
         *    <md-tab label="Tab #2"></md-tab>
         *    <md-tab label="Tab #3"></md-tab>
         *  </md-tabs>
         *  </hljs>
         *
         * Tabs supports three (3) usage scenarios:
         *
         *  1. Tabs (buttons only)
         *  2. Tabs with internal view content
         *  3. Tabs with external view content
         *
         * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views.
         * **Tabs with internal views** are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component.
         * **Tabs with external view content** is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.
         *
         * Additional features also include:
         *
         * *  Content can include any markup.
         * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
         *
         * ### Explanation of tab stretching
         *
         * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
         *
         * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
         *
         * On desktops, by default, stretching will never occur.
         *
         * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
         *
         * `md-stretch-tabs` | mobile    | desktop
         * ------------------|-----------|--------
         * `auto`            | stretched | ---
         * `always`          | stretched | stretched
         * `never`           | ---       | ---
         *
         * @param {integer=} md-selected Index of the active/selected tab
         * @param {boolean=} md-no-ink If present, disables ink ripple effects.
         * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
         * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
         * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
         * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
         * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
         * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
         * @param {boolean=} md-no-pagination When enabled, pagination will remain off
         * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
         * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
         * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
         * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
         *
         * @usage
         * <hljs lang="html">
         * <md-tabs md-selected="selectedIndex" >
         *   <img ng-src="img/angular.png" class="centered">
         *   <md-tab
         *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
         *       md-on-select="onTabSelected(tab)"
         *       md-on-deselect="announceDeselected(tab)"
         *       ng-disabled="tab.disabled">
         *     <md-tab-label>
         *       {{tab.title}}
         *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
         *     </md-tab-label>
         *     <md-tab-body>
         *       {{tab.content}}
         *     </md-tab-body>
         *   </md-tab>
         * </md-tabs>
         * </hljs>
         *
         */
        angular
            .module('material.components.tabs')
            .directive('mdTabs', MdTabs);

        function MdTabs() {
            return {
                scope: {
                    selectedIndex: '=?mdSelected'
                },
                template: function (element, attr) {
                    attr["$mdTabsTemplate"] = element.html();
                    return '' +
                        '<md-tabs-wrapper> ' +
                        '<md-tab-data></md-tab-data> ' +
                        '<md-prev-button ' +
                        'tabindex="-1" ' +
                        'role="button" ' +
                        'aria-label="Previous Page" ' +
                        'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
                        'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
                        'ng-if="$mdTabsCtrl.shouldPaginate" ' +
                        'ng-click="$mdTabsCtrl.previousPage()"> ' +
                        '<md-icon md-svg-icon="md-tabs-arrow"></md-icon> ' +
                        '</md-prev-button> ' +
                        '<md-next-button ' +
                        'tabindex="-1" ' +
                        'role="button" ' +
                        'aria-label="Next Page" ' +
                        'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
                        'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
                        'ng-if="$mdTabsCtrl.shouldPaginate" ' +
                        'ng-click="$mdTabsCtrl.nextPage()"> ' +
                        '<md-icon md-svg-icon="md-tabs-arrow"></md-icon> ' +
                        '</md-next-button> ' +
                        '<md-tabs-canvas ' +
                        'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
                        'aria-activedescendant="tab-item-{{$mdTabsCtrl.tabs[$mdTabsCtrl.focusIndex].id}}" ' +
                        'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
                        'ng-class="{ ' +
                        '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
                        '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
                        '}" ' +
                        'ng-keydown="$mdTabsCtrl.keydown($event)" ' +
                        'role="tablist"> ' +
                        '<md-pagination-wrapper ' +
                        'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
                        'md-tab-scroll="$mdTabsCtrl.scroll($event)"> ' +
                        '<md-tab-item ' +
                        'tabindex="-1" ' +
                        'class="md-tab" ' +
                        'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                        'role="tab" ' +
                        'aria-controls="tab-content-{{::tab.id}}" ' +
                        'aria-selected="{{tab.isActive()}}" ' +
                        'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                        'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
                        'ng-class="{ ' +
                        '\'md-active\':    tab.isActive(), ' +
                        '\'md-focused\':   tab.hasFocus(), ' +
                        '\'md-disabled\':  tab.scope.disabled ' +
                        '}" ' +
                        'ng-disabled="tab.scope.disabled" ' +
                        'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
                        'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
                        'md-tabs-template="::tab.label" ' +
                        'md-scope="::tab.parent"></md-tab-item> ' +
                        '<md-ink-bar></md-ink-bar> ' +
                        '</md-pagination-wrapper> ' +
                        '<div class="_md-visually-hidden md-dummy-wrapper"> ' +
                        '<md-dummy-tab ' +
                        'class="md-tab" ' +
                        'tabindex="-1" ' +
                        'id="tab-item-{{::tab.id}}" ' +
                        'role="tab" ' +
                        'aria-controls="tab-content-{{::tab.id}}" ' +
                        'aria-selected="{{tab.isActive()}}" ' +
                        'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                        'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
                        'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
                        'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                        'md-tabs-template="::tab.label" ' +
                        'md-scope="::tab.parent"></md-dummy-tab> ' +
                        '</div> ' +
                        '</md-tabs-canvas> ' +
                        '</md-tabs-wrapper> ' +
                        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0"> ' +
                        '<md-tab-content ' +
                        'id="tab-content-{{::tab.id}}" ' +
                        'role="tabpanel" ' +
                        'aria-labelledby="tab-item-{{::tab.id}}" ' +
                        'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
                        'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
                        'ng-if="$mdTabsCtrl.hasContent" ' +
                        'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
                        'ng-class="{ ' +
                        '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
                        '\'md-active\':        tab.isActive(), ' +
                        '\'md-left\':          tab.isLeft(), ' +
                        '\'md-right\':         tab.isRight(), ' +
                        '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
                        '}"> ' +
                        '<div ' +
                        'md-tabs-template="::tab.template" ' +
                        'md-connected-if="tab.isActive()" ' +
                        'md-scope="::tab.parent" ' +
                        'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
                        '</md-tab-content> ' +
                        '</md-tabs-content-wrapper>';
                },
                controller: 'MdTabsController',
                controllerAs: '$mdTabsCtrl',
                bindToController: true
            };
        }

    })();
    (function () {
        "use strict";

        angular
            .module('material.components.tabs')
            .directive('mdTabsTemplate', MdTabsTemplate);

        function MdTabsTemplate($compile, $mdUtil) {
            return {
                restrict: 'A',
                link: link,
                scope: {
                    template: '=mdTabsTemplate',
                    connected: '=?mdConnectedIf',
                    compileScope: '=mdScope'
                },
                require: '^?mdTabs'
            };

            function link(scope, element, attr, ctrl) {
                if (!ctrl) return;
                var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;
                element.html(scope.template);
                $compile(element.contents())(compileScope);
                //                 element.on('DOMSubtreeModified', function () {
                //                     ctrl.updatePagination();
                //                     ctrl.updateInkBarStyles();
                //                 });
                return $mdUtil.nextTick(handleScope);

                function handleScope() {
                    scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
                    scope.$on('$destroy', reconnect);
                }

                function disconnect() {
                    if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
                }

                function reconnect() {
                    if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
                }
            }
        }
        MdTabsTemplate.$inject = ["$compile", "$mdUtil"];

    })();
    (function () {
        angular.module("material.core").constant("$MD_THEME_CSS", "/*  Only used with Theme processes */html.md-THEME_NAME-theme, body.md-THEME_NAME-theme {  color: '{{foreground-1}}';  background-color: '{{background-color}}'; }md-autocomplete.md-THEME_NAME-theme {  background: '{{background-A100}}'; }  md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]) {    background: '{{background-100}}'; }  md-autocomplete.md-THEME_NAME-theme button md-icon path {    fill: '{{background-600}}'; }  md-autocomplete.md-THEME_NAME-theme button:after {    background: '{{background-600-0.3}}'; }.md-autocomplete-suggestions-container.md-THEME_NAME-theme {  background: '{{background-A100}}'; }  .md-autocomplete-suggestions-container.md-THEME_NAME-theme li {    color: '{{background-900}}'; }    .md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight {      color: '{{background-600}}'; }    .md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover, .md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected {      background: '{{background-200}}'; }md-backdrop {  background-color: '{{background-900-0.0}}'; }  md-backdrop.md-opaque.md-THEME_NAME-theme {    background-color: '{{background-900-1.0}}'; }md-bottom-sheet.md-THEME_NAME-theme {  background-color: '{{background-50}}';  border-top-color: '{{background-300}}'; }  md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item {    color: '{{foreground-1}}'; }  md-bottom-sheet.md-THEME_NAME-theme .md-subheader {    background-color: '{{background-50}}'; }  md-bottom-sheet.md-THEME_NAME-theme .md-subheader {    color: '{{foreground-1}}'; }.md-button.md-THEME_NAME-theme:not([disabled]):hover {  background-color: '{{background-500-0.2}}'; }.md-button.md-THEME_NAME-theme:not([disabled]).md-focused {  background-color: '{{background-500-0.2}}'; }.md-button.md-THEME_NAME-theme.md-fab {  background-color: '{{accent-color}}';  color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab md-icon {    color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover {    background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused {    background-color: '{{accent-A700}}'; }.md-button.md-THEME_NAME-theme.md-primary {  color: '{{primary-color}}'; }  .md-button.md-THEME_NAME-theme.md-primary.md-raised, .md-button.md-THEME_NAME-theme.md-primary.md-fab {    color: '{{primary-contrast}}';    background-color: '{{primary-color}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon {      color: '{{primary-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover {      background-color: '{{primary-600}}'; }    .md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused {      background-color: '{{primary-600}}'; }  .md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon {    color: '{{primary-color}}'; }.md-button.md-THEME_NAME-theme.md-fab {  background-color: '{{accent-color}}';  color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon {    color: '{{accent-contrast}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover {    background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused {    background-color: '{{accent-A700}}'; }.md-button.md-THEME_NAME-theme.md-raised {  color: '{{background-900}}';  background-color: '{{background-50}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon {    color: '{{background-900}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover {    background-color: '{{background-50}}'; }  .md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused {    background-color: '{{background-200}}'; }.md-button.md-THEME_NAME-theme.md-warn {  color: '{{warn-color}}'; }  .md-button.md-THEME_NAME-theme.md-warn.md-raised, .md-button.md-THEME_NAME-theme.md-warn.md-fab {    color: '{{warn-contrast}}';    background-color: '{{warn-color}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon {      color: '{{warn-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover {      background-color: '{{warn-600}}'; }    .md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused {      background-color: '{{warn-600}}'; }  .md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon {    color: '{{warn-color}}'; }.md-button.md-THEME_NAME-theme.md-accent {  color: '{{accent-color}}'; }  .md-button.md-THEME_NAME-theme.md-accent.md-raised, .md-button.md-THEME_NAME-theme.md-accent.md-fab {    color: '{{accent-contrast}}';    background-color: '{{accent-color}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon {      color: '{{accent-contrast}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover {      background-color: '{{accent-A700}}'; }    .md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused, .md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused {      background-color: '{{accent-A700}}'; }  .md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon {    color: '{{accent-color}}'; }.md-button.md-THEME_NAME-theme[disabled], .md-button.md-THEME_NAME-theme.md-raised[disabled], .md-button.md-THEME_NAME-theme.md-fab[disabled], .md-button.md-THEME_NAME-theme.md-accent[disabled], .md-button.md-THEME_NAME-theme.md-warn[disabled] {  color: '{{foreground-3}}';  cursor: default; }  .md-button.md-THEME_NAME-theme[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon, .md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon {    color: '{{foreground-3}}'; }.md-button.md-THEME_NAME-theme.md-raised[disabled], .md-button.md-THEME_NAME-theme.md-fab[disabled] {  background-color: '{{foreground-4}}'; }.md-button.md-THEME_NAME-theme[disabled] {  background-color: transparent; }a.md-THEME_NAME-theme:not(.md-button).md-primary {  color: '{{primary-color}}'; }  a.md-THEME_NAME-theme:not(.md-button).md-primary:hover {    color: '{{primary-700}}'; }a.md-THEME_NAME-theme:not(.md-button).md-accent {  color: '{{accent-color}}'; }  a.md-THEME_NAME-theme:not(.md-button).md-accent:hover {    color: '{{accent-700}}'; }a.md-THEME_NAME-theme:not(.md-button).md-accent {  color: '{{accent-color}}'; }  a.md-THEME_NAME-theme:not(.md-button).md-accent:hover {    color: '{{accent-A700}}'; }a.md-THEME_NAME-theme:not(.md-button).md-warn {  color: '{{warn-color}}'; }  a.md-THEME_NAME-theme:not(.md-button).md-warn:hover {    color: '{{warn-700}}'; }md-card.md-THEME_NAME-theme {  background-color: '{{background-hue-1}}';  border-radius: 2px; }  md-card.md-THEME_NAME-theme .md-card-image {    border-radius: 2px 2px 0 0; }  md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon {    color: '{{background-color}}';    background-color: '{{foreground-3}}'; }  md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead {    color: '{{foreground-2}}'; }  md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead {    color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme .md-ripple {  color: '{{accent-A700}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple {  color: '{{background-600}}'; }md-checkbox.md-THEME_NAME-theme.md-checked.md-focused ._md-container:before {  background-color: '{{accent-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme ._md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme.md-checked ._md-icon {  background-color: '{{accent-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme.md-checked ._md-icon:after {  border-color: '{{accent-contrast-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple {  color: '{{primary-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple {  color: '{{background-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple {  color: '{{primary-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary ._md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked ._md-icon {  background-color: '{{primary-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused ._md-container:before {  background-color: '{{primary-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked ._md-icon:after {  border-color: '{{primary-contrast-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] ._md-container {  color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple {  color: '{{warn-600}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple {  color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple {  color: '{{warn-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn ._md-icon {  border-color: '{{foreground-2}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked ._md-icon {  background-color: '{{warn-color-0.87}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) ._md-container:before {  background-color: '{{warn-color-0.26}}'; }md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked ._md-icon:after {  border-color: '{{background-200}}'; }md-checkbox.md-THEME_NAME-theme[disabled] ._md-icon {  border-color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme[disabled].md-checked ._md-icon {  background-color: '{{foreground-3}}'; }md-checkbox.md-THEME_NAME-theme[disabled].md-checked ._md-icon:after {  border-color: '{{background-200}}'; }md-checkbox.md-THEME_NAME-theme[disabled] ._md-label {  color: '{{foreground-3}}'; }md-chips.md-THEME_NAME-theme .md-chips {  box-shadow: 0 1px '{{foreground-4}}'; }  md-chips.md-THEME_NAME-theme .md-chips.md-focused {    box-shadow: 0 2px '{{primary-color}}'; }  md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input {    color: '{{foreground-1}}'; }    md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input::-webkit-input-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input:-moz-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input::-moz-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input:-ms-input-placeholder {      color: '{{foreground-3}}'; }    md-chips.md-THEME_NAME-theme .md-chips ._md-chip-input-container input::-webkit-input-placeholder {      color: '{{foreground-3}}'; }md-chips.md-THEME_NAME-theme md-chip {  background: '{{background-300}}';  color: '{{background-800}}'; }  md-chips.md-THEME_NAME-theme md-chip md-icon {    color: '{{background-700}}'; }  md-chips.md-THEME_NAME-theme md-chip.md-focused {    background: '{{primary-color}}';    color: '{{primary-contrast}}'; }    md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon {      color: '{{primary-contrast}}'; }  md-chips.md-THEME_NAME-theme md-chip._md-chip-editing {    background: transparent;    color: '{{background-800}}'; }md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path {  fill: '{{background-500}}'; }.md-contact-suggestion span.md-contact-email {  color: '{{background-400}}'; }md-content.md-THEME_NAME-theme {  color: '{{foreground-1}}';  background-color: '{{background-hue-1}}'; }/** Theme styles for mdCalendar. */.md-calendar.md-THEME_NAME-theme {  background: '{{background-A100}}';  color: '{{background-A200-0.87}}'; }  .md-calendar.md-THEME_NAME-theme tr:last-child td {    border-bottom-color: '{{background-200}}'; }.md-THEME_NAME-theme .md-calendar-day-header {  background: '{{background-300}}';  color: '{{background-A200-0.87}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator {  border: 1px solid '{{primary-500}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled {  color: '{{primary-500-0.6}}'; }.md-THEME_NAME-theme .md-calendar-date.md-focus .md-calendar-date-selection-indicator {  background: '{{background-hue-1}}'; }.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover {  background: '{{background-300}}'; }.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator {  background: '{{primary-500}}';  color: '{{primary-500-contrast}}';  border-color: transparent; }.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled {  color: '{{foreground-3}}'; }/** Theme styles for mdDatepicker. */.md-THEME_NAME-theme .md-datepicker-input {  color: '{{foreground-1}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder {    color: '{{foreground-3}}'; }  .md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }.md-THEME_NAME-theme .md-datepicker-input-container {  border-bottom-color: '{{background-300}}'; }  .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused {    border-bottom-color: '{{primary-500}}'; }  .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid {    border-bottom-color: '{{warn-A700}}'; }.md-THEME_NAME-theme .md-datepicker-calendar-pane {  border-color: '{{background-hue-1}}'; }.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle {  border-top-color: '{{foreground-3}}'; }.md-THEME_NAME-theme .md-datepicker-triangle-button:hover .md-datepicker-expand-triangle {  border-top-color: '{{foreground-2}}'; }.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon {  fill: '{{primary-500}}'; }.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container,.md-THEME_NAME-theme .md-datepicker-input-mask-opaque {  background: '{{background-hue-1}}'; }.md-THEME_NAME-theme .md-datepicker-calendar {  background: '{{background-A100}}'; }md-dialog.md-THEME_NAME-theme {  border-radius: 4px;  background-color: '{{background-hue-1}}'; }  md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions, md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions {    border-top-color: '{{foreground-4}}'; }md-divider.md-THEME_NAME-theme {  border-top-color: '{{foreground-4}}'; }.layout-row > md-divider.md-THEME_NAME-theme,.layout-xs-row > md-divider.md-THEME_NAME-theme, .layout-gt-xs-row > md-divider.md-THEME_NAME-theme,.layout-sm-row > md-divider.md-THEME_NAME-theme, .layout-gt-sm-row > md-divider.md-THEME_NAME-theme,.layout-md-row > md-divider.md-THEME_NAME-theme, .layout-gt-md-row > md-divider.md-THEME_NAME-theme,.layout-lg-row > md-divider.md-THEME_NAME-theme, .layout-gt-lg-row > md-divider.md-THEME_NAME-theme,.layout-xl-row > md-divider.md-THEME_NAME-theme {  border-right-color: '{{foreground-4}}'; }md-icon.md-THEME_NAME-theme {  color: '{{foreground-2}}'; }  md-icon.md-THEME_NAME-theme.md-primary {    color: '{{primary-color}}'; }  md-icon.md-THEME_NAME-theme.md-accent {    color: '{{accent-color}}'; }  md-icon.md-THEME_NAME-theme.md-warn {    color: '{{warn-color}}'; }md-input-container.md-THEME_NAME-theme .md-input {  color: '{{foreground-1}}';  border-color: '{{foreground-4}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder {    color: '{{foreground-3}}'; }  md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder {    color: '{{foreground-3}}'; }md-input-container.md-THEME_NAME-theme > md-icon {  color: '{{foreground-1}}'; }md-input-container.md-THEME_NAME-theme label,md-input-container.md-THEME_NAME-theme ._md-placeholder {  color: '{{foreground-3}}'; }md-input-container.md-THEME_NAME-theme label.md-required:after {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after {  color: '{{foreground-2}}'; }md-input-container.md-THEME_NAME-theme .md-input-messages-animation, md-input-container.md-THEME_NAME-theme .md-input-message-animation {  color: '{{warn-A700}}'; }  md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter, md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter {    color: '{{foreground-1}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label {  color: '{{foreground-2}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input {  border-color: '{{primary-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label {  color: '{{primary-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon {  color: '{{primary-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input {  border-color: '{{accent-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label {  color: '{{accent-color}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input {  border-color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input {  border-color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme.md-input-invalid label {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation, md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter {  color: '{{warn-A700}}'; }md-input-container.md-THEME_NAME-theme .md-input[disabled],md-input-container.md-THEME_NAME-theme .md-input [disabled] {  border-bottom-color: transparent;  color: '{{foreground-3}}';  background-image: linear-gradient(to right, \"{{foreground-3}}\" 0%, \"{{foreground-3}}\" 33%, transparent 0%);  background-image: -ms-linear-gradient(left, transparent 0%, \"{{foreground-3}}\" 100%); }md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3, md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4 {  color: '{{foreground-1}}'; }md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p {  color: '{{foreground-2}}'; }md-list.md-THEME_NAME-theme ._md-proxy-focus.md-focused div._md-no-style {  background-color: '{{background-100}}'; }md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon {  background-color: '{{foreground-3}}';  color: '{{background-color}}'; }md-list.md-THEME_NAME-theme md-list-item > md-icon {  color: '{{foreground-2}}'; }  md-list.md-THEME_NAME-theme md-list-item > md-icon.md-highlight {    color: '{{primary-color}}'; }    md-list.md-THEME_NAME-theme md-list-item > md-icon.md-highlight.md-accent {      color: '{{accent-color}}'; }md-menu-content.md-THEME_NAME-theme {  background-color: '{{background-A100}}'; }  md-menu-content.md-THEME_NAME-theme md-menu-item {    color: '{{background-A200-0.87}}'; }    md-menu-content.md-THEME_NAME-theme md-menu-item md-icon {      color: '{{background-A200-0.54}}'; }    md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] {      color: '{{background-A200-0.25}}'; }      md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon {        color: '{{background-A200-0.25}}'; }  md-menu-content.md-THEME_NAME-theme md-menu-divider {    background-color: '{{background-A200-0.11}}'; }md-menu-bar.md-THEME_NAME-theme > button.md-button {  color: '{{foreground-2}}';  border-radius: 2px; }md-menu-bar.md-THEME_NAME-theme md-menu._md-open > button, md-menu-bar.md-THEME_NAME-theme md-menu > button:focus {  outline: none;  background: '{{background-200}}'; }md-menu-bar.md-THEME_NAME-theme._md-open:not(._md-keyboard-mode) md-menu:hover > button {  background-color: '{{ background-500-0.2}}'; }md-menu-bar.md-THEME_NAME-theme:not(._md-keyboard-mode):not(._md-open) md-menu button:hover,md-menu-bar.md-THEME_NAME-theme:not(._md-keyboard-mode):not(._md-open) md-menu button:focus {  background: transparent; }md-menu-content.md-THEME_NAME-theme .md-menu > .md-button:after {  color: '{{background-A200-0.54}}'; }md-menu-content.md-THEME_NAME-theme .md-menu._md-open > .md-button {  background-color: '{{ background-500-0.2}}'; }md-toolbar.md-THEME_NAME-theme.md-menu-toolbar {  background-color: '{{background-A100}}';  color: '{{background-A200}}'; }  md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler {    background-color: '{{primary-color}}';    color: '{{background-A100-0.87}}'; }    md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon {      color: '{{background-A100-0.87}}'; }md-progress-circular.md-THEME_NAME-theme path {  stroke: '{{primary-color}}'; }md-progress-circular.md-THEME_NAME-theme.md-warn path {  stroke: '{{warn-color}}'; }md-progress-circular.md-THEME_NAME-theme.md-accent path {  stroke: '{{accent-color}}'; }md-progress-linear.md-THEME_NAME-theme ._md-container {  background-color: '{{primary-100}}'; }md-progress-linear.md-THEME_NAME-theme ._md-bar {  background-color: '{{primary-color}}'; }md-progress-linear.md-THEME_NAME-theme.md-warn ._md-container {  background-color: '{{warn-100}}'; }md-progress-linear.md-THEME_NAME-theme.md-warn ._md-bar {  background-color: '{{warn-color}}'; }md-progress-linear.md-THEME_NAME-theme.md-accent ._md-container {  background-color: '{{accent-A100}}'; }md-progress-linear.md-THEME_NAME-theme.md-accent ._md-bar {  background-color: '{{accent-color}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn ._md-bar1 {  background-color: '{{warn-100}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn ._md-dashed:before {  background: radial-gradient(\"{{warn-100}}\" 0%, \"{{warn-100}}\" 16%, transparent 42%); }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent ._md-bar1 {  background-color: '{{accent-A100}}'; }md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent ._md-dashed:before {  background: radial-gradient(\"{{accent-A100}}\" 0%, \"{{accent-A100}}\" 16%, transparent 42%); }md-radio-button.md-THEME_NAME-theme ._md-off {  border-color: '{{foreground-2}}'; }md-radio-button.md-THEME_NAME-theme ._md-on {  background-color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme.md-checked ._md-off {  border-color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color-0.87}}'; }md-radio-button.md-THEME_NAME-theme ._md-container .md-ripple {  color: '{{accent-A700}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary ._md-on, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary ._md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary ._md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary ._md-on {  background-color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked ._md-off {  border-color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple {  color: '{{primary-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary ._md-container .md-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary ._md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary ._md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary ._md-container .md-ripple {  color: '{{primary-600}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn ._md-on, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn ._md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn ._md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn ._md-on {  background-color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked ._md-off, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked ._md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked ._md-off {  border-color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple {  color: '{{warn-color-0.87}}'; }md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn ._md-container .md-ripple, md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn ._md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn ._md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn ._md-container .md-ripple {  color: '{{warn-600}}'; }md-radio-group.md-THEME_NAME-theme[disabled],md-radio-button.md-THEME_NAME-theme[disabled] {  color: '{{foreground-3}}'; }  md-radio-group.md-THEME_NAME-theme[disabled] ._md-container ._md-off,  md-radio-button.md-THEME_NAME-theme[disabled] ._md-container ._md-off {    border-color: '{{foreground-3}}'; }  md-radio-group.md-THEME_NAME-theme[disabled] ._md-container ._md-on,  md-radio-button.md-THEME_NAME-theme[disabled] ._md-container ._md-on {    border-color: '{{foreground-3}}'; }md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple {  color: '{{accent-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple, md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple {  color: '{{primary-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple {  color: '{{warn-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked ._md-container:before {  background-color: '{{accent-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked ._md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary ._md-container:before {  background-color: '{{primary-color-0.26}}'; }md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked ._md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn ._md-container:before {  background-color: '{{warn-color-0.26}}'; }md-select.md-THEME_NAME-theme[disabled] ._md-select-value {  border-bottom-color: transparent;  background-image: linear-gradient(to right, \"{{foreground-3}}\" 0%, \"{{foreground-3}}\" 33%, transparent 0%);  background-image: -ms-linear-gradient(left, transparent 0%, \"{{foreground-3}}\" 100%); }md-select.md-THEME_NAME-theme ._md-select-value {  border-bottom-color: '{{foreground-4}}'; }  md-select.md-THEME_NAME-theme ._md-select-value._md-select-placeholder {    color: '{{foreground-3}}'; }md-select.md-THEME_NAME-theme.ng-invalid.ng-dirty ._md-select-value {  color: '{{warn-A700}}' !important;  border-bottom-color: '{{warn-A700}}' !important; }md-select.md-THEME_NAME-theme:not([disabled]):focus ._md-select-value {  border-bottom-color: '{{primary-color}}';  color: '{{ foreground-1 }}'; }  md-select.md-THEME_NAME-theme:not([disabled]):focus ._md-select-value._md-select-placeholder {    color: '{{ foreground-1 }}'; }md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent ._md-select-value {  border-bottom-color: '{{accent-color}}'; }md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn ._md-select-value {  border-bottom-color: '{{warn-color}}'; }md-select.md-THEME_NAME-theme[disabled] ._md-select-value {  color: '{{foreground-3}}'; }  md-select.md-THEME_NAME-theme[disabled] ._md-select-value._md-select-placeholder {    color: '{{foreground-3}}'; }md-select-menu.md-THEME_NAME-theme md-content {  background: '{{background-A100}}'; }  md-select-menu.md-THEME_NAME-theme md-content md-optgroup {    color: '{{background-600-0.87}}'; }  md-select-menu.md-THEME_NAME-theme md-content md-option {    color: '{{background-900-0.87}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] ._md-text {      color: '{{background-400-0.87}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus, md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover {      background: '{{background-200}}'; }    md-select-menu.md-THEME_NAME-theme md-content md-option[selected] {      color: '{{primary-500}}'; }      md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus {        color: '{{primary-600}}'; }      md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent {        color: '{{accent-color}}'; }        md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus {          color: '{{accent-A700}}'; }._md-checkbox-enabled.md-THEME_NAME-theme .md-ripple {  color: '{{primary-600}}'; }._md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple {  color: '{{background-600}}'; }._md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple {  color: '{{foreground-2}}'; }._md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple {  color: '{{primary-color-0.87}}'; }._md-checkbox-enabled.md-THEME_NAME-theme ._md-icon {  border-color: '{{foreground-2}}'; }._md-checkbox-enabled.md-THEME_NAME-theme[selected] ._md-icon {  background-color: '{{primary-color-0.87}}'; }._md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused ._md-container:before {  background-color: '{{primary-color-0.26}}'; }._md-checkbox-enabled.md-THEME_NAME-theme[selected] ._md-icon:after {  border-color: '{{primary-contrast-0.87}}'; }._md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] ._md-container {  color: '{{foreground-3}}'; }._md-checkbox-enabled.md-THEME_NAME-theme md-option ._md-text {  color: '{{background-900-0.87}}'; }md-sidenav.md-THEME_NAME-theme, md-sidenav.md-THEME_NAME-theme md-content {  background-color: '{{background-hue-1}}'; }md-slider.md-THEME_NAME-theme ._md-track {  background-color: '{{foreground-3}}'; }md-slider.md-THEME_NAME-theme ._md-track-ticks {  color: '{{background-contrast}}'; }md-slider.md-THEME_NAME-theme ._md-focus-ring {  background-color: '{{accent-A200-0.2}}'; }md-slider.md-THEME_NAME-theme ._md-disabled-thumb {  border-color: '{{background-color}}';  background-color: '{{background-color}}'; }md-slider.md-THEME_NAME-theme._md-min ._md-thumb:after {  background-color: '{{background-color}}';  border-color: '{{foreground-3}}'; }md-slider.md-THEME_NAME-theme._md-min ._md-focus-ring {  background-color: '{{foreground-3-0.38}}'; }md-slider.md-THEME_NAME-theme._md-min[md-discrete] ._md-thumb:after {  background-color: '{{background-contrast}}';  border-color: transparent; }md-slider.md-THEME_NAME-theme._md-min[md-discrete] ._md-sign {  background-color: '{{background-400}}'; }  md-slider.md-THEME_NAME-theme._md-min[md-discrete] ._md-sign:after {    border-top-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme._md-min[md-discrete][md-vertical] ._md-sign:after {  border-top-color: transparent;  border-left-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme ._md-track._md-track-fill {  background-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme ._md-thumb:after {  border-color: '{{accent-color}}';  background-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme ._md-sign {  background-color: '{{accent-color}}'; }  md-slider.md-THEME_NAME-theme ._md-sign:after {    border-top-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme[md-vertical] ._md-sign:after {  border-top-color: transparent;  border-left-color: '{{accent-color}}'; }md-slider.md-THEME_NAME-theme ._md-thumb-text {  color: '{{accent-contrast}}'; }md-slider.md-THEME_NAME-theme.md-warn ._md-focus-ring {  background-color: '{{warn-200-0.38}}'; }md-slider.md-THEME_NAME-theme.md-warn ._md-track._md-track-fill {  background-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn ._md-thumb:after {  border-color: '{{warn-color}}';  background-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn ._md-sign {  background-color: '{{warn-color}}'; }  md-slider.md-THEME_NAME-theme.md-warn ._md-sign:after {    border-top-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn[md-vertical] ._md-sign:after {  border-top-color: transparent;  border-left-color: '{{warn-color}}'; }md-slider.md-THEME_NAME-theme.md-warn ._md-thumb-text {  color: '{{warn-contrast}}'; }md-slider.md-THEME_NAME-theme.md-primary ._md-focus-ring {  background-color: '{{primary-200-0.38}}'; }md-slider.md-THEME_NAME-theme.md-primary ._md-track._md-track-fill {  background-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary ._md-thumb:after {  border-color: '{{primary-color}}';  background-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary ._md-sign {  background-color: '{{primary-color}}'; }  md-slider.md-THEME_NAME-theme.md-primary ._md-sign:after {    border-top-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary[md-vertical] ._md-sign:after {  border-top-color: transparent;  border-left-color: '{{primary-color}}'; }md-slider.md-THEME_NAME-theme.md-primary ._md-thumb-text {  color: '{{primary-contrast}}'; }md-slider.md-THEME_NAME-theme[disabled] ._md-thumb:after {  border-color: transparent; }md-slider.md-THEME_NAME-theme[disabled]:not(._md-min) ._md-thumb:after, md-slider.md-THEME_NAME-theme[disabled][md-discrete] ._md-thumb:after {  background-color: '{{foreground-3}}';  border-color: transparent; }md-slider.md-THEME_NAME-theme[disabled][readonly] ._md-sign {  background-color: '{{background-400}}'; }  md-slider.md-THEME_NAME-theme[disabled][readonly] ._md-sign:after {    border-top-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] ._md-sign:after {  border-top-color: transparent;  border-left-color: '{{background-400}}'; }md-slider.md-THEME_NAME-theme[disabled][readonly] ._md-disabled-thumb {  border-color: transparent;  background-color: transparent; }md-slider-container[disabled] > *:first-child:not(md-slider),md-slider-container[disabled] > *:last-child:not(md-slider) {  color: '{{foreground-3}}'; }.md-subheader.md-THEME_NAME-theme {  color: '{{ foreground-2-0.23 }}';  background-color: '{{background-hue-2}}'; }  .md-subheader.md-THEME_NAME-theme.md-primary {    color: '{{primary-color}}'; }  .md-subheader.md-THEME_NAME-theme.md-accent {    color: '{{accent-color}}'; }  .md-subheader.md-THEME_NAME-theme.md-warn {    color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme .md-ink-ripple {  color: '{{background-500}}'; }md-switch.md-THEME_NAME-theme ._md-thumb {  background-color: '{{background-50}}'; }md-switch.md-THEME_NAME-theme ._md-bar {  background-color: '{{background-500}}'; }md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple {  color: '{{accent-color}}'; }md-switch.md-THEME_NAME-theme.md-inverted:not(.md-checked) ._md-thumb {  background-color: '{{accent-color}}'; }md-switch.md-THEME_NAME-theme.md-checked:not(.md-inverted) ._md-thumb {  background-color: '{{accent-color}}'; }md-switch.md-THEME_NAME-theme.md-inverted:not(.md-checked) ._md-bar {  background-color: '{{accent-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked:not(.md-inverted) ._md-bar {  background-color: '{{accent-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-inverted ._md-bar {  background-color: '{{background-500}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-focused ._md-thumb:before {  background-color: '{{accent-color-0.26}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple {  color: '{{primary-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary ._md-thumb {  background-color: '{{primary-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary ._md-bar {  background-color: '{{primary-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused ._md-thumb:before {  background-color: '{{primary-color-0.26}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple {  color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn ._md-thumb {  background-color: '{{warn-color}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn ._md-bar {  background-color: '{{warn-color-0.5}}'; }md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused ._md-thumb:before {  background-color: '{{warn-color-0.26}}'; }md-switch.md-THEME_NAME-theme[disabled] ._md-thumb {  background-color: '{{background-400}}'; }md-switch.md-THEME_NAME-theme[disabled] ._md-bar {  background-color: '{{foreground-4}}'; }md-tabs.md-THEME_NAME-theme md-tabs-wrapper {  background-color: transparent;  border-color: '{{foreground-4}}'; }md-tabs.md-THEME_NAME-theme .md-paginator md-icon {  color: '{{primary-color}}'; }md-tabs.md-THEME_NAME-theme md-ink-bar {  color: '{{accent-color}}';  background: '{{accent-color}}'; }md-tabs.md-THEME_NAME-theme .md-tab {  color: '{{foreground-2}}'; }  md-tabs.md-THEME_NAME-theme .md-tab[disabled], md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon {    color: '{{foreground-3}}'; }  md-tabs.md-THEME_NAME-theme .md-tab.md-active, md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon, md-tabs.md-THEME_NAME-theme .md-tab.md-focused, md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon {    color: '{{primary-color}}'; }  md-tabs.md-THEME_NAME-theme .md-tab.md-focused {    background: '{{primary-color-0.1}}'; }  md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container {    color: '{{accent-A100}}'; }md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper {  background-color: '{{accent-color}}'; }  md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{accent-A100}}'; }    md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{accent-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{accent-contrast-0.1}}'; }  md-tabs.md-THEME_NAME-theme.md-accent > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-ink-bar {    color: '{{primary-600-1}}';    background: '{{primary-600-1}}'; }md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper {  background-color: '{{primary-color}}'; }  md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{primary-100}}'; }    md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{primary-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-primary > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{primary-contrast-0.1}}'; }md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper {  background-color: '{{warn-color}}'; }  md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{warn-100}}'; }    md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{warn-contrast}}'; }    md-tabs.md-THEME_NAME-theme.md-warn > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{warn-contrast-0.1}}'; }md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{primary-color}}'; }  md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{primary-100}}'; }    md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{primary-contrast}}'; }    md-toolbar > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{primary-contrast-0.1}}'; }md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{accent-color}}'; }  md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{accent-A100}}'; }    md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{accent-contrast}}'; }    md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{accent-contrast-0.1}}'; }  md-toolbar.md-accent > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-ink-bar {    color: '{{primary-600-1}}';    background: '{{primary-600-1}}'; }md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper {  background-color: '{{warn-color}}'; }  md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]) {    color: '{{warn-100}}'; }    md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-active md-icon, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused, md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused md-icon {      color: '{{warn-contrast}}'; }    md-toolbar.md-warn > md-tabs.md-THEME_NAME-theme > md-tabs-wrapper > md-tabs-canvas > md-pagination-wrapper > md-tab-item:not([disabled]).md-focused {      background: '{{warn-contrast-0.1}}'; }md-toast.md-THEME_NAME-theme .md-toast-content {  background-color: #323232;  color: '{{background-50}}'; }  md-toast.md-THEME_NAME-theme .md-toast-content .md-button {    color: '{{background-50}}'; }    md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight {      color: '{{accent-color}}'; }      md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary {        color: '{{primary-color}}'; }      md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn {        color: '{{warn-color}}'; }md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) {  background-color: '{{primary-color}}';  color: '{{primary-contrast}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon {    color: '{{primary-contrast}}';    fill: '{{primary-contrast}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon {    color: '{{primary-contrast-0.26}}';    fill: '{{primary-contrast-0.26}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent {    background-color: '{{accent-color}}';    color: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple {      color: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon {      color: '{{accent-contrast}}';      fill: '{{accent-contrast}}'; }    md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon {      color: '{{accent-contrast-0.26}}';      fill: '{{accent-contrast-0.26}}'; }  md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn {    background-color: '{{warn-color}}';    color: '{{warn-contrast}}'; }md-tooltip.md-THEME_NAME-theme {  color: '{{background-A100}}'; }  md-tooltip.md-THEME_NAME-theme ._md-content {    background-color: '{{foreground-2}}'; }");
    })();


})(window, window.angular);;
window.ngMaterial = { version: { full: "1.0.7" } };
angular.module('digestHud', [])

.provider('digestHud', ['$provide', function($provide) {
  'use strict';

  function WatchTiming(key) {
    this.key = key;
    this.reset();
  }

  WatchTiming.prototype.reset = function() {
    this.watch = 0;
    this.handle = 0;
    this.overhead = 0;
    this.total = 0;
    this.cycleTotal = 0;
    this.cycleStart = null;
    this.subTotal = 0;
  };

  WatchTiming.prototype.startCycle = function(start) {
    timingStack.push(this);
    this.cycleStart = start;
    this.cycleTotal = 0;
    this.subTotal = 0;
  };

  WatchTiming.prototype.countTime = function(counter, duration) {
    this[counter] += duration - this.subTotal;
    this.cycleTotal += duration;
    this.subTotal = 0;
  };

  WatchTiming.prototype.endCycle = function() {
    if (!this.cycleStart) return;
    var duration = Date.now() - this.cycleStart;
    this.overhead += duration - this.cycleTotal;
    this.cycleStart = null;
    timingStack.pop();
    if (timingStack.length) {
      timingStack[timingStack.length - 1].subTotal += duration;
    } else {
      overheadTiming.overhead -= duration;
    }
  };

  WatchTiming.prototype.sum = function() {
    this.total = this.watch + this.handle + this.overhead;
  };

  WatchTiming.prototype.format = function(grandTotal) {
    return percentage(this.total / grandTotal) + '\u2003(' +
      percentage(this.watch / grandTotal) + ' + ' +
      percentage(this.handle / grandTotal) + ' + ' +
      percentage(this.overhead / grandTotal) +
      ')\u2003' + this.key;
  };

  function flushTimingCycle() {
    if (timingStack.length) timingStack[timingStack.length - 1].endCycle();
  }

  var digestTimings = [];
  var watchTimings = {};
  var timingStack;
  var overheadTiming = createTiming('$$ng-overhead');
  var digestHud = this;
  var inDigest = false;
  var hudElement;
  var defaultHudPosition = 'bottom right';
  var customHudPosition;
  var $parse;

  this.numTopWatches = 20;
  this.numDigestStats = 25;

  this.enable = function() {
    var toggle = false;
    var detailsText = '';

    hudElement = angular.element('<div></div>');
    var buttonsElement = angular.element(
      '<div>' +
      '<span id="digestHud-refresh">refresh</span> &bull; ' +
      '<span id="digestHud-reset">reset</span> ' +
      '</div>');
    hudElement.append(buttonsElement);
    var summaryElement = angular.element('<div></div>');
    hudElement.append(summaryElement);
    var detailsElement = angular.element('<div></div>');
    hudElement.append(detailsElement);
    var showDetails = false;
    hudElement.on('click', function() {
      showDetails = !showDetails;
      buttonsElement[0].style.display = showDetails ? '' : 'none';
      detailsElement[0].style.display = showDetails ? '' : 'none';
      if (showDetails) refreshDetails();
    });

    hudElement.on('copy', function(ev) {
      ev.originalEvent.clipboardData.setData('text/plain', detailsText);
      ev.preventDefault();
    });

    buttonsElement.find('#digestHud-refresh').on('click', refreshDetails);
    buttonsElement.find('#digestHud-reset').on('click', resetTimings);
    buttonsElement.on('click', function(ev) {ev.stopPropagation();});

    hudElement.on('mousedown mouseup click', function(ev) {ev.stopPropagation();});
    hudElement.css({
      position: 'fixed',
      backgroundColor: 'rgba(0, 0, 0, 0.65)',
      color: 'white',
      padding: '2px 5px',
      fontSize: 'small',
      cursor: 'default',
      zIndex: '1000000'
    });

    this.setHudPosition(customHudPosition || defaultHudPosition);

    buttonsElement.css({
      float: 'right',
      display: 'none'
    });
    buttonsElement.children().css({
      cursor: 'pointer'
    });
    detailsElement.css({
      whiteSpace: 'pre',
      minWidth: '30em',
      maxWidth: '50em',
      display: 'none'
    });
    angular.element(document.body).append(hudElement);

    function refreshDetails() {
      var grandTotal = 0, topTotal = 0;

      var topWatchTimings = Object.keys(watchTimings).map(function(k){
        return watchTimings[k];
      }).map(function(timing) {
        timing.sum(); grandTotal += timing.total;
        return timing;
      }).sort(function(a, b) {
        var x = a.total; var y = b.total;
         return ((x < y) ? 1 : ((x > y) ? -1 : 0));
      }).slice(0, digestHud.numTopWatches);

      var lines = topWatchTimings.map(function(timing) {
        topTotal += timing.total;
        return timing.format(grandTotal);
      });
      var rows = lines.map(function(text) {
        var row = angular.element('<div></div>');
        row.css({
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        });
        row.text(text.replace(/[ \n]+/g, ' '));
        row.attr('title', text.slice(29));
        return row;
      });
      detailsElement.empty();
      var headerElement = angular.element('<div>\u2007Total\u2007\u2007\u2007Watch\u2007Work\u2007Overhead\u2007\u2007Function</div>')
        .css({borderBottom: '1px solid'});
      detailsElement.append(headerElement);
      rows.forEach(function(row) {
        detailsElement.append(row);
      });
      var footer = 'Top ' + topWatchTimings.length + ' items account for ' +
        percentage(topTotal / grandTotal) + ' of ' + grandTotal + 'ms of digest processing time.';
      var footerElement = angular.element('<div></div>').text(footer);
      detailsElement.append(footerElement);
      detailsText = 'Total  Watch   Work Overhead  Function\n' + lines.map(function(text) {
        return text.replace(/[ \n]+/g, ' ');
      }).join('\n') + '\n' + footer + '\n';
    }

    function resetTimings() {
      digestTimings = [];

      Object.keys(watchTimings).map(function(k){
        return watchTimings[k];
      }).forEach(function(watchTiming) {
        watchTiming.reset();
      });
    }

    $provide.decorator('$rootScope', ['$delegate', function($delegate) {
      var proto = Object.getPrototypeOf($delegate);
      var originalDigest = proto.$digest;
      var originalEvalAsync = proto.$evalAsync;
      var originalApplyAsync = proto.$applyAsync;
      var originalPostDigest = proto.$$postDigest;
      var originalWatch = proto.$watch;
      var originalWatchGroup = proto.$watchGroup;
      // $watchCollection delegates to $watch, no extra processing necessary
      proto.$digest = instrumentedDigest;
      proto.$evalAsync = instrumentedEvalAsync;
      proto.$applyAsync = instrumentedApplyAsync;
      proto.$$postDigest = instrumentedPostDigest;
      proto.$watch = instrumentedWatch;
      proto.$watchGroup = instrumentedWatchGroup;

      var watchTiming;

      function instrumentedDigest() {
        // jshint validthis:true
        timingStack = [];
        this.$$postDigest(flushTimingCycle);
        var start = Date.now();
        inDigest = true;
        try {
          originalDigest.call(this);
        } finally {
          inDigest = false;
        }
        var duration = Date.now() - start;
        overheadTiming.overhead += duration;
        toggle = !toggle;
        digestTimings.push(duration);
        if (digestTimings.length > digestHud.numDigestStats) digestTimings.shift();
        var len = digestTimings.length;
        var sorted = digestTimings.slice().sort(function(a, b) {return a - b;});
        var median = len % 2 ?
          sorted[(len - 1) / 2] : Math.round((sorted[len / 2] + sorted[len / 2 - 1]) / 2);
        var description =
          'digest ' + sorted[0] + 'ms ' + median + 'ms ' + sorted[len - 1] + 'ms ' +
          (toggle ? '\u25cf' : '\u25cb');
        summaryElement.text(description);
      }

      function instrumentedEvalAsync(expression, locals) {
        // jshint validthis:true
        var timing = createTiming('$evalAsync(' + formatExpression(expression) + ')');
        originalEvalAsync.call(
          this, wrapExpression(expression, timing, 'handle', true, true), locals);
      }

      function instrumentedApplyAsync(expression) {
        // jshint validthis:true
        var timing = createTiming('$applyAsync(' + formatExpression(expression) + ')');
        originalApplyAsync.call(this, wrapExpression(expression, timing, 'handle', false, true));
      }

      function instrumentedPostDigest(fn) {
        // jshint validthis:true
        if (timingStack.length) {
          fn = wrapExpression(fn, timingStack[timingStack.length - 1], 'overhead', true, true);
        }
        originalPostDigest.call(this, fn);
      }

      function instrumentedWatch(watchExpression, listener, objectEquality) {
        // jshint validthis:true
        var watchTimingSet = false;
        if (!watchTiming) {
          // Capture watch timing (and its key) once, before we descend in $$watchDelegates.
          watchTiming = createTiming(formatExpression(watchExpression));
          watchTimingSet = true;
        }
        try {
          if (angular.isString(watchExpression)) {
            if (!$parse) {
              angular.injector(['ng']).invoke(['$parse', function(parse) {$parse = parse;}]);
            }
            watchExpression = $parse(watchExpression);
          }
          if (watchExpression && watchExpression.$$watchDelegate) {
            return originalWatch.call(this, watchExpression, listener, objectEquality);
          } else {
            return originalWatch.call(
              this, wrapExpression(watchExpression, watchTiming, 'watch', true, false),
              wrapListener(listener, watchTiming), objectEquality);
          }
        } finally {
          if (watchTimingSet) watchTiming = null;
        }
      }

      function instrumentedWatchGroup(watchExpressions, listener) {
        // jshint validthis:true
        var watchTimingSet = false;
        if (!watchTiming) {
          // $watchGroup delegates to $watch for each expression, so just make sure to set the group's
          // aggregate key as the override first.
          watchTiming = createTiming(
            '[' + watchExpressions.map(formatExpression).join(', ') + ']');
          watchTimingSet = true;
        }
        try {
          return originalWatchGroup.call(this, watchExpressions, listener);
        } finally {
          if (watchTimingSet) watchTiming = null;
        }
      }

      return $delegate;
    }]);

    $provide.decorator('$parse', ['$delegate', function($delegate) {
      return function(expression) {
        var result = $delegate.apply(this, arguments);
        if (angular.isString(expression)) result.exp = expression;
        return result;
      };
    }]);

    $provide.decorator('$q', ['$delegate', function($delegate) {
      var proto = Object.getPrototypeOf($delegate.defer().promise);
      var originalThen = proto.then;
      var originalFinally = proto.finally;
      proto.then = instrumentedThen;
      proto.finally = instrumentedFinally;

      function instrumentedThen(onFulfilled, onRejected, progressBack) {
        // jshint validthis:true
        return originalThen.call(
          this,
          wrapExpression(
            onFulfilled, createTiming('$q(' + formatExpression(onFulfilled) + ')'), 'handle',
            false, true),
          wrapExpression(
            onRejected, createTiming('$q(' + formatExpression(onRejected) + ')'), 'handle',
            false, true),
          wrapExpression(
            progressBack, createTiming('$q(' + formatExpression(progressBack) + ')'), 'handle',
            false, true)
        );
      }

      function instrumentedFinally(callback, progressBack) {
        // jshint validthis:true
        return originalFinally.call(
          this,
          wrapExpression(
            callback, createTiming('$q(' + formatExpression(callback) + ')'), 'handle',
            false, true),
          wrapExpression(
            progressBack, createTiming('$q(' + formatExpression(callback) + ')'), 'handle',
            false, true)
        );
      }

      return $delegate;
    }]);

    var originalBind = angular.bind;
    angular.bind = function(self, fn, args) {
      var result = originalBind.apply(this, arguments);
      try {
        result.exp = formatExpression(fn);
      } catch (e) {
        console.log('error binding to', fn)
      }
      return result;
    };
  };

  this.setHudPosition = function(position) {
    if (hudElement) {
      // reset all to defaults
      var styles = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
      };
      position = position ? '' + position : defaultHudPosition;
      position.split(' ').map(function(prop) { styles[prop] = 0; });
      hudElement.css(styles);
    } else {
      // save and apply on enabled
      customHudPosition = position;
    }
  };

  function percentage(value) {
    if (value >= 1) return (value * 100).toFixed(1) + '%';
    return ('\u2007\u2007' + (value * 100).toFixed(1) + '%').slice(-5);
  }

  function formatExpression(watchExpression) {
    if (!watchExpression) return '';
    if (angular.isString(watchExpression)) return watchExpression;
    if (angular.isString(watchExpression.exp)) return watchExpression.exp;
    if (watchExpression.name) return 'function ' + watchExpression.name + '() {\u2026}';
    return watchExpression.toString();
  }

  function wrapExpression(expression, timing, counter, flushCycle, endCycle) {
    if (!expression && !flushCycle) return expression;
    if (!$parse) angular.injector(['ng']).invoke(['$parse', function(parse) {$parse = parse;}]);
    var actualExpression = angular.isString(expression) ? $parse(expression) : expression;
    return function instrumentedExpression() {
      if (flushCycle) flushTimingCycle();
      if (!actualExpression) return;
      if (!inDigest) return actualExpression.apply(this, arguments);
      var start = Date.now();
      timing.startCycle(start);
      try {
        return actualExpression.apply(this, arguments);
      } finally {
        timing.countTime(counter, Date.now() - start);
        if (endCycle) timing.endCycle();
      }
    };
  }

  function wrapListener(listener, timing) {
    if (!listener) return listener;
    return function instrumentedListener() {
      var start = Date.now();
      try {
        return listener.apply(this, arguments);
      } finally {
        timing.countTime('handle', Date.now() - start);
      }
    };
  }

  function createTiming(key) {
    var timing = watchTimings[key];
    if (!timing) timing = watchTimings[key] = new WatchTiming(key);
    return timing;
  }

  this.$get = function() {};
}]);


(function () {
	'use strict';

	_TemplateItemController.$inject = ["$scope", "toast", "$filter", "$state", "ItemViewer", "itemSettings", "auUtility"];
	angular
		.module('app')
		.controller('_TemplateItemController', _TemplateItemController);

	/* @ngInject */
	function _TemplateItemController($scope, toast, $filter, $state, ItemViewer, itemSettings, auUtility) {
		var vm = this;
		
		//turn this into an item viewer
		ItemViewer.create(vm, itemSettings, $scope)	
		
		//expose the item to the view
		vm.item = itemSettings.item;
	}
})();
(function() {
	'use strict';

	_TemplateWizardDialog.$inject = ["$timeout", "toast", "User"];
	angular
		.module('app')
		.controller('_TemplateWizardDialog', _TemplateWizardDialog);

	/* @ngInject */
	function _TemplateWizardDialog($timeout, toast, User) {
		var vm = this;

		vm.init = function () {
			toast.toast('Welcome to some wizard!')
		}

		//the toast is super annoying, but you get the idea		
		vm.stepChanged = function(currentStep, fromStep) { 
			toast.toast('Navigated from ' + fromStep + ' to ' + currentStep)
		}

		//potentially block a step by adding on-next-step to any au-wizard-step		
		vm.confirmNextStep = function() {
			var res = confirm('Allow user to proceed going forward?')
			if (!res) toast.error('User prevented from proceeding.')
			return res //return false to prevent the user from going to the next step
		}

		//return an object when the user gets to the review step		
		vm.review = function() {
			//must be {error: boolean, details: array}
			return {
				error: false,
				details: [
					{name: 'Ready', value: 'Am I ever?!?'},
					{name: 'Time', value: Date()},
				]
			}
		}

		//complete the user request to finish the dialog		
		vm.finish = function(){
			var promise = $q.defer()

			//simulate a delay
			setTimeout(function() {
				var res = confirm('Resolve the promise and mark the wizard as finished?')
				if (res) promise.resolve('The wizard has completed.')
				else promise.reject('User prevented from finishing.')
			}, 2000)

			return promise.promise
		}
	}
}
)();
(function () {
	'use strict'
	techSupportConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider"];
	angular
		.module('app')
		.config(techSupportConfig)

	/* @ngInject */
	function techSupportConfig($stateProvider, LandingRecentGroupingsProvider) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.techsupport',
			title: 'Tech Support Toolbox',
			subTitle: 'Choose a tech support tool.',
			cardClass: 'sub-menu-card',
			menuItems: [
				{
					title: 'View all organizations',
					subtitle: '',
					image: '',
					sref: 'shell.techsupport.viewallorganizations.list'
				},
				{
					title: 'Search Users',
					subtitle: '',
					image: '',
					sref: 'shell.techsupport.searchusers'
				}, {
					title: 'Run Script',
					subtitle: '',
					image: '',
					sref: 'shell.techsupport.run-migration-script'
				}, {
					title: 'Make Global Post',
					subtitle: '',
					image: '',
					sref: 'shell.techsupport.make-global-post'
				}
			]
		})
	}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "UserProvider", "TeamProvider", "LocationProvider", "DepartmentProvider", "PermissionPresetProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, UserProvider, TeamProvider, LocationProvider, DepartmentProvider, PermissionPresetProvider) {

		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.structure',
			title: 'Structure',
			sectionSettings: {
				title: "Structure",
				color: "rgba(0,167,157,1)",
			},
			
			sections: [
			{				
				title: 'Contacts',
				subTitle: 'Track and share items with everyone important to {{org}}.',

				menuItems: [
					{
						title: 'Add Contact',
						subtitle: 'Add a new contact.',
						image: '/assets/images/cards/slim/add-contact.png',
						action: function() {
							$mdDialog.show({
								controller: 'AddContactDialog',
								controllerAs: 'vm',
								templateUrl: '/app/structure/users-and-teams/dialogs/add-contact.tmpl.html'
							})
						},
						permissionNeeded: '$root.user.EffPerms.Contacts.CanCreate'
					},
					{
						title: 'List All Contacts',
						subtitle: 'View all contacts in the organization.',
						image: '/assets/images/cards/slim/list-contacts.png',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						action: LandingRecentGroupingsProvider.goToOptimalView('shell.structure.all-contacts.list')
					},
					{
						title: 'Send Message',
						subtitle: 'Message groups or individuals with the option to cc:email.',
						image: '/assets/images/cards/slim/compose-message.png',
						action: function() {
							$mdDialog.show({
								controller: 'NewPrivateMessageController',
								controllerAs: 'vm',
								templateUrl: '/app/social/dialogs/new-private-message.tmpl.html',
								locals: {
									options: {}
								}
							})
						}
					},
					{
						title: 'List By Group',
						subtitle: 'List all contacts in a group.',
						image: '/assets/images/cards/slim/team.jpg',
						permissionNeeded: '$root.user.EffPerms.Teams.CanView',
						sref: 'shell.structure.by-team'
					}
				]
			},
			{
				title: 'Users',
				subTitle: 'Explore {{org}}\'s members and their connections in different ways.',

				menuItems: [
					{
						title: 'Add User',
						subtitle: 'Add a new user.',
						image: '/assets/images/cards/slim/add-user.png',
						action: UserProvider.addItem,
						permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
					},
					{
						title: 'List All Users',
						subtitle: 'List all active users licensed.',
						image: '/assets/images/cards/slim/user.jpg',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						action: LandingRecentGroupingsProvider.goToOptimalView('shell.structure.all-users.list')
					},
					{
						title: 'By Reports-To',
						subtitle: 'Show the organizational reporting hierarchy.',
						image: '/assets/images/cards/slim/connection.jpg',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						sref: 'shell.structure.by-reports-to'
					},
					{
						title: 'List By Team',
						subtitle: 'List users in a team',
						image: '/assets/images/cards/slim/team.jpg',
						permissionNeeded: '$root.user.EffPerms.Teams.CanView',
						sref: 'shell.structure.by-team'
					}
				]
			},
			{
				title: 'Teams and Groups',
				subTitle: 'Explore the teams and groups in {{org}}.',

				menuItems: [
					{						
						title: 'Add Team / Group',
						subtitle: 'Add a new team or group.',
						image: '/assets/images/cards/slim/add-team.png',
						action: TeamProvider.addItem,
						permissionNeeded: '$root.user.EffPerms.Teams.CanCreate'
					},
					{
						title: 'List All Teams / Groups',
						subtitle: 'List all teams and groups.',
						image: '/assets/images/cards/slim/teams.jpg',
						permissionNeeded: '$root.user.EffPerms.Teams.CanView',
						action: LandingRecentGroupingsProvider.goToOptimalView('shell.structure.manage-teams.list')
					},
					{
						title: 'Members by Team / Group',
						subtitle: 'List all members in a team or group.',
						image: '/assets/images/cards/slim/connection.jpg',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						sref: 'shell.structure.by-team'						
					}
				]	
			},
			{
				title: 'Locations',
				subTitle: 'Manage {{org}}\'s buildings, offices, regions, etc.',

				menuItems: [
					{
						title: 'Add Location',
						subtitle: 'Add a new location',
						image: '/assets/images/cards/slim/add-location.png',
						action: LocationProvider.addItem,
						permissionNeeded: '$root.user.EffPerms.Locations.CanManage'
					},
					{
						title: 'List All Locations',
						subtitle: 'List all locations in this organization.',
						image: '/assets/images/cards/slim/location.jpg',
						permissionNeeded: '$root.user.EffPerms.Users.CanView', //'$root.user.managesLocations()',
						action: LandingRecentGroupingsProvider.goToOptimalView('shell.structure.all-locations.list')
					},
					{
						title: 'Users By Location',
						subtitle: 'View all users in a chosen location.',
						image: '/assets/images/cards/slim/users-by-location.png',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						sref: 'shell.structure.by-location'						
					}
				]
			},
			{
				title: 'Departments',
				subTitle: 'Manage {{org}}\'s functional groups.',

				menuItems: [
					{
						title: 'Add Department',
						subtitle: 'Add a new department.',
						image: '/assets/images/cards/slim/add-department.png',
						action: DepartmentProvider.addItem,
						permissionNeeded: '$root.user.EffPerms.Departments.CanManage'
					},
					{
						title: 'List All Departments',
						subtitle: 'View and edit all departments.',
						image: '/assets/images/cards/slim/department.jpg',
						permissionNeeded:  '$root.user.EffPerms.Users.CanView', //'$root.user.managesDepartments()',
						action: LandingRecentGroupingsProvider.goToOptimalView('shell.structure.all-departments.list')
					},
					{
						title: 'Users By Department',
						subtitle: 'View all users in a chosen department.',
						image: '/assets/images/cards/slim/user.jpg',
						permissionNeeded: '$root.user.EffPerms.Users.CanView',
						sref: 'shell.structure.by-department'						
					}
				]
			},
			{
				title: 'Organization',
				subTitle: 'Manage {{org}}\'s settings, user licenses, and permission presets.',
				XpermissionNeeded: '$root.user.EffPerms.Organization.CanManageLicenses || $root.user.EffPerms.Users.IsAdminFor.Org || $root.user.EffPerms.Organization.CanManage',

				menuItems: [
					{
						title: 'Add User Licenses',
						subtitle: 'User licenses for just $1/mo',
						image: '/assets/images/cards/slim/userlicense.png',
						action: function() {
							$mdDialog.show({
								controller: 'AddUserLicenseController',
								controllerAs: 'vm',
								templateUrl: '/app/structure/organization-settings/dialogs/add-user-license-dialog.tmpl.html'
							})
						},
						permissionNeeded: '$root.user.EffPerms.Organization.CanManageLicenses'
					},
					{
						title: 'Permission Presets',
						subtitle: 'View, edit, and add permission presets.',
						image: '/assets/images/cards/main/permissions.jpg',
						sref: 'shell.structure.permission-presets.list',
						permissionNeeded: '$root.user.IsUserAdmin'
					},
					{
						title: 'View Organization',
						subtitle: 'Timezone, colors, personalization, etc.',
						image: '/assets/images/cards/slim/organization.jpg',
						action: function () {
							$rootScope.Organization.open()
						},
						XpermissionNeeded: '$root.user.EffPerms.Organization.CanManage'
					}
				]
			}], //end of sections

			fabButtons: [
				{
					title: 'Add User',
					icon: 'zmdi zmdi-account-add',
					action: UserProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
				},
				{
					title: 'Add Contact',
					icon: 'zmdi zmdi-account-add',
					action: function(){
						$mdDialog.show({
							controller: 'AddContactDialog',
							controllerAs: 'vm',
							templateUrl: '/app/structure/users-and-teams/dialogs/add-contact.tmpl.html'
						})
					},
					permissionNeeded: '$root.user.EffPerms.Contacts.CanCreate'
				},
				{
					title: 'Add Team',
					icon: 'zmdi zmdi-accounts-add',
					action: TeamProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Teams.CanCreate'
				},
				{
					title: 'Add Location',
					icon: 'au au-add-location',
					action: LocationProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Locations.CanManage'
				},
				{
					title: 'Add Department',
					icon: 'au au-add-department',
					action: DepartmentProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Departments.CanManage'
				},
				{
					title: 'Add User Licenses',
					icon: 'au au-add-userlicense',
					action: function() {
						$mdDialog.show({
							controller: 'AddUserLicenseController',
							controllerAs: 'vm',
							templateUrl: '/app/structure/organization-settings/dialogs/add-user-license-dialog.tmpl.html'
						})
					},
					permissionNeeded: '$root.user.EffPerms.Organization.CanManageLicenses'
				},
				{
					title: 'Add Permission Preset',
					icon: 'zmdi zmdi-playlist-plus',
					action: PermissionPresetProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
				}
			],
			fabIcon: 'zmdi zmdi-plus'

		}) //end of createRoutes
	}


})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "SelectFilterProvider", "ListViewerProvider", "InitiativeProvider", "StrategyProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, SelectFilterProvider, ListViewerProvider, InitiativeProvider, StrategyProvider) {

		SelectFilterProvider.createRoutes($stateProvider, {
			name: 'shell.strategy',
			title: "Strategies",
			subTitle: "Multiple strategies may be in play at the same time. Select one below.",
			/* @ngInject */
			values: ["localCacheReady", "Strategy", "$filter", function (localCacheReady, Strategy, $filter) {
				return Strategy.getCache().$httpPromise.then(function(strategies) {
					return $filter('orderBy')(strategies, "Title").map(function (value) {
						return {title: value.Title, sref: '.initiatives.list', srefOpts: {query: value._id}, item: value}
					})
				})
			}],
			breadcrumbItemMap: function (value) {
				return { title: value.title, sref: 'shell.strategy.initiatives.list', srefOpts: value.srefOpts }
			},
			fabButtons: [
				{
					title: 'Add Strategy',
					icon: 'au au-target',
					action: function() {
						$mdDialog.show({
							controller: 'AddStrategyDialog',
							controllerAs: 'vm',
							templateUrl: '/app/strategy/dialogs/add-strategy.tmpl.html',
							targetEvent: null
						})
					},
					permissionNeeded: '$root.user.EffPerms.Strategy.CanCreate'
				},
				{
					title: 'Add Initiative',
					icon: 'au au-chess-piece',
					action: function() {
						$mdDialog.show({
							controller: 'AddInitiativeDialog',
							controllerAs: 'vm',
							templateUrl: '/app/strategy/dialogs/add-initiative.tmpl.html',
							targetEvent: null,
							options: {}
						})
					},
					permissionNeeded: '$root.user.EffPerms.Initiative.CanCreate'
				}

			],
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.strategy.initiatives',
			title: 'Initiatives For...',
			itemType: InitiativeProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Initiative", "$state", "$stateParams", function (localCacheReady, Initiative, $state, $stateParams) {
				return Initiative.getCache({StrategyId: $stateParams.query})
			}],
			initialSortBy: 'Title',
			initialView: 'list',
			/* @ngInject */
			onEnter: ["$stateParams", "Strategy", function ($stateParams, Strategy) {
				//display the strategy title as the breadcrumb title
				this.navigationData.breadcrumbTitle = Strategy.getCache({ _id: $stateParams.query })[0].Title
			}],
			fabButtons: [
				{
					title: 'Add Initiative',
					icon: 'zmdi zmdi-plus',
					action: function() {
						$mdDialog.show({
							controller: 'AddInitiativeDialog',
							controllerAs: 'vm',
							templateUrl: '/app/strategy/dialogs/add-initiative.tmpl.html',
							targetEvent: null,
							options: {}
						})
					},
					permissionNeeded: '$root.user.EffPerms.Initiative.CanCreate'
				},
			]
		})


	}
})();
(function() {
    'use strict'

    //define the routes and menu for this module
    moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "SingleItemViewerProvider", "PageProvider", "PostProvider"];
    angular
        .module('app')
        .config(moduleConfig)

    /* @ngInject */
    function moduleConfig($stateProvider, LandingRecentGroupingsProvider, SingleItemViewerProvider, PageProvider, PostProvider) {
        // create route for social landing page
        LandingRecentGroupingsProvider.createRoutes($stateProvider, {
            name: 'shell.social',
            title: 'Social',
            subTitle: 'A collection of tools for connected teams.',
            cardClass: "sub-menu-card",

            sectionSettings: {
                title: "Social",
                color: "rgba(0,174,239,1)",
            },

            sections: [
                {
                    title: 'Social',
                    subTitle: 'Stay current with your organization’s activity.',

                    menuItems: [
                        {
                            title: 'News Feed',
                            subtitle: 'What\'s happening at {{org}}?',
                            image: '/assets/images/cards/slim/social/news.png',
                            sref: 'shell.social.news-feed'
                        },
                        {
                            title: 'Inbox',
                            subtitle: 'An inbox version of your messages.',
                            image: '/assets/images/cards/slim/social/inbox.png',
                            sref: 'shell.social.messages.list'
                        },
                        {
                            title: 'Page Directory',
                            subtitle: 'Find a page in the {{org}} private social network.',
                            image: '/assets/images/cards/slim/social/pages.png',
                            sref: 'shell.social.pages'
                        },
                    ]
                },

                {
                    title: 'Meetings',
                    subTitle: 'Digitize meetings at {{org}}. Share agendas and related documents and encourage feedback to help perfect your meetings.',

                    menuItems: [
                        {
                            title: 'New Meeting',
                            subtitle: 'Hosting a meeting? Start here!',
                            image: '/assets/images/cards/slim/social/event-new.png',
                            action: function ($event) {
                                $mdDialog.show({
                                        controller: 'AddMeetingDialog',
                                        controllerAs: 'vm',
                                        templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
                                        targetEvent: $event,
                                        locals: {
                                            options: null
                                        }
                                })
                            },
                            permissionNeeded: '$root.user.EffPerms.Meetings.CanCreate'
                        },
                        {
                            title: 'Upcoming Meetings',
                            subtitle: 'Meetings you are hosting or attending.',
                            image: '/assets/images/cards/slim/social/meetings.png',
                            sref: 'shell.social.meetings.upcoming.list'
                        },
                        {
                            title: 'Past Meetings',
                            subtitle: 'View all meetings you have hosted or attended in the past.',
                            image: '/assets/images/cards/slim/social/meetings-past.png',
                            sref: 'shell.social.meetings.past.list'
                        },
                        {
                            title: 'Meeting Drafts',
                            subtitle: 'Unscheduled meetings that have no start date or time.',
                            image: '/assets/images/cards/slim/social/meetings-drafts.png',
                            sref: 'shell.social.meetings.drafts.list'
                        },
                        {
                            title: 'Reports',
                            subtitle: 'View reports about meetings.',
                            image: '/assets/images/cards/slim/social/meetings-reports.png',
                            sref: 'shell.social.meetings.reports'
                        }
                    ]
                },

                {
                    title: 'Q & A',
                    subTitle: 'Knowledge base built and curated by {{org}}.',

                    menuItems: [
                        {
                            title: 'Search Q&A',
                            subtitle: 'Need something? Start here!',
                            image: '/assets/images/cards/slim/social/searchqa.png',
                            sref: 'shell.social.questions.search'
                        },
                        {
                            title: 'Respond',
                            subtitle: 'Answer questions sent to you.',
                            image: '/assets/images/cards/slim/social/pendingresponse.png',
                            sref: 'shell.social.questions.respond.list'
                        },
                        {
                            title: 'Recent Answers',
                            subtitle: 'View questions that have recently been answered.',
                            image: '/assets/images/cards/slim/social/recentlyanswered.png',
                            sref: 'shell.social.questions.recently-answered.list'
                        },
                        {
                            title: 'FAQs',
                            subtitle: 'View frequently asked questions.',
                            image: '/assets/images/cards/slim/social/faq.png',
                            sref: 'shell.social.questions.faq.list'
                        },
                        {
                            title: 'Tags',
                            subtitle: 'Manage question tags and their moderators.',
                            image: '/assets/images/cards/slim/social/tags.png',
                            permissionNeeded: '$root.user.EffPerms.QnA.Manager',
                            sref: 'shell.social.questions.tags.list'
                        },
                        {
                            title: 'My Tags',
                            subtitle: 'Show questions for tags you\'re moderating.',
                            image: '/assets/images/cards/slim/social/moderators.png',
                            sref: 'shell.social.questions.my-tags'
                        }
                    ]
                },
                
            ],

            fabButtons: [{
                    title: 'Add Page',
                    icon: 'zmdi zmdi-view-web',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'General' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Add Event',
                    icon: 'au au-add-event',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'Event' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Add Meeting',
                    icon: 'au au-meeting',
                    action: function($event) {
                        $mdDialog.show({
                            controller: 'AddMeetingDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
                            targetEvent: $event,
							locals: {
								options: null
							}
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Meetings.CanCreate'
                },
                {
                    title: 'Add Discussion Board',
                    icon: 'zmdi zmdi-comments',
                    action: function() {
                        $mdDialog.show({
                            controller: 'PageWizardDialog',
                            controllerAs: 'vm',
                            templateUrl: '/app/social/dialogs/page-wizard.tmpl.html',
                            targetEvent: null,
                            locals: { options: { pageType: 'Discussion' } }
                        })
                    },
                    permissionNeeded: '$root.user.EffPerms.Pages.CanCreate'
                },
                {
                    title: 'Compose Message',
                    icon: 'zmdi zmdi-edit',
                    action: function() {
                        window.$injector
                            .get('Conversation')
                            .NewConversationFull()
                    }
                }
            ],
            fabIcon: 'zmdi zmdi-plus',

        })

        // create single item route for page
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemSection: 'social',
            itemType: PageProvider,
            detailTemplateUrl: '/app/social/page/tmpl.html',
            controller: 'PageItemController'
        })

        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemSection: 'social',
            itemType: PostProvider,
            detailTemplateUrl: '/app/social/post/posts.tmpl.html',
            controller: 'PostItemController'
        })

        
    }
})();
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "PostProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, PostProvider) {
		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.social.all-posts',
			title: 'All Posts',
			itemTitle: '{{itemSettings.item.Creator}}',
			itemType: PostProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Post", function (localCacheReady, Post) {
				// console.log(Post.getCache())
				return Post.getCache()
			}],
			initialSortBy: 'Creator',
			initialView: 'list'
		})
	}
})();
(function() {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "ProjectProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, ProjectProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, {
            itemType: ProjectProvider,
            itemSection: 'project',
            detailTemplateUrl: '/app/project/projects/detail.tmpl.html',
            controller: 'ProjectController'
        })
    }
})();
(function () {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "SingleItemViewerProvider", "ProjectProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, SingleItemViewerProvider, ProjectProvider) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.project',
			cardClass: 'sub-menu-card',
			title: 'Projects',

			sectionSettings: {
				searchTitle: "Projects",
				color: "rgba(55, 176, 74, 1)",
				image: "projects",
				title: "Projects"
			},

			fabButtons: [
				{
					title: 'Add Project',
					icon: 'zmdi zmdi-folder',
					action: ProjectProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Projects.CanCreate'
				},
				{
					title: 'Add Task',
					icon: 'au au-task-check',
					action: function () {
						$mdDialog.show({
							controller: 'AddTaskDialog',
							controllerAs: 'vm',
							templateUrl: '/app/project/dialogs/add-task.tmpl.html',
							targetEvent: null,
							locals: {
								options: {
									associatedItem: null
								}
							}
						})
					}
				}
			],
			fabIcon: 'zmdi zmdi-plus',



			sections: [
				{
					title: 'Projects',
					subTitle: 'Plan your projects, create tasks, assign them, and keep track of progress.',

					menuItems: [
						{
							title: 'Add Project',
							subtitle: 'Add a new project.',
							image: '/assets/images/cards/slim/projects/add-project.png',
							action: ProjectProvider.addItem,
							permissionNeeded: '$root.user.EffPerms.Projects.CanCreate'
						},
						{
							title: 'My Projects',
							subtitle: 'All projects that you are a member of.',
							image: '/assets/images/cards/slim/projects/projects.png',
							sref: 'shell.project.my-projects.list'
						},
						{
							title: 'My Tasks',
							subtitle: 'All tasks assigned to you.',
							image: '/assets/images/cards/slim/projects/tasks.png',
							sref: 'shell.project.all-tasks.list'
						}
					]
				},
				{
					title: 'Find Projects & Tasks',
					subTitle: 'Show projects listed by various methods.',

					menuItems: [
						{
							title: 'Projects by Owner',
							subtitle: 'Find projects owned by a team/group, department, etc.',
							image: '/assets/images/cards/slim/projects/mytasks.png',
							sref: 'shell.project.by-owner'
						},
						{
							title: 'Tasks by User',
							subtitle: 'List all tasks assigned to a user.',
							image: '/assets/images/cards/slim/projects/tasksbyuser.png',
							sref: 'shell.project.tasks-by-user',
							// permissionNeeded: '$root.user.hasSubordinates()'
						},
						{
							title: 'Tasks I Created',
							subtitle: 'All incomplete tasks you\'ve created.',
							image: '/assets/images/cards/slim/projects/mytasks.png',
							sref: 'shell.project.tasks-created-by-me.list'
						},
						{
							title: 'All Projects',
							subtitle: 'All active projects in your organization.',
							image: '/assets/images/cards/slim/projects/projects.png',
							sref: 'shell.project.reports.all-projects.list'
						}
					]
				}
			]
		})


	}
})();
(function () {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "PhilosophyProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, ListViewerProvider, PhilosophyProvider) {
		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.philosophy',
			title: 'Philosophy',
			itemTitle: '{{itemSettings.item.toString()}}',
			itemType: PhilosophyProvider,
			/* @ngInject */
			listItems: ["$rootScope", "localCacheReady", "Philosophy", function($rootScope, localCacheReady, Philosophy) {
				return Philosophy.getCache()
			}],
			initialSortBy: 'Title',
			initialView: 'list'
		})
	}
})();
(function() {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider) {

		$stateProvider
			.state('shell.home', {
				url: '/home',

				templateUrl: function(){
					if (angular.element(window).innerWidth() < 600) {
						return '/app/home/dashboard-mobile.tmpl.html'
					} else {
						return '/app/home/dashboard.tmpl.html'
					}
				},
				controller: 'DashboardController',
				controllerAs: 'vm',

				data: { //leverage prototypical inheritance - all other states get this data until they override it
					sectionSettings: {
						searchTitle: "Home",
						color: "rgba(119, 19, 28, 1)",
						image: "home",
						title: "Home"
					}
				},

				navigationData: {
					breadcrumbTitle: 'Home',
					menuItems: []
				},

				resolve: {
					ready: ["localCacheReady", function (localCacheReady) {
						console.log('Welcome home!')
				}]}
			})
	}
})();
(function() {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider) {

		$stateProvider
			.state('shell.home-mobile', {
				url: '/home-mobile',

				templateUrl: '/app/home/dashboard-mobile.tmpl.html',
				controller: 'DashboardController',
				controllerAs: 'vm',

				data: { //leverage prototypical inheritance - all other states get this data until they override it
					sectionSettings: {
						searchTitle: "Home",
						color: "rgba(119, 19, 28, 1)",
						image: "home",
						title: "Home"
					}
				},

				navigationData: {
					breadcrumbTitle: 'Home',
					menuItems: []
				},

				resolve: {
					ready: ["localCacheReady", function (localCacheReady) {
						console.log('Welcome home!')
				}]}
			})
	}
})();
(function () {
	'use strict';

	DashboardController.$inject = ["$scope", "$timeout", "$http", "toast", "auUtility", "$rootScope", "UserNewsFeed", "Conversation"];
	angular
		.module('app')
		.controller('DashboardController', DashboardController);

	/* @ngInject */
	function DashboardController($scope, $timeout, $http, toast, auUtility, $rootScope, UserNewsFeed, Conversation) {
		var vm = this;
		vm.chartDays = []
		vm.chartLabels = []
		vm.currentHappiness = 3
		vm.eventSources = []
		vm.unfTop = 0
		vm.conversationTop = 0

        //fade in the contents scrolled up
        var el = angular.element('#HomeDashboard md-content')
        auUtility.initPageScrolledDown(el)

		// bind newsfeed so UI can display
		vm.unfs = UserNewsFeed.getCache(150, '-DateCreated', true)

		// update conversations, time out for a bit to let that complete, bind conversations to vm
		Conversation.updateConversations()
		$timeout(function() {
			vm.conversations = Conversation.conversations		
		}, 500)

		// get happiness chart data
		getChartData()

		// when the user selects a happiness rating, update UI
		// with the text that matches it
		$scope.$watch('vm.currentHappiness', function (newVal, old) {
			vm.currentHappinessRating = getRating(newVal)
		})

		// happiness meter
		vm.submitHappinessRating = function () {
			$http.post('/api/happiness', { Score: vm.currentHappiness })
				.then(function () {
					toast.success('Your happiness rating was submitted!')
					getChartData()
				})
		}

		function getChartData() {
			$http.get('/api/reportvalue/getpastxdays?reportType=Happiness')
				.then(function (response) {
					var reports = response.data
					vm.chartData = [reports.map(function (report) {
						return report.Value.toFixed(2)
					})]
					vm.chartDays = reports.map(function (report) {
						var date = new Date(report.Date)
						return (date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear())
					})
				})
		}

		function getRating(newVal) {
			switch (newVal) {
				case 1: return 'Very Unhappy'
				case 2: return 'Unhappy'
				case 3: return 'Indifferent'
				case 4: return 'Happy'
				case 5: return 'Very Happy'
				default: return '--'
			}
		}
	}

})();
(function() {
	'use strict'
	
		moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "HandbookProvider", "HandbookEntryProvider", "HandbookEntryRevisionProvider"];
	angular
		.module('app')
		.config(moduleConfig)

		/* @ngInject */
		function moduleConfig($stateProvider, SingleItemViewerProvider, HandbookProvider, HandbookEntryProvider, HandbookEntryRevisionProvider) {
			//Handbook
			SingleItemViewerProvider.createRouteFor($stateProvider, {
				itemType: HandbookProvider,
				itemSection: 'handbook',
				detailTemplateUrl: '/app/handbook/item/detail.tmpl.html',
				controller: 'HandbookItemController'
			})

			//HandbookEntry
			SingleItemViewerProvider.createRouteFor($stateProvider, {
				itemType: HandbookEntryProvider,
				itemSection: 'handbookentry',
				detailTemplateUrl: '/app/handbook/handbookentry/detail.tmpl.html',
				controller: 'HandbookEntryItemController'
			})

			//HandbookEntryRevision
			SingleItemViewerProvider.createRouteFor($stateProvider, {
				itemType: HandbookEntryRevisionProvider,
				itemSection: 'handbookentryrevision',
				detailTemplateUrl: '/app/handbook/revision/detail.tmpl.html',
				controller: 'HandbookEntryRevisionItemController'
			})
		}
})();
(function() {
	'use strict';
		moduleConfig.$inject = ["$stateProvider", "ListViewerProvider", "SelectFilterProvider", "HandbookProvider", "HandbookEntryProvider"];
	angular
		.module('app')
		.config(moduleConfig)

		/* @ngInject */
		function moduleConfig($stateProvider, ListViewerProvider, SelectFilterProvider, HandbookProvider, HandbookEntryProvider) {
            SelectFilterProvider.createRoutes($stateProvider, {
				name: 'shell.handbook',
				title: 'Handbooks',
				subTitle: 'See a handbook below',
				/* @ngInject */
				values: ["localCacheReady", "$rootScope", "Handbook", function(localCacheReady, $rootScope, Handbook) {
                    return Handbook.getCache().$httpPromise
                    .then(function(results){
						return results.map(function(handbook) {
							return {
								title: handbook.Title,
								sref: 'shell.handbook.view-handbook.list',
								srefOpts: {
									query: handbook._id
								},
								item: handbook
							}
						})
					})
				}],
				breadcrumbItemMap: function(value) {
					return {
						title: value.title,
						sref: 'shell.handbook.view-handbook.list',
						srefOpts: value.srefOpts
					}
				},
				fabButtons: [
					{
						title: 'Add Handbook',
						icon: 'zmdi zmdi-plus',
						action: function() {
							$mdDialog.show({
								controller: 'AddHandbookDialog',
								controllerAs: 'vm',
								templateUrl: '/app/handbook/dialogs/add-handbook.tmpl.html',
								targetEvent: null
							})
						},
						permissionNeeded: '$root.user.EffPerms.Handbook.CanCreate'
					}
				]
			})

			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.handbook.view-handbook',
				title: 'Handbook Entries',
				itemType: HandbookEntryProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "HandbookEntry", "$stateParams", function(localCacheReady, HandbookEntry, $stateParams) {
					return HandbookEntry.query({
						Handbook: $stateParams.query
					}).$httpPromise
				}],
				initialSortBy: 'EntryNumber',
				initialView: 'list',
				showGroupHeaders: false,
				/* @ngInject */
				onEnter: ["$stateParams", "$filter", "Handbook", function($stateParams, $filter, Handbook) {
					// change the breadcrumb to something appropriate
					this.navigationData.breadcrumbTitle = $filter('auItemFilter')(Handbook.getCache({_id: $stateParams.query})[0]) + ' Handbook Entries'
				}],
				fabButtons: [
					{
						title: 'Add Entry',
						icon: 'zmdi zmdi-file',
						action: function($event) {
							$injector.get('Handbook').getCache({_id: $state.params.query})[0].addEntry('New Entry')
						}
					}						
					
				],
				fabIcon: 'zmdi zmdi-plus'
			})

			
		}
})();
(function() {
		VideoDialogController.$inject = ["$scope", "$mdDialog", "options", "$sce"];
	angular
		.module('app')
		.controller('VideoDialogController', VideoDialogController)

		/* @ngInject */
		function VideoDialogController($scope, $mdDialog, options, $sce) {
			var vm = this
			vm.options = options
			vm.cancel = $mdDialog.cancel

			$scope.trustSrc = function (src) {
				return $sce.trustAsResourceUrl(src)
			}
		}
})();
(function () {
	'use strict'

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "SingleItemViewerProvider", "UserProvider", "TeamProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, SingleItemViewerProvider, UserProvider, TeamProvider ) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.getting-started',
			title: 'Getting Started',
			subTitle: 'Watch these short videos to learn how to get started using Align Us.',
			cardClass: 'menu-card',

			sectionSettings: {
				searchTitle: "Getting Started",
				color: "rgba(119, 19, 28, 1)",
				image: "getting-started",
				title: "Getting Started"
			},


			sections: [
				{
					title: 'Add Team Members',
					subTitle: 'Using Align Us is all about collaboration - add Users and Contacts and then group them by Team.',
					permissionNeeded: '$root.user.IsUserAdmin',

					menuItems: [
						{
							title: 'Add a User',
							subtitle: 'Get started by adding your team members in as Users.',
							image: '/assets/images/cards/getting-started/add-users.png',
							action: UserProvider.addItem,
						},
						{
							title: 'Add Team/Group',
							subtitle: 'Group your team members any way you need.',
							image: '/assets/images/cards/getting-started/team.png',
							action: TeamProvider.addItem,
						},
						{
							title: 'Users',
							subtitle: 'Watch a video on user management within Align Us.',
							image: '/assets/images/cards/video/users.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/BBAXiOgHz84?autoplay=1&rel=0',
											title: 'Users'
										}
									}
		
								})
							}
						},
					]
				},

				{
					title: 'Create Tasks',
					subTitle: 'Track to-dos and assign work-items to other users.',

					menuItems: [
						{
							title: 'Add Task',
							subtitle: 'Assign tasks to other users, contacts, or yourself to ensure they are taken care of.',
							image: '/assets/images/cards/getting-started/task.png',
							action: function () {
								$mdDialog.show({
									controller: 'AddTaskDialog',
									controllerAs: 'vm',
									templateUrl: '/app/project/dialogs/add-task.tmpl.html',
									targetEvent: null,
									locals: {
										options: {
											associatedItem: null
										}
									}
								})
							}
						},
						{
							title: 'My Tasks',
							subtitle: 'View all tasks assigned to you.',
							image: '/assets/images/cards/getting-started/my-tasks.png',
							sref: 'shell.project.all-tasks.list'
						},
						{
							title: 'My Tasks',
							subtitle: 'Watch a video on task management within Align Us.',
							image: '/assets/images/cards/video/my-tasks.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/0232z6v6pzI?autoplay=1&rel=0',
											title: 'My Tasks'
										}
									}
		
								})
							}
						},
					]
				},

				{
					title: 'Engage the Social Network',
					subTitle: 'All items within Align Us use the Social Intranet to share updates and team communications. Check your feeds often!',

					menuItems: [
						{
							title: 'News Feed',
							subtitle: 'See what\'s happening at {{org}}.',
							image: '/assets/images/cards/getting-started/newsfeed.png',
							sref: 'shell.social.news-feed'
						},
						{
							title: 'Inbox',
							subtitle: 'Check for messages sent directly to you.',
							image: '/assets/images/cards/getting-started/inbox.png',
							sref: 'shell.social.messages.list'
						},
						{
							title: 'Messages',
							subtitle: 'Watch a video on how Align Us works as your Social Intranet.',
							image: '/assets/images/cards/video/messages.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/yU4vrEvingg?autoplay=1&rel=0',
											title: 'Messages'
										}
									}
		
								})
							}
						},
					]
				},
				
				// getting started videos

				{
					title: 'Getting Started Videos',
					subTitle: 'Watch these short videos to learn how to get started using Align Us.',

					menuItems: [
						{
							title: 'Dashboard',
							subtitle: 'Quickly manage your tasks and calendar.',
							image: '/assets/images/cards/video/dashboard.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/AQNAH7lNMeo?autoplay=1&rel=0',
											title: 'Dashboard'
										}
									}
		
								})
							}
						},
						{
							title: 'Add a User (Sys Admin)',
							subtitle: 'As a system administrator, you can add and edit users and teams in your organization.',
							image: '/assets/images/cards/video/add-users.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/Lh7pTX6JerE?autoplay=1&rel=0',
											title: 'Users'
										}
									}
		
								})
							},
							permissionNeeded: '$root.user.IsUserAdmin'
						},
						{
							title: 'Users',
							subtitle: 'View the directory by name, department, or location by using a simple menu. You can sort or search for users.',
							image: '/assets/images/cards/video/users.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/BBAXiOgHz84?autoplay=1&rel=0',
											title: 'Users'
										}
									}
		
								})
							}
						},
						{
							title: 'Quick Action Toolbar',
							subtitle: 'A shortcut to the core functions that make your day more efficient.',
							image: '/assets/images/cards/video/quick-add.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/gpBhrHDVoi8?autoplay=1&rel=0',
											title: 'Quick Action Toolbar'
										}
									}
		
								})
							}
						},
						{
							title: 'Communications Toolbar',
							subtitle: 'A shortcut to communicating with your internal team.',
							image: '/assets/images/cards/video/communications-toolbar.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/EM1igT7In14?autoplay=1&rel=0',
											title: 'Communications Toolbar'
										}
									}
		
								})
							}
						},
						{
							title: 'Quick Add Button',
							subtitle: 'Add elements to Align Us from the top toolbar.',
							image: '/assets/images/cards/video/quick-add.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/q-Sso-n9hu4?autoplay=1&rel=0',
											title: 'Quick Add Button'
										}
									}
		
								})
							}
						},
						{
							title: 'Send Menu',
							subtitle: ' A shortcut to posting and sending messages.',
							image: '/assets/images/cards/video/send-menu.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/a4htOfbB2zI?autoplay=1&rel=0',
											title: 'Send Menu'
										}
									}
		
								})
							}
						},
						{
							title: 'My Tasks',
							subtitle: ' My Tasks is the Key to Personal and Team Productivity and Collaboration.',
							image: '/assets/images/cards/video/my-tasks.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/0232z6v6pzI?autoplay=1&rel=0',
											title: 'My Tasks'
										}
									}
		
								})
							}
						},
						{
							title: 'Messages',
							subtitle: 'Send messages to stay connected with individuals and teams.',
							image: '/assets/images/cards/video/messages.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/yU4vrEvingg?autoplay=1&rel=0',
											title: 'Messages'
										}
									}
		
								})
							}
						},
						{
							title: 'OneSearch',
							subtitle: 'Instantly find what you\'re looking for!',
							image: '/assets/images/cards/video/search.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/j20EDBkRKww?autoplay=1&rel=0',
											title: 'OneSearch'
										}
									}
		
								})
							}
						},
						{
							title: 'Add A Meeting',
							subtitle: 'Create a meeting with a step by step wizard!',
							image: '/assets/images/cards/video/add-meeting.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/B8hHTh98Fb0?autoplay=1&rel=0',
											title: 'Add A Meeting'
										}
									}
		
								})
							}
						},
						{
							title: 'Add A Project',
							subtitle: 'Use projects to organize tasks and people.',
							image: '/assets/images/cards/video/projects.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/S9n41G8iklQ?autoplay=1&rel=0',
											title: 'Add A Project'
										}
									}
		
								})
							}
						},
						{
							title: 'Making a Video Call',
							subtitle: 'Make crystal clear, no-lag internal peer-to-peer video calls to your colleagues.',
							image: '/assets/images/cards/video/video.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/lU7UCkOw-kw?autoplay=1&rel=0',
											title: 'Making a Video Call'
										}
									}
		
								})
							}
						},
						{
							title: 'Add A Page',
							subtitle: 'Create a space for people to come together, discuss, and share ideas.',
							image: '/assets/images/cards/video/page.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/xtjaW9qaeSs?autoplay=1&rel=0',
											title: 'Add A Project'
										}
									}
		
								})
							}
						},
						{
							title: 'Add A Document',
							subtitle: 'Create live docs with multiple editors and/or viewers.',
							image: '/assets/images/cards/video/documents.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/iyIzYHpANWo?autoplay=1&rel=0',
											title: 'Add A Document'
										}
									}
		
								})
							}
						},
						{
							title: 'Add A Discussion Board',
							subtitle: 'With easy privacy settings and a streamlined interface, a discussion board lets people connect on any topic.',
							image: '/assets/images/cards/video/discussion-board.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/FA30IVRstvg?autoplay=1&rel=0',
											title: 'Add a Discussion Board'
										}
									}
		
								})
							}
						},
						{
							title: 'Help and Settings',
							subtitle: 'Access your recently opened items, most recent messages, and help section.',
							image: '/assets/images/cards/video/settings.png',
							action: function ($event) {
								$mdDialog.show({
									controller: 'VideoDialogController',
									controllerAs: 'vm',
									templateUrl: 'app/getting-started/video-dialog.tmpl.html',
									targetEvent: $event,
									locals: {
										options: {
											videoSrc: 'https://www.youtube.com/embed/8YlVp_u5Qnc?autoplay=1&rel=0',
											title: 'Help and Settings'
										}
									}
		
								})
							}
						},
		
					]


				},
			],

			fabButtons: [
				{
					title: 'Add User',
					icon: 'zmdi zmdi-account-add',
					action: UserProvider.addItem,
					permissionNeeded: '$root.user.EffPerms.Users.IsAdminFor.Org'
				},
				{
					title: 'Add Meeting',
					icon: 'au au-meeting',
					action: function ($event) {
						$mdDialog.show({
							controller: 'AddMeetingDialog',
							controllerAs: 'vm',
							templateUrl: '/app/social/dialogs/add-meeting.tmpl.html',
							targetEvent: $event,
							locals: {
								options: null
							}
						}).then(function (hide) {
							//
						})
					}
				},
				{
					title: 'Add Project',
					icon: 'zmdi zmdi-folder',
					action: function () {
						$mdDialog.show({
							controller: 'AddProjectDialog',
							controllerAs: 'vm',
							templateUrl: '/app/project/dialogs/add-project.tmpl.html',
							targetEvent: null
						}).then(function () {
							//
						})
					}
				}
			],
			fabIcon: 'zmdi zmdi-plus',

			menuItems: [
				{
					title: 'Dashboard',
					subtitle: 'Quickly manage your tasks and calendar.',
					image: '/assets/images/cards/video/dashboard.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/AQNAH7lNMeo?autoplay=1&rel=0',
									title: 'Dashboard'
								}
							}

						})
					}
				},
				{
					title: 'Add a User (Sys Admin)',
					subtitle: 'As a system administrator, you can add and edit users and teams in your organization as well as view them in a variety of formats.',
					image: '/assets/images/cards/video/add-users.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/Lh7pTX6JerE?autoplay=1&rel=0',
									title: 'Users'
								}
							}

						})
					},
					permissionNeeded: '$root.user.IsUserAdmin'
				},
				{
					title: 'Users',
					subtitle: 'View the directory by name, department, or location by using a simple menu. You can sort or search for users by any number of options.',
					image: '/assets/images/cards/video/users.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/BBAXiOgHz84?autoplay=1&rel=0',
									title: 'Users'
								}
							}

						})
					}
				},
				{
					title: 'Quick Action Toolbar',
					subtitle: 'A shortcut to the core functions that make your day more efficient.',
					image: '/assets/images/cards/video/quick-add.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/gpBhrHDVoi8?autoplay=1&rel=0',
									title: 'Quick Action Toolbar'
								}
							}

						})
					}
				},
				{
					title: 'Communications Toolbar',
					subtitle: 'A shortcut to communicating with your internal team.',
					image: '/assets/images/cards/video/communications-toolbar.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/EM1igT7In14?autoplay=1&rel=0',
									title: 'Communications Toolbar'
								}
							}

						})
					}
				},
				{
					title: 'Quick Add Button',
					subtitle: 'Add elements to Align Us from the top toolbar.',
					image: '/assets/images/cards/video/quick-add.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/q-Sso-n9hu4?autoplay=1&rel=0',
									title: 'Quick Add Button'
								}
							}

						})
					}
				},
				{
					title: 'Send Menu',
					subtitle: ' A shortcut to posting and sending messages.',
					image: '/assets/images/cards/video/send-menu.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/a4htOfbB2zI?autoplay=1&rel=0',
									title: 'Send Menu'
								}
							}

						})
					}
				},
				{
					title: ' My Tasks',
					subtitle: ' My Tasks is the Key to Personal and Team Productivity and Collaboration.',
					image: '/assets/images/cards/video/my-tasks.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/0232z6v6pzI?autoplay=1&rel=0',
									title: 'My Tasks'
								}
							}

						})
					}
				},
				{
					title: 'Messages',
					subtitle: 'Send messages to stay connected with individuals and teams.',
					image: '/assets/images/cards/video/messages.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/yU4vrEvingg?autoplay=1&rel=0',
									title: 'Messages'
								}
							}

						})
					}
				},
				{
					title: 'OneSearch',
					subtitle: 'Instantly find what you\'re looking for!',
					image: '/assets/images/cards/video/search.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/j20EDBkRKww?autoplay=1&rel=0',
									title: 'OneSearch'
								}
							}

						})
					}
				},
				{
					title: 'Add A Meeting',
					subtitle: 'Create a meeting with a step by step wizard!',
					image: '/assets/images/cards/video/add-meeting.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/B8hHTh98Fb0?autoplay=1&rel=0',
									title: 'Add A Meeting'
								}
							}

						})
					}
				},
				{
					title: 'Add A Project',
					subtitle: 'Use projects to organize tasks and people.',
					image: '/assets/images/cards/video/projects.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/S9n41G8iklQ?autoplay=1&rel=0',
									title: 'Add A Project'
								}
							}

						})
					}
				},
				{
					title: 'Making a Video Call',
					subtitle: 'Make crystal clear, no-lag internal peer-to-peer video calls to your colleagues.',
					image: '/assets/images/cards/video/video.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/lU7UCkOw-kw?autoplay=1&rel=0',
									title: 'Making a Video Call'
								}
							}

						})
					}
				},
				{
					title: 'Add A Page',
					subtitle: 'Create a space for people to come together, discuss, and share ideas.',
					image: '/assets/images/cards/video/page.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/xtjaW9qaeSs?autoplay=1&rel=0',
									title: 'Add A Project'
								}
							}

						})
					}
				},
				{
					title: 'Add A Document',
					subtitle: 'Create live docs with multiple editors and/or viewers.',
					image: '/assets/images/cards/video/documents.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/iyIzYHpANWo?autoplay=1&rel=0',
									title: 'Add A Document'
								}
							}

						})
					}
				},
				{
					title: 'Add A Discussion Board',
					subtitle: 'With easy privacy settings and a streamlined interface, a discussion board lets people connect on any they topic they wish.',
					image: '/assets/images/cards/video/discussion-board.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/FA30IVRstvg?autoplay=1&rel=0',
									title: 'Add a Discussion Board'
								}
							}

						})
					}
				},
				{
					title: 'Help and Settings',
					subtitle: 'Access your recently opened items, most recent messages, and help section.',
					image: '/assets/images/cards/video/settings.png',
					action: function ($event) {
						$mdDialog.show({
							controller: 'VideoDialogController',
							controllerAs: 'vm',
							templateUrl: 'app/getting-started/video-dialog.tmpl.html',
							targetEvent: $event,
							locals: {
								options: {
									videoSrc: 'https://www.youtube.com/embed/8YlVp_u5Qnc?autoplay=1&rel=0',
									title: 'Help and Settings'
								}
							}

						})
					}
				},

			]
		})
	}
})();
(function () {
    'use strict';

    moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "FundraiserProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, SingleItemViewerProvider, FundraiserProvider) {
        SingleItemViewerProvider.createRouteFor($stateProvider, { itemType: FundraiserProvider })
    }
})();
(function () {
    'use strict';

    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        $stateProvider
            .state('fundraiser', {
                url: '/welcome',
                templateUrl: '/app/fundraiser/public-welcome.tmpl.html',
                // controller: 'SignupController',
                // controllerAs: 'vm',
                resolve: {
                    /* @ngInject */
                    themeLoaded: ["auTheme", function (auTheme) {
                        //always use the default color
                        auTheme.loadTheme('#be1e2d')
                        setTimeout(function () { document.getElementById('loading-container').style.display = "none" }, 1000)
                    }],
                    /* @ngInject */
                    schemaLoaded: ["Schema", function (Schema) {
                        return Schema.query().$httpPromise
                    }]
                },
            })
            .state('fundraiser.list', {
                url: '/active-fundraisers',
                title: 'Active Fundraisers',
                templateUrl: '/app/authentication/signup/signup.tmpl.html',
                controller: 'SignupController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
    }
})();
//#4 - THE ROUTE - Present a list of resources as a URL
(function () {
	'use strict';

	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "LandingRecentGroupingsProvider", "FundraiserProvider", "FundraiserParticipantProvider"];
	angular.module('app').config(configRoutes);

	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, LandingRecentGroupingsProvider, FundraiserProvider, FundraiserParticipantProvider) {

		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.fundraiser',
			cardClass: 'sub-menu-card',
			title: 'Fundraising',

			sectionSettings: {
				searchTitle: "Fundraising",
				color: "rgba(55, 176, 74, 1)",
				image: "project",
				title: "Fundraiser"
			},

			fabButtons: [
				{
					title: 'Add Fundraiser',
					icon: 'au au-fundraiser-o',
					action: FundraiserProvider.addItem
				}
			],
			fabIcon: 'zmdi zmdi-plus',

			sections: [
				{
					title: 'Fundraising',
					subTitle: 'Build the funds for your organization.',

					menuItems: [
						{
							title: 'Add Fundraiser',
							subtitle: 'Start a new fundraiser.',
							image: '/assets/images/cards/slim/fundraiser/fundraiser-add.png',
							action: FundraiserProvider.addItem
						},
						{
							title: 'All Fundraisers',
							subtitle: 'All fundraisers',
							image: '/assets/images/cards/slim/fundraiser/fundraiser-all.png',
							sref: 'shell.fundraiser.all-fundraisers.list'
						}
					]
				}
			]
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.fundraiser.all-fundraisers',
			title: 'All Fundraisers',
			itemType: FundraiserProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Fundraiser", function (localCacheReady, Fundraiser) {
				return Fundraiser.getCache()
			}],
			initialSortBy: 'Title',
			initialView: 'list',
			showGroupHeaders: true,
			listOptions: {
				mode: 'edit'
			}
		})

		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.fundraiser.participants',
			url: 'participants/:id',
            title: 'Fundraiser Participants',
            itemType: FundraiserParticipantProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "FundraiserParticipant", function(localCacheReady, FundraiserParticipant) {
                return FundraiserParticipant.getCache()
            }],
            initialSortBy: 'Name',
            initialView: 'list',
            showGroupHeaders: true,
        })
	}

})();
(function() {
	'use strict'
	
	moduleConfig.$inject = ["$stateProvider", "SingleItemViewerProvider", "DocumentProvider"];
	angular
		.module('app')
		.config(moduleConfig)

	/* @ngInject */
	function moduleConfig($stateProvider, SingleItemViewerProvider, DocumentProvider) {
		SingleItemViewerProvider.createRouteFor($stateProvider, {
			itemType: DocumentProvider,
			itemSection: 'documents',
			detailTemplateUrl: '/app/document/item/tmpl.html',
			controller: 'DocumentItemController'
		})
	}
})();
(function() {
	'use strict';
		configFn.$inject = ["$stateProvider", "ListViewerProvider", "SelectFilterProvider", "DocumentProvider"];
	angular
		.module('app')
		.config(configFn)

		/* @ngInject */
		function configFn($stateProvider, ListViewerProvider, SelectFilterProvider, DocumentProvider) {
			ListViewerProvider.createRoutes($stateProvider, {
				name: 'shell.documents.documents-for-user.list',
				title: 'Documents For...',
				itemType: DocumentProvider,
				/* @ngInject */
				listItems: ["localCacheReady", "Document", "$stateParams", "$rootScope", function(localCacheReady, Document, $stateParams, $rootScope) {
					var userId = $stateParams.query
					return Document.query({
						Owner: userId, 
						$or: [
							{ 
								'IsPrivate': false 
							},
							{ 
								'Viewers': $rootScope.user._id
							},
							{ 
								'Editors': $rootScope.user._id
							}
						]
					}).$httpPromise
				}],
				initialSortBy: 'Title',
				initialView: 'list',
				/* @ngInject */
				onEnter: ["$stateParams", "$filter", "Document", "User", function($stateParams, $filter, Document, User) {
					// change the breadcrumb to something appropriate
					this.navigationData.breadcrumbTitle = 'Documents For ' + $filter('auItemFilter')(User.getCache({_id: $stateParams.query})[0])
				}]
			})

			SelectFilterProvider.createRoutes($stateProvider, {
				name: 'shell.documents.documents-for-user',
				title: 'Documents By User',
				subTitle: 'See a list of Documents where you and the user you select are Editors.',
				/* @ngInject */
				values: ["localCacheReady", "$rootScope", "Document", "User", "$filter", function(localCacheReady, $rootScope, Document, User, $filter) {
					return User.getCache().$httpPromise.then(function(results){
						return results.map(function(user) {
							return {
								title: user.toString(),
								sref: '.list.list',
								srefOpts: {
									query: user._id
								},
								item: user
							}
						})
					})
				}],
				breadcrumbItemMap: function(value) {
					return {
						title: value.title,
						sref: 'shell.documents.documents-for-user',
						srefOpts: value.srefOpts
					}
				}
			})
		}
})();
//#4 - THE ROUTE - Present a list of resources as a URL
(function () {
	'use strict';
	
	//define the routes and menu for this module
	configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "DocumentProvider"];
	angular.module('app').config(configRoutes);
	
	/* @ngInject */
	function configRoutes($stateProvider, ListViewerProvider, DocumentProvider) {
		ListViewerProvider.createRoutes($stateProvider, {
			name: 'shell.documents.all',
			title: 'Documents',
			itemTitle: '{{itemSettings.item.Title}}',
			itemType: DocumentProvider,
			/* @ngInject */
			listItems: ["localCacheReady", "Document", function (localCacheReady, Document) {
				return Document.getCache()
			}],
			initialSortBy: 'Title',
			initialView: 'list',
			showGroupHeaders: true,
		})
	}
})();
(function () {
	'use strict';

	//define the routes and menu for this module
	moduleConfig.$inject = ["$stateProvider", "LandingRecentGroupingsProvider", "DocumentProvider"];
	angular
		.module('app')
		.config(moduleConfig);

	/* @ngInject */
	function moduleConfig($stateProvider, LandingRecentGroupingsProvider, DocumentProvider) {
		LandingRecentGroupingsProvider.createRoutes($stateProvider, {
			name: 'shell.documents',
			title: 'Documents',
			subTitle: 'This is documents',
			cardClass: "sub-menu-card",

			sectionSettings: {
				title: "Documents",
				color: "rgba(0,167,157,1)",
			},	

			fabButtons: [
				{
					title: 'Add Document',
					icon: 'zmdi zmdi-file-plus',
					action: function() {
						$mdDialog.show({
							controller: 'AddDocumentDialog',
							controllerAs: 'vm',
							templateUrl: '/app/document/dialogs/add-doc.tmpl.html',
							targetEvent: null
						})
					},
					permissionNeeded: '$root.user.EffPerms.Documents.CanCreate'
				}

			],
			fabIcon: 'zmdi zmdi-plus',

			menuItems: [
				{
					title: 'Add Document',
					subtitle: 'Create a new document.',
					image: '/assets/images/cards/slim/documents/new.png',
					action: function() {
						$mdDialog.show({
							controller: 'AddDocumentDialog',
							controllerAs: 'vm',
							templateUrl: '/app/document/dialogs/add-doc.tmpl.html'
						})
					},
					permissionNeeded: '$root.user.EffPerms.Documents.CanCreate'
				},
				{
					title: 'All Documents',
					subtitle: 'List all public docs & private docs you can edit and view.',
					image: '/assets/images/cards/slim/documents/mydocuments.png',
					sref: 'shell.documents.all.list'
				},
				{
					title: 'Docs By User',
					subtitle: 'List all documents owned by a certain user.',
					image: '/assets/images/cards/slim/documents/byproject.png',
					sref: 'shell.documents.documents-for-user'
				}
			]
		})
	}
})();
(function () {
    'use strict';

    moduleConfig.$inject = ["$stateProvider"];
    angular
        .module('app.authentication')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider) {
        $stateProvider
            .state('authentication', {
                abstract: true,
                templateUrl: '/app/authentication/layouts/authentication.tmpl.html',
                resolve: {
                    /* @ngInject */
                    themeLoaded: ["auTheme", function (auTheme) {
                        //always use the default color
                        auTheme.loadTheme('#be1e2d')
                        setTimeout(function () { document.getElementById('loading-container').style.display = "none" }, 1000)
                    }],
                    /* @ngInject */
                    schemaLoaded: ["Schema", function (Schema) {
                        return Schema.query().$httpPromise
                    }]
                },
            })
            .state('authentication.signup', {
                url: '/signup',
                title: 'Sign Up',
                templateUrl: '/app/authentication/signup/signup.tmpl.html',
                controller: 'SignupController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
            .state('authentication.login', {
                url: '/login?uls',
                title: 'Log In',
                templateUrl: '/app/authentication/login/login.tmpl.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
            .state('authentication.forgot', {
                url: '/forgot',
                title: 'Forgot Password',
                templateUrl: '/app/authentication/forgot/forgot.tmpl.html',
                controller: 'ForgotController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
            .state('authentication.tos', {
                url: '/termsofservice',
                title: 'Terms of Service',
                templateUrl: '/app/authentication/tos/tos.tmpl.html',
                controller: 'ToSController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
            .state('authentication.select', {
                url: '/select?udata&uls',
                params: {
                    localOptions: {},
                    udata: '',
                    uls: 'false'
                },
                title: 'Select Account',
                templateUrl: '/app/authentication/select/select.tmpl.html',
                controller: 'SelectController',
                controllerAs: 'vm',
                /* @ngInject */
                resolve: { ready: ["schemaLoaded", function(schemaLoaded) { }] }
            })
    }
})();
(function() {
    'use strict';

    //namespace for alignus
    angular
        .module('alignus', [])
       	

})();
//#4 - THE ROUTE - Present a list of resources as a URL
(function() {
    'use strict';

    //define the routes and menu for this module
    configRoutes.$inject = ["$stateProvider", "ListViewerProvider", "_TemplateProvider"];
    angular.module('app').config(configRoutes);

    /* @ngInject */
    function configRoutes($stateProvider, ListViewerProvider, _TemplateProvider) {

        ListViewerProvider.createRoutes($stateProvider, {
            name: 'shell._template',
            title: 'Translation for _Template',
            itemTitle: '{{itemSettings.item.Name}}',
            itemType: _TemplateProvider,
            /* @ngInject */
            listItems: ["localCacheReady", "_Template", function(localCacheReady, _Template) {
                return _Template.getCache()
            }],
            initialSortBy: 'Name',
            initialView: 'list',
            showGroupHeaders: true,
        })
    }

})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("/app/fundraiser/public-welcome.tmpl.html","<div class=\"full-image-background overflow-x-hidden overflow-auto constrain-to-screen background-color-700\" layout=\"column\"\n layout-fill layout-align=\"center center\" id=\'authBG\' Xs3-background=\"/assets/images/login/bg.jpg\">\n <div class=\"animate-wrapper-fullscreen\" flex layout=\"column\">\n <div class=\"full-height angular-animate\" layout=\"column\" layout-align=\"start center\" >\n <div layout=\"column\" layout-align=\"start center\" class=\"padding-30\">\n <img class=\"center grow\" s3-src=\"/assets/images/ifund4us/logo-red-beige.png\" style=\"width:250px;\">\n <img class=\"center fadeup\" s3-src=\"/assets/images/ifund4us/logotype-beige.png\" style=\"width:250px;\">\n </div>\n <div>\n <md-button class=\"md-primary md-raised fadedown\" ng-click=\"vm.showActive = true\" ng-hide=\"vm.showActive\">\n &nbsp; Show Active Fundraisers\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n\n </md-button>\n </div>\n\n <!-- fundraiser list -->\n <div ng-show=\"vm.showActive\">\n <div class=\"fadeup margin-20\">\n <md-content>\n <md-card style=\"max-width:500px;\">\n <md-card-header>\n <md-card-avatar>\n <img s3-src=\"/assets/images/ifund4us/headers/district28-logo.png\" />\n </md-card-avatar>\n <md-card-header-text>\n <span class=\"md-title\">District 28</span>\n <span class=\"md-subhead\">Music Parents Club</span>\n </md-card-header-text>\n </md-card-header>\n <img s3-src=\"/assets/images/ifund4us/headers/wreath-sale.png\" class=\"md-card-image\"> \n <md-card-content>\n <p class=\"md-title\">62nd Annual Coffee and Wreath Sale</p>\n <p class=\"md-subhead\">Proceeds are spent on enriching District 28th\'s excellent music program.</p>\n </md-card-content>\n <md-card-actions layout=\"row\" layout-align=\"end center\" class=\"margin-15\">\n <md-button class=\"md-raised md-primary faderight\" onclick=\"window.open(\'http://ifund4.us/nb28\', \'_blank\')\">\n Go <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </md-card-actions>\n </md-card>\n </md-content>\n </div>\n \n </div>\n\n <div flex></div>\n\n <div class=\"margin-bottom-20 md-caption\" layout=\"column\" layout-align=\"center center\">\n <div>\n IFUND4.US is part of the Align.Us product for small groups.\n </div>\n <div onclick=\"window.open(\'http://align.us/\', \'_blank\')\">\n Learn more about Align Us<b> at www.align.us.</b>\n </div>\n <md-icon md-font-icon=\"au au-align\"></md-icon>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/getting-started/video-dialog.tmpl.html","<md-dialog Xclass=\"mobile-fullwidth-dialog\" style=\"max-height: 90% !important\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n {{vm.options.title}}\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\">\n <iframe width=\"640\" height=\"320\" ng-src=\"{{trustSrc(vm.options.videoSrc)}}\" frameborder=\"0\" allowfullscreen style=\"display: block;\"></iframe>\n </md-dialog-content>\n</md-dialog>");
$templateCache.put("/app/home/dashboard-mobile.tmpl.html","<div class=\"home au-landing-page\" id=\"HomeDashboard\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\" style=\"position: fixed; top: 64px;\"></div>\n\n <md-tabs md-align-tabs=\"bottom\" Xmd-stretch-tabs=\"always\" flex layout-fill>\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-plus\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <div class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n Create New Item\n <md-icon md-font-icon=\"zmdi zmdi-plus\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon>\n </div>\n\n <div>\n <!--Send Menu-->\n <md-menu md-position-mode=\"target-right target\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"background-color-900 padding-20 usercard-button\" ng-click=\"$mdOpenMenu($event)\">\n <span class=\"md-title\">Send Menu</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"font-color-100 font-size-4 faderight md-raised\" md-menu-origin></md-icon>\n </div>\n <md-menu-content>\n <div>\n <!--Compose Message-->\n <md-menu-item>\n <md-button ng-click=\"$root.composeMessage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/compose.png\" />\n <div>Compose Message</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--High Five-->\n <md-menu-item>\n <md-button ng-click=\"$root.sendHighFive()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/high-five.png\" />\n <div>Send High Five</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Post to Page-->\n <md-menu-item>\n <md-button ng-click=\"$root.postToPage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/post-to-page.png\" />\n <div>Post to Page</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Ask Question-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.QnA.CanCreate\">\n <md-button ng-click=\"$root.askQuestion()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/ask.png\" />\n <div>Ask Question</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Request Approval-->\n <md-menu-item>\n <md-button ng-click=\"$root.requestApproval()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/request.png\" />\n <div>Request Approval</div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n </md-menu-content>\n </md-menu>\n \n \n <div ng-click=\"$root.auUtility.addNewItem(\'Task\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-800 padding-20 usercard-button\">\n <span class=\"md-title\">Task</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-task-check\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Document\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-700 padding-20 usercard-button\">\n <span class=\"md-title\">Document</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-file\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Project\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-600 padding-20 usercard-button\">\n <span class=\"md-title\">Project</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-project2\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Meeting\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-500 padding-20 usercard-button\">\n <span class=\"md-title\">Meeting</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-meeting\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Page\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-400 padding-20 usercard-button\">\n <span class=\"md-title\">Page</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-view-web\" class=\"font-color-100 font-size-4 grow\" style=\"transform:scaleX(-1)\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Contact\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-300 padding-20 usercard-button\">\n <span class=\"md-title\">Contact</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-account\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-if=\"::$root.user.IsUserAdmin\" ng-click=\"$root.auUtility.addNewItem(\'User\')\" ng-if=\"::$root.user.IsUserAdmin\" layout=\"row\"\n layout-align=\"space-between center\" class=\"background-color-400 padding-20 usercard-button\">\n <span class=\"md-title\">User</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n </div>\n </md-tab-body>\n </md-tab>\n\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-time-restore\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <div ui-sref=\"shell.social.news-feed\" class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n Recent Items\n <md-icon md-font-icon=\"zmdi zmdi-time-restore\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon> \n </div>\n <md-menu class=\"padding-0\">\n <md-menu-content style=\"min-height: 100vh;\" au-suspendable update-on-event=\"recent\">\n <div ng-if=\"$root.showRecentItems\">\n <div ng-if=\"$root.user.getGeneralRecentItems().length > 0\">\n <md-menu-item ng-repeat=\"recentItem in $root.user.getGeneralRecentItems() track by (recentItem.item.$key + recentItem.item._id)\"\n ng-click=\"recentItem.item.open()\" style=\"height:auto;\">\n <md-button aria-label=\"{{::recentItem.item.toString()}}\">\n <div layout=\"row\" layout-align=\"start start\">\n <au-profile-image item=\"recentItem.item\" size=\"25\" flex=\"shrink\" class=\"margin-right-10 margin-top-10 grow\"></au-profile-image>\n <div class=\"column\" flex=\"grow\" style=\"width:90%;\">\n <div class=\"text-ellipsis\" ng-bind=\"recentItem.item.toString()\" flex=\"grow\"></div>\n <div class=\"md-caption opacity-50\" style=\"margin-top: -14px\">\n <span>Modified </span>\n <span am-time-ago=\"recentItem.item.LastModified.Date\"></span>\n </div>\n </div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n <!-- empty state -->\n <div layout=\"column\" layout-align=\"center center\" class=\"padding-40 opacity-50\" ng-if=\"$root.user.getGeneralRecentItems().length == 0\"\n style=\"text-align: center;\">\n <img s3-src=\"/assets/images/empty-states/items.png\" class=\"fadeup\" style=\"width: 75%;\">\n <span class=\"md-headline font-weight-300\">No Recent Items</span>\n <span class=\"md-caption\">\n You haven\'t opened anything yet. As you view items they will appear here.\n </span>\n </div>\n </div>\n </md-menu-content>\n </md-menu> \n </md-tab-body>\n </md-tab>\n\n \n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-view-dashboard\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <md-list layout-fill class=\"padding-0\" flex>\n <md-virtual-repeat-container md-top-index=\"vm.unfTop\" class=\"widget-row-container-mobile\">\n <div ui-sref=\"shell.social.news-feed\" class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n News Feed\n <md-icon md-font-icon=\"zmdi zmdi-view-dashboard\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon> \n </div>\n \n <md-list-item md-virtual-repeat=\"unf in vm.unfs | orderBy: [\'-DateCreated\']\" ng-click=\"unf.$Post.open()\" style=\"border-bottom: solid thin whitesmoke;\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-10 margin-bottom-10\">\n <au-profile-image size=\"30\" item=\"unf.$Post.$Creator\" class=\"margin-top-4\"></au-profile-image>\n\n <div layout=\"column\" style=\"line-height:20px;\">\n <div layout=\"row\" layout-align=\"start center\" class=\"font-color-700\">\n <span class=\"md-caption font-weight-500\">{{unf.$Post.$Creator.FirstName}}</span>\n <div ng-if=\"unf.$Post.$Creator != unf.$Post.$Page.toString()\">\n <md-icon md-font-icon=\"zmdi zmdi-caret-right\" class=\"md-primary\" style=\"margin:-4px -8px -4px -4px;\"></md-icon>\n <span class=\"md-caption\">{{unf.$Post.$Page.toString()}}</span>\n </div>\n <span flex></span>\n </div>\n <span class=\"md-body-1\" style=\"word-break: break-word;word-wrap: break-word;\">{{unf.$Post.toString()}}</span>\n <span class=\"md-caption opacity-50\" am-time-ago=\"unf.DateCreated\"></span>\n </div>\n </div>\n </md-list-item>\n </md-virtual-repeat-container>\n </md-list>\n </md-tab-body>\n </md-tab>\n\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <md-list layout-fill class=\"padding-0\">\n <md-virtual-repeat-container md-top-index=\"vm.conversationTop\" class=\"widget-row-container-mobile\">\n <div ui-sref=\"shell.social.messages.list\" class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n Inbox\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon>\n </div>\n <md-list-item md-virtual-repeat=\"conversation in vm.conversations | orderBy: [\'-$LastMessageDate\', \'toString()\']\" ng-click=\"conversation.$key == \'Page\' ? $root.$injector.get(\'chats\').openChat(conversation) : conversation.open()\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-10 margin-bottom-10\">\n <au-profile-image size=\"30\" item=\"conversation\" class=\"margin-top-4\"></au-profile-image>\n <div layout=\"column\" class=\"dash-inbox\">\n <span class=\"md-caption font-weight-500 font-color-700\">{{conversation.toString(true)}}</span>\n <span class=\"md-body-1\">{{conversation.$LastMessageText}}</span>\n <span class=\"md-caption opacity-50\" am-time-ago=\"conversation.$LastMessageDate\"></span>\n </div>\n </div>\n </md-list-item>\n </md-virtual-repeat-container>\n </md-list>\n </md-tab-body>\n </md-tab>\n\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <md-list layout-fill class=\"padding-0\">\n <md-virtual-repeat-container md-top-index=\"vm.conversationTop\" class=\"widget-row-container-mobile\">\n <div ui-sref=\"shell.social.pages.events.upcoming.list\" class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n Event List\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon>\n </div>\n <div style=\"overflow:hidden; overflow-y: auto;\">\n <au-event-calendar show-only-details=\"true\"></au-event-calendar>\n </div>\n </md-virtual-repeat-container>\n </md-list>\n </md-tab-body>\n </md-tab>\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-trending-up\" class=\"font-size-3\"></md-icon>\n </md-tab-label>\n <md-tab-body>\n <div class=\"md-title font-color-100 background-color-700 text-center padding-10 padding-top-70 bottom-shadow\">\n Happiness Monitor\n <md-icon md-font-icon=\"zmdi zmdi-trending-up\" class=\"font-color-600 font-size-14 fadedown\" style=\"position:absolute;top:30px;right:-100px;\"></md-icon>\n </div>\n <div>\n <div>\n <div layout=\"row\" layout-align=\"space-between center\" class=\"padding-20\">\n <md-icon class=\"font-size-4 margin-right-20 md-primary grow\" md-font-icon=\"au au-mood-sad\" aria-hidden=\"true\">\n <md-tooltip>1 - Very unhappy</md-tooltip>\n </md-icon>\n <md-slider flex md-discrete ng-model=\"vm.currentHappiness\" step=\"1\" min=\"1\" max=\"5\" aria-label=\"rating\"></md-slider>\n <md-icon class=\"font-size-4 margin-left-20 md-primary grow\" md-font-icon=\"au au-mood-excited\" aria-hidden=\"true\">\n <md-tooltip>5 - Very happy</md-tooltip>\n </md-icon>\n </div>\n </div>\n <div layout=\"column\" layout-align=\"center center\" class=\"padding-bottom-30\">\n <md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.submitHappinessRating()\" ng-disabled=\"!vm.currentHappiness\">\n <span class=\"padding-10\">Submit \"{{vm.currentHappinessRating}}\" Rating</span>\n </md-button>\n </div>\n <div class=\"padding-20\">\n <div ng-if=\"vm.chartData[0].length > 0\">\n <div class=\"md-title margin-bottom-40 text-center\">Organization\'s Happiness</div>\n <div layout=\"row\" layout-align=\"center center\">\n <canvas class=\"chart chart-line\" chart-data=\"vm.chartData\" chart-labels=\"vm.chartDays\"></canvas>\n </div>\n </div>\n <div ng-if=\"vm.chartData[0].length == 0\" layout=\"column\" layout-align=\"top center\" class=\"padding-20\" style=\"text-align:center;\"\n id=\"GoodGraphEmptyState\">\n <img s3-src=\"/assets/images/empty-states/graph.png\" class=\"opacity-50\">\n <span class=\"md-headline font-weight-300 ng-binding\">Oh, graph!</span>\n <span class=\"md-caption ng-binding\">There is no data to display. Make sure to submit your happiness rating.</span>\n </div>\n </div>\n </div>\n </md-tab-body>\n </md-tab>\n\n </md-tabs>\n\n <!-- </md-card> -->\n\n</div>");
$templateCache.put("/app/home/dashboard.tmpl.html","<div class=\"home au-landing-page\" id=\"HomeDashboard\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\" style=\"position: fixed; top: 64px;\"></div>\n\n <md-content style=\"background: transparent;\" md-scroll-y flex=\"100\">\n <div layout-wrap=\"wrap-around\" layout=\"row\" layout-align=\"center start\" class=\"big-margin-content\">\n <!-- Quick Add / Send Menu -->\n <md-card class=\"widget background-color-700\">\n <div class=\"padding-20 background-color-600 bottom-shadow\" style=\"z-index:1;\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <span class=\"md-headline text-ellipsis\">Create Something New</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-plus\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n </div>\n\n <div style=\"overflow: hidden;overflow-y: auto\">\n <!--Send Menu-->\n <div>\n <md-menu md-position-mode=\"target-right target\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"background-color-900 padding-20 usercard-button\" ng-click=\"$mdOpenMenu($event)\">\n <span class=\"md-title\">Send Menu</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"font-color-100 font-size-4 faderight\" md-menu-origin></md-icon>\n </div>\n <md-menu-content>\n <div>\n <!--Compose Message-->\n <md-menu-item>\n <md-button ng-click=\"$root.composeMessage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/compose.png\" />\n <div>Compose Message</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--High Five-->\n <md-menu-item>\n <md-button ng-click=\"$root.sendHighFive()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/high-five.png\" />\n <div>Send High Five</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Post to Page-->\n <md-menu-item>\n <md-button ng-click=\"$root.postToPage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/post-to-page.png\" />\n <div>Post to Page</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Ask Question-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.QnA.CanCreate\">\n <md-button ng-click=\"$root.askQuestion()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/ask.png\" />\n <div>Ask Question</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Request Approval-->\n <md-menu-item>\n <md-button ng-click=\"$root.requestApproval()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/request.png\" />\n <div>Request Approval</div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n </md-menu-content>\n </md-menu>\n </div>\n\n <div ng-click=\"$root.auUtility.addNewItem(\'Task\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-800 padding-20 usercard-button\">\n <span class=\"md-title\">Task</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-task-check\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Document\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-700 padding-20 usercard-button\">\n <span class=\"md-title\">Document</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-file\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Project\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-600 padding-20 usercard-button\">\n <span class=\"md-title\">Project</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-project2\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Meeting\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-500 padding-20 usercard-button\">\n <span class=\"md-title\">Meeting</span>\n <span flex></span>\n <md-icon md-font-icon=\"au au-meeting\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Page\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-400 padding-20 usercard-button\">\n <span class=\"md-title\">Page</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-view-web\" class=\"font-color-100 font-size-4 grow\" style=\"transform:scaleX(-1)\"></md-icon>\n </div>\n <div ng-click=\"$root.auUtility.addNewItem(\'Contact\')\" layout=\"row\" layout-align=\"space-between center\" class=\"background-color-300 padding-20 usercard-button\">\n <span class=\"md-title\">Contact</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-account\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n <div ng-if=\"::$root.user.IsUserAdmin\" ng-click=\"$root.auUtility.addNewItem(\'User\')\" ng-if=\"::$root.user.IsUserAdmin\" layout=\"row\"\n layout-align=\"space-between center\" class=\"background-color-400 padding-20 usercard-button\">\n <span class=\"md-title\">User</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"font-color-100 font-size-4 grow\"></md-icon>\n </div>\n </div>\n </md-card>\n\n <!--Recent Items-->\n <md-card class=\"widget\">\n <div class=\"padding-20 background-color-600 bottom-shadow\" style=\"z-index:1;\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <span class=\"md-headline\">Recent Items</span>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-time-restore\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n </div>\n <div au-suspendable update-on-event=\"recent\" style=\"overflow: hidden;overflow-y: auto;\">\n <md-list ng-if=\"$root.user.getGeneralRecentItems().length > 0\" class=\"padding-0\">\n <md-list-item ng-repeat=\"recentItem in $root.user.getGeneralRecentItems() track by (recentItem.item.$key + recentItem.item._id)\"\n ng-click=\"recentItem.item.open()\" style=\"height:auto;\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-15 margin-bottom-15\" layout-fill>\n <au-profile-image item=\"recentItem.item\" size=\"25\" class=\"margin-right-10 grow\"></au-profile-image>\n <div class=\"column\" flex style=\"line-height: 20px;\">\n <div class=\"text-ellipsis\" ng-bind=\"recentItem.item.toString()\"></div>\n <div class=\"md-caption\" style=\"color: #999\">\n <span>Modified </span>\n <span am-time-ago=\"recentItem.item.LastModified.Date\"></span>\n </div>\n </div>\n </div>\n </md-list-item>\n </md-list>\n <!-- empty state -->\n <div ng-if=\"$root.user.getGeneralRecentItems().length == 0\" layout=\"column\" layout-align=\"center center\" class=\"padding-40 opacity-50\" style=\"text-align: center\">\n <img s3-src=\"/assets/images/empty-states/items.png\" class=\"fadeup\" style=\"width: 75%;\">\n <span class=\"md-headline font-weight-300\">No Recent Items</span>\n <span class=\"md-caption\">No recent items yet. Open something and it will appear here.</span>\n </div>\n </div>\n </md-card>\n\n <!--News Feed widget-->\n <md-card class=\"widget\" id=\"NewsfeedWidget\">\n <div ui-sref=\"shell.social.news-feed\" class=\"padding-20 background-color-600 bottom-shadow usercard-button\" style=\"height:100px;\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <span class=\"md-headline\">News Feed</span>\n <md-tooltip>Go to your Fullscreen News Feed</md-tooltip>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-view-dashboard\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n\n </div>\n <md-list layout-fill class=\"padding-0 faderight\">\n <md-virtual-repeat-container md-top-index=\"vm.unfTop\" class=\"widget-row-container\">\n <md-list-item md-virtual-repeat=\"unf in vm.unfs | orderBy: [\'-DateCreated\']\" ng-click=\"unf.$Post.open()\" style=\"border-bottom: solid thin whitesmoke;\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-10 margin-bottom-10\">\n <au-profile-image size=\"30\" item=\"unf.$Post.$Creator\" class=\"margin-top-4 grow\"></au-profile-image>\n\n <div layout=\"column\" style=\"line-height:20px;\">\n <div layout=\"row\" layout-align=\"start center\" class=\"font-color-700\">\n <span class=\"md-caption font-weight-500\">{{unf.$Post.$Creator.FirstName}}</span>\n <div ng-if=\"unf.$Post.$Creator != unf.$Post.$Page.toString()\">\n <md-icon md-font-icon=\"zmdi zmdi-caret-right\" class=\"md-primary\" style=\"margin:-4px -8px -4px -4px;\"></md-icon>\n <span class=\"md-caption\">{{unf.$Post.$Page.toString()}}</span>\n </div>\n <span flex></span>\n </div>\n <span class=\"md-body-1\" style=\"word-break: break-word;word-wrap: break-word;\">{{unf.$Post.toString()}}</span>\n <span class=\"md-caption\" style=\"color: #999\" am-time-ago=\"unf.DateCreated\"></span>\n </div>\n </div>\n </md-list-item>\n </md-virtual-repeat-container>\n </md-list>\n </md-card>\n <!--Inbox Widget-->\n <md-card class=\"widget\" id=\"InboxWidget\">\n <div ui-sref=\"shell.social.messages.list\" class=\"padding-20 background-color-600 bottom-shadow usercard-button\" style=\"height:100px;\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <span class=\"md-headline\">Inbox</span>\n <md-tooltip>Go to your Fullscreen Inbox</md-tooltip>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-inbox\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n\n </div>\n <md-list layout-fill class=\"padding-0\">\n <md-virtual-repeat-container md-top-index=\"vm.conversationTop\" class=\"widget-row-container\">\n <md-list-item md-virtual-repeat=\"conversation in vm.conversations | orderBy: [\'-LastPostDate\', \'toString()\']\" ng-click=\"conversation.$key == \'Page\' ? $root.$injector.get(\'chats\').openChat(conversation) : conversation.open()\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-10 margin-bottom-10\">\n <au-profile-image size=\"30\" item=\"conversation\" class=\"margin-top-4 grow\"></au-profile-image>\n <div class=\"unread-badge background-accent\" ng-if=\"conversation.UnreadCounts[$root.user._id]\" layout=\"column\" layout-align=\"center center\"\n ng-attr-id=\"DashInboxNumUnread{{$index}}\">\n {{conversation.UnreadCounts[$root.user._id]}}\n </div>\n <div layout=\"column\" class=\"dash-inbox fadeup\">\n <span class=\"md-caption font-weight-500 font-color-700\">{{conversation.toString(true)}}</span>\n <span class=\"md-body-1\" dynamic=\"(conversation.$fromUserText + \' \' + conversation.LastPostText) || \'Click to chat\'\"></span>\n <span class=\"md-caption\" style=\"color: #999\" am-time-ago=\"conversation.LastPostDate\"></span>\n </div>\n </div>\n </md-list-item>\n </md-virtual-repeat-container>\n </md-list>\n </md-card>\n <!-- Event List Widget -->\n <md-card class=\"widget\" id=\"EventsWidget\">\n <div class=\"padding-20 background-color-600 bottom-shadow usercard-button\" ui-sref=\"shell.social.pages.events.upcoming.list\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <div layout=\"column\">\n <span class=\"md-headline\">Event List</span>\n </div>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n </div>\n <div style=\"overflow:hidden; overflow-y: auto;\">\n <!-- prevent animation overflow + enable scroll-->\n <au-event-calendar show-only-details=\"true\"></au-event-calendar>\n </div>\n </md-card>\n <!-- Happiness Widget -->\n <md-card class=\"widget\" id=\"HappinessWidget\">\n <div class=\"padding-20 background-color-600 bottom-shadow usercard-button\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <div layout=\"column\">\n <span class=\"md-headline\">Happiness Monitor</span>\n </div>\n <span flex></span>\n <md-icon md-font-icon=\"zmdi zmdi-trending-up\" class=\"font-color-400 font-size-5\"></md-icon>\n </div>\n </div>\n <div class=\"margin-top-20 md-caption\" layout=\"column\" layout-align=\"center center\">\n How happy are you at {{$root.Organization.Name}}?\n </div>\n <div class=\"margin-20\" layout=\"column\" layout-align=\"center stretch\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <md-icon class=\"font-size-4 margin-right-20 md-primary grow\" md-font-icon=\"au au-mood-sad\" aria-hidden=\"true\">\n <md-tooltip>1 - Very unhappy</md-tooltip>\n </md-icon>\n <md-slider flex md-discrete ng-model=\"vm.currentHappiness\" step=\"1\" min=\"1\" max=\"5\" aria-label=\"rating\"></md-slider>\n <md-icon class=\"font-size-4 margin-left-20 md-primary grow\" md-font-icon=\"au au-mood-excited\" aria-hidden=\"true\">\n <md-tooltip>5 - Very happy</md-tooltip>\n </md-icon>\n </div>\n </div>\n <div layout=\"column\" layout-align=\"center center\">\n <md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"vm.submitHappinessRating()\" ng-disabled=\"!vm.currentHappiness\">\n <span class=\"padding-10\">Submit \"{{vm.currentHappinessRating}}\" Rating</span>\n </md-button>\n </div>\n <div class=\"padding-20\">\n <div ng-if=\"vm.chartData[0].length > 0\">\n <div class=\"md-title margin-bottom-20\">Organization\'s Happiness</div>\n <div layout=\"row\" layout-align=\"center center\">\n <canvas class=\"chart chart-line\" chart-data=\"vm.chartData\" chart-labels=\"vm.chartDays\"></canvas>\n </div>\n </div>\n <div ng-if=\"vm.chartData[0].length == 0\" layout=\"column\" layout-align=\"top center\" class=\"padding-20 opacity-50\" style=\"text-align:center;\"\n id=\"GoodGraphEmptyState\">\n <img s3-src=\"/assets/images/empty-states/graph.png\" style=\"width:75%\">\n <span class=\"md-headline font-weight-300 ng-binding\">Oh, graph!</span>\n <span class=\"md-caption ng-binding\">There is no data to display. Make sure to submit your happiness rating.</span>\n </div>\n </div>\n </md-card>\n </div>\n </md-content>\n</div>");
$templateCache.put("/app/_template/dialogs/some-wizard.tmpl.html","<md-dialog \n au-wizard dialog-title=\"Some Wizard\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Wizard Dialog\" \n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/add.png\">\n <h3>Need to do something?</h3>\n <p>A wizard dialog is a great way to make complex, long, tasks easy for a user to complete.</p>\n <p>Each step should have an h3 as a header and, usually, at least one p tag for contents.</p>\n </au-wizard-step>\n <au-wizard-step step-name=\"step2\" on-next-step=\"vm.confirmNextStep()\" step-bg=\"/assets/images/dialogs/email.png\">\n <h3>Step 2</h3>\n <p>If you do not add a step with step-name \"review\" and \"finished\", the directive will add them for you. For style, each step should also have a consistent step-bg.</p>\n <p>Forms are easy to implement, too. Take a look at Add User License Dialog for examples.</p>\n </au-wizard-step>\n <au-wizard-step step-name=\"step3\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Events</h3>\n <p>Use the following properties:\n <ul>\n <li>step - the wizard will populate this variable with the steps it finds in the mark up. Set any step to .visible = false to hide it from the user. Useful when the wizard should dyanmically show responses based on prior responses.</li>\n <li>disableNext - the wizard will disable the Next button if the expression evaluates to true.\n </p>\n <p>Handle the following events:\n <ul>\n <li>onReview - a function that must return an object like {error: boolean, details: [{name: \'fld1\', value: \'ok\'}]}</li>\n <li>onFinish - a function to run when the user clicks Finish. If the onReview.error is true, the Finish button is disabled.</li>\n <li>onClose - an optional function to run when the user clicks Close. If an error occurs during finish, this controller should reject the promise. In that event, the Close button is turning into Cancel, which just closes the dialog.</li>\n <li>onStepChange - an optional function to run whenever the user exits any step. It is passed the currentStep and the fromStep as the 1st and 2nd arguments, respectively.</li>\n <li>Step.onNextStep - an optional function to run when the user clicks Next on a step. Note this attribute is added to the au-wizard-step tag.</li>\n </ul>\n </p>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/_template/item/tmpl.html","<div class=\"_template-item-detail\">\n <ng-form name=\'editItem\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\" ignore-fields=\"[\'Field\',\'NamesTo\',\'Ignore\']\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" item=\"vm.item\">\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- another card (add as many as makes sense) -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Other Details</div>\n <div class=\"description\">Edit the description.</div>\n </div>\n <md-icon md-font-icon=\"au au-chess-piece\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Title-->\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n\n <!--Description-->\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"Description\" display-mode=\"field\" extra-plugins=\"au-task,table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\" style=\"border: solid thin rgb(224,224,224);\"\n placeholder=\"Description\" flex></div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/authentication/forgot/forgot.tmpl.html","<div class=\"forgot-bg\" layout-fill s3-background=\"/assets/images/login/forgotpassword.png\" layout=\"column\" layout-column=\"space-between-stretch\"\n style=\"min-height:100%; overflow-y:auto;\">\n <md-card class=\"padding-20 transparent\" layout=\"column\" layout-align=\"start stretch\">\n <div class=\"padding-20 text-center\">\n <div>\n <img class=\"center\" s3-src=\"/assets/images/login/logo.png\">\n <p>Forgot Your Password?\n <br/>Enter your email and we\'ll send you a recovery link.</p>\n </div>\n </div>\n <form name=\"forgot\">\n <md-input-container class=\"md-icon-float roundedinputfield\" md-no-float layout=\"row\" layout-align=\"start center\">\n <div class=\"margin-left-10\">\n <md-icon md-font-icon=\"zmdi zmdi-email\" style=\"font-size: 2em; top: 22px; left: 14px;\" class=\"bounce\"></md-icon>\n </div>\n <input id=\"email\" label=\"email\" placeholder=\"Email*\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\"\n required style=\"border-bottom:none; margin-left:10px; max-width: 270px;\" />\n </md-input-container>\n <div ng-messages=\"forgot.email.$error\" ng-if=\"forgot.email.$dirty\">\n <div ng-message when=\"required\">\n <span>Please enter your email.</span>\n </div>\n <div ng-message when=\"email\">\n <span>Please enter a valid email address.</span>\n </div>\n </div>\n\n <div layout=\"column\" layout-align=\"center center\">\n <md-button id=\"reset\" class=\"md-raised md-primary\" ng-click=\"vm.resetClick()\" ng-disabled=\"forgot.$invalid\" aria-label=\"Reset Password\">Reset Password</md-button>\n <md-button class=\"md-raised\" ui-sref=\"authentication.login\" aria-label=\"Log in\">Back to Login Page</md-button>\n </div>\n </form>\n </md-card>\n <div flex></div>\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-primary\" onclick=\"window.open(\'http://align.us\', \'_blank\')\" aria-label=\"Align Us\">\n <span class=\"md-caption\">\n <md-icon md-font-icon=\"au au-align\" class=\"margin-right-3\"></md-icon>Align Us, Inc.</span>\n </md-button>\n <md-button class=\"md-primary\" ui-sref=\"authentication.tos\" target=\"_blank\" aria-label=\"Terms of Service\">\n <span class=\"md-caption\">Terms of Service</span>\n </md-button>\n </div>\n</div>");
$templateCache.put("/app/authentication/layouts/authentication.tmpl.html","<!--TA187: (done) remove mg-bg-fb-05 and replace with https://s3.amazonaws.com/alignusstatic/UI/login/login-bg.jpg\nCreate a class in authentication.module.scss for re-use. -->\n<div class=\"full-image-background overflow-x-hidden overflow-auto constrain-to-screen\" flex layout=\"column\" layout-fill layout-align=\"center stretch\" id=\'authBG\' s3-background=\"/assets/images/login/bg.jpg\">\n <div class=\"animate-wrapper-fullscreen\" flex layout=\"column\">\n <div id=\"ui-login\" class=\"full-height login-frame angular-animate\" ui-view flex layout=\"row\"></div>\n </div>\n</div>");
$templateCache.put("/app/authentication/login/login.tmpl.html","<div class=\"login-bg\" layout-fill s3-background=\"/assets/images/login/desk2.png\" style=\"min-height:100%; overflow-y:auto;\"\n layout=\"column\" layout-column=\"space-between-stretch\">\n\n <md-card class=\"padding-20 transparent\">\n <div>\n <div class=\"padding-20 text-center\" layout=\"row\" layout-align=\"center center\">\n <div>\n <img class=\"center\" s3-src=\"/assets/images/login/logo.png\">\n </div>\n </div>\n </div>\n\n <div>\n <form name=\"login\">\n <div class=\"google-button margin-top-40\" ng-click=\"vm.loginWith(\'google\')\" style=\"width:220px; height:50px; margin:auto\"></div>\n\n <div class=\"margin-10\" style=\"text-align:center\">or</div>\n \n <md-input-container class=\"md-icon-float roundedinputfield\" md-no-float layout=\"row\" layout-align=\"start center\">\n <div class=\"margin-left-10\">\n <md-icon md-font-icon=\"zmdi zmdi-email\" style=\"font-size: 2em; width: 30px;\" class=\"grow\"></md-icon>\n </div>\n <input id=\"email\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" placeholder=\"Email*\" required style=\"border-bottom:none; max-width: 270px; margin-left: 10px;\"\n autocomplete=\"username email\" />\n </md-input-container>\n\n <md-input-container class=\"md-icon-float roundedinputfield\" md-no-float layout=\"row\" layout-align=\"start center\">\n <div class=\"margin-left-10\">\n <md-icon md-font-icon=\"zmdi zmdi-key\" style=\"font-size: 2em; width: 30px;\" class=\"grow\"></md-icon>\n </div>\n <input id=\"password\" label=\"password\" name=\"password\" type=\"password\" ng-model=\"vm.user.password\" placeholder=\"Password*\"\n required style=\"border-bottom:none; margin-left: 10px; max-width: 270px;\" autocomplete=\"current-password\"\n />\n </md-input-container>\n\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-20\">\n <button id=\"login\" class=\"md-button md-raised md-primary iconright\" ng-click=\"vm.loginClick()\" ng-disabled=\"login.$invalid\"\n aria-label=\"Login\">\n <span>Login</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </button>\n\n <md-button class=\"md-raised\" ui-sref=\"authentication.forgot\" aria-label=\"Forgot Password\">Forgot Password</md-button>\n <md-button class=\"md-raised\" ui-sref=\"authentication.signup\" aria-label=\"Sign Up\">Sign Up</md-button>\n <md-button ui-sref=\"authentication.signup\" ng-if=\"vm.devMode\" aria-label=\"(dev signup)\">(dev signup)</md-button>\n </div>\n </form>\n </div>\n </md-card>\n <div flex></div>\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-20\">\n <a class=\"md-primary center\" onclick=\"window.open(\'http://align.us\', \'_blank\')\" aria-label=\"Align Us\">\n <span class=\"md-caption\">\n <md-icon md-font-icon=\"au au-align\" class=\"margin-right-3\"></md-icon>Align Us, Inc. 2018</span>\n </a>\n </div>\n\n</div>");
$templateCache.put("/app/authentication/select/select.tmpl.html","<div class=\"login-bg\" layout-fill layout=\"column\" layout-column=\"space-between stretch\" s3-background=\"/assets/images/login/desk2.png\">\n <md-card class=\"padding-20 transparent\">\n <div class=\"padding-20 text-center\">\n <img class=\"center\" s3-src=\"/assets/images/login/logo.png\">\n <div ng-if=\"vm.users.length > 0\" class=\"md-body-2 margin-top-10\">Awesome! You have accounts in multiple organizations.\n <div class=\"md-body-2\">-- Select One --</div>\n </div>\n <div ng-if=\"vm.users.length == 0\">\n Hmmm... this device has no logged in users.\n </div>\n\n </div>\n <div class=\"md-padding\" layout=\"column\">\n <div class=\"roundedinputfield material-card material-shadow hover-container\" style=\"margin:10px 0;\" ng-repeat=\"user in vm.users | orderBy: \'-LastModified.Date\'\"\n ng-click=\"vm.loginClicked(user)\" layout=\"row\">\n <img ng-if=\"!user.Organization.Photo\" src=\"/assets/images/logo.png\" width=\"50\" height=\"50\" style=\"background-size:cover;\"\n />\n <div ng-if=\"user.Organization.Photo\" style=\"width:50px;height:50px;border-radius:50%;background-size:cover;\" ng-style=\"{ backgroundImage: \'url(https://s3.amazonaws.com/alignussecure/{{user.Organization._id}}/{{user.Organization.Photo}})\'}\"></div>\n <div flex style=\"margin-left:20px;\" layout=\"column\">\n <div class=\"md-body-2\">{{user.Organization.Name}}</div>\n <div class=\"md-caption font-weight-400\">{{user.FirstName + \' \' + user.LastName}}</div>\n </div>\n <div class=\"show-on-hover-container\" ng-if=\"vm.showingUserSelect\">\n <md-button class=\"md-icon-button\" ng-click=\"vm.logout(user); $event.stopPropagation()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" class=\"font-color-100\"></md-icon>\n <md-tooltip>Log user off this device</md-tooltip>\n </md-button>\n </div>\n </div>\n <div ng-if=\"vm.users.length == 0\">\n <img src=\"\\assets\\images\\empty-states\\meeting.png\" />\n </div>\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-80\">\n <button id=\"add-account\" class=\"md-button md-raised md-primary iconright\" aria-label=\"Add Account\" ui-sref=\"authentication.login({uls: true})\">\n <span>Add Account</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </button>\n <button id=\"login\" class=\"md-button md-raised iconright\" ng-click=\"vm.closeWindow()\" aria-label=\"Close Window\">\n <span>Close Window</span>\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </button>\n </div>\n </div>\n </md-card>\n <div flex></div>\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-80\">\n <a class=\"md-primary center\" onclick=\"window.open(\'http://align.us\', \'_blank\')\" aria-label=\"Align Us\">\n <span class=\"md-caption\">\n <md-icon md-font-icon=\"au au-align\" class=\"margin-right-3\"></md-icon>Align Us, Inc.</span>\n </a>\n </div>\n</div>");
$templateCache.put("/app/authentication/signup/password.messages.html","<div ng-message when=\"required\">\n <span>Password required.</span>\n</div>\n<div ng-message when=\"minlength\">\n <span>Password must have at least six characters.</span>\n</div>\n<div ng-message when=\"samePassword\">\n <span>Passwords don\'t match.</span>\n</div>\n");
$templateCache.put("/app/authentication/signup/signup.tmpl.html","<script src=\'https://www.google.com/recaptcha/api.js\'></script>\n<!-- Hotjar Tracking Code for https://app.align.us/signup --> \n<script> (function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:953538,hjsv:6}; a=o.getElementsByTagName(\'head\')[0]; r=o.createElement(\'script\');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,\'https://static.hotjar.com/c/hotjar-\',\'.js?sv=\'); </script>\n\n<div class=\"signup-bg\" layout=\"row\" layout-align=\"start start\" s3-background=\"/assets/images/login/building.png\" style=\"overflow-y: auto; min-height: 100%;\">\n <div layout=\"row\" layout-xs=\"column\">\n <div class=\"padding-30\" flex layout=\"column\" layout-align=\"start center\">\n <div style=\"max-width: 600px;\">\n <div class=\"text-center margin-bottom-20\" layout=\"column\">\n <img class=\"center\" s3-src=\"/assets/images/login/logo-beta.png\" style=\"width:400px\">\n <span class=\"md-headline\">Create New Organization</span>\n <span class=\"md-body-1\">If your organization already uses Align Us, ask your administrator to add your account.</span>\n </div>\n\n <form name=\"signup\" layout=\"column\">\n <md-input-container class=\"md-icon-float margin-bottom-0\">\n <label for=\"organization\">Organization Name</label>\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\" class=\"opacity-50\"></md-icon>\n <input id=\"TxtOrganization\" label=\"organization\" name=\"organization\" type=\"text\" ng-model=\"vm.user.organization\" required/>\n </md-input-container>\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container class=\"md-icon-float\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-balance\" class=\"opacity-50\"></md-icon>\n <md-select ng-model=\"vm.user.industry\" placeholder=\"Organization Type\" id=\"DrpOrgType\">\n <md-option ng-repeat=\"industry in vm.industries\" ng-attr-id=\"DrpOrgTypeOption{{$index}}\">{{industry}}</md-option>\n </md-select>\n </md-input-container>\n <au-help-icon class=\"md-accent\" key=\"OrgSettings.Industry\"></au-help-icon>\n </div>\n <div layout=\"column\" layout-align=\"start start\">\n <div layout=\"row\" class=\"margin-bottom-16\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"margin-left-2 opacity-70\"></md-icon>\n <div class=\"margin-left-13\">How are you hoping to use Align Us? (check all that apply)</div>\n </div>\n <div class=\"margin-left-40\">\n <md-checkbox class=\"md-primary\" ng-model=\"vm.user.signUpGoals.project\">To track group <strong>projects</strong> (fundraisers, events, and more)</md-checkbox>\n <md-checkbox class=\"md-primary\" ng-model=\"vm.user.signUpGoals.handbook\">For my group\'s <strong>handbook</strong></md-checkbox>\n <md-checkbox class=\"md-primary\" ng-model=\"vm.user.signUpGoals.social\">As my group\'s <strong>communication</strong> and collaboration hub</md-checkbox>\n <md-checkbox class=\"md-primary\" ng-model=\"vm.user.signUpGoals.event\" ng-disabled=\"true\">Event Management - Coming Soon!</md-checkbox>\n </div>\n </div>\n <div layout=\"row\" layout-sm=\"column\">\n <md-input-container class=\"md-icon-float margin-right-20\" flex>\n <label for=\"city\">City, State/Prov (and Country if not USA)</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"opacity-50\"></md-icon>\n <input id=\"TxtCity\" label=\"city\" name=\"city\" type=\"text\" ng-model=\"vm.user.city\" required/>\n </md-input-container>\n </div>\n\n\n <p class=\"md-caption margin-top-40\">Please enter your name and email below. You will be the initial administrator for your organization and add the other\n users.\n </p>\n <div layout=\"row\" layout-sm=\"column\">\n <md-input-container class=\"md-icon-float\" flex>\n <label for=\"first-name\">First Name</label>\n <md-icon md-font-icon=\"zmdi zmdi-face\" class=\"opacity-50\"></md-icon>\n <input id=\"TxtFirstName\" label=\"first-name\" name=\"first-name\" type=\"text\" ng-model=\"vm.user.firstName\" required/>\n <div ng-messages=\"signup.firstName.$error\">\n <div ng-message when=\"required\">\n <span>First name is required</span>\n </div>\n </div>\n </md-input-container>\n <md-input-container class=\"md-icon-float\" flex>\n <label for=\"lastname\" class=\"noicon\">Last Name</label>\n <md-icon md-font-icon=\"zmdi zmdi-face\" class=\"opacity-50\" style=\"visibility: hidden;\"></md-icon>\n <input id=\"TxtLastName\" label=\"lastname\" name=\"lastname\" type=\"text\" ng-model=\"vm.user.lastName\" required/>\n <div ng-messages=\"signup.lastName.$error\">\n <div ng-message when=\"required\">\n <span>Last name is required</span>\n </div>\n </div>\n </md-input-container>\n </div>\n <md-input-container class=\"md-icon-float\">\n <label for=\"email\">Email</label>\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"opacity-50\"></md-icon>\n <input id=\"TxtEmail\" label=\"email\" name=\"email\" type=\"email\" ng-model=\"vm.user.email\" required pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\" autocomplete=\"username password\"\n />\n <div ng-messages=\"signup.email.$error\">\n <div ng-message when=\"email\">\n <span>Email is invalid</span>\n </div>\n </div>\n </md-input-container>\n\n\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-40\">\n <div class=\"g-recaptcha\" data-sitekey=\"6LcfMEMUAAAAAPL1FZ28TSSYAIgWxWWdYXUGRng7\" data-callback=\"recaptchaResp\"></div>\n <input type=\"text\" ng-model=\"vm.user.captcha\" ng-required=\"true\" class=\"display-none\">\n <md-button style=\"width:304px;\" id=\"BtnSignup\" class=\"md-raised md-primary\" ng-click=\"vm.signupClick()\" ng-disabled=\"signup.$invalid\">Sign Up\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n <md-button class=\"margin-bottom-10 md-raised\" ui-sref=\"authentication.login\" id=\"BtnLogin\">Back to Log In Page</md-button>\n <div class=\"md-caption\">By signing up you agree to the <a ui-sref=\"authentication.tos\" aria-label=\"Terms of Service\">Terms of Service</a></div>\n </div>\n\n </form>\n </div>\n\n </div>\n\n <div flex=\"30\" flex-xs=\"100\" flex-sm=\"50\" style=\"margin:0;background: #be1e2d;\" style=\"height:100%\">\n <div class=\"beta-copy padding-30\">\n <div class=\"font-size-3 font-weight-300\">Exclusive Beta Access</div>\n <div>\n <p class=\"md-caption\">Welcome to your exclusive first look at Align Us! You will be using the Beta Version of Align Us until we launch the\n full product. This means that everything you can see and do within Align Us is the real deal but not the final version.\n We will be continually upgrading the system until we are ready to launch. We are so excited you’re here! Your experience\n and feedback are going to shape the product and make it better for all users. Beta users will be first in line for\n product updates and customized features at your request!</p>\n <p class=\"md-caption\">Since this is not the final version of Align Us there are a couple of things you should watch out for:</p>\n <ul class=\"md-caption\" style=\"margin-left: -25px;\">\n <li>When you create documents, projects and meetings you should use naming conventions to organize them. Folders and grouping\n of items is in development.</li>\n <li>There is no support for task dependencies or very complex project management charts like Gannt or waterfalls. These\n are in our backlog.</li>\n <li>Our mobile support is poor. This is currently being addressed and expected to be much better in the coming weeks.</li>\n </ul>\n <p class=\"md-caption\">While you use the Beta Version of Align Us, it is free of charge! You can add as many users as you want to your organization\n at no cost. Our offical launch won\'t be until at least October, and as a special thank you to all of our Beta users,\n we are waiving six additional months of fees after launch. So, it\'s likely you\'ll have nine to twelve months of unlimited\n usage for no charge, just for helping us root out all the bugs and providing your feedback. After our Beta Offer closes,\n organizations can purchase user licenses in blocks of $25/month for 25 users. </p>\n <p class=\"md-caption\">We only want one thing from you: your honest opinion. You can send us feedback at any time through the Help &amp; Setting\n menu. We would love it if you sent us feedback multiple times! Here are some things we want you to look for:</p>\n <ul class=\"md-caption\" style=\"margin-left: -25px;\">\n <li>Anything that doesn’t make sense. If you are looking at a page and you feel confused, send us a screenshot and tell\n us about your confusion. We want to make sure that Align Us is easy to understand.</li>\n <li>Bugs and typos. If something isn’t working the way you expected it to, let us know right away. </li>\n <li>Taking the next step. What else can Align Us do for you? Is there a certain type of report that you wish you could\n easily run? Tell us what you want to do and we’ll do our best to make your dreams come true.</li>\n </ul>\n </div>\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-20\">\n <md-button class=\"md-raised\" ui-sref=\"authentication.tos\" aria-label=\"Terms of Service\">\n <span class=\"md-caption\">Terms of Service</span>\n </md-button>\n <md-button class=\"md-raised\" onclick=\"window.open(\'http://align.us\', \'_blank\')\" aria-label=\"Align Us\">\n <md-icon md-font-icon=\"au au-align\"></md-icon>\n <span class=\"md-caption\">Align Us, Inc.</span>\n </md-button>\n </div>\n\n </div>\n </div>\n </div>\n\n\n</div>");
$templateCache.put("/app/authentication/tos/tos.tmpl.html","<div class=\"login-bg full-height\" layout=\"row\" flex layout-padding layout-align=\"center start\">\n <div flex=\"40\" flex-lg=\"50\" flex-md=\"80\" flex-sm=\"100\" flex-xs=\"100\">\n <div class=\"padding-20 text-center\">\n <div><img s3-src=\"/assets/images/login/logo.png\" style=\"width:200px\"></div>\n <h3 flex>Terms of Service</h5>\n <md-button class=\"md-primary\" ui-sref=\"authentication.signup\" id=\"BtnLogin\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>\n Back to Sign Up\n </md-button>\n </div>\n\n <div class=\"padding-40 md-whiteframe-1dp\" style=\"background:white; height:100%; display:inline-table;\">\n <div>\n <h5>NOTICE TO USER:</h5>\n <p class=\"md-caption\">This Align Us Beta Software Agreement (“Agreement”) is a CONTRACT between you (either an individual or a single entity)\n (“Licensee” or “you”) and Align Us Inc (“the Company”), which covers your use of the Align Us Inc beta software  and/or\n service that accompanies this Beta-Software Agreement and related software components, which may include associated\n media, printed materials, and “online” or electronic documentation. All such software and materials are referred to\n herein as the “Beta Software”. If you do not agree to the terms of this Beta Software Agreement, then do not access\n or use the Beta Software. By explicitly accepting this Beta-Software Agreement, however, or by accessing, or otherwise\n using the Beta Software, you are acknowledging and agreeing to be bound by the following terms.</p>\n\n <h5>1. DEFINITIONS</h5>\n <p class=\"md-caption\">(a) “Beta Software” shall mean the software hosted by app.align.us including any Updates thereto, in service, object\n and source form, and the media and Documentation provided by the Company to Licensee and for which Licensee is granted\n a use license pursuant to this Agreement. (b) “Documentation” shall mean the printed or online written reference material\n furnished to Licensee in conjunction with the Beta Software, including, without limitation, instructions, run rules,\n beta testing guidelines, and end user guides. (c) “Intellectual Property Rights” shall mean all intellectual property\n rights, including, without limitation, patent, copyright, trademark, and trade secret. (d) “Updates” shall mean a modification,\n error correction, bug fix, new release, or other update to or for the Beta Software. (e) “Confidential Information”\n means all non-public materials and information provided or made available by Company to Licensee, including products\n and services, characteristics, performance, the Beta Software itself, information regarding technology, know-how, processes,\n software programs, research, development, financial information and information the Company provides regarding third\n parties.\n </p>\n\n <h5>2. LICENSE GRANT, USE AND OWNERSHIP</h5>\n <p class=\"md-caption\">(a) Limited License. Subject to the terms and conditions of this Agreement, the Company grants to Licensee a non-exclusive,\n nontransferable license (without the right to sublicense) (i) to use the Beta Software in accordance with the Documentation\n solely for purposes of internal testing and evaluation, (ii) to use the Documentation provided with the Beta Software\n in support of Licensee’s authorized use of the Beta Software. Nothing in this limited license permits Licensee to modify\n the Beta Software. (b) Evaluation Feedback. The purpose of this limited license is the testing and evaluation of the\n Beta Software and Documentation. In furtherance of this purpose, Licensee shall provide feedback to the Company concerning\n the functionality and performance of the Beta Software from time to time as reasonably requested by the Company, including,\n without limitation, identifying potential errors, improvements, modifications, bug fixes, or enhancements (“Feedback”).\n Such Feedback will be in a manner convenient to Licensee and will be subject to reasonable availability of Licensee’s\n personnel. Notwithstanding the foregoing, prior to Licensee disclosing to the Company any information in connection\n with this Agreement which Licensee considers proprietary or confidential, Licensee shall obtain the Company’s prior\n written approval to disclose such information to the Company, and without such prior written approval from the Company,\n Licensee shall not disclose any such information to the Company. Feedback and other information which is provided by\n Licensee to the Company in connection with the Beta Software or this Agreement may be used by the Company to improve\n or enhance its products and, accordingly, Licensee grants the Company a non-exclusive, perpetual, irrevocable, royalty-free,\n worldwide right and license to use, reproduce, disclose, sublicense, distribute, modify, and otherwise exploit such\n Feedback and information without restriction. (c) Restrictions. Licensee shall not copy or use the Beta Software (including\n the Documentation) or disseminate Confidential Information, as defined below, to any third party except as expressly\n permitted in this Agreement. Licensee will not, and will not permit any third party to, sublicense, rent, copy, modify,\n create derivative works of, translate, reverse engineer, decompile, disassemble, or otherwise reduce to human perceivable\n form any portion of the Beta Software or accompanying Documentation. (d) Ownership. The Company shall own and retain\n all right, title and interest in and to the Intellectual Property Rights in the Beta Software and any derivative works\n thereof, subject only to the limited license expressly set forth in Section 2(a) hereof. Licensee does not acquire any\n other rights, express or implied, in the Beta Software. ALL RIGHTS NOT EXPRESSLY GRANTED HEREUNDER ARE RESERVED TO THE\n COMPANY. (e) No Support Services. Though we provide superior support and updates as a business practice, The Company\n is under no obligation to support the Beta Software in any way or to provide any Updates to Licensee. In the event the\n Company, in its sole discretion, supplies any Update to Licensee, such Update shall be deemed Beta Software hereunder\n and shall be subject to the terms and conditions of this Agreement.</p>\n\n <h5>3. TERM AND TERMINATION</h5>\n <p class=\"md-caption\">Unless otherwise terminated as specified under this Agreement, Licensee’s rights with respect to the Beta Software will\n terminate upon the earlier of (a) 6 months after the initial release by the Company of a generally available version\n of the Beta Software or (b) one year after acceptance of this agreement. Both parties may terminate this Agreement at\n any time for any reason or no reason. The Company shall immediately terminate this Agreement and any Licensee rights\n with respect to the Beta Software without notice in the event of improper disclosure of the Company’s Beta Software\n as specified under Section 4 (Confidentiality) below. Upon any expiration or termination of this Agreement, the rights\n and licenses granted to Licensee under this Agreement shall immediately terminate, and Licensee shall immediately cease\n using the Beta Software, Documentation, and all other tangible items in Licensee’s possession or control that are proprietary\n to or contain Confidential Information. The rights and obligations of the parties set forth in Sections 2(b) 2(c), 2(d),\n 2(e), 2(f), 3, 4, 5, 6 and 7 shall survive termination or expiration of this Agreement for any reason.</p>\n\n <h5>4. CONFIDENTIALITY</h5>\n <p class=\"md-caption\">Product, Align Us Beta Software, Align Us, Inc Intellectual Property, and benchmark test results are Align Us, Inc’s\n confidential information (“Confidential Information”). Licensee will use Confidential Information solely according to\n the License Terms. Licensee will take commercially reasonable steps to safeguard Align Us, Inc Confidential Information,\n including no less than the steps taken to protect its own Confidential Information. Licensee must promptly notify Align\n Us, Inc in writing of unauthorized use or disclosure of Confidential Information and, at its expense, take all reasonable\n action to recover Confidential Information and prevent further unauthorized use or disclosure, including injunctive\n relief. If Licensee fails to do so, Align Us, Inc may do so at Licensee\'s expense. These Terms survive as long as Confidential\n Information is in Licensee’s possession. Confidential Information does not include information that is publicly available\n without Licensee’s breach of these Terms; proven to have been known by Licensee prior to this Agreement or independently\n developed by Licensee without breach of these Terms; or provided to Licensee without confidentiality obligation. Product\n is not deemed to be placed in the public domain by Align Us, Inc.</p>\n\n <h5>5. LIMITATION OF LIABILITY</h5>\n <p class=\"md-caption\">IT IS UNDERSTOOD THAT THE BETA SOFTWARE IS PROVIDED WITHOUT CHARGE FOR LIMITED EVALUATION PURPOSES. ACCORDINGLY, THE\n TOTAL LIABILITY OF THE COMPANY AND ITS SUPPLIERS ARISING OUT OF OR RELATED TO THIS AGREEMENT SHALL NOT EXCEED $1 US\n DOLLAR. IN NO EVENT SHALL THE COMPANY OR ITS SUPPLIERS HAVE LIABILITY FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL\n DAMAGES (INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION, OR LOSS OF BUSINESS\n INFORMATION), HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, EVEN IF THE COMPANY AND ITS SUPPLIERS HAVE BEEN ADVISED\n OF THE POSSIBILITY OF SUCH DAMAGES. THESE LIMITATIONS SHALL APPLY NOTWITHSTANDING ANY FAILURE OF ESSENTIAL PURPOSE OF\n ANY LIMITED REMEDY.</p>\n\n <h5>6. WARRANTY DISCLAIMER</h5>\n <p class=\"md-caption\">IT IS UNDERSTOOD THAT THE BETA SOFTWARE, DOCUMENTATION, AND ANY UPDATES MAY CONTAIN ERRORS AND ARE PROVIDED FOR LIMITED\n EVALUATION ONLY. THE BETA SOFTWARE, THE DOCUMENTATION, AND ANY UPDATES ARE PROVIDED “AS IS” WITHOUT WARRANTY OF ANY\n KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE. THE COMPANY AND ITS SUPPLIERS SPECIFICALLY DISCLAIM ALL IMPLIED\n WARRANTIES OF MERCHANTABILITY, NONINFRINGEMENT, AND FITNESS FOR A PARTICULAR PURPOSE. Licensee acknowledges that the\n Company has not promised or guaranteed to Licensee that such Beta Software will be announced or made available to anyone\n in the future, that the Company has no express or implied obligation to Licensee to announce or introduce the Beta Software,\n and that the Company may not introduce a product similar or compatible with the Beta Software. Accordingly, Licensee\n acknowledges that any research or development that it performs regarding the Beta Software or any product associated\n with the Beta Software is done entirely at Licensee’s own risk. Specifically, the Beta Software may contain features,\n functionality or modules that will not be included in the production version of the Beta Software, if released, or that\n will be marketed separately for additional fees.</p>\n\n <h5>7. OTHER PROVISIONS</h5>\n <p class=\"md-caption\">(a) Governing Law. This Agreement, and all disputes arising out of or related thereto shall be governed by and construed\n under the laws of the State of Illinois, United States of America, without reference to conflict of laws principles.\n All such disputes shall be subject to the exclusive jurisdiction of the state and federal courts located in Illinois,\n United States of America, and the parties agree and submit to the personal and exclusive jurisdiction and venue of these\n courts. (b) Assignment. Licensee shall not assign this Agreement or any rights or obligations hereunder, directly or\n indirectly, by operation of law, merger, acquisition of stock or assets, or otherwise, without the prior written consent\n of the Company. Subject to the foregoing, this Agreement shall inure to the benefit of and be binding upon the parties\n and their respective successors and permitted assigns. (c) Modification. This is the entire agreement between the parties\n relating to the subject matter hereof and all other terms are rejected. No waiver or modification of this Agreement\n shall be valid unless in writing signed by each party. The waiver of a breach of any term hereof shall in no way be\n construed as a waiver of any term or other breach hereof. If any provision of this Agreement is held by a court of competent\n jurisdiction to be contrary to law the remaining provisions of this Agreement shall remain in full force and effect.</p>\n\n <h5>CONTACT INFORMATION</h5>\n <p class=\"md-caption\">If you have any questions about this Software Beta Test Agreement, or to contact the Company for any reason, please direct electronic correspondence to: mr.service@align.us </p>\n\n\n\n\n </div>\n\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-60\">\n <md-button class=\"md-raised md-primary\" ui-sref=\"authentication.signup\" id=\"BtnLogin\"><md-icon md-font-icon=\"zmdi zmdi-arrow-left\"></md-icon>Back to Sign Up</md-button>\n <md-button class=\"md-primary\" onclick=\"window.open(\'http://align.us\', \'_blank\')\" aria-label=\"Align Us\"><span class=\"md-caption\"><md-icon md-font-icon=\"au au-align\" class=\"margin-right-3\"></md-icon>2018 Align Us, Inc.</span></md-button>\n </div>\n </div>\n\n </div>\n</div>");
$templateCache.put("/app/document/dialogs/add-doc.tmpl.html","<md-dialog\n au-wizard dialog-title=\"Add Document\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Add Document Dialog\"\n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddDoc\">\n\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <h3>Create A New Document</h3>\n <div>A document is a blank page that you can use to collaborate with peers. With real time updates everyone can work on the document at the same time and see each other\'s changes as they happen. Create tasks through the document by typing [ ] with no space between. Each task will be assigned to you by default.</div>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/document-tasks.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/document-collaborate.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/document-privacy.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Create tasks through the document by typing [ ] with no space between.</div>\n <div class=\"padding-20\" flex=\"33\">Work on the document at the same time and see each other\'s changes as they happen.</div>\n <div class=\"padding-20\" flex=\"33\">Control your document\'s editors and privacy settings.</div>\n </div>\n <au-from-template-state-button item-type=\"Document\"></au-from-template-state-button> \n </au-wizard-step>\n\n <au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleEntered()\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <h3>Document Title</h3>\n <p>This title will be displayed across Align Us to represent this document. It should be clear and concise.</p>\n <!--for BETA-->\n <div class=\"background-accent padding-10 padding-bottom-20\" layout=\"column\" layout-align=\"start center\" style=\"color: white;\">\n <h3>BETA Note - Folders in Development - Use Naming Conventions</h3>\n <p style=\"margin: 0px; color: white; text-align: center;\">Name your document like this example: Phase 1 - Market Research. <br>Where \'Phase 1\' is the Folder name and \'Market Research\' is the Document name.</p>\n </div>\n <md-input-container>\n <label>Title</label>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <input ng-model=\"vm.document.Title\" required id=\"TxtDocTitle\"/>\n </md-input-container>\n\n <h3>Editors and Privacy</h3>\n <p>By default, documents are read-only to everyone in your organization. If you set the document to private, only assigned editors will have access to this document.</p>\n \n <div layout-align=\"start center\" layout=\"row\" flex>\n <span class=\"margin-right-10\">All Users in {{vm.orgName}}</span>\n <md-switch class=\"md-primary\" ng-model=\"vm.document.IsPrivate\" id=\"SwitchPrivate\"></md-switch>\n <span class=\"margin-left-10\">Editors Only</span>\n </div>\n\n <!--editor-->\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.document.Editors\" md-require-match=\"true\" flex md-transform-chip=\"$root.auUtility.preventDuplicates(vm.document.Editors, $chip); $root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.document.Editors})\">\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.editorsSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.editorsSearchText, excludeContacts: true, showAdd: true})\" \n placeholder=\"Add Editor\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtDocEditor\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.editorsSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoDocEditor{{$index}}\">\n {{user | auItemFilter: \'User\'}}\n </span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipDocEditor{{$index}}\">{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </au-wizard-step>\n<!--end wire up-->\n</md-dialog>");
$templateCache.put("/app/document/item/tmpl.html","<div class=\"document-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!--Document Editor Card-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentEditorHeader\">\n <div class=\"md-title\">Document</div>\n <div class=\"description\">Edit the document itself.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <div class=\"au-cke-document\" item=\"vm.item\" item-field=\"Content\" can-edit=\"vm.item\" acl=\"U\" auto-focus=\"true\" document-id=\"vm.item._id\"\n resize-trigger=\"vm.resizeDoc\"></div>\n </div>\n </md-card>\n\n <!-- Security and Sharing -->\n <md-card ng-if=\"!$root.user.$AnonymousUser && vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Security and Sharing</div>\n <div class=\"description\">Control who has read/write access to this document.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <au-item-security-and-sharing item=\"vm.item\"></au-item-security-and-sharing>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Discussion Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDiscussionHeader\">\n <div class=\"md-title\">Discussion</div>\n <div class=\"description\">Document conversation board.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-discussion-board item=\"vm.item\" activity-log=\"true\"></au-discussion-board>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Workflows Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-workflow\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"\n style=\"width: 1.28571em;\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Workflows</div>\n <div class=\"description\">Collection box for all your approval requests.</div>\n </div>\n <md-icon md-font-icon=\"au au-workflow\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\" style=\"width: 1.28571em;\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-workflows item=\"vm.item\"></au-workflows>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings related to this document.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n <p>&nbsp;</p>\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/fundraiser/dialogs/buy-now.tmpl.html","<script src=\"https://js.stripe.com/v3/\"></script>\n<md-dialog class=\"au-dialog fundraiser-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\"\n style=\"min-height: 480px\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Buy Now</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 10px 10px 0 10px;\">\n\n <div id=\"items\" ng-show=\"vm.stepNbr == 0\">\n <div au-cover-photo item=\"$root.fundraiser\" layout=\"row\" layout-align=\"center center\" layout-fill style=\"height: 150px; margin-bottom: 75px;\">\n <au-profile-image item=\"$root.fundraiser\" size=\"100\" style=\"margin-top: 150px;\"></au-profile-image>\n </div>\n\n <p class=\"md-body-1\" dynamic=\"$root.fundraiser.BuyNowIntro\"></p>\n\n <md-divider class=\"margin-0\"></md-divider>\n\n <p class=\"margin-bottom-20\">Please Select Your Items Below</p>\n <div layout=\"column\" ng-repeat=\"item in $root.fundraiser.AvailableItems track by item._id\">\n <div layout=\"row\" layout-fill class=\"margin-bottom-10\" layout-align=\"start center\">\n <au-profile-image item=\"item\" size=\"200\"></au-profile-image>\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"start center\">\n <div flex class=\"md-title\">\n {{item.Title}}\n </div>\n <div class=\"margin-right-10\">\n ${{item.Cost}}\n </div>\n </div>\n <div class=\"md-caption\">\n {{item.Description}}\n </div>\n\n <div class=\"md-caption\" ng-if=\"vm.showQtySold\">\n ({{item.QtySold}} Sold So Far)\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-top-20\" ng-if=\"!item.SoldOut\">\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, -1)\">\n <md-icon md-font-icon=\"zmdi zmdi-minus\"></md-icon>\n </md-button>\n\n <div\n style=\"width: 30px; border-bottom: 1px solid #ccc; text-align: center; padding: 0 5px;\">\n {{vm.newOrder[item._id] || 0}}\n </div>\n\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, 1)\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n </md-button>\n </div>\n <div layout=\"row\" layout-align=\"center center\" ng-if=\"item.SoldOut\">\n <div style=\"border: 1px solid #ccc; text-align: center; padding: 0 5px; border-radius: 6px; background: #efefef; color: red;\">\n SOLD OUT\n </div>\n </div>\n </div>\n\n <div style=\"margin: 30px 0; border-top: 1px solid #efefef\"></div>\n\n </div>\n\n </div>\n\n <p>Confirm the totals below.</p>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h3>Number of Items Sold:</h3>\n <div flex></div>\n <h2>{{vm.totalItems}}</h2>\n </div>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h3>Total Sale:</h3>\n <div flex></div>\n <h2>{{vm.order.OrderTotal | currency}}</h2>\n </div>\n\n </div>\n <div id=\"checkout\" ng-show=\"vm.stepNbr == 1\">\n <h3>1. Confirm the totals below</h3>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h4>Number of Items Sold:</h4>\n <div flex></div>\n <h4>{{vm.totalItems}}</h4>\n </div>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h4>Total Sale:</h4>\n <div flex></div>\n <h4>{{vm.order.OrderTotal | currency}}</h4>\n </div>\n\n\n <ng-form name=\'buyNow\'>\n\n\n <h3 class=\"margin-top-20\">2. Credit a participant</h3>\n <p>Did you receive a flyer or hear about this fundraiser from someone? If so, please mention them below\n so\n we can credit their account. Otherwise select \"Self Pick Up Customer\". This is a required field.</p>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-file-plus\"></md-icon>\n\n <md-select ng-model=\"vm.order.Participant\" flex placeholder=\"Select a participant\" required>\n <md-option ng-value=\"0\">\n Self Pick Up Customer -- Credit The Whole Group\n </md-option>\n <md-option ng-repeat=\"participant in vm.participants | orderBy: \'Title +LastName +FirstName\'\"\n ng-value=\"participant._id\" ng-order-by=\"participant.LastName\">\n {{participant.LastName}}, {{participant.FirstName}} - {{participant.Title}}\n </md-option>\n </md-select>\n </md-input-container>\n\n <div ng-show=\"vm.order.Participant === 0\" style=\"border-radius: 2px; background-color: #efefef; padding: 10px;\"\n dynamic=\"$root.fundraiser.BuyNowSelfPickupNote\">\n </div>\n\n <h3 class=\"margin-top-30\">3. Enter your contact details</h3>\n\n <div layout=\"row\" layout-fill>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.order.FirstName\" placeholder=\"First Name\" autocomplete=\"given-name\" required>\n </md-input-container>\n\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.order.LastName\" placeholder=\"Last Name\" autocomplete=\"family-name\" required>\n </md-input-container>\n </div>\n\n <div layout=\"row\" layout-fill>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <input ng-model=\"vm.order.BuyerDetails\" placeholder=\"Address\" autocomplete=\"street-address\"\n required>\n </md-input-container>\n\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input ng-model=\"vm.order.BuyerEmail\" placeholder=\"Email\" autocomplete=\"email\" required>\n </md-input-container>\n </div>\n\n <h3 class=\"margin-top-20\">4. Credit card authorization</h3>\n\n <fieldset>\n <!-- Display a payment form -->\n <div id=\"card-element\"></div>\n </fieldset>\n </ng-form>\n </div>\n\n <div id=\"finish\" ng-show=\"vm.stepNbr == 2\">\n <div au-cover-photo item=\"$root.fundraiser\" layout=\"row\" layout-align=\"center center\" layout-fill style=\"height: 150px; margin-bottom: 75px;\">\n <au-profile-image item=\"$root.fundraiser\" size=\"100\" style=\"margin-top: 150px;\"></au-profile-image>\n </div>\n\n <div ng-show=\"vm.processingOrder\">\n Processing order... please wait...\n </div>\n\n <div ng-show=\"vm.orderError\">\n There was an error processing your card. Your card was not charged and your order is not\n submitted.<br><br>Please go back and check your checkout details and try again.\n </div>\n\n <div ng-show=\"vm.orderComplete\">\n <h2>Thank you! Your order has been submitted.</h2>\n <md-divider class=\"margin-0\"></md-divider>\n <p class=\"md-body-1\" dynamic=\"$root.fundraiser.BuyNowThankYou\"></p>\n\n </div>\n </div>\n\n </md-dialog-content>\n <md-dialog-actions id=\"FirstStepButtons\" class=\"margin-15\" ng-show=\"vm.stepNbr == 0\">\n <div layout=\"row\" layout-fill layout-align=\"center center\">\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.proceedToCheckout()\"\n ng-disabled=\"!vm.proceedToCheckoutOkay\">Proceed to Checkout</md-button>\n </div>\n </md-dialog-actions>\n <md-dialog-actions id=\"CheckoutButtons\" class=\"margin-15\" ng-show=\"vm.stepNbr == 1\">\n <div layout=\"row\" layout-align=\"space-between center\" layout-fill>\n <md-button class=\"md-raised\" ng-click=\"vm.backToItems()\" class=\"margin-left-0\">Back to Items</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.payNow()\" ng-disabled=\"!vm.proceedToPayOkay\">Pay {{vm.order.OrderTotal | currency}} Now\n </md-button>\n </div>\n </md-dialog-actions>\n <md-dialog-actions id=\"CheckoutButtons\" class=\"margin-15\" ng-show=\"vm.stepNbr == 2\">\n <div layout=\"row\" layout-align=\"space-between center\" layout-fill>\n <md-button class=\"md-raised\" ng-click=\"vm.backToCheckout()\" class=\"margin-left-0\"\n ng-disabled=\"vm.processingOrder || vm.orderComplete\">Back to Checkout</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.processingOrder\">Close\n </md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/enter-order.tmpl.html","<md-dialog au-wizard dialog-title=\"Enter Order\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n custom-review-step=\"true\" class=\"au-dialog fundraiser-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\"\n style=\"min-height: 480px\">\n <au-wizard-step step-bg=\"/assets/images/dialogs/add.png\">\n\n <p>Enter at least the name of the customer.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.order.BuyerName\" placeholder=\"Customer Name*\" autocomplete=\"off\" required=\"true\">\n </md-input-container>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <textarea rows=\"2\" ng-model=\"vm.order.BuyerDetails\" class=\"md_input\" placeholder=\"Address (optional)\" autocomplete=\"off\"></textarea>\n </md-input-container>\n </au-wizard-step>\n <au-wizard-step step-bg=\"/assets/images/dialogs/addbg.png\" title=\"Select Products\">\n\n <p class=\"margin-bottom-20\">What is the customer ordering?</p>\n\n\n <div layout=\"column\" ng-repeat=\"item in $root.fundraiser.AvailableItems track by item._id\">\n <div layout=\"row\" layout-fill class=\"margin-bottom-10\" layout-align=\"start center\">\n <au-profile-image item=\"item\" size=\"60\"></au-profile-image>\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"start center\">\n <div flex class=\"md-title\">\n {{item.Title}}\n </div>\n <div class=\"margin-right-10\">\n ${{item.Cost}}\n </div>\n </div>\n <div class=\"md-caption\">\n {{item.Description}}\n </div>\n\n <div class=\"md-caption\" ng-if=\"vm.showQtySold\">\n ({{item.QtySold}} Sold So Far)\n </div>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" ng-if=\"!item.SoldOut\">\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, -1)\">\n <md-icon md-font-icon=\"zmdi zmdi-minus\"></md-icon>\n </md-button>\n\n <div style=\"width: 30px; border-bottom: 1px solid #ccc; text-align: center; padding: 0 5px;\">\n {{vm.newOrder[item._id] || 0}}\n </div>\n\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, 1)\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n </md-button>\n </div>\n <div layout=\"row\" layout-align=\"center center\" ng-if=\"item.SoldOut\">\n <div style=\"border: 1px solid #ccc; text-align: center; padding: 0 5px; border-radius: 6px; background: #efefef; color: red;\">\n SOLD OUT\n </div>\n </div>\n\n <div style=\"margin: 30px 0; border-top: 1px solid #efefef\"></div>\n\n <!-- <md-divider style=\"margin: 30px -20px;\"></md-divider> -->\n\n </div>\n\n </au-wizard-step>\n <au-wizard-step step-bg=\"/assets/images/dialogs/add.png\" title=\"Review\">\n\n <p>Confirm the totals below.</p>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h3>Number of Items Sold:</h3>\n <div flex></div>\n <h2>{{vm.totalItems}}</h2>\n </div>\n <div layout=\"row\" class=\"total-row\" layout-align=\"start center\">\n <h3>Total Sale:</h3>\n <div flex></div>\n <h2>{{vm.order.OrderTotal | currency}}</h2>\n </div>\n <p ng-if=\"$root.fundraiser.WriteChecksTo\" class=\"payable-to md-caption text-center background-color-200 font-color-600 padding-15 blink_me\">\n <span class=\"nowrap\">\n Make checks payable to:\n </span>\n {{$root.fundraiser.WriteChecksTo}}\n </p>\n\n <div layout=\"column\" class=\"margin-top-10\" layout-align=\"start center\">\n <div class=\"receive-funds-label\">Did you receive the funds? (cash or check)</div>\n <div layout=\"row\" layout-align=\"center center\">\n <div class=\"margin-right-10\">Not Yet</div>\n <md-switch class=\"green-on\" ng-model=\"vm.order.ReceivedPayment\"></md-switch>\n <div ng-class=\"{\'received\': vm.order.ReceivedPayment}\">Yes, It\'s in the envelope</div>\n </div>\n </div>\n\n <md-divider style=\"margin: 8px -8px;\"></md-divider>\n\n <md-input-container class=\"margin-top-30\">\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.order.BuyerEmail\" placeholder=\"Send receipt to email (optional)\" autocomplete=\"off\">\n </md-input-container>\n <p class=\"md-caption\">Enter the customer\'s email to send them a receipt.</p>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/list-items.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" class=\"fundraiser-dialog\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>{{::vm.title}}</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.print()\" ng-if=\"vm.showPrint\">\n <md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <p ng-if=\"$root.fundraiser.ItemListHeader\" class=\"margin-10\" dynamic=\"$root.fundraiser.ItemListHeader\"></p>\n\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-hide=\"vm.showForgot\" class=\"section-to-print\">\n <div class=\"print-header\" layout=\"column\" layout-align=\"center center\">\n <div class=\"md-display-2\">\n {{$root.fundraiser.Title}}\n </div>\n <div class=\"md-title\">\n Order Form - All orders due before {{$root.fundraiser.ClosingDate | date}}\n </div>\n <div class=\"md-caption\">\n Please make checks payable to: {{$root.fundraiser.WriteChecksTo}}\n </div>\n </div>\n <md-divider class=\"print-header margin-top-30 margin-bottom-30\"></md-divider>\n <div class=\"print-header margin-bottom-30\" layout=\"row\">\n <div layout=\"column\" flex>\n <div>Please write your name/address/contact info below.</div>\n <div style=\"border:1px solid black; width: 100%; height: 150px;\"></div>\n </div>\n <div layout=\"column\">\n <div style=\"width: 300px;\">Write your total order ($) below.</div>\n <div style=\"border:1px solid black; width: 100%; height: 150px; width: 300px;\"></div>\n </div>\n </div>\n <div class=\"print-header\" layout=\"row\" layout-align=\"end center\">\n <div>\n Write Qty To Order Below\n </div>\n </div>\n <div layout=\"column\" class=\"my-order-summary\" ng-if=\"vm.showPrizeSummary\">\n <div class=\"md-headline margin-bottom-10\">Summary</div>\n <div ng-if=\"!vm.participant.SelectedPrizes.length\" class=\"md-title padding-50 text-center\">\n No Prizes Selected\n </div>\n <div layout=\"row\" ng-repeat=\"prize in vm.participant.SelectedPrizes\" layout-align=\"start center\" class=\"row\">\n <au-profile-image item=\"$root.fundraiser.prizeMap[prize.Item]\" size=\"40\"></au-profile-image>\n <div class=\"md-title padding-left-20\" flex>{{$root.fundraiser.prizeMap[prize.Item].Title}}</div>\n <div class=\"md-display-1\">{{prize.Qty}}</div>\n </div>\n <md-divider class=\"margin-top-20 margin-bottom-20\"></md-divider>\n <div class=\"md-headline margin-bottom-10\">All Prizes</div>\n </div>\n <div class=\"list-items-column\">\n <div layout=\"column\" ng-repeat=\"item in vm.items | orderBy: vm.orderBy\" style=\"break-inside: avoid;\">\n <div layout=\"row\" class=\"margin-bottom-10\" layout-align=\"start center\">\n <au-profile-image item=\"item\" size=\"vm.size\"></au-profile-image>\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"start center\">\n <div flex class=\"md-title\">\n {{item.Title}}\n </div>\n <div class=\"margin-right-10\">\n ${{item.Cost}}\n </div>\n </div>\n <div class=\"md-caption\">\n {{item.Description}}\n </div>\n <div class=\"md-caption strong\" ng-if=\"item.MaxCount\">\n Max: {{item.MaxCount}}\n </div>\n\n <div class=\"md-caption\" ng-if=\"vm.showQtySold\">\n ({{item.QtySold}} Sold So Far)\n </div>\n\n <div class=\"md-caption\" ng-if=\"vm.showQtySelected\">\n ({{item.QtySelected}} Selected So Far)\n </div>\n </div>\n <div class=\"print-qty-to-order\"></div>\n </div>\n\n <div layout=\"row\" ng-if=\"vm.showAddPrizes\" layout-align=\"center center\">\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, -1)\" ng-disabled=\"vm.getQty(item._id) == 0\">\n <md-icon md-font-icon=\"zmdi zmdi-minus\"></md-icon>\n </md-button>\n <div style=\"width: 30px; border-bottom: 1px solid #ccc; text-align: center; padding: 0 5px;\">\n {{vm.getQty(item._id)}}\n </div>\n\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.updateQty(item, 1)\" ng-disabled=\"!vm.fundsAvailable(item.Cost) || (item.MaxCount && vm.getQty(item._id) == item.MaxCount)\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n </md-button>\n </div>\n\n <md-divider style=\"margin: 30px -10px;\"></md-divider>\n\n </div>\n </div>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15 padding-left-0\" ng-if=\"vm.showAddPrizes\">\n <div layout=\"row\" layout-fill layout-align=\"start center\">\n <div layout=\"column\">\n <div class=\"total-row\">\n <span>Earned:</span>\n <b style=\'color: green\'>{{vm.fundsEarned | currency}}</b>\n </div>\n <div class=\"total-row\">\n <span>Spent:</span>\n <b>{{vm.fundsSpent | currency}}</b>\n </div>\n </div>\n <div flex></div>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.savePrizeSelections()\" ng-disabled=\"vm.fundsSpent == 0 && vm.fundsEarned == 0\">Save</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/login-participant.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Participant Login</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-hide=\"vm.showForgot\">\n <p>Enter the username &amp; password you signed up with.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-gamepad\"></md-icon>\n <input ng-model=\"vm.username\" placeholder=\"Username\" autocomplete=\"username\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input type=\"password\" ng-model=\"vm.password\" placeholder=\"Password\" autocomplete=\"current-password\" required=\"true\">\n </md-input-container>\n </md-dialog-content>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-show=\"vm.showForgot\">\n <p>Enter the recovery email you used for this fundraiser.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-gamepad\"></md-icon>\n <input ng-model=\"vm.email\" placeholder=\"Recovery Email\" autocomplete=\"email\" type=\"email\" required=\"true\">\n </md-input-container>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15 padding-left-0\">\n <div layout=\"row\" layout-fill>\n <md-button class=\"md-raised\" ng-click=\"vm.showForgot = true\" ng-hide=\"vm.showForgot\">Recover Login</md-button>\n <div flex></div>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.forgot($event)\" ng-disabled=\"vm.forgotDisabled\" ng-show=\"vm.showForgot\">Send Recovery Email</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.login($event)\" ng-disabled=\"vm.loginDisabled\" ng-hide=\"vm.showForgot\">Login</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/my-account.tmpl.html","<md-dialog class=\"au-dialog\" flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>My Account</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"$root.$mdDialog.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-hide=\"vm.showChangePassword\">\n\n <au-cover-photo item=\"vm.user\" class=\"coverhead\" layout=\"row\" layout-align=\"start center\" allow-update=\"true\" style=\"margin: -20px 0px 100px -10px; min-width: calc(100% + 20px)\">\n <au-image-uploader class=\"overhang margin-right-0 margin-left-30\" item=\"vm.user\" style=\"height: 100px; width: 100px\" id=\"BtnProfilePicture\" allow-update=\"true\" size=\"100\"></au-image-uploader>\n </au-cover-photo>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.user.FirstName\" placeholder=\"First Name\" autocomplete=\"given-name\" required=\"true\" ng-change=\"vm.generateUsername()\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.user.LastName\" placeholder=\"Last Name\" autocomplete=\"family-name\" required=\"true\" ng-change=\"vm.generateUsername()\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-gamepad\"></md-icon>\n <input ng-model=\"vm.user.Username\" placeholder=\"Pick a Username\" autocomplete=\"username\" required=\"true\" ng-change=\"vm.verifyUsername()\"\n ng-blur=\"vm.verifyUsername()\">\n </md-input-container>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <input ng-model=\"vm.user.Email\" type=\"email\" placeholder=\"Recovery Email\" autocomplete=\"email\" required=\"true\">\n </md-input-container>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n <label>Select Group</label>\n <md-select ng-model=\"vm.user.Title\" placeholder=\"Group\" required=\"true\">\n <md-option ng-repeat=\"group in $root.fundraiser.Groups.split(\',\')\">{{group.trim()}}</md-option>\n </md-select>\n </md-input-container>\n </md-dialog-content>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-show=\"vm.showChangePassword\">\n <p>Pick a new password.</p>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.user.Password\" type=\"password\" placeholder=\"Pick a Password\" autocomplete=\"new-password\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.user.participantConfirmPassword\" type=\"password\" placeholder=\"Confirm Password\" autocomplete=\"new-password\"\n required=\"true\">\n </md-input-container>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15 padding-left-0\">\n <div layout=\"row\" layout-fill>\n <md-button class=\"md-raised\" ng-click=\"vm.showChangePassword = true\" ng-hide=\"vm.showChangePassword\">Change Password</md-button>\n <div flex></div>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.saveMyAccount($event)\" ng-disabled=\"vm.changePasswordDisabled\" ng-show=\"vm.showChangePassword\">Update Password</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.saveMyAccount($event)\" ng-disabled=\"vm.saveDisabled\" ng-hide=\"vm.showChangePassword\">Save Changes</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/my-orders.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" class=\"fundraiser-dialog\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>My Orders</h2>\n <span flex></span>\n <md-button xclass=\"md-raised\" ng-click=\"vm.print()\">\n <md-icon md-font-icon=\"zmdi zmdi-print\"></md-icon>\n Print\n </md-button>\n <div style=\"border-right: 1px solid #ffffff54; width: 1px; height: 50%; margin: 0 10px;\"></div>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 20px 10px 0 10px;\" ng-hide=\"vm.showForgot\"\n au-can-edit=\"$root.fundraiser.IsOpen || vm.editable\" class=\"section-to-print\">\n <div layout=\"row\">\n\n <div layout=\"column\" flex>\n <p class=\'md-title\'>Thank you for selling.</p>\n <p class=\'md-caption margin-bottom-10 alert\' style=\"color:white;\" ng-if=\"vm.participant.TotalToCollect && !vm.participant.FundsReceived\">Please turn in <b>{{vm.participant.TotalToCollect | currency}}</b> to {{$root.fundraiser.WriteChecksTo}}.</p>\n <p class=\'md-caption margin-bottom-30\' ng-if=\"$root.fundraiser.IsOpen\">Manage your orders below.</p>\n <p class=\'md-caption margin-bottom-30\' ng-if=\"$root.fundraiser.AfterClose\">The fundraiser closed\n {{$root.fundraiser.ClosingDate | amCalendar}}.</p>\n </div>\n <div>\n <md-button class=\"md-icon-button\" ng-click=\"vm.orderBy = (vm.orderBy ? \'\' : \'-\')\">\n <md-icon md-font-icon=\"zmdi zmdi-sort-amount-desc\" ng-if=\"vm.orderBy\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-sort-amount-asc\" ng-if=\"!vm.orderBy\"></md-icon>\n <md-tooltip>Sort</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <div class=\"print-header\" layout=\"column\" layout-align=\"center center\">\n <div class=\"md-display-2\">\n {{vm.participant.FirstName}}&nbsp;{{vm.participant.LastName}} &dash; {{vm.participant.TotalSold | currency}} Sold!\n </div>\n <div class=\"md-title\">\n {{$root.fundraiser.Title}}\n </div>\n </div>\n <md-divider class=\"print-header margin-top-30 margin-bottom-30\"></md-divider>\n\n <!-- Summary -->\n <div layout=\"row\">\n <div layout=\"column\" flex>\n <div class=\"md-headline margin-bottom-10 padding-left-20\">Order Summary</div>\n <div layout=\"column\" class=\"striped-rows\">\n <div layout=\"row\" ng-repeat=\"item in vm.orderSummary | orderBy: \'Title\'\" layout-align=\"start center\" class=\"row\">\n <au-profile-image item=\"item\" size=\"40\"></au-profile-image>\n <div class=\"md-title padding-left-20\" flex>{{item.Title}}</div>\n <div class=\"md-display-1\">{{item.SumQty}}</div>\n </div>\n </div>\n </div>\n <div layout=\"column\" style=\"border-left: 1px dashed #ccc;\" flex>\n <div class=\"md-headline margin-bottom-10 padding-left-20\">Prizes</div>\n <div ng-if=\"!vm.participant.SelectedPrizes.length\" class=\"md-title padding-50 text-center\">\n No Prizes Selected<br>\n ({{vm.participant.TotalSold * ($root.fundraiser.IncentivePercentage / 100) | currency}} Earned)\n </div>\n <div layout=\"column\" class=\"striped-rows\">\n <div layout=\"row\" ng-repeat=\"prize in vm.participant.$selectedPrizes\" layout-align=\"start center\" class=\"row\">\n <au-profile-image item=\"$root.fundraiser.prizeMap[prize.Item]\" size=\"40\"></au-profile-image>\n <div class=\"md-title padding-left-20\" flex>{{$root.fundraiser.prizeMap[prize.Item].Title}}</div>\n <div class=\"md-display-1\">{{prize.Qty}}</div>\n </div>\n </div>\n </div>\n </div>\n\n <md-divider class=\"margin-top-20 margin-bottom-20\"></md-divider>\n\n <!-- Details -->\n <div class=\"md-headline margin-bottom-10\">Order Details</div>\n <div class=\"list-items-column\">\n <div layout=\"column\" ng-repeat=\"item in vm.orders | orderBy: (vm.orderBy + \'LastModified.Date\')\" style=\"break-inside: avoid;\">\n <div layout=\"row\" class=\"margin-bottom-10\" layout-align=\"start start\">\n <au-profile-image item=\"{Title: item.BuyerName}\" size=\"40\"></au-profile-image>\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"start center\">\n <div flex class=\"md-title\">\n {{item.BuyerName}}\n </div>\n <div class=\"margin-right-10\">\n <b ng-if=\"item.PaymentReference\" class=\"alert margin-right-10\">CC Payment</b>\n ${{item.OrderTotal}}\n </div>\n </div>\n <div layout=\"row\" ng-if=\"item.BuyerDetails\">\n {{item.BuyerDetails}}\n </div>\n <div layout=\"column\" class=\"md-caption\" style=\"max-width: 75%\">\n <div layout=\"row\" layout-align=\"start center\" ng-repeat=\"orderItem in item.Items track by $root.protectedId(orderItem)\">\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-circle\" class=\"padding-0 margin-0\" style=\"font-size: 8px; margin-left: -10px !important;\"></md-icon>\n </div>\n <div>{{$root.fundraiser.itemMap[orderItem.Item].Title}}</div>\n <div class=\"margin-left-10\">(Qty: {{orderItem.Qty}})</div>\n </div>\n </div>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-top-10 order-functions\">\n <md-button class=\"md-icon-button md-raised margin-left-40\" ng-click=\"vm.editOrder(item, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"font-color-600\"></md-icon>\n <md-tooltip>Edit Order</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button md-raised\" ng-click=\"vm.deleteOrder(item, $index, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" class=\"font-color-500\"></md-icon>\n <md-tooltip>Delete Order</md-tooltip>\n </md-button>\n\n <div flex></div>\n\n <div class=\"margin-right-20\">Paid: {{(item.ReceivedPayment ? \'YES\' : \'NO\')}}</div>\n <md-switch ng-model=\"item.ReceivedPayment\" class=\"green-on\" ng-change=\"item.$participantToken = $root.fundraiser.getParticipantToken(); item.$updateItem()\"></md-switch>\n </div>\n </div>\n </div>\n\n <div ng-if=\"vm.orders.length == 0\">\n <div layout=\"column\" layout-align=\"center center\" class=\"margin-top-40\">\n <img src=\"/assets/images/empty-states/drop.png\" style=\"max-width: 200px\">\n <div class=\"md-title\">\n They don\'t just drop out of the sky!\n </div>\n <div class=\"md-caption\">Get out there, Tiger!</div>\n </div>\n </div>\n </md-dialog-content>\n</md-dialog>");
$templateCache.put("/app/fundraiser/dialogs/new-participant.tmpl.html","<md-dialog au-wizard dialog-title=\"Sign Up New Participant\" on-review=\"vm.review()\" on-finish=\"vm.finish()\"\n steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\"\n flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <script src=\'https://www.google.com/recaptcha/api.js\'></script>\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/add.png\">\n <form>\n <p>Thank you for your interest in helping {{$root.fundraiser.Title}}!</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.user.FirstName\" placeholder=\"First Name\" autocomplete=\"given-name\" required=\"true\"\n ng-change=\"vm.generateUsername()\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.user.LastName\" placeholder=\"Last Name\" autocomplete=\"family-name\" required=\"true\"\n ng-change=\"vm.generateUsername()\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-gamepad\"></md-icon>\n <input ng-model=\"vm.user.Username\" placeholder=\"Pick a Username\" autocomplete=\"username\" required=\"true\"\n ng-change=\"vm.verifyUsername()\" ng-blur=\"vm.verifyUsername()\">\n </md-input-container>\n <md-input-container ng-hide=\"vm.isAdmin\">\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.user.Password\" type=\"password\" placeholder=\"Pick a Password\"\n autocomplete=\"new-password\" required=\"true\">\n </md-input-container>\n <md-input-container ng-hide=\"vm.isAdmin\">\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.newParticipantConfirmPassword\" type=\"password\" placeholder=\"Confirm Password\"\n autocomplete=\"new-password\" required=\"true\">\n </md-input-container>\n <md-input-container ng-hide=\"vm.isAdmin\">\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <input ng-model=\"vm.user.Email\" type=\"email\" placeholder=\"Recovery Email\" autocomplete=\"email\"\n required=\"true\">\n </md-input-container>\n\n <md-input-container ng-if=\"$root.fundraiser.Groups\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n <md-select ng-model=\"vm.user.Title\" placeholder=\"What group are you part of?\" required=\"true\">\n <md-option ng-repeat=\"group in $root.fundraiser.Groups.split(\',\')\">{{group.trim()}}</md-option>\n </md-select>\n </md-input-container>\n\n <div layout=\"column\" layout-align=\"start center\" ng-hide=\"vm.isAdmin\">\n <div class=\"g-recaptcha\" data-sitekey=\"6LcfMEMUAAAAAPL1FZ28TSSYAIgWxWWdYXUGRng7\"\n data-callback=\"newFundraiserParticipantResp\"></div>\n <input type=\"text\" ng-model=\"vm.user.captcha\" ng-required=\"true\" class=\"display-none\">\n </div>\n </form>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/fundraiser/item/orderLine.html","<div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-10 padding-bottom-10\"\n style=\"border-bottom: 1px solid #efefef\">\n\n <div layout=\"column\" layout-align=\"start start\" layout-fill>\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <au-profile-image item=\"order.BuyerName\" size=\"30\"></au-profile-image>\n <div class=\"md-title\">\n {{::order.BuyerName}}\n </div>\n\n <div>&nbsp;- {{::order.BuyerDetails}}</div>\n <span flex></span>\n <div class=\"md-title\">{{(order.OrderTotal || 0) | currency}}</div>\n </div>\n <div layout=\"row\" layout-align=\"start start\" layout-fill>\n <div class=\"margin-left-40\"></div>\n <div layout=\"column\" layout-align=\"start start\">\n\n <a href=\"mailto:{{::order.BuyerEmail}}\">\n {{::order.BuyerEmail}}\n </a>\n\n <div layout=\"row\" layout-fill layout-align=\"space-between\" class=\"margin-top-20\">\n <div><b>Item</b></div>\n <div><b>Qty</b></div>\n </div>\n <div ng-repeat=\"item in order.Items\" layout=\"row\" layout-fill layout-align=\"space-between\">\n <div>{{::$root.fundraiser.itemMap[item.Item].Title}}</div>\n <div>{{::item.Qty}}</div>\n </div>\n\n\n </div>\n <span flex></span>\n <div layout=\"column\" layout-align=\"start end\">\n <div layout=\"row\">\n <div class=\"md-caption margin-right-5\">\n Order Picked Up:\n </div>\n <md-checkbox class=\"margin-0 padding-0\" ng-model=\"order.OrderPickedUp\" style=\"width: 20px;\"\n ng-change=\"order.$updateItem()\"></md-checkbox>\n </div>\n </div>\n </div>\n <div ng-if=\"order.Participant != \'0\'.repeat(24)\" style=\"margin: 40px; padding: 15px; border: 1px solid red; width: calc(100% - 60px);\">\n <b>Sold By</b>\n {{::vm.FundraiserParticipant.getCache({_id:order.Participant})[0].FirstName }}\n {{::vm.FundraiserParticipant.getCache({_id:order.Participant})[0].LastName }}\n <ng-include ng-repeat=\"participant in vm.FundraiserParticipant.getCache({_id: order.Participant}) track by participant._id\"\n src=\"\'/app/fundraiser/item/participantLine.html\'\">\n\n </ng-include>\n <ng-include></ng-include>\n </div>\n <div ng-if=\"order.Participant == \'0\'.repeat(24)\" style=\"margin-left:40px; padding 15px;\">\n <b>Self Pickup Customer</b>\n </div>\n </div>\n</div>");
$templateCache.put("/app/fundraiser/item/participantLine.html","<div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-10 padding-bottom-10\"\n style=\"border-bottom: 1px solid #efefef\">\n <div layout=\"column\" layout-align=\"start start\" layout-fill ng-if=\"participant.isSectionHeader\">\n <h1>{{participant.Title}}</h1>\n </div>\n <div layout=\"column\" layout-align=\"start start\" layout-fill ng-if=\"!participant.isSectionHeader\">\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <au-profile-image item=\"participant\" size=\"30\"></au-profile-image>\n <div class=\"md-title\">\n {{::participant.FirstName}}\n {{::participant.LastName}}\n </div>\n <div>&nbsp;- {{::participant.Title}}&nbsp;&nbsp;</div>\n <a ng-click=\"vm.openMyAccount($event, participant)\" class=\"font-size-1\">(edit account)</a>\n <span flex></span>\n <div class=\"md-title\">{{(participant.TotalSold || 0) | currency}}</div>\n </div>\n <div layout=\"row\" layout-align=\"start start\" layout-fill>\n <div class=\"margin-left-40\"></div>\n <div layout=\"column\" layout-align=\"start start\">\n <a href=\"mailto:{{::participant.Email}}\">\n {{::participant.Email}}\n </a>\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"!vm.copying\">\n <md-button class=\"md-raised\" ng-click=\"vm.enterParticipantOrder($event, participant)\">\n <md-icon md-font-icon=\"zmdi zmdi-inbox\"></md-icon>\n Enter Order\n </md-button>\n\n <md-button class=\"md-raised\" ng-click=\"vm.editParticipantOrders($event, participant)\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n View Orders\n </md-button>\n\n <md-button class=\"md-raised\" ng-click=\"vm.shopPrizes($event, participant)\">\n <md-icon md-font-icon=\"zmdi zmdi-ticket-star\"></md-icon>\n View Prizes\n </md-button>\n </div>\n </div>\n <span flex></span>\n <div layout=\"column\" layout-align=\"start end\" ng-if=\"!vm.copying\">\n <div layout=\"row\">\n <div class=\"md-caption margin-right-5\">\n <b>{{(participant.TotalToCollect || 0) | currency}}</b> of\n Funds Received?\n </div>\n <md-checkbox class=\"margin-0 padding-0\" ng-model=\"participant.FundsReceived\" style=\"width: 20px;\"\n ng-change=\"participant.$updateItem()\"></md-checkbox>\n </div>\n <div layout=\"row\">\n <div class=\"md-caption margin-right-5\">\n Order Picked Up?\n </div>\n <md-checkbox class=\"margin-0 padding-0\" ng-model=\"participant.OrderPickedUp\" style=\"width: 20px;\"\n ng-change=\"participant.$updateItem()\"></md-checkbox>\n </div>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/fundraiser/item/tmpl.html","<div class=\"fundraiser-item-detail\">\n <div ng-show=\"vm.mode==\'edit\'\">\n <ng-form name=\'editItem\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\"\n cached-resource=\"vm.item\" ignore-fields=\"[\'Field\',\'NamesTo\',\'Ignore\']\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" item=\"vm.item\">\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Details -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-fundraiser-o\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Details</div>\n <div class=\"description\">Edit the description and open/close dates.</div>\n </div>\n <md-icon md-font-icon=\"au au-fundraiser-o\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Description-->\n <p class=\"margin-bottom-20 md-body-1\">Describe your fundraiser below.</p>\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"\n class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"Description\"\n display-mode=\"field\" extra-plugins=\"table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\"\n style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Description\" flex>\n </div>\n </div>\n\n\n <div layout=\"row\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-placeholder=\"Opening Date\" mdp-open-on-click\n ng-model=\"vm.item.OpeningDate\" mdp-format=\"M/D/YYYY\"\n class=\"md-icon-float md-block\"></mdp-date-picker>\n\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-placeholder=\"Closing Date\" mdp-open-on-click\n ng-model=\"vm.item.ClosingDate\" mdp-format=\"M/D/YYYY\"\n class=\"md-icon-float md-block\"></mdp-date-picker>\n </div>\n\n <p class=\"margin-bottom-20 md-body-1\">Intro message for Buy Now</p>\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"\n class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"BuyNowIntro\"\n display-mode=\"field\" extra-plugins=\"table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\"\n style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Intro\" flex>\n </div>\n </div>\n\n <p class=\"margin-bottom-20 md-body-1\">Thank you for your order for Buy Now</p>\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"\n class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"BuyNowThankYou\"\n display-mode=\"field\" extra-plugins=\"table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\"\n style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Thank You\" flex>\n </div>\n </div>\n\n <p class=\"margin-bottom-20 md-body-1\">Note for self pickup customers</p>\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"\n class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\"\n item-field=\"BuyNowSelfPickupNote\" display-mode=\"field\"\n extra-plugins=\"table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\"\n style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Self Pickup Note\"\n flex>\n </div>\n </div>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.Groups\"\n placeholder=\"List your groups separated by commas. (Band, Orchestra, Lion Den, etc.)\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.PostAs\"\n placeholder=\"Who should the \'About our Fundraiser\' posts be from?\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.WriteChecksTo\"\n placeholder=\"Who should checks be made out to?\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.ItemListHeader\"\n placeholder=\"What do you want to print at the top of the item list?\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.PrizeIntro\"\n placeholder=\"What do you want to print at the top of the prize list?\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.IncentivePercentage\" type=\"number\"\n placeholder=\"How much of the total sold should be allocated to incentives?\" />\n </md-input-container>\n\n <md-checkbox class=\"margin-0 padding-0\" ng-model=\"vm.item.ShopPrizesOpen\">Shop Prizes\n is Open</md-checkbox>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.NewStripeServerKey\" type=\"number\"\n placeholder=\"Paste your Stripe Private Key\" ng-change=\"vm.updateServerKey()\" />\n </md-input-container>\n\n <md-input-container>\n <input type=\"text\" ng-model=\"vm.item.StripeClientKey\" type=\"number\"\n placeholder=\"Paste your Stripe Publishable Key?\" />\n </md-input-container>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Available Items -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-label\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Available Items</div>\n <div class=\"description\">Manage the items for sale.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-label\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <table class=\"table table-header table-hover table-noborder\">\n <!--header-->\n <tr>\n <th class=\"left-margin-spacer\"></th>\n <th class=\"padding-top-10\" style=\"min-width: 200px\">Title</th>\n <th width=\"70%\" class=\"padding-top-10\">Description</th>\n <th stlyle=\"min-width: 100px;\" class=\"padding-top-10\">Cost</th>\n <th class=\"padding-top-10\" style=\"text-align: center;\">Sold Out</th>\n <th class=\"padding-top-5 padding-right-10\"></th>\n </tr>\n\n <tr ng-repeat=\"item in vm.item.AvailableItems\">\n <td class=\"left-margin-spacer\"></td>\n <td width=\"40%\" style=\"white-space: nowrap; vertical-align: middle;\">\n <span layout=\"row\" layout-align=\"start center\"\n style=\"margin-right: 40px; vertical-align: middle\">\n <au-image-uploader item=\"item\" allow-update=\"true\"\n style=\"min-width: 100px; min-height: 100px; margin-right: 20px;\">\n </au-image-uploader>\n <!-- <au-profile-image item=\"item\" class=\"margin-right-20\"></au-profile-image> -->\n <div layout=\"column\" layout-align=\"start start\">\n\n <md-input-container class=\"margin-0\">\n\n <input ng-model=\"item.Title\" class=\"md-input full-width\"\n style=\"min-width: 200px\" />\n </md-input-container>\n\n <md-button class=\"md-raised\"\n ng-click=\"vm.particpantItemReport(item._id)\">View Participants\n </md-button>\n </div>\n\n </span>\n </td>\n <td width=\"40%\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <textarea ng-model=\"item.Description\" class=\"full-width\" />\n </md-input-container>\n </td>\n <td stlyle=\"min-width: 100px;\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <input ng-model=\"item.Cost\" type=\"number\" class=\"md-input full-width\" />\n </md-input-container>\n </td>\n\n <td stlyle=\"xmin-width: 100px;\" style=\"text-align: center; vertical-align: middle;\">\n <md-checkbox class=\"margin-0 padding-0\" ng-model=\"item.SoldOut\"\n style=\"width: 20px;\"></md-checkbox>\n </td>\n <td style=\"vertical-align: middle; text-align: center;\">\n <span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeItem($index, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove item</md-tooltip>\n </md-button>\n </span>\n </td>\n </tr>\n\n\n <tr>\n <td class=\"left-margin-spacer\"></td>\n <td style=\"padding-top: 40px;\">\n <md-input-container class=\"margin-0\">\n\n <input ng-model=\"vm.newTitle\" class=\"md-input full-width\"\n placeholder=\"New Item\" />\n </md-input-container>\n\n </td>\n <td width=\"80%\" style=\"vertical-align: middle; padding-top: 40px;\">\n <md-input-container class=\"margin-0 padding-0\">\n <input ng-model=\"vm.newDescription\" class=\"full-width\"\n placeholder=\"Description\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; padding-top: 40px;\">\n <md-input-container class=\"margin-0 padding-0\">\n <input ng-model=\"vm.newCost\" type=\"number\" class=\"full-width\"\n placeholder=\"Cost\" style=\"min-width:100px\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; text-align: center; padding-top: 40px;\">\n <span>\n <md-button class=\"md-raised md-accent margin-0\"\n ng-click=\"vm.addItem($event)\" ng-disabled=\"!vm.newTitle\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;Add&nbsp; </span>\n </md-button>\n </span>\n </td>\n </tr>\n </table>\n </div>\n </md-card>\n\n <!-- Available Prizes -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-ticket-star\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Available Prizes</div>\n <div class=\"description\">Manage the prizes for sale.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-ticket-star\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <table class=\"table table-header table-hover table-noborder\">\n <!--header-->\n <tr>\n <th class=\"left-margin-spacer\"></th>\n <th class=\"padding-top-10\" style=\"min-width: 200px\">Title</th>\n <th width=\"70%\" class=\"padding-top-10\">Description</th>\n <th stlyle=\"min-width: 100px;\" class=\"padding-top-10\">Cost</th>\n <th stlyle=\"min-width: 100px;\" class=\"padding-top-10\">Max</th>\n <th class=\"padding-top-5 padding-right-10\"></th>\n </tr>\n\n <tr ng-repeat=\"item in vm.item.AvailablePrizes\">\n <td class=\"left-margin-spacer\"></td>\n <td width=\"40%\" style=\"white-space: nowrap; vertical-align: middle;\">\n <span layout=\"row\" layout-align=\"start center\"\n style=\"margin-right: 40px; vertical-align: middle\">\n <au-image-uploader item=\"item\" allow-update=\"true\"\n style=\"min-width: 100px; min-height: 100px; margin-right: 20px;\">\n </au-image-uploader>\n <!-- <au-profile-image item=\"item\" class=\"margin-right-20\"></au-profile-image> -->\n <span layout=\"column\" layout-align=\"start start\">\n <md-input-container class=\"margin-0\">\n <input ng-model=\"item.Title\" class=\"md-input full-width\"\n style=\"min-width: 200px\" />\n </md-input-container>\n <md-button class=\"md-raised\"\n ng-click=\"vm.particpantPrizeReport(item._id)\">View Participants\n </md-button>\n </span>\n </span>\n </td>\n <td width=\"40%\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <textarea ng-model=\"item.Description\" class=\"full-width\"></textarea>\n </md-input-container>\n </td>\n <td stlyle=\"min-width: 100px;\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <input ng-model=\"item.Cost\" type=\"number\" class=\"md-input full-width\" />\n </md-input-container>\n </td>\n <td stlyle=\"min-width: 100px;\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <input ng-model=\"item.MaxCount\" type=\"number\" class=\"md-input full-width\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; text-align: center;\">\n <span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removePrize($index, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove item</md-tooltip>\n </md-button>\n </span>\n </td>\n </tr>\n\n <tr>\n <td class=\"left-margin-spacer\"></td>\n <td style=\"padding-top: 40px;\">\n <md-input-container class=\"margin-0\">\n <input ng-model=\"vm.newPrizeTitle\" class=\"md-input full-width\"\n placeholder=\"New Prize\" />\n </md-input-container>\n </td>\n <td width=\"80%\" style=\"vertical-align: middle; padding-top: 40px;\">\n <md-input-container class=\"margin-0 padding-0\">\n <input ng-model=\"vm.newPrizeDescription\" class=\"full-width\"\n placeholder=\"Description\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; padding-top: 40px;\">\n <md-input-container class=\"margin-0 padding-0\">\n <input ng-model=\"vm.newPrizeCost\" type=\"number\" class=\"full-width\"\n placeholder=\"Cost\" style=\"min-width:100px\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; text-align: center; padding-top: 40px;\">\n <span>\n <md-button class=\"md-raised md-accent margin-0\"\n ng-click=\"vm.addPrize($event)\" ng-disabled=\"!vm.newPrizeTitle\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;Add&nbsp; </span>\n </md-button>\n </span>\n </td>\n </tr>\n </table>\n </div>\n </md-card>\n\n <!-- Participants -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Participants</div>\n <div class=\"description\">Manage particpants and their orders.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <div class=\"card-toolbar\" layout=\"row\" layout-align=\"start center\">\n <md-button class=\"md-raised\" ng-click=\"vm.signUp($event, true)\">\n Add Participant\n </md-button>\n\n <md-button class=\"md-raised\" ng-click=\"vm.showFundsNeeded()\">\n Find Funds Needed\n </md-button>\n\n <md-button class=\"md-raised\" ng-click=\"vm.showPickupNeeded()\">\n Find Pickup Needed\n </md-button>\n\n <md-button class=\"md-raised\" ng-click=\"vm.showPrizesNeeded()\">\n Find Prizes Needed\n </md-button>\n </div>\n <md-card-content layout=\"column\">\n\n <md-input-container class=\"margin-0 padding-0 margin-bottom-30\">\n <input ng-model=\"vm.searchParticipants\" ng-change=\"vm.updateParticipants()\"\n class=\"full-width\" placeholder=\"Search Participant\" style=\"min-width:100px\" />\n </md-input-container>\n\n <ng-include ng-repeat=\"participant in vm.participants track by participant._id\"\n src=\"\'/app/fundraiser/item/participantLine.html\'\">\n\n </ng-include>\n\n\n </md-card-content>\n </div>\n </md-card>\n\n\n <!-- Self Pickup Customers -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Self Pickup Customers</div>\n <div class=\"description\">Manage customers who bought online and elected to pick up\n themselves.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <div class=\"card-toolbar\" layout=\"row\" layout-align=\"start center\">\n <md-button class=\"md-raised\" ng-click=\"vm.showBuyNowPickupNeeded()\">\n Find Pickup Needed\n </md-button>\n </div>\n <md-card-content layout=\"column\">\n\n <md-input-container class=\"margin-0 padding-0 margin-bottom-30\">\n <input ng-model=\"vm.searchBuyNow\" ng-change=\"vm.updateBuyNowOrders()\"\n class=\"full-width\" placeholder=\"Search Orders\" style=\"min-width:100px\" />\n </md-input-container>\n\n <ng-include ng-repeat=\"order in vm.buyNowOrders track by order._id\"\n src=\"\'/app/fundraiser/item/orderLine.html\'\">\n\n </ng-include>\n\n\n\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Search At Pickup -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Pickup Search</div>\n <div class=\"description\">Search participants, self-pickup and orders.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <div class=\"card-toolbar\" layout=\"row\" layout-align=\"start center\">\n <md-input-container class=\"full-width margin-top-20\">\n <input ng-model=\"vm.searchPickup\" ng-change=\"vm.updateSearchPickup()\"\n class=\"full-width\" placeholder=\"Search by Name\" style=\"min-width:100px\" />\n </md-input-container>\n\n </div>\n <md-card-content layout=\"column\">\n\n <h1>Participants</h1>\n <ng-include ng-repeat=\"participant in vm.participants track by participant._id\"\n src=\"\'/app/fundraiser/item/participantLine.html\'\">\n\n </ng-include>\n\n <h1>Orders</h1>\n <ng-include ng-repeat=\"order in vm.buyNowOrders track by order._id\"\n src=\"\'/app/fundraiser/item/orderLine.html\'\">\n\n </ng-include>\n\n\n\n\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Reports -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Reports</div>\n <div class=\"description\">Audit real-time data.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <div class=\"card-toolbar\" layout=\"row\" layout-align=\"start center\">\n <md-button class=\"md-raised\" ng-click=\"vm.runItemCountReport()\">\n True Up Fundraiser Counts\n </md-button>\n <md-button class=\"md-raised\" ng-click=\"vm.getEmails()\">\n Get All participant emails\n </md-button>\n <md-button class=\"md-raised\" ng-click=\"vm.printAllParticipantOrders()\">\n Print All Orders\n </md-button>\n </div>\n <md-card-content layout=\"column\">\n <div>\n {{vm.reportItems}}\n </div>\n <div style=\"overflow: auto\">\n <span ng-repeat=\"participant in vm.allParticipants\">{{::participant.Email}};</span>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Security and Sharing -->\n <md-card ng-if=\"!$root.user.$AnonymousUser && vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\"\n class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\">\n </md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Security and Sharing</div>\n <div class=\"description\">Control who, in addition to the Members, has read/write\n access to this project.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\"\n class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <au-item-security-and-sharing item=\"vm.item\"></au-item-security-and-sharing>\n </md-card-content>\n </div>\n </md-card>\n\n\n\n </md-popout-card-list>\n\n </div>\n </ng-form>\n </div>\n\n <div ng-if=\"vm.mode==\'view\'\" class=\"fundraiser-view faux-up\" layout=\"column\" layout-fill>\n <div au-cover-photo item=\"vm.item\" layout=\"row\" layout-align=\"start end\" layout-fill>\n </div>\n <div layout=\"column\" layout-align=\"start center\" layout-gt-sm=\"row\" layout-fill\n class=\"padding-bottom-20 header-content\">\n <div layout=\"column\" layout-align=\"start center\" flex flex-grow layout-gt-sm=\"row\" class=\"title\">\n <div class=\"margin-left-30\"></div>\n <au-profile-image item=\"vm.item\" size=\"100\" class=\"bounce\"></au-profile-image>\n <div class=\"margin-bottom-30\" hide-gt-sm></div>\n <div layout=\"column\" layout-align=\"center center\" layout-align-gt-sm=\"center start\"\n class=\"margin-left-20 margin-right-20\">\n <span class=\"md-title\">{{vm.item.Title}}</span>\n <div ng-if=\"vm.item.$currentParticipant\">\n Logged in as {{vm.item.$currentParticipant.Username}}.\n <a class=\"md-caption\" ng-click=\"vm.logout()\">(Log Out)</a>\n </div>\n <div ng-if=\"vm.item.$currentParticipant.TotalSold\">\n You\'ve Sold: {{vm.item.$currentParticipant.TotalSold | currency}}.\n </div>\n\n <div class=\"margin-bottom-30\" hide-gt-sm></div>\n </div>\n </div>\n\n <div layout=\"column\" layout-align=\"start center\" layout-align-gt-sm=\"start end\" layout-fill>\n <div ng-if=\"!vm.IsOpen\" class=\"margin-bottom-20\" layout=\"row\">\n <div class=\"margin-left-20\" hide-gt-sm></div>\n <div ng-if=\"!vm.AfterClose\">\n The fundraiser opens {{vm.item.OpeningDate | amCalendar}}.\n </div>\n <div ng-if=\"vm.AfterClose\">\n The fundraiser closed {{vm.item.ClosingDate | amCalendar}}.\n </div>\n <div class=\"margin-right-30\" hide-sm hide-xs></div>\n </div>\n <div layout=\"row\" layout-align=\"end end\" style=\"top: 10px; position: relative; margin-top:-30px;\"\n class=\"participant-buttons fadeup\" ng-hide=\"vm.item.$currentParticipant\">\n <!--action icons-->\n <md-button ng-click=\"vm.signUp($event)\" class=\"md-raised md-primary\" flex ng-disabled=\"!vm.IsOpen\">\n <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n Sign Up &nbsp;&nbsp;\n </md-button>\n\n <md-button ng-click=\"vm.logIn($event)\" class=\"md-raised\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n Log In &nbsp;&nbsp;\n </md-button>\n </div>\n <div layout=\"row\" layout-align=\"end end\" style=\"top: 10px; position: relative; margin-top:-30px;\"\n class=\"participant-buttons fadeup\" ng-show=\"vm.item.$currentParticipant\">\n <!--action icons-->\n <md-button ng-click=\"vm.enterOrder($event)\" class=\"md-raised md-primary\" flex\n ng-disabled=\"!vm.IsOpen\">\n <md-icon md-font-icon=\"zmdi zmdi-money\"></md-icon>\n Enter Order &nbsp;&nbsp;\n </md-button>\n\n <md-button ng-click=\"vm.myOrders($event)\" class=\"md-raised\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n My Orders &nbsp;&nbsp;\n </md-button>\n\n <md-button ng-click=\"vm.openMyAccount($event)\" class=\"md-raised\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n My Account &nbsp;&nbsp;\n </md-button>\n\n <md-button ng-click=\"vm.shopPrizes($event)\" class=\"md-raised\" flex\n ng-disabled=\"!vm.item.ShopPrizesOpen\">\n <md-icon md-font-icon=\"zmdi zmdi-ticket-star\"></md-icon>\n Shop Prizes &nbsp;&nbsp;\n </md-button>\n </div>\n\n </div>\n </div>\n <!-- END cover photo -->\n\n <div layout=\"column\" flex layout-fill class=\"view-body\">\n <!--we need separate divs to have 2 post feeds-->\n <div>\n <div au-post-feed=\"vm.getPinnedPosts\" feed-type=\"Page\" watch-scroll=\"false\" posts-only=\"true\"\n feed-id=\"{{vm.item._id}}.pinnedPosts\" hide-headers=\"true\"></div>\n </div>\n <div flex>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 14px;\"></md-icon>\n <span flex class=\"md-caption\">Recent Activity</span>\n </div>\n <div au-post-feed page-id=\"vm.item._id\" feed-type=\"Page\" exclude-pinned=\"true\"\n no-empty-instructions=\"true\" hide-headers=\"true\"></div>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/fundraiser/participant/tmpl.html","<div class=\"_template-item-detail\">\n <ng-form name=\'editItem\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\" ignore-fields=\"[\'Field\',\'NamesTo\',\'Ignore\']\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" item=\"vm.item\">\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Username\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- another card (add as many as makes sense) -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Other Details</div>\n <div class=\"description\">Edit the description.</div>\n </div>\n <md-icon md-font-icon=\"au au-chess-piece\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.item.FirstName\" placeholder=\"First Name\" autocomplete=\"given-name\" md-auto-focus required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account-box-mail\"></md-icon>\n <input ng-model=\"vm.item.LastName\" placeholder=\"Last Name\" autocomplete=\"family-name\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-gamepad\"></md-icon>\n <input ng-model=\"vm.item.Username\" placeholder=\"Username\" autocomplete=\"username\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.item.Password\" type=\"password\" placeholder=\"Password\" autocomplete=\"new-password\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-key\"></md-icon>\n <input ng-model=\"vm.newParticipantConfirmPassword\" type=\"password\" placeholder=\"Confirm Password\" autocomplete=\"new-password\"\n required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <input ng-model=\"vm.item.Email\" type=\"email\" placeholder=\"Recovery Email\" autocomplete=\"email\" required=\"true\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-audio\"></md-icon>\n <label>Select Group</label>\n <md-select ng-model=\"vm.item.Group\" placeholder=\"Group\" required=\"true\">\n <md-option>Band</md-option>\n <md-option>Orchestra</md-option>\n <md-option>Choir</md-option>\n </md-select>\n </md-input-container>\n </md-card-content>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/handbook/dialogs/add-handbook.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Handbook\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n<au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/addbg.png\">\n <h3>Add A Handbook</h3>\n <p>A handbook is a place where you can store all policies and procedures for a certain group within your organization. Keep everyone organized and up to date by filling your handbook with entries for every topic.</p>\n</au-wizard-step>\n<au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleEntered()\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Title</h3>\n <p>Enter the title of this handbook.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input ng-model=\"vm.handbook.Title\" required/>\n </md-input-container>\n</au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/handbook/handbookentry/detail.tmpl.html","<div class=\"handbook-entry-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!--Working Copy cke auto expanded-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Working Copy</div>\n <div class=\"description\">Edit the handbook entry document.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <div class=\"au-cke-document\" item=\"vm.item\" item-field=\"WorkingCopy\" auto-focus=\"true\" display-mode=\"document\" resize-trigger=\"vm.resizeDoc\"\n can-edit=\"vm.item\" acl=\"U\"></div>\n </div>\n </md-card>\n\n <!-- Handbook Entry Settings -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Settings</div>\n <div class=\"description\">Edit the entry title, publish this version, and view old versions.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Entry Title-->\n <md-input-container flex>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n <!--Publish button-->\n <div class=\"margin-10\" layout=\"row\" layout-align=\"center center\" flex>\n <h2>Published Version History</h2>\n <div flex></div>\n <md-button class=\"md-accent md-raised\" ng-click=\"vm.item.Publish($event)\">\n <span>&nbsp;Publish</span>\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n </md-button>\n </div>\n <!--Revision History table-->\n <div>\n <table class=\"table table-header table-hover table-noborder\">\n <tr>\n <th>Date Published</th>\n <th>Published By</th>\n <th>Version Number</th>\n </tr>\n <tr ng-repeat=\"revision in vm.revisionHistory\" ng-click=\"revision.open(\'recent\')\" class=\"usercard-button\">\n <td>{{revision.PublishedDate | date: \"short\"}}</td>\n <td>{{revision.PublishedBy | fullNameFilter}}</td>\n <td>{{revision.RevisionNumber}}</td>\n </tr>\n </table>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/handbook/item/detail.tmpl.html","<div class=\"handbook-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Handbook Settings -->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Settings</div>\n <div class=\"description\">Edit the title, privacy, editors, and who this handbook is shared with.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Title-->\n <md-input-container flex>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n <!--Creator-->\n <div layout=\"row\" class=\"md-body-1\" flex style=\"top:-10px; position:relative; color: rgba(0,0,0,0.54);\">\n <span>Creator: </span>\n <span class=\"margin-left-5\">\n <strong>{{vm.item.Creator | auItemFilter: \'User\'}}</strong>\n </span>\n </div>\n <!--Editors-->\n <div class=\"md-body-1\" style=\"margin-bottom: -20px;\">Editors:</div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.item.Editors\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.Editors, $chip)\"\n flex id=\"ChipDocEditor\">\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.editorsSearchText\" md-items=\"editor in $root.auUtility.searchUsers({query: vm.editorsSearchText, excludeContact: true})\"\n placeholder=\"Add Editor\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.editorsSearchText\" md-highlight-flags=\"i\">{{editor | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n <!--Active / Inactive-->\n <div layout=\"row\" layout-align=\"start center\">\n <div flex=\"50\">\n <md-icon md-font-icon=\"zmdi zmdi-power\" class=\"icon-switch\"></md-icon>\n <span ng-if=\"!vm.item.IsActive\">This handbook is\n <strong>inactive</strong>. Click to active this handbook.</span>\n <span ng-if=\"vm.item.IsActive\">This handbook is\n <strong>active</strong>. Click to mark it as Inactive.</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex=\"50\">\n <span class=\"margin-right-10\">{{ vm.item.IsActive ? \'Active\' : \'Inactive\' }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Active Switch\" ng-model=\"vm.item.IsActive\" id=\"SwitchActive\"></md-switch>\n </div>\n </div>\n <!--Privacy Switch-->\n <div layout=\"row\" layout-align=\"start center\">\n <div ng-if=\"!vm.item.IsPrivate\" flex=\"70\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"icon-switch\"></md-icon>\n <span>This handbook is\n <strong>readable</strong> by all users in {{vm.orgName}}. Click to make it private.</span>\n </div>\n <div ng-if=\"vm.item.IsPrivate\" flex=\"70\">\n <md-icon md-font-icon=\"zmdi zmdi-eye-off\" class=\"icon-switch\"></md-icon>\n <span>This handbook is\n <strong>private</strong>. Click to make it viewable by all users in {{vm.orgName}}.</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex>\n <span class=\"margin-right-10\">{{ vm.item.IsPrivate ? \'Editors and Shared Users\' : \'All Users in \' + vm.orgName }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Privacy Switch\" ng-model=\"vm.item.IsPrivate\" id=\"SwitchPrivacy\"></md-switch>\n </div>\n </div>\n <!--SharedWith-->\n <div ng-show=\"vm.item.IsPrivate\" class=\"expanded animate-show-hide\">\n <div class=\"md-body-1\" style=\"margin-bottom: -20px;\">Shared With:</div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.item.SharedWith\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.SharedWith, $chip)\"\n flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.sharedWithSearchText\" md-items=\"sharedWith in $root.auUtility.searchUsers({query:vm.sharedWithSearchText, excludeContacts: true})\"\n placeholder=\"Share with users\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\">{{sharedWith | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n </div>\n\n </md-card-content>\n </div>\n </md-card>\n\n <!--Doc Section-->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!--Workflows-->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"au au-workflow\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"\n style=\"width: 1.28571em;\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Workflows</div>\n <div class=\"description\">Collection box for all your approval requests.</div>\n </div>\n <md-icon md-font-icon=\"au au-workflow\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\" style=\"width: 1.28571em;\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-workflows item=\"vm.item\"></au-workflows>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/handbook/revision/detail.tmpl.html","<div class=\"handbook-entry-item-detail\">\n <ng-form name=\'editItemForm\' cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!--HandbookEntry Quickview-->\n <md-card class=\"no-clip\">\n <md-card-content class=\"background-color-500 padding-30\">\n <!--Title-->\n <div layout=\"row\" layout-align=\"space-between start\">\n <div class=\"font-size-3 font-weight-300 margin-right-10 margin-bottom-10\">{{vm.item.$HandbookEntry.Title}} - Version #{{vm.item.RevisionNumber}}</div>\n <div layout=\"row\" layout-align=\"end start\">\n <!--New Tab-->\n <md-button class=\"md-icon-button open-single margin-0\" ng-click=\"vm.item.open(\'new\')\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip md-direction=\"left\">Open In New Tab</md-tooltip>\n </md-button>\n <!--Share in Video Call-->\n <au-share-in-video-button item=\"vm.item\" ng-show=\"$root.getUiActiveVideoCall()\"></au-share-in-video-button>\n </div>\n </div>\n <div layout=\"column\" layout-align=\"start start\">\n <!--Published By-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>Published By: {{vm.item.PublishedBy | auItemFilter: \'User\'}}</span>\n </div>\n <!--Date Published-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>{{vm.item.PublishedDate | date: \'short\'}}</span>\n </div>\n <!--Handbook-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-handbook2\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>{{vm.item.$HandbookEntry.Handbook | auItemFilter: \'Handbook\'}}</span>\n </div>\n <!--Privacy-->\n <div layout=\"column\" layout-align=\"start start\">\n <div ng-if=\"!vm.item.$Handbook.IsPrivate\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>Public</span>\n </div>\n <div ng-if=\"vm.item.$Handbook.IsPrivate\" layout=\"column\" layout-align=\"start start\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-lock\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>Private</span>\n </div>\n </div>\n </div>\n </div>\n </md-card-content>\n </md-card>\n\n <!--Text cke auto expanded-->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Text</div>\n <div class=\"description\">View the handbook entry document.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <div class=\"au-cke-document\" item=\"vm.item\" item-field=\"Text\" auto-focus=\"true\" display-mode=\"document\" resize-trigger=\"vm.resizeDoc\"\n can-edit=\"false\"></div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/philosophy/item/detail.tmpl.html","<div class=\"philosophy-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Mission, Vision, Values -->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-favorite\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Mission, Vision, Values</div>\n <div class=\"description\">Explain the mission, vision, and values for this {{vm.item.Type.toLowerCase()}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-favorite\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Title-->\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n <!--Mission-->\n <div layout=\"row\" layout-align=\"space-between center\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-star-circle\"></md-icon>\n <label>Mission</label>\n <textarea ng-model=\"vm.item.Mission\" class=\"bottom-border\" md-detect-visible style=\"white-space:pre-wrap;\" />\n </md-input-container>\n <au-help-icon key=\"Philosophy.Mission\"></au-help-icon>\n </div>\n <!--Vision-->\n <div layout=\"row\" layout-align=\"space-between center\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n <label>Vision</label>\n <textarea ng-model=\"vm.item.Vision\" class=\"bottom-border\" md-detect-visible style=\"white-space:pre-wrap;\" />\n </md-input-container>\n <au-help-icon key=\"Philosophy.Vision\"></au-help-icon>\n </div>\n <!--Values-->\n <div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"value in vm.item.Values track by $index\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-star-outline\"></md-icon>\n <label>Value</label>\n <textarea ng-model=\"value.Text\" class=\"bottom-border\" md-detect-visible style=\"white-space:pre-wrap;\" />\n </md-input-container>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeValue($index, $event)\" aria-label=\"Remove Value\">\n <md-tooltip md-direction=\"left\">\n <span>Remove Value</span>\n </md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n <md-button class=\"md-raised margin-left-40\" ng-click=\"vm.addValue()\">Add Value</md-button>\n\n </md-card-content>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/project/dialogs/add-project.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Project\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\"\n on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\"\n aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/projectbg.png\">\n <h3>Add A Project</h3>\n\n <div>Keep the tasks, project plans, discussion and documentation together with a project. In the Project Plan, create a task\n by typing [] (no space between brackets).</div>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/project.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/setdates.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/checkbox.png\">\n </div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Keep all the details that go into planning in one place.</div>\n <div class=\"padding-20\" flex=\"33\">Set dates, create tasks, assign users, and more.</div>\n <div class=\"padding-20\" flex=\"33\">Type [] in the project plan to add a Task.</div>\n </div>\n <au-from-template-state-button item-type=\"Project\"></au-from-template-state-button>\n </au-wizard-step>\n\n <au-wizard-step on-next-step=\"vm.confirmTitleEntered()\" step-name=\"title\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <md-input-container class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input ng-model=\"vm.project.Title\" required md-auto-focus />\n </md-input-container>\n\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-65\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document text-area margin-top-15\" ng-model=\"vm.project.Description\" placeholder=\"Description\"></div>\n </div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"privacy\" step-bg=\"/assets/images/dialogs/users.png\">\n <h3>Ownership</h3>\n <p>Designate one or more team/groups, departments, or locations as the project owner(s).\n <au-help-icon key=\"OwnedBy.Description\"></au-help-icon>\n </p>\n\n <au-item-ownedby item=\"vm.project\"></au-item-ownedby>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"privacy\" step-bg=\"/assets/images/dialogs/permissions.png\">\n <h3>Privacy</h3>\n\n <div layout-align=\"start center\" layout=\"row\" layout-fill class=\"padding-right-30\">\n <div flex>Searchable to users in {{$root.Organization.Name}}?</div>\n\n <div class=\"margin-right-10\" ng-class=\"{\'font-weight-bold\' : vm.project.IsPrivate}\">No - Listed Users Only</div>\n <md-switch class=\"md-primary margin-0\" ng-model=\"vm.project.IsPrivate\" md-invert></md-switch>\n <div class=\"margin-left-10\" ng-class=\"{\'font-weight-bold\' : !vm.project.IsPrivate}\">Yes - All Users</div>\n </div>\n\n <h3 class=\"margin-top-40\">Send Share</h3>\n <p>Optionally, send a share to specific users to notify them of this project.\n <au-help-icon key=\"SharedWith.Description\"></au-help-icon>\n </p>\n\n <!--Shared With Users-->\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container flex class=\"margin-0\" md-no-float>\n <md-chips ng-model=\"vm.project.SharedWith\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.project.SharedWith, $chip);$root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.project.SharedWith})\"\n flex>\n <md-autocomplete md-search-text=\"vm.sharedWithSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.sharedWithSearchText, showAdd: true})\"\n placeholder=\"Add a User\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\">{{user | fullNameFilter}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n\n </au-wizard-step>\n\n\n\n</md-dialog>");
$templateCache.put("/app/project/dialogs/add-task.tmpl.html","<md-dialog\n au-wizard dialog-title=\"Add Task\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Add Task Dialog\"\n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddTask\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/task.png\">\n <h3>Add One Task</h3>\n \n <div>Let tasks run your organization. Assign a tasks to other users, contacts or yourself to ensure they are taken care of. After creating this task, optionally make a sub-task list using the story editor.</div>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/assign-task.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/calendar.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/checkbox.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Assign tasks to users to ensure they are taken care of.</div>\n <div class=\"padding-20\" flex=\"33\">When a task is given a due date, it will appear on the user\'s calendar.</div>\n <div class=\"padding-20\" flex=\"33\">To create more than one task at a time, use the Story Editor.</div>\n </div>\n <au-from-template-state-button item-type=\"Task\"></au-from-template-state-button> \n </au-wizard-step>\n\n <au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleEntered()\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <div layout=\"row\">\n <!--Title-->\n <md-input-container flex>\n <label>Title</label>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <input ng-model=\"vm.task.Title\" required id=\"TxtTaskTitle\"/>\n </md-input-container>\n <!--Task Priority-->\n <md-input-container>\n <md-select ng-model=\"vm.task.TaskPriority\" id=\"BtnPriorityMenu\" placeholder=\"Task Priority\">\n <md-option ng-repeat=\"priority in vm.taskPriorities\" ng-value=\"priority.number\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"{{priority.icon}}\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex ng-attr-id=\"BtnPriorityOption{{$index}}\">{{priority.text}}</p>\n </div>\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n <!--Description-->\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-65\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document text-area margin-top-15\" ng-model=\"vm.task.Details\" placeholder=\"Description\" id=\"CkeTaskDescription\"></div>\n </div> \n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"assignment\" step-bg=\"/assets/images/dialogs/user.png\">\n <h3>Assignment</h3>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.task.User\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.userSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.userSearchText})\"\n md-selected-item-change=\"vm.checkForNewUser(user)\"\n md-item-text=\"user | fullNameFilter\" md-floating-label=\"User Assignment\" md-input-name=\"user\"\n md-autofocus required flex id=\"TxtUserAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoUserAssign{{$index}}\">\n {{ user | fullNameFilter }}\n </span>\n </md-item-template>\n <div ng-messages=\"reassignUsers.user.$error\">\n <div ng-message=\"required\">\n <span>Please select a user</span>\n </div>\n </div>\n </md-autocomplete>\n <au-help-icon key=\"Project.Task.UserAssign\" style=\"margin:10px\"></au-help-icon>\n </div>\n\n <div layout=\"row\" ng-show=\"!vm.task.Meeting && !vm.task.Document\">\n <md-icon md-font-icon=\"zmdi zmdi-folder\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"vm.task.Project\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.projectSearchText\" md-items=\"project in vm.searchProjects(vm.projectSearchText, {Type: [\'U\']})\" md-item-text=\"project | auItemFilter : \'Project\'\" md-floating-label=\"Project Assignment\" md-input-name=\"project\" md-autofocus flex id=\"TxtProjectAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoProjectAssign{{$index}}\">{{ project | auItemFilter : \'Project\' }}</span>\n </md-item-template>\n </md-autocomplete>\n <au-help-icon key=\"Project.Task.ProjectAssign\" style=\"margin:10px\"></au-help-icon>\n </div>\n\n <div layout=\"row\" ng-show=\"!vm.task.Project && !vm.task.Document\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"vm.task.Meeting\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.meetingSearchText\" md-items=\"meeting in vm.searchMeetings(vm.meetingSearchText, {Type: [\'U\']})\" md-item-text=\"meeting | auItemFilter : \'Meeting\'\" md-floating-label=\"Meeting Assignment\" md-input-name=\"meeting\" md-autofocus flex id=\"TxtMeetingAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoMeetingAssign{{$index}}\">{{ meeting | auItemFilter : \'Meeting\' }}</span>\n </md-item-template>\n </md-autocomplete>\n <au-help-icon key=\"Project.Task.MeetingAssign\" style=\"margin:10px\"></au-help-icon>\n </div>\n\n <div layout=\"row\" ng-show=\"!vm.task.Project && !vm.task.Meeting\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"vm.task.Document\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.documentSearchText\" md-items=\"document in vm.searchDocuments(vm.documentSearchText, {Type: [\'U\']})\" md-item-text=\"document | auItemFilter : \'Document\'\" md-floating-label=\"Document Assignment\" md-input-name=\"document\" md-autofocus flex id=\"TxtDocumentAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoDocumentAssign{{$index}}\">{{ document | auItemFilter : \'Document\' }}</span>\n </md-item-template>\n </md-autocomplete>\n <au-help-icon key=\"Project.Task.DocumentAssign\" style=\"margin:10px\"></au-help-icon>\n </div>\n\n <!--Parent Task-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"vm.task.ParentTask\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"task in $root.auUtility.searchTasks(vm.taskSearchText, {Type: [\'U\']})\"\n md-search-text=\"vm.taskSearchText\" md-floating-label=\"Parent Task\"\n md-item-text=\"task | auItemFilter: \'Task\'\" id=\"TxtParentTask\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.taskSearchText\" md-highlight-flags=\"i\" id=\"AutoParentTask{{$index}}\">{{ task | auItemFilter: \'Task\' }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <au-help-icon key=\"Project.Task.ParentTask\" style=\"margin:10px\"></au-help-icon>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"dates\" step-bg=\"/assets/images/dialogs/post-event-bg.png\">\n <h3>Timing Planning</h3>\n <p>Optionally, estimate the number of hours and dates for this task.</p>\n <div layout=\"row\" layout-align=\"space-between center\" class=\"margin-top-20 margin-bottom-20\">\n <!--Est Hours-->\n <div layout-gt-xs=\"row\" flex=\"30\">\n <md-input-container>\n <label>Planned Hours</label>\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <input type=\"number\" ng-model=\"vm.task.EstimatedHours\" id=\"NumEstimatedHours\"/>\n </md-input-container>\n </div>\n\n <div layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 80px;\"></div>\n\n <!--Planned Start Date-->\n <div layout-gt-xs=\"row\" flex=\"30\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Planned Start Date\" ng-model=\"vm.task.PlannedStartDate\" mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" id=\"TxtPlannedStartDate\"></mdp-date-picker>\n </div>\n \n <div layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 80px;\"></div>\n \n <!--Planned End Date-->\n <div layout-gt-xs=\"row\" flex=\"30\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Planned End Date\" ng-model=\"vm.task.PlannedEndDate\" mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" id=\"TxtPlannedEndDate\"></mdp-date-picker> \n </div>\n\n </div>\n\n <h3>Share With Users</h3>\n <p>Optionally, configure additional sharing below.<p>\n <div layout=\"column\">\n <!--Auto Post Switch-->\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-switch class=\"md-primary\" aria-label=\"Post Switch\" ng-model=\"vm.task.AutoPostUpdates\" ng-value=\"true\" id=\"SwitchCompletePost\">\n <span class=\"margin-left-10\">{{ vm.task.AutoPostUpdates ? \"Automatically\" : \"Do Not\" }} post to the News Feed when this task is marked complete</span>\n </md-switch>\n </div>\n <!--Shared With Autocomplete-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n <md-input-container flex class=\"md-icon-float md-block\" md-no-float flex>\n <md-chips ng-model=\"vm.task.SharedWith\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.task.SharedWith, $chip); $root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.task.SharedWith}) \" id=\"ChipTaskSharedWith\">\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.sharedWithSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.sharedWithSearchText, showAdd: true})\"\n placeholder=\"Share With\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtTaskSharedWith\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoTaskSharedWith{{$index}}\">{{user | fullNameFilter}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipTaskSharedWith{{$index}}\">{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n </div>\n\n </au-wizard-step>\n\n</md-dialog>");
$templateCache.put("/app/project/dialogs/batch-add-members.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Members\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" steps=\"vm.wizardSteps\" class=\"au-dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step>\n <h3>Add Members</h3>\n <p>Anyone that you will assign a task to should be added as a member. When you link a team to this project every member of\n that team will be added as a member. You can individually remove members by clicking the X next to their name.</p>\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;color:rgba(0,0,0,0.54);\"></md-icon>\n <md-chips ng-model=\"vm.dummyProject.Members\" md-require-match=\"true\" md-transform-chip=\"vm.transformMemberChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.membersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.membersSearchText})\"\n placeholder=\"Add Member\" md-autoselect=\"true\" md-select-on-match=\"true\" md-no-cache=\"true\" flex id=\"TxtProjectMember\">\n <md-item-template>\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.membersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoProjectMembers{{$index}}\">\n {{user | auItemFilter: \'User\'}}\n </span>\n </div>\n </md-item-template>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip.LinkWithUserId\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip.LinkWithUserId | auItemFilter : \'User\'}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n <md-input-container class=\"margin-left-10\" flex>\n <md-autocomplete md-selected-item=\"vm.dummyProject.Team\" md-item-text=\"team | auItemFilter: \'Team\'\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-require-match=\"true\" md-search-text=\"vm.teamSearchText\" md-items=\"team in vm.searchTeams(vm.teamSearchText)\" md-selected-item-change=\"vm.dummyProject.LinkWithTeamLocal(vm.dummyProject.Team)\"\n id=\"TxtLinkTeam\" md-floating-label=\"Link with Team...\">\n <md-item-template>\n <span md-highlight-text=\"vm.teamSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLinkTeam{{$index}}\">\n {{ team | auItemFilter : \'Team\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n </div>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/project/dialogs/batch-reassign-tasks.tmpl.html","<md-dialog au-wizard dialog-title=\"Edit Task Assignments\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" steps=\"vm.wizardSteps\" class=\"au-dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step>\n <h3 class=\"margin-bottom-20\">You are reassigning the following {{vm.selectedTasks.length}} Tasks:</h3>\n \n \n <md-list id=\"TblMeetingCost\" flex=\"100\">\n <md-list-item layout=\"row\" layout-align=\"start center\" class=\"md-caption\" style=\"background-color: rgb(245,245,245); font-weight:bold;\">\n <div flex=\"40\" class=\"padding-right-10\">Task</div>\n <div flex=\"20\" class=\"padding-right-10\"><md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-5 font-size-2 md-primary\"></md-icon>Current User</div>\n <div flex=\"20\" class=\"padding-right-10\"><md-icon md-font-icon=\"zmdi zmdi-folder\" class=\"margin-right-5 font-size-2 md-primary\"></md-icon>Current Project</div>\n <div flex=\"20\"><md-icon md-font-icon=\"zmdi zmdi-calendar-note\" class=\"margin-right-5 font-size-2 md-primary\"></md-icon>Current Meeting</div>\n </md-list-item>\n <md-list-item ng-repeat=\"task in vm.selectedTasks\" class=\"secondary-button-padding md-caption\" layout=\"row\" layout-align=\"start center\" style=\"border-bottom: thin solid whitesmoke;\">\n <div flex=\"40\" class=\"padding-right-10\">{{task.Title}}</div>\n <div flex=\"20\" class=\"padding-right-10\" layout=\"row\" layout-align=\"start center\">\n <au-profile-image size=\"20\" user=\"task.User\"></au-profile-image>\n {{task.User | auItemFilter: \'User\'}}</div>\n <div flex=\"20\" class=\"padding-right-10\">{{task.Project | auItemFilter: \'Project\'}}</div>\n <div flex=\"20\">{{task.Meeting | auItemFilter: \'Meeting\'}}</div>\n </md-list-item>\n </md-list>\n \n <!--<table class=\"table table-bordered table-hover\" style=\"width:70%\" id=\"TblMeetingCost\">\n <tr>\n <th>Task</th>\n <th>Current User</th>\n <th>Current Project</th>\n <th>Current Meeting</th>\n </tr>\n <tr ng-repeat=\"task in vm.selectedTasks\">\n <td>{{task.Title}}</td>\n <td layout=\"row\">\n <au-profile-image size=\"30\" user=\"task.User\"></au-profile-image>\n {{task.User | auItemFilter: \'User\'}}\n </td>\n <td>{{task.Project | auItemFilter: \'Project\'}}</td>\n <td>{{task.Meeting | auItemFilter: \'Meeting\'}}</td> \n </tr>\n </table>-->\n\n </au-wizard-step>\n <au-wizard-step on-next-step=\"vm.wasAssignmentSelected()\">\n <h3>Reassignment</h3>\n <p>Change what/who the task is assigned to below.</p>\n <form name=\"reassignUsers\">\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-no-cache=\"true\" md-selected-item=\"vm.dummyTask.User\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.userSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.userSearchText})\"\n md-item-text=\"user | fullNameFilter\" md-floating-label=\"New User Assignment\" md-input-name=\"user\"\n flex id=\"TxtUserAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoUserAssign{{$index}}\">\n {{ user | fullNameFilter }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </div>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-folder\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"vm.dummyTask.Project\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.projectSearchText\" md-items=\"project in $root.auUtility.searchProjects(vm.projectSearchText, {Type: [\'U\']})\" md-item-text=\"project | auItemFilter : \'Project\'\" md-floating-label=\"New Project Assignment\" md-input-name=\"project\" flex id=\"TxtProjectAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoProjectAssign{{$index}}\">{{ project | auItemFilter : \'Project\' }}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"vm.dummyTask.Meeting\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.meetingSearchText\" md-items=\"meeting in $root.auUtility.searchMeeting(vm.meetingSearchText, {Type: [\'U\']})\" md-item-text=\"meeting | auItemFilter : \'Meeting\'\" md-floating-label=\"New Meeting Assignment\" md-input-name=\"meeting\" flex id=\"TxtMeetingAssign\">\n <md-item-template>\n <span ng-attr-id=\"AutoMeetingAssign{{$index}}\">{{ meeting | auItemFilter : \'Meeting\' }}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n </form>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/project/dialogs/batch-request-status-update.tmpl.html","<md-toolbar>\n <div class=\"md-toolbar-tools\">\n <h2>Request Status Update(s)</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.$mdDialog.hide()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"close\"></md-icon>\n </md-button>\n </div>\n</md-toolbar>\n\n<form name=\"reassignUsers\">\n <md-dialog-content class=\"md-padding\">\n <div class=\"md-body-1\">\n You are requesting a status update for <b>{{vm.selectedTasks.length}} tasks.</b>\n <span>Type your status request message here:</span>\n <md-input-container>\n <input ng-model=\"vm.updateRequestMessage\" type=\"text\" />\n </md-input-container>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.$mdDialog.hide()\" ng-if=\"!vm.loading\" id=\"BtnCancel\">\n <span>Cancel</span>\n </md-button>\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.sendMessages()\" type=\"submit\" ng-if=\"!vm.loading\" ng-disabled=\"requiredUsers.$invalid\" id=\"BtnSubmit\">\n <span>Do It</span>\n </md-button>\n <!--<md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-circular>-->\n </md-dialog-actions>\n</form>");
$templateCache.put("/app/project/dialogs/link-with-team.tmpl.html","<md-toolbar>\n <div class=\"md-toolbar-tools\">\n <h2>Link With Team</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.$mdDialog.hide()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"close\"></md-icon>\n </md-button>\n </div>\n</md-toolbar>\n\n<form name=\"reassignUsers\">\n <md-dialog-content class=\"md-padding\">\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n <md-input-container class=\"margin-left-10\" flex>\n <md-autocomplete md-selected-item=\"vm.linkWithTeam\" md-item-text=\"team | auItemFilter: \'Team\'\" md-search-text=\"vm.teamSearchText\" md-items=\"team in vm.searchTeams(vm.teamSearchText)\" md-autoselect=\"true\" md-select-on-match=\"true\" md-floating-label=\"Team\" id=\"TxtLinkWithTeam\">\n <md-item-template>\n <span md-highlight-text=\"vm.teamSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLinkWithTeam{{$index}}\">\n {{ team | auItemFilter: \'Team\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n <au-help-icon key=\"Project.LinkWithTeam\" style=\"padding-top: 35px;\"></au-help-icon>\n </div>\n\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.$mdDialog.hide()\" ng-if=\"!vm.loading\" id=\"BtnCancel\">\n <span>Cancel</span>\n </md-button>\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.finish()\" type=\"submit\" ng-if=\"!vm.loading\" ng-disabled=\"requiredUsers.$invalid\"\n id=\"BtnSubmit\">\n <span>Do It</span>\n </md-button>\n </md-dialog-actions>\n</form>");
$templateCache.put("/app/project/dialogs/request-update.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog request-update\" flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" id=\"DialogRequestUpdate\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Request Update</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex>\n <div class=\"margin-10\" layout=\"row\" layout-align=\"start center\">\n <img s3-src=\"/assets/images/avatars/al.png\" style=\"height:50px; width:50px;\" />\n <div class=\"margin-left-10\">\n Quickly post a message to the {{vm.item.toString()}} discussion board.\n </div>\n <span flex></span>\n <div layout=\"row\" layout-align=\"end center\" class=\"margin-left-20\">\n <md-checkbox ng-model=\"vm.message.Data.SendAsEmail\" class=\"margin-0\"><span style=\'white-space: nowrap\'>Copy to Email</span>\n <md-tooltip>Email a copy to recipients - Useful if they check email more than Align Us</md-tooltip>\n </md-checkbox>\n </div>\n </div>\n <md-divider></md-divider>\n\n <au-inline-post item=\"vm.message\" options=\"{expandOnLoad:true}\" before-add-post=\"vm.save\" on-complete=\"vm.close\" post-label=\"Post\" no-copy=\"true\" grow=\"true\"\n id=\"CkeMessage\" auto-focus=\"true\"></au-inline-post>\n\n </md-dialog-content>\n</md-dialog>");
$templateCache.put("/app/project/projects/detail.tmpl.html","<div class=\"project-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" Xselected=\"0\" item=\"vm.item\">\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Rich Text -->\n <!-- <md-card ng-if=\"::1 == 2\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnStoryEditorHeader\">\n <div class=\"md-title\">Rich Text Story Editor</div>\n <div class=\"description\">Explain all the details of your project in the story editor.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n <au-help-icon key=\"Project.StoryEditor\"></au-help-icon>\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1; toggleFullWindow($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\" class=\"md-primary\"></md-icon>\n <md-tooltip>Show Full Screen</md-tooltip>\n </md-button>\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" on-visible=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1\">\n <md-divider></md-divider>\n <div flex au-rich-text height=\"fill\" track-changes=\"true\" class=\"xfield\" item=\"vm.item\" item-field=\"Story\" project-id=\"vm.item._id\"\n resize-trigger=\"vm.resizeStoryDoc\" can-edit=\"vm.item\" acl=\"U\"></div>\n </div>\n </md-card> -->\n\n <!-- Story Editor Card -->\n <md-card name=\"StoryEditor\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnStoryEditorHeader\">\n <div class=\"md-title\">Project Plan</div>\n <div class=\"description\">Define the project goals, scope, approach and tasks.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm\">\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1; toggleFullWindow($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\" class=\"md-primary\"></md-icon>\n <md-tooltip>Show Full Screen</md-tooltip>\n </md-button>\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" on-visible=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1\">\n <md-divider></md-divider>\n <div id=\"StoryEditor\" class=\"au-cke-document\" item=\"vm.item\" item-field=\"Story\" project-id=\"vm.item._id\" resize-trigger=\"vm.resizeStoryDoc\"\n can-edit=\"vm.item\" acl=\"U\"></div>\n </div>\n </md-card>\n\n <!-- Ownership Card -->\n <md-card flex>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-structure\" class=\"zmdi-hc-fw auto-height padding-left-30 font-size-4 md-primary hide-xs hide-sm font-color-500\"></md-icon>\n <div layout=\"column\" flex id=\"BtnProjectHeader\">\n <div class=\"md-title\">Ownership</div>\n <div class=\"description\">Designate a responsible party to lead this project.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-folder\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-item-ownedby item=\"vm.item\"></au-item-ownedby>\n </div>\n </md-card>\n\n <!-- Dates Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Dates</div>\n <div class=\"description\">Edit the project\'s start and end dates.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <div layout=\"row\" layout-align=\"space-between center\">\n\n <div layout-gt-sm=\"column\" flex>\n <h3>Start Date</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Planned Start Date\" mdp-open-on-click ng-model=\"vm.item.PlannedStartDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtPlanStartDate\"></mdp-date-picker>\n </div>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Actual Start Date\" mdp-open-on-click ng-model=\"vm.item.DateStarted\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtActualStartDate\"></mdp-date-picker>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 160px;\"></div>\n\n <div layout-gt-sm=\"column\" flex>\n <h3>End Date</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Planned End Date\" mdp-open-on-click ng-model=\"vm.item.PlannedEndDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtPlanEndDate\"></mdp-date-picker>\n </div>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Actual End Date\" mdp-open-on-click ng-model=\"vm.item.DateEnded\" mdp-format=\"M/D/YYYY\" mdp-min-date=\"\'2000-01-01\'\"\n mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtActualEndDate\"></mdp-date-picker>\n </div>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Members Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Project Members</div>\n <div class=\"description\" layout=\"row\">\n <div flex>Add members/roles/titles/etc. to your project.</div>\n </div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm\">\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"vm.centerContentTrigger = vm.centerContentTrigger + 1; toggleFullWindow($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\" class=\"md-primary\"></md-icon>\n <md-tooltip>Show Full Screen</md-tooltip>\n </md-button>\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" au-can-edit=\"vm.item\" acl=\"U\" on-visible=\"vm.centerContentTrigger = vm.centerContentTrigger + 1\">\n <md-divider></md-divider>\n\n <div style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%; padding: 30px 10px;\" ng-if=\"$root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner\"\n ng-click=\"vm.showConfirmRemove = false\" layout=\"row\" layout-align=\"space-between center\">\n\n <div layout=\"row\" layout-align=\"end center\">\n <md-button aria-label=\"Add Member\" class=\"md-accent md-raised md-main-theme\" ng-click=\"vm.showAddMember($event)\" id=\"BtnAddMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add\"></i>\n <span flex>&nbsp; Add Member</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Import Team\" class=\"md-accent md-raised md-main-theme\" ng-click=\"vm.showLinkWithTeam()\" ng-disabled=\"vm.selected\"\n id=\"BtnImportTeam\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-accounts-add\"></i>\n <span flex>&nbsp; Import Team</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Remove Member\" class=\"md-accent md-raised md-main-theme\" ng-click=\"vm.showRemoveMember($event)\" ng-disabled=\"!vm.showRemoveButton()\"\n id=\"BtnRemoveMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"au au-account-remove\" style=\"line-height:0px;\"></i>\n <span flex>&nbsp; Remove Member</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Confirm Remove Member\" class=\"md-raised\" ng-click=\"vm.confirmRemoval($event)\" ng-if=\"vm.showConfirmRemove\"\n id=\"BtnConfirmRemoveMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"au au-account-remove\" style=\"line-height:0px;\"></i>\n <span flex>&nbsp; Confirm Removal of Member</span>\n </div>\n <md-tooltip>Removing a member takes them out of this team without affecting their user account.</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <div angular-org-chart nodes=\"vm.item.Members\" flex=\"grow\" style=\"background-color: white;\" ng-style=\"{\'height\':viewportHeight - 50 + \'px\'}\"\n node-width=\"200\" node-height=\"200\" parent-id-property=\"ParentId\" id-property=\"_id\" enable-selection=\"::vm.item.CanEdit()\"\n node-template=\"\'/app/structure/users-and-teams/team/node.tmpl.html\'\" enable-parent-update=\"::vm.item.CanEdit()\"\n zoom-to-fit-trigger=\"vm.centerContentTrigger\"></div>\n </div>\n </md-card>\n\n <!-- Task Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-view-column\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnTaskBoardHeader\">\n <div class=\"md-title\">Task Board</div>\n <div class=\"description\">Keep track of all the tasks and who they are assigned to.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-view-column\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <md-button class=\"md-icon-button big-icon-button hide-xs hide-sm\" ng-click=\"toggleFullWindow($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\" class=\"md-primary\"></md-icon>\n <md-tooltip>Show Full Screen</md-tooltip>\n </md-button>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" au-can-edit=\"vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-task-board item=\"vm.item\"></au-task-board>\n </div>\n </md-card>\n\n <!-- Strategic Alignment Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-format-valign-center\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAlignmentHeader\">\n <div class=\"md-title\">Strategic Alignment</div>\n <div class=\"description\">Ensure that your project aligns with your organization\'s initiatives.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-format-valign-center\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <md-autocomplete md-selected-item=\"vm.item.Initiative\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"initiative in $root.auUtility.searchInitiatives(vm.initiativeSearchText)\"\n md-search-text=\"vm.initiativeSearchText\" md-floating-label=\"Initiative\" md-item-text=\"initiative | auItemFilter: \'Initiative\'\"\n flex required>\n\n <md-item-template>\n <span md-highlight-text=\"vm.initiativeSearchText\" md-highlight-flags=\"i\">{{initiative | auItemFilter: \'Initiative\'}}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Security and Sharing -->\n <md-card ng-if=\"!$root.user.$AnonymousUser && vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Security and Sharing</div>\n <div class=\"description\">Control who, in addition to the Members, has read/write access to this project.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <au-item-security-and-sharing item=\"vm.item\"></au-item-security-and-sharing>\n <div ng-if=\"1==1 || $root.user.ReportsTo && vm.item.Type != \'Reminder\' && vm.item.Type != \'Note\'\">\n <md-divider></md-divider>\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n Note: Users in owning groups automatically have read access. Members automatically have write access.\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Documents Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\" only-list=\"!vm.item.CanEdit()\"></au-document-section>\n </div>\n </md-card>\n\n <!-- Discussion Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDiscussionHeader\">\n <div class=\"md-title\">Discussion</div>\n <div class=\"description\">Project conversation board.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-discussion-board item=\"vm.item\" activity-log=\"true\"></au-discussion-board>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings related to this project.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/project/task/detail.tmpl.html","<div class=\"task-item-detail\">\n <ng-form name=\"editItemForm\" auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" selected=\"1\" item=\"vm.item\">\n\n <!-- Task Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\">\n\n <!-- Start/Stop/Status Row -->\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-5\">\n <!-- Start/stop buttons -->\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-right-5\" style=\"border: solid thin rgba(255, 255, 255, 0.2);border-radius: 30px;\">\n <div class=\"md-whiteframe-1dp padding-left-12 margin-right-8 background-color-600\" style=\"border-radius: 20px;\" layout=\"row\"\n layout-align=\"center center\" ng-click=\"$event.stopPropagation()\">\n <div class=\"au-can-edit-button\" ng-click=\"vm.item.Start()\" ng-show=\"!vm.item.IsRunning\" id=\"BtnPlay\" aria-label=\"play\" layout=\"row\"\n layout-align=\"start center\">\n <span class=\"md-caption\">Start</span>\n <md-icon md-font-icon=\"zmdi zmdi-play-circle\" class=\"margin-right-5 font-color-100\" style=\"font-size: initial\"></md-icon>\n </div>\n <div class=\"au-can-edit-button\" ng-click=\"vm.item.Stop()\" ng-show=\"vm.item.IsRunning\" id=\"BtnPause\" aria-label=\"pause\" layout=\"row\"\n layout-align=\"start center\">\n <span class=\"md-caption\">Pause</span>\n <md-icon md-font-icon=\"zmdi zmdi-pause-circle\" class=\"margin-right-5 font-color-100\" style=\"font-size: initial\"></md-icon>\n </div>\n </div>\n <span flex class=\"md-caption margin-right-10\">\n <au-timer duration=\"vm.item.TotalDuration\" start-date=\"vm.item.LastStartedRunning\"></au-timer>\n </span>\n </div>\n\n <!-- Status (not started, etc.) -->\n <div layout=\"row\" layout-align=\"start center\" style=\"border: thin solid rgba(255, 255, 255, 0.2);border-radius: 30px;padding: 0px 8px;\"\n class=\"margin-right-10\">\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.item.KanbanState == \'Not Started\'\">\n <md-icon md-font-icon=\"zmdi zmdi-circle\" class=\"margin-right-3 font-size-1\" style=\"color:red;\"></md-icon>\n <span class=\"md-caption\">Not Started</span>\n </div>\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.item.KanbanState == \'In Progress\'\">\n <md-icon md-font-icon=\"zmdi zmdi-circle\" class=\"margin-right-3 font-size-1\" style=\"color:#39b54a;\"></md-icon>\n <span class=\"md-caption\">In Progress</span>\n </div>\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.item.KanbanState == \'Completed\'\">\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\" class=\"margin-right-3 font-size-1\" style=\"color:#39b54a;\"></md-icon>\n <span class=\"md-caption\">Completed</span>\n </div>\n </div>\n </div>\n </au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Task Details -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment-o\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnTaskHeader\">\n <div class=\"md-title\">\n Task Details\n </div>\n <div class=\"description\">Edit the task\'s details.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-assignment-o\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n\n <div layout=\"row\" layout-sm=\"column\" layout-xs=\"column\" layout-align=\"start start\" layout-align-sm=\"start start\" layout-align-xs=\"start start\"\n class=\"cke_match_height\">\n\n <div flex=\"70\" flex-sm=\"100\" flex-xs=\"100\">\n <!-- Description -->\n <div layout=\"row\" layout-align=\"start start\">\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-right-12 margin-top-9\"></md-icon>\n </div>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"Details\" display-mode=\"field\" extra-plugins=\"au-task,table,quicktable,tabletools,tableresize\"\n project-id=\"vm.item.Project\" resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\"\n acl=\"U\" style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Description\" flex></div>\n </div>\n </div>\n\n <div flex=\"30\" flex-sm=\"100\" flex-xs=\"100\" class=\"padding-left-10\" layout-fill>\n <!--Task State Dropdown-->\n <md-input-container class=\"margin-top-0\">\n <md-select ng-model=\"vm.item.KanbanState\" id=\"BtnStateMenu\" placeholder=\"Task State\">\n <md-option ng-repeat=\"state in vm.possibleStates\" ng-value=\"state.text\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"{{state.icon}}\" style=\"color:{{state.iconColor}};margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex ng-attr-id=\"BtnStateOption{{$index}}\">{{state.text}}</p>\n </div>\n </md-option>\n </md-select>\n </md-input-container>\n\n <!--Task Priority-->\n <md-input-container class=\"margin-top-0\">\n <md-select ng-model=\"vm.item.TaskPriority\" id=\"BtnPriorityMenu\" placeholder=\"Task Priority\">\n <md-option ng-repeat=\"priority in vm.taskPriorities\" ng-value=\"priority.number\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"{{priority.icon}}\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex ng-attr-id=\"BtnPriorityOption{{$index}}\">{{priority.text}}</p>\n </div>\n </md-option>\n </md-select>\n </md-input-container>\n\n <!--Estimated Hours-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"margin-right-10\"></md-icon>\n <md-input-container class=\"md-icon-float md-block\" flex>\n <label>Estimated Hours</label>\n <div>\n <input ng-model=\"vm.item.EstimatedHours\" type=\"number\" id=\"NumEstimatedHours\" />\n </div>\n </md-input-container>\n <au-help-icon key=\"Project.Task.EstimatedHours\"></au-help-icon>\n </div>\n\n <!--Assigned to User-->\n <div layout=\"row\" layout-align=\"start center\">\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-account\" class=\"margin-right-10\"></md-icon>\n </div>\n <md-autocomplete flex md-no-cache=\"true\" md-selected-item=\"vm.item.User\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"user in $root.auUtility.searchUsers({query:vm.assignedToSearchText})\"\n md-search-text=\"vm.assignedToSearchText\" md-floating-label=\"Assigned to\" md-item-text=\"user | fullNameFilter\"\n id=\"TxtUserAssign\">\n <md-item-template>\n <span md-highlight-text=\"vm.assignedToSearchText\" md-highlight-flags=\"i\" id=\"AutoUserAssign{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n\n <!--Assigned to Project-->\n <div ng-show=\"!vm.item.Meeting && !vm.item.Document\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-folder\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"vm.item.Project\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"project in vm.searchProjects(vm.projectSearchText, {Type: [\'U\']})\" md-search-text=\"vm.projectSearchText\"\n md-floating-label=\"Assigned to Project\" md-item-text=\"project | projectFilter\" id=\"TxtProjectAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.projectSearchText\" md-highlight-flags=\"i\" id=\"AutoProjectAssign{{$index}}\">{{ project | projectFilter }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"!vm.isAssignmentEmpty()\" ng-click=\"vm.item.$Project.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Project</md-tooltip>\n </md-button>\n </div>\n\n <!--Assigned to Meeting-->\n <div ng-show=\"!vm.item.Project && !vm.item.Document\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-meeting\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"vm.item.Meeting\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"meeting in vm.searchMeetings(vm.meetingSearchText, {Type: [\'U\']})\" md-search-text=\"vm.meetingSearchText\"\n md-floating-label=\"Assigned to Meeting\" md-item-text=\"meeting | meetingFilter\" id=\"TxtMeetingAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.meetingSearchText\" md-highlight-flags=\"i\" id=\"AutoMeetingAssign{{$index}}\">{{ meeting | meetingFilter }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"!vm.isAssignmentEmpty()\" ng-click=\"vm.item.$Meeting.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Meeting</md-tooltip>\n </md-button>\n </div>\n\n <!--Assigned to Document-->\n <div ng-show=\"!vm.item.Project && !vm.item.Meeting\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"vm.item.Document\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"document in vm.searchDocuments(vm.documentSearchText, {Type: [\'U\']})\" md-search-text=\"vm.documentSearchText\"\n md-floating-label=\"Assigned to Document\" md-item-text=\"document | auItemFilter: \'Document\'\"\n id=\"TxtDocumentAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.documentSearchText\" md-highlight-flags=\"i\" id=\"AutoDocumentAssign{{$index}}\">{{ document | auItemFilter: \'Document\' }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"!vm.isAssignmentEmpty()\" ng-click=\"vm.item.$Document.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Document</md-tooltip>\n </md-button>\n </div>\n\n <!--Parent Task-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"vm.item.ParentTask\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"task in vm.searchTasks(vm.taskSearchText, {Type: [\'U\']})\" md-search-text=\"vm.taskSearchText\"\n md-floating-label=\"Parent Task\" md-item-text=\"task | auItemFilter: \'Task\'\" id=\"TxtParentTask\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.taskSearchText\" md-highlight-flags=\"i\" id=\"AutoParentTask{{$index}}\">{{ task | auItemFilter: \'Task\' }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"vm.item.ParentTask\" ng-click=\"vm.item.$ParentTask.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Parent Task</md-tooltip>\n </md-button>\n </div>\n\n <!--Task Duplicate-->\n <div layout=\"row\" flex class=\"margin-right-10 margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon>\n <md-chips ng-model=\"vm.item.Duplicates\" md-require-match=\"true\" flex>\n <md-autocomplete flex class=\"md-icon-float md-block margin-0 margin-left-10\" placeholder=\"Duplicate of...\" md-search-text=\"vm.duplicatesSearchText\"\n md-items=\"task in vm.searchTasks(vm.duplicatesSearchText)\" md-autoselect=\"true\"\n md-select-on-match=\"true\" id=\"TxtTaskDuplicate\">\n <md-item-template>\n <span md-highlight-text=\"vm.duplicatesSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoTaskDuplicate{{$index}}\">\n {{task | auItemFilter : \'Task\'}}\n </span>\n </md-item-template>\n </md-autocomplete>\n <md-chip-template ng-click=\"vm.openTaskFab($event, $chip)\" style=\"cursor:pointer;\" ng-attr-id=\"ChipTaskDuplicate{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment\" class=\"margin-left-10\" class=\"grow\"></md-icon>\n <span>{{$chip | auItemFilter : \'Task\'}}</span>\n </md-chip-template>\n </md-chips>\n </div>\n\n <!--Auto Task Complete Post-->\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"space-between center\">\n <span class=\"margin-left-10\">{{ vm.item.AutoPostUpdates ? \"Auto Post\" : \"Don\'t Post\" }}\n <md-tooltip>Post on {{(vm.item.User ? vm.item.$User.FirstName + \"\'s\" : \'your\')}} page when\n complete.\n </md-tooltip>\n </span>\n <md-switch class=\"md-primary\" aria-label=\"Post Switch\" ng-model=\"vm.item.AutoPostUpdates\" id=\"SwitchCompletePost\"></md-switch>\n </div>\n </div>\n\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Dates Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Dates</div>\n <div class=\"description\">Edit the task\'s start and due dates.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <div layout=\"row\" layout-align=\"space-between center\">\n\n <div layout-gt-sm=\"column\" flex>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Planned Start Date\" mdp-open-on-click ng-model=\"vm.item.PlannedStartDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtPlanStartDate\"></mdp-date-picker>\n </div>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Actual Start Date\" mdp-open-on-click ng-model=\"vm.item.StartDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtActualStartDate\"></mdp-date-picker>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 160px;\"></div>\n\n <div layout-gt-sm=\"column\" flex>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Due Date\" mdp-open-on-click ng-model=\"vm.item.PlannedEndDate\" mdp-format=\"M/D/YYYY\" mdp-min-date=\"\'2000-01-01\'\"\n mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtPlanEndDate\"></mdp-date-picker>\n </div>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-placeholder=\"Actual Date Completed\" mdp-open-on-click ng-model=\"vm.item.EndDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\"\n flex id=\"TxtActualEndDate\"></mdp-date-picker>\n </div>\n </div>\n\n </div>\n\n\n <div layout=\"row\" layout-align=\"start end\">\n <h3>Task Regeneration</h3>\n <div class=\"padding-bottom-10\">\n &nbsp; - Is this a recurring task?\n </div>\n <au-help-icon key=\"Meeting.TaskRegeneration\"></au-help-icon>\n </div>\n <div layout=\"row\">\n <md-radio-group layout=\"column\" ng-model=\"vm.showTaskRepeatSettings\" ng-change=\"vm.onRepeatingChange()\">\n <md-radio-button ng-value=\"false\">No - This is a one-time task.</md-radio-button>\n <md-radio-button ng-value=\"true\" class=\"md-align-top-left\">Yes\n <span ng-if=\"vm.showTaskRepeatSettings\">\n - After this task is completed, Align Us will create a copy with a new due date.\n </span>\n <div ng-if=\"vm.showTaskRepeatSettings\" class=\"pointer-events-all cursor-default\">\n\n <div class=\"margin-top-10\">\n <b>How often should this task be completed?</b>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\"></md-icon>\n\n <div>\n This task should be completed every &nbsp;\n </div>\n <md-select ng-model=\"vm.item.RepeatsEvery.Interval\" md-size=\"1\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6]\">\n {{number}}\n </md-option>\n </md-select>\n\n <md-select ng-model=\"vm.item.RepeatsEvery.IntervalType\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-value=\"\'weekly\'\">\n week(s)\n </md-option>\n <md-option ng-value=\"\'monthly\'\">\n month(s)\n </md-option>\n </md-select>\n <div>\n .\n </div>\n </div>\n\n <div ng-if=\"vm.item.RepeatsEvery.IntervalType == \'weekly\'\" layout=\"column\" layout-align=\"start center\" class=\"margin-top-20\"\n layout-gt-sm=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\" hide show-gt-sm></md-icon>\n <div class=\"margin-right-10 nowrap\">\n Make the task due on a:\n </div>\n\n <div layout=\"row\" layout-wrap flex>\n <md-checkbox ng-repeat=\"day in $root.daysOfWeek\" ng-model=\"vm.item.RepeatsEvery.RepeatDays[day]\" class=\"margin-0 margin-right-10\"\n style=\"min-width: 100px\">{{day}}</md-checkbox>\n </div>\n </div>\n\n <div ng-if=\"vm.item.RepeatsEvery.IntervalType == \'monthly\'\" layout=\"row\" layout-align=\"start center\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\"></md-icon>\n\n <div class=\"nowrap\">Make the task due on the &nbsp; </div>\n <md-select ng-model=\"vm.item.RepeatsEvery.DayOfMonth\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]\">\n {{number}}\n </md-option>\n </md-select>\n <div>\n <sup>\n {{$root.auUtility.ordinal_suffix_of(vm.item.RepeatsEvery.DayOfMonth, true)}}\n </sup>\n &nbsp; day of the month.\n </div>\n </div>\n </div>\n\n\n </md-radio-button>\n </md-radio-group>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Security and Sharing -->\n <md-card ng-if=\"!$root.user.$AnonymousUser && vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Security and Sharing</div>\n <div class=\"description\">Control who has read/write access to this task.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <au-item-security-and-sharing item=\"vm.item\"></au-item-security-and-sharing>\n <div ng-if=\"$root.user.ReportsTo && vm.item.Type != \'Reminder\' && vm.item.Type != \'Note\'\" class=\"font-color-600\">\n <md-divider></md-divider>\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n Note: As your Reports-To, {{$root.user.ReportsTo | fullNameFilter}} always has read/write access to this task.\n </div>\n <div ng-if=\"vm.item.Project || vm.item.Meeting || vm.item.Document || vm.item.ParentTask\" class=\"font-color-600\">\n <md-divider></md-divider>\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n Note: Because this task is part of a\n <span ng-if=\"vm.item.Project\">Project,</span>\n <span ng-if=\"vm.item.Meeting\">Meeting,</span>\n <span ng-if=\"vm.item.Document\">Document,</span>\n <span ng-if=\"vm.item.ParentTask\">Task List,</span>\n users with permission to view\n <span ng-if=\"vm.item.Project\">the Project</span>\n <span ng-if=\"vm.item.Meeting\">the Meeting</span>\n <span ng-if=\"vm.item.Document\">the Document</span>\n <span ng-if=\"vm.item.ParentTask\">the Task List</span>\n will always be able to view this task.\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Documents Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- Discussion Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDiscussionHeader\">\n <div class=\"md-title\">Discussion</div>\n <div class=\"description\">View this task\'s history and discussion board.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-discussion-board item=\"vm.item\"></au-discussion-board>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Workflows Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-workflow\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"\n style=\"width: 1.28571em;\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Workflows</div>\n <div class=\"description\">Collection box for all your approval requests.</div>\n </div>\n <md-icon md-font-icon=\"au au-workflow\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\" style=\"width: 1.28571em;\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-workflows item=\"vm.item\"></au-workflows>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings related to this task.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/social/calendar/calendar.tmpl.html","<div class=\"landing-recent-groupings au-landing-page\" ng-class=\"$state.$current.data.sectionSettings.title.toLowerCase()\" layout=\"column\" layout-fill style=\"background-color:rgb(255,255,255)\" id=\"ContentLandingPage\">\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\"></div>\n <md-content class=\"padding-60\" style=\"margin-right:auto;margin-left:auto;\">\n <au-event-calendar events=\"vm.eventSources\"></au-event-calendar> \n </md-content>\n</div>");
$templateCache.put("/app/social/dialogs/add-meeting.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Meeting\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\"\n on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\"\n aria-label=\"Add Meeting Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddMeeting\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/meeting.png\">\n <h3>Plan A Meeting</h3>\n <div>Plan your meeting in a few short and easy steps! Set your goal for the meeting, invite the most important people, and add\n it to the calendar. The meeting manager keeps all the necessary information and documents in one place so you can have\n the most efficient meeting possible.</div>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/manage-documents.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/people.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/evaluate.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Manage all the necessary information and documents of your meeting.</div>\n <div class=\"padding-20\" flex=\"33\">Invite the most important people for the meeting.</div>\n <div class=\"padding-20\" flex=\"33\">Survey and evaluate your meeting\'s feedback.</div>\n </div>\n <au-from-template-state-button item-type=\"Meeting\"></au-from-template-state-button> \n </au-wizard-step>\n\n <au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleGoalEntered()\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Meeting Details</h3>\n <p>Enter a meaningful title, briefly explain the goal and indicate where you\'ll hold this meeting.</p>\n <div class=\"margin-top-40\">\n <md-input-container>\n <label>Title</label>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <input ng-model=\"vm.meeting.Title\" required id=\"TxtMeetingTitle\" />\n </md-input-container>\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-star-circle\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.meeting.Goal\" placeholder=\"Goal *\" id=\"CkeMeetingGoal\" grow=\"true\"></div>\n </div>\n </div>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-pin margin-right-10\"></md-icon>\n <md-autocomplete flex md-items=\"location in vm.searchLocations(vm.locationSearchText)\" md-search-text=\"vm.locationSearchText\"\n md-selected-item=\"vm.meeting.Location\" md-floating-label=\"Location\" md-min-length=\"0\" md-autoselect=\"true\" md-select-on-match=\"true\"\n id=\"TxtLocationName\">\n <md-item-template>\n <span md-highlight-text=\"vm.locationSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLocationName{{$index}}\">{{location}}</span>\n </md-item-template>\n </md-autocomplete>\n <au-help-icon key=\"Meeting.Location\"></au-help-icon>\n </div>\n </div>\n </au-wizard-step>\n\n <!--date and time-->\n <au-wizard-step step-name=\"dates\" step-bg=\"/assets/images/dialogs/post-event-bg.png\">\n <h3>Ready to Schedule?</h3>\n\n <p>Optionally, if this is a one-time meeting, enter when it will start and stop. If this is a recurring meeting, or you don\'t have the date yet, enter these details after the wizard closes.</p>\n\n <div layout=\"row\" layout-align=\"space-between center\" class=\"margin-top-20 margin-bottom-20\">\n\n <!--date-->\n <div layout-gt-sm=\"column\" flex=\"30\">\n <h3>Date</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Date\" ng-model=\"vm.meeting.StartDate\" mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" id=\"TxtStartDate\" class=\"md-icon-float md-block\"></mdp-date-picker>\n </div>\n </div>\n\n <div layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 160px;\"></div>\n\n <!--start time-->\n <div layout-gt-sm=\"column\" flex=\"30\">\n <h3>Start Time</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker flex mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.meeting.StartDate\" mdp-placeholder=\"Start Time\"\n id=\"TxtStartTime\" class=\"md-icon-float md-block\"></mdp-time-picker>\n </div>\n </div>\n\n <div layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 160px;\"></div>\n\n <!--end time-->\n <div layout-gt-sm=\"column\" flex=\"30\">\n <h3>End Time</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker flex mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.meeting.EndDate\" mdp-placeholder=\"End Time\"\n id=\"TxtEndTime\" class=\"md-icon-float md-block\"></mdp-time-picker>\n </div>\n </div>\n </div>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/social/dialogs/edit-topic-item.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" id=\"DialogEditTopicItem\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Edit Topic Item</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.mdDialog.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex class=\"padding-10\">\n <div class=\"md-body-1 margin-top-10\">Choose an item that you will discuss at this meeting. This meeting will appear in that item\'s Meeting List. Only items that have a Meeting List card will be available. <strong>Start by selecting an item type.</strong></div>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container class=\"margin-right-10\">\n <md-icon md-font-icon=\"zmdi zmdi-label-alt-outline\"></md-icon>\n <label>Item Type</label>\n <md-select ng-model=\"vm.selectedTopicItemType\">\n <md-option ng-repeat=\"type in vm.topicItemTypes\" ng-value=\"type\">\n {{type}}\n </md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex>\n <md-autocomplete ng-disabled=\"vm.typeSelected\" md-selected-item=\"vm.topicItem\" md-autoselect=\"true\" md-select-on-match=\"true\" md-require-match=\"true\" md-items=\"item in vm.oneSearch()\" md-search-text=\"vm.itemSearchText\" md-floating-label=\"Search for Topic Item\" md-item-text=\"vm.topicItem.SearchTitle || vm.topicItem.toString()\">\n <md-item-template>\n <span md-highlight-text=\"vm.itemSearchText\" md-highlightFlags=\"i\">{{item.SearchTitle}}</span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.mdDialog.hide()\">\n <span>Cancel</span>\n </md-button>\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.finish()\" type=\"submit\">\n <span>Save</span>\n </md-button>\n </md-dialog-actions>\n </md-dialog>");
$templateCache.put("/app/social/dialogs/new-private-message.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog new-private-message\" flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" id=\"DialogComposeMessage\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Compose Message</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex>\n <div class=\"header\">\n <md-chips ng-model=\"vm.conversation.$UsersAndTeams\" md-require-match=\"true\" md-transform-chip=\"vm.transformUserChip($chip)\" flex>\n <md-autocomplete md-search-text=\"vm.toUsersSearchText\" md-items=\"item in $root.auUtility.searchUsersAndTeams(vm.toUsersSearchText, false, true, true, true)\" placeholder=\"To...\" md-select-on-match=\"true\" md-autoselect=\"true\" id=\"TxtToUsers\" md-autofocus>\n <span md-highlight-text=\"vm.toUsersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoToUser{{$index}}\">\n {{item.$Display}}\n </span>\n </md-autocomplete>\n <md-chip-template layout=\"row\">\n <au-profile-image item=\"$chip.item\" size=\"30\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipToUser{{$index}}\">{{$chip.$Display}}</span>\n </md-chip-template>\n </md-chips>\n <md-input-container md-no-float>\n <input ng-model=\"vm.conversation.Title\" placeholder=\"Subject\" class=\"subject\" id=\"TxtSubject\" md-maxlength=\"75\" maxlength=\"75\" style=\"padding-right: 125px\"/>\n </md-input-container>\n </div>\n \n <au-inline-post item=\"vm.message\" options=\"{expandOnLoad:true}\" before-add-post=\"vm.createConversation\" on-complete=\"vm.editComplete\" post-label=\"Send\" no-copy=\"true\" grow=\"true\" id=\"CkeMessage\" auto-focus=\"false\"></au-inline-post>\n \n <md-checkbox ng-model=\"vm.message.Data.SendAsEmail\" class=\"send-as-email\">Copy to Email\n <md-tooltip>Email a copy to recipients - Useful if they check email more than Align Us</md-tooltip>\n </md-checkbox>\n </md-dialog-content>\n</md-dialog>");
$templateCache.put("/app/social/dialogs/page-wizard.tmpl.html","<md-dialog au-wizard dialog-title=\"{{vm.pageWasNew ? \'Add\' : \'Manage\'}} {{::vm.getPageTypeText()}}\" on-review=\"vm.review()\"\n on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\"\n disable-next=\"vm.disableNext\" class=\"create-page-dialog au-dialog\" aria-label=\"Create and Edit Page\" flex=\"50\" flex-sm=\"100\"\n flex-md=\"60\" style=\"min-height: 480px\" id=\"AddPage\">\n\n <au-wizard-step step-name=\"intro\" on-next-step=\"vm.determineEventStepVisible(); vm.adjustForConversation()\" step-bg=\"/assets/images/dialogs/addbg.png\">\n <h3>{{::vm.getTitlePlaceholder()}}</h3>\n\n <!--discussion board-->\n <div ng-if=\"vm.page.Type == \'Discussion\' || vm.page.Type == \'Conversation\'\">\n <p>A discussion board is a stream of messages. With easy privacy settings and a streamlined interface, a discussion\n board lets people connect on any they topic they wish.\n </p>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/discussion-topic.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/discussion-privacy.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/discussion-messages.png\">\n </div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Make one for any topic under the sun!</div>\n <div class=\"padding-20\" flex=\"33\">Control who can view and post.</div>\n <div class=\"padding-20\" flex=\"33\">A streamlined message interface.</div>\n </div>\n </div>\n\n <!--event-->\n <div ng-if=\"vm.page.Type == \'Event\'\">\n <p>An event page keeps users up to date on an upcoming occasion. With event specific fields such as the date and\n location as well as RSVP functions, event pages make it easy for people to respond and coordinators to manage\n the event.\n </p>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/event-list.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/event-feed.png\">\n </div>\n <div flex=\"33\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/posts.png\">\n </div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Manage your event effortlessly.</div>\n <div class=\"padding-20\" flex=\"33\">Keep users up to date on an upcoming event.</div>\n <div class=\"padding-20\" flex=\"33\">Easily connect and engage with attendees by posting on the event page.</div>\n </div>\n </div>\n\n <!--general-->\n <div ng-if=\"vm.page.Type != \'Discussion\' && vm.page.Type != \'Event\' && vm.page.Type != \'Conversation\'\">\n <p>Pages are a place for people to come together for a common purpose. All users will be able to make posts on the\n page as well as follow the page to see those posts on their news feed. Page editors will maintain the content\n of the page, like the contact info and cover photo.</p>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"50\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/collaborate-posts.png\">\n </div>\n <div flex=\"50\" class=\"grow\">\n <img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/newsfeed.png\">\n </div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"50\">Create a space for people to come together, discuss, and share ideas.</div>\n <div class=\"padding-20\" flex=\"50\">Stay current on your page’s activity and get them right in your News Feed.</div>\n </div>\n </div>\n\n <au-from-template-state-button item-type=\"Page\" ng-if=\"vm.pageWasNew\"></au-from-template-state-button>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"page-details\" step-bg=\"/assets/images/dialogs/typebg.png\" on-next-step=\"vm.confirmTitleEntered()\">\n <h3>Title</h3>\n <p ng-if=\"vm.page.Type == \'Discussion\'||vm.page.Type == \'Conversation\'\">What topic will you be discussing?</p>\n <p ng-if=\"vm.page.Type == \'Event\'\">What\'s the name of this event?</p>\n <p ng-if=\"vm.page.Type != \'Discussion\' && vm.page.Type != \'Event\' && vm.page.Type != \'Conversation\'\">What do you want to call this page?</p>\n <div class=\"margin-top-20\" layout=\"column\">\n <md-input-container class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input ng-model=\"vm.page.Title\" required id=\"TxtPageTitle\" />\n </md-input-container>\n\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.page.SideBarWidgets[0].Data.PageDescription\" placeholder=\"Description\"\n id=\"CkePageDescription\" grow=\"true\"></div>\n </div>\n </div>\n </div>\n </au-wizard-step>\n\n\n <au-wizard-step step-name=\"page-profile-photo\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <h3>Contact Info</h3>\n <p>Optionally, list contact details and supply a profile image below.</p>\n <div class=\"margin-top-20\">\n <div layout=\"row\" layout-align=\"center\" layout-xs=\"column\" layout-align-xs=\"center stretch\">\n <div layout=\"column\" flex>\n <md-input-container class=\"md-icon-float md-block\">\n <label>Email</label>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <input type=\"email\" ng-model=\"vm.page.SideBarWidgets[0].Data.contactEmail\" id=\"TxtPageEmail\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\"\n />\n </md-input-container>\n <md-input-container class=\"md-icon-float md-block\">\n <label>Phone</label>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <input type=\"tel\" ng-model=\"vm.page.SideBarWidgets[0].Data.contactPhone\" id=\"TxtPagePhone\" />\n </md-input-container>\n <md-input-container class=\"md-icon-float md-block\" ng-if=\"vm.page.Type != \'Event\'\">\n <label>Contact Address</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input type=\"text\" ng-model=\"vm.page.SideBarWidgets[0].Data.contactAddress\" id=\"TxtPageAddress\" />\n </md-input-container>\n </div>\n <div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.page.Type!=\'Event\'\">\n <au-image-uploader item=\"vm.page\" style=\"height: 100px; width: 100px; margin:20px\" id=\"BtnUploadImage\"></au-image-uploader>\n </div>\n </div>\n </div>\n </au-wizard-step>\n\n <!-- page.Event.Start, page.Event.End, page.Event.Location, page.Event.Attending[{User, Response, Comment}] page.SideBarWidgets[0].Data.PageDescription -->\n\n <au-wizard-step step-name=\"page-event-details\" step-bg=\"/assets/images/dialogs/post-event-bg.png\">\n <h3>Event Date and Time</h3>\n <p>The start and end of the event will be displayed on this event\'s page in the sidebar widget. Enter the dates and\n times your event will begin and end.</p>\n\n <div layout=\"column\" layout-gt-sm=\"row\" class=\"margin-top-40\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-open-on-click required name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Start Date\" ng-model=\"vm.page.Event.Start\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\"\n id=\"TxtStartDate\">\n <div ng-messages=\"eventPage2.date.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-date-picker>\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" required ng-model=\"vm.page.Event.Start\" mdp-placeholder=\"Start Time\"\n class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\" id=\"TxtStartTime\">\n <div ng-messages=\"eventPage2.time.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-time-picker>\n </div>\n\n <div layout=\"column\" layout-gt-sm=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker mdp-open-on-click required name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"End Date\" ng-model=\"vm.page.Event.End\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\"\n id=\"TxtEndDate\">\n <div ng-messages=\"eventPage2.date.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-date-picker>\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" required ng-model=\"vm.page.Event.End\" mdp-placeholder=\"End Time\"\n class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\" id=\"TxtEndTime\">\n <div ng-messages=\"eventPage2.time.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-time-picker>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"page-event-details-2\" step-bg=\"/assets/images/dialogs/location.png\">\n <h3>Event Location</h3>\n <p>The location details will be displayed publicly on the event\'s page in the sidebar widget. Enter the address of your\n event to help guests find their way.</p>\n <div class=\"margin-top-40\">\n <md-input-container class=\"md-icon-float md-block\">\n <label>Address</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input type=\"text\" ng-model=\"vm.page.Event.Location.Address1\" id=\"TxtAddress\">\n </md-input-container>\n <div layout=\"column\" layout-gt-sm=\"row\">\n <md-input-container class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\" id=\"TxtCity\">\n <label>City</label>\n <md-icon md-font-icon=\"zmdi zmdi-city\"></md-icon>\n <input type=\"text\" ng-model=\"vm.page.Event.Location.City\">\n </md-input-container>\n\n <md-input-container class=\"md-block\" flex-gt-sm=\"20\" flex=\"100\">\n <label>State</label>\n <md-icon md-font-icon=\"zmdi zmdi-balance\" hide-gt-sm></md-icon>\n <md-select ng-model=\"vm.page.Event.Location.StateProv\" ng-model-options=\"[{trackBy: \'$value\'}]\" id=\"DrpEventState\">\n <md-option ng-repeat=\"state in ::vm.states\" ng-value=\"state\" ng-attr-id=\"SettingsDrpStateOption{{$index}}\">\n {{state}}\n </md-option>\n </md-select>\n </md-input-container>\n\n <md-input-container class=\"md-block\" flex-gt-sm=\"30\" flex=\"100\" id=\"TxtZipCode\">\n <label>Zip Code</label>\n <md-icon md-font-icon=\"zmdi zmdi-markunread-mailbox\" hide-gt-sm></md-icon>\n <input name=\"zipCode\" type=\"tel\" ng-model=\"vm.page.Event.Location.ZipPostalCode\">\n </md-input-container>\n </div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"page-editors-and-owner\" step-bg=\"/assets/images/dialogs/user.png\">\n <h3>Page Editors</h3>\n <p ng-if=\"vm.page.Type == \'Discussion\'\">Will others help you moderate this discussion board?\n <br/> A page editor can remove posts and control privacy settings.</p>\n <p ng-if=\"vm.page.Type == \'Conversation\'\">Will others help you moderate this conversation?\n <br/> A conversation editor can remove messages and control conversation settings.</p>\n <p ng-if=\"vm.page.Type == \'Event\'\">Will others help you host this event?\n <br/> A page editor can update the event page and remove any inappropriate posts.</p>\n <p ng-if=\"vm.page.Type != \'Discussion\' && vm.page.Type != \'Event\' && vm.page.Type != \'Conversation\'\">Will others help administer this page?\n <br/> A page editor can update the cover photo, control privacy settings and remove posts.</p>\n\n\n <div layout=\"row\" class=\"md-icon-float md-block margin-top-40\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"float:left;\"></md-icon>\n <md-chips ng-model=\"vm.page.Editors\" md-require-match=\"true\" md-transform-chip=\"vm.transformEditorsChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.editorsSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.editorsSearchText, excludeContacts: true})\"\n placeholder=\"Add Editor\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtPageEditor\">\n <div layout=\"row\" layout-align=\"start center\">\n <!--chip profile image not working-->\n <!--<au-profile-image item=\"$chip\" size=\"32\"></au-profile-image>-->\n <span md-highlight-text=\"vm.editorsSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoPageEditor{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </div>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipPageEditor{{$index}}\">{{$chip | fullNameFilter}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"page-members-and-viewers\" step-bg=\"/assets/images/dialogs/user.png\" on-next-step=\"vm.determinePublicLinkVisible();\">\n <h3>Internal Privacy Settings</h3>\n\n <p ng-if=\"vm.page.Type!=\'Conversation\'\">\n <md-switch ng-model=\"vm.page.IsPrivate\" aria-label=\"Is Private\" class=\"md-warn\" id=\"SwitchPrivacy\">\n <span ng-if=\"vm.page.IsPrivate\">Private: Limit access to this {{::vm.getPageTypeText()}} to the people below.</span>\n <span ng-if=\"!vm.page.IsPrivate\">Visible to all Users: List this {{::vm.getPageTypeText()}} in {{::$root.Organization.Name}}\'s Directory.</span>\n </md-switch>\n </p>\n\n <p ng-if=\"vm.page.Type==\'Conversation\'\">\n <md-switch ng-model=\"vm.page.IsPrivate\" aria-label=\"Is Private\" class=\"md-warn\" ng-disabled=\"true\">\n <span>Conversations are always private. Enter the names of the members of this conversation below.</span>\n </md-switch>\n </p>\n\n <p ng-if=\"!vm.page.IsPrivate\">\n All users in {{$root.Organization.Name}} will find this {{::vm.getPageTypeText()}} in their directory and are welcome to\n post on it.\n <span ng-if=\"vm.page.Type==\'Discussion\'\"> Only Members will see it in their inbox.</span>\n </p>\n\n <!--Always show Members for discussion boards-->\n <div ng-if=\"vm.page.Type==\'Discussion\' && !vm.page.IsPrivate\" layout=\"row\" class=\"md-icon-float md-block margin-top-40\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"float:left;\"></md-icon>\n <md-chips ng-model=\"vm.page.Members\" md-require-match=\"true\" md-transform-chip=\"vm.transformMembersChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.membersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.membersSearchText})\"\n placeholder=\"Add Member\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtPageMember\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.membersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoPageMember{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </div>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipPageMember{{$index}}\">{{$chip | fullNameFilter}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </div>\n\n <div ng-if=\"vm.page.IsPrivate\">\n <p ng-if=\"vm.page.Type!=\'Conversation\'\">Choose who has access to this {{::vm.getPageTypeText()}}. Those who you share the page with will only be able\n to see the {{::vm.getPageTypeText()}}, not post on it. Members can do both.</p>\n\n <div layout=\"row\" class=\"md-icon-float md-block margin-top-40\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"float:left;\"></md-icon>\n <md-chips ng-model=\"vm.page.Members\" md-require-match=\"true\" md-transform-chip=\"vm.transformMembersChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.membersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.membersSearchText})\"\n placeholder=\"Add Member\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtPageMember\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.membersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoPageMember{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </div>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipPageMember{{$index}}\">{{$chip | fullNameFilter}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </div>\n\n <div layout=\"row\" class=\"md-icon-float md-block margin-top-40\" ng-if=\"vm.page.Type!=\'Conversation\'\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"float:left;\"></md-icon>\n <md-chips ng-model=\"vm.page.SharedWith\" md-require-match=\"true\" md-transform-chip=\"vm.transformViewersChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.viewersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.viewersSearchText})\"\n placeholder=\"Add Viewer\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtPageViewer\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.viewersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoPageViewer{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </div>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipPageViewer{{$index}}\">{{$chip | fullNameFilter}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"public-link\" step-bg=\"/assets/images/dialogs/user.png\">\n <h3>Public Link Settings</h3>\n\n <p>\n If this page should be visible to the public, no sign-in-required, turn on Public Link Sharing and share the link to this\n Page anywhere on the internet.\n </p>\n\n <!--Anonymous Read-->\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-globe-lock\" class=\"margin-right-15\"></md-icon>\n <span>Public Link Sharing </span>\n <au-help-icon key=\"Project.Privacy\"></au-help-icon>\n <span flex></span>\n <span class=\"margin-right-10\">{{ vm.page.IsAnonymousReadAllowed ? \'Link Sharing Enabled\' : \'Link Sharing Disabled\' }}\n </span>\n <md-switch class=\"md-primary\" aria-label=\"Anonymous Access\" ng-model=\"vm.page.IsAnonymousReadAllowed\" id=\"SwitchAnonymousRead\"></md-switch>\n </div>\n\n <!-- Anonymous Link -->\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.page.IsAnonymousReadAllowed\">\n <md-icon md-font-icon=\"zmdi zmdi-link\" class=\"margin-right-15\"></md-icon>\n <div flex class=\"font-color-600\">Anyone with the link can {{vm.item.IsAnonymousWriteAllowed ? \'edit content\' : \'view but not post\'}}.\n <span style=\"white-space: nowrap\">- No sign in required.</span>\n </div>\n <input type=\"input\" value=\"{{$root.location.origin}}/page/{{vm.page._id}}\" flex class=\"link-sharing-url\"\n readonly onclick=\"this.select()\" />\n </div>\n </au-wizard-step>\n\n <!--Only for Event pages-->\n <au-wizard-step step-name=\"page-event-details-3\" step-bg=\"/assets/images/dialogs/post-status-bg.png\">\n <h3>Invite Users</h3>\n\n <p>Optionally, create a group message inviting users to your event.</p>\n\n <div class=\"margin-top-40\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:18px;\"></md-icon>\n <md-chips ng-model=\"vm.invitedUsers\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.invitedUsers, $chip)\"\n flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.sharedWithSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.sharedWithSearchText})\"\n placeholder=\"Share with these users...\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtWhereToShare\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoWhereToShare{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\" ng-attr-id=\"ChipWhereToShare{{$index}}\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span class=\"margin-left-10\" ng-attr-id=\"ChipWhereToShare{{$index}}\">{{$chip | fullNameFilter }}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.shareText\" placeholder=\"Personal message...\" id=\"CkeShareMessage\"\n grow=\"true\"></div>\n </div>\n </div>\n\n </div>\n </au-wizard-step>\n\n</md-dialog>");
$templateCache.put("/app/social/dialogs/select-cover-photo.tmpl.html","<md-dialog flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"max-height: 80vh;\" id=\"DialogCoverPhoto\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n Select A Cover Photo\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\">\n\n <form>\n <div layout=\"row\" class=\"md-padding\" layout-align=\"start start\">\n <md-input-container flex=\"50\">\n <input ng-model=\"vm.searchText\" placeholder=\"Search Google Images\" layout-fill id=\"TxtSearchGoogle\" autocomplete=\"off\"/>\n </md-input-container>\n <button ng-click=\"vm.search(vm.searchText)\" class=\"md-button md-raised\" style=\"height: 40px;\" id=\"BtnSearchGoogle\">Search</button>\n <span flex></span>\n <au-file-uploader on-upload=\"vm.onDocumentsUploaded\" on-upload-fail=\"vm.onUploadFail\" on-select=\"vm.onDocumentsSelected\" accept=\"image/*\" ng-if=\"!vm.uploading\" \n s3-options=\"{makePublic: true}\"\n id=\"BtnUploadImage\">\n <md-button class=\"md-raised md-primary\" style=\"height: 40px;\">\n <md-icon md-font-icon=\"zmdi zmdi-upload\"></md-icon>Upload file</md-button>\n </au-file-uploader>\n <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\" ng-if=\"vm.uploading\"></md-progress-circular>\n </div>\n <md-popout-card-list>\n <md-card ng-repeat=\"img in vm.searchResults track by $index\">\n <md-card-content>\n <div ng-style=\"{\'background-image\': \'url(\' + img + \')\'}\" style=\"height: 150px; width: 100%; background-size: cover; background-position: center center\" class=\"background-color-400\"\n ng-click=\"vm.select(img)\" ng-attr-id=\"BtnCoverPhoto{{$index}}\"></div>\n </md-card-content>\n </md-card>\n </md-popout-card-list>\n </form>\n <md-button ng-click=\"vm.loadMore()\" id=\"BtnLoadMore\">Load More</md-button>\n\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" class=\"margin-bottom-20 margin-right-20\">\n <span flex class=\"text-ellipsis\" style=\"color:#999\">{{vm.selected}}</span>\n <md-button ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" id=\"BtnFinish\">\n Done\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/social/dialogs/select-profile-photo.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog select-profile-dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"max-height: 90vh;\"\n id=\"DialogCoverPhoto\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n Select A Profile Image\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n\n <md-dialog-content>\n\n <form>\n <div layout=\"row\" layout-xs=\"column\" layout-align-xs=\"start stretch\" class=\"md-padding\" layout-fill>\n <div layout=\"row\" layout-align=\"space-between start\" layout-fill>\n <md-input-container flex>\n <input ng-model=\"vm.searchText\" placeholder=\"Search Google Images\" layout-fill id=\"TxtSearchGoogle\" autocomplete=\"off\" />\n </md-input-container>\n <button ng-click=\"vm.search(vm.searchText)\" class=\"md-button md-raised\" style=\"height: 40px;\" id=\"BtnSearchGoogle\">\n <md-icon md-font-icon=\"zmdi zmdi-search\" hide-gt-xs></md-icon>\n <span hide-xs>Search</span></md-button>\n </button>\n </div>\n\n <div layout-xs=\"row\" layout-align-xs=\"center start\">\n <input type=\"file\" id=\"fileInput\" style=\"width: 0; visibility: hidden;\" />\n <md-button class=\"md-raised md-accent\" style=\"height: 40px;\" onclick=\"$(\'.select-profile-dialog #fileInput\').click()\" >\n <md-icon md-font-icon=\"zmdi zmdi-upload\"></md-icon>\n <span>Upload file &nbsp;</span></md-button>\n <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"40\" class=\"md-accent\" ng-if=\"vm.uploading\"></md-progress-circular>\n </div>\n \n </div>\n\n <div layout=\"row\" layout-align=\"start start\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <md-popout-card-list ng-if=\"vm.showSearchResults\" layout-fill>\n <md-card ng-repeat=\"img in vm.searchResults track by $index\">\n <md-card-content>\n <div ng-style=\"{\'background-image\': \'url(\' + img + \')\'}\" style=\"height: 250px; width: 100%; background-size: cover; background-position: center center\"\n class=\"background-color-400\" ng-click=\"vm.select(img)\" ng-attr-id=\"BtnCoverPhoto{{$index}}\"></div>\n </md-card-content>\n </md-card>\n <md-card>\n <div layout=\"column\" layout-align=\"center center\">\n <md-button ng-click=\"vm.loadMore()\" id=\"BtnLoadMore\">Load More</md-button>\n </div>\n </md-card>\n </md-popout-card-list>\n\n\n <div class=\"cropArea md-padding\" ng-if=\"!vm.showSearchResults\" flex>\n <img-crop image=\"vm.myImage\" result-image=\"vm.myCroppedImage\" on-load-error=\"vm.imgLoadError()\"></img-crop>\n </div>\n\n <div flex=\"20\" flex-xs=\"100\" style=\"min-width: 250px\" layout=\"column \" layout-align=\"start center\">\n <p class=\"md-body-1 opacity-50\">Preview:</p>\n <div class=\"preview-cropped\">\n <img ng-src=\"{{vm.myCroppedImage}}\" />\n </div>\n </div>\n\n </div>\n\n </form>\n\n </md-dialog-content>\n\n <md-dialog-actions layout=\"row\" class=\"margin-bottom-20 margin-right-20\">\n <span flex class=\"text-ellipsis\" style=\"color:#999\">{{vm.selected}}</span>\n <md-button ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Cancel\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" id=\"BtnFinish\">\n Done\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/social/dialogs/select-user.tmpl.html","<md-dialog>\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n {{vm.options.title}}\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\">\n <div class=\"margin-20\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-add\" style=\"top:18px;\"></md-icon>\n <md-chips ng-model=\"vm.selectedUsers\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.selectedUsers, $chip); $root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.selectedUsers}) \" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.selectUserText\" md-items=\"user in vm.searchUsers({query:vm.selectUserText, excludeContacts: vm.options.excludeContacts, showAdd: true})\" placeholder=\"Select user(s)\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtSelectUser\">\n <span md-highlight-text=\"vm.selectUserText\" md-highlight-flags=\"i\" id=\"BtnSelectUser{{::$index}}\">\n {{user | fullNameFilter}}\n </span>\n </md-autocomplete>\n <md-chip-template>\n <span class=\"margin-left-10\" ng-attr-id=\"ChipSelectUser{{::$index}}\">{{$chip | fullNameFilter }}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" class=\"margin-bottom-20 margin-right-20\">\n <md-button ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" id=\"BtnSelect\">\n Done\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/social/dialogs/universal-share.tmpl.html","<md-dialog flex=\"50\" flex-sm=\"100\" flex-md=\"60\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n Share With Users\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" class=\"share-dialog\">\n <!--User Page(s) to Share on-->\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-desktop-windows\" style=\"top:18px;\"></md-icon>\n <md-chips ng-model=\"vm.shareOnPages\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.shareOnPages, $chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.userSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.userSearchText})\"\n placeholder=\"Share with these users...\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtWhereToShare\">\n <span md-highlight-text=\"vm.userSearchText\" md-highlight-flags=\"i\" id=\"AutoWhereToShare{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </md-autocomplete>\n <md-chip-template layout=\"row\" ng-attr-id=\"ChipWhereToShare{{$index}}\">\n <au-profile-image item=\"$chip\" size=\"30\" class=\"grow\"></au-profile-image>\n <span>{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n\n <!--Optional Message-->\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.shareIntro\" placeholder=\"Optional Message\" id=\"CkeSaySomething\"\n grow=\"true\"></div>\n </div>\n </div>\n \n <!--Item to Share - there is always only 1 item in vm.itemToShare-->\n <div layout=\"row\" class=\"margin-top-40\">\n <au-profile-image item=\"vm.itemToShare[0]\" size=\"25\" class=\"margin-right-20\"></au-profile-image>\n <div ng-if=\"vm.itemToShare[0].$key == \'Post\'\" layout=\"column\" style=\"line-height:20px;\">\n <div layout=\"row\" layout-align=\"start center\" class=\"font-color-700\">\n <span class=\"md-caption font-weight-500\">{{vm.itemToShare[0].$Creator.FirstName}}</span>\n <div ng-if=\"vm.itemToShare[0].$Creator != vm.itemToShare[0].$Page.toString()\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-caret-right\" class=\"md-primary\" style=\"margin:-4px -8px -4px -4px;\"></md-icon>\n <span class=\"md-caption\">{{vm.itemToShare[0].$Page.toString()}}</span>\n </div>\n <span flex></span>\n </div>\n <div dynamic=\"vm.sharedItemTitle\"></div>\n </div>\n <div ng-if=\"vm.itemToShare[0].$key != \'Post\'\"><strong>{{vm.sharedItemTitle}}</strong></div>\n </div>\n\n <!--Note: sharing a private page-->\n <div ng-if=\"vm.itemToShare[0].$key == \'Page\' && vm.itemToShare[0].IsPrivate\" layout=\"row\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle-o\" class=\"margin-right-20\"></md-icon>\n <span class=\"md-caption\">Note: Sharing a private page will give users access to view the page but not post on it. Make them a Member of the page to give them access to post on it.</span>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" class=\"margin-15\">\n <md-button class=\"md-raised margin-right-10\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" id=\"BtnShare\">\n Share\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/social/meetings/detail.tmpl.html","<ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\"\n ignore-fields=\"[\'Attendees\', \'EstimatedCost\']\">\n <div class=\"meeting-item-detail\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Meeting Details card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingHeader\">\n <div layout=\"row\" layout-align=\"start center\" class=\"md-title\">\n <div>Meeting Details</div>\n\n <!-- if master -->\n <div class=\"pill faderight font-color-600\" ng-if=\"vm.item.RepeatsEvery\">\n <md-icon md-font-icon=\"zmdi zmdi-graduation-cap\" class=\"grow font-color-600\"></md-icon>\n <span>Master of a recurring series</span>\n </div>\n <!-- if recurring -->\n <div class=\"pill faderight font-color-600\" ng-if=\"vm.item.LinkedToRecurring\">\n <md-icon md-font-icon=\"zmdi zmdi-refresh\" class=\"grow font-color-600\"></md-icon>\n <span>Part of a recurring series</span>\n </div>\n\n </div>\n <div class=\"description\">Edit the meeting\'s details.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\" layout-gt-sm=\"row\">\n <div flex=\"70\">\n <!-- Title -->\n <md-input-container class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required id=\"TxtMeetingTitle\" />\n </md-input-container>\n <!--Creator -->\n <div layout=\"row\" class=\"md-caption\" flex style=\"margin-left:40px; position:relative; top:-10px; color: rgba(0,0,0,0.54);\">\n <span>Created by</span>\n <span id=\"StringCreator\" class=\"margin-left-5\">\n <strong>{{vm.item.Creator | fullNameFilter}} &nbsp;</strong>\n </span>\n </div>\n <!-- Goal -->\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-star-circle\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.item.Goal\" placeholder=\"Goal\" id=\"CkeMeetingGoal\" grow=\"true\"></div>\n </div>\n </div>\n\n <!--Location-->\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-pin margin-right-10\"></md-icon>\n <md-autocomplete flex md-items=\"location in vm.searchLocations(vm.locationSearchText)\" md-search-text=\"vm.locationSearchText\"\n md-selected-item=\"vm.item.Location\" md-floating-label=\"Location\" md-min-length=\"0\" md-autoselect=\"true\"\n md-select-on-match=\"true\" id=\"TxtLocationName\">\n <md-item-template>\n <span md-highlight-text=\"vm.locationSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLocationName{{$index}}\">{{location}}</span>\n </md-item-template>\n </md-autocomplete>\n <au-help-icon key=\"Meeting.Location\"></au-help-icon>\n </div>\n\n <!-- Date and Time -->\n <div layout=\"row\" layout-align=\"start end\">\n <h3>Meeting Date(s) and Time(s)</h3>\n <au-help-icon key=\"Meeting.TaskRegeneration\"></au-help-icon>\n </div>\n <div layout=\"row\">\n <md-radio-group layout=\"column\" ng-model=\"vm.showRepeatSettings\" ng-change=\"vm.onRepeatingChange()\">\n <md-radio-button ng-value=\"false\" class=\"md-align-top-left\">This is a one-time meeting.\n <!--date/time-->\n <div layout=\"row\" layout-align=\"space-between center\" class=\"margin-top-20 margin-bottom-20 pointer-events-all cursor-default\"\n ng-if=\"!vm.showRepeatSettings\">\n\n <div layout-gt-sm=\"column\" flex>\n <h3>Start Date/Time</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Start Date\" ng-model=\"vm.item.StartDate\"\n id=\"TxtStartDate\" class=\"md-icon-float md-block\">\n </mdp-date-picker>\n </div>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker flex mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.item.StartDate\" mdp-placeholder=\"Start Time\"\n id=\"TxtStartTime\" class=\"md-icon-float md-block\">\n </mdp-time-picker>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-left-20 margin-right-20\" style=\"border-left: solid thin rgb(224,224,224);height: 160px;\"></div>\n\n <div layout-gt-sm=\"column\" flex>\n <h3>End Date/Time</h3>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm></md-icon>\n <mdp-date-picker flex mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"End Date\" ng-model=\"vm.item.EndDate\"\n id=\"TxtEndDate\" class=\"md-icon-float md-block\">\n </mdp-date-picker>\n </div>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm></md-icon>\n <mdp-time-picker flex mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.item.EndDate\" mdp-placeholder=\"End Time\"\n id=\"TxtEndTime\" class=\"md-icon-float md-block\">\n </mdp-time-picker>\n </div>\n </div>\n </div>\n </md-radio-button>\n <md-radio-button ng-value=\"true\" ng-disabled=\"vm.item.LinkedToRecurring\" class=\"md-align-top-left\">This is a recurring meeting.\n <span ng-if=\"vm.showRepeatSettings\">\n Align Us will automatically keep a year\'s worth of meetings on your calendar.\n </span>\n <div ng-if=\"vm.showRepeatSettings\" class=\"pointer-events-all cursor-default\">\n\n <div class=\"margin-top-10\">\n <b>How often should this meeting be held?</b>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\"></md-icon>\n\n <div>\n This meeting should be held every &nbsp;\n </div>\n <md-select ng-model=\"vm.item.RepeatsEvery.Interval\" md-size=\"1\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]\">\n {{number}}\n </md-option>\n </md-select>\n\n <md-select ng-model=\"vm.item.RepeatsEvery.IntervalType\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-value=\"\'weekly\'\">\n week(s)\n </md-option>\n <md-option ng-value=\"\'monthly\'\">\n month(s)\n </md-option>\n </md-select>\n <div>\n .\n </div>\n </div>\n\n <div ng-if=\"vm.item.RepeatsEvery.IntervalType == \'weekly\'\" layout=\"column\" layout-align=\"start center\" class=\"margin-top-20\"\n layout-gt-sm=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\" hide show-gt-sm></md-icon>\n <div class=\"margin-right-10 nowrap\">\n Schedule the meeting on a:\n </div>\n <div layout=\"row\" layout-wrap flex>\n <md-checkbox ng-repeat=\"day in $root.daysOfWeek\" ng-model=\"vm.item.RepeatsEvery.RepeatDays[day]\" class=\"margin-0 margin-right-10\"\n style=\"min-width: 100px\">{{day}}</md-checkbox>\n </div>\n </div>\n <div ng-if=\"vm.item.RepeatsEvery.IntervalType == \'weekly\'\" layout=\"column\" layout-align=\"start center\" class=\"margin-top-20\"\n layout-gt-sm=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\" hide show-gt-sm></md-icon>\n <div class=\"margin-right-10 nowrap\">\n Schedule the meeting at time:\n </div>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.item.RepeatsEvery.TimeOfDay\" mdp-placeholder=\"Time of Day\"\n id=\"TxtEndTime\" class=\"md-icon-float md-block margin-0\" mdp-no-float=\"true\">\n </mdp-time-picker>\n </div>\n\n <div ng-if=\"vm.item.RepeatsEvery.IntervalType == \'monthly\'\" layout=\"row\" layout-align=\"start center\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\"></md-icon>\n\n <div class=\"nowrap\">Schedule the meeting on the &nbsp; </div>\n <md-select ng-model=\"vm.item.RepeatsEvery.DayOfMonth\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]\">\n {{number}}\n </md-option>\n </md-select>\n <div>\n <sup>\n {{$root.auUtility.ordinal_suffix_of(vm.item.RepeatsEvery.DayOfMonth, true)}}\n </sup>\n day of the month at:\n </div>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" ng-model=\"vm.item.RepeatsEvery.TimeOfDay\" mdp-placeholder=\"Time of Day\"\n id=\"TxtEndTime\" class=\"md-icon-float md-block margin-0\" mdp-no-float=\"true\">\n </mdp-time-picker>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0\"></md-icon>\n <div>Starting:</div>\n <mdp-date-picker mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"First Date\" ng-model=\"vm.item.RepeatsEvery.StartDate\"\n id=\"TxtStartDate\" class=\"md-icon-float md-block margin-0\" mdp-no-float=\"true\">\n </mdp-date-picker>\n </div>\n </div>\n </md-radio-button>\n </md-radio-group>\n </div>\n </div>\n <div flex=\"30\">\n <!-- master -->\n <div ng-if=\"vm.item.RepeatsEvery\">\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-20\">\n <div class=\"margin-right-10\">\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle\"></md-icon>\n </div>\n <div>Please note that changes to the master meeting take up to 30 seconds to propagate\n to all occurrences.</div>\n </div>\n </div>\n <!-- part of recurring -->\n <div ng-if=\"vm.item.LinkedToRecurring\">\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-right-10\">\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle\"></md-icon>\n </div>\n <div>\n This meeting is part of a recurring series.\n <md-button class=\"md-raised md-primary margin-0 margin-bottom-20\" ng-click=\"vm.masterMeeting.open()\">\n <md-icon md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n Open the master meeting\n </md-button>\n\n <p class=\"font-color-500 margin-bottom-20\" ng-if=\"vm.item.IsEditedRecurring\">\n <b>Because this occurrence was edited, changes to the master meeting will not\n update this occurrence.</b>\n </p>\n\n <p class=\"margin-bottom-20\">Changing details or adding documents to this meeting occurence \"unsubscribes\"\n this occurence from the master meeting so that changes to the master time,\n attendees, agenda, etc. will not update this occurrence.</p>\n <p class=\"margin-bottom-20\">The attendees and discussion board transcend all occurencences so that posts\n in this occurrence are visible in all occurencences.</p>\n </div>\n </div>\n </div>\n </div>\n\n\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Attendees Card -->\n <md-card flex>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts-alt\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAttendeesHeader\">\n <div class=\"md-title\" layout=\"row\" layout-align=\"start center\">\n <span>Meeting Attendees</span>\n </div>\n <div class=\"description\">Edit the meeting\'s attendees.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts-alt\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <md-card-content class=\"padding-0\">\n <ng-form name=\'meetingAttendees\' auto-save-form=\"vm.saveMasterMeeting()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.masterMeeting\"\n ignore-fields=\"[\'EstimatedCost\']\">\n <!--header-->\n <div layout=\"row\" layout-align=\"start center\" class=\"md-caption md-default-theme background-color-700\" style=\"color:white; text-align:center;\">\n <div flex=\"50\" class=\"margin-right-5 margin-left-20\"></div>\n <div flex=\"10\" class=\"margin-10\">Facilitator\n <md-tooltip>Can edit the meeting.</md-tooltip>\n </div>\n <div flex=\"10\" class=\"margin-10\">Required</div>\n <div flex=\"10\" class=\"margin-10\">Present</div>\n <div flex=\"10\" class=\"margin-10\" style=\"visibility:hidden;\"></div>\n </div>\n\n <!--user list-->\n <div ng-mouseenter=\"shouldShowDelete = true\" ng-mouseleave=\"shouldShowDelete = false\" ng-repeat=\"attendee in vm.masterMeeting.Attendees track by $root.protectedId(attendee)\"\n layout=\"row\" layout-align=\"start center\" style=\"margin:10px 0;\">\n <div layout=\"row\" layout-align=\"start center\" flex=\"50\" class=\"margin-right-5 margin-left-20\">\n <au-profile-image user=\"attendee.User\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-body-2\" ng-if=\"attendee.User\">{{attendee.User | fullNameFilter}}</span>\n <span class=\"md-body-2\" ng-if=\"attendee.WriteInUser\">{{attendee.WriteInUser}}</span>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"attendee.IsFacilitator\" ng-change=\"vm.alwaysRequireFacilitator(attendee)\" aria-label=\"check\" style=\"margin:0px;left:6px;\"\n ng-attr-id=\"CbxFacilitator{{$index}}\"></md-checkbox>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"attendee.IsRequired\" ng-change=\"vm.alwaysRequireFacilitator(attendee)\" aria-label=\"check\" style=\"margin:0px;left:6px;\"\n ng-attr-id=\"CbxRequired{{$index}}\"></md-checkbox>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"attendee.IsPresent\" aria-label=\"check\" style=\"margin:0px;left:6px;\" ng-attr-id=\"CbxPresent{{$index}}\"></md-checkbox>\n </div>\n <!--on hover delete-->\n <div Xng-show=\"shouldShowDelete\" style=\"text-align:center;\" flex=\"10\" class=\"margin-10\">\n <md-button ng-click=\"vm.masterMeeting.RemoveAttendee(attendee)\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove Attendee</md-tooltip>\n </md-button>\n </div>\n </div>\n <div ng-if=\"vm.masterMeeting.Attendees.length == 0\" layout=\"column\" layout-align=\"start center\" class=\"margin-top-30 md-title\">\n <div>No attendees. Add one by typing their name below.</div>\n </div>\n <md-divider></md-divider>\n\n <!--add attendee-->\n <div layout=\"row\" layout-align=\"start center\">\n <div layout=\"row\" layout-align=\"start center\" flex=\"50\" class=\"margin-right-5 margin-left-20\">\n <md-icon md-font-icon=\"zmdi zmdi-face\"></md-icon>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.attendeeSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.attendeeSearchText, showAdd: true})\"\n md-no-cache=\"true\" placeholder=\"Add Attendee\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-selected-item=\"vm.newAttendee.User\" au-on-enter=\"vm.addAttendee(vm.newAttendee)\"\n md-item-text=\"user | fullNameFilter\" md-require-match=\"false\" md-selected-item-change=\"vm.newAttendeeChanged(user)\"\n flex id=\"TxtAddAttendee\">\n <span md-highlight-text=\"vm.attendeeSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoAddAttendee{{$index}}\">{{user | auItemFilter : \'User\'}}\n </span>\n </md-autocomplete>\n </div>\n\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"vm.newAttendee.IsFacilitator\" ng-change=\"vm.alwaysRequireFacilitator(vm.newAttendee)\" aria-label=\"check\"\n style=\"margin:0px;left:6px;\" id=\"CbxAddFacilitator\"></md-checkbox>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"vm.newAttendee.IsRequired\" ng-change=\"vm.alwaysRequireFacilitator(vm.newAttendee)\" aria-label=\"check\"\n style=\"margin:0px;left:6px;\" id=\"CbxAddRequired\"></md-checkbox>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-checkbox ng-model=\"vm.newAttendee.IsPresent\" aria-label=\"check\" style=\"margin:0px;left:6px;\" id=\"CbxAddPresent\"></md-checkbox>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:center;\">\n <md-button ng-click=\"vm.addAttendee(vm.newAttendee)\" class=\"md-icon-button md-accent md-raised\" aria-label=\"Add Attendee\"\n id=\"BtnAddAttendee\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\"></md-icon>\n <md-tooltip>Add Attendee</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <div layout=\"row\" class=\"padding-20\">\n <!--invite users-->\n <div class=\"margin-top-10\" layout-align=\"start center\" flex>\n <md-button class=\"md-accent md-raised\" ng-click=\"vm.inviteUsers()\">\n <span>&nbsp;Invite Users</span>\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\"></md-icon>\n </md-button>\n </div>\n\n <!--cost-->\n <div layout=\"row\" ng-show=\"vm.item.EstimatedCost > 0\" layout-align=\"end center\" style=\"margin: 10px 20px 10px 0px;\" flex>\n <span class=\"md-caption margin-right-20\">Estimated Cost </span>\n <span class=\"md-headline\" style=\"font-family:\'Roboto Mono\';\" id=\"NumEstCost\">{{vm.item.EstimatedCost | currency : \'$\'}}</span>\n <au-help-icon key=\"Meeting.Cost\"></au-help-icon>\n </div>\n </div>\n </ng-form>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Agenda Card-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-star-circle\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAgendaHeader\">\n <div class=\"md-title\">Agenda</div>\n <div class=\"description\">Edit the meeting\'s agenda.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-star-circle\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm\">\n <au-help-icon key=\"Meeting.Agenda\"></au-help-icon>\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1; toggleFullWindow($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\" class=\"md-primary\"></md-icon>\n <md-tooltip>Show Full Screen</md-tooltip>\n </md-button>\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" on-visible=\"vm.resizeStoryDoc = vm.resizeStoryDoc + 1\">\n <md-divider></md-divider>\n <div class=\"au-cke-document\" item=\"vm.item\" item-field=\"AgendaContent\" meeting-id=\"vm.item._id\" resize-trigger=\"vm.resizeStoryDoc\"\n can-edit=\"vm.item\"></div>\n </div>\n </md-card>\n\n <!--Requirements Card-->\n <md-card flex>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-check-square\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnRequirementsHeader\">\n <div class=\"md-title\">\n Requirements\n </div>\n <div class=\"description\">List everything required to make this meeting successful.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-check-square\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <au-task-board item=\"vm.item\" exclude-unassigned=\"true\"></au-task-board>\n </div>\n </md-card>\n\n <!-- Security and Sharing -->\n <md-card ng-if=\"!$root.user.$AnonymousUser && vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-security\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDatesHeader\">\n <div class=\"md-title\">Security and Sharing</div>\n <div class=\"description\">Control who has read/write access to this task.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <au-item-security-and-sharing item=\"vm.item\"></au-item-security-and-sharing>\n <div ng-if=\"$root.user.ReportsTo && vm.item.Type != \'Reminder\' && vm.item.Type != \'Note\'\" class=\"font-color-600\">\n <md-divider></md-divider>\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n Note: As your Reports-To, {{$root.user.ReportsTo | fullNameFilter}} always has read/write access to this task.\n </div>\n <div ng-if=\"vm.item.Project || vm.item.Meeting || vm.item.Document || vm.item.ParentTask\" class=\"font-color-600\">\n <md-divider></md-divider>\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n Note: Because this task is part of a\n <span ng-if=\"vm.item.Project\">Project,</span>\n <span ng-if=\"vm.item.Meeting\">Meeting,</span>\n <span ng-if=\"vm.item.Document\">Document,</span>\n <span ng-if=\"vm.item.ParentTask\">Task List,</span>\n users with permission to view\n <span ng-if=\"vm.item.Project\">the Project</span>\n <span ng-if=\"vm.item.Meeting\">the Meeting</span>\n <span ng-if=\"vm.item.Document\">the Document</span>\n <span ng-if=\"vm.item.ParentTask\">the Task List</span>\n will always be able to view this task.\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Documents Card-->\n <md-card flex>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">\n Documents\n </div>\n <div class=\"description\">A list of all documents related to this meeting.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\" id=\"Documents\"></au-document-section>\n </div>\n </md-card>\n \n <!--Discussion Card-->\n <md-card flex>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDiscussionHeader\">\n <div class=\"md-title\">\n Discussion\n </div>\n <div class=\"description\">Post any comments, questions, or suggestions you may have about the meeting.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-discussion-board item=\"vm.masterMeeting\"></au-discussion-board>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Meeting Notes Card-->\n <md-card flex ng-if=\"!$root.user.$AnonymousUser\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnNotesHeader\">\n <div class=\"md-title\">\n Meeting Notes\n </div>\n <div class=\"description\">Post your notes from the meeting to share with other attendees.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\" new-document-subtype=\"\'Meeting Notes\'\" display-subtype=\"\'Meeting Notes\'\" button-term=\"\'Notes\'\"\n id=\"MeetingNotes\"></au-document-section>\n </div>\n </md-card>\n\n <!--Feedback Card-->\n <md-card flex ng-if=\"!$root.user.$AnonymousUser\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-edit\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnFeedbackHeader\">\n <div class=\"md-title\">\n Feedback\n </div>\n <div class=\"description\">Give your feedback on how this meeting went.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comment-edit\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n\n <md-card-content>\n <!-- meeting voting view -->\n <div ng-show=\"vm.item.DidUserGiveFeedback($root.user._id)\" id=\"StringGaveFeedback\" layout=\"column\" layout-align=\"center center\">\n <h3 style=\"text-align: center; width: 100%; color: white\" class=\"background-color-500\">You already gave feedback about this meeting. Thank you!</h3>\n </div>\n <div au-can-edit=\"!vm.item.DidUserGiveFeedback($root.user._id)\">\n <div layout=\"column\" layout-align=\"center center\">\n <div ng-repeat=\"vote in vm.feedback.Votes\" layout=\"row\" layout-align=\"center center\" class=\"margin-8\" ng-attr-id=\"StringReasons{{$index}}\"\n layout-fill>\n <span ng-click=\"vm.voteTextClicked($event, vote, 1)\" class=\"usercard-button feedback-reason\" ng-attr-id=\"StringGoodReason{{$index}}\">{{vote.GoodText}}</span>\n <tms-toggle ng-model=\"vote.Score\" val-default=\"0\" val-false=\"1\" val-null=\"0\" val-true=\"-1\" style=\"margin:0 10px; width:45px;\"></tms-toggle>\n <span ng-click=\"vm.voteTextClicked($event, vote, -1)\" class=\"usercard-button feedback-reason right\" ng-attr-id=\"StringBadReason{{$index}}\">{{vote.BadText}}</span>\n </div>\n <div ng-repeat=\"customReason in vm.customReasons\" layout=\"row\" layout-align=\"center center\" class=\"margin-8\">\n <md-input-container>\n <label></label>\n <input ng-model=\"customReason.GoodText\" id=\"{{::customReason.htmlId + \'Good\'}}\" ng-click=\"customReason.Score = 1\" />\n </md-input-container>\n <tms-toggle val-false=\"1\" val-true=\"-1\" val-null=\"0\" ng-model=\"customReason.Score\" val-default=\"0\"></tms-toggle>\n <md-input-container>\n <label></label>\n <input ng-model=\"customReason.BadText\" id=\"{{::customReason.htmlId + \'Bad\'}}\" ng-click=\"customReason.Score = -1\" />\n </md-input-container>\n </div>\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-8\">\n <md-input-container>\n <label>Other (Impressive)</label>\n <input ng-click=\"vm.addNewReason(true)\" id=\"BtnAddGoodReason\" />\n </md-input-container>\n <tms-toggle ng-model=\"desperation\" val-default=\"0\" disabled=\"true\"></tms-toggle>\n <md-input-container>\n <label>Other (Needs Improvement)</label>\n <input ng-click=\"vm.addNewReason(false)\" id=\"BtnAddBadReason\" />\n </md-input-container>\n </div>\n </div>\n\n <md-divider class=\"margin-top-20 margin-bottom-10\"></md-divider>\n <div ng-show=\"vm.item.DidUserGiveFeedback($root.user._id)\" id=\"StringGaveFeedback\" layout=\"column\" layout-align=\"center center\">\n <h3 style=\"text-align: center; width: 100%; color: white\" class=\"background-color-500\">You already gave feedback about this meeting. Thank you!</h3>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\">\n <md-checkbox ng-model=\"vm.feedback.AttachUsername\" class=\"margin-right-20\" style=\"top:8px;\" id=\"CbxAttachName\">Attach my name to my response</md-checkbox>\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.submitFeedback()\" id=\"BtnSubmitFeedback\">Submit</md-button>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n\n <!--Feedback Report -->\n <md-card flex ng-if=\"!$root.user.$AnonymousUser\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-chart\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnFeedbackHeader\">\n <div class=\"md-title\">\n Feedback Report\n </div>\n <div class=\"description\">View feedback on this meeting.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-chart\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n\n <md-card-content>\n\n <!-- results view -->\n <div layout=\"column\">\n <div layout=\"row\" layout-align=\"end center\" layout-sm=\"column\" layout-xs=\"column\">\n <div layout=\"row\" layout-align=\"end center\" class=\"rating\">\n\n <!--good rating-->\n <span style=\"font-size:30px\">{{vm.item.ReportData.ApprovalStats.approvedPercentage}}%</span>\n <div layout=\"column\" layout-align=\"center end\" style=\"width:164px;margin:0 0 0 8px;\">\n <span class=\"md-caption\" style=\"line-height:14px;\">of people thought this meeting was a success.</span>\n </div>\n <div ng-if=\"vm.item.ReportData.ApprovalStats.approvedPercentage >= 50\" class=\"rating-icon-container\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"rating-icon\" id=\"IconThumbsUp\"></md-icon>\n </div>\n <div ng-if=\"vm.item.ReportData.ApprovalStats.approvedPercentage < 50\" class=\"rating-icon-container-bad\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-down\" class=\"rating-icon\" id=\"IconThumbsDown\"></md-icon>\n </div>\n </div>\n </div>\n <!--graphs-->\n <div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" class=\"margin-bottom-20 margin-top-60\">\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"margin-10\" style=\"color:#39B54A\"></md-icon>\n <span class=\"md-title\" flex>Impressive Areas</span>\n </div>\n <canvas ng-if=\"vm.goodChartData[0].length > 0\" class=\"chart chart-bar\" chart-data=\"vm.goodChartData\" chart-labels=\"vm.goodChartLabels\"\n id=\"GoodGraph\"></canvas>\n <!--empty state impressive graph-->\n <div ng-if=\"vm.goodChartData[0].length == 0\" layout=\"column\" layout-align=\"top center\" class=\"padding-20\" style=\"color:rgba(0,0,0,0.4);\"\n id=\"GoodGraphEmptyState\">\n <img s3-src=\"/assets/images/empty-states/graph.png\">\n <span class=\"md-headline font-weight-300 ng-binding\">Oh, graph!</span>\n <span class=\"md-caption ng-binding\">There is no data to display. Make sure to give feedback for this meeting.</span>\n </div>\n </div>\n\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-down\" class=\"margin-10\" style=\"color:#ED1C24\"></md-icon>\n <span class=\"md-title\" flex>Needs Improvement</span>\n </div>\n <canvas ng-if=\"vm.badChartData[0].length > 0\" class=\"chart chart-bar\" chart-data=\"vm.badChartData\" chart-labels=\"vm.badChartLabels\"\n id=\"BadGraph\"></canvas>\n <!--empty state need improvement graph-->\n <div ng-if=\"vm.badChartData[0].length == 0\" layout=\"column\" layout-align=\"top center\" class=\"padding-20\" style=\"color:rgba(0,0,0,0.4);\"\n id=\"BadGraphEmptyState\">\n <img s3-src=\"/assets/images/empty-states/graph.png\">\n <span class=\"md-headline font-weight-300 ng-binding\">Oh, graph!</span>\n <span class=\"md-caption ng-binding\">There is no data to display. Make sure to give feedback for this meeting.</span>\n </div>\n </div>\n </div>\n\n <!--opinion list-->\n <div ng-if=\"$root.user._id == vm.item.Creator\">\n <div class=\"md-title margin-bottom-10 margin-top-30\">Attendee Opinions</div>\n <au-menu-accordion ng-repeat=\"userData in vm.item.ReportData.UserChartData | orderBy: \'$_id.LastName\'\" selected=\"selected[$index]\">\n <md-button class=\"au-menu-accordion-header \" layout=\"row\" layout-align=\"space-between center\" ng-attr-id=\"BtnOpenUserFeedback{{$index}}\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"userData._id\" size=\"30\"></au-profile-image>\n <span class=\"md-body-2\" ng-attr-id=\"StringUser{{$index}}\">\n {{(userData.$_id | fullNameFilter) || \'Anonymous Users\'}}\n </span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" style=\"position:absolute; right:50px;\">\n <div class=\"margin-right-10\">\n <span>\n <md-icon ng-if=\"userData.totalPositiveVotes >= userData.totalNegativeVotes\" md-font-icon=\"zmdi zmdi-thumb-up\" style=\"font-size: 20px;color: #39B54A;\"\n ng-attr-id=\"IconUserThumbsUp{{$index}}\"></md-icon>\n <md-icon ng-if=\"userData.totalPositiveVotes < userData.totalNegativeVotes\" md-font-icon=\"zmdi zmdi-thumb-down\" style=\"font-size:20px; color: #ED1C24;\"\n ng-attr-id=\"IconUserThumbsDown{{$index}}\"></md-icon>\n </span>\n </div>\n </div>\n </md-button>\n\n <au-collapsible-container collapsed=\"selected[$index] != 0\">\n <div layout=\"row\" layout-align=\"space-between-center\" class=\"md-caption subhead\">\n <div>Reason</div>\n <div>Vote Count</div>\n </div>\n <div layout=\"column\" ng-repeat=\"reason in userData.reasonStats\">\n <div ng-if=\"reason.$reason.GoodText\" layout=\"row\" layout-align=\"space-between-center\" class=\"md-caption goodreason\">\n <div>{{reason.$reason.GoodText}}</div>\n <!--<div>{{reason.sumPos}} votes</div>-->\n <div>\n {{reason.sumPos}}\n <ng-pluralize count=\"reason.sumPos\" when=\"{\'0\': \'votes\', \'one\': \'vote\', \'other\': \'votes\'}\"></ng-pluralize>\n </div>\n </div>\n <div ng-if=\"reason.$reason.BadText\" layout=\"row\" layout-align=\"space-between-center\" class=\"md-caption badreason\">\n <div>{{reason.$reason.BadText}}</div>\n <div>\n {{reason.sumNeg}}\n <ng-pluralize count=\"reason.sumNeg\" when=\"{\'0\': \'votes\', \'one\': \'vote\', \'other\': \'votes\'}\"></ng-pluralize>\n </div>\n </div>\n </div>\n </au-collapsible-container>\n <md-divider></md-divider>\n </au-menu-accordion>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n </div>\n</ng-form>");
$templateCache.put("/app/social/news-feed/tmpl.html","<div class=\"user-news-feed au-landing-page\" ng-class=\"$state.$current.data.sectionSettings.title.toLowerCase()\" layout=\"column\" layout-fill>\n\n <div class=\"one-search-toolbar-container\">\n <div class=\"one-search-toolbar clip\" layout=\"row\" layout-align=\"center center\">\n <div flex=\"25\"></div>\n <div class=\"search-input\" layout=\"row\" layout-align=\"center center\" flex=\"50\">\n <one-search flex=\"100\"></one-search>\n </div>\n <div flex=\"25\" layout=\"row\" layout-align=\"center center\" class=\"font-color-500\">\n <!--<span style=\"font-size: 14px; text-transform: uppercase; font-weight: 500; margin-right: 5px;\" ng-if=\"$mdMedia(\'min-width: 700px\')\">View</span>-->\n <span ng-class=\"{\'background-primary\': (!vm.showRead && !vm.showPinned)}\" style=\"border-radius: 50%\">\n <md-button class=\"md-icon-button md-primary\" style=\"min-width: 30px; margin:0; padding: 0\"\n ng-click=\"vm.toggleNewsFeed()\" ng-attr-id=\"BtnToggleNewsFeed\">\n <md-icon md-font-icon=\"zmdi zmdi-view-dashboard\" style=\"font-size: 25px; margin-top: 3px;\" ng-style=\"{color: (!vm.showRead && !vm.showPinned) ? \'white\' : null}\">\n </md-icon>\n <md-tooltip>News Feed</md-tooltip>\n </md-button>\n </span>\n\n <span ng-class=\"{\'background-primary\': (vm.showRead)}\" style=\"border-radius: 50%\">\n <md-button class=\"md-icon-button md-primary\" style=\"min-width: 30px; margin:0; padding: 0\"\n ng-click=\"vm.toggleRead()\" ng-attr-id=\"BtnToggleRead\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" style=\"font-size: 25px; margin-top: 3px;\" ng-style=\"{color: vm.showRead ? \'white\' : null}\">\n </md-icon>\n <md-tooltip>{{vm.showRead ? \'Show Unread Posts\' : \'Show Read Posts\'}}</md-tooltip>\n </md-button>\n </span>\n\n <span ng-class=\"{\'background-primary\': (vm.showPinned)}\" style=\"border-radius: 50%\">\n <md-button class=\"md-icon-button md-primary\" style=\"min-width: 30px; margin:0; padding: 0\"\n ng-click=\"vm.togglePinned()\" ng-attr-id=\"BtnTogglePinned\">\n <md-icon md-font-icon=\"au au-pin\" style=\"font-size: 25px; margin-top: 3px;\" ng-style=\"{color: vm.showPinned ? \'white\' : null}\">\n </md-icon>\n <md-tooltip>{{vm.showPinned ? \'Show All Posts\' : \'Show Pinned Posts\'}}</md-tooltip>\n </md-button>\n </span>\n </div>\n </div>\n </div>\n\n <md-content style=\"background: transparent;\" md-scroll-y flex=\"100\" id=\"UserNewsFeedPage\">\n <div class=\"big-margin-content\">\n <div class=\"landing-header\">\n <h1>{{$root.user.FirstName}}\'s News Feed <span ng-if=\"vm.showRead\">- Read Posts</span><span ng-if=\"vm.showPinned\">- Pinned Posts</span></h1>\n </div>\n <div class=\"padded-content-page\" au-post-feed=\"vm.getPosts\" feed-type=\"NewsFeed\">\n </div>\n </div>\n </md-content>\n</div>");
$templateCache.put("/app/social/page/tmpl.html","<!--Standard Social Page-->\n<div class=\"social-page faux-up\" layout=\"column\" ng-if=\"::vm.showSocialPage\">\n\n <!-- cover photo -->\n <div au-cover-photo page=\"vm.item._id\" allow-update=\"vm.showCoverPhotoButton\" class=\"page-cover-photo\" layout=\"row\" layout-align=\"start end\">\n <div class=\"social-bar\" layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" layout-align-xs=\"start center\">\n <div layout=\"row\" layout-align=\"start center\" flex layout-xs=\"column\">\n <au-profile-image item=\"vm.item\" size=\"80\" class=\"bounce\"></au-profile-image>\n <div layout=\"column\" layout-align=\"center start\">\n <div class=\"margin-bottom-100\" hide-gt-xs></div>\n <span class=\"md-title\" id=\"StringPageTitle\">{{vm.item.Title}}</span>\n </div>\n </div>\n <div flex></div>\n <div layout=\"row\" layout-align=\"end end\" style=\"top: 10px; position: relative; margin-top:-30px;\" class=\"margin-right-20 fadeup\">\n <!-- BEGIN event-specific cover photo menu -->\n <md-menu ng-if=\"::vm.item.IsEvent()\">\n <md-button ng-click=\"$mdOpenMenu($event)\" style=\"top: 12px;\" aria-label=\"calendar\" id=\"BtnRsvp\">\n <span ng-if=\'!vm.item.EventHasUserResponded()\' class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" style=\"color:#FFF;\"></md-icon> Going?\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.item.EventDidUserSelect(\'Yes\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\" style=\"color:#FFF;\"></md-icon> Attending\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.item.EventDidUserSelect(\'Maybe\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\" style=\"color:#FFF;\"></md-icon> Maybe\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.item.EventDidUserSelect(\'No\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\" style=\"color:#FFF;\"></md-icon> Not Going\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n </md-button>\n\n <md-menu-content width=\"3\">\n <md-menu-item>\n <md-button aria-label=\"Yes\" ng-click=\"vm.item.EventRespond(\'Yes\')\" id=\"BtnYes\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon> Yes\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Maybe\" ng-click=\"vm.item.EventRespond(\'Maybe\')\" id=\"BtnMaybe\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon> Maybe\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"No\" ng-click=\"vm.item.EventRespond(\'No\')\" id=\"BtnNo\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon> No\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <!-- END event-specific cover photo menu -->\n\n <!--action icons-->\n <md-button ng-if=\"::vm.item.Type != \'User\'\" ng-show=\"vm.item.IsUserOwner($root.user._id)\" ng-click=\"vm.deletePageClicked($event)\"\n aria-label=\"delete\" class=\"md-icon-button\" id=\"BtnDeletePage\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:#fff\"></md-icon>\n <md-tooltip>Delete Page</md-tooltip>\n </md-button>\n\n <au-follow-star page=\"vm.item\" style=\"color:#fff;\" class=\"spinfull\" id=\"BtnFollow\"></au-follow-star>\n\n <md-button ng-if=\"::vm.item.Type == \'User\'\" aria-label=\"high five\" class=\"md-icon-button floatup\" id=\"BtnHighFive\">\n <md-icon md-font-icon=\"au au-highfive\" style=\"color:#FFF;\" ng-click=\"vm.item.$relatedItem.HighFive(vm.item)\"></md-icon>\n <md-tooltip>Send a High-Five</md-tooltip>\n </md-button>\n\n <md-button ng-if=\"!vm.item.IsPrivate\" aria-label=\"share\" class=\"md-icon-button flip\" au-share au-share-items=\"vm.item\" id=\"BtnSharePage\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>Share Page</md-tooltip>\n </md-button>\n\n <au-from-template-button ng-if=\"vm.item.IsTemplate\" item=\"vm.item\"></au-from-template-button>\n <md-button class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\')\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n </div>\n </div>\n <!-- END cover photo -->\n\n <div layout=\"row\" layout-xs=\"column\">\n <ng-form name=\"editForm\" auto-save-form=\"vm.item.$updateItem()\" cached-resource=\"vm.item\" class=\"sidebar-widgets\" layout=\"column\">\n <au-is-template-button item=\"vm.item\" edit-item-form=\"editForm\"></au-is-template-button>\n <au-sidebar-widgets page=\"vm.item\"></au-sidebar-widgets>\n </ng-form>\n\n <div flex layout=\"column\" class=\"margin-20\">\n\n <div ng-if=\"!vm.showPageInput\">\n <div layout=\"row\" class=\"inlineNewPost mini\" ng-click=\"vm.expandPageInput()\">\n <au-profile-image user=\"$root.user\"></au-profile-image>\n\n <div class=\"chat-pointer\"></div>\n <div flex class=\"editor padding-left-10\" layout=\"row\" layout-align=\"start center\" style=\"color: rgb(128, 128, 128); cursor: text;\">\n Say Something!\n </div>\n </div>\n </div>\n <au-inline-post ng-if=\"vm.showPageInput && (!vm.item.IsPrivate || vm.item.IsUserMember($root.user._id))\" page-id=\"vm.item._id\"\n post-type=\"\'Update\'\" class=\"new-post\" grow=\"true\" start-big=\"true\"></au-inline-post>\n\n <!--we need separate divs to have 2 post feeds-->\n <div ng-if=\"vm.pinnedPosts.length > 0\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-pin\" style=\"font-size: 14px;\"></md-icon>\n <span flex class=\"md-caption\">Pinned Posts</span>\n </div>\n <div au-post-feed=\"vm.getPinnedPosts\" feed-type=\"Page\" watch-scroll=\"false\" posts-only=\"true\" feed-id=\"{{vm.item._id}}.pinnedPosts\"></div>\n </div>\n <div>\n <div ng-if=\"vm.pinnedPosts.length > 0\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 14px;\"></md-icon>\n <span flex class=\"md-caption\">Recent Posts</span>\n </div>\n <div au-post-feed page-id=\"vm.item._id\" feed-type=\"Page\" exclude-pinned=\"vm.excludePinned\"></div>\n </div>\n </div>\n </div>\n</div>\n\n<!--Discussion and Conversation type page-->\n<div class=\"discussion-page\" ng-if=\"::vm.showDiscussionPage\" ng-click=\"vm.item.MarkPostsRead()\">\n\n <!--Message Settings-->\n <div class=\"chat-settings\" layout=\"row\" layout-align=\"start center\" flex=\"85\" flex-sm=\"100\" flex-md=\"80\">\n <md-button class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\'); ItemDialogClose()\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button md-primary margin-0\" aria-label=\"settings\" ng-click=\"vm.openManagePageDialog($event)\" ng-show=\"vm.item.IsUserEditor($root.user._id) && vm.item.Title != \'##1:1##\' && vm.item.Title != \'##AlLinus##\' \">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" ng-class=\"{\'spin\': vm.item.IsUserEditor($root.user._id)}\"></md-icon>\n <md-tooltip>Manage Settings</md-tooltip>\n </md-button>\n <div class=\"md-caption margin-right-10\">\n <strong>{{vm.item.toString()}}</strong>\n </div>\n <au-profile-image ng-repeat=\"member in vm.item.$Members\" item=\'member\' size=\"30\" class=\"margin-4 grow\" ng-attr-id=\"BtnPageMember{{$index}}\"\n ng-style=\"{\'opacity\': (member.IsOnline ? 1 : .3)}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n\n <!-- The chat-settings are pulled up to the root by JS so we need this buffer so that the scrollbar doesn\'t go under the settings -->\n <div class=\"buffer margin-top-70\"></div>\n\n <div au-post-feed page-id=\"vm.item._id\" recent-on=\"bottom\" feed-type=\"Discussion\" on-scroll=\"{atEnd:vm.scrolledToEnd}\" search=\"vm.searchText\"></div>\n\n <div class=\"fix-bottom\" ng-class=\"{\'dimmed\':vm.dimSaySomething}\" ng-click=\"vm.expandMargin()\">\n <div ng-if=\"!vm.showDiscussionInput\">\n <div layout=\"row\" class=\"inlineNewPost mini\" style=\"min-width: 600px\">\n <au-profile-image user=\"$root.user\"></au-profile-image>\n\n <div class=\"chat-pointer\"></div>\n <div flex class=\"editor padding-left-10\" layout=\"row\" layout-align=\"start center\" style=\"color: rgb(128, 128, 128); cursor: text;\">\n Say Something!\n </div>\n </div>\n </div>\n <au-inline-post ng-if=\"vm.showDiscussionInput\" page-id=\"vm.item._id\" post-type=\"\'Discussion\'\" on-complete=\"vm.reduceMargin\"\n grow=\"true\" on-key-press=\"vm.sendTyping\" start-big=\"true\"></au-inline-post>\n </div>\n\n</div>");
$templateCache.put("/app/social/post/detail.tmpl.html","<div layout=\"column\" layout-fill layout-align=\"start center\">\n <div au-post post=\"vm.item\" style=\"width: 100%\"></div>\n\n <!-- Link to Page -->\n <div class=\"link-to-page\">\n <p ng-if=\"vm.item.PageType==\'Conversation\' || vm.item.PageType==\'Message\'\">\n This post is part of the conversation between {{::vm.item.$Page.ListAllMembers()}}.\n </p>\n <p ng-if=\"vm.item.PageType==\'Discussion\' || vm.item.PageIsEmbedded\">\n This post is part of the discussion between {{::vm.item.$Page.ListAllMembers()}}.\n </p>\n <p ng-if=\"vm.item.PageType!=\'Conversation\' && vm.item.PageType!=\'Message\' && vm.item.PageType!=\'Discussion\' && !vm.item.PageIsEmbedded\">\n This post is on the page {{::vm.item.$Page.Title}}.\n </p>\n </div>\n <md-button class=\"md-raised\" ng-click=\"vm.item.$Page.open(\'recent\')\">Open {{::vm.item.$Page.toString()}}</md-button>\n</div>");
$templateCache.put("/app/social/post/posts.tmpl.html","<div class=\"posts au-landing-page\" ng-class=\"$state.$current.data.sectionSettings.title.toLowerCase()\"\n layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\"></div>\n\n <md-content style=\"background: transparent;\" md-scroll-y flex=\"100\" id=\"PostsPage\">\n <div class=\"big-margin-content\">\n\n <div class=\"landing-header margin-top-0\">\n <h1>{{::vm.title}}</h1>\n <h4>{{::vm.subTitle}}</h4>\n </div>\n\n <div class=\"padded-content-page\" au-post-feed=\"vm.getPosts\"></div>\n </md-content>\n</div>");
$templateCache.put("/app/social/test/calendar.tmpl.html","<div class=\"overflow-auto calendar\">\n\n<!--FAB-->\n <md-fab-speed-dial md-direction=\"up\" class=\"md-scale\" style=\"position: fixed; bottom: 50px; right: 50px;\">\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-fab md-accent\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n </md-button>\n </md-fab-trigger>\n <md-fab-actions>\n <md-button aria-label=\"Create a Page\" class=\"md-fab md-raised md-accent md-mini\">\n <md-icon md-font-icon=\"zmdi zmdi-view-web\"></md-icon>\n </md-button>\n <md-button aria-label=\"Create Post\" class=\"md-fab md-raised md-accent md-mini\" ng-click=\"vm.openCreatePostWizard($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n </md-button>\n\n </md-fab-actions>\n </md-fab-speed-dial>\n<!--FAB end-->\n\n\n<div layout=\"row\" layout-align=\"start start\">\n\n\n\n<!--Sidebar----------------------------------------------------------------------------------------------------->\n <div layout-wrap style=\"max-width:380px\">\n \n <!--About Widget-->\n <!--<md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Calendar Page</span>\n <p class=\"md-body-1\">This houses all event-related stuff including the handy calendar. </p>\n </md-card-title-text>\n </md-card-title>\n \n <md-card-actions layout=\"row\" layout-align=\"end center\">\n <md-button><md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon> Add Widget</md-button>\n </md-card-actions>\n </md-card>\n </div>\n </md-content>-->\n\n <!--Event List Widget-->\n <md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Events</span>\n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Office Party<br></span>\n <span class=\"md-subhead\">It\'s about that time of the year when we get to eat, drink, and dance all at the once!</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Mar</span>\n <span class=\"day\">27</span>\n <span class=\"week\">Wed</span>\n </div>\n\n <div class=\"md-icon-float md-block social-event-details\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Wednesday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">9:30AM - 11:00AM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">5519 N. Cumberland</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n </div>\n </div> \n <!--Event Details End-->\n \n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Pam Poovey\'s Birthday Party<br></span>\n <span class=\"md-subhead\">Hooray! Let\'s celebrate Pam\'s birthday!</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Aug</span>\n <span class=\"day\">3</span>\n <span class=\"week\">Fri</span>\n </div> \n\n <div class=\"md-icon-float md-block social-event-details\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Friday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">11:30AM - 1:00PM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">6254 N. Washtenaw</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n </div>\n </div> \n <!--Event Details End-->\n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Annual Staff Meeting<br></span>\n <span class=\"md-subhead\">Company meeting held annually.</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Sep</span>\n <span class=\"day\">6</span>\n <span class=\"week\">Tue</span>\n </div> \n\n <div class=\"md-icon-float md-block social-event-details\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Tuesday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">11:30AM - 1:00PM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">6254 N. Washtenaw</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n </div>\n </div> \n <!--Event Details End--> \n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Halloween Party<br></span>\n <span class=\"md-subhead\">Boo!</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Oct</span>\n <span class=\"day\">30</span>\n <span class=\"week\">Thu</span>\n </div> \n\n <div class=\"md-icon-float md-block social-event-details\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Thursday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">11:30AM - 1:00PM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">6254 N. Washtenaw</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n </div>\n </div> \n <!--Event Details End-->\n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Christmas Party<br></span>\n <span class=\"md-subhead\">Winter wonderland office party.</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Dec</span>\n <span class=\"day\">20</span>\n <span class=\"week\">Fri</span>\n </div> \n\n <div class=\"md-icon-float md-block social-event-details\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Friday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">11:30AM - 1:00PM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">6254 N. Washtenaw</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n </div>\n </div> \n <!--Event Details End-->\n\n </md-card-title-text>\n </md-card-title>\n </md-card>\n </div>\n </md-content>\n\n \n \n \n </div>\n<!--Sidebar End------------------------------------------------------------------------------------------------->\n\n\n\n\n\n\n<!--Timeline --------------------------------------------------------------------------------------------------->\n<div layout-fill layout-wrap layout=\"column\" layout-align=\"start center\">\n \n<!--Calendar-->\n \n <!--Calendar View Option-->\n <!--<div class=\"margin-right-30 margin-top-20\"> \n <md-menu Xng-init=\"reply=\'Week\'\" md-position-mode=\"target-right target\">\n <md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"calendar view\">\n \n <span ng-if=\'!reply\' class=\"md-body-2\"><md-icon md-font-icon=\"zmdi zmdi-eye\" ></md-icon> Calendar View<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></span>\n <span ng-if=\"reply==\'Month\'\"class=\"md-body-2\"><md-icon md-font-icon=\"zmdi zmdi-calendar\" ></md-icon> Monthly View<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></span>\n <span ng-if=\"reply==\'Week\'\" class=\"md-body-2\"><md-icon md-font-icon=\"zmdi zmdi-view-week\" ></md-icon> Weekly View<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></span>\n <span ng-if=\"reply==\'Day\'\" class=\"md-body-2\"><md-icon md-font-icon=\"zmdi zmdi-view-day\" ></md-icon> Daily<md-icon md-font-icon=\"zmdi zmdi-caret-down\"></md-icon></span>\n\n </md-button>\n\n <md-menu-content width=\"3\">\n <md-menu-item>\n <md-button aria-label=\"Month\">\n <div layout=\"row\" flex>\n <span flex>Monthly View</span><md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Week\">\n <div layout=\"row\" flex>\n <span flex>Weekly View</span><md-icon md-font-icon=\"zmdi zmdi-view-week\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Day\">\n <div layout=\"row\" flex>\n <span flex>Daily View</span><md-icon md-font-icon=\"zmdi zmdi-view-day\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div> -->\n <!--Calendar View Option End-->\n \n \n <div ui-calendar=\"uiConfig.calendar\" class=\"calendar padding-60\" ng-model=\"eventSources\" style=\"max-width:1400px\">\n </div>\n \n<!--Calendar End-->\n\n</div>\n<!--Timeline End------------------------------------------------------------------------------------------------>\n\n\n\n\n</div>\n</div>");
$templateCache.put("/app/social/test/conversation.tmpl.html","<div class=\"conversation-item-detail\" style=\"overflow-y: scroll !important;\">\n <div class=\"md-padding\" layout=\"column\">\n\n <!--tab peek-->\n <div class=\"detail-button slide background-accent-500\" ng-click=\"vm.$mdSidenav(\'right\').toggle()\" aria-label=\"Message Settings\">\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\" class=\"margin-right-6 action-button scale\" style=\"color:white;\"></md-icon> \n <span class=\"md-body-1\"><strong>Message Settings</strong></span> \n </div>\n\n <!--sidenav-->\n <md-sidenav class=\"md-sidenav-right md-whiteframe-4dp background-accent-500\" md-component-id=\"right\">\n <div class=\"background-accent-900\" style=\"height:3px;\"></div>\n <md-content layout-padding class=\"background-accent-500\">\n \n <div layout=\"column\" style=\"padding: 0 15px;\" >\n <div layout=\"row\" layout-align=\"end center\">\n\n <!--view option--> \n <md-menu layout=\"row\" layout-align=\"end center\" md-position-mode=\"target-right target\" style=\"padding:0\">\n <md-button class=\"md-icon-button action-button scale\" aria-label=\"View Option\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" md-menu-align-target style=\"color:#FFFFFF;\"></md-icon>\n </md-button>\n <md-menu-content width=\"3\">\n <md-menu-item>\n <md-button>\n <span flex>Messages</span>\n <md-icon md-font-icon=\"zmdi zmdi-comments\"></md-icon> \n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <span flex>Done</span>\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\"></md-icon> \n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <span flex>Pinned</span>\n <md-icon md-font-icon=\"au au-pin\"></md-icon> \n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu> \n\n <md-button class=\"md-icon-button action-button scale\" aria-label=\"Edit\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" style=\"color:#FFFFFF;\"></md-icon>\n </md-button>\n <md-button ng-click=\"vm.$mdSidenav(\'right\').close()\" class=\"md-icon-button action-button rotate\" aria-label=\"Close\" style=\"margin-right: -10px;\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"color:#FFFFFF;\"></md-icon> \n </md-button>\n </div>\n \n <!--details-->\n <span class=\"md-body-2 margin-bottom-20\"><strong>Keys to Success</strong></span> \n <span class=\"timestamp margin-bottom-10\" style=\"color: rgba(255, 255, 255, 0.6);\">Description</span>\n <span class=\"md-body-1 sidenav-divider\">This is the description for this conversation. Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life.</span>\n \n <!--created by-->\n <span class=\"timestamp margin-bottom-10\" style=\"color: rgba(255, 255, 255, 0.6);\">Created by</span>\n <div layout=\"row\" layout-align=\"start center\" class=\"sidenav-divider\">\n <au-profile-image user=\"User\" size=\"40\"></au-profile-image>\n <div layout=\"column\">\n <span class=\"md-caption\"><strong>Dee Reynolds</strong></span>\n <span class=\"md-caption\">January 23, 2015</span>\n </div>\n </div>\n\n <!--members-->\n <div class=\"margin-bottom-20\">\n <span class=\"timestamp margin-bottom-10\" style=\"color: rgba(255, 255, 255, 0.6);\">Members</span>\n <div layout=\"row\" layout-wrap>\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-5\"></au-profile-image>\n <au-profile-image size=\"40\" class=\"margin-5\"></au-profile-image>\n \n <!--edit members button-->\n <md-button class=\"md-primary md-fab md-mini margin-5\" aria-label=\"Edit Members\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\"></md-icon>\n <md-tooltip>Edit Members</md-tooltip>\n </md-button>\n </div>\n </div>\n\n </div>\n </md-content> \n </md-sidenav>\n\n <!--Detail-->\n <!--<md-card>\n <au-menu-accordion selected=\"vm.selected\">\n <div class=\"background-color-500\">\n <md-button class=\"au-menu-accordion-header\" id=\"1\">\n <span class=\"md-body-2\">Keys to Success Conversation</span>\n </md-button>\n </div>\n \n <au-collapsible-container collapsed=\"vm.selected != 0\">\n <div layout=\"column\" style=\"padding:20px 30px;\">\n <div layout=\"row\" layout-xs=\"column\">\n <div layout=\"column\" flex=\"70\" flex-xs=\"100\" class=\"margin-right-20\">\n <span class=\"timestamp margin-bottom-10\">Description</span>\n <span class=\"md-body-1 margin-bottom-20\">You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life.</span>\n <span class=\"timestamp margin-bottom-10\">Created by</span>\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-bottom-20\">\n <au-profile-image user=\"User\" size=\"40\"></au-profile-image>\n <div layout=\"column\">\n <span class=\"md-caption\"><strong>Dee Reynolds</strong></span>\n <span class=\"md-caption\">January 23, 2015</span>\n </div>\n </div>\n </div>\n\n <div layout=\"column\" flex=\"30\" flex-xs=\"100\" >\n <span class=\"timestamp margin-bottom-10\">Members</span>\n <div layout=\"row\" layout-wrap>\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-5\"></au-profile-image>\n <au-profile-image size=\"40\" class=\"margin-5\"></au-profile-image>\n </div>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"end center\"> \n \n <md-button class=\"md-raised\">\n &nbsp; Edit\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n </md-button>\n </div>\n\n </div>\n <div style=\"height:2px;\" class=\"background-color-500\">\n </div>\n </au-collapsible-container>\n </au-menu-accordion>\n </md-card>-->\n \n <!--Received Message Email Style 1-->\n <!--<md-card layout=\"column\" class=\"padding-30\">\n <div layout=\"row\" layout-align=\"space-between center\" flex layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"row\" layout-align=\"start center\" flex>\n <au-profile-image user=\"User\" size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-caption\"><strong>Dee Reynolds</strong></span>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">38 sec ago</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\" flex>\n <md-fab-speed-dial md-direction=\"left\" class=\"md-scale\">\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-icon-button md-primary\">\n <md-icon md-font-icon=\"zmdi zmdi-more\">\n </md-button>\n </md-fab-trigger>\n\n <md-fab-actions>\n <md-button aria-label=\"Done\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"top\">Mark as Done</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"top\">Pin Message</md-tooltip>\n <md-icon md-font-icon=\"au au-pin\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"top\">Share</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-fab-speed-dial>\n </div>\n </div>\n\n <div class=\"md-body-1 margin-top-10\" flex>\n Learning is cool, but knowing is better, and I know the key to success. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice. I pick my choice, squeaky clean. You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. Special cloth alert, cut from a special cloth. Eliptical talk.\n </div>\n </md-card> -->\n\n <!--Received Message-->\n <!--<md-card layout=\"column\" class=\"padding-30\" style=\"background-color:#f5f5f5;\" ng-mouseenter=\"showMessageOptions = true\" ng-mouseleave=\"showMessageOptions = false\">\n <div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"row\" layout-align=\"start center\" >\n <au-profile-image size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-caption\"><strong>Align Us, Inc.</strong></span>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">15 days ago</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\" ng-show=\"showMessageOptions\">\n <md-button aria-label=\"Done\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Mark as Done</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Pin Message</md-tooltip>\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Share</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <div class=\"md-body-1 margin-top-10\">\n Learning is cool, but knowing is better, and I know the key to success. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice. I pick my choice, squeaky clean. You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. Special cloth alert, cut from a special cloth. Eliptical talk.\n </div>\n </md-card> -->\n\n <!--Sent Message-->\n <!--<md-card layout=\"column\" class=\"padding-30\">\n <div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"row\" layout-align=\"start center\" >\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-caption\"><strong>Dee Reynolds</strong></span>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">15 days ago</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\" >\n <md-button aria-label=\"Done\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Mark as Done</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Pin Message</md-tooltip>\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Share</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <div class=\"md-body-1 margin-top-10\">\n Bless up. It’s on you how you want to live your life. \n </div>\n </md-card> -->\n\n <!--Received Message-->\n <!--<md-card layout=\"column\" class=\"padding-30\" style=\"background-color:#f5f5f5;\">\n <div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"row\" layout-align=\"start center\" >\n <au-profile-image size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-caption\"><strong>Align Us, Inc.</strong></span>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">38 sec ago</span>\n </div>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\">\n <md-button aria-label=\"Done\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\"> Mark as Done</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Pin Message</md-tooltip>\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary action-button scale\">\n <md-tooltip md-direction=\"top\">Share</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <div class=\"md-body-1 margin-top-10\">\n I pick my choice, squeaky clean. You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. Special cloth alert, cut from a special cloth. Eliptical talk.\n </div>\n </md-card> -->\n\n <!--Received Message-->\n <!--<div layout=\"row\" layout-align=\"start end\" class=\"margin-bottom-20\">\n <div class=\"margin-left-10\" >\n <au-profile-image size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image> \n </div>\n \n <md-card layout=\"column\" style=\"background-color:#f5f5f5; border-radius: 50px 0 50px 0; margin: 0px 60px 0 0 !important; padding:20px 30px 30px 30px;\"\n ng-mouseenter=\"showMessageOptions1 = true\" ng-mouseleave=\"showMessageOptions1 = false\">\n \n <div layout=\"row\" layout-align=\"center center\" ng-hide=\"showMessageOptions1\">\n <md-button aria-label=\"More\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" aria-label=\"More\"></md-icon>\n </md-button>\n </div> \n \n <div layout=\"row\" layout-align=\"center center\" ng-show=\"showMessageOptions1\"> \n <md-button aria-label=\"Done\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button> \n </div>\n\n <div class=\"md-body-1 margin-top-10 margin-bottom-5\" style=\"text-align: justify;\">\n You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice. \n </div>\n\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">15 days ago</span>\n\n </md-card> \n </div>-->\n\n <!--date stamp-->\n <div layout=\"row\" layout-align=\"center center\">\n <div class=\"timeline\" flex=\"30\"></div>\n <div class=\"timestamp margin-10\"><md-icon md-font-icon=\"zmdi zmdi-time\" class=\"timestamp\"></md-icon>October 22, 2016</div>\n <div class=\"timeline\" flex=\"30\"></div>\n </div>\n\n <!--Sent Message-->\n <div layout=\"row\" layout-align=\"end end\" class=\"margin-bottom-20\">\n \n <md-card layout=\"column\" style=\"background-color:#FFFFFF; border-radius: 0 50px 0 50px; margin: 0 0 0 60px !important; padding:20px 30px 30px 30px;\" \n ng-mouseenter=\"showMessageOptions2 = true\" ng-mouseleave=\"showMessageOptions2 = false\">\n \n <div layout=\"row\" layout-align=\"center center\" ng-hide=\"showMessageOptions2\">\n <md-button aria-label=\"More\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" aria-label=\"More\"></md-icon>\n </md-button>\n </div> \n \n <div layout=\"row\" layout-align=\"center center\" ng-show=\"showMessageOptions2\"> \n <md-button aria-label=\"Done\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button> \n </div> \n \n\n <div class=\"md-body-1 margin-top-10 margin-bottom-5\" style=\"text-align-last: right; text-align: justify;\">\n I’m giving you cloth talk, cloth. Special cloth alert, cut from a special cloth. Eliptical talk.\n </div>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\" style=\"text-align: right;\">2 min ago</span>\n\n </md-card> \n \n <div>\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-left-10\" >\n </au-profile-image> \n </div>\n </div>\n\n <!--Received Message-->\n <div layout=\"row\" layout-align=\"start end\" class=\"margin-bottom-20\">\n <div class=\"margin-left-10\" >\n <au-profile-image size=\"40\" class=\"margin-right-10\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image> \n </div>\n \n <md-card layout=\"column\" style=\"background-color:#f5f5f5; border-radius: 50px 0 50px 0; margin: 0px 60px 0 0 !important; padding:20px 30px 30px 30px;\">\n <div layout=\"column\" layout=\"start center\" class=\"expand\">\n <!--<div layout=\"row\" layout-align=\"center center\" >\n <md-button aria-label=\"More\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" aria-label=\"More\"></md-icon>\n </md-button>\n </div> -->\n \n <div layout=\"row\" layout-align=\"center center\"> \n <md-button aria-label=\"Done\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button> \n </div>\n </div>\n\n <div class=\"md-body-1 margin-top-10 margin-bottom-5\" style=\"text-align: justify;\">\n You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice. \n </div>\n\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">15 days ago</span>\n\n </md-card> \n </div>\n\n <!--Received Message Speech Bubble-->\n <!--<div layout=\"row\" layout-align=\"start start\" flex>\n \n <au-profile-image size=\"40\" class=\"margin-top-10 margin-left-20\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div class=\"message-received\">\n <div class=\"tri-left left-top\" layout=\"column\">\n <span class=\"md-body-1 margin-bottom-10\" flex>\n Learning is cool, but knowing is better, and I know the key to success. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing.\n </span>\n <div layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"column\">\n <span class=\"md-caption\"><strong>Align Us, Inc.</strong></span>\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">38 sec ago</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex>\n <md-button aria-label=\"Done\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"bottom\">Mark as Done</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"bottom\">Pin Message</md-tooltip>\n <md-icon md-font-icon=\"au au-pin\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary\">\n <md-tooltip md-direction=\"bottom\">Share</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </div>\n </div>\n </div>\n </div>\n </div>-->\n\n <!--Sent Message Speech Bubble-->\n <!--<div layout=\"row\" layout-align=\"end start\">\n \n <div class=\"message-sent\">\n <div class=\"tri-right right-top\" layout=\"column\">\n <span class=\"md-body-1\">\n Special cloth alert, cut from a special cloth. Eliptical talk.\n </span>\n <div layout=\"row\" layout-align=\"space-between center\">\n <div layout=\"row\" flex> \n <md-button aria-label=\"Delete\" class=\"md-icon-button md-primary\">\n <md-icon md-font-icon=\"au au-pin\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Share\" class=\"md-icon-button md-primary\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" aria-label=\"Share\"></md-icon>\n </md-button>\n </div>\n <div layout=\"column\">\n <span class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\">38 sec ago</span>\n </div>\n </div>\n </div>\n </div>\n <au-profile-image user=\"User\" size=\"40\" class=\"margin-top-10 margin-right-20\"></au-profile-image>\n </div>--> \n\n <!--Respond accordion attach-->\n <!--<div class=\"margin-top-20\">\n <au-menu-accordion selected=\"vm.attach\"> \n <div layout=\"column\" class=\"padding-30\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-right-10\" hide-xs ></au-profile-image>\n <md-input-container class=\"md-block\" flex>\n <label>Message</label>\n <textarea rows=\"5\" md-select-on-focus></textarea>\n </md-input-container> \n <md-button aria-label=\"Attach\" class=\"md-icon-button au-menu-accordion-header\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment\" style=\"color:gray;\" aria-label=\"Attach\"></md-icon>\n </md-button> \n <md-button aria-label=\"Send\" class=\"md-raised md-primary md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" aria-label=\"Send\"></md-icon>\n </md-button>\n </div>\n\n <au-collapsible-container collapsed=\"vm.attach != 0\" class=\"margin-bottom-20\">\n <div layout=\"column\" layout-align-xs=\"center center\">\n <au-document-section></au-document-section>\n </div>\n </au-collapsible-container>\n \n </div>\n </au-menu-accordion>\n </div>-->\n\n\n <!--Response-->\n <div class=\"margin-top-20\">\n <div layout=\"column\" style=\"padding: 30px 0 0 10px;\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <au-profile-image user=\"user\" size=\"40\" class=\"margin-right-10\" hide-xs ></au-profile-image>\n <md-input-container class=\"md-block\" flex>\n <label>Message</label>\n <textarea rows=\"3\" md-select-on-focus></textarea>\n </md-input-container> \n <md-button aria-label=\"Attach\" class=\"md-icon-button au-menu-accordion-header action-button rotate\" style=\"margin: 0px;\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment\" style=\"color:gray;\" aria-label=\"Attach\"></md-icon>\n </md-button> \n <md-button aria-label=\"Send\" class=\"md-fab md-mini md-primary action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" aria-label=\"Send\"></md-icon>\n </md-button>\n </div>\n </div> \n </div>\n\n <div class=\"margin-40\">\n </div>\n\n<!--long message-->\n \n <md-card>\n <md-card-content style=\"background-color:#f1f1f1;\">\n <div layout=\"row\" layout-align=\"space-between center\" style=\"padding:0;\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image size=\"40\"></au-profile-image>\n <div layout=\"column\" flex id=\"BtnPersonalInfoHeader\">\n <div class=\"md-title\">This is the subject line.</div>\n <div class=\"description\">Align Us, Inc.</div>\n </div>\n </div>\n <div>\n <md-button aria-label=\"Done\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" aria-label=\"Done\"></md-icon>\n </md-button>\n <md-button aria-label=\"Delete\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"au au-pin-outline\" aria-label=\"Pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"Reply\" class=\"md-icon-button action-button scale\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-reply\"></md-icon>\n </md-button>\n </div>\n </div>\n </md-card-content>\n <div>\n <md-card-content layout=\"column\" class=\"padding-30\">\n <div class=\"md-body-1\">\n You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice.\n\n </div>\n \n \n <div>\n <md-input-container class=\"md-block\">\n <label>Message</label>\n <textarea rows=\"5\" md-select-on-focus></textarea>\n </md-input-container>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n\n\n\n\n <md-card class=\"au-post material-card material-shadow\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\" ng-init=\"toolbarIsOpen = false\">\n\n <md-card-header class=\"social-blue-bg\" layout=\"row\">\n <div>\n <au-profile-image size=\"40\" style=\"width:40px;\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n <md-card-header-text class=\"margin-0\">\n <span class=\"md-body-2 limit-text\">Align Us, Inc.</span>\n <span class=\"md-caption limit-text-subhead\"><md-icon md-font-icon=\"zmdi zmdi-caret-right\" style=\"margin-left:-8px;\"></md-icon>{{::vm.post.$Page.Title}}</span>\n <!--<span class=\"md-caption\" am-time-ago=\"::vm.post.DateCreated\"></span>-->\n </md-card-header-text>\n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\" ng-if=\"!$removing\" style=\"max-height: 40px\">\n\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\"></md-icon>\n </md-button>\n </md-fab-trigger>\n \n <md-toolbar> \n <md-fab-actions class=\"md-toolbar-tools\" style=\"max-height: 40px; right: -26px; position: relative;\">\n <md-button aria-label=\"check\" class=\"md-icon-button\" ng-click=\"vm.toggleRead($event)\" id=\"BtnReadPost\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n <md-button aria-label=\"pin\" class=\"md-icon-button\" ng-click=\"vm.post.TogglePinned()\" id=\"BtnPinPost\">\n <md-icon ng-if=\"vm.post.IsPinned\" md-font-icon=\"au au-pin\"></md-icon>\n <md-icon ng-if=\"!vm.post.IsPinned\" md-font-icon=\"au au-pin-outline\"></md-icon> \n </md-button> \n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n </md-card-header>\n \n <md-card-content ng-if=\"!$removing\" style=\"padding:16px;\">\n \n <!--timestamp-->\n <div layout=\"row\" layout-align=\"end center\" style=\"float: right;\">\n <span class=\"social-count-text\" am-time-ago=\"::vm.post.DateCreated\">36 days ago</span>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-count-icon\" style=\"font-size: 1em;\"></md-icon> \n </div>\n\n <!--Content-->\n <div class=\"margin-top-30 margin-bottom-30 md-body-1\">\n You smart, you loyal, you a genius. I’m giving you cloth talk, cloth. I told you all this before, when you have a swimming pool, do not use chlorine, use salt water, the healing, salt water is the healing. You see that bamboo behind me though, you see that bamboo? Ain’t nothin’ like bamboo. Bless up. It’s on you how you want to live your life. Everyone has a choice.\n </div>\n <!--End content-->\n <div>\n <!--Social Count-->\n <div class=\"social-count\" layout=\"row\" layout-align=\"end start\" layout-align-xs=\"center start\">\n <div flex class=\"margin-top-10\" hide-xs>\n <span class=\"social-count-text\">\n <span ng-show=\"vm.post.Likes.length > 0\" id=\"StringLikeUsers\">\n {{vm.getWhoLikesString()}}\n </span>\n <au-popover class=\"scrollable-content\">\n <md-menu-content style=\"max-height:250px; overflow-y:auto;\" width=\"4\">\n <md-menu-item ng-repeat=\"like in vm.post.Likes\">\n <md-button Xng-click=\"vm.goToPage(like.User)\">\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\">\n <au-profile-image user=\"like.User\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-body-2\">{{like.User | fullNameFilter}}</span>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </au-popover>\n </span>\n </div>\n\n <!--likes-->\n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\" ng-class=\"{\'post-liked\': vm.post.doesCurrentUserLikePost()}\" ng-click=\"vm.toggleLike()\" id=\"BtnLikePost\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\" id=\"NumLikeCount\">17 Likes</span>\n </md-button>\n </div>\n\n <!--tagged -->\n <div>\n <md-menu>\n <md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"tags\" class=\"margin-0 padding-0\" id=\"BtnTaggedCount\">\n <md-icon md-font-icon=\"zmdi zmdi-tag\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">&nbsp; {{vm.post.Tagged.length}} Tagged</span>\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item ng-repeat=\"user in vm.post.Tagged\" ng-attr-id=\"BtnTaggedUser{{$index}}\">\n <md-button Xng-click=\"vm.goToPage(user)\">\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\">\n <au-profile-image user=\"user\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-body-2\">{{user | fullNameFilter}}</span>\n </div> \n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n \n <!--comments-->\n\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\" id=\"BtnCommentPost\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\" id=\"NumCommentCount\">&nbsp; {{vm.post.Comments.length}} Comments</span>\n </md-button>\n </div>\n </div>\n <!--End Social Count-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <ng-form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20 margin-bottom-10\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\" ng-model=\"vm.newComment.Comment\" ng-keydown=\"vm.addCommentClicked($event)\" id=\"TxtComment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button ng-click=\"vm.addCommentClicked($event)\" class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\" id=\"BtnSubmitComment\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" style=\"color: #00aeef;\" aria-hidden=\"true\"></md-icon>\n </button>\n </ng-form>\n <!--Comment Expanded-->\n \n <div class=\"padding-10\" style=\"max-height:350px; overflow-y:auto;\">\n <div class=\"margin-bottom-30\" class=\"md-3-line md-long-text\" ng-repeat=\"comment in vm.post.Comments track by comment._id\" ng-mouseenter=\"comment.$hovered=true;\" ng-mouseleave=\"comment.$hovered = false\">\n \n <div layout=\"row\" layout-align=\"space-between start\">\n <div layout=\"row\" class=\"social-avatar-comment\" flex> \n <au-profile-image user=\"::comment.User\" size=\"40\" Xng-show=\"!(comment.$hovered && $root.user._id == comment.User)\" style=\"margin-right:-4px;\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <div layout=\"column\" layout-align=\"center start\" ng-attr-id=\"StringCommentList{{$index}}\" class=\"margin-left-15\">\n <span class=\"md-body-2\">{{comment.User | fullNameFilter}}</span>\n <span class=\"md-caption\">{{comment.Comment}}</span>\n <span class=\"social-comment-time\" am-time-ago=\"::comment.DateCreated\"></span>\n </div>\n </div>\n\n <!--delete comment-->\n <md-button aria-label=\"delete-comment\" ng-show=\"comment.$hovered && $root.user._id == comment.User\" ng-click=\"vm.post.removeComment(comment._id)\" class=\"md-icon-button\" ng-attr-id=\"BtnDeleteComment{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:gray\"></md-icon>\n </md-button> \n </div>\n </div>\n </div>\n \n </div>\n <!--Comment Expanded End-->\n </md-card-content>\n <md-card-content ng-if=\"$removing\">\n Removing Post... Please wait...\n </md-card-content>\n</md-card>\n \n\n\n\n\n\n\n </div>\n</div>");
$templateCache.put("/app/social/test/socialpage.tmpl.html","<div class=\"overflow-auto social-page\">\n\n<!--Cover Photo--> \n <div class=\"social-page-cover\" style=\"background-image: url(http://phandroid.s3.amazonaws.com/wp-content/uploads/2014/06/forest-patrol.jpg);\" >\n </div>\n<!--Cover Photo end-->\n\n\n<!--Avatar-->\n <div class=\"social-bar\" layout=\"row\" layout-align=\"space-between center\">\n \n <div layout=\"row\" layout-align=\"start center\" class=\"social-page-avatar\" flex>\n <au-profile-image user=\"$root.user\" size=\"80\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-title\">Sterling Archer</span>\n <span class=\"md-caption\">CIA Agent</span>\n </div>\n </div> \n \n \n <div layout=\"row\" layout-align=\"end end\" style=\"top: 10px; position: relative;\" class=\"margin-right-20\">\n \n <md-menu Xng-init=\"reply=\'Yes\'\" md-position-mode=\"target-right target\">\n <md-button ng-click=\"$mdOpenMenu($event)\" style=\"top: 14px;\" aria-label=\"calendar\">\n \n <span ng-if=\'!reply\' class=\"md-body-2\" style=\"color:#FFF;\"><md-icon md-font-icon=\"zmdi zmdi-calendar\" style=\"color:#FFF;\"></md-icon> Going?<md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon></span>\n <span ng-if=\"reply==\'Yes\'\" class=\"md-body-2\" style=\"color:#FFF;\"><md-icon md-font-icon=\"zmdi zmdi-calendar-check\" style=\"color:#FFF;\"></md-icon> Attending<md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon></span>\n <span ng-if=\"reply==\'Maybe\'\" class=\"md-body-2\" style=\"color:#FFF;\"><md-icon md-font-icon=\"zmdi zmdi-calendar-note\" style=\"color:#FFF;\"></md-icon> Maybe<md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon></span>\n <span ng-if=\"reply==\'No\'\" class=\"md-body-2\" style=\"color:#FFF;\"><md-icon md-font-icon=\"zmdi zmdi-calendar-close\" style=\"color:#FFF;\"></md-icon> Not Going<md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon></span>\n \n </md-button>\n\n <md-menu-content width=\"3\">\n <md-menu-item>\n <md-button aria-label=\"Yes\">\n <div layout=\"row\" flex>\n <span flex>Yes</span><md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Maybe\">\n <div layout=\"row\" flex>\n <span flex>Maybe</span><md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"No\">\n <div layout=\"row\" flex>\n <span flex>No</span><md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n \n <!--<md-menu-item>\n <md-button aria-label=\"Yes\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon> Yes\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Maybe\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon> Maybe\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"No\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon> No\n </md-button>\n </md-menu-item>\n -->\n </md-menu-content>\n </md-menu>\n \n \n \n \n \n \n \n \n <md-button aria-label=\"high five\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-highfive\" style=\"color:#FFF;\"></md-icon>\n </md-button>\n \n <md-button aria-label=\"share\" class=\"md-icon-button\"> \n <md-icon md-font-icon=\"zmdi zmdi-share\" style=\"color:#FFF;\"></md-icon>\n </md-button>\n \n <md-button aria-label=\"follow\" class=\"md-icon-button\"> \n <md-icon md-font-icon=\"zmdi zmdi-star\" style=\"color:#FFF;\"></md-icon>\n </md-button>\n\n <md-button aria-label=\"message\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" style=\"color:#FFF;\"></md-icon>\n </md-button>\n </div> \n \n \n \n </div>\n<!--Avatar End-->\n\n\n\n<!--FAB-->\n <md-fab-speed-dial md-direction=\"up\" class=\"md-scale\" style=\"position: fixed; bottom: 50px; right: 50px;\">\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-fab md-accent\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n </md-button>\n </md-fab-trigger>\n <md-fab-actions>\n <md-button aria-label=\"Create a Page\" class=\"md-fab md-raised md-accent md-mini\">\n <md-icon md-font-icon=\"zmdi zmdi-view-web\"></md-icon>\n </md-button>\n <md-button aria-label=\"Create Post\" class=\"md-fab md-raised md-accent md-mini\" ng-click=\"vm.openCreatePostWizard($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n </md-button>\n\n </md-fab-actions>\n </md-fab-speed-dial>\n<!--FAB end-->\n\n\n\n\n<div layout=\"row\" layout-align=\"start start\">\n\n\n\n<!--Sidebar----------------------------------------------------------------------------------------------------->\n <div layout-fill layout-wrap style=\"max-width:380px\">\n\n <!--About Event Widget-->\n <md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">About (Event Page)</span>\n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Office Party<br></span>\n <span class=\"md-subhead\">It\'s about that time of the year when we get to eat, drink, and dance all at the once!</span>\n </div>\n </div>\n \n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Mar</span>\n <span class=\"day\">27</span>\n <span class=\"week\">Wed</span>\n </div>\n\n \n\n <div class=\"md-icon-float md-block social-event-details\">\n\n\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Wednesday<br></span>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">9:30AM - 11:00AM<br></span>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">5519 N. Cumberland<br></span>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656<br></span>\n\n \n \n \n <md-menu Xng-init=\"reply=\'Yes\'\">\n <md-button ng-click=\"$mdOpenMenu($event)\" style=\"border-radius: 0;padding: 0;margin: -4px 0 0 0px;line-height: 0;text-transform: none;\" aria-label=\"calendar\">\n \n <span class=\"md-body-1\" ng-if=\'!reply\'><md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"social-event-icons-white\"></md-icon> Are You Going?<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color:#FFF;\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'Yes\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-check\" class=\"social-event-icons-white\"></md-icon>Attending<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color:#FFF;\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'Maybe\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-note\" class=\"social-event-icons-white\"></md-icon>Maybe<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color:#FFF;\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'No\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-close\" class=\"social-event-icons-white\"></md-icon>Not Going<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color:#FFF;\"></md-icon></span>\n \n </md-button>\n\n <md-menu-content width=\"4\">\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon> Yes\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon> Maybe\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon> No\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n \n </div> \n \n \n \n </div> \n \n <span class=\"md-body-2 margin-top-20 margin-bottom-10\">Attending</span>\n \n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n \n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n \n \n </div> \n <!--Event Details End-->\n\n\n\n </md-card-title-text>\n </md-card-title>\n \n <md-card-actions layout=\"row\" layout-align=\"end center\">\n <md-button><md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon> Add Widget</md-button>\n </md-card-actions>\n </md-card>\n </div>\n \n </md-content>\n \n <!--About Widget-->\n <md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">About (Generic Page)</span>\n <p class=\"md-body-1\">Sterling Archer is the world\'s deadliest spy. Upon growing up, Archer attempted to join the army, but failed. Instead,\n he began work as a spy at his mother\'s agency, ISIS, quickly climbing the ranks as their top spy thanks to both his\n genuine skill and his mother\'s preferential treatment. </p>\n <span class=\"md-body-2\">Contact</span>\n \n \n <div class=\"md-icon-float md-block\">\n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-phone\" class=\"social-event-icons-white\"></md-icon> (312) 588-2300<br></span>\n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-email\" class=\"social-event-icons-white\"></md-icon> info@email.com <br></span>\n </div>\n \n \n \n <span class=\"md-body-2 margin-top-20 margin-bottom-10\">Followers</span>\n \n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n \n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n \n </div> \n \n \n \n </md-card-title-text>\n </md-card-title>\n <md-card-actions layout=\"row\" layout-align=\"end center\">\n <md-button><md-icon md-font-icon=\"zmdi zmdi-star\" style=\"color:#fff\"></md-icon> Follow</md-button>\n <md-button><md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon> Add Widget</md-button>\n </md-card-actions>\n </md-card>\n </div>\n </md-content>\n\n <!--Events Widget-->\n <md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Events</span>\n\n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Office Party<br></span>\n <span class=\"md-subhead\">It\'s about that time of the year when we get to eat, drink, and dance all at the once!</span>\n </div>\n </div>\n \n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Mar</span>\n <span class=\"day\">27</span>\n <span class=\"week\">Wed</span>\n </div>\n\n \n\n <div class=\"md-icon-float md-block social-event-details\">\n\n\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Wednesday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">9:30AM - 11:00AM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">5519 N. Cumberland</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n\n </div>\n </div> \n <!--Event Details End-->\n \n <!--Event Details-->\n <div layout=\"column\" layout-align=\"start start\" class=\"social-event-container\">\n\n <div class=\"margin-bottom-10\">\n <span class=\"md-headline\">Pam Poovey\'s Birthday Party<br></span>\n <span class=\"md-subhead\">Hooray! Let\'s celebrate Pam\'s birthday!</span>\n </div>\n </div>\n \n \n <div layout=\"row\" layout-align=\"start start\">\n\n <div class=\"social-event-date\">\n <span class=\"month\">Aug</span>\n <span class=\"day\">3</span>\n <span class=\"week\">Fri</span>\n </div>\n\n \n\n <div class=\"md-icon-float md-block social-event-details\">\n\n\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">Friday</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">11:30AM - 1:00PM</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">6254 N. Washtenaw</span><br>\n <md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons-white\" style=\"visibility: hidden;\"></md-icon>\n <span class=\"md-body-1\">Chicago, IL 60656</span>\n\n </div>\n </div> \n <!--Event Details End-->\n\n\n\n </md-card-title-text>\n </md-card-title>\n <md-card-actions layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" style=\"color:#ffffff\"></md-icon> View More</md-button>\n </md-card-actions>\n </md-card>\n </div>\n </md-content>\n\n <!--Pinned Posts Widget-->\n <md-content layout-fill>\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Pinned Posts</span>\n <p class=\"md-body-1\">A widget that allows an editor to pin a post to the left.</p>\n \n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n \n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n <au-profile-image item=\'$root.user\' user=\"vm.detail\" size=\"40\" class=\"margin-6\"></au-profile-image>\n \n </div> \n \n </md-card-title-text>\n </md-card-title>\n </md-card>\n </div>\n </md-content>\n\n <!--Polls Widget-->\n <md-content layout-xs=\"column\" layout=\"row\" >\n <div layout=\"column\">\n <md-card class=\"social-blue-theme\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Polls</span>\n <span class=\"md-headline margin-top-20\">What\'s for lunch?</span>\n <span class=\"md-body-1\">We are trying to figure out what to get for lunch.</span>\n <span class=\"md-body-1\">Thank you for your <u>input</u>.<br>\n <au-popover class=\"md-padding\"> \n <div style=\"overflow-y:auto;\">\n <span class=\"md-body-1\">You chose <b>Pizza</b 12 min ago></span>\n </div>\n </au-popover>\n </span>\n <div class=\"md-icon-float md-block margin-bottom-20\"> \n <!--<span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-timer\" class=\"social-event-icons-white\"></md-icon> Poll closes <b>Fri Oct 25 10:30AM</b><br></span>-->\n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"social-event-icons-white\"></md-icon> Poll has ended.<br></span> \n </div>\n </md-card-title-text>\n </md-card-title>\n \n <div>\n <!--Chart Here-->\n <img src=\"http://localhost:3000/assets/images/hero/poll.png\">\n <!--Chart End-->\n </div>\n \n </md-card>\n </div>\n </md-content>\n\n </div>\n<!--Sidebar End------------------------------------------------------------------------------------------------->\n\n\n\n\n\n\n<!--Timeline --------------------------------------------------------------------------------------------------->\n\n\n<div layout-wrap layout=\"row\" layout-align=\"center start\">\n\n<!--Create Post-->\n <div>\n <md-card class=\"social-feed\"> \n <md-card-content layout=\"row\" layout-align=\"space-between start\"> \n <au-profile-image user=\"$root.user\" size=\"50\"></au-profile-image>\n \n <md-input-container class=\"md-icon-float md-icon-right md-block\" md-no-float flex>\n <input type=\"text\" placeholder=\"What\'s up?\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" style=\"color:#00AEEF;\"></md-icon>\n </md-input-container> \n </md-card-content>\n </md-card>\n </div>\n<!--Create Post End-->\n\n<!--Share Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar\" xng-if=\"!toolbarIsOpen\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">2 min ago</span>\n </div>\n </div>\n <!--Avatar End-->\n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n <md-card-content>\n\n \n \n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-body-1 margin-bottom-10\">Look at what Lana posted! Isn\'t that cat the coolest?</span>\n \n <md-card>\n\n <md-card-content layout=\"column\">\n <div layout=\"row\" layout-align=\"start center\" > \n <au-profile-image user=\"$root.user\" size=\"20\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Lana Kane</span>\n </div>\n </div> \n\n <div layout=\"column\"> \n <p class=\"md-body-1\">Cool Cat</p>\n <img src=\"https://d13yacurqjgara.cloudfront.net/users/740188/screenshots/2752871/cc-pin-playoff-sean-kerry.png\" class=\"md-card-image\">\n </div>\n\n <!--More Button-->\n <section layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> Go to Page\n </md-button>\n </section>\n <!--More Button End-->\n\n </md-card-content>\n </md-card>\n </div> \n \n\n \n \n\n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">Abe Reese liked this and 16 others\n <au-popover class=\"md-padding scrollable-content\"> \n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n </md-list> \n </au-popover>\n </span>\n </div>\n \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">17 LIKES</span>\n </md-button>\n </div>\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">38 COMMENTS</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n\n\n\n <!--Comment Expanded-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item class=\"md-3-line md-long-text margin-bottom-20\">\n <div layout=\"row\" layout-align=\"start start\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\" class=\"margin-0\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">This is a really long comment about nothing. This post does not make any sense. Why would someone post something like this?</span>\n <span class=\"social-comment-time\">38 min ago</span>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </div>\n </div>\n <!--Comment Expanded End-->\n\n </md-card-content>\n </md-card>\n </div>\n<!--Share Card End-->\n\n<!--Question Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar\" xng-if=\"!toolbarIsOpen\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">39 sec ago</span>\n </div>\n </div>\n <!--Avatar End-->\n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n <md-card-content>\n\n <span class=\"md-headline\">What is the meaning of life?</span>\n <p class=\"md-caption\">What is the significance of living or existence in general? Why are we here, what is life all about?, and What is the purpose of existence? Does life exist at all?</p>\n <p class=\"md-caption\">*The comment feature on this card should not be enabled so all answers/comments are in one place (question thread).</p>\n \n <!--More Button-->\n <section layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> Answer\n </md-button>\n </section>\n <!--More Button End-->\n \n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">Abe Reese liked this and 16 others\n <au-popover class=\"md-padding scrollable-content\"> \n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n </md-list> \n </au-popover>\n </span>\n </div> \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">17 LIKES</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n\n\n </md-card-content>\n </md-card>\n </div>\n<!--Question Card End-->\n\n<!--Status Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar\" xng-if=\"!toolbarIsOpen\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">3 days ago</span>\n </div>\n </div>\n <!--Avatar End-->\n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n <md-card-content>\n <p class=\"md-body-1\">This is a simple status post. The status can have an image attached like the one right below. </p>\n <img src=\"https://d13yacurqjgara.cloudfront.net/users/394518/screenshots/2722002/brandguidelines.jpg\" class=\"md-card-image\">\n\n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">Abe Reese liked this and 16 others\n <au-popover class=\"md-padding scrollable-content\"> \n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n </md-list> \n </au-popover>\n </span>\n </div>\n \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">17 LIKES</span>\n </md-button>\n </div>\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">38 COMMENTS</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n\n\n\n <!--Comment Expanded-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item class=\"md-3-line md-long-text margin-bottom-20\">\n <div layout=\"row\" layout-align=\"start start\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\" class=\"margin-0\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">This is a really long comment about nothing. This post does not make any sense. Why would someone post something like this?</span>\n <span class=\"social-comment-time\">38 min ago</span>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </div>\n </div>\n <!--Comment Expanded End-->\n\n </md-card-content>\n </md-card>\n </div>\n<!--Status Card End-->\n\n<!--Event Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-event-avatar\" xng-if=\"!toolbarIsOpen\"> \n \n <div layout=\"column\" layout-align=\"center start\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"social-event-avatar-icon\"></md-icon>\n </div>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Office Party</span>\n </div>\n </div>\n <!--Avatar End-->\n \n \n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n <md-card-content>\n\n <div class=\"social-event-cover-container\" style=\"background-image: url(https://media.giphy.com/media/d7DuNStBbHW0w/giphy.gif); display: block; background-position: center center;\" >\n </div>\n\n <h1 class=\"md-headline\">Office Party</h1>\n <p class=\"md-body-1\">It\'s about that time of the year when we get to eat, drink, and dance all at once!\n\n </p>\n\n <!--Event Details-->\n <div layout=\"row\" layout-align=\"start start\">\n\n <div layout=\"row\" layout-align=\"start center\">\n <div>\n <div class=\"social-event-date\">\n <span class=\"month\">Mar</span>\n <span class=\"day\">27</span>\n <span class=\"week\">Wed</span>\n </div>\n </div>\n \n </div>\n\n <div class=\"md-icon-float md-block social-event-details\">\n \n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons\"></md-icon>Wednesday<br></span> \n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons\"></md-icon>9:30AM - 11:00AM<br></span> \n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons\"></md-icon>5519 N. Cumberland<br></span> \n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-city\" class=\"social-event-icons\" style=\"visibility: hidden;\"></md-icon>Chicago, IL 60656<br></span>\n \n \n \n <md-menu Xng-init=\"reply=\'Yes\'\">\n <md-button ng-click=\"$mdOpenMenu($event)\" style=\"border-radius: 0;padding: 0;margin: -4px 0 0 0px;line-height: 0;text-transform: none;\" aria-label=\"calendar\">\n \n <span class=\"md-body-1\" ng-if=\'!reply\'><md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"social-event-icons\"></md-icon>Are You Going?<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color: rgba(0, 0, 0, 1);\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'Yes\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-check\" class=\"social-event-icons\"></md-icon>Attending<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color: rgba(0, 0, 0, 1);\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'Maybe\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-note\" class=\"social-event-icons\"></md-icon>Maybe<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color: rgba(0, 0, 0, 1);\"></md-icon></span>\n <span class=\"md-body-1\" ng-if=\"reply==\'No\'\"><md-icon md-font-icon=\"zmdi zmdi-calendar-close\" class=\"social-event-icons\"></md-icon>Not Going<md-icon md-font-icon=\"zmdi zmdi-caret-down\" class=\"social-event-icons\" style=\"color: rgba(0, 0, 0, 1);\"></md-icon></span>\n \n </md-button>\n\n <md-menu-content width=\"4\">\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon> Yes\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon> Maybe\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon> No\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n \n \n </div>\n </div>\n \n <!--Event Details End-->\n \n <!--More Button-->\n <section layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> Event Page\n </md-button>\n </section>\n <!--More Button End-->\n \n\n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">Matt Packard and 5 others are going\n <au-popover class=\"md-padding scrollable-content\"> \n \n <md-subheader>Going</md-subheader>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n </md-list> \n <md-subheader>Not Going</md-subheader>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n <md-list-item>\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">Sterling Archer</span> \n </div>\n </md-list-item>\n </md-list>\n \n </au-popover>\n </span>\n </div>\n \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">17 LIKES</span>\n </md-button>\n </div>\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">38 COMMENTS</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n\n <!--Comment Expanded-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item class=\"md-3-line md-long-text margin-bottom-20\">\n <div layout=\"row\" layout-align=\"start start\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\" class=\"margin-0\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">This is a really long comment about nothing. This post does not make any sense. Why would someone post something like this?</span>\n <span class=\"social-comment-time\">38 min ago</span>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </div>\n </div>\n <!--Comment Expanded End-->\n\n\n </md-card-content>\n </md-card>\n </div>\n<!--Event Card End-->\n\n<!--Main Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar\" xng-if=\"!toolbarIsOpen\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">15 min ago</span>\n </div>\n </div>\n <!--Avatar End-->\n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n\n <md-card-content>\n\n <h1 class=\"md-headline\">Archer TV Series</h1>\n <img src=\"http://i.imgur.com/FSrmZNg.jpg\" class=\"md-card-image\">\n\n \n <!--More Button-->\n <section layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> Go to Document\n </md-button>\n </section>\n <!--More Button End-->\n \n \n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">\n <au-popover class=\"md-padding scrollable-content\">\n </au-popover>\n </span>\n </div>\n \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">LIKE</span>\n </md-button>\n </div>\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">1 COMMENT</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n \n <!--Comment Expanded-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item class=\"md-3-line md-long-text margin-bottom-20\">\n <div layout=\"row\" layout-align=\"start start\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\" class=\"margin-0\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">This is a really long comment about nothing. This post does not make any sense. Why would someone post something like this?</span>\n <span class=\"social-comment-time\">38 min ago</span>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </div>\n </div>\n <!--Comment Expanded End-->\n\n\n </md-card-content>\n </md-card>\n </div>\n<!--Main Card End-->\n\n<!--Poll Card-->\n <div>\n <md-card class=\"social-feed\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\" ng-mouseleave=\"toolbarIsOpen = false\">\n\n <!--Avatar-->\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar\" xng-if=\"!toolbarIsOpen\"> \n <au-profile-image user=\"$root.user\" size=\"40\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">15 min ago</span>\n </div>\n </div>\n <!--Avatar End-->\n \n\n <!--Toolbar-->\n <md-fab-toolbar md-direction=\"left\" class=\"social-blue-bg\" md-open=\"toolbarIsOpen\">\n \n <md-fab-trigger style=\"top: 14px;\">\n <md-button aria-label=\"menu\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" style=\"color: #fff\"></md-icon>\n </md-button>\n </md-fab-trigger>\n\n <md-toolbar>\n <md-fab-actions class=\"md-toolbar-tools\">\n <md-button aria-label=\"pin\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"au au-pin\"></md-icon>\n </md-button>\n <md-button aria-label=\"check\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-toolbar>\n </md-fab-toolbar>\n <!--Toolbar End-->\n\n\n <md-card-content>\n\n <h1 class=\"md-headline\">What\'s for lunch?</h1>\n <span class=\"md-body-1\">We are trying to figure out what to get for lunch. Please help and select from the options below.<br></span>\n \n <span class=\"md-body-1\">Thank you for your <u>input</u>.<br>\n <au-popover class=\"md-padding scrollable-content\"> \n <div style=\"overflow-y:auto;\">\n <span class=\"md-body-1\">You chose <b>Pizza</b 12 min ago></span>\n </div>\n </au-popover>\n </span>\n \n <div class=\"md-icon-float md-block margin-bottom-20\"> \n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-timer\" class=\"social-event-icons\"></md-icon>Poll closes <b>Fri Oct 25 10:30AM</b><br></span>\n <span class=\"md-body-1\"><md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"social-event-icons\"></md-icon>Poll has ended.<br></span> \n </div>\n \n \n <!--Poll-->\n <div>\n <form ng-submit=\"submit()\"> \n <md-radio-group ng-model=\"data.group\" ng-init=\"data.group2 =\'Sushi\'\" layout=\"column\" layout-align=\"start start\"\n layout-wrap class=\"margin-top-10 post-type-container\">\n <md-radio-button value=\"Sushi\" aria-label=\"Sushi\">Sushi</md-radio-button>\n <md-radio-button value=\"Pizza\" aria-label=\"Pizza\">Pizza</md-radio-button>\n <md-radio-button value=\"Burger\" aria-label=\"Burger\">Burger</md-radio-button>\n <md-radio-button value=\"Chinese\" aria-label=\"Chinese\">Chinese</md-radio-button>\n </md-radio-group>\n \n \n <!--More Button-->\n <section layout=\"row\" layout-align=\"end center\">\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\"></md-icon> Submit \n </md-button>\n </section>\n <!--More Button End-->\n \n <!--Graph Here-->\n <div>\n <img src=\"/assets/images/hero/poll.png\">\n </div>\n <!--Graph Here End-->\n\n </form>\n </div>\n <!--Poll End-->\n \n \n <!--Social Count--> \n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\">\n <div flex>\n <span class=\"social-count-text\">\n <au-popover class=\"md-padding scrollable-content\">\n </au-popover>\n </span>\n </div>\n \n \n <div>\n <md-button aria-label=\"likes\" class=\"margin-0 padding-0\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">LIKE</span>\n </md-button>\n </div>\n <div>\n <md-button aria-label=\"comments\" class=\"margin-0 padding-0\" ng-click=\"vm.unCollapsed=!vm.unCollapsed;\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon><span class=\"social-count-text\">1 COMMENT</span>\n </md-button>\n </div>\n </div> \n <!--Social Count End-->\n \n <!--Comment Expanded-->\n <div au-collapsible-container collapsed=\"!vm.unCollapsed\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row margin-top-20\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div>\n <md-list style=\"max-height:250px; overflow-y:auto;\">\n <md-list-item class=\"md-3-line md-long-text margin-bottom-20\">\n <div layout=\"row\" layout-align=\"start start\" class=\"social-avatar-comment\"> \n <au-profile-image user=\"$root.user\" size=\"40\" class=\"margin-0\"></au-profile-image>\n \n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">Sterling Archer</span>\n <span class=\"md-caption\">This is a really long comment about nothing. This post does not make any sense. Why would someone post something like this?</span>\n <span class=\"social-comment-time\">38 min ago</span>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </div>\n </div>\n <!--Comment Expanded End-->\n\n\n </md-card-content>\n </md-card>\n </div>\n<!--Poll Card End-->\n \n</div>\n<!--Timeline End------------------------------------------------------------------------------------------------>\n\n\n\n\n</div>\n</div>");
$templateCache.put("/app/strategy/dialogs/add-initiative.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Initiative\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/addbg.png\">\n <h3>Add An Initiative</h3>\n <p>An initiative is a specific way to execute a strategy to achieve a goal. Initiatives will be measured by key performance indicators.</p>\n </au-wizard-step>\n <au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleEntered()\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Title</h3>\n <p>Enter the title and description of this initiative.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input ng-model=\"vm.initiative.Title\" required/>\n </md-input-container>\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" ng-model=\"vm.initiative.Description\" display-mode=\"field\" extra-plugins=\"table,quicktable,tabletools,tableresize\" resize-trigger=\"vm.resizeTrigger\" style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Description\" flex can-edit=\"true\"></div>\n </div>\n </au-wizard-step>\n <au-wizard-step step-name=\"strategy\" on-next-step=\"vm.confirmStrategyChosen()\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Strategy</h3>\n <p>Which strategy is this initiative for? You can only choose from strategies that you have permission to edit.</p>\n <md-select ng-model=\"vm.initiative.StrategyId\" placeholder=\"Strategy\">\n <md-option ng-repeat=\"strategy in vm.strategies\" ng-value=\"strategy._id\">\n {{strategy.Title}}\n </md-option>\n </md-select>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/strategy/dialogs/add-kpi-data.tmpl.html","<md-dialog au-wizard dialog-title=\"Add KPI Data\" class=\"add-kpi-data-dialog\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\"\n on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\"\n aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step step-name=\"lights\" on-next-step=\"vm.confirmDataEntered()\" step-bg=\"/assets/images/dialogs/add.png\">\n <h3>Enter Data</h3>\n <p>Choose a KPI, enter the number value, and see your results.</p>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-search\" class=\"margin-10\"></md-icon>\n <md-select ng-model=\"vm.kpiData.KPI_id\" placeholder=\"Choose KPI\">\n <md-option ng-repeat=\"kpi in vm.initiative.KPIs\" ng-value=\"kpi._id\">{{kpi.Title}}</md-option>\n </md-select>\n </div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"margin-10\"></md-icon> \n <input ng-model=\"vm.kpiData.Value\" type=\"number\" class=\"number\" placeholder=\"Value\" ng-change=\"vm.calculateResult()\" />\n </div>\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.result\" class=\"margin-10\">\n <div font-size=\"20px\">{{vm.result.Emoji}}</div>\n <div class=\"md-body-2 margin-left-10\">{{vm.result.Name}}</div>\n </div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-10\"></md-icon>\n <mdp-date-picker mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Date Collected\" ng-model=\"vm.kpiData.DateCollected\" class=\"md-icon-float md-block margin-0\" mdp-no-float=\"true\">\n </mdp-date-picker>\n </div>\n\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/strategy/dialogs/add-strategy.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Strategy\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/addbg.png\">\n <h3>Add A Strategy</h3>\n <div>Each team, department or group can own parts of the overall organization\'s strategy...</div>\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/strategy-team.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/strategy-initiatives.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/strategy-dashboard.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Any team, department or group can a part in the strategy.</div>\n <div class=\"padding-20\" flex=\"33\">A strategy can have many Initiatives.</div>\n <div class=\"padding-20\" flex=\"33\">As progress is made, the Strategy dashboard shows KPIs, burndown charts and reviews for all stakeholders to view.</div>\n </div>\n </au-wizard-step>\n <au-wizard-step step-name=\"title\" on-next-step=\"vm.confirmTitleEntered()\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3>Title</h3>\n <p>Enter the title of this strategy.</p>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Title</label>\n <input ng-model=\"vm.strategy.Title\" required/>\n </md-input-container>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/strategy/initiative/detail.tmpl.html","<div class=\"strategy-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" item=\"vm.item\" selected=\"1\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Title\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!--Initiative Details-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-chess-piece\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Initiative Details</div>\n <div class=\"description\">Edit the title and description.</div>\n </div>\n <md-icon md-font-icon=\"au au-chess-piece\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Title-->\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n <!--Creator-->\n <div layout=\"row\" class=\"md-body-1\" flex style=\"top:-10px;margin-left:40px; position:relative; color: rgba(0,0,0,0.54);\">\n <span>Creator: </span>\n <span class=\"margin-left-5\">\n <strong>{{vm.item.Creator | auItemFilter: \'User\'}}</strong>\n </span>\n </div>\n <!--Description-->\n <div layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" item=\"vm.item\" item-field=\"Description\" display-mode=\"field\" extra-plugins=\"au-task,table,quicktable,tabletools,tableresize\"\n resize-trigger=\"vm.resizeTrigger\" can-edit=\"vm.item\" acl=\"U\" style=\"border: solid thin rgb(224,224,224);\"\n placeholder=\"Description\" flex></div>\n </div>\n <!--Active / Inactive-->\n <div layout=\"row\" layout-align=\"start center\">\n <div flex=\"50\">\n <md-icon md-font-icon=\"zmdi zmdi-power\" class=\"icon-switch\"></md-icon>\n <span ng-if=\"!vm.item.IsActive\">This initiative is\n <strong>inactive</strong>. Click to activate this initiative.</span>\n <span ng-if=\"vm.item.IsActive\">This initiative is\n <strong>active</strong>. Click to mark it as Inactive.</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex=\"50\">\n <span class=\"margin-right-10\">{{ vm.item.IsActive ? \'Active\' : \'Inactive\' }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Active Switch\" ng-model=\"vm.item.IsActive\" id=\"SwitchActive\"></md-switch>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!--KPIs-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-ruler\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnKPIHeader\">\n <div class=\"md-title\">KPIs: Key Performance Indicators</div>\n <div class=\"description\">Set measurable goals for this initiative.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-ruler\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!-- Empty state -->\n <div ng-if=\"vm.item.KPIs.length == 0\" class=\"margin-bottom-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/beaker.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No KPIs</h1>\n <span class=\"md-body-1 opacity-50\">This item does not have any key performance indicators.</span>\n <span class=\"md-body-1 opacity-50\">Start by selecting the New KPI button!</span>\n </div>\n\n <!--the KPI table-->\n <div layout=\"column\" layout-align=\"center start\" ng-repeat=\"kpi in vm.item.KPIs\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"full-width\">\n <!--Title-->\n <md-input-container layout=\"row\" layout-align=\"center start\" class=\"full-width\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <input ng-model=\"kpi.Title\" placeholder=\"Title\" />\n </md-input-container>\n <div flex=\"20\"></div>\n <!--Delete button-->\n <md-button ng-click=\"vm.confirmThenRemove($event, kpi)\" class=\"md-icon-button\" ng-show=\"$root.user._id == kpi.CreatedBy\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" aria-label=\"delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n </div>\n <!--Description-->\n <div layout=\"row\" layout-align=\"start start\" layout-fill>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-top-9\"></md-icon>\n <div class=\"au-cke-document md-input\" ng-model=\"kpi.Description\" can-edit=\"vm.item\" acl=\"U\" placeholder=\"Description\" grow=\"true\"\n flex></div>\n </div>\n\n <md-divider></md-divider>\n\n <div class=\"md-subhead\">KPI Thresholds </div>\n <div class=\"md-caption margin-bottom-20\">Define how you will grade KPI data entered. Rules are evaluated top-down.\n </div>\n <div layout=\"row\" layout-align=\"start center\" ng-repeat=\"threshold in kpi.Thresholds track by $index\" class=\"full-width\">\n <md-select ng-model=\"threshold.Emoji\" placeholder=\"Emoji\" class=\"emoji\">\n <md-option ng-repeat=\"emoji in vm.emojiOptions\">\n {{emoji}}\n </md-option>\n </md-select>\n <input class=\"kpi-label\" ng-model=\"threshold.Name\" placeholder=\"Title\" flex />\n <md-select ng-model=\"threshold.Operation\" placeholder=\"Choose Operation\" class=\"operation\">\n <md-option ng-repeat=\"op in vm.operations\" ng-value=\"op.symbol\">\n {{op.word}}\n </md-option>\n </md-select>\n <input type=\"number\" ng-model=\"threshold.LowValue\" placeholder=\"Target Number\" class=\"number\" />\n <div ng-if=\"threshold.Operation == \'btw\'\" class=\"md-body-1 margin-left-50\">and</div>\n <input ng-if=\"threshold.Operation == \'btw\'\" type=\"number\" ng-model=\"threshold.HighValue\" placeholder=\"Target Number\" class=\"number\"\n />\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeThreshold(kpi._id, $index)\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"remove\">\n <md-tooltip>Remove</md-tooltip>\n </md-icon>\n </md-button>\n </div>\n <md-button ng-click=\"vm.addThreshold(kpi._id)\" class=\"md-primary\">Add Threshold</md-button>\n\n <md-divider></md-divider>\n\n <!--Collection Process-->\n <div class=\"md-subhead\">Collection Process </div>\n <div class=\"md-caption margin-bottom-20\">To ensure consistent measurement of the KPI over time, record the process for collecting\n and measuring KPIs below.\n </div>\n\n <div layout=\"row\" layout-align=\"start start\" layout-fill>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-right-12 margin-top-9\"></md-icon>\n <div class=\"au-cke-document text-area\" ng-model=\"kpi.CollectionProcess\" display-mode=\"field\" extra-plugins=\"au-task,table,quicktable,tabletools,tableresize\"\n style=\"border: solid thin rgb(224,224,224);\" placeholder=\"Collection Process\" flex></div>\n </div>\n <!--Last Indicator-->\n <div layout=\"row\" layout-align=\"center start\" ng-show=\"kpi.LastIndicator\" class=\"md-body-1\">The last KPI data entered was {{kpi.LastIndicator}}.</div>\n\n <!--Repeats Every-->\n <div class=\"md-subhead margin-top-20\">Manual KPI Data Entry Schedule</div>\n <div class=\"md-caption margin-bottom-20\">An Align Us Task will be created per the schedule you set below.\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-right-10\"></md-icon>\n <div class=\"margin-right-10\">\n Enter data every:\n </div>\n <md-select ng-model=\"kpi.RepeatsEvery.Interval\" md-size=\"1\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]\">\n {{number}}\n </md-option>\n </md-select>\n <md-select ng-model=\"kpi.RepeatsEvery.IntervalType\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-value=\"\'weekly\'\">\n week(s)\n </md-option>\n <md-option ng-value=\"\'monthly\'\">\n month(s)\n </md-option>\n </md-select>\n <div>\n .\n </div>\n </div>\n\n <div ng-if=\"kpi.RepeatsEvery.IntervalType == \'weekly\'\" layout=\"row\" layout-align=\"start start\" class=\"margin-top-10\" style=\"margin-bottom: -10px;\"\n layout-gt-sm=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0 margin-right-10\" hide show-gt-sm></md-icon>\n <div class=\"margin-right-10 nowrap\">\n On Day(s):\n </div>\n <div layout=\"row\" layout-wrap flex>\n <md-checkbox ng-repeat=\"day in $root.daysOfWeek\" ng-model=\"kpi.RepeatsEvery.RepeatDays[day]\" class=\"margin-right-10\" style=\"min-width: 100px\">{{day}}</md-checkbox>\n </div>\n </div>\n\n <div ng-if=\"kpi.RepeatsEvery.IntervalType == \'monthly\'\" layout=\"row\" layout-align=\"start center\" class=\"margin-top-10\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0 margin-right-10\"></md-icon>\n\n <div class=\"nowrap margin-right-10\">Task is due on the &nbsp; </div>\n <md-select ng-model=\"kpi.RepeatsEvery.DayOfMonth\" class=\"margin-0 margin-bottom-5\">\n <md-option ng-repeat=\"number in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]\">\n {{number}}\n </md-option>\n </md-select>\n <div>\n <sup>\n {{$root.auUtility.ordinal_suffix_of(kpi.RepeatsEvery.DayOfMonth, true)}}\n </sup>\n day of the month.\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-top-10\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"margin-0 margin-right-10\"></md-icon>\n <div class=\"margin-right-10\">Starting:</div>\n <mdp-date-picker mdp-open-on-click name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"First Date\" ng-model=\"kpi.RepeatsEvery.StartDate\"\n id=\"TxtStartDate\" class=\"md-icon-float md-block margin-0\" mdp-no-float=\"true\">\n </mdp-date-picker>\n </div>\n <md-divider ng-if=\"!$last\" class=\"margin-bottom-20 thick border-top-color\"></md-divider>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.addKPI($event)\" id=\"BtnAddKPI\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;New KPI&nbsp;</span>\n </md-button>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!--KPI Data-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-chart\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnKPIDataHeader\">\n <div class=\"md-title\">KPI Data</div>\n <div class=\"description\">Table of data for KPIs in this initiative.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-chart\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.openNewKPIDataDialog($event)\" id=\"BtnNewKPIData\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;New KPI Data&nbsp;</span>\n </md-button>\n </div>\n\n <!-- Empty state -->\n <div ng-if=\"vm.item.KPIData.length == 0\" class=\"margin-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/beaker.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No KPI Data</h1>\n <span class=\"md-body-1 opacity-50\">There is no data for any KPIs.</span>\n <span class=\"md-body-1 opacity-50\">Start by selecting the New KPI Data button!</span>\n </div>\n\n <!--KPI Data Table-->\n <md-list class=\"margin-20\">\n <md-list-item flex class=\"full-width\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"data in vm.item.KPIData\">\n <div class=\"emoji\">{{data.Emoji}}</div>\n <div>{{vm.kpiTitle(data)}}: {{data.Value}}</div>\n <div flex></div>\n <div class=\"md-caption\">Date Collected: {{moment(data.DateCollected).format(\'M/D/YYYY h:mma\')}}</div>\n <div flex></div>\n <md-button ng-click=\"vm.confirmThenRemove($event, data)\" class=\"md-icon-button margin-0\" ng-show=\"$root.user._id == data.CreatedBy\"\n layout-align=\"end center\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" aria-label=\"delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n </md-list-item>\n </md-list>\n </div>\n </md-card>\n\n <!--Review Schedule-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnReviewScheduleHeader\">\n <div class=\"md-title\">Review Schedule</div>\n <div class=\"description\">Tasks to remind reviewers to update progress on this initiative.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <!--Reviewers-->\n <div class=\"padding-20\">\n <div class=\"md-subhead\">\n Enter one or more users who will be responsible for reviewing this initiative and logging their findings below.\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.item.Reviewers\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.Reviewers, $chip)\"\n flex id=\"ChipInitiativeReviewer\">\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.reviewersSearchText\" md-items=\"reviewer in $root.auUtility.searchUsers({query:vm.reviewersSearchText, excludeContacts: true})\"\n placeholder=\"Add Reviewer\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtInitiativeReviewer\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.reviewersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoInitiativeReviewer{{$index}}\">{{reviewer | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipIniativeReviewer{{$index}}\">{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n <au-help-icon key=\"Initiative.Reviewer\"></au-help-icon>\n </div>\n </div>\n\n <!-- Empty state -->\n <div ng-if=\"vm.item.ReviewSchedule.length == 0\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/schedule.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No Schedule Set</h1>\n <span class=\"md-body-1 opacity-50\">Enter a new review schedule by clicking the button below.</span>\n </div>\n\n <!--Review List-->\n <div ng-repeat=\"reviewTask in vm.reviewTaskList track by reviewTask._id\" ng-dblclick=\"reviewTask.open()\">\n <au-task-row task=\"reviewTask\"></au-task-row>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-20\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.openNewReviewScheduleDialog($event)\" id=\"BtnNewReviewSchedule\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;New Review Schedule&nbsp;</span>\n </md-button>\n </div>\n </div>\n </md-card>\n\n <!--Reviews-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up-down\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnReviewsHeader\">\n <div class=\"md-title\">Reviews</div>\n <div class=\"description\">Collection of reviews for this initiative.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up-down\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <!--Input -->\n <div layout=\"column\" class=\"margin-20\">\n <div class=\"au-cke-document md-input\" ng-model=\"vm.workingReview\" placeholder=\"Review\" id=\"TxtReviewInput\" flex grow=\"true\"></div>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.postReviewClicked($event)\" class=\"md-raised md-accent\" type=\"submit\" aria-label=\"Post\" id=\"BtnPostReview\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n Post Review\n </md-button>\n </div>\n </div>\n\n <!-- Empty state -->\n <div ng-if=\"vm.item.Reviews.length == 0\" class=\"margin-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/task.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No Reviews</h1>\n <span class=\"md-body-1 opacity-50\">There are no reviews for this initiative.</span>\n <span class=\"md-body-1 opacity-50\">Start by typing your review on the line above.</span>\n </div>\n\n <!--Review List-->\n <div class=\"padding-10\" style=\"max-height:350px; overflow-y:auto;\">\n <div class=\"margin-bottom-10\" class=\"md-3-line md-long-text\" ng-repeat=\"review in vm.item.Reviews track by review._id\" ng-mouseenter=\"review.$hovered = true;\"\n ng-mouseleave=\"review.$hovered = false\">\n <div layout=\"row\" layout-align=\"space-between start\">\n <div layout=\"row\" flex>\n <au-profile-image user=\"review.User\" size=\"30\" style=\"margin-right:-4px;\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <div layout=\"column\" layout-align=\"center start\" ng-attr-id=\"StringReviewList{{::$index}}\" class=\"margin-left-15\">\n <span class=\"md-body-2\">{{review.User | auItemFilter: \'User\'}}</span>\n <span class=\"review\" dynamic=\"::review.Comment\"></span>\n <span class=\"review-time\" am-time-ago=\"::review.DateCreated\"></span>\n </div>\n </div>\n <!--delete review-->\n <md-button aria-label=\"delete-review\" ng-show=\"review.$hovered && $root.user._id == review.User\" ng-click=\"vm.confirmThenRemove($event, review)\"\n class=\"md-icon-button\" ng-attr-id=\"BtnRemoveReview{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:gray\"></md-icon>\n </md-button>\n </div>\n </div>\n </div>\n </div>\n </md-card>\n\n <!-- Discussion Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDiscussionHeader\">\n <div class=\"md-title\">Discussion</div>\n <div class=\"description\">View this task\'s history and discussion board.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-discussion-board item=\"vm.item\"></au-discussion-board>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Document Section-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- Workflows Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au au-workflow\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"\n style=\"width: 1.28571em;\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Workflows</div>\n <div class=\"description\">Collection box for all your approval requests.</div>\n </div>\n <md-icon md-font-icon=\"au au-workflow\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\" style=\"width: 1.28571em;\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-workflows item=\"vm.item\"></au-workflows>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all meetings regarding this initiative.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/strategy/item/detail.tmpl.html","<div class=\"strategy-item-detail\">\n <ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" item=\"vm.item\" selected=\"1\">\n\n <!--Strategy Quickview-->\n <md-card class=\"no-clip\">\n <md-card-content class=\"background-color-500 padding-30\">\n\n <div layout=\"row\" layout-align=\"space-between start\">\n <div class=\"font-size-3 font-weight-300 margin-right-10 margin-bottom-10\">{{vm.item.Title}}</div>\n <!--buttons-->\n <div layout=\"row\" layout-align=\"end start\">\n <au-template-buttons item=\"vm.item\"></au-template-buttons>\n <md-button ng-click=\"vm.item.DeleteMe()\" class=\"md-icon-button\" ng-if=\"vm.item.userHasPermission(\'D\')\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>Delete</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\')\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip md-direction=\"left\">Open In New Tab</md-tooltip>\n </md-button>\n <au-share-in-video-button item=\"vm.item\" ng-show=\"$root.getUiActiveVideoCall()\"></au-share-in-video-button>\n </div>\n </div>\n <!--subtitles-->\n <div layout=\"row\">\n <div layout=\"column\" layout=\"start start\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>{{vm.item.Creator | auItemFilter: \'User\'}}</span>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-caption font-color-100\" flex>Editors</span>\n </div>\n <div layout=\"row\" layout-align- \"start center\" class=\"margin-left-20\">\n <div layout=\"row\" layout-align- \"start center\" ng-repeat=\"editor in vm.item.Editors\" layout-wrap>\n <au-profile-image user=\"editor\" size=\"20\" class=\"margin-right-8 grow\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n </div>\n </div>\n </div>\n\n <div layout=\"column\" layout-align=\"start start\">\n <div ng-if=\"!vm.item.IsPrivate\" layout=\"row\" layout-align=\"start center\" class=\"margin-left-20\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>All Users in {{vm.orgName}}</span>\n </div>\n <div ng-if=\"vm.item.IsPrivate\" layout=\"column\" layout-align=\"start start\" class=\"margin-left-20\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-lock\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-body-1\" flex>Editors and Shared users Only</span>\n </div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"font-size-1 font-color-100 margin-right-8\"></md-icon>\n <span class=\"md-caption font-color-100\" flex>Shared With</span>\n </div>\n\n <div layout=\"row\" layout-align- \"start center\">\n <div layout=\"row\" layout-align- \"start center\" ng-repeat=\"viewer in vm.item.SharedWith\" layout-wrap>\n <au-profile-image user=\"viewer\" size=\"20\" class=\"margin-right-8 grow\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n </div>\n </div>\n </div>\n </div>\n </md-card-content>\n </md-card>\n\n <!--Strategy Settings-->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Settings</div>\n <div class=\"description\">Edit the title, privacy, editors, and who this strategy is shared with.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <!--Title-->\n <md-input-container flex>\n <label>\n <span>Title</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n <!--Creator-->\n <div layout=\"row\" class=\"md-body-1\" flex style=\"top:-10px; position:relative; color: rgba(0,0,0,0.54);\">\n <span>Creator: </span>\n <span class=\"margin-left-5\">\n <strong>{{vm.item.Creator | auItemFilter: \'User\'}}</strong>\n </span>\n </div>\n <!--Editors-->\n <div class=\"md-body-1\" style=\"margin-bottom: -20px;\">Editors:</div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.item.Editors\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.Editors, $chip)\"\n flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.editorsSearchText\" md-items=\"editor in $root.auUtility.searchUsers(vm.editorsSearchText, null, true)\"\n placeholder=\"Add Editor\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.editorsSearchText\" md-highlight-flags=\"i\">{{editor | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n <!--Active / Inactive-->\n <div layout=\"row\" layout-align=\"start center\">\n <div flex=\"50\">\n <md-icon md-font-icon=\"zmdi zmdi-power\" class=\"icon-switch\"></md-icon>\n <span ng-if=\"!vm.item.IsActive\">This strategy is\n <strong>inactive</strong>. Click to activate this strategy.</span>\n <span ng-if=\"vm.item.IsActive\">This strategy is\n <strong>active</strong>. Click to mark it as Inactive.</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex=\"50\">\n <span class=\"margin-right-10\">{{ vm.item.IsActive ? \'Active\' : \'Inactive\' }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Active Switch\" ng-model=\"vm.item.IsActive\" id=\"SwitchActive\"></md-switch>\n </div>\n </div>\n <!--Privacy Switch-->\n <div layout=\"row\" layout-align=\"start center\">\n <div ng-if=\"!vm.item.IsPrivate\" flex=\"70\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"icon-switch\"></md-icon>\n <span>This strategy is\n <strong>readable</strong> by all users in {{vm.orgName}}. Click to make it private.</span>\n </div>\n <div ng-if=\"vm.item.IsPrivate\" flex=\"70\">\n <md-icon md-font-icon=\"zmdi zmdi-eye-off\" class=\"icon-switch\"></md-icon>\n <span>This strategy is\n <strong>private</strong>. Click to make it viewable by all users in {{vm.orgName}}.</span>\n </div>\n <div layout=\"row\" layout-align=\"end center\" flex>\n <span class=\"margin-right-10\">{{ vm.item.IsPrivate ? \'Editors and Shared Users\' : \'All Users in \' + vm.orgName }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Privacy Switch\" ng-model=\"vm.item.IsPrivate\" id=\"SwitchPrivacy\"></md-switch>\n </div>\n </div>\n <!--SharedWith-->\n <div ng-show=\"vm.item.IsPrivate\" class=\"expanded animate-show-hide\">\n <div class=\"md-body-1\" style=\"margin-bottom: -20px;\">Shared With:</div>\n <div layout=\"row\" layout-align=\"start center\">\n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" style=\"top:14px;\"></md-icon>\n <md-chips ng-model=\"vm.item.SharedWith\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.SharedWith, $chip)\"\n flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.sharedWithSearchText\" md-items=\"sharedWith in $root.auUtility.searchUsers(vm.sharedWithSearchText, null, true)\"\n placeholder=\"Share with users\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\">{{sharedWith | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Initiatives-->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-lamp\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Initiatives</div>\n <div class=\"description\">View the list of initiatives for this strategy and add new ones.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-lamp\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <md-card-content>\n <div layout=\"row\" layout-align=\"space-between center\" class=\"toolbar\">\n <md-menu>\n <md-button class=\"md-accent\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.initiatives.length == 0\" id=\"BtnSortInitiatives\">\n <md-icon md-font-icon=\"zmdi zmdi-sort\"></md-icon> Sort &nbsp;\n </md-button>\n <md-menu-content>\n <md-menu-item ng-repeat=\"sortDescriptor in vm.sortableBy\">\n <md-button ng-click=\"vm.setSortBy($index)\">\n {{sortDescriptor.display}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <div flex></div>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.openNewInitiativeDialog($event)\" id=\"BtnNewInitiative\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon><span hide-xs hide-sm>&nbsp;New Initiative&nbsp;</span>\n </md-button>\n </div>\n </div>\n \n <!-- Empty state -->\n <div ng-if=\"vm.initiatives.length == 0\" class=\"margin-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/workflow.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No Initatives</h1>\n <span class=\"md-body-1 opacity-50\">This item does not have any initiatives.</span>\n <span class=\"md-body-1 opacity-50\">Start by selecting the New Initiative button!</span>\n </div>\n\n <!--Initiative List-->\n <md-list-item flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"initiative in vm.initiatives\" ng-click=\"initiative.open()\">\n <md-icon md-font-icon=\"zmdi zmdi-lamp\"></md-icon>\n <div layout=\"column\" layout-align=\"center start\" flex>\n <div class=\"text-ellipsis\" style=\"margin-bottom: -5px;\">{{initiative.Title}}</div>\n <div class=\"md-caption\" style=\"margin-top: -5px;\">Created By {{initiative.$Creator.toString()}} on {{initiative.DateCreated | date: \'MM-dd-yyyy h:mma\'}}</div>\n </div>\n <md-button ng-click=\"vm.confirmThenRemove($event, initiative)\" class=\"md-icon-button\" ng-show=\"$root.user._id == initiative.Creator\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n </md-list-item>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Doc Section or Workflows?-->\n </md-popout-card-list>\n </div>\n </ng-form>\n</div>");
$templateCache.put("/app/techsupport/make-global-post/make-global-post.tmpl.html","<div class=\"big-margin-content\" layout-fill layout=\"column\">\n Post ID Here: <input ng-model=\"vm.postId\">\n <md-button ng-click=\"vm.distribute()\">Distribute Post</md-button>\n</div>");
$templateCache.put("/app/techsupport/run-migration-script/run-migration-script.tmpl.html","<div class=\"big-margin-content\" layout-fill layout=\"column\">\n <md-input-container flex>\n <label>Script Name</label>\n <input ng-model=\"vm.scriptName\" />\n </md-input-container>\n <md-input-container flex>\n <label>Request Body</label>\n <textarea ng-model=\"vm.body\" />\n </md-input-container>\n <md-button ng-click=\"vm.go()\">\n Run Script\n </md-button>\n <div ng-repeat=\"res in vm.results\">\n {{res}}\n </div>\n</div>");
$templateCache.put("/app/techsupport/search-users/search-users.tmpl.html","<div>\n <md-input-container ng-repeat=\"fieldName in vm.searchApi.searchableBy\">\n <label>{{fieldName}}</label>\n <input ng-model=\"vm.params[fieldName]\" />\n </md-input-container>\n <md-button ng-click=\"vm.searchClicked(vm.params)\">\n Search\n </md-button>\n <div ng-repeat=\"user in vm.results\">\n {{user.LastName}}\n <md-button ng-click=\"vm.getLoginAsClicked(user)\">Get LoginAs Link</md-button>\n <md-button ng-click=\"user.open()\">Open Detail</md-button>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/angular-org-chart/org-chart-node.html","<div id=\"{{node.$id}}\" class=\"node-container\">\n\n <div class=\"node node-type{{nodeType}}\" ng-attr-style=\"width:{{nodeWidth}}px;\" ng-class=\"{\'just-dropped\' : node.$justDropped}\">\n <div ng-if=\"node.$parentId\" class=\"vert-line-top\" comment=\"Connects the node to the horizontal line above it.\"></div>\n\n <div class=\"node-contents\" ng-style=\"{\'min-height\': (nodeHeight-30) + \'px\', \'min-width\':nodeWidth + \'px\'}\" \n ng-dblclick=\"onDoubleClick({node:node})\"\n ng-click=\"selectNode(node, $event)\"\n ng-class=\"{selected : node.$selected}\">\n <div ng-if=\"displayProperty\">\n {{node[displayProperty]}}\n </div>\n <div ng-if=\"nodeTemplate\" ng-include=\"::nodeTemplate\" style=\"width: 100%\" ng-style=\"{\'min-height\': (nodeHeight-30) + \'px\'}\"></div>\n <div ng-if=\"nodeExpression\" dynamic=\"nodeExpression\" style=\"width: 100%\" ng-style=\"{\'min-height\': (nodeHeight-30) + \'px\'}\"></div>\n </div>\n\n <div ng-if=\"node.$hasChildren\" class=\"vert-line-bottom\" comment=\"Connects the node to the plus sign below it\">\n <div class=\"toggle-button\" ng-click=\"setOpen(node,true)\" id=\"BtnExpand\">\n +\n </div>\n </div>\n\n </div>\n\n <div class=\"tree-children id_{{node.$id}} angular-animate\" ng-if=\"node.$hasChildren && node.$isOpen\">\n <div class=\"horz-line-container\">\n <div class=\"horz-line id_{{node.$id}}\" ng-attr-style=\"{{getLine(node.$id)}}\"></div>\n </div>\n <!-- needed to get the minus sign on top of the connecting lines -->\n <div class=\"toggle-button toggle-button-minus\" ng-click=\"setOpen(node,false)\" id=\"BtnCollapse\">\n &#8210;\n </div>\n <div ng-repeat=\"node in nodes | filter: {$parentId: node.$id} track by node.$id\" class=\"tree-parent tree-child\" ng-include=\"::layoutTemplate\">\n </div>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/directives/angular-org-chart/org-chart-root.html","<span class=\"console\">\n <i ng-repeat=\"node in nodes\"><u ng-if=\"!node.$OrgChartReady\">{{prepNode(node)}}</u></i>\n</span>\n<div layout=\"row\" class=\"angular-org-chart-container\">\n <div class=\"unassigned-nodes\" ng-mouseenter=\"enterUnassigned()\" ng-mouseleave=\"leaveUnassigned()\" flex=\"10\" layout=\"column\"\n layout-fill id=\"SpaceForSelfManaged\">\n <div class=\"background-primary unassigned-members\">\n <div style=\"max-width: 150px\">\n {{unassignedMembersText}}&nbsp;({{(nodes | filter: filterUnassignedNodes).length}})\n </div>\n </div>\n\n <div class=\"node-list\" layout=\"column\" flex>\n <div ng-repeat=\"node in nodes | filter: filterUnassignedNodes | orderBy: node.toString track by node.$id\" class=\"unassigned-node unassigned-node{{nodeType}}\"\n ng-class=\"{selected : node.$selected}\" id=\"{{node.$id}}\" ng-include=\"::unassignedMemberTemplate\" ng-click=\"selectNode(node, $event)\" ng-dblclick=\"node.open()\">\n </div>\n </div>\n </div>\n <div flex=\"90\" class=\"root\" ng-click=\"selectNode({},$event);\" note=\"This is the viewport. We scale the canvas to fit the viewport. I.E. if the viewport is 500px wide but the content is 1000px wide, we scale the canvas to .5, plus a little padding, so all the content can fit in the viewport.\">\n <div class=\"angular-org-chart\" note=\"This is the canvas.\">\n <div class=\"tree-roots\" ng-if=\"nodes\">\n <div class=\"tree-parent\" ng-repeat=\"node in nodes | filter: filterRootNodes track by node.$id\" ng-include=\"::layoutTemplate\"></div>\n </div>\n <div class=\"noManagedMembers\" ng-if=\"noRootNodes\" ng-style=\"{width: viewportWidth}\">{{noManagedMembersText}}\n <div>Drop items here to connect them.</div>\n </div>\n </div>\n </div>\n</div>\n\n<script type=\"text/ng-template\" id=\"default-unassignedMemberTemplate\">\n <div style=\"display: inline-block; background-color: #ccc; min-width: 30px; height: 30px; border-radius: 50%; margin-right: 10px;\"></div>\n <span class=\"name\">{{node.toString()}}</span>\n</script>");
$templateCache.put("/app/alignus/directives/angular-org-chart/org-chart-unassigned.tmpl.html","<div layout=\"row\">\n <au-profile-image ng-if=\"node.LinkWithUserId\" user=\"node.LinkWithUserId\" size=\"30\"></au-profile-image>\n <au-profile-image ng-if=\"!node.LinkWithUserId\" item=\"node\" size=\"30\"></au-profile-image>\n <span class=\"name\" flex>{{node.toString()}}</span>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/au-activity-log.tmpl.html","<div layout=\"row\" layout-align=\"space-between center\" style=\"box-sizing: border-box; background-color: rgb(245, 245, 245); height: 50px; width: 100%; padding: 30px 10px;\">\n <div>\n <!--WIRE UP Filter View Option-->\n <md-menu>\n <md-button class=\"md-accent\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon> View &nbsp;\n </md-button>\n <md-menu-content>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-view-list-alt\"></md-icon>All Activity &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"au au-reassign\"></md-icon>Reassignment History &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-flash\"></md-icon>Task State Changes &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-timer\"></md-icon>Time Logged &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-folder\"></md-icon>Task Location Changes &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle\"></md-icon>Task Priority Changes &nbsp;\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.refreshLog()\" id=\"BtnRefresh\">\n <md-icon md-font-icon=\"zmdi zmdi-refresh\"></md-icon><span hide-xs hide-sm>Refresh Log &nbsp; </span>\n </md-button>\n </div>\n</div>\n\n<div class=\"margin-10\">\n <md-list>\n <md-list-item ng-repeat=\"log in vm.activity | orderBy: \'-Date\'\" style=\"border-bottom: thin solid whitesmoke;\" class=\"secondary-button-padding\" ng-mouseenter=\"showRemove = true\" ng-mouseleave=\"showRemove = false\" ng-click=\"doPrimaryAction($event)\">\n <div ng-include=\"::log.GetTemplate()\" ng-attr-id=\"StringActivity{{$index}}\"></div>\n \n <!--WIRE UP-->\n <md-button class=\"md-icon-button md-secondary\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\" ng-show=\"showRemove\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-comments\" ng-hide=\"showRemove\" style=\"visibility:hidden;\"></md-icon>\n </md-button>\n </md-list-item>\n </md-list>\n</div>\n\n<!--<div class=\"margin-10\">\n <md-list >\n <md-list-item ng-repeat=\"log in vm.activity | orderBy: \'-Date\'\" ng-include=\"::log.GetTemplate()\" ng-attr-id=\"StringActivity{{$index}}\" style=\"border-bottom: thin solid whitesmoke;\">\n </md-list-item>\n </md-list>\n</div>-->\n\n\n<!--<table class=\"table table-header\">\n <tr>\n <th>\n <md-button ng-click=\"vm.refreshLog()\" id=\"BtnRefresh\">\n Refresh Log\n </md-button>\n </th>\n </tr>\n <tr ng-repeat=\"log in vm.activity | orderBy: \'-Date\'\" ng-include=\"::log.GetTemplate()\" ng-attr-id=\"StringActivity{{$index}}\"></tr>\n</table>-->");
$templateCache.put("/app/alignus/directives/au-activity-log/completion.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <img s3-src=\"/assets/images/gifs/no-loop/check.gif\" style=\"border-radius: 50%; width: 20px;\" class=\"margin-left-4 margin-right-7\">\n <div class=\"margin-right-2\">\n <strong>{{log.User | auItemFilter: \'User\'}}</strong> finished\n <strong>{{log.Task | auItemFilter: \'Task\'}}</strong> on {{log.Date | date: \'short\'}}\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/creation.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <au-profile-image user=\"log.User\" size=\"20\" style=\"margin:0 7px 0 4px;\"></au-profile-image>\n <span class=\"margin-right-2\">\n <strong>{{log.User | auItemFilter: \'User\'}}</strong>\n </span>\n <span class=\"margin-right-2\">created this task on</span>\n <span>{{log.Date | date: \'short\'}}</span>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/documentattached.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-attachment\" class=\"margin-right-5 opacity-50\"></md-icon>\n </div>\n <div class=\"margin-right-2\">\n <strong>{{log.User | auItemFilter: \'User\'}}</strong> attached {{log.Data.DocumentTitle}} on {{log.Date | date: \'short\'}}\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/duplicate.tmpl.html","<!--WIRE UP: This activity log is never created-->\n<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div><md-icon md-font-icon=\"zmdi zmdi-copy\" class=\"margin-right-5 opacity-50\"></md-icon></div> \n <span class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> marked this task as a duplicate of <strong>{{log.Data.DuplicateTask | auItemFilter: \'Task\'}}</strong> on {{log.Date | date: \'short\'}} </span>\n</div>\n");
$templateCache.put("/app/alignus/directives/au-activity-log/inactive.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div><md-icon md-font-icon=\"zmdi zmdi-power\" class=\"margin-right-5 margin-left-2 opacity-70\"></md-icon></div>\n <span class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> marked the task as <strong>{{log.Data.IsActive ? \'Active\' : \'Inactive\'}}</strong> on {{log.Date | date : \'short\'}}</span>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/projectprioritychanged.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div><md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"margin-right-5 margin-left-2 opacity-50\"></md-icon></div>\n <span><strong>{{log.User | auItemFilter: \'User\'}}</strong> updated this to <strong>{{log.Data.NewProjectPriority | priorityFilter}}</strong> on {{log.Date | date: \'short\'}}</span>\n</div>\n\n");
$templateCache.put("/app/alignus/directives/au-activity-log/reassigneddocument.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\"log-entry\">\n <div><md-icon md-font-icon=\"zmdi zmdi-file-text\" class=\"opacity-50 margin-right-5\"></md-icon></div>\n <span ng-if=\"!log.Data.OldDocument && log.Data.NewDocument\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> assigned the task to <strong>{{log.Data.NewDocument | auItemFilter : \'Document\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldDocument && log.Data.NewDocument\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> reassigned the task from {{log.Data.OldDocument | auItemFilter: \'Document\'}} to <strong>{{log.Data.NewDocument | auItemFilter: \'Document\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldDocument && !log.Data.NewDocument\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> unassigned the task from <strong>{{log.Data.OldDocument | auItemFilter : \'Document\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n</div>\n");
$templateCache.put("/app/alignus/directives/au-activity-log/reassignedmeeting.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\"log-entry\">\n <div><md-icon md-font-icon=\"au au-meeting\" class=\"opacity-50 margin-right-5\"></md-icon></div>\n <span ng-if=\"!log.Data.OldMeeting && log.Data.NewMeeting\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> assigned the task to <strong>{{log.Data.NewMeeting | auItemFilter : \'Meeting\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldMeeting && log.Data.NewMeeting\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> reassigned the task from {{log.Data.OldMeeting | auItemFilter: \'Meeting\'}} to <strong>{{log.Data.NewMeeting | auItemFilter: \'Meeting\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldMeeting && !log.Data.NewMeeting\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> unassigned the task from <strong>{{log.Data.OldMeeting | auItemFilter : \'Meeting\'}}</strong> on {{log.Date | date: \'short\'}}</span> \n</div>\n");
$templateCache.put("/app/alignus/directives/au-activity-log/reassignedparenttask.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\"log-entry\">\n <div><md-icon md-font-icon=\"zmdi zmdi-check\" class=\"margin-right-5 opacity-50\"></md-icon></div>\n <span ng-if=\"!log.Data.OldParentTask && log.Data.NewParentTask\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> assigned the task to <strong>{{log.Data.NewParentTask | auItemFilter : \'Task\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldParentTask && log.Data.NewParentTask\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> reassigned the task from {{log.Data.OldParentTask | auItemFilter: \'Task\'}} to <strong>{{log.Data.NewParentTask | auItemFilter: \'Task\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldParentTask && !log.Data.NewParentTask\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> unassigned the task from <strong>{{log.Data.OldParentTask | auItemFilter : \'Task\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n</div>");
$templateCache.put("/app/alignus/directives/au-activity-log/reassignedproject.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\"log-entry\">\n <div><md-icon md-font-icon=\"zmdi zmdi-folder\" class=\"margin-right-5 opacity-50\"></md-icon></div>\n <span ng-if=\"!log.Data.OldProject && log.Data.NewProject\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> assigned the task to <strong>{{log.Data.NewProject | auItemFilter : \'Project\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldProject && log.Data.NewProject\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> reassigned the task from {{log.Data.OldProject | auItemFilter: \'Project\'}} to <strong>{{log.Data.NewProject | auItemFilter: \'Project\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.OldProject && !log.Data.NewProject\" class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> unassigned the task from <strong>{{log.Data.OldProject | auItemFilter : \'Project\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n</div>\n\n\n");
$templateCache.put("/app/alignus/directives/au-activity-log/reassigneduser.tmpl.html","<!--I don\'t think this is used bc we post in the discussion board where the activity log is viewed-->\n<div layout=\"row\" layout-align=\"start center\" class=\"log-entry\">\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"!log.Data.ReassignedFrom && log.Data.ReassignedTo\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment\" class=\"opacity-50\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n <au-profile-image user=\"log.Data.ReassignedTo\" size=\"20\" style=\"margin: 0 10px 0 0;\"></au-profile-image>\n <span ng-if=\"!log.Data.ReassignedFrom && log.Data.ReassignedTo\" class=\"margin-right-2\">{{log.User | auItemFilter: \'User\'}} assigned the task to <strong>{{log.Data.ReassignedTo | auItemFilter: \'User\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.ReassignedFrom && log.Data.ReassignedTo\" class=\"margin-right-2\">{{log.User | auItemFilter: \'User\'}} reassigned the task from {{log.Data.ReassignedFrom | auItemFilter: \'User\'}} to <strong>{{log.Data.ReassignedTo | auItemFilter: \'User\'}}</strong> on {{log.Date | date: \'short\'}}</span>\n <span ng-if=\"log.Data.ReassignedFrom && !log.Data.ReassignedTo\" class=\"margin-right-2\">{{log.User | auItemFilter: \'User\'}} unassigned the task from {{log.Data.ReassignedFrom | auItemFilter: \'User\'}} on {{log.Date | date: \'short\'}}</span>\n </div>\n</div>\n");
$templateCache.put("/app/alignus/directives/au-activity-log/startstop.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div><md-icon md-font-icon=\"zmdi zmdi-timer\" class=\"margin-right-5 opacity-50\"></md-icon></div>\n <div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" layout-align-gt-sm=\"start center\" ng-if=\"log.Data.Duration\" flex>\n <span class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> started working on this task on {{log.Date | date: \'short\'}} and stopped after <strong>{{log.Data.Duration | durationFilter}}</strong> on {{log.Data.StoppedAt | date: \'short\'}}</span>\n </div>\n <div ng-if=\"log.Data.Duration == null\">\n <span class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> started working on this task on {{log.Date | date: \'short\'}}</span>\n </div>\n</div>\n");
$templateCache.put("/app/alignus/directives/au-activity-log/statechanged.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\'log-entry\'>\n <div><md-icon md-font-icon=\"zmdi zmdi-flash\" class=\"margin-right-5 margin-left-2 opacity-50\"></md-icon></div>\n <span class=\"margin-right-2\"><strong>{{log.User | auItemFilter: \'User\'}}</strong> changed the task state to <strong>{{log.Data.NewState}}</strong> on {{log.Date | date : \'short\'}}</span>\n</div>\n");
$templateCache.put("/app/alignus/directives/au-audit-trail/au-audit-trail.tmpl.html","<div>\n <table ng-if=\"vm.auditTrail.length > 0\" class=\"table table-header table-hover\">\n <tr>\n <th>Edited By User</th>\n <th>Date</th>\n </tr>\n <tr ng-repeat=\"trailItem in vm.auditTrail\">\n <td>{{trailItem.ByUser | auItemFilter: \'User\'}}</td>\n <td>{{trailItem.Date}}</td>\n </tr>\n </table>\n <!-- i don\'t think this should ever really happen -->\n <div ng-if=\"vm.auditTrail.length <= 0\">\n There are no audit trail records for this {{vm.item.$key}}\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-cke-document/au-cke-document.tmpl.html","<div class=\"clip-scrolled-content\"></div>\n<div class=\"au-cke-document-editor\"></div>\n<div class=\"au-cke-document-placeholder\">{{::placeholder}}</div>\n<div class=\"au-cke-document-disconnected\">\n <md-card style=\"position: relative; top: 40px;\">\n <img src=\"/assets/images/dialogs/error-banner.jpg\" class=\"md-card-image\" alt=\"image caption\">\n <md-card-content layout=\"column\" layout-align=\"center center\" style=\"background-color:#ff8f00; color:#fff; padding:20px;\">\n <span class=\"md-headline\">Holy guacamole!</span>\n <span class=\"md-body-1\">It looks like your connection is down. Editing is disabled.</span>\n </md-card-content>\n </md-card>\n</div>\n<div class=\"au-suggestions md-whiteframe-1dp border-top-color\" title=\"Type an underscore in place of a space to search with multiple words.\">\n <div layout=\"row\" class=\"item no-animate margin-0\" layout-align=\"start start\" ng-class=\"{\'selected\':$index == suggestIndex, \'header\': item.isSection, \'first\' : $first}\" ng-repeat=\"item in suggestItems track by $index\">\n <img ng-if=\"item.isSection && item.icon\" width=\"20\" height=\"20\" class=\"icon\" s3-src=\"/assets/images/avatars/{{item.icon}}\" />\n <span class=\"section\" ng-if=\"item.isSection\"><b>{{item.sectionTitle}}</b></span>\n <span class=\"tag\" ng-if=\"!item.isSection\" ng-bind-html=\"highlightSuggestion(item.SearchTitle)\" title=\"{{item.ModelName}}: {{item.SearchTitle}}\" ng-click=\"insertMention($index, item)\"></span>\n </div>\n</div>\n<div class=\"ng-hide\">\n <div class=\"au-cke-document-project-id\">{{::projectId}}</div>\n <div class=\"au-cke-document-meeting-id\">{{::meetingId}}</div>\n <div class=\"au-cke-document-document-id\">{{::documentId}}</div> \n</div>");
$templateCache.put("/app/alignus/directives/au-completion-percentage/au-completion-percentage.tmpl.html","<div ng-class=\"::{c100: true, p100: completionPercentage==\'100\', p75: completionPercentage==\'75\', p50: completionPercentage==\'50\', p25: completionPercentage==\'25\', green: completionPercentage==\'100\' || completionPercentage==\'75\', lightgreen: completionPercentage==\'50\', orange: completionPercentage==\'25\'}\" class=\"small clearfix margin-right-10\">\n <span ng-if=\"completionPercentage!=\'100\'\">\n {{::completionPercentage}}%\n </span>\n <span ng-if=\"::completionPercentage==\'100\'\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" style=\"color: #39B54A; font-size: 2em;\"></md-icon>\n </span>\n <div class=\"slice\">\n <div class=\"bar\"></div>\n <div class=\"fill\"></div>\n </div>\n </div>");
$templateCache.put("/app/alignus/directives/au-discussion-board/au-discussion-board.tmpl.html","<div>\n <!-- say something -->\n <au-inline-post page-id=\"vm.item._id\" post-type=\"\'Discussion\'\"></au-inline-post>\n\n <div au-post-feed page-id=\"vm.item._id\" watch-scroll=\"false\" feed-type=\"Discussion\" activity-log=\"vm.activityLog\" style=\"display: flex\"></div>\n\n <div style=\"clear: both;\" layout=\"row\" layout-align=\"center center\" ng-show=\"vm.showMorePostsButton\" class=\"ng-hide\">\n <md-button class=\"md-raised\" ng-click=\"vm.loadMorePosts()\" id=\"BtnLoadOlderPosts\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon><span class=\"margin-right-10\">LOAD MORE</span></md-button>\n </div>\n <p></p>\n</div>");
$templateCache.put("/app/alignus/directives/au-document-section/au-document-section.tmpl.html","<div class=\"au-document-section\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"toolbar\" ng-if=\"vm.showToolbar\">\n <md-menu>\n <md-button class=\"md-accent\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.item.Documents.length == 0\" id=\"BtnSortAttachedDocs\">\n <md-icon md-font-icon=\"zmdi zmdi-sort\"></md-icon> Sort &nbsp;\n </md-button>\n <md-menu-content>\n <md-menu-item ng-repeat=\"sortDescriptor in vm.sortableBy\">\n <md-button ng-click=\"vm.setSortBy($index)\">\n {{sortDescriptor.display}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <div flex></div>\n <div layout=\"row\" layout-align=\"end center\" ng-show=\"!vm.onlyListProxy()\">\n <md-button ng-disabled=\"!$root.user.EffPerms.Documents.CanCreate\" class=\"md-raised md-accent\" ng-click=\"vm.openAddDocumentDialog($event)\"\n id=\"BtnAddDocument\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>Add {{vm.buttonTerm}} &nbsp; </span>\n </md-button>\n <div au-file-uploader on-upload=\"vm.onDocumentsUploaded\" on-upload-fail=\"vm.onUploadFail\" on-select=\"vm.onDocumentsSelected\"\n ng-disabled=\"!$root.user.EffPerms.Files.CanCreate\" item=\"vm.item\">\n <md-button class=\"md-raised md-accent\" id=\"BtnUploadDocument\">\n <md-icon md-font-icon=\"zmdi zmdi-upload\">\n </md-icon>\n <span hide-xs hide-sm>Upload {{vm.buttonTerm}} &nbsp; </span>\n </md-button>\n </div>\n </div>\n </div>\n\n <div au-file-uploader on-upload=\"vm.onDocumentsUploaded\" on-upload-fail=\"vm.onUploadFail\" on-select=\"vm.onDocumentsSelected\"\n ng-disabled=\"!$root.user.EffPerms.Files.CanCreate\" class=\"drop-to-upload\" item=\"vm.item\">\n\n <!--Empty State / upload drag & drop area-->\n <div layout=\"column\" layout-align=\"center center\" class=\"empty-state ng-hide angular-animate\" ng-hide=\"vm.hideEmptyState()\">\n <span>\n <img src=\"/assets/images/empty-states/drop.png\" style=\"max-width: 200px\">\n </span>\n <span class=\"md-headline font-weight-300\">Drop it like it\'s hot!</span>\n <span class=\"md-caption\">Add files by selecting a button above or dropping them here!</span>\n </div>\n\n <md-list-item flex ng-click=\"vm.openDocument(document);$event.stopPropagation();\" ng-attr-id=\"StringDoc{{$index}}\" title=\"{{::document.Title}}\"\n layout=\"row\" layout-align=\"start center\" class=\"document\" ng-repeat=\"document in vm.documents | orderBy:vm.sortBy.fieldName\"\n ng-if=\"document.Subtype == vm.displaySubtype\">\n <div class=\"icons\">\n <img ng-if=\"::vm.hasImgExtension(document.Title)\" ng-src=\"{{$root.auUtility.getSignedS3ImgUrl(document.Id)}}\" class=\"img\" />\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'Document\'\" md-font-icon=\"au au-document md-accent\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.unknownExtension(document)\" md-font-icon=\"zmdi zmdi-file\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.csv\')\"\n md-font-icon=\"au au-view-report\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.docx\')\"\n md-font-icon=\"zmdi zmdi-file-text\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.rtf\')\"\n md-font-icon=\"zmdi zmdi-file-text\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.txt\')\"\n md-font-icon=\"zmdi zmdi-file-text\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.pdf\')\"\n md-font-icon=\"zmdi zmdi-collection-pdf\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.mov\')\"\n md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.mp4\')\"\n md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.mpeg\')\"\n md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.mp3\')\"\n md-font-icon=\"zmdi zmdi-audio\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.ppt\')\"\n md-font-icon=\"zmdi zmdi-slideshow\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.pps\')\"\n md-font-icon=\"zmdi zmdi-slideshow\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.key\')\"\n md-font-icon=\"zmdi zmdi-slideshow\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.css\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.html\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.htm\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.xhtml\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.php\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.js\')\"\n md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.psd\')\"\n md-font-icon=\"zmdi zmdi-layers\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.ai\')\"\n md-font-icon=\"zmdi zmdi-group\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.zip\')\"\n md-font-icon=\"zmdi zmdi-archive\"></md-icon>\n <md-icon ng-if=\"::!vm.hasImgExtension(document.Title) && document.Type == \'UserFile\' && vm.hasExtension(document, \'.rar\')\"\n md-font-icon=\"zmdi zmdi-archive\"></md-icon>\n </div>\n\n <div layout=\"column\" layout-align=\"center start\" class=\"details\" flex>\n <span class=\"text-ellipsis\">{{::vm.getTitleFromDocument(document)}}</span>\n <span class=\"creator md-caption\">\n <strong>{{document.CreatedBy | auItemFilter: \'User\'}}</strong>\n <span class=\"date-created md-caption margin-left-4\" ng-if=\"document.DateCreated\">Added on {{document.DateCreated | date : \"MM-dd-yyyy\' \'h:mma\"}}</span>\n </span>\n\n </div>\n\n <md-button ng-click=\"vm.confirmThenRemove($event, document)\" class=\"md-icon-button\" ng-attr-id=\"BtnRemoveDoc{{$index}}\" ng-show=\"!vm.onlyListProxy() && $root.user._id == document.CreatedBy\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" aria-label=\"delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n </md-list-item>\n\n <md-list-item layout=\"row\" layout-align=\"start center\" class=\"document\" ng-repeat=\"document in vm.uploadingQueue\">\n <div class=\"icons\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment\"></md-icon>\n </div>\n <div layout=\"column\" layout-align=\"center start\" class=\"details\" flex>\n <span class=\"text-ellipsis\">{{document.name}}</span>\n <md-progress-linear ng-disabled=\"document.$uploadFailed\" md-mode=\"indeterminate\"></md-progress-linear>\n </div>\n\n <span ng-if=\"!document.$uploadFailed\" class=\"uploading-message md-caption\">\n Uploading...\n </span>\n <span ng-if=\"document.$uploadFailed\" class=\"uploading-message md-caption failed\">\n Upload failed\n </span>\n </md-list-item>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-event-calendar/au-event-calendar.tmpl.html","<div layout=\"row\" layout-align=\"space-between start\" layout-xs=\"column\" flex layout-fill>\n <!--calendar-->\n <div ng-if=\"!showOnlyDetails\" ui-calendar=\"vm.calendarConfig\" class=\"calendar-widget padding-20\" ng-model=\"vm.events\" flex flex-xs=\"100\"></div>\n <!--events-->\n <div ng-if=\"!showOnlyCalendar\" layout=\"column\" layout-align=\"start start\">\n <div ng-if=\"vm.eventDetails.length == 0\" layout=\"column\" layout-align=\"center center\" style=\"padding:30px;\" >\n <div><img src=\"/assets/images/empty-states/calendar.png\" class=\"fadeup\"></div>\n <span class=\"md-headline font-weight-300\" style=\"text-align:center;\">It’s looking dusty here.</span>\n <span class=\"md-caption\" style=\"text-align:center;\">When you create, join, or follow an event, you’ll see it here. Get on it!</span>\n </div>\n <perfect-scrollbar ng-if=\"vm.eventDetails.length > 0\" style=\"width: 480px;\">\n <au-event-list-item ng-repeat=\"event in vm.eventDetails | orderBy: \'sortByMe\'\" event=\"event\" ng-attr-id=\"Event{{$index}}\"></au-event-list-item>\n </perfect-scrollbar>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-event-list-item/au-event-list-item.tmpl.html","<md-list class=\"padding-0\">\n <md-list-item layout=\"row\" ng-click=\"vm.openAssociatedItem($event, vm.event)\">\n <div layout=\"column\" layout-align=\"center start\" class=\"padding-10\" flex style=\"line-height: initial\">\n <span class=\"md-body-2 margin-bottom-10\" style=\"cursor:pointer;\">{{vm.event.title}}</span>\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-bottom-10\">\n <md-whiteframe class=\"md-whiteframe-2dp\" style=\"cursor:pointer;\">\n <!--show StartDate: Meetings, Event Pages-->\n <div class=\"social-event-date\" ng-if=\"vm.event.type == \'Meeting\' || vm.event.type == \'Event\'\">\n <span class=\"month\">{{vm.event.start | date : \'MMM\'}}</span>\n <span class=\"day\">{{vm.event.start | date : \'d\'}}</span>\n </div>\n <!--show EndDate: Tasks, Projects-->\n <div class=\"social-event-date\" ng-if=\"vm.event.type == \'Task\' || vm.event.type == \'Project\'\">\n <span class=\"month\">{{vm.event.end | date : \'MMM\'}}</span>\n <span class=\"day\">{{vm.event.end | date : \'d\'}}</span>\n </div>\n </md-whiteframe>\n\n <!--show StartDate: Meetings, Event Pages-->\n <div class=\"md-icon-float md-block margin-left-5\" ng-if=\"vm.event.type == \'Meeting\' || vm.event.type == \'Event\'\" style=\"width:320px;\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"opacity-30\"></md-icon>\n <span class=\"md-caption\">{{vm.event.start | date: \'EEEE\'}}</span>\n <br>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"opacity-30\"></md-icon>\n <span class=\"md-caption\">{{vm.event.start | date: \'h:mma\'}}</span>\n <!--TO DO: only show the span below if the the end time is different from start time -->\n <span class=\"md-caption margin-left-4\">&mdash; {{vm.event.end | date: \'h:mma\'}}</span>\n <br>\n <div layout=\"row\" layout-align=\"start start\" ng-if=\"event.location\" ng-show=\"event.location\">\n <div class=\"margin-right-4\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"opacity-30\"></md-icon>\n </div>\n <div ng-if=\"event.location\">\n <span ng-if=\"vm.event.type == \'Event\'\" class=\"md-caption\">{{vm.event.location | fullLocationFilter: \'full\'}}</span>\n <span ng-if=\"vm.event.type == \'Meeting\'\" class=\"md-caption\">{{vm.event.location}}</span>\n </div>\n </div>\n </div>\n\n <!--show EndDate: Tasks, Projects-->\n <div class=\"md-icon-float md-block margin-left-5\" ng-if=\"vm.event.end && (vm.event.type == \'Task\' || vm.event.type == \'Project\')\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"opacity-30\"></md-icon>\n <span class=\"md-caption\">{{vm.event.end | date: \'EEEE\'}}</span>\n <br>\n </div>\n\n </div>\n <!-- <span class=\"md-caption\" dynamic=\"event.subtitle\"></span> -->\n </div>\n </md-list-item>\n</md-list>");
$templateCache.put("/app/alignus/directives/au-file-uploader/au-file-uploader.html","<ng-transclude ng-model=\"vm.files\" ngf-select=\"vm.uploadFiles($files)\" ngf-multiple=\"true\" id=\"{{inputId}}\" ngf-drop=\"vm.uploadFiles($files)\"></ng-transclude>\n");
$templateCache.put("/app/alignus/directives/au-follow-star/au-follow-star.tmpl.html","<md-button ng-click=\"followClicked()\" aria-label=\"follow\" class=\"md-icon-button md-primary\" au-suspendable update-on-item=\"Page-{{page._id}}\">\n <md-icon ng-show=\"page.IsCurrentUserFollowing()\" md-font-icon=\"zmdi zmdi-star\" style=\"{{style}}\" id=\"FollowingStar\"></md-icon>\n <md-icon ng-show=\"!page.IsCurrentUserFollowing()\" md-font-icon=\"zmdi zmdi-star-outline\" style=\"{{style}}\" id=\"NotFollowingStar\"></md-icon>\n <md-tooltip>{{page.IsCurrentUserFollowing() ? \"Unfollow\" : \"Follow\"}}</md-tooltip>\n</md-button>");
$templateCache.put("/app/alignus/directives/au-help-icon/au-help-icon.tmpl.html","<md-button class=\"md-icon-button opacity-30 margin-0\" aria-label=\"Help for {{title}}\">\n <i class=\"zmdi zmdi-help\" style=\"font-size: 18px\"></i>\n <au-help-popup title=\"title\" description=\"description\" link=\"url\" action=\"action\" class=\"md-primary\"></au-help-popup>\n</md-button>");
$templateCache.put("/app/alignus/directives/au-help-popup/au-help-popup.tmpl.html","<div class=\"popup-container md-whiteframe-5dp\" layout=\"column\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n {{ title }}\n </div>\n </md-toolbar>\n <md-card-content class=\"md-padding\">\n {{ description }}\n </md-card-content>\n <md-card-actions layout=\"row\" layout-align=\"end center\">\n <md-button ng-if=\"!hideLink\" ng-href=\"{{link}}\" target=\"_blank\" class=\"md-primary\">{{ action }}</md-button>\n </md-card-actions>\n</div>");
$templateCache.put("/app/alignus/directives/au-image-uploader/au-image-uploader.tmpl.html","<div ng-mouseenter=\"vm.showUpdatePhoto = true\" ng-mouseleave=\"vm.showUpdatePhoto = false\" layout=\"column\" layout-align=\"center center\" style=\"height: 100%; width: 100%;\">\n <au-profile-image item=\"vm.item\" size=\"vm.size\" class=\"margin-0\">\n </au-profile-image>\n <div ng-if=\"vm.uploading\" class=\"uploading\" layout=\"row\" layout-align=\"center center\">\n <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n </div>\n <div ng-if=\"vm.allowUpdate && vm.showUpdatePhoto\" layout=\"column\" class=\"update\">\n <md-button class=\"md-fab md-mini\" ng-click=\"vm.openUploadPhoto()\">\n <md-icon md-font-icon=\"zmdi zmdi-camera\"></md-icon>\n <md-tooltip>Update Photo</md-tooltip>\n </md-button>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-inline-post/au-inline-post.tmpl.html","<div layout=\"row\" class=\"inlineNewPost\" id=\"BtnNewPost\" ng-class=\"{\'mini\':!startBig}\">\n <au-profile-image user=\"$root.user\"></au-profile-image>\n\n <div class=\"chat-pointer\"></div>\n <div flex class=\"editor\" layout=\"column\">\n <div layout=\"row\" class=\"cover-photo ng-hide\" ng-show=\"vm.showCoverPhoto\" au-cover-photo item=\'vm.newPost\'></div>\n\n <div layout=\"{{(vm.elWidth > 700 ? \'row\' : \'column\')}}\">\n <div class=\"au-cke-document no-animate ng-hide\" ng-hide=\"vm.newPost.Type == \'Poll\'\" ng-model=\"vm.newPost.Data.Update\" placeholder=\"Say something!\" resize-trigger=\"vm.resizeEditorTrigger\" process-content=\"vm.processContent\" flex=\"vm.tagged.length > 0 || vm.documents.length > 0 ? 100 : 75\" on-key-press=\"onKeyPress\"\n on-enter=\"vm.ctrlEnter\" grow=\"grow\" auto-focus=\"autoFocus\"></div>\n\n <div layout=\"column\" class=\"poll no-animate padding-20 ng-hide\" ng-show=\"vm.newPost.Type == \'Poll\'\" flex=\"75\">\n <md-input-container>\n <label>Ask a question</label>\n <textarea ng-model=\"vm.newPost.Data.Poll.Question\" required id=\"TxtQuestion\" md-auto-focus md-detect-hidden></textarea>\n </md-input-container>\n\n <p class=\"md-body-1\" ng-if=\"vm.newPost.Data.Poll.PossibleResponses.length == 0\">\n <span layout=\"row\" layout-align=\"center center\">Click the button below to add some response choices.</span>\n </p>\n\n <div class=\"grow\" ng-repeat=\"response in vm.newPost.Data.Poll.PossibleResponses\" ng-if=\"vm.newPost.Data.Poll.PossibleResponses.length > 0\">\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <md-button class=\"md-icon-button icon-button-input-margin md-icon-float md-block\" aria-label=\"Delete additional choices\" ng-click=\"vm.newPost.Data.Poll.PossibleResponses.splice($index, 1)\" ng-attr-id=\"BtnDeleteResponse{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n </md-button>\n\n <md-input-container md-no-float flex>\n <input type=\"text\" placeholder=\"Choice\" ng-model=\"response.Response\" ng-attr-id=\"TxtResponse{{$index}}\" />\n </md-input-container>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-bottom-20\">\n <md-button class=\"md-raised\" ng-click=\"vm.newPost.Data.Poll.PossibleResponses.push({Response: \'\', ResponseCount: 0})\" id=\"BtnAddResponse\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon><span>ADD CHOICE</span></md-button>\n </div>\n </div>\n\n <div flex=\"25\" ng-if=\"vm.newPost.Type == \'Poll\' || vm.newPost.Tagged.length > 0 || vm.newPost.Documents.length > 0 || vm.uploadingQueue.length > 0\" layout=\"column\" class=\"attached\">\n <div ng-if=\"vm.newPost.Type == \'Poll\'\">\n <div layout=\"row\" layout-align=\"center center\" class=\"header\">\n Poll Closing Date\n </div>\n <p class=\"md-caption\">Optionally, enter the date and time this poll should close.</p>\n\n <div layout=\"column\">\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" hide show-gt-sm class=\"poll-date-icon\"></md-icon>\n <mdp-date-picker mdp-open-on-click required name=\"date\" mdp-format=\"M/D/YYYY\" mdp-placeholder=\"Poll end date\" ng-model=\"vm.newPost.Data.Poll.End\" mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" id=\"TxtPollEndDate\">\n </mdp-date-picker>\n </div>\n\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm class=\"poll-date-icon\"></md-icon>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" required ng-model=\"vm.newPost.Data.Poll.End\" mdp-placeholder=\"Poll end time\" class=\"md-icon-float md-block\" id=\"TxtPollEndTime\">\n </mdp-time-picker>\n </div>\n </div>\n </div>\n\n\n <div ng-if=\"vm.newPost.Tagged.length > 0\" class=\"tagged-users\">\n <div layout=\"row\" layout-align=\"center center\" class=\"header\">\n Tagged Users\n </div>\n <div layout=\"row\" layout-align=\"start center\" ng-repeat=\"user in vm.newPost.Tagged\" class=\"user\" ng-attr-id=\"StringTaggedUser{{::$index}}\">\n <au-profile-image user=\"user\" size=\"25\"></au-profile-image>\n <span class=\"text-ellipsis\" flex>{{user | auItemFilter: \'User\'}}</span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeTaggedUser($index)\" ng-attr-id=\"BtnRemove{{::$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove</md-tooltip>\n </md-button>\n </div>\n </div>\n <div ng-if=\"vm.newPost.Documents.length > 0 || vm.uploadingQueue.length > 0\">\n <div layout=\"row\" layout-align=\"center center\" class=\"header\">\n Attachments\n </div>\n <au-document-section item=\"vm.newPost\" uploading-queue=\"vm.uploadingQueue\" show-toolbar=\"false\" class=\"mini\"></au-document-section>\n </div>\n </div>\n </div>\n\n <div class=\"actions\">\n <div layout=\"{{(vm.elWidth > 700 ? \'row\' : \'column\')}}\" layout-align=\"start center\">\n <div class=\"padding-left-10\" layout=\"row\">\n <md-button ng-click=\"vm.changePostType()\" aria-label=\"change-post\" class=\"md-icon-button\" id=\"BtnChangePost\" layout-fill layout-align=\"start center\" md-no-ink>\n <md-icon md-font-icon=\"zmdi zmdi-comment-outline\" ng-if=\"vm.newPost.Type == \'Poll\'\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-chart\" ng-if=\"vm.newPost.Type != \'Poll\'\"></md-icon>\n <md-tooltip>Change Post Type</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button\" ng-click=\"vm.toggleCoverPhoto()\" id=\"BtnCoverPhoto\">\n <md-icon md-font-icon=\"zmdi zmdi-image-alt\"></md-icon>\n <md-tooltip>Cover Photo</md-tooltip>\n </md-button>\n\n <span au-file-uploader on-upload=\"vm.onDocumentsUploaded\" on-upload-fail=\"vm.onUploadFail\" on-select=\"vm.onDocumentsSelected\">\n <md-button class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment-alt\"></md-icon><md-tooltip>Attach File</md-tooltip></md-button>\n </span>\n\n <md-button class=\"md-icon-button\" ng-click=\"vm.openTagUsers($event)\" id=\"BtnTagUsers\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\"></md-icon>\n <md-tooltip>Tag User(s)</md-tooltip>\n </md-button>\n\n <md-button ng-hide=\"vm.options.fullscreen\" class=\"md-icon-button\" ng-click=\"vm.goFullScreen($event)\" id=\"BtnFullScreen\">\n <md-icon md-font-icon=\"zmdi zmdi-fullscreen\"></md-icon>\n <md-tooltip>Full Screen</md-tooltip>\n </md-button>\n </div>\n <span flex></span>\n <span ng-if=\"!vm.newPost._id && !vm.options.fullscreen\" layout=\"row\" layout-align=\"end center\" class=\"margin-15\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancelPost($event)\" id=\"BtnCancelPost\"> Cancel\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.addPost($event)\" id=\"BtnSubmitPost\"> {{postLabel}}\n <md-tooltip direction=\"up\">\n CTRL + Enter\n </md-tooltip>\n </md-button>\n </span>\n\n <span ng-if=\"vm.newPost._id && !vm.options.fullscreen\" layout=\"row\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancelEdit($event)\" id=\"BtnCancelEdit\"> Cancel\n </md-button>\n <md-button class=\"md-raised\" ng-click=\"vm.savePost($event)\" id=\"BtnSavePost\"> Save\n </md-button>\n </span>\n\n <span ng-if=\"vm.options.fullscreen\" layout=\"row\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancelEdit($event)\" id=\"BtnCancelEdit\"> Cancel\n </md-button>\n <md-button class=\"md-raised\" ng-click=\"vm.exitFullscreen($event)\" id=\"BtnExitFullscreen\"> Exit Fullscreen\n </md-button>\n </span>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-item-buttons/au-item-buttons.tmpl.html","<div class=\"au-item-buttons\" ng-click=\"$event.stopPropagation()\" layout=\"row\">\n <div layout=\"row\" ng-repeat=\"button in vm.itemType.itemSettings.itemButtons\">\n <div ng-if=\"button.dynamic && $root.auUtility.hasPermission(button.permissionNeeded, vm.item)\" dynamic=\"::button.dynamic\"></div>\n <div ng-if=\"button.icon && $root.auUtility.hasPermission(button.permissionNeeded, vm.item)\">\n <md-button ng-click=\"button.action(item, $event)\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"{{button.icon}}\"></md-icon>\n <md-tooltip>{{button.tooltip}}</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <!-- Request update -->\n <div>\n <md-button ng-if=\"vm.itemSchema.hasDiscussionBoard\" ng-click=\"vm.requestUpdate($event)\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-info-outline\"></md-icon>\n <md-tooltip>Request Update</md-tooltip>\n </md-button>\n </div>\n\n <!-- Create/remove template -->\n <span ng-if=\"vm.itemSchema.supportsCopy && vm.item.userHasPermission(\'C\')\" layout=\"row\">\n <md-button class=\"md-icon-button\" ng-click=\"vm.createCopy($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-copy\"></md-icon>\n <md-tooltip>Create Copy</md-tooltip>\n </md-button>\n\n <div>\n <md-button class=\"md-icon-button\" ng-click=\"vm.toggleTemplate($event)\">\n <md-icon ng-if=\"!vm.item.IsTemplate\" md-font-icon=\"zmdi zmdi-lock-open\"></md-icon>\n <md-icon ng-if=\"vm.item.IsTemplate\" md-font-icon=\"zmdi zmdi-lock\"></md-icon>\n <md-tooltip>{{ vm.item.IsTemplate ? \'Unlock and Remove from Templates\' : \'Lock and Convert to Template\' }}</md-tooltip>\n </md-button>\n </div>\n\n <!-- Edit Template -->\n <div>\n <md-button ng-if=\"vm.item.IsTemplate\" class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\', \'?unlocktemplate=true\');\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <md-tooltip>Edit Template</md-tooltip>\n </md-button>\n </div>\n </span>\n\n <!-- Delete -->\n <div>\n <md-button ng-if=\"vm.item.userHasPermission(\'D\')\" ng-click=\"vm.item.DeleteMe()\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Delete {{vm.item.$key}}</md-tooltip>\n </md-button>\n </div>\n\n <!-- Copy Share -->\n <div ng-if=\"!vm.item.IsPrivate\" class=\"hover-container\" layout=\"column\">\n <md-button ng-click=\"vm.showShareDialog($event)\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-share\"></md-icon>\n <md-tooltip>Share {{vm.item.$key}}</md-tooltip>\n </md-button>\n <div ng-click=\"$root.auUtility.copyMention($event)\" layout=\"column\" layout-align=\"center center\" class=\"share-hover show-on-hover-container\">\n <span class=\"copy-tooltip\">\n {{$root.auUtility.copyMentionTooltipText}}\n </span>\n <span class=\"copy-mention\">\n <span>&nbsp;</span>\n <span contenteditable=\"false\" class=\"doc-mention\" ng-class=\"vm.item.$key\" data-item-type=\"{{vm.item.$key}}\" data-item-id=\"{{vm.item._id}}\"\n data-cke-filter=\"off\" title=\"{{vm.item.$key}}: {{vm.item.toString()}}\">{{vm.item.toString()}}</span>\n <span>&nbsp;</span>\n </span>\n </div>\n </div>\n\n <!-- Open in new tab -->\n <div>\n <md-button class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\'); vm.item.close()\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n\n <!-- Share in video call -->\n <div>\n <au-share-in-video-button ng-if=\"$root.getUiActiveVideoCall()\" item=\"vm.item\"></au-share-in-video-button>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-item-card/au-item-card.tmpl.html","<md-card class=\"item-card md-default-theme border-top-color-contrast\" ng-class=\"{\'currently-selected\': item.$selected}\" ng-click=\"vm.cardClicked($event, item)\"\n ng-dblclick=\"item.open()\" ng-attr-id=\"Card{{$index}}\">\n <div au-suspendable update-on-item=\"{{item.$key}}-{{item._id}}\" layout=\"column\" layout-align=\"start center\" layout-fill>\n <md-toolbar au-cover-photo allow-update=\"$root.false\" item=\"item\" class=\"md-default-theme background-color-500\" layout=\"column\"\n layout-align=\"center center\">\n <au-profile-image item=\"item\" size=\"70\" class=\"overhang margin-right-0\"></au-profile-image>\n </md-toolbar>\n\n <md-card-title-text flex=\"100\" layout=\"column\" layout-align=\"start center\">\n <div class=\"md-headline\" ng-click=\"item.open()\" layout=\"column\" layout-align=\"center center\">{{item.toString() | limitTo : 60}}</div>\n <div layout=\"column\" layout-align=\"start center\" flex>\n <div>\n <div class=\"item-subhead\" ng-repeat=\"subhead in vm.item.getSubHeads() | limitTo : 4\" dynamic=\"subhead\" layout=\"row\" layout-align=\"center center\" flex></div>\n </div>\n </div>\n </md-card-title-text>\n\n <div class=\"card-actions\" layout=\"row\" layout=\"center center\">\n <au-item-buttons item=\"item\" class=\"text-ellipsis\"></au-item-buttons>\n </div>\n </div>\n</md-card>");
$templateCache.put("/app/alignus/directives/au-item-detail-header-card/au-item-detail-header-card.tmpl.html","<div class=\"au-item-detail-header-card\">\n <!--cover photo and profile image-->\n <au-cover-photo item=\"vm.item\" class=\"coverhead\" layout=\"row\" layout-align=\"start center\" allow-update=\"vm.item.userHasPermission(\'U\')\">\n <au-image-uploader class=\"overhang margin-right-0 margin-left-30\" item=\"vm.item\" style=\"height: 100px; width: 100px\" id=\"BtnProfilePicture\"></au-image-uploader>\n </au-cover-photo>\n\n <!--buttons-->\n <au-item-buttons item=\"item\"></au-item-buttons>\n\n <!--title and subtitles-->\n <div layout=\"row\" layout-align=\"space-between start\">\n <div layout=\"column\" class=\"margin-left-30 margin-bottom-30 margin-top-10\" layout-fill>\n <div class=\"hover-container margin-right-10 margin-bottom-10 title-row text-ellipsis\" ng-click=\"$event.stopPropagation()\">\n <div ng-if=\"vm.editingTitle\" layout=\"row\" layout-align=\"start center\">\n <input class=\"font-size-3 font-weight-300\" ng-model=\"vm.editTitle\" ng-change=\"vm.titleEdited()\">\n <md-button class=\"md-icon-button show-on-hover-container\" ng-click=\"vm.editingTitle = false\" ng-if=\"vm.allowTitleEdit\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n <md-tooltip>Done</md-tooltip>\n </md-button>\n </div>\n <div ng-if=\"!vm.editingTitle\" layout=\"row\" layout-align=\"start center\">\n <span class=\"font-size-3 font-weight-300\">{{vm.item.toString()}}</span>\n <md-button class=\"md-icon-button show-on-hover-container\" ng-click=\"vm.enterEditMode()\" ng-if=\"vm.allowTitleEdit && vm.item.userHasPermission(\'U\') && !$root.user.$AnonymousUser\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <md-tooltip>Edit {{titleField}}</md-tooltip>\n </md-button>\n </div>\n\n\n </div>\n\n <ng-transclude></ng-transclude>\n\n <div layout=\"row\" layout-wrap layout-fill class=\"limit-subhead-height\">\n <div class=\"item-subhead text-ellipsis\" ng-repeat=\"subhead in vm.item.getSubHeads() | limitTo: 9\" dynamic=\"subhead\" flex=\"50\"\n flex-gt-sm=\"33\" flex-gt-lg=\"25\"></div>\n </div>\n\n </div>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/directives/au-item-ownedby/au-item-ownedby.tmpl.html","<div class=\"au-item-ownedby\" au-can-edit=\"item\" acl=\"\'U\'\">\n\n <table class=\"table table-header table-hover table-noborder\">\n <!--header-->\n <tr>\n <th class=\"left-margin-spacer\"></th>\n <th class=\"padding-top-10\" style=\"min-width: 200px\">Owner</th>\n <th width=\"80%\" class=\"padding-top-10\">Responsibility/Notes</th>\n <th class=\"padding-top-5 padding-right-10\"></th>\n </tr>\n\n <tr ng-repeat=\"owner in vm.item.OwnedBy\">\n <td class=\"left-margin-spacer\"></td>\n <td style=\"white-space: nowrap; vertical-align: middle;\">\n <span layout=\"row\" layout-align=\"start center\" style=\"margin-right: 40px\">\n <au-profile-image item-type=\"{{owner.Type}}\" item=\"owner.DocId\" class=\"margin-right-20\"></au-profile-image>\n <a ng-click=\"vm.openOwner(owner)\">{{owner.DocId | auItemFilter: owner.Type}}\n <md-tooltip>\n View Profile\n </md-tooltip>\n </a>\n </span>\n </td>\n <td width=\"80%\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0\">\n <textarea ng-model=\"owner.Note\" class=\"full-width\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: top; padding-top: 20px; text-align: center;\">\n <span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeOwner(owner, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove as Owner</md-tooltip>\n </md-button>\n </span>\n </td>\n </tr>\n\n <tr>\n <td class=\"left-margin-spacer\"></td>\n <td>\n <md-autocomplete flex class=\"margin-right-20\" md-search-text=\"vm.newOwnerSearchText\" md-items=\"item in $root.auUtility.searchUsersAndTeams(vm.newOwnerSearchText, false, true, true, true)\"\n placeholder=\"Add Owner\" md-select-on-match=\"true\" md-autoselect=\"true\" md-selected-item=\"vm.newOwner\" md-item-text=\"item.$Display\"\n md-require-match=\"false\" title=\"A responsible user, department, team or location.\">\n <span md-highlight-text=\"vm.newOwnerSearchText\" md-highlight-flags=\"i\">\n {{item.$Display}}\n </span>\n\n </md-autocomplete>\n\n </td>\n <td width=\"80%\" style=\"vertical-align: middle\">\n <md-input-container class=\"margin-0 padding-0\">\n <textarea ng-model=\"vm.newOwnerNote\" class=\"full-width\" />\n </md-input-container>\n </td>\n <td style=\"vertical-align: middle; text-align: center;\">\n <span>\n <md-button class=\"md-raised md-accent margin-0\" ng-click=\"vm.addOwner($event)\" ng-disabled=\"!vm.newOwner\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>&nbsp;Add&nbsp; </span>\n </md-button>\n </span>\n </td>\n </tr>\n </table>\n <!-- end columns -->\n</div>");
$templateCache.put("/app/alignus/directives/au-item-security-and-sharing/au-item-security-and-sharing.tmpl.html","<div class=\"au-item-security-and-sharing\">\n\n <!--Active/Inactive switch-->\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-power\" class=\"margin-right-15\"></md-icon>\n <span flex>Set this {{vm.item.$key}} as Active or Inactive:\n <au-help-icon key=\"Project.Active\"></au-help-icon>\n </span>\n <span class=\"margin-right-10\">{{ vm.item.IsActive ? vm.item.$key + \' is Active\' : vm.item.$key + \' is Inactive\' }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Active Switch\" ng-model=\"vm.item.IsActive\" id=\"SwitchActive\"></md-switch>\n </div>\n\n <!--Privacy switch-->\n <div class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" class=\"margin-right-15\"></md-icon>\n <span>Searchable within {{$root.Organization.Name}}:</span>\n <au-help-icon key=\"Project.Privacy\"></au-help-icon>\n <span flex></span>\n <span class=\"margin-right-10\">{{ vm.item.IsPrivate ? \'Private to Listed Users Only\' : \'Visible to All Users\' }}\n </span>\n <md-switch class=\"md-primary\" aria-label=\"Privacy Switch\" ng-model=\"vm.item.IsPrivate\" md-invert></md-switch>\n </div>\n\n <!-- Copy Mention -->\n <div ng-show=\"!vm.item.IsPrivate\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-link\" class=\"margin-right-15\"></md-icon>\n <span>Copy a Mention to this {{vm.item.$key}}:</span>\n <au-help-icon key=\"Project.Privacy\"></au-help-icon>\n <span flex></span>\n <div ng-click=\"$root.auUtility.copyMention($event)\" layout=\"row\" layout-align=\"start center\">\n <span class=\"copy-mention\">\n <span>&nbsp;</span>\n <span contenteditable=\"false\" class=\"doc-mention\" ng-class=\"vm.item.$key\" data-item-type=\"{{vm.item.$key}}\" data-item-id=\"{{vm.item._id}}\"\n data-cke-filter=\"off\" title=\"{{vm.item.$key}}: {{vm.item.toString()}}\">{{vm.item.toString()}}</span>\n <span>&nbsp;</span>\n </span>\n <md-tooltip md-direction=\"left\">{{$root.auUtility.copyMentionTooltipText}}</md-tooltip>\n </div>\n </div>\n\n <!--Editors-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-15\"></md-icon>\n <div>Editors:</div>\n <au-help-icon key=\"Document.Editors\"></au-help-icon>\n <md-input-container flex class=\"margin-0\" md-no-float flex>\n <md-chips ng-model=\"vm.item.Editors\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.Editors, $chip); $root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.item.Editors}) \"\n flex id=\"ChipDocEditor\">\n <md-autocomplete md-search-text=\"vm.editorsSearchText\" md-items=\"editor in $root.auUtility.searchUsers({query:vm.editorsSearchText, excludeContacts: true, showAdd: true})\"\n placeholder=\"Add an Editor\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtDocEditor\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.editorsSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoDocEditor{{$index}}\">{{editor | auItemFilter: \'User\'}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipDocEditor{{$index}}\">{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n\n <!--Shared With Users-->\n <div ng-show=\"vm.item.IsPrivate\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-15\"></md-icon>\n <div>Read Access:</div>\n <au-help-icon key=\"SharedWith.Description\"></au-help-icon>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container flex class=\"margin-0\" md-no-float>\n <md-chips ng-model=\"vm.item.SharedWith\" md-require-match=\"true\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.item.SharedWith, $chip);$root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.item.SharedWith})\"\n flex id=\"ChipProjectSharedWith\">\n <md-autocomplete md-search-text=\"vm.sharedWithSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.sharedWithSearchText, showAdd: true})\"\n placeholder=\"Add a User\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtProjectSharedWith\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoProjectSharedWith{{$index}}\">{{user | fullNameFilter}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipProjectSharedWith{{$index}}\">{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </div>\n </div>\n\n <!--Anonymous Read-->\n <div ng-show=\"!vm.item.IsPrivate\" class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-globe-lock\" class=\"margin-right-15\"></md-icon>\n <span>Public Link Sharing </span>\n <au-help-icon key=\"Project.Privacy\"></au-help-icon>\n <span flex></span>\n <span class=\"margin-right-10\">{{ vm.item.IsAnonymousReadAllowed ? \'Link Sharing Enabled\' : \'Link Sharing Disabled\' }}\n </span>\n <md-switch class=\"md-primary\" aria-label=\"Anonymous Access\" ng-model=\"vm.item.IsAnonymousReadAllowed\" id=\"SwitchAnonymousRead\"></md-switch>\n </div>\n <!--Anonymous Write-->\n <div ng-show=\"vm.item.IsAnonymousReadAllowed\" class=\"md-icon-float md-block\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-eye margin-right-14\" style=\"color:rgba(0,0,0,0.87);\"></md-icon>\n <span flex>{{vm.item.$key}} is Publicly Editable - no signin required.\n <au-help-icon key=\"Project.Privacy\"></au-help-icon>\n </span>\n <span class=\"margin-right-10\">{{ vm.item.IsAnonymousWriteAllowed ? \'Public Link is Editable\' : \'Public Link is Read-Only\' }}</span>\n <md-switch class=\"md-primary\" aria-label=\"Anonymous Write Access\" ng-model=\"vm.item.IsAnonymousWriteAllowed\" id=\"SwitchAnonymousWrite\"></md-switch>\n </div>\n\n <!-- Custom URL -->\n <div ng-show=\"vm.item.IsAnonymousReadAllowed\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-cloud\" class=\"margin-right-15\"></md-icon>\n <div flex>Specify a custom url:\n <au-help-icon key=\"CustomUrl.Description\"></au-help-icon>\n </div>\n <md-input-container class=\"margin-0\">\n <input type=\"input\" value=\"\" placeholder=\"custom-link-here\" ng-keydown=\"vm.customUrlKeyPress($event)\" ng-change=\"vm.ensureValidCustomUrl()\" flex class=\"link-sharing-url\" onclick=\"this.select()\" ng-model=\"vm.item.CustomUrl\" />\n\n </md-input-container>\n </div>\n\n <!-- Anonymous Link -->\n <div ng-show=\"!vm.item.IsPrivate && vm.item.IsAnonymousReadAllowed\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-link\" class=\"margin-right-15\"></md-icon>\n <div flex class=\"font-color-600\">Anyone with the link can {{vm.item.IsAnonymousWriteAllowed ? \'edit content\' : \'view but not edit\'}}.\n <span style=\"white-space: nowrap\">- No sign in required.</span>\n </div>\n <input type=\"input\" value=\"{{$root.$location.absUrl().split(\'/\').splice(0,3).join(\'/\')}}/{{vm.item.CustomUrl.trim().length ? vm.item.CustomUrl.toLowerCase() : vm.item.$key.toLowerCase() + \'/\' + vm.item._id}}\"\n flex class=\"link-sharing-url\" readonly onclick=\"this.select()\" />\n </div>\n\n</div>");
$templateCache.put("/app/alignus/directives/au-meeting-list/au-meeting-list.tmpl.html","<div class=\"au-meeting-list\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"toolbar\">\n <md-menu>\n <md-button class=\"md-accent\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.item.MeetingList.length == 0\" id=\"BtnSortMeetingList\">\n <md-icon md-font-icon=\"zmdi zmdi-sort\"></md-icon> Sort &nbsp;\n </md-button>\n <md-menu-content>\n <md-menu-item ng-repeat=\"sortDescriptor in vm.sortableBy\">\n <md-button ng-click=\"vm.setSortBy($index)\">\n {{sortDescriptor.display}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <div flex></div>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.openAddMeetingDialog($event)\" id=\"BtnAddMeeting\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon><span hide-xs hide-sm>&nbsp;New Meeting &nbsp; </span>\n </md-button>\n </div>\n </div>\n \n <!-- Empty state -->\n <div ng-if=\"vm.meetingList.length == 0\" class=\"margin-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/meeting.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No Meetings</h1>\n <span class=\"md-body-1 opacity-50\">This item does not have any past or future meetings.</span>\n <span class=\"md-body-1 opacity-50\">Start by selecting the New Meeting button!</span>\n </div>\n\n <!--Meeting list table-->\n <div ng-if=\"vm.meetingList.length > 0\" class=\"margin-bottom-50 padding-20\">\n <div layout=\"row\" layout-align=\"start center\" class=\"md-caption md-default-theme background-color-700\" style=\"color:white; text-align:left;\">\n <div flex=\"30\" class=\"margin-10\">Meeting Title</div>\n <div flex=\"30\" class=\"margin-10\">Attendees</div>\n <div flex=\"30\" class=\"margin-10\">Created By</div>\n <div flex=\"20\" class=\"margin-10\">Meeting Date</div>\n </div>\n <div flex ng-repeat=\"meeting in vm.meetingList track by meeting._id\" ng-click=\"meeting.open()\" class=\"usercard-button\" layout=\"row\" laout-align=\"start center\" style=\"border-bottom:solid thin #f1f1f1;\">\n <!--Title-->\n <div layout-fill flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"margin-10 md-body-2\" ng-attr-id=\"BtnMeetingTitle{{$index}}\">\n {{meeting.Title}}\n </div>\n <!--Attendees-->\n <div layout-fill flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"margin-10\" layout-wrap>\n <au-profile-image user=\"attendee.User\" size=\"20\" class=\"margin-right-8 grow\" ng-repeat=\"attendee in meeting.Attendees track by $root.protectedId(attendee)\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n <!--Created By-->\n <div flex=\"30\" class=\"margin-10\" layout=\"row\" layout-align=\"start center\">\n <au-profile-image size=\"20\" user=\"meeting.Creator\" ng-attr-id=\"ImgMeetingCreator{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-body-1\" ng-attr-id=\"StringMeetingCreator{{$index}}\">{{meeting.Creator | fullNameFilter}}</span>\n </div>\n <!--Meeting Date-->\n <div flex=\"20\" class=\"margin-10 md-body-1\" ng-attr-id=\"StringMeetingDate{{$index}}\">{{meeting.StartDate | date : \'short\'}}</div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-my-tasks/au-my-tasks.tmpl.html","<md-card class=\"padding-20 au-my-tasks\">\n <div class=\"md-headline margin-bottom-10\">My Tasks</div>\n\n <!-- Add new task -->\n <div layout=\"row\" layout-align=\"start center\" class=\"add-task\" ng-class=\"{focused: addFocused}\">\n <div>\n <md-menu class=\"padding-0\">\n <md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"change-post\" class=\"padding-0 margin-0\" id=\"BtnChangeTaskType\">\n <i class=\"change-type-icon\" ng-class=\"vm.newTaskTypeIcon\"></i>\n <!-- <md-icon ng-class=\"{{vm.newTaskTypeIcon}}\"></md-icon> -->\n <md-tooltip>Change entry to a to-do, reminder, journal entry or note.</md-tooltip>\n </md-button>\n <md-menu-content>\n <md-menu-item>\n <md-button ng-click=\"vm.changeTaskType(\'ToDo\')\">\n <md-icon md-font-icon=\"zmdi zmdi-square-o\"></md-icon> To-Do\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.changeTaskType(\'Reminder\')\">\n <md-icon md-font-icon=\"zmdi zmdi-alarm-plus\"></md-icon> Reminder\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.changeTaskType(\'Journal\')\">\n <md-icon md-font-icon=\"zmdi zmdi-book\"></md-icon> Journal Entry\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.changeTaskType(\'Note\')\">\n <md-icon md-font-icon=\"zmdi zmdi-file-text\"></md-icon> Note\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.showLearnMore()\">\n <md-icon md-font-icon=\"zmdi zmdi-help\"></md-icon> Learn More\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n <textarea type=\"text\" ng-model=\"vm.newTaskTitle\" placeholder=\"{{vm.newTitlePlaceholder}}\" ng-enter-key=\"vm.addTask($event)\"\n class=\"transparent-input\" ng-focus=\"addFocused = true\" ng-blur=\"addFocused = false\" au-grow-textarea rows=\"1\"></textarea>\n </div>\n\n <!-- In Progress -->\n <div ng-mouseenter=\"inProgressHovered = true\" ng-mouseleave=\"inProgressHovered = false\">\n <!-- Header -->\n <div layout=\"row\" class=\"margin-top-20\" layout-align=\"start center\" layout-fill>\n <div class=\"md-subhead\" ng-class=\"{hovered: inProgressHovered}\">In Progress</div>\n <div class=\"section-divider\" flex></div>\n <div class=\"column-header md-caption\" ng-class=\"{hovered: inProgressHovered}\" flex>Actual vs. Estimated Hours</div>\n </div>\n\n\n\n <!-- Task list, the sortable container -->\n <div as-sortable=\"vm.dragControlListeners\" data-ng-model=\"vm.myTaskTracker.myInProgressTasks\" class=\"list\">\n\n <!-- Empty state -->\n <div ng-if=\"vm.myTaskTracker.myInProgressTasks.length == 0\" >\n Nothing in progress\n </div>\n\n <!-- The task row, the sortable item (must stay separate from item-handle-->\n <div ng-repeat=\"task in vm.myTaskTracker.myInProgressTasks track by task._id\" as-sortable-item ng-dblclick=\"task.open()\">\n\n <!-- Make the whole row the handle -->\n <div as-sortable-item-handle style=\"cursor: ns-resize\">\n <au-task-row task=\"task\"></au-task-row>\n </div>\n </div>\n </div>\n </div>\n\n\n <!-- To Do(ne) List -->\n <div ng-mouseenter=\"toDoneHovered = true\" ng-mouseleave=\"toDoneHovered = false\">\n <!-- Header -->\n <div layout=\"row\" class=\"margin-top-20\" layout-align=\"start center\">\n <div class=\"md-subhead\" ng-class=\"{hovered: toDoneHovered}\">To Do(ne) List</div>\n <div class=\"section-divider\" flex></div>\n <div class=\"column-header md-caption\" ng-class=\"{hovered: toDoneHovered}\" flex>Actual vs. Estimated Hours</div>\n </div>\n\n <!-- Task list, the sortable container -->\n <div as-sortable=\"vm.dragControlListeners\" data-ng-model=\"vm.myTaskTracker.myToDoneTasks\" class=\"list\">\n\n <!-- Empty state -->\n <div ng-if=\"vm.myTaskTracker.myToDoneTasks.length == 0\">\n Nothing in the hopper...\n </div>\n\n <!-- The task row, the sortable item (must stay separate from item-handle-->\n <div ng-repeat=\"task in vm.myTaskTracker.myToDoneTasks track by task._id\" as-sortable-item ng-dblclick=\"task.open()\">\n\n <!-- Make the whole row the handle -->\n <div as-sortable-item-handle style=\"cursor: ns-resize\">\n <au-task-row task=\"task\"></au-task-row>\n </div>\n\n </div>\n </div>\n </div>\n\n\n <!--empty state-->\n <div class=\"md-body-1\" ng-if=\"vm.myTaskTracker.myInProgressTasks.length == 0 && vm.myTaskTracker.myToDoneTasks.length == 0\"\n layout=\"column\" layout-align=\"center center\" style=\"color:rgba(0,0,0,0.4);padding:40px;\">\n <img src=\"/assets/images/empty-states/bell.png\" class=\"bounce\">\n <span class=\"md-headline font-weight-300\">Lookin\' good!</span>\n <span class=\"md-caption\">You have no tasks.</span>\n </div>\n <!-- end empty state -->\n\n\n</md-card>");
$templateCache.put("/app/alignus/directives/au-philosophy-card/au-philosophy-card.tmpl.html","<div>\n {{vm.item.getPhilosophy()}}\n</div>>");
$templateCache.put("/app/alignus/directives/au-posts/au-post-feed.tmpl.html","<div layout=\"column\" layout-align=\"start center\" layout-fill>\n <div class=\"loading-message top\" layout=\"row\" layout-align=\"center center\">\n <div dynamic=\"feed.loadingMessage\"></div>\n </div>\n\n <div class=\"fill\"></div>\n\n <div class=\"post-placeholder-wrapper\" layout=\"row\" layout-align=\"start start\" layout-fill>\n <div class=\"bottom-chat\" ng-init=\"post = feed.loadingPost\">\n <div ng-compiled-include=\"/app/alignus/layouts/chat-bar/feed-template.tmpl.html\"></div>\n </div>\n <div class=\"discussion au-post full-width\" ng-init=\"vm = feed; vm.post = feed.loadingPost;\">\n <div ng-compiled-include=\"/app/alignus/directives/au-posts/au-post-loading-discussion.tmpl.html\"></div>\n </div>\n <div class=\"card au-post material-card material-shadow full-width\" ng-init=\"vm = feed; vm.post = feed.loadingPost;\">\n <div ng-compiled-include=\"/app/alignus/directives/au-posts/au-post-loading-card.tmpl.html\"></div>\n </div>\n </div>\n\n <div class=\"backstage\" ng-style=\"{width: 100 / feed.columns.length + \'%\'}\"></div>\n\n <!-- The columns are filled by js -->\n <div layout=\"row\" layout-fill class=\"columns\"></div>\n\n <div ng-show=\"!postsOnly\">\n <div ng-if=\"feed.showEmptyState\" layout=\"column\" layout-align=\"center center\" class=\"feed-empty-state\">\n <img src=\"/assets/images/empty-states/cricket.png\" class=\"fadeup\">\n <span class=\"md-headline\">It’s awfully quiet in here.</span>\n <span class=\"md-subhead\" ng-hide=\"feed.noEmptyInstructions\">Make some noise by saying something {{(recentOn == \'top\' ? \'above\' : \'below\')}}.</span>\n </div>\n\n <div ng-if=\"!feed.showEmptyState && recentOn == \'top\' && !!feed.loadingMessage\" class=\"loading-message bottom\" layout=\"row\" layout-align=\"center center\">\n <div dynamic=\"feed.loadingMessage\"></div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/au-post-loading-card.tmpl.html","<md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\">\n <div class=\"au-profile-image-placeholder\" style=\"width: 40px; height: 40px\">\n <span class=\"au-profile-image-container\" style=\"width: 40px; height: 40px\">\n <span class=\"normal\">\n <span class=\"au-profile-image no-animate\" style=\"background-image: url(https://s3.amazonaws.com/alignusstatic/UI/avatars/al.png);\"></span>\n </span>\n </span>\n </div>\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 200px;\"></div>\n </div>\n </div>\n </md-card-header-text>\n\n <!--Toolbar-->\n <div class=\"toolbar no-animate\" layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" class=\"opacity-60 zmdi-more\"></md-icon>\n </md-button>\n </div>\n <!--Toolbar End-->\n</md-card-header>\n<div class=\"au-post-content\">\n\n <!--Content-->\n <div layout=\"row\">\n <div layout=\"column\" flex=\"::(vm.post.filterImgDocuments(false).length > 0 ? 75 : 100)\">\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 200px;\"></div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 300px;\"></div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 280px;\"></div>\n </div>\n </div>\n </div>\n <!--End content-->\n\n <!-- bottom buttons -->\n <div>\n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\" layout-align-xs=\"center start\">\n <!--like button-->\n <div>\n <md-button>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\" id=\"NumLikeCount\">0 Likes</span>\n </md-button>\n </div>\n\n <!--comment button-->\n <div ng-class=\"{\'post-commented\': vm.post.Comments.length}\">\n <md-button aria-label=\"comments\" ng-click=\"vm.showComments = !vm.showComments\" id=\"BtnCommentPost\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\" id=\"NumCommentCount\">Loading Comments</span>\n </md-button>\n </div>\n </div>\n </div>\n\n\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/au-post-loading-discussion.tmpl.html","<md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\">\n <div class=\"au-profile-image-placeholder\" style=\"width: 50px; height: 50px\">\n <span class=\"au-profile-image-container\" style=\"width: 50px; height: 50px\">\n <span class=\"normal\">\n <span class=\"au-profile-image no-animate\" style=\"background-image: url(https://s3.amazonaws.com/alignusstatic/UI/avatars/al.png);\"></span>\n </span>\n </span> \n </div>\n <div class=\"chat-pointer\"></div>\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 200px;\"></div>\n </div>\n </div>\n </md-card-header-text>\n\n <!--Toolbar-->\n <div class=\"toolbar no-animate\" layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" class=\"opacity-60 zmdi-more\"></md-icon>\n </md-button>\n </div>\n <!--Toolbar End-->\n</md-card-header>\n<div class=\"au-post-content\">\n\n <!--Content-->\n <div layout=\"row\">\n <div layout=\"column\" flex=\"::(vm.post.filterImgDocuments(false).length > 0 ? 75 : 100)\">\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 200px;\"></div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 300px;\"></div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" style=\"height: 20px\">\n <div class=\"animated-background\" style=\"height: 5px;width: 280px;\"></div>\n </div>\n </div>\n </div>\n <!--End content-->\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/au-post.tmpl.html","<div ng-if=\"!vm.editMode\" class=\"au-post material-card material-shadow no-animate\" layout=\"column\" ng-mouseenter=\"toolbarIsOpen = true\"\n ng-mouseleave=\"toolbarIsOpen = false\" flex>\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" ng-if=\"!vm.hideHeader\">\n <div>\n <au-profile-image user=\"vm.post.Creator\" size=\"(vm.feedType == \'Discussion\' ? 50 : 40)\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n <div class=\"chat-pointer\" ng-if=\"::vm.feedType == \'Discussion\'\"></div>\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n {{vm.post.Creator | fullNameFilter}}\n <span class=\"md-caption opacity-60\" style=\"font-weight: 400;\" ng-if=\"::vm.feedType == \'Discussion\'\">\n commented\n <span am-time-ago=\"::vm.post.DateCreated\"></span>\n </span>\n </div>\n <span ng-if=\"::vm.feedType == \'NewsFeed\' || vm.feedType == undefined\" class=\"md-caption limit-text-subhead\">\n <md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>\n {{::vm.post.$Page.Title}}\n <span>({{vm.post.$UNF.RelevanceScore}} Relevance)</span>\n </span>\n </md-card-header-text>\n <!--Toolbar-->\n <div class=\"toolbar no-animate\" ng-show=\"toolbarIsOpen\" layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-icon-button fadeleft\" ng-click=\"vm.openAddTaskDialog($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment-check\" title=\"Create Task From Post\" class=\"scale\"></md-icon>\n </md-button>\n <md-menu ng-if=\"::vm.feedType == \'Discussion\' && vm.post.Tagged.length > 0\">\n <md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"tags\" class=\"margin-0 padding-0 fadeleft\" id=\"BtnTaggedCount\" layout-fill\n layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n <span> {{::vm.post.Tagged.length}} {{::vm.post.Tagged.length == 1 ? \'Person\' : \'People\'}} Tagged &nbsp;</span>\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item ng-repeat=\"user in vm.post.Tagged\" ng-attr-id=\"BtnTaggedUser{{$index}}\">\n <md-button ng-click=\"vm.goToUserPage(user)\">\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\">\n <au-profile-image user=\"user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">{{user | auItemFilter: \'User\'}}</span>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <md-button ng-if=\"::vm.feedType == \'Discussion\'\" aria-label=\"like\" ng-class=\"{\'post-liked\': vm.post.doesCurrentUserLikePost()}\"\n id=\"BtnLikeDiscussionPost\" ng-click=\"vm.toggleLike(); $event.stopPropagation()\" ng-att-title=\"Click to {{(vm.post.doesCurrentUserLikePost() ? \'unlike\' : \'like\')}} this post\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"floatup fadeleft\"></md-icon>\n <span>{{vm.getLikeButtonText()}} &nbsp;</span>\n </md-button>\n <md-button ng-if=\"::vm.feedType != \'Discussion\'\" aria-label=\"share\" class=\"md-icon-button fadeleft\" au-share au-share-items=\"vm.post\"\n id=\"BtnSharePost\">\n <md-icon md-font-icon=\"zmdi zmdi-share\" title=\"Share Post\" class=\"scale\"></md-icon>\n </md-button>\n <md-button ng-if=\"::vm.feedType != \'NewsFeed\' && vm.post.canRemove()\" aria-label=\"edit\" class=\"md-icon-button fadeleft\" ng-click=\"vm.removePost($event)\"\n id=\"BtnRemovePost\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" class=\"scale\" title=\"Delete This Post\"></md-icon>\n </md-button>\n <md-button ng-if=\"::vm.post.canEdit()\" aria-label=\"edit\" class=\"md-icon-button fadeleft\" ng-click=\"vm.editPost($event)\" id=\"BtnEditPost\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"scale\" title=\"Edit Your Post\"></md-icon>\n </md-button>\n <md-button ng-if=\"::vm.showPinButton\" aria-label=\"pin\" class=\"md-icon-button fadeleft\" ng-click=\"vm.togglePagePinned($event)\"\n id=\"BtnPinPost\">\n <md-icon ng-if=\"vm.post.IsPinned\" md-font-icon=\"au au-pin\" title=\"Unpin from Page\" class=\"no-animate scale\"></md-icon>\n <md-icon ng-if=\"!vm.post.IsPinned\" md-font-icon=\"au au-pin-outline\" title=\"Pin to Page\" class=\"no-animate scale\"></md-icon>\n </md-button>\n <md-button ng-if=\"::vm.feedType == \'NewsFeed\'\" aria-label=\"pin\" class=\"md-icon-button fadeleft\" ng-click=\"vm.toggleUnfPinned($event)\"\n id=\"BtnPinPost\">\n <md-icon ng-if=\"vm.post.$UNF.Pinned\" md-font-icon=\"au au-pin\" title=\"Unpin from News Feed\" class=\"no-animate scale\"></md-icon>\n <md-icon ng-if=\"!vm.post.$UNF.Pinned\" md-font-icon=\"au au-pin-outline\" title=\"Pin to News Feed\" class=\"no-animate scale\"></md-icon>\n </md-button>\n <md-button ng-if=\"::vm.feedType == \'NewsFeed\'\" aria-label=\"check\" class=\"md-icon-button fadeleft\" ng-click=\"vm.toggleUnfRead($event)\"\n id=\"BtnReadPost\">\n <md-icon ng-if=\"!vm.post.$UNF.Read\" md-font-icon=\"zmdi zmdi-check\" title=\"Mark Read\" class=\"no-animate scale\"></md-icon>\n <md-icon ng-if=\"vm.post.$UNF.Read\" md-font-icon=\"zmdi zmdi-check-circle\" title=\"Mark Unread\" class=\"no-animate scale\"></md-icon>\n </md-button>\n </div>\n <div ng-hide=\"toolbarIsOpen\" class=\"toolbar no-animate\" layout=\"row\" layout-align=\"end center\">\n <span class=\"timestamp\" am-time-ago=\"::vm.post.DateCreated\" ng-hide=\"vm.feedType == \'Discussion\'\"></span>\n <md-button class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" class=\"opacity-60\" ng-class=\"::{\'zmdi-more\':vm.feedType == \'Discussion\', \'zmdi-time\':vm.feedType != \'Discussion\'}\"></md-icon>\n </md-button>\n </div>\n <!--Toolbar End-->\n </md-card-header>\n <div class=\"au-post-content\">\n <!-- cover photo -->\n <div style=\"height: 150px\" au-cover-photo item=\"vm.post\" ng-if=\"::vm.post.CoverPhoto || vm.post.CoverPhotoUrl\" allow-update=\"false\"\n class=\"cover-photo\"></div>\n\n <!--Content-->\n <div layout=\"row\">\n <div layout=\"column\" flex=\"::(vm.post.filterImgDocuments(false).length > 0 ? 75 : 100)\">\n <div ng-if=\"vm.post.Type == \'Update\'\" class=\"au-post-container\">\n <p class=\"md-body-1\" dynamic=\"vm.post.Data.Update\"></p>\n </div>\n <div ng-if=\"vm.post.Type != \'Update\'\" ng-include=\"::vm.getTemplate()\" class=\"au-post-container\"></div>\n <div ng-if=\"vm.imgCols\" style=\"padding-right: 10px;\">\n <div class=\"img-container\" ng-if=\"::vm.post.filterImgDocuments(true).length > 0\">\n <div ng-repeat=\"img in vm.post.filterImgDocuments(true)\" ng-click=\"vm.openDocument(img)\" class=\"clip\">\n <img ng-src=\"{{$root.auUtility.getSignedS3ImgUrl(img.Id)}}\" />\n </div>\n </div>\n </div>\n </div>\n\n <!--Attachments-->\n <div flex=\"25\" class=\"attachments fadeleft\" ng-if=\"::vm.post.filterImgDocuments(false).length > 0\">\n <div layout=\"row\" layout-align=\"center center\" class=\"social-count-text header\">Attachments</div>\n <au-document-section item=\"vm.post\" show-toolbar=\"false\" only-list=\"true\" exclude-images=\"true\" class=\"mini\"></au-document-section>\n </div>\n </div>\n <!--End content-->\n\n <!-- bottom buttons -->\n <div ng-if=\"::vm.feedType != \'Discussion\'\">\n <div class=\"social-count\" layout=\"row\" layout-align=\"end center\" layout-align-xs=\"center start\">\n <!--who likes-->\n <div hide-xs>\n <div class=\"social-count-text\" ng-if=\"vm.post.Likes.length > 0\">\n <span id=\"StringLikeUsers\">\n {{vm.getWhoLikesString()}}\n </span>\n <au-popover class=\"scrollable-content\">\n <md-menu-content style=\"max-height:250px; overflow-y:auto;\" width=\"4\">\n <md-menu-item ng-repeat=\"like in vm.post.Likes\">\n <md-button ng-click=\"vm.goToUserPage(like.User)\">\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\">\n <au-profile-image user=\"like.User\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">{{like.User | auItemFilter: \'User\'}}</span>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </au-popover>\n </div>\n </div>\n\n <div flex></div>\n\n <!--labels button - show if this post is labeled or the page has labels and the user is an editor -->\n <div ng-if=\"::vm.post.canEdit() && vm.labelsAvailable\">\n <md-menu class=\"padding-0\">\n <md-button ng-click=\"$mdOpenMenu($event)\" class=\"padding-0 margin-0\">\n <md-icon md-font-icon=\"zmdi zmdi-label\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\">\n {{vm.post.Labels.length}} Label{{(vm.post.Labels.length == 1 ? \'\' : \'s\')}}\n </span>\n </md-button>\n <md-menu-content>\n <md-menu-item ng-repeat=\"label in vm.possibleLabels\">\n <md-button ng-click=\"vm.togglePostLabel(label)\" md-prevent-menu-close>\n <i class=\"zmdi margin-right-10\" ng-class=\"(vm.post.Labels.indexOf(label) == -1 ? \'select-post-label zmdi-label\': \'zmdi-check\')\"></i>\n {{label}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n\n <!--like button-->\n <div>\n <md-button aria-label=\"likes\" ng-class=\"{\'post-liked\': vm.post.doesCurrentUserLikePost()}\" ng-click=\"vm.toggleLike()\" ng-disabled=\"$root.user.$AnonymousUser\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\" id=\"NumLikeCount\">{{vm.getLikeButtonText()}}</span>\n <md-tooltip>\n Click to {{(vm.post.doesCurrentUserLikePost() ? \'unlike\' : \'like\')}} this post\n </md-tooltip>\n </md-button>\n </div>\n\n <!--tagged button-->\n <div ng-if=\"::vm.post.Tagged.length\" class=\"post-tagged\">\n <md-menu>\n <md-button ng-click=\"$mdOpenMenu($event)\" aria-label=\"tags\" id=\"BtnTaggedCount\">\n <md-icon md-font-icon=\"zmdi zmdi-tag\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\">{{::vm.post.Tagged.length}} Tagged</span>\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item ng-repeat=\"user in vm.post.Tagged\" ng-attr-id=\"BtnTaggedUser{{$index}}\">\n <md-button ng-click=\"vm.goToUserPage(user)\">\n <div layout=\"row\" layout-align=\"start center\" class=\"social-avatar-comment\">\n <au-profile-image user=\"user\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2\">{{user | auItemFilter: \'User\'}}</span>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n\n <!--comment button-->\n <div ng-class=\"{\'post-commented\': vm.post.Comments.length}\">\n <md-button aria-label=\"comments\" ng-click=\"vm.showComments = !vm.showComments\" id=\"BtnCommentPost\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" class=\"social-count-icon\"></md-icon>\n <span class=\"social-count-text\" id=\"NumCommentCount\">{{vm.post.Comments.length}} Comments</span>\n </md-button>\n </div>\n </div>\n </div>\n\n <!--Comment Expanded-->\n <div ng-if=\"vm.showComments\" class=\"comments\">\n <!-- input -->\n <div layout=\"row\" class=\"margin-top-10 margin-bottom-20\" au-can-edit=\"!$root.user.$AnonymousUser\">\n <div class=\"au-cke-document md-input\" ng-model=\"vm.newComment.Comment\" placeholder=\"Comment\" on-enter=\"vm.addCommentClicked\"\n id=\"TxtComment\" flex grow=\"true\"></div>\n <button ng-click=\"vm.addCommentClicked($event)\" class=\"margin-0 md-icon-button md-button md-ink-ripple\" type=\"submit\" aria-label=\"Send\"\n id=\"BtnSubmitComment\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" style=\"color: #00aeef;\"\n aria-hidden=\"true\"></md-icon>\n </button>\n </div>\n\n <!--comment list-->\n <div class=\"comments-list padding-10\" style=\"max-height:350px; overflow-y:auto;\" ng-if=\"vm.showComments\">\n <div class=\"margin-bottom-10\" class=\"md-3-line md-long-text\" ng-repeat=\"comment in vm.post.Comments track by comment._id\"\n ng-mouseenter=\"comment.$hovered=true;\" ng-mouseleave=\"comment.$hovered = false\">\n <div layout=\"row\" layout-align=\"space-between start\">\n <div layout=\"row\" class=\"social-avatar-comment\" flex>\n <au-profile-image user=\"comment.User\" size=\"30\" style=\"margin-right:-4px;\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <div layout=\"column\" layout-align=\"center start\" ng-attr-id=\"StringCommentList{{::$index}}\" class=\"margin-left-15\">\n <span class=\"md-body-2\">{{comment.User | auItemFilter: \'User\'}}</span>\n <span class=\"comment\" dynamic=\"::comment.Comment\"></span>\n <span class=\"social-comment-time\" am-time-ago=\"::comment.DateCreated\"></span>\n </div>\n </div>\n <!--delete comment-->\n <md-button aria-label=\"delete-comment\" ng-show=\"comment.$hovered && $root.user._id == comment.User\" ng-click=\"vm.post.removeComment(comment._id)\"\n class=\"md-icon-button\" ng-attr-id=\"BtnDeleteComment{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:gray\"></md-icon>\n </md-button>\n </div>\n </div>\n </div>\n </div>\n </div>\n</div>\n<div ng-if=\"vm.editMode\" class=\"no-animate au-post-edit-area\">\n <au-inline-post item=\"vm.post\" options=\"{expandOnLoad:true}\" on-complete=\"vm.editComplete\" auto-focus=\"true\" grow=\"true\"></au-inline-post>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/discussion.tmpl.html","<p dynamic=\"vm.post.Data.Update\"></p>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-description.tmpl.html","<div class=\"fundraiser-item-post\">\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px)\">\n <img s3-src=\"/assets/images/avatars/fundraiser.png\" width=\"40px\" class=\"margin-right-10\">\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n About our Fundraiser\n </div>\n <div class=\"md-caption\">\n {{$root.fundraiser.PostAs}}\n </div>\n </md-card-header-text>\n </md-card-header>\n\n <p class=\"md-body-1\" dynamic=\"$root.fundraiser.Description\"></p>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-body-1\">\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-right-30\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" class=\"padding-right-10 opacity-50\"></md-icon>\n <div layout=\"column\" flex layout-align=\"start start\">\n <span flex class=\"md-caption\">Opening Date</span>\n <div layout=\"row\" flex>\n <span class=\"md-title\" flex>{{$root.fundraiser.OpeningDate | amCalendar}}</span>\n </div>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\" class=\"padding-right-10 opacity-50\"></md-icon>\n <div layout=\"column\" flex layout-align=\"start start\">\n <span flex class=\"md-caption\">Closing Date</span>\n <div layout=\"row\" flex>\n <span class=\"md-title\" flex>{{$root.fundraiser.ClosingDate | amCalendar}}</span>\n </div>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-items.tmpl.html","<div>\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px);height: 72px;\">\n <img s3-src=\"/assets/images/avatars/pricetag.png\" width=\"40px\" class=\"margin-right-10\">\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n Available Items for Sale\n </div>\n <div class=\"md-caption\">\n {{$root.fundraiser.PostAs}}\n </div>\n </md-card-header-text>\n </md-card-header>\n\n <div layout=\"row\" ng-click=\"$root.fundraiser.showAvailableItems($event)\" class=\"margin-bottom-10\" style=\"cursor: pointer; max-height: 160px; overflow: hidden;\">\n <div layout=\"column\" layout-align=\"start center\" ng-repeat=\"item in $root.fundraiser.AvailableItems\">\n <au-profile-image size=\"100\" item=\"item\"></au-profile-image>\n <span class=\"md-caption margin-top-10\">{{item.Title}}</span>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-raised\" ng-click=\"$root.fundraiser.showAvailableItems($event)\">\n &nbsp; View all Items\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-raised md-primary\" ng-click=\"$root.fundraiser.showBuyNow($event)\" style=\"font-size: 24px\" ng-disabled=\"!$root.fundraiser.IsOpen\">\n &nbsp; Buy Online Now!\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-newparticipant.tmpl.html","<div class=\"fundraiser-item-post\">\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px)\">\n <au-profile-image item=\"vm.post.Data.Participant\" size=\"40\"></au-profile-image>\n <!-- <img s3-src=\"/assets/images/avatars/fundraiser.png\" width=\"40px\" class=\"margin-right-10\"> -->\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n {{vm.post.Data.Participant.FirstName}} {{vm.post.Data.Participant.LastName.substr(0,1)}} Just Signed Up\n </div>\n <div class=\"md-caption\">\n {{vm.post.DateCreated | amCalendar}}\n </div>\n </md-card-header-text>\n </md-card-header>\n\n <div layout=\"row\" layout-align=\"space-between start\" class=\"margin-top-20\" style=\"height: 140px;background-image: url(/assets/images/dialogs/completed.png);background-size: 250px;background-position: right top;background-repeat: no-repeat;\">\n <div class=\"padding-10\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\" class=\"opacity-50\"></md-icon>\n <span class=\"md-caption\">New Participant</span>\n <div layout=\"row\" layout-align=\"start center\">\n <span class=\"md-title margin-right-5\">{{vm.post.Data.Participant.FirstName}}</span>\n <span class=\"margin-right-5\">({{vm.post.Data.Participant.Title}}) </span>\n <span class=\"margin-right-5\">just joined!</span>\n </div>\n </div>\n <div flex></div>\n\n </div>\n\n <!-- <p class=\"md-body-1\">\n Here\'s a big <span contenteditable=\"false\" class=\"doc-mention HighFive\" data-item-type=\"HighFive\" high-five-type=\"high-five\" high-five-message=\"Good Luck!\" data-cke-filter=\"off\" title=\"High Five\">High Five</span> to {{vm.post.Data.Participant.FirstName}} ({{vm.post.Data.Participant.Title}}) for signing up.\n </p> -->\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-prizes.tmpl.html","<div>\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px)\">\n <img s3-src=\"/assets/images/avatars/prize.png\" width=\"40px\" class=\"margin-right-10\">\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n Prizes Available for Participants\n </div>\n <div class=\"md-caption\">\n {{$root.fundraiser.PostAs}}\n </div>\n </md-card-header-text>\n </md-card-header>\n\n <p class=\"margin-bottom-30\">{{$root.fundraiser.PrizeIntro}}</p>\n\n <div layout=\"row\" ng-click=\"$root.fundraiser.showAvailblePrizes()\" class=\"margin-bottom-10\" style=\"cursor: pointer; cursor: pointer; max-height: 160px; overflow: hidden;\">\n <div layout=\"column\" layout-align=\"start center\" ng-repeat=\"item in $root.fundraiser.AvailablePrizes\">\n <au-profile-image size=\"100\" item=\"item\"></au-profile-image>\n <span class=\"md-caption margin-top-10\">{{item.Title}}</span>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-raised\" ng-click=\"$root.fundraiser.showAvailblePrizes()\">\n &nbsp; View all Prizes\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-salemade.tmpl.html","<div class=\"fundraiser-item-post\">\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px)\">\n <au-profile-image item=\"vm.post.Data.Participant\" size=\"40\"></au-profile-image>\n <!-- <img s3-src=\"/assets/images/avatars/fundraiser.png\" width=\"40px\" class=\"margin-right-10\"> -->\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n {{vm.post.Data.Participant.FirstName}} {{vm.post.Data.Participant.LastName.substr(0,1)}} Made a Sale!\n </div>\n <div class=\"md-caption\">\n {{vm.post.DateCreated | amCalendar}}\n </div>\n </md-card-header-text>\n </md-card-header>\n\n <div layout=\"row\" layout-align=\"space-between start\" class=\"margin-top-20\">\n \n <div flex class=\"padding-10\" style=\"border-right:solid 1px #eee;\">\n <md-icon md-font-icon=\"zmdi zmdi-money-box\" class=\"opacity-50\"></md-icon>\n <span class=\"md-caption\">{{vm.post.Data.Participant.FirstName}} sold</span>\n <div layout=\"row\" layout-align=\"start center\">\n <span class=\"md-title margin-right-6\">{{vm.post.Data.NbrItems}} item{{vm.post.Data.NbrItems == 1 ? \'\' : \'s\'}}</span>\n <span class=\"margin-right-8\">for</span> \n <span class=\"md-title\" style=\"background:#00aeef0d;padding: 2px 8px;font-weight: 500;border-radius: 5px;border: solid 1px #00aeef33;\">{{vm.post.Data.OrderTotal | currency}}</span>\n </div>\n </div>\n \n \n <div style=\"text-align: right\" class=\"padding-10 padding-left-20 padding-right-20\">\n <md-icon md-font-icon=\"zmdi zmdi-receipt\" class=\"opacity-50\"></md-icon>\n <span class=\"md-caption\">{{vm.post.Data.Participant.FirstName}}\'s total </span>\n <div class=\"md-title\">{{vm.post.Data.Participant.TotalSold | currency}}</div>\n </div>\n </div>\n\n\n\n <!-- <p class=\"md-body-1\">\n {{vm.post.Data.Participant.FirstName}} sold {{vm.post.Data.NbrItems}} item{{vm.post.Data.NbrItems == 1 ? \'\' : \'s\'}} for {{vm.post.Data.OrderTotal | currency}}.\n \n </p>\n <p class=\"md-body-1\" ng-if=\"vm.post.Data.Participant.TotalSold\">\n This brings their total to {{vm.post.Data.Participant.TotalSold | currency}}!\n </p> -->\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/fundraiser-status.tmpl.html","<div>\n <md-card-header class=\"header\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.keepToolbarOpen($event)\" style=\"margin: -16px 0 16px -16px; min-width: calc(100% + 36px)\">\n <img s3-src=\"/assets/images/avatars/linechart.png\" width=\"40px\" class=\"margin-right-10\">\n <md-card-header-text class=\"margin-0\" flex layout=\"column\" layout-align=\"center start\">\n <div class=\"text-ellipsis md-body-2\">\n Fundraiser Statistics\n </div>\n <div class=\"md-caption\">\n {{$root.fundraiser.PostAs}}\n </div>\n </md-card-header-text>\n </md-card-header>\n <p>Participant Count: {{$root.fundraiser.ParticipantCount}}</p>\n <p>Total Sold: {{$root.fundraiser.TotalSold | currency}}</p>\n\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/message.tmpl.html","<p dynamic=\"::vm.post.Data.Update\"></p>");
$templateCache.put("/app/alignus/directives/au-posts/poll.tmpl.html","<div style=\"margin: auto;\">\n <h1 class=\"md-headline\">{{vm.post.Data.Poll.Question}}</h1>\n\n <span ng-if=\"vm.post.Data.Poll.End && !vm.pollIsPollClosed()\" style=\"font-size: 14px; margin-left: -5px; margin-top: 5px;\">\n <md-icon md-font-icon=\"zmdi zmdi-timer\" class=\"social-event-icons\"></md-icon>Poll closes <b>{{vm.post.Data.Poll.End | date : \'short\'}}</b>\n </span>\n\n <div ng-if=\"vm.pollHasUserResponded()\">\n Thank you for your <u>input</u>.\n <au-popover class=\"md-padding scrollable-content\">\n <span class=\"md-body-1\">\n You chose <b>{{::vm.pollGetThisUsersResponse().VotedFor}}</b>&nbsp;\n <span am-time-ago=\"::vm.pollGetThisUsersResponse().VotedAt\"></span>\n </span>\n </au-popover>\n </div>\n\n <div ng-if=\"!vm.pollHasUserResponded() && !vm.pollIsPollClosed()\" class=\"margin-top-30 no-animate\">\n <md-radio-group ng-model=\"vm.isVotingFor\" layout=\"column\" layout-align=\"start start\" layout-wrap class=\"margin-top-10 post-type-container\">\n <md-radio-button ng-repeat=\"response in vm.post.Data.Poll.PossibleResponses\" value=\"{{::response.Response}}\" aria-label=\"{{::response.Response}}\">{{::response.Response}}</md-radio-button>\n </md-radio-group>\n <div layout=\"row\" layout-align=\"end center\">\n <md-button ng-disabled=\"!vm.isVotingFor\" ng-click=\"vm.pollSubmitResponse(vm.isVotingFor)\" class=\"md-raised\">\n &nbsp; Submit\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <span ng-if=\"vm.pollIsPollClosed()\" class=\"no-animate\" style=\"margin: auto;\">\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"social-event-icons\"></md-icon>\n The poll has ended.\n </span>\n\n <div ng-if=\"vm.pollIsPollClosed() || vm.pollHasUserResponded()\" style=\"margin: 30px auto;\">\n <span ng-show=\"!vm.pollDoesPollHaveResponses()\">Nobody responded to this poll!</span>\n <canvas style=\" margin: auto;\" ng-show=\"vm.pollDoesPollHaveResponses()\" class=\"chart chart-doughnut\" chart-data=\"vm.pollChartData\" chart-labels=\"vm.pollChartLabels\" chart-options=\"{animation:false, legend:{display: true, position:\'left\'}}\"></canvas>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/projectcompletionupdate.tmpl.html","<div layout=\"row\" layout-align=\"start center\" class=\"project-completion-update\">\n <!-- Chart -->\n <au-completion-percentage completion-percentage=\"vm.post.Data.ProjectCompletionUpdate.CompletionPercentage\"></au-completion-percentage>\n <!--End Chart-->\n <p class=\"md-body-1\" flex><b>{{vm.post.Data.ProjectCompletionUpdate.ProjectTitle}}</b><br>{{vm.post.Data.ProjectCompletionUpdate.CompletionText}}</p>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/share.tmpl.html","<div ng-if=\"vm.post.Data.Introduction\">\n <p class=\"md-body-1 margin-bottom-10\" dynamic=\"::vm.post.Data.Introduction\"></p>\n <md-divider class=\"margin-bottom-10\"></md-divider>\n</div>\n<div ng-include=\"::vm.getShareTemplate(item.$key)\" ng-repeat=\"item in vm.sharedItems\"></div>");
$templateCache.put("/app/alignus/directives/au-posts/sharedocument.tmpl.html","<div layout=\"row\" layout-align=\"start center\">\n <img s3-src=\"/assets/images/avatars/document.png\" style=\"border-radius: 50%; width: 50px;\" class=\"margin-right-10\">\n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-title\">{{item | auItemFilter : \'Document\'}}</span>\n </div>\n</div>\n\n<section layout=\"row\" layout-align=\"end center\">\n <md-button id=\"BtnGoToDocument\" style=\"float:right;\" class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\">\n <span>&nbsp; Go to Document</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> \n </md-button>\n</section>");
$templateCache.put("/app/alignus/directives/au-posts/sharegeneric.tmpl.html","<p class=\"md-title\">{{item.toString()}}</p>\n\n<section layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\" id=\"BtnGoToItem\">\n <span>&nbsp; Take me there</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> \n </md-button>\n</section>");
$templateCache.put("/app/alignus/directives/au-posts/sharepage.tmpl.html","<au-cover-photo item=\"item\" allow-update=\"false\" ng-if=\"item.GetCoverPhotoUrl()\" style=\"display: block; height:100px; width: 100%;\" class=\"margin-bottom-10\"></au-cover-photo>\n\n<!--Event Specific-->\n<div ng-if=\"item.Type == \'Event\'\">\n <!--Event Details-->\n <h1 class=\"md-title margin-top-10\">{{item.Title}}</h1>\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-10\">\n <div layout=\"row\" layout-align=\"start center\">\n <div>\n <div class=\"social-event-date md-whiteframe-2dp\">\n <span class=\"month\">{{item.Event.Start | date: \'MMMM\'}}</span>\n <span class=\"day\">{{item.Event.Start | date: \'d\'}}</span>\n <!--<span class=\"week\">{{::vm.getEventDayOfWeekString()}}</span>-->\n </div>\n </div>\n </div>\n <div class=\"md-icon-float md-block padding-left-10\">\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons\"></md-icon>\n <span class=\"md-body-1\">{{item.Event.Start | date: \'EEEE\'}}<br></span>\n </div>\n <div ng-if=\"item.Event.Start\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons\"></md-icon>\n <span class=\"md-body-1\">{{item.Event.Start | date : \'h:mm a\'}} - {{item.Event.End | date : \'h:mm a\'}}<br></span>\n </div>\n <div ng-if=\"item.Event.Location\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons\"></md-icon>\n <span class=\"md-body-1\">{{item.Event.Location | fullLocationFilter : \'full\'}}<br></span>\n </div>\n </div>\n </div>\n <p class=\"md-body-1\" dynamic=\"::item.SideBarWidgets[0].Data.PageDescription\"></p>\n</div>\n<!--Event Specific End-->\n<div layout=\"row\" layout-align=\"start center\" ng-if=\"item.Type != \'Event\'\">\n <img s3-src=\"/assets/images/avatars/page.png\" style=\"border-radius: 50%; width: 50px; margin-right: 10px\">\n <span class=\"md-title\">{{item.Title}}</span>\n</div>\n<section layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\" id=\"BtnGoToPage\">\n <span>&nbsp; Go to Page</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n</section>");
$templateCache.put("/app/alignus/directives/au-posts/sharepost.tmpl.html","<au-post post=\"item\"></au-post>");
$templateCache.put("/app/alignus/directives/au-posts/shareproject.tmpl.html","<div layout=\"row\" layout-align=\"start center\">\n <img s3-src=\"/assets/images/avatars/project.png\" style=\"border-radius: 50%; width: 50px; margin-right: 10px\">\n <span class=\"md-title\">{{item.Title}}</span>\n</div>\n<section layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\" id=\"BtnGoToPage\">\n <span>&nbsp; Go to Project</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n</section>\n");
$templateCache.put("/app/alignus/directives/au-posts/sharequestion.tmpl.html","<div layout=\"row\" layout-align=\"start center\">\n <img s3-src=\"/assets/images/avatars/question.png\" style=\"border-radius: 50%; width: 50px; margin-right: 10px\">\n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-title\">{{item.QuestionTitle}}</span>\n <span class=\"md-body-1\" dynamic=\"item.QuestionBody\"></span>\n </div>\n</div>\n \n<section layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\" id=\"BtnGoToQuestion\">\n <span>&nbsp; Answer</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon> \n </md-button>\n</section>");
$templateCache.put("/app/alignus/directives/au-posts/sharetask.tmpl.html","<div layout=\"row\" layout-align=\"start center\">\n <img s3-src=\"/assets/images/avatars/task.png\" style=\"border-radius: 50%; width: 50px; margin-right: 10px\">\n <span class=\"md-title\">{{item.Title}}</span>\n</div>\n<section layout=\"row\" layout-align=\"end center\">\n <md-button class=\"md-raised iconright\" ng-click=\"item.open(\'new\')\" id=\"BtnGoToPage\">\n <span>&nbsp; Go to Task</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n</section>\n");
$templateCache.put("/app/alignus/directives/au-posts/taskupdate.tmpl.html","<div layout=\"row\" layout-align=\"start center\">\n <div class=\"margin-right-10\">\n <!--<md-icon md-font-icon=\"zmdi zmdi-play-circle\" style=\"position:absolute;color:white;top:108px;left:14px;\"></md-icon>-->\n <img s3-src=\"/assets/images/avatars/task.png\" style=\"border-radius:50%; width:30px;\">\n </div>\n <div flex>\n <span class=\"md-body-1\">I just started working on</span>\n <span class=\"md-body-2\" ng-click=\"vm.goToSharedTask()\">{{vm.sharedTask.Title}}!</span> \n </div>\n</div>\n\n<div layout=\"row\" layout-align=\"end center\" class=\"margin-top-10\">\n <md-button class=\"md-raised iconright\" aria-label=\"GoToTask\" ng-click=\"vm.goToSharedTask()\" id=\"BtnGoToTask\">\n <span>&nbsp; Go To Task</span>\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/update.tmpl.html","<div>\n <!--high five emoji pic gif-->\n <img ng-if=\"vm.post.Data.Emoji\" ng-src=\"/assets/images/gifs/no-loop/{{vm.post.Data.Emoji}}.gif\" class=\"high-five-gif margin-right-5 bounce-no-delay\">\n \n <p class=\"md-body-1\" dynamic=\"vm.post.Data.Update.Update || vm.post.Data.Update\"></p>\n <img ng-if=\"vm.post.Data.Update.Photo\" ng-src=\"{{::vm.post.Data.Update.Photo.Url}}\" class=\"md-card-image\">\n</div>");
$templateCache.put("/app/alignus/directives/au-posts/welcome.tmpl.html","<div>\n <p class=\"md-body-1\">{{::vm.post.Data.Introduction}}</p>\n <md-divider class=\"margin-bottom-20\"></md-divider>\n</div>\n\n<img ng-src=\"{{::vm.post.Data.Photo}}\" class=\"md-card-image margin-bottom-20\">\n\n<section layout=\"row\" layout-align=\"end center\">\n <md-button ng-if=\"vm.post.Data.Button.Link\" class=\"md-raised\" ng-click=\"vm.goToLink()\" id=\"BtnGoToLink\">\n &nbsp; {{::vm.post.Data.Button.Text}} <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n\n <md-button ng-if=\"vm.post.Data.Button.Href\" class=\"md-raised\" ng-click=\"vm.goToSref()\" id=\"BtnGoToLink\">\n &nbsp; {{::vm.post.Data.Button.Text}} <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n\n <md-button ng-if=\"vm.post.Data.Button.myPage\" class=\"md-raised\" ng-click=\"vm.goToMyPage()\" id=\"BtnGoToLink\">\n &nbsp; {{::vm.post.Data.Button.Text}} <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n</section>\n");
$templateCache.put("/app/alignus/directives/au-profile-image/au-profile-image.tmpl.html","<span class=\"au-profile-image-container\" ng-style=\"{width: size + \'px\', height: size + \'px\' }\">\n <span class=\"normal\">\n <span class=\"initials-image ng-hide no-animate\" ng-show=\"showInitials\" ng-style=\"{ \'background-color\': color, \'font-size\': fontSize }\">{{initials}}</span>\n<span class=\"au-profile-image ng-hide no-animate\" ng-show=\"showPhotoBackground\" ng-style=\"{ \'background-image\': \'url(\' + photoBackground + \'?\' + photoQS + \')\'}\" alt=\"{{initials}}\"></span>\n<span class=\"composite-image\" ng-show=\"showCompositeImage\" dynamic=\"compositeImage\">\n </span>\n</span>\n<span class=\"display-none hover\">\n <ng-transclude style=\"display: inline-block;\"></ng-transclude>\n </span>\n</span>");
$templateCache.put("/app/alignus/directives/au-project-overview/au-project-overview.tmpl.html","<md-card class=\"widget\" layout-fill>\n <div class=\"bottom-shadow\" style=\"color: white;\n background-image: url(/assets/images/cards/slim/projects/projects.png);\n background-size: 250px;\n background-position: 160px -51px;\n background-repeat: no-repeat;\n background-color: #39b54a;\n z-index:2;\">\n <div class=\"padding-20\" style=\"height:65px;\">\n <div class=\"md-headline\">Project Overview</div>\n <div class=\"md-caption\">In-progress projects</div>\n <md-button class=\"md-fab grow\" aria-label=\"My Projects\" style=\"left:286px; background-color: #f79420;\" ui-sref=\'shell.project.my-projects.list\'>\n <md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Go to My Projects</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-folder\"></md-icon>\n </md-button>\n </div>\n </div>\n <md-content class=\"fadeleft\">\n <div ng-if=\"vm.projects.length > 0\">\n <md-list-item ng-repeat=\"project in vm.projects track by project._id\" ng-click=\"vm.openProject(project)\" layout=\"row\" layout-align=\"start center\" style=\"margin:20px 0px;\">\n <au-completion-percentage completion-percentage=\"project.LastPercentCompleted\"></au-completion-percentage>\n <span class=\"md-body-2\" flex>{{project.Title}}</span>\n </md-list-item>\n </div>\n <!--empty state-->\n <div ng-if=\"vm.projects.length == 0\" layout=\"column\" layout-align=\"center center\" style=\"color:rgba(0,0,0,0.4);padding:40px;\">\n <img src=\"/assets/images/empty-states/folder.png\">\n <span class=\"md-headline font-weight-300\">Nothing to see here.</span>\n <span class=\"md-caption\">You have no projects in progress!</span>\n </div>\n </md-content>\n</md-card>");
$templateCache.put("/app/alignus/directives/au-rich-text/au-rich-text.tmpl.html","<div class=\"au-rich-text\" layout=\"column\">\n <!-- <div class=\"clip-scrolled-content\"></div> -->\n\n <div layout=\"row\" layout-align=\"space-between center\" class=\"toolbar fade-left\">\n <md-menu>\n <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-more-vert\"></md-icon>\n <md-tooltip>\n All Options\n </md-tooltip>\n </md-button>\n <md-menu-content>\n <md-menu-item>Print</md-menu-item>\n <md-menu-item>Link</md-menu-item>\n </md-menu-content>\n </md-menu>\n\n <md-button class=\"md-icon-button\" ng-click=\"vm.execCmd(\'bold\');\">\n <md-icon md-font-icon=\"zmdi zmdi-format-bold\" class=\"scale\"></md-icon>\n <md-tooltip>Bold</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.execCmd(\'bold\');\">\n <md-icon md-font-icon=\"zmdi zmdi-format-align-left\" class=\"scale\"></md-icon>\n <md-tooltip>Alignment</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.execCmd(\'bold\');\">\n <md-icon md-font-icon=\"zmdi zmdi-format-color-fill\" class=\"scale\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.execCmd(\'bold\');\">\n <md-icon md-font-icon=\"zmdi zmdi-format-size\" class=\"scale\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.execCmd(\'bold\');\">\n <md-icon md-font-icon=\"zmdi zmdi-format-strikethrough-s\" class=\"scale\"></md-icon>\n </md-button>\n\n <div flex></div>\n <div layout=\"row\" layout-align=\"end center\" ng-show=\"!vm.onlyListProxy()\">\n <md-button ng-disabled=\"!$root.user.EffPerms.Documents.CanCreate\" class=\"md-raised md-accent\" ng-click=\"vm.openAddDocumentDialog($event)\"\n id=\"BtnAddDocument\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon>\n <span hide-xs hide-sm>Add {{vm.buttonTerm}} &nbsp; </span>\n </md-button>\n <div au-file-uploader on-upload=\"vm.onDocumentsUploaded\" on-upload-fail=\"vm.onUploadFail\" on-select=\"vm.onDocumentsSelected\"\n ng-disabled=\"!$root.user.EffPerms.Files.CanCreate\">\n <md-button class=\"md-raised md-accent\" id=\"BtnUploadDocument\">\n <md-icon md-font-icon=\"zmdi zmdi-upload\">\n </md-icon>\n <span hide-xs hide-sm>Upload {{vm.buttonTerm}} &nbsp; </span>\n </md-button>\n </div>\n </div>\n </div>\n\n <div class=\"outer-body\" layout=\"column\" layout-align=\"start center\" flex-order=\"{{::vm.hasClass(\'field\') ? 1 : 2}}\">\n <div flex class=\"inner-body CT-hide\">\n\n </div>\n </div>\n\n\n\n\n\n\n\n <!-- <div class=\"au-cke-document-placeholder\">{{::placeholder}}</div> -->\n <!-- <div class=\"au-cke-document-disconnected\">\n <md-card style=\"position: relative; top: 40px;\">\n <img src=\"/assets/images/dialogs/error-banner.jpg\" class=\"md-card-image\" alt=\"image caption\">\n <md-card-content layout=\"column\" layout-align=\"center center\" style=\"background-color:#ff8f00; color:#fff; padding:20px;\">\n <span class=\"md-headline\">Holy guacamole!</span>\n <span class=\"md-body-1\">It looks like your connection is down. Editing is disabled.</span>\n </md-card-content>\n </md-card>\n</div> -->\n <!-- <div class=\"au-suggestions md-whiteframe-1dp border-top-color\" title=\"Type an underscore in place of a space to search with multiple words.\">\n <div layout=\"row\" class=\"item no-animate margin-0\" layout-align=\"start start\" ng-class=\"{\'selected\':$index == suggestIndex, \'header\': item.isSection, \'first\' : $first}\" ng-repeat=\"item in suggestItems track by $index\">\n <img ng-if=\"item.isSection && item.icon\" width=\"20\" height=\"20\" class=\"icon\" s3-src=\"/assets/images/avatars/{{item.icon}}\" />\n <span class=\"section\" ng-if=\"item.isSection\"><b>{{item.sectionTitle}}</b></span>\n <span class=\"tag\" ng-if=\"!item.isSection\" ng-bind-html=\"highlightSuggestion(item.SearchTitle)\" title=\"{{item.ModelName}}: {{item.SearchTitle}}\" ng-click=\"insertMention($index, item)\"></span>\n </div>\n</div> -->\n <div class=\"ng-hide\">\n <div class=\"au-cke-document-project-id\">{{::projectId}}</div>\n <div class=\"au-cke-document-meeting-id\">{{::meetingId}}</div>\n <div class=\"au-cke-document-document-id\">{{::documentId}}</div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-share-in-video-button/au-share-in-video-button.tmpl.html","<md-button class=\"md-icon-button open-single\" ng-click=\"$root.getUiActiveVideoCall().shareItem(item);$event.stopPropagation();\">\n <md-icon md-font-icon=\"zmdi zmdi-long-arrow-tab\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>Share in Call</md-tooltip>\n</md-button>");
$templateCache.put("/app/alignus/directives/au-sticky-note/au-sticky-note.tmpl.html","<md-card class=\"widget padding-20\" style=\"background-color:rgb(255, 255, 210);\" id=\"StickyNoteWidget\">\n\n <div>\n <div class=\"md-headline\">Sticky Note</div>\n <div class=\"md-caption\">Personal notes/reminders</div>\n </div>\n\n <div>\n <md-input-container class=\"md-icon-float md-block\" md-no-float>\n <input type=\"text\" ng-model=\"vm.newSticky.Text\" placeholder=\"Add a new note...\" ng-keydown=\"vm.addSticky($event)\">\n </md-input-container>\n </div>\n\n <!--empty state-->\n <div class=\"md-body-1\" ng-if=\"vm.stickies.length == 0\" layout=\"column\" layout-align=\"center center\" style=\"color:rgba(0,0,0,0.4);padding:40px;\">\n <img src=\"/assets/images/empty-states/bell.png\" class=\"bounce\">\n <span class=\"md-headline font-weight-300\">Lookin\' good!</span>\n <span class=\"md-caption\">You have no personal notes/reminders.</span>\n </div>\n <perfect-scrollbar ng-if=\"vm.stickies.length > 0\">\n <md-content style=\"background:transparent\" as-sortable=\"vm.sortOptions\" data-ng-model=\"vm.stickies\" class=\"dont-block-sortables\">\n <!-- BE VERY CAREFUL EDITING THIS MARKUP -->\n <!-- the order of as-sortable -> as-sortable-item -> as-sortable-item-handle should not be changed -->\n <!-- i realize it looks tempting to remove the \"extra\"\n div here, but it\'s basically the only thing keeping\n the sticky drag and drop from breaking -->\n\n <div ng-repeat=\"sticky in vm.stickies\" as-sortable-item style=\"width: 100%\">\n <div ng-mouseenter=\"showRemove = true\" ng-mouseleave=\"showRemove = false\" as-sortable-item-handle layout=\"row\" layout-align=\"start start\" style=\"margin-left:-10px; width: 100%;\">\n <!--<md-checkbox md-no-ink style=\"margin: 10px 0 0 10px;\" ng-click=\"note.isChecked=\'checkedNote\'\"></md-checkbox>-->\n <md-checkbox md-no-ink style=\"margin: 10px 0 0 10px;\" ng-model=\"sticky.isChecked\" ng-change=\"vm.saveStickies()\" ng-class=\"{\'checkedNote\':sticky.isChecked,\'uncheckedNote\':!sticky.isChecked}\"></md-checkbox>\n <md-input-container md-no-float flex style=\"margin: 4px 0 0 0\">\n <textarea ng-model=\"sticky.Text\" ng-change=\"vm.saveStickies()\" style=\"border-style:none;position:relative;cursor:move;\" class=\"md-body-1\" ng-class=\"{\'checkedNote\':sticky.isChecked,\'uncheckedNote\':!sticky.isChecked}\"></textarea>\n </md-input-container>\n <md-button class=\"md-icon-button icon-button-input-margin md-icon-float md-block\" aria-label=\"Done\" ng-click=\"vm.removeSticky($index)\" style=\"margin:0 -5px 0 0; \">\n <md-icon md-font-icon=\"zmdi zmdi-close-circle\" ng-show=\"showRemove\" style=\"cursor:pointer;\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-close-circle\" ng-hide=\"showRemove\" style=\"visibility:hidden;\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <div class=\"margin-bottom-20\"></div>\n </md-content>\n </perfect-scrollbar>\n</md-card>");
$templateCache.put("/app/alignus/directives/au-task-board/au-task-board.tmpl.html","<div ng-if=\"!vm.excludeToolbar\" style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%; padding: 30px 10px\" layout=\"row\" layout-align=\"space-between center\">\n <md-menu ng-if=\"!vm.disableOtherStates\">\n <md-button aria-label=\"View Option\" class=\"md-accent md-main-theme\" ng-click=\"$mdOpenMenu($event)\" id=\"BtnOpenTaskView\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n View\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item>\n <md-button ng-click=\"vm.setBoardState(\'UserBoard\')\" ng-disabled=\"vm.boardState == \'UserBoard\'\" class=\"md-accent\" id=\"BtnUserView\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon> User &nbsp;\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.setBoardState(\'KanbanBoard\')\" ng-disabled=\"vm.boardState == \'KanbanBoard\'\" class=\"md-accent\" id=\"BtnStateView\">\n <md-icon md-font-icon=\"zmdi zmdi-time-interval\"></md-icon> State &nbsp;\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <div flex>\n </div>\n <md-button ng-click=\"vm.openAddTaskDialog($event)\" class=\"md-accent md-main-theme md-raised\" id=\"BtnAddTask\">\n <md-icon md-font-icon=\"au au-task-add\"></md-icon>\n <span>Add Task &nbsp;</span>\n </md-button>\n</div>\n\n<div id=\"columns\" layout=\"row\" layout-align=\"start start\" style=\"overflow-x: scroll; width: 100%;\">\n <!--<div class=\"padding-left-10\"></div>-->\n <div class=\"au-task-board md-whiteframe-1dp\" ng-repeat=\"column in vm.board.columns\" data-columnindex=\"{{$index}}\" id=\"column{{$index}}\">\n <div class=\"margin-bottom-10\" layout=\"row\" layout-align=\"start center\">\n <au-profile-image ng-if=\"column.member._id\" user=\"column.member\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <au-profile-image ng-if=\"!column.member._id\" item=\"{Photo: null}\" size=\"40\"></au-profile-image>\n <span class=\"md-body-2 margin-right-10\" flex ng-attr-id=\"StringTitle{{$index}}\">{{column.columnTitle}}</span>\n\n <div layout=\"column\" layout-align=\"center\">\n <div layout=\"row\" layout-align=\"end center\" flex>\n <span class=\"task-completed md-primary\">\n {{column.hoursCompleted}}<md-tooltip md-direction=\"top\">Total Planned Hours Completed In The Last 7 Days</md-tooltip>\n </span>\n <span class=\"task-planned md-default-theme background-color-500\">\n {{column.hoursTotal}}<md-tooltip md-direction=\"top\">Total Planned Hours</md-tooltip>\n </span>\n </div>\n <div class=\"task-time-label\">\n <md-icon md-font-icon=\"zmdi zmdi-time\" style=\"font-size: 12px;position: relative;margin: auto;top: 0px;color: #bbbbbb;\"></md-icon>\n <span>EST HRS</span>\n </div>\n </div>\n </div>\n\n <perfect-scrollbar ng-style=\"{\'height\': $parent.$parent.viewportHeight ? $parent.$parent.viewportHeight - 165 + \'px\' : \'100%\'}\" style=\"margin-right: -15px; padding-right: 15px\">\n <md-button ng-if=\"column.member\" ng-attr-id=\"BtnAddTask{{$index}}\" ng-click=\"vm.openAddTaskDialog($event, column.member)\"\n style=\"box-shadow:none; margin:10px 0px; background-color:#F1F1F1; width:100%;\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\"></md-icon>\n <md-tooltip>Add Task</md-tooltip>\n </md-button>\n\n <div ng-if=\"column.groups\" ng-repeat=\"timeRangeGroup in column.groups\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"task-subhead-labels md-default-theme {{timeRangeGroup.groupHeaderClasses}}\">\n <span>{{timeRangeGroup.groupHeader}}</span>\n <span>Est hrs</span>\n </div>\n <!--NOTE: THE MIN-HEIGHT STYLE ON THE FOLLOWING DIV IS NEEDED, OTHERWISE DRAGGING TO AN EMPTY LIST WILL NOT WORK-->\n <!--PLEASE DO NOT REMOVE THE MIN-HEIGHT STYLE-->\n <div class=\"cards card-list\" as-sortable=\"vm.sortOptions\" data-ng-model=\"column.tasks\" style=\"min-height:35px; user-select: none;\">\n <div class=\"card\" ng-repeat=\"task in timeRangeGroup.tasks\" as-sortable-item ng-dblclick=\"vm.openTaskAsRecent(task)\" ng-model=\"task\">\n <ng-include src=\"::\'task-board-task-row\'\"></ng-include>\n </div>\n </div>\n </div>\n <div ng-if=\"!column.groups\" class=\"cards card-list\" as-sortable=\"vm.sortOptions\" data-ng-model=\"column.tasks\" style=\"min-height:35px;\">\n <div class=\"card\" ng-repeat=\"task in column.tasks\" as-sortable-item ng-dblclick=\"vm.openTaskAsRecent(task)\">\n <ng-include src=\"::\'task-board-task-row\'\"></ng-include>\n </div>\n </div>\n <div class=\"padding-20\"></div>\n\n </perfect-scrollbar>\n </div>\n <!--<div class=\"padding-right-10\"></div>-->\n</div>\n\n<script type=\"text/ng-template\" id=\"task-board-task-row\">\n<div as-sortable-item-handle>\n <div layout=\"row\" layout-align=\"start start\" style=\"border-bottom: solid thin #ececec; padding: 5px 0;\" class=\"board-task\">\n <au-profile-image ng-if=\"task.User && task.IsActive\" user=\"task.User\" size=\"30\"></au-profile-image>\n <span class=\"docTask board\" ng-click=\"vm.openTaskFab($event, task)\">\n <input type=\"checkbox\" ng-checked=\"task.EndDate\"/>\n <label></label>\n </span>\n <div class=\"task-overflow margin-right-20\" flex>\n <span class=\"md-body-1\" ng-class=\"{\'completed-task\' : task.EndDate, \'inactive-task\': !task.IsActive}\" flex>{{task.Title}}</span>\n </div>\n <span class=\"md-caption margin-right-8 margin-top-5\">{{task.EstimatedHours}}</span>\n <b ng-if=\"!task.IsActive\" class=\"zmdi zmdi-block inactive-task\" style=\"font-size: 30px\"></b>\n </div>\n</div>\n</script>");
$templateCache.put("/app/alignus/directives/au-task-quickview/au-task-quickview.tmpl.html","<md-card class=\"widget\" layout-fill>\n <div class=\"bottom-shadow\" style=\"color: white;\n background-image: url(/assets/images/cards/slim/projects/tasks.png);\n background-size: 250px;\n background-position: 160px -34px;\n background-repeat: no-repeat;\n background-color: #39b54a;\n z-index:2;\">\n <div class=\"padding-20\" style=\"height:65px;\">\n <div class=\"md-headline\">Task Quickview</div>\n <div class=\"md-caption\">Most recent tasks</div>\n <md-button class=\"md-fab grow\" aria-label=\"My Tasks\" style=\"left:286px; background-color: #f79420;\" ui-sref=\'shell.project.all-tasks.list\'>\n <md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Go to My Tasks</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-assignment\"></md-icon>\n </md-button>\n </div>\n </div>\n <md-card-content style=\"padding:0; background-color: #FFF\">\n <md-tabs md-stretch-tabs=\"always\" md-selected=\"vm.currentTab\" md-align-tabs=\"bottom\" style=\"min-height: 367px !important;\">\n <md-tab ng-repeat=\"key in ::vm.tabKeys\" md-on-select=\"vm.loadTasks(key)\">\n <md-tab-label>\n <md-icon md-font-icon=\"{{::vm.taskTabs[key].icon}}\">\n <md-tooltip md-direction=\"top\">{{key}}</md-tooltip>\n </md-icon>\n </md-tab-label>\n <md-tab-body>\n <md-list>\n <div flex ng-repeat=\"task in vm.taskTabs[key].tasks | orderBy: \'DateCreated\' track by task._id\" class=\"margin-top-20 margin-bottom-20\">\n <md-list-item ng-click=\"vm.openTask(task)\">\n <div ng-if=\"!task.EndDate\" layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment-o\" class=\"margin-right-20\" style=\"color:#39B54A;\"></md-icon>\n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\">{{task.Title}}</span>\n <span ng-if=\"task.EstimatedHours != undefined\" class=\"md-caption\" style=\"line-height:20px;\">Estimated {{task.EstimatedHours}} Hours</span>\n </div>\n </div>\n <div ng-if=\"task.EndDate\" layout=\"row\" layout-align=\"start start\">\n <md-icon md-font-icon=\"zmdi zmdi-assignment-check\" class=\"margin-right-20\" style=\"color:rgba(0,0,0,0.3);\"></md-icon>\n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\" style=\"text-decoration: line-through; color: rgba(0,0,0,0.3)\">{{task.Title}}</span>\n <span ng-if=\"task.EstimatedHours != undefined\" class=\"md-caption opacity-50\" style=\"line-height:20px;\">Estimated {{task.EstimatedHours}} Hours</span>\n </div>\n </div>\n </md-list-item>\n </div>\n </md-list>\n <!--empty state-->\n <div ng-if=\"vm.taskTabs[key].tasks.length == 0\" layout=\"column\" layout-align=\"center center\" style=\"color:rgba(0,0,0,0.4);padding:40px 40px 80px 40px;\">\n <img src=\"/assets/images/empty-states/task.png\">\n <span class=\"md-headline font-weight-300\">Yikes</span>\n <span class=\"md-caption\">No tasks to display in this category!</span>\n <md-button ng-click=\"vm.openAddTask()\">\n <md-icon md-font-icon=\"au au-task-add\"></md-icon>\n <span>Add Task &nbsp;</span>\n </md-button>\n </div>\n </md-tab-body>\n </md-tab>\n </md-tabs>\n </md-card-content>\n</md-card>");
$templateCache.put("/app/alignus/directives/au-task-row/au-task-row.tmpl.html","<div class=\"au-task-row\" layout=\"row\" layout-align=\"start start\" layout-fill ng-mouseenter=\"hovered = true\" ng-mouseleave=\"hovered = false\" au-suspendable suspend-when=\"!hovered\" update-on-item=\"Task-{{task._id}}\">\n\n <!-- If hovered, show the checkbox -->\n <div ng-show=\"hovered || (task.Type || \'ToDo\') == \'ToDo\' || ($root.taskFab.isOpen && $root.taskFab.Task._id == task._id)\" class=\"docTask board no-animate\" ng-click=\"vm.openTaskFab($event, task)\">\n <input type=\"checkbox\" ng-checked=\"task.EndDate\" />\n <label></label>\n </div>\n <div ng-hide=\"hovered || (task.Type || \'ToDo\') == \'ToDo\' || ($root.taskFab.isOpen && $root.taskFab.Task._id == task._id)\">\n <i ng-class=\"\'zmdi au-task-\' + (task.Type || \'ToDo\') + \'-icon\'\"></i>\n </div>\n\n <div class=\"margin-right-20\" flex>\n <div layout=\"row\">\n <!--High Priority-->\n <b ng-if=\"task.TaskPriority == 1\" class=\"zmdi zmdi-alert-polygon\" style=\"color:rgba(255, 0, 0, 0.35); font-size:20px;\"></b>\n \n <!-- Title -->\n <textarea ng-model=\"task.Title\" placeholder=\"Title is required\" ng-class=\"{\'completed-task\' : task.EndDate, \'inactive-task\': !task.IsActive, \'focused\' : vm.focused}\"\n class=\"transparent-input no-animate\" ng-focus=\"vm.setFocus(true)\" ng-blur=\"vm.setFocus(false); vm.update()\" ng-click=\"vm.handleClick($event)\"\n au-grow-textarea rows=\"1\" ng-enter-key=\"vm.blur()\"></textarea>\n </div>\n\n <div class=\"opacity-60\">\n <!-- Who created (ideally, assigned) -->\n <span class=\"md-body-1\" ng-if=\"task.Creator != \'0\'.repeat(24) && task.User != task.Creator\" flex>&raquo; Assigned by: {{task.Creator | fullNameFilter}}</span>\n <span class=\"md-body-1\" ng-if=\"task.Creator == \'0\'.repeat(24)\" flex>&raquo; Created by Al Linus</span>\n <!-- The project/meeting/document title -->\n <span class=\"md-body-1\" ng-if=\"task.Parent()\" flex>&raquo; {{task.Parent().Title}}</span>\n <!-- The due date -->\n <span class=\"md-body-1\" ng-if=\"task.PlannedEndDate\" flex>&raquo; Due: {{task.PlannedEndDate | amCalendar:referenceTime:formats | replaceText:\'at 12:00 AM\':\'\' }}</span>\n </div>\n </div>\n\n <!-- If the task is inactive, put a block symbol on the line -->\n <b ng-if=\"!task.IsActive\" class=\"zmdi zmdi-block inactive-task\" style=\"font-size: 30px\"></b>\n\n <!-- Otherwise, show hours info -->\n <div ng-if=\"task.IsActive\" class=\"info\" layout=\"row\">\n <!-- If the task is running, show a timer -->\n <div layout=\"column\" class=\"timer-controls\" layout-align=\"start center\">\n <div class=\"md-caption timer\" ng-show=\"task.IsRunning\" ng-class=\"{joined: task.EstimatedHours}\">\n <au-timer layout=\"row\" duration=\"task.TotalDuration\" start-date=\"task.LastStartedRunning\" format=\"short\"></au-timer>\n </div>\n <div class=\"md-caption duration\" ng-show=\"!task.IsRunning && task.TotalDuration\" ng-class=\"{joined: task.EstimatedHours}\"\n ng-bind-html=\"$root.auUtility.formatDuration(task.TotalDuration, \'short\')\"></div>\n\n <div class=\"md-caption play-button no-animate\" ng-show=\"hovered\" layout=\"column\" layout-align=\"center center\" ng-click=\"vm.playClicked(task)\"\n ng-class=\"{joined: task.EstimatedHours, new: !task.IsRunning && !task.TotalDuration}\">\n <md-icon md-font-icon=\"zmdi zmdi-pause\" style=\"font-size:1em;\" ng-show=\"task.IsRunning\"></md-icon>\n <md-icon md-font-icon=\"zmdi zmdi-play\" style=\"font-size:1em;\" ng-show=\"!task.IsRunning\"></md-icon>\n <md-tooltip>Click to {{(task.IsRunning?\'Pause\':\'Start Timing\')}}</md-tooltip>\n </div>\n </div>\n\n <div ng-if=\"task.EstimatedHours\" class=\"md-caption estimated-hours\">\n {{task.EstimatedHours}} hr{{task.EstimatedHours != 1 ? \'s\' : \'\'}}\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-template-buttons/au-template-buttons.tmpl.html","<div layout-gt-xs=\"row\" layout=\"column\">\n <md-button class=\"md-icon-button\" ng-click=\"$root.auUtility.newItemFromTemplate(item._id, item.$key);$event.stopPropagation();\">\n <md-icon md-font-icon=\"zmdi zmdi-copy\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>Create Copy</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button\" ng-click=\"toggleTemplate($event)\">\n <md-icon ng-if=\"!item.IsTemplate\" md-font-icon=\"zmdi zmdi-lock-open\" style=\"color:#FFF;\"></md-icon>\n <md-icon ng-if=\"item.IsTemplate\" md-font-icon=\"zmdi zmdi-lock\" style=\"color:#FFF;\"></md-icon>\n <md-tooltip>{{ item.IsTemplate ? \'Unlock and Remove from Templates\' : \'Lock and Convert to Template\' }}</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button open-single\" ng-click=\"item.open(\'new\', \'?unlocktemplate=true\');$event.stopPropagation();\" ng-if=\"item.IsTemplate\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" style=\"color: #fff;\"></md-icon>\n <md-tooltip>Edit Template</md-tooltip> \n </md-button>\n</div>");
$templateCache.put("/app/alignus/directives/au-user-hover/au-user-hover.tmpl.html","<div class=\"material-shadow profile-user-hover expandwidth background-color-600\" layout=\"column\" layout-align=\"center stretch\">\n <div layout=\"row\" class=\"padding-10\">\n <div>\n <au-profile-image item=\"$parent.item\" size=\"40\"></au-profile-image>\n </div>\n <div layout=\"column\" layout-align=\"center start\" class=\"margin-left-5 faderight\">\n <span class=\"md-body-2\" style=\"color:#FFF;\">{{::$parent.item.FirstName}} {{::$parent.item.LastName}}</span>\n <span class=\"md-caption accent-color-100\">{{::$parent.item.Title}}</span>\n </div>\n </div>\n <div ng-click=\"$event.stopPropagation()\" layout=\"row\" class=\"fadeup\" style=\"border-radius: 0 0 10px 10px;background-color: #FFF;\" ng-if=\"!$root.user.$AnonymousUser\">\n <au-follow-star page=\"$parent.$parent.item._id\" class=\"scale\" id=\"BtnHoverFollow\"></au-follow-star>\n <md-button aria-label=\"high five\" class=\"md-icon-button scale md-primary\" id=\"BtnHoverHighFive\" ng-click=\"$parent.$parent.item.HighFive()\">\n <md-icon md-font-icon=\"au au-highfive\" ></md-icon>\n <md-tooltip>High-Five</md-tooltip>\n </md-button>\n <md-button aria-label=\"button\" class=\"md-icon-button scale md-primary\" ng-click=\"$parent.$parent.item.message()\" id=\"BtnHoverMessage\">\n <md-icon md-font-icon=\"zmdi zmdi-comment-alt\" ></md-icon>\n <md-tooltip>Message</md-tooltip>\n </md-button>\n <md-button aria-label=\"button\" class=\"md-icon-button scale md-primary\" ng-click=\"$parent.$parent.item.showProfile()\" id=\"BtnHoverUserDetail\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts-list-alt\" ></md-icon>\n <md-tooltip>User Profile</md-tooltip>\n </md-button>\n <md-button aria-label=\"button\" class=\"md-icon-button scale md-primary\" ng-click=\"$parent.$parent.item.visitPageRecentItem()\" id=\"BtnHoverProfile\">\n <md-icon md-font-icon=\"zmdi zmdi-face\" ></md-icon>\n <md-tooltip>Social Page</md-tooltip>\n </md-button>\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/au-wizard/au-wizard.tmpl.html","<md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n <span>{{wizard.title}}</span>\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"wizard.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\" ng-disabled=\"wizard.finished\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n</md-toolbar>\n\n<md-dialog-content layout-align=\"center center\" style=\"min-height: 350px\" flex>\n <div class=\"md-padding\" ng-transclude></div>\n</md-dialog-content>\n\n<md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"margin-bottom-15\">\n <md-button class=\"md-primary\" ng-click=\"wizard.prevStep()\" ng-disabled=\"wizard.currentStep == 0 || wizard.finishing || (wizard.finished && !wizard.finishError)\" ng-if=\"!wizard.newItem._id\"\n id=\"BtnPreviousStep\">\n Previous\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"wizard.nextStep()\" ng-disabled=\"wizard.finishing || wizard.disableNext\" ng-if=\"wizard.currentStep <= wizard.steps.length - 3\"\n style=\"margin-right:20px;\" id=\"BtnNextStep\">\n Next\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"wizard.finish()\" ng-disabled=\"wizard.reviewDetails.error || wizard.finishing\" ng-if=\"wizard.currentStep == wizard.steps.length - 2\"\n style=\"margin-right:20px;\" id=\"BtnFinishStep\">\n Finish\n </md-button>\n <md-button class=\"md-raised\" ng-class=\"{\'md-primary\':!wizard.newItem._id}\" ng-click=\"wizard.close()\" ng-disabled=\"wizard.finishing\" ng-if=\"wizard.currentStep == wizard.steps.length - 1 && !wizard.finishError\" aria-label=\"close\"\n ng-style=\"{\'margin-right\': wizard.newItem._id ? \'0\' : \'20px\'};\" id=\"BtnCloseStep\">\n Close\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"wizard.openItem()\" ng-if=\"vm.newItem._id\" \n style=\"margin-right:20px;\" id=\"BtnOpenItem\">\n Open Item\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"wizard.cancel()\" ng-if=\"wizard.finishError\" \n style=\"margin-right:20px;\" id=\"BtnCloseStep\">\n Cancel\n </md-button>\n</md-dialog-actions>");
$templateCache.put("/app/alignus/directives/au-workflows/au-workflows.tmpl.html","<div class=\"au-workflows\">\n <div layout=\"row\" layout-align=\"space-between center\" class=\"toolbar\">\n <md-menu>\n <md-button class=\"md-accent\" ng-click=\"$mdOpenMenu($event)\" ng-disabled=\"vm.item.Workflows.length == 0\" id=\"BtnSortWorkflows\">\n <md-icon md-font-icon=\"zmdi zmdi-sort\"></md-icon> Sort &nbsp;\n </md-button>\n <md-menu-content>\n <md-menu-item ng-repeat=\"sortDescriptor in vm.sortableBy\">\n <md-button ng-click=\"vm.setSortBy($index)\">\n {{sortDescriptor.display}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <div flex></div>\n <div layout=\"row\" layout-align=\"end center\" ng-show=\"!vm.onlyListProxy()\">\n <md-button class=\"md-raised md-accent\" ng-click=\"vm.openRequestApprovalDialog($event)\" id=\"BtnRequestApproval\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\"></md-icon><span hide-xs hide-sm>Request Approval &nbsp; </span>\n </md-button>\n </div>\n </div>\n \n <!-- Empty state -->\n <div ng-if=\"vm.workflows.length == 0\" class=\"margin-60\" layout=\"column\" layout-align=\"center center\">\n <img src=\"assets/images/empty-states/workflow.png\" style=\"max-width: 200px;\">\n <h1 class=\"md-headline opacity-50\">No Workflow</h1>\n <span class=\"md-body-1 opacity-50\">This item does not have any pending approval requests.</span>\n <span class=\"md-body-1 opacity-50\">Start by selecting the Request Approval button!</span>\n </div>\n\n <!-- The task rows-->\n <div ng-repeat=\"flow in vm.workflows track by flow._id\" ng-dblclick=\"flow.open()\">\n <au-task-row task=\"flow\"></au-task-row>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/directives/one-search/one-search.tmpl.html","<div style=\"position: relative\">\n <input type=\"text\" id=\"TxtOneSearchInput\" ng-attr-placeholder=\"{{vm.placeholder}}\" ng-focus=\"vm.isFocused=true\" ng-blur=\"vm.isFocused=false\"\n ng-model=\"vm.oneSearchInput\" ng-change=\"vm.getItemsMatchingSearch()\" class=\"md-whiteframe-z1 one-search-input\" ng-class=\"{focused:vm.isFocused}\"\n ng-keydown=\"vm.keyPressed($event)\" autocomplete=\"off\"/>\n <i class=\"zmdi zmdi-search search-input-icon\"></i>\n\n <div class=\"one-search-results md-whiteframe-1dp no-animate ng-hide\" ng-show=\"vm.showResults\">\n <div class=\"item no-animate margin-0\" layout-align=\"start start\" ng-class=\"{\'selected\':$index == vm.suggestIndex, \'header\': item.isSection, \'first\' : $first}\"\n ng-repeat=\"item in vm.results track by $index\">\n <div layout=\"row\" ng-if=\"item.isSection\">\n <img ng-if=\"item.icon\" width=\"20\" height=\"20\" class=\"icon\" s3-src=\"/assets/images/avatars/{{item.icon}}\" />\n <span class=\"section\">\n <b>{{item.sectionTitle}}</b>\n <span ng-if=\"item.sectionTitle != \'Top Results\' && item.sectionTitle != \'Searching...\' && item.sectionTitle != \'No Results\' && !vm.showingMore\">&nbsp;-\n <a ng-click=\"vm.showMore($event, item.sectionTitle)\">More</a>\n </span>\n </span>\n </div>\n <div layout=\"row\" ng-if=\"!item.isSection\" ng-click=\"vm.openItem(item, \'recent\')\" title=\"{{item.ModelName}}: {{item.SearchTitle}}\">\n <div layout=\"column\" class=\"margin-left-35\" flex>\n <span ng-bind-html=\"vm.highlightSuggestion((item.sectionTitle == \'Top Results\' ? \'<span style=\\\'color:#999\\\'>\' + item.ModelName + \':</span>&nbsp;\' : \'\') + item.SearchTitle)\" \n flex></span>\n \n <div layout=\"row\">\n <span ng-if=\"item.SearchMetadata.Tip\" class=\"md-caption\" style=\"color: green\">&raquo; {{item.SearchMetadata.Tip}} &nbsp;</span>\n <span ng-if=\"item.Creator && item.Creator != \'0\'.repeat(24)\" class=\"md-caption\" style=\"color: red\">&raquo; {{item.Creator | auItemFilter: \'User\'}} &nbsp;</span>\n <span class=\"md-caption\" style=\"color: purple\">&raquo; {{item.LastModified | date}}</span>\n </div>\n </div>\n <div class=\"new-tab\">\n <md-button class=\"md-icon-button\" ng-click=\"vm.openItem(item, \'new\')\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n </div>\n </div>\n <div class=\"all-results\" ng-if=\"vm.showingMore\">-- Showing All Results --</div>\n </div>\n <div class=\"one-search-results message md-whiteframe-1dp no-animate ng-hide\" ng-show=\"vm.showMessage\" ng-click=\"vm.overrideHook($event)\">\n {{vm.message}} - Click here to search globally.\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-page-about.tmpl.html","<md-card au-suspendable update-on-item=\"Page-{{vm.page._id}}\">\n <md-card-title>\n <md-card-title-text>\n <span class=\"widget-title\">About</span>\n <div ng-if=\"!vm.widget.$editing\">\n\n <!--Event Details-->\n <div ng-if=\"::vm.page.IsEvent()\">\n\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-30\">\n <div class=\"social-event-date md-whiteframe-2dp\">\n <span class=\"month\">{{::vm.getEventMonthString()}}</span>\n <span class=\"day\">{{::vm.getEventDayString()}}</span>\n <span class=\"week\">{{::vm.getEventDayOfWeekString()}}</span>\n </div>\n <div class=\"md-icon-float md-block padding-left-10\">\n <md-icon md-font-icon=\"zmdi zmdi-brightness-5\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">{{::vm.getEventDayOfWeekString()}}\n <br>\n </span>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"social-event-icons-white\"></md-icon>\n <span class=\"md-body-1\">{{vm.page.Event.Start | date : \'h:mma\'}}-{{(vm.page.Event.End | date : \'h:mma\')}}</span>\n <span class=\"md-body-1\">\n <br>\n </span>\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-right-4\">\n <md-icon ng-if=\"vm.page.Event.Location\" md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white\"></md-icon>\n </div>\n <div>\n <span ng-if=\"vm.page.Event.Location\" class=\"md-body-1\">{{vm.page.Event.Location | fullLocationFilter : \'full\'}}\n <br>\n </span>\n </div>\n </div>\n <div class=\"md-body-1\" id=\"StringPrivacy\" ng-if=\"vm.page.IsPrivate\">\n <md-icon md-font-icon=\"zmdi zmdi-globe-lock\" class=\"social-event-icons-white margin-right-4\"></md-icon>Private Event</div>\n <md-menu>\n <md-button ng-click=\"$mdOpenMenu($event)\" style=\"border-radius: 0;padding: 0;margin: -4px 0 0 0px;line-height: 0;text-transform: none;\"\n aria-label=\"calendar\">\n <span ng-if=\'!vm.page.EventHasUserResponded()\' class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" style=\"color:#FFF;\"></md-icon> Going?\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.page.EventDidUserSelect(\'Yes\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\" style=\"color:#FFF;\"></md-icon> Attending\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.page.EventDidUserSelect(\'Maybe\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\" style=\"color:#FFF;\"></md-icon> Maybe\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n <span ng-if=\"vm.page.EventDidUserSelect(\'No\')\" class=\"md-body-2\" style=\"color:#FFF;\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\" style=\"color:#FFF;\"></md-icon> Not Going\n <md-icon md-font-icon=\"zmdi zmdi-caret-down\" style=\"color:#FFF;\"></md-icon>\n </span>\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item>\n <md-button aria-label=\"Yes\" ng-click=\"vm.page.EventRespond(\'Yes\')\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-check\"></md-icon> Yes\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"Maybe\" ng-click=\"vm.page.EventRespond(\'Maybe\')\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-note\"></md-icon> Maybe\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button aria-label=\"No\" ng-click=\"vm.page.EventRespond(\'No\')\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-close\"></md-icon> No\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n </div>\n <div layout=\"column\" layout-align=\"start start\">\n <div class=\"margin-bottom-10\">\n <p class=\"md-body-1\" style=\"white-space: pre-wrap;\" dynamic=\"vm.page.SideBarWidgets[0].Data.PageDescription\"></p>\n </div>\n </div>\n <!--Attending-->\n <span class=\"md-body-2 margin-top-20 margin-bottom-10\">\n Attending\n <au-help-icon key=\"Page.Attending\" class=\"accent\"></au-help-icon>\n </span>\n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n <au-profile-image ng-repeat=\"attendee in vm.page.EventGetConfirmedAttendees()\" user=\'attendee\' size=\"40\" class=\"margin-6 grow\"\n ng-attr-id=\"BtnAttending{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n\n </div>\n <!--Event Details End-->\n\n <!--Page Details-->\n <div ng-if=\"!vm.page.IsEvent()\">\n <div layout=\"column\">\n <p ng-if=\"vm.widget.Data.PageDescription\" class=\"md-body-1\" style=\"white-space: pre-wrap;\" id=\"StringPageDescription\" dynamic=\"vm.widget.Data.PageDescription\"></p>\n <span ng-if=\"vm.widget.Data.contactPhone\" class=\"md-body-1\" id=\"StringPagePhone\">\n <md-icon md-font-icon=\"zmdi zmdi-phone\" class=\"social-event-icons-white margin-right-5\"></md-icon>{{vm.widget.Data.contactPhone}}</span>\n <span ng-if=\"vm.widget.Data.contactEmail\" class=\"md-body-1\" id=\"StringPageEmail\">\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"social-event-icons-white margin-right-5\"></md-icon>{{vm.widget.Data.contactEmail}}</span>\n <div ng-if=\"vm.widget.Data.contactAddress\" layout=\"row\" layout-align=\"start start\">\n <div>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"social-event-icons-white margin-right-5\"></md-icon>\n </div>\n <div>\n <span flex class=\"md-body-1\" id=\"StringPageAddress\">{{vm.widget.Data.contactAddress}}</span>\n </div>\n </div>\n <span class=\"md-body-1\" ng-if=\"vm.page.IsPrivate\">\n <md-icon md-font-icon=\"zmdi zmdi-globe-lock\" class=\"social-event-icons-white margin-right-5\"></md-icon>Private Page</span>\n </div>\n </div>\n\n <!--Page Editors-->\n <h1 class=\"md-body-2 margin-top-20 margin-bottom-10\">\n Editors\n <au-help-icon key=\"Page.Editor\" class=\"accent\"></au-help-icon>\n </h1>\n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n <au-profile-image ng-repeat=\"editor in vm.page.Editors\" user=\'editor\' size=\"40\" class=\"margin-6 grow\" ng-attr-id=\"BtnPageEditor{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n\n <!-- Followers -->\n <div ng-if=\"vm.page.Followers.length > 0\">\n <h1 class=\"md-body-2 margin-top-20 margin-bottom-10\">\n Followers\n <au-help-icon key=\"Page.Followers\" class=\"accent\"></au-help-icon>\n </h1>\n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap ng-init=\"vm.followerLimit = 5; vm.showAllFollowersButtons = true\">\n <au-profile-image user=\"follower.User\" ng-repeat=\"follower in vm.page.Followers | limitTo: vm.followerLimit\" size=\"40\" class=\"margin-6 grow\"\n ng-attr-id=\"BtnPageFollower{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n <md-button ng-if=\"vm.page.Followers.length > 5 && vm.showAllFollowersButtons == true\" ng-click=\"vm.followerLimit = 999; vm.showAllFollowersButtons = false\">Show All</md-button>\n </div>\n\n <!-- Members -->\n <div ng-if=\"vm.page.Members.length > 0\">\n <h1 class=\"md-body-2 margin-top-20 margin-bottom-10\">\n Members\n <au-help-icon key=\"Page.Member\" class=\"accent\"></au-help-icon>\n </h1>\n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n <au-profile-image ng-repeat=\"member in vm.page.Members\" user=\'member\' size=\"40\" class=\"margin-6 grow\" ng-attr-id=\"BtnPageMember{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n </div>\n\n <!-- Shared With -->\n <div ng-if=\"vm.page.SharedWith.length > 0\">\n <h1 class=\"md-body-2 margin-top-20 margin-bottom-10\">\n Shared With\n <au-help-icon key=\"Page.Viewer\" class=\"accent\"></au-help-icon>\n </h1>\n <div layout=\"row\" layout-align=\"start start\" layout-fill layout-wrap>\n <au-profile-image ng-repeat=\"viewer in vm.page.SharedWith\" user=\'viewer\' size=\"40\" class=\"margin-6 grow\" ng-attr-id=\"BtnPageViewer{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n </div>\n </div>\n </div>\n </md-card-title-text>\n </md-card-title>\n\n <!--Action Buttons-->\n <md-card-actions layout=\"row\" layout-align=\"end center\" class=\"margin-top-20\">\n <md-button ng-click=\"vm.openManagePageDialog($event)\" ng-if=\"vm.page.IsUserEditor($root.user._id)\" id=\"BtnManagePage\">\n <md-icon md-font-icon=\"zmdi zmdi-tune\" style=\"color:#fff\"></md-icon>\n <span> Manage Page</span>\n </md-button>\n <md-button ng-click=\"vm.addWidget($event)\" ng-if=\"vm.page.IsUserEditor($root.user._id)\" id=\"BtnAddWidget\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon> Add Widget</md-button>\n </md-card-actions>\n</md-card>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-page-events.tmpl.html","<md-card>\n <md-card-title>\n <md-card-title-text>\n <span class=\"widget-title\">Events</span>\n </md-card-title-text>\n </md-card-title>\n <md-card-content>\n <au-event-list-item ng-repeat=\"event in vm.widgetEvents\" event=\"event\"></au-event-list-item>\n <div class=\"margin-bottom-40\"></div>\n\n <!--empty state-->\n <div ng-if=\"vm.widgetEvents.length == 0\" layout=\"column\" layout-align=\"center center\" style=\"padding:30px;\">\n <div><img src=\"/assets/images/empty-states/calendar-blue.png\" class=\"fadeup\"></div>\n <span class=\"md-headline font-weight-300\" style=\"text-align:center;\">It’s looking dusty here.</span>\n <span class=\"md-caption\" style=\"text-align:center;\">When you create, join, or follow an event, you’ll see it here. Get on it!</span>\n </div>\n </md-card-content>\n</md-card>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-page-filter-posts.tmpl.html","<md-card>\n <md-card-title>\n <md-card-title-text>\n <div class=\"md-title\">Labeled Posts</div>\n <div class=\"md-caption\">Filter to show posts with label(s) you select.</div>\n </md-card-title-text>\n </md-card-title>\n <div class=\"labeled-container\">\n <div ng-repeat=\"label in vm.widget.Data\" layout=\"row\" layout-align=\"start center\" ng-mouseenter=\"hovered = true\" ng-mouseleave=\"hovered = false\" class=\"margin-bottom-10\">\n <div class=\"page-label\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.filterByLabel(label)\" ng-class=\"{selected:vm.currentLabels.indexOf(label) > -1}\">\n {{label}}\n </div>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeLabel($index, $event)\" ng-style=\"{opacity: hovered ? 1 : 0}\" ng-if=\"vm.page.IsUserEditor($root.user._id)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:#fff\"></md-icon>\n <md-tooltip>\n Remove Label\n </md-tooltip>\n </md-button>\n </div>\n\n <div ng-if=\"vm.addingLabel\" layout=\"row\" layout-align=\"center center\">\n <md-input-container flex class=\"margin-left-10 margin-bottom-0 text-white\">\n <label>New Label Name</label>\n <input type=\"text\" ng-model=\"vm.newLabelName\" maxlength=\"100\" />\n </md-input-container>\n <md-button class=\"md-icon-button\" ng-click=\"vm.completeAdd()\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon>\n <md-tooltip>\n Add\n </md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancelAdd()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"color:#fff\"></md-icon>\n <md-tooltip>\n Cancel\n </md-tooltip>\n </md-button>\n </div>\n\n <md-card-actions layout=\"row\" layout-align=\"end center\" class=\"margin-top-20\">\n <md-button ng-if=\"!vm.addingLabel && vm.page.IsUserEditor($root.user._id)\" ng-click=\"vm.addLabel()\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-plus\" style=\"color:#fff\"></md-icon>\n Add Label\n </md-button>\n </md-card-actions>\n </div>\n</md-card>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-page-pinned-post.tmpl.html","<!--Pinned Posts Widget-->\n<md-card>\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Pinned Posts</span>\n </md-card-title-text>\n </md-card-title>\n <!--pinned post-->\n <div class=\"pinned-container\"> \n <div layout=\"row\" layout-align=\"start center\" ng-repeat=\"post in vm.postBin\" ng-mouseenter=\"showRemove = true\" ng-mouseleave=\"showRemove = false\"\n class=\"margin-bottom-10 padding-5\" ng-attr-id=\"StringPinnedPost{{$index}}\">\n <div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.goToPost(post)\">\n <au-profile-image user=\"post.Creator\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <div layout=\"column\" layout-align=\"center start\" style=\"cursor: pointer;\">\n <span class=\"md-body-2\" style=\"color:white\">{{post.Creator | auItemFilter: \'User\'}}</span>\n <span class=\"md-caption\" style=\"color:white\">{{post.toString() | cut: true:50}}</span>\n <span class=\"md-caption\" style=\"color:white\" am-time-ago=\"post.DateCreated\"></span>\n </div>\n </div>\n <div ng-show=\"showRemove\">\n <md-button class=\"md-icon-button\" ng-click=\"vm.unpinPost(post)\" ng-attr-id=\"BtnRemovePost{{$index}}\">\n <md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Unpin</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-close\" style=\"color:#FFFFFF\"></md-icon>\n </md-button>\n </div>\n </div>\n </div>\n</md-card>\n");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-page-poll.tmpl.html","<!-- Poll Widget -->\n<md-card>\n <md-card-title>\n <md-card-title-text>\n <span class=\"md-title\">Poll Posts</span>\n <p class=\"md-body-1\">A widget that displays polls posted on this page.</p>\n </md-card-title-text>\n </md-card-title>\n\n <!--poll post-->\n <div class=\"pinned-container\">\n <div layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"poll in vm.pollBin\" ng-mouseenter=\"showRemove = true\" ng-mouseleave=\"showRemove = false\"\n class=\"margin-bottom-10 padding-5\" ng-attr-id=\"StringPollPost{{$index}}\">\n\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"poll.Creator\" size=\"30\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <div layout=\"column\" layout-align=\"center start\">\n <span class=\"md-body-2\" style=\"color:white\">{{poll.Creator | auItemFilter: \'User\'}}</span>\n <span class=\"md-caption\" style=\"color:white\">{{poll.Data.Poll.Question}}</span>\n </div>\n\n </div>\n<!-- <div ng-show=\"showRemove\">\n <md-button class=\"md-icon-button\" ng-click=\"poll.Unpin()\" ng-attr-id=\"BtnRemovePost{{$index}}\">\n <md-tooltip md-direction=\"left\" md-visible=\"tooltipVisible\">Remove</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:#FFFFFF\"></md-icon>\n </md-button>\n </div> -->\n </div>\n </div>\n</md-card>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/au-sidebar-widgets.tmpl.html","<div ng-attr-id=\"sidebar-widget-container{{vm.sidebarId}}\" as-sortable=\"vm.dragControlListeners\" ng-model=\"vm.page.SideBarWidgets\" long-touch=\"true\">\n <div class=\"sidebar-widget\" ng-repeat=\"item in vm.page.SideBarWidgets track by $index\" as-sortable-item ng-attr-id=\"Widget{{$index}}\" ng-model=\"item\">\n <div style=\"position: absolute; height: 50px; left: 8px; right: 8px;\">\n <div class=\"toolbar\" ng-if=\"vm.page.IsUserEditor($root.user._id)\" as-sortable-item-handle>\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <div class=\"padding-left-5\" style=\"color:white; text-shadow: 1px 1px 1px #ccc\" flex></div>\n\n <!--about help-->\n <au-help-icon key=\"Page.SidebarWidget.About\" class=\"edit-button\" ng-if=\"vm.page.SideBarWidgets[$index].Type == \'au-page-about\'\"></au-help-icon>\n\n <md-button class=\"edit-button md-icon-button\" ng-if=\"vm.page.SideBarWidgets[$index].Type != \'au-page-about\'\"\n ng-click=\"vm.page.SideBarWidgets.splice($index, 1);vm.page.$updateItem()\" ng-attr-id=\"BtnDeleteWidget{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n <md-tooltip>Remove widget</md-tooltip>\n </md-button>\n\n </div>\n </div>\n </div>\n <!-- widget is injected here -->\n </div>\n</div>");
$templateCache.put("/app/alignus/directives/task/au-inline-task.tmpl.html","<div layout=\"row\" layout-align=\"start center\" ng-class=\"{\'completed-task\' : vm.task.EndDate}\" class=\"padding-10\" style=\"white-space: normal\">\n <au-profile-image ng-if=\"vm.task.User\" user=\"vm.task.User\" size=\"20\"></au-profile-image>\n <span class=\"docTask board\" ng-click=\"vm.openTaskFab($event, vm.task)\">\n <input type=\"checkbox\" ng-checked=\"vm.task.EndDate\"/>\n <label></label>\n </span>\n <div class=\"task-overflow margin-right-20\" flex>\n <span flex>{{vm.task.Title}}</span>\n </div>\n <span class=\"md-caption margin-right-8 margin-top-5\">{{vm.task.EstimatedHours}}</span>\n</div>");
$templateCache.put("/app/alignus/layouts/ListViewer/addItemDialog.tmpl.html","<md-dialog class=\"au-dialog add-item-dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" ng-style=\"{\'background-image\': vm.getStepBg()}\" id=\"dialogContent_AddItem\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n <span id=\"StringAddItemHeader\">Add {{vm.itemType.name}}</span>\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\" ng-disabled=\"vm.newItem._id\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n\n <md-dialog-content layout-align=\"center center\" style=\"height: 380px; overflow: visible;\">\n <div class=\"md-padding full-height\">\n <div ng-if=\"vm.currentStep == \'intro\'\">\n <h3>Ready. Set. Add.</h3>\n <p dynamic=\"vm.steps.intro.text\"></p>\n <au-from-template-state-button ng-if=\"$root.$injector.get(\'Schema\').for(vm.itemType.name).supportsCopy\" item-type=\"{{vm.itemType.name}}\"></au-from-template-state-button> \n </div>\n <div ng-if=\"vm.currentStep == \'typeOrUpload\'\" class=\"typeOrUpload\">\n <h3>Do you want to type in a single {{vm.itemType.name.toLowerCase()}} or upload a list?</h3>\n <md-radio-group ng-model=\"vm.typeOrUpload\">\n <div layout=\"row\" layout-fill style=\"padding: 30px 10% 0 10%\">\n <div flex=\"50\" layout=\"column\" layout-align=\"start center\">\n <md-radio-button name=\"type\" value=\"type\" aria-label=\"type\" style=\"white-space: nowrap\" id=\"RdoTypeIn\">\n <img class=\"typeOrUploadImg\" aria-lable=\"type\" s3-src=\"{{vm.steps.typeOrUpload.type.image || \'/assets/images/dialogs/post-status.png\'}}\">\n <br> Type in a single {{vm.itemType.name.toLowerCase()}}\n </md-radio-button>\n </div>\n <div flex=\"50\" layout=\"column\" layout-align=\"start center\">\n <md-radio-button name=\"upload\" value=\"upload\" aria-label=\"type\" style=\"white-space: nowrap\" id=\"RdoUpload\">\n <img class=\"typeOrUploadImg\" s3-src=\"{{vm.steps.typeOrUpload.upload.image || \'/assets/images/dialogs/upload2.png\'}}\">\n <br> Upload a list\n </md-radio-button>\n </div>\n </div>\n </md-radio-group>\n </div>\n <div ng-if=\"vm.currentStep == \'type\'\">\n <h3>Type required fields here.</h3>\n <p>You\'ll type additional details after this wizard.</p>\n\n <md-input-container ng-repeat=\"field in vm.typeFields\">\n <label>{{field.display}}</label>\n <input ng-model=\"vm.newItem[field.name]\" ng-attr-id=\"TxtTypeInField{{$index}}\" md-autofocus=\"$index == 0\" required>\n </md-input-container>\n </div>\n <div ng-if=\"vm.currentStep == \'upload\'\">\n <h3>Upload file.</h3>\n\n\n <span>Align Us only accepts CSV files with a known set of headers.</span>\n <a target=\"_blank\" style=\"text-decoration: underline\" ng-href=\"{{vm.steps.typeOrUpload.upload.example}}\">Download an example file.</a>\n\n <div layout=\"column\" layout-align=\"start center\" class=\"padding-top-30\" layout-fill>\n <md-button class=\"md-primary md-raised material-shadow\" ngf-select ng-model=\"vm.file\" ngf-multiple=\"false\" ngf-capture=\"\'other\'\" ngf-pattern=\"\'.csv\'\" accept=\".csv\" id=\"BtnSelectFile\">\n Select File To Upload\n </md-button>\n <p class=\"padding-top-10\">{{vm.file.name}}</p>\n </div>\n\n </div>\n <div ng-repeat=\"step in vm.extraSteps\" ng-if=\"vm.currentStep == \'extra\' + $index\" dynamic=\"step.contents\"></div>\n <div ng-if=\"vm.currentStep == \'review\'\">\n <h3>Review!</h3>\n <p>Please review the following, and if it\'s all good, go ahead and click Finish.</p>\n <table>\n <tr ng-repeat=\"detail in vm.reviewDetails()\" style=\"height: 30px\" ng-attr-id=\"StringReviewDetail{{$index}}\">\n <td>{{detail.name}}:</td>\n <td class=\"padding-left-30\">{{detail.value}}</td>\n </tr>\n </table>\n </div>\n <div ng-if=\"vm.currentStep == \'complete\'\">\n <h3 ng-if=\"!vm.finishError\" id=\"StringConfirm\">You did it!</h3>\n <p ng-if=\"vm.finishError\" style=\"color: red\" ng-bind-html=\"vm.finishError\" id=\"StringErrorMessage\"></p>\n <p ng-if=\"!vm.finishError && vm.typeOrUpload == \'type\'\">{{vm.steps.typeOrUpload.type.successText}}</p>\n <p ng-if=\"!vm.finishError && vm.typeOrUpload == \'upload\'\">{{vm.steps.typeOrUpload.upload.successText}}</p>\n <input type=hidden id=\"HdnNewId\" value=\"{{vm.newId}}\" />\n </div>\n </div>\n </md-dialog-content>\n\n <md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"margin-bottom-20\">\n <md-button class=\"md-raised md-primary\" ng-if=\"!vm.newItem._id\" ng-click=\"vm.prevStep()\" ng-disabled=\"vm.currentStepIndex == 0 || vm.finished || vm.finishing\" aria-label=\"previous\" id=\"BtnPreviousStep\">\n Previous\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.nextStep()\" ng-disabled=\"vm.finishing\" ng-if=\"vm.currentStepIndex <= vm.stepOrder.length - 3\" aria-label=\"next\" style=\"margin-right:20px;\" id=\"BtnNextStep\">\n Next\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" ng-disabled=\"vm.reviewError || vm.finishing\" ng-if=\"vm.currentStepIndex == vm.stepOrder.length - 2\" aria-label=\"next\" style=\"margin-right:20px;\" id=\"BtnFinishStep\">\n Finish\n </md-button>\n <md-button class=\"md-raised\" ng-class=\"{\'md-primary\':!vm.newItem._id}\" ng-click=\"vm.close()\" ng-if=\"vm.currentStepIndex == vm.stepOrder.length - 1\" aria-label=\"next\" ng-style=\"{\'margin-right\':vm.newItem._id?\'\':\'20px\'};\" id=\"BtnCloseStep\">\n Close\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.openItem()\" ng-if=\"vm.newItem._id\" aria-label=\"next\" style=\"margin-right:20px;\" id=\"BtnCloseStep\">\n Open Item\n </md-button>\n </md-dialog-actions>\n\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/ListViewer/itemDialog.tmpl.html","<div class=\"mobile-fullwidth-dialog item-dialog\" ng-class=\"{\'pinned\' : $root.notificationsPanelPinned}\" flex=\"85\" flex-sm=\"100\"\n flex-md=\"80\" id=\"DialogRecentItem\">\n <div class=\"recent-item-container\" layout=\"row\" layout-align=\"end center\">\n <!--<au-profile-image item=\"Item\" size=\"35\"></au-profile-image>-->\n <div class=\"recent-item-pointer\" ng-style=\"{right: recentItemPointerRight + \'px\'}\"></div>\n </div>\n\n <div class=\"item-dialog-content\">\n <md-progress-circular md-mode=\"indeterminate\" ng-if=\"!loaded\" style=\"margin:auto; position: absolute; left: calc(50% - 50px); top: 50px;\"></md-progress-circular>\n <ng-include src=\"::ItemDialogTemplate\" ng-if=\"loaded\"></ng-include>\n <img src=\"/assets/images/clear.gif\" height=\"300\" class=\"bottom-spacer\">\n </div>\n</div>\n\n<md-button class=\"window-fab md-fab md-accent\" ng-if=\"$root.windowFab.showCloseItem && !$root.$mdDialogOpen && !$root.windowFab.forceHide\" md-no-focus-style=\"true\" ng-click=\"closeThisDialog()\" id=\"BtnItemDialogClose\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"close\"></md-icon>\n</md-button>");
$templateCache.put("/app/alignus/layouts/ListViewer/no-records.tmpl.html","<md-content layout=\"column\" layout-align=\"end center\" layout-fill>\n <div flex layout=\"column\" layout-align=\"center center\" style=\"color: rgba(0,0,0,0.4);\">\n <img id=\"ImgListViewerEmpty\" s3-src=\"/assets/images/empty-states/desk.gif\" />\n <div layout=\"column\" layout-align=\"center center\" style=\"position: relative; top: -100px;\">\n <span class=\"md-display-1\">Nothing to show yet.</span>\n <span class=\"md-subhead\">Get started by using the add button below.</span>\n </div>\n </div>\n\n</md-content>");
$templateCache.put("/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html","<div class=\"one-search-toolbar clip\" layout=\"row\" layout-align=\"center center\">\n <div flex=\"25\" layout=\"row\" layout-align=\"start center\">\n <md-checkbox class=\"select-all-checkbox md-primary font-color-500\" ng-model=\"list.allSelected\" ng-change=\"list.selectAllChanged()\" ng-click=\"$event.stopPropagation()\"\n aria-label=\"select all\" title=\"Select All\" id=\"CbxSelectAll\">\n <span ng-if=\"$mdMedia(\'gt-xs\')\" style=\"padding-right: 10px\"><span ng-if=\"$mdMedia(\'min-width: 900px\')\">Select&nbsp;</span>All</span>\n </md-checkbox>\n <md-menu-bar>\n <md-menu>\n <button class=\"md-primary md-button\" ng-click=\"$mdOpenMenu($event)\" id=\"BtnSort\">\n <md-icon md-font-icon=\"zmdi zmdi-sort-amount-asc\"></md-icon><span ng-if=\"$mdMedia(\'gt-xs\')\">Sort</span>\n </button>\n <md-menu-content class=\"md-dense\">\n <!-- primary fields -->\n <md-menu-item type=\"checkbox\" ng-repeat=\"field in list.primaryItemFields\" ng-model=\"list.sortedBy[field.name]\" ng-click=\"list.sortBy(field.name, $event)\" ng-attr-id=\"BtnSortOption{{$index}}\">\n <md-button>{{field.display}}</md-button>\n </md-menu-item>\n <!-- all other fields in the More... menu -->\n <md-menu-item class=\"md-indent\" ng-if=\"list.moreItemFields.length > 0\">\n <md-menu>\n <md-button ng-click=\"$mdOpenMenu()\">More...</md-button>\n <md-menu-content style=\"max-height: 90vh; overflow-y: auto\">\n <md-menu-item type=\"checkbox\" ng-repeat=\"field in list.moreItemFields\" ng-model=\"list.sortedBy[field.name]\"\n ng-click=\"list.sortBy(field.name, $event)\">\n <md-button>\n {{field.display}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </md-menu-item>\n\n <md-menu-divider></md-menu-divider>\n <md-menu-item type=\"checkbox\" ng-model=\"list.sortDirectionAsc\" ng-click=\"list.sortDirection(\'asc\')\" id=\"BtnSortAscending\">Sort Ascending (A-Z)</md-menu-item>\n <md-menu-item type=\"checkbox\" ng-model=\"list.sortDirectionDesc\" ng-click=\"list.sortDirection(\'desc\')\" id=\"BtnSortDescending\">Sort Descending (Z-A)</md-menu-item>\n <md-menu-divider></md-menu-divider>\n <md-menu-item type=\"checkbox\" ng-model=\"list.showGroupHeaders\" ng-click=\"list.refresh()\" id=\"BtnSortHeaders\">Show Group Headers</md-menu-item>\n <md-menu-item type=\"checkbox\" ng-model=\"list.showInactive\" ng-click=\"list.refresh()\" id=\"BtnSortInactive\">Show Inactive</md-menu-item>\n </md-menu-content>\n </md-menu>\n </md-menu-bar>\n </div>\n <div flex=\"50\" layout=\"row\" layout-align=\"center center\">\n <div class=\"batch-actions\" ng-show=\"list.atLeastOneSelected\" layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-primary md-raised\" ng-disabled=\"list.getSelected().length > 1\" ng-click=\"list.openItem(list.getSelected()[0])\" id=\"BtnOpenItem\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\" ng-if=\"$mdMedia(\'gt-sm\')\"></md-icon>\n <span>Open<span ng-if=\"$mdMedia(\'min-width: 1100px\')\"> Item</span>\n\n <md-tooltip ng-if=\"list.getSelected().length > 1\">Cannot open more than one item at a time. Double-click/long-tap an item to open it.</md-tooltip>\n </span>\n </md-button>\n\n <md-button class=\"md-primary md-raised\" ng-click=\"list.removeItems(list.getSelected(), $event)\" ng-disabled=\"!list.hasPermission(list.listSettings.removePermissionNeeded)\" id=\"BtnRemoveItem\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" ng-if=\"$mdMedia(\'gt-sm\')\"></md-icon>\n <span>Remove<span ng-if=\"$mdMedia(\'min-width: 1100px\')\"> {{list.getSelected().length > 1 ? list.getSelected().length : \'\'}} Item{{list.getSelected().length > 1 ? \'s\' : \'\'}}</span>\n\n <md-tooltip ng-if=\"!list.hasPermission(list.listSettings.removePermissionNeeded)\">Not authorized</md-tooltip>\n </span>\n </md-button>\n\n <!--<md-menu-bar>-->\n <md-menu md-offset=\"0 45\">\n <md-button class=\"md-primary md-raised\" ng-click=\"$mdOpenMenu($event)\"id=\"BtnMoreActions\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" ng-if=\"$mdMedia(\'gt-sm\')\"></md-icon><span>More<span ng-if=\"$mdMedia(\'min-width: 1100px\')\"> Actions</span></span>\n </md-button>\n <md-menu-content class=\"one-search-more-actions\">\n <strong style=\"padding: 0 0 10px 20px\">For the {{list.getSelected().length}} selected item{{list.getSelected().length > 1 ? \'s\' : \'\'}}...</strong>\n <md-menu-item>\n <md-button ng-click=\"list.downloadAsCsv(list.getSelected(),$event)\" id=\"BtnDownloadAsCsv\">\n <md-icon md-font-icon=\"zmdi zmdi-download\" class=\"zmdi-hc-fw\"></md-icon>\n Download as a .csv file\n </md-button>\n </md-menu-item>\n <!-- Security and Sharing to go here -->\n <md-menu-item class=\"md-indent\" ng-repeat=\"(id,action) in list.listSettings.batchActions\" ng-if=\"list.hasPermission(action.permissionNeeded)\">\n <md-button ng-click=\"action.action(list.getSelected(),$event)\" ng-attr-id=\"BtnMoreActionsOption{{$index}}\">\n <md-icon md-font-icon=\"{{action.icon}}\" class=\"zmdi-hc-fw\"></md-icon>\n {{action.text}}\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <!--</md-menu-bar>-->\n </div>\n <div class=\"search-input\" ng-show=\"!list.atLeastOneSelected\" layout=\"row\" layout-align=\"center center\">\n <one-search flex=\"100\" mode=\"items\"></one-search>\n </div>\n </div>\n\n <!-- two versions: mobile/desktop -->\n <div flex=\"25\" class=\"font-color-500\" layout=\"row\" layout-align=\"center center\" ng-if=\"$mdMedia(\'gt-xs\')\" id=\"ViewContainer\">\n <span style=\"font-size: 14px; text-transform: uppercase; font-weight: 500; margin-right: 5px;\" ng-if=\"$mdMedia(\'min-width: 700px\')\">View</span>\n <md-button class=\"md-icon-button md-primary\" ng-repeat=\"view in ::list.listSettings.viewTypes\" style=\"min-width: 30px; margin:0; padding: 0\"\n ng-disabled=\"$state.params.view.toLowerCase() == view.toLowerCase()\" ng-click=\"list.changeToView(view)\" ng-attr-id=\"BtnListView{{$index}}\">\n <md-icon md-font-icon=\"{{view | viewicon}}\" class=\"font-color-500\" ng-style=\"{opacity: $state.params.view == view.toLowerCase() ? 1 : 0.5}\" style=\"font-size: 25px; margin-top: 3px;\">\n </md-icon>\n <md-tooltip>{{view}} {{$state.params.view == view.toLowerCase() ? \' (Active)\' : \'\'}}</md-tooltip>\n </md-button>\n </div>\n <div flex=\"25\" class=\"font-color-500\" layout=\"row\" layout-align=\"center center\" ng-if=\"!$mdMedia(\'gt-xs\')\">\n <md-menu md-position-mode=\"target-right target\">\n <md-button aria-label=\"View\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-menu-origin md-font-icon=\"{{$state.params.view | viewicon}}\"></md-icon>\n </md-button>\n <md-menu-content width=\"3\">\n <md-menu-item ng-repeat=\"view in ::list.listSettings.viewTypes\">\n <md-button ng-click=\"list.changeToView(view)\">\n <div layout=\"row\" flex>\n <p style=\"text-transform: uppercase; padding-right: 30px\" flex>{{view}} {{$state.params.view == view.toLowerCase() ? \' (Active)\' : \'\'}}</p>\n <md-icon md-font-icon=\"{{view | viewicon}}\" md-menu-align-target></md-icon>\n </div>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n</div>");
$templateCache.put("/app/alignus/layouts/ListViewer/removeItemDialog.tmpl.html","<md-dialog flex=\"50\" flex-sm=\"100\" flex-md=\"60\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>\n <span>Remove {{vm.itemCount}} Item{{vm.itemCount > 1 ? \'s\' : \'\'}}?</span>\n </h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel(\'cancelled\')\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n\n <md-dialog-content layout-align=\"center center\">\n <div class=\"md-padding\">\n <div ng-if=\"vm.itemType == \'Team\' || vm.itemType == \'Department\' || vm.itemType == \'Location\'\">\n Removing this {{vm.itemType}} will also remove its Handbok, Philosophy, and Page.\n </div>\n <h3>This action cannot be undone.</h3>\n\n <div ng-if=\"vm.showConfirmationSignature\">\n <p style=\"margin-bottom: 40px\">\n Type your name exactly as <b>{{$root.user.FirstName}} {{$root.user.LastName}}</b> to confirm the removal of {{vm.itemCount}}\n item{{vm.itemCount > 1 ? \'s\' : \'\'}}.\n </p>\n <md-input-container>\n <label>Confirmation Signature</label>\n <input ng-model=\"vm.confimationSignature\" md-autofocus id=\"TxtSignature\">\n </md-input-container>\n </div>\n </div>\n </md-dialog-content>\n \n <md-dialog-actions layout=\"row\" layout-align=\"end center\" class=\"margin-bottom-20 margin-right-20\">\n <md-button ng-click=\"vm.cancel(\'cancelled\')\" aria-label=\"cancel\" style=\"margin-right:20px;\" id=\"BtnCancel\">\n Cancel\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-disabled=\"vm.removeStarted\" ng-click=\"vm.confirmRemove($event, this)\" id=\"BtnRemove\">\n Remove {{vm.itemCount}} Item{{vm.itemCount > 1 ? \'s\' : \'\'}}\n </md-button>\n </md-dialog-actions>\n\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/_shell/_shell.tmpl.html","<div layout=\"row\" class=\"full-height\" id=\"shell-layout\">\n\n <!-- left sidebar -->\n <md-sidenav id=\"shell-navbar\" class=\"md-whiteframe-4dp\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" ng-class=\"{\'pinned\': $root.leftPanelPinned}\"\n md-component-id=\"left\" ng-include=\"::\'/app/alignus/layouts/_shell/side-nav.tmpl.html\'\" ng-if=\"::!$root.isShellPeek\">\n </md-sidenav>\n\n <div layout=\"column \" flex layout-fill>\n\n <!-- top toolbar -->\n <md-toolbar id=\"shell-toolbar\" class=\"md-primary\" ng-include=\"::\'/app/alignus/layouts/_shell/main-toolbar.tmpl.html\'\" ng-if=\"::!$root.isShellPeek\">\n </md-toolbar>\n\n <!-- main content -->\n <div layout=\"row\" ui-view flex layout-fill id=\"content-panel\" class=\"overflow-hidden\" ng-if=\"$root.showMainContent\"></div>\n\n <ng-include src=\"::\'/app/alignus/layouts/_shell/window-fab.tmpl.html\'\" ng-if=\"!$root.isShellPeek && (!$root.rightSideNavIsOpen || $root.notificationsPanelPinned) && !$root.peekIsOpen\"></ng-include>\n </div>\n\n <!-- right sidebar -->\n <ng-include layout=\"column\" src=\"::\'/app/alignus/layouts/_shell/notifications-panel.tmpl.html\'\" ng-controller=\"NotificationsPanelController as vm\"\n ng-if=\"!$root.isShellPeek\"></ng-include>\n\n <!--chat bottom bar-->\n <div class=\"chat-bottom-bar\" layout=\"row\" ng-include=\"::\'/app/alignus/layouts/chat-bar/bottom-chat.tmpl.html\'\" ng-show=\"::!$root.isShellPeek\"\n ng-if=\"$root.showBottomChat\">\n </div>\n</div>\n\n<ng-include src=\"::\'/app/alignus/layouts/_shell/au-global-elements.html\'\"></ng-include>");
$templateCache.put("/app/alignus/layouts/_shell/au-global-elements.html","<div id=\"offline-message\" class=\"ng-hide\" ng-show=\"$root.offline\">\n Working offline! Look around but changes will not be saved!\n</div>\n\n<au-suspendable suspend-when=\"!$root.peekIsOpen\">\n <md-card id=\"shell-peek\" class=\"md-image-no-fill\" ng-if=\"::!$root.isShellPeek\">\n <md-card-content ng-hide=\"$root.peekOpenNewTabUrl.startsWith(\'/social/page/\')\">\n <div id=\"TxtDocTitle\" class=\"md-display-1\" layout=\"row\" layout-align=\"start center\">\n\n {{$root.peekTitle}}\n\n <span flex></span>\n\n <md-button class=\"md-icon-button big-icon-button ng-hide\" ng-click=\"$root.openPeekInNewTab()\" ng-show=\"peekOpenNewTabUrl\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open In New Browser Tab</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"$root.closePeek()\" id=\"BtnPeekClose\" ng-hide=\"$root.peekTitle == \'Post Editor\'\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" class=\"md-primary\"></md-icon>\n <md-tooltip>Close</md-tooltip>\n </md-button>\n </div>\n </md-card-content>\n <div ng-show=\"$root.peekOpenNewTabUrl.startsWith(\'/social/page/\')\" class=\"toolbar\">\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"$root.openPeekInNewTab()\" style=\"background-color: rgba(255,255,255,.5);\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open In New Browser Tab</md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"$root.closePeek()\" id=\"BtnPeekClose\" style=\"background-color: rgba(255,255,255,.5);\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" class=\"md-primary\"></md-icon>\n <md-tooltip>Close</md-tooltip>\n </md-button>\n </div>\n\n <iframe ng-hide=\"$root.peekDoc || $root.peekImg\" ng-src=\"{{$root.peekUrl}}\"></iframe>\n <md-card-content ng-if=\"$root.peekImg\" layout=\"column\" layout-align=\"start center\">\n <img class=\"peekImg\" ng-src=\"{{$root.peekImg}}\" />\n </md-card-content>\n </md-card>\n</au-suspendable>\n\n<!-- task fab -->\n<au-suspendable suspend-when=\"!$root.taskFab.isOpen\">\n <div ng-show=\"$root.taskFab.isOpen\" class=\"taskFAB md-whiteframe-1dp angular-animate\" layout-align=\"center start\" ng-style=\"{\'top\': $root.taskFab.top, \'left\': $root.taskFab.left, \'bottom\' : $root.taskFab.bottom, \'flex-direction\': ($root.taskFab.openTop ? \'column-reverse\' : \'\')}\"\n ng-click=\"$event.stopPropagation()\" flex-order=\"reverse\" layout=\"column\">\n <div layout=\"row\" layout-align=\"center start\" layout-fill>\n\n <!-- Checkbox -->\n <div ng-if=\"$root.taskFab.Task.EndDate\" class=\"fabButton\">\n <md-button ng-disabled=\"!$root.taskFab.Task.CanEdit()\" ng-click=\"$root.docTask.setFinished(null)\" class=\"md-icon-button\"\n aria-label=\"Mark as Incomplete\" id=\"BtnQuickIncomplete\">\n <md-icon md-font-icon class=\'au au-square-check\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Mark as Incomplete</span>\n </md-tooltip>\n </md-button>\n </div>\n <div ng-if=\"!$root.taskFab.Task.EndDate\" class=\"fabButton\">\n <md-button ng-disabled=\"!$root.taskFab.Task.CanEdit()\" ng-click=\"$root.docTask.setFinished(\'now\')\" class=\"md-icon-button\"\n aria-label=\"Mark as Complete\" id=\"BtnQuickComplete\">\n <md-icon md-font-icon class=\'au au-square\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Mark as Complete</span>\n </md-tooltip>\n </md-button>\n </div>\n\n <div ng-click=\"$root.taskFab.showTab(\'details\'); $event.stopPropagation()\" class=\"fabButton\">\n <md-button class=\"md-icon-button\" aria-label=\"Details\" id=\"BtnQuickEditDetail\">\n <md-icon md-font-icon class=\'zmdi zmdi-edit\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Quick Edit</span>\n </md-tooltip>\n </md-button>\n </div>\n\n <div ng-click=\"$root.taskFab.showTab(\'dates\'); $event.stopPropagation()\" class=\"fabButton\">\n <md-button class=\"md-icon-button\" aria-label=\"Dates\" id=\"BtnQuickEditDates\">\n <md-icon md-font-icon class=\'zmdi zmdi-calendar\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Quick Edit Dates</span>\n </md-tooltip>\n </md-button>\n </div>\n\n <div ng-click=\"$root.taskFab.showTab(\'description\'); $event.stopPropagation()\" class=\"fabButton\">\n <md-button class=\"md-icon-button\" aria-label=\"Description\" id=\"BtnQuickDescription\">\n <md-icon md-font-icon class=\'au au-task-list\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Description</span>\n </md-tooltip>\n </md-button>\n </div>\n\n <span style=\"font-size: 2.6rem; margin: 0 10px\" class=\"opacity-30\">|</span>\n\n <div ng-click=\"$root.docTask.openTask($root.taskFab.Task);\" class=\"fabButton\">\n <md-button class=\"md-icon-button\" aria-label=\"Task Item\" id=\"BtnQuickOpen\">\n <md-icon md-font-icon class=\'zmdi zmdi-open-in-browser\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Open Task</span>\n </md-tooltip>\n </md-button>\n </div>\n\n\n <div class=\"fabButton\">\n <md-button ng-disabled=\"!$root.taskFab.Task.CanEdit()\" ng-click=\"$root.docTask.confirmThenRemove($event, $root.taskFab.Task);\"\n class=\"md-icon-button\" aria-label=\"Task Item\" id=\"BtnQuickRemove\">\n <md-icon md-font-icon class=\'zmdi zmdi-delete\' style=\"font-size: 3rem; color: red;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Remove Task</span>\n </md-tooltip>\n </md-button>\n </div>\n\n <div flex></div>\n\n <div ng-click=\"$root.taskFab.isOpen = false\" class=\"fabButton\">\n <md-button id=\"BtnCloseTaskFab\" class=\"md-icon-button\">\n <md-icon md-font-icon class=\'zmdi zmdi-close\' style=\"font-size: 3rem;\"></md-icon>\n <md-tooltip md-direction=\"down\">\n <span class=\"md-caption\">Close</span>\n </md-tooltip>\n </md-button>\n </div>\n </div>\n\n <!--Task Detail-->\n <div ng-if=\"$root.taskFab.showTaskDetails\" ng-click=\"$event.stopPropagation()\" layout=\"column\" layout-align=\"start start\"\n class=\"taskTab\" au-can-edit=\"$root.taskFab.Task\" acl=\"U\">\n\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <md-input-container flex>\n <label>Task Title</label>\n <textarea ng-model=\"$root.taskFab.Task.Title\" rows=\"2\" id=\"TaskFabTitle\" md-detect-hidden style=\"border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: rgba(0,0,0,0.12);\"></textarea>\n </md-input-container>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-time\" class=\"margin-right-10\"></md-icon>\n <md-input-container class=\"md-icon-float md-block\" flex>\n <label>Estimated Hours</label>\n <div>\n <input ng-model=\"$root.taskFab.Task.EstimatedHours\" type=\"number\" id=\"TaskFabNumEstimatedHours\" />\n </div>\n </md-input-container>\n </div>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-icon md-font-icon=\"au au-reassign\" class=\"margin-right-10\"></md-icon>\n <md-autocomplete md-selected-item=\"$root.taskFab.Task.User\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"user in $root.auUtility.searchUsers({query:$root.taskFabAssignedToSearchText})\"\n md-search-text=\"$root.taskFabAssignedToSearchText\" md-item-text=\"user | auItemFilter: \'User\'\" md-floating-label=\"Assigned User\"\n id=\"TxtUserAssign\" flex>\n <md-item-template>\n <span md-highlight-text=\"$root.taskFabAssignedToSearchText\" md-highlight-flags=\"i\" id=\"TaskFabAutoUserAssign{{$index}}\">{{user | auItemFilter: \'User\'}}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n </div>\n\n <div layout=\"row\" layout-fill>\n <div flex>\n <md-input-container>\n <md-select ng-model=\"$root.taskFab.Task.KanbanState\" id=\"TaskFabBtnStateMenu\" placeholder=\"Task State\">\n <md-option ng-repeat=\"state in $root.kanbanStates\" ng-value=\"state.text\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"{{state.icon}}\" ng-style=\"{\'color\':state.iconColor};\" style=\"margin-left:-4px;\"\n class=\"margin-right-12\"></md-icon>\n <p flex ng-attr-id=\"TaskFabBtnStateOption{{$index}}\">{{state.text}}</p>\n </div>\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n <div flex>\n <md-input-container>\n <md-select ng-model=\"$root.taskFab.Task.TaskPriority\" id=\"TaskFabBtnPriorityMenu\" placeholder=\"Task Priority\">\n <md-option ng-repeat=\"priority in $root.taskPriorities\" ng-value=\"priority.number\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"{{priority.icon}}\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex ng-attr-id=\"TaskFabBtnPriorityOption{{$index}}\">{{priority.text}}</p>\n </div>\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n </div>\n\n <div layout=\"row\" layout-fill>\n <md-select ng-model=\"$root.taskFab.linkTaskWith\" ng-disabled=\"$root.taskFab.Task.Project||$root.taskFab.Task.Meeting||$root.taskFab.Task.Document\">\n <md-option>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"zmdi zmdi-folder\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex>Project</p>\n </div>\n </md-option>\n <md-option>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"au au-meeting\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex>Meeting</p>\n </div>\n </md-option>\n <md-option>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-menu-align-target md-font-icon=\"zmdi zmdi-file-text\" style=\"margin-left:-4px;\" class=\"margin-right-12\"></md-icon>\n <p flex>Document</p>\n </div>\n </md-option>\n </md-select>\n\n <!--Assigned to Project-->\n <div ng-show=\"$root.taskFab.linkTaskWith == \'Project\'\" layout=\"row\" layout-align=\"start center\" flex class=\"margin-left-10\">\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"$root.taskFab.Task.Project\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"project in $root.auUtility.searchProjects(vm.projectSearchText, {Type: [\'U\']})\" md-search-text=\"vm.projectSearchText\"\n md-floating-label=\"Assigned to Project\" md-item-text=\"project | projectFilter\" id=\"TxtProjectAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.projectSearchText\" md-highlight-flags=\"i\" id=\"AutoProjectAssign{{$index}}\">{{ project | projectFilter }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"$root.taskFab.Task.Project\" ng-click=\"$root.taskFab.Task.$Project.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Project</md-tooltip>\n </md-button>\n </div>\n\n <!--Assigned to Meeting-->\n <div ng-show=\"$root.taskFab.linkTaskWith == \'Meeting\'\" layout=\"row\" layout-align=\"start center\" flex class=\"margin-left-10\">\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"$root.taskFab.Task.Meeting\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"meeting in $root.auUtility.searchMeetings(vm.meetingSearchText, {Type: [\'U\']})\" md-search-text=\"vm.meetingSearchText\"\n md-floating-label=\"Assigned to Meeting\" md-item-text=\"meeting | meetingFilter\" id=\"TxtMeetingAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.meetingSearchText\" md-highlight-flags=\"i\" id=\"AutoMeetingAssign{{$index}}\">{{ meeting | meetingFilter }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"$root.taskFab.Task.Meeting\" ng-click=\"$root.taskFab.Task.$Meeting.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Meeting</md-tooltip>\n </md-button>\n </div>\n\n <!--Assigned to Document-->\n <div ng-show=\"$root.taskFab.linkTaskWith == \'Document\'\" layout=\"row\" layout-align=\"start center\" flex class=\"margin-left-10\">\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"$root.taskFab.Task.Document\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"document in $root.auUtility.searchDocuments(vm.documentSearchText, {Type: [\'U\']})\" md-search-text=\"vm.documentSearchText\"\n md-floating-label=\"Assigned to Document\" md-item-text=\"document | auItemFilter: \'Document\'\" id=\"TxtDocumentAssign\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.documentSearchText\" md-highlight-flags=\"i\" id=\"AutoDocumentAssign{{$index}}\">{{ document | auItemFilter: \'Document\' }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"$root.taskFab.Task.Document\" ng-click=\"$root.taskFab.Task.$Document.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Document</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <!--Parent Task-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n <md-autocomplete class=\"margin-left-10\" flex md-selected-item=\"$root.taskFab.Task.ParentTask\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-items=\"task in $root.auUtility.searchTasks(vm.taskSearchText, {Type: [\'U\']})\" md-search-text=\"vm.taskSearchText\" md-floating-label=\"Parent Task\"\n md-item-text=\"task | auItemFilter: \'Task\'\" id=\"TxtParentTask\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.taskSearchText\" md-highlight-flags=\"i\" id=\"AutoParentTask{{$index}}\">{{ task | auItemFilter: \'Task\' }}\n </span>\n </md-item-template>\n\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-show=\"$root.taskFab.Task.ParentTask\" ng-click=\"$root.taskFab.Task.$ParentTask.open(\'recent\')\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open Parent Task</md-tooltip>\n </md-button>\n </div>\n </div>\n\n <!--Description Tab -->\n <div ng-if=\"$root.taskFab.showDescription\" ng-click=\"$event.stopPropagation()\" style=\"height: 302px; overflow: hidden; visibility: visible;\"\n class=\"cke taskTab\">\n\n <b dynamic=\"$root.taskFab.Task.Title\"></b>\n\n <div ng-if=\"$root.taskFab.Task.CanEdit()\" class=\"au-cke-document text-area margin-top-15\" ng-model=\"$root.taskFab.Task.Details\"\n max-height=\"220\" placeholder=\"Description\" id=\"CkeTaskDescription\" style=\"background-color: rgba(255, 255, 255, .87); border-radius: 4px;\"\n grow=\"false\"></div>\n\n <div ng-if=\"!$root.taskFab.Task.CanEdit()\" dynamic=\"$root.taskFab.Task.Details\" class=\"cke_reset cke_wysiwyg_div taskFab-description\"\n style=\"background-color: transparent; overflow: visible;\"></div>\n </div>\n\n <!-- Date Tab -->\n <div ng-if=\"$root.taskFab.showEventDetails\" ng-click=\"$event.stopPropagation()\" class=\"taskTab\" au-can-edit=\"$root.taskFab.Task\"\n acl=\"U\">\n <b dynamic=\"$root.taskFab.Task.Title\"></b>\n <div layout=\"row\" layout-align=\"space-between center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-alt\"></md-icon>\n <mdp-date-picker mdp-placeholder=\"Planned Start Date\" mdp-open-on-click ng-model=\"$root.taskFab.Task.PlannedStartDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtPlanStartDate\"></mdp-date-picker>\n <div class=\"margin-5\">\n <md-icon md-font-icon=\"zmdi zmdi-long-arrow-right\"></md-icon>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n <mdp-date-picker mdp-placeholder=\"Planned End Date\" mdp-open-on-click ng-model=\"$root.taskFab.Task.PlannedEndDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtPlannedEndDate\"></mdp-date-picker>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-calendar-alt\"></md-icon>\n <mdp-date-picker mdp-placeholder=\"Actual Start Date\" mdp-open-on-click ng-model=\"$root.taskFab.Task.StartDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtActualStartDate\"></mdp-date-picker>\n <div class=\"margin-5\">\n <md-icon md-font-icon=\"zmdi zmdi-long-arrow-right\"></md-icon>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\"></md-icon>\n <!-- <input type=\"date\" ng-model=\"$root.taskFab.Task.EndDate\" id=\"TxtQuickActualEndDate\" /> -->\n <mdp-date-picker mdp-placeholder=\"Actual End Date\" mdp-open-on-click ng-model=\"$root.taskFab.Task.EndDate\" mdp-format=\"M/D/YYYY\"\n mdp-min-date=\"\'2000-01-01\'\" mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex id=\"TxtActualEndDate\"></mdp-date-picker>\n </div>\n </div>\n </div>\n</au-suspendable>\n\n<!-- tour -->\n<au-suspendable suspend-when=\"!vm.auTour.isOpen\">\n <div class=\"tour-tip ng-hide\" ng-show=\"vm.auTour.isOpen\">\n <span class=\"tour-arrow tt-{{ vm.auTour.currentTour.tourtipPlacement }}\" ng-hide=\"centered\"></span>\n <div class=\"tour-content-wrapper\" layout=\"row\">\n <div ng-if=\"vm.auTour.currentTour.image\" class=\"image\">\n <img ng-src=\"{{vm.auTour.currentTour.image}}\">\n </div>\n <div flex>\n <h3 dynamic=\"vm.auTour.currentTour.tourtipHeader\"></h3>\n <p dynamic=\"vm.auTour.currentTour.tourtipText\"></p>\n </div>\n </div>\n <a ng-click=\"vm.auTour.nextStep()\" dynamic=\"vm.auTour.currentTour.tourtipNextLabel\" class=\"tour-next-tip\"></a>\n <a ng-click=\"vm.auTour.markCurrentStateDone()\" class=\"tour-close-tip\">×</a>\n </div>\n</au-suspendable>\n\n\n<!-- emojiFullscreen -->\n<div class=\"emojiFullscreen backdrop\" style=\"display: none\" layout=\"column\" layout-align=\"start center\"></div>\n<div class=\"emojiFullscreen content\" style=\"display: none\" layout=\"column\" layout-align=\"center center\">\n <!-- <img src=\"/assets/images/blank.png\" /> will be prepended via script-->\n <div class=\"md-display-3 md-primary message\"></div>\n</div>");
$templateCache.put("/app/alignus/layouts/_shell/main-toolbar.tmpl.html","<div class=\"md-toolbar-tools main-toolbar actual\" layout=\"row\" layout-align=\"start center\">\n <!--hide menu and logo when large-->\n <md-button class=\"margin-left-10 margin-right-0 hide-gt-sm\" ng-click=\"vm.toggleSideNav(\'left\')\" aria-label=\"side navigation\"\n style=\"min-width: 30px;\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\"></md-icon>\n </md-button>\n\n <!--breadcumbs-->\n <div flex=\"100\" id=\"breadcrumb-container\" class=\"breadcrumb-container margin-left-30\" ng-cloak>\n <div class=\"breadcrumb angular-animate\" ng-repeat=\"crumb in vm.breadcrumbs\" ng-class=\"{ active: $last }\">\n <div class=\"breadcrumb-text\" ng-if=\"!$last\">\n <a ui-sref=\"{{ crumb.self.name }}({{crumb.navigationData.srefOpts}})\" ng-style=\"{maxWidth: vm.crumbMaxWidth + \'px\'}\">{{crumb.self.navigationData.breadcrumbTitle}}</a>\n\n <md-icon md-menu-origin md-font-icon=\"zmdi zmdi-chevron-right\" class=\"noMenu\" ng-if=\"!crumb.self.navigationData.menuItems\"></md-icon>\n <md-menu md-position-mode=\"target-right target\" ng-if=\"crumb.self.navigationData.menuItems\">\n <md-button aria-label=\"Open menu\" class=\"md-icon-button breadcrumb-menu-icon\" ng-click=\"$mdOpenMenu($event)\" ng-attr-id=\"BtnBreadcrumbOpen{{::$index}}\">\n <md-icon md-menu-origin md-font-icon=\"zmdi zmdi-chevron-right\"></md-icon>\n </md-button>\n\n <md-menu-content width=\"3\" class=\"breadcrumb-menu\" ng-attr-id=\"SetBreadcrumbMenu{{::$index}}\" style=\"max-height: 85vh\">\n <md-menu-item class=\"breadcrumb-menu-item\" ng-repeat=\"menuItem in ::crumb.self.navigationData.menuItems\" ng-if=\"::(menuItem.permissionNeeded == undefined || $eval(menuItem.permissionNeeded))\"\n layout=\"row\" layout-align=\"start center\">\n <div ng-if=\"menuItem.isSectionHeader\" class=\"breadcrumb-section-header\">{{::menuItem.sectionHeader}}</div>\n <md-button ng-if=\"!menuItem.isSectionHeader\" ng-click=\"go(menuItem)\" layout=\"row\" layout-align=\"start center\" ng-attr-id=\"BtnBreadcrumbMenuItem{{::$index}}\">\n <p flex>{{::menuItem.title }}</p>\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n <div ng-if=\"$last\" class=\"breadcrumb-text last\" ng-style=\"{maxWidth: vm.crumbMaxWidth + \'px\'}\">\n {{crumb.self.navigationData.breadcrumbTitle }}\n </div>\n </div>\n </div>\n\n <!--My Tasks-->\n <div style=\"width: 38px; height: 38px; margin-right: 10px; background-color: rgba(255,255,255,.12); border-radius: 50%; box-sizing: border-box;\"\n layout=\"column\" layout-align=\"center center\" hide show-gt-xs id=\"BtnMyTasks\">\n <md-button class=\"md-icon-button\" ng-click=\"$root.showMyTasks = true\">\n <md-icon md-font-icon=\"au au-task-check\" style=\"color: white; padding-right: 2px;\"></md-icon>\n <md-tooltip>\n <div>My Tasks</div>\n </md-tooltip>\n <au-popover class=\"scrollable-content toolbar-my-tasks\" open=\"$root.myTasksIsOpen\" style=\"width: 500px; max-height: 85vh;\">\n <au-suspendable suspend-when=\"!$root.myTasksIsOpen\" ng-if=\"$root.showMyTasks\">\n <au-my-tasks></au-my-tasks>\n </au-suspendable>\n </au-popover>\n </md-button>\n </div>\n\n <!--Send Menu-->\n <div style=\"width: 38px; height: 38px; margin-right: 10px; background-color: rgba(255,255,255,.12); border-radius: 50%; box-sizing: border-box;\"\n layout=\"column\" layout-align=\"center center\" hide show-gt-xs>\n <md-menu layout=\"column\" layout-align=\"center center\" layout-fill id=\"BtnSendMenu\" md-position-mode=\"target-right target\">\n <md-button class=\"md-icon-button\" aria-label=\"Send Menu\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-menu-origin md-font-icon=\"zmdi zmdi-mail-send\" style=\"color: white;\"></md-icon>\n <md-tooltip>\n <div>Send Menu</div>\n </md-tooltip>\n </md-button>\n <md-menu-content style=\"max-height:400px\">\n <div>\n <h3 class=\"margin-0 padding-10 font-weight-400\" style=\"line-height: 30px\">Send Menu</h3>\n <!--Compose Message-->\n <md-menu-item>\n <md-button ng-click=\"$root.composeMessage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/compose.png\" />\n <div>Compose Message</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--High Five-->\n <md-menu-item>\n <md-button ng-click=\"$root.sendHighFive()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/high-five.png\" />\n <div>Send High Five</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Post to Page-->\n <md-menu-item>\n <md-button ng-click=\"$root.postToPage()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/post-to-page.png\" />\n <div>Post to Page</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Ask Question-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.QnA.CanCreate\">\n <md-button ng-click=\"$root.askQuestion()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/ask.png\" />\n <div>Ask Question</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Request Approval-->\n <md-menu-item>\n <md-button ng-click=\"$root.requestApproval()\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/request.png\" />\n <div>Request Approval</div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n </md-menu-content>\n </md-menu>\n </div>\n\n <!--Quick Add Item-->\n <div style=\"width: 38px; height: 38px; margin-right: 10px; background-color: rgba(255,255,255,.12); border-radius: 50%; box-sizing: border-box; \"\n layout=\"column\" layout-align=\"center center\" hide show-gt-xs>\n <md-menu layout=\"column\" layout-align=\"center center\" layout-fill id=\"BtnQuickAdd\" md-position-mode=\"target-right target\">\n <md-button class=\"md-icon-button\" aria-label=\"Quick Add\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-menu-origin md-font-icon=\"zmdi zmdi-plus\" style=\"color: white; padding-right: 3px\"></md-icon>\n <md-tooltip>\n <div>Quick Add Item</div>\n </md-tooltip>\n </md-button>\n <md-menu-content style=\"max-height: 80vh;\">\n <div>\n <h3 class=\"margin-0 padding-10 font-weight-400\" style=\"line-height: 30px\">Quick Add...</h3>\n <!--Project-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.Projects.CanCreate\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Project\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/project.png\" />\n <div>Project</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Document-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.Documents.CanCreate\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Document\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/document.png\" />\n <div>Document</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Task-->\n <md-menu-item>\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Task\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/task.png\" />\n <div>Task</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Meeting-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.Meetings.CanCreate\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Meeting\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/meeting.png\" />\n <div>Meeting</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Page-->\n <md-menu-item ng-show=\"::$root.user.EffPerms.Pages.CanCreate\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Page\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/page.png\" />\n <div>Page</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--Contact -->\n <md-menu-item ng-if=\"::$root.user.EffPerms.Contacts.CanCreate\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'Contact\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/user.png\" />\n <div>Contact</div>\n </div>\n </md-button>\n </md-menu-item>\n <!--User -->\n <md-menu-item ng-if=\"::$root.user.IsUserAdmin\">\n <md-button ng-click=\"$root.auUtility.addNewItem(\'User\')\">\n <div layout=\"row\" layout-align=\"start center\">\n <img style=\"height: 25px; width: 25px;\" class=\"margin-right-10\" ng-src=\"/assets/images/avatars/user.png\" />\n <div>User</div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n </md-menu-content>\n </md-menu>\n </div>\n\n <!--Recent Items-->\n <div style=\"width: 38px; height: 38px; margin-right: 10px; background-color: rgba(255,255,255,.12); border-radius: 50%; box-sizing: border-box\"\n ng-controller=\"RecentItemsController as ri\" layout=\"column\" layout-align=\"center center\" hide show-gt-xs>\n <md-menu layout=\"column\" layout-align=\"center center\" layout-fill md-position-mode=\"target-right target\">\n <md-button class=\"md-icon-button\" aria-label=\"All recent items\" ng-click=\"$mdOpenMenu($event)\" id=\"BtnRecentItems\">\n <md-icon md-menu-origin md-font-icon=\"zmdi zmdi-time-restore\" style=\"color: white; padding-right: 2px;\"></md-icon>\n <md-tooltip>\n <div>Recent Items</div>\n </md-tooltip>\n </md-button>\n <md-menu-content style=\"min-height: 90vh; max-width: 60vw; min-width: 250px;\" class=\"recent-items\" au-suspendable update-on-event=\"recent\">\n <div ng-if=\"$root.showRecentItems\">\n <div class=\"recent-items-menu\" ng-if=\"$root.user.getGeneralRecentItems().length > 0\">\n <h3 class=\"margin-0 padding-10 font-weight-400\" style=\"line-height: 30px\">All Recent Items...</h3>\n <md-menu-item ng-repeat=\"recentItem in $root.user.getGeneralRecentItems() track by (recentItem.item.$key + recentItem.item._id)\"\n ng-click=\"recentItem.item.open()\">\n <md-button aria-label=\"{{::recentItem.item.toString()}}\">\n <div layout=\"row\" layout-align=\"start center\" class=\"recent-item\">\n <au-profile-image item=\"recentItem.item\" size=\"25\" flex=\"shrink\" class=\"margin-right-40\"></au-profile-image>\n <div flex=\"grow\" ng-bind=\"(recentItem.item.$key == \'Page\' ? \'Page for \' : \'\') + recentItem.item.toString()\"></div>\n <div class=\"new-tab\">\n <!-- pointer-events needed when md-tooltip is inside a menu-item-->\n <md-button class=\"md-icon-button\" ng-click=\"recentItem.item.open(\'new\'); $event.stopPropagation()\" style=\"pointer-events: auto\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n <div class=\"recent-items-menu md-padding\" ng-if=\"$root.user.getGeneralRecentItems().length == 0\" style=\"max-width: 250px\">\n <h3>No Recent Items :-(</h3>\n <p class=\"md-body-1\">\n You haven\'t open anything yet. As you view items they will appear here.\n </p>\n <!--<p class=\"md-body-1\">\n The last three items will also appear to the right, where it says \"No recent items yet.\", for one-click access to the most\n recent things you\'ve looked at in Align Us.\n </p>-->\n </div>\n </div>\n </md-menu-content>\n </md-menu>\n </div>\n\n <div class=\"border-right-color-contrast\" style=\"border-right: 1px solid rgba(255, 255, 255, .2); height: 40px; width: 1px;\"\n hide show-gt-xs></div>\n\n <!--Notification and Profile icons-->\n <md-button ng-hide=\"$root.notificationsPanelPinned\" class=\"md-icon-button toolbar-button no-animate\" ng-click=\"vm.toggleNotificationsTab(\'zmdi-comments\')\"\n aria-label=\"Messages\" id=\"BtnMessages\">\n <md-icon md-font-icon=\"zmdi zmdi-comments\"></md-icon>\n <div class=\"toolbar-button-badge background-accent\" ng-if=\"Conversation.TotalUnreadPosts\" theme-background=\"accent\">\n {{Conversation.TotalUnreadPosts}}\n </div>\n <md-tooltip>\n Inbox &amp; Video Calling\n </md-tooltip>\n </md-button>\n\n <md-button class=\"md-icon-button toolbar-button margin-right-20\" aria-label=\"Help and settings\" ng-click=\"vm.toggleNotificationsTab(\'zmdi-help\')\"\n aria-label=\"side navigation\" id=\"BtnUserMenu\">\n <au-profile-image item=\"$root.user\" size=\"30\">\n <md-tooltip>\n Help &amp; Settings\n </md-tooltip>\n </md-button>\n</div>");
$templateCache.put("/app/alignus/layouts/_shell/notifications-panel.tmpl.html","<md-button class=\"pin-sidebar ng-hide background-primary no-animate\" aria-label=\"pin sidebar\"\n ng-click=\"vm.pinSidebar()\" ng-show=\"$root.notificationsPanelPinned || $root.rightSideNavIsOpen\" hide show-gt-xs>\n <md-icon ng-show=\"!$root.notificationsPanelPinned\" md-font-icon=\"au au-pin\" class=\"rotate no-animate\" style=\"transform: rotate(-45deg); -webkit-transform: rotate(-45deg);\"></md-icon>\n <md-icon ng-show=\"$root.notificationsPanelPinned\" md-font-icon=\"zmdi zmdi-square-right\" class=\"no-animate\"></md-icon>\n <md-tooltip>\n {{($root.notificationsPanelPinned ? \'Un-pin sidebar\' : \'Pin sidebar\')}}\n </md-tooltip>\n</md-button>\n\n<md-sidenav md-is-locked-open=\"$root.notificationsPanelPinned\" md-is-open=\"$root.rightSideNavIsOpen\" class=\"md-sidenav-right md-whiteframe-z2 notifications-panel\"\n md-component-id=\"notifications\" layout=\"column\" flex>\n <md-content flex layout=\"column\" au-suspendable suspend-when=\"!($root.notificationsPanelPinned || $root.rightSideNavIsOpen)\">\n <md-tabs flex md-stretch-tabs=\"always\" md-selected=\"vm.currentTab\" md-no-pagination=\"true\">\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <md-tooltip>\n Video Call\n </md-tooltip>\n </md-tab-label>\n <md-tab-body>\n <md-content class=\"full-height\">\n <au-suspendable suspend-when=\"vm.currentTab != 0\">\n <ng-include ng-if=\"$root.showMainContent\" src=\"::\'/app/alignus/layouts/notifications-panel/tab-video-calls.tmpl.html\'\" ng-controller=\"SidebarTabVideoCallController as vm\"></ng-include>\n </au-suspendable>\n </md-content>\n </md-tab-body>\n </md-tab>\n <md-tab>\n <md-tab-label>\n <md-icon md-font-icon=\"zmdi zmdi-comments\"></md-icon>\n <span class=\"toolbar-button-badge background-accent\" ng-if=\"Conversation.TotalUnreadPosts\">\n {{Conversation.TotalUnreadPosts}}\n </span>\n <md-tooltip>\n Inbox\n </md-tooltip>\n </md-tab-label>\n <md-tab-body>\n <au-suspendable suspend-when=\"vm.currentTab != 1\">\n <div ng-if=\"!vm.shownTabs[\'zmdi-comments\']\" style=\"height: 300px\" layout=\"column\" layout-align=\"center center\">\n <div id=\"loading-img\"></div>\n <div id=\"loading-message\">Loading Inbox...</div>\n </div>\n <ng-include src=\"::\'/app/alignus/layouts/notifications-panel/tab-conversations.tmpl.html\'\" ng-controller=\"SidebarTabConversationsController as vm\"\n ng-if=\"vm.shownTabs[\'zmdi-comments\']\"></ng-include>\n </au-suspendable>\n </md-tab-body>\n </md-tab>\n <md-tab>\n <md-tab-label layout=\"row\" layout-align=\"start center\">\n <md-icon ng-show=\"sdjakfa\" md-font-icon=\"zmdi zmdi-help\"></md-icon>\n <au-profile-image item=\"$root.user\" size=\"30\" id=\"BtnProfileTab\" style=\"margin-right:-30px; margin-top:5px;\"></au-profile-image>\n <md-tooltip>\n Help and Settings\n </md-tooltip>\n </md-tab-label>\n <md-tab-body>\n <md-content class=\"full-height\" style=\"overflow: hidden\">\n <div ng-if=\"!vm.shownTabs[\'zmdi-help\']\" style=\"height: 300px\" layout=\"column\" layout-align=\"center center\">\n <div id=\"loading-img\"></div>\n <div id=\"loading-message\">Loading Help...</div>\n </div>\n <au-suspendable suspend-when=\"vm.currentTab != 2\">\n <ng-include src=\"::\'/app/alignus/layouts/notifications-panel/tab-help.tmpl.html\'\" ng-controller=\"SidebarTabHelpController as vm\"\n style=\"overflow-x: hidden;\" ng-if=\"vm.shownTabs[\'zmdi-help\']\"></ng-include>\n </au-suspendable>\n </md-content>\n </md-tab-body>\n </md-tab>\n </md-tabs>\n </md-content>\n</md-sidenav>");
$templateCache.put("/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html","<div class=\"one-search-toolbar\" layout=\"row\" layout-align=\"center center\">\n <div class=\"search-input\" layout=\"row\" layout-align=\"center center\" flex=\"50\">\n <one-search flex=\"100\"></one-search>\n </div>\n</div>");
$templateCache.put("/app/alignus/layouts/_shell/side-nav.tmpl.html","<div class=\"au-sidenav\">\n <md-toolbar class=\"md-toolbar-tools md-primary main-toolbar no-animate\">\n <md-button class=\"toolbar-fullheight-button link-button\" ui-sref=\"shell.home\" aria-label=\"Home\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image item=\"$root.Organization\" size=\"40\" ng-if=\"$root.Organization.Photo\" style=\"position:relative; left: 3px;\"></au-profile-image>\n <md-icon md-font-icon=\"au au-align-badge nav-icon\" style=\"margin-top: 5px;\" ng-if=\"!$root.Organization.Photo\"></md-icon>\n <span flex class=\"nav-title\" style=\"color: white\">Dashboard</span>\n </div>\n </md-button>\n </md-toolbar>\n\n <md-list layout=\"column\" class=\"sidenav hide-overflow-x\">\n <md-list-item ng-repeat=\"link in $root.sideNavLinks | filter: {enabled:true}\">\n <md-button class=\"link-button\" aria-label=\"{{::link.title}}\" ng-click=\"vm.goToState($index)\" ng-attr-id=\"BtnMainTool{{::$index}}\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"au\" ng-class=\"::link.icon\" class=\"nav-icon\">\n </md-icon>\n <span class=\"nav-title\" flex>{{::link.title}}</span>\n <md-tooltip md-direction=\"right\" class=\"nav-tooltip\">\n {{::link.title}}\n </md-tooltip>\n </div>\n </md-button>\n </md-list-item>\n </md-list>\n</div>");
$templateCache.put("/app/alignus/layouts/_shell/window-fab.tmpl.html","<div ng-if=\"!$root.windowFab.windowFabHidden && $root.windowFab.getVisibleButtons().length > 0 && !$root.$mdDialogOpen && !$root.windowFab.forceHide\">\n <md-fab-speed-dial md-direction=\"up\" class=\"md-scale window-fab angular-animate\"\n layout-align=\"center end\">\n <md-fab-trigger>\n\n <div class=\"flip-container\">\n <div class=\"flipper\">\n <div class=\"front\">\n <md-button class=\"md-fab md-accent\" aria-label=\"new\" id=\"BtnMainFab\">\n <md-icon md-font-icon ng-class=\"$root.getItemFabIcon() || $state.$current.data.fabIcon\"></md-icon>\n </md-button>\n <md-progress-circular id=\"autoSaveProgress\" md-diameter=\"58\" md-mode=\"determinate\" value=\"{{$root.saveProgressValue}}\"></md-progress-circular>\n </div>\n <div class=\"back\">\n <md-button class=\"md-fab\" style=\"background-color: #00943c;\" aria-label=\"new\" id=\"BtnMainFabSaved\">\n <md-icon md-font-icon=\"zmdi zmdi-check\">\n </md-button>\n </div>\n </div>\n </div>\n\n </md-fab-trigger>\n <md-fab-actions layout-align=\"center end\">\n <div ng-click=\"button.action($event)\" ng-if=\"::button.permissionNeeded == undefined || $eval(button.permissionNeeded)\" ng-repeat=\"button in ($root.getItemFabButtons() || $state.$current.data.fabButtons)\">\n <span class=\"alwaysVisibleFabTooltip\">{{::button.title}}</span>\n <md-button class=\"md-fab md-accent md-mini\" ng-attr-id=\"BtnMiniFab{{::$index}}\">\n <md-icon md-font-icon ng-class=\"::button.icon\"></md-icon>\n </md-button>\n </div>\n </md-fab-actions>\n </md-fab-speed-dial>\n</div>\n<md-button class=\"window-fab md-fab md-accent\" ng-click=\"$root.closeListItem()\" id=\"BtnListItemClose\" ng-show=\"$root.windowFab.showCloseItem && !$root.recentItemOpen && !$root.$mdDialogOpen && !$root.windowFab.forceHide\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"close\"></md-icon>\n</md-button>\n<div class=\"window-fab-tooltip\" ng-if=\"$root.fabTooltip && !$root.windowFab.forceHide\" ng-style=\"{opacity:$root.rootTooltipVisible?1:0}\">\n {{$root.fabTooltip}}\n</div>");
$templateCache.put("/app/alignus/layouts/card-viewer/card-viewer.tmpl.html","<div class=\"card-viewer\" layout=\"column\" layout-fill id=\"Background\" ng-click=\"list.deselectAll()\">\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html\'\"></div>\n\n <md-content style=\"background: transparent\">\n <div class=\"one-search-content-buffer\"></div>\n <div ng-repeat=\"group in list.itemGroups track by group.groupHeader\" ng-cloak ng-if=\"group.items.length > 0\" ng-click=\"list.deselectAll()\"\n class=\"no-outline\" ng-attr-id=\"SpaceForCards\">\n <div class=\"card-group-header\" ng-attr-id=\"GroupHeader{{$index}}\">\n <md-checkbox ng-model=\"group.$selected\" ng-change=\"list.markGroupAs(group.groupId, group.$selected)\" ng-click=\"$event.stopPropagation()\">\n {{group.groupHeader}}\n </md-checkbox>\n </div>\n <div class=\"md-padding padding-bottom-0\" layout=\"row\" layout-wrap>\n <au-item-card item=\"item\" ng-repeat=\"item in group.items track by item._id\"></au-item-card>\n \n\n </div>\n </div>\n </md-content>\n</div>");
$templateCache.put("/app/alignus/layouts/chat-bar/bottom-chat.tmpl.html","<div class=\"chat-tab-container\" ng-repeat=\"chat in vm.chats.chats\" ng-click=\"chat.conversationPage.MarkPostsRead()\">\n <div class=\"chat-window md-whiteframe-3dp\" layout=\"column\" ng-click=\"vm.chats.setChatTabActive(chat.conversationPage._id)\"\n ng-class=\"{\'active\' : chat.$isActive, \'unread\' : chat.conversationPage.$UnreadCount}\">\n <div class=\"chat-title background-primary\" layout=\"row\" layout-align=\"center center\">\n <span class=\"unread-count background-accent md-whiteframe-3dp\" ng-if=\"chat.conversationPage.UnreadCounts[$root.user._id]\">\n {{ chat.conversationPage.UnreadCounts[$root.user._id] }}\n </span>\n <au-profile-image item=\"chat.conversationPage\" size=\"20\"></au-profile-image>\n <div class=\"title-bar\" ng-click=\"chat.poppedOpen = !chat.poppedOpen\">\n {{chat.conversationPage.toString(true)}}\n </div>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"chat.poppedOpen = !chat.poppedOpen; vm.scroll1($index)\" aria-label=\"minimize chat\"\n ng-attr-id=\"BtnMinimizeChat{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-window-minimize\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"chat.poppedOpen = true; chat.maximized = !chat.maximized; vm.scroll1($index)\"\n aria-label=\"close chat\" ng-attr-id=\"BtnMaximizeChat{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-window-maximize\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"chat.openAsRecentItem()\" aria-label=\"maximize chat\" ng-attr-id=\"BtnChatRecentItem{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right-top\"></md-icon>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.chats.closeChat(chat.conversationPage._id)\" aria-label=\"close chat\" ng-attr-id=\"BtnCloseChat{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n\n <div class=\"chat-body\" ng-show=\"chat.poppedOpen\">\n <div class=\"settings-bar\">\n <div layout=\"row\" layout-align=\"space-between center\">\n <div layout=\"row\" layout-align=\"start center\" class=\"margin-left-10\" layout-fill layout-wrap>\n <au-profile-image ng-repeat=\"member in chat.conversationPage.$Members | limitTo: 8\" item=\'member\' size=\"20\" ng-attr-id=\"BtnPageMember{{$index}}\"\n ng-style=\"{\'opacity\': (member.IsOnline ? 1 : .3)}\" class=\"margin-2 grow\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n\n <!--show this if more than 10 users : test with more than 2 for now : this is showing up behind the chat window-->\n <md-menu ng-if=\"chat.conversationPage.Members.length > 8\" class=\"padding-0\" style=\"z-index: 9999999\">\n <md-button class=\"md-icon-button md-primary margin-0\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\"></md-icon>\n <md-tooltip md-direction=\"bottom\">Show all</md-tooltip>\n </md-button>\n <md-menu-content width=\"4\">\n <md-menu-item ng-repeat=\"member in chat.conversationPage.Members\" ng-attr-id=\"BtnPageMember{{$index}}\">\n <div layout=\"row\" layout-align=\"start center\" class=\"padding-10\">\n <au-profile-image user=\"member\" size=\"30\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-caption\">{{member | auItemFilter: \'User\'}}</span>\n </div>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n </div>\n\n <md-button class=\"md-icon-button md-primary\" aria-label=\"settings\" ng-click=\"chat.openManagePageDialog($event)\" ng-disabled=\"!(chat.conversationPage.IsUserEditor($root.user._id)) || (chat.conversationPage.Title == \'##1:1##\') || (chat.conversationPage.Title == \'##AlLinus##\')\"\n ng-attr-id=\"BtnManageMessage{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" ng-class=\"{\'spin\': chat.conversationPage.IsUserEditor($root.user._id) && chat.conversationPage.Title != \'##1:1##\' && chat.conversationPage.Title != \'##AlLinus##\'}\"></md-icon>\n <md-tooltip>Manage Members</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button md-primary grow\" aria-label=\"video chat\" ng-click=\"chat.createVideoCall({userIds: chat.conversationPage.Members})\"\n ng-disabled=\"chat.conversationPage.Members.length > 10\" ng-attr-id=\"BtnVideoChat{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <md-tooltip ng-show=\"chat.conversationPage.Members.length > 10\">Video chat supported only for groups of 10 or less</md-tooltip>\n <md-tooltip ng-show=\"chat.conversationPage.Members.length <= 10\">Video chat</md-tooltip>\n </md-button>\n </div>\n </div>\n\n\n <md-content class=\"chat-content\" ng-attr-id=\"ChatContent{{$index}}\" layout=\"column\" ng-class=\"{\'maximized\':chat.maximized}\">\n <au-post-feed page-id=\"chat.conversationPage._id\" recent-on=\"bottom\" template=\"/app/alignus/layouts/chat-bar/feed-template.tmpl.html\"\n feed-type=\"Conversation\"></au-post-feed>\n </md-content>\n <!-- <div ng-if=\"chat.conversationPage.Title != \'##AlLinus##\'\" au-rich-text class=\"field md-input\" ng-model=\"chat.newMessage\" placeholder=\"Send a message...\" on-enter=\"chat.sendMessage\"\n on-key-press=\"chat.sendTyping\" ng-attr-id=\"Message{{$index}}\"></div> -->\n <div ng-if=\"chat.conversationPage.Title != \'##AlLinus##\'\" class=\"au-cke-document md-input\" ng-model=\"chat.newMessage\" placeholder=\"Send a message...\"\n on-enter=\"chat.sendMessage\" on-key-press=\"chat.sendTyping\" ng-attr-id=\"CkeMessage{{$index}}\"></div>\n <div ng-if=\"chat.conversationPage.Title == \'##AlLinus##\'\" layout=\"column\" style=\"background:#FFF;\">\n <md-button ng-click=\"vm.chatReadUpToHere(chat.conversationPage)\" class=\"md-raised md-primary\">\n <md-icon md-font-icon=\"zmdi zmdi-eye\"></md-icon>\n <span>Read Up To Here</span>\n </md-button>\n </div>\n </div>\n </div>\n</div>");
$templateCache.put("/app/alignus/layouts/chat-bar/dialog-new-chat.tmpl.html","<md-dialog flex=\"100\" flex-gt-sm=\"40\" flex-gt-md=\"30\">\n <md-toolbar>\n <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n <h2>New Conversation</h2>\n <md-button class=\"md-icon-button\" ng-click=\"$mdDialog.cancel()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\">\n </md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <form name=\"newChatDialogForm\">\n <md-dialog-content class=\"md-padding\" layout=\"column\">\n\n <md-chips class=\"user-chips padding-bottom-20\" ng-model=\"vm.members\" md-require-match=\"true\"\n md-highlight-flags=\"i\" filter-selected=\"true\" required>\n <md-autocomplete md-selected-item=\"vm.selectedMemberAutocomplete\" md-search-text=\"vm.membersSearchText\" md-items=\"user in vm.autocompleteFilter(vm.membersSearchText)\"\n placeholder=\"{{ vm.members < 1 ? \'To: \' : \'Add people\' }}\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image item=\"user\" size=\"32\">\n </au-profile-image>\n <span md-highlight-text=\"vm.membersSearchText\">{{user | fullNameFilter}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image item=\"$chip\" size=\"32\" class=\"grow\">\n </au-profile-image>\n <span>{{$chip | fullNameFilter}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n\n <md-input-container layout=\"row\">\n <input placeholder=\"Message content\" ng-model=\"vm.message\" flex required />\n <md-button class=\"md-primary md-icon-button\" style=\"order :3\" ng-click=\"$mdDialog.hide({members: vm.members, message: vm.message})\" ng-disabled=\"newChatDialogForm.$invalid || vm.members == 0\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\">\n </md-icon>\n </md-button>\n </md-input-container>\n\n </md-dialog-content>\n </form>\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/chat-bar/feed-template.tmpl.html","<au-suspendable update-on-item=\"Post-{{post._id}}\">\n <div layout=\"row\" ng-class=\"::(post.Creator == $root.user._id ? \'sent\':\'received\')\" ng-init=\"vm.post = post\">\n <au-profile-image ng-if=\"post.$firstInGroup && post.Creator != $root.user._id\" user=\"post.Creator\" size=\"30\"></au-profile-image>\n\n <!--Content-->\n <div layout=\"column\" class=\"message\" ng-class=\"{\'first\': post.$firstInGroup, \'last\': post.$lastInGroup, \'full-width\': post.CoverPhoto || post.CoverPhotoUrl}\">\n\n <!-- cover photo -->\n <div style=\"height: 60px\" au-cover-photo item=\"post\" ng-if=\"::post.CoverPhoto || post.CoverPhotoUrl\" allow-update=\"false\"\n class=\"cover-photo\"></div>\n\n <!--post content-->\n <div ng-if=\"::post.Data.Update\" class=\"au-post-container\">\n <p class=\"md-body-1\" dynamic=\"::post.Data.Update\"></p>\n </div>\n <div ng-if=\"::!post.Data.Update\" ng-include=\"::\'/app/alignus/directives/au-posts/\' + post.Type.toLowerCase() + \'.tmpl.html\'\"\n class=\"au-post-container\" ng-controller=\"AuPostController as vm\"></div>\n\n <!--Attachments-->\n <au-document-section item=\"post\" show-toolbar=\"false\" only-list=\"true\" class=\"mini\" ng-if=\"::post.Documents.length\"></au-document-section>\n </div>\n </div>\n <!--End content-->\n\n <div ng-if=\"post.$lastInGroup\" class=\"md-caption timestamp\" ng-class=\"::(post.Creator == $root.user._id ? \'sent\':\'received\')\"\n layout=\"row\" layout-align=\"start center\">\n <span ng-if=\"::post.Creator != $root.user._id\" class=\"margin-right-3\">{{::post.$Creator | firstNameFilter}} &bull;</span>\n <span am-time-ago=\"post.DateCreated\" class=\"margin-bottom-10\"></span>\n </div>\n</au-suspendable>");
$templateCache.put("/app/alignus/layouts/coming-soon/coming-soon.tmpl.html","<div class=\"coming-soon\" ng-class=\"vm.sectionSettings.image\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\"></div>\n\n <md-content layout=\"column\" layout-align=\"end center\" style=\"background:transparent; max-height: 1000px; padding-bottom: 50px\" id=\"ContentComingSoon\" flex>\n <div class=\"one-search-content-buffer\"></div>\n <div class=\"limit-width\">\n <div class=\"margin-bottom-70 fadeup\" ng-class=\"{\'semi-transparent-card\': !$mdMedia(\'gt-sm\')}\">\n <div flex=\"100\" flex-gt-sm=\"50\" class=\"padding-10\">\n <h2>\n This section is almost ready.\n </h2>\n <p class=\"md-body-1\">\n Our team is currently working on this tool but as an exclusive user, you have early access to <a ui-sref=\"shell.structure\">Structure</a>. Go ahead and set up your organization. It\'s the first thing you have to do anyway!\n </p>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" flex=\"noshrink\">\n <md-card class=\"semi-transparent-card\">\n <md-card-content class=\"padding-40\">\n <h1>\n {{ vm.sectionSettings.title }}\n </h1>\n <p class=\"md-caption margin-bottom-80\">\n {{ vm.sectionSettings.description }}\n </p>\n <md-button class=\"md-primary md-raised\">\n <span>\n Let me know when it\'s ready\n </span>\n </md-button>\n </md-card-content>\n </md-card>\n </div>\n </div>\n </md-content>\n</div>");
$templateCache.put("/app/alignus/layouts/connections-viewer/connections-viewer.tmpl.html","<div class=\"connections-viewer\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html\'\"></div>\n\n <div class=\"one-search-content-buffer\"></div>\n <div angular-org-chart nodes=\"list.listItems\" flex=\"grow\" node-width=\"240\" node-height=\"290\"\n parent-id-property=\"{{list.listSettings.connections.relationship.parentIdProperty}}\" id-property=\"{{list.listSettings.connections.relationship.idProperty}}\"\n node-expression=\"\'<au-item-card item=\\\'node\\\' class=\\\'item-card-no-margin\\\'></au-item-card>\'\" \n on-select=\"list.itemSelected()\"\n no-managed-members-text=\"list.listSettings.connections.noManagedMembersText\"\n unassigned-members-text=\"list.listSettings.connections.unassignedMembersText\"\n enable-parent-update=\"list.listSettings.connections.canEdit\" \n on-parent-update=\"list.listSettings.connections.onParentUpdate(node, oldParent)\">\n </div>\n</div>");
$templateCache.put("/app/alignus/layouts/kanban-board-viewer/kanban-board-viewer.tmpl.html","<div class=\"card-viewer\" layout=\"column\" layout-fill id=\"Background\" ng-click=\"list.deselectAll()\">\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html\'\"></div>\n\n <md-content style=\"background: transparent\">\n <div class=\"one-search-content-buffer\"></div>\n <!-- content go here -->\n <au-task-board initial-state=\"{{::list.initialState}}\" tasks=\"list.listItems\"></au-task-board>\n </md-content>\n</div>");
$templateCache.put("/app/alignus/layouts/landing-recent-groupings/landing.tmpl.html","<div class=\"landing-recent-groupings au-landing-page\" ng-class=\"::$state.$current.data.sectionSettings.title.toLowerCase()\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\"></div>\n\n <md-content style=\"background: transparent;\" md-scroll-y flex=\"100\" id=\"ContentLandingPage\">\n <div class=\"big-margin-content\">\n <au-suspendable update-on-event=\"recent\">\n <div class=\"margin-bottom-75\" ng-if=\"user.getRecentItems()[$state.$current.data.sectionSettings.title].length\">\n <div class=\"landing-header margin-top-0\">\n <h1>Recent Activity</h1>\n <h4>Most recent activity</h4>\n </div>\n <div class=\"padding-left-25 padding-right-25 fadeup limit-visible-activity\" layout=\"row\" layout-align=\"start start\" layout-wrap=\"wrap-around\" layout-fill>\n <div ng-repeat=\"item in user.getRecentItems()[$state.$current.data.sectionSettings.title] | limitTo : 15 track by trackByIdAndType(item)\" flex=\"15\" class=\"menu-card material-card material-shadow flex-15 recent-activity scale-medium\" ng-click=\"vm.openRecentItemDialog(item)\" id=\"BtnRecentItemCard{{$index}}\" style=\"max-height:84px\">\n <au-profile-image item=\"item.item\" class=\"recent-img grow\" size=\"40\"></au-profile-image>\n <p class=\"margin-top-0 margin-bottom-0 text-ellipsis md-body-2\">{{item.item.toString()}}</p>\n <p class=\"margin-top-0 margin-bottom-0 md-caption\">{{item.item.IsContact ? \'Contact\' : item.itemType.name}}</p>\n </div>\n </div>\n </div>\n </au-suspendable>\n \n <div ng-repeat=\"section in vm.sections\" class=\"section{{::$index}}\">\n <div class=\"landing-header\" ng-if=\"::section.permissionNeeded == undefined || $eval(section.permissionNeeded)\">\n <h1 dynamic=\"::section.title\"></h1>\n <h4 dynamic=\"::section.subTitle\"></h4>\n </div>\n\n <div class=\"padding-25 fadeup\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"wrap-around\" layout-fill>\n\n <md-card class=\"material-card material-shadow scale-medium\" ng-class=\"::vm.landingSettings.cardClass\" ng-repeat=\"card in ::section.menuItems\" ng-if=\"::card.permissionNeeded == undefined || $eval(card.permissionNeeded)\"\n flex=\"15\" ng-click=\"vm.cardGo(card, $event)\" ng-attr-id=\"Card{{::$index}}\">\n <md-toolbar class=\"toolbar-background\" s3-background=\"{{::card.image}}\">\n </md-toolbar>\n <md-card-content>\n <h3 class=\"margin-top-0 margin-bottom-0\" dynamic=\"::card.title\"></h3>\n <p class=\"margin-top-0 margin-bottom-0\" dynamic=\"::card.subtitle\"></p>\n </md-card-content>\n </md-card>\n </div>\n </div>\n </div>\n </md-content>\n</div>\n");
$templateCache.put("/app/alignus/layouts/list-item-viewer/list-item-viewer.tmpl.html","<div class=\"list-item-viewer\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html\'\"\n ng-if=\"$mdMedia(\'gt-xs\') || !itemIsOpen\"></div>\n\n <div layout=\"row\" flex layout-fill>\n <div class=\"list-pane\" ng-show=\"list.showList\" layout=\"column\" ng-style=\"{maxWidth: list.listSettings.maxWidth || \'inherit\'}\">\n <perfect-scrollbar class=\"ps-scrollTopOffset-100 ps-alwaysShowScrollThumb\" at-scroll-end=\"list.loadNextGroup()\" flex=\"100\">\n <div class=\"one-search-content-buffer\" style=\"min-height: 97px\"></div>\n\n <section ng-repeat=\"group in list.loadedItemGroups track by group.groupHeader\" ng-if=\"group.items.length > 0\">\n <div class=\"subheader md-title\" ng-attr-id=\"BtnGroupHeader{{$index}}\" ng-show=\"list.showGroupHeaders\">\n <md-checkbox ng-model=\"group.$selected\" ng-change=\"list.markGroupAs(group.groupId, group.$selected);\">\n {{::group.groupHeader}}\n </md-checkbox>\n </div>\n\n <md-list>\n <md-list-item class=\"md-3-line border-bottom-color\" ng-class=\"{\'selected\': $state.params.itemID == item._id}\" md-no-ink ng-click=\"list.itemClicked(item)\"\n aria-label=\"item\" ng-repeat=\"item in group.items | orderBy: list.orderByFields track by item._id\"\n layout=\"row\" flex layout-fill ng-attr-id=\"BtnLeftListItem0{{$index}}\">\n <div layout=\"row\" layout-align=\"start center\" layout-fill class=\"item-row\">\n <au-profile-image item=\"item\" size=\"50\">\n <hover>\n <md-checkbox class=\"select-list-item\" ng-model=\"item.$selected\" ng-click=\"$event.stopPropagation()\" ng-change=\"list.itemSelected()\"\n aria-label=\"select item\" style=\"margin: 3px 0 0 11px\"></md-checkbox>\n </hover>\n </au-profile-image>\n\n <div class=\"text-ellipsis margin-left-10\" flex=\"100\" au-suspendable update-on-item=\"{{item.$key}}-{{item._id}}\">\n <p ng-if=\"list.listSettings.itemHeadline\" class=\"item-headline\" dynamic=\"list.listSettings.itemHeadline\"></p>\n <p ng-if=\"!list.listSettings.itemHeadline\" class=\"item-headline\">{{item.toString()}}</p>\n <div class=\"item-subhead-limit-height\">\n <p class=\"item-subhead\" ng-repeat=\"subhead in item.getSubHeads() | limitTo: 2\" layout=\"row\" layout-align=\"start center\" dynamic=\"subhead\">\n </p>\n </div>\n </div>\n </div>\n </md-list-item>\n </md-list>\n </section>\n\n <div layout=\"row\" layout-align=\"center center\" style=\"height:250px\" ng-if=\"list.listItems.length == 0\">\n <h2 style=\"text-align: center\" flex>Sorry, no records found.</h2>\n </div>\n\n </perfect-scrollbar>\n </div>\n\n <div class=\"item-pane overflow-auto\" ng-style=\"{\'padding-top\': $mdMedia(\'xs\') ? \'0px\' : \'80px\'}\" flex=\"100\" layout=\"column\"\n style=\"overflow-y: scroll !important;\" ui-view layout-fill>\n <md-content class=\"no-item-selected\" flex layout-align=\"center center\" layout-fill style=\"min-height:1500px\">\n <img s3-src=\'{{::list.emptyImage}}\' class=\"default-state\" />\n <h2 class=\"font-weight-300\">{{::list.emptyTitle}}</h2>\n <div class=\"md-caption\">{{::list.emptyDescription}}</div>\n </md-content>\n </div>\n\n </div>\n\n</div>");
$templateCache.put("/app/alignus/layouts/new-from-template/new-from-template.tmpl.html","<div layout=\"row\" class=\"full-height new-from-template\" id=\"shell-layout\">\n <div layout=\"column \" flex layout-fill>\n <div class=\"single-item-viewer\" style=\"position: relative;\" layout=\"column\" layout-fill>\n <md-content md-scroll-y flex class=\"background-color-900\" style=\"background: radial-gradient(ellipse at center, rgba(255,255,255,.4) 0%,rgba(255,255,255,0) 100%);\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <div style=\"max-width: 1024px; min-width: 60%;\">\n <ng-form>\n <md-popout-card-list class=\"full-width\">\n <md-card>\n <md-card-content class=\"background-color-500\">\n <div class=\"padding-30 font-size-3 font-weight-300\">{{\'New \' + vm.itemType + \' from Template\'}}</div>\n </md-card-content>\n </md-card>\n <md-card ng-repeat=\"template in vm.templates\">\n <md-card-content class=\"font-color-800\">\n <div layout-fill layout=\"row\" layout-align=\"space-between start\" flex id=\"BtnProjectHeader\">\n <div layout=\"column\" class=\"padding-20\">\n <div class=\"md-title padding-0\">{{template.toString()}}</div>\n <div>\n Created by: {{template.Creator | fullNameFilter}}\n </div>\n <div>\n Created on: {{template.DateCreated | date : \'short\'}}\n </div>\n\n <div class=\"hidden\">\n <div class=\"padding-top-40\" layout=\"row\">\n <md-button class=\"md-primary md-raised margin-left-0\" ng-click=\"$root.auUtility.newItemFromTemplate(template._id, template.$key, true); disableButtons = true\"\n ng-disabled=\"disableButtons\">\n <span ng-hide=\"disableButtons\">\n Create New {{vm.itemType}} From This\n </span>\n <span ng-show=\"disableButtons\">\n Working... This may take a moment...\n </span>\n </md-button>\n <md-button class=\"md-raised\" ng-click=\"template.open(\'recent\'); $event.stopPropagation();\">\n View Template\n </md-button>\n </div>\n </div>\n </div>\n\n <div class=\"hidden md-primary\" style=\"min-width:250px;\">\n <div class=\"background-accent preview-bg\" s3-background=\"/assets/images/cards/slim/documents/doc-preview-bg.png\">\n <div class=\"clip-doc\">\n <!-- test img -->\n <!-- <img src=\"https://align.us/wp-content/uploads/2018/04/discussion-board-uai-1440x1920.png\" /> -->\n <img ng-src=\"{{template.getScreenshotUrl()}}\" />\n </div>\n </div>\n </div>\n\n </div>\n </md-card-content>\n </md-card>\n <md-card ng-if=\"vm.templates.length == 0\">\n <md-card-content class=\"padding-40\" layout=\"column\" layout-align=\"center center\">\n <div layout=\"column\" layout-align=\"center center\" style=\"text-align:center; color:gray; max-width:400px;\">\n <img s3-src=\"/assets/images/empty-states/template.png\" style=\"max-width:200px\">\n <span class=\"md-title\">Oops!</span>\n <span class=\"md-subhead\">Sorry, no templates exist for {{vm.itemType}}s right now. To create a template, just create a {{vm.itemType}}\n and click the \"Lock and Convert to Template\" (\n <i class=\"zmdi zmdi-lock-open\"></i> ) button.</span>\n <md-button ng-click=\"closeWindow()\" class=\"md-raised md-primary margin-top-30\">&nbsp; Close Window &nbsp;</md-button>\n </div>\n\n\n </md-card-content>\n </md-card>\n </md-popout-card-list>\n </ng-form>\n </div>\n </div>\n <!-- <div ng-include src=\"::$state.$current.itemTemplateUrl\" style=\"margin: auto; padding: 40px 40px 150px 40px; color: rgba(0,0,0,0.87); \"></div> -->\n </md-content>\n </div>\n </div>\n</div>\n\n<ng-include src=\"::\'/app/alignus/layouts/_shell/au-global-elements.html\'\"></ng-include>");
$templateCache.put("/app/alignus/layouts/notifications-panel/tab-conversations.tmpl.html","<md-list id=\"chat-panel\" layout-fill class=\"padding-0 background-color-700\">\n <!-- Search and Go to Inbox -->\n <div layout=\"row\" layout-align=\"center center\" class=\"background-color-600 padding-left-15 padding-right-5 padding-top-15 padding-bottom-15 md-whiteframe-2dp\">\n <div class=\"search-input faderight\" flex>\n <div style=\"position: relative\">\n <input type=\"text\" placeholder=\"Filter Inbox\" ng-focus=\"searchIsFocused=true\" ng-blur=\"searchIsFocused=false\" ng-model=\"vm.searchInput\"\n ng-change=\"vm.getItemsMatchingSearch()\" class=\"md-whiteframe-z1 one-search-input\" ng-class=\"{focused:searchIsFocused}\"\n />\n <i class=\"zmdi zmdi-search search-input-icon\"></i>\n </div>\n </div>\n <md-button class=\"md-icon-button\" ui-sref=\"shell.social.messages.list\" ng-click=\"$root.rightSideNavIsOpen = false\">\n <md-icon md-font-icon=\"zmdi zmdi-inbox\" class=\"font-color-100\"></md-icon>\n <md-tooltip>Go to Inbox</md-tooltip>\n </md-button>\n </div>\n\n <md-virtual-repeat-container md-top-index=\"vm.conversationTop\">\n <md-list-item class=\"conversation md-3-line md-long-text\" md-virtual-repeat=\"conversation in vm.showConversations | orderBy: [\'-$searchScore\', \'-LastPostDate\', \'toString()\']\"\n ng-click=\"vm.openChat(conversation)\" ng-attr-id=\"PanelBtnMessage{{$index}}\">\n <div flex layout=\"row\" layout-align=\"start start\" class=\"conversation-row\">\n <div class=\"conversation-image margin-top-2\">\n <au-profile-image ng-if=\"conversation.$key != \'User\'\" item=\"conversation\" size=\"50\" no-member-watch=\"true\"></au-profile-image>\n <au-profile-image ng-if=\"conversation.$key == \'User\'\" item=\"conversation\" size=\"50\" ng-style=\"{\'opacity\': (conversation.IsOnline ? 1 : .3)}\"></au-profile-image>\n <div class=\"unread-badge background-accent\" ng-if=\"conversation.UnreadCounts[$root.user._id]\" layout=\"column\" layout-align=\"center center\"\n ng-attr-id=\"PanelNumUnread{{$index}}\">\n {{conversation.UnreadCounts[$root.user._id]}}\n </div>\n </div>\n\n <div layout=\"column\" flex>\n <span class=\"md-body-2\" ng-attr-id=\"PanelStringConvoTitle{{$index}}\">{{conversation.toString(true)}}</span>\n <span class=\"md-body-1\" ng-attr-id=\"PanelStringConvoMessage{{$index}}\">\n {{conversation.$fromUserText}}\n <span dynamic=\"conversation.LastPostText\"></span>\n </span>\n <span class=\"md-caption font-color-200\" ng-if=\"conversation.LastPostDate\" am-time-ago=\"conversation.LastPostDate\"></span>\n </div>\n\n <div class=\"quick-buttons\" layout=\"column\" layout-align=\"center center\">\n <!--Dismiss button-->\n <md-button class=\"md-icon-button md-accent\" ng-if=\"conversation.$key == \'Page\'\" ng-click=\"vm.dismiss($event, conversation);\"\n ng-attr-id=\"PanelBtnDismiss{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\" class=\"message-options\"></md-icon>\n <md-tooltip md-direction=\"left\">Mark Done</md-tooltip>\n </md-button>\n\n <!--Undismiss button-->\n <md-button class=\"md-icon-button md-accent\" ng-if=\"conversation.$key == \'Page\' && conversation.$IsDismissed\" ng-click=\"vm.undismiss($event, conversation);\"\n ng-attr-id=\"PanelBtnUndismiss{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle\" class=\"message-options\"></md-icon>\n <md-tooltip md-direction=\"left\">Move back to Inbox</md-tooltip>\n </md-button>\n\n <!--Send Emoji button-->\n <md-button class=\"md-icon-button md-accent\" ng-if=\"conversation.$key == \'Page\' && !conversation.$IsDismissed\" ng-click=\"conversation.$showEmojies = true; vm.showSelectEmoji($event, conversation)\">\n <md-icon md-font-icon=\"zmdi zmdi-mood\" class=\"message-options\"></md-icon>\n <md-tooltip md-direction=\"left\">Quick Reply</md-tooltip>\n </md-button>\n </div>\n\n <div class=\"send-emoji-options\" ng-if=\"conversation.$showEmojies\" ng-class=\"conversation._id\" layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.sendEmoji(\'😃\', conversation)\" class=\"md-fab md-raised md-mini\">\n 😃\n <md-tooltip>\n Happy\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'😉\', conversation)\" class=\"md-fab md-raised md-mini\">\n 😉\n <md-tooltip>\n Wink\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'😌\', conversation)\" class=\"md-fab md-raised md-mini\">\n 😌\n <md-tooltip>\n Phew\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'😎\', conversation)\" class=\"md-fab md-raised md-mini\">\n 😎\n <md-tooltip>\n Cool\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'❤️\', conversation)\" class=\"md-fab md-raised md-mini\">\n ❤️\n <md-tooltip>\n Love It\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'🎇\', conversation)\" class=\"md-fab md-raised md-mini\">\n 🎇\n <md-tooltip>\n Impressive\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'👆\', conversation)\" class=\"md-fab md-raised md-mini\">\n 👆\n <md-tooltip>\n One Minute\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'❓\', conversation)\" class=\"md-fab md-raised md-mini\">\n ❓\n <md-tooltip>\n Question\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'👊\', conversation)\" class=\"md-fab md-raised md-mini\">\n 👊\n <md-tooltip>\n Fist Bump\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'👎\', conversation)\" class=\"md-fab md-raised md-mini\">\n 👎\n <md-tooltip>\n No\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.sendEmoji(\'👍\', conversation)\" class=\"md-fab md-raised md-mini\">\n 👍\n <md-tooltip>\n Yes\n </md-tooltip>\n </md-button>\n </div>\n </div>\n </md-list-item>\n </md-virtual-repeat-container>\n</md-list>");
$templateCache.put("/app/alignus/layouts/notifications-panel/tab-help.tmpl.html","<div class=\"background-color-700\" layout-fill layout=\"column\" layout-align=\"start center\">\n <!--toolbar-->\n <div style=\"width:100%;\" layout=\"row\" layout-align=\"center center\" class=\"background-color-600 padding-15 md-whiteframe-2dp\">\n <md-button class=\"md-icon-button\" ng-click=\"vm.toggleSideNav(\'notifications\');vm.openUserSettings()\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\" class=\"font-color-100\"></md-icon>\n <md-tooltip>My Account</md-tooltip>\n </md-button>\n <div>\n <md-button class=\"md-icon-button\" ng-click=\"vm.openSelectAccount()\" ng-disabled=\"vm.disableSwitch\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts-list-alt\" class=\"font-color-100\" ng-style=\"{opacity: vm.disableSwitch ? \'.3\' : 1}\"></md-icon>\n </md-button>\n <md-tooltip>Switch Account {{vm.disableSwitch ? \'(You Must Add Account First)\' : \'\'}}</md-tooltip>\n </div>\n <md-button class=\"md-icon-button\" ng-click=\"vm.openLoginTab()\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\" class=\"font-color-100\"></md-icon>\n <md-tooltip>Add Account</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button\" ng-click=\"vm.logout()\">\n <md-icon md-font-icon=\"zmdi zmdi-power\" class=\"font-color-100\"></md-icon>\n <md-tooltip>Logout</md-tooltip>\n </md-button>\n </div>\n <!--help header-->\n <div class=\"margin-bottom-60\">\n <div class=\"full-image-background\" style=\"width:100%;\" s3-background=\"/assets/images/walkthrough/leaf-header.png\" layout=\"row\"\n layout-align=\"center\">\n <div class=\"make-round overhang full-image-background\" style=\"height:100px; width:100px\" s3-background=\"/assets/images/walkthrough/al.png\"></div>\n </div>\n </div>\n <p class=\"md-title margin-bottom-20\" style=\"text-align:center;\">\n How may I help you, {{$root.user.FirstName}}?\n </p>\n\n <!--tour widget-->\n <div class=\"layout-padding background-color-700 usercard-button\" layout=\"row\" layout-align=\"start center\" id=\"BtnTour\" ng-click=\"vm.initiateTourForCurrentState()\">\n <md-icon class=\"font-size-4 opacity-60 margin-left-15\" md-font-icon=\"zmdi zmdi-walk\" aria-hidden=\"true\" style=\"color:#ffffff\"></md-icon>\n <span flex></span>\n <p class=\"md-headline font-weight-300 margin-right-10\">Start Tour</p>\n <md-tooltip>\n Let \"Al Linus\" show you around the current page.\n </md-tooltip>\n </div>\n\n <!--getting started videos widget-->\n <div class=\"layout-padding background-color-800 usercard-button\" layout=\"row\" layout-align=\"start center\" id=\"BtnVideos\"\n ng-click=\"vm.goToGettingStarted()\">\n <md-icon class=\"font-size-4 opacity-60 margin-left-15\" md-font-icon=\"zmdi zmdi-youtube-play\" aria-hidden=\"true\" style=\"color:#ffffff\"></md-icon>\n <span flex></span>\n <p class=\"md-headline font-weight-300 margin-right-10\">Getting Started</p>\n <md-tooltip>\n Short videos on how to get started with Align Us.\n </md-tooltip>\n </div>\n\n <!--questions widget-->\n <div class=\"layout-padding background-color-900 usercard-button\" layout=\"row\" layout-align=\"start center\" id=\"BtnQuestions\"\n ui-sref=\"shell.social.questions.search\" ng-click=\"vm.toggleSideNav(\'notifications\')\">\n <md-icon class=\"font-size-4 opacity-60 margin-left-10\" md-font-icon=\"zmdi zmdi-help\" aria-hidden=\"true\" style=\"color:#ffffff\"></md-icon>\n <span flex></span>\n <p class=\"md-headline font-weight-300 margin-right-10\">Q &amp; A</p>\n <md-tooltip>\n Search the knowledge base curated by {{::$root.Organization.Name}}.\n </md-tooltip>\n </div>\n\n <!--feedback widget-->\n <div class=\"layout-padding background-color-800 usercard-button\" layout=\"row\" layout-align=\"start center\" id=\"BtnFeedback\"\n onclick=\"window.FreshWidget.show()\">\n <md-icon class=\"font-size-4 opacity-60 margin-left-10\" md-font-icon=\"zmdi zmdi-comment-alt-text\" aria-hidden=\"true\" style=\"color:#ffffff\"></md-icon>\n <span flex></span>\n <p class=\"md-headline font-weight-300 margin-right-10\">Send Feedback</p>\n <md-tooltip>\n Find a bug or have the next great idea for Align Us?\n </md-tooltip>\n </div>\n\n <!--help widget-->\n <div class=\"layout-padding background-color-700 usercard-button\" layout=\"row\" layout-align=\"start center\" id=\"BtnHelp\" onclick=\"window.open(\'https://alignus.freshdesk.com/support/home\', \'_blank\')\">\n <md-icon class=\"font-size-4 opacity-60 margin-left-10\" md-font-icon=\"zmdi zmdi-info\" aria-hidden=\"true\" style=\"color:#ffffff\"></md-icon>\n <span flex></span>\n <p class=\"md-headline font-weight-300 margin-right-10\">Help Center</p>\n <md-tooltip>\n Search solutions, chat with Align Us agents or open a help ticket.\n </md-tooltip>\n </div>\n</div>");
$templateCache.put("/app/alignus/layouts/notifications-panel/tab-video-calls.tmpl.html","<div layout=\"column\" layout-fill class=\"sidebar-video-chat background-color-700\">\n \n <!--toolbar-->\n <div ng-if=\"!vm.activeCall.userStream.active\" style=\"width:100%;\" layout=\"row\" layout-align=\"center center\" class=\"background-color-600 padding-15 md-whiteframe-2dp\">\n <md-button class=\"md-accent md-raised margin-2\" ng-click=\"vm.startNewChat()\">\n <md-icon md-font-icon=\"zmdi zmdi-videocam\"></md-icon>\n <span class=\"margin-right-5\">Start Video</span>\n </md-button>\n </div>\n <div ng-if=\"vm.activeCall.userStream.active\" style=\"width:100%;\" layout=\"row\" layout-align=\"center center\" class=\"background-color-600 padding-7 md-whiteframe-2dp\">\n <md-menu>\n <md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-more\" class=\"font-color-100\"></md-icon>\n </md-button>\n <md-menu-content>\n <md-menu-item>\n <md-button ng-click=\"vm.joinLastCall()\">\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon> Join Last Call\n </md-button>\n </md-menu-item>\n <md-menu-item>\n <md-button ng-click=\"vm.showSettings($event)\" ng-disabled=\"!vm.activeCall.userStream.active\">\n <md-icon md-font-icon=\"zmdi zmdi-settings\"></md-icon> Settings\n </md-button>\n </md-menu-item>\n </md-menu-content>\n </md-menu>\n <md-button class=\"md-icon-button video-end\" ng-click=\"vm.hangup()\" ng-disabled=\"!vm.activeCall.userStream.active\">\n <md-icon md-font-icon=\"zmdi zmdi-phone-end\" class=\"font-color-100\"></md-icon>\n <md-tooltip>End Call</md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button\" ng-class=\"{muted: !vm.activeCall.streamAudio}\" ng-click=\"vm.activeCall.toggleAudio()\" ng-disabled=\"!vm.activeCall.userStream.active\">\n <md-icon md-font-icon=\"zmdi zmdi-mic-off\" class=\"font-color-100\"></md-icon>\n <md-tooltip>\n {{vm.activeCall.streamAudio ? \'Mute Microphone\' : \'Unmute Microphone\'}}\n </md-tooltip>\n </md-button>\n <md-button class=\"md-icon-button pulse bounce\" ng-click=\"vm.addUser($event)\" ng-disabled=\"!vm.activeCall.userStream.active\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\" class=\"font-color-100\"></md-icon>\n <md-tooltip>\n Add User\n </md-tooltip>\n </md-button>\n </div>\n\n <div class=\"margin-top-20\" layout=\"row\" layout-align=\"center center\">\n <div ng-if=\"!vm.activeCall.userStream.active\" class=\"video-not-playing no-animate\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image class=\"margin-right-0\" item=\'$root.user\' size=\"150\"></au-profile-image>\n </div>\n\n </div>\n <div class=\"my-video no-animate\" ng-show=\"vm.activeCall.userStream.active\">\n <div class=\"my-video-container\" ng-click=\"vm.muteSelf()\">\n <video ng-if=\"!vm.activeCall.userStream.audioOnly\" ng-src=\"{{vm.activeCall.myStreamAsUrl}}\" autoplay muted id=\"my-video\"></video>\n <div ng-if=\"vm.activeCall.userStream.audioOnly\">\n <au-profile-image class=\"margin-right-0\" item=\'$root.user\' size=\"150\" style=\"margin-left:25px;\"></au-profile-image>\n <audio ng-src=\"{{vm.activeCall.myStreamAsUrl}}\"></audio>\n </div>\n </div>\n <div class=\"my-emoji\" ng-style=\"{\'opacity\':(vm.activeCall.myEmoji || vm.activeCall.myShare ? 1 : .5)}\">\n <div class=\"current\" ng-click=\"vm.showSelectEmoji($event)\">\n <span ng-show=\"vm.activeCall.myEmoji\" dynamic=\"vm.activeCall.myEmoji\"></span>\n <span ng-show=\"!vm.activeCall.myEmoji && !vm.activeCall.myShare\" style=\"font-size: 10px; color: #666; line-height: 17px; display: inline-block;\">Send<br>Emoji</span>\n <au-profile-image ng-show=\"vm.activeCall.myShare && !vm.activeCall.myEmoji\" item=\"vm.activeCall.myShare\" size=\"65\" class=\"my-share\"> \n </div>\n\n <div class=\"my-emoji-options\" layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.selectEmoji(\'😃\')\" class=\"md-fab md-raised md-mini\">\n 😃\n <md-tooltip>\n Happy\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'😉\')\" class=\"md-fab md-raised md-mini\">\n 😉\n <md-tooltip>\n Wink\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'😌\')\" class=\"md-fab md-raised md-mini\">\n 😌\n <md-tooltip>\n Phew\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'😎\')\" class=\"md-fab md-raised md-mini\">\n 😎\n <md-tooltip>\n Cool\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'💚\')\" class=\"md-fab md-raised md-mini\">\n 💚\n <md-tooltip>\n Love It\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'🎆\')\" class=\"md-fab md-raised md-mini\">\n 🎆\n <md-tooltip>\n Impressive 2\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'🎇\')\" class=\"md-fab md-raised md-mini\">\n 🎇\n <md-tooltip>\n Impressive 1\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'🎊\')\" class=\"md-fab md-raised md-mini\">\n 🎊\n <md-tooltip>\n Celebration\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'👊\')\" class=\"md-fab md-raised md-mini\">\n 👊\n <md-tooltip>\n Fist Bump\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'👏\')\" class=\"md-fab md-raised md-mini\">\n 👏\n <md-tooltip>\n Applause\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'👎\')\" class=\"md-fab md-raised md-mini\">\n 👎\n <md-tooltip>\n No\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'👍\')\" class=\"md-fab md-raised md-mini\">\n 👍\n <md-tooltip>\n Yes\n </md-tooltip>\n </md-button>\n <md-button ng-click=\"vm.selectEmoji(\'✋\')\" class=\"md-fab md-raised md-mini\">\n ✋\n <md-tooltip>\n Raise Hand\n </md-tooltip>\n </md-button>\n\n </div>\n </div>\n </div>\n </div>\n <div class=\"disconnected-state opacity-70\" ng-if=\"!vm.activeCall.userStream.active\" layout=\"column\" layout-align=\"start center\">\n <h1>Video disconnected</h1>\n <p>Click \"Start Video\" above to turn on your camera and make a call.</p>\n </div>\n <div class=\"disconnected-state opacity-70\" ng-if=\"vm.activeCall.userStream.active && vm.numberPeers == 0\" layout=\"column\" layout-align=\"start center\">\n <h1>Invite others</h1>\n <p>Click \"Add User\" above to add another person to this call.</p>\n </div>\n <div ng-if=\"vm.activeCall.userStream.active\" class=\"peers\" layout=\"row\" layout-align=\"center start\" flex layout-wrap>\n <div ng-repeat=\"(key,peer) in vm.activeCall.peers track by key\" class=\"peer\" ng-style=\"{width: vm.peerSize + \'px\', height: vm.peerSize + \'px\'}\">\n <au-profile-image size=\"vm.peerSize\" user=\"key\" watch-size=\"true\"></au-profile-image>\n <div ng-if=\"peer.isConnected && !peer.streamObject.audioOnly && peer.streamObject.active\" class=\"peer-video-container md-whiteframe-2dp\" ng-style=\"{width: vm.peerSize + \'px\', height: vm.peerSize + \'px\'}\" ng-click=\"peer.fixFrozenStream()\">\n <video ng-src=\"{{peer.stream}}\" ng-style=\"{height: vm.peerSize * 1.1 + \'px\' }\" autoplay></video>\n </div>\n <audio ng-if=\"peer.streamObject.audioOnly\" ng-src=\"{{peer.stream}}\" autoplay></audio> \n <div ng-show=\"peer.emoji\" class=\"peer-emoji\" layout=\"row\" layout-align=\"center center\" ng-style=\"{\'font-size\': vm.peerSize / 5 + \'px\'}\">\n <div class=\"bounce\">\n {{peer.emoji}}\n </div>\n </div>\n <div ng-show=\"peer.share && !peer.emoji\" ng-click=\"peer.share.Data.$item.open()\" class=\"peer-share\" layout=\"row\" layout-align=\"center center\">\n <md-tooltip md-direction=\"left\">\n {{peer.share.Data.$item.toString()}} shared by {{peer.share.User | fullNameFilter}} <span am-time-ago=\"peer.share.Date\"></span>\n </md-tooltip>\n <au-profile-image size=\"vm.peerSize / 3\" watch-size=\"true\" item=\"peer.share.Data.$item\" class=\"share-profile-image\"></au-profile-image>\n </div>\n <div class=\"whois md-whiteframe-3dp background-accent-500\" layout=\"column\" ng-style=\"{width: vm.peerSize - 10 + \'px\', \'height\' : (vm.whoisFontSize * 2) + \'px\', \'font-size\': vm.whoisFontSize + \'px\', \'line-height\' : (vm.whoisFontSize * 2) + \'px\'}\">\n <div layout=\"row\" flex layout-align=\"center start\" style=\"overflow: hidden;\">\n <span ng-show=\"peer.peerHtml\" dynamic=\"peer.peerHtml\"></span>\n <span ng-show=\"!peer.peerHtml\">{{key | fullNameFilter}}</span>\n <span ng-show=\"peer.streamObject.audioOnly\">&nbsp(Audio Only)</span>\n </div>\n <div layout=\"row\" style=\"width: 100%; background: rgba(100, 100, 100, .2)\" ng-if=\"peer.timeoutCounter && !peer.isConnected\">\n <div class=\"progress-bar\"></div>\n </div>\n </div>\n </div>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/layouts/report-viewer/report-viewer.tmpl.html","<div class=\"report-viewer\" layout=\"column\" layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/ListViewer/one-search-for-items-toolbar.tmpl.html\'\"\n style=\"width: 100%\"></div>\n\n <div class=\"one-search-content-buffer\"></div>\n\n <md-data-table-scroll flex=\"100\" at-scroll-end=\"list.loadNextGroup()\" ng-if=\"list.itemGroups.length > 0\">\n <table md-table md-row-select=\"true\" ng-model=\"list.reportItemsSelected\" layout=\"column\" layout-fill>\n\n <thead md-head md-order=\"list.orderedBy\" md-on-reorder=\"sortCol\">\n <tr md-row>\n <th md-column ng-repeat=\"col in list.selectedFields\" md-order-by=\"{{col.name}}\" ng-class=\"col.sortDirection\" ng-attr-id=\"BtnColumnHeader{{$index}}\">{{::col.display}}\n <md-tooltip ng-if=\"!$first\" md-direction=\"left\">\n {{::col.display}}\n </md-tooltip>\n </th>\n </tr>\n </thead>\n <tbody md-body ng-if=\"list.showReportBody\">\n <tr ng-attr-id=\"BtnGroupHeader{{$index}}\" class=\"report-group-header\" ng-disabled=\"true\" ng-repeat-start=\"group in list.loadedItemGroups track by group.groupHeader\"\n data-group-id=\"{{group.groupId}}\" expanded=\"\" ng-style=\"{display:(list.showGroupHeaders?\'table-row\':\'none\')}\" ng-if=\"group.items.length > 0\">\n <td colspan=\"100%\">\n <i class=\"zmdi zmdi-minus-square\" ng-click=\"list.toggleGroup(group.groupId)\" ng-attr-id=\"BtnCollapseSection{{$index}}\"></i>\n <span>{{::group.groupHeader}}</span>\n </td>\n </tr>\n <tr md-row class=\"no-user-select\" ng-repeat-end md-select=\"item\" ng-click=\"list.rowSelected(item, $event)\" md-on-select=\"list.rowSelected\"\n md-on-deselect=\"list.rowDeselected\" ng-repeat=\"item in group.items track by item._id\" data-group-id=\"{{group.groupId}}\"\n ng-dblclick=\"item.open()\" ng-attr-id=\"BtnItemRow{{$index}}\" style=\"min-width:100%\">\n <td md-cell ng-repeat=\"col in ::list.selectedFields\" ng-attr-style=\"{{::col.displayStyle}}\">\n <span ng-if=\"::col.displayTemplate\" dynamic=\"col.displayTemplate\"></span>\n <span ng-if=\"::!col.displayTemplate\">{{item | bystring : col.displayValue}}</span>\n </td>\n </tr>\n\n </tbody>\n </table>\n\n <div class=\"field-selector\">\n <md-menu-bar>\n <md-menu>\n <button ng-click=\"$mdOpenMenu($event)\" aria-label=\"select fields\" id=\"BtnSelectFields\">\n <i class=\"zmdi zmdi-eye\"></i>\n </button>\n\n <md-menu-content>\n <md-menu-item disabled=\"disabled\">\n <b style=\"padding-left: 20px\">Select the fields to display:</b>\n </md-menu-item>\n <div style=\"height: {{windowHeight-130}}px; overflow-y: auto\">\n <md-menu-item type=\"checkbox\" ng-repeat=\"field in ::list.itemFields | filter: {sortable : true} track by field.name\" ng-model=\"list.selectedFields[field.name]\"\n ng-click=\"list.toggleField(field.name, $event)\" md-prevent-menu-close=\"md-prevent-menu-close\" ng-attr-id=\"BtnSelectFieldsOption{{$index}}\">{{::field.display}}</md-menu-item>\n </div>\n </md-menu-content>\n </md-menu>\n </md-menu-bar>\n </div>\n\n </md-data-table-scroll>\n\n\n <div layout=\"row\" layout-align=\"center center\" style=\"height:250px\" ng-if=\"list.itemGroups.length == 0\">\n <h2 style=\"text-align: center\" flex>No details found.</h2>\n </div>\n\n</div>");
$templateCache.put("/app/alignus/layouts/select-filter/select-filter.tmpl.html","<div class=\"select-filter au-landing-page\" ng-class=\"$state.$current.data.sectionSettings.title.toLowerCase()\" layout=\"column\"\n layout-fill>\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\"></div>\n\n <md-content style=\"background: transparent;\" md-scroll-y flex=\"100\">\n <div class=\"big-margin-content landing-header\">\n <md-card class=\"filter-menu\">\n <md-card-content layout=\"column\" layout-align=\"start start\">\n\n <h1>{{::$state.$current.self.navigationData.breadcrumbTitle}}</h1>\n <h4>{{::$state.$current.self.navigationData.subTitle}}</h4>\n\n <md-list>\n <md-list-item ng-repeat=\"filter in ::vm.filterValues | orderBy: \'title\'\" ui-sref=\"{{::filter.sref}}({{::filter.srefOpts}})\"\n layout=\"row\" layout-align=\"start center\" ng-class=\"::{\'no-click\': filter.sref == \'#\'}\">\n <au-profile-image ng-if=\"filter.item\" item=\"filter.item\" class=\"margin-right-20\"></au-profile-image>\n <p>{{filter.title}}</p>\n </md-list-item>\n </md-list>\n <p ng-if=\"::vm.filterValues.length == 0\">\n No items found.\n </p>\n\n </md-card-content>\n </md-card>\n </div>\n </md-content>\n\n</div>");
$templateCache.put("/app/alignus/layouts/single-item-viewer/single-item-viewer.tmpl.html","<div layout=\"row\" class=\"full-height\" id=\"shell-layout\">\n <div layout=\"column \" flex layout-fill>\n <div class=\"single-item-viewer\" style=\"position: relative;\" layout=\"column\" layout-fill>\n <md-content md-scroll-y flex class=\"background-color-900\">\n <!--buttons for recent item and account-->\n <div ng-if=\"$root.user.IsContact\" layout=\"row\" layout-align=\"end center\" style=\"margin-bottom: -65px\">\n <md-menu layout=\"column\" layout-align=\"end center\" id=\"BtnRecentItems\">\n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n <md-icon md-font-icon=\"zmdi zmdi-time-restore\" style=\"color:white;\"></md-icon>\n <md-tooltip>Recent Items</md-tooltip>\n </md-button>\n <md-menu-content style=\"min-height: 90vh; max-width: 60vw; min-width: 250px;\" au-suspendable update-on-event=\"recent\">\n <div class=\"recent-items-menu\" ng-if=\"$root.user.getGeneralRecentItems().length > 0\">\n <h3 class=\"margin-0 padding-10 font-weight-400\" style=\"line-height: 30px\">All Recent Items...</h3>\n <md-menu-item ng-repeat=\"recentItem in $root.user.getGeneralRecentItems() track by (recentItem.item.$key + recentItem.item._id)\"\n ng-click=\"recentItem.item.open()\">\n <md-button aria-label=\"{{::recentItem.item.toString()}}\">\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image item=\"recentItem.item\" size=\"25\" flex=\"shrink\" class=\"margin-right-40\"></au-profile-image>\n <div flex=\"grow\" ng-bind=\"recentItem.item.toString()\"></div>\n </div>\n </md-button>\n </md-menu-item>\n </div>\n <div class=\"recent-items-menu md-padding\" ng-if=\"$root.user.getGeneralRecentItems().length == 0\" style=\"max-width: 250px\">\n <h3>No Recent Items ☹</h3>\n <p class=\"md-body-1\">\n You haven\'t open anything yet. As you view items they will appear here.\n </p>\n </div>\n </md-menu-content>\n </md-menu>\n \n <md-button class=\"md-icon-button big-icon-button\" ng-click=\"$root.user.open()\" id=\"BtnMyAccount\">\n <au-profile-image item=\"$root.user\" size=\"40\"></au-profile-image>\n <md-tooltip>My Account</md-tooltip>\n </md-button>\n </div>\n <div ng-include src=\"::$state.$current.itemTemplateUrl\" class=\"item-include\"></div>\n </md-content>\n </div>\n </div>\n </div>\n \n <ng-include src=\"::\'/app/alignus/layouts/_shell/window-fab.tmpl.html\'\" ng-if=\"!$root.isShellPeek && !$root.rightSideNavIsOpen && !root.peekIsOpen\"></ng-include>\n <ng-include src=\"::\'/app/alignus/layouts/_shell/au-global-elements.html\'\"></ng-include>");
$templateCache.put("/app/alignus/layouts/task-board-viewer/task-board-viewer.tmpl.html","<div class=\"card-viewer\" layout=\"column\" layout-fill id=\"Background\">\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/alignus/layouts/_shell/one-search-toolbar.tmpl.html\'\" style=\"position: fixed; top: 64px;\"></div>\n\n <md-content style=\"background: transparent\">\n <div class=\"one-search-content-buffer\"></div>\n <!-- content go here -->\n <au-task-board initial-state=\"UserBoard\" item=\"vm.item\"></au-task-board>\n </md-content>\n</div>");
$templateCache.put("/app/alignus/services/toast/toast-error.tmpl.html","<!-- based off of angular material mdToast template -->\n<md-toast class=\"error\">\n <div class=\"md-toast-content\">\n <span flex role=\"alert\" aria-relevant=\"all\" aria-atomic=\"true\" layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-alert-circle\" class=\"bounce\"></md-icon>\n <p class=\"md-body-1 margin-left-20\" flex style=\"color: white\">\n {{ toastContent }}\n </p>\n </span>\n </div>\n</md-toast>");
$templateCache.put("/app/alignus/services/toast/toast-success.tmpl.html","<!-- based off of angular material mdToast template -->\n<md-toast class=\"success\">\n <div class=\"md-toast-content\">\n <span flex role=\"alert\" aria-relevant=\"all\" aria-atomic=\"true\" layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\" class=\"bounce\"></md-icon>\n <p class=\"md-body-1 margin-left-20\" flex>\n {{ toastContent }}\n </p>\n </span>\n </div>\n</md-toast>");
$templateCache.put("/app/alignus/services/videocall/incoming-video-call.tmpl.html","<md-dialog class=\"incoming-video-call\">\n <md-toolbar>\n <div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n <h2 dynamic=\"vm.currentState.titleHtml || \'Incoming Video Call\'\"></h2>\n <md-button class=\"md-icon-button\" ng-click=\"vm.currentState.secondaryAction()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\">\n </md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content>\n <div class=\"md-padding\" dynamic=\"vm.currentState.html\"></div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\">\n <md-button ng-show=\"vm.currentState.thirdAction\" ng-click=\"vm.currentState.thirdAction()\" dynamic=\"vm.currentState.thirdActionHtml\"></md-button> \n <md-button ng-click=\"vm.currentState.secondaryAction()\" dynamic=\"vm.currentState.secondaryHtml || \'Decline\'\"></md-button>\n <md-button ng-click=\"vm.currentState.primaryAction()\" ng-disabled=\"vm.currentState.disablePrimary\" dynamic=\"vm.currentState.primaryHtml || \'Accept\'\" class=\"md-primary md-raised\"></md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/social/meetings/report/one-search-for-meeting-stats.tmpl.html","<div class=\"one-search-toolbar clip\" layout=\"column\" layout-align=\"center center\">\n\n <div class=\"search-input margin-top-8\" layout=\"row\" layout-align=\"center center\" style=\"width:70%\">\n <one-search flex=\"100\" mode=\"meetingReport\"></one-search>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-top-20\" layout-fill style=\"width:70%\">\n <mdp-date-picker mdp-open-on-click required name=\"date\" mdp-placeholder=\"Meetings from...\" ng-model=\"vm.reportQuery.startDate\" mdp-format=\"M/D/YYYY\" mdp-min-date=\"\'2000-01-01\'\"\n mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\" id=\"TxtStartDate\">\n <div ng-messages=\"eventPage2.date.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-date-picker>\n <mdp-date-picker mdp-open-on-click required name=\"date\" mdp-placeholder=\"to...\" ng-model=\"vm.reportQuery.endDate\" mdp-format=\"M/D/YYYY\" mdp-min-date=\"\'2000-01-01\'\"\n mdp-max-date=\"\'2025-01-01\'\" class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"100\" id=\"TxtStartDate\">\n <div ng-messages=\"eventPage2.date.$error\">\n <div ng-message=\"required\">This is required</div>\n <div ng-message=\"format\">Invalid format</div>\n </div>\n </mdp-date-picker>\n <md-button ng-click=\"vm.goClicked()\" class=\"md-raised md-accent\" id=\"BtnGetReport\">&nbsp; Go <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n </md-button>\n </div>\n</div>");
$templateCache.put("/app/social/meetings/report/report.tmpl.html","<div class=\"landing-recent-groupings Xau-landing-page\" ng-class=\"$state.$current.data.sectionSettings.title.toLowerCase()\" layout=\"column\" layout-fill style=\"background-color:rgb(255,255,255)\" id=\"ContentLandingPage\">\n <div class=\"one-search-toolbar-container\" ng-include=\"::\'/app/social/meetings/report/one-search-for-meeting-stats.tmpl.html\'\">\n </div>\n <md-content class=\"margin-top-130\" Xstyle=\"margin-right:auto;margin-left:auto;\" style=\"position:relative;\">\n <!--insert no meeting to display empty state-->\n <div ng-show=\"!vm.report.MatchedMeetings\" layout=\"column\" layout-align=\"top center\" style=\"color:rgba(0,0,0,0.4);\">\n <img s3-src=\"/assets/images/empty-states/meeting.png\" style=\"max-width:500px; width:100%;\">\n <div layout=\"column\" layout-align=\"top center\" style=\"position:relative;top:-70px\">\n <div class=\"md-headline font-weight-300 ng-binding\">Nothing to see here!</div>\n <div class=\"md-caption ng-binding\">There are no meetings to display.</div>\n </div>\n </div>\n <div ng-show=\"vm.report.MatchedMeetings\" class=\"padding-60 margin-top-60\">\n <md-divider></md-divider>\n <div layout=\"column\" layout-align=\"center center\" class=\"padding-10\">\n <span class=\"md-subhead\" id=\"StringReportSummary\"><b>{{(vm.reportQuery.item | auItemFilter) || $root.Organization.Name}}</b> hosted <b>{{vm.report.MatchedMeetings.length}}</b> meetings from <b>{{vm.reportQuery.startDate | date: \'shortDate\'}}</b> to <b>{{vm.reportQuery.endDate | date : \'shortDate\'}}</b> with an estimated cost of <b>${{vm.report.EstimatedTotalCost}}</b>.\n </span>\n </div>\n <md-divider class=\"margin-bottom-40\"></md-divider>\n <div>\n <div layout=\"column\" class=\"margin-bottom-40\">\n <div layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-trending-up\" class=\"margin-10\"></md-icon>\n <span class=\"md-title\" flex>Percentage of Successful Meetings</span>\n </div>\n <div flex ng-if=\"vm.lineChart.data.length > 1 || vm.lineChart.data[0] != 0\">\n <!--line graph for percentage of succesful meetings-->\n <canvas class=\"chart chart-line\" chart-data=\"vm.lineChart.data\" chart-labels=\"vm.lineChart.labels\" id=\"GraphPercentSuccess\"></canvas>\n </div>\n <div flex ng-if=\"vm.lineChart.data.length < 1 || (vm.lineChart.data.length == 1 && vm.lineChart.data[0] == 0)\" id=\"GraphPercentSuccessEmpty\">\n Employees did not think any of these meetings were successful. Oops!\n </div>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" class=\"margin-bottom-40\">\n <div flex class=\"margin-bottom-20\">\n <div layout=\"column\">\n <div layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" class=\"margin-10\" style=\"color:#39B54A\"></md-icon>\n <span class=\"md-title\" flex>Impressive Areas</span>\n </div>\n <canvas class=\"chart chart-bar\" chart-data=\"vm.topFive.data\" chart-labels=\"vm.topFive.labels\" id=\"GraphImpressiveAreas\"></canvas>\n </div>\n </div>\n <div flex>\n <div layout=\"column\">\n <div layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-thumb-down\" class=\"margin-10\" style=\"color:#ED1C24\"></md-icon>\n <span class=\"md-title\" flex>Needs Improvement</span>\n </div>\n <canvas class=\"chart chart-bar\" chart-data=\"vm.bottomFive.data\" chart-labels=\"vm.bottomFive.labels\" id=\"GraphNeedsImprovement\"></canvas>\n </div>\n </div>\n </div>\n\n <!-- Cost table -->\n <div layout=\"row\" layout-align=\"start center\" class=\"md-caption md-default-theme background-color-700\" style=\"color:white; text-align:left;\" hide-xs>\n <div flex=\"30\" class=\"margin-10\">Meeting</div>\n <div flex=\"20\" class=\"margin-10\">Date</div>\n <div flex=\"30\" class=\"margin-10\">Organizer</div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:right;\">Estimated Cost</div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:right;\">Feedback\n </div>\n </div>\n\n <div ng-repeat=\"meeting in vm.report.MatchedMeetings\" class=\"usercard-button\" ng-click=\"vm.openMeeting(meeting)\" layout=\"row\" layout-align=\"start center\" style=\"border-bottom:solid thin #f1f1f1;\" hide-xs>\n <div layout-fill flex=\"30\" layout=\"row\" layout-align=\"start center\" class=\"margin-10 md-body-2\" ng-attr-id=\"BtnMeetingTitle{{$index}}\">\n {{meeting.Title}}\n </div>\n <div flex=\"20\" class=\"margin-10 md-caption\" ng-attr-id=\"StringMeetingDate{{$index}}\">{{meeting.StartDate | date : \'short\'}}</div>\n <div flex=\"30\" class=\"margin-10\" layout=\"row\" layout-align=\"start center\">\n <au-profile-image size=\"40\" user=\"meeting.Creator\" ng-attr-id=\"ImgMeetingCreator{{$index}}\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n <span class=\"md-body-2\" ng-attr-id=\"StringMeetingCreator{{$index}}\">{{meeting.Creator | fullNameFilter}}</span>\n </div>\n <div flex=\"10\" class=\"margin-10\" style=\"text-align:right;\" ng-attr-id=\"StringMeetingCost{{$index}}\">${{meeting.EstimatedCost}}</div>\n <div flex=\"10\" class=\"margin-10\" layout=\"row\" layout-align=\"end center\">\n <div ng-if=\"meeting.ReportData.ApprovalStats.approvedPercentage >= 50\" layout=\"row\" layout-align=\"end center\" ng-attr-id=\"StringMeetingPercentUp{{$index}}\">\n <span flex style=\"text-align:right;\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}%</span>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" style=\"color:#39B54A\"></md-icon>\n </div>\n <div ng-if=\"meeting.ReportData.ApprovalStats.approvedPercentage < 50\" layout=\"row\" layout-align=\"end center\" ng-attr-id=\"StringMeetingPercentDown{{$index}}\">\n <span flex style=\"text-align:right;\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}%</span>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-down\" style=\"color:#ED1C24\"></md-icon>\n </div>\n <md-tooltip md-direction=\"bottom\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}% of users thought this meeting was successful</md-tooltip>\n </div>\n </div>\n\n <!--cost table mobile view-->\n <div layout=\"row\" layout-align=\"start center\" class=\"md-caption md-default-theme background-color-700\" style=\"color:white; text-align:left;\" hide-gt-xs>\n <div flex=\"60\" class=\"margin-10\">Meeting</div>\n <div flex=\"20\" class=\"margin-10\" style=\"text-align:right;\">Est Cost</div>\n <div flex=\"20\" class=\"margin-10\" style=\"text-align:right;\">Feedback\n </div>\n </div>\n\n <div ng-repeat=\"meeting in vm.report.MatchedMeetings\" layout=\"row\" layout-align=\"start center\" style=\"border-bottom:solid thin #f1f1f1;\" hide-gt-xs >\n <div flex=\"60\" ng-click=\"vm.openMeeting(meeting)\" layout=\"column\" layout-align=\"center start\" style=\"cursor:pointer;\" class=\"margin-10\">\n <span class=\"md-body-2\" >{{meeting.Title}}</span>\n <span class=\"md-caption\">{{meeting.StartDate | date : \'short\'}}</span>\n <div layout=\"row\" class=\"md-caption margin-top-\">\n <au-profile-image size=\"20\" user=\"meeting.Creator\" style=\"margin-right:5px;\"></au-profile-image>\n <span><strong>{{meeting.Creator | fullNameFilter}}</strong></span>\n </div>\n </div>\n\n\n <div flex=\"20\" class=\"margin-10\" style=\"text-align:right;\">${{meeting.EstimatedCost}}</div>\n <div flex=\"20\" class=\"margin-10\" layout=\"row\" layout-align=\"end center\">\n <div ng-if=\"meeting.ReportData.ApprovalStats.approvedPercentage >= 50\" layout=\"row\" layout-align=\"end center\">\n <span flex style=\"text-align:right;\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}%</span>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-up\" style=\"color:#39B54A\"></md-icon>\n </div>\n <div ng-if=\"meeting.ReportData.ApprovalStats.approvedPercentage < 50\" layout=\"row\" layout-align=\"end center\">\n <span flex style=\"text-align:right;\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}%</span>\n <md-icon md-font-icon=\"zmdi zmdi-thumb-down\" style=\"color:#ED1C24\"></md-icon>\n </div>\n <md-tooltip md-direction=\"bottom\">{{meeting.ReportData.ApprovalStats.approvedPercentage}}% of users thought this meeting was successful</md-tooltip>\n </div>\n </div>\n <!--mobile view end-->\n\n\n <div layout=\"row\" layout-align=\"end center\" class=\"margin-top-40 margin-bottom-80\">\n <span class=\"md-caption margin-right-20\">Total Estimated Cost </span>\n <span class=\"md-headline\" style=\"font-family:\'Roboto Mono\';\" id=\"StringTotalCost\">${{vm.report.EstimatedTotalCost}}</span>\n </div>\n </div>\n </md-content>\n</div>");
$templateCache.put("/app/social/questions/dialogs/add-tag.tmpl.html","<md-dialog\n au-wizard dialog-title=\"Add Tag\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Wizard Dialog\"\n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddTag\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/add.png\">\n <h3>Add A Tag</h3>\n <p>Tags make it easier for users to search for questions. Every question will have at least one tag. A tag should be a keyword that can be associated with many questions. Try to stay away from phrases, individual words work best as tags.</p>\n <p>Each tag will have a moderator. A tag moderator has administrative control over all questions that have their tag. Tag moderators will be able to add questions to the FAQ list as well as edit and delete questions and all of their answers. This will hep manage questions as more and more are asked.</p>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"tag\" step-bg=\"/assets/images/dialogs/name.png\" on-next-step=\"vm.confirmTitleEntered()\">\n <h3>Add A Tag</h3>\n <p>The tag title will be the tag that is given to a question. Give the tag a brief description to help everyone understand the meaning of your tag. Remember that some words have multiple meanings.</p>\n <!--wire up tag title and description-->\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-label\"></md-icon>\n <label>Tag Title</label>\n <input ng-model=\"vm.questionTag.TagText\" required id=\"TxtTagTitle\" />\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n <label>Tag Description</label>\n <input ng-model=\"vm.questionTag.Description\" id=\"TxtTagDescription\" />\n </md-input-container>\n <!--end wire up-->\n </au-wizard-step>\n\n <au-wizard-step step-name=\"moderator\" step-bg=\"/assets/images/dialogs/name.png\" on-next-step=\"vm.confirmModeratorEntered()\">\n <h3>Tag Moderator</h3>\n <p>Tag moderators will have administrative control over any question given with their tag. This means that they will be able to mark a question as an FAQ as well as edit and delete questions and all of their answers. Each tag will have one moderator. But one question can have many tags, so one question can have many moderators.</p>\n <!--wire up autocomplete for tag moderators-->\n <md-autocomplete md-search-text=\"vm.moderatorSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.moderatorSearchText, excludeContacts: true})\" placeholder=\"Select Moderator\" md-autoselect=\"true\" md-select-on-match=\"true\" md-selected-item=\"vm.questionTag.Moderator\" md-item-text=\"user | fullNameFilter\" id=\"TxtTagModerator\">\n <span md-highlight-text=\"vm.moderatorSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoTagModerator{{$index}}\">\n {{user | fullNameFilter}}\n </span>\n </md-autocomplete>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/social/questions/dialogs/ask-question.tmpl.html","<md-dialog au-wizard dialog-title=\"Ask Question\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\"\n steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Ask Question Dialog\" flex=\"50\" flex-sm=\"100\"\n flex-md=\"60\" style=\"min-height: 480px\" id=\"AskQuestion\">\n <au-wizard-step step-name=\"ask\" step-bg=\"/assets/images/dialogs/email.png\" on-next-step=\"vm.confirmQuestionEntered()\">\n <div>\n <div layout=\"row\">\n <md-input-container class=\"dialog-question-input-container\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-help-outline\"></md-icon>\n <input ng-model=\"vm.question.QuestionTitle\" type=\"text\" placeholder=\"Question Subject\" ng-change=\"vm.getQuestionsMatchingSearch()\" ng-enter-key=\"vm.shrinkResults()\"\n />\n </md-input-container>\n <md-button ng-if=\"vm.question.QuestionTitle\" class=\"md-button md-accent\" ng-click=\"vm.shrinkResults()\">\n <md-tooltip md-direction=left md-visible=\"vm.showTooltip\">Answer not below? Ask those who know!</md-tooltip>\n <md-icon ng-show=\"vm.showResults\" md-font-icon=\"zmdi zmdi-close\"></md-icon>\n <md-icon ng-show=\"!vm.showResults\" md-font-icon=\"zmdi zmdi-search\"></md-icon>\n </md-button>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-65\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div class=\"au-cke-document text-area margin-top-15\" flex ng-model=\"vm.question.QuestionBody\" placeholder=\"Question Body\" id=\"CkeQuestionBody\" grow=\"true\"></div>\n </div>\n\n <au-document-section ng-show=\"vm.docSection\" item=\"vm.question\" prevent-new-documents=\"true\"></au-document-section>\n <md-button ng-click=\"vm.showDocSection()\" class=\"md-raised\" id=\"BtnAttach\" style=\"position: absolute; bottom: 20px; left: 20px;\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment\"></md-icon>\n &nbsp; Attach\n </md-button>\n\n <div ng-show=\"vm.showResults\" class=\"dialog-question-search-results border-top-color\">\n <div class=\"padding-20 font-color-700\">Others have asked similar questions. Please prevent duplicate questions by viewing answers below or click \"Next\" to continue typing your question.</div>\n <div layout=\"row\" class=\"dialog-question no-animate margin-0\" layout-align=\"start start\" ng-repeat=\"item in vm.searchResults track by $index\">\n <img class=\"icon\" s3-src=\"/assets/images/avatars/question.png\" />\n <span ng-bind-html=\"vm.highlightSuggestion(item.QuestionTitle)\" title=\"{{item.QuestionTitle | auItemFilter: \'Question\'}}\"\n ng-click=\"vm.openQuestion(item)\" flex></span>\n </div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"whoToAsk\" step-bg=\"/assets/images/dialogs/name.png\" on-next-step=\"vm.confirmWhoToAskEntered()\">\n <h3>Who Are You Asking?</h3>\n <p>You can direct the question to a particular user, a team, or your entire organization if you type \'everyone\'. Then, choose\n how much time can pass before escalating the question to the next person or group of people.</p>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block margin-top-40\">\n <!--<md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-10\"></md-icon>-->\n <md-autocomplete md-selected-item=\"vm.question.WhoToAsk.FirstAsk\" md-search-text=\"vm.firstAskSearchText\" md-items=\"item in vm.searchUsersAndTeams(vm.firstAskSearchText, true, true)\"\n md-select-on-focus placeholder=\"First Ask...\" md-autoselect=\"true\" md-select-on-match=\"true\" md-item-text=\"item.$Display\"\n md-selected-item-change=\"vm.itemChanged()\" flex=\"100\" id=\"TxtFirstAsk\">\n <span md-highlight-text=\"vm.firstAskSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoFirstAsk{{$index}}\">\n {{ item.$Display }}\n </span>\n </md-autocomplete>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <md-input-container class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"80\">\n <label>If they don\'t respond after</label>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <md-select ng-model=\"vm.question.WhoToAsk.DelaySecondAsk\" id=\"DrpSecondAskAfter\">\n <md-option ng-repeat=\"hourOption in vm.escalateDelayOptions\" value=\"{{hourOption.dataValue}}\" ng-attr-id=\"BtnSecondAskAfterOption{{$index}}\">\n {{hourOption.optionString}}\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <!--<md-icon md-font-icon=\"zmdi zmdi-account-circle\" class=\"margin-right-10\"></md-icon>-->\n <md-autocomplete md-selected-item=\"vm.question.WhoToAsk.SecondAsk\" md-search-text=\"vm.secondAskSearchText\" md-items=\"item in vm.searchUsersAndTeams(vm.secondAskSearchText, true, true)\"\n md-select-on-focus placeholder=\"Then Ask...\" md-autoselect=\"true\" md-select-on-match=\"true\" md-item-text=\"item.$Display\"\n md-selected-item-change=\"vm.itemChanged(\'second\')\" flex=\"100\" id=\"TxtSecondAsk\">\n <span md-highlight-text=\"vm.secondAskSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoSecondAsk{{$index}}\">\n {{ item.$Display }}\n </span>\n </md-autocomplete>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <md-input-container class=\"md-icon-float md-block\" flex-gt-sm=\"50\" flex=\"80\">\n <label>If they don\'t respond after</label>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <md-select ng-model=\"vm.question.WhoToAsk.DelayFinallyAsk\" id=\"DrpThirdAskAfter\">\n <md-option ng-repeat=\"hourOption in vm.escalateDelayOptions\" value=\"{{hourOption.dataValue}}\" ng-attr-id=\"BtnThirdAskAfterOption{{$index}}\">\n {{hourOption.optionString}}\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <!--<md-icon md-font-icon=\"zmdi zmdi-accounts-alt\" class=\"margin-right-10\"></md-icon>-->\n <md-autocomplete md-selected-item=\"vm.question.WhoToAsk.FinallyAsk\" md-search-text=\"vm.finallyAskSearchText\" md-items=\"item in vm.searchUsersAndTeams(vm.finallyAskSearchText, true, true)\"\n placeholder=\"Finally Ask...\" md-autoselect=\"true\" md-select-on-match=\"true\" md-item-text=\"item.$Display\" md-selected-item-change=\"vm.itemChanged(\'finally\')\"\n md-select-on-focus flex=\"100\" id=\"TxtThirdAsk\">\n <span md-highlight-text=\"vm.finallyAskSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoThirdAsk{{$index}}\">\n {{ item.$Display }}\n </span>\n </md-autocomplete>\n </div>\n\n </au-wizard-step>\n\n\n <au-wizard-step step-name=\"tag\" step-bg=\"/assets/images/dialogs/name.png\">\n <h3 class=\"text-ellipsis\">Categorize \"{{vm.question.QuestionTitle}}\"</h3>\n <p>Categorize your question with others like it. Enter all applicable tags.</p>\n\n <div layout=\"row\" layout-align=\"center start\" class=\"margin-top-40 margin-bottom-20\">\n <md-input-container flex layout=\"row\" layout-align=\"center start\">\n <md-icon md-font-icon=\"zmdi zmdi-search\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <input type=\"text\" ng-model=\"vm.searchTagsText\" placeholder=\"Filter tags\" id=\"TxtTag\" />\n </md-input-container>\n\n <md-button class=\"md-raised md-accent\" ng-show=\"vm.searchTagsText && vm.showAddTag()\" ng-click=\"vm.addTag()\" id=\"BtnAddTag\">\n Add \"{{vm.searchTagsText}}\"\n </md-button>\n </div>\n\n <div layout=\"row\" layout-wrap>\n <div flex=\"50\" ng-repeat=\"tag in vm.newTags\">\n <md-checkbox ng-checked=\"true\" ng-click=\"vm.removeNewTag(tag)\">\n {{tag.TagText}}\n </md-checkbox>\n </div>\n\n <div flex=\"50\" ng-repeat=\"tag in vm.allTags | filter : vm.searchTagsText\">\n <md-checkbox ng-checked=\"vm.tagInQuestion(tag)\" ng-click=\"vm.toggleTagInQuestion(tag)\" ng-attr-id=\"CbxTagOption{{$index}}\">\n {{tag.TagText}}\n </md-checkbox>\n </div>\n </div>\n </au-wizard-step>\n <au-wizard-step step-name=\"newTags\" on-next-step=\"vm.confirmTagDescriptions()\">\n <h3>New Category Tags</h3>\n <p>You created a new tag! As the tag creator, you will be the first moderator of the tag topic (a sys admin may adjust who\n the moderator is in the future). <br><br>Please provide a description of each new tag below to help others use them correctly.</p>\n\n <div layout=\"column\" layout-align=\"center start\" ng-repeat=\"newTag in vm.newTags\" class=\"margin-bottom-30 margin-top-40\">\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-tag\" class=\"margin-right-5\"></md-icon><span class=\"md-headline\">{{newTag.TagText}}</span>\n </div>\n\n <div>\n <md-input-container class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <input required ng-model=\"newTag.Description\" placeholder=\"Tag Description\" style=\"width: 500px;\" ng-attr-id=\"TxtTagDescription{{$index}}\"\n />\n </md-input-container>\n </div>\n </div>\n\n </au-wizard-step>\n\n</md-dialog>");
$templateCache.put("/app/social/questions/dialogs/edit-question-answer.tmpl.html","<md-dialog\n au-wizard dialog-title=\"Edit Answer\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Edit Answer Dialog\"\n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"EditAnswer\">\n <au-wizard-step step-name=\"step2\" step-bg=\"/assets/images/dialogs/email.png\">\n <h3>Edit Question Answer</h3>\n <p>You are editing the answer to a question.</p>\n <md-input-container>\n <label><span>Answer Title</span></label>\n <input type=\"text\" name=\"answerTitle\" required id=\"TxtEditAnswerTitle\" ng-model=\"vm.answer.AnswerTitle\">\n </md-input>\n </md-input-container>\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-15\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n </div>\n <div flex layout=\"column\">\n <div class=\"au-cke-document md-input margin-top-15\" ng-model=\"vm.answer.Content\" placeholder=\"Answer Details\" id=\"CkeAnswerBody\" grow=\"true\"></div>\n </div>\n </div>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/social/questions/dialogs/edit-question.tmpl.html","<md-dialog au-wizard dialog-title=\"Edit Question\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\"\n steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog\" aria-label=\"Edit Question Dialog\" flex=\"50\" flex-sm=\"100\"\n flex-md=\"60\" style=\"min-height: 480px\" id=\"EditQuestion\">\n\n <au-wizard-step step-name=\"ask\" step-bg=\"/assets/images/dialogs/typebg.png\" on-next-step=\"vm.confirmTitleEntered()\">\n <md-input-container flex style=\"margin: 18px 0 0 0;\">\n <input ng-model=\"vm.question.QuestionTitle\" type=\"text\" placeholder=\"Question Title\" />\n </md-input-container>\n\n <div flex layout=\"column\">\n <div class=\"au-cke-document text-area margin-top-15\" ng-model=\"vm.question.QuestionBody\" placeholder=\"Question Body\" id=\"CkeQuestionBody\" grow=\"true\"></div>\n </div>\n\n <au-document-section ng-show=\"vm.docSection\" item=\"vm.question\" prevent-new-documents=\"true\"></au-document-section>\n <md-button ng-click=\"vm.showDocSection()\" class=\"md-raised\" id=\"BtnAttach\" style=\"position: absolute; bottom: 20px; left: 20px;\">\n <md-icon md-font-icon=\"zmdi zmdi-attachment\"></md-icon>\n &nbsp; Attach\n </md-button>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"step4\" step-bg=\"/assets/images/dialogs/name.png\" on-next-step=\"vm.checkForNewTags()\">\n <h3 class=\"text-ellipsis\">Categorize \"{{vm.question.QuestionTitle}}\"</h3>\n <p class=\"margin-bottom-20\">Categorize your question with others like it. Enter all applicable tags.</p>\n\n <div layout=\"row\" layout-align=\"center start\" class=\"margin-top-40 margin-bottom-20\">\n <md-input-container flex layout=\"row\" layout-align=\"center start\">\n <md-icon md-font-icon=\"zmdi zmdi-search\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <input type=\"text\" ng-model=\"vm.searchTagsText\" placeholder=\"Filter tags\" id=\"TxtTag\" />\n </md-input-container>\n\n <md-button class=\"md-raised md-accent\" ng-show=\"vm.searchTagsText && vm.showAddTag()\" ng-click=\"vm.addTag()\" id=\"BtnAddTag\">\n Add \"{{vm.searchTagsText}}\"\n </md-button>\n </div>\n\n <div layout=\"row\" layout-wrap>\n <div flex=\"50\" ng-repeat=\"tag in vm.newTags\">\n <md-checkbox ng-checked=\"true\" ng-click=\"vm.removeNewTag(tag)\">\n {{tag.TagText}}\n </md-checkbox>\n </div>\n\n <div flex=\"50\" ng-repeat=\"tag in vm.allTags | filter : vm.searchTagsText\">\n <md-checkbox ng-checked=\"vm.tagInQuestion(tag)\" ng-click=\"vm.toggleTagInQuestion(tag)\" ng-attr-id=\"CbxTagOption{{$index}}\">\n {{tag.TagText}}\n </md-checkbox>\n </div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"newTags\" on-next-step=\"vm.makeNewTags()\">\n <h3>New Category Tags</h3>\n <p>You created a new tag! As the tag creator, you will be the first moderator of the tag topic (a sys admin may adjust who\n the moderator is in the future). <br><br>Please provide a description of each new tag below to help others use them correctly.</p>\n\n <div layout=\"column\" layout-align=\"center start\" ng-repeat=\"newTag in vm.newTags\" class=\"margin-bottom-30\">\n <div layout=\"row\" layout-align=\"start center\" class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-tag\" class=\"margin-right-5\"></md-icon><span class=\"md-headline\">{{newTag.TagText}}</span>\n </div>\n\n <div>\n <md-input-container class=\"md-icon-float md-block\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" style=\"color: rgba(0,0,0,0.54);\"></md-icon>\n <input required ng-model=\"newTag.Description\" placeholder=\"Tag Description\" style=\"width: 500px;\" ng-attr-id=\"TxtTagDescription{{$index}}\"\n />\n </md-input-container>\n </div>\n </div>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/social/questions/moderators/moderators.tmpl.html","<div class=\"overflow-auto moderators md-padding\">\n\n<!--FAB-->\n <md-fab-speed-dial md-direction=\"up\" class=\"md-scale\" style=\"position: fixed; bottom: 50px; right: 50px;\">\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-fab md-accent\">\n <md-icon md-font-icon=\"zmdi zmdi-plus\" style=\"font-size: 30px;\"></md-icon>\n </md-button>\n </md-fab-trigger>\n <md-fab-actions class=\"margin-left-8\">\n <md-button aria-label=\"ask\" class=\"md-fab md-raised md-accent md-mini\" ng-click=\"vm.openAskQuestionDialog($event)\">\n <md-tooltip md-direction=\"left\">Ask Question</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-help-outline\"></md-icon>\n </md-button>\n <md-button aria-label=\"share\" class=\"md-fab md-raised md-accent md-mini\" au-share>\n <md-tooltip md-direction=\"left\">Share Question</md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-share\"></md-icon>\n </md-button>\n\n </md-fab-actions>\n </md-fab-speed-dial>\n<!--FAB end-->\n\n<div class=\"margin-40\"><h1>Manage Moderators Test Pane</h1></div>\n\n\n<ng-form name=\'editForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n \n\n <!--Tag Card-->\n <md-card style=\"border-radius: 0 50px 0px 0;\">\n \n <md-card-content layout=\"column\">\n <div layout=\"row\" layout-align=\"start center\" class=\"padding-left-30 padding-right-30\">\n <md-icon md-font-icon=\"zmdi zmdi-label\" class=\"zmdi-hc-fw auto-height font-size-4\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Life</div>\n <div class=\"description\">Edit moderators</div>\n </div>\n <div class=\"timestamp\">3 questions tagged</div> \n </div>\n </md-card-content> \n \n \n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content> \n \n <div layout=\"column\" layout-align=\"center none\">\n \n \n <span class=\"md-subhead\">Moderators:</span>\n <div>\n <form>\n <md-chips placeholder=\"Add a moderator\" md-enable-chip-edit=\"true\">\n <md-chip>Pam Poovey</md-chip>\n <md-chip>Lana Kane</md-chip>\n </md-chips>\n </form>\n </div>\n </div>\n </md-card-content>\n </div>\n </md-card>\n \n<!------------------------------------------------------------------------------------------------------------------------------------------->\n\n \n \n <!--Question Card-->\n <md-card class=\"questions\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\" id=\"BtnQuestionHeader\" class=\"padding-left-30 padding-right-30\">\n <au-profile-image user=\"$root.user\" size=\"50\" class=\"margin-0\"></au-profile-image>\n <div layout=\"column\" flex>\n <div class=\"md-title\">What is the meaning of life?</div>\n <div class=\"description\">Sterling Archer<md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>Marketing Department</div>\n </div>\n <div class=\"timestamp\">16 min ago</div>\n </div> \n </md-card-content> \n \n \n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content> \n \n <div layout=\"column\" layout-align=\"center none\">\n \n <div layout=\"column\" flex>\n <p>\n What is the significance of living or existence in general? Why are we here, what is life all about?, and What is the purpose of existence? Does life exist at all?\n The search for life\'s meaning has produced much philosophical, scientific, theological, and metaphysical speculation throughout history.\n </p>\n </div>\n \n <div>\n <md-chips md-enable-chip-edit=\"true\">\n <md-chip>life</md-chip>\n <md-chip>meaning</md-chip>\n <md-chip>purpose</md-chip>\n <md-chip>philosophy</md-chip>\n <md-chip>existence</md-chip>\n </md-chips>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\">\n <md-button aria-label=\"go to question\" class=\"md-button\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n <span>go to question thread</span>\n </md-button> \n </div>\n \n \n </div>\n </md-card-content> \n </div>\n </md-card>\n \n<!-------------------------------------------------------------------------------------------------------------------------------------------> \n\n <!--Question Card-->\n <md-card class=\"questions\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\" id=\"BtnQuestionHeader\" class=\"padding-left-30 padding-right-30\">\n <au-profile-image user=\"$root.user\" size=\"50\" class=\"margin-0\"></au-profile-image>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Is there life on Mars?</div>\n <div class=\"description\">Sterling Archer<md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>Lana Kane</div>\n </div>\n <div class=\"timestamp\">2 days ago</div>\n </div> \n </md-card-content> \n \n \n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content> \n \n <div layout=\"column\" layout-align=\"center none\">\n \n <div layout=\"column\" flex>\n <p>\n Recent NASA reports have suggested human-like activities on the surface of Mars. Can someone confirm this?\n </p>\n </div>\n \n <div>\n <md-chips md-enable-chip-edit=\"true\">\n <md-chip>life</md-chip>\n <md-chip>mars</md-chip>\n <md-chip>alien</md-chip>\n </md-chips>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\">\n <md-button aria-label=\"go to question\" class=\"md-button\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n <span>go to question thread</span>\n </md-button> \n </div>\n \n \n </div>\n </md-card-content> \n </div>\n </md-card>\n \n<!-------------------------------------------------------------------------------------------------------------------------------------------> \n \n <!--Question Card-->\n <md-card class=\"questions\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\" id=\"BtnQuestionHeader\" class=\"padding-left-30 padding-right-30\">\n <au-profile-image user=\"$root.user\" size=\"50\" class=\"margin-0\"></au-profile-image>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Was Kanye\'s recent album any good?</div>\n <div class=\"description\">Sterling Archer<md-icon md-font-icon=\"zmdi zmdi-caret-right\"></md-icon>Cyril Figgis</div>\n </div>\n <div class=\"timestamp\">1 month ago</div>\n </div> \n </md-card-content> \n \n \n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content> \n \n <div layout=\"column\" layout-align=\"center none\">\n \n <div layout=\"column\" flex>\n <p>\n The \"Life of Pablo\" was released about a month ago and I haven\'t heard anything about it because it\'s only on tidal. Is it any good?\n </p>\n </div>\n \n <div>\n <md-chips md-enable-chip-edit=\"true\">\n <md-chip>life</md-chip>\n <md-chip>Pablo</md-chip>\n <md-chip>Kanye</md-chip>\n <md-chip>music</md-chip>\n </md-chips>\n </div>\n \n <div layout=\"row\" layout-align=\"end center\">\n <md-button aria-label=\"go to question\" class=\"md-button\">\n <md-icon md-font-icon=\"zmdi zmdi-arrow-right\"></md-icon>\n <span>go to question thread</span>\n </md-button> \n </div>\n \n \n </div>\n </md-card-content> \n </div>\n </md-card>\n \n<!-------------------------------------------------------------------------------------------------------------------------------------------> \n \n \n \n \n\n </md-popout-card-list>\n </div>\n</ng-form>\n\n<!--<md-button class=\"md-button md-raised\" ng-click=\"vm.openAskQuestionDialog($event)\">\n Ask Question\n</md-button>\n-->\n\n</div>");
$templateCache.put("/app/social/questions/question/questions.tmpl.html","<ng-form class=\"question-item-detail\" name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n\n\n <!--Question Card-->\n <md-card class=\"questions\" style=\"border-radius: 0 50px 0px 0;\">\n\n <md-card-content id=\"StringQuestionHeader\">\n <div layout=\"row\" layout-align=\"space-between center\" id=\"BtnQuestionHeader\" class=\"padding-30\" layout-xs=\"column\" layout-align-xs=\"center center\">\n <div layout=\"row\" layout-align=\"start center\" flex>\n <au-profile-image user=\"vm.item.Creator\" size=\"40\" class=\"margin-right-20\" >\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n\n <div layout=\"column\" layout-align=\"center start\" flex>\n <span class=\"md-subhead\"><strong>{{vm.item.QuestionTitle}}</strong></span>\n <span class=\"md-caption\">\n From {{vm.item.Creator | fullNameFilter}} \n <span ng-if=\"vm.item.WhoToAsk.FirstAsk\">to {{vm.item.WhoToAsk.FirstAsk.Id | auItemFilter : vm.item.WhoToAsk.FirstAsk.Type}}</span>\n <span ng-if=\"vm.item.WhoToAsk.SecondAsk\">, {{vm.item.WhoToAsk.SecondAsk.Id | auItemFilter : vm.item.WhoToAsk.SecondAsk.Type}}</span>\n <span ng-if=\"vm.item.WhoToAsk.FinallyAsk\"> and {{vm.item.WhoToAsk.FinallyAsk.Id | auItemFilter: vm.item.WhoToAsk.FinallyAsk.Type}}\n </span>\n <div ng-if=\"vm.item.ShouldUIShowAsFlagged()\" style=\"color:red;\">Flagged as inappropriate by {{vm.item.FlaggedBy.length}} {{vm.item.FlaggedBy.length == 1 ? \'user\' : \'users\'}}</div>\n <div class=\"timestamp\" am-time-ago=\"vm.item.DateCreated\"></div>\n </div>\n </div>\n\n <!--action buttons-->\n <div layout=\"row\" layout-align=\"end center\" id=\"BtnActions\" ng-click=\"$event.stopPropagation()\">\n <au-is-template-button item=\"vm.item\" edit-item-form=\"editItemForm\"></au-is-template-button>\n <md-button ng-if=\"vm.item.CanCurrentUserEdit()\" aria-label=\"delete\" class=\"md-icon-button\" ng-click=\"vm.deleteQuestion($event)\"\n id=\"BtnDeleteQuestion\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n <md-button ng-if=\"vm.item.CanCurrentUserEdit()\" aria-label=\"edit\" class=\"md-icon-button\" ng-click=\"vm.openEditQuestionDialog($event)\"\n id=\"BtnEditQuestion\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\">\n <md-tooltip>Edit</md-tooltip>\n </md-icon>\n </md-button>\n <md-button ng-disabled=\"!vm.item.IsCurrentUserTagModerator()\" aria-label=\"favorite\" class=\"md-icon-button\" ng-click=\"vm.toggleFaq()\"\n id=\"BtnFAQ\">\n <md-icon md-font-icon=\"zmdi zmdi-star\" ng-style=\"vm.item.IsFAQ ? {\'color\': \'gold\'} : \'\'\" name=\"faq\">\n <md-tooltip>Mark as FAQ</md-tooltip>\n </md-icon>\n </md-button>\n <md-button aria-label=\"flag\" class=\"md-icon-button\" ng-disabled=\"vm.item.DidCurrentUserFlag()\" ng-click=\"vm.flag($event)\"\n id=\"BtnFlagQuestion\">\n <md-icon md-font-icon=\"zmdi zmdi-flag\" ng-style=\"vm.item.DidCurrentUserFlag() ? {\'color\': \'crimson\'} : \'\'\" name=\"flag\">\n <md-tooltip>{{vm.item.DidCurrentUserFlag() ? \'You flagged this question as inappropriate\' : \'Flag as inappropriate\'}}</md-tooltip>\n </md-icon>\n </md-button>\n <md-button aria-label=\"follow\" class=\"md-icon-button\" ng-click=\"vm.toggleFollow()\" id=\"BtnFollowQuestion\">\n <md-icon md-font-icon=\"zmdi zmdi-alarm-plus\" ng-style=\"vm.item.IsThisUserFollowing() ? {\'color\': \'green\'} : \'\'\">\n <md-tooltip>{{vm.item.IsThisUserFollowing() ? \'Unfollow\' : \'Follow\'}}</md-tooltip>\n </md-icon>\n </md-button>\n <au-share-in-video-button item=\"vm.item\" ng-show=\"$root.getUiActiveVideoCall()\"></au-share-in-video-button>\n <au-from-template-button ng-if=\"vm.item.IsTemplate\" item=\"vm.item\"></au-from-template-button>\n <md-button class=\"md-icon-button open-single\" ng-click=\"vm.item.open(\'new\')\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n\n </div>\n </md-card-content>\n\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n <div layout=\"column\" layout-align=\"center none\">\n\n <!--Question Body-->\n <div layout=\"column\" flex class=\"padding-30\">\n <div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.showBody()\">\n <p id=\"StringQuestionBody\" dynamic=\"vm.item.QuestionBody\"></p>\n <au-help-icon key=\"Question.Body\"></au-help-icon>\n </div>\n <!--tags-->\n <div>\n <md-chips ng-model=\"vm.item.Tags\" readonly=\"true\" id=\"StringTags\">\n <md-chip-template class=\"padding-left-10\">{{$chip | questionTagFilter}}</md-chip-template>\n </md-chips>\n </div>\n </div>\n\n <!--attached files-->\n <au-document-section item=\"vm.item\" only-list=\"true\" ng-show=\"vm.item.Documents.length > 0\"></au-document-section>\n\n </div>\n </div>\n </md-card>\n\n <!--Answer Card-->\n <md-card ng-repeat=\"answer in vm.item.$Answers | orderBy: \'-VoteTotal\'\" class=\"answers\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\" ng-attr-id=\"BtnAnswerHeader{{$index}}\" class=\"padding-30\" layout-xs=\"column\" layout-align-xs=\"center center\">\n\n <!--votes-->\n <div layout=\"row\" layout-align=\"center center\" class=\"margin-right-20\">\n <div layout=\"column\" layout-align=\"center center\" ng-click=\"$event.stopPropagation()\">\n\n <md-fab-speed-dial md-direction=\"up\" class=\"md-scale angular-animate\" style=\"position:relative;\">\n <md-fab-trigger>\n <md-button aria-label=\"menu\" class=\"md-fab md-raised\" ng-attr-id=\"BtnOpenVote{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-unfold-more\"></md-icon><strong>{{answer.VoteTotal}} &nbsp;</strong>\n </md-button>\n </md-fab-trigger>\n\n <md-fab-actions style=\"position:absolute; top:-20px; left:8px;\">\n <md-button ng-click=\"vm.downvoteAnswer($event, answer)\" ng-disabled=\"answer.DidCurrentUserAlreadyVote()\" aria-label=\"vote down\" class=\"md-fab md-raised md-mini md-accent\" ng-attr-id=\"BtnVoteDown{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-chevron-down\" style=\"position:relative; right:2px;\"></md-icon>\n </md-button>\n <md-button ng-click=\"vm.upvoteAnswer($event, answer)\" ng-disabled=\"answer.DidCurrentUserAlreadyVote()\" aria-label=\"vote up\" class=\"md-fab md-raised md-mini md-accent\" ng-attr-id=\"BtnVoteUp{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-chevron-up\" style=\"position:relative; right:2px;\"></md-icon>\n </md-button>\n </md-fab-actions>\n </md-fab-speed-dial>\n\n </div>\n </div>\n <!--end votes-->\n\n <div layout=\"column\" layout-align=\"center start\" flex>\n <div class=\"md-subhead\"><strong>{{answer.AnswerTitle}}</strong></div>\n <div layout=\"row\" layout-align=\"start center\">\n <span class=\"md-caption margin-right-5\">{{answer.Creator | fullNameFilter}}</span>\n </div>\n <div class=\"md-caption\" ng-if=\"answer.ShouldUIShowAsFlagged()\" style=\"color:red;\">Flagged as inappropriate by {{answer.FlaggedBy.length}} {{answer.FlaggedBy.length == 1 ? \'user\' : \'users\'}}</div>\n <span class=\"timestamp\" am-time-ago=\"answer.DateCreated\"></span>\n </div>\n\n <!--answer action buttons-->\n <div layout=\"row\" layout-align=\"end center\" ng-click=\"$event.stopPropagation()\">\n <span layout=\"row\" layout-align=\"end center\" flex>\n <md-button ng-if=\"answer.CanCurrentUserEdit()\" ng-click=\"vm.deleteAnswer($event, answer, $index)\" aria-label=\"delete\" class=\"md-icon-button\" ng-attr-id=\"BtnDeleteAnswer{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\">\n <md-tooltip>Delete</md-tooltip>\n </md-icon>\n </md-button>\n <md-button ng-if=\"answer.CanCurrentUserEdit()\" ng-click=\"vm.openEditAnswerDialog($event, answer)\" aria-label=\"edit\" class=\"md-icon-button\" ng-attr-id=\"BtnEditAnswer{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\">\n <md-tooltip>Edit</md-tooltip>\n </md-icon>\n </md-button>\n <md-button ng-disabled=\"answer.DidCurrentUserFlag()\" ng-click=\"vm.flagAnswer($event, answer)\" aria-label=\"flag\" class=\"md-icon-button\" ng-attr-id=\"BtnFlagAnswer{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-flag\" ng-style=\"answer.DidCurrentUserFlag() ? {\'color\': \'crimson\'} : \'\'\" name=\"flag\">\n <md-tooltip>{{answer.DidCurrentUserFlag() ? \'You flagged this answer as inappropriate\' : \'Flag as inappropriate\'}}</md-tooltip>\n </md-icon>\n </md-button>\n\n <md-button ng-click=\"vm.acceptAnswer($event, answer._id)\" ng-if=\"vm.item.Creator == $root.user._id && !vm.item.AcceptedAnswer\" aria-label=\"accept\" class=\"md-icon-button\" ng-attr-id=\"BtnAcceptAnswer{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-check\"></md-icon>\n <md-tooltip>Mark as best answer</md-tooltip>\n </md-button>\n\n <md-button ng-show=\"answer._id == vm.item.AcceptedAnswer\" class=\"md-icon-button\">\n <md-icon md-font-icon=\"zmdi zmdi-check-circle\" style=\"color:#39B54A; font-size:2em;\" ng-attr-id=\"IconAcceptedAnswer{{$index}}\">\n <md-tooltip>Accepted answer</md-tooltip>\n </md-icon>\n </md-button>\n\n </span>\n </div>\n <!--end answer action buttons-->\n\n\n </div>\n </md-card-content>\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <div layout=\"column\" layout-align=\"center none\">\n <div layout=\"column\" flex ng-attr-id=\"StringAnswerBody{{$index}}\">\n <p class=\"md-body-1\" dynamic=\"answer.Content\"></p>\n </div>\n </div>\n </md-card-content>\n <au-document-section item=\"answer\" only-list=\"true\" ng-if=\"answer.Documents.length > 0\"></au-document-section>\n\n\n\n\n <!--Comment-->\n <div class=\"margin-bottom-40 margin-top-30\">\n <form layout=\"row\" class=\"ng-pristine ng-valid layout-row\" style=\"margin:0 30px\">\n <md-input-container class=\"margin-0 padding-bottom-10 md-input-has-placeholder flex\" md-no-float=\"\" flex=\"\">\n <input type=\"text\" placeholder=\"Comment\" class=\"ng-pristine ng-valid md-input ng-empty ng-touched\" aria-label=\"Comment\" ng-model=\"answer.$newComment\"\n ng-attr-id=\"TxtComment{{$index}}\">\n <div class=\"md-errors-spacer\"></div>\n </md-input-container>\n\n <button ng-click=\"vm.addCommentToAnswer($event, answer)\" class=\"margin-0 md-icon-button md-button md-ink-ripple md-accent\" type=\"submit\"\n aria-label=\"Send\" ng-attr-id=\"BtnSubmitComment{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"ng-scope md-font zmdi zmdi-mail-send material-icons\" aria-hidden=\"true\"></md-icon>\n </button>\n </form>\n\n <div style=\"margin:20px 30px;\">\n <div layout=\"row\" layout-align=\"space-between start\" class=\"social-avatar-comment\" ng-repeat=\"comment in answer.Comments\" ng-attr-id=\"StringComment{{$index}}\" style=\"margin:0px 0px 20px; padding:0px;\">\n <div layout=\"row\" layout-align=\"start start\" flex>\n <au-profile-image user=\"comment.Creator\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n\n <div layout=\"column\" layout-align=\"center start\" class=\"margin-left-10\">\n <span class=\"md-body-2\">{{comment.Creator | fullNameFilter}}</span>\n <span class=\"md-caption\">{{comment.Content}}</span>\n <span class=\"timestamp\" am-time-ago=\"comment.DateCreated\"></span>\n </div>\n </div>\n\n <div>\n <md-button ng-show=\"::answer.CanCurrentUserEdit() || comment.Creator == $root.user._id\" ng-click=\"answer.RemoveComment(comment._id)\" aria-label=\"delete-comment\" class=\"md-icon-button\" ng-attr-id=\"BtnDeleteComment{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\" style=\"color:gray\"></md-icon>\n </md-button>\n </div>\n </div>\n </div>\n </div>\n </div>\n </md-card>\n\n\n\n <!--Submit Answer Card-->\n <md-card class=\"answers margin-top-40\" style=\"border-radius: 0 0 50px 0;\">\n <md-card-content layout=\"column\" id=\"BtnSubmitAnswerHeader\">\n <div layout=\"row\" layout-align=\"start center\" class=\"padding-left-30 padding-right-30\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"zmdi-hc-fw auto-height font-size-4\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Your Answer</div>\n <div class=\"description\">Enter your answer to this question.</div>\n </div>\n </div>\n </md-card-content>\n\n\n <div class=\"hidden\" au-can-edit=\"!vm.page.$isPlaceholder\">\n <md-divider></md-divider>\n <md-card-content>\n <md-input-container class=\"md-icon-float md-block\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <label>Answer Title</label>\n <input type=\"text\" required ng-model=\"vm.newAnswer.AnswerTitle\" id=\"TxtAnswerTitle\"/>\n </md-input-container>\n\n <md-input-container class=\"md-icon-float md-block md-icon-left margin-top-20\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n <label>Answer Explanation</label>\n <textarea ng-model=\"vm.newAnswer.Content\" rows=\"5\" id=\"TxtAnswerBody\" md-no-autogrow/ style=\"white-space: pre-wrap;\"/>\n </md-input-container>\n </md-card-content>\n <div>\n <au-document-section item=\"vm.newAnswer\" prevent-new-documents=\"true\"></au-document-section>\n </div>\n <div layout=\"row\" layout-align=\"space-between center\" class=\"margin-top-20 margin-bottom-170\">\n <div flex></div>\n <div class=\"margin-right-20\">\n <span ng-if=\"vm.responseText\">{{vm.responseText}}</span>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.answerButtonClicked()\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" id=\"BtnSubmitAnswer\"></md-icon>\n <span hide-xs> {{vm.submitButtonText}} &nbsp;</span>\n </md-button>\n </div>\n </div>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/social/questions/questionanswer/questionanswer.tmpl.html","<ng-form name=\'editItem\' class=\"_template-item-detail\" auto-save-form=\"vm.save()\" cached-resource=\"vm.item\" ignore-fields=\"[\'Field\',\'NamesTo\',\'Ignore\']\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n <!-- auto expanded, first, card -->\n <md-card>\n <md-card-content>\n <p class=\"md-display-1\">\n <md-icon class=\"zmdi zmdi-accounts-list zmdi-hc-fw auto-height\"></md-icon>\n {{vm.item.Name}}\n </p>\n <p class=\"md-subhead description\">Please edit me below</p>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <md-input-container flex>\n <label><span>Name</span></label>\n <input type=\"text\" ng-model=\"vm.item.Name\" required maxlength=\"100\" />\n </md-input-container>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- another card (add as many as makes sense) -->\n <md-card>\n <md-card-content>\n <p class=\"md-title\">\n <md-icon class=\"zmdi zmdi-key zmdi-hc-fw\"></md-icon>\n <span>Another card</span>\n </p>\n <p class=\"md-subhead description\">It\'s easy to add additional cards to break up the UI</p>\n </md-card-content>\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <md-input-container flex>\n <label><span>Title</span></label>\n <input type=\"text\" ng-model=\"vm.item.Title\" required maxlength=\"100\" />\n </md-input-container>\n </md-card-content>\n </div>\n </md-card>\n </md-popout-card-list>\n\n <md-button class=\"md-primary md-raised margin-20\" ng-click=\"vm.saveAndClose()\" ng-if=\"!vm.isDialog\">\n <span>Save and Close</span>\n </md-button>\n\n </div>\n</ng-form>");
$templateCache.put("/app/social/questions/questiontag/questiontag.tmpl.html","<ng-form class=\"questiontag-item-detail\" name=\'editTagForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\"\n cached-resource=\"vm.item\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-label\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30\"></md-icon>\n <div layout=\"column\" flex id=\"BtnNameHeader\">\n <div class=\"md-display-1\">{{vm.item.TagText}}</div>\n <div class=\"description\">{{vm.item.Description}}</div>\n </div>\n <md-button class=\"md-icon-button big-icon-button open-single\" ng-click=\"vm.item.open(\'new\'); ItemDialogClose()\">\n <md-icon md-font-icon=\"zmdi zmdi-open-in-new\" class=\"md-primary\"></md-icon>\n <md-tooltip>Open In New Tab</md-tooltip>\n </md-button>\n </div>\n\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <h3>Details</h3>\n <md-input-container flex>\n <label><span>Name</span></label>\n <input type=\"text\" ng-model=\"vm.item.TagText\" required maxlength=\"15\" id=\"TxtTagName\" />\n </md-input-container>\n <md-input-container flex>\n <label><span>Description</span></label>\n <input type=\"text\" ng-model=\"vm.item.Description\" required maxlength=\"140\" id=\"TxtTagDescription\" />\n </md-input-container>\n <h3>Moderator</h3>\n <p>The moderator of this tag will be able to edit and delete questions with this tag. They will also be able to mark a\n question as FAQ and edit the answers and comments for questions with this tag.</p>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n <md-input-container class=\"margin-left-10\" flex>\n <md-autocomplete md-selected-item=\"vm.item.Moderator\" md-select-on-match=\"true\" md-search-text=\"vm.moderatorSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.moderatorSearchText, excludeContacts: true})\"\n md-item-text=\"user | fullNameFilter\" md-floating-label=\"Tag Moderator\" md-autofocus required id=\"TxtModerator\">\n <md-item-template>\n <span md-highlight-text=\"vm.moderatorSearchText\" md-highlight-flags=\"i\" id=\"AutoModerator{{$index}}\">{{user | fullNameFilter}}\n </span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n </div>\n </md-card-content>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/social/questions/search/questionsearch.tmpl.html","<div class=\"au-landing-page social questionsearch\" layout=\"column\" layout-fill>\n\n <!-- standard ui component -->\n <div class=\"one-search-toolbar-container\">\n <div class=\"one-search-toolbar\"></div>\n </div>\n\n <form class=\"search-form\" layout=\"column\" layout-align=\"center center\">\n <h1 class=\"search-header\">Search Q&A</h1>\n\n <div class=\"question-input-container md-whiteframe-1dp focused\" layout=\"row\" layout-align=\"center center\">\n <md-icon md-font-icon=\"zmdi zmdi-search\" class=\"question-search-icon\"></md-icon>\n <input class=\"question-input-font\" ng-model=\"vm.searchText\" md-no-float flex id=\"TxtSearch\" au-focus-on-load aria-label=\"Search Questions\"\n autocomplete=\"off\" />\n <input type=\"submit\" class=\"search-button md-raised md-primary md-button md-ink-ripple\" ng-click=\"vm.submitSearch()\" ng-disabled=\"!vm.searchText || vm.searching\"\n value=\"Search\" id=\"BtnSubmitSearch\" />\n\n\n </div>\n <md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.searching\"></md-progress-linear>\n\n\n </form>\n\n <div class=\"overflow-auto\">\n <!--search results-->\n <div class=\"question-search-results\" flex layout-fill>\n <div class=\"ask-question display-none\" md-whiteframe=\"1\" ng-show=\"$root.user.EffPerms.QnA.CanCreate\">\n <h2>Answer not below?</h2>\n\n Launch the\n <md-button class=\"md-primary\" style=\"margin-left: -5px; margin-right: -5px\" ng-click=\"vm.openAddQuestionDialog()\">\n <u>new question wizard</u>\n </md-button> to ask those who know.\n </div>\n <div class=\"search-result-container display-none\">\n <h2 class=\"margin-bottom-30\">{{vm.qasFound}} Q&As found for \"{{vm.searchText}}\"</h2>\n <div ng-repeat=\"question in vm.searchResults track by question._id\" layout=\"row\" layout-align=\"start start\" class=\"padding-bottom-20\">\n\n <div>\n <au-profile-image user=\"::question.Creator\" size=\"50\"></au-profile-image>\n <md-tooltip>\n {{question.Creator | fullNameFilter}}\n </md-tooltip>\n </div>\n\n <div layout=\"column\" layout-align=\"start start\" flex>\n <div class=\"title\" ng-attr-id=\"StringQuestionTitle{{$index}}\" ng-click=\"vm.goToQuestion(question)\">{{::question.QuestionTitle}}</div>\n <div class=\"tags\">\n <a ui-sref=\"shell.social.questions.by-tag.list({\'query\': \'{{tag._id || tag}}\'})\" ng-repeat=\"tag in ::question.$Tags\">{{tag | questionTagFilter}}\n </a>\n </div>\n <div class=\"timestamp\" am-time-ago=\"::question.DateCreated\"></div>\n <p class=\"search-result-desc\" dynamic=\"question.QuestionBody\"></p>\n </div>\n </div>\n </div>\n </div>\n\n\n\n <div class=\"footer\" layout=\"column\" layout-align=\"center center\">\n There are {{vm.questionCount}} Questions in the database. So, search first. Then, if you don\'t find an answer, you can submit your question\n to appropriate staff of {{$root.Organization.Name}}.\n </div>\n </md-content>\n </div>");
$templateCache.put("/app/social/questions/search/searchresults.tmpl.html","<div class=\"overflow-auto searchpage\">\n\n <div layout=\"column\" layout-align=\"space-between none\">\n\n <!--Search Results--->\n <div layout-fill layout-wrap layout=\"column\" layout-align=\"start start\" class=\"search-result\">\n \n <div>\n <div class=\"md-headline margin-bottom-20\">Results</div>\n </div>\n \n <!--Question List--> \n <div layout=\"row\" layout-align=\"start start\" class=\"search-result-container\" ng-repeat=\"question in vm.searchResults\" style=\"width:100%;\">\n <au-profile-image user=\"question.Creator\" size=\"40\">\n <hover>\n <au-user-hover></au-user-hover>\n </hover>\n </au-profile-image>\n \n <div layout=\"column\" layout-align=\"start start\" flex>\n <h1 class=\"md-body-2\" ng-attr-id=\"StringQuestionTitle{{$index}}\" ng-click=\"vm.goToQuestion(question)\">{{::question.QuestionTitle}}</h1>\n <div class=\"md-body-1 name\">{{question.Creator | fullNameFilter}}</div>\n <div class=\"timestamp\" am-time-ago=\"question.DateCreated\"></div>\n <p class=\"md-body-1 search-result-desc\">{{::question.QuestionBody}}</p>\n \n <div>\n <md-chips ng-model=\"question.Tags\" readonly=\"true\" ng-attr-id=\"StringQuestionTags{{$index}}\">\n <md-chip-template>\n <span>{{$chip | questionTagFilter}}</span>\n </md-chip-template>\n </md-chips>\n </div>\n </div>\n \n <!--arrow-->\n <!--<div layout=\"row\" layout-align=\"end start\">\n <md-button aria-label=\"go to question\" class=\"md-button\" ng-click=\"vm.goToQuestion(question)\" ng-attr-id=\"BtnGoToQuestion{{$index}}\">\n <md-icon md-font-icon=\"zmdi zmdi-long-arrow-right\"></md-icon>\n </md-button> \n </div>-->\n </div> \n\n <md-button class=\"md-raised margin-top-30 margin-left-0\" ng-click=\"vm.openAddQuestionDialog($event)\" id=\"BtnAskQuestion\">Didn\'t find an answer?</md-button> \n </div>\n\n <!--Search Tips--->\n <div layout-fill layout-wrap>\n <md-content layout-xs=\"column\" layout=\"row\">\n <div layout=\"column\">\n <md-card>\n <md-card-title>\n <md-card-title-text>\n <div layout=\"row\" layout-align=\"space-between center\" style=\"border-bottom: solid 1px rgba(250,250,250,.2);\">\n <h1 class=\"md-display-1 margin-bottom-30\" flex>Search Tips</h1>\n </div>\n \n <div layout=\"row\" layout-align=\"center start\" layout-xs=\"column\" class=\"margin-top-30\">\n <div class=\"margin-right-40\" flex>\n <span class=\"md-title\" id=\"StringFindAnswers\">\n <md-icon md-font-icon=\"zmdi zmdi-info\" class=\"social-event-icons-white\">\n </md-icon>\n The Key to Finding Answers\n </span>\n \n <p class=\"md-caption\">The search text you entered is used to search the database of questions that users in your organization have asked. Questions\' titles are searched first, then the questions\' explanation. So if a question\'s title contains one or more of the words you searched for, that question will be at the top of the search results. The search text you enter is searched individually rather than as a phrase. For example, if you search \"request days off\" the search engine will look for the words individually. The words \"request\", \"days\", and \"off\" will be searched. When using this search engine, keep it simple. Less words will give you more results!</p>\n </div>\n \n <div flex>\n <span class=\"md-title\">\n <md-icon md-font-icon=\"zmdi zmdi-info\" class=\"social-event-icons-white\" id=\"StringUseTags\"></md-icon>\n How to Choose Effective Tags\n </span>\n \n <p class=\"md-caption margin-bottom-60\">When tagging a question use the most general terms as possible for tags. Use keywords that can apply to similar questions in the same category. Stay away from phrases, tags work best when they are just one word. Sometimes there are multiple words that all mean the same thing. Use all those words to tag your question. The more tags your question has, the easier it will be to find.</p>\n\n </div> \n </div>\n </md-card-title-text>\n </md-card-title>\n </md-card>\n </div>\n </md-content>\n </div> \n </div>\n</div>");
$templateCache.put("/app/structure/organization-settings/department/tmpl.html","<ng-form name=\'editForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding department-item-detail\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Name\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Department Info Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" id=\"BtnDepartmentInfoHeader\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Contact Information</div>\n <div class=\"description\">Edit the department address and phone.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <div layout=\"column\" flex>\n <md-input-container>\n <label>Address</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input name=\"Address1\" ng-model=\"vm.item.Address.Address1\" id=\"TxtAddress1\" />\n </md-input-container>\n <div style=\"margin-left: 32px\">\n <md-input-container flex>\n <label>Apt/Ste/Unit</label>\n <input name=\"Address2\" ng-model=\"vm.item.Address.Address2\" id=\"TxtAddress2\" />\n </md-input-container>\n <div layout=\"row\" flex>\n <md-input-container flex>\n <label>City</label>\n <input name=\"City\" ng-model=\"vm.item.Address.City\" id=\"TxtCity\" />\n </md-input-container>\n <md-input-container>\n <label>State</label>\n <md-select name=\"StateProv\" ng-model=\"vm.item.Address.StateProv\" id=\"DrpState\">\n <md-option ng-repeat=\"state in vm.states\" ng-attr-id=\"DrpStateOption{{$index}}\">{{state}}</md-option>\n </md-select>\n </md-input-container>\n </div>\n <md-input-container flex>\n <label>Zip Code</label>\n <input name=\"ZipPostalCode\" type=\"tel\" ng-model=\"vm.item.Address.ZipPostalCode\" id=\"TxtZipCode\" />\n </md-input-container>\n </div>\n <md-input-container flex>\n <label>Phone Number</label>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <input name=\"Phone\" type=\"tel\" ng-model=\"vm.item.Phone\" id=\"TxtPhoneNumber\" />\n </md-input-container>\n\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Members -->\n <md-card>\n <md-card-content layout=\"column\">\n <div layout=\"row\" id=\"BtnTeamMembersHeader\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Department Members</div>\n <div class=\"description\" layout=\"row\">\n <div flex>View the department org-chart.</div>\n </div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" on-visible=\"vm.centerContentTrigger = vm.centerContentTrigger + 1\">\n <md-divider></md-divider>\n\n <div style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%\" layout=\"row\" layout-align=\"start center\"\n au-can-edit=\"$root.user.IsUserAdmin\">\n <md-button class=\"md-primary md-main-theme\" ng-click=\"vm.addUser($event)\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Add User</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Remove Member\" class=\"md-primary md-main-theme\" ng-click=\"vm.removeMember($event)\" ng-disabled=\"!vm.oneUserSelected()\"\n id=\"BtnRemoveTeamMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Remove User</span>\n </div>\n </md-button>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon class=\"md-primary\" style=\"font-size: 14px;\" md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n <span class=\"md-body-2 font-color-500\">HEAD:</span>\n <md-tooltip>Assign a head to allow the user to edit the department details.</md-tooltip>\n </div>\n\n <md-autocomplete class=\"md-input\" md-selected-item=\"vm.item.Head\" md-autoselect=\"true\" md-require-match=\"true\" md-select-on-match=\"true\"\n md-items=\"user in $root.auUtility.searchUsers({query:vm.headSearchText, excludeContacts: true, showAdd: true})\" md-search-text=\"vm.headSearchText\"\n placeholder=\"Not Assigned\" md-selected-item-change=\"vm.selectedHeadChanged(user)\" md-item-text=\"user | fullNameFilter\"\n flex>\n <md-item-template>\n <span md-highlight-text=\"vm.headSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLocationHead{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n\n <div angular-org-chart flex=\"grow\" style=\"background-color: white;\" ng-style=\"{\'height\':viewportHeight - 50 + \'px\'}\" nodes=\"vm.item.$Members\"\n node-width=\"240\" node-height=\"290\" parent-id-property=\"ReportsTo\" id-property=\"_id\" enable-selection=\"true\" node-expression=\"\'<au-item-card item=\\\'node\\\' class=\\\'item-card-no-margin\\\'></au-item-card>\'\"\n enable-parent-update=\"$root.user.IsUserAdmin\" zoom-to-fit-trigger=\"vm.centerContentTrigger\" on-parent-update=\"node.$updateItem()\"></div>\n </div>\n </md-card>\n\n <!-- Social Page -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Social Page</div>\n <div class=\"description\">View the Organization\'s page on the social intranet.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" style=\'max-height: 3000px; overflow: hidden\'>\n <md-divider></md-divider>\n <div ng-include=\"\'/app/social/page/tmpl.html\'\" ng-controller=\"PageItemController as vm\" ng-inject=\"{itemSettings: {item: vm.item.getPage()} }\"></div>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings by this team.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n <!-- Documents Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- audit trail card -->\n <md-card ng-if=\"::$root.user.EffPerms.SysAdmin\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAuditTrail\">\n <div class=\"md-title\">Audit Trail</div>\n <div class=\"description\">See a history of modifications to this {{vm.item.$key}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <div class=\"padding-40 md-caption\" style=\"line-height:30px\">\n <au-audit-trail item=\"vm.item\"></au-audit-trail>\n </div>\n </div>\n </md-card>\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/structure/organization-settings/dialogs/add-user-license-dialog.tmpl.html","<md-dialog au-wizard dialog-title=\"Add User Licenses\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" class=\"au-dialog add-user-license-dialog\" aria-label=\"Add User Licenses\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 500px\" id=\"StringAddLicensesHeader\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/user.png\">\n <h3>Need more user licenses?</h3>\n <p>All Align Us organizations get 10 user licenses free of charge. A user license is required for each active user account.</p>\n <p>After the beta period, your organization will be charged $1 per user license purchased per month. Again, the first 10 are included free of charge.</p>\n <h3>Current Plan</h3>\n <table class=\"table table-bordered table-hover\" style=\'width:50%\'>\n <tr>\n <td>User Licenses:</td>\n <td style=\"text-align: right\">{{$root.Organization.OrgSettings.Subscription.UserLicenses}}</td>\n </tr>\n <tr>\n <td>Current Monthly Bill:</td>\n <td style=\"text-align: right\">${{$root.Organization.OrgSettings.Subscription.UserLicenses - 10}}.00</td>\n </tr>\n </table>\n </au-wizard-step>\n <au-wizard-step step-name=\"selectLicenseCount\" step-bg=\"/assets/images/dialogs/licenses.png\" on-next-step=\"vm.validateSelectLicenseStep()\">\n <h3>How many licenses do you need?</h3>\n <p>Enter the number of user licenses you want to add below. Prices reflect a monthly rate.</p>\n <table class=\"table table-bordered table-hover\" style=\'width:50%\'>\n <tr>\n <td>Current Licenses:</td>\n <td style=\"text-align: right\">{{$root.Organization.OrgSettings.Subscription.UserLicenses}}</td>\n <td style=\"text-align: right\">${{vm.parseInt($root.Organization.OrgSettings.Subscription.UserLicenses) - 10}}.00</td>\n </tr>\n <tr>\n <td colspan=\"2\">\n <md-input-container>\n <label>Please select a number</label>\n <md-select ng-model=\"vm.addLicenses\" id=\"DrpAddLicenses\" ng-init=\"vm.addLicenses = 0\">\n <md-option ng-repeat=\"i in [1,2,3,4,5,6,7,8,9,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,100]\" ng-attr-id=\"Option{{$index}}\">{{i}}</md-option>\n <md-option ng-disabled=\"true\">Please contact sales for more.</md-option>\n </md-select>\n </md-input-container>\n </td>\n <td style=\"vertical-align:middle; text-align: right\">\n ${{vm.addLicenses}}.00\n </td>\n\n </tr>\n <tr>\n <td>Total Licenses:</td>\n <td style=\"text-align: right\">{{vm.parseInt($root.Organization.OrgSettings.Subscription.UserLicenses) + vm.parseInt(vm.addLicenses)}}</td>\n <td style=\"text-align: right\">${{vm.parseInt($root.Organization.OrgSettings.Subscription.UserLicenses) - 10 + vm.parseInt(vm.addLicenses)}}.00</td>\n </tr>\n </table>\n\n <md-checkbox id=\"CbxReadToS\" ng-model=\"vm.agreedToTerms\" required>\n <span>I have read and agree to the terms of service.</span>\n </md-checkbox>\n </au-wizard-step>\n <au-wizard-step step-name=\"billingInfo\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <h3>Until the official launch, all licenses are free! The form below is just for testing.</h3>\n\n <form name=\"step2form \" tri-wizard-form layout=\"column \" novalidate>\n <div layout=\"column \" flex=\"60 \">\n <!-- put form things here -->\n <md-input-container class=\"md-icon-float \" flex>\n <label>Credit Card Number</label>\n <md-icon md-font-icon=\"zmdi zmdi-card \"></md-icon>\n <input name=\"creditCard \" ng-model=\"vm.data.creditCard \" required pattern=\"\\d{16} \" id=\"TxtCreditCard\">\n <div ng-messages=\"step2form.creditCard.$error \" ng-if=\"step2form.creditCard.$touched && (step2form.creditCard.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n <div ng-message when=\"pattern \">\n <span>Invalid format</span>\n </div>\n </div>\n </md-input-container>\n <div layout=\"row \">\n <md-input-container class=\"md-icon-float \" flex>\n <label>Expiration Date</label>\n <md-icon md-font-icon=\"zmdi zmdi-calendar \"></md-icon>\n <input name=\"expirationDate \" ng-model=\"vm.data.expirationDate \" required pattern=\"\\d{1,2}/\\d{4} \" id=\"TxtExpirationDate\">\n <div ng-messages=\"step2form.expirationDate.$error \" ng-if=\"step2form.expirationDate.$touched && (step2form.expirationDate.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n <div ng-message when=\"pattern \">\n <span>Invalid format</span>\n </div>\n </div>\n </md-input-container>\n <div layout=\"row \">\n <md-input-container class=\"md-icon-float \" flex>\n <label>CCV</label>\n <md-icon md-font-icon=\"zmdi zmdi-shield-check \"></md-icon>\n <input name=\"CCV \" ng-model=\"vm.data.CCV \" required pattern=\"\\d{3,4} \" id=\"TxtCCV\">\n <div ng-messages=\"step2form.CCV.$error \" ng-if=\"step2form.CCV.$touched && (step2form.CCV.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n <div ng-message when=\"pattern \">\n <span>Invalid format</span>\n </div>\n </div>\n </md-input-container>\n <au-help-icon class=\"md-accent \" key=\"OrgSettings.AddLicenses.CCV \"></au-help-icon>\n </div>\n </div>\n <md-input-container class=\"md-icon-float \" flex>\n <label>First and Last Name</label>\n <md-icon md-font-icon=\"zmdi zmdi-account \"></md-icon>\n <input name=\"cardName \" ng-model=\"vm.data.cardName \" required id=\"TxtNameOnCard\">\n <div ng-messages=\"step2form.cardName.$error \" ng-if=\"step2form.cardName.$touched && (step2form.cardName.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n </div>\n </md-input-container>\n <md-input-container class=\"md-icon-float \" flex>\n <label>Street Address</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input name=\"billingAddress \" ng-model=\"vm.data.billingAddress \" required id=\"TxtAddress\">\n <div ng-messages=\"step2form.billingAddress.$error \" ng-if=\"step2form.billingAddress.$touched && (step2form.billingAddress.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n </div>\n </md-input-container>\n\n <div layout=\"row \">\n <md-input-container flex=\"70 \">\n <label>City </label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input name=\"city \" ng-model=\"vm.data.city \" required id=\"TxtCity\">\n <div ng-messages=\"step2form.city.$error \" ng-if=\"step2form.city.$touched && (step2form.city.$invalid) \">\n <div ng-message when=\"required \">\n <span Required</span>\n </div>\n </div>\n </md-input-container>\n <md-input-container flex=\"30 \">\n <label>State</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <md-select name=\"state \" ng-model=\"vm.data.state \" required id=\"DrpState\">\n <md-option ng-repeat=\"state in vm.states \" value=\"{{state}} \" ng-attr-id=\"DrpStateOption{{$index}}\">\n {{state}}\n </md-option>\n </md-select>\n <div ng-messages=\"step2form.state.$error \" ng-if=\"step2form.state.$touched && (step2form.state.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n </div>\n </md-input-container>\n </div>\n <div layout=\"row \">\n <md-input-container flex>\n <label>Zip/Postal Code</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input name=\"zip \" ng-model=\"vm.data.zip \" required pattern=\"\\d{5} \" id=\"TxtZipCode\">\n <div ng-messages=\"step2form.zip.$error \" ng-if=\"step2form.zip.$touched && (step2form.zip.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n <div ng-message when=\"pattern \">\n <span>Invalid format</span>\n </div>\n </div>\n </md-input-container>\n <md-input-container flex>\n <label>Phone Number</label>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <input name=\"phone \" ng-model=\"vm.data.phone \" required pattern=\".*\\d{3}.*\\d{3}.*\\d{4}.* \" id=\"TxtPhoneNumber\">\n <div ng-messages=\"step2form.phone.$error \" ng-if=\"step2form.phone.$touched && (step2form.phone.$invalid) \">\n <div ng-message when=\"required \">\n <span>Required</span>\n </div>\n <div ng-message when=\"pattern \">\n <span>Invalid format</span>\n </div>\n </div>\n </md-input-container>\n </div>\n\n\n </div>\n </form>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/structure/organization-settings/dialogs/batch-add-to-team.tmpl.html","<md-dialog flex=\"50\" flex-sm=\"100\" flex-md=\"60\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Add or Remove Users from a Team</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"$root.$mdDialog.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content>\n <div class=\"margin-20\">\n\n <div class=\'md-title\'>Add to Team / Group</div>\n <md-autocomplete md-selected-item=\"vm.addToTeam\" md-item-text=\"team | auItemFilter: \'Team\'\" md-search-text=\"vm.addToTeamSearchText\"\n md-items=\"team in $root.auUtility.searchTeams(vm.addToTeamSearchText)\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-floating-label=\"Add to Team\">\n <md-item-template>\n <span md-highlight-text=\"vm.addToTeamSearchText\" md-highlight-flags=\"i\">\n {{ team | auItemFilter: \'Team\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n\n <div class=\'md-title margin-top-20\'>Remove from Team / Group</div>\n <md-autocomplete md-selected-item=\"vm.removeFromTeam\" md-item-text=\"team | auItemFilter: \'Team\'\" md-search-text=\"vm.removeFromTeamSearchText\"\n md-items=\"team in $root.auUtility.searchTeams(vm.removeFromTeamSearchText)\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-floating-label=\"Add to Team\">\n <md-item-template>\n <span md-highlight-text=\"vm.removeFromTeamSearchText\" md-highlight-flags=\"i\">\n {{ team | auItemFilter: \'Team\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" class=\"margin-15\">\n <md-button class=\"md-raised margin-right-10\" ng-click=\"$root.$mdDialog.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" ng-disabled=\"vm.finishing\">\n Make Change\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/structure/organization-settings/dialogs/batch-change-department-location.tmpl.html","<md-dialog flex=\"50\" flex-sm=\"100\" flex-md=\"60\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Change User Department / Location</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"$root.$mdDialog.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content>\n <div class=\"margin-20\">\n\n <div class=\'md-title\'>Assign user(s) to Department</div>\n <md-autocomplete md-selected-item=\"vm.department\" md-item-text=\"department | auItemFilter: \'Department\'\" md-search-text=\"vm.departmentSearchText\"\n md-items=\"department in $root.auUtility.searchDepartments(vm.departmentSearchText)\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-floating-label=\"Department\" id=\"TxtDepartment\">\n <md-item-template>\n <span md-highlight-text=\"vm.departmentSearchText\" md-highlight-flags=\"i\">\n {{ department | auItemFilter: \'Department\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n\n <div class=\'md-title margin-top-20\'>Assign user(s) to Location</div>\n <md-autocomplete md-selected-item=\"vm.location\" md-item-text=\"location | auItemFilter: \'Location\'\" md-search-text=\"vm.locationSearchText\"\n md-items=\"location in $root.auUtility.searchLocations(vm.locationSearchText)\" md-autoselect=\"true\" md-select-on-match=\"true\"\n md-floating-label=\"Location\" id=\"TxtLocation\">\n <md-item-template>\n <span md-highlight-text=\"vm.locationSearchText\" md-highlight-flags=\"i\" >\n {{ location | auItemFilter: \'Location\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </div>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" class=\"margin-15\">\n <md-button class=\"md-raised margin-right-10\" ng-click=\"$root.$mdDialog.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" ng-disabled=\"vm.finishing\">\n Make Change\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/structure/organization-settings/location/tmpl.html","<ng-form name=\'editForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding location-item-detail\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n\n <!-- Quickview -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Name\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!--Location Info-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" id=\"BtnLocationInfoHeader\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Contact Information</div>\n <div class=\"description\">Edit the location address and phone.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <div layout=\"column\" flex>\n <md-input-container>\n <label>Address</label>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <input name=\"Address1\" ng-model=\"vm.item.Address.Address1\" id=\"TxtAddress1\" />\n </md-input-container>\n <div style=\"margin-left: 32px\">\n <md-input-container flex>\n <label>Apt/Ste/Unit</label>\n <input name=\"Address2\" ng-model=\"vm.item.Address.Address2\" id=\"TxtAddress2\" />\n </md-input-container>\n <div layout=\"row\" flex>\n <md-input-container flex>\n <label>City</label>\n <input name=\"City\" ng-model=\"vm.item.Address.City\" id=\"TxtCity\" />\n </md-input-container>\n <md-input-container>\n <label>State</label>\n <md-select name=\"StateProv\" ng-model=\"vm.item.Address.StateProv\" id=\"DrpState\">\n <md-option ng-repeat=\"state in vm.states\" ng-attr-id=\"DrpStateOption{{$index}}\">{{state}}</md-option>\n </md-select>\n </md-input-container>\n </div>\n <md-input-container flex>\n <label>Zip Code</label>\n <input type=\"tel\" name=\"ZipPostalCode\" ng-model=\"vm.item.Address.ZipPostalCode\" id=\"TxtZipCode\" />\n </md-input-container>\n </div>\n <md-input-container flex>\n <label>Phone Number</label>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <input name=\"Phone\" type=\"tel\" ng-model=\"vm.item.Phone\" id=\"TxtPhoneNumber\" />\n </md-input-container>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Members -->\n <md-card>\n <md-card-content layout=\"column\">\n <div layout=\"row\" id=\"BtnTeamMembersHeader\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Location Members</div>\n <div class=\"description\" layout=\"row\">\n <div flex>View the department org-chart.</div>\n </div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" on-visible=\"vm.centerContentTrigger = vm.centerContentTrigger + 1\">\n <md-divider></md-divider>\n\n <div style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%\" layout=\"row\" layout-align=\"start center\"\n au-can-edit=\"$root.user.IsUserAdmin\">\n <md-button class=\"md-primary md-main-theme\" ng-click=\"vm.addUser($event)\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Add User</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Remove Member\" class=\"md-primary md-main-theme\" ng-click=\"vm.removeMember($event)\" ng-disabled=\"!vm.oneUserSelected()\"\n id=\"BtnRemoveTeamMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Remove User</span>\n </div>\n </md-button>\n\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon class=\"md-primary\" style=\"font-size: 14px;\" md-font-icon=\"zmdi zmdi-account-circle\"></md-icon>\n <span class=\"md-body-2 font-color-500\">HEAD:</span>\n <md-tooltip>Assign a head to allow the user to edit the location details.</md-tooltip>\n </div>\n\n <md-autocomplete class=\"md-input\" md-selected-item=\"vm.item.Head\" md-autoselect=\"true\" md-require-match=\"true\" md-select-on-match=\"true\"\n md-items=\"user in $root.auUtility.searchUsers({query:vm.headSearchText, excludeContacts: true, showAdd: true})\" md-search-text=\"vm.headSearchText\"\n placeholder=\"Not Assigned\" md-selected-item-change=\"vm.selectedHeadChanged(user)\" md-item-text=\"user | fullNameFilter\"\n flex>\n <md-item-template>\n <span md-highlight-text=\"vm.headSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoLocationHead{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n\n <div angular-org-chart flex=\"grow\" style=\"background-color: white;\" ng-style=\"{\'height\':viewportHeight - 50 + \'px\'}\" nodes=\"vm.item.$Members\"\n node-width=\"240\" node-height=\"290\" parent-id-property=\"ReportsTo\" id-property=\"_id\" enable-selection=\"true\" node-expression=\"\'<au-item-card item=\\\'node\\\' class=\\\'item-card-no-margin\\\'></au-item-card>\'\"\n enable-parent-update=\"$root.user.IsUserAdmin\" zoom-to-fit-trigger=\"vm.centerContentTrigger\" on-parent-update=\"node.$updateItem()\"></div>\n </div>\n </md-card>\n\n <!-- Social Page -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Social Page</div>\n <div class=\"description\">View the Organization\'s page on the social intranet.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" style=\'max-height: 3000px; overflow: hidden\'>\n <md-divider></md-divider>\n <div ng-include=\"\'/app/social/page/tmpl.html\'\" ng-controller=\"PageItemController as vm\" ng-inject=\"{itemSettings: {item: vm.item.getPage()} }\"></div>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings by this team.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n <!-- Documents Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\"\'U\'\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- audit trail card -->\n <md-card ng-if=\"::$root.user.EffPerms.SysAdmin\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAuditTrail\">\n <div class=\"md-title\">Audit Trail</div>\n <div class=\"description\">See a history of modifications to this {{vm.item.$key}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <div class=\"padding-40 md-caption\" style=\"line-height:30px\">\n <au-audit-trail item=\"vm.item\"></au-audit-trail>\n </div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/structure/organization-settings/organization/tmpl.html","<ng-form name=\'editUserForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\" ignore-fields=\"[\'Settings\', \'OrgSettings\']\">\n <div class=\"user-detail md-padding\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\">\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Name\"></au-item-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Group Information Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnOrgInfoHeader\">\n <div class=\"md-title\">Contact Information</div>\n <div class=\"description\">Edit your organization\'s info such as its address and main phone number.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\'U\'>\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <label>\n <span>Address</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Address\" maxlength=\"100\" id=\"TxtOrgAddress1\" />\n </md-input-container>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi\"></md-icon>\n <label>\n <span>Apt/Ste/Unit</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Address2\" maxlength=\"100\" id=\"TxtOrgAddress2\" />\n </md-input-container>\n\n <div layout=\"row\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-city\"></md-icon>\n <label>\n <span>City</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.City\" maxlength=\"100\" id=\"TxtOrgCity\" />\n </md-input-container>\n <md-input-container>\n <md-select ng-model=\"vm.item.StateProv\" placeholder=\"State\" id=\"DrpState\">\n <md-option ng-repeat=\"state in vm.states\" ng-attr-id=\"DrpStateOption{{$index}}\">{{state}}</md-option>\n </md-select>\n </md-input-container>\n <md-input-container>\n <label>\n <span>Zip Code</span>\n </label>\n <input type=\"tel\" ng-model=\"vm.item.PostalCode\" maxlength=\"100\" id=\"TxtOrgZipCode\" />\n </md-input-container>\n </div>\n\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-globe\"></md-icon>\n <label>\n <span>Country</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Country\" maxlength=\"100\" id=\"TxtOrgCountry\" />\n </md-input-container>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <label>\n <span>Phone Number</span>\n </label>\n <input type=\"tel\" ng-model=\"vm.item.Phone\" maxlength=\"100\" id=\"TxtOrgPhoneNumber\" />\n </md-input-container>\n <div layout=\"row\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi\"></md-icon>\n <md-select ng-model=\"vm.item.Industry\" placeholder=\"Industry\" id=\"DrpOrgIndustry\">\n <md-option ng-repeat=\"industry in vm.industries\" ng-attr-id=\"DrpOrgIndustryOption{{$index}}\">{{industry}}</md-option>\n </md-select>\n </md-input-container>\n <au-help-icon class=\"md-accent\" key=\"OrgSettings.Industry\"></au-help-icon>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Personalization -->\n <md-card ng-if=\"vm.item.userHasPermission(\'U\')\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-palette\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPersonalizationHeader\">\n <div class=\"md-title\">Personalization</div>\n <div class=\"description\">Edit your organization\'s personalization settings such as the color scheme and timezone.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-palette\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\" layout-align=\"start start\">\n\n <div class=\"margin-bottom-20\">\n <div class=\"md-heading\">Personalize the color theme for your members.</div>\n <div class=\'md-caption\'>(They can override their color but you set the default.)</div>\n </div>\n\n <!-- Color picker -->\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-format-color-fill\"></md-icon>\n <label>Toolbar Color</label>\n <md-select ng-model=\"vm.toolbarColor\" ng-change=\"vm.setToolbarColor(vm.toolbarColor.color)\" ng-model-options=\"{trackBy: \'$value.color\'}\"\n md-container-class=\"color-select-container\" id=\"SettingsDrpSettingsToolbarColor\">\n <div class=\"color-select-wrapper\">\n <md-option class=\"color-select\" ng-repeat=\"color in ::vm.colors track by color.color\" ng-value=\"color\" ng-attr-id=\"SettingsDrpSettingsToolbarColorOption{{::$index}}\">\n <div class=\"color-pill-inner-wrapper\">\n <div class=\"color-pill\" ng-class=\"::{light: color.lightHighlight}\" ng-style=\"::{\'background-color\': color.color}\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" class=\"checked font-size-4\" ng-if=\"vm.item.Settings.TitlebarColor == color.color\"></md-icon>\n </div>\n <div class=\"color-pill-accent\" ng-style=\"::{\'background-color\': color.accent}\">\n </div>\n </div>\n </md-option>\n </div>\n </md-select>\n </md-input-container>\n <au-help-icon class=\"md-accent\" key=\"OrgSettings.Color\"></au-help-icon>\n </div>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <label>Hex Color</label>\n <input ng-model=\"vm.toolbarColor.color\" validate-color ng-blur=\"vm.setToolbarColor(vm.toolbarColor.color)\" id=\"TxtHexColor\"\n flex/>\n </md-input-container>\n </div>\n </div>\n <md-divider></md-divider>\n\n <div class=\"margin-bottom-20\">\n <div class=\"md-heading\">Select what time daily summaries are sent to your members.</div>\n <div class=\'md-caption\'>(They can set their own email preferences but you set the default.)</div>\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm class=\"margin-right-10\"></md-icon>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" required ng-model=\"vm.item.Settings.SendMorningEmail\"\n mdp-placeholder=\"Send Morning Email Summary at...\" class=\"md-icon-float md-block\" flex>\n </mdp-time-picker>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <md-icon md-font-icon=\"zmdi zmdi-time\" hide show-gt-sm class=\"margin-right-10\"></md-icon>\n <mdp-time-picker mdp-open-on-click mdp-auto-switch=\"true\" name=\"time\" required ng-model=\"vm.item.Settings.SendNightlyEmail\"\n mdp-placeholder=\"Send Nightly Email Summary at...\" class=\"md-icon-float md-block\" flex>\n </mdp-time-picker>\n </div>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <md-input-container>\n <label>Timezone</label>\n <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n <md-select ng-model=\"vm.item.Settings.Timezone\" placeholder=\"Timezone\" id=\"DrpTimezone\" flex>\n <md-option ng-repeat=\"timezone in vm.timezones track by $index\" ng-attr-id=\"DrpTimezoneOption{{$index}}\">{{timezone}}</md-option>\n </md-select>\n </md-input-container>\n <au-help-icon class=\"md-accent\" key=\"Settings.Timezone\"></au-help-icon>\n </div>\n\n <md-divider></md-divider>\n\n <div class=\"margin-bottom-20\">\n <div class=\"md-heading\">Select additional options below.</div>\n <div class=\'md-caption\'>(Turns on/off features organization-wide.)</div>\n </div>\n\n <md-checkbox ng-checked=\"vm.item.Settings.Fundraising.Enabled\" ng-click=\"vm.item.setSetting({Fundraising: {Enabled: !vm.item.Settings.Fundraising.Enabled}})\">\n Enable Fundraising functionality for your small group. (beta)\n </md-checkbox>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Members -->\n <md-card>\n <md-card-content layout=\"column\">\n <div layout=\"row\" id=\"BtnTeamMembersHeader\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Organization Members</div>\n <div class=\"description\" layout=\"row\">\n <div flex>View the organization org-chart.</div>\n </div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" on-visible=\"vm.centerContentTrigger = vm.centerContentTrigger + 1\">\n <md-divider></md-divider>\n\n <div style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%\" ng-if=\"$root.user.IsUserAdmin\">\n <md-button class=\"md-primary md-main-theme\" ng-click=\"$root.auUtility.addNewItem(\'User\')\" id=\"BtnAddTeamMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Add User</span>\n </div>\n </md-button>\n </div>\n\n <div angular-org-chart flex=\"grow\" style=\"background-color: white;\" ng-style=\"{\'height\':viewportHeight - 50 + \'px\'}\" nodes=\"vm.Members\"\n node-width=\"240\" node-height=\"290\" parent-id-property=\"ReportsTo\" id-property=\"_id\" enable-selection=\"true\" node-expression=\"\'<au-item-card item=\\\'node\\\' class=\\\'item-card-no-margin\\\'></au-item-card>\'\"\n enable-parent-update=\"$root.user.IsUserAdmin\" zoom-to-fit-trigger=\"vm.centerContentTrigger\" on-parent-update=\"vm.onParentUpdate(node, oldParent)\"></div>\n </div>\n </md-card>\n\n <!-- Documents Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"vm.item\" acl=\'U\'>\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- Social Page -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Social Page</div>\n <div class=\"description\">View the Organization\'s page on the social intranet.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" style=\'max-height: 3000px; overflow: hidden\'>\n <md-divider></md-divider>\n <div ng-include=\"\'/app/social/page/tmpl.html\'\" ng-controller=\"PageItemController as vm\" ng-inject=\"{itemSettings: {item: vm.item.getPage()} }\"></div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/structure/permission-presets/detail/detail.tmpl.html","<ng-form name=\'editUserForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.detail\"\n ignore-fields=\"[\'Permissions\']\">\n <div class=\"md-padding\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n <!-- Permission Preset Information Card -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.detail\" title-field=\"Name\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- permissions card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-key\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPermissionsHeader\">\n <div class=\"md-title\">Permissions</div>\n <div class=\"description\">Change the permissions users with this Permission Preset should have.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-key\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <div class=\"md-title\">System Admin</div>\n <users-permissions-tree detail=\"vm.detail\"></users-permissions-tree>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- members card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMembersHeader\">\n <div class=\"md-title\">Members</div>\n <div class=\"description\">Manage who uses this Permission Preset.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <span class=\"md-title\">Users With This Permission Preset\n <au-help-icon class=\"md-accent\" key=\"Permissions.Members\"></au-help-icon>\n </span>\n\n <md-chips ng-model=\"vm.members\" md-require-match=\"true\" md-on-add=\"vm.addUser($chip)\" md-on-remove=\"vm.removeUser($chip)\"\n md-transform-chip=\"vm.transformChip($chip)\">\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.membersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.membersSearchText, excludeContacts: true})\"\n placeholder=\"Add User\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtMember\">\n <span md-highlight-text=\"vm.membersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoMember{{$index}}\">{{user | fullNameFilter}}</span>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\" ng-attr-id=\"ChipMember{{$index}}\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- audit trail card -->\n <md-card ng-if=\"::$root.user.EffPerms.SysAdmin\">\n <md-card-content>\n <div layout=\"row\">\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAuditTrail\">\n <div class=\"md-title\">Audit Trail</div>\n <div class=\"description\">See a history of modifications to this {{vm.detail.$key}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <div class=\"padding-30 md-caption\" style=\"line-height:30px\">\n <au-audit-trail item=\"vm.detail\"></au-audit-trail>\n </div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/structure/users-and-teams/dialogs/add-contact.tmpl.html","<md-dialog au-wizard dialog-title=\"Add Contact\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" on-step-change=\"vm.stepChanged(currentStep, fromStep)\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\" class=\"au-dialog addContactDialog\" aria-label=\"Wizard Dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddContactDialog\">\n\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/addbg.png\">\n <h3>Add A Contact</h3>\n <div>Create a contact to track anyone important to {{$root.Organization.Name}}. Optionally, if you share items (meetings, tasks, etc) with a contact, the system will automatically email them a secure link. Contacts do not have access to the full Align Us system. Contacts do not count against your user licenses, so you can add as many as you want!</div>\n \n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/contact-add-unlimited-contacts.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/contact-share-items.png\"></div>\n <div flex=\"33\" class=\"grow\"><img src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/contact-search-accessibility.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Create unlimited, org-wide, contacts.</div>\n <div class=\"padding-20\" flex=\"33\">Share items and invite contacts to meetings.</div>\n <div class=\"padding-20\" flex=\"33\">Contacts can’t search or access anything else..</div>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"typeOrUpload\" step-bg=\"/assets/images/dialogs/addbg.png\" on-next-step=\"vm.determineNextStep()\">\n <h3 class=\"margin-bottom-40\">Do you want to type in a single contact or upload a list?</h3>\n <md-radio-group ng-model=\"vm.typeOrUpload\">\n <div layout=\"row\" layout-fill class=\"typeOrUpload\">\n <div flex=\"50\" layout=\"column\" layout-align=\"start center\">\n <md-radio-button name=\"type\" value=\"type\" aria-label=\"type\" style=\"white-space: nowrap\" id=\"RdoTypeIn\">\n <img class=\"typeOrUploadImg\" aria-lable=\"type\" s3-src=\"/assets/images/dialogs/post-status.png\">\n <br> Type in a single contact\n </md-radio-button>\n </div>\n <div flex=\"50\" layout=\"column\" layout-align=\"start center\">\n <md-radio-button name=\"upload\" value=\"upload\" aria-label=\"type\" style=\"white-space: nowrap\" id=\"RdoUpload\">\n <img class=\"typeOrUploadImg\" s3-src=\"/assets/images/dialogs/upload2.png\">\n <br> Upload a list\n </md-radio-button>\n </div>\n </div>\n </md-radio-group>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"basicInfo\" step-bg=\"/assets/images/dialogs/name.png\" on-next-step=\"vm.confirmNameEntered()\"> \n <h3>Enter Basic Info</h3>\n <p>You\'ll type additional details after this wizard.</p>\n <md-input-container>\n <label>First Name</label>\n <input ng-model=\"vm.contact.FirstName\" required />\n </md-input-container>\n <md-input-container>\n <label>Last Name</label>\n <input ng-model=\"vm.contact.LastName\" required />\n </md-input-container>\n <md-input-container>\n <label>Email</label>\n <input ng-model=\"vm.contact.Email\" />\n </md-input-container>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"upload\" step-bg=\"/assets/images/dialogs/uploadbg.png\" on-next-step=\"vm.confirmFileChosen()\">\n <h3>Upload File</h3>\n <p>Align Us only accepts CSV files with a known set of headers. <a target=\"_blank\" style=\"text-decoration: underline\" ng-href=\"https://alignusstatic.s3.amazonaws.com/files/example_users.csv\">Download an example file.</a></p>\n\n <div layout=\"column\" layout-align=\"start center\" class=\"padding-top-30\" layout-fill>\n <md-button class=\"md-primary md-raised material-shadow\" ngf-select ng-model=\"vm.file\" ngf-multiple=\"false\" ngf-capture=\"\'other\'\" ngf-pattern=\"\'.csv\'\" accept=\".csv\" id=\"BtnSelectFile\">\n Select File To Upload\n </md-button>\n <p class=\"padding-top-10\">{{vm.file.name}}</p>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"teams\" step-bg=\"/assets/images/dialogs/users.png\">\n <h3>Groups</h3>\n <p>Add contact to groups by typing in the name of the group.</p>\n <md-chips ng-model=\"vm.teams\" md-require-match=\"true\" md-transform-chip=\"vm.transformTeamChip($chip)\" flex>\n <md-autocomplete class=\"padding-top-10\" md-search-text=\"vm.teamSearchText\" md-items=\"team in $root.auUtility.searchTeams(vm.teamSearchText)\" placeholder=\"Group\" md-autoselect=\"true\" md-select-on-match=\"true\">\n <md-item-template>\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.teamSearchText\" md-highlight-flags=\"i\">\n {{team | auItemFilter: \'Team\'}}\n </span>\n </div>\n </md-item-template>\n </md-autocomplete>\n <md-chip-template>\n <div layout=\"row\" layout-align=\"start center\">\n <au-profile-image item=\"$chip\" item-type=\"Team\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'Team\'}}</span>\n </div>\n </md-chip-template>\n </md-chips>\n </au-wizard-step>\n\n</md-dialog>");
$templateCache.put("/app/structure/users-and-teams/dialogs/reassign-subordinates-dialog.tmpl.html","<md-toolbar>\n <div class=\"md-toolbar-tools\">\n <h2>Reassign Subordinates</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.$mdDialog.hide()\">\n <md-icon md-font-icon=\"zmdi zmdi-close\" aria-label=\"close\"></md-icon>\n </md-button>\n </div>\n</md-toolbar>\n\n<form name=\"reassignUsers\">\n <md-dialog-content class=\"md-padding\">\n <div class=\"md-body-1 margin-bottom-30\">\n <span>Change everyone that reports to </span>\n <span class=\"md-body-2\">{{ vm.selectedUser | fullNameFilter }}</span>\n <span> to now report to...</span>\n </div>\n <md-autocomplete md-selected-item=\"vm.toUser\" md-autoselect=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.searchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.searchText, excludeContacts: true})\"\n md-item-text=\"user | fullNameFilter\" md-floating-label=\"Select a user\" md-input-name=\"user\"\n md-autofocus required id=\"AutoReassignSubordinates\">\n <md-item-template>\n <span ng-attr-id=\"AutoReassignSubOption{{$index}}\">\n {{ user | fullNameFilter }}\n </span>\n </md-item-template>\n <div ng-messages=\"reassignUsers.user.$error\">\n <div ng-message=\"required\">\n <span>Please select a user</span>\n </div>\n </div>\n </md-autocomplete>\n\n <md-radio-group ng-model=\"vm.clearBoss\" ng-if=\"vm.selectedUser.ReportsTo\">\n <md-radio-button ng-value=\"false\">\n <span>Leave {{ vm.selectedUser | fullNameFilter }} reporting to {{ vm.selectedUser.ReportsTo | fullNameFilter }}.</span>\n\n </md-radio-button>\n <md-radio-button ng-value=\"true\">\n <span>Clear who </span> {{ vm.selectedUser | fullNameFilter }} reports to.\n </md-radio-button>\n </md-radio-group>\n <p ng-if=\"!vm.selectedUser.ReportsTo\">\n {{ vm.selectedUser | fullNameFilter }} does not currently report to anyone.\n </p>\n\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n <md-button ng-click=\"vm.$mdDialog.hide()\" ng-if=\"!vm.loading\" id=\"BtnCancel\">\n <span>Cancel</span>\n </md-button>\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.reassignUsers()\" type=\"submit\" ng-if=\"!vm.loading\" ng-disabled=\"requiredUsers.$invalid\" id=\"BtnSubmit\">\n <span>Do It</span>\n </md-button>\n <md-progress-circular md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-circular>\n </md-dialog-actions>\n</form>");
$templateCache.put("/app/structure/users-and-teams/dialogs/reset-passwords-dialog.tmpl.html","<md-dialog id=\"edit-team-dialog\" flex=\"50\" flex-sm=\"100\" flex-md=\"60\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Reset Password</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content class=\"layout-padding\">\n <md-content>\n <p class=\"md-body-1 margin-bottom-30\">You can choose to create a new random password for the selected users or create one manually. You can choose to have the users be emailed their new password.</p>\n <md-radio-group ng-model=\'vm.newPassword.specify\'>\n <md-radio-button value=\"0\" id=\"RdoRandomPassword\"><span>Generate a random password</span></md-radio-button>\n <md-radio-button value=\"1\" id=\"RdoManualPassword\"><span>Manually specify a new password</span></md-radio-button>\n </md-radio-group>\n <ng-form class=\"md-padding\" ng-if=\"vm.newPassword.specify == \'1\'\" name=\"newPassword\" layout=\"column\">\n <md-input-container>\n <label><span>Enter a new password</span></label>\n <input type=\"password\" name=\"password\" ng-model=\"vm.newPassword.password\" minlength=\"8\" required id=\"TxtNewPassword\">\n </md-input>\n </md-input-container>\n <md-input-container>\n <label><span>Verify password</span></label>\n <input type=\"password\" name=\"passwordVerify\" ng-model=\"vm.newPassword.passwordVerify\" input-match=\"vm.newPassword.password\"\n minlength=\"8\" required id=\"TxtVerifyPassword\" />\n </md-input>\n <div ng-messages=\"newPassword.passwordVerify.$error\">\n <div ng-message-exp=\"[\'required\', \'minlength\', \'inputMatch\']\">\n <span>Passwords don\'t match</span>\n </div>\n </div>\n </md-input-container>\n </ng-form>\n <md-checkbox class=\"margin-top-20\" ng-model=\"vm.newPassword.sendEmail\" ng-init=\"vm.newPassword.sendEmail=true\"><span>Email users their new password</span></md-checkbox>\n <div layout layout-align=\"center center\" ng-if=\"vm.newPassword.inProgress\">\n <md-progress-circular md-mode=\"indeterminate\" class=\"md-primary\"></md-progress-circular>\n </div>\n </md-content>\n </md-dialog-content>\n <md-dialog-actions layout=\"row\" layout-align=\"end center\">\n <div ng-if=\"!vm.finishing\">\n <md-button ng-click=\"vm.cancel()\" Xmd-theme=\"grey\" class=\"md-primary\" aria-label=\"cancel\">Cancel</md-button>\n <md-button type=\"submit\" ng-click=\"vm.handleBatchPasswordReset()\" class=\"md-primary md-raised\" ng-disabled=\"addTeamForm.$invalid\"\n aria-label=\"Add User\" id=\"BtnResetPassword\">Reset Password</md-button>\n </div>\n <div ng-if=\"vm.finishing\">\n <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/structure/users-and-teams/team/item.tmpl.html","<ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.item\">\n <div class=\"md-padding team-item-detail\" layout=\"column\" layout-align=\"start center\">\n <md-popout-card-list class=\"full-width\" selected=\"0\" item=\"vm.item\">\n <!-- Top User Information Card -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.item\" title-field=\"Name\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Team Information Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">{{vm.item.Name}}</div>\n <div class=\"description\">Edit the team details</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-edit\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"$root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <md-input-container>\n <label>\n <span>Team Name</span>\n </label>\n <input type=\"text\" ng-model=\"vm.item.Name\" required maxlength=\"100\" id=\"TxtTeamName\" />\n </md-input-container>\n\n <md-autocomplete md-selected-item=\"vm.item.Owner\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"user in $root.auUtility.searchUsers({query:vm.headSearchText, excludeContacts: true, showAdd: true})\"\n md-search-text=\"vm.headSearchText\" md-floating-label=\"Team Owner\" md-item-text=\"user | fullNameFilter\" id=\"TxtTeamOwner\"\n md-selected-item-change=\"vm.selectedHeadChanged(user)\" required>\n <md-item-template>\n <span md-highlight-text=\"vm.headSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoTeamOwner{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </md-card-content>\n </div>\n </md-card>\n\n <!--members-->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex>\n <div class=\"md-title\">Team Members</div>\n <div class=\"description\" layout=\"row\">\n <div flex>Add members/roles/titles/etc. to your team.</div>\n </div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden fill-viewport\" au-can-edit=\"$root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner\" on-visible=\"vm.centerContentTrigger = vm.centerContentTrigger + 1\">\n <md-divider></md-divider>\n\n <div style=\"box-sizing: border-box; background-color: #efefef; height: 50px; width: 100%\" ng-if=\"$root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner\"\n ng-click=\"vm.showConfirmRemove = false\">\n <md-button aria-label=\"Add Member\" class=\"md-primary md-main-theme\" ng-click=\"vm.showAddMember($event)\" id=\"BtnAddTeamMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Add Member</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Remove Member\" class=\"md-primary md-main-theme\" ng-click=\"vm.showRemoveMember($event)\"\n id=\"BtnRemoveTeamMember\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>&nbsp; Remove Member</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Message Members\" class=\"md-primary md-main-theme\" ng-click=\"vm.item.message()\"\n id=\"BtnMessageTeamMembers\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-comment-alt zmdi-hc-fw\"></i>\n <span flex>&nbsp; Message Members</span>\n </div>\n </md-button>\n\n <md-button aria-label=\"Confirm Remove Member\" class=\"md-primary md-main-theme md-raised\" ng-click=\"vm.confirmRemoval($event)\"\n ng-if=\"vm.showConfirmRemove\" id=\"BtnConfirmRemove\">\n <div layout=\"row\" layout-align=\"center center\">\n <i class=\"zmdi zmdi-account-add zmdi-hc-fw\"></i>\n <span flex>Confirm Removal of Member</span>\n </div>\n <md-tooltip>Removing a member takes them out of this team without affecting their user account.</md-tooltip>\n </md-button>\n </div>\n\n <div angular-org-chart nodes=\"vm.item.Nodes\" flex=\"grow\" style=\"background-color: white;\" ng-style=\"{\'height\':viewportHeight - 50 + \'px\'}\"\n node-width=\"150\" node-height=\"200\" parent-id-property=\"ParentId\" id-property=\"_id\" enable-selection=\"true\" node-template=\"\'/app/structure/users-and-teams/team/node.tmpl.html\'\"\n enable-parent-update=\"$root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner\" zoom-to-fit-trigger=\"vm.centerContentTrigger\"></div>\n </div>\n </md-card>\n\n <!-- Social Page -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Social Page</div>\n <div class=\"description\">View the Organization\'s page on the social intranet.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" style=\'max-height: 3000px; overflow: hidden\'>\n <md-divider></md-divider>\n <div ng-include=\"\'/app/social/page/tmpl.html\'\" ng-controller=\"PageItemController as vm\" ng-inject=\"{itemSettings: {item: vm.item.getPage()} }\"></div>\n </div>\n </md-card>\n\n <!-- Meeting List Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnMeetingListHeader\">\n <div class=\"md-title\">Meeting List</div>\n <div class=\"description\">List of all Meetings by this team.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-menu\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n <div layout=\"row\" layout-align=\"center center\" class=\"hide-xs hide-sm margin-right-10\">\n </div>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"::vm.item\" acl=\"U\">\n <md-divider></md-divider>\n <au-meeting-list item=\"vm.item\"></au-meeting-list>\n </div>\n </md-card>\n\n <!-- Documents Board Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"($root.user.EffPerms.Teams.CanEditAll || $root.user._id == vm.item.Owner)\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.item\"></au-document-section>\n </div>\n </md-card>\n\n <!-- audit trail card -->\n <md-card ng-if=\"::$root.user.EffPerms.SysAdmin\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAuditTrail\">\n <div class=\"md-title\">Audit Trail</div>\n <div class=\"description\">See a history of modifications to this {{vm.item.$key}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <div class=\"padding-40 md-caption\" style=\"line-height:30px\">\n <au-audit-trail item=\"vm.item\"></au-audit-trail>\n </div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n\n </div>\n</ng-form>");
$templateCache.put("/app/structure/users-and-teams/team/node.tmpl.html","<md-card class=\"margin-0\" layout-fill style=\"min-height: 170px\">\n <md-toolbar class=\"background-banner\" layout=\"column\" layout-align=\"center center\">\n <au-profile-image class=\"overhang margin-right-0\" ng-if=\"node.LinkWithUserId\" user=\"node.LinkWithUserId\" size=\"60\"></au-profile-image>\n <au-profile-image class=\"overhang margin-right-0\" ng-if=\"!node.LinkWithUserId\" item=\"node\" size=\"60\"></au-profile-image>\n </md-toolbar>\n <div class=\"padding-10 padding-top-30\">\n <div ng-if=\"node.$selected\" class=\"margin-top-40\" style=\"text-align: left\">\n <md-input-container>\n <label><span>Title/Role/Etc.</span></label>\n <input type=\"text\" ng-model=\"node.Text\" required maxlength=\"100\" id=\"TxtTeamMemberTitle\" />\n </md-input-container>\n\n <md-autocomplete class=\"padding-top-20\" md-selected-item=\"node.LinkWithUserId\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"user in $root.auUtility.searchUsers({query:nodeSearchText, showAdd: true})\"\n md-selected-item-change=\"$root.auUtility.linkNodeWithUser(node,user)\" md-search-text=\"nodeSearchText\" md-floating-label=\"User\" md-item-text=\"user | fullNameFilter\" id=\"AutoTeamMember\">\n <md-item-template>\n <span md-highlight-text=\"nodeSearchText\" md-highlight-flags=\"i\" id=\"AutoTeamMemberOption{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </div>\n <div ng-if=\"!node.$selected\">\n <div class=\"md-title\">\n {{ node.Text }}\n </div>\n <div class=\"md-caption\" ng-if=\"node.Text != $root.fullName(node.LinkWithUserId)\">\n {{ node.LinkWithUserId | fullNameFilter }}\n </div>\n </div>\n </div>\n</md-card>");
$templateCache.put("/app/structure/users-and-teams/user/detail.tmpl.html","<ng-form name=\'editItemForm\' auto-save-form=\"vm.save()\" auto-save-on-dirty=\"vm.setFabToSave()\" cached-resource=\"vm.detail\"\n ignore-fields=\"[\'Permissions\',\'IsActive\',\'MySettings\']\">\n <div class=\"user-detail\" layout=\"column\" layout-align=\"start center\">\n\n <md-popout-card-list class=\"full-width\" item=\"vm.item\">\n\n <!-- Top User Information Card -->\n <md-card>\n <md-card-content class=\"background-color-500\">\n <au-item-detail-header-card item=\"vm.detail\" allow-title-edit=\"false\"></au-item-detail-header-card>\n </md-card-content>\n </md-card>\n\n <!-- Change Password Card -->\n <md-card ng-if=\"vm.detail._id == $root.user._id && !vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-key\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPersonalInfoHeader\">\n <div class=\"md-title\">\n Change Password\n </div>\n <div class=\"description\">Change your password</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-key\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <div class=\"md-padding\" style=\"background-color: white\">\n <md-input-container>\n <label>New Password (min 8 characters)</label>\n <input type=\"password\" ng-model=\"vm.ownNewPassword\" required />\n </md-input-container>\n <md-input-container>\n <label>Confirm New Password</label>\n <input type=\"password\" ng-model=\"vm.verifyPassword\" required />\n </md-input-container>\n <md-button class=\"md-primary\" ng-click=\"vm.resetPassword($event, true)\" ng-disabled=\"!vm.ownNewPassword || (vm.ownNewPassword != vm.verifyPassword) || (vm.ownNewPassword.length < 8)\">\n Set Password\n </md-button>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Social Page -->\n <md-card ng-if=\"!vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Social Page</div>\n <div class=\"description\">View {{::$root.user._id == vm.detail._id ? \'your\' : \'their\'}} page on the social intranet.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-laptop\" class=\"font-size-3 padding-right-30 md-primary hide-gt-sm\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" style=\'max-height: 3000px; overflow: hidden\'>\n <md-divider></md-divider>\n <div ng-include=\"\'/app/social/page/tmpl.html\'\" ng-controller=\"PageItemController as vm\" ng-inject=\"{itemSettings: {item: vm.detail.getPage()} }\"></div>\n </div>\n </md-card>\n\n <!-- User Information Card -->\n <md-card ng-if=\"::$root.user.IsUserAdmin || $root.user._id == vm.detail._id || vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-face\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPersonalInfoHeader\">\n <div class=\"md-title\">\n {{::vm.detail.IsContact ? \'Contact\' : \'User\'}} Profile\n </div>\n <div class=\"description\">Edit the {{::vm.detail.IsContact ? \'contact\' : \'user\'}}\'s details</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-face\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"$root.user.IsUserAdmin || $root.user._id == vm.detail._id || vm.detail.IsContact\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <div layout=\"column\" flex>\n <div layout=\"row\" layout-align=\"center center\" layout-xs=\"column\">\n <div layout=\"column\" flex=\"70\" flex-xs=\"100\" flex-order-xs=\"2\" flex-sm=\"100\">\n <div layout=\"row\">\n <md-input-container flex=\"70\">\n <md-icon md-font-icon=\"zmdi zmdi-account\"></md-icon>\n <label>First Name</label>\n <input type=\"text\" ng-model=\"vm.detail.FirstName\" required maxlength=\"100\" id=\"TxtFirstName\" />\n </md-input-container>\n <md-input-container flex=\"30\">\n <md-icon md-font-icon=\"zmdi zmdi-account\" style=\"visibility:hidden;\"></md-icon>\n <label>Middle Name</label>\n <input type=\"text\" ng-model=\"vm.detail.MiddleName\" maxlength=\"100\" id=\"TxtMiddleName\" />\n </md-input-container>\n </div>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-account\" style=\"visibility:hidden;\"></md-icon>\n <label>Last Name</label>\n <input type=\"text\" ng-model=\"vm.detail.LastName\" required maxlength=\"100\" id=\"TxtLastName\" />\n </md-input-container>\n </div>\n\n <div layout=\"column\" layout-align=\"center center\" flex=\"30\" flex-xs=\"100\" flex-order-xs=\"1\" class=\"margin-20\">\n <au-image-uploader item=\"vm.detail\" style=\"height: 100px; width: 100px\" id=\"BtnProfilePicture\"></au-image-uploader>\n </div>\n </div>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <label>Email Address</label>\n <input type=\"email\" ng-model=\"vm.detail.Email\" maxlength=\"200\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\" id=\"TxtEmailAddress\"\n />\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <label>\n <span>Work Phone</span>\n </label>\n <input type=\"tel\" ng-model=\"vm.detail.Phone\" maxlength=\"200\" id=\"TxtWorkPhone\" />\n </md-input-container>\n </div>\n\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-assignment-account\"></md-icon>\n <label>Title</label>\n <input type=\"text\" ng-model=\"vm.detail.Title\" maxlength=\"100\" id=\"TxtTitle\" />\n </md-input-container>\n\n <div au-can-edit=\"$root.user.IsUserAdmin\" layout=\"row\" layout-align=\"start center\" ng-show=\"!vm.detail.IsContact\">\n <md-icon md-font-icon=\"au au-reassign\" style=\"color:rgba(0,0,0,0.87);\"></md-icon>\n <md-input-container flex class=\"margin-left-10\">\n <md-autocomplete md-selected-item=\"vm.detail.ReportsTo\" md-autoselect=\"true\" md-select-on-match=\"true\" md-items=\"user in vm.searchUsers(vm.reportsToSearchText)\"\n md-search-text=\"vm.reportsToSearchText\" md-floating-label=\"Reports To\" md-item-text=\"user | fullNameFilter\" id=\"AutoReportsTo\">\n <md-item-template>\n <span md-highlight-text=\"vm.reportsToSearchText\" md-highlight-flags=\"i\" id=\"AutoReportsToOption{{$index}}\">{{user | fullNameFilter}}</span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n <au-help-icon key=\"EditUser.ReportsTo\"></au-help-icon>\n </div>\n\n <div ng-if=\"!vm.detail.IsContact\" au-can-edit=\"$root.user.IsUserAdmin\" layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n <md-input-container flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\"></md-icon>\n <label>Department</label>\n <md-select ng-model=\"vm.detail.Department\" id=\"DrpDepartment\">\n <md-option ng-repeat=\"department in vm.departments\" ng-value=\"department._id\" ng-attr-id=\"DrpDepartmentOption{{$index}}\">\n {{department.Name}}\n </md-option>\n </md-select>\n </md-input-container>\n\n <md-input-container flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <label>Location</label>\n <md-select ng-model=\"vm.detail.Location\" id=\"DrpLocation\">\n <md-option ng-repeat=\"location in vm.locations\" ng-value=\"location._id\" ng-attr-id=\"DrpLocationOption{{$index}}\">\n {{location.Name}}\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n\n <p class=\"md-body-1\">Add this {{vm.detail.IsContact ? \'contact\' : \'user\'}} to a team, group, or committee by typing the name of the group.</p>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-city-alt\" style=\"margin-left: 2px; color: rgba(0, 0, 0, 0.87)\"></md-icon>\n <md-chips class=\"margin-left-10\" ng-model=\"vm.detail.Teams\" md-require-match=\"true\" md-transform-chip=\"vm.transformChip($chip)\" flex>\n <md-autocomplete style=\"padding: 0 0 0 10px\" md-search-text=\"vm.teamSearchText\" md-items=\"team in $root.auUtility.searchTeams(vm.teamSearchText)\"\n placeholder=\"Add Team\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtTeam\">\n <span md-highlight-text=\"vm.teamSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoTeam{{$index}}\">{{team | auItemFilter: \'Team\'}}</span>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\" ng-attr-id=\"ChipTeam{{$index}}\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'Team\'}}</span>\n </md-chip-template>\n </md-chips>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!--Email Preferenes-->\n <md-card ng-if=\"::$root.user.IsUserAdmin || vm.detail._id==$root.user._id\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnEmailPrefsHeader\">\n <div class=\"md-title\">Email Preferences</div>\n <div class=\"description\">Manage when the {{::vm.detail.IsContact ? \'contact\' : \'user\'}} receives emails.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-mail-send\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.InboxMessage\" ng-click=\"vm.detail.setSetting({Email: {InboxMessage: !vm.detail.Settings.Email.InboxMessage}})\">\n When {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} receive a private message.\n </md-checkbox>\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.DiscussionBoardMessage\" ng-click=\"vm.detail.setSetting({Email: {DiscussionBoardMessage: !vm.detail.Settings.Email.DiscussionBoardMessage}})\">\n When {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} receive a message in a discussion board.\n </md-checkbox>\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.Notification\" ng-click=\"vm.detail.setSetting({Email: {Notification: !vm.detail.Settings.Email.Notification}})\">\n When {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} receive a notification from Al Linus.\n </md-checkbox>\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.TaskFYI\" ng-click=\"vm.detail.setSetting({Email: {TaskFYI: !vm.detail.Settings.Email.TaskFYI}})\">\n When a task is assigned to someone in a project {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} are a member of.\n </md-checkbox>\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.NewTaskAssignment\" ng-click=\"vm.detail.setSetting({Email: {NewTaskAssignment: !vm.detail.Settings.Email.NewTaskAssignment}})\">\n When a task is assigned to {{::$root.user._id == vm.detail._id ? \'you\' : \'them\'}}.\n </md-checkbox>\n <md-checkbox ng-checked=\"vm.detail.Settings.Email.MeetingInvite\" ng-click=\"vm.detail.setSetting({Email: {MeetingInvite: !vm.detail.Settings.Email.MeetingInvite}})\">\n When {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} are invited to a meeting.\n </md-checkbox>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-time\"></md-icon>\n <label>What timezone are {{::$root.user._id == vm.detail._id ? \'you\' : \'they\'}} in?</label>\n <md-select ng-model=\"vm.detail.Settings.Timezone\" placeholder=\"Timezone\" id=\"DrpTimezone\" ng-change=\"vm.setTimezone()\">\n <md-option ng-repeat=\"timezone in vm.timezones track by $index\" ng-attr-id=\"DrpTimezoneOption{{$index}}\">{{timezone}}</md-option>\n </md-select>\n </md-input-container>\n\n <!-- \n <md-checkbox ng-model=\"vm.SendMorningEmail\" ng-change=\"vm.setDailyEmail(\'SendMorningEmail\')\">Send morning reminders of upcoming tasks and events.</md-checkbox>\n <div ng-show=\"vm.detail.Settings.SendMorningEmail\" class=\"margin-left-30\">\n <mdp-time-picker mdp-auto-switch=\"true\" name=\"time\" mdp-placeholder=\"Send Morning Email Refresher at...\" mdp-open-on-click\n ng-model=\"vm.detail.Settings.SendMorningEmail\"></mdp-time-picker>\n </div>\n <md-checkbox ng-model=\"vm.SendNightlyEmail\" ng-change=\"vm.setDailyEmail(\'SendNightlyEmail\')\">Send nightly recap of {{::$root.Organization.toString()}} activity.</md-checkbox>\n <div ng-show=\"vm.detail.Settings.SendNightlyEmail\" class=\"margin-left-30\">\n <mdp-time-picker mdp-auto-switch=\"true\" name=\"time\" mdp-placeholder=\"Send Nightly Email Summary at...\" mdp-open-on-click\n ng-model=\"vm.detail.Settings.SendNightlyEmail\"></mdp-time-picker>\n </div> \n -->\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Employment Info Card -->\n <md-card ng-if=\"::!vm.detail.IsContact && ($root.user.IsUserAdmin || $root.user._id == vm.detail._id)\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-folder-person\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnEmploymentInfoHeader\">\n <div class=\"md-title\">Employment Info</div>\n <div class=\"description\">{{$root.user._id == vm.detail._id ? \'Manage information such as your date of birth and marital status\' : \'Maintain\n employment info such as salary, hire date, and more\'}}</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-folder-person\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"$root.user.IsUserAdmin\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <div class=\"md-caption margin-bottom-20\">The following information is only visible to the user ({{vm.detail.toString()}}) and user administrators. Only user\n admins can edit.\n </div>\n\n <div layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" layout-sm=\"column\" layout-align-xs=\"start stretch\" layout-align-sm=\"start stretch\">\n <md-input-container flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"au au-account-id\"></md-icon>\n <label>Employee ID</label>\n <input type=\"text\" ng-model=\"vm.detail.EmployeeID\" maxlength=\"100\" id=\"TxtEmployeeId\" />\n </md-input-container>\n <div layout=\"row\" layout-align=\"start center\" flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-input-container flex=\"90\">\n <md-icon md-font-icon=\"zmdi zmdi-device-hub\"></md-icon>\n <label>Network ID</label>\n <input type=\"text\" ng-model=\"vm.detail.NetworkID\" maxlength=\"100\" id=\"TxtNetworkId\" />\n </md-input-container>\n <au-help-icon key=\"EditUser.NetworkID\" flex=\"10\"></au-help-icon>\n </div>\n </div>\n\n <md-input-container flex-gt-xs=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-money\"></md-icon>\n <label>Salary</label>\n <input type=\"number\" pattern=\"^\\$?[0-9\\,]+(\\.[0-9]{1,2})?$\" ng-model=\"vm.detail.Salary\" id=\"TxtSalary\" />\n </md-input-container>\n\n <div layout=\"row\" layout-align=\"start center\" layout-xs=\"column\" layout-sm=\"column\" layout-align-xs=\"start stretch\" layout-align-sm=\"start stretch\">\n <md-input-container flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-male-female\"></md-icon>\n <label>Marital Status</label>\n <md-select placeholder=\"Marital Status\" ng-model=\"vm.detail.MaritalStatus\" id=\"DrpMaritalStatus\">\n <md-option ng-repeat=\"value in vm.maritalSatuses\" value=\"{{value}}\" ng-attr-id=\"DrpMaritalStatusOption{{$index}}\">\n <span ng-if=\"value\">{{value}}</span>\n </md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex=\"50\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-globe\"></md-icon>\n <label>Citizenship Status</label>\n <md-select placeholder=\"Citizenship Status\" ng-model=\"vm.detail.CitizenshipStatus\" id=\"DrpCitizenshipStatus\">\n <md-option ng-repeat=\"value in vm.citizenshipStatuses\" value=\"{{value}}\" ng-attr-id=\"DrpCitizenshipStatusOption{{$index}}\">\n <span ng-if=\"value\">{{value}}</span>\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n\n <div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n <div layout=\"row\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-calendar\" style=\"color: rgba(0, 0, 0, 0.87);\" class=\"padding-left-2\"></md-icon>\n <mdp-date-picker mdp-placeholder=\"Date Hired\" mdp-open-on-click ng-change=\"vm.fixDate(vm.detail.DateHired)\" ng-model=\"vm.detail.DateHired\"\n mdp-format=\"M/D/YY\" class=\"md-icon-float md-block margin-left-10\" flex id=\"BtnDateHired\">\n </mdp-date-picker>\n </div>\n\n <div layout=\"row\" flex>\n <md-icon md-font-icon=\"zmdi zmdi-cake\" style=\"color: rgba(0, 0, 0, 0.87);\" class=\"padding-left-2\"></md-icon>\n <mdp-date-picker mdp-placeholder=\"Date of Birth\" mdp-open-on-click ng-change=\"vm.fixDate(vm.detail.DateOfBirth)\" ng-model=\"vm.detail.DateOfBirth\"\n mdp-format=\"M/D/YY\" class=\"md-icon-float md-block margin-left-10\" flex id=\"BtnDateOfBirth\">\n </mdp-date-picker>\n </div>\n </div>\n\n <div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-male-alt\"></md-icon>\n <label>Gender</label>\n <md-select placeholder=\"Gender\" ng-model=\"vm.detail.Gender\" id=\"DrpGender\">\n <md-option ng-value=\"null\">\n <span></span>\n </md-option>\n <md-option id=\"DrpGenderMale\">\n <span>Male</span>\n </md-option>\n <md-option id=\"DrpGenderFemale\">\n <span>Female</span>\n </md-option>\n <md-option id=\"DrpGenderOther\">\n <span>Does not Identify</span>\n </md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-graduation-cap\"></md-icon>\n <label>Education Level</label>\n <md-select placeholder=\"Education Level\" ng-model=\"vm.detail.EducationLevel\" id=\"DrpEducationLevel\">\n <md-option ng-repeat=\"level in vm.educationLevels\" value=\"{{level}}\" ng-attr-id=\"DrpEducationLevelOption{{$index}}\">\n <span>{{level}}</span>\n </md-option>\n </md-select>\n </md-input-container>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Personalization Card -->\n <md-card ng-if=\"vm.detail._id == $root.user._id\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-palette\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPersonalInfoHeader\">\n <div class=\"md-title\">\n Personalization\n </div>\n <div class=\"description\">Change the color of Align Us when you login.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-palette\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <div class=\"md-padding\" layout=\"column\">\n\n\n <!-- Color picker -->\n <div layout=\"row\" layout-align=\"start center\" layout-fill>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-format-color-fill\"></md-icon>\n <label>Toolbar Color</label>\n <md-select ng-model=\"vm.toolbarColor\" ng-change=\"vm.setToolbarColor(vm.toolbarColor.color)\" ng-model-options=\"{trackBy: \'$value.color\'}\"\n md-container-class=\"color-select-container\" id=\"SettingsDrpSettingsToolbarColor\">\n <div class=\"color-select-wrapper\">\n <md-option class=\"color-select\" ng-repeat=\"color in ::vm.colors track by color.color\" ng-value=\"color\" ng-attr-id=\"SettingsDrpSettingsToolbarColorOption{{::$index}}\">\n <div class=\"color-pill-inner-wrapper\">\n <div class=\"color-pill\" ng-class=\"::{light: color.lightHighlight}\" ng-style=\"::{\'background-color\': color.color}\">\n <md-icon md-font-icon=\"zmdi zmdi-check\" class=\"checked font-size-4\" ng-if=\"vm.detail.Settings.TitlebarColor == color.color\"></md-icon>\n </div>\n <div class=\"color-pill-accent\" ng-style=\"::{\'background-color\': color.accent}\">\n </div>\n </div>\n </md-option>\n </div>\n </md-select>\n </md-input-container>\n <au-help-icon class=\"md-accent\" key=\"OrgSettings.Color\"></au-help-icon>\n </div>\n <div layout=\"row\" layout-align=\"start center\" flex>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-code\"></md-icon>\n <label>Hex Color</label>\n <input ng-model=\"vm.toolbarColor.color\" validate-color ng-blur=\"vm.setToolbarColor(vm.toolbarColor.color)\" id=\"TxtHexColor\"\n flex/>\n </md-input-container>\n </div>\n </div>\n\n\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Contact Information -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnContactInfoHeader\">\n <div class=\"md-title\">Additional Phone & Emails</div>\n <div class=\"description\">Alternate phone and email addresses for the {{::vm.detail.IsContact ? \'Contact\' : \'User\'}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-email\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\" au-can-edit=\"$root.user.IsUserAdmin || vm.detail._id==$root.user._id || vm.detail.IsContact\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <div class=\"md-subhead margin-bottom-20\">\n Phone Numbers\n </div>\n\n <p class=\"grow md-body-1 angular-animate\" ng-if=\"!vm.detail.AdditionalPhoneNumbers || vm.detail.AdditionalPhoneNumbers.length==0\">\n <span layout=\"row\" layout-align=\"center center\" id=\"StringEmptyPhone\">No additional phone numbers on file.</span>\n </p>\n <div class=\"grow contact angular-animate\" ng-repeat=\"phone in vm.detail.AdditionalPhoneNumbers\">\n <div layout=\"row\">\n <md-button class=\"md-icon-button icon-button-input-margin\" aria-label=\"Delete additional phone\" ng-click=\"vm.removeContactInfo(vm.detail.AdditionalPhoneNumbers, $index, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n </md-button>\n <md-input-container flex=\"25\">\n <label>Phone type</label>\n <md-select ng-model=\"phone.Type\" ng-attr-id=\"DrpPhoneType{{$index}}\">\n <md-option ng-attr-id=\"DrpPhoneTypeWork{{$index}}\">Work</md-option>\n <md-option ng-attr-id=\"DrpPhoneTypeHome{{$index}}\">Home</md-option>\n <md-option ng-attr-id=\"DrpPhoneTypeCell{{$index}}\">Cell</md-option>\n <md-option ng-attr-id=\"DrpPhoneTypeOther{{$index}}\">Other</md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-phone\"></md-icon>\n <label>Phone</label>\n <input type=\"tel\" ng-model=\"phone.Value\" ng-attr-id=\"TxtPhoneNumber{{$index}}\" />\n </md-input-container>\n </div>\n </div>\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.addContactRow(vm.detail.AdditionalPhoneNumbers)\" id=\"BtnAddPhone\">\n <span>ADD PHONE</span>\n </md-button>\n </div>\n </md-card-content>\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n\n <div class=\"md-subhead margin-bottom-20\">\n Primary Email Address\n </div>\n\n <div class=\"contact margin-bottom-20\" layout=\"row\">\n <md-input-container flex>\n <md-icon md-font-icon=\"zmdi zmdi-email\"></md-icon>\n <label>Primary Email</label>\n <input type=\"email\" ng-model=\"vm.detail.Email\" maxlength=\"200\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\" id=\"TxtPrimaryEmailAddress\"\n />\n </md-input-container>\n </div>\n\n\n <div class=\"md-subhead\">\n Additional Email Address\n </div>\n\n <p class=\"grow md-body-1\" ng-if=\"!vm.detail.AdditionalEmails.length\">\n <span layout=\"row\" layout-align=\"center center\" id=\"StringEmptyEmail\">No additional emails on record.</span>\n </p>\n <div class=\"grow contact\" ng-repeat=\"email in vm.detail.AdditionalEmails\">\n <div layout=\"row\">\n <md-button class=\"md-icon-button icon-button-input-margin\" aria-label=\"Delete additional email\" ng-click=\"vm.removeContactInfo(vm.detail.AdditionalEmails, $index, $event)\">\n <md-icon md-font-icon=\"zmdi zmdi-delete\"></md-icon>\n </md-button>\n <md-input-container flex=\"25\">\n <label>Email type</label>\n <md-select ng-model=\"email.Type\" ng-attr-id=\"DrpEmailType{{$index}}\">\n <md-option ng-attr-id=\"DrpEmailTypeWork{{$index}}\">Work</md-option>\n <md-option ng-attr-id=\"DrpEmailTypePersonal{{$index}}\">Personal</md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex>\n <label>Email</label>\n <input type=\"email\" ng-model=\"email.Value\" pattern=\"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$\" id=\"TxtNewEmailAddress{{$index}}\"\n />\n </md-input-container>\n </div>\n </div>\n\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.addContactRow(vm.detail.AdditionalEmails)\" id=\"BtnAddEmail\">\n <span>ADD EMAIL</span>\n </md-button>\n </div>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Addresses Card -->\n <md-card>\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAddressHeader\">\n <div class=\"md-title\">Mailing Address(es)</div>\n <div class=\"description\">The {{::vm.detail.IsContact ? \'contact\' : \'user\'}}\'s address(es).</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-pin\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\" au-can-edit=\"$root.user.IsUserAdmin || vm.detail._id==$root.user._id || vm.detail.IsContact\">\n <md-list class=\"padding-30\">\n <div class=\"grow addresses\" ng-repeat=\"address in vm.detail.Addresses track by $index\">\n <md-list-item layout=\"column\">\n <div class=\"full-width margin-bottom-10\">\n <div layout=\"row\" layout-align=\"space-between start\" class=\"full-width\">\n <md-autocomplete md-name=\"{{ \'addressType\'+$index}}\" md-items=\"item in vm.addressTypes\" md-floating-label=\"Type\" md-search-text=\"address.AddressType\"\n md-min-length=\"0\" ng-attr-id=\"AutoAddressType{{$index}}\">\n <md-item-template>\n <span ng-attr-id=\"AutoAddressTypeOption{{$index}}\">{{item}}</span>\n </md-item-template>\n </md-autocomplete>\n <md-button class=\"md-icon-button\" ng-click=\"vm.removeAddress($index, $event)\" aria-label=\"Remove address\">\n <md-tooltip md-direction=\"left\">\n <span>Remove Address</span>\n </md-tooltip>\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-home\"></md-icon>\n <label>Address</label>\n <input ng-model=\"address.Address1\" ng-attr-id=\"TxtAddress1{{$index}}\">\n </md-input-container>\n <md-input-container>\n <md-icon md-font-icon=\"zmdi zmdi-home\" style=\"visibility:hidden;\"></md-icon>\n <label>Apt/Ste/Unit</label>\n <input ng-model=\"address.Address2\" ng-attr-id=\"TxtAddress2{{$index}}\">\n </md-input-container>\n\n <div layout=\"row\" layout-xs=\"column\" layout-sm=\"column\">\n <md-input-container flex=\"60\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-pin\"></md-icon>\n <label>City</label>\n <input ng-model=\"address.City\" ng-attr-id=\"TxtCity{{$index}}\">\n </md-input-container>\n <md-input-container flex=\"10\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-balance\" hide-gt-sm></md-icon>\n <label>State</label>\n <md-select ng-model=\"address.StateProv\" ng-model-options=\"[{trackBy: \'$value\'}]\" ng-attr-id=\"DrpState{{$index}}\">\n <md-option ng-repeat=\"state in vm.states\" ng-value=\"state\" ng-attr-id=\"DrpStateOption{{$index}}\">\n {{state}}\n </md-option>\n </md-select>\n </md-input-container>\n <md-input-container flex=\"20\" flex-xs=\"100\" flex-sm=\"100\">\n <md-icon md-font-icon=\"zmdi zmdi-markunread-mailbox\" hide-gt-sm></md-icon>\n <label>Zip Code</label>\n <input ng-model=\"address.ZipPostalCode\" ng-attr-id=\"TxtZipCode{{$index}}\" />\n </md-input-container>\n </div>\n </div>\n </md-list-item>\n <md-divider ng-if=\"!$last\" class=\"margin-bottom-20\"></md-divider>\n </div>\n <div layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.detail.Addresses || vm.detail.Addresses.length==0\" id=\"StringEmptyAddress\">\n No address is on file for this user.\n </div>\n <div layout=\"row\" layout-align=\"center center\">\n <md-button class=\"md-primary md-raised\" ng-click=\"vm.addAddress()\" id=\"BtnAddAddress\">\n <span>ADD ADDRESS</span>\n </md-button>\n </div>\n </md-list>\n </div>\n </md-card>\n\n <!-- Login Info (password) Card -->\n <md-card ng-if=\"::!vm.detail.IsContact && $root.user.EffPerms.Users.IsAdminFor.Org\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-lock\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnLoginHeader\">\n <div class=\"md-title\">Login Info</div>\n <div class=\"description\">Manage the {{::vm.detail.IsContact ? \'contact\' : \'user\'}}\'s password and account status</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-lock\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content layout=\"column\">\n <ng-form name=\"passwordReset\" id=\"passwordReset\">\n <p class=\"md-title\">Reset Password</p>\n <p class=\"md-body-1\">Choose a method for password reset. The {{vm.detail.IsContact ? \'contact\' : \'user\'}} will be required to change their\n password the next time they log in.</p>\n <md-radio-group ng-model=\'vm.newPassword.specify\'>\n <md-radio-button value=\"0\" id=\"RdoRandomPassword\">\n <span>Email the {{vm.detail.IsContact ? \'contact\' : \'user\'}} a password recovery link.</span>\n </md-radio-button>\n <md-radio-button value=\"1\" id=\"RdoManualPassword\">\n <span>Manually specify a new, one-time, password.</span>\n </md-radio-button>\n </md-radio-group>\n <div class=\"md-padding\" ng-show=\"vm.newPassword.specify==\'1\'\" name=\"newPassword\" layout=\"column\">\n <md-input-container>\n <label>\n <span>New Password</span>\n </label>\n <input type=\"password\" name=\"password\" ng-model=\"vm.newPassword.password\" minlength=\"8\" required id=\"TxtNewPassword\" />\n </md-input-container>\n <md-input-container>\n <label>\n <span>Verify Password</span>\n </label>\n <input type=\"password\" name=\"passwordVerify\" ng-model=\"vm.newPassword.passwordVerify\" input-match=\"vm.newPassword.password\"\n minlength=\"8\" required id=\"TxtVerifyPassword\" />\n <div ng-messages=\"passwordReset.passwordVerify.$error\">\n <div ng-message=\"inputMatch\">Your password doesn\'t match the verification test</div>\n </div>\n </md-input-container>\n </div>\n\n\n <md-checkbox ng-show=\"vm.newPassword.specify==\'1\'\" ng-model=\"vm.newPassword.sendEmail\" ng-init=\"vm.newPassword.sendEmail=true\"\n id=\"CbxSendEmail\">\n <span>Email the {{::vm.detail.IsContact ? \'contact\' : \'user\'}} their password.</span>\n </md-checkbox>\n\n <div layout layout-align=\"start center\" ng-show=\"!vm.newPassword.inProgress\">\n <md-button ng-disabled=\"vm.newPassword.specify==\'1\' && (passwordReset.password.$invalid || passwordReset.passwordVerify.$invalid)\"\n class=\"md-primary md-raised\" ng-click=\"vm.resetPassword($event)\" id=\"BtnResetPassword\">\n <span>Reset Password</span>\n </md-button>\n </div>\n <div layout layout-align=\"center center\" ng-if=\"vm.newPassword.inProgress\">\n <md-progress-circular md-mode=\"indeterminate\" class=\"md-primary\"></md-progress-circular>\n </div>\n\n <md-divider style=\"margin-top: 20px\"></md-divider>\n <div layout=\"row\" flex layout-align=\"start center\">\n <p class=\"md-title\">Login as This User</p>\n <au-help-icon key=\"EditUser.LoginAsUser\"></au-help-icon>\n </div>\n\n <p class=\"md-body-1\">A simple way to test what this {{::vm.detail.IsContact ? \'contact\' : \'user\'}} can do and see is to log in as them.</p>\n\n <div layout layout-align=\"start center\" ng-if=\"!vm.showLoginAsUrl\">\n <md-button layout layout-align=\"start center\" class=\"md-primary md-raised\" ng-click=\"vm.loginAsClicked()\" id=\"BtnLoginLink\">\n <span>Generate Login Link</span>\n </md-button>\n </div>\n\n <md-input-container ng-show=\"vm.showLoginAsUrl\" style=\"margin-top: -20px; padding: 0px;\">\n <p class=\"md-body-1\">Visiting the link below will log you out of your session and log you in as this user. We recommend copying the link\n below into a new browser or an incognito/private window so that you stay logged in here.</p>\n <p style=\"font-weight: 600\">Please note that this login link will expire in, and only allow you to stay logged in as {{vm.detail.FirstName}}\n for, 15 minutes.</p>\n <input type=\"text\" ng-readonly=\"true\" ng-model=\"vm.loginAsUserUrl\" ng-click=\"vm.selectUrl($event)\n \" aria-label=\"login as user url\" />\n <span class=\"md-caption\" ng-show=\"vm.copiedOK\">Copied to clipboard. Open an incoginto/private window and \"Paste & Go\".</span>\n </md-input-container>\n\n <md-divider style=\"margin-top: 20px\"></md-divider>\n <div layout=\"row\" flex layout-align=\"start center\">\n <p class=\"md-title\">Account Status</p>\n <au-help-icon key=\"EditUser.Deactivate\"></au-help-icon>\n </div>\n <md-checkbox ng-model=\"vm.detail.IsActive\" ng-change=\"vm.setIsActive()\" aria-label=\"Toggle account enabled\n \" id=\"CbxActivateUser\">\n <span ng-if=\"!vm.detail.IsActive\">This account is currently deactivated. Click to activate this account.</span>\n <span ng-if=\"vm.detail.IsActive\">This account is currently active. Click to deactivate this account.</span>\n </md-checkbox>\n </ng-form>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Permission Presets Card -->\n <md-card ng-if=\"::$root.user.EffPerms.Users.IsAdminFor.Org && !vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-accounts-list\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnPermissionPresetsHeader\">\n <div class=\"md-title\">Permission Presets</div>\n <div class=\"description\">Choose which permission presets apply to the user.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-accounts-list\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n\n\n <div class=\"hidden\">\n <md-divider></md-divider>\n <md-card-content>\n <au-groups-list user=\"vm.detail\" groups=\"vm.permissionPresets\" direction=\"column\"></au-groups-list>\n </md-card-content>\n </div>\n </md-card>\n\n <!-- Custom Permissions Card -->\n <md-card ng-if=\"::$root.user.EffPerms.Users.IsAdminFor.Org && !vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-shield-check\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnCustomPermissionsHeader\">\n <div class=\"md-title\">Custom Permissions</div>\n <div class=\"description\">Set and edit specific permission for users.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-key\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <users-permissions-tree detail=\"vm.detail\" class=\"hidden\"></users-permissions-tree>\n </div>\n </md-card>\n\n <!-- Documents Board Card -->\n <md-card ng-if=\"::$root.user.EffPerms.Users.IsAdminFor.Org || $root.user.EffPerms.Users.CanViewEmploymentInfoList.indexOf(vm.detail._id) !=- 1 || vm.detail.IsContact\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnDocumentsHeader\">\n <div class=\"md-title\">Documents</div>\n <div class=\"description\">Collection box for all your files on this {{::vm.detail.IsContact ? \'contact\' : \'user\'}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-collection-text\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <div class=\"hidden\">\n <md-divider></md-divider>\n <au-document-section item=\"vm.detail\" only-list=\"!$root.user.IsUserAdmin\"></au-document-section>\n </div>\n </md-card>\n\n <!-- Audit Trail Card -->\n <md-card ng-if=\"::$root.user.EffPerms.SysAdmin\">\n <md-card-content>\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"zmdi-hc-fw auto-height font-size-4 padding-left-30 md-primary hide-xs hide-sm\"></md-icon>\n <div layout=\"column\" flex id=\"BtnAuditTrailHeader\">\n <div class=\"md-title\">Audit Trail</div>\n <div class=\"description\">See a history of modifications to this {{::vm.detail.IsContact ? \'contact\' : \'user\'}}.</div>\n </div>\n <md-icon md-font-icon=\"zmdi zmdi-time-countdown\" class=\"font-size-3 md-primary hide-gt-sm padding-right-30\"></md-icon>\n </div>\n </md-card-content>\n <md-divider class=\"hidden\"></md-divider>\n <div class=\"hidden\">\n <div class=\"padding-40 md-caption\" style=\"line-height:30px\">\n <au-audit-trail item=\"vm.detail\"></au-audit-trail>\n </div>\n </div>\n </md-card>\n\n </md-popout-card-list>\n </div>\n</ng-form>");
$templateCache.put("/app/alignus/directives/au-document-section/dialog/add-document-dialog.tmpl.html","<md-dialog\n au-wizard dialog-title=\"Add A Document\" on-init=\"vm.init()\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"New Document Dialog\"\n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\" id=\"AddDoc\">\n\n <au-wizard-step step-name=\"stepSelectNewOrExisting\" on-next-step=\"vm.determineNextStep()\">\n <h3>New or Existing</h3>\n <p>Do you want to use an existing document or create a new, blank, document?</p>\n <md-radio-group ng-model=\"vm.newDocument\" layout=\"row\" layout-align=\"space-around center\" layout-sm=\"column\" layout-wrap class=\"margin-top-10 margin-bottom-20\">\n <md-radio-button value=\"true\" aria-label=\"New Document\" id=\"RdoNewDoc\">\n <img src=\"/assets/images/dialogs/post-status.png\" style=\"max-width: 200px;\" class=\"grow\">\n <h4 style=\"margin:auto;text-align:center;\">Start a new document</h4>\n </md-radio-button>\n <md-radio-button value=\"false\" aria-label=\"Existing Doc\" id=\"RdoExistingDoc\">\n <img src=\"/assets/images/dialogs/post-document.png\" style=\"max-width: 200px;\" class=\"grow\">\n <h4 style=\"margin:auto;text-align:center;\">Use an existing document</h4>\n </md-radio-button>\n </md-radio-group>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"findDocument\" step-bg=\"/assets/images/dialogs/review.png\" on-next-step=\"vm.confirmTitleEntered()\">\n <h3>Use An Existing Document</h3>\n <p>Search for the document you\'d like to attach.</p>\n <div class=\"md-icon-float md-block margin-top-15\" layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-file-plus\"></md-icon>\n <md-autocomplete placeholder=\"Document to add...\" md-selected-item=\"vm.document\" md-autoselect=\"true\" md-autofocus=\"true\"\n md-items=\"document in vm.searchDocuments(vm.documentSearchText)\" au-return-object=\"true\" md-require-match=\"true\" md-search-text=\"vm.documentSearchText\" md-item-text=\"document.Title\" style=\"padding: 0 0 0 10px; background-color:rgba(255, 255, 255, 0.7);\" flex id=\"TxtDocTitle\">\n\n <md-item-template>\n <span md-highlight-text=\"vm.documentSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoDocTitle{{$index}}\">\n {{ document.Title }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </div>\n </au-wizard-step>\n\n <au-wizard-step step-name=\"createDocument\" step-bg=\"/assets/images/dialogs/typebg.png\" on-next-step=\"vm.confirmTitleEntered()\">\n <h3>Start A New Document</h3>\n <p>Give the document that you will attach a title. As the editor, you can control more privacy settings after this wizard.</p>\n <md-input-container md-autofocus=\"true\">\n <label>Title</label>\n <md-icon md-font-icon=\"zmdi zmdi-edit\"></md-icon>\n <input ng-model=\"vm.document.Title\" required id=\"TxtNewDocTitle\"/>\n </md-input-container>\n </au-wizard-step>\n\n</md-dialog>");
$templateCache.put("/app/alignus/directives/au-item-ownedby/dialog/select-owner.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Add Owner</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 10px 10px 0 10px;\">\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-account-add\"></md-icon>\n <md-autocomplete flex md-search-text=\"vm.newOwnerSearchText\" md-items=\"item in $root.auUtility.searchUsersAndTeams(vm.newOwnerSearchText, false, true, true, true)\"\n placeholder=\"Type a department, location, user or team name\" md-select-on-match=\"true\" md-autoselect=\"true\" md-selected-item=\"vm.newOwner\"\n md-item-text=\"item.$Display\" md-require-match=\"false\" md-autofocus>\n <span md-highlight-text=\"vm.newOwnerSearchText\" md-highlight-flags=\"i\">\n {{item.$Display}}\n </span>\n </md-autocomplete>\n </div>\n\n <div layout=\"row\" layout-align=\"start start\" class=\"margin-top-5\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\" class=\"margin-0 margin-top-25\"></md-icon>\n <md-input-container flex>\n <label>Optionally, describe the responsibilities of this owner.</label>\n <textarea ng-model=\"vm.newOwnerNote\" md-maxlength=\"250\" rows=\"5\" md-select-on-focus></textarea>\n </md-input-container>\n </div>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15\">\n <div layout=\"row\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancel()\">Cancel</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.done()\">Done</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/alignus/directives/au-item-security-and-sharing/dialog/share-dialog.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Share {{vm.item.$key}}</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 10px 10px 0 10px;\">\n <div class=\"header\">\n Send specified users a link to this {{vm.item.$key}}.\n </div>\n <!--to user-->\n <md-input-container flex class=\"margin-0 padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" style=\"top: 18px\"></md-icon>\n\n <md-chips ng-model=\"vm.toUsers\" md-require-match=\"txrue\" md-transform-chip=\"$root.auUtility.preventDuplicates(vm.toUsers, $chip);$root.auUtility.checkForNewItem({item: $chip, thenAddToArray: vm.toUsers})\"\n flex>\n <md-autocomplete md-search-text=\"vm.sharedWithSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.sharedWithSearchText, showAdd: true})\"\n placeholder=\"Share with User\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtProjectSharedWith\">\n <div layout=\"row\" layout-align=\"start center\">\n <span md-highlight-text=\"vm.sharedWithSearchText\" md-highlight-flags=\"i\">{{user | fullNameFilter}}</span>\n </div>\n </md-autocomplete>\n <md-chip-template layout=\"row\" layout-align=\"start center\">\n <au-profile-image user=\"$chip\" size=\"32\" class=\"grow\"></au-profile-image>\n <span>{{$chip | fullNameFilter}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15\">\n <div layout=\"row\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancel()\">Cancel</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.sendShare()\">Share</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/alignus/directives/au-template-buttons/au-from-template-state-button/au-from-template-state-button.tmpl.html","<md-button class=\"md-raised\" style=\"position: absolute; bottom: 20px; left: 20px;\" ng-click=\"openFromTemplate()\">\n <md-icon md-font-icon=\"zmdi zmdi-layers\"></md-icon>\n Create from Template &nbsp;\n</md-button>");
$templateCache.put("/app/alignus/directives/au-workflows/dialogs/request-approval.tmpl.html","<md-dialog \n au-wizard dialog-title=\"Request Approval\" on-review=\"vm.review()\" on-finish=\"vm.finish()\" on-close=\"vm.close()\" steps=\"vm.wizardSteps\" disable-next=\"vm.disableNext\"\n class=\"au-dialog\" aria-label=\"Request Approval Dialog\" \n flex=\"50\" flex-sm=\"100\" flex-md=\"60\" style=\"min-height: 480px\">\n <au-wizard-step step-name=\"intro\" step-bg=\"/assets/images/dialogs/typebg.png\">\n <h3>Request for Approval</h3> \n <div>Select the item you want approval on. It can be a task, document, project, or any other item, just type it\'s title!<br>\n Each user that you request approval from will receive a task to approve the item you sent. When they complete the task your item is approved!</div>\n <div layout=\"row\" layout-align=\"center center\" style=\"text-align: center;\">\n <div flex=\"33\"><img class=\"grow\" src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/request-add-users.png\"></div>\n <div flex=\"33\"><img class=\"grow\" src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/request-items.png\"></div>\n <div flex=\"33\"><img class=\"grow\" src=\"https://s3.amazonaws.com/alignusstatic/UI/dialogs/intros/request-attachment.png\"></div>\n </div>\n <div layout=\"row\" class=\"md-caption\" style=\"text-align: center;\">\n <div class=\"padding-20\" flex=\"33\">Choose one or more users to request approval from.</div>\n <div class=\"padding-20\" flex=\"33\">Enter the item you need approved: Document, Task, Project, Meeting, it could be anything!</div>\n <div class=\"padding-20\" flex=\"33\">Attach an optional message.</div>\n </div>\n </au-wizard-step>\n \n <au-wizard-step step-name=\"approval\" on-next-step=\"vm.confirmApproval()\" step-bg=\"/assets/images/dialogs/email.png\">\n <!--choose users--> \n <md-input-container flex class=\"md-icon-float md-block padding-left-30\" md-no-float>\n <md-icon md-font-icon=\"zmdi zmdi-accounts\" style=\"top:18px;\"></md-icon>\n <md-chips ng-model=\"vm.usersToRequest\" md-require-match=\"true\" md-transform-chip=\"vm.transformUserChip($chip)\" flex>\n <md-autocomplete md-search-text=\"vm.userSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.userSearchText, excludeContacts: true})\" placeholder=\"User(s) to Request\" md-autoselect=\"true\" md-select-on-match=\"true\" id=\"TxtUserToRequest\">\n <md-item-template>\n <span md-highlight-text=\"vm.userSearchText\" md-highlight-flags=\"i\" id=\"AutoUserToRequest{{$index}}\">\n {{user | auItemFilter: \'User\'}}\n </span>\n </md-item-template>\n </md-autocomplete>\n <md-chip-template layout=\"row\" ng-attr-id=\"ChipUserToRequest{{$index}}\">\n <au-profile-image item=\"$chip\" size=\"30\" class=\"grow\"></au-profile-image>\n <span>{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n </md-input-container>\n\n <!--choose item-->\n <div layout=\"row\" layout-align=\"start center\">\n <md-icon md-font-icon=\"zmdi zmdi-label\" style=\"margin:0 0 0 0;\"></md-icon>\n <md-input-container flex class=\"margin-left-10\">\n <md-autocomplete ng-disabled=\"vm.itemToApproveProvided\" md-clear-button=\"true\" md-require-match=\"true\" md-select-on-match=\"true\" md-search-text=\"vm.itemSearchText\" md-items=\"item in vm.search()\"\n md-floating-label=\"Item to Approve\" md-item-text=\"vm.itemToApprove.SearchTitle || vm.itemToApprove.toString()\" md-selected-item=\"vm.itemToApprove\" id=\"TxtItemToApprove\">\n <md-item-template>\n <span md-highlight-text=\"vm.itemSearchText\" md-highlight-flags=\"i\" id=\"AutoItemToApprove{{$index}}\">\n {{ item.SearchTitle + \' (\' + item.ModelName + \')\' }}\n </span>\n </md-item-template>\n </md-autocomplete>\n </md-input-container>\n </div>\n \n <!--optional message-->\n <div layout=\"row\" layout-align=\"start start\">\n <div class=\"margin-top-65\">\n <md-icon md-font-icon=\"zmdi zmdi-format-subject\"></md-icon>\n </div>\n <div class=\"au-cke-document text-area margin-top-15\" flex ng-model=\"vm.optionalMessage\" placeholder=\"Optional Message\" id=\"CkeOptionalMessage\" grow=\"true\"></div>\n </div>\n </au-wizard-step>\n</md-dialog>");
$templateCache.put("/app/alignus/directives/sidebarWidgets/dialogs/add-widgets-wizard.tmpl.html","<md-dialog id=\"AddWidgetWizard\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Add Page Widget</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n\n <md-dialog-content layout-align=\"center center\" class=\"marign-bottom-20\">\n <div class=\"margin-20\">\n <div class=\"opacity-80\">Page widgets let you customize your page by featuring events, poll responses, pinned posts and more.</div>\n <div class=\"opacity-80\">After you add a widget, arrange it on your page by simple drag-and-drop. You can always remove or reconfigure the widget\n - just click the \'Edit\' button on the widget.</div>\n <br></br>\n <md-divider></md-divider>\n\n\n <div layout=\"row\" layout-align=\"start center\">\n <span flex>\n Show a summary of poll responses for this page.\n </span>\n <md-button class=\"md-raised\" ng-click=\"vm.installWidget(0, \'au-page-poll\', \'Poll Results\')\" id=\"BtnAddPollWidget\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n Polls\n </md-button>\n </div>\n <md-divider></md-divider>\n\n <div layout=\"row\" layout-align=\"start center\">\n <span flex>\n Feature a post on this page.\n </span>\n <md-button class=\"md-raised\" ng-click=\"vm.installWidget(1, \'au-page-pinned-post\', \'Pinned Post\')\" id=\"BtnAddPinnedWidget\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n Pinned Posts\n </md-button>\n </div>\n <md-divider></md-divider>\n\n <div layout=\"row\" layout-align=\"start center\">\n <span flex>\n Label and filter posts on this page.\n </span>\n <md-button class=\"md-raised\" ng-click=\"vm.installWidget(2, \'au-page-filter-posts\', \'Label Posts\')\" id=\"BtnAddCategoryWidget\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n Label Posts\n </md-button>\n </div>\n <md-divider></md-divider>\n\n <div layout=\"row\" layout-align=\"start center\" ng-if=\"vm.page.Type == \'User\'\">\n <span flex>\n Show a mini-calendar of upcoming events you are attending.\n </span>\n <md-button class=\"md-raised\" ng-click=\"vm.installWidget(3, \'au-page-events\', \'Events\')\" id=\"BtnAddEventWidget\">\n <md-icon md-font-icon=\"zmdi zmdi-plus-circle-o\"></md-icon>\n Events\n </md-button>\n </div>\n <md-divider></md-divider>\n\n </div>\n </md-dialog-content>\n\n <md-dialog-actions layout=\"row\" class=\"margin-15\">\n <md-button class=\"md-raised margin-right-10\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCancel\">\n Nevermind\n </md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.finish()\" id=\"BtnSubmit\">\n Add Widget\n </md-button>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/_shell/dialogs/high-five-dialog.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Send High Five</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 10px 10px 0 10px;\">\n <div class=\"header\">\n <!--to user-->\n <md-chips ng-model=\"vm.toUsers\" md-require-match=\"true\" md-transform-chip=\"vm.transformUserChip($chip)\" flex>\n <md-autocomplete md-search-text=\"vm.toUsersSearchText\" md-items=\"user in $root.auUtility.searchUsers({query:vm.toUsersSearchText, excludeContacts: true})\" placeholder=\"To...\" md-select-on-match=\"true\" md-autoselect=\"true\" id=\"TxtToUsers\" md-autofocus>\n <span md-highlight-text=\"vm.toUsersSearchText\" md-highlight-flags=\"i\" ng-attr-id=\"AutoToUser{{$index}}\">\n {{user | auItemFilter: \'User\'}}\n </span>\n </md-autocomplete>\n <md-chip-template layout=\"row\">\n <au-profile-image user=\"$chip\" size=\"30\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipToUser{{$index}}\">{{$chip | auItemFilter: \'User\'}}</span>\n </md-chip-template>\n </md-chips>\n <!--personal message-->\n <md-input-container md-no-float>\n <input ng-model=\"vm.message\" placeholder=\"Message\" id=\"TxtMessage\" maxlength=\"150\" />\n </md-input-container>\n </div>\n <!--choose emoji-->\n <md-radio-group ng-model=\"vm.emojiType\">\n <div layout=\"row\" layout-fill style=\"padding: 20px 10% 0 10%\">\n <div layout=\"column\" layout-align=\"start center\" flex=\"40\">\n <md-radio-button name=\"high-five\" value=\"high-five\" aria-label=\"high-five\">\n <img aria-label=\"high-five\" ng-src=\"/assets/images/gifs/no-loop/high-five.gif\">\n <div align=\"center\">High Five!</div>\n </md-radio-button>\n </div>\n <div flex=\"15\"></div>\n <div layout=\"column\" layout-align=\"start center\" flex=\"40\"> \n <md-radio-button name=\"great-job\" value=\"check\" aria-label=\"great-job\">\n <img aria-label=\"great-job\" ng-src=\"/assets/images/gifs/no-loop/check.gif\">\n <div align=\"center\">Great Job!</div>\n </md-radio-button>\n </div>\n <div flex=\"15\"></div>\n <div layout=\"column\" layout-align=\"start center\" flex=\"40\"> \n <md-radio-button name=\"thank-you\" value=\"thumb\" aria-label=\"thank-you\">\n <img aria-label=\"thank-you\" ng-src=\"/assets/images/gifs/no-loop/thumb.gif\">\n <div align=\"center\">Thank You!</div>\n </md-radio-button>\n </div>\n </div>\n </md-radio-group>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15\">\n <div layout=\"row\">\n <md-button class=\"md-raised\" ng-click=\"vm.cancel()\">Cancel</md-button>\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.createHighFive()\">Send</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/_shell/dialogs/post-to-page.tmpl.html","<md-dialog class=\"mobile-fullwidth-dialog post-to-page\" flex=\"50\" flex-xs=\"100\" flex-sm=\"80\" id=\"DialogPostToPage\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Post To Page</h2>\n <span flex></span>\n <md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"cancel\" id=\"BtnCloseDialog\">\n <md-icon md-font-icon=\"zmdi zmdi-close\"></md-icon>\n </md-button>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex>\n <div class=\"header\">\n <!--pages to post on-->\n <md-chips ng-model=\"vm.pageIds\" md-require-match=\"true\" flex style=\"margin-bottom: 20px; display: block;\">\n <md-autocomplete md-search-text=\"vm.pageSearchText\" md-items=\"page in vm.searchPages(vm.pageSearchText)\" placeholder=\"Page(s)\" md-select-on-match=\"true\" md-autoselect=\"true\" id=\"TxtPages\" md-autofocus>\n <span md-highlight-text=\"vm.searchPages\" md-highlight-flags=\"i\" ng-attr-id=\"AutoPage{{$index}}\">\n {{page | auItemFilter: \'Page\'}}\n </span>\n </md-autocomplete>\n <md-chip-template layout=\"row\">\n <au-profile-image item=\"$chip\" item-type=\'Page\' size=\"30\" class=\"grow\"></au-profile-image>\n <span ng-attr-id=\"ChipPage{{$index}}\">{{$chip | auItemFilter: \'Page\'}}</span>\n </md-chip-template>\n </md-chips>\n </div>\n <!--actual post-->\n <au-inline-post item=\"vm.post\" options=\"{expandOnLoad:true}\" before-add-post=\"vm.savePost\" on-complete=\"vm.close\" no-copy=\"true\" grow=\"true\" id=\"CkePost\" auto-focus=\"false\"></au-inline-post>\n </md-dialog-content>\n</md-dialog>");
$templateCache.put("/app/alignus/layouts/_shell/dialogs/update-your-password.tmpl.html","<md-dialog flex=\"50\" flex-xs=\"100\" flex-sm=\"80\">\n <md-toolbar class=\"md-primary\">\n <div class=\"md-toolbar-tools\">\n <h2>Update Your Password</h2>\n <span flex></span>\n </div>\n </md-toolbar>\n <md-dialog-content layout-align=\"center center\" flex style=\"padding: 10px 10px 0 10px;\">\n <div class=\"margin-10\" layout=\"row\">\n <img s3-src=\"/assets/images/avatars/al.png\" style=\"height:50px; width:50px;\" />\n <div class=\"margin-left-10\">\n To log into Align Us in the future, visit\n <span style=\"color: blue; text-decoration: underline;\">https://app.align.us<md-tooltip md-direction=\"top\">\n Or, just Press Ctrl/Cmd + D to bookmark this page now.\n </md-tooltip></span>. Then enter your email ({{$root.user.Email}}) and the password you\'ll create below. Easy!\n <br/>\n </div>\n </div>\n\n <div layout=\"column\">\n <md-input-container>\n <label>New Password (min 8 characters)</label>\n <input type=\"password\" ng-model=\"vm.ownNewPassword\" required />\n </md-input-container>\n <md-input-container>\n <label>Confirm New Password</label>\n <input type=\"password\" ng-model=\"vm.verifyPassword\" required />\n </md-input-container>\n </div>\n </md-dialog-content>\n <md-dialog-actions class=\"margin-15\">\n <div layout=\"row\">\n <md-button class=\"md-raised md-primary\" ng-click=\"vm.change()\" ng-disabled=\"!vm.ownNewPassword || (vm.ownNewPassword != vm.verifyPassword) || (vm.ownNewPassword.length < 8)\">Done!</md-button>\n </div>\n </md-dialog-actions>\n</md-dialog>");}]);
(function () {
	'use strict';

	themesConfig.$inject = ["$mdThemingProvider", "$provide"];
	angular
		.module('app')
		.config(themesConfig);

	/* @ngInject */
	function themesConfig($mdThemingProvider, $provide) {

		// to allow use later:
		$provide.value('themeProvider', $mdThemingProvider);
		// we have to manually generate themes but now we can do it in services
		// $mdThemingProvider.generateThemesOnDemand(true);

		loadDefaultThemes();

		function loadDefaultThemes() {
		
			// /**
			//  *  PALETTES
			//  */
			$mdThemingProvider.definePalette('White', {
				'50': 'ffffff',
				'100': 'ffffff',
				'200': 'ffffff',
				'300': 'ffffff',
				'400': 'ffffff',
				'500': 'ffffff',
				'600': 'ffffff',
				'700': 'ffffff',
				'800': 'ffffff',
				'900': 'ffffff',
				'A100': 'ffffff',
				'A200': 'ffffff',
				'A400': 'ffffff',
				'A700': 'ffffff',
				'contrastDefaultColor': 'dark'
			});

			$mdThemingProvider.definePalette('Main', {
				"50": "#f9e9ea",
				"100": "#ecbcc0",
				"200": "#df8f96",
				"300": "#d46973",
				"400": "#c94350",
				"500": "#be1e2d",
				"600": "#a61a27",
				"700": "#8f1722",
				"800": "#77131c",
				"900": "#5f0f17",
				"A100": "#ecbcc0",
				"A200": "#df8f96",
				"A400": "#c94350",
				"A700": "#8f1722",
				'contrastDefaultColor': 'dark',
				'contrastLightColors': '500 600 700 800 900 A200 A400 A700',
				'contrastStrongLightColors': '500 700 800 900 A200 A400 A700'
			});

			$mdThemingProvider.definePalette('Accent', {
				"50": "#fde8e9",
				"100": "#fabbbd",
				"200": "#f68e92",
				"300": "#f3686d",
				"400": "#f04248",
				"500": "#ed1c24",
				"600": "#cf1920",
				"700": "#b2151b",
				"800": "#941217",
				"900": "#770e12",
				"A100": "#fabbbd",
				"A200": "#f68e92",
				"A400": "#ed1c24",
				"A700": "#b2151b",
				"contrastDefaultColor": "light"
			});

			$mdThemingProvider.theme('default')
				.primaryPalette('Main')
				.accentPalette('Accent')
				.warnPalette('orange')

			// $mdThemingProvider.theme('alignus')
			// 	.primaryPalette('Main', {
			// 		'hue-2': 'A700'
			// 	})
			// 	.accentPalette('Accent', {
			// 		'default': '500'
			// 	})
			// 	.warnPalette('orange')			

			// $mdThemingProvider.theme('grey')
			// 	.primaryPalette('grey')
			// 	.accentPalette('White')
			// 	.warnPalette('red')
		
		}
	}
})();
(function () {
    'use strict';

    routeConfig.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$httpProvider"];
    angular
        .module('app')
        .config(routeConfig);

    /* @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {
        // Setup the apps routes
        appReady.$inject = ["Schema"];
        initialize.$inject = ["appReady", "$rootScope", "$location", "$injector", "$q", "toast", "$timeout", "$interval", "$mdDialog", "$mdMedia", "$state", "s3Service", "Authorization", "moment", "Schema", "Task", "ItemViewer", "socket", "$compile", "$mdSidenav", "$mdUtil", "$window", "$filter", "$stateParams", "$sce", "auUtility", "Document", "oneSearch", "auTour", "tourJSON", "windowFab", "User", "taskPriorities", "kanbanStates", "emojiFullscreen", "manageUsers"];
        $locationProvider.html5Mode(true);

        //application specific authentication package
        $httpProvider.interceptors.push('httpInterceptor')

        $stateProvider
            .state('shell', {
                abstract: true,
                templateUrl: '/app/alignus/layouts/_shell/_shell.tmpl.html',
                controller: 'ShellLayoutController',
                controllerAs: 'vm',
                resolve: {
                    //don't start the app until the schemas have been loaded/refreshed
                    appReady: appReady,
                    initialize: initialize,
                    /* @ngInject */
                    localCacheReady: ["appReady", "initialize", "$rootScope", "$q", "auTheme", "Authorization", "Schema", "socket", function (appReady, initialize, $rootScope, $q, auTheme, Authorization, Schema, socket) {
                        return auth(true, $rootScope, $q, auTheme, Authorization, Schema, socket)
                    }]

                },
                navigationData: {
                    hideBreadcrumb: true
                }
            })

        $stateProvider
            .state('single', {
                abstract: true,
                template: '<ui-view/>',
                resolve: {
                    //this is called before any other controllers - put singleItemViewer settings here
                    /* @ngInject */
                    singleView: ["$rootScope", function ($rootScope) {
                        $rootScope.singleItemViewer = true
                    }],
                    //don't start the app until the schemas have been loaded/refreshed
                    appReady: appReady,
                    initialize: initialize,
                    /* @ngInject */
                    localCacheReady: ["appReady", "initialize", "$rootScope", "$q", "auTheme", "Authorization", "Schema", "socket", function (appReady, initialize, $rootScope, $q, auTheme, Authorization, Schema, socket) {
                        return auth(false, $rootScope, $q, auTheme, Authorization, Schema, socket)
                    }]
                }
            })


        // Route to /home if the url is unspecified or invalid
        $urlRouterProvider.otherwise(function ($injector, $location) {
            // single item viewer will change the url to a customurl so ignore it in that context
            if (Object.byString(window, "$rootScope.singleItemViewer")) return

            var url = $location.path()
            if (url == "" || url == "/") {
                if ($location.host().indexOf('ifund4') > -1) {
                    return $location.path("/welcome")
                } else {
                    return $location.path("/home")
                }
            }
            
            //trim off leading /
            url = url.substr(1)
            
            if (url.split('/').length == 1) {
                //check if this is a valid single item
                return $injector.get('$http').post('/api/verifyCustomUrl', { customUrl: url }).then(function (response) {
                    if (response.data.success) {
                        //they entered a customurl for an item - go to it's single item viewer
                        $location.path('/' + response.data.ModelName.toLowerCase() + '/' + response.data.DocId)
                    } else {
                        $location.path('/home')
                    }
                })
            } else {
                //they entered an unknown multi-part path, go to home
                $location.path('/home')
            }
        });

        /* @ngInject */
        function appReady(Schema) {
            return Schema.query().$httpPromise
        }

        /* @ngInject */
        function initialize(appReady, $rootScope, $location, $injector, $q, toast, $timeout, $interval, $mdDialog, $mdMedia, $state, s3Service, Authorization, moment, Schema, Task, ItemViewer, socket, $compile, $mdSidenav, $mdUtil, $window, $filter, $stateParams, $sce, auUtility, Document, oneSearch, auTour, tourJSON, windowFab, User, taskPriorities, kanbanStates, emojiFullscreen, manageUsers) {
            updateLoadingMsg('Initializing services...')

            //expose the rootScope to the window for easy broadcasting
            window.rootScope = window.$rootScope = $rootScope
            $rootScope.shellLoaded = false

            //expose the showDialog function to the window
            window.showDialog = function (options) {
                return $mdDialog.show(options)
            }

            window.closeDialog = $rootScope.closeDialog = function () {
                $mdDialog.cancel()
            }

            //expose the simple toaster to the window
            window.showToast = toast.toast
            window.toast = toast

            //expose utility angular services to the window
            window.$mdMedia = $rootScope.$mdMedia = $mdMedia
            window.$state = $rootScope.$state = $state
            window.$location = $rootScope.$location = $location
            $rootScope.location = window.location
            window.$mdDialog = $rootScope.$mdDialog = $mdDialog
            window.$filter = $rootScope.$filter = $filter
            window.$injector = $rootScope.$injector = $injector
            window.$q = $rootScope.$q = $q
            window.s3Service = $rootScope.s3Service = s3Service
            $rootScope.moment = window.moment
            window.auUtility = $rootScope.auUtility = auUtility
            $rootScope.false = false
            $rootScope.true = true

            // expose this as a global
            $rootScope.daysOfWeek = [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ]

            //expose windowHeight to window/$rootScope
            window.onresize = debounce(function () {
                window.windowHeight = $rootScope.windowHeight = angular.element(window).innerHeight()
                window.windowWidth = $rootScope.windowWidth = angular.element(window).innerWidth()
                $rootScope.$broadcast('window-resized', { width: window.windowWidth, height: window.windowHeight })
                $rootScope.minScrollTop = 150 //todo: optimize for mobile
                $rootScope.$digest()
            }, 300)
            window.onresize()

            //put state.go function on window for jsFunction and $scope for ng-clicks
            window.goToState = $rootScope.goToState = function (stateName, params, options) {
                $state.go(stateName, params, options)
            }

            //put a handy track by function that doesn't blow up when _ids are missing
            $rootScope.protectedId = function (item) {
                if (!item) return Math.random() * 100000000000
                if (item._id) return item._id
                return Math.random() * 100000000000
            }

            //put a handy function to access $parents waaaayyy up in scope
            $rootScope.findInParentScope = function (currentScope, find, returnScope) {
                if (currentScope == $rootScope) return false

                do {
                    if (currentScope.hasOwnProperty(find)) return returnScope ? currentScope : currentScope[find]

                    currentScope = currentScope.$parent
                } while (currentScope.$parent)
            }

            //track all state changes in google analytics
            $rootScope.$on('$stateChangeSuccess', function (event, to, toParams, from, fromParams) {
                $rootScope.$previousState = from
                $window.ga('send', 'pageview', $location.path());
            });

            ////////////////////////////////////////////////////////////////////
            //    HANDLE MENTION and IMAGES IN POSTS CLICKS
            ////////////////////////////////////////////////////////////////////

            //let at least one full digest occur and then attach to the document
            setTimeout(function () {
                angular.element('body').on('click', '.doc-mention', function (event) {
                    // if (event.data.$.srcElement.classList.contains('doc-mention')) {
                    var el = event.target
                    console.log(el.attributes)

                    var itemType = el.attributes['data-item-type'].value
                    switch (itemType) {
                        case 'HighFive':
                            //currently don't support different animation styles
                            //update models/post.js line 208 when we do
                            emojiFullscreen.show(el.attributes['high-five-type'].value, 'animation', el.attributes['high-five-message'].value)
                            break;
                        default:
                            {
                                var collection = Schema.resource(itemType)
                                collection.getCache({ _id: el.attributes['data-item-id'].value })[0].open()
                            }
                    }
                })

                //links to our own site aren't opened by the base tag
                angular.element('body').on('click', 'au-post-feed a', function (event) {
                    var el = event.target
                    if (el.host.startsWith(location.host)) {
                        window.open(el.href, "_blank")
                        event.preventDefault()
                    }
                })

                angular.element('body').on('click', 'img.user-image.not-a-widget', function (event) {
                    var el = event.target
                    console.log(el.attributes)

                    $rootScope.$apply(function () {
                        $rootScope.openPeek(el.currentSrc, 'Image')
                    })
                })
            }, 6000)

            ////////////////////////////////////////////////////////////////////
            //    PREVENT CTRL+S
            ////////////////////////////////////////////////////////////////////

            angular.element(document).on('keydown', function (e) {
                if (e.keyCode == 83 && e.ctrlKey) {
                    console.debug('Ctrl + S does nothing here...')
                    e.preventDefault()
                }
            })

            ////////////////////////////////////////////////////////////////////
            //    ROOT PEEK FUNCTIONS
            ////////////////////////////////////////////////////////////////////
            $rootScope.peekDefault = $rootScope.peekUrl = "/assets/files/peek.html"
            $rootScope.openPeek = function (url, title) {
                //--optimize for document viewing
                if (url.$key == "Document") {
                    window.open('/document/' + url._id)
                    return
                }

                //hide all peek versions
                $rootScope.peekDoc = $rootScope.peekImg = null

                //hide the windowFab
                windowFab.hideWindowFab()

                //show the peek window
                angular.element('#shell-peek').fadeIn()

                //let the shell template know it's open
                $rootScope.peekIsOpen = true

                //--optimize for inline post
                if (url.inlinePost) {
                    $rootScope.peekPostScope = $rootScope.$new()
                    angular.element('#shell-peek .au-cke-document, #shell-peek au-inline-post').remove()
                    angular.element('#shell-peek').append(
                        $compile('<au-inline-post ng-if="$root.peekDoc" item="$root.peekDoc" options="{expandOnLoad: true, fullscreen:true}" on-complete="$root.closePeek" grow="false"></au-inline-post > ')($rootScope.peekPostScope)
                    )
                    $rootScope.peekDoc = url.item
                    $rootScope.peekOpenNewTabUrl = undefined
                    $rootScope.peekTitle = 'Post Editor'
                    return
                }

                //url is a string - normalize it
                $rootScope.peekOpenNewTabUrl = url

                //--optimize image viewing
                if (title && (title == "Image" || auUtility.hasImgExtension(title))) {
                    $rootScope.peekImg = url
                    $rootScope.peekTitle = title
                    return
                }

                //--no optimization available - load the iframe with the given url
                url += ((url.indexOf('?') === -1) ? '?' : '&') + 'shellPeek=1'
                url = $sce.trustAsResourceUrl(url)
                $rootScope.peekUrl = url
                $rootScope.peekTitle = title || url

                //wait to see if the document loaded
                $timeout(function () {
                    try {
                        if (angular.element('#shell-peek iframe')[0].contentDocument.URL.contains($rootScope.peekDefault)) {
                            $rootScope.closePeek()
                        }
                    } catch (e) { }

                }, 1000)
            }

            $rootScope.closePeek = function () {
                $rootScope.peekIsOpen = false
                angular.element('#shell-peek').fadeOut()
                angular.element('#shell-peek .au-cke-document, #shell-peek au-inline-post').remove()
                //hide all peek versions
                $rootScope.peekDoc = $rootScope.peekImg = null
                $rootScope.peekUrl = $rootScope.peekDefault

                if ($rootScope.peekPostScope) {
                    $rootScope.peekPostScope.$destroy()
                    $rootScope.peekPostScope = null
                }
            }

            $rootScope.openPeekInNewTab = function () {
                $window.open($rootScope.peekOpenNewTabUrl, '_blank')
            }

            /////////////////////////////////////////////////
            //  REFRESH AUTH TOKEN MANAGEMENT
            ////////////////////////////////////////////////
            window.addEventListener("beforeunload", function (event) {
                manageUsers.storeAuthToken()
            })

            /////////////////////////////////////////////////
            //  ALERT THEM IF THEY'RE KILLING A VIDEO CALL
            ////////////////////////////////////////////////
            window.addEventListener("beforeunload", function (event) {
                if ($rootScope.getUiActiveVideoCall()) {
                    // this will make Chrome display its default "are you sure you want to leave this page" dialog.
                    // we can't really do anything clever here; this returnValue is the only thing stopping the page
                    // from reloading immediately, yet it also stops all other scripts on the page. so if we show a toast/dialog it won't show
                    // up until after they click "okay" to Chrome's dialog.
                    event.returnValue = 'any string will do'
                    return 'any string will do'
                }
            })

            ////////////////////////////////////////////////
            //   TASK FAB FUNCTIONS 
            ////////////////////////////////////////////////

            if (!$rootScope.docTask) {
                $rootScope.taskPriorities = taskPriorities
                $rootScope.kanbanStates = kanbanStates
                $rootScope.docTask = {}
                $rootScope.taskFab = {
                    showTaskDetails: false,
                    showDescription: false,
                    showEventDetails: false,
                    showTab: function (tab) {
                        $rootScope.taskFab.showTaskDetails = false
                        $rootScope.taskFab.showDescription = false
                        $rootScope.taskFab.showEventDetails = false

                        switch (tab) {
                            case 'details':
                                $rootScope.taskFab.showTaskDetails = true;
                                break;
                            case 'dates':
                                $rootScope.taskFab.showEventDetails = true;
                                break;
                            case 'description':
                                $rootScope.taskFab.showDescription = true;
                                break;

                        }
                    }
                }

                $rootScope.docTask.msgEnterToRemove = "Hit ENTER to remove this task from the document<br>Hit DELETE to delete it from the system"
                $rootScope.docTask.msgTabToDetails = "Hit TAB to list task details here"
                $rootScope.docTask.template = '<div class="au-task" id="NewTask">' +
                    '<div class="au-task-container">' +
                    '<span class="docTask">' +
                    '<input type="checkbox"/>' +
                    '<label></label>' +
                    '</span>' +
                    '<span class="au-task-title">New Task</span>' +
                    '</div>' +
                    '<div class="au-task-details">' +
                    '</div>' +
                    '</div>'

                $rootScope.docTask.create = function (options, next) {
                    var newTask = new Task()
                    newTask.Title = "New Task"
                    if (options.projectId) {
                        newTask.Project = options.projectId
                        newTask.ProjectPriority = options.projectPriority
                    } else if (options.meetingId) {
                        newTask.Meeting = options.meetingId
                        // newTask.ProjectPriority = projectPriority
                    } else if (options.documentId) {
                        newTask.Document = options.documentId
                    } else {
                        newTask.User = $rootScope.user._id
                    }
                    newTask.Creator = $rootScope.user._id

                    //don't add this to the project/document/meeting again on the server
                    newTask.$createdByCKEditor = true

                    newTask.$saveItem().then(function (task) {
                        next(task)
                    }).catch(function (fail) {
                        next()
                    })
                }

                $rootScope.docTask.confirmThenRemove = function ($event, item) {
                    $rootScope.taskFab.isOpen = false

                    // request confirmation
                    $mdDialog.show($mdDialog.confirm({
                        title: 'Remove Task',
                        textContent: 'Are you sure you want to remove ' + item.Title + ' from the system?',
                        ok: 'Yes',
                        cancel: 'Cancel',
                        targetEvent: $event
                    })).then(function () {
                        // remove the document if they confirmed
                        item.$removeItem().catch(function () {
                            toast.error('Error removing task - permission denied.')
                        })
                    })
                }

                $rootScope.docTask.openFab = function (offset, task, eventTarget) {
                    $rootScope.taskFab.openTop = ($rootScope.windowHeight - offset.top < 400)

                    $rootScope.taskFab.left = Math.min(offset.left - 19, $rootScope.windowWidth - 525) + 'px'
                    if ($rootScope.taskFab.openTop) {
                        $rootScope.taskFab.top = ""
                        $rootScope.taskFab.bottom = $rootScope.windowHeight - 43 - offset.top + 'px'
                    } else {
                        $rootScope.taskFab.top = offset.top - 15 + 'px'
                        $rootScope.taskFab.bottom = ""
                    }

                    //assign task to root scope
                    $rootScope.taskFab.Task = task
                    $rootScope.taskFab.TaskWhenOpened = angular.copy(task)
                    $rootScope.taskFab.eventTarget = eventTarget

                    //assign linkTaskWith dropdown to correct item type
                    if (task.Meeting) {
                        $rootScope.taskFab.linkTaskWith = 'Meeting'
                    } else if (task.Document) {
                        $rootScope.taskFab.linkTaskWith = 'Document'
                    } else {
                        $rootScope.taskFab.linkTaskWith = 'Project'
                    }

                    //open the task fab
                    $rootScope.taskFabAssignedToSearchText = ""
                    $rootScope.taskFab.isOpen = true

                    if (!$rootScope.$$phase) $rootScope.$digest()

                    //watch the scroll parent
                    angular.element(eventTarget).scrollParent().on('scroll.taskFab', function (e) {
                        var newOffset = angular.element(eventTarget).offset()
                        $rootScope.taskFab.left = newOffset.left - 19 + 'px'
                        if ($rootScope.taskFab.openTop) {
                            $rootScope.taskFab.top = ""
                            $rootScope.taskFab.bottom = $rootScope.windowHeight - 43 - newOffset.top + 'px'
                        } else {
                            $rootScope.taskFab.top = newOffset.top - 15 + 'px'
                            $rootScope.taskFab.bottom = ""
                        }
                        $rootScope.$digest()
                    })

                    //close the taskFab when the document is clicked
                    angular.element(document).on('click.taskFab', function (e) {
                        if (Object.byString(e.target, 'parentNode.classList').contains('docTask') || Object.byString(e.target, 'classList').contains('md-dialog-container') || e.target.id.toLowerCase().contains('taskfab') || angular.element(e.target).closest('md-virtual-repeat-container').length || angular.element(e.target).closest('.md-dialog-container').length)
                            return

                        $rootScope.$apply(function () {
                            $rootScope.taskFab.isOpen = false
                        })
                    })
                }

                $rootScope.$watch('taskFab.isOpen', function (isOpen, wasOpen) {
                    if (wasOpen && !isOpen) {
                        angular.element(document).off('click.taskFab')
                        angular.element($rootScope.taskFab.eventTarget).scrollParent().off('scroll.taskFab')

                        $rootScope.taskFab.showTaskDetails = false
                        $rootScope.taskFab.showDescription = false
                        $rootScope.taskFab.showEventDetails = false
                        if (auUtility.cachedResourceChanged($rootScope.taskFab.Task, $rootScope.taskFab.TaskWhenOpened)) {
                            $rootScope.taskFab.Task.$updateItem().$promise
                                .then(function () { })
                                .catch(function (err) {
                                    //pop up a red piece of toast
                                    toast.error('Error! Couldn\'t save task - check your permissions.');
                                    console.error('when updating item,', err);
                                });
                        }
                    }
                })

                $rootScope.docTask.openTask = function (task) {
                    task.open('recent')
                    $rootScope.taskFab.isOpen = false
                }

                $rootScope.docTask.getTask = function (taskId) {
                    return Task.getCache({ _id: taskId }, true)
                }

                $rootScope.docTask.setFinished = function (endDate) {
                    $rootScope.taskFab.Task.SetFinished(endDate)
                    $rootScope.taskFab.eventTarget.children[0].checked = !!endDate
                    $rootScope.taskFab.isOpen = false
                }
            }

        } //end of initialize

        function auth(getShellData, $rootScope, $q, auTheme, Authorization, Schema, socket) {
            var pArray = []

            //if the user just logged in, they are already authenticated
            //otherwise, authorize
            if (!$rootScope.user) {
                $rootScope.user = {}
                Schema.resource('User').init()
                Schema.resource('Organization').init()

                //authorize the local user and get all recent items
                //the server will send all items in the user's MySettings.RecentItems plus any items they are connected with via populate / de-populate algorithm
                updateLoadingMsg('Authorizing your account...')

                pArray.push(Authorization.authorize({ preloadForShell: getShellData }).then(function (authorized) {
                    if (!authorized) throw new Error('authorization failed')
                }))
            }

            //remember if we should get recent items on reconnections
            $rootScope.getShellDataOnReconnect = getShellData

            $q.all(pArray).then(function () {
                //when switching servers the old user could auth and not be found so get out
                if (!Object.byString($rootScope, 'user.Settings')) return

                updateLoadingMsg('Loading personal theme...')

                //apply their theme					
                auTheme.loadTheme($rootScope.user.Settings.TitlebarColor)

                updateLoadingMsg('Putting it all together...')

                //as soon as the browser is ready, fade the shell in and hide the loading message
                poll(function () {//when
                    return document.getElementById('shell-layout')
                }, reveal_shell, reveal_shell, 150000, 250)

                function reveal_shell() {
                    window.localCacheReady = true
                    updateLoadingMsg('Lights. Camera. Action!')

                    $location.search('udata', null)
                    $location.search('icu', null)
                    $location.search('ctx', null)
                    $location.search('org', null)

                    try {
                        document.getElementById('shell-layout').style.opacity = 1;
                        document.getElementById('loading-container').style.display = "none";
                    } catch (e) {
                        updateLoadingMsg('A fatal error has occurred while loading. Please refresh and try again.')
                    }

                }
            }).catch(function (e) {
                console.error(e)
            })

            return $q.all(pArray)
        }
    }
})();